(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec720"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec720"] = parcelRequire;
}
parcelRequire.register("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRequire.register("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRequire.register("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("d2lNW", function(module, exports) {
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

module.exports = (parcelRequire("h8vP0"));

});
parcelRequire.register("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRequire.register("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});




parcelRequire.register("bisEj", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $839799496b62fb71$var$ReactIs, $839799496b62fb71$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("jpdgm"))();

});
parcelRequire.register("jpdgm", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $L7tyD = parcelRequire("L7tyD");
function $e20aa3d84dea372f$var$emptyFunction() {}
function $e20aa3d84dea372f$var$emptyFunctionWithReset() {}
$e20aa3d84dea372f$var$emptyFunctionWithReset.resetWarningCache = $e20aa3d84dea372f$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $L7tyD) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $e20aa3d84dea372f$var$emptyFunctionWithReset,
        resetWarningCache: $e20aa3d84dea372f$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("L7tyD", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $08da306d15728f79$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $08da306d15728f79$var$ReactPropTypesSecret;

});



parcelRequire.register("kricu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $3c0c317d38dc134b$export$2e2bcd8739ae039; });

var $atwIM = parcelRequire("atwIM");
var $3c0c317d38dc134b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($atwIM)));

});
parcelRequire.register("atwIM", function(module, exports) {

var $50BUi = parcelRequire("50BUi");
/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $7a05fe8fe2c0d846$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $50BUi(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
module.exports = $7a05fe8fe2c0d846$var$StyleToObject;
module.exports.default = $7a05fe8fe2c0d846$var$StyleToObject; // ESM support

});
parcelRequire.register("50BUi", function(module, exports) {
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $3a5a5b62cae4d9e0$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $3a5a5b62cae4d9e0$var$NEWLINE_REGEX = /\n/g;
var $3a5a5b62cae4d9e0$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $3a5a5b62cae4d9e0$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $3a5a5b62cae4d9e0$var$COLON_REGEX = /^:\s*/;
var $3a5a5b62cae4d9e0$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $3a5a5b62cae4d9e0$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $3a5a5b62cae4d9e0$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $3a5a5b62cae4d9e0$var$NEWLINE = "\n";
var $3a5a5b62cae4d9e0$var$FORWARD_SLASH = "/";
var $3a5a5b62cae4d9e0$var$ASTERISK = "*";
var $3a5a5b62cae4d9e0$var$EMPTY_STRING = "";
// types
var $3a5a5b62cae4d9e0$var$TYPE_COMMENT = "comment";
var $3a5a5b62cae4d9e0$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ module.exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($3a5a5b62cae4d9e0$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($3a5a5b62cae4d9e0$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($3a5a5b62cae4d9e0$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($3a5a5b62cae4d9e0$var$FORWARD_SLASH != style.charAt(0) || $3a5a5b62cae4d9e0$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($3a5a5b62cae4d9e0$var$EMPTY_STRING != style.charAt(i) && ($3a5a5b62cae4d9e0$var$ASTERISK != style.charAt(i) || $3a5a5b62cae4d9e0$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($3a5a5b62cae4d9e0$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $3a5a5b62cae4d9e0$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($3a5a5b62cae4d9e0$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($3a5a5b62cae4d9e0$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($3a5a5b62cae4d9e0$var$VALUE_REGEX);
        var ret = pos({
            type: $3a5a5b62cae4d9e0$var$TYPE_DECLARATION,
            property: $3a5a5b62cae4d9e0$var$trim(prop[0].replace($3a5a5b62cae4d9e0$var$COMMENT_REGEX, $3a5a5b62cae4d9e0$var$EMPTY_STRING)),
            value: val ? $3a5a5b62cae4d9e0$var$trim(val[0].replace($3a5a5b62cae4d9e0$var$COMMENT_REGEX, $3a5a5b62cae4d9e0$var$EMPTY_STRING)) : $3a5a5b62cae4d9e0$var$EMPTY_STRING
        });
        // ;
        match($3a5a5b62cae4d9e0$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $3a5a5b62cae4d9e0$var$trim(str) {
    return str ? str.replace($3a5a5b62cae4d9e0$var$TRIM_REGEX, $3a5a5b62cae4d9e0$var$EMPTY_STRING) : $3a5a5b62cae4d9e0$var$EMPTY_STRING;
}

});



parcelRequire.register("1wVs5", function(module, exports) {
"use strict";

});

parcelRequire.register("aNJCr", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $7dd1ddf6834435ca$export$bdfd709ae4826697; }, function (v) { return $7dd1ddf6834435ca$export$bdfd709ae4826697 = v; });
var $7dd1ddf6834435ca$export$bdfd709ae4826697;
var $7dd1ddf6834435ca$export$c9e73fbda7da57b6;
var $7dd1ddf6834435ca$export$5a759dc7a1cfb72a;
"use strict";
var $7dd1ddf6834435ca$var$bundleURL = {};
function $7dd1ddf6834435ca$var$getBundleURLCached(id) {
    var value = $7dd1ddf6834435ca$var$bundleURL[id];
    if (!value) {
        value = $7dd1ddf6834435ca$var$getBundleURL();
        $7dd1ddf6834435ca$var$bundleURL[id] = value;
    }
    return value;
}
function $7dd1ddf6834435ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $7dd1ddf6834435ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $7dd1ddf6834435ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $7dd1ddf6834435ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$7dd1ddf6834435ca$export$bdfd709ae4826697 = $7dd1ddf6834435ca$var$getBundleURLCached;
$7dd1ddf6834435ca$export$c9e73fbda7da57b6 = $7dd1ddf6834435ca$var$getBaseURL;
$7dd1ddf6834435ca$export$5a759dc7a1cfb72a = $7dd1ddf6834435ca$var$getOrigin;

});

parcelRequire.register("gPYQ3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c4209a0c8c116bab$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $exYeM = parcelRequire("exYeM");
var $c4209a0c8c116bab$var$_react2 = $c4209a0c8c116bab$var$_interopRequireDefault($exYeM);

var $bisEj = parcelRequire("bisEj");
var $c4209a0c8c116bab$var$_propTypes2 = $c4209a0c8c116bab$var$_interopRequireDefault($bisEj);

var $ozA37 = parcelRequire("ozA37");

var $k0VxY = parcelRequire("k0VxY");

var $8Rebc = parcelRequire("8Rebc");
var $c4209a0c8c116bab$var$_object2 = $c4209a0c8c116bab$var$_interopRequireDefault($8Rebc);

var $5Spdc = parcelRequire("5Spdc");
var $c4209a0c8c116bab$var$_document2 = $c4209a0c8c116bab$var$_interopRequireDefault($5Spdc);
function $c4209a0c8c116bab$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c4209a0c8c116bab$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c4209a0c8c116bab$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c4209a0c8c116bab$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c4209a0c8c116bab$var$DISPLAY = {
    BLOCK: "block",
    FLEX: "flex",
    INLINE: "inline",
    INLINE_BLOCK: "inline-block",
    CONTENTS: "contents"
};
var $c4209a0c8c116bab$var$propTypes = (0, $ozA37.forbidExtraProps)({
    children: $c4209a0c8c116bab$var$_propTypes2["default"].node.isRequired,
    onOutsideClick: $c4209a0c8c116bab$var$_propTypes2["default"].func.isRequired,
    disabled: $c4209a0c8c116bab$var$_propTypes2["default"].bool,
    useCapture: $c4209a0c8c116bab$var$_propTypes2["default"].bool,
    display: $c4209a0c8c116bab$var$_propTypes2["default"].oneOf((0, $c4209a0c8c116bab$var$_object2["default"])($c4209a0c8c116bab$var$DISPLAY))
});
var $c4209a0c8c116bab$var$defaultProps = {
    disabled: false,
    // `useCapture` is set to true by default so that a `stopPropagation` in the
    // children will not prevent all outside click handlers from firing - maja
    useCapture: true,
    display: $c4209a0c8c116bab$var$DISPLAY.BLOCK
};
var $c4209a0c8c116bab$var$OutsideClickHandler = function(_React$Component) {
    $c4209a0c8c116bab$var$_inherits(OutsideClickHandler, _React$Component);
    function OutsideClickHandler() {
        var _ref;
        $c4209a0c8c116bab$var$_classCallCheck(this, OutsideClickHandler);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var _this = $c4209a0c8c116bab$var$_possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [
            this
        ].concat(args)));
        _this.onMouseDown = _this.onMouseDown.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
        return _this;
    }
    $c4209a0c8c116bab$var$_createClass(OutsideClickHandler, [
        {
            key: "componentDidMount",
            value: function() {
                function componentDidMount() {
                    var _props = this.props, disabled = _props.disabled, useCapture = _props.useCapture;
                    if (!disabled) this.addMouseDownEventListener(useCapture);
                }
                return componentDidMount;
            }()
        },
        {
            key: "componentDidUpdate",
            value: function() {
                function componentDidUpdate(_ref2) {
                    var prevDisabled = _ref2.disabled;
                    var _props2 = this.props, disabled = _props2.disabled, useCapture = _props2.useCapture;
                    if (prevDisabled !== disabled) {
                        if (disabled) this.removeEventListeners();
                        else this.addMouseDownEventListener(useCapture);
                    }
                }
                return componentDidUpdate;
            }()
        },
        {
            key: "componentWillUnmount",
            value: function() {
                function componentWillUnmount() {
                    this.removeEventListeners();
                }
                return componentWillUnmount;
            }()
        },
        {
            key: "onMouseDown",
            value: function() {
                function onMouseDown(e) {
                    var useCapture = this.props.useCapture;
                    var isDescendantOfRoot = this.childNode && (0, $c4209a0c8c116bab$var$_document2["default"])(this.childNode, e.target);
                    if (!isDescendantOfRoot) {
                        if (this.removeMouseUp) {
                            this.removeMouseUp();
                            this.removeMouseUp = null;
                        }
                        this.removeMouseUp = (0, $k0VxY.addEventListener)(document, "mouseup", this.onMouseUp, {
                            capture: useCapture
                        });
                    }
                }
                return onMouseDown;
            }()
        },
        {
            key: "onMouseUp",
            value: function() {
                function onMouseUp(e) {
                    var onOutsideClick = this.props.onOutsideClick;
                    var isDescendantOfRoot = this.childNode && (0, $c4209a0c8c116bab$var$_document2["default"])(this.childNode, e.target);
                    if (this.removeMouseUp) {
                        this.removeMouseUp();
                        this.removeMouseUp = null;
                    }
                    if (!isDescendantOfRoot) onOutsideClick(e);
                }
                return onMouseUp;
            }()
        },
        {
            key: "setChildNodeRef",
            value: function() {
                function setChildNodeRef(ref) {
                    this.childNode = ref;
                }
                return setChildNodeRef;
            }()
        },
        {
            key: "addMouseDownEventListener",
            value: function() {
                function addMouseDownEventListener(useCapture) {
                    this.removeMouseDown = (0, $k0VxY.addEventListener)(document, "mousedown", this.onMouseDown, {
                        capture: useCapture
                    });
                }
                return addMouseDownEventListener;
            }()
        },
        {
            key: "removeEventListeners",
            value: function() {
                function removeEventListeners() {
                    if (this.removeMouseDown) this.removeMouseDown();
                    if (this.removeMouseUp) this.removeMouseUp();
                }
                return removeEventListeners;
            }()
        },
        {
            key: "render",
            value: function() {
                function render() {
                    var _props3 = this.props, children = _props3.children, display = _props3.display;
                    return $c4209a0c8c116bab$var$_react2["default"].createElement("div", {
                        ref: this.setChildNodeRef,
                        style: display !== $c4209a0c8c116bab$var$DISPLAY.BLOCK && (0, $c4209a0c8c116bab$var$_object2["default"])($c4209a0c8c116bab$var$DISPLAY).includes(display) ? {
                            display: display
                        } : undefined
                    }, children);
                }
                return render;
            }()
        }
    ]);
    return OutsideClickHandler;
}($c4209a0c8c116bab$var$_react2["default"].Component);
module.exports["default"] = $c4209a0c8c116bab$var$OutsideClickHandler;
$c4209a0c8c116bab$var$OutsideClickHandler.propTypes = $c4209a0c8c116bab$var$propTypes;
$c4209a0c8c116bab$var$OutsideClickHandler.defaultProps = $c4209a0c8c116bab$var$defaultProps;

});
parcelRequire.register("ozA37", function(module, exports) {

module.exports = (parcelRequire("8wiv8"));

});
parcelRequire.register("8wiv8", function(module, exports) {
"use strict";
function $633fa9d4b79ebeb3$var$noop() {
    return null;
}
$633fa9d4b79ebeb3$var$noop.isRequired = $633fa9d4b79ebeb3$var$noop;
function $633fa9d4b79ebeb3$var$noopThunk() {
    return $633fa9d4b79ebeb3$var$noop;
}
module.exports = {
    and: $633fa9d4b79ebeb3$var$noopThunk,
    between: $633fa9d4b79ebeb3$var$noopThunk,
    booleanSome: $633fa9d4b79ebeb3$var$noopThunk,
    childrenHavePropXorChildren: $633fa9d4b79ebeb3$var$noopThunk,
    childrenOf: $633fa9d4b79ebeb3$var$noopThunk,
    childrenOfType: $633fa9d4b79ebeb3$var$noopThunk,
    childrenSequenceOf: $633fa9d4b79ebeb3$var$noopThunk,
    componentWithName: $633fa9d4b79ebeb3$var$noopThunk,
    disallowedIf: $633fa9d4b79ebeb3$var$noopThunk,
    elementType: $633fa9d4b79ebeb3$var$noopThunk,
    empty: $633fa9d4b79ebeb3$var$noopThunk,
    explicitNull: $633fa9d4b79ebeb3$var$noopThunk,
    forbidExtraProps: Object,
    integer: $633fa9d4b79ebeb3$var$noopThunk,
    keysOf: $633fa9d4b79ebeb3$var$noopThunk,
    mutuallyExclusiveProps: $633fa9d4b79ebeb3$var$noopThunk,
    mutuallyExclusiveTrueProps: $633fa9d4b79ebeb3$var$noopThunk,
    nChildren: $633fa9d4b79ebeb3$var$noopThunk,
    nonNegativeInteger: $633fa9d4b79ebeb3$var$noop,
    nonNegativeNumber: $633fa9d4b79ebeb3$var$noopThunk,
    numericString: $633fa9d4b79ebeb3$var$noopThunk,
    object: $633fa9d4b79ebeb3$var$noopThunk,
    or: $633fa9d4b79ebeb3$var$noopThunk,
    predicate: $633fa9d4b79ebeb3$var$noopThunk,
    range: $633fa9d4b79ebeb3$var$noopThunk,
    ref: $633fa9d4b79ebeb3$var$noopThunk,
    requiredBy: $633fa9d4b79ebeb3$var$noopThunk,
    restrictedProp: $633fa9d4b79ebeb3$var$noopThunk,
    sequenceOf: $633fa9d4b79ebeb3$var$noopThunk,
    shape: $633fa9d4b79ebeb3$var$noopThunk,
    stringEndsWith: $633fa9d4b79ebeb3$var$noopThunk,
    stringStartsWith: $633fa9d4b79ebeb3$var$noopThunk,
    uniqueArray: $633fa9d4b79ebeb3$var$noopThunk,
    uniqueArrayOf: $633fa9d4b79ebeb3$var$noopThunk,
    valuesOf: $633fa9d4b79ebeb3$var$noopThunk,
    withShape: $633fa9d4b79ebeb3$var$noopThunk
};

});


parcelRequire.register("k0VxY", function(module, exports) {

$parcel$export(module.exports, "addEventListener", function () { return $e920725db28e929b$export$3f65cefe8380dbea; });
var $e920725db28e929b$var$CAN_USE_DOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function $e920725db28e929b$var$testPassiveEventListeners() {
    if (!$e920725db28e929b$var$CAN_USE_DOM) return false;
    if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) return false;
    var supportsPassiveOption = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            // eslint-disable-next-line getter-return
            get: function() {
                function get() {
                    supportsPassiveOption = true;
                }
                return get;
            }()
        });
        var noop = function noop() {};
        window.addEventListener("testPassiveEventSupport", noop, opts);
        window.removeEventListener("testPassiveEventSupport", noop, opts);
    } catch (e) {
    // do nothing
    }
    return supportsPassiveOption;
}
var $e920725db28e929b$var$memoized = void 0;
function $e920725db28e929b$var$canUsePassiveEventListeners() {
    if ($e920725db28e929b$var$memoized === undefined) $e920725db28e929b$var$memoized = $e920725db28e929b$var$testPassiveEventListeners();
    return $e920725db28e929b$var$memoized;
}
function $e920725db28e929b$var$normalizeEventOptions(eventOptions) {
    if (!eventOptions) return undefined;
    if (!$e920725db28e929b$var$canUsePassiveEventListeners()) // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
    return eventOptions;
}
/* eslint-disable no-bitwise */ /**
 * Generate a unique key for any set of event options
 */ function $e920725db28e929b$var$eventOptionsKey(normalizedEventOptions) {
    if (!normalizedEventOptions) return 0;
    // If the browser does not support passive event listeners, the normalized
    // event options will be a boolean.
    if (normalizedEventOptions === true) return 100;
    // At this point, the browser supports passive event listeners, so we expect
    // the event options to be an object with possible properties of capture,
    // passive, and once.
    //
    // We want to consistently return the same value, regardless of the order of
    // these properties, so let's use binary maths to assign each property to a
    // bit, and then add those together (with an offset to account for the
    // booleans at the beginning of this function).
    var capture = normalizedEventOptions.capture << 0;
    var passive = normalizedEventOptions.passive << 1;
    var once = normalizedEventOptions.once << 2;
    return capture + passive + once;
}
function $e920725db28e929b$var$ensureCanMutateNextEventHandlers(eventHandlers) {
    if (eventHandlers.handlers === eventHandlers.nextHandlers) // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
}
function $e920725db28e929b$var$TargetEventHandlers(target) {
    this.target = target;
    this.events = {};
}
$e920725db28e929b$var$TargetEventHandlers.prototype.getEventHandlers = function() {
    function getEventHandlers(eventName, options) {
        var key = String(eventName) + " " + String($e920725db28e929b$var$eventOptionsKey(options));
        if (!this.events[key]) {
            this.events[key] = {
                handlers: [],
                handleEvent: undefined
            };
            this.events[key].nextHandlers = this.events[key].handlers;
        }
        return this.events[key];
    }
    return getEventHandlers;
}();
$e920725db28e929b$var$TargetEventHandlers.prototype.handleEvent = function() {
    function handleEvent(eventName, options, event) {
        var eventHandlers = this.getEventHandlers(eventName, options);
        eventHandlers.handlers = eventHandlers.nextHandlers;
        eventHandlers.handlers.forEach(function(handler) {
            if (handler) // We need to check for presence here because a handler function may
            // cause later handlers to get removed. This can happen if you for
            // instance have a waypoint that unmounts another waypoint as part of an
            // onEnter/onLeave handler.
            handler(event);
        });
    }
    return handleEvent;
}();
$e920725db28e929b$var$TargetEventHandlers.prototype.add = function() {
    function add(eventName, listener, options) {
        var _this = this;
        // options has already been normalized at this point.
        var eventHandlers = this.getEventHandlers(eventName, options);
        $e920725db28e929b$var$ensureCanMutateNextEventHandlers(eventHandlers);
        if (eventHandlers.nextHandlers.length === 0) {
            eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
            this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
        }
        eventHandlers.nextHandlers.push(listener);
        var isSubscribed = true;
        var unsubscribe = function() {
            function unsubscribe() {
                if (!isSubscribed) return;
                isSubscribed = false;
                $e920725db28e929b$var$ensureCanMutateNextEventHandlers(eventHandlers);
                var index = eventHandlers.nextHandlers.indexOf(listener);
                eventHandlers.nextHandlers.splice(index, 1);
                if (eventHandlers.nextHandlers.length === 0) {
                    // All event handlers have been removed, so we want to remove the event
                    // listener from the target node.
                    if (_this.target) // There can be a race condition where the target may no longer exist
                    // when this function is called, e.g. when a React component is
                    // unmounting. Guarding against this prevents the following error:
                    //
                    //   Cannot read property 'removeEventListener' of undefined
                    _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
                    eventHandlers.handleEvent = undefined;
                }
            }
            return unsubscribe;
        }();
        return unsubscribe;
    }
    return add;
}();
var $e920725db28e929b$var$EVENT_HANDLERS_KEY = "__consolidated_events_handlers__";
// eslint-disable-next-line import/prefer-default-export
function $e920725db28e929b$export$3f65cefe8380dbea(target, eventName, listener, options) {
    if (!target[$e920725db28e929b$var$EVENT_HANDLERS_KEY]) // eslint-disable-next-line no-param-reassign
    target[$e920725db28e929b$var$EVENT_HANDLERS_KEY] = new $e920725db28e929b$var$TargetEventHandlers(target);
    var normalizedEventOptions = $e920725db28e929b$var$normalizeEventOptions(options);
    return target[$e920725db28e929b$var$EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}

});

parcelRequire.register("8Rebc", function(module, exports) {
"use strict";

var $i2yNJ = parcelRequire("i2yNJ");

var $jS9v3 = parcelRequire("jS9v3");

var $bs9Fr = parcelRequire("bs9Fr");

var $hMuDe = parcelRequire("hMuDe");

var $jCeaX = parcelRequire("jCeaX");
var $672e45bf7a04cd22$var$polyfill = $jS9v3($hMuDe(), Object);
$i2yNJ($672e45bf7a04cd22$var$polyfill, {
    getPolyfill: $hMuDe,
    implementation: $bs9Fr,
    shim: $jCeaX
});
module.exports = $672e45bf7a04cd22$var$polyfill;

});
parcelRequire.register("i2yNJ", function(module, exports) {
"use strict";

var $b8vtb = parcelRequire("b8vtb");
var $d22368af35b1b5d0$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $d22368af35b1b5d0$var$toStr = Object.prototype.toString;
var $d22368af35b1b5d0$var$concat = Array.prototype.concat;

var $1FJER = parcelRequire("1FJER");
var $d22368af35b1b5d0$var$isFunction = function(fn) {
    return typeof fn === "function" && $d22368af35b1b5d0$var$toStr.call(fn) === "[object Function]";
};

var $d22368af35b1b5d0$var$supportsDescriptors = (parcelRequire("8CDym"))();
var $d22368af35b1b5d0$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$d22368af35b1b5d0$var$isFunction(predicate) || !predicate()) return;
    }
    if ($d22368af35b1b5d0$var$supportsDescriptors) $1FJER(object, name, value, true);
    else $1FJER(object, name, value);
};
var $d22368af35b1b5d0$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $b8vtb(map);
    if ($d22368af35b1b5d0$var$hasSymbols) props = $d22368af35b1b5d0$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$d22368af35b1b5d0$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$d22368af35b1b5d0$var$defineProperties.supportsDescriptors = !!$d22368af35b1b5d0$var$supportsDescriptors;
module.exports = $d22368af35b1b5d0$var$defineProperties;

});
parcelRequire.register("b8vtb", function(module, exports) {
"use strict";
var $81b8da4d1a464d3f$var$slice = Array.prototype.slice;

var $917Cr = parcelRequire("917Cr");
var $81b8da4d1a464d3f$var$origKeys = Object.keys;

var $81b8da4d1a464d3f$var$keysShim = $81b8da4d1a464d3f$var$origKeys ? function keys(o) {
    return $81b8da4d1a464d3f$var$origKeys(o);
} : (parcelRequire("hB7z5"));
var $81b8da4d1a464d3f$var$originalKeys = Object.keys;
$81b8da4d1a464d3f$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($917Cr(object)) return $81b8da4d1a464d3f$var$originalKeys($81b8da4d1a464d3f$var$slice.call(object));
            return $81b8da4d1a464d3f$var$originalKeys(object);
        };
    } else Object.keys = $81b8da4d1a464d3f$var$keysShim;
    return Object.keys || $81b8da4d1a464d3f$var$keysShim;
};
module.exports = $81b8da4d1a464d3f$var$keysShim;

});
parcelRequire.register("917Cr", function(module, exports) {
"use strict";
var $690a1e0e4fa3e65f$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $690a1e0e4fa3e65f$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $690a1e0e4fa3e65f$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("hB7z5", function(module, exports) {
"use strict";
var $ccfbc299093c74d2$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $ccfbc299093c74d2$var$has = Object.prototype.hasOwnProperty;
    var $ccfbc299093c74d2$var$toStr = Object.prototype.toString;
    var $ccfbc299093c74d2$var$isArgs = (parcelRequire("917Cr")); // eslint-disable-line global-require
    var $ccfbc299093c74d2$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $ccfbc299093c74d2$var$hasDontEnumBug = !$ccfbc299093c74d2$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $ccfbc299093c74d2$var$hasProtoEnumBug = $ccfbc299093c74d2$var$isEnumerable.call(function() {}, "prototype");
    var $ccfbc299093c74d2$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $ccfbc299093c74d2$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $ccfbc299093c74d2$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $ccfbc299093c74d2$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$ccfbc299093c74d2$var$excludedKeys["$" + k] && $ccfbc299093c74d2$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $ccfbc299093c74d2$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $ccfbc299093c74d2$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$ccfbc299093c74d2$var$hasAutomationEqualityBug) return $ccfbc299093c74d2$var$equalsConstructorPrototype(o);
        try {
            return $ccfbc299093c74d2$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $ccfbc299093c74d2$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $ccfbc299093c74d2$var$toStr.call(object) === "[object Function]";
        var isArguments = $ccfbc299093c74d2$var$isArgs(object);
        var isString = isObject && $ccfbc299093c74d2$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $ccfbc299093c74d2$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$ccfbc299093c74d2$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $ccfbc299093c74d2$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($ccfbc299093c74d2$var$hasDontEnumBug) {
            var skipConstructor = $ccfbc299093c74d2$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $ccfbc299093c74d2$var$dontEnums.length; ++k)if (!(skipConstructor && $ccfbc299093c74d2$var$dontEnums[k] === "constructor") && $ccfbc299093c74d2$var$has.call(object, $ccfbc299093c74d2$var$dontEnums[k])) theKeys.push($ccfbc299093c74d2$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $ccfbc299093c74d2$var$keysShim;

});


parcelRequire.register("1FJER", function(module, exports) {
"use strict";

var $137d097eb6278a68$var$hasPropertyDescriptors = (parcelRequire("8CDym"))();

var $5XoKB = parcelRequire("5XoKB");
var $137d097eb6278a68$var$$defineProperty = $137d097eb6278a68$var$hasPropertyDescriptors && $5XoKB("%Object.defineProperty%", true);
var $137d097eb6278a68$var$$SyntaxError = $5XoKB("%SyntaxError%");
var $137d097eb6278a68$var$$TypeError = $5XoKB("%TypeError%");

var $eJu2D = parcelRequire("eJu2D");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $137d097eb6278a68$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $137d097eb6278a68$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $137d097eb6278a68$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $137d097eb6278a68$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $137d097eb6278a68$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $137d097eb6278a68$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$eJu2D && $eJu2D(obj, property);
    if ($137d097eb6278a68$var$$defineProperty) $137d097eb6278a68$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $137d097eb6278a68$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRequire.register("8CDym", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");
var $64708dc9f5193715$var$$defineProperty = $5XoKB("%Object.defineProperty%", true);
var $64708dc9f5193715$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($64708dc9f5193715$var$$defineProperty) try {
        $64708dc9f5193715$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$64708dc9f5193715$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$64708dc9f5193715$var$hasPropertyDescriptors()) return null;
    try {
        return $64708dc9f5193715$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $64708dc9f5193715$var$hasPropertyDescriptors;

});
parcelRequire.register("5XoKB", function(module, exports) {
"use strict";
var $4565a9698af8efed$var$undefined;
var $4565a9698af8efed$var$$SyntaxError = SyntaxError;
var $4565a9698af8efed$var$$Function = Function;
var $4565a9698af8efed$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $4565a9698af8efed$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $4565a9698af8efed$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $4565a9698af8efed$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($4565a9698af8efed$var$$gOPD) try {
    $4565a9698af8efed$var$$gOPD({}, "");
} catch (e) {
    $4565a9698af8efed$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $4565a9698af8efed$var$throwTypeError = function() {
    throw new $4565a9698af8efed$var$$TypeError();
};
var $4565a9698af8efed$var$ThrowTypeError = $4565a9698af8efed$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $4565a9698af8efed$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $4565a9698af8efed$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $4565a9698af8efed$var$throwTypeError;
        }
    }
}() : $4565a9698af8efed$var$throwTypeError;

var $4565a9698af8efed$var$hasSymbols = (parcelRequire("1zrnp"))();

var $4565a9698af8efed$var$hasProto = (parcelRequire("8mH7E"))();
var $4565a9698af8efed$var$getProto = Object.getPrototypeOf || ($4565a9698af8efed$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $4565a9698af8efed$var$needsEval = {};
var $4565a9698af8efed$var$TypedArray = typeof Uint8Array === "undefined" || !$4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$undefined : $4565a9698af8efed$var$getProto(Uint8Array);
var $4565a9698af8efed$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $4565a9698af8efed$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $4565a9698af8efed$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto([][Symbol.iterator]()) : $4565a9698af8efed$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $4565a9698af8efed$var$undefined,
    "%AsyncFunction%": $4565a9698af8efed$var$needsEval,
    "%AsyncGenerator%": $4565a9698af8efed$var$needsEval,
    "%AsyncGeneratorFunction%": $4565a9698af8efed$var$needsEval,
    "%AsyncIteratorPrototype%": $4565a9698af8efed$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $4565a9698af8efed$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $4565a9698af8efed$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $4565a9698af8efed$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $4565a9698af8efed$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $4565a9698af8efed$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $4565a9698af8efed$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $4565a9698af8efed$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $4565a9698af8efed$var$undefined : FinalizationRegistry,
    "%Function%": $4565a9698af8efed$var$$Function,
    "%GeneratorFunction%": $4565a9698af8efed$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $4565a9698af8efed$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $4565a9698af8efed$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $4565a9698af8efed$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto($4565a9698af8efed$var$getProto([][Symbol.iterator]())) : $4565a9698af8efed$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $4565a9698af8efed$var$undefined,
    "%Map%": typeof Map === "undefined" ? $4565a9698af8efed$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$4565a9698af8efed$var$hasSymbols || !$4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$undefined : $4565a9698af8efed$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $4565a9698af8efed$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $4565a9698af8efed$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $4565a9698af8efed$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $4565a9698af8efed$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$4565a9698af8efed$var$hasSymbols || !$4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$undefined : $4565a9698af8efed$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $4565a9698af8efed$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $4565a9698af8efed$var$hasSymbols && $4565a9698af8efed$var$getProto ? $4565a9698af8efed$var$getProto(""[Symbol.iterator]()) : $4565a9698af8efed$var$undefined,
    "%Symbol%": $4565a9698af8efed$var$hasSymbols ? Symbol : $4565a9698af8efed$var$undefined,
    "%SyntaxError%": $4565a9698af8efed$var$$SyntaxError,
    "%ThrowTypeError%": $4565a9698af8efed$var$ThrowTypeError,
    "%TypedArray%": $4565a9698af8efed$var$TypedArray,
    "%TypeError%": $4565a9698af8efed$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $4565a9698af8efed$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $4565a9698af8efed$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $4565a9698af8efed$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $4565a9698af8efed$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $4565a9698af8efed$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $4565a9698af8efed$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $4565a9698af8efed$var$undefined : WeakSet
};
if ($4565a9698af8efed$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $4565a9698af8efed$var$errorProto = $4565a9698af8efed$var$getProto($4565a9698af8efed$var$getProto(e));
    $4565a9698af8efed$var$INTRINSICS["%Error.prototype%"] = $4565a9698af8efed$var$errorProto;
}
var $4565a9698af8efed$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $4565a9698af8efed$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $4565a9698af8efed$var$getProto) value = $4565a9698af8efed$var$getProto(gen.prototype);
    }
    $4565a9698af8efed$var$INTRINSICS[name] = value;
    return value;
};
var $4565a9698af8efed$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $dY0J9 = parcelRequire("dY0J9");

var $9fqH9 = parcelRequire("9fqH9");
var $4565a9698af8efed$var$$concat = $dY0J9.call(Function.call, Array.prototype.concat);
var $4565a9698af8efed$var$$spliceApply = $dY0J9.call(Function.apply, Array.prototype.splice);
var $4565a9698af8efed$var$$replace = $dY0J9.call(Function.call, String.prototype.replace);
var $4565a9698af8efed$var$$strSlice = $dY0J9.call(Function.call, String.prototype.slice);
var $4565a9698af8efed$var$$exec = $dY0J9.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $4565a9698af8efed$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $4565a9698af8efed$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $4565a9698af8efed$var$stringToPath = function stringToPath(string) {
    var first = $4565a9698af8efed$var$$strSlice(string, 0, 1);
    var last = $4565a9698af8efed$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $4565a9698af8efed$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $4565a9698af8efed$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $4565a9698af8efed$var$$replace(string, $4565a9698af8efed$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $4565a9698af8efed$var$$replace(subString, $4565a9698af8efed$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $4565a9698af8efed$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($9fqH9($4565a9698af8efed$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $4565a9698af8efed$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($9fqH9($4565a9698af8efed$var$INTRINSICS, intrinsicName)) {
        var value = $4565a9698af8efed$var$INTRINSICS[intrinsicName];
        if (value === $4565a9698af8efed$var$needsEval) value = $4565a9698af8efed$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $4565a9698af8efed$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $4565a9698af8efed$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $4565a9698af8efed$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $4565a9698af8efed$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($4565a9698af8efed$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $4565a9698af8efed$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $4565a9698af8efed$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $4565a9698af8efed$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $4565a9698af8efed$var$$spliceApply(parts, $4565a9698af8efed$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $4565a9698af8efed$var$$strSlice(part, 0, 1);
        var last = $4565a9698af8efed$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $4565a9698af8efed$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($9fqH9($4565a9698af8efed$var$INTRINSICS, intrinsicRealName)) value = $4565a9698af8efed$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $4565a9698af8efed$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($4565a9698af8efed$var$$gOPD && i + 1 >= parts.length) {
                var desc = $4565a9698af8efed$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $9fqH9(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $4565a9698af8efed$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("1zrnp", function(module, exports) {
"use strict";
var $124e4bbb3f3c510d$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $e6ibc = parcelRequire("e6ibc");
module.exports = function hasNativeSymbols() {
    if (typeof $124e4bbb3f3c510d$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $124e4bbb3f3c510d$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $e6ibc();
};

});
parcelRequire.register("e6ibc", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("8mH7E", function(module, exports) {
"use strict";
var $6171d3ff235c4b4e$var$test = {
    foo: {}
};
var $6171d3ff235c4b4e$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $6171d3ff235c4b4e$var$test
    }).foo === $6171d3ff235c4b4e$var$test.foo && !(({
        __proto__: null
    }) instanceof $6171d3ff235c4b4e$var$$Object);
};

});

parcelRequire.register("dY0J9", function(module, exports) {
"use strict";

var $a9gvA = parcelRequire("a9gvA");
module.exports = Function.prototype.bind || $a9gvA;

});
parcelRequire.register("a9gvA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $76378ce80e32fd91$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $76378ce80e32fd91$var$slice = Array.prototype.slice;
var $76378ce80e32fd91$var$toStr = Object.prototype.toString;
var $76378ce80e32fd91$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $76378ce80e32fd91$var$toStr.call(target) !== $76378ce80e32fd91$var$funcType) throw new TypeError($76378ce80e32fd91$var$ERROR_MESSAGE + target);
    var args = $76378ce80e32fd91$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($76378ce80e32fd91$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($76378ce80e32fd91$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("9fqH9", function(module, exports) {
"use strict";

var $dY0J9 = parcelRequire("dY0J9");
module.exports = $dY0J9.call(Function.call, Object.prototype.hasOwnProperty);

});



parcelRequire.register("eJu2D", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");
var $ab9c92447e4858f1$var$$gOPD = $5XoKB("%Object.getOwnPropertyDescriptor%", true);
if ($ab9c92447e4858f1$var$$gOPD) try {
    $ab9c92447e4858f1$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $ab9c92447e4858f1$var$$gOPD = null;
}
module.exports = $ab9c92447e4858f1$var$$gOPD;

});



parcelRequire.register("jS9v3", function(module, exports) {
"use strict";

var $dY0J9 = parcelRequire("dY0J9");

var $5XoKB = parcelRequire("5XoKB");
var $e77a6dec9495dcaa$var$$apply = $5XoKB("%Function.prototype.apply%");
var $e77a6dec9495dcaa$var$$call = $5XoKB("%Function.prototype.call%");
var $e77a6dec9495dcaa$var$$reflectApply = $5XoKB("%Reflect.apply%", true) || $dY0J9.call($e77a6dec9495dcaa$var$$call, $e77a6dec9495dcaa$var$$apply);
var $e77a6dec9495dcaa$var$$gOPD = $5XoKB("%Object.getOwnPropertyDescriptor%", true);
var $e77a6dec9495dcaa$var$$defineProperty = $5XoKB("%Object.defineProperty%", true);
var $e77a6dec9495dcaa$var$$max = $5XoKB("%Math.max%");
if ($e77a6dec9495dcaa$var$$defineProperty) try {
    $e77a6dec9495dcaa$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e77a6dec9495dcaa$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $e77a6dec9495dcaa$var$$reflectApply($dY0J9, $e77a6dec9495dcaa$var$$call, arguments);
    if ($e77a6dec9495dcaa$var$$gOPD && $e77a6dec9495dcaa$var$$defineProperty) {
        var desc = $e77a6dec9495dcaa$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $e77a6dec9495dcaa$var$$defineProperty(func, "length", {
            value: 1 + $e77a6dec9495dcaa$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $e77a6dec9495dcaa$var$applyBind = function applyBind() {
    return $e77a6dec9495dcaa$var$$reflectApply($dY0J9, $e77a6dec9495dcaa$var$$apply, arguments);
};
if ($e77a6dec9495dcaa$var$$defineProperty) $e77a6dec9495dcaa$var$$defineProperty(module.exports, "apply", {
    value: $e77a6dec9495dcaa$var$applyBind
});
else module.exports.apply = $e77a6dec9495dcaa$var$applyBind;

});

parcelRequire.register("bs9Fr", function(module, exports) {
"use strict";

var $lCvBI = parcelRequire("lCvBI");

var $l28vI = parcelRequire("l28vI");
var $8569cefcc3fc1c24$var$$isEnumerable = $l28vI("Object.prototype.propertyIsEnumerable");
var $8569cefcc3fc1c24$var$$push = $l28vI("Array.prototype.push");
module.exports = function values(O) {
    var obj = $lCvBI(O);
    var vals = [];
    for(var key in obj)if ($8569cefcc3fc1c24$var$$isEnumerable(obj, key)) $8569cefcc3fc1c24$var$$push(vals, obj[key]);
    return vals;
};

});
parcelRequire.register("lCvBI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2JB1w"));

});
parcelRequire.register("2JB1w", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");
var $1fdc80d69b80c805$var$$TypeError = $5XoKB("%TypeError%");
// http://262.ecma-international.org/5.1/#sec-9.10
module.exports = function CheckObjectCoercible(value, optMessage) {
    if (value == null) throw new $1fdc80d69b80c805$var$$TypeError(optMessage || "Cannot call method on " + value);
    return value;
};

});


parcelRequire.register("l28vI", function(module, exports) {
"use strict";

var $5XoKB = parcelRequire("5XoKB");

var $jS9v3 = parcelRequire("jS9v3");
var $f50062e307a9927c$var$$indexOf = $jS9v3($5XoKB("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $5XoKB(name, !!allowMissing);
    if (typeof intrinsic === "function" && $f50062e307a9927c$var$$indexOf(name, ".prototype.") > -1) return $jS9v3(intrinsic);
    return intrinsic;
};

});


parcelRequire.register("hMuDe", function(module, exports) {
"use strict";

var $bs9Fr = parcelRequire("bs9Fr");
module.exports = function getPolyfill() {
    return typeof Object.values === "function" ? Object.values : $bs9Fr;
};

});

parcelRequire.register("jCeaX", function(module, exports) {
"use strict";

var $hMuDe = parcelRequire("hMuDe");

var $i2yNJ = parcelRequire("i2yNJ");
module.exports = function shimValues() {
    var polyfill = $hMuDe();
    $i2yNJ(Object, {
        values: polyfill
    }, {
        values: function testValues() {
            return Object.values !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRequire.register("5Spdc", function(module, exports) {
"use strict";

var $i2yNJ = parcelRequire("i2yNJ");

var $0yTfp = parcelRequire("0yTfp");

var $8EjJ9 = parcelRequire("8EjJ9");
var $44758d774ae67c36$var$polyfill = $8EjJ9();

var $eEbjh = parcelRequire("eEbjh");
var $44758d774ae67c36$var$boundContains = function contains(node, other) {
    return $44758d774ae67c36$var$polyfill.apply(node, [
        other
    ]);
};
$i2yNJ($44758d774ae67c36$var$boundContains, {
    getPolyfill: $8EjJ9,
    implementation: $0yTfp,
    shim: $eEbjh
});
module.exports = $44758d774ae67c36$var$boundContains;

});
parcelRequire.register("0yTfp", function(module, exports) {
"use strict";
module.exports = function contains(other) {
    if (arguments.length < 1) throw new TypeError("1 argument is required");
    if (typeof other !== "object") throw new TypeError("Argument 1 (”other“) to Node.contains must be an instance of Node");
    var node = other;
    do {
        if (this === node) return true;
        if (node) node = node.parentNode;
    }while (node);
    return false;
};

});

parcelRequire.register("8EjJ9", function(module, exports) {
"use strict";

var $0yTfp = parcelRequire("0yTfp");
module.exports = function getPolyfill() {
    if (typeof document !== "undefined") {
        if (document.contains) return document.contains;
        if (document.body && document.body.contains) try {
            if (typeof document.body.contains.call(document, "") === "boolean") return document.body.contains;
        } catch (e) {}
    }
    return $0yTfp;
};

});

parcelRequire.register("eEbjh", function(module, exports) {
"use strict";

var $i2yNJ = parcelRequire("i2yNJ");

var $8EjJ9 = parcelRequire("8EjJ9");
module.exports = function shimContains() {
    var polyfill = $8EjJ9();
    if (typeof document !== "undefined") {
        $i2yNJ(document, {
            contains: polyfill
        }, {
            contains: function() {
                return document.contains !== polyfill;
            }
        });
        if (typeof Element !== "undefined") $i2yNJ(Element.prototype, {
            contains: polyfill
        }, {
            contains: function() {
                return Element.prototype.contains !== polyfill;
            }
        });
    }
    return polyfill;
};

});



parcelRequire.register("bBc9P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871c949f46815a7e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $exYeM = parcelRequire("exYeM");
var $871c949f46815a7e$var$_react2 = $871c949f46815a7e$var$_interopRequireDefault($exYeM);

var $bisEj = parcelRequire("bisEj");
var $871c949f46815a7e$var$_propTypes2 = $871c949f46815a7e$var$_interopRequireDefault($bisEj);
function $871c949f46815a7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $871c949f46815a7e$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $871c949f46815a7e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $871c949f46815a7e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $871c949f46815a7e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $871c949f46815a7e$var$InfiniteScroll = function(_Component) {
    $871c949f46815a7e$var$_inherits(InfiniteScroll, _Component);
    function InfiniteScroll(props) {
        $871c949f46815a7e$var$_classCallCheck(this, InfiniteScroll);
        var _this = $871c949f46815a7e$var$_possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));
        _this.scrollListener = _this.scrollListener.bind(_this);
        _this.eventListenerOptions = _this.eventListenerOptions.bind(_this);
        _this.mousewheelListener = _this.mousewheelListener.bind(_this);
        return _this;
    }
    $871c949f46815a7e$var$_createClass(InfiniteScroll, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.pageLoaded = this.props.pageStart;
                this.options = this.eventListenerOptions();
                this.attachScrollListener();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.isReverse && this.loadMore) {
                    var parentElement = this.getParentElement(this.scrollComponent);
                    parentElement.scrollTop = parentElement.scrollHeight - this.beforeScrollHeight + this.beforeScrollTop;
                    this.loadMore = false;
                }
                this.attachScrollListener();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.detachScrollListener();
                this.detachMousewheelListener();
            }
        },
        {
            key: "isPassiveSupported",
            value: function isPassiveSupported() {
                var passive = false;
                var testOptions = {
                    get passive () {
                        passive = true;
                    }
                };
                try {
                    document.addEventListener("test", null, testOptions);
                    document.removeEventListener("test", null, testOptions);
                } catch (e) {
                // ignore
                }
                return passive;
            }
        },
        {
            key: "eventListenerOptions",
            value: function eventListenerOptions() {
                var options = this.props.useCapture;
                if (this.isPassiveSupported()) options = {
                    useCapture: this.props.useCapture,
                    passive: true
                };
                else options = {
                    passive: false
                };
                return options;
            }
        },
        {
            key: "setDefaultLoader",
            value: function setDefaultLoader(loader) {
                this.defaultLoader = loader;
            }
        },
        {
            key: "detachMousewheelListener",
            value: function detachMousewheelListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.scrollComponent.parentNode;
                scrollEl.removeEventListener("mousewheel", this.mousewheelListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: "detachScrollListener",
            value: function detachScrollListener() {
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = this.getParentElement(this.scrollComponent);
                scrollEl.removeEventListener("scroll", this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.removeEventListener("resize", this.scrollListener, this.options ? this.options : this.props.useCapture);
            }
        },
        {
            key: "getParentElement",
            value: function getParentElement(el) {
                var scrollParent = this.props.getScrollParent && this.props.getScrollParent();
                if (scrollParent != null) return scrollParent;
                return el && el.parentNode;
            }
        },
        {
            key: "filterProps",
            value: function filterProps(props) {
                return props;
            }
        },
        {
            key: "attachScrollListener",
            value: function attachScrollListener() {
                var parentElement = this.getParentElement(this.scrollComponent);
                if (!this.props.hasMore || !parentElement) return;
                var scrollEl = window;
                if (this.props.useWindow === false) scrollEl = parentElement;
                scrollEl.addEventListener("mousewheel", this.mousewheelListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener("scroll", this.scrollListener, this.options ? this.options : this.props.useCapture);
                scrollEl.addEventListener("resize", this.scrollListener, this.options ? this.options : this.props.useCapture);
                if (this.props.initialLoad) this.scrollListener();
            }
        },
        {
            key: "mousewheelListener",
            value: function mousewheelListener(e) {
                // Prevents Chrome hangups
                // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
                if (e.deltaY === 1 && !this.isPassiveSupported()) e.preventDefault();
            }
        },
        {
            key: "scrollListener",
            value: function scrollListener() {
                var el = this.scrollComponent;
                var scrollEl = window;
                var parentNode = this.getParentElement(el);
                var offset = void 0;
                if (this.props.useWindow) {
                    var doc = document.documentElement || document.body.parentNode || document.body;
                    var scrollTop = scrollEl.pageYOffset !== undefined ? scrollEl.pageYOffset : doc.scrollTop;
                    if (this.props.isReverse) offset = scrollTop;
                    else offset = this.calculateOffset(el, scrollTop);
                } else if (this.props.isReverse) offset = parentNode.scrollTop;
                else offset = el.scrollHeight - parentNode.scrollTop - parentNode.clientHeight;
                // Here we make sure the element is visible as well as checking the offset
                if (offset < Number(this.props.threshold) && el && el.offsetParent !== null) {
                    this.detachScrollListener();
                    this.beforeScrollHeight = parentNode.scrollHeight;
                    this.beforeScrollTop = parentNode.scrollTop;
                    // Call loadMore after detachScrollListener to allow for non-async loadMore functions
                    if (typeof this.props.loadMore === "function") {
                        this.props.loadMore(this.pageLoaded += 1);
                        this.loadMore = true;
                    }
                }
            }
        },
        {
            key: "calculateOffset",
            value: function calculateOffset(el, scrollTop) {
                if (!el) return 0;
                return this.calculateTopPosition(el) + (el.offsetHeight - scrollTop - window.innerHeight);
            }
        },
        {
            key: "calculateTopPosition",
            value: function calculateTopPosition(el) {
                if (!el) return 0;
                return el.offsetTop + this.calculateTopPosition(el.offsetParent);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var renderProps = this.filterProps(this.props);
                var children = renderProps.children, element = renderProps.element, hasMore = renderProps.hasMore, initialLoad = renderProps.initialLoad, isReverse = renderProps.isReverse, loader = renderProps.loader, loadMore = renderProps.loadMore, pageStart = renderProps.pageStart, ref = renderProps.ref, threshold = renderProps.threshold, useCapture = renderProps.useCapture, useWindow = renderProps.useWindow, getScrollParent = renderProps.getScrollParent, props = $871c949f46815a7e$var$_objectWithoutProperties(renderProps, [
                    "children",
                    "element",
                    "hasMore",
                    "initialLoad",
                    "isReverse",
                    "loader",
                    "loadMore",
                    "pageStart",
                    "ref",
                    "threshold",
                    "useCapture",
                    "useWindow",
                    "getScrollParent"
                ]);
                props.ref = function(node) {
                    _this2.scrollComponent = node;
                    if (ref) ref(node);
                };
                var childrenArray = [
                    children
                ];
                if (hasMore) {
                    if (loader) isReverse ? childrenArray.unshift(loader) : childrenArray.push(loader);
                    else if (this.defaultLoader) isReverse ? childrenArray.unshift(this.defaultLoader) : childrenArray.push(this.defaultLoader);
                }
                return $871c949f46815a7e$var$_react2.default.createElement(element, props, childrenArray);
            }
        }
    ]);
    return InfiniteScroll;
}($exYeM.Component);
$871c949f46815a7e$var$InfiniteScroll.propTypes = {
    children: $871c949f46815a7e$var$_propTypes2.default.node.isRequired,
    element: $871c949f46815a7e$var$_propTypes2.default.node,
    hasMore: $871c949f46815a7e$var$_propTypes2.default.bool,
    initialLoad: $871c949f46815a7e$var$_propTypes2.default.bool,
    isReverse: $871c949f46815a7e$var$_propTypes2.default.bool,
    loader: $871c949f46815a7e$var$_propTypes2.default.node,
    loadMore: $871c949f46815a7e$var$_propTypes2.default.func.isRequired,
    pageStart: $871c949f46815a7e$var$_propTypes2.default.number,
    ref: $871c949f46815a7e$var$_propTypes2.default.func,
    getScrollParent: $871c949f46815a7e$var$_propTypes2.default.func,
    threshold: $871c949f46815a7e$var$_propTypes2.default.number,
    useCapture: $871c949f46815a7e$var$_propTypes2.default.bool,
    useWindow: $871c949f46815a7e$var$_propTypes2.default.bool
};
$871c949f46815a7e$var$InfiniteScroll.defaultProps = {
    element: "div",
    hasMore: false,
    initialLoad: true,
    pageStart: 0,
    ref: null,
    threshold: 250,
    useWindow: true,
    isReverse: false,
    useCapture: false,
    loader: null,
    getScrollParent: null
};
module.exports.default = $871c949f46815a7e$var$InfiniteScroll;
module.exports = module.exports["default"];

});

parcelRequire.register("5GlTO", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRequire.register("jPR8W", function(module, exports) {
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command("cut");
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                    var fakeElement = document.createElement("textarea"); // Prevent zooming on iOS
                    fakeElement.style.fontSize = "12pt"; // Reset box model
                    fakeElement.style.border = "0";
                    fakeElement.style.padding = "0";
                    fakeElement.style.margin = "0"; // Move element out of screen horizontally
                    fakeElement.style.position = "absolute";
                    fakeElement.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute("readonly", "");
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command("copy");
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = "";
                    if (typeof target === "string") selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "password"
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command("copy");
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== "copy" && action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === "object" && target.nodeType === 1) {
                            if (action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === "cut" ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || "copy";
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? "success" : "error", {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});

});

parcelRequire.register("675Yl", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hvCjw"));

});
parcelRequire.register("hvCjw", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $cbf30d47bd3c9121$export$ffb0004e005737fa; }, function (v) { return $cbf30d47bd3c9121$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $cbf30d47bd3c9121$export$5f8d39834fd61797; }, function (v) { return $cbf30d47bd3c9121$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $cbf30d47bd3c9121$export$e2c29f18771995cb; }, function (v) { return $cbf30d47bd3c9121$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $cbf30d47bd3c9121$export$74bf444e3cd11ea5; }, function (v) { return $cbf30d47bd3c9121$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $cbf30d47bd3c9121$export$dca3b0875bd9a954; }, function (v) { return $cbf30d47bd3c9121$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $cbf30d47bd3c9121$export$16fa2f45be04daa8; }, function (v) { return $cbf30d47bd3c9121$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $cbf30d47bd3c9121$export$221d75b3f55bb0bd; }, function (v) { return $cbf30d47bd3c9121$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $cbf30d47bd3c9121$export$ae55be85d98224ed; }, function (v) { return $cbf30d47bd3c9121$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $cbf30d47bd3c9121$export$e530037191fcd5d7; }, function (v) { return $cbf30d47bd3c9121$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $cbf30d47bd3c9121$export$fd42f52fd3ae1109; }, function (v) { return $cbf30d47bd3c9121$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $cbf30d47bd3c9121$export$c8a8987d4410bf2d; }, function (v) { return $cbf30d47bd3c9121$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $cbf30d47bd3c9121$export$d38cd72104c1f0e9; }, function (v) { return $cbf30d47bd3c9121$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $cbf30d47bd3c9121$export$7d1e3a5e95ceca43; }, function (v) { return $cbf30d47bd3c9121$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $cbf30d47bd3c9121$export$257a8862b851cb5b; }, function (v) { return $cbf30d47bd3c9121$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $cbf30d47bd3c9121$export$a8257692ac88316c; }, function (v) { return $cbf30d47bd3c9121$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $cbf30d47bd3c9121$export$488013bae63b21da; }, function (v) { return $cbf30d47bd3c9121$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $cbf30d47bd3c9121$export$7c73462e0d25e514; }, function (v) { return $cbf30d47bd3c9121$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $cbf30d47bd3c9121$export$35808ee640e87ca7; }, function (v) { return $cbf30d47bd3c9121$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $cbf30d47bd3c9121$export$fae74005e78b1a27; }, function (v) { return $cbf30d47bd3c9121$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $cbf30d47bd3c9121$export$dc8fbce3eb94dc1e; }, function (v) { return $cbf30d47bd3c9121$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $cbf30d47bd3c9121$export$6d9c69b0de29b591; }, function (v) { return $cbf30d47bd3c9121$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $cbf30d47bd3c9121$export$d5a552a76deda3c2; }, function (v) { return $cbf30d47bd3c9121$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $cbf30d47bd3c9121$export$e5c5a5f917a5871c; }, function (v) { return $cbf30d47bd3c9121$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $cbf30d47bd3c9121$export$1538c33de8887b59; }, function (v) { return $cbf30d47bd3c9121$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $cbf30d47bd3c9121$export$13e3392192263954; }, function (v) { return $cbf30d47bd3c9121$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $cbf30d47bd3c9121$export$b8f5890fc79d6aca; }, function (v) { return $cbf30d47bd3c9121$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $cbf30d47bd3c9121$export$60241385465d0a34; }, function (v) { return $cbf30d47bd3c9121$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $cbf30d47bd3c9121$export$83d89fbfd8236492; }, function (v) { return $cbf30d47bd3c9121$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf30d47bd3c9121$export$ffb0004e005737fa;
var $cbf30d47bd3c9121$export$5f8d39834fd61797;
var $cbf30d47bd3c9121$export$e2c29f18771995cb;
var $cbf30d47bd3c9121$export$74bf444e3cd11ea5;
var $cbf30d47bd3c9121$export$dca3b0875bd9a954;
var $cbf30d47bd3c9121$export$16fa2f45be04daa8;
var $cbf30d47bd3c9121$export$221d75b3f55bb0bd;
var $cbf30d47bd3c9121$export$ae55be85d98224ed;
var $cbf30d47bd3c9121$export$e530037191fcd5d7;
var $cbf30d47bd3c9121$export$fd42f52fd3ae1109;
var $cbf30d47bd3c9121$export$c8a8987d4410bf2d;
var $cbf30d47bd3c9121$export$d38cd72104c1f0e9;
var $cbf30d47bd3c9121$export$7d1e3a5e95ceca43;
var $cbf30d47bd3c9121$export$257a8862b851cb5b;
var $cbf30d47bd3c9121$export$a8257692ac88316c;
var $cbf30d47bd3c9121$export$488013bae63b21da;
var $cbf30d47bd3c9121$export$7c73462e0d25e514;
var $cbf30d47bd3c9121$export$35808ee640e87ca7;
var $cbf30d47bd3c9121$export$fae74005e78b1a27;
var $cbf30d47bd3c9121$export$dc8fbce3eb94dc1e;
var $cbf30d47bd3c9121$export$6d9c69b0de29b591;
var $cbf30d47bd3c9121$export$d5a552a76deda3c2;
var $cbf30d47bd3c9121$export$e5c5a5f917a5871c;
var $cbf30d47bd3c9121$export$1538c33de8887b59;
var $cbf30d47bd3c9121$export$13e3392192263954;
var $cbf30d47bd3c9121$export$b8f5890fc79d6aca;
var $cbf30d47bd3c9121$export$60241385465d0a34;
var $cbf30d47bd3c9121$export$83d89fbfd8236492;
"use strict";

var $j8GnD = parcelRequire("j8GnD");
var $cbf30d47bd3c9121$var$n = 60103, $cbf30d47bd3c9121$var$p = 60106;
$cbf30d47bd3c9121$export$ffb0004e005737fa = 60107;
$cbf30d47bd3c9121$export$5f8d39834fd61797 = 60108;
$cbf30d47bd3c9121$export$e2c29f18771995cb = 60114;
var $cbf30d47bd3c9121$var$q = 60109, $cbf30d47bd3c9121$var$r = 60110, $cbf30d47bd3c9121$var$t = 60112;
$cbf30d47bd3c9121$export$74bf444e3cd11ea5 = 60113;
var $cbf30d47bd3c9121$var$u = 60115, $cbf30d47bd3c9121$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $cbf30d47bd3c9121$var$w = Symbol.for;
    $cbf30d47bd3c9121$var$n = $cbf30d47bd3c9121$var$w("react.element");
    $cbf30d47bd3c9121$var$p = $cbf30d47bd3c9121$var$w("react.portal");
    $cbf30d47bd3c9121$export$ffb0004e005737fa = $cbf30d47bd3c9121$var$w("react.fragment");
    $cbf30d47bd3c9121$export$5f8d39834fd61797 = $cbf30d47bd3c9121$var$w("react.strict_mode");
    $cbf30d47bd3c9121$export$e2c29f18771995cb = $cbf30d47bd3c9121$var$w("react.profiler");
    $cbf30d47bd3c9121$var$q = $cbf30d47bd3c9121$var$w("react.provider");
    $cbf30d47bd3c9121$var$r = $cbf30d47bd3c9121$var$w("react.context");
    $cbf30d47bd3c9121$var$t = $cbf30d47bd3c9121$var$w("react.forward_ref");
    $cbf30d47bd3c9121$export$74bf444e3cd11ea5 = $cbf30d47bd3c9121$var$w("react.suspense");
    $cbf30d47bd3c9121$var$u = $cbf30d47bd3c9121$var$w("react.memo");
    $cbf30d47bd3c9121$var$v = $cbf30d47bd3c9121$var$w("react.lazy");
}
var $cbf30d47bd3c9121$var$x = "function" === typeof Symbol && Symbol.iterator;
function $cbf30d47bd3c9121$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $cbf30d47bd3c9121$var$x && a[$cbf30d47bd3c9121$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $cbf30d47bd3c9121$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $cbf30d47bd3c9121$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $cbf30d47bd3c9121$var$B = {};
function $cbf30d47bd3c9121$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $cbf30d47bd3c9121$var$B;
    this.updater = c || $cbf30d47bd3c9121$var$A;
}
$cbf30d47bd3c9121$var$C.prototype.isReactComponent = {};
$cbf30d47bd3c9121$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($cbf30d47bd3c9121$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$cbf30d47bd3c9121$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $cbf30d47bd3c9121$var$D() {}
$cbf30d47bd3c9121$var$D.prototype = $cbf30d47bd3c9121$var$C.prototype;
function $cbf30d47bd3c9121$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $cbf30d47bd3c9121$var$B;
    this.updater = c || $cbf30d47bd3c9121$var$A;
}
var $cbf30d47bd3c9121$var$F = $cbf30d47bd3c9121$var$E.prototype = new $cbf30d47bd3c9121$var$D;
$cbf30d47bd3c9121$var$F.constructor = $cbf30d47bd3c9121$var$E;
$j8GnD($cbf30d47bd3c9121$var$F, $cbf30d47bd3c9121$var$C.prototype);
$cbf30d47bd3c9121$var$F.isPureReactComponent = !0;
var $cbf30d47bd3c9121$var$G = {
    current: null
}, $cbf30d47bd3c9121$var$H = Object.prototype.hasOwnProperty, $cbf30d47bd3c9121$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $cbf30d47bd3c9121$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$cbf30d47bd3c9121$var$H.call(b, e) && !$cbf30d47bd3c9121$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $cbf30d47bd3c9121$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $cbf30d47bd3c9121$var$G.current
    };
}
function $cbf30d47bd3c9121$var$K(a, b) {
    return {
        $$typeof: $cbf30d47bd3c9121$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $cbf30d47bd3c9121$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cbf30d47bd3c9121$var$n;
}
function $cbf30d47bd3c9121$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $cbf30d47bd3c9121$var$M = /\/+/g;
function $cbf30d47bd3c9121$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $cbf30d47bd3c9121$var$escape("" + a.key) : b.toString(36);
}
function $cbf30d47bd3c9121$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $cbf30d47bd3c9121$var$n:
                case $cbf30d47bd3c9121$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $cbf30d47bd3c9121$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($cbf30d47bd3c9121$var$M, "$&/") + "/"), $cbf30d47bd3c9121$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($cbf30d47bd3c9121$var$L(d) && (d = $cbf30d47bd3c9121$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($cbf30d47bd3c9121$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $cbf30d47bd3c9121$var$N(k, g);
        h += $cbf30d47bd3c9121$var$O(k, b, c, f, d);
    }
    else if (f = $cbf30d47bd3c9121$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $cbf30d47bd3c9121$var$N(k, g++), h += $cbf30d47bd3c9121$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($cbf30d47bd3c9121$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $cbf30d47bd3c9121$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $cbf30d47bd3c9121$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $cbf30d47bd3c9121$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $cbf30d47bd3c9121$var$R = {
    current: null
};
function $cbf30d47bd3c9121$var$S() {
    var a = $cbf30d47bd3c9121$var$R.current;
    if (null === a) throw Error($cbf30d47bd3c9121$var$z(321));
    return a;
}
var $cbf30d47bd3c9121$var$T = {
    ReactCurrentDispatcher: $cbf30d47bd3c9121$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $cbf30d47bd3c9121$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $j8GnD
};
$cbf30d47bd3c9121$export$dca3b0875bd9a954 = {
    map: $cbf30d47bd3c9121$var$P,
    forEach: function(a, b, c) {
        $cbf30d47bd3c9121$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $cbf30d47bd3c9121$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $cbf30d47bd3c9121$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$cbf30d47bd3c9121$var$L(a)) throw Error($cbf30d47bd3c9121$var$z(143));
        return a;
    }
};
$cbf30d47bd3c9121$export$16fa2f45be04daa8 = $cbf30d47bd3c9121$var$C;
$cbf30d47bd3c9121$export$221d75b3f55bb0bd = $cbf30d47bd3c9121$var$E;
$cbf30d47bd3c9121$export$ae55be85d98224ed = $cbf30d47bd3c9121$var$T;
$cbf30d47bd3c9121$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($cbf30d47bd3c9121$var$z(267, a));
    var e = $j8GnD({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $cbf30d47bd3c9121$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$cbf30d47bd3c9121$var$H.call(b, f) && !$cbf30d47bd3c9121$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $cbf30d47bd3c9121$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$cbf30d47bd3c9121$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $cbf30d47bd3c9121$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $cbf30d47bd3c9121$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$cbf30d47bd3c9121$export$c8a8987d4410bf2d = $cbf30d47bd3c9121$var$J;
$cbf30d47bd3c9121$export$d38cd72104c1f0e9 = function(a) {
    var b = $cbf30d47bd3c9121$var$J.bind(null, a);
    b.type = a;
    return b;
};
$cbf30d47bd3c9121$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$cbf30d47bd3c9121$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $cbf30d47bd3c9121$var$t,
        render: a
    };
};
$cbf30d47bd3c9121$export$a8257692ac88316c = $cbf30d47bd3c9121$var$L;
$cbf30d47bd3c9121$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $cbf30d47bd3c9121$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $cbf30d47bd3c9121$var$Q
    };
};
$cbf30d47bd3c9121$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $cbf30d47bd3c9121$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$cbf30d47bd3c9121$export$35808ee640e87ca7 = function(a, b) {
    return $cbf30d47bd3c9121$var$S().useCallback(a, b);
};
$cbf30d47bd3c9121$export$fae74005e78b1a27 = function(a, b) {
    return $cbf30d47bd3c9121$var$S().useContext(a, b);
};
$cbf30d47bd3c9121$export$dc8fbce3eb94dc1e = function() {};
$cbf30d47bd3c9121$export$6d9c69b0de29b591 = function(a, b) {
    return $cbf30d47bd3c9121$var$S().useEffect(a, b);
};
$cbf30d47bd3c9121$export$d5a552a76deda3c2 = function(a, b, c) {
    return $cbf30d47bd3c9121$var$S().useImperativeHandle(a, b, c);
};
$cbf30d47bd3c9121$export$e5c5a5f917a5871c = function(a, b) {
    return $cbf30d47bd3c9121$var$S().useLayoutEffect(a, b);
};
$cbf30d47bd3c9121$export$1538c33de8887b59 = function(a, b) {
    return $cbf30d47bd3c9121$var$S().useMemo(a, b);
};
$cbf30d47bd3c9121$export$13e3392192263954 = function(a, b, c) {
    return $cbf30d47bd3c9121$var$S().useReducer(a, b, c);
};
$cbf30d47bd3c9121$export$b8f5890fc79d6aca = function(a) {
    return $cbf30d47bd3c9121$var$S().useRef(a);
};
$cbf30d47bd3c9121$export$60241385465d0a34 = function(a) {
    return $cbf30d47bd3c9121$var$S().useState(a);
};
$cbf30d47bd3c9121$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("j8GnD", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $deefa37a789291dc$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $deefa37a789291dc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $deefa37a789291dc$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $deefa37a789291dc$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $deefa37a789291dc$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $deefa37a789291dc$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $deefa37a789291dc$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($deefa37a789291dc$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($deefa37a789291dc$var$getOwnPropertySymbols) {
            symbols = $deefa37a789291dc$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($deefa37a789291dc$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRequire.register("1LeEK", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; });
$parcel$export(module.exports, "browserPerformanceTimeOrigin", function () { return browserPerformanceTimeOrigin; });

var $g11oe = parcelRequire("g11oe");

var $j8hA7 = parcelRequire("j8hA7");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $j8hA7.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $g11oe.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $g11oe.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
})();

});
parcelRequire.register("g11oe", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; });

var $kol7a = parcelRequire("kol7a");

var $6qd2L = parcelRequire("6qd2L");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $kol7a.isBrowserBundle)() && Object.prototype.toString.call(typeof $6qd2L !== "undefined" ? $6qd2L : 0) === "[object process]";
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, "process");
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRequire.register("kol7a", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $ed866d75309c1265$export$2928c40372e623c0; });
$parcel$export(module.exports, "getSDKSource", function () { return $ed866d75309c1265$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $ed866d75309c1265$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $ed866d75309c1265$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRequire.register("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("j8hA7", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $dedc66ff3063d1c8$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $dedc66ff3063d1c8$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $dedc66ff3063d1c8$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $dedc66ff3063d1c8$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $dedc66ff3063d1c8$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $dedc66ff3063d1c8$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $dedc66ff3063d1c8$var$isGlobalObj(window) || typeof self == "object" && $dedc66ff3063d1c8$var$isGlobalObj(self) || typeof $parcel$global == "object" && $dedc66ff3063d1c8$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $dedc66ff3063d1c8$export$256479dc0cea61c4() {
    return $dedc66ff3063d1c8$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $dedc66ff3063d1c8$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $dedc66ff3063d1c8$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));


var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";

var $d2lNW = parcelRequire("d2lNW");
var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $d2lNW.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $d2lNW.hydrateRoot;




/**
 * React Router DOM v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");
/**
 * React Router v6.16.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $exYeM = parcelRequire("exYeM");
/**
 * @remix-run/router v1.9.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d09e32d367368ff7$var$_extends() {
    $d09e32d367368ff7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d09e32d367368ff7$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d09e32d367368ff7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d09e32d367368ff7$export$e19cd5f9376f8cee || ($d09e32d367368ff7$export$e19cd5f9376f8cee = {}));
const $d09e32d367368ff7$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d09e32d367368ff7$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d09e32d367368ff7$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d09e32d367368ff7$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d09e32d367368ff7$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d09e32d367368ff7$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d09e32d367368ff7$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d09e32d367368ff7$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d09e32d367368ff7$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d09e32d367368ff7$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d09e32d367368ff7$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d09e32d367368ff7$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d09e32d367368ff7$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d09e32d367368ff7$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d09e32d367368ff7$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d09e32d367368ff7$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d09e32d367368ff7$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d09e32d367368ff7$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d09e32d367368ff7$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let location = $d09e32d367368ff7$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d09e32d367368ff7$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d09e32d367368ff7$export$fe53371bee54353d(to);
        $d09e32d367368ff7$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d09e32d367368ff7$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d09e32d367368ff7$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d09e32d367368ff7$var$ResultType || ($d09e32d367368ff7$var$ResultType = {}));
const $d09e32d367368ff7$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d09e32d367368ff7$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d09e32d367368ff7$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d09e32d367368ff7$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d09e32d367368ff7$var$isIndexRoute(route)) {
            let indexRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d09e32d367368ff7$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d09e32d367368ff7$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d09e32d367368ff7$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d09e32d367368ff7$var$flattenRoutes(routes);
    $d09e32d367368ff7$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $d09e32d367368ff7$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $d09e32d367368ff7$var$safelyDecodeURI(pathname));
    return matches;
}
function $d09e32d367368ff7$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d09e32d367368ff7$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d09e32d367368ff7$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d09e32d367368ff7$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d09e32d367368ff7$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d09e32d367368ff7$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d09e32d367368ff7$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d09e32d367368ff7$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d09e32d367368ff7$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d09e32d367368ff7$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d09e32d367368ff7$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d09e32d367368ff7$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d09e32d367368ff7$var$paramRe = /^:\w+$/;
const $d09e32d367368ff7$var$dynamicSegmentValue = 3;
const $d09e32d367368ff7$var$indexRouteValue = 2;
const $d09e32d367368ff7$var$emptySegmentValue = 1;
const $d09e32d367368ff7$var$staticSegmentValue = 10;
const $d09e32d367368ff7$var$splatPenalty = -2;
const $d09e32d367368ff7$var$isSplat = (s)=>s === "*";
function $d09e32d367368ff7$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d09e32d367368ff7$var$isSplat)) initialScore += $d09e32d367368ff7$var$splatPenalty;
    if (index) initialScore += $d09e32d367368ff7$var$indexRouteValue;
    return segments.filter((s)=>!$d09e32d367368ff7$var$isSplat(s)).reduce((score, segment)=>score + ($d09e32d367368ff7$var$paramRe.test(segment) ? $d09e32d367368ff7$var$dynamicSegmentValue : segment === "" ? $d09e32d367368ff7$var$emptySegmentValue : $d09e32d367368ff7$var$staticSegmentValue), initialScore);
}
function $d09e32d367368ff7$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d09e32d367368ff7$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d09e32d367368ff7$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d09e32d367368ff7$export$a5c6d149b50c1d86($d09e32d367368ff7$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d09e32d367368ff7$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d09e32d367368ff7$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d09e32d367368ff7$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d09e32d367368ff7$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $d09e32d367368ff7$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $d09e32d367368ff7$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d09e32d367368ff7$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d09e32d367368ff7$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $d09e32d367368ff7$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $d09e32d367368ff7$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $d09e32d367368ff7$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d09e32d367368ff7$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d09e32d367368ff7$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d09e32d367368ff7$var$normalizeSearch(search),
        hash: $d09e32d367368ff7$var$normalizeHash(hash)
    };
}
function $d09e32d367368ff7$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d09e32d367368ff7$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d09e32d367368ff7$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $d09e32d367368ff7$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d09e32d367368ff7$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d09e32d367368ff7$var$_extends({}, toArg);
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d09e32d367368ff7$var$getInvalidPathError("?", "pathname", "search", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "pathname", "hash", to));
        $d09e32d367368ff7$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d09e32d367368ff7$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d09e32d367368ff7$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d09e32d367368ff7$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d09e32d367368ff7$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d09e32d367368ff7$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d09e32d367368ff7$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d09e32d367368ff7$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d09e32d367368ff7$export$42a99a7a4bc0e76a extends Error {
}
class $d09e32d367368ff7$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d09e32d367368ff7$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d09e32d367368ff7$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d09e32d367368ff7$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d09e32d367368ff7$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $d09e32d367368ff7$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d09e32d367368ff7$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d09e32d367368ff7$var$unwrapTrackedPromise(value) {
    if (!$d09e32d367368ff7$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d09e32d367368ff7$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d09e32d367368ff7$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d09e32d367368ff7$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d09e32d367368ff7$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d09e32d367368ff7$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $d09e32d367368ff7$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d09e32d367368ff7$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d09e32d367368ff7$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d09e32d367368ff7$var$validMutationMethods = new Set($d09e32d367368ff7$var$validMutationMethodsArr);
const $d09e32d367368ff7$var$validRequestMethodsArr = [
    "get",
    ...$d09e32d367368ff7$var$validMutationMethodsArr
];
const $d09e32d367368ff7$var$validRequestMethods = new Set($d09e32d367368ff7$var$validRequestMethodsArr);
const $d09e32d367368ff7$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d09e32d367368ff7$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d09e32d367368ff7$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d09e32d367368ff7$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d09e32d367368ff7$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d09e32d367368ff7$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d09e32d367368ff7$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d09e32d367368ff7$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $d09e32d367368ff7$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d09e32d367368ff7$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d09e32d367368ff7$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $d09e32d367368ff7$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d09e32d367368ff7$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d09e32d367368ff7$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($d09e32d367368ff7$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d09e32d367368ff7$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d09e32d367368ff7$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d09e32d367368ff7$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d09e32d367368ff7$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d09e32d367368ff7$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d09e32d367368ff7$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$d09e32d367368ff7$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $d09e32d367368ff7$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $d09e32d367368ff7$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d09e32d367368ff7$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d09e32d367368ff7$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($d09e32d367368ff7$var$isDeferredResult(result)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d09e32d367368ff7$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d09e32d367368ff7$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d09e32d367368ff7$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($d09e32d367368ff7$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d09e32d367368ff7$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $d09e32d367368ff7$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d09e32d367368ff7$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $d09e32d367368ff7$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $d09e32d367368ff7$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $d09e32d367368ff7$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($d09e32d367368ff7$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($d09e32d367368ff7$var$isDeferredResult(actionResult)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d09e32d367368ff7$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d09e32d367368ff7$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d09e32d367368ff7$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d09e32d367368ff7$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($d09e32d367368ff7$var$_extends({
                errors: errors,
                loaderData: $d09e32d367368ff7$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $d09e32d367368ff7$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $d09e32d367368ff7$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $d09e32d367368ff7$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d09e32d367368ff7$var$isDeferredResult(result)) result = await $d09e32d367368ff7$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d09e32d367368ff7$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $d09e32d367368ff7$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $d09e32d367368ff7$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d09e32d367368ff7$export$e19cd5f9376f8cee.Replace : $d09e32d367368ff7$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d09e32d367368ff7$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d09e32d367368ff7$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $d09e32d367368ff7$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d09e32d367368ff7$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d09e32d367368ff7$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $d09e32d367368ff7$var$callLoaderOrAction("loader", $d09e32d367368ff7$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $d09e32d367368ff7$var$ResultType.error,
                        error: $d09e32d367368ff7$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d09e32d367368ff7$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d09e32d367368ff7$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d09e32d367368ff7$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d09e32d367368ff7$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d09e32d367368ff7$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d09e32d367368ff7$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d09e32d367368ff7$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d09e32d367368ff7$export$4d0306f8f6a4585b = Symbol("deferred");
function $d09e32d367368ff7$export$3336b097a6fbc59a(routes, opts) {
    $d09e32d367368ff7$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d09e32d367368ff7$var$defaultMapRouteProperties;
    let dataRoutes = $d09e32d367368ff7$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d09e32d367368ff7$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d09e32d367368ff7$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d09e32d367368ff7$var$createLocation("", $d09e32d367368ff7$export$fe53371bee54353d(url), null, "default");
        let matches = $d09e32d367368ff7$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d09e32d367368ff7$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d09e32d367368ff7$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d09e32d367368ff7$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d09e32d367368ff7$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($d09e32d367368ff7$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d09e32d367368ff7$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $d09e32d367368ff7$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d09e32d367368ff7$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d09e32d367368ff7$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $d09e32d367368ff7$var$isResponse(result) ? result : $d09e32d367368ff7$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($d09e32d367368ff7$var$isQueryRouteResponse(e)) {
                if (e.type === $d09e32d367368ff7$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d09e32d367368ff7$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        } else {
            result = await $d09e32d367368ff7$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($d09e32d367368ff7$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($d09e32d367368ff7$var$isDeferredResult(result)) {
            let error = $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d09e32d367368ff7$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d09e32d367368ff7$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $d09e32d367368ff7$var$_extends({}, context, {
                statusCode: $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $d09e32d367368ff7$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $d09e32d367368ff7$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d09e32d367368ff7$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$d09e32d367368ff7$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d09e32d367368ff7$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d09e32d367368ff7$export$fec11da027c70692(routes, context, error) {
    let newContext = $d09e32d367368ff7$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d09e32d367368ff7$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d09e32d367368ff7$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d09e32d367368ff7$export$cae722b0cc860f13(to ? to : ".", $d09e32d367368ff7$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $d09e32d367368ff7$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d09e32d367368ff7$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d09e32d367368ff7$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d09e32d367368ff7$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d09e32d367368ff7$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d09e32d367368ff7$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d09e32d367368ff7$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d09e32d367368ff7$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d09e32d367368ff7$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d09e32d367368ff7$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d09e32d367368ff7$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d09e32d367368ff7$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d09e32d367368ff7$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d09e32d367368ff7$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d09e32d367368ff7$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d09e32d367368ff7$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d09e32d367368ff7$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $d09e32d367368ff7$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($d09e32d367368ff7$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d09e32d367368ff7$var$shouldRevalidateLoader(match, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d09e32d367368ff7$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $d09e32d367368ff7$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d09e32d367368ff7$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d09e32d367368ff7$var$shouldRevalidateLoader(fetcherMatch, $d09e32d367368ff7$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d09e32d367368ff7$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d09e32d367368ff7$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d09e32d367368ff7$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d09e32d367368ff7$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d09e32d367368ff7$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d09e32d367368ff7$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d09e32d367368ff7$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $d09e32d367368ff7$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $d09e32d367368ff7$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d09e32d367368ff7$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d09e32d367368ff7$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d09e32d367368ff7$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d09e32d367368ff7$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $d09e32d367368ff7$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($d09e32d367368ff7$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($d09e32d367368ff7$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $d09e32d367368ff7$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$d09e32d367368ff7$var$ABSOLUTE_URL_REGEX.test(location)) location = $d09e32d367368ff7$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $d09e32d367368ff7$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $d09e32d367368ff7$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $d09e32d367368ff7$var$ResultType.error ? $d09e32d367368ff7$var$ResultType.error : $d09e32d367368ff7$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
            type: resultType,
            error: new $d09e32d367368ff7$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $d09e32d367368ff7$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($d09e32d367368ff7$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $d09e32d367368ff7$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d09e32d367368ff7$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d09e32d367368ff7$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d09e32d367368ff7$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d09e32d367368ff7$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d09e32d367368ff7$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d09e32d367368ff7$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d09e32d367368ff7$export$3e9cee6b33872309(!$d09e32d367368ff7$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d09e32d367368ff7$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d09e32d367368ff7$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($d09e32d367368ff7$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d09e32d367368ff7$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d09e32d367368ff7$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d09e32d367368ff7$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d09e32d367368ff7$var$isErrorResult(result)) {
            let boundaryMatch = $d09e32d367368ff7$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d09e32d367368ff7$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d09e32d367368ff7$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d09e32d367368ff7$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d09e32d367368ff7$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d09e32d367368ff7$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d09e32d367368ff7$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d09e32d367368ff7$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d09e32d367368ff7$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d09e32d367368ff7$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d09e32d367368ff7$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d09e32d367368ff7$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d09e32d367368ff7$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d09e32d367368ff7$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $d09e32d367368ff7$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(path) : path;
    return $d09e32d367368ff7$export$fe53371bee54353d($d09e32d367368ff7$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d09e32d367368ff7$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d09e32d367368ff7$var$isDeferredResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.deferred;
}
function $d09e32d367368ff7$var$isErrorResult(result) {
    return result.type === $d09e32d367368ff7$var$ResultType.error;
}
function $d09e32d367368ff7$var$isRedirectResult(result) {
    return (result && result.type) === $d09e32d367368ff7$var$ResultType.redirect;
}
function $d09e32d367368ff7$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d09e32d367368ff7$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d09e32d367368ff7$var$isRedirectResponse(result) {
    if (!$d09e32d367368ff7$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d09e32d367368ff7$var$isQueryRouteResponse(obj) {
    return obj && $d09e32d367368ff7$var$isResponse(obj.response) && (obj.type === $d09e32d367368ff7$var$ResultType.data || obj.type === $d09e32d367368ff7$var$ResultType.error);
}
function $d09e32d367368ff7$var$isValidMethod(method) {
    return $d09e32d367368ff7$var$validRequestMethods.has(method.toLowerCase());
}
function $d09e32d367368ff7$var$isMutationMethod(method) {
    return $d09e32d367368ff7$var$validMutationMethods.has(method.toLowerCase());
}
async function $d09e32d367368ff7$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d09e32d367368ff7$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d09e32d367368ff7$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d09e32d367368ff7$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d09e32d367368ff7$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d09e32d367368ff7$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d09e32d367368ff7$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d09e32d367368ff7$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d09e32d367368ff7$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d09e32d367368ff7$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d09e32d367368ff7$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d09e32d367368ff7$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d09e32d367368ff7$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d09e32d367368ff7$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d09e32d367368ff7$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d09e32d367368ff7$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d09e32d367368ff7$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d09e32d367368ff7$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d09e32d367368ff7$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d09e32d367368ff7$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}


function $b0e6fcd50b7ef685$var$_extends() {
    $b0e6fcd50b7ef685$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b0e6fcd50b7ef685$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $b0e6fcd50b7ef685$export$3add0d5dce533e2e = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$145dfa71566a64dc = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$var$AwaitContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $b0e6fcd50b7ef685$export$26749e8557646306 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$c7914228fb69b0f5 = /*#__PURE__*/ $exYeM.createContext(null);
const $b0e6fcd50b7ef685$export$9072aa6dd1f93057 = /*#__PURE__*/ $exYeM.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $b0e6fcd50b7ef685$var$RouteErrorContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $b0e6fcd50b7ef685$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $b0e6fcd50b7ef685$export$9c954a9d03d32f4a() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $b0e6fcd50b7ef685$export$45d76561a5302f2b() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $b0e6fcd50b7ef685$export$1b3f31771c5d07c() {
    return $exYeM.useContext($b0e6fcd50b7ef685$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $b0e6fcd50b7ef685$export$6c330e8992e8a295(pattern) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $b0e6fcd50b7ef685$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $exYeM.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $b0e6fcd50b7ef685$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $b0e6fcd50b7ef685$var$useNavigateStable() : $b0e6fcd50b7ef685$var$useNavigateUnstable();
}
function $b0e6fcd50b7ef685$var$useNavigateUnstable() {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$OutletContext = /*#__PURE__*/ $exYeM.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $b0e6fcd50b7ef685$export$4138103a3ae699cc() {
    return $exYeM.useContext($b0e6fcd50b7ef685$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(context) {
    let outlet = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $d09e32d367368ff7$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $exYeM.useMemo(()=>(0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $b0e6fcd50b7ef685$export$5d3fca4a98652595(routes, locationArg) {
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $exYeM.useContext($b0e6fcd50b7ef685$export$26749e8557646306);
    let { matches: parentMatches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $d09e32d367368ff7$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $b0e6fcd50b7ef685$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $b0e6fcd50b7ef685$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $b0e6fcd50b7ef685$var$DefaultErrorComponent() {
    let error = $b0e6fcd50b7ef685$export$ed527bf60f6e05f2();
    let message = (0, $d09e32d367368ff7$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $exYeM.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $exYeM.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $b0e6fcd50b7ef685$var$defaultErrorElement = /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DefaultErrorComponent, null);
class $b0e6fcd50b7ef685$var$RenderErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $b0e6fcd50b7ef685$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $b0e6fcd50b7ef685$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $b0e6fcd50b7ef685$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $exYeM.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $b0e6fcd50b7ef685$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($b0e6fcd50b7ef685$var$DataRouterHook || {});
var $b0e6fcd50b7ef685$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($b0e6fcd50b7ef685$var$DataRouterStateHook || {});
function $b0e6fcd50b7ef685$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $b0e6fcd50b7ef685$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext($b0e6fcd50b7ef685$export$3add0d5dce533e2e);
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b0e6fcd50b7ef685$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext($b0e6fcd50b7ef685$export$145dfa71566a64dc);
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
function $b0e6fcd50b7ef685$var$useRouteContext(hookName) {
    let route = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $b0e6fcd50b7ef685$var$useCurrentRouteId(hookName) {
    let route = $b0e6fcd50b7ef685$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $b0e6fcd50b7ef685$export$5fc8298006ad9e58() {
    return $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $b0e6fcd50b7ef685$export$d0fd4b7106de2769() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $b0e6fcd50b7ef685$export$600dc272ed516c15() {
    let dataRouterContext = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseRevalidator);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRevalidator);
    return $exYeM.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $b0e6fcd50b7ef685$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseMatches);
    return $exYeM.useMemo(()=>matches.map((m)=>(0, $d09e32d367368ff7$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $b0e6fcd50b7ef685$export$1448a5050d252c4d() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $b0e6fcd50b7ef685$export$fd5d37484eab868d(routeId) {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $b0e6fcd50b7ef685$export$fdc00f3f26066d5e() {
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseActionData);
    let route = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $b0e6fcd50b7ef685$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $exYeM.useContext($b0e6fcd50b7ef685$var$RouteErrorContext);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    let routeId = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $b0e6fcd50b7ef685$export$78a72ddb39bdd145() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $b0e6fcd50b7ef685$export$17f53340677d5831() {
    let value = $exYeM.useContext($b0e6fcd50b7ef685$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $b0e6fcd50b7ef685$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $b0e6fcd50b7ef685$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseBlocker);
    let state = $b0e6fcd50b7ef685$var$useDataRouterState($b0e6fcd50b7ef685$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $exYeM.useState("");
    let blockerFunction = $exYeM.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $b0e6fcd50b7ef685$var$_extends({}, currentLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $b0e6fcd50b7ef685$var$_extends({}, nextLocation, {
                pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $exYeM.useEffect(()=>{
        let key = String(++$b0e6fcd50b7ef685$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $exYeM.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $d09e32d367368ff7$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $b0e6fcd50b7ef685$var$useNavigateStable() {
    let { router: router } = $b0e6fcd50b7ef685$var$useDataRouterContext($b0e6fcd50b7ef685$var$DataRouterHook.UseNavigateStable);
    let id = $b0e6fcd50b7ef685$var$useCurrentRouteId($b0e6fcd50b7ef685$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $exYeM.useRef(false);
    $b0e6fcd50b7ef685$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $exYeM.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $b0e6fcd50b7ef685$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $b0e6fcd50b7ef685$var$alreadyWarned = {};
function $b0e6fcd50b7ef685$var$warningOnce(key, cond, message) {
    if (!cond && !$b0e6fcd50b7ef685$var$alreadyWarned[key]) $b0e6fcd50b7ef685$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b0e6fcd50b7ef685$var$START_TRANSITION = "startTransition";
const $b0e6fcd50b7ef685$var$startTransitionImpl = $exYeM[$b0e6fcd50b7ef685$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b0e6fcd50b7ef685$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $exYeM.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl ? $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $exYeM.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $exYeM.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $b0e6fcd50b7ef685$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $b0e6fcd50b7ef685$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $b0e6fcd50b7ef685$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $b0e6fcd50b7ef685$var$startTransitionImpl ? $b0e6fcd50b7ef685$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $b0e6fcd50b7ef685$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let { matches: matches } = $exYeM.useContext($b0e6fcd50b7ef685$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $b0e6fcd50b7ef685$export$45d76561a5302f2b();
    let navigate = $b0e6fcd50b7ef685$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $d09e32d367368ff7$export$cae722b0cc860f13)(to, (0, $d09e32d367368ff7$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $exYeM.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $b0e6fcd50b7ef685$export$910ae8079b2c2852(props) {
    return $b0e6fcd50b7ef685$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $b0e6fcd50b7ef685$export$e7b0ac011bb776c6(_props) {
    (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $b0e6fcd50b7ef685$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $d09e32d367368ff7$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$b0e6fcd50b7ef685$export$9c954a9d03d32f4a() && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $exYeM.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $d09e32d367368ff7$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $exYeM.useMemo(()=>{
        let trailingPathname = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $b0e6fcd50b7ef685$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $b0e6fcd50b7ef685$export$5d3fca4a98652595($b0e6fcd50b7ef685$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $b0e6fcd50b7ef685$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$ResolveAwait, null, children));
}
var $b0e6fcd50b7ef685$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($b0e6fcd50b7ef685$var$AwaitRenderStatus || {});
const $b0e6fcd50b7ef685$var$neverSettledPromise = new Promise(()=>{});
class $b0e6fcd50b7ef685$var$AwaitErrorBoundary extends $exYeM.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.error : promise._data !== undefined ? $b0e6fcd50b7ef685$var$AwaitRenderStatus.success : $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $b0e6fcd50b7ef685$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && promise._error instanceof (0, $d09e32d367368ff7$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $b0e6fcd50b7ef685$var$neverSettledPromise;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $b0e6fcd50b7ef685$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $exYeM.createElement($b0e6fcd50b7ef685$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $b0e6fcd50b7ef685$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $b0e6fcd50b7ef685$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $exYeM.createElement($exYeM.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $b0e6fcd50b7ef685$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $exYeM.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $exYeM.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $exYeM.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $b0e6fcd50b7ef685$export$e7b0ac011bb776c6) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $b0e6fcd50b7ef685$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $b0e6fcd50b7ef685$export$daf73786167a7f72(matches) {
    return $b0e6fcd50b7ef685$var$_renderMatches(matches);
}
function $b0e6fcd50b7ef685$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $exYeM.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $exYeM.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $b0e6fcd50b7ef685$export$f30f7e456d254e83(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b0e6fcd50b7ef685$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $b0e6fcd50b7ef685$export$52b333d321859367
    }).initialize();
}



function $2cc1d3688dd37f6f$var$_extends() {
    $2cc1d3688dd37f6f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2cc1d3688dd37f6f$var$_extends.apply(this, arguments);
}
function $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $2cc1d3688dd37f6f$var$defaultMethod = "get";
const $2cc1d3688dd37f6f$var$defaultEncType = "application/x-www-form-urlencoded";
function $2cc1d3688dd37f6f$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $2cc1d3688dd37f6f$var$isButtonElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $2cc1d3688dd37f6f$var$isFormElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $2cc1d3688dd37f6f$var$isInputElement(object) {
    return $2cc1d3688dd37f6f$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $2cc1d3688dd37f6f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$2cc1d3688dd37f6f$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $2cc1d3688dd37f6f$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = null;
function $2cc1d3688dd37f6f$var$isFormDataSubmitterSupported() {
    if ($2cc1d3688dd37f6f$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter = true;
    }
    return $2cc1d3688dd37f6f$var$_formDataSupportsSubmitter;
}
const $2cc1d3688dd37f6f$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $2cc1d3688dd37f6f$var$getFormEncType(encType) {
    if (encType != null && !$2cc1d3688dd37f6f$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($2cc1d3688dd37f6f$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        formData = new FormData(target);
    } else if ($2cc1d3688dd37f6f$var$isButtonElement(target) || $2cc1d3688dd37f6f$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $2cc1d3688dd37f6f$var$defaultMethod;
        encType = $2cc1d3688dd37f6f$var$getFormEncType(target.getAttribute("formenctype")) || $2cc1d3688dd37f6f$var$getFormEncType(form.getAttribute("enctype")) || $2cc1d3688dd37f6f$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$2cc1d3688dd37f6f$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($2cc1d3688dd37f6f$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $2cc1d3688dd37f6f$var$defaultMethod;
        action = null;
        encType = $2cc1d3688dd37f6f$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $2cc1d3688dd37f6f$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $2cc1d3688dd37f6f$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $2cc1d3688dd37f6f$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $2cc1d3688dd37f6f$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367)
    }).initialize();
}
function $2cc1d3688dd37f6f$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d09e32d367368ff7$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $2cc1d3688dd37f6f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $d09e32d367368ff7$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $2cc1d3688dd37f6f$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $b0e6fcd50b7ef685$export$52b333d321859367)
    }).initialize();
}
function $2cc1d3688dd37f6f$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $2cc1d3688dd37f6f$var$_extends({}, state, {
        errors: $2cc1d3688dd37f6f$var$deserializeErrors(state.errors)
    });
    return state;
}
function $2cc1d3688dd37f6f$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $d09e32d367368ff7$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $2cc1d3688dd37f6f$var$START_TRANSITION = "startTransition";
const $2cc1d3688dd37f6f$var$startTransitionImpl = $exYeM[$2cc1d3688dd37f6f$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $2cc1d3688dd37f6f$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $exYeM.useRef();
    if (historyRef.current == null) historyRef.current = (0, $d09e32d367368ff7$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $2cc1d3688dd37f6f$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $exYeM.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $exYeM.useCallback((newState)=>{
        v7_startTransition && $2cc1d3688dd37f6f$var$startTransitionImpl ? $2cc1d3688dd37f6f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $exYeM.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $exYeM.createElement((0, $b0e6fcd50b7ef685$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $2cc1d3688dd37f6f$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a = /*#__PURE__*/ $exYeM.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref4, $2cc1d3688dd37f6f$var$_excluded);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $2cc1d3688dd37f6f$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($2cc1d3688dd37f6f$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $b0e6fcd50b7ef685$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $2cc1d3688dd37f6f$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $exYeM.createElement("a", $2cc1d3688dd37f6f$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $2cc1d3688dd37f6f$export$b0d92dbee9b5b60d = /*#__PURE__*/ $exYeM.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref5, $2cc1d3688dd37f6f$var$_excluded2);
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let routerState = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    let { navigator: navigator } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$export$a6c7ac8248d6e38a, $2cc1d3688dd37f6f$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $2cc1d3688dd37f6f$export$a7fed597f4b8afd8 = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
    let submit = $2cc1d3688dd37f6f$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$var$FormImpl, $2cc1d3688dd37f6f$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $2cc1d3688dd37f6f$var$FormImpl = /*#__PURE__*/ $exYeM.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $2cc1d3688dd37f6f$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $2cc1d3688dd37f6f$var$_objectWithoutPropertiesLoose(_ref6, $2cc1d3688dd37f6f$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $exYeM.createElement("form", $2cc1d3688dd37f6f$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $2cc1d3688dd37f6f$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $2cc1d3688dd37f6f$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $2cc1d3688dd37f6f$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($2cc1d3688dd37f6f$var$DataRouterHook || ($2cc1d3688dd37f6f$var$DataRouterHook = {}));
var $2cc1d3688dd37f6f$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($2cc1d3688dd37f6f$var$DataRouterStateHook || ($2cc1d3688dd37f6f$var$DataRouterStateHook = {}));
function $2cc1d3688dd37f6f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $2cc1d3688dd37f6f$var$useDataRouterContext(hookName) {
    let ctx = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$3add0d5dce533e2e));
    !ctx && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return ctx;
}
function $2cc1d3688dd37f6f$var$useDataRouterState(hookName) {
    let state = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$145dfa71566a64dc));
    !state && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $2cc1d3688dd37f6f$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let path = (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $exYeM.useCallback((event)=>{
        if ($2cc1d3688dd37f6f$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $d09e32d367368ff7$export$fe53371bee54353d)(location) === (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $2cc1d3688dd37f6f$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $exYeM.useRef($2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $exYeM.useRef(false);
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let searchParams = $exYeM.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $2cc1d3688dd37f6f$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    let setSearchParams = $exYeM.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $2cc1d3688dd37f6f$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $2cc1d3688dd37f6f$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $2cc1d3688dd37f6f$export$47c85c6e3a081d3() {
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let currentRouteId = (0, $b0e6fcd50b7ef685$export$5fc8298006ad9e58)();
    return $exYeM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2cc1d3688dd37f6f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $2cc1d3688dd37f6f$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    return $exYeM.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $2cc1d3688dd37f6f$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $2cc1d3688dd37f6f$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $2cc1d3688dd37f6f$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let routeContext = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    !routeContext && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $2cc1d3688dd37f6f$var$_extends({}, (0, $b0e6fcd50b7ef685$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $d09e32d367368ff7$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $d09e32d367368ff7$export$fe53371bee54353d)(path);
}
function $2cc1d3688dd37f6f$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $exYeM.forwardRef((props, ref)=>{
        let submit = $2cc1d3688dd37f6f$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $exYeM.createElement($2cc1d3688dd37f6f$var$FormImpl, $2cc1d3688dd37f6f$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $2cc1d3688dd37f6f$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $2cc1d3688dd37f6f$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseFetcher);
    let route = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$9072aa6dd1f93057));
    !route && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $exYeM.useState(()=>String(++$2cc1d3688dd37f6f$var$fetcherId));
    let [Form] = $exYeM.useState(()=>{
        !routeId && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
        return $2cc1d3688dd37f6f$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $exYeM.useState(()=>(href)=>{
            !router && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
            !routeId && (0, $d09e32d367368ff7$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $2cc1d3688dd37f6f$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $exYeM.useMemo(()=>$2cc1d3688dd37f6f$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $exYeM.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $2cc1d3688dd37f6f$export$fa996778a3a31087() {
    let state = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $2cc1d3688dd37f6f$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $2cc1d3688dd37f6f$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $2cc1d3688dd37f6f$var$useDataRouterContext($2cc1d3688dd37f6f$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $2cc1d3688dd37f6f$var$useDataRouterState($2cc1d3688dd37f6f$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $exYeM.useContext((0, $b0e6fcd50b7ef685$export$26749e8557646306));
    let location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    let matches = (0, $b0e6fcd50b7ef685$export$2378eb7f5ff86053)();
    let navigation = (0, $b0e6fcd50b7ef685$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $exYeM.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $2cc1d3688dd37f6f$var$usePageHide($exYeM.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $2cc1d3688dd37f6f$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($2cc1d3688dd37f6f$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $2cc1d3688dd37f6f$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $2cc1d3688dd37f6f$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($2cc1d3688dd37f6f$var$_extends({}, location, {
                    pathname: (0, $d09e32d367368ff7$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($2cc1d3688dd37f6f$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $exYeM.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $2cc1d3688dd37f6f$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $exYeM.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $2cc1d3688dd37f6f$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $b0e6fcd50b7ef685$export$2af03a1de5c0910)(when);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $exYeM.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}


"use strict";
function $fc8f2e2c969d032f$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $8ca3655f37d9652c$var$toString } = Object.prototype;
const { getPrototypeOf: $8ca3655f37d9652c$var$getPrototypeOf } = Object;
const $8ca3655f37d9652c$var$kindOf = ((cache)=>(thing)=>{
        const str = $8ca3655f37d9652c$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $8ca3655f37d9652c$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$8ca3655f37d9652c$var$kindOf(thing) === type;
};
const $8ca3655f37d9652c$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $8ca3655f37d9652c$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $8ca3655f37d9652c$var$isUndefined = $8ca3655f37d9652c$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ca3655f37d9652c$var$isBuffer(val) {
    return val !== null && !$8ca3655f37d9652c$var$isUndefined(val) && val.constructor !== null && !$8ca3655f37d9652c$var$isUndefined(val.constructor) && $8ca3655f37d9652c$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $8ca3655f37d9652c$var$isArrayBuffer = $8ca3655f37d9652c$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ca3655f37d9652c$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $8ca3655f37d9652c$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $8ca3655f37d9652c$var$isString = $8ca3655f37d9652c$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $8ca3655f37d9652c$var$isFunction = $8ca3655f37d9652c$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $8ca3655f37d9652c$var$isNumber = $8ca3655f37d9652c$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $8ca3655f37d9652c$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $8ca3655f37d9652c$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $8ca3655f37d9652c$var$isPlainObject = (val)=>{
    if ($8ca3655f37d9652c$var$kindOf(val) !== "object") return false;
    const prototype = $8ca3655f37d9652c$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $8ca3655f37d9652c$var$isDate = $8ca3655f37d9652c$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFile = $8ca3655f37d9652c$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $8ca3655f37d9652c$var$isBlob = $8ca3655f37d9652c$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $8ca3655f37d9652c$var$isFileList = $8ca3655f37d9652c$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $8ca3655f37d9652c$var$isStream = (val)=>$8ca3655f37d9652c$var$isObject(val) && $8ca3655f37d9652c$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $8ca3655f37d9652c$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $8ca3655f37d9652c$var$isFunction(thing.append) && ((kind = $8ca3655f37d9652c$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $8ca3655f37d9652c$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $8ca3655f37d9652c$var$isURLSearchParams = $8ca3655f37d9652c$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $8ca3655f37d9652c$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $8ca3655f37d9652c$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ca3655f37d9652c$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $8ca3655f37d9652c$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $8ca3655f37d9652c$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $8ca3655f37d9652c$var$isContextDefined = (context)=>!$8ca3655f37d9652c$var$isUndefined(context) && context !== $8ca3655f37d9652c$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $8ca3655f37d9652c$var$merge() {
    const { caseless: caseless } = $8ca3655f37d9652c$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $8ca3655f37d9652c$var$findKey(result, key) || key;
        if ($8ca3655f37d9652c$var$isPlainObject(result[targetKey]) && $8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge(result[targetKey], val);
        else if ($8ca3655f37d9652c$var$isPlainObject(val)) result[targetKey] = $8ca3655f37d9652c$var$merge({}, val);
        else if ($8ca3655f37d9652c$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $8ca3655f37d9652c$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $8ca3655f37d9652c$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $8ca3655f37d9652c$var$forEach(b, (val, key)=>{
        if (thisArg && $8ca3655f37d9652c$var$isFunction(val)) a[key] = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $8ca3655f37d9652c$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $8ca3655f37d9652c$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $8ca3655f37d9652c$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $8ca3655f37d9652c$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $8ca3655f37d9652c$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($8ca3655f37d9652c$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$8ca3655f37d9652c$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $8ca3655f37d9652c$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $8ca3655f37d9652c$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $8ca3655f37d9652c$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $8ca3655f37d9652c$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $8ca3655f37d9652c$var$isHTMLForm = $8ca3655f37d9652c$var$kindOfTest("HTMLFormElement");
const $8ca3655f37d9652c$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $8ca3655f37d9652c$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $8ca3655f37d9652c$var$isRegExp = $8ca3655f37d9652c$var$kindOfTest("RegExp");
const $8ca3655f37d9652c$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $8ca3655f37d9652c$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $8ca3655f37d9652c$var$freezeMethods = (obj)=>{
    $8ca3655f37d9652c$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($8ca3655f37d9652c$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$8ca3655f37d9652c$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $8ca3655f37d9652c$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $8ca3655f37d9652c$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $8ca3655f37d9652c$var$noop = ()=>{};
const $8ca3655f37d9652c$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $8ca3655f37d9652c$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $8ca3655f37d9652c$var$DIGIT = "0123456789";
const $8ca3655f37d9652c$var$ALPHABET = {
    DIGIT: $8ca3655f37d9652c$var$DIGIT,
    ALPHA: $8ca3655f37d9652c$var$ALPHA,
    ALPHA_DIGIT: $8ca3655f37d9652c$var$ALPHA + $8ca3655f37d9652c$var$ALPHA.toUpperCase() + $8ca3655f37d9652c$var$DIGIT
};
const $8ca3655f37d9652c$var$generateString = (size = 16, alphabet = $8ca3655f37d9652c$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $8ca3655f37d9652c$var$isSpecCompliantForm(thing) {
    return !!(thing && $8ca3655f37d9652c$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $8ca3655f37d9652c$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($8ca3655f37d9652c$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $8ca3655f37d9652c$var$isArray(source) ? [] : {};
                $8ca3655f37d9652c$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$8ca3655f37d9652c$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $8ca3655f37d9652c$var$isAsyncFn = $8ca3655f37d9652c$var$kindOfTest("AsyncFunction");
const $8ca3655f37d9652c$var$isThenable = (thing)=>thing && ($8ca3655f37d9652c$var$isObject(thing) || $8ca3655f37d9652c$var$isFunction(thing)) && $8ca3655f37d9652c$var$isFunction(thing.then) && $8ca3655f37d9652c$var$isFunction(thing.catch);
var $8ca3655f37d9652c$export$2e2bcd8739ae039 = {
    isArray: $8ca3655f37d9652c$var$isArray,
    isArrayBuffer: $8ca3655f37d9652c$var$isArrayBuffer,
    isBuffer: $8ca3655f37d9652c$var$isBuffer,
    isFormData: $8ca3655f37d9652c$var$isFormData,
    isArrayBufferView: $8ca3655f37d9652c$var$isArrayBufferView,
    isString: $8ca3655f37d9652c$var$isString,
    isNumber: $8ca3655f37d9652c$var$isNumber,
    isBoolean: $8ca3655f37d9652c$var$isBoolean,
    isObject: $8ca3655f37d9652c$var$isObject,
    isPlainObject: $8ca3655f37d9652c$var$isPlainObject,
    isUndefined: $8ca3655f37d9652c$var$isUndefined,
    isDate: $8ca3655f37d9652c$var$isDate,
    isFile: $8ca3655f37d9652c$var$isFile,
    isBlob: $8ca3655f37d9652c$var$isBlob,
    isRegExp: $8ca3655f37d9652c$var$isRegExp,
    isFunction: $8ca3655f37d9652c$var$isFunction,
    isStream: $8ca3655f37d9652c$var$isStream,
    isURLSearchParams: $8ca3655f37d9652c$var$isURLSearchParams,
    isTypedArray: $8ca3655f37d9652c$var$isTypedArray,
    isFileList: $8ca3655f37d9652c$var$isFileList,
    forEach: $8ca3655f37d9652c$var$forEach,
    merge: $8ca3655f37d9652c$var$merge,
    extend: $8ca3655f37d9652c$var$extend,
    trim: $8ca3655f37d9652c$var$trim,
    stripBOM: $8ca3655f37d9652c$var$stripBOM,
    inherits: $8ca3655f37d9652c$var$inherits,
    toFlatObject: $8ca3655f37d9652c$var$toFlatObject,
    kindOf: $8ca3655f37d9652c$var$kindOf,
    kindOfTest: $8ca3655f37d9652c$var$kindOfTest,
    endsWith: $8ca3655f37d9652c$var$endsWith,
    toArray: $8ca3655f37d9652c$var$toArray,
    forEachEntry: $8ca3655f37d9652c$var$forEachEntry,
    matchAll: $8ca3655f37d9652c$var$matchAll,
    isHTMLForm: $8ca3655f37d9652c$var$isHTMLForm,
    hasOwnProperty: $8ca3655f37d9652c$var$hasOwnProperty,
    hasOwnProp: $8ca3655f37d9652c$var$hasOwnProperty,
    reduceDescriptors: $8ca3655f37d9652c$var$reduceDescriptors,
    freezeMethods: $8ca3655f37d9652c$var$freezeMethods,
    toObjectSet: $8ca3655f37d9652c$var$toObjectSet,
    toCamelCase: $8ca3655f37d9652c$var$toCamelCase,
    noop: $8ca3655f37d9652c$var$noop,
    toFiniteNumber: $8ca3655f37d9652c$var$toFiniteNumber,
    findKey: $8ca3655f37d9652c$var$findKey,
    global: $8ca3655f37d9652c$var$_global,
    isContextDefined: $8ca3655f37d9652c$var$isContextDefined,
    ALPHABET: $8ca3655f37d9652c$var$ALPHABET,
    generateString: $8ca3655f37d9652c$var$generateString,
    isSpecCompliantForm: $8ca3655f37d9652c$var$isSpecCompliantForm,
    toJSONObject: $8ca3655f37d9652c$var$toJSONObject,
    isAsyncFn: $8ca3655f37d9652c$var$isAsyncFn,
    isThenable: $8ca3655f37d9652c$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $44aee3fe793a4c74$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($44aee3fe793a4c74$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $44aee3fe793a4c74$var$prototype = $44aee3fe793a4c74$var$AxiosError.prototype;
const $44aee3fe793a4c74$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $44aee3fe793a4c74$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($44aee3fe793a4c74$var$AxiosError, $44aee3fe793a4c74$var$descriptors);
Object.defineProperty($44aee3fe793a4c74$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$44aee3fe793a4c74$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($44aee3fe793a4c74$var$prototype);
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $44aee3fe793a4c74$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $44aee3fe793a4c74$export$2e2bcd8739ae039 = $44aee3fe793a4c74$var$AxiosError;


// eslint-disable-next-line strict
var $82d0d0537dc0bac3$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3caef5c332c7293f$export$6100ba28696e12de(buf);
    else return $3caef5c332c7293f$export$6100ba28696e12de(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $56a54f6ebabce67d$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $56a54f6ebabce67d$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $3caef5c332c7293f$export$d622b2ad8d90c771($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $0c29ca57d54f85e9$require$Buffer = $24f87a6f86a8996f$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isVisitable(thing) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0c29ca57d54f85e9$var$removeBrackets(key) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0c29ca57d54f85e9$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0c29ca57d54f85e9$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0c29ca57d54f85e9$var$isFlatArray(arr) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(arr) && !arr.some($0c29ca57d54f85e9$var$isVisitable);
}
const $0c29ca57d54f85e9$var$predicates = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject((0, $8ca3655f37d9652c$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0c29ca57d54f85e9$var$toFormData(obj, formData, options) {
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $82d0d0537dc0bac3$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $0c29ca57d54f85e9$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) && $0c29ca57d54f85e9$var$isFlatArray(value) || ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(value) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0c29ca57d54f85e9$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0c29ca57d54f85e9$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($0c29ca57d54f85e9$var$isVisitable(value)) return true;
        formData.append($0c29ca57d54f85e9$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0c29ca57d54f85e9$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0c29ca57d54f85e9$var$isVisitable
    });
    function build(value, path) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $0c29ca57d54f85e9$export$2e2bcd8739ae039 = $0c29ca57d54f85e9$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $63e4e0dff2b7ef1a$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $63e4e0dff2b7ef1a$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(params, this, options);
}
const $63e4e0dff2b7ef1a$var$prototype = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams.prototype;
$63e4e0dff2b7ef1a$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$63e4e0dff2b7ef1a$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $63e4e0dff2b7ef1a$var$encode);
    } : $63e4e0dff2b7ef1a$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $63e4e0dff2b7ef1a$export$2e2bcd8739ae039 = $63e4e0dff2b7ef1a$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $4858799f155a4706$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $4858799f155a4706$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $4858799f155a4706$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $089e14d5c08cea15$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $089e14d5c08cea15$export$2e2bcd8739ae039 = $089e14d5c08cea15$var$InterceptorManager;





"use strict";
var $c54b4d6d29e2eb6b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $d2ba66411c13cc9b$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $63e4e0dff2b7ef1a$export$2e2bcd8739ae039);


"use strict";
var $7cdf1698dc68a071$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e86ffb493d13ed1$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $97999e9cdfd9bdaf$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $97999e9cdfd9bdaf$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $97999e9cdfd9bdaf$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $d2ba66411c13cc9b$export$2e2bcd8739ae039,
        FormData: $7cdf1698dc68a071$export$2e2bcd8739ae039,
        Blob: $2e86ffb493d13ed1$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $97999e9cdfd9bdaf$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $97999e9cdfd9bdaf$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $3444de215011fd2b$export$2e2bcd8739ae039(data, options) {
    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(data, new (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).isNode && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $bdd273a6ec9f935e$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $bdd273a6ec9f935e$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $bdd273a6ec9f935e$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $bdd273a6ec9f935e$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(formData) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($bdd273a6ec9f935e$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $bdd273a6ec9f935e$export$2e2bcd8739ae039 = $bdd273a6ec9f935e$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $8d19883a18ea96be$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $8d19883a18ea96be$var$defaults = {
    transitional: (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039),
    adapter: (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).isNode ? "http" : "xhr",
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBuffer(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isStream(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFile(data) || (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $3444de215011fd2b$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $8d19883a18ea96be$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $8d19883a18ea96be$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).from(e, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $8d19883a18ea96be$var$defaults.headers[method] = {};
});
var $8d19883a18ea96be$export$2e2bcd8739ae039 = $8d19883a18ea96be$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $102410410d0dc09d$var$ignoreDuplicateOf = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $102410410d0dc09d$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $102410410d0dc09d$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $c2923f037e2bae4f$var$$internals = Symbol("internals");
function $c2923f037e2bae4f$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $c2923f037e2bae4f$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.map($c2923f037e2bae4f$var$normalizeValue) : String(value);
}
function $c2923f037e2bae4f$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $c2923f037e2bae4f$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $c2923f037e2bae4f$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $c2923f037e2bae4f$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $c2923f037e2bae4f$var$buildAccessors(obj, header) {
    const accessorName = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $c2923f037e2bae4f$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $c2923f037e2bae4f$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$c2923f037e2bae4f$var$isValidHeaderName(header)) setHeaders((0, $102410410d0dc09d$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $c2923f037e2bae4f$var$parseTokens(value);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $c2923f037e2bae4f$var$normalizeHeader(header);
        if (header) {
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $c2923f037e2bae4f$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $c2923f037e2bae4f$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $c2923f037e2bae4f$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $c2923f037e2bae4f$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$c2923f037e2bae4f$var$$internals] = this[$c2923f037e2bae4f$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $c2923f037e2bae4f$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $c2923f037e2bae4f$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$c2923f037e2bae4f$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).reduceDescriptors($c2923f037e2bae4f$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).freezeMethods($c2923f037e2bae4f$var$AxiosHeaders);
var $c2923f037e2bae4f$export$2e2bcd8739ae039 = $c2923f037e2bae4f$var$AxiosHeaders;


"use strict";
function $e27ce2658796d30f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $8d19883a18ea96be$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $ffcdf0443516cf49$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $a251e9fa67c89486$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).inherits($a251e9fa67c89486$var$CanceledError, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $a251e9fa67c89486$export$2e2bcd8739ae039 = $a251e9fa67c89486$var$CanceledError;







"use strict";
function $df046ee58fb378eb$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $e52288d5ced91a0f$export$2e2bcd8739ae039 = (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $57cabc98a428ac0d$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b453718e09262365$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $c5c7eeec01fb8b89$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $57cabc98a428ac0d$export$2e2bcd8739ae039)(requestedURL)) return (0, $b453718e09262365$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $6c85e22328488296$export$2e2bcd8739ae039 = (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $39416e5131ec2dd8$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $a1af1a7f806b22ba$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $a1af1a7f806b22ba$export$2e2bcd8739ae039 = $a1af1a7f806b22ba$var$speedometer;


"use strict";
function $85bd0ac91b9e9771$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $a1af1a7f806b22ba$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $85bd0ac91b9e9771$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $85bd0ac91b9e9771$export$2e2bcd8739ae039 = $85bd0ac91b9e9771$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $4858799f155a4706$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $df046ee58fb378eb$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Request aborted", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Network Error", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $c54b4d6d29e2eb6b$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ETIMEDOUT : (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $6c85e22328488296$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $e52288d5ced91a0f$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $85bd0ac91b9e9771$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $85bd0ac91b9e9771$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $39416e5131ec2dd8$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $97999e9cdfd9bdaf$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $b57d5c296e05dd0f$var$knownAdapters = {
    http: (0, $82d0d0537dc0bac3$export$2e2bcd8739ae039),
    xhr: (0, $85bd0ac91b9e9771$export$2e2bcd8739ae039)
};
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach($b57d5c296e05dd0f$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $b57d5c296e05dd0f$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $b57d5c296e05dd0f$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).hasOwnProp($b57d5c296e05dd0f$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $b57d5c296e05dd0f$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $03c1ec60679d4a92$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(null, config);
}
function $03c1ec60679d4a92$export$2e2bcd8739ae039(config) {
    $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
    config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $8d19883a18ea96be$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $ffcdf0443516cf49$export$2e2bcd8739ae039)(reason)) {
            $03c1ec60679d4a92$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $e27ce2658796d30f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $ed738da9502ca495$var$headersToObject = (thing)=>thing instanceof (0, $c2923f037e2bae4f$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $ed738da9502ca495$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(target) && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($ed738da9502ca495$var$headersToObject(a), $ed738da9502ca495$var$headersToObject(b), true)
    };
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $f1f155cc89389bcb$export$a4ad2735b021c132 = "1.5.0";



"use strict";
const $73047b42f9e782d3$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $73047b42f9e782d3$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $73047b42f9e782d3$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $73047b42f9e782d3$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $f1f155cc89389bcb$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$73047b42f9e782d3$var$deprecatedWarnings[opt]) {
            $73047b42f9e782d3$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $73047b42f9e782d3$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("options must be an object", (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $44aee3fe793a4c74$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $44aee3fe793a4c74$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $73047b42f9e782d3$export$2e2bcd8739ae039 = {
    assertOptions: $73047b42f9e782d3$var$assertOptions,
    validators: $73047b42f9e782d3$var$validators
};



"use strict";
const $6c6ea2375c06af66$var$validators = (0, $73047b42f9e782d3$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $6c6ea2375c06af66$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)(),
            response: new (0, $089e14d5c08cea15$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            forcedJSONParsing: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean),
            clarifyTimeoutError: $6c6ea2375c06af66$var$validators.transitional($6c6ea2375c06af66$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $73047b42f9e782d3$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $6c6ea2375c06af66$var$validators.function,
                serialize: $6c6ea2375c06af66$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $03c1ec60679d4a92$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $ed738da9502ca495$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $c5c7eeec01fb8b89$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $4858799f155a4706$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6c6ea2375c06af66$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $8ca3655f37d9652c$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $ed738da9502ca495$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $6c6ea2375c06af66$var$Axios.prototype[method] = generateHTTPMethod();
    $6c6ea2375c06af66$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $6c6ea2375c06af66$export$2e2bcd8739ae039 = $6c6ea2375c06af66$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $52ff30ac6ac58fe8$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $a251e9fa67c89486$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $52ff30ac6ac58fe8$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $52ff30ac6ac58fe8$export$2e2bcd8739ae039 = $52ff30ac6ac58fe8$var$CancelToken;






"use strict";
function $6fd2256c627864a1$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $eecd01492f51a517$export$2e2bcd8739ae039(payload) {
    return (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $3f8e319a46440ea5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($3f8e319a46440ea5$var$HttpStatusCode).forEach(([key, value])=>{
    $3f8e319a46440ea5$var$HttpStatusCode[value] = key;
});
var $3f8e319a46440ea5$export$2e2bcd8739ae039 = $3f8e319a46440ea5$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $eb999ef253053d6e$var$createInstance(defaultConfig) {
    const context = new (0, $6c6ea2375c06af66$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $fc8f2e2c969d032f$export$2e2bcd8739ae039)((0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, (0, $6c6ea2375c06af66$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $8ca3655f37d9652c$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $eb999ef253053d6e$var$createInstance((0, $ed738da9502ca495$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $eb999ef253053d6e$var$axios = $eb999ef253053d6e$var$createInstance((0, $8d19883a18ea96be$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$eb999ef253053d6e$var$axios.Axios = (0, $6c6ea2375c06af66$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$eb999ef253053d6e$var$axios.CanceledError = (0, $a251e9fa67c89486$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.CancelToken = (0, $52ff30ac6ac58fe8$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.isCancel = (0, $ffcdf0443516cf49$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.VERSION = (0, $f1f155cc89389bcb$export$a4ad2735b021c132);
$eb999ef253053d6e$var$axios.toFormData = (0, $0c29ca57d54f85e9$export$2e2bcd8739ae039);
// Expose AxiosError class
$eb999ef253053d6e$var$axios.AxiosError = (0, $44aee3fe793a4c74$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$eb999ef253053d6e$var$axios.Cancel = $eb999ef253053d6e$var$axios.CanceledError;
// Expose all/spread
$eb999ef253053d6e$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$eb999ef253053d6e$var$axios.spread = (0, $6fd2256c627864a1$export$2e2bcd8739ae039);
// Expose isAxiosError
$eb999ef253053d6e$var$axios.isAxiosError = (0, $eecd01492f51a517$export$2e2bcd8739ae039);
// Expose mergeConfig
$eb999ef253053d6e$var$axios.mergeConfig = (0, $ed738da9502ca495$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.AxiosHeaders = (0, $c2923f037e2bae4f$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.formToJSON = (thing)=>(0, $bdd273a6ec9f935e$export$2e2bcd8739ae039)((0, $8ca3655f37d9652c$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$eb999ef253053d6e$var$axios.getAdapter = (0, $b57d5c296e05dd0f$export$2e2bcd8739ae039).getAdapter;
$eb999ef253053d6e$var$axios.HttpStatusCode = (0, $3f8e319a46440ea5$export$2e2bcd8739ae039);
$eb999ef253053d6e$var$axios.default = $eb999ef253053d6e$var$axios;
var // this module should only have a default export
$eb999ef253053d6e$export$2e2bcd8739ae039 = $eb999ef253053d6e$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $9fc967f4cbe5a6f7$export$1c00760e9e5a4e95, AxiosError: $9fc967f4cbe5a6f7$export$c1fbed17c2f6a328, CanceledError: $9fc967f4cbe5a6f7$export$1ab0c6b20d94fa14, isCancel: $9fc967f4cbe5a6f7$export$3b22524397b493c6, CancelToken: $9fc967f4cbe5a6f7$export$fd08e3cb425f0d61, VERSION: $9fc967f4cbe5a6f7$export$a4ad2735b021c132, all: $9fc967f4cbe5a6f7$export$84bf76cd7afc7469, Cancel: $9fc967f4cbe5a6f7$export$848c9b7ead0df967, isAxiosError: $9fc967f4cbe5a6f7$export$fbafdbe06a5b5a9a, spread: $9fc967f4cbe5a6f7$export$3ae0fd4797ed47c8, toFormData: $9fc967f4cbe5a6f7$export$10ae0d317ea97f8b, AxiosHeaders: $9fc967f4cbe5a6f7$export$4e7d6ff0f3e6520, HttpStatusCode: $9fc967f4cbe5a6f7$export$a972f69c851492b3, formToJSON: $9fc967f4cbe5a6f7$export$86d7c59254d6a2c9, getAdapter: $9fc967f4cbe5a6f7$export$17ddc20a97d669e2, mergeConfig: $9fc967f4cbe5a6f7$export$7ec1ebcfa9d8bd6a } = (0, $eb999ef253053d6e$export$2e2bcd8739ae039);


(0, $eb999ef253053d6e$export$2e2bcd8739ae039).defaults.baseURL = window?.location?.host?.startsWith("localhost") ? "http://localhost:8000" : "https://api.sitestash.net";
// axios.defaults.baseURL = 'http://localhost:8000'
let $e6d4445b9ec5d3b6$var$auth_token = localStorage.getItem("authToken") || null;
function $e6d4445b9ec5d3b6$export$7c4ce05e1c99c99b(authToken, storage = null) {
    $e6d4445b9ec5d3b6$var$auth_token = authToken;
    (0, $eb999ef253053d6e$export$2e2bcd8739ae039).defaults.headers.common["Authorization"] = `Bearer ${authToken}`;
    if (storage) storage.setItem("authToken", authToken);
}
function $e6d4445b9ec5d3b6$export$38e1f53b76ec7fed() {
    return $e6d4445b9ec5d3b6$var$auth_token;
}
async function $e6d4445b9ec5d3b6$export$a0973bcfe11b05c9() {
    localStorage.removeItem("authToken");
    sessionStorage.removeItem("authToken");
    return await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post("/api/v1/logout");
}
async function $e6d4445b9ec5d3b6$export$ddb906a32562356c() {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get("/api/v1/user")).data;
}
async function $e6d4445b9ec5d3b6$export$bf950db3913272ff({ email: email, language: language, translate_to_language: translate_to_language } = {}) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).patch("/api/v1/user", {
        email: email,
        language: language,
        translate_to_language: translate_to_language
    })).data;
}
async function $e6d4445b9ec5d3b6$export$d0d68bb9ed2c643d() {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get("/api/v1/languages")).data;
}
async function $e6d4445b9ec5d3b6$export$1eb8f9a671ab6195() {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get("/api/v1/summarizer")).data;
}
function $e6d4445b9ec5d3b6$var$userAgentDevice() {
    return navigator.userAgent.replace(/\s.+$/, "");
}
async function $e6d4445b9ec5d3b6$export$92a2a7f4653d8ef6(email, password, deviceName = null) {
    if (!deviceName) deviceName = $e6d4445b9ec5d3b6$var$userAgentDevice();
    await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get("/sanctum/csrf-cookie");
    // this request above did just set cookie in application cookie, otherwise we'll get a CSRF mismatch error
    let { data: data } = await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post("/sanctum/token", {
        email: email,
        password: password,
        device_name: deviceName
    });
    return data;
}
async function $e6d4445b9ec5d3b6$export$cc7f960a19545afa(email) {
    // await axios.post('/passwordless-login/token')
    let { data: data } = await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post("/passwordless-login", {
        email: email,
        device_name: $e6d4445b9ec5d3b6$var$userAgentDevice()
    });
    return data;
}
async function $e6d4445b9ec5d3b6$export$fa4e1662809fcdbb(email, code) {
    let { data: data } = await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post("/passwordless-login/token", {
        email: email,
        code: code,
        device_name: $e6d4445b9ec5d3b6$var$userAgentDevice()
    });
    return data.token;
}
async function $e6d4445b9ec5d3b6$export$a66962373efc50e6() {
    return await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get("/sanctum/csrf-cookie");
}
async function $e6d4445b9ec5d3b6$export$7200a869094fec36({ email: email, password: password, invitationCode: invitationCode } = {}) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post("/api/v1/signup", {
        email: email,
        password: password,
        invitation_code: invitationCode
    }))?.data;
}
async function $e6d4445b9ec5d3b6$export$f401af2a0cdbf548(email) {
    let res = await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(`/api/v1/signup/email_is_available/${email}`);
    return res.data.email_is_available && res.data.email_is_valid;
}
async function $e6d4445b9ec5d3b6$export$db579c517e4aeb29(email) {
    return await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post("/api/v1/forgot-password", {
        email: email
    });
}
async function $e6d4445b9ec5d3b6$export$b47079be406b9011({ html: html, url: url, is_behind_paywall: is_behind_paywall, language: language, summarize_mode: summarize_mode, content_classification: content_classification, collection_id: collection_id, custom_article_text: custom_article_text } = {}) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post("/api/v1/website", {
        html: html,
        url: url,
        language: language,
        summarize_mode: summarize_mode,
        is_behind_paywall: is_behind_paywall,
        content_classification: content_classification,
        collection_id: collection_id,
        custom_article_text: custom_article_text
    })).data;
}
async function $e6d4445b9ec5d3b6$export$4135797811fd963d(url) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(`/api/v1/website_exists?url=${encodeURIComponent(url)}`)).data;
}
async function $e6d4445b9ec5d3b6$export$a998db9f214ca37d(id) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(`/api/v1/websites/${id}`)).data?.website;
}
async function $e6d4445b9ec5d3b6$export$1b3728eeff4927a2() {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(`/api/v1/user/credits`)).data;
}
async function $e6d4445b9ec5d3b6$export$a46a2e1c490934e3(id, targetLanguage) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post(`/api/v1/websites/${id}/translate/${targetLanguage}`)).data;
}
async function $e6d4445b9ec5d3b6$export$10ca37dcc57736ab(id, imageUrl) {
    return await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).delete(`/api/v1/websites/${id}`);
}
async function $e6d4445b9ec5d3b6$export$fb1f670b3e66577f({ limit: limit = 20, url: url = "", page: page = 1, title: title = "" } = {}) {
    if (!title) title = "";
    let query = new URLSearchParams({
        limit: limit,
        url: url,
        title: title,
        page: page
    });
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(`/api/v1/websites${query ? "?" + query.toString() : ""}`)).data?.websites || [];
}
async function $e6d4445b9ec5d3b6$export$8a6bc556b09e441b(websiteId, imageUrl, save = false) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post(`/api/v1/websites/${websiteId}/display_image`, {
        image_url: imageUrl,
        save: save
    })).data;
}
async function $e6d4445b9ec5d3b6$export$475ece786eef46a9(websiteId, params) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).patch(`/api/v1/websites/${websiteId}`, params)).data;
}
async function $e6d4445b9ec5d3b6$export$a409bf62ca41eca7(websiteId, { url: url, html: html, analyze: analyze } = {}) {
    return await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post(`/api/v1/websites/${websiteId}/analyze`, {
        html: html,
        url: url,
        analyze: analyze
    });
}
async function $e6d4445b9ec5d3b6$export$e5bbb53e009237db(websiteId) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post(`/api/v1/websites/${websiteId}/process_status_finished`)).data;
}
async function $e6d4445b9ec5d3b6$export$c74125a8e3af6bb2(name) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post(`/api/v1/collection`, {
        name: name
    })).data;
}
async function $e6d4445b9ec5d3b6$export$167de583c0ce0e55() {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(`/api/v1/collections`)).data.collections;
}
async function $e6d4445b9ec5d3b6$export$3d16e031f6551662(id) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).delete(`/api/v1/collections/${id}`)).data;
}
async function $e6d4445b9ec5d3b6$export$e7ff9a1e8c127508(id, { name: name } = {}) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).patch(`/api/v1/collections/${id}`, {
        name: name
    })).data;
}
async function $e6d4445b9ec5d3b6$export$c9b39eef4d7f6496(url = null) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).get(`/api/v1/possible_content_categories${url ? "?url=" + encodeURIComponent(url) : ""}`)).data;
}
async function $e6d4445b9ec5d3b6$export$f133bf94867451a9(id, text, targetLanguage = null) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post(`/api/v1/websites/${id}/summary`, {
        text: text,
        target_language: targetLanguage
    })).data;
}
async function $e6d4445b9ec5d3b6$export$3c8f3110610b22c8(websiteId, collectionId) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).post(`/api/v1/collections/${collectionId}/websites/${websiteId}`)).data;
}
async function $e6d4445b9ec5d3b6$export$9bf88d0259feec91(websiteId, collectionId) {
    return (await (0, $eb999ef253053d6e$export$2e2bcd8739ae039).delete(`/api/v1/collections/${collectionId}/websites/${websiteId}`)).data;
} // export async function version() {
 //     return await axios.get('/api/v1/version')
 // }
 // export async function deleteAccount(password) {
 //     return await axios.delete('/api/v1/account', { data: { password } })
 // }


var $5892d26dd4f89ebf$exports = {};
"use strict";
var $f4b6cfc101e2aa87$exports = {};

$parcel$export($f4b6cfc101e2aa87$exports, "atom", function () { return $f4b6cfc101e2aa87$export$5fb5cc0d078610b; }, function (v) { return $f4b6cfc101e2aa87$export$5fb5cc0d078610b = v; });
$parcel$export($f4b6cfc101e2aa87$exports, "createStore", function () { return $f4b6cfc101e2aa87$export$f51a9068ac82ea43; }, function (v) { return $f4b6cfc101e2aa87$export$f51a9068ac82ea43 = v; });
$parcel$export($f4b6cfc101e2aa87$exports, "getDefaultStore", function () { return $f4b6cfc101e2aa87$export$39b2e4393dfcb8aa; }, function (v) { return $f4b6cfc101e2aa87$export$39b2e4393dfcb8aa = v; });
var $f4b6cfc101e2aa87$export$5fb5cc0d078610b;
var $f4b6cfc101e2aa87$export$f51a9068ac82ea43;
var $f4b6cfc101e2aa87$export$39b2e4393dfcb8aa;
"use strict";
var $f4b6cfc101e2aa87$var$keyCount = 0;
function $f4b6cfc101e2aa87$var$atom(read, write) {
    var key = "atom" + ++$f4b6cfc101e2aa87$var$keyCount;
    var config = {
        toString: function toString() {
            return key;
        }
    };
    if (typeof read === "function") config.read = read;
    else {
        config.init = read;
        config.read = function(get) {
            return get(config);
        };
        config.write = function(get, set, arg) {
            return set(config, typeof arg === "function" ? arg(get(config)) : arg);
        };
    }
    if (write) config.write = write;
    return config;
}
function $f4b6cfc101e2aa87$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f4b6cfc101e2aa87$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f4b6cfc101e2aa87$var$_arrayLikeToArray(o, minLen);
}
function $f4b6cfc101e2aa87$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f4b6cfc101e2aa87$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $f4b6cfc101e2aa87$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $f4b6cfc101e2aa87$var$hasInitialValue = function hasInitialValue(atom) {
    return "init" in atom;
};
var $f4b6cfc101e2aa87$var$isActuallyWritableAtom = function isActuallyWritableAtom(atom) {
    return !!atom.write;
};
var $f4b6cfc101e2aa87$var$cancelPromiseMap = new WeakMap();
var $f4b6cfc101e2aa87$var$registerCancelPromise = function registerCancelPromise(promise, cancel) {
    $f4b6cfc101e2aa87$var$cancelPromiseMap.set(promise, cancel);
    promise.catch(function() {}).finally(function() {
        return $f4b6cfc101e2aa87$var$cancelPromiseMap.delete(promise);
    });
};
var $f4b6cfc101e2aa87$var$cancelPromise = function cancelPromise(promise, next) {
    var cancel = $f4b6cfc101e2aa87$var$cancelPromiseMap.get(promise);
    if (cancel) {
        $f4b6cfc101e2aa87$var$cancelPromiseMap.delete(promise);
        cancel(next);
    }
};
var $f4b6cfc101e2aa87$var$resolvePromise = function resolvePromise(promise, value) {
    promise.status = "fulfilled";
    promise.value = value;
};
var $f4b6cfc101e2aa87$var$rejectPromise = function rejectPromise(promise, e) {
    promise.status = "rejected";
    promise.reason = e;
};
var $f4b6cfc101e2aa87$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var $f4b6cfc101e2aa87$var$isEqualAtomValue = function isEqualAtomValue(a, b) {
    return "v" in a && "v" in b && Object.is(a.v, b.v);
};
var $f4b6cfc101e2aa87$var$isEqualAtomError = function isEqualAtomError(a, b) {
    return "e" in a && "e" in b && Object.is(a.e, b.e);
};
var $f4b6cfc101e2aa87$var$hasPromiseAtomValue = function hasPromiseAtomValue(a) {
    return "v" in a && a.v instanceof Promise;
};
var $f4b6cfc101e2aa87$var$isEqualPromiseAtomValue = function isEqualPromiseAtomValue(a, b) {
    return "v" in a && "v" in b && a.v.orig && a.v.orig === b.v.orig;
};
var $f4b6cfc101e2aa87$var$returnAtomValue = function returnAtomValue(atomState) {
    if ("e" in atomState) throw atomState.e;
    return atomState.v;
};
var $f4b6cfc101e2aa87$var$createStore = function createStore() {
    var atomStateMap = new WeakMap();
    var mountedMap = new WeakMap();
    var pendingMap = new Map();
    var storeListenersRev2;
    var mountedAtoms;
    var getAtomState = function getAtomState(atom) {
        return atomStateMap.get(atom);
    };
    var setAtomState = function setAtomState(atom, atomState) {
        var prevAtomState = atomStateMap.get(atom);
        atomStateMap.set(atom, atomState);
        if (!pendingMap.has(atom)) pendingMap.set(atom, prevAtomState);
        if (prevAtomState && $f4b6cfc101e2aa87$var$hasPromiseAtomValue(prevAtomState)) {
            var _next = "v" in atomState ? atomState.v instanceof Promise ? atomState.v : Promise.resolve(atomState.v) : Promise.reject(atomState.e);
            if (prevAtomState.v !== _next) $f4b6cfc101e2aa87$var$cancelPromise(prevAtomState.v, _next);
        }
    };
    var updateDependencies = function updateDependencies(atom, nextAtomState, nextDependencies) {
        var dependencies = new Map();
        var changed = false;
        nextDependencies.forEach(function(aState, a) {
            if (!aState && a === atom) aState = nextAtomState;
            if (aState) {
                dependencies.set(a, aState);
                if (nextAtomState.d.get(a) !== aState) changed = true;
            }
        });
        if (changed || nextAtomState.d.size !== dependencies.size) nextAtomState.d = dependencies;
    };
    var setAtomValue = function setAtomValue(atom, value, nextDependencies) {
        var prevAtomState = getAtomState(atom);
        var nextAtomState = {
            d: (prevAtomState == null ? void 0 : prevAtomState.d) || new Map(),
            v: value
        };
        if (nextDependencies) updateDependencies(atom, nextAtomState, nextDependencies);
        if (prevAtomState && $f4b6cfc101e2aa87$var$isEqualAtomValue(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) return prevAtomState;
        if (prevAtomState && $f4b6cfc101e2aa87$var$hasPromiseAtomValue(prevAtomState) && $f4b6cfc101e2aa87$var$hasPromiseAtomValue(nextAtomState) && $f4b6cfc101e2aa87$var$isEqualPromiseAtomValue(prevAtomState, nextAtomState)) {
            if (prevAtomState.d === nextAtomState.d) return prevAtomState;
            else nextAtomState.v = prevAtomState.v;
        }
        setAtomState(atom, nextAtomState);
        return nextAtomState;
    };
    var setAtomValueOrPromise = function setAtomValueOrPromise(atom, valueOrPromise, nextDependencies, abortPromise) {
        if ($f4b6cfc101e2aa87$var$isPromiseLike(valueOrPromise)) {
            var continuePromise;
            var promise = new Promise(function(resolve, reject) {
                var settled = false;
                valueOrPromise.then(function(v) {
                    if (!settled) {
                        settled = true;
                        var prevAtomState = getAtomState(atom);
                        var nextAtomState = setAtomValue(atom, promise, nextDependencies);
                        $f4b6cfc101e2aa87$var$resolvePromise(promise, v);
                        resolve(v);
                        if (mountedMap.has(atom) && (prevAtomState == null ? void 0 : prevAtomState.d) !== nextAtomState.d) mountDependencies(atom, nextAtomState, prevAtomState == null ? void 0 : prevAtomState.d);
                    }
                }, function(e) {
                    if (!settled) {
                        settled = true;
                        var prevAtomState = getAtomState(atom);
                        var nextAtomState = setAtomValue(atom, promise, nextDependencies);
                        $f4b6cfc101e2aa87$var$rejectPromise(promise, e);
                        reject(e);
                        if (mountedMap.has(atom) && (prevAtomState == null ? void 0 : prevAtomState.d) !== nextAtomState.d) mountDependencies(atom, nextAtomState, prevAtomState == null ? void 0 : prevAtomState.d);
                    }
                });
                continuePromise = function continuePromise(next) {
                    if (!settled) {
                        settled = true;
                        next.then(function(v) {
                            return $f4b6cfc101e2aa87$var$resolvePromise(promise, v);
                        }, function(e) {
                            return $f4b6cfc101e2aa87$var$rejectPromise(promise, e);
                        });
                        resolve(next);
                    }
                };
            });
            promise.orig = valueOrPromise;
            promise.status = "pending";
            $f4b6cfc101e2aa87$var$registerCancelPromise(promise, function(next) {
                if (next) continuePromise(next);
                abortPromise == null || abortPromise();
            });
            return setAtomValue(atom, promise, nextDependencies);
        }
        return setAtomValue(atom, valueOrPromise, nextDependencies);
    };
    var setAtomError = function setAtomError(atom, error, nextDependencies) {
        var prevAtomState = getAtomState(atom);
        var nextAtomState = {
            d: (prevAtomState == null ? void 0 : prevAtomState.d) || new Map(),
            e: error
        };
        if (nextDependencies) updateDependencies(atom, nextAtomState, nextDependencies);
        if (prevAtomState && $f4b6cfc101e2aa87$var$isEqualAtomError(prevAtomState, nextAtomState) && prevAtomState.d === nextAtomState.d) return prevAtomState;
        setAtomState(atom, nextAtomState);
        return nextAtomState;
    };
    var readAtomState = function readAtomState(atom, force) {
        var atomState = getAtomState(atom);
        if (!force && atomState) {
            if (mountedMap.has(atom)) return atomState;
            if (Array.from(atomState.d).every(function(_ref) {
                var a = _ref[0], s = _ref[1];
                return a === atom || readAtomState(a) === s;
            })) return atomState;
        }
        var nextDependencies = new Map();
        var isSync = true;
        var getter = function getter(a) {
            if (a === atom) {
                var _aState = getAtomState(a);
                if (_aState) {
                    nextDependencies.set(a, _aState);
                    return $f4b6cfc101e2aa87$var$returnAtomValue(_aState);
                }
                if ($f4b6cfc101e2aa87$var$hasInitialValue(a)) {
                    nextDependencies.set(a, undefined);
                    return a.init;
                }
                throw new Error("no atom init");
            }
            var aState = readAtomState(a);
            nextDependencies.set(a, aState);
            return $f4b6cfc101e2aa87$var$returnAtomValue(aState);
        };
        var controller;
        var setSelf;
        var options = {
            get signal () {
                if (!controller) controller = new AbortController();
                return controller.signal;
            },
            get setSelf () {
                if (!setSelf && $f4b6cfc101e2aa87$var$isActuallyWritableAtom(atom)) setSelf = function setSelf() {
                    if (!isSync) {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return writeAtom.apply(void 0, [
                            atom
                        ].concat(args));
                    }
                };
                return setSelf;
            }
        };
        try {
            var valueOrPromise = atom.read(getter, options);
            return setAtomValueOrPromise(atom, valueOrPromise, nextDependencies, function() {
                var _controller;
                return (_controller = controller) == null ? void 0 : _controller.abort();
            });
        } catch (error) {
            return setAtomError(atom, error, nextDependencies);
        } finally{
            isSync = false;
        }
    };
    var readAtom = function readAtom(atom) {
        return $f4b6cfc101e2aa87$var$returnAtomValue(readAtomState(atom));
    };
    var addAtom = function addAtom(atom) {
        var mounted = mountedMap.get(atom);
        if (!mounted) mounted = mountAtom(atom);
        return mounted;
    };
    var canUnmountAtom = function canUnmountAtom(atom, mounted) {
        return !mounted.l.size && (!mounted.t.size || mounted.t.size === 1 && mounted.t.has(atom));
    };
    var delAtom = function delAtom(atom) {
        var mounted = mountedMap.get(atom);
        if (mounted && canUnmountAtom(atom, mounted)) unmountAtom(atom);
    };
    var recomputeDependents = function recomputeDependents(atom) {
        var dependencyMap = new Map();
        var dirtyMap = new WeakMap();
        var getDependents = function getDependents(a) {
            var _mountedMap$get;
            var dependents = new Set((_mountedMap$get = mountedMap.get(a)) == null ? void 0 : _mountedMap$get.t);
            pendingMap.forEach(function(_, pendingAtom) {
                var _getAtomState;
                if ((_getAtomState = getAtomState(pendingAtom)) != null && _getAtomState.d.has(a)) dependents.add(pendingAtom);
            });
            return dependents;
        };
        var loop1 = function loop1(a) {
            getDependents(a).forEach(function(dependent) {
                if (dependent !== a) {
                    dependencyMap.set(dependent, (dependencyMap.get(dependent) || new Set()).add(a));
                    dirtyMap.set(dependent, (dirtyMap.get(dependent) || 0) + 1);
                    loop1(dependent);
                }
            });
        };
        loop1(atom);
        var loop2 = function loop2(a) {
            getDependents(a).forEach(function(dependent) {
                if (dependent !== a) {
                    var dirtyCount = dirtyMap.get(dependent);
                    if (dirtyCount) dirtyMap.set(dependent, --dirtyCount);
                    if (!dirtyCount) {
                        var _dependencyMap$get;
                        var isChanged = !!((_dependencyMap$get = dependencyMap.get(dependent)) != null && _dependencyMap$get.size);
                        if (isChanged) {
                            var prevAtomState = getAtomState(dependent);
                            var nextAtomState = readAtomState(dependent, true);
                            isChanged = !prevAtomState || !$f4b6cfc101e2aa87$var$isEqualAtomValue(prevAtomState, nextAtomState);
                        }
                        if (!isChanged) dependencyMap.forEach(function(s) {
                            return s.delete(dependent);
                        });
                    }
                    loop2(dependent);
                }
            });
        };
        loop2(atom);
    };
    var writeAtomState = function writeAtomState(atom) {
        var isSync = true;
        var getter = function getter(a) {
            return $f4b6cfc101e2aa87$var$returnAtomValue(readAtomState(a));
        };
        var setter = function setter(a) {
            var r;
            for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
            if (a === atom) {
                if (!$f4b6cfc101e2aa87$var$hasInitialValue(a)) throw new Error("atom not writable");
                var prevAtomState = getAtomState(a);
                var nextAtomState = setAtomValueOrPromise(a, args[0]);
                if (!prevAtomState || !$f4b6cfc101e2aa87$var$isEqualAtomValue(prevAtomState, nextAtomState)) recomputeDependents(a);
            } else r = writeAtomState.apply(void 0, [
                a
            ].concat(args));
            if (!isSync) var flushed = flushPending();
            return r;
        };
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var result = atom.write.apply(atom, [
            getter,
            setter
        ].concat(args));
        isSync = false;
        return result;
    };
    var writeAtom = function writeAtom(atom) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        var result = writeAtomState.apply(void 0, [
            atom
        ].concat(args));
        var flushed = flushPending();
        return result;
    };
    var mountAtom = function mountAtom(atom, initialDependent, onMountQueue) {
        var _getAtomState2;
        var queue = onMountQueue || [];
        (_getAtomState2 = getAtomState(atom)) == null || _getAtomState2.d.forEach(function(_, a) {
            var aMounted = mountedMap.get(a);
            if (aMounted) aMounted.t.add(atom);
            else if (a !== atom) mountAtom(a, atom, queue);
        });
        readAtomState(atom);
        var mounted = {
            t: new Set(initialDependent && [
                initialDependent
            ]),
            l: new Set()
        };
        mountedMap.set(atom, mounted);
        if ($f4b6cfc101e2aa87$var$isActuallyWritableAtom(atom) && atom.onMount) {
            var onMount = atom.onMount;
            queue.push(function() {
                var onUnmount = onMount(function() {
                    for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                    return writeAtom.apply(void 0, [
                        atom
                    ].concat(args));
                });
                if (onUnmount) mounted.u = onUnmount;
            });
        }
        if (!onMountQueue) queue.forEach(function(f) {
            return f();
        });
        return mounted;
    };
    var unmountAtom = function unmountAtom(atom) {
        var _mountedMap$get2;
        var onUnmount = (_mountedMap$get2 = mountedMap.get(atom)) == null ? void 0 : _mountedMap$get2.u;
        if (onUnmount) onUnmount();
        mountedMap.delete(atom);
        var atomState = getAtomState(atom);
        if (atomState) {
            if ($f4b6cfc101e2aa87$var$hasPromiseAtomValue(atomState)) $f4b6cfc101e2aa87$var$cancelPromise(atomState.v);
            atomState.d.forEach(function(_, a) {
                if (a !== atom) {
                    var mounted = mountedMap.get(a);
                    if (mounted) {
                        mounted.t.delete(atom);
                        if (canUnmountAtom(a, mounted)) unmountAtom(a);
                    }
                }
            });
        }
    };
    var mountDependencies = function mountDependencies(atom, atomState, prevDependencies) {
        var depSet = new Set(atomState.d.keys());
        prevDependencies == null || prevDependencies.forEach(function(_, a) {
            if (depSet.has(a)) {
                depSet.delete(a);
                return;
            }
            var mounted = mountedMap.get(a);
            if (mounted) {
                mounted.t.delete(atom);
                if (canUnmountAtom(a, mounted)) unmountAtom(a);
            }
        });
        depSet.forEach(function(a) {
            var mounted = mountedMap.get(a);
            if (mounted) mounted.t.add(atom);
            else if (mountedMap.has(atom)) mountAtom(a, atom);
        });
    };
    var flushPending = function flushPending() {
        var flushed;
        while(pendingMap.size){
            var pending = Array.from(pendingMap);
            pendingMap.clear();
            pending.forEach(function(_ref2) {
                var atom = _ref2[0], prevAtomState = _ref2[1];
                var atomState = getAtomState(atom);
                if (atomState) {
                    var mounted = mountedMap.get(atom);
                    if (mounted && atomState.d !== (prevAtomState == null ? void 0 : prevAtomState.d)) mountDependencies(atom, atomState, prevAtomState == null ? void 0 : prevAtomState.d);
                    if (mounted && !(prevAtomState && !$f4b6cfc101e2aa87$var$hasPromiseAtomValue(prevAtomState) && ($f4b6cfc101e2aa87$var$isEqualAtomValue(prevAtomState, atomState) || $f4b6cfc101e2aa87$var$isEqualAtomError(prevAtomState, atomState)))) mounted.l.forEach(function(listener) {
                        return listener();
                    });
                }
            });
        }
    };
    var subscribeAtom = function subscribeAtom(atom, listener) {
        var mounted = addAtom(atom);
        var flushed = flushPending();
        var listeners = mounted.l;
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
            delAtom(atom);
        };
    };
    return {
        get: readAtom,
        set: writeAtom,
        sub: subscribeAtom
    };
};
var $f4b6cfc101e2aa87$var$defaultStore;
var $f4b6cfc101e2aa87$var$getDefaultStore = function getDefaultStore() {
    if (!$f4b6cfc101e2aa87$var$defaultStore) $f4b6cfc101e2aa87$var$defaultStore = $f4b6cfc101e2aa87$var$createStore();
    return $f4b6cfc101e2aa87$var$defaultStore;
};
$f4b6cfc101e2aa87$export$5fb5cc0d078610b = $f4b6cfc101e2aa87$var$atom;
$f4b6cfc101e2aa87$export$f51a9068ac82ea43 = $f4b6cfc101e2aa87$var$createStore;
$f4b6cfc101e2aa87$export$39b2e4393dfcb8aa = $f4b6cfc101e2aa87$var$getDefaultStore;


var $cb7e33a89d5908a3$exports = {};

$parcel$export($cb7e33a89d5908a3$exports, "Provider", function () { return $cb7e33a89d5908a3$export$2881499e37b75b9a; }, function (v) { return $cb7e33a89d5908a3$export$2881499e37b75b9a = v; });
$parcel$export($cb7e33a89d5908a3$exports, "useAtom", function () { return $cb7e33a89d5908a3$export$83cf7ae8bb57e7ed; }, function (v) { return $cb7e33a89d5908a3$export$83cf7ae8bb57e7ed = v; });
$parcel$export($cb7e33a89d5908a3$exports, "useAtomValue", function () { return $cb7e33a89d5908a3$export$89a40582f8c436cc; }, function (v) { return $cb7e33a89d5908a3$export$89a40582f8c436cc = v; });
$parcel$export($cb7e33a89d5908a3$exports, "useSetAtom", function () { return $cb7e33a89d5908a3$export$a247c952d39ea7ea; }, function (v) { return $cb7e33a89d5908a3$export$a247c952d39ea7ea = v; });
$parcel$export($cb7e33a89d5908a3$exports, "useStore", function () { return $cb7e33a89d5908a3$export$6ccbb43953eebf8; }, function (v) { return $cb7e33a89d5908a3$export$6ccbb43953eebf8 = v; });
var $cb7e33a89d5908a3$export$2881499e37b75b9a;
var $cb7e33a89d5908a3$export$83cf7ae8bb57e7ed;
var $cb7e33a89d5908a3$export$89a40582f8c436cc;
var $cb7e33a89d5908a3$export$a247c952d39ea7ea;
var $cb7e33a89d5908a3$export$6ccbb43953eebf8;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $cb7e33a89d5908a3$var$StoreContext = $exYeM.createContext(undefined);
var $cb7e33a89d5908a3$var$useStore = function useStore(options) {
    var store = $exYeM.useContext($cb7e33a89d5908a3$var$StoreContext);
    return (options == null ? void 0 : options.store) || store || $f4b6cfc101e2aa87$export$39b2e4393dfcb8aa();
};
var $cb7e33a89d5908a3$var$Provider = function Provider(_ref) {
    var children = _ref.children, store = _ref.store;
    var storeRef = $exYeM.useRef();
    if (!store && !storeRef.current) storeRef.current = $f4b6cfc101e2aa87$export$f51a9068ac82ea43();
    return $exYeM.createElement($cb7e33a89d5908a3$var$StoreContext.Provider, {
        value: store || storeRef.current
    }, children);
};
var $cb7e33a89d5908a3$var$isPromiseLike = function isPromiseLike(x) {
    return typeof (x == null ? void 0 : x.then) === "function";
};
var $cb7e33a89d5908a3$var$use = $exYeM.use || function(promise) {
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then(function(v) {
            promise.status = "fulfilled";
            promise.value = v;
        }, function(e) {
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
};
function $cb7e33a89d5908a3$var$useAtomValue(atom, options) {
    var store = $cb7e33a89d5908a3$var$useStore(options);
    var _useReducer = $exYeM.useReducer(function(prev) {
        var nextValue = store.get(atom);
        if (Object.is(prev[0], nextValue) && prev[1] === store && prev[2] === atom) return prev;
        return [
            nextValue,
            store,
            atom
        ];
    }, undefined, function() {
        return [
            store.get(atom),
            store,
            atom
        ];
    }), _useReducer$ = _useReducer[0], valueFromReducer = _useReducer$[0], storeFromReducer = _useReducer$[1], atomFromReducer = _useReducer$[2], rerender = _useReducer[1];
    var value = valueFromReducer;
    if (storeFromReducer !== store || atomFromReducer !== atom) {
        rerender();
        value = store.get(atom);
    }
    var delay = options == null ? void 0 : options.delay;
    $exYeM.useEffect(function() {
        var unsub = store.sub(atom, function() {
            if (typeof delay === "number") {
                setTimeout(rerender, delay);
                return;
            }
            rerender();
        });
        rerender();
        return unsub;
    }, [
        store,
        atom,
        delay
    ]);
    $exYeM.useDebugValue(value);
    return $cb7e33a89d5908a3$var$isPromiseLike(value) ? $cb7e33a89d5908a3$var$use(value) : value;
}
function $cb7e33a89d5908a3$var$useSetAtom(atom, options) {
    var store = $cb7e33a89d5908a3$var$useStore(options);
    var setAtom = $exYeM.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return store.set.apply(store, [
            atom
        ].concat(args));
    }, [
        store,
        atom
    ]);
    return setAtom;
}
function $cb7e33a89d5908a3$var$useAtom(atom, options) {
    return [
        $cb7e33a89d5908a3$var$useAtomValue(atom, options),
        $cb7e33a89d5908a3$var$useSetAtom(atom, options)
    ];
}
$cb7e33a89d5908a3$export$2881499e37b75b9a = $cb7e33a89d5908a3$var$Provider;
$cb7e33a89d5908a3$export$83cf7ae8bb57e7ed = $cb7e33a89d5908a3$var$useAtom;
$cb7e33a89d5908a3$export$89a40582f8c436cc = $cb7e33a89d5908a3$var$useAtomValue;
$cb7e33a89d5908a3$export$a247c952d39ea7ea = $cb7e33a89d5908a3$var$useSetAtom;
$cb7e33a89d5908a3$export$6ccbb43953eebf8 = $cb7e33a89d5908a3$var$useStore;


Object.keys($f4b6cfc101e2aa87$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($5892d26dd4f89ebf$exports, k)) Object.defineProperty($5892d26dd4f89ebf$exports, k, {
        enumerable: true,
        get: function() {
            return $f4b6cfc101e2aa87$exports[k];
        }
    });
});
Object.keys($cb7e33a89d5908a3$exports).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call($5892d26dd4f89ebf$exports, k)) Object.defineProperty($5892d26dd4f89ebf$exports, k, {
        enumerable: true,
        get: function() {
            return $cb7e33a89d5908a3$exports[k];
        }
    });
});


const $74b6691fdb32da4b$export$980ac9afb4d68a01 = (0, $5892d26dd4f89ebf$exports.atom)({
    email: null,
    plan: null,
    translate_to_language: null,
    language: null
});



var $exYeM = parcelRequire("exYeM");
class $795732ec5bccecd3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Component {
    static instances = [];
    static rerenderAll() {
        $795732ec5bccecd3$export$2e2bcd8739ae039.instances.forEach((instance)=>instance.forceUpdate());
    }
    componentDidMount() {
        $795732ec5bccecd3$export$2e2bcd8739ae039.instances.push(this);
    }
    componentWillUnmount() {
        $795732ec5bccecd3$export$2e2bcd8739ae039.instances.splice($795732ec5bccecd3$export$2e2bcd8739ae039.instances.indexOf(this), 1);
    }
}
const $795732ec5bccecd3$export$a547427fd19c987a = ()=>{
    $795732ec5bccecd3$export$2e2bcd8739ae039.rerenderAll();
};



var $bisEj = parcelRequire("bisEj");

var $exYeM = parcelRequire("exYeM");
const $48d779be1bbcb0ab$export$77ad94ebf1c2b9ed = (translation, replacements)=>{
    if (typeof translation === "string") {
        let result = translation;
        Object.keys(replacements).forEach((replacement)=>{
            result = result.split(`%{${replacement}}`).join(replacements[replacement] ?? "");
        });
        return result;
    }
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).isValidElement(translation)) return translation;
    if (typeof translation === "object") {
        const result = {};
        Object.keys(translation).forEach((translationKey)=>{
            result[translationKey] = $48d779be1bbcb0ab$export$77ad94ebf1c2b9ed(translation[translationKey], replacements);
        });
        return result;
    }
    return null;
};
const $48d779be1bbcb0ab$export$805800ad6d0194f7 = function(translations, key) {
    let count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    const _index = key.indexOf(".");
    if (typeof translations === "undefined") throw new Error("not found");
    if (_index > -1) return $48d779be1bbcb0ab$export$805800ad6d0194f7(translations[key.substring(0, _index)], key.substr(_index + 1), count);
    if (count !== null) {
        if (translations[`${key}_${count}`]) // when key = 'items_3' if count is 3
        return translations[`${key}_${count}`];
        if (count !== 1 && translations[`${key}_plural`]) // when count is not simply singular, return _plural
        return translations[`${key}_plural`];
    }
    if (translations[key] != null) return translations[key];
    throw new Error("not found");
};


/* eslint no-console: "off" */ 
const $b7ce7ba39a245f74$var$settings = {
    localeKey: "en",
    translationsObject: {},
    getTranslations: null,
    getLocale: null,
    handleMissingTranslation: (text)=>text.split(".").pop(),
    handleFailedLocalization: ()=>null
};
const $b7ce7ba39a245f74$export$180605366c04f0cd = ()=>$b7ce7ba39a245f74$var$settings.getLocale ? $b7ce7ba39a245f74$var$settings.getLocale() : $b7ce7ba39a245f74$var$settings.localeKey;
const $b7ce7ba39a245f74$export$c8aadf3621e41efb = function(locale) {
    let rerenderComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $b7ce7ba39a245f74$var$settings.localeKey = locale;
    $b7ce7ba39a245f74$var$settings.getLocale = null;
    if (rerenderComponents) (0, $795732ec5bccecd3$export$2e2bcd8739ae039).rerenderAll();
};
const $b7ce7ba39a245f74$export$b714c664bcce0254 = function() {
    return $b7ce7ba39a245f74$var$settings.handleMissingTranslation(...arguments);
};
const $b7ce7ba39a245f74$export$56874b2b97a83b27 = function() {
    return $b7ce7ba39a245f74$var$settings.handleFailedLocalization(...arguments);
};
const $b7ce7ba39a245f74$export$a7e3aedd9ea505f2 = ()=>$b7ce7ba39a245f74$var$settings.getTranslations ? $b7ce7ba39a245f74$var$settings.getTranslations() : $b7ce7ba39a245f74$var$settings.translationsObject;
const $b7ce7ba39a245f74$export$69890adb93456605 = function(translations) {
    let rerenderComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    $b7ce7ba39a245f74$var$settings.translationsObject = translations;
    $b7ce7ba39a245f74$var$settings.getTranslations = null;
    if (rerenderComponents) (0, $795732ec5bccecd3$export$2e2bcd8739ae039).rerenderAll();
};
const $b7ce7ba39a245f74$export$a14cb0f4d5a61442 = (fn)=>{
    if (typeof fn !== "function") throw new Error("Locale getter must be a function");
    $b7ce7ba39a245f74$var$settings.getLocale = fn;
};
const $b7ce7ba39a245f74$export$8cd88d89fd3ac516 = (fn)=>{
    if (typeof fn !== "function") throw new Error("Translations getter must be a function");
    $b7ce7ba39a245f74$var$settings.getTranslations = fn;
};
const $b7ce7ba39a245f74$export$52cef9b23c04172 = (fn)=>{
    if (typeof fn !== "function") throw new Error("Handle missing translation must be a function");
    $b7ce7ba39a245f74$var$settings.handleMissingTranslation = fn;
};
const $b7ce7ba39a245f74$export$d1f459dbc6ef581b = (fn)=>{
    if (typeof fn !== "function") throw new Error("Handle failed localization must be a function");
    $b7ce7ba39a245f74$var$settings.handleFailedLocalization = fn;
};


var $17c4d184a1f6cffa$export$2e2bcd8739ae039 = function(key) {
    let replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const locale = options.locale || (0, $b7ce7ba39a245f74$export$180605366c04f0cd)();
    let translation = "";
    try {
        const translationLocale = (0, $b7ce7ba39a245f74$export$a7e3aedd9ea505f2)()[locale] ? locale : locale.split("-")[0];
        translation = (0, $48d779be1bbcb0ab$export$805800ad6d0194f7)((0, $b7ce7ba39a245f74$export$a7e3aedd9ea505f2)(), `${translationLocale}.${key}`, replacements.count);
    } catch (err) {
        if (options.returnNullOnError) return null;
        if (options.returnKeyOnError) return key;
        return (0, $b7ce7ba39a245f74$export$b714c664bcce0254)(key, replacements, options, err);
    }
    return (0, $48d779be1bbcb0ab$export$77ad94ebf1c2b9ed)(translation, replacements);
};



class $01b25f31556ef409$var$Translate extends (0, $795732ec5bccecd3$export$2e2bcd8739ae039) {
    render() {
        const { value: value, locale: locale, ...otherProps } = this.props;
        const translation = (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)(value, otherProps, {
            locale: locale
        });
        return translation;
    }
}
$01b25f31556ef409$var$Translate.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string.isRequired,
    locale: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string
};
var $01b25f31556ef409$export$2e2bcd8739ae039 = $01b25f31556ef409$var$Translate;



var $bisEj = parcelRequire("bisEj");
var $0c5f86c746bdc3a3$exports = {};
!function(t, e) {
    $0c5f86c746bdc3a3$exports = e();
}($0c5f86c746bdc3a3$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = function(t) {
        return t instanceof b;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new b(n);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var b = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, f = O.p(t), l = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = O.p(f), y = function(t) {
                var e = w(l);
                return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return O.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return O.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return O.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return O.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return O.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return O.s(e.$s, 2, "0");
                        case "SSS":
                            return O.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = O.p(d), m = w(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return O.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : O.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), _ = b.prototype;
    return w.prototype = _, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        _[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, b, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
});


var $c42c634570fb1244$exports = {};
!function(e, t) {
    $c42c634570fb1244$exports = t();
}($c42c634570fb1244$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var a = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, f = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], h = function(e) {
        var t = o[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, u = function(e, t) {
        var n, r = o.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, d = {
        A: [
            i,
            function(e) {
                this.afternoon = u(e, !1);
            }
        ],
        a: [
            i,
            function(e) {
                this.afternoon = u(e, !0);
            }
        ],
        S: [
            /\d/,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            n,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            r,
            a("seconds")
        ],
        ss: [
            r,
            a("seconds")
        ],
        m: [
            r,
            a("minutes")
        ],
        mm: [
            r,
            a("minutes")
        ],
        H: [
            r,
            a("hours")
        ],
        h: [
            r,
            a("hours")
        ],
        HH: [
            r,
            a("hours")
        ],
        hh: [
            r,
            a("hours")
        ],
        D: [
            r,
            a("day")
        ],
        DD: [
            n,
            a("day")
        ],
        Do: [
            i,
            function(e) {
                var t = o.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        M: [
            r,
            a("month")
        ],
        MM: [
            n,
            a("month")
        ],
        MMM: [
            i,
            function(e) {
                var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            i,
            function(e) {
                var t = h("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            a("year")
        ],
        YY: [
            n,
            function(e) {
                this.year = s(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            a("year")
        ],
        Z: f,
        ZZ: f
    };
    function c(n) {
        var r, i;
        r = n, i = o && o.formats;
        for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = s.length, f = 0; f < a; f += 1){
            var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
            s[f] = l ? {
                regex: c,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = s[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, s = e.args;
            this.$u = r;
            var a = s[1];
            if ("string" == typeof a) {
                var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                        i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                        var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                        return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
            } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                s[1] = a[m - 1];
                var M = n.apply(this, s);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === l && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $35172335eeb4ed1d$exports = {};
!function(e, t) {
    $35172335eeb4ed1d$exports = t();
}($35172335eeb4ed1d$exports, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});


var $9a31df7f368f2d49$exports = {};
!function(e, t) {
    $9a31df7f368f2d49$exports = t();
}($9a31df7f368f2d49$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});


var $5043bf0d4c203a0d$exports = {};
!function(r, e) {
    $5043bf0d4c203a0d$exports = e();
}($5043bf0d4c203a0d$exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});




(0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($c42c634570fb1244$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($35172335eeb4ed1d$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($9a31df7f368f2d49$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($5043bf0d4c203a0d$exports))));
var $32e88d694bc2680a$export$2e2bcd8739ae039 = function(value) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const locale = options.locale || (0, $b7ce7ba39a245f74$export$180605366c04f0cd)();
    if (options.dateFormat) try {
        let dayJsLocale = locale.toLowerCase();
        if (locale === "no") dayJsLocale = "nb"; // Bokmål as default Norwegian
        const parsedDate = (options.parseFormat ? (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(value, (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)(options.parseFormat, {}, {
            locale: locale,
            returnKeyOnError: true
        }), dayJsLocale) : (0, (/*@__PURE__*/$parcel$interopDefault($0c5f86c746bdc3a3$exports)))(value)).locale(dayJsLocale);
        if (!dayJsLocale.startsWith(parsedDate.locale())) throw new Error("Invalid locale");
        if (!parsedDate.isValid()) throw new Error("Invalid date");
        if (options.dateFormat === "distance-to-now") return parsedDate.fromNow();
        return parsedDate.format((0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)(options.dateFormat, {}, {
            locale: locale,
            returnKeyOnError: true
        }));
    } catch (err) {
        return (0, $b7ce7ba39a245f74$export$56874b2b97a83b27)(value, options, err);
    }
    if (typeof value === "number") try {
        return new Intl.NumberFormat(locale, options).format(value);
    } catch (err) {
        return (0, $b7ce7ba39a245f74$export$56874b2b97a83b27)(value, options, err);
    }
    return value;
};



class $cf14fbe0a509e3c8$var$Localize extends (0, $795732ec5bccecd3$export$2e2bcd8739ae039) {
    render() {
        const { value: value, dateFormat: dateFormat, parseFormat: parseFormat, options: options = {} } = this.props;
        const localization = (0, $32e88d694bc2680a$export$2e2bcd8739ae039)(value, {
            ...options,
            dateFormat: dateFormat,
            parseFormat: parseFormat
        });
        return localization;
    }
}
$cf14fbe0a509e3c8$var$Localize.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
    ]).isRequired,
    dateFormat: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    parseFormat: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).string,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).object
};
var $cf14fbe0a509e3c8$export$2e2bcd8739ae039 = $cf14fbe0a509e3c8$var$Localize;



var $bisEj = parcelRequire("bisEj");

class $df1cf292185ac897$var$I18n extends (0, $795732ec5bccecd3$export$2e2bcd8739ae039) {
    render = ()=>this.props.render();
}
$df1cf292185ac897$var$I18n.propTypes = {
    render: (0, (/*@__PURE__*/$parcel$interopDefault($bisEj))).func.isRequired
};
var $df1cf292185ac897$export$2e2bcd8739ae039 = $df1cf292185ac897$var$I18n;








var $0c3290ddecd94337$exports = {};
$0c3290ddecd94337$exports = JSON.parse('{"en":{"sitestash":"sitestash","Please enter a URL":"Please enter a URL","Some problem occured while adding site":"Some problem occured while adding site","Please ensure that you have access to the site":"Please ensure that you have access to the site","In most cases that means that you need to be logged in on the website you want to stash":"In most cases that means that you need to be logged in on the website you want to stash","Then try again to the save the website with the browser plugin":"Then try again to the save the website with the browser plugin","Add Website":"Add Website","Click here to show all options":"Click here to show all options","Or press ctrl / ⌘":"Or press ctrl / ⌘","Content classification":"Content classification","Target language":"Target language","Keep original":"Keep original","Add to collection":"Add to collection","Auto":"Auto","Summarize mode":"Summarize mode","The website is behind a paywall - or not accessible by third parties":"The website is behind a paywall - or not accessible by third parties","Hint: It might be easier to use the <a href=\'https://www_sitestash_net/browser-extension\' target=\'blank\'>sitestash-browser-plugin</a> instead of inserting html code manually":"Hint: It might be easier to use the <a href=\'https://www.sitestash.net/browser-extension\' target=\'blank\'>sitestash-browser-plugin</a> instead of inserting html code manually","Insert the complete html of the page here, so that we can analyze the content without accessing the website":"Insert the complete html of the page here, so that we can analyze the content without accessing the website","${website_process_status}":"${website.process_status}","Title could not be detected":"Title could not be detected","Read more":"Read more","Name of the collection":"Name of the collection","Add collection":"Add collection","Websites":"Websites","Sure?":"Sure?","delete":"delete","No websites stashed, yet":"No websites stashed, yet","Start adding websites easily by using the browser plugin":"Start adding websites easily by using the browser plugin","or add a website manually here":"or add a website manually here","Could not login":"Could not login","Could not login_ Wrong Password?":"Could not login. Wrong Password?","E-Mail":"E-Mail","Password":"Password","Your login code":"Your login code","If you have signed up correctly, you have now received a login code which you can place here":"If you have signed up correctly, you have now received a login code which you can place here","We sent the login code":"We sent the login code","Click here, if you want to use your password instead":"Click here, if you want to use your password instead","Remember login":"Remember login","No Account, yet? Sign up here":"No Account, yet? Sign up here","Theme":"Theme","Collections":"Collections","Your Profile":"Your Profile","Search":"Search","Signup":"Signup","Login":"Login","5 websites":"5 websites","0 €":"0 €","initial":"initial","Select":"Select","200 websites":"200 websites","5 €":"5 €","per Month":"per Month","Your profile":"Your profile","Language":"Language","Translate articles by default to":"Translate articles by default to","Credits":"Credits","Number of credits left":"Number of credits left","Articles":"Articles","Buy more credits":"Buy more credits","Log out":"Log out","E-mail has already been signed up":"E-mail has already been signed up","Passwords do not match":"Passwords do not match","Could not signup":"Could not signup","Confirm password":"Confirm password","Invitation code":"Invitation code","The summarizer will add extra costs":"The summarizer will add extra costs","Translate":"Translate","Text is saving…":"Text is saving…","Save text":"Save text","Save custom text":"Save custom text","Create professional summarize":"Create professional summarize","Professional Summary":"Professional Summary","Analyze HTML":"Analyze HTML","Delete Article":"Delete Article","Change Article URL":"Change Article URL","Remove custom summary":"Remove custom summary","Save and use custom summary above":"Save and use custom summary above","Change URL":"Change URL","Summarize custom text instead of auto-extracted content":"Summarize custom text instead of auto-extracted content","Helpful if the summary seems to be wrong in regards of context":"Helpful if the summary seems to be wrong in regards of context","The update of the summary may take a minute or so - so please be patient":"The update of the summary may take a minute or so - so please be patient","Summarize custom text":"Summarize custom text","Share Article":"Share Article","Share edited article text":"Share edited article text","Don\'t share article anymore":"Don\'t share article anymore","Copied":"Copied","Copy Share URL to Clipboard":"Copy Share URL to Clipboard","Make this article public to share it with others":"Make this article public to share it with others","Share article":"Share article","Remove from favourites":"Remove from favourites","Add to favourites":"Add to favourites","Star":"Star","There was a problem while processing the url":"There was a problem while processing the url","Maybe not all parts of the website are accessible or have relevant content? If the website is behind a paywall which you can access, you should try again with the browser plugin_":"Maybe not all parts of the website are accessible or have relevant content? If the website is behind a paywall which you can access, you should try again with the browser plugin.","Alternatively you can read the article anyway, by clicking here":"Alternatively you can read the article anyway, by clicking here","Note":"Note","The original text was too long_ So parts from the end of the text are not included in the summary and may corrupt the correct gist_":"The original text was too long. So parts from the end of the text are not included in the summary and may corrupt the correct gist.","Source: ":"Source: ","Key moments":"Key moments","Hide key moments":"Hide key moments","Show image":"Show image","Add image by url":"Add image by url","Save":"Save","Hide original content":"Hide original content","Show original content":"Show original content","Original URL: ":"Original URL: ","Website is ready to read here in a moment":"Website is ready to read here in a moment","Website is already stashed":"Website is already stashed","Update Website":"Update Website","Website is behind paywall":"Website is behind paywall","Content":"Content","Translate to":"Translate to","Please login to use sitestash":"Please login to use sitestash","Sign up here for free":"Sign up here for free","Log In":"Log In","The provided credentials are incorrect":"The provided credentials are incorrect","Please confirm your e-mail-address first":"Please confirm your e-mail-address first","Your login code:":"Your login code:","If you did not request a login, no further action is required":"If you did not request a login, no further action is required","URL not found":"URL not found","Invalid URL":"Invalid URL","URL is probably behind cloudflare protecion":"URL is probably behind cloudflare protecion","URL could not be accessed":"URL could not be accessed","Not enough credits":"Not enough credits","Website already stashed":"Website already stashed","Website is stashed":"Website is stashed","Not allowed":"Not allowed","No valid invitation code":"No valid invitation code","E-Mail already exists":"E-Mail already exists","Password must be different than email":"Password must be different than email","Signup created - Please confirm your e-mail before logging in":"Signup created - Please confirm your e-mail before logging in","Language not supported":"Language not supported","Resource not found":"Resource not found","The password did not match":"The password did not match","Fast":"Fast","Accurate":"Accurate","Large content":"Large content","Large content and accurate summary":"Large content and accurate summary","If you have signed up correctly, you have now received a login code":"If you have signed up correctly, you have now received a login code","Too many login attempts":"Too many login attempts","Code or e-mail is invalid":"Code or e-mail is invalid"}}');


var $d25650ced9542cd5$exports = {};
$d25650ced9542cd5$exports = JSON.parse('{"de":{"sitestash":"sitestash","Please enter a URL":"Bitte geben Sie eine URL ein","Some problem occured while adding site":"Beim Hinzuf\xfcgen der Website ist ein Problem aufgetreten","Please ensure that you have access to the site":"Bitte stellen Sie sicher, dass Sie Zugang zur Website haben","In most cases that means that you need to be logged in on the website you want to stash":"In den meisten F\xe4llen bedeutet dies, dass Sie auf der Website, auf der Sie Ihre Daten speichern m\xf6chten, angemeldet sein m\xfcssen.","Then try again to the save the website with the browser plugin":"Versuchen Sie dann erneut, die Website mit dem Browser-Plugin zu speichern","Add Website":"Website hinzuf\xfcgen","Click here to show all options":"Klicken Sie hier, um alle Optionen anzuzeigen","Or press ctrl / ⌘":"Oder dr\xfccken Sie ctrl / ⌘.","Content classification":"Klassifizierung des Inhalts","Target language":"Zielsprache","Keep original":"Original beibehalten","Add to collection":"Zur Sammlung hinzuf\xfcgen","Auto":"Auto","Summarize mode":"Modus \\"Zusammenfassen","The website is behind a paywall - or not accessible by third parties":"Die Website befindet sich hinter einer Paywall - oder ist f\xfcr Dritte nicht zug\xe4nglich","Hint: It might be easier to use the <a href=\'https://www_sitestash_net/browser-extension\' target=\'blank\'>sitestash-browser-plugin</a> instead of inserting html code manually":"Hinweis: Es k\xf6nnte einfacher sein, das <a href=\'https://www.sitestash.net/browser-extension\' target=\'blank\'>sitestash-browser-plugin</a> zu verwenden, anstatt den HTML-Code manuell einzuf\xfcgen","Insert the complete html of the page here, so that we can analyze the content without accessing the website":"F\xfcgen Sie hier die vollst\xe4ndige HTML der Seite ein, damit wir den Inhalt analysieren k\xf6nnen, ohne auf die Website zuzugreifen","${website_process_status}":"${website.process_status}","Title could not be detected":"Titel konnte nicht gefunden werden","Read more":"Mehr lesen","Name of the collection":"Name der Sammlung","Add collection":"Sammlung hinzuf\xfcgen","Websites":"Webseiten","Sure?":"Sicher?","delete":"l\xf6schen","No websites stashed, yet":"Noch keine Websites versteckt","Start adding websites easily by using the browser plugin":"Einfaches Hinzuf\xfcgen von Websites mit dem Browser-Plugin","or add a website manually here":"oder f\xfcgen Sie hier manuell eine Website hinzu","Could not login":"Keine Anmeldung m\xf6glich","Could not login_ Wrong Password?":"Sie konnten sich nicht anmelden. Falsches Passwort?","E-Mail":"E-Mail","Password":"Passwort","Your login code":"Ihr Anmeldecode","If you have signed up correctly, you have now received a login code which you can place here":"Wenn Sie sich korrekt angemeldet haben, haben Sie jetzt einen Anmeldecode erhalten, den Sie hier eingeben k\xf6nnen","We sent the login code":"Wir haben den Anmeldecode gesendet","Click here, if you want to use your password instead":"Klicken Sie hier, wenn Sie stattdessen Ihr Passwort verwenden m\xf6chten","Remember login":"Anmeldung merken","No Account, yet? Sign up here":"Noch kein Konto? Hier anmelden","Theme":"Thema","Collections":"Sammlungen","Your Profile":"Ihr Profil","Search":"Suche","Signup":"Anmeldung","Login":"Anmeldung","5 websites":"5 Webseiten","0 €":"0 €","initial":"erste","Select":"W\xe4hlen Sie","200 websites":"200 Websites","5 €":"5 €","per Month":"pro Monat","Your profile":"Ihr Profil","Language":"Sprache","Translate articles by default to":"Artikel standardm\xe4\xdfig \xfcbersetzen in","Credits":"Guthaben","Number of credits left":"Anzahl der verbleibenden Credits","Articles":"Artikel","Buy more credits":"Mehr Guthaben kaufen","Log out":"Abmelden","E-mail has already been signed up":"Die E-Mail wurde bereits registriert","Passwords do not match":"Passw\xf6rter stimmen nicht \xfcberein","Could not signup":"Konnte sich nicht anmelden","Confirm password":"Best\xe4tigen Sie das Passwort","Invitation code":"Einladungscode","The summarizer will add extra costs":"Die Zusammenfassung wird zus\xe4tzliche Kosten verursachen","Translate":"\xdcbersetzen Sie","Text is saving…":"Text wird gespeichert...","Save text":"Text speichern","Save custom text":"Benutzerdefinierten Text speichern","Create professional summarize":"Professionelle Zusammenfassungen erstellen","Professional Summary":"Professionelle Zusammenfassung","Analyze HTML":"HTML analysieren","Delete Article":"Artikel l\xf6schen","Change Article URL":"Artikel-URL \xe4ndern","Remove custom summary":"Benutzerdefinierte Zusammenfassung entfernen","Save and use custom summary above":"Speichern und benutzerdefinierte Zusammenfassung oben verwenden","Change URL":"URL \xe4ndern","Summarize custom text instead of auto-extracted content":"Zusammenfassen von benutzerdefiniertem Text anstelle von automatisch extrahiertem Inhalt","Helpful if the summary seems to be wrong in regards of context":"Hilfreich, wenn die Zusammenfassung in Bezug auf den Kontext falsch zu sein scheint","The update of the summary may take a minute or so - so please be patient":"Die Aktualisierung der Zusammenfassung kann etwa eine Minute dauern - haben Sie also bitte etwas Geduld","Summarize custom text":"Benutzerdefinierten Text zusammenfassen","Share Article":"Artikel teilen","Share edited article text":"Bearbeiteten Artikeltext teilen","Don\'t share article anymore":"Artikel nicht mehr teilen","Copied":"Kopiert","Copy Share URL to Clipboard":"Freigabe-URL in die Zwischenablage kopieren","Make this article public to share it with others":"Machen Sie diesen Artikel \xf6ffentlich, um ihn mit anderen zu teilen","Share article":"Artikel teilen","Remove from favourites":"Aus den Favoriten entfernen","Add to favourites":"Zu Favoriten hinzuf\xfcgen","Star":"Stern","There was a problem while processing the url":"Es gab ein Problem bei der Verarbeitung der Url","Maybe not all parts of the website are accessible or have relevant content? If the website is behind a paywall which you can access, you should try again with the browser plugin_":"Vielleicht sind nicht alle Teile der Website zug\xe4nglich oder haben relevante Inhalte? Wenn die Website hinter einer Paywall liegt, auf die Sie zugreifen k\xf6nnen, sollten Sie es erneut mit dem Browser-Plugin versuchen.","Alternatively you can read the article anyway, by clicking here":"Alternativ k\xf6nnen Sie den Artikel auch lesen, indem Sie hier klicken","Note":"Hinweis","The original text was too long_ So parts from the end of the text are not included in the summary and may corrupt the correct gist_":"Der urspr\xfcngliche Text war zu lang. Daher sind Teile am Ende des Textes nicht in der Zusammenfassung enthalten, was den Sinn des Textes verf\xe4lschen k\xf6nnte.","Source: ":"Quelle: ","Key moments":"Wichtige Momente","Hide key moments":"Schl\xfcsselmomente ausblenden","Show image":"Bild anzeigen","Add image by url":"Bild per Url hinzuf\xfcgen","Save":"Speichern Sie","Hide original content":"Originalinhalte ausblenden","Show original content":"Originalinhalte anzeigen","Original URL: ":"Urspr\xfcngliche URL: ","Website is ready to read here in a moment":"Die Website ist in K\xfcrze hier zu lesen","Website is already stashed":"Website ist bereits versteckt","Update Website":"Website aktualisieren","Website is behind paywall":"Website ist hinter einer Paywall","Content":"Inhalt","Translate to":"\xdcbersetzen in","Please login to use sitestash":"Bitte loggen Sie sich ein, um sitestash zu benutzen","Sign up here for free":"Registrieren Sie sich hier kostenlos","Log In":"Einloggen","The provided credentials are incorrect":"Die angegebenen Anmeldeinformationen sind falsch","Please confirm your e-mail-address first":"Bitte best\xe4tigen Sie zun\xe4chst Ihre E-Mail Adresse","Your login code:":"Ihr Anmeldecode:","If you did not request a login, no further action is required":"Wenn Sie keine Anmeldung beantragt haben, sind keine weiteren Schritte erforderlich.","URL not found":"URL nicht gefunden","Invalid URL":"Ung\xfcltige URL","URL is probably behind cloudflare protecion":"URL ist wahrscheinlich hinter cloudflare Schutz","URL could not be accessed":"URL konnte nicht aufgerufen werden","Not enough credits":"Nicht genug Kredite","Website already stashed":"Website bereits versteckt","Website is stashed":"Website ist versteckt","Not allowed":"Nicht erlaubt","No valid invitation code":"Kein g\xfcltiger Einladungscode","E-Mail already exists":"E-Mail existiert bereits","Password must be different than email":"Das Passwort muss sich von der E-Mail unterscheiden","Signup created - Please confirm your e-mail before logging in":"Anmeldung erstellt - Bitte best\xe4tigen Sie Ihre E-Mail, bevor Sie sich anmelden","Language not supported":"Sprache nicht unterst\xfctzt","Resource not found":"Ressource nicht gefunden","The password did not match":"Das Passwort stimmt nicht \xfcberein","Fast":"Schnell","Accurate":"Genaue","Large content":"Gro\xdfer Inhalt","Large content and accurate summary":"Umfangreicher Inhalt und genaue Zusammenfassung","If you have signed up correctly, you have now received a login code":"Wenn Sie sich korrekt angemeldet haben, haben Sie jetzt einen Anmeldecode erhalten","Too many login attempts":"Zu viele Anmeldeversuche","Code or e-mail is invalid":"Code oder E-Mail ist ung\xfcltig"}}');


var $e7b3c1f398d8d12a$exports = {};
$e7b3c1f398d8d12a$exports = JSON.parse('{"fr":{"sitestash":"sitestash","Please enter a URL":"Veuillez saisir une URL","Some problem occured while adding site":"Un probl\xe8me est survenu lors de l\'ajout du site","Please ensure that you have access to the site":"Veuillez vous assurer que vous avez acc\xe8s au site","In most cases that means that you need to be logged in on the website you want to stash":"Dans la plupart des cas, cela signifie que vous devez \xeatre connect\xe9 sur le site web que vous souhaitez cacher.","Then try again to the save the website with the browser plugin":"R\xe9essayez ensuite d\'enregistrer le site web avec le plugin du navigateur.","Add Website":"Ajouter un site web","Click here to show all options":"Cliquez ici pour afficher toutes les options","Or press ctrl / ⌘":"Ou appuyez sur ctrl / ⌘","Content classification":"Classification du contenu","Target language":"Langue cible","Keep original":"Conserver l\'original","Add to collection":"Ajouter \xe0 la collection","Auto":"Auto","Summarize mode":"Mode r\xe9sum\xe9","The website is behind a paywall - or not accessible by third parties":"Le site web est derri\xe8re un paywall - ou n\'est pas accessible par des tiers","Hint: It might be easier to use the <a href=\'https://www_sitestash_net/browser-extension\' target=\'blank\'>sitestash-browser-plugin</a> instead of inserting html code manually":"Conseil : il peut \xeatre plus facile d\'utiliser le <a href=\'https://www.sitestash.net/browser-extension\' target=\'blank\'>plugin sitestash-browser</a> au lieu d\'ins\xe9rer le code html manuellement.","Insert the complete html of the page here, so that we can analyze the content without accessing the website":"Ins\xe9rer ici le code html complet de la page, afin que nous puissions analyser le contenu sans acc\xe9der au site web.","${website_process_status}":"${website.process_status}","Title could not be detected":"Le titre n\'a pas pu \xeatre d\xe9tect\xe9","Read more":"En savoir plus","Name of the collection":"Nom de la collection","Add collection":"Ajouter une collection","Websites":"Sites web","Sure?":"C\'est s\xfbr ?","delete":"supprimer","No websites stashed, yet":"Pas de sites web cach\xe9s pour l\'instant","Start adding websites easily by using the browser plugin":"Commencez \xe0 ajouter des sites web facilement en utilisant le plugin du navigateur","or add a website manually here":"ou ajouter un site web manuellement ici","Could not login":"Impossible de se connecter","Could not login_ Wrong Password?":"Impossible de se connecter. Mauvais mot de passe ?","E-Mail":"Courrier \xe9lectronique","Password":"Mot de passe","Your login code":"Votre code d\'acc\xe8s","If you have signed up correctly, you have now received a login code which you can place here":"Si vous vous \xeates inscrit correctement, vous avez re\xe7u un code de connexion que vous pouvez placer ici.","We sent the login code":"Nous avons envoy\xe9 le code de connexion","Click here, if you want to use your password instead":"Cliquez ici, si vous souhaitez utiliser votre mot de passe \xe0 la place.","Remember login":"M\xe9moriser le login","No Account, yet? Sign up here":"Pas encore de compte ? S\'inscrire ici","Theme":"Th\xe8me","Collections":"Collections","Your Profile":"Votre profil","Search":"Recherche","Signup":"S\'inscrire","Login":"Connexion","5 websites":"5 sites web","0 €":"0 €","initial":"initial","Select":"S\xe9lectionner","200 websites":"200 sites web","5 €":"5 €","per Month":"par mois","Your profile":"Votre profil","Language":"Langue","Translate articles by default to":"Traduire les articles par d\xe9faut en","Credits":"Cr\xe9dits","Number of credits left":"Nombre de cr\xe9dits restants","Articles":"Articles","Buy more credits":"Acheter plus de cr\xe9dits","Log out":"D\xe9connexion","E-mail has already been signed up":"L\'e-mail a d\xe9j\xe0 \xe9t\xe9 enregistr\xe9","Passwords do not match":"Les mots de passe ne correspondent pas","Could not signup":"Impossible de s\'inscrire","Confirm password":"Confirmer le mot de passe","Invitation code":"Code d\'invitation","The summarizer will add extra costs":"Le r\xe9sum\xe9 entra\xeenera des co\xfbts suppl\xe9mentaires","Translate":"Traduire","Text is saving…":"Le texte est sauvegard\xe9...","Save text":"Enregistrer le texte","Save custom text":"Enregistrer le texte personnalis\xe9","Create professional summarize":"Cr\xe9er un r\xe9sum\xe9 professionnel","Professional Summary":"R\xe9sum\xe9 professionnel","Analyze HTML":"Analyser le HTML","Delete Article":"Supprimer l\'article","Change Article URL":"Modifier l\'URL de l\'article","Remove custom summary":"Supprimer le r\xe9sum\xe9 personnalis\xe9","Save and use custom summary above":"Enregistrer et utiliser le r\xe9sum\xe9 personnalis\xe9 ci-dessus","Change URL":"Modifier l\'URL","Summarize custom text instead of auto-extracted content":"R\xe9sumer un texte personnalis\xe9 au lieu d\'un contenu extrait automatiquement","Helpful if the summary seems to be wrong in regards of context":"Utile si le r\xe9sum\xe9 semble erron\xe9 par rapport au contexte","The update of the summary may take a minute or so - so please be patient":"La mise \xe0 jour du r\xe9sum\xe9 peut prendre une minute ou deux - soyez patient.","Summarize custom text":"R\xe9sumer un texte personnalis\xe9","Share Article":"Partager l\'article","Share edited article text":"Partager le texte de l\'article \xe9dit\xe9","Don\'t share article anymore":"Ne plus partager l\'article","Copied":"Copi\xe9","Copy Share URL to Clipboard":"Copier l\'URL du partage dans le presse-papiers","Make this article public to share it with others":"Rendez cet article public pour le partager avec d\'autres","Share article":"Partager l\'article","Remove from favourites":"Supprimer des favoris","Add to favourites":"Ajouter aux favoris","Star":"\xc9toile","There was a problem while processing the url":"Il y a eu un probl\xe8me lors du traitement de l\'url","Maybe not all parts of the website are accessible or have relevant content? If the website is behind a paywall which you can access, you should try again with the browser plugin_":"Peut-\xeatre que toutes les parties du site ne sont pas accessibles ou ne pr\xe9sentent pas un contenu pertinent ? Si le site web se trouve derri\xe8re un paywall auquel vous pouvez acc\xe9der, vous devriez r\xe9essayer avec le plugin du navigateur.","Alternatively you can read the article anyway, by clicking here":"Vous pouvez \xe9galement lire l\'article en cliquant ici.","Note":"Note","The original text was too long_ So parts from the end of the text are not included in the summary and may corrupt the correct gist_":"Le texte original \xe9tait trop long. Les parties de la fin du texte ne sont donc pas incluses dans le r\xe9sum\xe9 et peuvent alt\xe9rer l\'essentiel.","Source: ":"Source : ","Key moments":"Moments cl\xe9s","Hide key moments":"Cacher les moments cl\xe9s","Show image":"Afficher l\'image","Add image by url":"Ajouter une image par url","Save":"\xc9conomiser","Hide original content":"Cacher le contenu original","Show original content":"Afficher le contenu original","Original URL: ":"URL original : ","Website is ready to read here in a moment":"Le site web est pr\xeat \xe0 \xeatre lu ici dans un instant","Website is already stashed":"Le site web est d\xe9j\xe0 cach\xe9","Update Website":"Mise \xe0 jour du site web","Website is behind paywall":"Le site web est derri\xe8re un paywall","Content":"Contenu","Translate to":"Traduire en","Please login to use sitestash":"Veuillez vous connecter pour utiliser sitestash","Sign up here for free":"S\'inscrire ici gratuitement","Log In":"Se connecter","The provided credentials are incorrect":"Les informations d\'identification fournies sont incorrectes","Please confirm your e-mail-address first":"Veuillez d\'abord confirmer votre adresse \xe9lectronique","Your login code:":"Votre code d\'acc\xe8s :","If you did not request a login, no further action is required":"Si vous n\'avez pas demand\xe9 d\'ouverture de session, aucune autre action n\'est requise.","URL not found":"URL non trouv\xe9","Invalid URL":"URL invalide","URL is probably behind cloudflare protecion":"L\'URL est probablement derri\xe8re la protection cloudflare","URL could not be accessed":"Impossible d\'acc\xe9der \xe0 l\'URL","Not enough credits":"Pas assez de cr\xe9dits","Website already stashed":"Site web d\xe9j\xe0 cach\xe9","Website is stashed":"Le site web est cach\xe9","Not allowed":"Non autoris\xe9","No valid invitation code":"Pas de code d\'invitation valide","E-Mail already exists":"Le courriel existe d\xe9j\xe0","Password must be different than email":"Le mot de passe doit \xeatre diff\xe9rent de l\'email","Signup created - Please confirm your e-mail before logging in":"Inscription cr\xe9\xe9e - Veuillez confirmer votre e-mail avant de vous connecter","Language not supported":"La langue n\'est pas prise en charge","Resource not found":"Ressource non trouv\xe9e","The password did not match":"Le mot de passe ne correspond pas","Fast":"Rapide","Accurate":"Pr\xe9cision","Large content":"Un contenu important","Large content and accurate summary":"Un contenu important et un r\xe9sum\xe9 pr\xe9cis","If you have signed up correctly, you have now received a login code":"Si vous vous \xeates inscrit correctement, vous avez re\xe7u un code d\'acc\xe8s.","Too many login attempts":"Trop de tentatives de connexion","Code or e-mail is invalid":"Le code ou l\'e-mail n\'est pas valide"}}');


var $3d7fc57663fe875f$exports = {};
$3d7fc57663fe875f$exports = JSON.parse('{"nl":{"sitestash":"sitestash","Please enter a URL":"Voer een URL in","Some problem occured while adding site":"Er is een probleem opgetreden bij het toevoegen van de site","Please ensure that you have access to the site":"Zorg ervoor dat je toegang hebt tot de site","In most cases that means that you need to be logged in on the website you want to stash":"In de meeste gevallen betekent dit dat je ingelogd moet zijn op de website die je wilt opslaan.","Then try again to the save the website with the browser plugin":"Probeer dan opnieuw de website op te slaan met de browserplugin","Add Website":"Website toevoegen","Click here to show all options":"Klik hier om alle opties weer te geven","Or press ctrl / ⌘":"Of druk op ctrl / ⌘","Content classification":"Inhoud classificatie","Target language":"Doeltaal","Keep original":"Bewaar origineel","Add to collection":"Toevoegen aan collectie","Auto":"Auto","Summarize mode":"Modus Samenvatten","The website is behind a paywall - or not accessible by third parties":"De website staat achter een paywall - of is niet toegankelijk voor derden","Hint: It might be easier to use the <a href=\'https://www_sitestash_net/browser-extension\' target=\'blank\'>sitestash-browser-plugin</a> instead of inserting html code manually":"Tip: Het is misschien gemakkelijker om de <a href=\'https://www.sitestash.net/browser-extension\' target=\'blank\'>sitestash-browser-plugin</a> te gebruiken in plaats van handmatig html-code in te voegen.","Insert the complete html of the page here, so that we can analyze the content without accessing the website":"Voeg hier de volledige html van de pagina in, zodat we de inhoud kunnen analyseren zonder de website te openen","${website_process_status}":"${website.process_status}","Title could not be detected":"Titel kon niet worden gedetecteerd","Read more":"Meer lezen","Name of the collection":"Naam van de collectie","Add collection":"Collectie toevoegen","Websites":"Websites","Sure?":"Zeker weten?","delete":"verwijderen","No websites stashed, yet":"Nog geen websites verborgen","Start adding websites easily by using the browser plugin":"Eenvoudig websites toevoegen met de browser-plugin","or add a website manually here":"of voeg hier handmatig een website toe","Could not login":"Kan niet inloggen","Could not login_ Wrong Password?":"Kan niet inloggen. Verkeerd wachtwoord?","E-Mail":"E-mail","Password":"Wachtwoord","Your login code":"Uw inlogcode","If you have signed up correctly, you have now received a login code which you can place here":"Als je je correct hebt aangemeld, heb je nu een inlogcode ontvangen die je hier kunt plaatsen","We sent the login code":"We hebben de inlogcode verzonden","Click here, if you want to use your password instead":"Klik hier als je in plaats daarvan je wachtwoord wilt gebruiken","Remember login":"Login onthouden","No Account, yet? Sign up here":"Nog geen account? Meld je hier aan","Theme":"Thema","Collections":"Collecties","Your Profile":"Uw profiel","Search":"Zoek op","Signup":"Aanmelden","Login":"Inloggen","5 websites":"5 websites","0 €":"0 €","initial":"eerste","Select":"Selecteer","200 websites":"200 websites","5 €":"5 €","per Month":"per maand","Your profile":"Jouw profiel","Language":"Taal","Translate articles by default to":"Vertaal artikelen standaard naar","Credits":"Credits","Number of credits left":"Aantal resterende credits","Articles":"Artikelen","Buy more credits":"Meer credits kopen","Log out":"Afmelden","E-mail has already been signed up":"E-mail is al aangemeld","Passwords do not match":"Wachtwoorden komen niet overeen","Could not signup":"Kan niet aanmelden","Confirm password":"Wachtwoord bevestigen","Invitation code":"Code uitnodiging","The summarizer will add extra costs":"De samenvatter brengt extra kosten met zich mee","Translate":"Vertaal","Text is saving…":"Tekst is opslaan...","Save text":"Tekst opslaan","Save custom text":"Aangepaste tekst opslaan","Create professional summarize":"Professioneel samenvatten","Professional Summary":"Professionele samenvatting","Analyze HTML":"HTML analyseren","Delete Article":"Artikel verwijderen","Change Article URL":"Artikel URL wijzigen","Remove custom summary":"Aangepaste samenvatting verwijderen","Save and use custom summary above":"Bovenstaande aangepaste samenvatting opslaan en gebruiken","Change URL":"URL wijzigen","Summarize custom text instead of auto-extracted content":"Aangepaste tekst samenvatten in plaats van automatisch ge\xebxtraheerde inhoud","Helpful if the summary seems to be wrong in regards of context":"Nuttig als de samenvatting niet lijkt te kloppen wat betreft de context","The update of the summary may take a minute or so - so please be patient":"Het bijwerken van de samenvatting kan ongeveer een minuut duren - wees dus geduldig","Summarize custom text":"Aangepaste tekst samenvatten","Share Article":"Artikel delen","Share edited article text":"Bewerkte tekst van artikel delen","Don\'t share article anymore":"Artikel niet meer delen","Copied":"Gekopieerd","Copy Share URL to Clipboard":"URL delen naar klembord kopi\xebren","Make this article public to share it with others":"Maak dit artikel openbaar om het met anderen te delen","Share article":"Artikel delen","Remove from favourites":"Verwijderen uit favorieten","Add to favourites":"Toevoegen aan favorieten","Star":"Ster","There was a problem while processing the url":"Er is een probleem opgetreden tijdens het verwerken van de url","Maybe not all parts of the website are accessible or have relevant content? If the website is behind a paywall which you can access, you should try again with the browser plugin_":"Misschien zijn niet alle delen van de website toegankelijk of hebben ze relevante inhoud? Als de website zich achter een betaalmuur bevindt waar je wel toegang tot hebt, moet je het opnieuw proberen met de browserplugin.","Alternatively you can read the article anyway, by clicking here":"Je kunt het artikel ook lezen door hier te klikken","Note":"Opmerking","The original text was too long_ So parts from the end of the text are not included in the summary and may corrupt the correct gist_":"De oorspronkelijke tekst was te lang. Delen aan het einde van de tekst zijn dus niet opgenomen in de samenvatting en kunnen de juiste essentie bederven.","Source: ":"Bron: ","Key moments":"Belangrijke momenten","Hide key moments":"Belangrijke momenten verbergen","Show image":"Afbeelding tonen","Add image by url":"Afbeelding toevoegen via url","Save":"Sla","Hide original content":"Verberg originele inhoud","Show original content":"Toon originele inhoud","Original URL: ":"Oorspronkelijke URL: ","Website is ready to read here in a moment":"Website is zo te lezen hier","Website is already stashed":"Website is al opgeborgen","Update Website":"Website bijwerken","Website is behind paywall":"Website zit achter betaalmuur","Content":"Inhoud","Translate to":"Vertalen naar","Please login to use sitestash":"Log in om sitestash te gebruiken","Sign up here for free":"Meld je hier gratis aan","Log In":"Aanmelden","The provided credentials are incorrect":"De opgegeven referenties zijn onjuist","Please confirm your e-mail-address first":"Bevestig eerst je e-mailadres","Your login code:":"Uw inlogcode:","If you did not request a login, no further action is required":"Als u geen login heeft aangevraagd, hoeft u geen verdere actie te ondernemen.","URL not found":"URL niet gevonden","Invalid URL":"Ongeldige URL","URL is probably behind cloudflare protecion":"URL zit waarschijnlijk achter cloudflare-protectie","URL could not be accessed":"URL kon niet worden geopend","Not enough credits":"Niet genoeg credits","Website already stashed":"Website al verstopt","Website is stashed":"Website is verborgen","Not allowed":"Niet toegestaan","No valid invitation code":"Geen geldige uitnodigingscode","E-Mail already exists":"E-mail bestaat al","Password must be different than email":"Wachtwoord moet anders zijn dan e-mail","Signup created - Please confirm your e-mail before logging in":"Aanmelden gemaakt - Bevestig je e-mail voordat je inlogt","Language not supported":"Taal niet ondersteund","Resource not found":"Bron niet gevonden","The password did not match":"Het wachtwoord kwam niet overeen","Fast":"Snel","Accurate":"Nauwkeurig","Large content":"Grote inhoud","Large content and accurate summary":"Grote inhoud en nauwkeurige samenvatting","If you have signed up correctly, you have now received a login code":"Als je je correct hebt aangemeld, heb je nu een inlogcode ontvangen","Too many login attempts":"Te veel aanmeldpogingen","Code or e-mail is invalid":"Code of e-mail is ongeldig"}}');



var $6qd2L = parcelRequire("6qd2L");
const $c2ac8bd085cf62d5$var$debug = $6qd2L?.env?.NODE_ENV === "development" || window?.location?.host?.startsWith("localhost");
const $c2ac8bd085cf62d5$var$lang = (navigator ? navigator.language : "en").replace(/(\-.+?)$/, "");
const $c2ac8bd085cf62d5$export$150b732325d14d04 = {
    en: $0c3290ddecd94337$exports.en,
    de: $d25650ced9542cd5$exports.de,
    fr: $e7b3c1f398d8d12a$exports.fr,
    nl: $3d7fc57663fe875f$exports.nl
};
if ($c2ac8bd085cf62d5$var$debug) {
    console.debug(`Selected language (i18nify): ${$c2ac8bd085cf62d5$var$lang}`);
    console.debug(`Translations (i18nify)`, $c2ac8bd085cf62d5$export$150b732325d14d04);
}
(0, $b7ce7ba39a245f74$export$52cef9b23c04172)((value, options, err)=>value?.replace(/%{dot}/g, "."));
(0, $b7ce7ba39a245f74$export$69890adb93456605)($c2ac8bd085cf62d5$export$150b732325d14d04);
(0, $b7ce7ba39a245f74$export$c8aadf3621e41efb)($c2ac8bd085cf62d5$export$150b732325d14d04[$c2ac8bd085cf62d5$var$lang] ? $c2ac8bd085cf62d5$var$lang : "en");



var $94ae3b4f9cdd4d92$exports = {};
/** Types of elements found in htmlparser2's DOM */ var $73d59426df31acd1$export$b992dc138d950e31;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($73d59426df31acd1$export$b992dc138d950e31 || ($73d59426df31acd1$export$b992dc138d950e31 = {}));
function $73d59426df31acd1$export$3bf645f08efe3292(elem) {
    return elem.type === $73d59426df31acd1$export$b992dc138d950e31.Tag || elem.type === $73d59426df31acd1$export$b992dc138d950e31.Script || elem.type === $73d59426df31acd1$export$b992dc138d950e31.Style;
}
const $73d59426df31acd1$export$be92b6f5f03c0fe9 = $73d59426df31acd1$export$b992dc138d950e31.Root;
const $73d59426df31acd1$export$5f1af8db9871e1d6 = $73d59426df31acd1$export$b992dc138d950e31.Text;
const $73d59426df31acd1$export$befdefbdce210f91 = $73d59426df31acd1$export$b992dc138d950e31.Directive;
const $73d59426df31acd1$export$4d299b491347818a = $73d59426df31acd1$export$b992dc138d950e31.Comment;
const $73d59426df31acd1$export$2f8b47a141e57afc = $73d59426df31acd1$export$b992dc138d950e31.Script;
const $73d59426df31acd1$export$d9e45bc13d335801 = $73d59426df31acd1$export$b992dc138d950e31.Style;
const $73d59426df31acd1$export$3288d34c523a1192 = $73d59426df31acd1$export$b992dc138d950e31.Tag;
const $73d59426df31acd1$export$1f8b8f7e5c763232 = $73d59426df31acd1$export$b992dc138d950e31.CDATA;
const $73d59426df31acd1$export$31b44af36ff2c60f = $73d59426df31acd1$export$b992dc138d950e31.Doctype;



class $377a80095ac7e925$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $377a80095ac7e925$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $377a80095ac7e925$export$c3569d91cd44d357 extends $377a80095ac7e925$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $377a80095ac7e925$export$5f1af8db9871e1d6 extends $377a80095ac7e925$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $377a80095ac7e925$export$4d299b491347818a extends $377a80095ac7e925$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $377a80095ac7e925$export$9269dce19ee35e96 extends $377a80095ac7e925$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $377a80095ac7e925$export$62be934f90997196 extends $377a80095ac7e925$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $377a80095ac7e925$export$1f8b8f7e5c763232 extends $377a80095ac7e925$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $377a80095ac7e925$export$b34a105447964f9f extends $377a80095ac7e925$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $377a80095ac7e925$export$db77ccec0bb4ccac extends $377a80095ac7e925$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $73d59426df31acd1$export$b992dc138d950e31).Script : name === "style" ? (0, $73d59426df31acd1$export$b992dc138d950e31).Style : (0, $73d59426df31acd1$export$b992dc138d950e31).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $377a80095ac7e925$export$3bf645f08efe3292(node) {
    return (0, $73d59426df31acd1$export$3bf645f08efe3292)(node);
}
function $377a80095ac7e925$export$c2d65aed98d39b56(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).CDATA;
}
function $377a80095ac7e925$export$1879817ac5c922b7(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Text;
}
function $377a80095ac7e925$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Comment;
}
function $377a80095ac7e925$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Directive;
}
function $377a80095ac7e925$export$62858bae88b53fd0(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Root;
}
function $377a80095ac7e925$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $377a80095ac7e925$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($377a80095ac7e925$export$1879817ac5c922b7(node)) result = new $377a80095ac7e925$export$5f1af8db9871e1d6(node.data);
    else if ($377a80095ac7e925$export$3ab01370f5e64ac8(node)) result = new $377a80095ac7e925$export$4d299b491347818a(node.data);
    else if ($377a80095ac7e925$export$3bf645f08efe3292(node)) {
        const children = recursive ? $377a80095ac7e925$var$cloneChildren(node.children) : [];
        const clone = new $377a80095ac7e925$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($377a80095ac7e925$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $377a80095ac7e925$var$cloneChildren(node.children) : [];
        const clone = new $377a80095ac7e925$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($377a80095ac7e925$export$62858bae88b53fd0(node)) {
        const children = recursive ? $377a80095ac7e925$var$cloneChildren(node.children) : [];
        const clone = new $377a80095ac7e925$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($377a80095ac7e925$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $377a80095ac7e925$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $377a80095ac7e925$var$cloneChildren(childs) {
    const children = childs.map((child)=>$377a80095ac7e925$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


// Default options
const $caee0260e51a48f5$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $caee0260e51a48f5$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $377a80095ac7e925$export$b34a105447964f9f)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $caee0260e51a48f5$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $caee0260e51a48f5$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $377a80095ac7e925$export$b34a105447964f9f)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $73d59426df31acd1$export$b992dc138d950e31).Tag : undefined;
        const element = new (0, $377a80095ac7e925$export$db77ccec0bb4ccac)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $377a80095ac7e925$export$5f1af8db9871e1d6)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $377a80095ac7e925$export$4d299b491347818a)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $377a80095ac7e925$export$5f1af8db9871e1d6)("");
        const node = new (0, $377a80095ac7e925$export$1f8b8f7e5c763232)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $377a80095ac7e925$export$9269dce19ee35e96)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $caee0260e51a48f5$export$2e2bcd8739ae039 = $caee0260e51a48f5$export$ff8ccbac9225de62;


var $4cfb0b55720cd0c8$exports = {};

$parcel$defineInteropFlag($4cfb0b55720cd0c8$exports);

$parcel$export($4cfb0b55720cd0c8$exports, "default", function () { return $4cfb0b55720cd0c8$export$2e2bcd8739ae039; });
var $6080ace9a331ef46$exports = {};
// constants
var $6080ace9a331ef46$var$HTML = "html";
var $6080ace9a331ef46$var$HEAD = "head";
var $6080ace9a331ef46$var$BODY = "body";
var $6080ace9a331ef46$var$FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/; // e.g., <h1>
// match-all-characters in case of newlines (DOTALL)
var $6080ace9a331ef46$var$HEAD_TAG_REGEX = /<head[^]*>/i;
var $6080ace9a331ef46$var$BODY_TAG_REGEX = /<body[^]*>/i;
// falls back to `parseFromString` if `createHTMLDocument` cannot be used
var $6080ace9a331ef46$var$parseFromDocument = function() {
    throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
};
var $6080ace9a331ef46$var$parseFromString = function() {
    throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
};
var $6080ace9a331ef46$var$DOMParser = typeof window === "object" && window.DOMParser;
/**
 * DOMParser (performance: slow).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
 */ if (typeof $6080ace9a331ef46$var$DOMParser === "function") {
    var $6080ace9a331ef46$var$domParser = new $6080ace9a331ef46$var$DOMParser();
    var $6080ace9a331ef46$var$mimeType = "text/html";
    /**
   * Creates an HTML document using `DOMParser.parseFromString`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $6080ace9a331ef46$var$parseFromString = function(html, tagName) {
        if (tagName) html = "<" + tagName + ">" + html + "</" + tagName + ">";
        return $6080ace9a331ef46$var$domParser.parseFromString(html, $6080ace9a331ef46$var$mimeType);
    };
    $6080ace9a331ef46$var$parseFromDocument = $6080ace9a331ef46$var$parseFromString;
}
/**
 * DOMImplementation (performance: fair).
 *
 * @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
 */ if (typeof document === "object" && document.implementation) {
    var $6080ace9a331ef46$var$doc = document.implementation.createHTMLDocument();
    /**
   * Use HTML document created by `document.implementation.createHTMLDocument`.
   *
   * @param  {string} html      - The HTML string.
   * @param  {string} [tagName] - The element to render the HTML (with 'body' as fallback).
   * @return {HTMLDocument}
   */ $6080ace9a331ef46$var$parseFromDocument = function(html, tagName) {
        if (tagName) {
            var element = $6080ace9a331ef46$var$doc.documentElement.querySelector(tagName);
            element.innerHTML = html;
            return $6080ace9a331ef46$var$doc;
        }
        $6080ace9a331ef46$var$doc.documentElement.innerHTML = html;
        return $6080ace9a331ef46$var$doc;
    };
}
/**
 * Template (performance: fast).
 *
 * @see https://developer.mozilla.org/docs/Web/HTML/Element/template
 */ var $6080ace9a331ef46$var$template = typeof document === "object" ? document.createElement("template") : {};
var $6080ace9a331ef46$var$parseFromTemplate;
if ($6080ace9a331ef46$var$template.content) /**
   * Uses a template element (content fragment) to parse HTML.
   *
   * @param  {string} html - The HTML string.
   * @return {NodeList}
   */ $6080ace9a331ef46$var$parseFromTemplate = function(html) {
    $6080ace9a331ef46$var$template.innerHTML = html;
    return $6080ace9a331ef46$var$template.content.childNodes;
};
/**
 * Parses HTML string to DOM nodes.
 *
 * @param  {string}   html - HTML markup.
 * @return {NodeList}
 */ function $6080ace9a331ef46$var$domparser(html) {
    var firstTagName;
    var match = html.match($6080ace9a331ef46$var$FIRST_TAG_REGEX);
    if (match && match[1]) firstTagName = match[1].toLowerCase();
    var doc;
    var element;
    var elements;
    switch(firstTagName){
        case $6080ace9a331ef46$var$HTML:
            doc = $6080ace9a331ef46$var$parseFromString(html);
            // the created document may come with filler head/body elements,
            // so make sure to remove them if they don't actually exist
            if (!$6080ace9a331ef46$var$HEAD_TAG_REGEX.test(html)) {
                element = doc.querySelector($6080ace9a331ef46$var$HEAD);
                if (element) element.parentNode.removeChild(element);
            }
            if (!$6080ace9a331ef46$var$BODY_TAG_REGEX.test(html)) {
                element = doc.querySelector($6080ace9a331ef46$var$BODY);
                if (element) element.parentNode.removeChild(element);
            }
            return doc.querySelectorAll($6080ace9a331ef46$var$HTML);
        case $6080ace9a331ef46$var$HEAD:
        case $6080ace9a331ef46$var$BODY:
            doc = $6080ace9a331ef46$var$parseFromDocument(html);
            elements = doc.querySelectorAll(firstTagName);
            // if there's a sibling element, then return both elements
            if ($6080ace9a331ef46$var$BODY_TAG_REGEX.test(html) && $6080ace9a331ef46$var$HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
            return elements;
        // low-level tag or text
        default:
            if ($6080ace9a331ef46$var$parseFromTemplate) return $6080ace9a331ef46$var$parseFromTemplate(html);
            element = $6080ace9a331ef46$var$parseFromDocument(html, $6080ace9a331ef46$var$BODY).querySelector($6080ace9a331ef46$var$BODY);
            return element.childNodes;
    }
}
$6080ace9a331ef46$exports = $6080ace9a331ef46$var$domparser;


var $fa79864a3d82266e$exports = {};

$parcel$export($fa79864a3d82266e$exports, "formatAttributes", function () { return $fa79864a3d82266e$export$9ca5fb17560152b9; }, function (v) { return $fa79864a3d82266e$export$9ca5fb17560152b9 = v; });
$parcel$export($fa79864a3d82266e$exports, "formatDOM", function () { return $fa79864a3d82266e$export$82ef7ce8825bcfd1; }, function (v) { return $fa79864a3d82266e$export$82ef7ce8825bcfd1 = v; });
var $fa79864a3d82266e$export$9ca5fb17560152b9;
var $fa79864a3d82266e$export$82ef7ce8825bcfd1;


class $7891ee6517f817f7$export$85c928794f8d04d4 {
    constructor(){
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    // Read-write aliases for properties
    /**
     * Same as {@link parent}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get parentNode() {
        return this.parent;
    }
    set parentNode(parent) {
        this.parent = parent;
    }
    /**
     * Same as {@link prev}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get previousSibling() {
        return this.prev;
    }
    set previousSibling(prev) {
        this.prev = prev;
    }
    /**
     * Same as {@link next}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nextSibling() {
        return this.next;
    }
    set nextSibling(next) {
        this.next = next;
    }
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ cloneNode(recursive = false) {
        return $7891ee6517f817f7$export$ae8e35ea29ddac22(this, recursive);
    }
}
class $7891ee6517f817f7$export$c3569d91cd44d357 extends $7891ee6517f817f7$export$85c928794f8d04d4 {
    /**
     * @param data The content of the data node
     */ constructor(data){
        super();
        this.data = data;
    }
    /**
     * Same as {@link data}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get nodeValue() {
        return this.data;
    }
    set nodeValue(data) {
        this.data = data;
    }
}
class $7891ee6517f817f7$export$5f1af8db9871e1d6 extends $7891ee6517f817f7$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Text;
    }
    get nodeType() {
        return 3;
    }
}
class $7891ee6517f817f7$export$4d299b491347818a extends $7891ee6517f817f7$export$c3569d91cd44d357 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Comment;
    }
    get nodeType() {
        return 8;
    }
}
class $7891ee6517f817f7$export$9269dce19ee35e96 extends $7891ee6517f817f7$export$c3569d91cd44d357 {
    constructor(name, data){
        super(data);
        this.name = name;
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Directive;
    }
    get nodeType() {
        return 1;
    }
}
class $7891ee6517f817f7$export$62be934f90997196 extends $7891ee6517f817f7$export$85c928794f8d04d4 {
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ constructor(children){
        super();
        this.children = children;
    }
    // Aliases
    /** First child of the node. */ get firstChild() {
        var _a;
        return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
    }
    /** Last child of the node. */ get lastChild() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
    }
    /**
     * Same as {@link children}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get childNodes() {
        return this.children;
    }
    set childNodes(children) {
        this.children = children;
    }
}
class $7891ee6517f817f7$export$1f8b8f7e5c763232 extends $7891ee6517f817f7$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).CDATA;
    }
    get nodeType() {
        return 4;
    }
}
class $7891ee6517f817f7$export$b34a105447964f9f extends $7891ee6517f817f7$export$62be934f90997196 {
    constructor(){
        super(...arguments);
        this.type = (0, $73d59426df31acd1$export$b992dc138d950e31).Root;
    }
    get nodeType() {
        return 9;
    }
}
class $7891ee6517f817f7$export$db77ccec0bb4ccac extends $7891ee6517f817f7$export$62be934f90997196 {
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ constructor(name, attribs, children = [], type = name === "script" ? (0, $73d59426df31acd1$export$b992dc138d950e31).Script : name === "style" ? (0, $73d59426df31acd1$export$b992dc138d950e31).Style : (0, $73d59426df31acd1$export$b992dc138d950e31).Tag){
        super(children);
        this.name = name;
        this.attribs = attribs;
        this.type = type;
    }
    get nodeType() {
        return 1;
    }
    // DOM Level 1 aliases
    /**
     * Same as {@link name}.
     * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
     */ get tagName() {
        return this.name;
    }
    set tagName(name) {
        this.name = name;
    }
    get attributes() {
        return Object.keys(this.attribs).map((name)=>{
            var _a, _b;
            return {
                name: name,
                value: this.attribs[name],
                namespace: (_a = this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                prefix: (_b = this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
            };
        });
    }
}
function $7891ee6517f817f7$export$3bf645f08efe3292(node) {
    return (0, $73d59426df31acd1$export$3bf645f08efe3292)(node);
}
function $7891ee6517f817f7$export$c2d65aed98d39b56(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).CDATA;
}
function $7891ee6517f817f7$export$1879817ac5c922b7(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Text;
}
function $7891ee6517f817f7$export$3ab01370f5e64ac8(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Comment;
}
function $7891ee6517f817f7$export$4b5d79f26e0e3ad5(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Directive;
}
function $7891ee6517f817f7$export$62858bae88b53fd0(node) {
    return node.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Root;
}
function $7891ee6517f817f7$export$bd5ff50f0e53d41c(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
function $7891ee6517f817f7$export$ae8e35ea29ddac22(node, recursive = false) {
    let result;
    if ($7891ee6517f817f7$export$1879817ac5c922b7(node)) result = new $7891ee6517f817f7$export$5f1af8db9871e1d6(node.data);
    else if ($7891ee6517f817f7$export$3ab01370f5e64ac8(node)) result = new $7891ee6517f817f7$export$4d299b491347818a(node.data);
    else if ($7891ee6517f817f7$export$3bf645f08efe3292(node)) {
        const children = recursive ? $7891ee6517f817f7$var$cloneChildren(node.children) : [];
        const clone = new $7891ee6517f817f7$export$db77ccec0bb4ccac(node.name, {
            ...node.attribs
        }, children);
        children.forEach((child)=>child.parent = clone);
        if (node.namespace != null) clone.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone["x-attribsNamespace"] = {
            ...node["x-attribsNamespace"]
        };
        if (node["x-attribsPrefix"]) clone["x-attribsPrefix"] = {
            ...node["x-attribsPrefix"]
        };
        result = clone;
    } else if ($7891ee6517f817f7$export$c2d65aed98d39b56(node)) {
        const children = recursive ? $7891ee6517f817f7$var$cloneChildren(node.children) : [];
        const clone = new $7891ee6517f817f7$export$1f8b8f7e5c763232(children);
        children.forEach((child)=>child.parent = clone);
        result = clone;
    } else if ($7891ee6517f817f7$export$62858bae88b53fd0(node)) {
        const children = recursive ? $7891ee6517f817f7$var$cloneChildren(node.children) : [];
        const clone = new $7891ee6517f817f7$export$b34a105447964f9f(children);
        children.forEach((child)=>child.parent = clone);
        if (node["x-mode"]) clone["x-mode"] = node["x-mode"];
        result = clone;
    } else if ($7891ee6517f817f7$export$4b5d79f26e0e3ad5(node)) {
        const instruction = new $7891ee6517f817f7$export$9269dce19ee35e96(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error(`Not implemented yet: ${node.type}`);
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
function $7891ee6517f817f7$var$cloneChildren(childs) {
    const children = childs.map((child)=>$7891ee6517f817f7$export$ae8e35ea29ddac22(child, true));
    for(let i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}


// Default options
const $ee000861eb313469$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
class $ee000861eb313469$export$ff8ccbac9225de62 {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ constructor(callback, options, elementCB){
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (0, $7891ee6517f817f7$export$b34a105447964f9f)(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $ee000861eb313469$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $ee000861eb313469$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    onparserinit(parser) {
        this.parser = parser;
    }
    // Resets the handler back to starting state
    onreset() {
        this.dom = [];
        this.root = new (0, $7891ee6517f817f7$export$b34a105447964f9f)(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    }
    // Signals the handler that parsing is done
    onend() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    }
    onerror(error) {
        this.handleCallback(error);
    }
    onclosetag() {
        this.lastNode = null;
        const elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    }
    onopentag(name, attribs) {
        const type = this.options.xmlMode ? (0, $73d59426df31acd1$export$b992dc138d950e31).Tag : undefined;
        const element = new (0, $7891ee6517f817f7$export$db77ccec0bb4ccac)(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    }
    ontext(data) {
        const { lastNode: lastNode } = this;
        if (lastNode && lastNode.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            const node = new (0, $7891ee6517f817f7$export$5f1af8db9871e1d6)(data);
            this.addNode(node);
            this.lastNode = node;
        }
    }
    oncomment(data) {
        if (this.lastNode && this.lastNode.type === (0, $73d59426df31acd1$export$b992dc138d950e31).Comment) {
            this.lastNode.data += data;
            return;
        }
        const node = new (0, $7891ee6517f817f7$export$4d299b491347818a)(data);
        this.addNode(node);
        this.lastNode = node;
    }
    oncommentend() {
        this.lastNode = null;
    }
    oncdatastart() {
        const text = new (0, $7891ee6517f817f7$export$5f1af8db9871e1d6)("");
        const node = new (0, $7891ee6517f817f7$export$1f8b8f7e5c763232)([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    }
    oncdataend() {
        this.lastNode = null;
    }
    onprocessinginstruction(name, data) {
        const node = new (0, $7891ee6517f817f7$export$9269dce19ee35e96)(name, data);
        this.addNode(node);
    }
    handleCallback(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    }
    addNode(node) {
        const parent = this.tagStack[this.tagStack.length - 1];
        const previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    }
}
var $ee000861eb313469$export$2e2bcd8739ae039 = $ee000861eb313469$export$ff8ccbac9225de62;


/**
 * SVG elements are case-sensitive.
 *
 * @see {@link https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z}
 */ var $598a0829760ceeb7$export$fe8547a1bfbc8a99;
$598a0829760ceeb7$export$fe8547a1bfbc8a99 = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
];


var $fa79864a3d82266e$var$CASE_SENSITIVE_TAG_NAMES = $598a0829760ceeb7$export$fe8547a1bfbc8a99;
var $fa79864a3d82266e$var$Comment = $7891ee6517f817f7$export$4d299b491347818a;
var $fa79864a3d82266e$var$Element = $7891ee6517f817f7$export$db77ccec0bb4ccac;
var $fa79864a3d82266e$var$ProcessingInstruction = $7891ee6517f817f7$export$9269dce19ee35e96;
var $fa79864a3d82266e$var$Text = $7891ee6517f817f7$export$5f1af8db9871e1d6;
var $fa79864a3d82266e$var$caseSensitiveTagNamesMap = {};
var $fa79864a3d82266e$var$tagName;
for(var $fa79864a3d82266e$var$i = 0, $fa79864a3d82266e$var$len = $fa79864a3d82266e$var$CASE_SENSITIVE_TAG_NAMES.length; $fa79864a3d82266e$var$i < $fa79864a3d82266e$var$len; $fa79864a3d82266e$var$i++){
    $fa79864a3d82266e$var$tagName = $fa79864a3d82266e$var$CASE_SENSITIVE_TAG_NAMES[$fa79864a3d82266e$var$i];
    $fa79864a3d82266e$var$caseSensitiveTagNamesMap[$fa79864a3d82266e$var$tagName.toLowerCase()] = $fa79864a3d82266e$var$tagName;
}
/**
 * Gets case-sensitive tag name.
 *
 * @param {string} tagName - Tag name in lowercase.
 * @returns {string|undefined} - Case-sensitive tag name.
 */ function $fa79864a3d82266e$var$getCaseSensitiveTagName(tagName) {
    return $fa79864a3d82266e$var$caseSensitiveTagNamesMap[tagName];
}
/**
 * Formats DOM attributes to a hash map.
 *
 * @param {NamedNodeMap} attributes - List of attributes.
 * @returns {object} - Map of attribute name to value.
 */ function $fa79864a3d82266e$var$formatAttributes(attributes) {
    var result = {};
    var attribute;
    // `NamedNodeMap` is array-like
    for(var i = 0, len = attributes.length; i < len; i++){
        attribute = attributes[i];
        result[attribute.name] = attribute.value;
    }
    return result;
}
/**
 * Corrects the tag name if it is case-sensitive (SVG).
 * Otherwise, returns the lowercase tag name (HTML).
 *
 * @param {string} tagName - Lowercase tag name.
 * @returns {string} - Formatted tag name.
 */ function $fa79864a3d82266e$var$formatTagName(tagName) {
    tagName = tagName.toLowerCase();
    var caseSensitiveTagName = $fa79864a3d82266e$var$getCaseSensitiveTagName(tagName);
    if (caseSensitiveTagName) return caseSensitiveTagName;
    return tagName;
}
/**
 * Transforms DOM nodes to `domhandler` nodes.
 *
 * @param {NodeList} nodes - DOM nodes.
 * @param {Element|null} [parent=null] - Parent node.
 * @param {string} [directive] - Directive.
 * @returns {Array<Comment|Element|ProcessingInstruction|Text>}
 */ function $fa79864a3d82266e$var$formatDOM(nodes, parent, directive) {
    parent = parent || null;
    var result = [];
    var tagName;
    for(var index = 0, len = nodes.length; index < len; index++){
        var node = nodes[index];
        var current;
        // set the node data given the type
        switch(node.nodeType){
            case 1:
                tagName = $fa79864a3d82266e$var$formatTagName(node.nodeName);
                // script, style, or tag
                current = new $fa79864a3d82266e$var$Element(tagName, $fa79864a3d82266e$var$formatAttributes(node.attributes));
                current.children = $fa79864a3d82266e$var$formatDOM(// template children are on content
                tagName === "template" ? node.content.childNodes : node.childNodes, current);
                break;
            case 3:
                current = new $fa79864a3d82266e$var$Text(node.nodeValue);
                break;
            case 8:
                current = new $fa79864a3d82266e$var$Comment(node.nodeValue);
                break;
            default:
                continue;
        }
        // set previous node next
        var prev = result[index - 1] || null;
        if (prev) prev.next = current;
        // set properties for current node
        current.parent = parent;
        current.prev = prev;
        current.next = null;
        result.push(current);
    }
    if (directive) {
        current = new $fa79864a3d82266e$var$ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
        current.next = result[0] || null;
        current.parent = parent;
        result.unshift(current);
        if (result[1]) result[1].prev = result[0];
    }
    return result;
}
$fa79864a3d82266e$export$9ca5fb17560152b9 = $fa79864a3d82266e$var$formatAttributes;
$fa79864a3d82266e$export$82ef7ce8825bcfd1 = $fa79864a3d82266e$var$formatDOM;


var $4cfb0b55720cd0c8$var$formatDOM = (0, (/*@__PURE__*/$parcel$interopDefault($fa79864a3d82266e$exports))).formatDOM;
var $4cfb0b55720cd0c8$var$DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/; // e.g., <!doctype html>
function $4cfb0b55720cd0c8$export$2e2bcd8739ae039(html) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (html === "") return [];
    // match directive
    var match = html.match($4cfb0b55720cd0c8$var$DIRECTIVE_REGEX);
    var directive;
    if (match && match[1]) directive = match[1];
    return $4cfb0b55720cd0c8$var$formatDOM((0, (/*@__PURE__*/$parcel$interopDefault($6080ace9a331ef46$exports)))(html), null, directive);
}


var $94ae3b4f9cdd4d92$require$htmlToDOM = $4cfb0b55720cd0c8$exports;
var $d8e860a6c9a7b7b9$exports = {};
var $7fdc5f23c8bc7fc8$exports = {};
"use strict";
Object.defineProperty($7fdc5f23c8bc7fc8$exports, "__esModule", {
    value: true
});
function $7fdc5f23c8bc7fc8$var$_slicedToArray(arr, i) {
    return $7fdc5f23c8bc7fc8$var$_arrayWithHoles(arr) || $7fdc5f23c8bc7fc8$var$_iterableToArrayLimit(arr, i) || $7fdc5f23c8bc7fc8$var$_unsupportedIterableToArray(arr, i) || $7fdc5f23c8bc7fc8$var$_nonIterableRest();
}
function $7fdc5f23c8bc7fc8$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7fdc5f23c8bc7fc8$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7fdc5f23c8bc7fc8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7fdc5f23c8bc7fc8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7fdc5f23c8bc7fc8$var$_arrayLikeToArray(o, minLen);
}
function $7fdc5f23c8bc7fc8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7fdc5f23c8bc7fc8$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// A reserved attribute.
// It is handled by React separately and shouldn't be written to the DOM.
var $7fdc5f23c8bc7fc8$var$RESERVED = 0; // A simple string attribute.
// Attributes that aren't in the filter are presumed to have this type.
var $7fdc5f23c8bc7fc8$var$STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
// "enumerated" attributes with "true" and "false" as possible values.
// When true, it should be set to a "true" string.
// When false, it should be set to a "false" string.
var $7fdc5f23c8bc7fc8$var$BOOLEANISH_STRING = 2; // A real boolean attribute.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
var $7fdc5f23c8bc7fc8$var$BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
// When true, it should be present (set either to an empty string or its name).
// When false, it should be omitted.
// For any other value, should be present with that value.
var $7fdc5f23c8bc7fc8$var$OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
// When falsy, it should be removed.
var $7fdc5f23c8bc7fc8$var$NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
// When falsy, it should be removed.
var $7fdc5f23c8bc7fc8$var$POSITIVE_NUMERIC = 6;
function $7fdc5f23c8bc7fc8$var$getPropertyInfo(name) {
    return $7fdc5f23c8bc7fc8$var$properties.hasOwnProperty(name) ? $7fdc5f23c8bc7fc8$var$properties[name] : null;
}
function $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
    this.acceptsBooleans = type === $7fdc5f23c8bc7fc8$var$BOOLEANISH_STRING || type === $7fdc5f23c8bc7fc8$var$BOOLEAN || type === $7fdc5f23c8bc7fc8$var$OVERLOADED_BOOLEAN;
    this.attributeName = attributeName;
    this.attributeNamespace = attributeNamespace;
    this.mustUseProperty = mustUseProperty;
    this.propertyName = name;
    this.type = type;
    this.sanitizeURL = sanitizeURL;
    this.removeEmptyString = removeEmptyString;
} // When adding attributes to this list, be sure to also add them to
// the `possibleStandardNames` module to ensure casing and incorrect
// name warnings.
var $7fdc5f23c8bc7fc8$var$properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
var $7fdc5f23c8bc7fc8$var$reservedProps = [
    "children",
    "dangerouslySetInnerHTML",
    // elements (not just inputs). Now that ReactDOMInput assigns to the
    // defaultValue property -- do we need this?
    "defaultValue",
    "defaultChecked",
    "innerHTML",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "style"
];
$7fdc5f23c8bc7fc8$var$reservedProps.forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$RESERVED, false, name, null, false, false);
}); // A few React string attributes have a different name.
// This is a mapping from React prop names to the attribute names.
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(_ref) {
    var _ref2 = $7fdc5f23c8bc7fc8$var$_slicedToArray(_ref, 2), name = _ref2[0], attributeName = _ref2[1];
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$STRING, false, attributeName, null, false, false);
}); // These are "enumerated" HTML attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
}); // These are "enumerated" SVG attributes that accept "true" and "false".
// In React, we let users pass `true` and `false` even though technically
// these aren't boolean attributes (they are coerced to strings).
// Since these are SVG attributes, their attribute names are case-sensitive.
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$BOOLEANISH_STRING, false, name, null, false, false);
}); // These are HTML boolean attributes.
[
    "allowFullScreen",
    "async",
    // on the client side because the browsers are inconsistent. Instead we call focus().
    "autoFocus",
    "autoPlay",
    "controls",
    "default",
    "defer",
    "disabled",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "formNoValidate",
    "hidden",
    "loop",
    "noModule",
    "noValidate",
    "open",
    "playsInline",
    "readOnly",
    "required",
    "reversed",
    "scoped",
    "seamless",
    "itemScope"
].forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$BOOLEAN, false, name.toLowerCase(), null, false, false);
}); // These are the few React props that we set as DOM properties
// rather than attributes. These are all booleans.
[
    "checked",
    // disabled with `removeAttribute`. We have special logic for handling this.
    "multiple",
    "muted",
    "selected" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$BOOLEAN, true, name, null, false, false);
}); // These are HTML attributes that are "overloaded booleans": they behave like
// booleans, but can also accept a string value.
[
    "capture",
    "download" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$OVERLOADED_BOOLEAN, false, name, null, false, false);
}); // These are HTML attributes that must be positive numbers.
[
    "cols",
    "rows",
    "size",
    "span" // NOTE: if you add a camelCased prop to this list,
].forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$POSITIVE_NUMERIC, false, name, null, false, false);
}); // These are HTML attributes that must be numbers.
[
    "rowSpan",
    "start"
].forEach(function(name) {
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$NUMERIC, false, name.toLowerCase(), null, false, false);
});
var $7fdc5f23c8bc7fc8$var$CAMELIZE = /[\-\:]([a-z])/g;
var $7fdc5f23c8bc7fc8$var$capitalize = function capitalize(token) {
    return token[1].toUpperCase();
}; // This is a list of all SVG attributes that need special casing, namespacing,
// or boolean value assignment. Regular attributes that just accept strings
// and have the same names are omitted, just like in the HTML attribute filter.
// Some of these attributes can be hard to find. This list was created by
// scraping the MDN documentation.
[
    "accent-height",
    "alignment-baseline",
    "arabic-form",
    "baseline-shift",
    "cap-height",
    "clip-path",
    "clip-rule",
    "color-interpolation",
    "color-interpolation-filters",
    "color-profile",
    "color-rendering",
    "dominant-baseline",
    "enable-background",
    "fill-opacity",
    "fill-rule",
    "flood-color",
    "flood-opacity",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-stretch",
    "font-style",
    "font-variant",
    "font-weight",
    "glyph-name",
    "glyph-orientation-horizontal",
    "glyph-orientation-vertical",
    "horiz-adv-x",
    "horiz-origin-x",
    "image-rendering",
    "letter-spacing",
    "lighting-color",
    "marker-end",
    "marker-mid",
    "marker-start",
    "overline-position",
    "overline-thickness",
    "paint-order",
    "panose-1",
    "pointer-events",
    "rendering-intent",
    "shape-rendering",
    "stop-color",
    "stop-opacity",
    "strikethrough-position",
    "strikethrough-thickness",
    "stroke-dasharray",
    "stroke-dashoffset",
    "stroke-linecap",
    "stroke-linejoin",
    "stroke-miterlimit",
    "stroke-opacity",
    "stroke-width",
    "text-anchor",
    "text-decoration",
    "text-rendering",
    "underline-position",
    "underline-thickness",
    "unicode-bidi",
    "unicode-range",
    "units-per-em",
    "v-alphabetic",
    "v-hanging",
    "v-ideographic",
    "v-mathematical",
    "vector-effect",
    "vert-adv-y",
    "vert-origin-x",
    "vert-origin-y",
    "word-spacing",
    "writing-mode",
    "xmlns:xlink",
    "x-height" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($7fdc5f23c8bc7fc8$var$CAMELIZE, $7fdc5f23c8bc7fc8$var$capitalize);
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$STRING, false, attributeName, null, false, false);
}); // String SVG attributes with the xlink namespace.
[
    "xlink:actuate",
    "xlink:arcrole",
    "xlink:role",
    "xlink:show",
    "xlink:title",
    "xlink:type" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($7fdc5f23c8bc7fc8$var$CAMELIZE, $7fdc5f23c8bc7fc8$var$capitalize);
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
}); // String SVG attributes with the xml namespace.
[
    "xml:base",
    "xml:lang",
    "xml:space" // NOTE: if you add a camelCased prop to this list,
].forEach(function(attributeName) {
    var name = attributeName.replace($7fdc5f23c8bc7fc8$var$CAMELIZE, $7fdc5f23c8bc7fc8$var$capitalize);
    $7fdc5f23c8bc7fc8$var$properties[name] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(name, $7fdc5f23c8bc7fc8$var$STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
}); // These attribute exists both in HTML and SVG.
// The attribute name is case-sensitive in SVG so we can't just use
// the React name like we do for attributes that exist only in HTML.
[
    "tabIndex",
    "crossOrigin"
].forEach(function(attributeName) {
    $7fdc5f23c8bc7fc8$var$properties[attributeName] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(attributeName, $7fdc5f23c8bc7fc8$var$STRING, false, attributeName.toLowerCase(), null, false, false);
}); // These attributes accept URLs. These must not allow javascript: URLS.
// These will also need to accept Trusted Types object in the future.
var $7fdc5f23c8bc7fc8$var$xlinkHref = "xlinkHref";
$7fdc5f23c8bc7fc8$var$properties[$7fdc5f23c8bc7fc8$var$xlinkHref] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord("xlinkHref", $7fdc5f23c8bc7fc8$var$STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(attributeName) {
    $7fdc5f23c8bc7fc8$var$properties[attributeName] = new $7fdc5f23c8bc7fc8$var$PropertyInfoRecord(attributeName, $7fdc5f23c8bc7fc8$var$STRING, false, attributeName.toLowerCase(), null, true, true);
});
// An attribute in which the DOM/SVG standard name is the same as the React prop name (e.g., 'accept').
var $1a1a44613dada715$export$7359a57b3ac1f378;
var $1a1a44613dada715$export$5ab28d07cff57c11;
var $1a1a44613dada715$export$bbecfff5ecf65cd8;
var $1a1a44613dada715$var$SAME = 0;
$1a1a44613dada715$export$7359a57b3ac1f378 = $1a1a44613dada715$var$SAME;
// An attribute in which the React prop name is the camelcased version of the DOM/SVG standard name (e.g., 'acceptCharset').
var $1a1a44613dada715$var$CAMELCASE = 1;
$1a1a44613dada715$export$5ab28d07cff57c11 = $1a1a44613dada715$var$CAMELCASE;
$1a1a44613dada715$export$bbecfff5ecf65cd8 = {
    accept: 0,
    acceptCharset: 1,
    "accept-charset": "acceptCharset",
    accessKey: 1,
    action: 0,
    allowFullScreen: 1,
    alt: 0,
    as: 0,
    async: 0,
    autoCapitalize: 1,
    autoComplete: 1,
    autoCorrect: 1,
    autoFocus: 1,
    autoPlay: 1,
    autoSave: 1,
    capture: 0,
    cellPadding: 1,
    cellSpacing: 1,
    challenge: 0,
    charSet: 1,
    checked: 0,
    children: 0,
    cite: 0,
    class: "className",
    classID: 1,
    className: 1,
    cols: 0,
    colSpan: 1,
    content: 0,
    contentEditable: 1,
    contextMenu: 1,
    controls: 0,
    controlsList: 1,
    coords: 0,
    crossOrigin: 1,
    dangerouslySetInnerHTML: 1,
    data: 0,
    dateTime: 1,
    default: 0,
    defaultChecked: 1,
    defaultValue: 1,
    defer: 0,
    dir: 0,
    disabled: 0,
    disablePictureInPicture: 1,
    disableRemotePlayback: 1,
    download: 0,
    draggable: 0,
    encType: 1,
    enterKeyHint: 1,
    for: "htmlFor",
    form: 0,
    formMethod: 1,
    formAction: 1,
    formEncType: 1,
    formNoValidate: 1,
    formTarget: 1,
    frameBorder: 1,
    headers: 0,
    height: 0,
    hidden: 0,
    high: 0,
    href: 0,
    hrefLang: 1,
    htmlFor: 1,
    httpEquiv: 1,
    "http-equiv": "httpEquiv",
    icon: 0,
    id: 0,
    innerHTML: 1,
    inputMode: 1,
    integrity: 0,
    is: 0,
    itemID: 1,
    itemProp: 1,
    itemRef: 1,
    itemScope: 1,
    itemType: 1,
    keyParams: 1,
    keyType: 1,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: 0,
    low: 0,
    manifest: 0,
    marginWidth: 1,
    marginHeight: 1,
    max: 0,
    maxLength: 1,
    media: 0,
    mediaGroup: 1,
    method: 0,
    min: 0,
    minLength: 1,
    multiple: 0,
    muted: 0,
    name: 0,
    noModule: 1,
    nonce: 0,
    noValidate: 1,
    open: 0,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: 1,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 1,
    readOnly: 1,
    referrerPolicy: 1,
    rel: 0,
    required: 0,
    reversed: 0,
    role: 0,
    rows: 0,
    rowSpan: 1,
    sandbox: 0,
    scope: 0,
    scoped: 0,
    scrolling: 0,
    seamless: 0,
    selected: 0,
    shape: 0,
    size: 0,
    sizes: 0,
    span: 0,
    spellCheck: 1,
    src: 0,
    srcDoc: 1,
    srcLang: 1,
    srcSet: 1,
    start: 0,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 1,
    target: 0,
    title: 0,
    type: 0,
    useMap: 1,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,
    about: 0,
    accentHeight: 1,
    "accent-height": "accentHeight",
    accumulate: 0,
    additive: 0,
    alignmentBaseline: 1,
    "alignment-baseline": "alignmentBaseline",
    allowReorder: 1,
    alphabetic: 0,
    amplitude: 0,
    arabicForm: 1,
    "arabic-form": "arabicForm",
    ascent: 0,
    attributeName: 1,
    attributeType: 1,
    autoReverse: 1,
    azimuth: 0,
    baseFrequency: 1,
    baselineShift: 1,
    "baseline-shift": "baselineShift",
    baseProfile: 1,
    bbox: 0,
    begin: 0,
    bias: 0,
    by: 0,
    calcMode: 1,
    capHeight: 1,
    "cap-height": "capHeight",
    clip: 0,
    clipPath: 1,
    "clip-path": "clipPath",
    clipPathUnits: 1,
    clipRule: 1,
    "clip-rule": "clipRule",
    color: 0,
    colorInterpolation: 1,
    "color-interpolation": "colorInterpolation",
    colorInterpolationFilters: 1,
    "color-interpolation-filters": "colorInterpolationFilters",
    colorProfile: 1,
    "color-profile": "colorProfile",
    colorRendering: 1,
    "color-rendering": "colorRendering",
    contentScriptType: 1,
    contentStyleType: 1,
    cursor: 0,
    cx: 0,
    cy: 0,
    d: 0,
    datatype: 0,
    decelerate: 0,
    descent: 0,
    diffuseConstant: 1,
    direction: 0,
    display: 0,
    divisor: 0,
    dominantBaseline: 1,
    "dominant-baseline": "dominantBaseline",
    dur: 0,
    dx: 0,
    dy: 0,
    edgeMode: 1,
    elevation: 0,
    enableBackground: 1,
    "enable-background": "enableBackground",
    end: 0,
    exponent: 0,
    externalResourcesRequired: 1,
    fill: 0,
    fillOpacity: 1,
    "fill-opacity": "fillOpacity",
    fillRule: 1,
    "fill-rule": "fillRule",
    filter: 0,
    filterRes: 1,
    filterUnits: 1,
    floodOpacity: 1,
    "flood-opacity": "floodOpacity",
    floodColor: 1,
    "flood-color": "floodColor",
    focusable: 0,
    fontFamily: 1,
    "font-family": "fontFamily",
    fontSize: 1,
    "font-size": "fontSize",
    fontSizeAdjust: 1,
    "font-size-adjust": "fontSizeAdjust",
    fontStretch: 1,
    "font-stretch": "fontStretch",
    fontStyle: 1,
    "font-style": "fontStyle",
    fontVariant: 1,
    "font-variant": "fontVariant",
    fontWeight: 1,
    "font-weight": "fontWeight",
    format: 0,
    from: 0,
    fx: 0,
    fy: 0,
    g1: 0,
    g2: 0,
    glyphName: 1,
    "glyph-name": "glyphName",
    glyphOrientationHorizontal: 1,
    "glyph-orientation-horizontal": "glyphOrientationHorizontal",
    glyphOrientationVertical: 1,
    "glyph-orientation-vertical": "glyphOrientationVertical",
    glyphRef: 1,
    gradientTransform: 1,
    gradientUnits: 1,
    hanging: 0,
    horizAdvX: 1,
    "horiz-adv-x": "horizAdvX",
    horizOriginX: 1,
    "horiz-origin-x": "horizOriginX",
    ideographic: 0,
    imageRendering: 1,
    "image-rendering": "imageRendering",
    in2: 0,
    in: 0,
    inlist: 0,
    intercept: 0,
    k1: 0,
    k2: 0,
    k3: 0,
    k4: 0,
    k: 0,
    kernelMatrix: 1,
    kernelUnitLength: 1,
    kerning: 0,
    keyPoints: 1,
    keySplines: 1,
    keyTimes: 1,
    lengthAdjust: 1,
    letterSpacing: 1,
    "letter-spacing": "letterSpacing",
    lightingColor: 1,
    "lighting-color": "lightingColor",
    limitingConeAngle: 1,
    local: 0,
    markerEnd: 1,
    "marker-end": "markerEnd",
    markerHeight: 1,
    markerMid: 1,
    "marker-mid": "markerMid",
    markerStart: 1,
    "marker-start": "markerStart",
    markerUnits: 1,
    markerWidth: 1,
    mask: 0,
    maskContentUnits: 1,
    maskUnits: 1,
    mathematical: 0,
    mode: 0,
    numOctaves: 1,
    offset: 0,
    opacity: 0,
    operator: 0,
    order: 0,
    orient: 0,
    orientation: 0,
    origin: 0,
    overflow: 0,
    overlinePosition: 1,
    "overline-position": "overlinePosition",
    overlineThickness: 1,
    "overline-thickness": "overlineThickness",
    paintOrder: 1,
    "paint-order": "paintOrder",
    panose1: 0,
    "panose-1": "panose1",
    pathLength: 1,
    patternContentUnits: 1,
    patternTransform: 1,
    patternUnits: 1,
    pointerEvents: 1,
    "pointer-events": "pointerEvents",
    points: 0,
    pointsAtX: 1,
    pointsAtY: 1,
    pointsAtZ: 1,
    prefix: 0,
    preserveAlpha: 1,
    preserveAspectRatio: 1,
    primitiveUnits: 1,
    property: 0,
    r: 0,
    radius: 0,
    refX: 1,
    refY: 1,
    renderingIntent: 1,
    "rendering-intent": "renderingIntent",
    repeatCount: 1,
    repeatDur: 1,
    requiredExtensions: 1,
    requiredFeatures: 1,
    resource: 0,
    restart: 0,
    result: 0,
    results: 0,
    rotate: 0,
    rx: 0,
    ry: 0,
    scale: 0,
    security: 0,
    seed: 0,
    shapeRendering: 1,
    "shape-rendering": "shapeRendering",
    slope: 0,
    spacing: 0,
    specularConstant: 1,
    specularExponent: 1,
    speed: 0,
    spreadMethod: 1,
    startOffset: 1,
    stdDeviation: 1,
    stemh: 0,
    stemv: 0,
    stitchTiles: 1,
    stopColor: 1,
    "stop-color": "stopColor",
    stopOpacity: 1,
    "stop-opacity": "stopOpacity",
    strikethroughPosition: 1,
    "strikethrough-position": "strikethroughPosition",
    strikethroughThickness: 1,
    "strikethrough-thickness": "strikethroughThickness",
    string: 0,
    stroke: 0,
    strokeDasharray: 1,
    "stroke-dasharray": "strokeDasharray",
    strokeDashoffset: 1,
    "stroke-dashoffset": "strokeDashoffset",
    strokeLinecap: 1,
    "stroke-linecap": "strokeLinecap",
    strokeLinejoin: 1,
    "stroke-linejoin": "strokeLinejoin",
    strokeMiterlimit: 1,
    "stroke-miterlimit": "strokeMiterlimit",
    strokeWidth: 1,
    "stroke-width": "strokeWidth",
    strokeOpacity: 1,
    "stroke-opacity": "strokeOpacity",
    suppressContentEditableWarning: 1,
    suppressHydrationWarning: 1,
    surfaceScale: 1,
    systemLanguage: 1,
    tableValues: 1,
    targetX: 1,
    targetY: 1,
    textAnchor: 1,
    "text-anchor": "textAnchor",
    textDecoration: 1,
    "text-decoration": "textDecoration",
    textLength: 1,
    textRendering: 1,
    "text-rendering": "textRendering",
    to: 0,
    transform: 0,
    typeof: 0,
    u1: 0,
    u2: 0,
    underlinePosition: 1,
    "underline-position": "underlinePosition",
    underlineThickness: 1,
    "underline-thickness": "underlineThickness",
    unicode: 0,
    unicodeBidi: 1,
    "unicode-bidi": "unicodeBidi",
    unicodeRange: 1,
    "unicode-range": "unicodeRange",
    unitsPerEm: 1,
    "units-per-em": "unitsPerEm",
    unselectable: 0,
    vAlphabetic: 1,
    "v-alphabetic": "vAlphabetic",
    values: 0,
    vectorEffect: 1,
    "vector-effect": "vectorEffect",
    version: 0,
    vertAdvY: 1,
    "vert-adv-y": "vertAdvY",
    vertOriginX: 1,
    "vert-origin-x": "vertOriginX",
    vertOriginY: 1,
    "vert-origin-y": "vertOriginY",
    vHanging: 1,
    "v-hanging": "vHanging",
    vIdeographic: 1,
    "v-ideographic": "vIdeographic",
    viewBox: 1,
    viewTarget: 1,
    visibility: 0,
    vMathematical: 1,
    "v-mathematical": "vMathematical",
    vocab: 0,
    widths: 0,
    wordSpacing: 1,
    "word-spacing": "wordSpacing",
    writingMode: 1,
    "writing-mode": "writingMode",
    x1: 0,
    x2: 0,
    x: 0,
    xChannelSelector: 1,
    xHeight: 1,
    "x-height": "xHeight",
    xlinkActuate: 1,
    "xlink:actuate": "xlinkActuate",
    xlinkArcrole: 1,
    "xlink:arcrole": "xlinkArcrole",
    xlinkHref: 1,
    "xlink:href": "xlinkHref",
    xlinkRole: 1,
    "xlink:role": "xlinkRole",
    xlinkShow: 1,
    "xlink:show": "xlinkShow",
    xlinkTitle: 1,
    "xlink:title": "xlinkTitle",
    xlinkType: 1,
    "xlink:type": "xlinkType",
    xmlBase: 1,
    "xml:base": "xmlBase",
    xmlLang: 1,
    "xml:lang": "xmlLang",
    xmlns: 0,
    "xml:space": "xmlSpace",
    xmlnsXlink: 1,
    "xmlns:xlink": "xmlnsXlink",
    xmlSpace: 1,
    y1: 0,
    y2: 0,
    y: 0,
    yChannelSelector: 1,
    z: 0,
    zoomAndPan: 1
};


var $7fdc5f23c8bc7fc8$var$CAMELCASE = $1a1a44613dada715$export$5ab28d07cff57c11, $7fdc5f23c8bc7fc8$var$SAME = $1a1a44613dada715$export$7359a57b3ac1f378, $7fdc5f23c8bc7fc8$var$possibleStandardNamesOptimized = $1a1a44613dada715$export$bbecfff5ecf65cd8;
var $7fdc5f23c8bc7fc8$var$ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
var $7fdc5f23c8bc7fc8$var$ATTRIBUTE_NAME_CHAR = $7fdc5f23c8bc7fc8$var$ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
/**
 * Checks whether a property name is a custom attribute.
 *
 * @see {@link https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25}
 *
 * @param {string}
 * @return {boolean}
 */ var $7fdc5f23c8bc7fc8$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp("^(data|aria)-[" + $7fdc5f23c8bc7fc8$var$ATTRIBUTE_NAME_CHAR + "]*$"));
var $7fdc5f23c8bc7fc8$var$possibleStandardNames = Object.keys($7fdc5f23c8bc7fc8$var$possibleStandardNamesOptimized).reduce(function(accumulator, standardName) {
    var propName = $7fdc5f23c8bc7fc8$var$possibleStandardNamesOptimized[standardName];
    if (propName === $7fdc5f23c8bc7fc8$var$SAME) accumulator[standardName] = standardName;
    else if (propName === $7fdc5f23c8bc7fc8$var$CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
    else accumulator[standardName] = propName;
    return accumulator;
}, {});
$7fdc5f23c8bc7fc8$exports.BOOLEAN = $7fdc5f23c8bc7fc8$var$BOOLEAN;
$7fdc5f23c8bc7fc8$exports.BOOLEANISH_STRING = $7fdc5f23c8bc7fc8$var$BOOLEANISH_STRING;
$7fdc5f23c8bc7fc8$exports.NUMERIC = $7fdc5f23c8bc7fc8$var$NUMERIC;
$7fdc5f23c8bc7fc8$exports.OVERLOADED_BOOLEAN = $7fdc5f23c8bc7fc8$var$OVERLOADED_BOOLEAN;
$7fdc5f23c8bc7fc8$exports.POSITIVE_NUMERIC = $7fdc5f23c8bc7fc8$var$POSITIVE_NUMERIC;
$7fdc5f23c8bc7fc8$exports.RESERVED = $7fdc5f23c8bc7fc8$var$RESERVED;
$7fdc5f23c8bc7fc8$exports.STRING = $7fdc5f23c8bc7fc8$var$STRING;
$7fdc5f23c8bc7fc8$exports.getPropertyInfo = $7fdc5f23c8bc7fc8$var$getPropertyInfo;
$7fdc5f23c8bc7fc8$exports.isCustomAttribute = $7fdc5f23c8bc7fc8$var$isCustomAttribute;
$7fdc5f23c8bc7fc8$exports.possibleStandardNames = $7fdc5f23c8bc7fc8$var$possibleStandardNames;


var $96db8adac50fa6a5$exports = {};

var $exYeM = parcelRequire("exYeM");
var $75e787f83c9daa96$exports = {};
"use strict";
var $75e787f83c9daa96$var$__importDefault = $75e787f83c9daa96$exports && $75e787f83c9daa96$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($75e787f83c9daa96$exports, "__esModule", {
    value: true
});

var $75e787f83c9daa96$var$style_to_object_1 = $75e787f83c9daa96$var$__importDefault((parcelRequire("kricu")));
var $76deae4748f458df$exports = {};
"use strict";
Object.defineProperty($76deae4748f458df$exports, "__esModule", {
    value: true
});
$76deae4748f458df$exports.camelCase = void 0;
var $76deae4748f458df$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9-]+$/;
var $76deae4748f458df$var$HYPHEN_REGEX = /-([a-z])/g;
var $76deae4748f458df$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $76deae4748f458df$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $76deae4748f458df$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
var $76deae4748f458df$var$skipCamelCase = function(property) {
    return !property || $76deae4748f458df$var$NO_HYPHEN_REGEX.test(property) || $76deae4748f458df$var$CUSTOM_PROPERTY_REGEX.test(property);
};
var $76deae4748f458df$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
var $76deae4748f458df$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
var $76deae4748f458df$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($76deae4748f458df$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) property = property.replace($76deae4748f458df$var$MS_VENDOR_PREFIX_REGEX, $76deae4748f458df$var$trimHyphen);
    else property = property.replace($76deae4748f458df$var$VENDOR_PREFIX_REGEX, $76deae4748f458df$var$trimHyphen);
    return property.replace($76deae4748f458df$var$HYPHEN_REGEX, $76deae4748f458df$var$capitalize);
};
$76deae4748f458df$exports.camelCase = $76deae4748f458df$var$camelCase;


function $75e787f83c9daa96$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== "string") return output;
    (0, $75e787f83c9daa96$var$style_to_object_1.default)(style, function(property, value) {
        if (property && value) output[(0, $76deae4748f458df$exports.camelCase)(property, options)] = value;
    });
    return output;
}
$75e787f83c9daa96$exports.default = $75e787f83c9daa96$var$StyleToJS;


var $96db8adac50fa6a5$require$styleToJS = $75e787f83c9daa96$exports.default;
/**
 * Swap key with value in an object.
 *
 * @param {object} obj - The object.
 * @param {Function} [override] - The override method.
 * @returns - The inverted object.
 */ function $96db8adac50fa6a5$var$invertObject(obj, override) {
    if (!obj || typeof obj !== "object") throw new TypeError("First argument must be an object");
    var isOverridePresent = typeof override === "function";
    var overrides = {};
    var result = {};
    for(var key in obj){
        var value = obj[key];
        if (isOverridePresent) {
            overrides = override(key, value);
            if (overrides && overrides.length === 2) {
                result[overrides[0]] = overrides[1];
                continue;
            }
        }
        if (typeof value === "string") result[value] = key;
    }
    return result;
}
var $96db8adac50fa6a5$var$RESERVED_SVG_MATHML_ELEMENTS = new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
]);
/**
 * Check if a given tag is a custom component.
 *
 * @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
 *
 * @param {string} tagName - The name of the html tag.
 * @param {object} props - The props being passed to the element.
 * @returns {boolean} - Whether tag is custom component.
 */ function $96db8adac50fa6a5$var$isCustomComponent(tagName, props) {
    if (tagName.indexOf("-") === -1) return props && typeof props.is === "string";
    // These are reserved SVG and MathML elements.
    // We don't mind this whitelist too much because we expect it to never grow.
    // The alternative is to track the namespace in a few places which is convoluted.
    // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
    if ($96db8adac50fa6a5$var$RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) return false;
    return true;
}
// styleToJSOptions
var $96db8adac50fa6a5$var$STYLE_TO_JS_OPTIONS = {
    reactCompat: true
};
/**
 * Sets style prop.
 *
 * @param {null|undefined|string} style
 * @param {object} props
 */ function $96db8adac50fa6a5$var$setStyleProp(style, props) {
    if (style === null || style === undefined) return;
    try {
        props.style = $96db8adac50fa6a5$require$styleToJS(style, $96db8adac50fa6a5$var$STYLE_TO_JS_OPTIONS);
    } catch (err) {
        props.style = {};
    }
}
/**
 * @constant {boolean}
 * @see {@link https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html}
 */ var $96db8adac50fa6a5$var$PRESERVE_CUSTOM_ATTRIBUTES = $exYeM.version.split(".")[0] >= 16;
// Taken from
// https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
var $96db8adac50fa6a5$var$ELEMENTS_WITH_NO_TEXT_CHILDREN = new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
]);
/**
 * Checks if the given node can contain text nodes
 *
 * @param {DomElement} node - Node.
 * @returns - Whether node can contain text nodes.
 */ function $96db8adac50fa6a5$var$canTextBeChildOfNode(node) {
    return !$96db8adac50fa6a5$var$ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node.name);
}
/**
 * Returns the first argument as is.
 *
 * @param {any} arg - The argument to be returned.
 * @returns {any} The input argument `arg`.
 */ function $96db8adac50fa6a5$var$returnFirstArg(arg) {
    return arg;
}
$96db8adac50fa6a5$exports = {
    PRESERVE_CUSTOM_ATTRIBUTES: $96db8adac50fa6a5$var$PRESERVE_CUSTOM_ATTRIBUTES,
    ELEMENTS_WITH_NO_TEXT_CHILDREN: $96db8adac50fa6a5$var$ELEMENTS_WITH_NO_TEXT_CHILDREN,
    invertObject: $96db8adac50fa6a5$var$invertObject,
    isCustomComponent: $96db8adac50fa6a5$var$isCustomComponent,
    setStyleProp: $96db8adac50fa6a5$var$setStyleProp,
    canTextBeChildOfNode: $96db8adac50fa6a5$var$canTextBeChildOfNode,
    returnFirstArg: $96db8adac50fa6a5$var$returnFirstArg
};


// https://reactjs.org/docs/uncontrolled-components.html
// https://developer.mozilla.org/docs/Web/HTML/Attributes
var $d8e860a6c9a7b7b9$var$UNCONTROLLED_COMPONENT_ATTRIBUTES = [
    "checked",
    "value"
];
var $d8e860a6c9a7b7b9$var$UNCONTROLLED_COMPONENT_NAMES = [
    "input",
    "select",
    "textarea"
];
var $d8e860a6c9a7b7b9$var$VALUE_ONLY_INPUTS = {
    reset: true,
    submit: true
};
/**
 * Converts HTML/SVG DOM attributes to React props.
 *
 * @param {object} [attributes={}] - HTML/SVG DOM attributes.
 * @param {string} [nodeName] - DOM node name.
 * @returns - React props.
 */ $d8e860a6c9a7b7b9$exports = function attributesToProps(attributes, nodeName) {
    attributes = attributes || {};
    var attributeName;
    var attributeNameLowerCased;
    var attributeValue;
    var propName;
    var propertyInfo;
    var props = {};
    var inputIsValueOnly = attributes.type && $d8e860a6c9a7b7b9$var$VALUE_ONLY_INPUTS[attributes.type];
    for(attributeName in attributes){
        attributeValue = attributes[attributeName];
        // ARIA (aria-*) or custom data (data-*) attribute
        if ($7fdc5f23c8bc7fc8$exports.isCustomAttribute(attributeName)) {
            props[attributeName] = attributeValue;
            continue;
        }
        // convert HTML/SVG attribute to React prop
        attributeNameLowerCased = attributeName.toLowerCase();
        propName = $d8e860a6c9a7b7b9$var$getPropName(attributeNameLowerCased);
        if (propName) {
            propertyInfo = $7fdc5f23c8bc7fc8$exports.getPropertyInfo(propName);
            // convert attribute to uncontrolled component prop (e.g., `value` to `defaultValue`)
            if ($d8e860a6c9a7b7b9$var$UNCONTROLLED_COMPONENT_ATTRIBUTES.indexOf(propName) !== -1 && $d8e860a6c9a7b7b9$var$UNCONTROLLED_COMPONENT_NAMES.indexOf(nodeName) !== -1 && !inputIsValueOnly) propName = $d8e860a6c9a7b7b9$var$getPropName("default" + attributeNameLowerCased);
            props[propName] = attributeValue;
            switch(propertyInfo && propertyInfo.type){
                case $7fdc5f23c8bc7fc8$exports.BOOLEAN:
                    props[propName] = true;
                    break;
                case $7fdc5f23c8bc7fc8$exports.OVERLOADED_BOOLEAN:
                    if (attributeValue === "") props[propName] = true;
                    break;
            }
            continue;
        }
        // preserve custom attribute if React >=16
        if ($96db8adac50fa6a5$exports.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
    }
    // transform inline style to object
    $96db8adac50fa6a5$exports.setStyleProp(attributes.style, props);
    return props;
};
/**
 * Gets prop name from lowercased attribute name.
 *
 * @param {string} attributeName - Lowercased attribute name.
 * @returns - Prop name.
 */ function $d8e860a6c9a7b7b9$var$getPropName(attributeName) {
    return $7fdc5f23c8bc7fc8$exports.possibleStandardNames[attributeName];
}


var $0a385d5d4712f4f4$exports = {};

var $exYeM = parcelRequire("exYeM");


var $0a385d5d4712f4f4$var$setStyleProp = $96db8adac50fa6a5$exports.setStyleProp;
var $0a385d5d4712f4f4$var$canTextBeChildOfNode = $96db8adac50fa6a5$exports.canTextBeChildOfNode;
/**
 * Converts DOM nodes to JSX element(s).
 *
 * @param {DomElement[]} nodes - DOM nodes.
 * @param {object} [options={}] - Options.
 * @param {Function} [options.replace] - Replacer.
 * @param {Function} [options.transform] - Transform.
 * @param {object} [options.library] - Library (React, Preact, etc.).
 * @returns - String or JSX element(s).
 */ function $0a385d5d4712f4f4$var$domToReact(nodes, options) {
    options = options || {};
    var library = options.library || $exYeM;
    var cloneElement = library.cloneElement;
    var createElement = library.createElement;
    var isValidElement = library.isValidElement;
    var result = [];
    var node;
    var isWhitespace;
    var hasReplace = typeof options.replace === "function";
    var transform = options.transform || $96db8adac50fa6a5$exports.returnFirstArg;
    var replaceElement;
    var props;
    var children;
    var trim = options.trim;
    for(var i = 0, len = nodes.length; i < len; i++){
        node = nodes[i];
        // replace with custom React element (if present)
        if (hasReplace) {
            replaceElement = options.replace(node);
            if (isValidElement(replaceElement)) {
                // set "key" prop for sibling elements
                // https://fb.me/react-warning-keys
                if (len > 1) replaceElement = cloneElement(replaceElement, {
                    key: replaceElement.key || i
                });
                result.push(transform(replaceElement, node, i));
                continue;
            }
        }
        if (node.type === "text") {
            isWhitespace = !node.data.trim().length;
            if (isWhitespace && node.parent && !$0a385d5d4712f4f4$var$canTextBeChildOfNode(node.parent)) continue;
            if (trim && isWhitespace) continue;
            // We have a text node that's not whitespace and it can be nested
            // in its parent so add it to the results
            result.push(transform(node.data, node, i));
            continue;
        }
        props = node.attribs;
        if ($0a385d5d4712f4f4$var$skipAttributesToProps(node)) $0a385d5d4712f4f4$var$setStyleProp(props.style, props);
        else if (props) props = $d8e860a6c9a7b7b9$exports(props, node.name);
        children = null;
        switch(node.type){
            case "script":
            case "style":
                // prevent text in <script> or <style> from being escaped
                // https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
                if (node.children[0]) props.dangerouslySetInnerHTML = {
                    __html: node.children[0].data
                };
                break;
            case "tag":
                // setting textarea value in children is an antipattern in React
                // https://reactjs.org/docs/forms.html#the-textarea-tag
                if (node.name === "textarea" && node.children[0]) props.defaultValue = node.children[0].data;
                else if (node.children && node.children.length) // continue recursion of creating React elements (if applicable)
                children = $0a385d5d4712f4f4$var$domToReact(node.children, options);
                break;
            // skip all other cases (e.g., comment)
            default:
                continue;
        }
        // set "key" prop for sibling elements
        // https://fb.me/react-warning-keys
        if (len > 1) props.key = i;
        result.push(transform(createElement(node.name, props, children), node, i));
    }
    return result.length === 1 ? result[0] : result;
}
/**
 * Determines whether DOM element attributes should be transformed to props.
 * Web Components should not have their attributes transformed except for `style`.
 *
 * @param {DomElement} node
 * @returns - Whether node attributes should be converted to props.
 */ function $0a385d5d4712f4f4$var$skipAttributesToProps(node) {
    return $96db8adac50fa6a5$exports.PRESERVE_CUSTOM_ATTRIBUTES && node.type === "tag" && $96db8adac50fa6a5$exports.isCustomComponent(node.name, node.attribs);
}
$0a385d5d4712f4f4$exports = $0a385d5d4712f4f4$var$domToReact;


// support backwards compatibility for ES Module
$94ae3b4f9cdd4d92$require$htmlToDOM = /* istanbul ignore next */ typeof $94ae3b4f9cdd4d92$require$htmlToDOM.default === "function" ? $94ae3b4f9cdd4d92$require$htmlToDOM.default : $94ae3b4f9cdd4d92$require$htmlToDOM;
var $94ae3b4f9cdd4d92$var$domParserOptions = {
    lowerCaseAttributeNames: false
};
/**
 * Converts HTML string to React elements.
 *
 * @param {string} html - HTML string.
 * @param {object} [options] - Parser options.
 * @param {object} [options.htmlparser2] - htmlparser2 options.
 * @param {object} [options.library] - Library for React, Preact, etc.
 * @param {Function} [options.replace] - Replace method.
 * @returns {JSX.Element|JSX.Element[]|string} - React element(s), empty array, or string.
 */ function $94ae3b4f9cdd4d92$var$HTMLReactParser(html, options) {
    if (typeof html !== "string") throw new TypeError("First argument must be a string");
    if (html === "") return [];
    options = options || {};
    return $0a385d5d4712f4f4$exports($94ae3b4f9cdd4d92$require$htmlToDOM(html, options.htmlparser2 || $94ae3b4f9cdd4d92$var$domParserOptions), options);
}
$94ae3b4f9cdd4d92$var$HTMLReactParser.domToReact = $0a385d5d4712f4f4$exports;
$94ae3b4f9cdd4d92$var$HTMLReactParser.htmlToDOM = $94ae3b4f9cdd4d92$require$htmlToDOM;
$94ae3b4f9cdd4d92$var$HTMLReactParser.attributesToProps = $d8e860a6c9a7b7b9$exports;
// domhandler
$94ae3b4f9cdd4d92$var$HTMLReactParser.Comment = $377a80095ac7e925$export$4d299b491347818a;
$94ae3b4f9cdd4d92$var$HTMLReactParser.Element = $377a80095ac7e925$export$db77ccec0bb4ccac;
$94ae3b4f9cdd4d92$var$HTMLReactParser.ProcessingInstruction = $377a80095ac7e925$export$9269dce19ee35e96;
$94ae3b4f9cdd4d92$var$HTMLReactParser.Text = $377a80095ac7e925$export$5f1af8db9871e1d6;
// support CommonJS and ES Modules
$94ae3b4f9cdd4d92$exports = $94ae3b4f9cdd4d92$var$HTMLReactParser;
$94ae3b4f9cdd4d92$var$HTMLReactParser.default = $94ae3b4f9cdd4d92$var$HTMLReactParser;


var $fb651b4393d0ff74$export$562c76a291853ae = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports))).domToReact;
var $fb651b4393d0ff74$export$131c6d55a47cefc8 = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports))).htmlToDOM;
var $fb651b4393d0ff74$export$af8e902ee50b21fc = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports))).attributesToProps;
var $fb651b4393d0ff74$export$4d299b491347818a = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports))).Comment;
var $fb651b4393d0ff74$export$db77ccec0bb4ccac = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports))).Element;
var $fb651b4393d0ff74$export$9269dce19ee35e96 = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports))).ProcessingInstruction;
var $fb651b4393d0ff74$export$5f1af8db9871e1d6 = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports))).Text;
var $fb651b4393d0ff74$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($94ae3b4f9cdd4d92$exports)));


function $78d3e8b7d5e47526$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $78d3e8b7d5e47526$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $78d3e8b7d5e47526$export$2e2bcd8739ae039(o);
}


function $b320e4b5494ae3f6$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $2285621ea3fa8491$export$2e2bcd8739ae039(argument) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $78d3e8b7d5e47526$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $34df346d5c5052d9$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $e186b8b389b84e48$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $d6e6dd41b8cf835a$var$MILLISECONDS_IN_DAY = 86400000;
function $d6e6dd41b8cf835a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $e186b8b389b84e48$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $d6e6dd41b8cf835a$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $83985fc780dba6d7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $d6e6dd41b8cf835a$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($83985fc780dba6d7$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $c0d321040488d36f$export$dfd9b671c89acc8e = 7;
var $c0d321040488d36f$export$3913210603d8e9ae = 365.2425;
var $c0d321040488d36f$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $c0d321040488d36f$export$91246f0b9bd9beff = 60000;
var $c0d321040488d36f$export$7f72910d6dfd237a = 3600000;
var $c0d321040488d36f$export$397c2d5776aa9055 = 1000;
var $c0d321040488d36f$export$4dec998e48f9c246 = -$c0d321040488d36f$export$81caae6e1cc7a622;
var $c0d321040488d36f$export$f2f5ae5a8e2d8f9f = 60;
var $c0d321040488d36f$export$3c58128db900d44e = 3;
var $c0d321040488d36f$export$80d7e435f744f319 = 12;
var $c0d321040488d36f$export$4db7641526e3241f = 4;
var $c0d321040488d36f$export$698aec755e92c695 = 3600;
var $c0d321040488d36f$export$a77c1a7ebebe2a5a = 60;
var $c0d321040488d36f$export$815a9362476d2fe3 = $c0d321040488d36f$export$698aec755e92c695 * 24;
var $c0d321040488d36f$export$34804a017b31e2fe = $c0d321040488d36f$export$815a9362476d2fe3 * 7;
var $c0d321040488d36f$export$7271e9e3478110d1 = $c0d321040488d36f$export$815a9362476d2fe3 * $c0d321040488d36f$export$3913210603d8e9ae;
var $c0d321040488d36f$export$8e6600bbdee7dabb = $c0d321040488d36f$export$7271e9e3478110d1 / 12;
var $c0d321040488d36f$export$be1dccf2de902d31 = $c0d321040488d36f$export$8e6600bbdee7dabb * 3;




function $c03b34c4f5393ff7$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    return (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $40cb9277785070a4$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $40cb9277785070a4$var$defaultRoundingMethod = "trunc";
function $40cb9277785070a4$export$b6474a47258c1211(method) {
    return method ? $40cb9277785070a4$var$roundingMap[method] : $40cb9277785070a4$var$roundingMap[$40cb9277785070a4$var$defaultRoundingMethod];
}


function $b4c5b0105a3de3c0$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $c03b34c4f5393ff7$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $c0d321040488d36f$export$91246f0b9bd9beff);
    return (0, $40cb9277785070a4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

var $bac751230e4fc222$var$defaultOptions = {};
function $bac751230e4fc222$export$430a3269e24b912e() {
    return $bac751230e4fc222$var$defaultOptions;
}
function $bac751230e4fc222$export$95365be1b0704abc(newOptions) {
    $bac751230e4fc222$var$defaultOptions = newOptions;
}




function $f319ee1b0fdb288a$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}





function $0c02c7faee7ab2f0$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $f23682b0b5b2d802$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $1da06aa14904949d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $1eff655f63a9bbd9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $f23682b0b5b2d802$export$2e2bcd8739ae039)(date).getTime() === (0, $1da06aa14904949d$export$2e2bcd8739ae039)(date).getTime();
}


function $f26794150f1b1a6c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $0c02c7faee7ab2f0$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $1eff655f63a9bbd9$export$2e2bcd8739ae039)((0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}





function $cf34d7234eab092f$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $c03b34c4f5393ff7$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $40cb9277785070a4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}


var $9d3b8f1bbb60dc8e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $9d3b8f1bbb60dc8e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9d3b8f1bbb60dc8e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039 = $9d3b8f1bbb60dc8e$var$formatDistance;


function $772b9d5c5acb67c6$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $adadf9b5f344c056$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $adadf9b5f344c056$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $adadf9b5f344c056$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $adadf9b5f344c056$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $adadf9b5f344c056$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $adadf9b5f344c056$export$2e2bcd8739ae039 = $adadf9b5f344c056$var$formatLong;


var $27b07b6969b3b18a$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $27b07b6969b3b18a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $27b07b6969b3b18a$var$formatRelativeLocale[token];
};
var $27b07b6969b3b18a$export$2e2bcd8739ae039 = $27b07b6969b3b18a$var$formatRelative;


function $2ca886d2c8d77e4d$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $17da716efdeaa8e3$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $17da716efdeaa8e3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $17da716efdeaa8e3$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $17da716efdeaa8e3$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $17da716efdeaa8e3$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $17da716efdeaa8e3$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $17da716efdeaa8e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $17da716efdeaa8e3$var$localize = {
    ordinalNumber: $17da716efdeaa8e3$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $17da716efdeaa8e3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $17da716efdeaa8e3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $17da716efdeaa8e3$export$2e2bcd8739ae039 = $17da716efdeaa8e3$var$localize;


function $d8d845ab692d6dea$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $d8d845ab692d6dea$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $d8d845ab692d6dea$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $d8d845ab692d6dea$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $d8d845ab692d6dea$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $85cdfad058df8fd3$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $a0618466070b1817$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $a0618466070b1817$var$parseOrdinalNumberPattern = /\d+/i;
var $a0618466070b1817$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $a0618466070b1817$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $a0618466070b1817$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $a0618466070b1817$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a0618466070b1817$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $a0618466070b1817$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a0618466070b1817$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $a0618466070b1817$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $a0618466070b1817$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $a0618466070b1817$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $a0618466070b1817$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a0618466070b1817$var$matchOrdinalNumberPattern,
        parsePattern: $a0618466070b1817$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a0618466070b1817$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a0618466070b1817$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a0618466070b1817$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a0618466070b1817$export$2e2bcd8739ae039 = $a0618466070b1817$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b4f914fe53c31e55$var$locale = {
    code: "en-US",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $adadf9b5f344c056$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b4f914fe53c31e55$export$2e2bcd8739ae039 = $b4f914fe53c31e55$var$locale;


var $118b19c6d90f072d$export$2e2bcd8739ae039 = (0, $b4f914fe53c31e55$export$2e2bcd8739ae039);



function $c58087165184dc10$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $2af75fecfbb4da0a$export$2e2bcd8739ae039(object) {
    return (0, $c58087165184dc10$export$2e2bcd8739ae039)({}, object);
}





var $671507671fa5a6e8$var$MINUTES_IN_DAY = 1440;
var $671507671fa5a6e8$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $671507671fa5a6e8$var$MINUTES_IN_MONTH = 43200;
var $671507671fa5a6e8$var$MINUTES_IN_TWO_MONTHS = 86400;
function $671507671fa5a6e8$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $118b19c6d90f072d$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, $f319ee1b0fdb288a$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $c58087165184dc10$export$2e2bcd8739ae039)((0, $2af75fecfbb4da0a$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $cf34d7234eab092f$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $34df346d5c5052d9$export$2e2bcd8739ae039)(dateRight) - (0, $34df346d5c5052d9$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $671507671fa5a6e8$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $f26794150f1b1a6c$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $671507671fa5a6e8$var$MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}


var $cd9834982deadcf1$exports = {};

var $6qd2L = parcelRequire("6qd2L");


/**
 * [js-md5]{@link https://github.com/emn178/js-md5}
 *
 * @namespace md5
 * @version 0.8.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_MD5_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_MD5_NO_NODE_JS && typeof $6qd2L === "object" && $6qd2L.versions && $6qd2L.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && true && $cd9834982deadcf1$exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        128,
        32768,
        8388608,
        -2147483648
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "buffer",
        "arrayBuffer",
        "base64"
    ];
    var BASE64_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
    var blocks = [], buffer8;
    if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        buffer8 = new Uint8Array(buffer);
        blocks = new Uint32Array(buffer);
    }
    var isArray = Array.isArray;
    if (root.JS_MD5_NO_NODE_JS || !isArray) isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var isView = ArrayBuffer.isView;
    if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !isView)) isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    // [message: string, isString: bool]
    var formatMessage = function(message) {
        var type = typeof message;
        if (type === "string") return [
            message,
            true
        ];
        if (type !== "object" || message === null) throw new Error(INPUT_ERROR);
        if (ARRAY_BUFFER && message.constructor === ArrayBuffer) return [
            new Uint8Array(message),
            false
        ];
        if (!isArray(message) && !isView(message)) throw new Error(INPUT_ERROR);
        return [
            message,
            false
        ];
    };
    /**
   * @method hex
   * @memberof md5
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hex('The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method digest
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.digest('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method array
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.array('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method arrayBuffer
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.buffer('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method base64
   * @memberof md5
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.base64('The quick brown fox jumps over the lazy dog');
   */ var createOutputMethod = function(outputType) {
        return function(message) {
            return new Md5(true).update(message)[outputType]();
        };
    };
    /**
   * @method create
   * @memberof md5
   * @description Create Md5 object
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.create();
   */ /**
   * @method update
   * @memberof md5
   * @description Create and update Md5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.update('The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.create();
   * hash.update('The quick brown fox jumps over the lazy dog');
   */ var createMethod = function() {
        var method = createOutputMethod("hex");
        if (NODE_JS) method = nodeWrap(method);
        method.create = function() {
            return new Md5();
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type);
        }
        return method;
    };
    var nodeWrap = function(method) {
        var crypto = (parcelRequire("1wVs5"));
        var Buffer = (parcelRequire("1wVs5")).Buffer;
        var bufferFrom;
        if (Buffer.from && !root.JS_MD5_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === "string") return crypto.createHash("md5").update(message, "utf8").digest("hex");
            else {
                if (message === null || message === undefined) throw new Error(INPUT_ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (isArray(message) || isView(message) || message.constructor === Buffer) return crypto.createHash("md5").update(bufferFrom(message)).digest("hex");
            else return method(message);
        };
        return nodeMethod;
    };
    /**
   * @namespace md5.hmac
   */ /**
   * @method hex
   * @memberof md5.hmac
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hmac.hex('key', 'The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5.hmac('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method digest
   * @memberof md5.hmac
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.hmac.digest('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method array
   * @memberof md5.hmac
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.hmac.array('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method arrayBuffer
   * @memberof md5.hmac
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.hmac.arrayBuffer('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5.hmac
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.hmac.buffer('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method base64
   * @memberof md5.hmac
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.hmac.base64('key', 'The quick brown fox jumps over the lazy dog');
   */ var createHmacOutputMethod = function(outputType) {
        return function(key, message) {
            return new HmacMd5(key, true).update(message)[outputType]();
        };
    };
    /**
   * @method create
   * @memberof md5.hmac
   * @description Create HmacMd5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @returns {HmacMd5} HmacMd5 object.
   * @example
   * var hash = md5.hmac.create('key');
   */ /**
   * @method update
   * @memberof md5.hmac
   * @description Create and update HmacMd5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {HmacMd5} HmacMd5 object.
   * @example
   * var hash = md5.hmac.update('key', 'The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.hmac.create('key');
   * hash.update('The quick brown fox jumps over the lazy dog');
   */ var createHmacMethod = function() {
        var method = createHmacOutputMethod("hex");
        method.create = function(key) {
            return new HmacMd5(key);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type);
        }
        return method;
    };
    /**
   * Md5 class
   * @class Md5
   * @description This is internal class.
   * @see {@link md5.create}
   */ function Md5(sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
            this.buffer8 = buffer8;
        } else if (ARRAY_BUFFER) {
            var buffer = new ArrayBuffer(68);
            this.buffer8 = new Uint8Array(buffer);
            this.blocks = new Uint32Array(buffer);
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
    }
    /**
   * @method update
   * @memberof Md5
   * @instance
   * @description Update hash
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @see {@link md5.update}
   */ Md5.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var result = formatMessage(message);
        message = result[0];
        var isString = result[1];
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        var buffer8 = this.buffer8;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = blocks[16];
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (isString) {
                if (ARRAY_BUFFER) for(i = this.start; index < length && i < 64; ++index){
                    code = message.charCodeAt(index);
                    if (code < 0x80) buffer8[i++] = code;
                    else if (code < 0x800) {
                        buffer8[i++] = 0xc0 | code >>> 6;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    } else if (code < 0xd800 || code >= 0xe000) {
                        buffer8[i++] = 0xe0 | code >>> 12;
                        buffer8[i++] = 0x80 | code >>> 6 & 0x3f;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                        buffer8[i++] = 0xf0 | code >>> 18;
                        buffer8[i++] = 0x80 | code >>> 12 & 0x3f;
                        buffer8[i++] = 0x80 | code >>> 6 & 0x3f;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    }
                }
                else for(i = this.start; index < length && i < 64; ++index){
                    code = message.charCodeAt(index);
                    if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                    else if (code < 0x800) {
                        blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else if (code < 0xd800 || code >= 0xe000) {
                        blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                        blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    }
                }
            } else {
                if (ARRAY_BUFFER) for(i = this.start; index < length && i < 64; ++index)buffer8[i++] = message[index];
                else for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Md5.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[i >>> 2] |= EXTRA[i & 3];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = blocks[16];
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.bytes << 3;
        blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
        this.hash();
    };
    Md5.prototype.hash = function() {
        var a, b, c, d, bc, da, blocks = this.blocks;
        if (this.first) {
            a = blocks[0] - 680876937;
            a = (a << 7 | a >>> 25) - 271733879 << 0;
            d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
            d = (d << 12 | d >>> 20) + a << 0;
            c = (-271733879 ^ d & (a ^ -271733879)) + blocks[2] - 1126478375;
            c = (c << 17 | c >>> 15) + d << 0;
            b = (a ^ c & (d ^ a)) + blocks[3] - 1316259209;
            b = (b << 22 | b >>> 10) + c << 0;
        } else {
            a = this.h0;
            b = this.h1;
            c = this.h2;
            d = this.h3;
            a += (d ^ b & (c ^ d)) + blocks[0] - 680876936;
            a = (a << 7 | a >>> 25) + b << 0;
            d += (c ^ a & (b ^ c)) + blocks[1] - 389564586;
            d = (d << 12 | d >>> 20) + a << 0;
            c += (b ^ d & (a ^ b)) + blocks[2] + 606105819;
            c = (c << 17 | c >>> 15) + d << 0;
            b += (a ^ c & (d ^ a)) + blocks[3] - 1044525330;
            b = (b << 22 | b >>> 10) + c << 0;
        }
        a += (d ^ b & (c ^ d)) + blocks[4] - 176418897;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[5] + 1200080426;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[6] - 1473231341;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[7] - 45705983;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[8] + 1770035416;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[9] - 1958414417;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[10] - 42063;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[11] - 1990404162;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[12] + 1804603682;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[13] - 40341101;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[14] - 1502002290;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[15] + 1236535329;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[1] - 165796510;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[6] - 1069501632;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[11] + 643717713;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[0] - 373897302;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[5] - 701558691;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[10] + 38016083;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[15] - 660478335;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[4] - 405537848;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[9] + 568446438;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[14] - 1019803690;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[3] - 187363961;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[8] + 1163531501;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[13] - 1444681467;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[2] - 51403784;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[7] + 1735328473;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[12] - 1926607734;
        b = (b << 20 | b >>> 12) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[5] - 378558;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[8] - 2022574463;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[11] + 1839030562;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[14] - 35309556;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[1] - 1530992060;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[4] + 1272893353;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[7] - 155497632;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[10] - 1094730640;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[13] + 681279174;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[0] - 358537222;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[3] - 722521979;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[6] + 76029189;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[9] - 640364487;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[12] - 421815835;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[15] + 530742520;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[2] - 995338651;
        b = (b << 23 | b >>> 9) + c << 0;
        a += (c ^ (b | ~d)) + blocks[0] - 198630844;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[5] - 57434055;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[10] - 1051523;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[15] - 30611744;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[4] - 145523070;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[2] + 718787259;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[9] - 343485551;
        b = (b << 21 | b >>> 11) + c << 0;
        if (this.first) {
            this.h0 = a + 1732584193 << 0;
            this.h1 = b - 271733879 << 0;
            this.h2 = c - 1732584194 << 0;
            this.h3 = d + 271733878 << 0;
            this.first = false;
        } else {
            this.h0 = this.h0 + a << 0;
            this.h1 = this.h1 + b << 0;
            this.h2 = this.h2 + c << 0;
            this.h3 = this.h3 + d << 0;
        }
    };
    /**
   * @method hex
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.hex();
   */ Md5.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
        return HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F];
    };
    /**
   * @method toString
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.toString();
   */ Md5.prototype.toString = Md5.prototype.hex;
    /**
   * @method digest
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.digest}
   * @example
   * hash.digest();
   */ Md5.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
        return [
            h0 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 24 & 0xFF,
            h1 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 24 & 0xFF,
            h2 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 24 & 0xFF,
            h3 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 24 & 0xFF
        ];
    };
    /**
   * @method array
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.array}
   * @example
   * hash.array();
   */ Md5.prototype.array = Md5.prototype.digest;
    /**
   * @method arrayBuffer
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.arrayBuffer}
   * @example
   * hash.arrayBuffer();
   */ Md5.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(16);
        var blocks = new Uint32Array(buffer);
        blocks[0] = this.h0;
        blocks[1] = this.h1;
        blocks[2] = this.h2;
        blocks[3] = this.h3;
        return buffer;
    };
    /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.buffer}
   * @example
   * hash.buffer();
   */ Md5.prototype.buffer = Md5.prototype.arrayBuffer;
    /**
   * @method base64
   * @memberof Md5
   * @instance
   * @description Output hash as base64 string
   * @returns {String} base64 string
   * @see {@link md5.base64}
   * @example
   * hash.base64();
   */ Md5.prototype.base64 = function() {
        var v1, v2, v3, base64Str = "", bytes = this.array();
        for(var i = 0; i < 15;){
            v1 = bytes[i++];
            v2 = bytes[i++];
            v3 = bytes[i++];
            base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] + BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] + BASE64_ENCODE_CHAR[v3 & 63];
        }
        v1 = bytes[i];
        base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[v1 << 4 & 63] + "==";
        return base64Str;
    };
    /**
   * HmacMd5 class
   * @class HmacMd5
   * @extends Md5
   * @description This is internal class.
   * @see {@link md5.hmac.create}
   */ function HmacMd5(key, sharedMemory) {
        var i, result = formatMessage(key);
        key = result[0];
        if (result[1]) {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        }
        if (key.length > 64) key = new Md5(true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Md5.call(this, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacMd5.prototype = new Md5();
    HmacMd5.prototype.finalize = function() {
        Md5.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Md5.call(this, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Md5.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.md5 = exports;
    exports.md5.hmac = createHmacMethod();
    if (COMMON_JS) $cd9834982deadcf1$exports = exports;
    else {
        /**
     * @method md5
     * @description Md5 hash function, export to global in browsers.
     * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
     * @returns {String} md5 hashes
     * @example
     * md5(''); // d41d8cd98f00b204e9800998ecf8427e
     * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
     * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
     *
     * // It also supports UTF-8 encoding
     * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
     *
     * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
     * md5([]); // d41d8cd98f00b204e9800998ecf8427e
     * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
     */ root.md5 = exports;
        if (AMD) define(function() {
            return exports;
        });
    }
})();


var $81b906d4525c15ad$exports = {};

$parcel$export($81b906d4525c15ad$exports, "af", function () { return $43873d8e2112eec0$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ar", function () { return $c6a8c29cfc608398$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "arDZ", function () { return $c11c8b0f53e07f55$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "arEG", function () { return $fe403146efe3253a$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "arMA", function () { return $2196da9246dfc0dd$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "arSA", function () { return $661186325c8a8fd3$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "arTN", function () { return $5f689f20688937d2$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "az", function () { return $a45fe4d02cfa2cdb$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "be", function () { return $5e25a6695ec5ca45$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "beTarask", function () { return $5693041554d6599b$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "bg", function () { return $205654a4bdf8c548$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "bn", function () { return $b17b6c6f54b3410a$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "bs", function () { return $1bde6a6ee1d2cdc1$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ca", function () { return $a7e8afa2a884d090$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "cs", function () { return $38d5e154b7f2a6d4$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "cy", function () { return $800e113b5ad007d2$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "da", function () { return $37c91a473daced7f$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "de", function () { return $4a17e98ef64bb836$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "deAT", function () { return $317296a78ab9da30$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "el", function () { return $af9e25ef3d614e9d$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enAU", function () { return $c70e3f792f208dc6$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enCA", function () { return $efa65e52e686f1d7$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enGB", function () { return $83d9f6561f3e62c7$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enIE", function () { return $36c701d9fd969ae7$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enIN", function () { return $007e3ef601dc9291$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enNZ", function () { return $9e0c30d91b255dbf$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enUS", function () { return $b4f914fe53c31e55$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "enZA", function () { return $7af1ee3fc77667d2$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "eo", function () { return $1e6efb3215d44680$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "es", function () { return $5a245ea4459980b9$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "et", function () { return $913d48e43cc3d5ab$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "eu", function () { return $ad33979d2f6c8b52$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "faIR", function () { return $2373930e51969456$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "fi", function () { return $d271f2b00a2f1f84$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "fr", function () { return $30fd3bfe9e985633$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "frCA", function () { return $e6a36a0d68e9e2cd$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "frCH", function () { return $23391c162eceb983$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "fy", function () { return $dbca903092ce136e$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "gd", function () { return $388b1cd55881ad60$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "gl", function () { return $ce986bb5d94e5e7f$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "gu", function () { return $4dadab21df4729d0$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "he", function () { return $8bf7aa47470d15dc$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "hi", function () { return $75288b88e219c44d$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "hr", function () { return $e9ec61468eea6ed2$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ht", function () { return $9b1ebd2a57ebed66$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "hu", function () { return $7e0005519f36d882$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "hy", function () { return $016ab76aed515db7$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "id", function () { return $835119ee92742082$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "is", function () { return $09327723e077c271$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "it", function () { return $04337a305d386c62$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "itCH", function () { return $012ad164b7d0c867$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ja", function () { return $9ac7f69fbde9c7b1$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "jaHira", function () { return $3cc349efc9715d82$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ka", function () { return $b0030840b48521e0$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "kk", function () { return $6bd584f076ef4669$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "km", function () { return $a8289b4553e746e5$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "kn", function () { return $f9d81869d00cc31e$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ko", function () { return $2475feb152231d86$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "lb", function () { return $6e9ced47150432d9$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "lt", function () { return $5ade964a3d27137e$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "lv", function () { return $2cf9697567fc0736$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "mk", function () { return $495ddbe8bb3f8994$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "mn", function () { return $bc2f4b050d639119$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ms", function () { return $36aa0286c4020e90$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "mt", function () { return $ec5c7302abffe2df$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "nb", function () { return $bef79d848faf588a$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "nl", function () { return $0db204b582725790$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "nlBE", function () { return $396c7e5bfb78e458$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "nn", function () { return $0317191b79441e45$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "oc", function () { return $a967f19e9b927cc9$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "pl", function () { return $b7175c8100508d67$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "pt", function () { return $7cf2a5e83f77d5ea$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ptBR", function () { return $22c49fd2559c5058$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ro", function () { return $8bd70ba50433c355$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ru", function () { return $7f8fd36f2ae8dc9d$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "sk", function () { return $884a7dc31f124290$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "sl", function () { return $b6ef1862d3720b9f$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "sq", function () { return $31611afb540af3cc$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "sr", function () { return $90ff0240df1c0b0c$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "srLatn", function () { return $e2c78867160f7887$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "sv", function () { return $4a2c237fdb92252c$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ta", function () { return $13dc2957a9be2343$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "te", function () { return $e6c1073ec9e8542a$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "th", function () { return $8606191b94fc0138$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "tr", function () { return $5bb41a550539b55b$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "ug", function () { return $f540bb5d26e36a20$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "uk", function () { return $1e75cbfc6a899177$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "uz", function () { return $c1176042d276b112$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "uzCyrl", function () { return $1475c7d72c7ae0f0$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "vi", function () { return $17d82b633a01358b$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "zhCN", function () { return $9ee9f757c51e022b$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "zhHK", function () { return $900dea089dd32305$export$2e2bcd8739ae039; });
$parcel$export($81b906d4525c15ad$exports, "zhTW", function () { return $59fbfcc273919242$export$2e2bcd8739ae039; });
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var $5a9d64fbb59912a7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: "minder as {{count}} sekondes"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekondes"
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: "minder as {{count}} minute"
    },
    xMinutes: {
        one: "'n minuut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} ure"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} ure"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dae"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weke"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weke"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maande"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maande"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer as 1 jaar",
        other: "meer as {{count}} jaar"
    },
    almostXYears: {
        one: "byna 1 jaar",
        other: "byna {{count}} jaar"
    }
};
var $5a9d64fbb59912a7$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5a9d64fbb59912a7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oor " + result;
        else return result + " gelede";
    }
    return result;
};
var $5a9d64fbb59912a7$export$2e2bcd8739ae039 = $5a9d64fbb59912a7$var$formatDistance;



var $30664c16f78c2e88$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "yyyy/MM/dd"
};
var $30664c16f78c2e88$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $30664c16f78c2e88$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $30664c16f78c2e88$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $30664c16f78c2e88$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $30664c16f78c2e88$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $30664c16f78c2e88$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $30664c16f78c2e88$export$2e2bcd8739ae039 = $30664c16f78c2e88$var$formatLong;


var $b8ca719ae156bb55$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $b8ca719ae156bb55$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b8ca719ae156bb55$var$formatRelativeLocale[token];
};
var $b8ca719ae156bb55$export$2e2bcd8739ae039 = $b8ca719ae156bb55$var$formatRelative;



var $24f3e3364597b303$var$eraValues = {
    narrow: [
        "vC",
        "nC"
    ],
    abbreviated: [
        "vC",
        "nC"
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
var $24f3e3364597b303$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ste kwartaal",
        "2de kwartaal",
        "3de kwartaal",
        "4de kwartaal"
    ]
};
var $24f3e3364597b303$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januarie",
        "Februarie",
        "Maart",
        "April",
        "Mei",
        "Junie",
        "Julie",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
var $24f3e3364597b303$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "W",
        "D",
        "V",
        "S"
    ],
    short: [
        "So",
        "Ma",
        "Di",
        "Wo",
        "Do",
        "Vr",
        "Sa"
    ],
    abbreviated: [
        "Son",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vry",
        "Sat"
    ],
    wide: [
        "Sondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrydag",
        "Saterdag"
    ]
};
var $24f3e3364597b303$var$dayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    }
};
var $24f3e3364597b303$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    }
};
var $24f3e3364597b303$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + "ste";
        default:
            return number + "de";
    }
    return number + "ste";
};
var $24f3e3364597b303$var$localize = {
    ordinalNumber: $24f3e3364597b303$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $24f3e3364597b303$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $24f3e3364597b303$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $24f3e3364597b303$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $24f3e3364597b303$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $24f3e3364597b303$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $24f3e3364597b303$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $24f3e3364597b303$export$2e2bcd8739ae039 = $24f3e3364597b303$var$localize;




var $a8433f7efbf6a507$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var $a8433f7efbf6a507$var$parseOrdinalNumberPattern = /\d+/i;
var $a8433f7efbf6a507$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var $a8433f7efbf6a507$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $a8433f7efbf6a507$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var $a8433f7efbf6a507$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a8433f7efbf6a507$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var $a8433f7efbf6a507$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var $a8433f7efbf6a507$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var $a8433f7efbf6a507$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var $a8433f7efbf6a507$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var $a8433f7efbf6a507$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var $a8433f7efbf6a507$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a8433f7efbf6a507$var$matchOrdinalNumberPattern,
        parsePattern: $a8433f7efbf6a507$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a8433f7efbf6a507$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a8433f7efbf6a507$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a8433f7efbf6a507$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a8433f7efbf6a507$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a8433f7efbf6a507$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a8433f7efbf6a507$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a8433f7efbf6a507$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a8433f7efbf6a507$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a8433f7efbf6a507$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a8433f7efbf6a507$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a8433f7efbf6a507$export$2e2bcd8739ae039 = $a8433f7efbf6a507$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var $43873d8e2112eec0$var$locale = {
    code: "af",
    formatDistance: (0, $5a9d64fbb59912a7$export$2e2bcd8739ae039),
    formatLong: (0, $30664c16f78c2e88$export$2e2bcd8739ae039),
    formatRelative: (0, $b8ca719ae156bb55$export$2e2bcd8739ae039),
    localize: (0, $24f3e3364597b303$export$2e2bcd8739ae039),
    match: (0, $a8433f7efbf6a507$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $43873d8e2112eec0$export$2e2bcd8739ae039 = $43873d8e2112eec0$var$locale;


var $2db967ee5b76a08f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "أقل من ثانية",
        two: "أقل من ثانيتين",
        threeToTen: "أقل من {{count}} ثواني",
        other: "أقل من {{count}} ثانية"
    },
    xSeconds: {
        one: "ثانية واحدة",
        two: "ثانيتان",
        threeToTen: "{{count}} ثواني",
        other: "{{count}} ثانية"
    },
    halfAMinute: "نصف دقيقة",
    lessThanXMinutes: {
        one: "أقل من دقيقة",
        two: "أقل من دقيقتين",
        threeToTen: "أقل من {{count}} دقائق",
        other: "أقل من {{count}} دقيقة"
    },
    xMinutes: {
        one: "دقيقة واحدة",
        two: "دقيقتان",
        threeToTen: "{{count}} دقائق",
        other: "{{count}} دقيقة"
    },
    aboutXHours: {
        one: "ساعة واحدة تقريباً",
        two: "ساعتين تقريبا",
        threeToTen: "{{count}} ساعات تقريباً",
        other: "{{count}} ساعة تقريباً"
    },
    xHours: {
        one: "ساعة واحدة",
        two: "ساعتان",
        threeToTen: "{{count}} ساعات",
        other: "{{count}} ساعة"
    },
    xDays: {
        one: "يوم واحد",
        two: "يومان",
        threeToTen: "{{count}} أيام",
        other: "{{count}} يوم"
    },
    aboutXWeeks: {
        one: "أسبوع واحد تقريبا",
        two: "أسبوعين تقريبا",
        threeToTen: "{{count}} أسابيع تقريبا",
        other: "{{count}} أسبوعا تقريبا"
    },
    xWeeks: {
        one: "أسبوع واحد",
        two: "أسبوعان",
        threeToTen: "{{count}} أسابيع",
        other: "{{count}} أسبوعا"
    },
    aboutXMonths: {
        one: "شهر واحد تقريباً",
        two: "شهرين تقريبا",
        threeToTen: "{{count}} أشهر تقريبا",
        other: "{{count}} شهرا تقريباً"
    },
    xMonths: {
        one: "شهر واحد",
        two: "شهران",
        threeToTen: "{{count}} أشهر",
        other: "{{count}} شهرا"
    },
    aboutXYears: {
        one: "سنة واحدة تقريباً",
        two: "سنتين تقريبا",
        threeToTen: "{{count}} سنوات تقريباً",
        other: "{{count}} سنة تقريباً"
    },
    xYears: {
        one: "سنة واحد",
        two: "سنتان",
        threeToTen: "{{count}} سنوات",
        other: "{{count}} سنة"
    },
    overXYears: {
        one: "أكثر من سنة",
        two: "أكثر من سنتين",
        threeToTen: "أكثر من {{count}} سنوات",
        other: "أكثر من {{count}} سنة"
    },
    almostXYears: {
        one: "ما يقارب سنة واحدة",
        two: "ما يقارب سنتين",
        threeToTen: "ما يقارب {{count}} سنوات",
        other: "ما يقارب {{count}} سنة"
    }
};
var $2db967ee5b76a08f$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $2db967ee5b76a08f$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "خلال " + result;
        else return "منذ " + result;
    }
    return result;
};
var $2db967ee5b76a08f$export$2e2bcd8739ae039 = $2db967ee5b76a08f$var$formatDistance;



var $eb15dc2accf3e04c$var$dateFormats = {
    full: "EEEE، do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $eb15dc2accf3e04c$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $eb15dc2accf3e04c$var$dateTimeFormats = {
    full: "{{date}} 'عند الساعة' {{time}}",
    long: "{{date}} 'عند الساعة' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $eb15dc2accf3e04c$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $eb15dc2accf3e04c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $eb15dc2accf3e04c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $eb15dc2accf3e04c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $eb15dc2accf3e04c$export$2e2bcd8739ae039 = $eb15dc2accf3e04c$var$formatLong;


var $61ed8dc25057edae$var$formatRelativeLocale = {
    lastWeek: "eeee 'الماضي عند الساعة' p",
    yesterday: "'الأمس عند الساعة' p",
    today: "'اليوم عند الساعة' p",
    tomorrow: "'غدا عند الساعة' p",
    nextWeek: "eeee 'القادم عند الساعة' p",
    other: "P"
};
var $61ed8dc25057edae$var$formatRelative = function formatRelative(token) {
    return $61ed8dc25057edae$var$formatRelativeLocale[token];
};
var $61ed8dc25057edae$export$2e2bcd8739ae039 = $61ed8dc25057edae$var$formatRelative;



var $54948c71ebc82b9e$var$eraValues = {
    narrow: [
        "ق",
        "ب"
    ],
    abbreviated: [
        "ق.م.",
        "ب.م."
    ],
    wide: [
        "قبل الميلاد",
        "بعد الميلاد"
    ]
};
var $54948c71ebc82b9e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ر1",
        "ر2",
        "ر3",
        "ر4"
    ],
    wide: [
        "الربع الأول",
        "الربع الثاني",
        "الربع الثالث",
        "الربع الرابع"
    ]
};
var $54948c71ebc82b9e$var$monthValues = {
    narrow: [
        "ي",
        "ف",
        "م",
        "أ",
        "م",
        "ي",
        "ي",
        "أ",
        "س",
        "أ",
        "ن",
        "د"
    ],
    abbreviated: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
    ],
    wide: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
    ]
};
var $54948c71ebc82b9e$var$dayValues = {
    narrow: [
        "ح",
        "ن",
        "ث",
        "ر",
        "خ",
        "ج",
        "س"
    ],
    short: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    abbreviated: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    wide: [
        "الأحد",
        "الاثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت"
    ]
};
var $54948c71ebc82b9e$var$dayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        morning: "الصباح",
        noon: "الظهر",
        afternoon: "بعد الظهر",
        evening: "المساء",
        night: "الليل",
        midnight: "منتصف الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        morning: "الصباح",
        noon: "الظهر",
        afternoon: "بعد الظهر",
        evening: "المساء",
        night: "الليل",
        midnight: "منتصف الليل"
    },
    wide: {
        am: "ص",
        pm: "م",
        morning: "الصباح",
        noon: "الظهر",
        afternoon: "بعد الظهر",
        evening: "المساء",
        night: "الليل",
        midnight: "منتصف الليل"
    }
};
var $54948c71ebc82b9e$var$formattingDayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        morning: "في الصباح",
        noon: "الظهر",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل",
        midnight: "منتصف الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        morning: "في الصباح",
        noon: "الظهر",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل",
        midnight: "منتصف الليل"
    },
    wide: {
        am: "ص",
        pm: "م",
        morning: "في الصباح",
        noon: "الظهر",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل",
        midnight: "منتصف الليل"
    }
};
var $54948c71ebc82b9e$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $54948c71ebc82b9e$var$localize = {
    ordinalNumber: $54948c71ebc82b9e$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $54948c71ebc82b9e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $54948c71ebc82b9e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $54948c71ebc82b9e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $54948c71ebc82b9e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $54948c71ebc82b9e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $54948c71ebc82b9e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $54948c71ebc82b9e$export$2e2bcd8739ae039 = $54948c71ebc82b9e$var$localize;




var $3843fbfe7ff4fff5$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $3843fbfe7ff4fff5$var$parseOrdinalNumberPattern = /\d+/i;
var $3843fbfe7ff4fff5$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $3843fbfe7ff4fff5$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $3843fbfe7ff4fff5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $3843fbfe7ff4fff5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3843fbfe7ff4fff5$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $3843fbfe7ff4fff5$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $3843fbfe7ff4fff5$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $3843fbfe7ff4fff5$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $3843fbfe7ff4fff5$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var $3843fbfe7ff4fff5$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var $3843fbfe7ff4fff5$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $3843fbfe7ff4fff5$var$matchOrdinalNumberPattern,
        parsePattern: $3843fbfe7ff4fff5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3843fbfe7ff4fff5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3843fbfe7ff4fff5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3843fbfe7ff4fff5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3843fbfe7ff4fff5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3843fbfe7ff4fff5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3843fbfe7ff4fff5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3843fbfe7ff4fff5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3843fbfe7ff4fff5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3843fbfe7ff4fff5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3843fbfe7ff4fff5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $3843fbfe7ff4fff5$export$2e2bcd8739ae039 = $3843fbfe7ff4fff5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $c6a8c29cfc608398$var$locale = {
    code: "ar",
    formatDistance: (0, $2db967ee5b76a08f$export$2e2bcd8739ae039),
    formatLong: (0, $eb15dc2accf3e04c$export$2e2bcd8739ae039),
    formatRelative: (0, $61ed8dc25057edae$export$2e2bcd8739ae039),
    localize: (0, $54948c71ebc82b9e$export$2e2bcd8739ae039),
    match: (0, $3843fbfe7ff4fff5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $c6a8c29cfc608398$export$2e2bcd8739ae039 = $c6a8c29cfc608398$var$locale;


var $4ec087d22b279eaa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "أقل من ثانية واحدة",
        two: "أقل من ثانتين",
        threeToTen: "أقل من {{count}} ثواني",
        other: "أقل من {{count}} ثانية"
    },
    xSeconds: {
        one: "ثانية واحدة",
        two: "ثانتين",
        threeToTen: "{{count}} ثواني",
        other: "{{count}} ثانية"
    },
    halfAMinute: "نصف دقيقة",
    lessThanXMinutes: {
        one: "أقل من دقيقة",
        two: "أقل من دقيقتين",
        threeToTen: "أقل من {{count}} دقائق",
        other: "أقل من {{count}} دقيقة"
    },
    xMinutes: {
        one: "دقيقة واحدة",
        two: "دقيقتين",
        threeToTen: "{{count}} دقائق",
        other: "{{count}} دقيقة"
    },
    aboutXHours: {
        one: "ساعة واحدة تقريباً",
        two: "ساعتين تقريباً",
        threeToTen: "{{count}} ساعات تقريباً",
        other: "{{count}} ساعة تقريباً"
    },
    xHours: {
        one: "ساعة واحدة",
        two: "ساعتين",
        threeToTen: "{{count}} ساعات",
        other: "{{count}} ساعة"
    },
    xDays: {
        one: "يوم واحد",
        two: "يومين",
        threeToTen: "{{count}} أيام",
        other: "{{count}} يوم"
    },
    aboutXWeeks: {
        one: "أسبوع واحد تقريباً",
        two: "أسبوعين تقريباً",
        threeToTen: "{{count}} أسابيع تقريباً",
        other: "{{count}} أسبوع تقريباً"
    },
    xWeeks: {
        one: "أسبوع واحد",
        two: "أسبوعين",
        threeToTen: "{{count}} أسابيع",
        other: "{{count}} أسبوع"
    },
    aboutXMonths: {
        one: "شهر واحد تقريباً",
        two: "شهرين تقريباً",
        threeToTen: "{{count}} أشهر تقريباً",
        other: "{{count}} شهر تقريباً"
    },
    xMonths: {
        one: "شهر واحد",
        two: "شهرين",
        threeToTen: "{{count}} أشهر",
        other: "{{count}} شهر"
    },
    aboutXYears: {
        one: "عام واحد تقريباً",
        two: "عامين تقريباً",
        threeToTen: "{{count}} أعوام تقريباً",
        other: "{{count}} عام تقريباً"
    },
    xYears: {
        one: "عام واحد",
        two: "عامين",
        threeToTen: "{{count}} أعوام",
        other: "{{count}} عام"
    },
    overXYears: {
        one: "أكثر من عام",
        two: "أكثر من عامين",
        threeToTen: "أكثر من {{count}} أعوام",
        other: "أكثر من {{count}} عام"
    },
    almostXYears: {
        one: "عام واحد تقريباً",
        two: "عامين تقريباً",
        threeToTen: "{{count}} أعوام تقريباً",
        other: "{{count}} عام تقريباً"
    }
};
var $4ec087d22b279eaa$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $4ec087d22b279eaa$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "في خلال " + result;
        else return "منذ " + result;
    }
    return result;
};
var $4ec087d22b279eaa$export$2e2bcd8739ae039 = $4ec087d22b279eaa$var$formatDistance;



var $f0bf9b0152d28e9d$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $f0bf9b0152d28e9d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $f0bf9b0152d28e9d$var$dateTimeFormats = {
    full: "{{date}} 'عند' {{time}}",
    long: "{{date}} 'عند' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f0bf9b0152d28e9d$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f0bf9b0152d28e9d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f0bf9b0152d28e9d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f0bf9b0152d28e9d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f0bf9b0152d28e9d$export$2e2bcd8739ae039 = $f0bf9b0152d28e9d$var$formatLong;


var $40f643090c6eae07$var$formatRelativeLocale = {
    lastWeek: "'أخر' eeee 'عند' p",
    yesterday: "'أمس عند' p",
    today: "'اليوم عند' p",
    tomorrow: "'غداً عند' p",
    nextWeek: "eeee 'عند' p",
    other: "P"
};
var $40f643090c6eae07$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $40f643090c6eae07$var$formatRelativeLocale[token];
};
var $40f643090c6eae07$export$2e2bcd8739ae039 = $40f643090c6eae07$var$formatRelative;



var $47b433bdba751fdc$var$eraValues = {
    narrow: [
        "ق",
        "ب"
    ],
    abbreviated: [
        "ق.م.",
        "ب.م."
    ],
    wide: [
        "قبل الميلاد",
        "بعد الميلاد"
    ]
};
var $47b433bdba751fdc$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ر1",
        "ر2",
        "ر3",
        "ر4"
    ],
    wide: [
        "الربع الأول",
        "الربع الثاني",
        "الربع الثالث",
        "الربع الرابع"
    ]
};
var $47b433bdba751fdc$var$monthValues = {
    narrow: [
        "ج",
        "ف",
        "م",
        "أ",
        "م",
        "ج",
        "ج",
        "أ",
        "س",
        "أ",
        "ن",
        "د"
    ],
    abbreviated: [
        "جانـ",
        "فيفـ",
        "مارس",
        "أفريل",
        "مايـ",
        "جوانـ",
        "جويـ",
        "أوت",
        "سبتـ",
        "أكتـ",
        "نوفـ",
        "ديسـ"
    ],
    wide: [
        "جانفي",
        "فيفري",
        "مارس",
        "أفريل",
        "ماي",
        "جوان",
        "جويلية",
        "أوت",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
    ]
};
var $47b433bdba751fdc$var$dayValues = {
    narrow: [
        "ح",
        "ن",
        "ث",
        "ر",
        "خ",
        "ج",
        "س"
    ],
    short: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    abbreviated: [
        "أحد",
        "اثنـ",
        "ثلا",
        "أربـ",
        "خميـ",
        "جمعة",
        "سبت"
    ],
    wide: [
        "الأحد",
        "الاثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت"
    ]
};
var $47b433bdba751fdc$var$dayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    }
};
var $47b433bdba751fdc$var$formattingDayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "في الصباح",
        afternoon: "بعد الظـهر",
        evening: "في المساء",
        night: "في الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "في الصباح",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظـهر",
        evening: "في المساء",
        night: "في الليل"
    }
};
var $47b433bdba751fdc$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $47b433bdba751fdc$var$localize = {
    ordinalNumber: $47b433bdba751fdc$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $47b433bdba751fdc$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $47b433bdba751fdc$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $47b433bdba751fdc$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $47b433bdba751fdc$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $47b433bdba751fdc$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $47b433bdba751fdc$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $47b433bdba751fdc$export$2e2bcd8739ae039 = $47b433bdba751fdc$var$localize;




var $a14a5d3af74b0f66$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $a14a5d3af74b0f66$var$parseOrdinalNumberPattern = /\d+/i;
var $a14a5d3af74b0f66$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $a14a5d3af74b0f66$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $a14a5d3af74b0f66$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $a14a5d3af74b0f66$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a14a5d3af74b0f66$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $a14a5d3af74b0f66$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $a14a5d3af74b0f66$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $a14a5d3af74b0f66$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $a14a5d3af74b0f66$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $a14a5d3af74b0f66$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $a14a5d3af74b0f66$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a14a5d3af74b0f66$var$matchOrdinalNumberPattern,
        parsePattern: $a14a5d3af74b0f66$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a14a5d3af74b0f66$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a14a5d3af74b0f66$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a14a5d3af74b0f66$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a14a5d3af74b0f66$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a14a5d3af74b0f66$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a14a5d3af74b0f66$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a14a5d3af74b0f66$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a14a5d3af74b0f66$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a14a5d3af74b0f66$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a14a5d3af74b0f66$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a14a5d3af74b0f66$export$2e2bcd8739ae039 = $a14a5d3af74b0f66$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $c11c8b0f53e07f55$var$locale = {
    code: "ar-DZ",
    formatDistance: (0, $4ec087d22b279eaa$export$2e2bcd8739ae039),
    formatLong: (0, $f0bf9b0152d28e9d$export$2e2bcd8739ae039),
    formatRelative: (0, $40f643090c6eae07$export$2e2bcd8739ae039),
    localize: (0, $47b433bdba751fdc$export$2e2bcd8739ae039),
    match: (0, $a14a5d3af74b0f66$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $c11c8b0f53e07f55$export$2e2bcd8739ae039 = $c11c8b0f53e07f55$var$locale;


var $4f08ebc01fde8ba1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "أقل من ثانية",
        two: "أقل من ثانيتين",
        threeToTen: "أقل من {{count}} ثواني",
        other: "أقل من {{count}} ثانية"
    },
    xSeconds: {
        one: "ثانية",
        two: "ثانيتين",
        threeToTen: "{{count}} ثواني",
        other: "{{count}} ثانية"
    },
    halfAMinute: "نص دقيقة",
    lessThanXMinutes: {
        one: "أقل من دقيقة",
        two: "أقل من دقيقتين",
        threeToTen: "أقل من {{count}} دقايق",
        other: "أقل من {{count}} دقيقة"
    },
    xMinutes: {
        one: "دقيقة",
        two: "دقيقتين",
        threeToTen: "{{count}} دقايق",
        other: "{{count}} دقيقة"
    },
    aboutXHours: {
        one: "حوالي ساعة",
        two: "حوالي ساعتين",
        threeToTen: "حوالي {{count}} ساعات",
        other: "حوالي {{count}} ساعة"
    },
    xHours: {
        one: "ساعة",
        two: "ساعتين",
        threeToTen: "{{count}} ساعات",
        other: "{{count}} ساعة"
    },
    xDays: {
        one: "يوم",
        two: "يومين",
        threeToTen: "{{count}} أيام",
        other: "{{count}} يوم"
    },
    aboutXWeeks: {
        one: "حوالي أسبوع",
        two: "حوالي أسبوعين",
        threeToTen: "حوالي {{count}} أسابيع",
        other: "حوالي {{count}} أسبوع"
    },
    xWeeks: {
        one: "أسبوع",
        two: "أسبوعين",
        threeToTen: "{{count}} أسابيع",
        other: "{{count}} أسبوع"
    },
    aboutXMonths: {
        one: "حوالي شهر",
        two: "حوالي شهرين",
        threeToTen: "حوالي {{count}} أشهر",
        other: "حوالي {{count}} شهر"
    },
    xMonths: {
        one: "شهر",
        two: "شهرين",
        threeToTen: "{{count}} أشهر",
        other: "{{count}} شهر"
    },
    aboutXYears: {
        one: "حوالي سنة",
        two: "حوالي سنتين",
        threeToTen: "حوالي {{count}} سنين",
        other: "حوالي {{count}} سنة"
    },
    xYears: {
        one: "عام",
        two: "عامين",
        threeToTen: "{{count}} أعوام",
        other: "{{count}} عام"
    },
    overXYears: {
        one: "أكثر من سنة",
        two: "أكثر من سنتين",
        threeToTen: "أكثر من {{count}} سنين",
        other: "أكثر من {{count}} سنة"
    },
    almostXYears: {
        one: "عام تقريبًا",
        two: "عامين تقريبًا",
        threeToTen: "{{count}} أعوام تقريبًا",
        other: "{{count}} عام تقريبًا"
    }
};
var $4f08ebc01fde8ba1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4f08ebc01fde8ba1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "في خلال ".concat(result);
        else return "منذ ".concat(result);
    }
    return result;
};
var $4f08ebc01fde8ba1$export$2e2bcd8739ae039 = $4f08ebc01fde8ba1$var$formatDistance;



var $511aa9b7513b7ac8$var$dateFormats = {
    full: "EEEE، do MMMM y",
    long: "do MMMM y",
    medium: "dd/MMM/y",
    short: "d/MM/y"
};
var $511aa9b7513b7ac8$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $511aa9b7513b7ac8$var$dateTimeFormats = {
    full: "{{date}} 'الساعة' {{time}}",
    long: "{{date}} 'الساعة' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $511aa9b7513b7ac8$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $511aa9b7513b7ac8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $511aa9b7513b7ac8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $511aa9b7513b7ac8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $511aa9b7513b7ac8$export$2e2bcd8739ae039 = $511aa9b7513b7ac8$var$formatLong;


var $e3947944bb443277$var$formatRelativeLocale = {
    lastWeek: "eeee 'اللي جاي الساعة' p",
    yesterday: "'إمبارح الساعة' p",
    today: "'النهاردة الساعة' p",
    tomorrow: "'بكرة الساعة' p",
    nextWeek: "eeee 'الساعة' p",
    other: "P"
};
var $e3947944bb443277$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e3947944bb443277$var$formatRelativeLocale[token];
};
var $e3947944bb443277$export$2e2bcd8739ae039 = $e3947944bb443277$var$formatRelative;



var $cd0db3239b4ee5bf$var$eraValues = {
    narrow: [
        "ق",
        "ب"
    ],
    abbreviated: [
        "ق.م",
        "ب.م"
    ],
    wide: [
        "قبل الميلاد",
        "بعد الميلاد"
    ]
};
var $cd0db3239b4ee5bf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ر1",
        "ر2",
        "ر3",
        "ر4"
    ],
    wide: [
        "الربع الأول",
        "الربع الثاني",
        "الربع الثالث",
        "الربع الرابع"
    ]
};
var $cd0db3239b4ee5bf$var$monthValues = {
    narrow: [
        "ي",
        "ف",
        "م",
        "أ",
        "م",
        "ي",
        "ي",
        "أ",
        "س",
        "أ",
        "ن",
        "د"
    ],
    abbreviated: [
        "ينا",
        "فبر",
        "مارس",
        "أبريل",
        "مايو",
        "يونـ",
        "يولـ",
        "أغسـ",
        "سبتـ",
        "أكتـ",
        "نوفـ",
        "ديسـ"
    ],
    wide: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
    ]
};
var $cd0db3239b4ee5bf$var$dayValues = {
    narrow: [
        "ح",
        "ن",
        "ث",
        "ر",
        "خ",
        "ج",
        "س"
    ],
    short: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    abbreviated: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    wide: [
        "الأحد",
        "الاثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت"
    ]
};
var $cd0db3239b4ee5bf$var$dayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءً",
        night: "ليلاً"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهراً",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءً",
        night: "ليلاً"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهراً",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءً",
        night: "ليلاً"
    }
};
var $cd0db3239b4ee5bf$var$formattingDayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "في الصباح",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهراً",
        morning: "في الصباح",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        morning: "في الصباح",
        noon: "ظهراً",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل"
    }
};
var $cd0db3239b4ee5bf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $cd0db3239b4ee5bf$var$localize = {
    ordinalNumber: $cd0db3239b4ee5bf$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $cd0db3239b4ee5bf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $cd0db3239b4ee5bf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $cd0db3239b4ee5bf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $cd0db3239b4ee5bf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $cd0db3239b4ee5bf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $cd0db3239b4ee5bf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $cd0db3239b4ee5bf$export$2e2bcd8739ae039 = $cd0db3239b4ee5bf$var$localize;




var $56fa0b6540244a6f$var$matchOrdinalNumberPattern = /^(\d+)/;
var $56fa0b6540244a6f$var$parseOrdinalNumberPattern = /\d+/i;
var $56fa0b6540244a6f$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var $56fa0b6540244a6f$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var $56fa0b6540244a6f$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var $56fa0b6540244a6f$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var $56fa0b6540244a6f$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $56fa0b6540244a6f$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var $56fa0b6540244a6f$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var $56fa0b6540244a6f$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var $56fa0b6540244a6f$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var $56fa0b6540244a6f$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var $56fa0b6540244a6f$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $56fa0b6540244a6f$var$matchOrdinalNumberPattern,
        parsePattern: $56fa0b6540244a6f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $56fa0b6540244a6f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56fa0b6540244a6f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $56fa0b6540244a6f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56fa0b6540244a6f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $56fa0b6540244a6f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56fa0b6540244a6f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $56fa0b6540244a6f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56fa0b6540244a6f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $56fa0b6540244a6f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $56fa0b6540244a6f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $56fa0b6540244a6f$export$2e2bcd8739ae039 = $56fa0b6540244a6f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var $fe403146efe3253a$var$locale = {
    code: "ar-EG",
    formatDistance: (0, $4f08ebc01fde8ba1$export$2e2bcd8739ae039),
    formatLong: (0, $511aa9b7513b7ac8$export$2e2bcd8739ae039),
    formatRelative: (0, $e3947944bb443277$export$2e2bcd8739ae039),
    localize: (0, $cd0db3239b4ee5bf$export$2e2bcd8739ae039),
    match: (0, $56fa0b6540244a6f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fe403146efe3253a$export$2e2bcd8739ae039 = $fe403146efe3253a$var$locale;


var $bb39cbc78b8990b6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "أقل من ثانية واحدة",
        two: "أقل من ثانتين",
        threeToTen: "أقل من {{count}} ثواني",
        other: "أقل من {{count}} ثانية"
    },
    xSeconds: {
        one: "ثانية واحدة",
        two: "ثانتين",
        threeToTen: "{{count}} ثواني",
        other: "{{count}} ثانية"
    },
    halfAMinute: "نصف دقيقة",
    lessThanXMinutes: {
        one: "أقل من دقيقة",
        two: "أقل من دقيقتين",
        threeToTen: "أقل من {{count}} دقائق",
        other: "أقل من {{count}} دقيقة"
    },
    xMinutes: {
        one: "دقيقة واحدة",
        two: "دقيقتين",
        threeToTen: "{{count}} دقائق",
        other: "{{count}} دقيقة"
    },
    aboutXHours: {
        one: "ساعة واحدة تقريباً",
        two: "ساعتين تقريباً",
        threeToTen: "{{count}} ساعات تقريباً",
        other: "{{count}} ساعة تقريباً"
    },
    xHours: {
        one: "ساعة واحدة",
        two: "ساعتين",
        threeToTen: "{{count}} ساعات",
        other: "{{count}} ساعة"
    },
    xDays: {
        one: "يوم واحد",
        two: "يومين",
        threeToTen: "{{count}} أيام",
        other: "{{count}} يوم"
    },
    aboutXWeeks: {
        one: "أسبوع واحد تقريباً",
        two: "أسبوعين تقريباً",
        threeToTen: "{{count}} أسابيع تقريباً",
        other: "{{count}} أسبوع تقريباً"
    },
    xWeeks: {
        one: "أسبوع واحد",
        two: "أسبوعين",
        threeToTen: "{{count}} أسابيع",
        other: "{{count}} أسبوع"
    },
    aboutXMonths: {
        one: "شهر واحد تقريباً",
        two: "شهرين تقريباً",
        threeToTen: "{{count}} أشهر تقريباً",
        other: "{{count}} شهر تقريباً"
    },
    xMonths: {
        one: "شهر واحد",
        two: "شهرين",
        threeToTen: "{{count}} أشهر",
        other: "{{count}} شهر"
    },
    aboutXYears: {
        one: "عام واحد تقريباً",
        two: "عامين تقريباً",
        threeToTen: "{{count}} أعوام تقريباً",
        other: "{{count}} عام تقريباً"
    },
    xYears: {
        one: "عام واحد",
        two: "عامين",
        threeToTen: "{{count}} أعوام",
        other: "{{count}} عام"
    },
    overXYears: {
        one: "أكثر من عام",
        two: "أكثر من عامين",
        threeToTen: "أكثر من {{count}} أعوام",
        other: "أكثر من {{count}} عام"
    },
    almostXYears: {
        one: "عام واحد تقريباً",
        two: "عامين تقريباً",
        threeToTen: "{{count}} أعوام تقريباً",
        other: "{{count}} عام تقريباً"
    }
};
var $bb39cbc78b8990b6$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $bb39cbc78b8990b6$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "في خلال " + result;
        else return "منذ " + result;
    }
    return result;
};
var $bb39cbc78b8990b6$export$2e2bcd8739ae039 = $bb39cbc78b8990b6$var$formatDistance;



var $24ce0242f5eb5403$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $24ce0242f5eb5403$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $24ce0242f5eb5403$var$dateTimeFormats = {
    full: "{{date}} 'عند' {{time}}",
    long: "{{date}} 'عند' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $24ce0242f5eb5403$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $24ce0242f5eb5403$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $24ce0242f5eb5403$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $24ce0242f5eb5403$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $24ce0242f5eb5403$export$2e2bcd8739ae039 = $24ce0242f5eb5403$var$formatLong;


var $4eee88ee02d3dfe2$var$formatRelativeLocale = {
    lastWeek: "'أخر' eeee 'عند' p",
    yesterday: "'أمس عند' p",
    today: "'اليوم عند' p",
    tomorrow: "'غداً عند' p",
    nextWeek: "eeee 'عند' p",
    other: "P"
};
var $4eee88ee02d3dfe2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4eee88ee02d3dfe2$var$formatRelativeLocale[token];
};
var $4eee88ee02d3dfe2$export$2e2bcd8739ae039 = $4eee88ee02d3dfe2$var$formatRelative;



var $e1802c1a8a1559f0$var$eraValues = {
    narrow: [
        "ق",
        "ب"
    ],
    abbreviated: [
        "ق.م.",
        "ب.م."
    ],
    wide: [
        "قبل الميلاد",
        "بعد الميلاد"
    ]
};
var $e1802c1a8a1559f0$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ر1",
        "ر2",
        "ر3",
        "ر4"
    ],
    wide: [
        "الربع الأول",
        "الربع الثاني",
        "الربع الثالث",
        "الربع الرابع"
    ]
};
var $e1802c1a8a1559f0$var$monthValues = {
    narrow: [
        "ي",
        "ف",
        "م",
        "أ",
        "م",
        "ي",
        "ي",
        "غ",
        "ش",
        "أ",
        "ن",
        "د"
    ],
    abbreviated: [
        "ينا",
        "فبر",
        "مارس",
        "أبريل",
        "ماي",
        "يونـ",
        "يولـ",
        "غشت",
        "شتنـ",
        "أكتـ",
        "نونـ",
        "دجنـ"
    ],
    wide: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "ماي",
        "يونيو",
        "يوليوز",
        "غشت",
        "شتنبر",
        "أكتوبر",
        "نونبر",
        "دجنبر"
    ]
};
var $e1802c1a8a1559f0$var$dayValues = {
    narrow: [
        "ح",
        "ن",
        "ث",
        "ر",
        "خ",
        "ج",
        "س"
    ],
    short: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    abbreviated: [
        "أحد",
        "اثنـ",
        "ثلا",
        "أربـ",
        "خميـ",
        "جمعة",
        "سبت"
    ],
    wide: [
        "الأحد",
        "الإثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت"
    ]
};
var $e1802c1a8a1559f0$var$dayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    }
};
var $e1802c1a8a1559f0$var$formattingDayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "في الصباح",
        afternoon: "بعد الظـهر",
        evening: "في المساء",
        night: "في الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "في الصباح",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظـهر",
        evening: "في المساء",
        night: "في الليل"
    }
};
var $e1802c1a8a1559f0$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $e1802c1a8a1559f0$var$localize = {
    ordinalNumber: $e1802c1a8a1559f0$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e1802c1a8a1559f0$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e1802c1a8a1559f0$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e1802c1a8a1559f0$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e1802c1a8a1559f0$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e1802c1a8a1559f0$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e1802c1a8a1559f0$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $e1802c1a8a1559f0$export$2e2bcd8739ae039 = $e1802c1a8a1559f0$var$localize;




var $2079d497b7d384b6$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $2079d497b7d384b6$var$parseOrdinalNumberPattern = /\d+/i;
var $2079d497b7d384b6$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $2079d497b7d384b6$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $2079d497b7d384b6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $2079d497b7d384b6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2079d497b7d384b6$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var $2079d497b7d384b6$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $2079d497b7d384b6$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $2079d497b7d384b6$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $2079d497b7d384b6$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $2079d497b7d384b6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $2079d497b7d384b6$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $2079d497b7d384b6$var$matchOrdinalNumberPattern,
        parsePattern: $2079d497b7d384b6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2079d497b7d384b6$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2079d497b7d384b6$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2079d497b7d384b6$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2079d497b7d384b6$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2079d497b7d384b6$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2079d497b7d384b6$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2079d497b7d384b6$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2079d497b7d384b6$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2079d497b7d384b6$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2079d497b7d384b6$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $2079d497b7d384b6$export$2e2bcd8739ae039 = $2079d497b7d384b6$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var $2196da9246dfc0dd$var$locale = {
    code: "ar-MA",
    formatDistance: (0, $bb39cbc78b8990b6$export$2e2bcd8739ae039),
    formatLong: (0, $24ce0242f5eb5403$export$2e2bcd8739ae039),
    formatRelative: (0, $4eee88ee02d3dfe2$export$2e2bcd8739ae039),
    localize: (0, $e1802c1a8a1559f0$export$2e2bcd8739ae039),
    match: (0, $2079d497b7d384b6$export$2e2bcd8739ae039),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $2196da9246dfc0dd$export$2e2bcd8739ae039 = $2196da9246dfc0dd$var$locale;


var $814dcca5442d6af3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "أقل من ثانية واحدة",
        two: "أقل من ثانتين",
        threeToTen: "أقل من {{count}} ثواني",
        other: "أقل من {{count}} ثانية"
    },
    xSeconds: {
        one: "ثانية واحدة",
        two: "ثانتين",
        threeToTen: "{{count}} ثواني",
        other: "{{count}} ثانية"
    },
    halfAMinute: "نصف دقيقة",
    lessThanXMinutes: {
        one: "أقل من دقيقة",
        two: "أقل من دقيقتين",
        threeToTen: "أقل من {{count}} دقائق",
        other: "أقل من {{count}} دقيقة"
    },
    xMinutes: {
        one: "دقيقة واحدة",
        two: "دقيقتين",
        threeToTen: "{{count}} دقائق",
        other: "{{count}} دقيقة"
    },
    aboutXHours: {
        one: "ساعة واحدة تقريباً",
        two: "ساعتين تقريباً",
        threeToTen: "{{count}} ساعات تقريباً",
        other: "{{count}} ساعة تقريباً"
    },
    xHours: {
        one: "ساعة واحدة",
        two: "ساعتين",
        threeToTen: "{{count}} ساعات",
        other: "{{count}} ساعة"
    },
    xDays: {
        one: "يوم واحد",
        two: "يومين",
        threeToTen: "{{count}} أيام",
        other: "{{count}} يوم"
    },
    aboutXWeeks: {
        one: "أسبوع واحد تقريباً",
        two: "أسبوعين تقريباً",
        threeToTen: "{{count}} أسابيع تقريباً",
        other: "{{count}} أسبوع تقريباً"
    },
    xWeeks: {
        one: "أسبوع واحد",
        two: "أسبوعين",
        threeToTen: "{{count}} أسابيع",
        other: "{{count}} أسبوع"
    },
    aboutXMonths: {
        one: "شهر واحد تقريباً",
        two: "شهرين تقريباً",
        threeToTen: "{{count}} أشهر تقريباً",
        other: "{{count}} شهر تقريباً"
    },
    xMonths: {
        one: "شهر واحد",
        two: "شهرين",
        threeToTen: "{{count}} أشهر",
        other: "{{count}} شهر"
    },
    aboutXYears: {
        one: "عام واحد تقريباً",
        two: "عامين تقريباً",
        threeToTen: "{{count}} أعوام تقريباً",
        other: "{{count}} عام تقريباً"
    },
    xYears: {
        one: "عام واحد",
        two: "عامين",
        threeToTen: "{{count}} أعوام",
        other: "{{count}} عام"
    },
    overXYears: {
        one: "أكثر من عام",
        two: "أكثر من عامين",
        threeToTen: "أكثر من {{count}} أعوام",
        other: "أكثر من {{count}} عام"
    },
    almostXYears: {
        one: "عام واحد تقريباً",
        two: "عامين تقريباً",
        threeToTen: "{{count}} أعوام تقريباً",
        other: "{{count}} عام تقريباً"
    }
};
var $814dcca5442d6af3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $814dcca5442d6af3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "في خلال " + result;
        else return "منذ " + result;
    }
    return result;
};
var $814dcca5442d6af3$export$2e2bcd8739ae039 = $814dcca5442d6af3$var$formatDistance;



var $eee47dccbc9f6099$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $eee47dccbc9f6099$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $eee47dccbc9f6099$var$dateTimeFormats = {
    full: "{{date}} 'عند' {{time}}",
    long: "{{date}} 'عند' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $eee47dccbc9f6099$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $eee47dccbc9f6099$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $eee47dccbc9f6099$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $eee47dccbc9f6099$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $eee47dccbc9f6099$export$2e2bcd8739ae039 = $eee47dccbc9f6099$var$formatLong;


var $45ef5c301833f0f7$var$formatRelativeLocale = {
    lastWeek: "'أخر' eeee 'عند' p",
    yesterday: "'أمس عند' p",
    today: "'اليوم عند' p",
    tomorrow: "'غداً عند' p",
    nextWeek: "eeee 'عند' p",
    other: "P"
};
var $45ef5c301833f0f7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $45ef5c301833f0f7$var$formatRelativeLocale[token];
};
var $45ef5c301833f0f7$export$2e2bcd8739ae039 = $45ef5c301833f0f7$var$formatRelative;



var $080ee31b5b93a3a4$var$eraValues = {
    narrow: [
        "ق",
        "ب"
    ],
    abbreviated: [
        "ق.م.",
        "ب.م."
    ],
    wide: [
        "قبل الميلاد",
        "بعد الميلاد"
    ]
};
var $080ee31b5b93a3a4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ر1",
        "ر2",
        "ر3",
        "ر4"
    ],
    wide: [
        "الربع الأول",
        "الربع الثاني",
        "الربع الثالث",
        "الربع الرابع"
    ]
};
var $080ee31b5b93a3a4$var$monthValues = {
    narrow: [
        "ي",
        "ف",
        "م",
        "أ",
        "م",
        "ي",
        "ي",
        "أ",
        "س",
        "أ",
        "ن",
        "د"
    ],
    abbreviated: [
        "ينا",
        "فبر",
        "مارس",
        "أبريل",
        "مايو",
        "يونـ",
        "يولـ",
        "أغسـ",
        "سبتـ",
        "أكتـ",
        "نوفـ",
        "ديسـ"
    ],
    wide: [
        "يناير",
        "فبراير",
        "مارس",
        "أبريل",
        "مايو",
        "يونيو",
        "يوليو",
        "أغسطس",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
    ]
};
var $080ee31b5b93a3a4$var$dayValues = {
    narrow: [
        "ح",
        "ن",
        "ث",
        "ر",
        "خ",
        "ج",
        "س"
    ],
    short: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    abbreviated: [
        "أحد",
        "اثنـ",
        "ثلا",
        "أربـ",
        "خميـ",
        "جمعة",
        "سبت"
    ],
    wide: [
        "الأحد",
        "الاثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت"
    ]
};
var $080ee31b5b93a3a4$var$dayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظهر",
        evening: "مساءاً",
        night: "ليلاً"
    }
};
var $080ee31b5b93a3a4$var$formattingDayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "م",
        midnight: "ن",
        noon: "ظ",
        morning: "في الصباح",
        afternoon: "بعد الظـهر",
        evening: "في المساء",
        night: "في الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "في الصباح",
        afternoon: "بعد الظهر",
        evening: "في المساء",
        night: "في الليل"
    },
    wide: {
        am: "ص",
        pm: "م",
        midnight: "نصف الليل",
        noon: "ظهر",
        morning: "صباحاً",
        afternoon: "بعد الظـهر",
        evening: "في المساء",
        night: "في الليل"
    }
};
var $080ee31b5b93a3a4$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $080ee31b5b93a3a4$var$localize = {
    ordinalNumber: $080ee31b5b93a3a4$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $080ee31b5b93a3a4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $080ee31b5b93a3a4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $080ee31b5b93a3a4$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $080ee31b5b93a3a4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $080ee31b5b93a3a4$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $080ee31b5b93a3a4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $080ee31b5b93a3a4$export$2e2bcd8739ae039 = $080ee31b5b93a3a4$var$localize;




var $1c00d21522e65641$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $1c00d21522e65641$var$parseOrdinalNumberPattern = /\d+/i;
var $1c00d21522e65641$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $1c00d21522e65641$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $1c00d21522e65641$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $1c00d21522e65641$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1c00d21522e65641$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var $1c00d21522e65641$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $1c00d21522e65641$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $1c00d21522e65641$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $1c00d21522e65641$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $1c00d21522e65641$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $1c00d21522e65641$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $1c00d21522e65641$var$matchOrdinalNumberPattern,
        parsePattern: $1c00d21522e65641$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c00d21522e65641$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c00d21522e65641$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c00d21522e65641$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c00d21522e65641$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c00d21522e65641$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c00d21522e65641$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c00d21522e65641$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c00d21522e65641$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c00d21522e65641$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1c00d21522e65641$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $1c00d21522e65641$export$2e2bcd8739ae039 = $1c00d21522e65641$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var $661186325c8a8fd3$var$locale = {
    code: "ar-SA",
    formatDistance: (0, $814dcca5442d6af3$export$2e2bcd8739ae039),
    formatLong: (0, $eee47dccbc9f6099$export$2e2bcd8739ae039),
    formatRelative: (0, $45ef5c301833f0f7$export$2e2bcd8739ae039),
    localize: (0, $080ee31b5b93a3a4$export$2e2bcd8739ae039),
    match: (0, $1c00d21522e65641$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $661186325c8a8fd3$export$2e2bcd8739ae039 = $661186325c8a8fd3$var$locale;


var $c4fa155200e03739$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "أقل من ثانية",
        two: "أقل من زوز ثواني",
        threeToTen: "أقل من {{count}} ثواني",
        other: "أقل من {{count}} ثانية"
    },
    xSeconds: {
        one: "ثانية",
        two: "زوز ثواني",
        threeToTen: "{{count}} ثواني",
        other: "{{count}} ثانية"
    },
    halfAMinute: "نص دقيقة",
    lessThanXMinutes: {
        one: "أقل من دقيقة",
        two: "أقل من دقيقتين",
        threeToTen: "أقل من {{count}} دقايق",
        other: "أقل من {{count}} دقيقة"
    },
    xMinutes: {
        one: "دقيقة",
        two: "دقيقتين",
        threeToTen: "{{count}} دقايق",
        other: "{{count}} دقيقة"
    },
    aboutXHours: {
        one: "ساعة تقريب",
        two: "ساعتين تقريب",
        threeToTen: "{{count}} سوايع تقريب",
        other: "{{count}} ساعة تقريب"
    },
    xHours: {
        one: "ساعة",
        two: "ساعتين",
        threeToTen: "{{count}} سوايع",
        other: "{{count}} ساعة"
    },
    xDays: {
        one: "نهار",
        two: "نهارين",
        threeToTen: "{{count}} أيام",
        other: "{{count}} يوم"
    },
    aboutXWeeks: {
        one: "جمعة تقريب",
        two: "جمعتين تقريب",
        threeToTen: "{{count}} جماع تقريب",
        other: "{{count}} جمعة تقريب"
    },
    xWeeks: {
        one: "جمعة",
        two: "جمعتين",
        threeToTen: "{{count}} جماع",
        other: "{{count}} جمعة"
    },
    aboutXMonths: {
        one: "شهر تقريب",
        two: "شهرين تقريب",
        threeToTen: "{{count}} أشهرة تقريب",
        other: "{{count}} شهر تقريب"
    },
    xMonths: {
        one: "شهر",
        two: "شهرين",
        threeToTen: "{{count}} أشهرة",
        other: "{{count}} شهر"
    },
    aboutXYears: {
        one: "عام تقريب",
        two: "عامين تقريب",
        threeToTen: "{{count}} أعوام تقريب",
        other: "{{count}} عام تقريب"
    },
    xYears: {
        one: "عام",
        two: "عامين",
        threeToTen: "{{count}} أعوام",
        other: "{{count}} عام"
    },
    overXYears: {
        one: "أكثر من عام",
        two: "أكثر من عامين",
        threeToTen: "أكثر من {{count}} أعوام",
        other: "أكثر من {{count}} عام"
    },
    almostXYears: {
        one: "عام تقريب",
        two: "عامين تقريب",
        threeToTen: "{{count}} أعوام تقريب",
        other: "{{count}} عام تقريب"
    }
};
var $c4fa155200e03739$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $c4fa155200e03739$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "في " + result;
        else return "عندو " + result;
    }
    return result;
};
var $c4fa155200e03739$export$2e2bcd8739ae039 = $c4fa155200e03739$var$formatDistance;



var $a44cd858515da768$var$dateFormats = {
    full: "EEEE، do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $a44cd858515da768$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $a44cd858515da768$var$dateTimeFormats = {
    full: "{{date}} 'مع' {{time}}",
    long: "{{date}} 'مع' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $a44cd858515da768$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a44cd858515da768$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a44cd858515da768$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a44cd858515da768$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a44cd858515da768$export$2e2bcd8739ae039 = $a44cd858515da768$var$formatLong;


var $721f026d8d9ae95d$var$formatRelativeLocale = {
    lastWeek: "eeee 'إلي فات مع' p",
    yesterday: "'البارح مع' p",
    today: "'اليوم مع' p",
    tomorrow: "'غدوة مع' p",
    nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
    other: "P"
};
var $721f026d8d9ae95d$var$formatRelative = function formatRelative(token) {
    return $721f026d8d9ae95d$var$formatRelativeLocale[token];
};
var $721f026d8d9ae95d$export$2e2bcd8739ae039 = $721f026d8d9ae95d$var$formatRelative;



var $9b9b42cfea48b5e1$var$eraValues = {
    narrow: [
        "ق",
        "ب"
    ],
    abbreviated: [
        "ق.م.",
        "ب.م."
    ],
    wide: [
        "قبل الميلاد",
        "بعد الميلاد"
    ]
};
var $9b9b42cfea48b5e1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ر1",
        "ر2",
        "ر3",
        "ر4"
    ],
    wide: [
        "الربع الأول",
        "الربع الثاني",
        "الربع الثالث",
        "الربع الرابع"
    ]
};
var $9b9b42cfea48b5e1$var$monthValues = {
    narrow: [
        "د",
        "ن",
        "أ",
        "س",
        "أ",
        "ج",
        "ج",
        "م",
        "أ",
        "م",
        "ف",
        "ج"
    ],
    abbreviated: [
        "جانفي",
        "فيفري",
        "مارس",
        "أفريل",
        "ماي",
        "جوان",
        "جويلية",
        "أوت",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
    ],
    wide: [
        "جانفي",
        "فيفري",
        "مارس",
        "أفريل",
        "ماي",
        "جوان",
        "جويلية",
        "أوت",
        "سبتمبر",
        "أكتوبر",
        "نوفمبر",
        "ديسمبر"
    ]
};
var $9b9b42cfea48b5e1$var$dayValues = {
    narrow: [
        "ح",
        "ن",
        "ث",
        "ر",
        "خ",
        "ج",
        "س"
    ],
    short: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    abbreviated: [
        "أحد",
        "اثنين",
        "ثلاثاء",
        "أربعاء",
        "خميس",
        "جمعة",
        "سبت"
    ],
    wide: [
        "الأحد",
        "الاثنين",
        "الثلاثاء",
        "الأربعاء",
        "الخميس",
        "الجمعة",
        "السبت"
    ]
};
var $9b9b42cfea48b5e1$var$dayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "ع",
        morning: "الصباح",
        noon: "القايلة",
        afternoon: "بعد القايلة",
        evening: "العشية",
        night: "الليل",
        midnight: "نص الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "ع",
        morning: "الصباح",
        noon: "القايلة",
        afternoon: "بعد القايلة",
        evening: "العشية",
        night: "الليل",
        midnight: "نص الليل"
    },
    wide: {
        am: "ص",
        pm: "ع",
        morning: "الصباح",
        noon: "القايلة",
        afternoon: "بعد القايلة",
        evening: "العشية",
        night: "الليل",
        midnight: "نص الليل"
    }
};
var $9b9b42cfea48b5e1$var$formattingDayPeriodValues = {
    narrow: {
        am: "ص",
        pm: "ع",
        morning: "في الصباح",
        noon: "في القايلة",
        afternoon: "بعد القايلة",
        evening: "في العشية",
        night: "في الليل",
        midnight: "نص الليل"
    },
    abbreviated: {
        am: "ص",
        pm: "ع",
        morning: "في الصباح",
        noon: "في القايلة",
        afternoon: "بعد القايلة",
        evening: "في العشية",
        night: "في الليل",
        midnight: "نص الليل"
    },
    wide: {
        am: "ص",
        pm: "ع",
        morning: "في الصباح",
        noon: "في القايلة",
        afternoon: "بعد القايلة",
        evening: "في العشية",
        night: "في الليل",
        midnight: "نص الليل"
    }
};
var $9b9b42cfea48b5e1$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $9b9b42cfea48b5e1$var$localize = {
    ordinalNumber: $9b9b42cfea48b5e1$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9b9b42cfea48b5e1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9b9b42cfea48b5e1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9b9b42cfea48b5e1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9b9b42cfea48b5e1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9b9b42cfea48b5e1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9b9b42cfea48b5e1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9b9b42cfea48b5e1$export$2e2bcd8739ae039 = $9b9b42cfea48b5e1$var$localize;




var $9ec727c691a4223f$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $9ec727c691a4223f$var$parseOrdinalNumberPattern = /\d+/i;
var $9ec727c691a4223f$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $9ec727c691a4223f$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $9ec727c691a4223f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $9ec727c691a4223f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9ec727c691a4223f$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $9ec727c691a4223f$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $9ec727c691a4223f$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $9ec727c691a4223f$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $9ec727c691a4223f$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var $9ec727c691a4223f$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var $9ec727c691a4223f$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $9ec727c691a4223f$var$matchOrdinalNumberPattern,
        parsePattern: $9ec727c691a4223f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $9ec727c691a4223f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ec727c691a4223f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $9ec727c691a4223f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ec727c691a4223f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $9ec727c691a4223f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ec727c691a4223f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $9ec727c691a4223f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $9ec727c691a4223f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $9ec727c691a4223f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $9ec727c691a4223f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $9ec727c691a4223f$export$2e2bcd8739ae039 = $9ec727c691a4223f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $5f689f20688937d2$var$locale = {
    code: "ar-TN",
    formatDistance: (0, $c4fa155200e03739$export$2e2bcd8739ae039),
    formatLong: (0, $a44cd858515da768$export$2e2bcd8739ae039),
    formatRelative: (0, $721f026d8d9ae95d$export$2e2bcd8739ae039),
    localize: (0, $9b9b42cfea48b5e1$export$2e2bcd8739ae039),
    match: (0, $9ec727c691a4223f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $5f689f20688937d2$export$2e2bcd8739ae039 = $5f689f20688937d2$var$locale;


var $bd5eeffbf63d1e6a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniyədən az",
        other: "{{count}} bir saniyədən az"
    },
    xSeconds: {
        one: "1 saniyə",
        other: "{{count}} saniyə"
    },
    halfAMinute: "yarım dəqiqə",
    lessThanXMinutes: {
        one: "bir dəqiqədən az",
        other: "{{count}} bir dəqiqədən az"
    },
    xMinutes: {
        one: "bir dəqiqə",
        other: "{{count}} dəqiqə"
    },
    aboutXHours: {
        one: "təxminən 1 saat",
        other: "təxminən {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "təxminən 1 həftə",
        other: "təxminən {{count}} həftə"
    },
    xWeeks: {
        one: "1 həftə",
        other: "{{count}} həftə"
    },
    aboutXMonths: {
        one: "təxminən 1 ay",
        other: "təxminən {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "təxminən 1 il",
        other: "təxminən {{count}} il"
    },
    xYears: {
        one: "1 il",
        other: "{{count}} il"
    },
    overXYears: {
        one: "1 ildən \xe7ox",
        other: "{{count}} ildən \xe7ox"
    },
    almostXYears: {
        one: "demək olar ki 1 il",
        other: "demək olar ki {{count}} il"
    }
};
var $bd5eeffbf63d1e6a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bd5eeffbf63d1e6a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " əvvəl";
    }
    return result;
};
var $bd5eeffbf63d1e6a$export$2e2bcd8739ae039 = $bd5eeffbf63d1e6a$var$formatDistance;



var $ad745cddd6c86fcf$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: "dd.MM.yyyy"
};
var $ad745cddd6c86fcf$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $ad745cddd6c86fcf$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'də'",
    long: "{{date}} {{time}} - 'də'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $ad745cddd6c86fcf$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ad745cddd6c86fcf$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ad745cddd6c86fcf$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ad745cddd6c86fcf$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $ad745cddd6c86fcf$export$2e2bcd8739ae039 = $ad745cddd6c86fcf$var$formatLong;


var $94370710bfcccc84$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'də'",
    yesterday: "'d\xfcnən' p -'də'",
    today: "'bug\xfcn' p -'də'",
    tomorrow: "'sabah' p -'də'",
    nextWeek: "eeee p -'də'",
    other: "P"
};
var $94370710bfcccc84$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $94370710bfcccc84$var$formatRelativeLocale[token];
};
var $94370710bfcccc84$export$2e2bcd8739ae039 = $94370710bfcccc84$var$formatRelative;



var $b44eb72cbe5721cf$var$eraValues = {
    narrow: [
        "e.ə",
        "b.e"
    ],
    abbreviated: [
        "e.ə",
        "b.e"
    ],
    wide: [
        "eramızdan əvvəl",
        "bizim era"
    ]
};
var $b44eb72cbe5721cf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ci kvartal",
        "2ci kvartal",
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var $b44eb72cbe5721cf$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "İ",
        "İ",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "İyun",
        "İyul",
        "Avq",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "İyun",
        "İyul",
        "Avqust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr"
    ]
};
var $b44eb72cbe5721cf$var$dayValues = {
    narrow: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "Ş."
    ],
    short: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "Ş."
    ],
    abbreviated: [
        "Baz",
        "Baz.e",
        "\xc7ər.a",
        "\xc7ər",
        "C\xfcm.a",
        "C\xfcm",
        "Şə"
    ],
    wide: [
        "Bazar",
        "Bazar ertəsi",
        "\xc7ərşənbə axşamı",
        "\xc7ərşənbə",
        "C\xfcmə axşamı",
        "C\xfcmə",
        "Şənbə"
    ]
};
var $b44eb72cbe5721cf$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "gecəyarı",
        noon: "g\xfcn",
        morning: "səhər",
        afternoon: "g\xfcnd\xfcz",
        evening: "axşam",
        night: "gecə"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gecəyarı",
        noon: "g\xfcn",
        morning: "səhər",
        afternoon: "g\xfcnd\xfcz",
        evening: "axşam",
        night: "gecə"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gecəyarı",
        noon: "g\xfcn",
        morning: "səhər",
        afternoon: "g\xfcnd\xfcz",
        evening: "axşam",
        night: "gecə"
    }
};
var $b44eb72cbe5721cf$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gecəyarı",
        noon: "g\xfcn",
        morning: "səhər",
        afternoon: "g\xfcnd\xfcz",
        evening: "axşam",
        night: "gecə"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gecəyarı",
        noon: "g\xfcn",
        morning: "səhər",
        afternoon: "g\xfcnd\xfcz",
        evening: "axşam",
        night: "gecə"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gecəyarı",
        noon: "g\xfcn",
        morning: "səhər",
        afternoon: "g\xfcnd\xfcz",
        evening: "axşam",
        night: "gecə"
    }
};
var $b44eb72cbe5721cf$var$suffixes = {
    1: "-inci",
    5: "-inci",
    8: "-inci",
    70: "-inci",
    80: "-inci",
    2: "-nci",
    7: "-nci",
    20: "-nci",
    50: "-nci",
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-ncı",
    9: "-uncu",
    10: "-uncu",
    30: "-uncu",
    60: "-ıncı",
    90: "-ıncı"
};
var $b44eb72cbe5721cf$var$getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-ıncı";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if ($b44eb72cbe5721cf$var$suffixes[a]) return $b44eb72cbe5721cf$var$suffixes[a];
    else if ($b44eb72cbe5721cf$var$suffixes[b]) return $b44eb72cbe5721cf$var$suffixes[b];
    else if (c !== null) return $b44eb72cbe5721cf$var$suffixes[c];
    return "";
};
var $b44eb72cbe5721cf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = $b44eb72cbe5721cf$var$getSuffix(number);
    return number + suffix;
};
var $b44eb72cbe5721cf$var$localize = {
    ordinalNumber: $b44eb72cbe5721cf$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b44eb72cbe5721cf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b44eb72cbe5721cf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b44eb72cbe5721cf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b44eb72cbe5721cf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b44eb72cbe5721cf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b44eb72cbe5721cf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $b44eb72cbe5721cf$export$2e2bcd8739ae039 = $b44eb72cbe5721cf$var$localize;




var $7b76265b521abc98$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var $7b76265b521abc98$var$parseOrdinalNumberPattern = /\d+/i;
var $7b76265b521abc98$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var $7b76265b521abc98$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var $7b76265b521abc98$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var $7b76265b521abc98$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7b76265b521abc98$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var $7b76265b521abc98$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var $7b76265b521abc98$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var $7b76265b521abc98$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var $7b76265b521abc98$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var $7b76265b521abc98$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var $7b76265b521abc98$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $7b76265b521abc98$var$matchOrdinalNumberPattern,
        parsePattern: $7b76265b521abc98$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7b76265b521abc98$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b76265b521abc98$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7b76265b521abc98$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b76265b521abc98$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7b76265b521abc98$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b76265b521abc98$var$parseMonthPatterns,
        defaultParseWidth: "narrow"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7b76265b521abc98$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7b76265b521abc98$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7b76265b521abc98$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7b76265b521abc98$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7b76265b521abc98$export$2e2bcd8739ae039 = $7b76265b521abc98$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var $a45fe4d02cfa2cdb$var$locale = {
    code: "az",
    formatDistance: (0, $bd5eeffbf63d1e6a$export$2e2bcd8739ae039),
    formatLong: (0, $ad745cddd6c86fcf$export$2e2bcd8739ae039),
    formatRelative: (0, $94370710bfcccc84$export$2e2bcd8739ae039),
    localize: (0, $b44eb72cbe5721cf$export$2e2bcd8739ae039),
    match: (0, $7b76265b521abc98$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $a45fe4d02cfa2cdb$export$2e2bcd8739ae039 = $a45fe4d02cfa2cdb$var$locale;


function $eb5f51eaa4c01191$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $eb5f51eaa4c01191$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $eb5f51eaa4c01191$var$declension(scheme.future, count);
                else return "праз " + $eb5f51eaa4c01191$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $eb5f51eaa4c01191$var$declension(scheme.past, count);
                else return $eb5f51eaa4c01191$var$declension(scheme.regular, count) + " таму";
            }
        } else return $eb5f51eaa4c01191$var$declension(scheme.regular, count);
    };
}
var $eb5f51eaa4c01191$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "праз паўхвіліны";
        else return "паўхвіліны таму";
    }
    return "паўхвіліны";
};
var $eb5f51eaa4c01191$var$formatDistanceLocale = {
    lessThanXSeconds: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            one: "менш за секунду",
            singularNominative: "менш за {{count}} секунду",
            singularGenitive: "менш за {{count}} секунды",
            pluralGenitive: "менш за {{count}} секунд"
        },
        future: {
            one: "менш, чым праз секунду",
            singularNominative: "менш, чым праз {{count}} секунду",
            singularGenitive: "менш, чым праз {{count}} секунды",
            pluralGenitive: "менш, чым праз {{count}} секунд"
        }
    }),
    xSeconds: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} секунда",
            singularGenitive: "{{count}} секунды",
            pluralGenitive: "{{count}} секунд"
        },
        past: {
            singularNominative: "{{count}} секунду таму",
            singularGenitive: "{{count}} секунды таму",
            pluralGenitive: "{{count}} секунд таму"
        },
        future: {
            singularNominative: "праз {{count}} секунду",
            singularGenitive: "праз {{count}} секунды",
            pluralGenitive: "праз {{count}} секунд"
        }
    }),
    halfAMinute: $eb5f51eaa4c01191$var$halfAMinute,
    lessThanXMinutes: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            one: "менш за хвіліну",
            singularNominative: "менш за {{count}} хвіліну",
            singularGenitive: "менш за {{count}} хвіліны",
            pluralGenitive: "менш за {{count}} хвілін"
        },
        future: {
            one: "менш, чым праз хвіліну",
            singularNominative: "менш, чым праз {{count}} хвіліну",
            singularGenitive: "менш, чым праз {{count}} хвіліны",
            pluralGenitive: "менш, чым праз {{count}} хвілін"
        }
    }),
    xMinutes: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} хвіліна",
            singularGenitive: "{{count}} хвіліны",
            pluralGenitive: "{{count}} хвілін"
        },
        past: {
            singularNominative: "{{count}} хвіліну таму",
            singularGenitive: "{{count}} хвіліны таму",
            pluralGenitive: "{{count}} хвілін таму"
        },
        future: {
            singularNominative: "праз {{count}} хвіліну",
            singularGenitive: "праз {{count}} хвіліны",
            pluralGenitive: "праз {{count}} хвілін"
        }
    }),
    aboutXHours: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} гадзіны",
            singularGenitive: "каля {{count}} гадзін",
            pluralGenitive: "каля {{count}} гадзін"
        },
        future: {
            singularNominative: "прыблізна праз {{count}} гадзіну",
            singularGenitive: "прыблізна праз {{count}} гадзіны",
            pluralGenitive: "прыблізна праз {{count}} гадзін"
        }
    }),
    xHours: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} гадзіна",
            singularGenitive: "{{count}} гадзіны",
            pluralGenitive: "{{count}} гадзін"
        },
        past: {
            singularNominative: "{{count}} гадзіну таму",
            singularGenitive: "{{count}} гадзіны таму",
            pluralGenitive: "{{count}} гадзін таму"
        },
        future: {
            singularNominative: "праз {{count}} гадзіну",
            singularGenitive: "праз {{count}} гадзіны",
            pluralGenitive: "праз {{count}} гадзін"
        }
    }),
    xDays: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} дзень",
            singularGenitive: "{{count}} дні",
            pluralGenitive: "{{count}} дзён"
        }
    }),
    aboutXWeeks: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} месяца",
            // TODO
            singularGenitive: "каля {{count}} месяцаў",
            // TODO
            pluralGenitive: "каля {{count}} месяцаў" // TODO
        },
        future: {
            singularNominative: "прыблізна праз {{count}} месяц",
            // TODO
            singularGenitive: "прыблізна праз {{count}} месяцы",
            // TODO
            pluralGenitive: "прыблізна праз {{count}} месяцаў" // TODO
        }
    }),
    xWeeks: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} месяц",
            singularGenitive: "{{count}} месяцы",
            pluralGenitive: "{{count}} месяцаў"
        }
    }),
    aboutXMonths: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} месяца",
            singularGenitive: "каля {{count}} месяцаў",
            pluralGenitive: "каля {{count}} месяцаў"
        },
        future: {
            singularNominative: "прыблізна праз {{count}} месяц",
            singularGenitive: "прыблізна праз {{count}} месяцы",
            pluralGenitive: "прыблізна праз {{count}} месяцаў"
        }
    }),
    xMonths: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} месяц",
            singularGenitive: "{{count}} месяцы",
            pluralGenitive: "{{count}} месяцаў"
        }
    }),
    aboutXYears: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} года",
            singularGenitive: "каля {{count}} гадоў",
            pluralGenitive: "каля {{count}} гадоў"
        },
        future: {
            singularNominative: "прыблізна праз {{count}} год",
            singularGenitive: "прыблізна праз {{count}} гады",
            pluralGenitive: "прыблізна праз {{count}} гадоў"
        }
    }),
    xYears: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} год",
            singularGenitive: "{{count}} гады",
            pluralGenitive: "{{count}} гадоў"
        }
    }),
    overXYears: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "больш за {{count}} год",
            singularGenitive: "больш за {{count}} гады",
            pluralGenitive: "больш за {{count}} гадоў"
        },
        future: {
            singularNominative: "больш, чым праз {{count}} год",
            singularGenitive: "больш, чым праз {{count}} гады",
            pluralGenitive: "больш, чым праз {{count}} гадоў"
        }
    }),
    almostXYears: $eb5f51eaa4c01191$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "амаль {{count}} год",
            singularGenitive: "амаль {{count}} гады",
            pluralGenitive: "амаль {{count}} гадоў"
        },
        future: {
            singularNominative: "амаль праз {{count}} год",
            singularGenitive: "амаль праз {{count}} гады",
            pluralGenitive: "амаль праз {{count}} гадоў"
        }
    })
};
var $eb5f51eaa4c01191$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $eb5f51eaa4c01191$var$formatDistanceLocale[token](count, options);
};
var $eb5f51eaa4c01191$export$2e2bcd8739ae039 = $eb5f51eaa4c01191$var$formatDistance;



var $378383eb9bb9a9d0$var$dateFormats = {
    full: "EEEE, d MMMM y 'г.'",
    long: "d MMMM y 'г.'",
    medium: "d MMM y 'г.'",
    short: "dd.MM.y"
};
var $378383eb9bb9a9d0$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $378383eb9bb9a9d0$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $378383eb9bb9a9d0$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $378383eb9bb9a9d0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $378383eb9bb9a9d0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $378383eb9bb9a9d0$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $378383eb9bb9a9d0$export$2e2bcd8739ae039 = $378383eb9bb9a9d0$var$formatLong;






function $e988ad2ce58d9c6e$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}



function $4da6ce6e331a379d$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $bac751230e4fc222$export$430a3269e24b912e)();
    var weekStartsOn = (0, $e988ad2ce58d9c6e$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}


function $20baa0f6a4f9b6c5$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $b320e4b5494ae3f6$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfWeek = (0, $4da6ce6e331a379d$export$2e2bcd8739ae039)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $4da6ce6e331a379d$export$2e2bcd8739ae039)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}


var $aba6a9a0129be31f$var$accusativeWeekdays = [
    "нядзелю",
    "панядзелак",
    "аўторак",
    "сераду",
    "чацвер",
    "пятніцу",
    "суботу"
];
function $aba6a9a0129be31f$var$lastWeek(day) {
    var weekday = $aba6a9a0129be31f$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'у мінулую " + weekday + " а' p";
        case 1:
        case 2:
        case 4:
            return "'у мінулы " + weekday + " а' p";
    }
}
function $aba6a9a0129be31f$var$thisWeek(day) {
    var weekday = $aba6a9a0129be31f$var$accusativeWeekdays[day];
    return "'у " + weekday + " а' p";
}
function $aba6a9a0129be31f$var$nextWeek(day) {
    var weekday = $aba6a9a0129be31f$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'у наступную " + weekday + " а' p";
        case 1:
        case 2:
        case 4:
            return "'у наступны " + weekday + " а' p";
    }
}
var $aba6a9a0129be31f$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $aba6a9a0129be31f$var$thisWeek(day);
    else return $aba6a9a0129be31f$var$lastWeek(day);
};
var $aba6a9a0129be31f$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $aba6a9a0129be31f$var$thisWeek(day);
    else return $aba6a9a0129be31f$var$nextWeek(day);
};
var $aba6a9a0129be31f$var$formatRelativeLocale = {
    lastWeek: $aba6a9a0129be31f$var$lastWeekFormat,
    yesterday: "'учора а' p",
    today: "'сёння а' p",
    tomorrow: "'заўтра а' p",
    nextWeek: $aba6a9a0129be31f$var$nextWeekFormat,
    other: "P"
};
var $aba6a9a0129be31f$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $aba6a9a0129be31f$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $aba6a9a0129be31f$export$2e2bcd8739ae039 = $aba6a9a0129be31f$var$formatRelative;



var $1ee8882392bca481$var$eraValues = {
    narrow: [
        "да н.э.",
        "н.э."
    ],
    abbreviated: [
        "да н. э.",
        "н. э."
    ],
    wide: [
        "да нашай эры",
        "нашай эры"
    ]
};
var $1ee8882392bca481$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-ы кв.",
        "2-і кв.",
        "3-і кв.",
        "4-ы кв."
    ],
    wide: [
        "1-ы квартал",
        "2-і квартал",
        "3-і квартал",
        "4-ы квартал"
    ]
};
var $1ee8882392bca481$var$monthValues = {
    narrow: [
        "С",
        "Л",
        "С",
        "К",
        "М",
        "Ч",
        "Л",
        "Ж",
        "В",
        "К",
        "Л",
        "С"
    ],
    abbreviated: [
        "студз.",
        "лют.",
        "сак.",
        "крас.",
        "май",
        "чэрв.",
        "ліп.",
        "жн.",
        "вер.",
        "кастр.",
        "ліст.",
        "снеж."
    ],
    wide: [
        "студзень",
        "люты",
        "сакавік",
        "красавік",
        "май",
        "чэрвень",
        "ліпень",
        "жнівень",
        "верасень",
        "кастрычнік",
        "лістапад",
        "снежань"
    ]
};
var $1ee8882392bca481$var$formattingMonthValues = {
    narrow: [
        "С",
        "Л",
        "С",
        "К",
        "М",
        "Ч",
        "Л",
        "Ж",
        "В",
        "К",
        "Л",
        "С"
    ],
    abbreviated: [
        "студз.",
        "лют.",
        "сак.",
        "крас.",
        "мая",
        "чэрв.",
        "ліп.",
        "жн.",
        "вер.",
        "кастр.",
        "ліст.",
        "снеж."
    ],
    wide: [
        "студзеня",
        "лютага",
        "сакавіка",
        "красавіка",
        "мая",
        "чэрвеня",
        "ліпеня",
        "жніўня",
        "верасня",
        "кастрычніка",
        "лістапада",
        "снежня"
    ]
};
var $1ee8882392bca481$var$dayValues = {
    narrow: [
        "Н",
        "П",
        "А",
        "С",
        "Ч",
        "П",
        "С"
    ],
    short: [
        "нд",
        "пн",
        "аў",
        "ср",
        "чц",
        "пт",
        "сб"
    ],
    abbreviated: [
        "нядз",
        "пан",
        "аўт",
        "сер",
        "чац",
        "пят",
        "суб"
    ],
    wide: [
        "нядзеля",
        "панядзелак",
        "аўторак",
        "серада",
        "чацвер",
        "пятніца",
        "субота"
    ]
};
var $1ee8882392bca481$var$dayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дзень",
        evening: "веч.",
        night: "ноч"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дзень",
        evening: "веч.",
        night: "ноч"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўнач",
        noon: "поўдзень",
        morning: "раніца",
        afternoon: "дзень",
        evening: "вечар",
        night: "ноч"
    }
};
var $1ee8882392bca481$var$formattingDayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дня",
        evening: "веч.",
        night: "ночы"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дня",
        evening: "веч.",
        night: "ночы"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўнач",
        noon: "поўдзень",
        morning: "раніцы",
        afternoon: "дня",
        evening: "вечара",
        night: "ночы"
    }
};
var $1ee8882392bca481$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-га";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-я";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-і" : "-ы";
    return number + suffix;
};
var $1ee8882392bca481$var$localize = {
    ordinalNumber: $1ee8882392bca481$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1ee8882392bca481$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1ee8882392bca481$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1ee8882392bca481$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $1ee8882392bca481$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1ee8882392bca481$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1ee8882392bca481$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $1ee8882392bca481$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $1ee8882392bca481$export$2e2bcd8739ae039 = $1ee8882392bca481$var$localize;




var $b7e7fd0b8ae8d9bd$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $b7e7fd0b8ae8d9bd$var$parseOrdinalNumberPattern = /\d+/i;
var $b7e7fd0b8ae8d9bd$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $b7e7fd0b8ae8d9bd$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $b7e7fd0b8ae8d9bd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $b7e7fd0b8ae8d9bd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b7e7fd0b8ae8d9bd$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var $b7e7fd0b8ae8d9bd$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $b7e7fd0b8ae8d9bd$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $b7e7fd0b8ae8d9bd$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $b7e7fd0b8ae8d9bd$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $b7e7fd0b8ae8d9bd$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $b7e7fd0b8ae8d9bd$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $b7e7fd0b8ae8d9bd$var$matchOrdinalNumberPattern,
        parsePattern: $b7e7fd0b8ae8d9bd$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b7e7fd0b8ae8d9bd$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b7e7fd0b8ae8d9bd$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b7e7fd0b8ae8d9bd$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b7e7fd0b8ae8d9bd$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b7e7fd0b8ae8d9bd$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b7e7fd0b8ae8d9bd$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b7e7fd0b8ae8d9bd$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b7e7fd0b8ae8d9bd$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b7e7fd0b8ae8d9bd$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b7e7fd0b8ae8d9bd$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $b7e7fd0b8ae8d9bd$export$2e2bcd8739ae039 = $b7e7fd0b8ae8d9bd$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var $5e25a6695ec5ca45$var$locale = {
    code: "be",
    formatDistance: (0, $eb5f51eaa4c01191$export$2e2bcd8739ae039),
    formatLong: (0, $378383eb9bb9a9d0$export$2e2bcd8739ae039),
    formatRelative: (0, $aba6a9a0129be31f$export$2e2bcd8739ae039),
    localize: (0, $1ee8882392bca481$export$2e2bcd8739ae039),
    match: (0, $b7e7fd0b8ae8d9bd$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $5e25a6695ec5ca45$export$2e2bcd8739ae039 = $5e25a6695ec5ca45$var$locale;


function $511cdeae4b6a34b3$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $511cdeae4b6a34b3$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $511cdeae4b6a34b3$var$declension(scheme.future, count);
                else return "праз " + $511cdeae4b6a34b3$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $511cdeae4b6a34b3$var$declension(scheme.past, count);
                else return $511cdeae4b6a34b3$var$declension(scheme.regular, count) + " таму";
            }
        } else return $511cdeae4b6a34b3$var$declension(scheme.regular, count);
    };
}
var $511cdeae4b6a34b3$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "праз паўхвіліны";
        else return "паўхвіліны таму";
    }
    return "паўхвіліны";
};
var $511cdeae4b6a34b3$var$formatDistanceLocale = {
    lessThanXSeconds: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            one: "менш за секунду",
            singularNominative: "менш за {{count}} секунду",
            singularGenitive: "менш за {{count}} секунды",
            pluralGenitive: "менш за {{count}} секунд"
        },
        future: {
            one: "менш, чым праз секунду",
            singularNominative: "менш, чым праз {{count}} секунду",
            singularGenitive: "менш, чым праз {{count}} секунды",
            pluralGenitive: "менш, чым праз {{count}} секунд"
        }
    }),
    xSeconds: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} секунда",
            singularGenitive: "{{count}} секунды",
            pluralGenitive: "{{count}} секунд"
        },
        past: {
            singularNominative: "{{count}} секунду таму",
            singularGenitive: "{{count}} секунды таму",
            pluralGenitive: "{{count}} секунд таму"
        },
        future: {
            singularNominative: "праз {{count}} секунду",
            singularGenitive: "праз {{count}} секунды",
            pluralGenitive: "праз {{count}} секунд"
        }
    }),
    halfAMinute: $511cdeae4b6a34b3$var$halfAMinute,
    lessThanXMinutes: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            one: "менш за хвіліну",
            singularNominative: "менш за {{count}} хвіліну",
            singularGenitive: "менш за {{count}} хвіліны",
            pluralGenitive: "менш за {{count}} хвілін"
        },
        future: {
            one: "менш, чым праз хвіліну",
            singularNominative: "менш, чым праз {{count}} хвіліну",
            singularGenitive: "менш, чым праз {{count}} хвіліны",
            pluralGenitive: "менш, чым праз {{count}} хвілін"
        }
    }),
    xMinutes: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} хвіліна",
            singularGenitive: "{{count}} хвіліны",
            pluralGenitive: "{{count}} хвілін"
        },
        past: {
            singularNominative: "{{count}} хвіліну таму",
            singularGenitive: "{{count}} хвіліны таму",
            pluralGenitive: "{{count}} хвілін таму"
        },
        future: {
            singularNominative: "праз {{count}} хвіліну",
            singularGenitive: "праз {{count}} хвіліны",
            pluralGenitive: "праз {{count}} хвілін"
        }
    }),
    aboutXHours: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} гадзіны",
            singularGenitive: "каля {{count}} гадзін",
            pluralGenitive: "каля {{count}} гадзін"
        },
        future: {
            singularNominative: "прыблізна праз {{count}} гадзіну",
            singularGenitive: "прыблізна праз {{count}} гадзіны",
            pluralGenitive: "прыблізна праз {{count}} гадзін"
        }
    }),
    xHours: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} гадзіна",
            singularGenitive: "{{count}} гадзіны",
            pluralGenitive: "{{count}} гадзін"
        },
        past: {
            singularNominative: "{{count}} гадзіну таму",
            singularGenitive: "{{count}} гадзіны таму",
            pluralGenitive: "{{count}} гадзін таму"
        },
        future: {
            singularNominative: "праз {{count}} гадзіну",
            singularGenitive: "праз {{count}} гадзіны",
            pluralGenitive: "праз {{count}} гадзін"
        }
    }),
    xDays: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} дзень",
            singularGenitive: "{{count}} дні",
            pluralGenitive: "{{count}} дзён"
        }
    }),
    aboutXWeeks: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} месяца",
            // TODO
            singularGenitive: "каля {{count}} месяцаў",
            // TODO
            pluralGenitive: "каля {{count}} месяцаў" // TODO
        },
        future: {
            singularNominative: "прыблізна праз {{count}} месяц",
            // TODO
            singularGenitive: "прыблізна праз {{count}} месяцы",
            // TODO
            pluralGenitive: "прыблізна праз {{count}} месяцаў" // TODO
        }
    }),
    xWeeks: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} месяц",
            singularGenitive: "{{count}} месяцы",
            pluralGenitive: "{{count}} месяцаў"
        }
    }),
    aboutXMonths: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} месяца",
            singularGenitive: "каля {{count}} месяцаў",
            pluralGenitive: "каля {{count}} месяцаў"
        },
        future: {
            singularNominative: "прыблізна праз {{count}} месяц",
            singularGenitive: "прыблізна праз {{count}} месяцы",
            pluralGenitive: "прыблізна праз {{count}} месяцаў"
        }
    }),
    xMonths: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} месяц",
            singularGenitive: "{{count}} месяцы",
            pluralGenitive: "{{count}} месяцаў"
        }
    }),
    aboutXYears: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "каля {{count}} года",
            singularGenitive: "каля {{count}} гадоў",
            pluralGenitive: "каля {{count}} гадоў"
        },
        future: {
            singularNominative: "прыблізна праз {{count}} год",
            singularGenitive: "прыблізна праз {{count}} гады",
            pluralGenitive: "прыблізна праз {{count}} гадоў"
        }
    }),
    xYears: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} год",
            singularGenitive: "{{count}} гады",
            pluralGenitive: "{{count}} гадоў"
        }
    }),
    overXYears: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "больш за {{count}} год",
            singularGenitive: "больш за {{count}} гады",
            pluralGenitive: "больш за {{count}} гадоў"
        },
        future: {
            singularNominative: "больш, чым праз {{count}} год",
            singularGenitive: "больш, чым праз {{count}} гады",
            pluralGenitive: "больш, чым праз {{count}} гадоў"
        }
    }),
    almostXYears: $511cdeae4b6a34b3$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "амаль {{count}} год",
            singularGenitive: "амаль {{count}} гады",
            pluralGenitive: "амаль {{count}} гадоў"
        },
        future: {
            singularNominative: "амаль праз {{count}} год",
            singularGenitive: "амаль праз {{count}} гады",
            pluralGenitive: "амаль праз {{count}} гадоў"
        }
    })
};
var $511cdeae4b6a34b3$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $511cdeae4b6a34b3$var$formatDistanceLocale[token](count, options);
};
var $511cdeae4b6a34b3$export$2e2bcd8739ae039 = $511cdeae4b6a34b3$var$formatDistance;



var $056035a916193e48$var$dateFormats = {
    full: "EEEE, d MMMM y 'г.'",
    long: "d MMMM y 'г.'",
    medium: "d MMM y 'г.'",
    short: "dd.MM.y"
};
var $056035a916193e48$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $056035a916193e48$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $056035a916193e48$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $056035a916193e48$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $056035a916193e48$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $056035a916193e48$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $056035a916193e48$export$2e2bcd8739ae039 = $056035a916193e48$var$formatLong;




var $cc2da73d82ba65e5$var$accusativeWeekdays = [
    "нядзелю",
    "панядзелак",
    "аўторак",
    "сераду",
    "чацьвер",
    "пятніцу",
    "суботу"
];
function $cc2da73d82ba65e5$var$lastWeek(day) {
    var weekday = $cc2da73d82ba65e5$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'у мінулую " + weekday + " а' p";
        case 1:
        case 2:
        case 4:
            return "'у мінулы " + weekday + " а' p";
    }
}
function $cc2da73d82ba65e5$var$thisWeek(day) {
    var weekday = $cc2da73d82ba65e5$var$accusativeWeekdays[day];
    return "'у " + weekday + " а' p";
}
function $cc2da73d82ba65e5$var$nextWeek(day) {
    var weekday = $cc2da73d82ba65e5$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'у наступную " + weekday + " а' p";
        case 1:
        case 2:
        case 4:
            return "'у наступны " + weekday + " а' p";
    }
}
var $cc2da73d82ba65e5$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $cc2da73d82ba65e5$var$thisWeek(day);
    else return $cc2da73d82ba65e5$var$lastWeek(day);
};
var $cc2da73d82ba65e5$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $cc2da73d82ba65e5$var$thisWeek(day);
    else return $cc2da73d82ba65e5$var$nextWeek(day);
};
var $cc2da73d82ba65e5$var$formatRelativeLocale = {
    lastWeek: $cc2da73d82ba65e5$var$lastWeekFormat,
    yesterday: "'учора а' p",
    today: "'сёньня а' p",
    tomorrow: "'заўтра а' p",
    nextWeek: $cc2da73d82ba65e5$var$nextWeekFormat,
    other: "P"
};
var $cc2da73d82ba65e5$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $cc2da73d82ba65e5$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $cc2da73d82ba65e5$export$2e2bcd8739ae039 = $cc2da73d82ba65e5$var$formatRelative;



var $d5cddadbe809a6aa$var$eraValues = {
    narrow: [
        "да н.э.",
        "н.э."
    ],
    abbreviated: [
        "да н. э.",
        "н. э."
    ],
    wide: [
        "да нашай эры",
        "нашай эры"
    ]
};
var $d5cddadbe809a6aa$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-ы кв.",
        "2-і кв.",
        "3-і кв.",
        "4-ы кв."
    ],
    wide: [
        "1-ы квартал",
        "2-і квартал",
        "3-і квартал",
        "4-ы квартал"
    ]
};
var $d5cddadbe809a6aa$var$monthValues = {
    narrow: [
        "С",
        "Л",
        "С",
        "К",
        "Т",
        "Ч",
        "Л",
        "Ж",
        "В",
        "К",
        "Л",
        "С"
    ],
    abbreviated: [
        "студз.",
        "лют.",
        "сак.",
        "крас.",
        "трав.",
        "чэрв.",
        "ліп.",
        "жн.",
        "вер.",
        "кастр.",
        "ліст.",
        "сьнеж."
    ],
    wide: [
        "студзень",
        "люты",
        "сакавік",
        "красавік",
        "травень",
        "чэрвень",
        "ліпень",
        "жнівень",
        "верасень",
        "кастрычнік",
        "лістапад",
        "сьнежань"
    ]
};
var $d5cddadbe809a6aa$var$formattingMonthValues = {
    narrow: [
        "С",
        "Л",
        "С",
        "К",
        "Т",
        "Ч",
        "Л",
        "Ж",
        "В",
        "К",
        "Л",
        "С"
    ],
    abbreviated: [
        "студз.",
        "лют.",
        "сак.",
        "крас.",
        "трав.",
        "чэрв.",
        "ліп.",
        "жн.",
        "вер.",
        "кастр.",
        "ліст.",
        "сьнеж."
    ],
    wide: [
        "студзеня",
        "лютага",
        "сакавіка",
        "красавіка",
        "траўня",
        "чэрвеня",
        "ліпеня",
        "жніўня",
        "верасня",
        "кастрычніка",
        "лістапада",
        "сьнежня"
    ]
};
var $d5cddadbe809a6aa$var$dayValues = {
    narrow: [
        "Н",
        "П",
        "А",
        "С",
        "Ч",
        "П",
        "С"
    ],
    short: [
        "нд",
        "пн",
        "аў",
        "ср",
        "чц",
        "пт",
        "сб"
    ],
    abbreviated: [
        "нядз",
        "пан",
        "аўт",
        "сер",
        "чаць",
        "пят",
        "суб"
    ],
    wide: [
        "нядзеля",
        "панядзелак",
        "аўторак",
        "серада",
        "чацьвер",
        "пятніца",
        "субота"
    ]
};
var $d5cddadbe809a6aa$var$dayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дзень",
        evening: "веч.",
        night: "ноч"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дзень",
        evening: "веч.",
        night: "ноч"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўнач",
        noon: "поўдзень",
        morning: "раніца",
        afternoon: "дзень",
        evening: "вечар",
        night: "ноч"
    }
};
var $d5cddadbe809a6aa$var$formattingDayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дня",
        evening: "веч.",
        night: "ночы"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўн.",
        noon: "поўд.",
        morning: "ран.",
        afternoon: "дня",
        evening: "веч.",
        night: "ночы"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "поўнач",
        noon: "поўдзень",
        morning: "раніцы",
        afternoon: "дня",
        evening: "вечара",
        night: "ночы"
    }
};
var $d5cddadbe809a6aa$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-га";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-я";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-і" : "-ы";
    return number + suffix;
};
var $d5cddadbe809a6aa$var$localize = {
    ordinalNumber: $d5cddadbe809a6aa$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d5cddadbe809a6aa$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d5cddadbe809a6aa$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d5cddadbe809a6aa$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $d5cddadbe809a6aa$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d5cddadbe809a6aa$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d5cddadbe809a6aa$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $d5cddadbe809a6aa$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $d5cddadbe809a6aa$export$2e2bcd8739ae039 = $d5cddadbe809a6aa$var$localize;




var $4367b799e95d23fc$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $4367b799e95d23fc$var$parseOrdinalNumberPattern = /\d+/i;
var $4367b799e95d23fc$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $4367b799e95d23fc$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $4367b799e95d23fc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $4367b799e95d23fc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4367b799e95d23fc$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var $4367b799e95d23fc$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $4367b799e95d23fc$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $4367b799e95d23fc$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $4367b799e95d23fc$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $4367b799e95d23fc$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $4367b799e95d23fc$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $4367b799e95d23fc$var$matchOrdinalNumberPattern,
        parsePattern: $4367b799e95d23fc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4367b799e95d23fc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4367b799e95d23fc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4367b799e95d23fc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4367b799e95d23fc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4367b799e95d23fc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4367b799e95d23fc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4367b799e95d23fc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4367b799e95d23fc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4367b799e95d23fc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4367b799e95d23fc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $4367b799e95d23fc$export$2e2bcd8739ae039 = $4367b799e95d23fc$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var $5693041554d6599b$var$locale = {
    code: "be-tarask",
    formatDistance: (0, $511cdeae4b6a34b3$export$2e2bcd8739ae039),
    formatLong: (0, $056035a916193e48$export$2e2bcd8739ae039),
    formatRelative: (0, $cc2da73d82ba65e5$export$2e2bcd8739ae039),
    localize: (0, $d5cddadbe809a6aa$export$2e2bcd8739ae039),
    match: (0, $4367b799e95d23fc$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $5693041554d6599b$export$2e2bcd8739ae039 = $5693041554d6599b$var$locale;


var $8781134f312f9dc1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "по-малко от секунда",
        other: "по-малко от {{count}} секунди"
    },
    xSeconds: {
        one: "1 секунда",
        other: "{{count}} секунди"
    },
    halfAMinute: "половин минута",
    lessThanXMinutes: {
        one: "по-малко от минута",
        other: "по-малко от {{count}} минути"
    },
    xMinutes: {
        one: "1 минута",
        other: "{{count}} минути"
    },
    aboutXHours: {
        one: "около час",
        other: "около {{count}} часа"
    },
    xHours: {
        one: "1 час",
        other: "{{count}} часа"
    },
    xDays: {
        one: "1 ден",
        other: "{{count}} дни"
    },
    aboutXWeeks: {
        one: "около седмица",
        other: "около {{count}} седмици"
    },
    xWeeks: {
        one: "1 седмица",
        other: "{{count}} седмици"
    },
    aboutXMonths: {
        one: "около месец",
        other: "около {{count}} месеца"
    },
    xMonths: {
        one: "1 месец",
        other: "{{count}} месеца"
    },
    aboutXYears: {
        one: "около година",
        other: "около {{count}} години"
    },
    xYears: {
        one: "1 година",
        other: "{{count}} години"
    },
    overXYears: {
        one: "над година",
        other: "над {{count}} години"
    },
    almostXYears: {
        one: "почти година",
        other: "почти {{count}} години"
    }
};
var $8781134f312f9dc1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8781134f312f9dc1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "след " + result;
        else return "преди " + result;
    }
    return result;
};
var $8781134f312f9dc1$export$2e2bcd8739ae039 = $8781134f312f9dc1$var$formatDistance;



var $79b43667785a8d27$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
var $79b43667785a8d27$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
var $79b43667785a8d27$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
var $79b43667785a8d27$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $79b43667785a8d27$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $79b43667785a8d27$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $79b43667785a8d27$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $79b43667785a8d27$export$2e2bcd8739ae039 = $79b43667785a8d27$var$formatLong;




// Adapted from the `ru` translation
var $a03340fe03cfea85$var$weekdays = [
    "неделя",
    "понеделник",
    "вторник",
    "сряда",
    "четвъртък",
    "петък",
    "събота"
];
function $a03340fe03cfea85$var$lastWeek(day) {
    var weekday = $a03340fe03cfea85$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'миналата " + weekday + " в' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'миналия " + weekday + " в' p";
    }
}
function $a03340fe03cfea85$var$thisWeek(day) {
    var weekday = $a03340fe03cfea85$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'във " + weekday + " в' p";
    else return "'в " + weekday + " в' p";
}
function $a03340fe03cfea85$var$nextWeek(day) {
    var weekday = $a03340fe03cfea85$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'следващата " + weekday + " в' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'следващия " + weekday + " в' p";
    }
}
var $a03340fe03cfea85$var$lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $a03340fe03cfea85$var$thisWeek(day);
    else return $a03340fe03cfea85$var$lastWeek(day);
};
var $a03340fe03cfea85$var$nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $a03340fe03cfea85$var$thisWeek(day);
    else return $a03340fe03cfea85$var$nextWeek(day);
};
var $a03340fe03cfea85$var$formatRelativeLocale = {
    lastWeek: $a03340fe03cfea85$var$lastWeekFormatToken,
    yesterday: "'вчера в' p",
    today: "'днес в' p",
    tomorrow: "'утре в' p",
    nextWeek: $a03340fe03cfea85$var$nextWeekFormatToken,
    other: "P"
};
var $a03340fe03cfea85$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $a03340fe03cfea85$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $a03340fe03cfea85$export$2e2bcd8739ae039 = $a03340fe03cfea85$var$formatRelative;



var $a72299af5bed254d$var$eraValues = {
    narrow: [
        "пр.н.е.",
        "н.е."
    ],
    abbreviated: [
        "преди н. е.",
        "н. е."
    ],
    wide: [
        "преди новата ера",
        "новата ера"
    ]
};
var $a72299af5bed254d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-во тримес.",
        "2-ро тримес.",
        "3-то тримес.",
        "4-то тримес."
    ],
    wide: [
        "1-во тримесечие",
        "2-ро тримесечие",
        "3-то тримесечие",
        "4-то тримесечие"
    ]
};
var $a72299af5bed254d$var$monthValues = {
    abbreviated: [
        "яну",
        "фев",
        "мар",
        "апр",
        "май",
        "юни",
        "юли",
        "авг",
        "сеп",
        "окт",
        "ное",
        "дек"
    ],
    wide: [
        "януари",
        "февруари",
        "март",
        "април",
        "май",
        "юни",
        "юли",
        "август",
        "септември",
        "октомври",
        "ноември",
        "декември"
    ]
};
var $a72299af5bed254d$var$dayValues = {
    narrow: [
        "Н",
        "П",
        "В",
        "С",
        "Ч",
        "П",
        "С"
    ],
    short: [
        "нд",
        "пн",
        "вт",
        "ср",
        "чт",
        "пт",
        "сб"
    ],
    abbreviated: [
        "нед",
        "пон",
        "вто",
        "сря",
        "чет",
        "пет",
        "съб"
    ],
    wide: [
        "неделя",
        "понеделник",
        "вторник",
        "сряда",
        "четвъртък",
        "петък",
        "събота"
    ]
};
var $a72299af5bed254d$var$dayPeriodValues = {
    wide: {
        am: "преди обяд",
        pm: "след обяд",
        midnight: "в полунощ",
        noon: "на обяд",
        morning: "сутринта",
        afternoon: "следобед",
        evening: "вечерта",
        night: "през нощта"
    }
};
function $a72299af5bed254d$var$isFeminine(unit) {
    return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function $a72299af5bed254d$var$isNeuter(unit) {
    return unit === "quarter";
}
function $a72299af5bed254d$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = $a72299af5bed254d$var$isNeuter(unit) ? neuter : $a72299af5bed254d$var$isFeminine(unit) ? feminine : masculine;
    return number + "-" + suffix;
}
var $a72299af5bed254d$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return $a72299af5bed254d$var$numberWithSuffix(0, unit, "ев", "ева", "ево");
    else if (number % 1000 === 0) return $a72299af5bed254d$var$numberWithSuffix(number, unit, "ен", "на", "но");
    else if (number % 100 === 0) return $a72299af5bed254d$var$numberWithSuffix(number, unit, "тен", "тна", "тно");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $a72299af5bed254d$var$numberWithSuffix(number, unit, "ви", "ва", "во");
        case 2:
            return $a72299af5bed254d$var$numberWithSuffix(number, unit, "ри", "ра", "ро");
        case 7:
        case 8:
            return $a72299af5bed254d$var$numberWithSuffix(number, unit, "ми", "ма", "мо");
    }
    return $a72299af5bed254d$var$numberWithSuffix(number, unit, "ти", "та", "то");
};
var $a72299af5bed254d$var$localize = {
    ordinalNumber: $a72299af5bed254d$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a72299af5bed254d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a72299af5bed254d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a72299af5bed254d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a72299af5bed254d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a72299af5bed254d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $a72299af5bed254d$export$2e2bcd8739ae039 = $a72299af5bed254d$var$localize;




var $418592a27b7bf81d$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var $418592a27b7bf81d$var$parseOrdinalNumberPattern = /\d+/i;
var $418592a27b7bf81d$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var $418592a27b7bf81d$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $418592a27b7bf81d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var $418592a27b7bf81d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $418592a27b7bf81d$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var $418592a27b7bf81d$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var $418592a27b7bf81d$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var $418592a27b7bf81d$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $418592a27b7bf81d$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var $418592a27b7bf81d$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var $418592a27b7bf81d$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $418592a27b7bf81d$var$matchOrdinalNumberPattern,
        parsePattern: $418592a27b7bf81d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $418592a27b7bf81d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $418592a27b7bf81d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $418592a27b7bf81d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $418592a27b7bf81d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $418592a27b7bf81d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $418592a27b7bf81d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $418592a27b7bf81d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $418592a27b7bf81d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $418592a27b7bf81d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $418592a27b7bf81d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $418592a27b7bf81d$export$2e2bcd8739ae039 = $418592a27b7bf81d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var $205654a4bdf8c548$var$locale = {
    code: "bg",
    formatDistance: (0, $8781134f312f9dc1$export$2e2bcd8739ae039),
    formatLong: (0, $79b43667785a8d27$export$2e2bcd8739ae039),
    formatRelative: (0, $a03340fe03cfea85$export$2e2bcd8739ae039),
    localize: (0, $a72299af5bed254d$export$2e2bcd8739ae039),
    match: (0, $418592a27b7bf81d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $205654a4bdf8c548$export$2e2bcd8739ae039 = $205654a4bdf8c548$var$locale;



var $c3a83793ed7817f6$var$numberValues = {
    locale: {
        "1": "১",
        "2": "২",
        "3": "৩",
        "4": "৪",
        "5": "৫",
        "6": "৬",
        "7": "৭",
        "8": "৮",
        "9": "৯",
        "0": "০"
    },
    number: {
        "১": "1",
        "২": "2",
        "৩": "3",
        "৪": "4",
        "৫": "5",
        "৬": "6",
        "৭": "7",
        "৮": "8",
        "৯": "9",
        "০": "0"
    }
};
var $c3a83793ed7817f6$var$eraValues = {
    narrow: [
        "খ্রিঃপূঃ",
        "খ্রিঃ"
    ],
    abbreviated: [
        "খ্রিঃপূর্ব",
        "খ্রিঃ"
    ],
    wide: [
        "খ্রিস্টপূর্ব",
        "খ্রিস্টাব্দ"
    ]
};
var $c3a83793ed7817f6$var$quarterValues = {
    narrow: [
        "১",
        "২",
        "৩",
        "৪"
    ],
    abbreviated: [
        "১ত্রৈ",
        "২ত্রৈ",
        "৩ত্রৈ",
        "৪ত্রৈ"
    ],
    wide: [
        "১ম ত্রৈমাসিক",
        "২য় ত্রৈমাসিক",
        "৩য় ত্রৈমাসিক",
        "৪র্থ ত্রৈমাসিক"
    ]
};
var $c3a83793ed7817f6$var$monthValues = {
    narrow: [
        "জানু",
        "ফেব্রু",
        "মার্চ",
        "এপ্রিল",
        "মে",
        "জুন",
        "জুলাই",
        "আগস্ট",
        "সেপ্ট",
        "অক্টো",
        "নভে",
        "ডিসে"
    ],
    abbreviated: [
        "জানু",
        "ফেব্রু",
        "মার্চ",
        "এপ্রিল",
        "মে",
        "জুন",
        "জুলাই",
        "আগস্ট",
        "সেপ্ট",
        "অক্টো",
        "নভে",
        "ডিসে"
    ],
    wide: [
        "জানুয়ারি",
        "ফেব্রুয়ারি",
        "মার্চ",
        "এপ্রিল",
        "মে",
        "জুন",
        "জুলাই",
        "আগস্ট",
        "সেপ্টেম্বর",
        "অক্টোবর",
        "নভেম্বর",
        "ডিসেম্বর"
    ]
};
var $c3a83793ed7817f6$var$dayValues = {
    narrow: [
        "র",
        "সো",
        "ম",
        "বু",
        "বৃ",
        "শু",
        "শ"
    ],
    short: [
        "রবি",
        "সোম",
        "মঙ্গল",
        "বুধ",
        "বৃহ",
        "শুক্র",
        "শনি"
    ],
    abbreviated: [
        "রবি",
        "সোম",
        "মঙ্গল",
        "বুধ",
        "বৃহ",
        "শুক্র",
        "শনি"
    ],
    wide: [
        "রবিবার",
        "সোমবার",
        "মঙ্গলবার",
        "বুধবার",
        "বৃহস্পতিবার ",
        "শুক্রবার",
        "শনিবার"
    ]
};
var $c3a83793ed7817f6$var$dayPeriodValues = {
    narrow: {
        am: "পূ",
        pm: "অপ",
        midnight: "মধ্যরাত",
        noon: "মধ্যাহ্ন",
        morning: "সকাল",
        afternoon: "বিকাল",
        evening: "সন্ধ্যা",
        night: "রাত"
    },
    abbreviated: {
        am: "পূর্বাহ্ন",
        pm: "অপরাহ্ন",
        midnight: "মধ্যরাত",
        noon: "মধ্যাহ্ন",
        morning: "সকাল",
        afternoon: "বিকাল",
        evening: "সন্ধ্যা",
        night: "রাত"
    },
    wide: {
        am: "পূর্বাহ্ন",
        pm: "অপরাহ্ন",
        midnight: "মধ্যরাত",
        noon: "মধ্যাহ্ন",
        morning: "সকাল",
        afternoon: "বিকাল",
        evening: "সন্ধ্যা",
        night: "রাত"
    }
};
var $c3a83793ed7817f6$var$formattingDayPeriodValues = {
    narrow: {
        am: "পূ",
        pm: "অপ",
        midnight: "মধ্যরাত",
        noon: "মধ্যাহ্ন",
        morning: "সকাল",
        afternoon: "বিকাল",
        evening: "সন্ধ্যা",
        night: "রাত"
    },
    abbreviated: {
        am: "পূর্বাহ্ন",
        pm: "অপরাহ্ন",
        midnight: "মধ্যরাত",
        noon: "মধ্যাহ্ন",
        morning: "সকাল",
        afternoon: "বিকাল",
        evening: "সন্ধ্যা",
        night: "রাত"
    },
    wide: {
        am: "পূর্বাহ্ন",
        pm: "অপরাহ্ন",
        midnight: "মধ্যরাত",
        noon: "মধ্যাহ্ন",
        morning: "সকাল",
        afternoon: "বিকাল",
        evening: "সন্ধ্যা",
        night: "রাত"
    }
};
function $c3a83793ed7817f6$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "শে";
    else switch(number){
        case 1:
            return localeNumber + "লা";
        case 2:
        case 3:
            return localeNumber + "রা";
        case 4:
            return localeNumber + "ঠা";
        default:
            return localeNumber + "ই";
    }
}
var $c3a83793ed7817f6$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = $c3a83793ed7817f6$export$3e1d599946644f03(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === "date") return $c3a83793ed7817f6$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "তম";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "য়";
        case 4:
            return localeNumber + "র্থ";
        case 6:
            return localeNumber + "ষ্ঠ";
        default:
            return localeNumber + "ম";
    }
};
function $c3a83793ed7817f6$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $c3a83793ed7817f6$var$numberValues.locale[match];
    });
}
var $c3a83793ed7817f6$var$localize = {
    ordinalNumber: $c3a83793ed7817f6$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c3a83793ed7817f6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c3a83793ed7817f6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c3a83793ed7817f6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c3a83793ed7817f6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c3a83793ed7817f6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c3a83793ed7817f6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c3a83793ed7817f6$export$2e2bcd8739ae039 = $c3a83793ed7817f6$var$localize;


var $917a7cf01e58de27$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "প্রায় ১ সেকেন্ড",
        other: "প্রায় {{count}} সেকেন্ড"
    },
    xSeconds: {
        one: "১ সেকেন্ড",
        other: "{{count}} সেকেন্ড"
    },
    halfAMinute: "আধ মিনিট",
    lessThanXMinutes: {
        one: "প্রায় ১ মিনিট",
        other: "প্রায় {{count}} মিনিট"
    },
    xMinutes: {
        one: "১ মিনিট",
        other: "{{count}} মিনিট"
    },
    aboutXHours: {
        one: "প্রায় ১ ঘন্টা",
        other: "প্রায় {{count}} ঘন্টা"
    },
    xHours: {
        one: "১ ঘন্টা",
        other: "{{count}} ঘন্টা"
    },
    xDays: {
        one: "১ দিন",
        other: "{{count}} দিন"
    },
    aboutXWeeks: {
        one: "প্রায় ১ সপ্তাহ",
        other: "প্রায় {{count}} সপ্তাহ"
    },
    xWeeks: {
        one: "১ সপ্তাহ",
        other: "{{count}} সপ্তাহ"
    },
    aboutXMonths: {
        one: "প্রায় ১ মাস",
        other: "প্রায় {{count}} মাস"
    },
    xMonths: {
        one: "১ মাস",
        other: "{{count}} মাস"
    },
    aboutXYears: {
        one: "প্রায় ১ বছর",
        other: "প্রায় {{count}} বছর"
    },
    xYears: {
        one: "১ বছর",
        other: "{{count}} বছর"
    },
    overXYears: {
        one: "১ বছরের বেশি",
        other: "{{count}} বছরের বেশি"
    },
    almostXYears: {
        one: "প্রায় ১ বছর",
        other: "প্রায় {{count}} বছর"
    }
};
var $917a7cf01e58de27$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $917a7cf01e58de27$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $c3a83793ed7817f6$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " এর মধ্যে";
        else return result + " আগে";
    }
    return result;
};
var $917a7cf01e58de27$export$2e2bcd8739ae039 = $917a7cf01e58de27$var$formatDistance;



var $dd19a87881bc0b08$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $dd19a87881bc0b08$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $dd19a87881bc0b08$var$dateTimeFormats = {
    full: "{{date}} {{time}} 'সময়'",
    long: "{{date}} {{time}} 'সময়'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $dd19a87881bc0b08$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $dd19a87881bc0b08$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $dd19a87881bc0b08$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $dd19a87881bc0b08$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $dd19a87881bc0b08$export$2e2bcd8739ae039 = $dd19a87881bc0b08$var$formatLong;


var $ec4f89ba7210a04f$var$formatRelativeLocale = {
    lastWeek: "'গত' eeee 'সময়' p",
    yesterday: "'গতকাল' 'সময়' p",
    today: "'আজ' 'সময়' p",
    tomorrow: "'আগামীকাল' 'সময়' p",
    nextWeek: "eeee 'সময়' p",
    other: "P"
};
var $ec4f89ba7210a04f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ec4f89ba7210a04f$var$formatRelativeLocale[token];
};
var $ec4f89ba7210a04f$export$2e2bcd8739ae039 = $ec4f89ba7210a04f$var$formatRelative;





var $65447203a645ff40$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var $65447203a645ff40$var$parseOrdinalNumberPattern = /\d+/i;
var $65447203a645ff40$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var $65447203a645ff40$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var $65447203a645ff40$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var $65447203a645ff40$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var $65447203a645ff40$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var $65447203a645ff40$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var $65447203a645ff40$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var $65447203a645ff40$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var $65447203a645ff40$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var $65447203a645ff40$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var $65447203a645ff40$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $65447203a645ff40$var$matchOrdinalNumberPattern,
        parsePattern: $65447203a645ff40$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65447203a645ff40$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65447203a645ff40$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65447203a645ff40$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65447203a645ff40$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65447203a645ff40$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65447203a645ff40$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65447203a645ff40$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65447203a645ff40$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65447203a645ff40$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65447203a645ff40$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $65447203a645ff40$export$2e2bcd8739ae039 = $65447203a645ff40$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var $b17b6c6f54b3410a$var$locale = {
    code: "bn",
    formatDistance: (0, $917a7cf01e58de27$export$2e2bcd8739ae039),
    formatLong: (0, $dd19a87881bc0b08$export$2e2bcd8739ae039),
    formatRelative: (0, $ec4f89ba7210a04f$export$2e2bcd8739ae039),
    localize: (0, $c3a83793ed7817f6$export$2e2bcd8739ae039),
    match: (0, $65447203a645ff40$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b17b6c6f54b3410a$export$2e2bcd8739ae039 = $b17b6c6f54b3410a$var$locale;


var $e3741973b45377e0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 sedmicu",
            withPrepositionAgo: "oko 1 sedmicu",
            withPrepositionIn: "oko 1 sedmicu"
        },
        dual: "oko {{count}} sedmice",
        other: "oko {{count}} sedmice"
    },
    xWeeks: {
        one: {
            standalone: "1 sedmicu",
            withPrepositionAgo: "1 sedmicu",
            withPrepositionIn: "1 sedmicu"
        },
        dual: "{{count}} sedmice",
        other: "{{count}} sedmice"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
var $e3741973b45377e0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e3741973b45377e0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
var $e3741973b45377e0$export$2e2bcd8739ae039 = $e3741973b45377e0$var$formatDistance;



var $769ab7e3e996f5a4$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
var $769ab7e3e996f5a4$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $769ab7e3e996f5a4$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $769ab7e3e996f5a4$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $769ab7e3e996f5a4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $769ab7e3e996f5a4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $769ab7e3e996f5a4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $769ab7e3e996f5a4$export$2e2bcd8739ae039 = $769ab7e3e996f5a4$var$formatLong;


var $77403ff69f0b2901$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'prošle nedjelje u' p";
            case 3:
                return "'prošle srijede u' p";
            case 6:
                return "'prošle subote u' p";
            default:
                return "'prošli' EEEE 'u' p";
        }
    },
    yesterday: "'juče u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljedeće nedjelje u' p";
            case 3:
                return "'sljedeću srijedu u' p";
            case 6:
                return "'sljedeću subotu u' p";
            default:
                return "'sljedeći' EEEE 'u' p";
        }
    },
    other: "P"
};
var $77403ff69f0b2901$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $77403ff69f0b2901$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $77403ff69f0b2901$export$2e2bcd8739ae039 = $77403ff69f0b2901$var$formatRelative;



var $a8e80d18e06851b8$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Prije Hrista",
        "Poslije Hrista"
    ]
};
var $a8e80d18e06851b8$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $a8e80d18e06851b8$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $a8e80d18e06851b8$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $a8e80d18e06851b8$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "Č",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "čet",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "čet",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "četvrtak",
        "petak",
        "subota"
    ]
};
var $a8e80d18e06851b8$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uveče",
        night: "noću"
    }
};
var $a8e80d18e06851b8$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uveče",
        night: "noću"
    }
};
var $a8e80d18e06851b8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + ".";
};
var $a8e80d18e06851b8$var$localize = {
    ordinalNumber: $a8e80d18e06851b8$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a8e80d18e06851b8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a8e80d18e06851b8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a8e80d18e06851b8$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $a8e80d18e06851b8$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a8e80d18e06851b8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a8e80d18e06851b8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a8e80d18e06851b8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a8e80d18e06851b8$export$2e2bcd8739ae039 = $a8e80d18e06851b8$var$localize;




var $1f37afcc26fefda0$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $1f37afcc26fefda0$var$parseOrdinalNumberPattern = /\d+/i;
var $1f37afcc26fefda0$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var $1f37afcc26fefda0$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $1f37afcc26fefda0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $1f37afcc26fefda0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1f37afcc26fefda0$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $1f37afcc26fefda0$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $1f37afcc26fefda0$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $1f37afcc26fefda0$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $1f37afcc26fefda0$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var $1f37afcc26fefda0$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $1f37afcc26fefda0$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $1f37afcc26fefda0$var$matchOrdinalNumberPattern,
        parsePattern: $1f37afcc26fefda0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1f37afcc26fefda0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f37afcc26fefda0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1f37afcc26fefda0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f37afcc26fefda0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1f37afcc26fefda0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f37afcc26fefda0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1f37afcc26fefda0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1f37afcc26fefda0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1f37afcc26fefda0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1f37afcc26fefda0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $1f37afcc26fefda0$export$2e2bcd8739ae039 = $1f37afcc26fefda0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var $1bde6a6ee1d2cdc1$var$locale = {
    code: "bs",
    formatDistance: (0, $e3741973b45377e0$export$2e2bcd8739ae039),
    formatLong: (0, $769ab7e3e996f5a4$export$2e2bcd8739ae039),
    formatRelative: (0, $77403ff69f0b2901$export$2e2bcd8739ae039),
    localize: (0, $a8e80d18e06851b8$export$2e2bcd8739ae039),
    match: (0, $1f37afcc26fefda0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1bde6a6ee1d2cdc1$export$2e2bcd8739ae039 = $1bde6a6ee1d2cdc1$var$locale;


/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var $bfc1596c1d256142$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: "menys de {{count}} segons"
    },
    xSeconds: {
        one: "1 segon",
        other: "{{count}} segons"
    },
    halfAMinute: "mig minut",
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: "menys de {{count}} minuts"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minuts"
    },
    aboutXHours: {
        one: "aproximadament una hora",
        other: "aproximadament {{count}} hores"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} hores"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dies"
    },
    aboutXWeeks: {
        one: "aproximadament una setmana",
        other: "aproximadament {{count}} setmanes"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanes"
    },
    aboutXMonths: {
        one: "aproximadament un mes",
        other: "aproximadament {{count}} mesos"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} mesos"
    },
    aboutXYears: {
        one: "aproximadament un any",
        other: "aproximadament {{count}} anys"
    },
    xYears: {
        one: "1 any",
        other: "{{count}} anys"
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var $bfc1596c1d256142$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bfc1596c1d256142$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "fa " + result;
    }
    return result;
};
var $bfc1596c1d256142$export$2e2bcd8739ae039 = $bfc1596c1d256142$var$formatDistance;



var $1c378434c6ef08d6$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $1c378434c6ef08d6$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $1c378434c6ef08d6$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $1c378434c6ef08d6$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $1c378434c6ef08d6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $1c378434c6ef08d6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $1c378434c6ef08d6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $1c378434c6ef08d6$export$2e2bcd8739ae039 = $1c378434c6ef08d6$var$formatLong;


var $9bc219885905a5dd$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
var $9bc219885905a5dd$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: "P"
};
var $9bc219885905a5dd$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $9bc219885905a5dd$var$formatRelativeLocalePlural[token];
    return $9bc219885905a5dd$var$formatRelativeLocale[token];
};
var $9bc219885905a5dd$export$2e2bcd8739ae039 = $9bc219885905a5dd$var$formatRelative;



/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $a37a085bf8be5ca0$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a. de C.",
        "d. de C."
    ],
    wide: [
        "abans de Crist",
        "despr\xe9s de Crist"
    ]
};
var $a37a085bf8be5ca0$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1r trimestre",
        "2n trimestre",
        "3r trimestre",
        "4t trimestre"
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $a37a085bf8be5ca0$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MG",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DS"
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "maig",
        "juny",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "des."
    ],
    wide: [
        "gener",
        "febrer",
        "mar\xe7",
        "abril",
        "maig",
        "juny",
        "juliol",
        "agost",
        "setembre",
        "octubre",
        "novembre",
        "desembre"
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var $a37a085bf8be5ca0$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "diumenge",
        "dilluns",
        "dimarts",
        "dimecres",
        "dijous",
        "divendres",
        "dissabte"
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var $a37a085bf8be5ca0$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    }
};
var $a37a085bf8be5ca0$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var $a37a085bf8be5ca0$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "r";
        case 2:
            return number + "n";
        case 3:
            return number + "r";
        case 4:
            return number + "t";
    }
    return number + "\xe8";
};
var $a37a085bf8be5ca0$var$localize = {
    ordinalNumber: $a37a085bf8be5ca0$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a37a085bf8be5ca0$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a37a085bf8be5ca0$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a37a085bf8be5ca0$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a37a085bf8be5ca0$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a37a085bf8be5ca0$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a37a085bf8be5ca0$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a37a085bf8be5ca0$export$2e2bcd8739ae039 = $a37a085bf8be5ca0$var$localize;




var $09cc47b31bea2769$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var $09cc47b31bea2769$var$parseOrdinalNumberPattern = /\d+/i;
var $09cc47b31bea2769$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var $09cc47b31bea2769$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var $09cc47b31bea2769$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var $09cc47b31bea2769$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $09cc47b31bea2769$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var $09cc47b31bea2769$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var $09cc47b31bea2769$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var $09cc47b31bea2769$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var $09cc47b31bea2769$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var $09cc47b31bea2769$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var $09cc47b31bea2769$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $09cc47b31bea2769$var$matchOrdinalNumberPattern,
        parsePattern: $09cc47b31bea2769$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $09cc47b31bea2769$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09cc47b31bea2769$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $09cc47b31bea2769$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09cc47b31bea2769$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $09cc47b31bea2769$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09cc47b31bea2769$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $09cc47b31bea2769$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09cc47b31bea2769$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $09cc47b31bea2769$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09cc47b31bea2769$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $09cc47b31bea2769$export$2e2bcd8739ae039 = $09cc47b31bea2769$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var $a7e8afa2a884d090$var$locale = {
    code: "ca",
    formatDistance: (0, $bfc1596c1d256142$export$2e2bcd8739ae039),
    formatLong: (0, $1c378434c6ef08d6$export$2e2bcd8739ae039),
    formatRelative: (0, $9bc219885905a5dd$export$2e2bcd8739ae039),
    localize: (0, $a37a085bf8be5ca0$export$2e2bcd8739ae039),
    match: (0, $09cc47b31bea2769$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a7e8afa2a884d090$export$2e2bcd8739ae039 // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
 = $a7e8afa2a884d090$var$locale;


var $01686e7150fa7739$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9ně než sekunda",
            past: "před m\xe9ně než sekundou",
            future: "za m\xe9ně než sekundu"
        },
        few: {
            regular: "m\xe9ně než {{count}} sekundy",
            past: "před m\xe9ně než {{count}} sekundami",
            future: "za m\xe9ně než {{count}} sekundy"
        },
        many: {
            regular: "m\xe9ně než {{count}} sekund",
            past: "před m\xe9ně než {{count}} sekundami",
            future: "za m\xe9ně než {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "před sekundou",
            future: "za sekundu"
        },
        few: {
            regular: "{{count}} sekundy",
            past: "před {{count}} sekundami",
            future: "za {{count}} sekundy"
        },
        many: {
            regular: "{{count}} sekund",
            past: "před {{count}} sekundami",
            future: "za {{count}} sekund"
        }
    },
    halfAMinute: {
        type: "other",
        other: {
            regular: "půl minuty",
            past: "před půl minutou",
            future: "za půl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9ně než minuta",
            past: "před m\xe9ně než minutou",
            future: "za m\xe9ně než minutu"
        },
        few: {
            regular: "m\xe9ně než {{count}} minuty",
            past: "před m\xe9ně než {{count}} minutami",
            future: "za m\xe9ně než {{count}} minuty"
        },
        many: {
            regular: "m\xe9ně než {{count}} minut",
            past: "před m\xe9ně než {{count}} minutami",
            future: "za m\xe9ně než {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "před minutou",
            future: "za minutu"
        },
        few: {
            regular: "{{count}} minuty",
            past: "před {{count}} minutami",
            future: "za {{count}} minuty"
        },
        many: {
            regular: "{{count}} minut",
            past: "před {{count}} minutami",
            future: "za {{count}} minut"
        }
    },
    aboutXHours: {
        one: {
            regular: "přibližně hodina",
            past: "přibližně před hodinou",
            future: "přibližně za hodinu"
        },
        few: {
            regular: "přibližně {{count}} hodiny",
            past: "přibližně před {{count}} hodinami",
            future: "přibližně za {{count}} hodiny"
        },
        many: {
            regular: "přibližně {{count}} hodin",
            past: "přibližně před {{count}} hodinami",
            future: "přibližně za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: "hodina",
            past: "před hodinou",
            future: "za hodinu"
        },
        few: {
            regular: "{{count}} hodiny",
            past: "před {{count}} hodinami",
            future: "za {{count}} hodiny"
        },
        many: {
            regular: "{{count}} hodin",
            past: "před {{count}} hodinami",
            future: "za {{count}} hodin"
        }
    },
    xDays: {
        one: {
            regular: "den",
            past: "před dnem",
            future: "za den"
        },
        few: {
            regular: "{{count}} dny",
            past: "před {{count}} dny",
            future: "za {{count}} dny"
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "před {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "přibližně t\xfdden",
            past: "přibližně před t\xfddnem",
            future: "přibližně za t\xfdden"
        },
        few: {
            regular: "přibližně {{count}} t\xfddny",
            past: "přibližně před {{count}} t\xfddny",
            future: "přibližně za {{count}} t\xfddny"
        },
        many: {
            regular: "přibližně {{count}} t\xfddnů",
            past: "přibližně před {{count}} t\xfddny",
            future: "přibližně za {{count}} t\xfddnů"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "před t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "před {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddnů",
            past: "před {{count}} t\xfddny",
            future: "za {{count}} t\xfddnů"
        }
    },
    aboutXMonths: {
        one: {
            regular: "přibližně měs\xedc",
            past: "přibližně před měs\xedcem",
            future: "přibližně za měs\xedc"
        },
        few: {
            regular: "přibližně {{count}} měs\xedce",
            past: "přibližně před {{count}} měs\xedci",
            future: "přibližně za {{count}} měs\xedce"
        },
        many: {
            regular: "přibližně {{count}} měs\xedců",
            past: "přibližně před {{count}} měs\xedci",
            future: "přibližně za {{count}} měs\xedců"
        }
    },
    xMonths: {
        one: {
            regular: "měs\xedc",
            past: "před měs\xedcem",
            future: "za měs\xedc"
        },
        few: {
            regular: "{{count}} měs\xedce",
            past: "před {{count}} měs\xedci",
            future: "za {{count}} měs\xedce"
        },
        many: {
            regular: "{{count}} měs\xedců",
            past: "před {{count}} měs\xedci",
            future: "za {{count}} měs\xedců"
        }
    },
    aboutXYears: {
        one: {
            regular: "přibližně rok",
            past: "přibližně před rokem",
            future: "přibližně za rok"
        },
        few: {
            regular: "přibližně {{count}} roky",
            past: "přibližně před {{count}} roky",
            future: "přibližně za {{count}} roky"
        },
        many: {
            regular: "přibližně {{count}} roků",
            past: "přibližně před {{count}} roky",
            future: "přibližně za {{count}} roků"
        }
    },
    xYears: {
        one: {
            regular: "rok",
            past: "před rokem",
            future: "za rok"
        },
        few: {
            regular: "{{count}} roky",
            past: "před {{count}} roky",
            future: "za {{count}} roky"
        },
        many: {
            regular: "{{count}} roků",
            past: "před {{count}} roky",
            future: "za {{count}} roků"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce než rok",
            past: "před v\xedce než rokem",
            future: "za v\xedce než rok"
        },
        few: {
            regular: "v\xedce než {{count}} roky",
            past: "před v\xedce než {{count}} roky",
            future: "za v\xedce než {{count}} roky"
        },
        many: {
            regular: "v\xedce než {{count}} roků",
            past: "před v\xedce než {{count}} roky",
            future: "za v\xedce než {{count}} roků"
        }
    },
    almostXYears: {
        one: {
            regular: "skoro rok",
            past: "skoro před rokem",
            future: "skoro za rok"
        },
        few: {
            regular: "skoro {{count}} roky",
            past: "skoro před {{count}} roky",
            future: "skoro za {{count}} roky"
        },
        many: {
            regular: "skoro {{count}} roků",
            past: "skoro před {{count}} roky",
            future: "skoro za {{count}} roků"
        }
    }
};
var $01686e7150fa7739$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $01686e7150fa7739$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === "other") pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace("{{count}}", String(count));
};
var $01686e7150fa7739$export$2e2bcd8739ae039 = $01686e7150fa7739$var$formatDistance;



var $68cfd60928ea5a92$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy",
    long: "d. MMMM yyyy",
    medium: "d. M. yyyy",
    short: "dd.MM.yyyy"
};
var $68cfd60928ea5a92$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $68cfd60928ea5a92$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $68cfd60928ea5a92$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $68cfd60928ea5a92$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $68cfd60928ea5a92$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $68cfd60928ea5a92$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $68cfd60928ea5a92$export$2e2bcd8739ae039 = $68cfd60928ea5a92$var$formatLong;


var $44d10331ba3c5f1a$var$accusativeWeekdays = [
    "neděli",
    "ponděl\xed",
    "\xfater\xfd",
    "středu",
    "čtvrtek",
    "p\xe1tek",
    "sobotu"
];
var $44d10331ba3c5f1a$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'včera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $44d10331ba3c5f1a$var$accusativeWeekdays[day] + " o' p";
    },
    other: "P"
};
var $44d10331ba3c5f1a$var$formatRelative = function formatRelative(token, date) {
    var format = $44d10331ba3c5f1a$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $44d10331ba3c5f1a$export$2e2bcd8739ae039 = $44d10331ba3c5f1a$var$formatRelative;



var $864d20445171a8a6$var$eraValues = {
    narrow: [
        "př. n. l.",
        "n. l."
    ],
    abbreviated: [
        "př. n. l.",
        "n. l."
    ],
    wide: [
        "před naš\xedm letopočtem",
        "našeho letopočtu"
    ]
};
var $864d20445171a8a6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. čtvrtlet\xed",
        "2. čtvrtlet\xed",
        "3. čtvrtlet\xed",
        "4. čtvrtlet\xed"
    ],
    wide: [
        "1. čtvrtlet\xed",
        "2. čtvrtlet\xed",
        "3. čtvrtlet\xed",
        "4. čtvrtlet\xed"
    ]
};
var $864d20445171a8a6$var$monthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "Č",
        "Č",
        "S",
        "Z",
        "Ř",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "bře",
        "dub",
        "kvě",
        "čvn",
        "čvc",
        "srp",
        "z\xe1ř",
        "ř\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "leden",
        "\xfanor",
        "březen",
        "duben",
        "květen",
        "červen",
        "červenec",
        "srpen",
        "z\xe1ř\xed",
        "ř\xedjen",
        "listopad",
        "prosinec"
    ]
};
var $864d20445171a8a6$var$formattingMonthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "Č",
        "Č",
        "S",
        "Z",
        "Ř",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "bře",
        "dub",
        "kvě",
        "čvn",
        "čvc",
        "srp",
        "z\xe1ř",
        "ř\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "ledna",
        "\xfanora",
        "března",
        "dubna",
        "května",
        "června",
        "července",
        "srpna",
        "z\xe1ř\xed",
        "ř\xedjna",
        "listopadu",
        "prosince"
    ]
};
var $864d20445171a8a6$var$dayValues = {
    narrow: [
        "ne",
        "po",
        "\xfat",
        "st",
        "čt",
        "p\xe1",
        "so"
    ],
    short: [
        "ne",
        "po",
        "\xfat",
        "st",
        "čt",
        "p\xe1",
        "so"
    ],
    abbreviated: [
        "ned",
        "pon",
        "\xfate",
        "stř",
        "čtv",
        "p\xe1t",
        "sob"
    ],
    wide: [
        "neděle",
        "ponděl\xed",
        "\xfater\xfd",
        "středa",
        "čtvrtek",
        "p\xe1tek",
        "sobota"
    ]
};
var $864d20445171a8a6$var$dayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "půlnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "večer",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "půlnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "večer",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "půlnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "večer",
        night: "noc"
    }
};
var $864d20445171a8a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "půlnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "večer",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "půlnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "večer",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "půlnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "večer",
        night: "noc"
    }
};
var $864d20445171a8a6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $864d20445171a8a6$var$localize = {
    ordinalNumber: $864d20445171a8a6$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $864d20445171a8a6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $864d20445171a8a6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $864d20445171a8a6$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $864d20445171a8a6$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $864d20445171a8a6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $864d20445171a8a6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $864d20445171a8a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $864d20445171a8a6$export$2e2bcd8739ae039 = $864d20445171a8a6$var$localize;




var $e2b6b56d56cefcf6$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $e2b6b56d56cefcf6$var$parseOrdinalNumberPattern = /\d+/i;
var $e2b6b56d56cefcf6$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $e2b6b56d56cefcf6$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $e2b6b56d56cefcf6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $e2b6b56d56cefcf6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e2b6b56d56cefcf6$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $e2b6b56d56cefcf6$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $e2b6b56d56cefcf6$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $e2b6b56d56cefcf6$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $e2b6b56d56cefcf6$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $e2b6b56d56cefcf6$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $e2b6b56d56cefcf6$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $e2b6b56d56cefcf6$var$matchOrdinalNumberPattern,
        parsePattern: $e2b6b56d56cefcf6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e2b6b56d56cefcf6$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e2b6b56d56cefcf6$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e2b6b56d56cefcf6$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e2b6b56d56cefcf6$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e2b6b56d56cefcf6$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e2b6b56d56cefcf6$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e2b6b56d56cefcf6$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e2b6b56d56cefcf6$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e2b6b56d56cefcf6$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e2b6b56d56cefcf6$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e2b6b56d56cefcf6$export$2e2bcd8739ae039 = $e2b6b56d56cefcf6$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $38d5e154b7f2a6d4$var$locale = {
    code: "cs",
    formatDistance: (0, $01686e7150fa7739$export$2e2bcd8739ae039),
    formatLong: (0, $68cfd60928ea5a92$export$2e2bcd8739ae039),
    formatRelative: (0, $44d10331ba3c5f1a$export$2e2bcd8739ae039),
    localize: (0, $864d20445171a8a6$export$2e2bcd8739ae039),
    match: (0, $e2b6b56d56cefcf6$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $38d5e154b7f2a6d4$export$2e2bcd8739ae039 = $38d5e154b7f2a6d4$var$locale;


var $e6b3897ed2e69e4c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "llai na eiliad",
        other: "llai na {{count}} eiliad"
    },
    xSeconds: {
        one: "1 eiliad",
        other: "{{count}} eiliad"
    },
    halfAMinute: "hanner munud",
    lessThanXMinutes: {
        one: "llai na munud",
        two: "llai na 2 funud",
        other: "llai na {{count}} munud"
    },
    xMinutes: {
        one: "1 munud",
        two: "2 funud",
        other: "{{count}} munud"
    },
    aboutXHours: {
        one: "tua 1 awr",
        other: "tua {{count}} awr"
    },
    xHours: {
        one: "1 awr",
        other: "{{count}} awr"
    },
    xDays: {
        one: "1 diwrnod",
        two: "2 ddiwrnod",
        other: "{{count}} diwrnod"
    },
    aboutXWeeks: {
        one: "tua 1 wythnos",
        two: "tua pythefnos",
        other: "tua {{count}} wythnos"
    },
    xWeeks: {
        one: "1 wythnos",
        two: "pythefnos",
        other: "{{count}} wythnos"
    },
    aboutXMonths: {
        one: "tua 1 mis",
        two: "tua 2 fis",
        other: "tua {{count}} mis"
    },
    xMonths: {
        one: "1 mis",
        two: "2 fis",
        other: "{{count}} mis"
    },
    aboutXYears: {
        one: "tua 1 flwyddyn",
        two: "tua 2 flynedd",
        other: "tua {{count}} mlynedd"
    },
    xYears: {
        one: "1 flwyddyn",
        two: "2 flynedd",
        other: "{{count}} mlynedd"
    },
    overXYears: {
        one: "dros 1 flwyddyn",
        two: "dros 2 flynedd",
        other: "dros {{count}} mlynedd"
    },
    almostXYears: {
        one: "bron 1 flwyddyn",
        two: "bron 2 flynedd",
        other: "bron {{count}} mlynedd"
    }
};
var $e6b3897ed2e69e4c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e6b3897ed2e69e4c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "mewn " + result;
        else return result + " yn \xf4l";
    }
    return result;
};
var $e6b3897ed2e69e4c$export$2e2bcd8739ae039 = $e6b3897ed2e69e4c$var$formatDistance;



var $2373ad36f9774bb3$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $2373ad36f9774bb3$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $2373ad36f9774bb3$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $2373ad36f9774bb3$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2373ad36f9774bb3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2373ad36f9774bb3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2373ad36f9774bb3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2373ad36f9774bb3$export$2e2bcd8739ae039 = $2373ad36f9774bb3$var$formatLong;


var $9745e52d37c3092f$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: "P"
};
var $9745e52d37c3092f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9745e52d37c3092f$var$formatRelativeLocale[token];
};
var $9745e52d37c3092f$export$2e2bcd8739ae039 = $9745e52d37c3092f$var$formatRelative;



var $6b40c3f7464b199d$var$eraValues = {
    narrow: [
        "C",
        "O"
    ],
    abbreviated: [
        "CC",
        "OC"
    ],
    wide: [
        "Cyn Crist",
        "Ar \xf4l Crist"
    ]
};
var $6b40c3f7464b199d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Ch1",
        "Ch2",
        "Ch3",
        "Ch4"
    ],
    wide: [
        "Chwarter 1af",
        "2ail chwarter",
        "3ydd chwarter",
        "4ydd chwarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $6b40c3f7464b199d$var$monthValues = {
    narrow: [
        "I",
        "Ch",
        "Ma",
        "E",
        "Mi",
        "Me",
        "G",
        "A",
        "Md",
        "H",
        "T",
        "Rh"
    ],
    abbreviated: [
        "Ion",
        "Chwe",
        "Maw",
        "Ebr",
        "Mai",
        "Meh",
        "Gor",
        "Aws",
        "Med",
        "Hyd",
        "Tach",
        "Rhag"
    ],
    wide: [
        "Ionawr",
        "Chwefror",
        "Mawrth",
        "Ebrill",
        "Mai",
        "Mehefin",
        "Gorffennaf",
        "Awst",
        "Medi",
        "Hydref",
        "Tachwedd",
        "Rhagfyr"
    ]
};
var $6b40c3f7464b199d$var$dayValues = {
    narrow: [
        "S",
        "Ll",
        "M",
        "M",
        "I",
        "G",
        "S"
    ],
    short: [
        "Su",
        "Ll",
        "Ma",
        "Me",
        "Ia",
        "Gw",
        "Sa"
    ],
    abbreviated: [
        "Sul",
        "Llun",
        "Maw",
        "Mer",
        "Iau",
        "Gwe",
        "Sad"
    ],
    wide: [
        "dydd Sul",
        "dydd Llun",
        "dydd Mawrth",
        "dydd Mercher",
        "dydd Iau",
        "dydd Gwener",
        "dydd Sadwrn"
    ]
};
var $6b40c3f7464b199d$var$dayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    }
};
var $6b40c3f7464b199d$var$formattingDayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    }
};
var $6b40c3f7464b199d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + "fed";
        case 1:
            return number + "af";
        case 2:
            return number + "ail";
        case 3:
        case 4:
            return number + "ydd";
        case 5:
        case 6:
            return number + "ed";
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + "fed";
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + "eg";
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + "fed";
    return number + "ain";
};
var $6b40c3f7464b199d$var$localize = {
    ordinalNumber: $6b40c3f7464b199d$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6b40c3f7464b199d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6b40c3f7464b199d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6b40c3f7464b199d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6b40c3f7464b199d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6b40c3f7464b199d$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6b40c3f7464b199d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6b40c3f7464b199d$export$2e2bcd8739ae039 = $6b40c3f7464b199d$var$localize;




var $bb584eaede18ec56$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var $bb584eaede18ec56$var$parseOrdinalNumberPattern = /\d+/i;
var $bb584eaede18ec56$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var $bb584eaede18ec56$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var $bb584eaede18ec56$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var $bb584eaede18ec56$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bb584eaede18ec56$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var $bb584eaede18ec56$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var $bb584eaede18ec56$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var $bb584eaede18ec56$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var $bb584eaede18ec56$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var $bb584eaede18ec56$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var $bb584eaede18ec56$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $bb584eaede18ec56$var$matchOrdinalNumberPattern,
        parsePattern: $bb584eaede18ec56$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb584eaede18ec56$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb584eaede18ec56$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb584eaede18ec56$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb584eaede18ec56$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb584eaede18ec56$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb584eaede18ec56$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb584eaede18ec56$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb584eaede18ec56$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb584eaede18ec56$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bb584eaede18ec56$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bb584eaede18ec56$export$2e2bcd8739ae039 = $bb584eaede18ec56$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var $800e113b5ad007d2$var$locale = {
    code: "cy",
    formatDistance: (0, $e6b3897ed2e69e4c$export$2e2bcd8739ae039),
    formatLong: (0, $2373ad36f9774bb3$export$2e2bcd8739ae039),
    formatRelative: (0, $9745e52d37c3092f$export$2e2bcd8739ae039),
    localize: (0, $6b40c3f7464b199d$export$2e2bcd8739ae039),
    match: (0, $bb584eaede18ec56$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $800e113b5ad007d2$export$2e2bcd8739ae039 = $800e113b5ad007d2$var$locale;


var $265183786efd52ff$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: "mindre end {{count}} minutter"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "cirka 1 time",
        other: "cirka {{count}} timer"
    },
    xHours: {
        one: "1 time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dage"
    },
    aboutXWeeks: {
        one: "cirka 1 uge",
        other: "cirka {{count}} uger"
    },
    xWeeks: {
        one: "1 uge",
        other: "{{count}} uger"
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $265183786efd52ff$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $265183786efd52ff$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
var $265183786efd52ff$export$2e2bcd8739ae039 = $265183786efd52ff$var$formatDistance;



var $5e2406916ddf17de$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
};
var $5e2406916ddf17de$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $5e2406916ddf17de$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $5e2406916ddf17de$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $5e2406916ddf17de$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $5e2406916ddf17de$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $5e2406916ddf17de$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $5e2406916ddf17de$export$2e2bcd8739ae039 = $5e2406916ddf17de$var$formatLong;


var $cb653aec321a4c78$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: "P"
};
var $cb653aec321a4c78$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $cb653aec321a4c78$var$formatRelativeLocale[token];
};
var $cb653aec321a4c78$export$2e2bcd8739ae039 = $cb653aec321a4c78$var$formatRelative;



var $5cb5e01c1c10a142$var$eraValues = {
    narrow: [
        "fvt",
        "vt"
    ],
    abbreviated: [
        "f.v.t.",
        "v.t."
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        "vesterlandsk tidsregning"
    ]
};
var $5cb5e01c1c10a142$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. kvt.",
        "2. kvt.",
        "3. kvt.",
        "4. kvt."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $5cb5e01c1c10a142$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $5cb5e01c1c10a142$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        "man.",
        "tir.",
        "ons.",
        "tor.",
        "fre.",
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
var $5cb5e01c1c10a142$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    }
};
var $5cb5e01c1c10a142$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    }
};
var $5cb5e01c1c10a142$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $5cb5e01c1c10a142$var$localize = {
    ordinalNumber: $5cb5e01c1c10a142$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5cb5e01c1c10a142$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5cb5e01c1c10a142$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5cb5e01c1c10a142$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5cb5e01c1c10a142$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5cb5e01c1c10a142$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5cb5e01c1c10a142$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $5cb5e01c1c10a142$export$2e2bcd8739ae039 = $5cb5e01c1c10a142$var$localize;




var $4e1c687d1d19e9f5$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $4e1c687d1d19e9f5$var$parseOrdinalNumberPattern = /\d+/i;
var $4e1c687d1d19e9f5$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $4e1c687d1d19e9f5$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $4e1c687d1d19e9f5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $4e1c687d1d19e9f5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4e1c687d1d19e9f5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $4e1c687d1d19e9f5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $4e1c687d1d19e9f5$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $4e1c687d1d19e9f5$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $4e1c687d1d19e9f5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $4e1c687d1d19e9f5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $4e1c687d1d19e9f5$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $4e1c687d1d19e9f5$var$matchOrdinalNumberPattern,
        parsePattern: $4e1c687d1d19e9f5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1c687d1d19e9f5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1c687d1d19e9f5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1c687d1d19e9f5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1c687d1d19e9f5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1c687d1d19e9f5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1c687d1d19e9f5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1c687d1d19e9f5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1c687d1d19e9f5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1c687d1d19e9f5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4e1c687d1d19e9f5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $4e1c687d1d19e9f5$export$2e2bcd8739ae039 = $4e1c687d1d19e9f5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $37c91a473daced7f$var$locale = {
    code: "da",
    formatDistance: (0, $265183786efd52ff$export$2e2bcd8739ae039),
    formatLong: (0, $5e2406916ddf17de$export$2e2bcd8739ae039),
    formatRelative: (0, $cb653aec321a4c78$export$2e2bcd8739ae039),
    localize: (0, $5cb5e01c1c10a142$export$2e2bcd8739ae039),
    match: (0, $4e1c687d1d19e9f5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $37c91a473daced7f$export$2e2bcd8739ae039 = $37c91a473daced7f$var$locale;


var $d8ed457a7b642953$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "halbe Minute",
        withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
var $d8ed457a7b642953$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $d8ed457a7b642953$var$formatDistanceLocale[token].withPreposition : $d8ed457a7b642953$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};
var $d8ed457a7b642953$export$2e2bcd8739ae039 = $d8ed457a7b642953$var$formatDistance;



// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $55dc6389e5a2a429$var$dateFormats = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y" // 07.01.2018
};
var $55dc6389e5a2a429$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $55dc6389e5a2a429$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $55dc6389e5a2a429$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $55dc6389e5a2a429$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $55dc6389e5a2a429$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $55dc6389e5a2a429$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $55dc6389e5a2a429$export$2e2bcd8739ae039 = $55dc6389e5a2a429$var$formatLong;


var $bde64ff1d37123ab$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
var $bde64ff1d37123ab$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $bde64ff1d37123ab$var$formatRelativeLocale[token];
};
var $bde64ff1d37123ab$export$2e2bcd8739ae039 = $bde64ff1d37123ab$var$formatRelative;



var $87c7039b8bbbf914$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
var $87c7039b8bbbf914$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $87c7039b8bbbf914$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $87c7039b8bbbf914$var$formattingMonthValues = {
    narrow: $87c7039b8bbbf914$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $87c7039b8bbbf914$var$monthValues.wide
};
var $87c7039b8bbbf914$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $87c7039b8bbbf914$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
var $87c7039b8bbbf914$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
var $87c7039b8bbbf914$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $87c7039b8bbbf914$var$localize = {
    ordinalNumber: $87c7039b8bbbf914$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $87c7039b8bbbf914$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $87c7039b8bbbf914$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $87c7039b8bbbf914$var$monthValues,
        formattingValues: $87c7039b8bbbf914$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $87c7039b8bbbf914$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $87c7039b8bbbf914$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $87c7039b8bbbf914$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $87c7039b8bbbf914$export$2e2bcd8739ae039 = $87c7039b8bbbf914$var$localize;




var $52d941ca039ae8db$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $52d941ca039ae8db$var$parseOrdinalNumberPattern = /\d+/i;
var $52d941ca039ae8db$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $52d941ca039ae8db$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $52d941ca039ae8db$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $52d941ca039ae8db$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $52d941ca039ae8db$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $52d941ca039ae8db$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $52d941ca039ae8db$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $52d941ca039ae8db$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $52d941ca039ae8db$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $52d941ca039ae8db$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $52d941ca039ae8db$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $52d941ca039ae8db$var$matchOrdinalNumberPattern,
        parsePattern: $52d941ca039ae8db$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $52d941ca039ae8db$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $52d941ca039ae8db$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $52d941ca039ae8db$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $52d941ca039ae8db$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $52d941ca039ae8db$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $52d941ca039ae8db$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $52d941ca039ae8db$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $52d941ca039ae8db$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $52d941ca039ae8db$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $52d941ca039ae8db$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $52d941ca039ae8db$export$2e2bcd8739ae039 = $52d941ca039ae8db$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $4a17e98ef64bb836$var$locale = {
    code: "de",
    formatDistance: (0, $d8ed457a7b642953$export$2e2bcd8739ae039),
    formatLong: (0, $55dc6389e5a2a429$export$2e2bcd8739ae039),
    formatRelative: (0, $bde64ff1d37123ab$export$2e2bcd8739ae039),
    localize: (0, $87c7039b8bbbf914$export$2e2bcd8739ae039),
    match: (0, $52d941ca039ae8db$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4a17e98ef64bb836$export$2e2bcd8739ae039 = $4a17e98ef64bb836$var$locale;







var $9de1853cc64ede0c$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
var $9de1853cc64ede0c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9de1853cc64ede0c$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "J\xe4n",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "J\xe4nner",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var $9de1853cc64ede0c$var$formattingMonthValues = {
    narrow: $9de1853cc64ede0c$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $9de1853cc64ede0c$var$monthValues.wide
};
var $9de1853cc64ede0c$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $9de1853cc64ede0c$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
var $9de1853cc64ede0c$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
var $9de1853cc64ede0c$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $9de1853cc64ede0c$var$localize = {
    ordinalNumber: $9de1853cc64ede0c$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9de1853cc64ede0c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9de1853cc64ede0c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9de1853cc64ede0c$var$monthValues,
        formattingValues: $9de1853cc64ede0c$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9de1853cc64ede0c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9de1853cc64ede0c$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9de1853cc64ede0c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9de1853cc64ede0c$export$2e2bcd8739ae039 = $9de1853cc64ede0c$var$localize;


/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var $317296a78ab9da30$var$locale = {
    code: "de-AT",
    formatDistance: (0, $d8ed457a7b642953$export$2e2bcd8739ae039),
    formatLong: (0, $55dc6389e5a2a429$export$2e2bcd8739ae039),
    formatRelative: (0, $bde64ff1d37123ab$export$2e2bcd8739ae039),
    localize: (0, $9de1853cc64ede0c$export$2e2bcd8739ae039),
    match: (0, $52d941ca039ae8db$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $317296a78ab9da30$export$2e2bcd8739ae039 = $317296a78ab9da30$var$locale;


var $0d69af04667b0896$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "λιγότερο από ένα δευτερόλεπτο",
        other: "λιγότερο από {{count}} δευτερόλεπτα"
    },
    xSeconds: {
        one: "1 δευτερόλεπτο",
        other: "{{count}} δευτερόλεπτα"
    },
    halfAMinute: "μισό λεπτό",
    lessThanXMinutes: {
        one: "λιγότερο από ένα λεπτό",
        other: "λιγότερο από {{count}} λεπτά"
    },
    xMinutes: {
        one: "1 λεπτό",
        other: "{{count}} λεπτά"
    },
    aboutXHours: {
        one: "περίπου 1 ώρα",
        other: "περίπου {{count}} ώρες"
    },
    xHours: {
        one: "1 ώρα",
        other: "{{count}} ώρες"
    },
    xDays: {
        one: "1 ημέρα",
        other: "{{count}} ημέρες"
    },
    aboutXWeeks: {
        one: "περίπου 1 εβδομάδα",
        other: "περίπου {{count}} εβδομάδες"
    },
    xWeeks: {
        one: "1 εβδομάδα",
        other: "{{count}} εβδομάδες"
    },
    aboutXMonths: {
        one: "περίπου 1 μήνας",
        other: "περίπου {{count}} μήνες"
    },
    xMonths: {
        one: "1 μήνας",
        other: "{{count}} μήνες"
    },
    aboutXYears: {
        one: "περίπου 1 χρόνο",
        other: "περίπου {{count}} χρόνια"
    },
    xYears: {
        one: "1 χρόνο",
        other: "{{count}} χρόνια"
    },
    overXYears: {
        one: "πάνω από 1 χρόνο",
        other: "πάνω από {{count}} χρόνια"
    },
    almostXYears: {
        one: "περίπου 1 χρόνο",
        other: "περίπου {{count}} χρόνια"
    }
};
var $0d69af04667b0896$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0d69af04667b0896$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "σε " + result;
        else return result + " πριν";
    }
    return result;
};
var $0d69af04667b0896$export$2e2bcd8739ae039 = $0d69af04667b0896$var$formatDistance;



var $7975147ef2bf3ebb$var$dateFormats = {
    full: "EEEE, d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "d/M/yy"
};
var $7975147ef2bf3ebb$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $7975147ef2bf3ebb$var$dateTimeFormats = {
    full: "{{date}} - {{time}}",
    long: "{{date}} - {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $7975147ef2bf3ebb$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $7975147ef2bf3ebb$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $7975147ef2bf3ebb$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $7975147ef2bf3ebb$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $7975147ef2bf3ebb$export$2e2bcd8739ae039 = $7975147ef2bf3ebb$var$formatLong;


var $d7ca6c068f6879e3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'το προηγούμενο' eeee 'στις' p";
            default:
                return "'την προηγούμενη' eeee 'στις' p";
        }
    },
    yesterday: "'χθες στις' p",
    today: "'σήμερα στις' p",
    tomorrow: "'αύριο στις' p",
    nextWeek: "eeee 'στις' p",
    other: "P"
};
var $d7ca6c068f6879e3$var$formatRelative = function formatRelative(token, date) {
    var format = $d7ca6c068f6879e3$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $d7ca6c068f6879e3$export$2e2bcd8739ae039 = $d7ca6c068f6879e3$var$formatRelative;



var $0486bea81e93a558$var$eraValues = {
    narrow: [
        "πΧ",
        "μΧ"
    ],
    abbreviated: [
        "π.Χ.",
        "μ.Χ."
    ],
    wide: [
        "προ Χριστού",
        "μετά Χριστόν"
    ]
};
var $0486bea81e93a558$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Τ1",
        "Τ2",
        "Τ3",
        "Τ4"
    ],
    wide: [
        "1ο τρίμηνο",
        "2ο τρίμηνο",
        "3ο τρίμηνο",
        "4ο τρίμηνο"
    ]
};
var $0486bea81e93a558$var$monthValues = {
    narrow: [
        "Ι",
        "Φ",
        "Μ",
        "Α",
        "Μ",
        "Ι",
        "Ι",
        "Α",
        "Σ",
        "Ο",
        "Ν",
        "Δ"
    ],
    abbreviated: [
        "Ιαν",
        "Φεβ",
        "Μάρ",
        "Απρ",
        "Μάι",
        "Ιούν",
        "Ιούλ",
        "Αύγ",
        "Σεπ",
        "Οκτ",
        "Νοέ",
        "Δεκ"
    ],
    wide: [
        "Ιανουάριος",
        "Φεβρουάριος",
        "Μάρτιος",
        "Απρίλιος",
        "Μάιος",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος"
    ]
};
var $0486bea81e93a558$var$formattingMonthValues = {
    narrow: [
        "Ι",
        "Φ",
        "Μ",
        "Α",
        "Μ",
        "Ι",
        "Ι",
        "Α",
        "Σ",
        "Ο",
        "Ν",
        "Δ"
    ],
    abbreviated: [
        "Ιαν",
        "Φεβ",
        "Μαρ",
        "Απρ",
        "Μαΐ",
        "Ιουν",
        "Ιουλ",
        "Αυγ",
        "Σεπ",
        "Οκτ",
        "Νοε",
        "Δεκ"
    ],
    wide: [
        "Ιανουαρίου",
        "Φεβρουαρίου",
        "Μαρτίου",
        "Απριλίου",
        "Μαΐου",
        "Ιουνίου",
        "Ιουλίου",
        "Αυγούστου",
        "Σεπτεμβρίου",
        "Οκτωβρίου",
        "Νοεμβρίου",
        "Δεκεμβρίου"
    ]
};
var $0486bea81e93a558$var$dayValues = {
    narrow: [
        "Κ",
        "Δ",
        "T",
        "Τ",
        "Π",
        "Π",
        "Σ"
    ],
    short: [
        "Κυ",
        "Δε",
        "Τρ",
        "Τε",
        "Πέ",
        "Πα",
        "Σά"
    ],
    abbreviated: [
        "Κυρ",
        "Δευ",
        "Τρί",
        "Τετ",
        "Πέμ",
        "Παρ",
        "Σάβ"
    ],
    wide: [
        "Κυριακή",
        "Δευτέρα",
        "Τρίτη",
        "Τετάρτη",
        "Πέμπτη",
        "Παρασκευή",
        "Σάββατο"
    ]
};
var $0486bea81e93a558$var$dayPeriodValues = {
    narrow: {
        am: "πμ",
        pm: "μμ",
        midnight: "μεσάνυχτα",
        noon: "μεσημέρι",
        morning: "πρωί",
        afternoon: "απόγευμα",
        evening: "βράδυ",
        night: "νύχτα"
    },
    abbreviated: {
        am: "π.μ.",
        pm: "μ.μ.",
        midnight: "μεσάνυχτα",
        noon: "μεσημέρι",
        morning: "πρωί",
        afternoon: "απόγευμα",
        evening: "βράδυ",
        night: "νύχτα"
    },
    wide: {
        am: "π.μ.",
        pm: "μ.μ.",
        midnight: "μεσάνυχτα",
        noon: "μεσημέρι",
        morning: "πρωί",
        afternoon: "απόγευμα",
        evening: "βράδυ",
        night: "νύχτα"
    }
};
var $0486bea81e93a558$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === "year" || unit === "month") suffix = "ος";
    else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") suffix = "η";
    else suffix = "ο";
    return number + suffix;
};
var $0486bea81e93a558$var$localize = {
    ordinalNumber: $0486bea81e93a558$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0486bea81e93a558$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0486bea81e93a558$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0486bea81e93a558$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $0486bea81e93a558$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0486bea81e93a558$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0486bea81e93a558$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $0486bea81e93a558$export$2e2bcd8739ae039 = $0486bea81e93a558$var$localize;




var $3eb9466d0bd711d0$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var $3eb9466d0bd711d0$var$parseOrdinalNumberPattern = /\d+/i;
var $3eb9466d0bd711d0$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var $3eb9466d0bd711d0$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var $3eb9466d0bd711d0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var $3eb9466d0bd711d0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3eb9466d0bd711d0$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var $3eb9466d0bd711d0$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var $3eb9466d0bd711d0$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var $3eb9466d0bd711d0$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var $3eb9466d0bd711d0$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var $3eb9466d0bd711d0$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var $3eb9466d0bd711d0$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $3eb9466d0bd711d0$var$matchOrdinalNumberPattern,
        parsePattern: $3eb9466d0bd711d0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3eb9466d0bd711d0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3eb9466d0bd711d0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3eb9466d0bd711d0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3eb9466d0bd711d0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3eb9466d0bd711d0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3eb9466d0bd711d0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3eb9466d0bd711d0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3eb9466d0bd711d0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3eb9466d0bd711d0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3eb9466d0bd711d0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $3eb9466d0bd711d0$export$2e2bcd8739ae039 = $3eb9466d0bd711d0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var $af9e25ef3d614e9d$var$locale = {
    code: "el",
    formatDistance: (0, $0d69af04667b0896$export$2e2bcd8739ae039),
    formatLong: (0, $7975147ef2bf3ebb$export$2e2bcd8739ae039),
    formatRelative: (0, $d7ca6c068f6879e3$export$2e2bcd8739ae039),
    localize: (0, $0486bea81e93a558$export$2e2bcd8739ae039),
    match: (0, $3eb9466d0bd711d0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $af9e25ef3d614e9d$export$2e2bcd8739ae039 = $af9e25ef3d614e9d$var$locale;




var $d63a8dcc00e99db1$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $d63a8dcc00e99db1$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $d63a8dcc00e99db1$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d63a8dcc00e99db1$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d63a8dcc00e99db1$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d63a8dcc00e99db1$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d63a8dcc00e99db1$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d63a8dcc00e99db1$export$2e2bcd8739ae039 = $d63a8dcc00e99db1$var$formatLong;





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $c70e3f792f208dc6$var$locale = {
    code: "en-AU",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $d63a8dcc00e99db1$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c70e3f792f208dc6$export$2e2bcd8739ae039 = $c70e3f792f208dc6$var$locale;





var $2e92733dae98a929$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "a second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "a minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about an hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "an hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "a day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about a week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "a week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about a month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "a month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about a year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "a year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over a year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost a year",
        other: "almost {{count}} years"
    }
};
var $2e92733dae98a929$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2e92733dae98a929$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $2e92733dae98a929$export$2e2bcd8739ae039 = $2e92733dae98a929$var$formatDistance;



var $62d795f8214f077d$var$dateFormats = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
};
var $62d795f8214f077d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $62d795f8214f077d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $62d795f8214f077d$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $62d795f8214f077d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $62d795f8214f077d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $62d795f8214f077d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $62d795f8214f077d$export$2e2bcd8739ae039 = $62d795f8214f077d$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var $efa65e52e686f1d7$var$locale = {
    code: "en-CA",
    formatDistance: (0, $2e92733dae98a929$export$2e2bcd8739ae039),
    formatLong: (0, $62d795f8214f077d$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $efa65e52e686f1d7$export$2e2bcd8739ae039 = $efa65e52e686f1d7$var$locale;







var $3d1d5e2736a1dfff$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $3d1d5e2736a1dfff$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $3d1d5e2736a1dfff$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $3d1d5e2736a1dfff$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3d1d5e2736a1dfff$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3d1d5e2736a1dfff$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3d1d5e2736a1dfff$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $3d1d5e2736a1dfff$export$2e2bcd8739ae039 = $3d1d5e2736a1dfff$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $83d9f6561f3e62c7$var$locale = {
    code: "en-GB",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $3d1d5e2736a1dfff$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $83d9f6561f3e62c7$export$2e2bcd8739ae039 = $83d9f6561f3e62c7$var$locale;







/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var $36c701d9fd969ae7$var$locale = {
    code: "en-IE",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $3d1d5e2736a1dfff$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $36c701d9fd969ae7$export$2e2bcd8739ae039 = $36c701d9fd969ae7$var$locale;







var $98b7ce5822846b92$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
};
var $98b7ce5822846b92$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $98b7ce5822846b92$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $98b7ce5822846b92$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $98b7ce5822846b92$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $98b7ce5822846b92$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $98b7ce5822846b92$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $98b7ce5822846b92$export$2e2bcd8739ae039 = $98b7ce5822846b92$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var $007e3ef601dc9291$var$locale = {
    code: "en-IN",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $98b7ce5822846b92$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
var $007e3ef601dc9291$export$2e2bcd8739ae039 = $007e3ef601dc9291$var$locale;







var $cf5241addf110226$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $cf5241addf110226$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $cf5241addf110226$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $cf5241addf110226$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $cf5241addf110226$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $cf5241addf110226$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $cf5241addf110226$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $cf5241addf110226$export$2e2bcd8739ae039 = $cf5241addf110226$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var $9e0c30d91b255dbf$var$locale = {
    code: "en-NZ",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $cf5241addf110226$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9e0c30d91b255dbf$export$2e2bcd8739ae039 = $9e0c30d91b255dbf$var$locale;








var $3c8702d381e4d68b$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
};
var $3c8702d381e4d68b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $3c8702d381e4d68b$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $3c8702d381e4d68b$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3c8702d381e4d68b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3c8702d381e4d68b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3c8702d381e4d68b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $3c8702d381e4d68b$export$2e2bcd8739ae039 = $3c8702d381e4d68b$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var $7af1ee3fc77667d2$var$locale = {
    code: "en-ZA",
    formatDistance: (0, $9d3b8f1bbb60dc8e$export$2e2bcd8739ae039),
    formatLong: (0, $3c8702d381e4d68b$export$2e2bcd8739ae039),
    formatRelative: (0, $27b07b6969b3b18a$export$2e2bcd8739ae039),
    localize: (0, $17da716efdeaa8e3$export$2e2bcd8739ae039),
    match: (0, $a0618466070b1817$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
var $7af1ee3fc77667d2$export$2e2bcd8739ae039 = $7af1ee3fc77667d2$var$locale;


var $ab1110068de85491$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "malpli ol sekundo",
        other: "malpli ol {{count}} sekundoj"
    },
    xSeconds: {
        one: "1 sekundo",
        other: "{{count}} sekundoj"
    },
    halfAMinute: "duonminuto",
    lessThanXMinutes: {
        one: "malpli ol minuto",
        other: "malpli ol {{count}} minutoj"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutoj"
    },
    aboutXHours: {
        one: "proksimume 1 horo",
        other: "proksimume {{count}} horoj"
    },
    xHours: {
        one: "1 horo",
        other: "{{count}} horoj"
    },
    xDays: {
        one: "1 tago",
        other: "{{count}} tagoj"
    },
    aboutXMonths: {
        one: "proksimume 1 monato",
        other: "proksimume {{count}} monatoj"
    },
    xWeeks: {
        one: "1 semajno",
        other: "{{count}} semajnoj"
    },
    aboutXWeeks: {
        one: "proksimume 1 semajno",
        other: "proksimume {{count}} semajnoj"
    },
    xMonths: {
        one: "1 monato",
        other: "{{count}} monatoj"
    },
    aboutXYears: {
        one: "proksimume 1 jaro",
        other: "proksimume {{count}} jaroj"
    },
    xYears: {
        one: "1 jaro",
        other: "{{count}} jaroj"
    },
    overXYears: {
        one: "pli ol 1 jaro",
        other: "pli ol {{count}} jaroj"
    },
    almostXYears: {
        one: "preskaŭ 1 jaro",
        other: "preskaŭ {{count}} jaroj"
    }
};
var $ab1110068de85491$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ab1110068de85491$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return "post " + result;
        else return "antaŭ " + result;
    }
    return result;
};
var $ab1110068de85491$export$2e2bcd8739ae039 = $ab1110068de85491$var$formatDistance;



var $6a7c5a2cc03bdc01$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: "y-MMMM-dd",
    medium: "y-MMM-dd",
    short: "yyyy-MM-dd"
};
var $6a7c5a2cc03bdc01$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $6a7c5a2cc03bdc01$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
var $6a7c5a2cc03bdc01$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6a7c5a2cc03bdc01$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6a7c5a2cc03bdc01$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6a7c5a2cc03bdc01$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $6a7c5a2cc03bdc01$export$2e2bcd8739ae039 = $6a7c5a2cc03bdc01$var$formatLong;


var $39d8028538742d0f$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hieraŭ je' p",
    today: "'hodiaŭ je' p",
    tomorrow: "'morgaŭ je' p",
    nextWeek: "eeee 'je' p",
    other: "P"
};
var $39d8028538742d0f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $39d8028538742d0f$var$formatRelativeLocale[token];
};
var $39d8028538742d0f$export$2e2bcd8739ae039 = $39d8028538742d0f$var$formatRelative;



var $d03ce21ec6298b74$var$eraValues = {
    narrow: [
        "aK",
        "pK"
    ],
    abbreviated: [
        "a.K.E.",
        "p.K.E."
    ],
    wide: [
        "antaŭ Komuna Erao",
        "Komuna Erao"
    ]
};
var $d03ce21ec6298b74$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1-a kvaronjaro",
        "2-a kvaronjaro",
        "3-a kvaronjaro",
        "4-a kvaronjaro"
    ]
};
var $d03ce21ec6298b74$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "aŭg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januaro",
        "februaro",
        "marto",
        "aprilo",
        "majo",
        "junio",
        "julio",
        "aŭgusto",
        "septembro",
        "oktobro",
        "novembro",
        "decembro"
    ]
};
var $d03ce21ec6298b74$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "Ĵ",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "ĵa",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim",
        "lun",
        "mar",
        "mer",
        "ĵaŭ",
        "ven",
        "sab"
    ],
    wide: [
        "dimanĉo",
        "lundo",
        "mardo",
        "merkredo",
        "ĵaŭdo",
        "vendredo",
        "sabato"
    ]
};
var $d03ce21ec6298b74$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    abbreviated: {
        am: "a.t.m.",
        pm: "p.t.m.",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    wide: {
        am: "antaŭtagmeze",
        pm: "posttagmeze",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    }
};
var $d03ce21ec6298b74$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + "-a";
};
var $d03ce21ec6298b74$var$localize = {
    ordinalNumber: $d03ce21ec6298b74$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d03ce21ec6298b74$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d03ce21ec6298b74$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d03ce21ec6298b74$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d03ce21ec6298b74$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d03ce21ec6298b74$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $d03ce21ec6298b74$export$2e2bcd8739ae039 = $d03ce21ec6298b74$var$localize;




var $ff287e23d529e572$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var $ff287e23d529e572$var$parseOrdinalNumberPattern = /\d+/i;
var $ff287e23d529e572$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var $ff287e23d529e572$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var $ff287e23d529e572$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var $ff287e23d529e572$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ff287e23d529e572$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var $ff287e23d529e572$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ff287e23d529e572$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var $ff287e23d529e572$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var $ff287e23d529e572$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var $ff287e23d529e572$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $ff287e23d529e572$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $ff287e23d529e572$var$matchOrdinalNumberPattern,
        parsePattern: $ff287e23d529e572$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff287e23d529e572$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff287e23d529e572$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff287e23d529e572$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff287e23d529e572$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff287e23d529e572$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff287e23d529e572$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff287e23d529e572$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff287e23d529e572$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff287e23d529e572$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff287e23d529e572$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $ff287e23d529e572$export$2e2bcd8739ae039 = $ff287e23d529e572$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var $1e6efb3215d44680$var$locale = {
    code: "eo",
    formatDistance: (0, $ab1110068de85491$export$2e2bcd8739ae039),
    formatLong: (0, $6a7c5a2cc03bdc01$export$2e2bcd8739ae039),
    formatRelative: (0, $39d8028538742d0f$export$2e2bcd8739ae039),
    localize: (0, $d03ce21ec6298b74$export$2e2bcd8739ae039),
    match: (0, $ff287e23d529e572$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1e6efb3215d44680$export$2e2bcd8739ae039 = $1e6efb3215d44680$var$locale;


var $ecb42cdacfdc3c1b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $ecb42cdacfdc3c1b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ecb42cdacfdc3c1b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};
var $ecb42cdacfdc3c1b$export$2e2bcd8739ae039 = $ecb42cdacfdc3c1b$var$formatDistance;



var $65f6be3d744cb8a2$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $65f6be3d744cb8a2$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $65f6be3d744cb8a2$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $65f6be3d744cb8a2$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $65f6be3d744cb8a2$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $65f6be3d744cb8a2$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $65f6be3d744cb8a2$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $65f6be3d744cb8a2$export$2e2bcd8739ae039 = $65f6be3d744cb8a2$var$formatLong;


var $c2e53a6e6590c3ed$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
var $c2e53a6e6590c3ed$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
var $c2e53a6e6590c3ed$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $c2e53a6e6590c3ed$var$formatRelativeLocalePlural[token];
    else return $c2e53a6e6590c3ed$var$formatRelativeLocale[token];
};
var $c2e53a6e6590c3ed$export$2e2bcd8739ae039 = $c2e53a6e6590c3ed$var$formatRelative;



var $268a5cfc43bf8739$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
var $268a5cfc43bf8739$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $268a5cfc43bf8739$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
var $268a5cfc43bf8739$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
var $268a5cfc43bf8739$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
var $268a5cfc43bf8739$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
var $268a5cfc43bf8739$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $268a5cfc43bf8739$var$localize = {
    ordinalNumber: $268a5cfc43bf8739$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $268a5cfc43bf8739$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $268a5cfc43bf8739$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $268a5cfc43bf8739$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $268a5cfc43bf8739$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $268a5cfc43bf8739$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $268a5cfc43bf8739$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $268a5cfc43bf8739$export$2e2bcd8739ae039 = $268a5cfc43bf8739$var$localize;




var $4e04eadbd96dc7be$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $4e04eadbd96dc7be$var$parseOrdinalNumberPattern = /\d+/i;
var $4e04eadbd96dc7be$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $4e04eadbd96dc7be$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $4e04eadbd96dc7be$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $4e04eadbd96dc7be$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4e04eadbd96dc7be$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $4e04eadbd96dc7be$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $4e04eadbd96dc7be$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $4e04eadbd96dc7be$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $4e04eadbd96dc7be$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $4e04eadbd96dc7be$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $4e04eadbd96dc7be$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $4e04eadbd96dc7be$var$matchOrdinalNumberPattern,
        parsePattern: $4e04eadbd96dc7be$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e04eadbd96dc7be$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e04eadbd96dc7be$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e04eadbd96dc7be$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e04eadbd96dc7be$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e04eadbd96dc7be$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e04eadbd96dc7be$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e04eadbd96dc7be$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e04eadbd96dc7be$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e04eadbd96dc7be$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4e04eadbd96dc7be$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $4e04eadbd96dc7be$export$2e2bcd8739ae039 = $4e04eadbd96dc7be$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $5a245ea4459980b9$var$locale = {
    code: "es",
    formatDistance: (0, $ecb42cdacfdc3c1b$export$2e2bcd8739ae039),
    formatLong: (0, $65f6be3d744cb8a2$export$2e2bcd8739ae039),
    formatRelative: (0, $c2e53a6e6590c3ed$export$2e2bcd8739ae039),
    localize: (0, $268a5cfc43bf8739$export$2e2bcd8739ae039),
    match: (0, $4e04eadbd96dc7be$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $5a245ea4459980b9$export$2e2bcd8739ae039 = $5a245ea4459980b9$var$locale;


var $f593c0ea5e13af03$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: "{{count}} sekundit"
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: "{{count}} sekundi"
        }
    },
    halfAMinute: {
        standalone: "pool minutit",
        withPreposition: "poole minuti"
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: "{{count}} minutit"
        },
        withPreposition: {
            one: "\xfche minuti",
            other: "{{count}} minuti"
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: "umbes {{count}} tundi"
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: "umbes {{count}} tunni"
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: "{{count}} tundi"
        },
        withPreposition: {
            one: "\xfche tunni",
            other: "{{count}} tunni"
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: "umbes {{count}} kuud"
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: "umbes {{count}} kuu"
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: "{{count}} kuud"
        },
        withPreposition: {
            one: "\xfche kuu",
            other: "{{count}} kuu"
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: "umbes {{count}} aastat"
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: "umbes {{count}} aasta"
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: "{{count}} aastat"
        },
        withPreposition: {
            one: "\xfche aasta",
            other: "{{count}} aasta"
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: "rohkem kui {{count}} aastat"
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: "rohkem kui {{count}} aasta"
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: "peaaegu {{count}} aastat"
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: "peaaegu {{count}} aasta"
        }
    }
};
var $f593c0ea5e13af03$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $f593c0ea5e13af03$var$formatDistanceLocale[token].withPreposition : $f593c0ea5e13af03$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + " eest";
    }
    return result;
};
var $f593c0ea5e13af03$export$2e2bcd8739ae039 = $f593c0ea5e13af03$var$formatDistance;



var $137db494c6ec65ee$var$dateFormats = {
    full: "EEEE, d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
var $137db494c6ec65ee$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $137db494c6ec65ee$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: "{{date}}. {{time}}",
    short: "{{date}}. {{time}}"
};
var $137db494c6ec65ee$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $137db494c6ec65ee$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $137db494c6ec65ee$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $137db494c6ec65ee$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $137db494c6ec65ee$export$2e2bcd8739ae039 = $137db494c6ec65ee$var$formatLong;


var $daf25360c1941511$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: "P"
};
var $daf25360c1941511$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $daf25360c1941511$var$formatRelativeLocale[token];
};
var $daf25360c1941511$export$2e2bcd8739ae039 = $daf25360c1941511$var$formatRelative;



var $448c3a1c5c2d6ac1$var$eraValues = {
    narrow: [
        "e.m.a",
        "m.a.j"
    ],
    abbreviated: [
        "e.m.a",
        "m.a.j"
    ],
    wide: [
        "enne meie ajaarvamist",
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $448c3a1c5c2d6ac1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $448c3a1c5c2d6ac1$var$monthValues = {
    narrow: [
        "J",
        "V",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jaan",
        "veebr",
        "m\xe4rts",
        "apr",
        "mai",
        "juuni",
        "juuli",
        "aug",
        "sept",
        "okt",
        "nov",
        "dets"
    ],
    wide: [
        "jaanuar",
        "veebruar",
        "m\xe4rts",
        "aprill",
        "mai",
        "juuni",
        "juuli",
        "august",
        "september",
        "oktoober",
        "november",
        "detsember"
    ]
};
var $448c3a1c5c2d6ac1$var$dayValues = {
    narrow: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    short: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    abbreviated: [
        "p\xfchap.",
        "esmasp.",
        "teisip.",
        "kolmap.",
        "neljap.",
        "reede.",
        "laup."
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        "reede",
        "laup\xe4ev"
    ]
};
var $448c3a1c5c2d6ac1$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $448c3a1c5c2d6ac1$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $448c3a1c5c2d6ac1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $448c3a1c5c2d6ac1$var$localize = {
    ordinalNumber: $448c3a1c5c2d6ac1$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $448c3a1c5c2d6ac1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $448c3a1c5c2d6ac1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $448c3a1c5c2d6ac1$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $448c3a1c5c2d6ac1$var$monthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $448c3a1c5c2d6ac1$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $448c3a1c5c2d6ac1$var$dayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $448c3a1c5c2d6ac1$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $448c3a1c5c2d6ac1$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $448c3a1c5c2d6ac1$export$2e2bcd8739ae039 = $448c3a1c5c2d6ac1$var$localize;




var $486a3b906746413b$var$matchOrdinalNumberPattern = /^\d+\./i;
var $486a3b906746413b$var$parseOrdinalNumberPattern = /\d+/i;
var $486a3b906746413b$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $486a3b906746413b$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $486a3b906746413b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $486a3b906746413b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $486a3b906746413b$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $486a3b906746413b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $486a3b906746413b$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $486a3b906746413b$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $486a3b906746413b$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $486a3b906746413b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $486a3b906746413b$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $486a3b906746413b$var$matchOrdinalNumberPattern,
        parsePattern: $486a3b906746413b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $486a3b906746413b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $486a3b906746413b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $486a3b906746413b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $486a3b906746413b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $486a3b906746413b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $486a3b906746413b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $486a3b906746413b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $486a3b906746413b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $486a3b906746413b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $486a3b906746413b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $486a3b906746413b$export$2e2bcd8739ae039 = $486a3b906746413b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $913d48e43cc3d5ab$var$locale = {
    code: "et",
    formatDistance: (0, $f593c0ea5e13af03$export$2e2bcd8739ae039),
    formatLong: (0, $137db494c6ec65ee$export$2e2bcd8739ae039),
    formatRelative: (0, $daf25360c1941511$export$2e2bcd8739ae039),
    localize: (0, $448c3a1c5c2d6ac1$export$2e2bcd8739ae039),
    match: (0, $486a3b906746413b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $913d48e43cc3d5ab$export$2e2bcd8739ae039 = $913d48e43cc3d5ab$var$locale;


var $997e6824813f7072$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "segundo bat baino gutxiago",
        other: "{{count}} segundo baino gutxiago"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundo"
    },
    halfAMinute: "minutu erdi",
    lessThanXMinutes: {
        one: "minutu bat baino gutxiago",
        other: "{{count}} minutu baino gutxiago"
    },
    xMinutes: {
        one: "1 minutu",
        other: "{{count}} minutu"
    },
    aboutXHours: {
        one: "1 ordu gutxi gorabehera",
        other: "{{count}} ordu gutxi gorabehera"
    },
    xHours: {
        one: "1 ordu",
        other: "{{count}} ordu"
    },
    xDays: {
        one: "1 egun",
        other: "{{count}} egun"
    },
    aboutXWeeks: {
        one: "aste 1 inguru",
        other: "{{count}} aste inguru"
    },
    xWeeks: {
        one: "1 aste",
        other: "{{count}} astean"
    },
    aboutXMonths: {
        one: "1 hilabete gutxi gorabehera",
        other: "{{count}} hilabete gutxi gorabehera"
    },
    xMonths: {
        one: "1 hilabete",
        other: "{{count}} hilabete"
    },
    aboutXYears: {
        one: "1 urte gutxi gorabehera",
        other: "{{count}} urte gutxi gorabehera"
    },
    xYears: {
        one: "1 urte",
        other: "{{count}} urte"
    },
    overXYears: {
        one: "1 urte baino gehiago",
        other: "{{count}} urte baino gehiago"
    },
    almostXYears: {
        one: "ia 1 urte",
        other: "ia {{count}} urte"
    }
};
var $997e6824813f7072$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $997e6824813f7072$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "duela " + result;
    }
    return result;
};
var $997e6824813f7072$export$2e2bcd8739ae039 = $997e6824813f7072$var$formatDistance;



var $8e92029f1bf0ee0f$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: "y MMM d",
    short: "yy/MM/dd"
};
var $8e92029f1bf0ee0f$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $8e92029f1bf0ee0f$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $8e92029f1bf0ee0f$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $8e92029f1bf0ee0f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $8e92029f1bf0ee0f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $8e92029f1bf0ee0f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $8e92029f1bf0ee0f$export$2e2bcd8739ae039 = $8e92029f1bf0ee0f$var$formatLong;


var $7f937799be8030cb$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
var $7f937799be8030cb$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
var $7f937799be8030cb$var$formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return $7f937799be8030cb$var$formatRelativeLocalePlural[token];
    return $7f937799be8030cb$var$formatRelativeLocale[token];
};
var $7f937799be8030cb$export$2e2bcd8739ae039 = $7f937799be8030cb$var$formatRelative;



var $00ca33572a957ccd$var$eraValues = {
    narrow: [
        "k.a.",
        "k.o."
    ],
    abbreviated: [
        "k.a.",
        "k.o."
    ],
    wide: [
        "kristo aurretik",
        "kristo ondoren"
    ]
};
var $00ca33572a957ccd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1H",
        "2H",
        "3H",
        "4H"
    ],
    wide: [
        "1. hiruhilekoa",
        "2. hiruhilekoa",
        "3. hiruhilekoa",
        "4. hiruhilekoa"
    ]
};
var $00ca33572a957ccd$var$monthValues = {
    narrow: [
        "u",
        "o",
        "m",
        "a",
        "m",
        "e",
        "u",
        "a",
        "i",
        "u",
        "a",
        "a"
    ],
    abbreviated: [
        "urt",
        "ots",
        "mar",
        "api",
        "mai",
        "eka",
        "uzt",
        "abu",
        "ira",
        "urr",
        "aza",
        "abe"
    ],
    wide: [
        "urtarrila",
        "otsaila",
        "martxoa",
        "apirila",
        "maiatza",
        "ekaina",
        "uztaila",
        "abuztua",
        "iraila",
        "urria",
        "azaroa",
        "abendua"
    ]
};
var $00ca33572a957ccd$var$dayValues = {
    narrow: [
        "i",
        "a",
        "a",
        "a",
        "o",
        "o",
        "l"
    ],
    short: [
        "ig",
        "al",
        "as",
        "az",
        "og",
        "or",
        "lr"
    ],
    abbreviated: [
        "iga",
        "ast",
        "ast",
        "ast",
        "ost",
        "ost",
        "lar"
    ],
    wide: [
        "igandea",
        "astelehena",
        "asteartea",
        "asteazkena",
        "osteguna",
        "ostirala",
        "larunbata"
    ]
};
var $00ca33572a957ccd$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    }
};
var $00ca33572a957ccd$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    }
};
var $00ca33572a957ccd$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $00ca33572a957ccd$var$localize = {
    ordinalNumber: $00ca33572a957ccd$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $00ca33572a957ccd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $00ca33572a957ccd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $00ca33572a957ccd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $00ca33572a957ccd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $00ca33572a957ccd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $00ca33572a957ccd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $00ca33572a957ccd$export$2e2bcd8739ae039 = $00ca33572a957ccd$var$localize;




var $0de1a2f2b923e288$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var $0de1a2f2b923e288$var$parseOrdinalNumberPattern = /\d+/i;
var $0de1a2f2b923e288$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var $0de1a2f2b923e288$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var $0de1a2f2b923e288$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var $0de1a2f2b923e288$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0de1a2f2b923e288$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var $0de1a2f2b923e288$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var $0de1a2f2b923e288$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var $0de1a2f2b923e288$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var $0de1a2f2b923e288$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var $0de1a2f2b923e288$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var $0de1a2f2b923e288$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $0de1a2f2b923e288$var$matchOrdinalNumberPattern,
        parsePattern: $0de1a2f2b923e288$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0de1a2f2b923e288$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0de1a2f2b923e288$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0de1a2f2b923e288$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0de1a2f2b923e288$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0de1a2f2b923e288$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0de1a2f2b923e288$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0de1a2f2b923e288$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0de1a2f2b923e288$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0de1a2f2b923e288$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0de1a2f2b923e288$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $0de1a2f2b923e288$export$2e2bcd8739ae039 = $0de1a2f2b923e288$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var $ad33979d2f6c8b52$var$locale = {
    code: "eu",
    formatDistance: (0, $997e6824813f7072$export$2e2bcd8739ae039),
    formatLong: (0, $8e92029f1bf0ee0f$export$2e2bcd8739ae039),
    formatRelative: (0, $7f937799be8030cb$export$2e2bcd8739ae039),
    localize: (0, $00ca33572a957ccd$export$2e2bcd8739ae039),
    match: (0, $0de1a2f2b923e288$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $ad33979d2f6c8b52$export$2e2bcd8739ae039 = $ad33979d2f6c8b52$var$locale;


var $17f01400530af798$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "کمتر از یک ثانیه",
        other: "کمتر از {{count}} ثانیه"
    },
    xSeconds: {
        one: "1 ثانیه",
        other: "{{count}} ثانیه"
    },
    halfAMinute: "نیم دقیقه",
    lessThanXMinutes: {
        one: "کمتر از یک دقیقه",
        other: "کمتر از {{count}} دقیقه"
    },
    xMinutes: {
        one: "1 دقیقه",
        other: "{{count}} دقیقه"
    },
    aboutXHours: {
        one: "حدود 1 ساعت",
        other: "حدود {{count}} ساعت"
    },
    xHours: {
        one: "1 ساعت",
        other: "{{count}} ساعت"
    },
    xDays: {
        one: "1 روز",
        other: "{{count}} روز"
    },
    aboutXWeeks: {
        one: "حدود 1 هفته",
        other: "حدود {{count}} هفته"
    },
    xWeeks: {
        one: "1 هفته",
        other: "{{count}} هفته"
    },
    aboutXMonths: {
        one: "حدود 1 ماه",
        other: "حدود {{count}} ماه"
    },
    xMonths: {
        one: "1 ماه",
        other: "{{count}} ماه"
    },
    aboutXYears: {
        one: "حدود 1 سال",
        other: "حدود {{count}} سال"
    },
    xYears: {
        one: "1 سال",
        other: "{{count}} سال"
    },
    overXYears: {
        one: "بیشتر از 1 سال",
        other: "بیشتر از {{count}} سال"
    },
    almostXYears: {
        one: "نزدیک 1 سال",
        other: "نزدیک {{count}} سال"
    }
};
var $17f01400530af798$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $17f01400530af798$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "در " + result;
        else return result + " قبل";
    }
    return result;
};
var $17f01400530af798$export$2e2bcd8739ae039 = $17f01400530af798$var$formatDistance;



var $402ce7b305cc2461$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "yyyy/MM/dd"
};
var $402ce7b305cc2461$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $402ce7b305cc2461$var$dateTimeFormats = {
    full: "{{date}} 'در' {{time}}",
    long: "{{date}} 'در' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $402ce7b305cc2461$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $402ce7b305cc2461$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $402ce7b305cc2461$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $402ce7b305cc2461$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $402ce7b305cc2461$export$2e2bcd8739ae039 = $402ce7b305cc2461$var$formatLong;


var $57bc6edeb7257d39$var$formatRelativeLocale = {
    lastWeek: "eeee 'گذشته در' p",
    yesterday: "'دیروز در' p",
    today: "'امروز در' p",
    tomorrow: "'فردا در' p",
    nextWeek: "eeee 'در' p",
    other: "P"
};
var $57bc6edeb7257d39$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $57bc6edeb7257d39$var$formatRelativeLocale[token];
};
var $57bc6edeb7257d39$export$2e2bcd8739ae039 = $57bc6edeb7257d39$var$formatRelative;



var $a62bdd3ae4273111$var$eraValues = {
    narrow: [
        "ق",
        "ب"
    ],
    abbreviated: [
        "ق.م.",
        "ب.م."
    ],
    wide: [
        "قبل از میلاد",
        "بعد از میلاد"
    ]
};
var $a62bdd3ae4273111$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "س‌م1",
        "س‌م2",
        "س‌م3",
        "س‌م4"
    ],
    wide: [
        "سه‌ماهه 1",
        "سه‌ماهه 2",
        "سه‌ماهه 3",
        "سه‌ماهه 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a62bdd3ae4273111$var$monthValues = {
    narrow: [
        "ژ",
        "ف",
        "م",
        "آ",
        "م",
        "ج",
        "ج",
        "آ",
        "س",
        "ا",
        "ن",
        "د"
    ],
    abbreviated: [
        "ژانـ",
        "فور",
        "مارس",
        "آپر",
        "می",
        "جون",
        "جولـ",
        "آگو",
        "سپتـ",
        "اکتـ",
        "نوامـ",
        "دسامـ"
    ],
    wide: [
        "ژانویه",
        "فوریه",
        "مارس",
        "آپریل",
        "می",
        "جون",
        "جولای",
        "آگوست",
        "سپتامبر",
        "اکتبر",
        "نوامبر",
        "دسامبر"
    ]
};
var $a62bdd3ae4273111$var$dayValues = {
    narrow: [
        "ی",
        "د",
        "س",
        "چ",
        "پ",
        "ج",
        "ش"
    ],
    short: [
        "1ش",
        "2ش",
        "3ش",
        "4ش",
        "5ش",
        "ج",
        "ش"
    ],
    abbreviated: [
        "یکشنبه",
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنجشنبه",
        "جمعه",
        "شنبه"
    ],
    wide: [
        "یکشنبه",
        "دوشنبه",
        "سه‌شنبه",
        "چهارشنبه",
        "پنجشنبه",
        "جمعه",
        "شنبه"
    ]
};
var $a62bdd3ae4273111$var$dayPeriodValues = {
    narrow: {
        am: "ق",
        pm: "ب",
        midnight: "ن",
        noon: "ظ",
        morning: "ص",
        afternoon: "ب.ظ.",
        evening: "ع",
        night: "ش"
    },
    abbreviated: {
        am: "ق.ظ.",
        pm: "ب.ظ.",
        midnight: "نیمه‌شب",
        noon: "ظهر",
        morning: "صبح",
        afternoon: "بعدازظهر",
        evening: "عصر",
        night: "شب"
    },
    wide: {
        am: "قبل‌ازظهر",
        pm: "بعدازظهر",
        midnight: "نیمه‌شب",
        noon: "ظهر",
        morning: "صبح",
        afternoon: "بعدازظهر",
        evening: "عصر",
        night: "شب"
    }
};
var $a62bdd3ae4273111$var$formattingDayPeriodValues = {
    narrow: {
        am: "ق",
        pm: "ب",
        midnight: "ن",
        noon: "ظ",
        morning: "ص",
        afternoon: "ب.ظ.",
        evening: "ع",
        night: "ش"
    },
    abbreviated: {
        am: "ق.ظ.",
        pm: "ب.ظ.",
        midnight: "نیمه‌شب",
        noon: "ظهر",
        morning: "صبح",
        afternoon: "بعدازظهر",
        evening: "عصر",
        night: "شب"
    },
    wide: {
        am: "قبل‌ازظهر",
        pm: "بعدازظهر",
        midnight: "نیمه‌شب",
        noon: "ظهر",
        morning: "صبح",
        afternoon: "بعدازظهر",
        evening: "عصر",
        night: "شب"
    }
};
var $a62bdd3ae4273111$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $a62bdd3ae4273111$var$localize = {
    ordinalNumber: $a62bdd3ae4273111$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a62bdd3ae4273111$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a62bdd3ae4273111$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a62bdd3ae4273111$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a62bdd3ae4273111$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a62bdd3ae4273111$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a62bdd3ae4273111$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a62bdd3ae4273111$export$2e2bcd8739ae039 = $a62bdd3ae4273111$var$localize;




var $3c7a63bb8a5764fc$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $3c7a63bb8a5764fc$var$parseOrdinalNumberPattern = /\d+/i;
var $3c7a63bb8a5764fc$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var $3c7a63bb8a5764fc$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $3c7a63bb8a5764fc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var $3c7a63bb8a5764fc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3c7a63bb8a5764fc$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var $3c7a63bb8a5764fc$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var $3c7a63bb8a5764fc$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var $3c7a63bb8a5764fc$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var $3c7a63bb8a5764fc$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var $3c7a63bb8a5764fc$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var $3c7a63bb8a5764fc$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $3c7a63bb8a5764fc$var$matchOrdinalNumberPattern,
        parsePattern: $3c7a63bb8a5764fc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3c7a63bb8a5764fc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c7a63bb8a5764fc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3c7a63bb8a5764fc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c7a63bb8a5764fc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3c7a63bb8a5764fc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c7a63bb8a5764fc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3c7a63bb8a5764fc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c7a63bb8a5764fc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3c7a63bb8a5764fc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3c7a63bb8a5764fc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $3c7a63bb8a5764fc$export$2e2bcd8739ae039 = $3c7a63bb8a5764fc$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var $2373930e51969456$var$locale = {
    code: "fa-IR",
    formatDistance: (0, $17f01400530af798$export$2e2bcd8739ae039),
    formatLong: (0, $402ce7b305cc2461$export$2e2bcd8739ae039),
    formatRelative: (0, $57bc6edeb7257d39$export$2e2bcd8739ae039),
    localize: (0, $a62bdd3ae4273111$export$2e2bcd8739ae039),
    match: (0, $3c7a63bb8a5764fc$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $2373930e51969456$export$2e2bcd8739ae039 = $2373930e51969456$var$locale;


function $d33e7c5e0d8ac0bf$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, "sekunnin");
}
function $d33e7c5e0d8ac0bf$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, "minuutin");
}
function $d33e7c5e0d8ac0bf$var$futureHours(text) {
    return text.replace(/tuntia?/, "tunnin");
}
function $d33e7c5e0d8ac0bf$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $d33e7c5e0d8ac0bf$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, "viikon");
}
function $d33e7c5e0d8ac0bf$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function $d33e7c5e0d8ac0bf$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, "vuoden");
}
var $d33e7c5e0d8ac0bf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "alle sekunti",
        other: "alle {{count}} sekuntia",
        futureTense: $d33e7c5e0d8ac0bf$var$futureSeconds
    },
    xSeconds: {
        one: "sekunti",
        other: "{{count}} sekuntia",
        futureTense: $d33e7c5e0d8ac0bf$var$futureSeconds
    },
    halfAMinute: {
        one: "puoli minuuttia",
        other: "puoli minuuttia",
        futureTense: function futureTense(_text) {
            return "puolen minuutin";
        }
    },
    lessThanXMinutes: {
        one: "alle minuutti",
        other: "alle {{count}} minuuttia",
        futureTense: $d33e7c5e0d8ac0bf$var$futureMinutes
    },
    xMinutes: {
        one: "minuutti",
        other: "{{count}} minuuttia",
        futureTense: $d33e7c5e0d8ac0bf$var$futureMinutes
    },
    aboutXHours: {
        one: "noin tunti",
        other: "noin {{count}} tuntia",
        futureTense: $d33e7c5e0d8ac0bf$var$futureHours
    },
    xHours: {
        one: "tunti",
        other: "{{count}} tuntia",
        futureTense: $d33e7c5e0d8ac0bf$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $d33e7c5e0d8ac0bf$var$futureDays
    },
    aboutXWeeks: {
        one: "noin viikko",
        other: "noin {{count}} viikkoa",
        futureTense: $d33e7c5e0d8ac0bf$var$futureWeeks
    },
    xWeeks: {
        one: "viikko",
        other: "{{count}} viikkoa",
        futureTense: $d33e7c5e0d8ac0bf$var$futureWeeks
    },
    aboutXMonths: {
        one: "noin kuukausi",
        other: "noin {{count}} kuukautta",
        futureTense: $d33e7c5e0d8ac0bf$var$futureMonths
    },
    xMonths: {
        one: "kuukausi",
        other: "{{count}} kuukautta",
        futureTense: $d33e7c5e0d8ac0bf$var$futureMonths
    },
    aboutXYears: {
        one: "noin vuosi",
        other: "noin {{count}} vuotta",
        futureTense: $d33e7c5e0d8ac0bf$var$futureYears
    },
    xYears: {
        one: "vuosi",
        other: "{{count}} vuotta",
        futureTense: $d33e7c5e0d8ac0bf$var$futureYears
    },
    overXYears: {
        one: "yli vuosi",
        other: "yli {{count}} vuotta",
        futureTense: $d33e7c5e0d8ac0bf$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $d33e7c5e0d8ac0bf$var$futureYears
    }
};
var $d33e7c5e0d8ac0bf$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $d33e7c5e0d8ac0bf$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + " kuluttua";
        else return result + " sitten";
    }
    return result;
};
var $d33e7c5e0d8ac0bf$export$2e2bcd8739ae039 = $d33e7c5e0d8ac0bf$var$formatDistance;



var $39d401ea042c33f2$var$dateFormats = {
    full: "eeee d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "d.M.y"
};
var $39d401ea042c33f2$var$timeFormats = {
    full: "HH.mm.ss zzzz",
    long: "HH.mm.ss z",
    medium: "HH.mm.ss",
    short: "HH.mm"
};
var $39d401ea042c33f2$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $39d401ea042c33f2$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $39d401ea042c33f2$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $39d401ea042c33f2$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $39d401ea042c33f2$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $39d401ea042c33f2$export$2e2bcd8739ae039 = $39d401ea042c33f2$var$formatLong;


var $85ef23b92798649f$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: "P"
};
var $85ef23b92798649f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $85ef23b92798649f$var$formatRelativeLocale[token];
};
var $85ef23b92798649f$export$2e2bcd8739ae039 = $85ef23b92798649f$var$formatRelative;



var $e687a4c76be9b126$var$eraValues = {
    narrow: [
        "eaa.",
        "jaa."
    ],
    abbreviated: [
        "eaa.",
        "jaa."
    ],
    wide: [
        "ennen ajanlaskun alkua",
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $e687a4c76be9b126$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartaali",
        "2. kvartaali",
        "3. kvartaali",
        "4. kvartaali"
    ]
};
var $e687a4c76be9b126$var$monthValues = {
    narrow: [
        "T",
        "H",
        "M",
        "H",
        "T",
        "K",
        "H",
        "E",
        "S",
        "L",
        "M",
        "J"
    ],
    abbreviated: [
        "tammi",
        "helmi",
        "maalis",
        "huhti",
        "touko",
        "kes\xe4",
        "hein\xe4",
        "elo",
        "syys",
        "loka",
        "marras",
        "joulu"
    ],
    wide: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kes\xe4kuu",
        "hein\xe4kuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
    ]
};
var $e687a4c76be9b126$var$formattingMonthValues = {
    narrow: $e687a4c76be9b126$var$monthValues.narrow,
    abbreviated: $e687a4c76be9b126$var$monthValues.abbreviated,
    wide: [
        "tammikuuta",
        "helmikuuta",
        "maaliskuuta",
        "huhtikuuta",
        "toukokuuta",
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        "elokuuta",
        "syyskuuta",
        "lokakuuta",
        "marraskuuta",
        "joulukuuta"
    ]
};
var $e687a4c76be9b126$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "K",
        "T",
        "P",
        "L"
    ],
    short: [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
    ],
    abbreviated: [
        "sunn.",
        "maan.",
        "tiis.",
        "kesk.",
        "torst.",
        "perj.",
        "la"
    ],
    wide: [
        "sunnuntai",
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai"
    ]
};
var $e687a4c76be9b126$var$formattingDayValues = {
    narrow: $e687a4c76be9b126$var$dayValues.narrow,
    short: $e687a4c76be9b126$var$dayValues.short,
    abbreviated: $e687a4c76be9b126$var$dayValues.abbreviated,
    wide: [
        "sunnuntaina",
        "maanantaina",
        "tiistaina",
        "keskiviikkona",
        "torstaina",
        "perjantaina",
        "lauantaina"
    ]
};
var $e687a4c76be9b126$var$dayPeriodValues = {
    narrow: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    }
};
var $e687a4c76be9b126$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $e687a4c76be9b126$var$localize = {
    ordinalNumber: $e687a4c76be9b126$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e687a4c76be9b126$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e687a4c76be9b126$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e687a4c76be9b126$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $e687a4c76be9b126$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e687a4c76be9b126$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $e687a4c76be9b126$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e687a4c76be9b126$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $e687a4c76be9b126$export$2e2bcd8739ae039 = $e687a4c76be9b126$var$localize;




var $6477afa9837971da$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $6477afa9837971da$var$parseOrdinalNumberPattern = /\d+/i;
var $6477afa9837971da$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $6477afa9837971da$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $6477afa9837971da$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $6477afa9837971da$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6477afa9837971da$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $6477afa9837971da$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $6477afa9837971da$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $6477afa9837971da$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $6477afa9837971da$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $6477afa9837971da$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $6477afa9837971da$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $6477afa9837971da$var$matchOrdinalNumberPattern,
        parsePattern: $6477afa9837971da$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $6477afa9837971da$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6477afa9837971da$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $6477afa9837971da$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6477afa9837971da$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $6477afa9837971da$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6477afa9837971da$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $6477afa9837971da$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6477afa9837971da$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $6477afa9837971da$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6477afa9837971da$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6477afa9837971da$export$2e2bcd8739ae039 = $6477afa9837971da$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $d271f2b00a2f1f84$var$locale = {
    code: "fi",
    formatDistance: (0, $d33e7c5e0d8ac0bf$export$2e2bcd8739ae039),
    formatLong: (0, $39d401ea042c33f2$export$2e2bcd8739ae039),
    formatRelative: (0, $85ef23b92798649f$export$2e2bcd8739ae039),
    localize: (0, $e687a4c76be9b126$export$2e2bcd8739ae039),
    match: (0, $6477afa9837971da$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d271f2b00a2f1f84$export$2e2bcd8739ae039 = $d271f2b00a2f1f84$var$locale;


var $e9cf9854324ced59$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d’une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d’une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d’un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu’un an",
        other: "presque {{count}} ans"
    }
};
var $e9cf9854324ced59$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $e9cf9854324ced59$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
var $e9cf9854324ced59$export$2e2bcd8739ae039 = $e9cf9854324ced59$var$formatDistance;



var $65cb343e97d5407c$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $65cb343e97d5407c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $65cb343e97d5407c$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $65cb343e97d5407c$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $65cb343e97d5407c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $65cb343e97d5407c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $65cb343e97d5407c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $65cb343e97d5407c$export$2e2bcd8739ae039 = $65cb343e97d5407c$var$formatLong;


var $4e70e6de508cd0cc$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd’hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
var $4e70e6de508cd0cc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4e70e6de508cd0cc$var$formatRelativeLocale[token];
};
var $4e70e6de508cd0cc$export$2e2bcd8739ae039 = $4e70e6de508cd0cc$var$formatRelative;



var $d1a202db8d8536e9$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $d1a202db8d8536e9$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $d1a202db8d8536e9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
var $d1a202db8d8536e9$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
var $d1a202db8d8536e9$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l’apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
var $d1a202db8d8536e9$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return "0";
    var feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
var $d1a202db8d8536e9$var$localize = {
    ordinalNumber: $d1a202db8d8536e9$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1a202db8d8536e9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1a202db8d8536e9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1a202db8d8536e9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1a202db8d8536e9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1a202db8d8536e9$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $d1a202db8d8536e9$export$2e2bcd8739ae039 = $d1a202db8d8536e9$var$localize;




var $e00f6e2b696a2967$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $e00f6e2b696a2967$var$parseOrdinalNumberPattern = /\d+/i;
var $e00f6e2b696a2967$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $e00f6e2b696a2967$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $e00f6e2b696a2967$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $e00f6e2b696a2967$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e00f6e2b696a2967$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $e00f6e2b696a2967$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e00f6e2b696a2967$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $e00f6e2b696a2967$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $e00f6e2b696a2967$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $e00f6e2b696a2967$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $e00f6e2b696a2967$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $e00f6e2b696a2967$var$matchOrdinalNumberPattern,
        parsePattern: $e00f6e2b696a2967$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e00f6e2b696a2967$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e00f6e2b696a2967$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e00f6e2b696a2967$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e00f6e2b696a2967$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e00f6e2b696a2967$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e00f6e2b696a2967$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e00f6e2b696a2967$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e00f6e2b696a2967$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e00f6e2b696a2967$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e00f6e2b696a2967$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e00f6e2b696a2967$export$2e2bcd8739ae039 = $e00f6e2b696a2967$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $30fd3bfe9e985633$var$locale = {
    code: "fr",
    formatDistance: (0, $e9cf9854324ced59$export$2e2bcd8739ae039),
    formatLong: (0, $65cb343e97d5407c$export$2e2bcd8739ae039),
    formatRelative: (0, $4e70e6de508cd0cc$export$2e2bcd8739ae039),
    localize: (0, $d1a202db8d8536e9$export$2e2bcd8739ae039),
    match: (0, $e00f6e2b696a2967$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $30fd3bfe9e985633$export$2e2bcd8739ae039 = $30fd3bfe9e985633$var$locale;


// Same as fr





var $6052613b1acfbe97$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "yy-MM-dd"
};
var $6052613b1acfbe97$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $6052613b1acfbe97$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $6052613b1acfbe97$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6052613b1acfbe97$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6052613b1acfbe97$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6052613b1acfbe97$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $6052613b1acfbe97$export$2e2bcd8739ae039 = $6052613b1acfbe97$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var $e6a36a0d68e9e2cd$var$locale = {
    code: "fr-CA",
    formatDistance: (0, $e9cf9854324ced59$export$2e2bcd8739ae039),
    formatLong: (0, $6052613b1acfbe97$export$2e2bcd8739ae039),
    formatRelative: (0, $4e70e6de508cd0cc$export$2e2bcd8739ae039),
    localize: (0, $d1a202db8d8536e9$export$2e2bcd8739ae039),
    match: (0, $e00f6e2b696a2967$export$2e2bcd8739ae039),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $e6a36a0d68e9e2cd$export$2e2bcd8739ae039 = $e6a36a0d68e9e2cd$var$locale;


// Same as fr




var $280c051726ad16c9$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
var $280c051726ad16c9$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $280c051726ad16c9$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $280c051726ad16c9$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $280c051726ad16c9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $280c051726ad16c9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $280c051726ad16c9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $280c051726ad16c9$export$2e2bcd8739ae039 = $280c051726ad16c9$var$formatLong;


var $c90168a7bf7086b8$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd’hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: "P"
};
var $c90168a7bf7086b8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c90168a7bf7086b8$var$formatRelativeLocale[token];
};
var $c90168a7bf7086b8$export$2e2bcd8739ae039 = $c90168a7bf7086b8$var$formatRelative;


/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $23391c162eceb983$var$locale = {
    code: "fr-CH",
    formatDistance: (0, $e9cf9854324ced59$export$2e2bcd8739ae039),
    formatLong: (0, $280c051726ad16c9$export$2e2bcd8739ae039),
    formatRelative: (0, $c90168a7bf7086b8$export$2e2bcd8739ae039),
    localize: (0, $d1a202db8d8536e9$export$2e2bcd8739ae039),
    match: (0, $e00f6e2b696a2967$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $23391c162eceb983$export$2e2bcd8739ae039 = $23391c162eceb983$var$locale;


var $e2520031a1713d64$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 1 sekonde",
        other: "minder as {{count}} sekonden"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekonden"
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: "minder as {{count}} minuten"
    },
    xMinutes: {
        one: "1 min\xfat",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "sawat 1 oere",
        other: "sawat {{count}} oere"
    },
    xHours: {
        one: "1 oere",
        other: "{{count}} oere"
    },
    xDays: {
        one: "1 dei",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "sawat 1 wike",
        other: "sawat {{count}} wiken"
    },
    xWeeks: {
        one: "1 wike",
        other: "{{count}} wiken"
    },
    aboutXMonths: {
        one: "sawat 1 moanne",
        other: "sawat {{count}} moannen"
    },
    xMonths: {
        one: "1 moanne",
        other: "{{count}} moannen"
    },
    aboutXYears: {
        one: "sawat 1 jier",
        other: "sawat {{count}} jier"
    },
    xYears: {
        one: "1 jier",
        other: "{{count}} jier"
    },
    overXYears: {
        one: "mear as 1 jier",
        other: "mear as {{count}}s jier"
    },
    almostXYears: {
        one: "hast 1 jier",
        other: "hast {{count}} jier"
    }
};
var $e2520031a1713d64$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e2520031a1713d64$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oer " + result;
        else return result + " lyn";
    }
    return result;
};
var $e2520031a1713d64$export$2e2bcd8739ae039 = $e2520031a1713d64$var$formatDistance;



var $e8438d6804b5c91f$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
var $e8438d6804b5c91f$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $e8438d6804b5c91f$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $e8438d6804b5c91f$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e8438d6804b5c91f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e8438d6804b5c91f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e8438d6804b5c91f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e8438d6804b5c91f$export$2e2bcd8739ae039 = $e8438d6804b5c91f$var$formatLong;


var $d1fb71b127cf282e$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $d1fb71b127cf282e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d1fb71b127cf282e$var$formatRelativeLocale[token];
};
var $d1fb71b127cf282e$export$2e2bcd8739ae039 = $d1fb71b127cf282e$var$formatRelative;



var $f82e0ae06a10e0e9$var$eraValues = {
    narrow: [
        "f.K.",
        "n.K."
    ],
    abbreviated: [
        "f.Kr.",
        "n.Kr."
    ],
    wide: [
        "foar Kristus",
        "nei Kristus"
    ]
};
var $f82e0ae06a10e0e9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e fearnsjier",
        "2e fearnsjier",
        "3e fearnsjier",
        "4e fearnsjier"
    ]
};
var $f82e0ae06a10e0e9$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mai.",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "jannewaris",
        "febrewaris",
        "maart",
        "april",
        "maaie",
        "juny",
        "july",
        "augustus",
        "septimber",
        "oktober",
        "novimber",
        "desimber"
    ]
};
var $f82e0ae06a10e0e9$var$dayValues = {
    narrow: [
        "s",
        "m",
        "t",
        "w",
        "t",
        "f",
        "s"
    ],
    short: [
        "si",
        "mo",
        "ti",
        "wo",
        "to",
        "fr",
        "so"
    ],
    abbreviated: [
        "snein",
        "moa",
        "tii",
        "woa",
        "ton",
        "fre",
        "sneon"
    ],
    wide: [
        "snein",
        "moandei",
        "tiisdei",
        "woansdei",
        "tongersdei",
        "freed",
        "sneon"
    ]
};
var $f82e0ae06a10e0e9$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    }
};
var $f82e0ae06a10e0e9$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "e";
};
var $f82e0ae06a10e0e9$var$localize = {
    ordinalNumber: $f82e0ae06a10e0e9$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f82e0ae06a10e0e9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f82e0ae06a10e0e9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f82e0ae06a10e0e9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f82e0ae06a10e0e9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f82e0ae06a10e0e9$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $f82e0ae06a10e0e9$export$2e2bcd8739ae039 = $f82e0ae06a10e0e9$var$localize;




var $5ebe2863feaf3a4b$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $5ebe2863feaf3a4b$var$parseOrdinalNumberPattern = /\d+/i;
var $5ebe2863feaf3a4b$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var $5ebe2863feaf3a4b$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var $5ebe2863feaf3a4b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var $5ebe2863feaf3a4b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5ebe2863feaf3a4b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var $5ebe2863feaf3a4b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var $5ebe2863feaf3a4b$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var $5ebe2863feaf3a4b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var $5ebe2863feaf3a4b$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var $5ebe2863feaf3a4b$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var $5ebe2863feaf3a4b$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $5ebe2863feaf3a4b$var$matchOrdinalNumberPattern,
        parsePattern: $5ebe2863feaf3a4b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5ebe2863feaf3a4b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5ebe2863feaf3a4b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5ebe2863feaf3a4b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5ebe2863feaf3a4b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5ebe2863feaf3a4b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5ebe2863feaf3a4b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5ebe2863feaf3a4b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5ebe2863feaf3a4b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5ebe2863feaf3a4b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5ebe2863feaf3a4b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $5ebe2863feaf3a4b$export$2e2bcd8739ae039 = $5ebe2863feaf3a4b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var $dbca903092ce136e$var$locale = {
    code: "fy",
    formatDistance: (0, $e2520031a1713d64$export$2e2bcd8739ae039),
    formatLong: (0, $e8438d6804b5c91f$export$2e2bcd8739ae039),
    formatRelative: (0, $d1fb71b127cf282e$export$2e2bcd8739ae039),
    localize: (0, $f82e0ae06a10e0e9$export$2e2bcd8739ae039),
    match: (0, $5ebe2863feaf3a4b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $dbca903092ce136e$export$2e2bcd8739ae039 = $dbca903092ce136e$var$locale;


var $84d28c115e8b477b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "nas lugha na diog",
        other: "nas lugha na {{count}} diogan"
    },
    xSeconds: {
        one: "1 diog",
        two: "2 dhiog",
        twenty: "20 diog",
        other: "{{count}} diogan"
    },
    halfAMinute: "leth mhionaid",
    lessThanXMinutes: {
        one: "nas lugha na mionaid",
        other: "nas lugha na {{count}} mionaidean"
    },
    xMinutes: {
        one: "1 mionaid",
        two: "2 mhionaid",
        twenty: "20 mionaid",
        other: "{{count}} mionaidean"
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: "mu 1 seachdain",
        other: "mu {{count}} seachdainean"
    },
    xWeeks: {
        one: "1 seachdain",
        other: "{{count}} seachdainean"
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: "mu bhliadhna",
        other: "mu {{count}} bliadhnaichean"
    },
    xYears: {
        one: "1 bhliadhna",
        other: "{{count}} bliadhna"
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var $84d28c115e8b477b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $84d28c115e8b477b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "ann an " + result;
        else return "o chionn " + result;
    }
    return result;
};
var $84d28c115e8b477b$export$2e2bcd8739ae039 = $84d28c115e8b477b$var$formatDistance;



var $a3fab124d67d6825$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $a3fab124d67d6825$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $a3fab124d67d6825$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $a3fab124d67d6825$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a3fab124d67d6825$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a3fab124d67d6825$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a3fab124d67d6825$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a3fab124d67d6825$export$2e2bcd8739ae039 = $a3fab124d67d6825$var$formatLong;


var $c235b22e2b7f544f$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: "P"
};
var $c235b22e2b7f544f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c235b22e2b7f544f$var$formatRelativeLocale[token];
};
var $c235b22e2b7f544f$export$2e2bcd8739ae039 = $c235b22e2b7f544f$var$formatRelative;



var $f32d814aabe022fa$var$eraValues = {
    narrow: [
        "R",
        "A"
    ],
    abbreviated: [
        "RC",
        "AD"
    ],
    wide: [
        "ro Chr\xecosta",
        "anno domini"
    ]
};
var $f32d814aabe022fa$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "C1",
        "C2",
        "C3",
        "C4"
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        "an treas cairteal",
        "an ceathramh cairteal"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $f32d814aabe022fa$var$monthValues = {
    narrow: [
        "F",
        "G",
        "M",
        "G",
        "C",
        "\xd2",
        "I",
        "L",
        "S",
        "D",
        "S",
        "D"
    ],
    abbreviated: [
        "Faoi",
        "Gear",
        "M\xe0rt",
        "Gibl",
        "C\xe8it",
        "\xd2gmh",
        "Iuch",
        "L\xf9n",
        "Sult",
        "D\xe0mh",
        "Samh",
        "D\xf9bh"
    ],
    wide: [
        "Am Faoilleach",
        "An Gearran",
        "Am M\xe0rt",
        "An Giblean",
        "An C\xe8itean",
        "An t-\xd2gmhios",
        "An t-Iuchar",
        "An L\xf9nastal",
        "An t-Sultain",
        "An D\xe0mhair",
        "An t-Samhain",
        "An D\xf9bhlachd"
    ]
};
var $f32d814aabe022fa$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "C",
        "A",
        "H",
        "S"
    ],
    short: [
        "D\xf2",
        "Lu",
        "M\xe0",
        "Ci",
        "Ar",
        "Ha",
        "Sa"
    ],
    abbreviated: [
        "Did",
        "Dil",
        "Dim",
        "Dic",
        "Dia",
        "Dih",
        "Dis"
    ],
    wide: [
        "Did\xf2mhnaich",
        "Diluain",
        "Dim\xe0irt",
        "Diciadain",
        "Diardaoin",
        "Dihaoine",
        "Disathairne"
    ]
};
var $f32d814aabe022fa$var$dayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    }
};
var $f32d814aabe022fa$var$formattingDayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    }
};
var $f32d814aabe022fa$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "d";
        case 2:
            return number + "na";
    }
    if (rem100 === 12) return number + "na";
    return number + "mh";
};
var $f32d814aabe022fa$var$localize = {
    ordinalNumber: $f32d814aabe022fa$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f32d814aabe022fa$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f32d814aabe022fa$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f32d814aabe022fa$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f32d814aabe022fa$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f32d814aabe022fa$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f32d814aabe022fa$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $f32d814aabe022fa$export$2e2bcd8739ae039 = $f32d814aabe022fa$var$localize;




var $a370c7d2db2b1266$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var $a370c7d2db2b1266$var$parseOrdinalNumberPattern = /\d+/i;
var $a370c7d2db2b1266$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var $a370c7d2db2b1266$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $a370c7d2db2b1266$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var $a370c7d2db2b1266$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a370c7d2db2b1266$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var $a370c7d2db2b1266$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var $a370c7d2db2b1266$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var $a370c7d2db2b1266$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var $a370c7d2db2b1266$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var $a370c7d2db2b1266$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var $a370c7d2db2b1266$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a370c7d2db2b1266$var$matchOrdinalNumberPattern,
        parsePattern: $a370c7d2db2b1266$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a370c7d2db2b1266$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a370c7d2db2b1266$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a370c7d2db2b1266$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a370c7d2db2b1266$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a370c7d2db2b1266$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a370c7d2db2b1266$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a370c7d2db2b1266$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a370c7d2db2b1266$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a370c7d2db2b1266$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a370c7d2db2b1266$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a370c7d2db2b1266$export$2e2bcd8739ae039 = $a370c7d2db2b1266$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var $388b1cd55881ad60$var$locale = {
    code: "gd",
    formatDistance: (0, $84d28c115e8b477b$export$2e2bcd8739ae039),
    formatLong: (0, $a3fab124d67d6825$export$2e2bcd8739ae039),
    formatRelative: (0, $c235b22e2b7f544f$export$2e2bcd8739ae039),
    localize: (0, $f32d814aabe022fa$export$2e2bcd8739ae039),
    match: (0, $a370c7d2db2b1266$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $388b1cd55881ad60$export$2e2bcd8739ae039 = $388b1cd55881ad60$var$locale;


var $e47b74c23d13544e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos dun segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos dun minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "arredor dunha hora",
        other: "arredor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "arredor dunha semana",
        other: "arredor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "arredor de 1 mes",
        other: "arredor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "arredor dun ano",
        other: "arredor de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: "case un ano",
        other: "case {{count}} anos"
    }
};
var $e47b74c23d13544e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e47b74c23d13544e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hai " + result;
    }
    return result;
};
var $e47b74c23d13544e$export$2e2bcd8739ae039 = $e47b74c23d13544e$var$formatDistance;



var $d402dd915397ce36$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $d402dd915397ce36$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $d402dd915397ce36$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d402dd915397ce36$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d402dd915397ce36$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d402dd915397ce36$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d402dd915397ce36$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d402dd915397ce36$export$2e2bcd8739ae039 = $d402dd915397ce36$var$formatLong;


var $0b688ccc5db53c43$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: "P"
};
var $0b688ccc5db53c43$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: "P"
};
var $0b688ccc5db53c43$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $0b688ccc5db53c43$var$formatRelativeLocalePlural[token];
    return $0b688ccc5db53c43$var$formatRelativeLocale[token];
};
var $0b688ccc5db53c43$export$2e2bcd8739ae039 = $0b688ccc5db53c43$var$formatRelative;



var $757a2feb89294030$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despois de cristo"
    ]
};
var $757a2feb89294030$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $757a2feb89294030$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "xan",
        "feb",
        "mar",
        "abr",
        "mai",
        "xun",
        "xul",
        "ago",
        "set",
        "out",
        "nov",
        "dec"
    ],
    wide: [
        "xaneiro",
        "febreiro",
        "marzo",
        "abril",
        "maio",
        "xu\xf1o",
        "xullo",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "decembro"
    ]
};
var $757a2feb89294030$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "me",
        "xo",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "xov",
        "ven",
        "sab"
    ],
    wide: [
        "domingo",
        "luns",
        "martes",
        "m\xe9rcores",
        "xoves",
        "venres",
        "s\xe1bado"
    ]
};
var $757a2feb89294030$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    }
};
var $757a2feb89294030$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    }
};
var $757a2feb89294030$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $757a2feb89294030$var$localize = {
    ordinalNumber: $757a2feb89294030$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $757a2feb89294030$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $757a2feb89294030$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $757a2feb89294030$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $757a2feb89294030$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $757a2feb89294030$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $757a2feb89294030$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $757a2feb89294030$export$2e2bcd8739ae039 = $757a2feb89294030$var$localize;




var $c1d29ab5a738fa62$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $c1d29ab5a738fa62$var$parseOrdinalNumberPattern = /\d+/i;
var $c1d29ab5a738fa62$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var $c1d29ab5a738fa62$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var $c1d29ab5a738fa62$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $c1d29ab5a738fa62$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c1d29ab5a738fa62$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var $c1d29ab5a738fa62$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var $c1d29ab5a738fa62$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var $c1d29ab5a738fa62$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var $c1d29ab5a738fa62$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var $c1d29ab5a738fa62$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var $c1d29ab5a738fa62$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $c1d29ab5a738fa62$var$matchOrdinalNumberPattern,
        parsePattern: $c1d29ab5a738fa62$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c1d29ab5a738fa62$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1d29ab5a738fa62$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c1d29ab5a738fa62$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1d29ab5a738fa62$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c1d29ab5a738fa62$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1d29ab5a738fa62$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c1d29ab5a738fa62$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c1d29ab5a738fa62$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c1d29ab5a738fa62$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c1d29ab5a738fa62$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $c1d29ab5a738fa62$export$2e2bcd8739ae039 = $c1d29ab5a738fa62$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var $ce986bb5d94e5e7f$var$locale = {
    code: "gl",
    formatDistance: (0, $e47b74c23d13544e$export$2e2bcd8739ae039),
    formatLong: (0, $d402dd915397ce36$export$2e2bcd8739ae039),
    formatRelative: (0, $0b688ccc5db53c43$export$2e2bcd8739ae039),
    localize: (0, $757a2feb89294030$export$2e2bcd8739ae039),
    match: (0, $c1d29ab5a738fa62$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $ce986bb5d94e5e7f$export$2e2bcd8739ae039 = $ce986bb5d94e5e7f$var$locale;


// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $1b12d495bec8cf03$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "હમણાં",
        // CLDR #1461
        other: "​આશરે {{count}} સેકંડ"
    },
    xSeconds: {
        one: "1 સેકંડ",
        other: "{{count}} સેકંડ"
    },
    halfAMinute: "અડધી મિનિટ",
    lessThanXMinutes: {
        one: "આ મિનિટ",
        // CLDR #1448
        other: "​આશરે {{count}} મિનિટ"
    },
    xMinutes: {
        one: "1 મિનિટ",
        other: "{{count}} મિનિટ"
    },
    aboutXHours: {
        one: "​આશરે 1 કલાક",
        other: "​આશરે {{count}} કલાક"
    },
    xHours: {
        one: "1 કલાક",
        other: "{{count}} કલાક"
    },
    xDays: {
        one: "1 દિવસ",
        other: "{{count}} દિવસ"
    },
    aboutXWeeks: {
        one: "આશરે 1 અઠવાડિયું",
        other: "આશરે {{count}} અઠવાડિયા"
    },
    xWeeks: {
        one: "1 અઠવાડિયું",
        other: "{{count}} અઠવાડિયા"
    },
    aboutXMonths: {
        one: "આશરે 1 મહિનો",
        other: "આશરે {{count}} મહિના"
    },
    xMonths: {
        one: "1 મહિનો",
        other: "{{count}} મહિના"
    },
    aboutXYears: {
        one: "આશરે 1 વર્ષ",
        other: "આશરે {{count}} વર્ષ"
    },
    xYears: {
        one: "1 વર્ષ",
        other: "{{count}} વર્ષ"
    },
    overXYears: {
        one: "1 વર્ષથી વધુ",
        other: "{{count}} વર્ષથી વધુ"
    },
    almostXYears: {
        one: "લગભગ 1 વર્ષ",
        other: "લગભગ {{count}} વર્ષ"
    }
};
var $1b12d495bec8cf03$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1b12d495bec8cf03$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "માં";
        else return result + " પહેલાં";
    }
    return result;
};
var $1b12d495bec8cf03$export$2e2bcd8739ae039 = $1b12d495bec8cf03$var$formatDistance;



var $1140608dabb29752$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    // CLDR #1825
    long: "d MMMM, y",
    // CLDR #1826
    medium: "d MMM, y",
    // CLDR #1827
    short: "d/M/yy" // CLDR #1828
};
var $1140608dabb29752$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    // CLDR #1829
    long: "hh:mm:ss a z",
    // CLDR #1830
    medium: "hh:mm:ss a",
    // CLDR #1831
    short: "hh:mm a" // CLDR #1832
};
var $1140608dabb29752$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    // CLDR #1833
    long: "{{date}} {{time}}",
    // CLDR #1834
    medium: "{{date}} {{time}}",
    // CLDR #1835
    short: "{{date}} {{time}}" // CLDR #1836
};
var $1140608dabb29752$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $1140608dabb29752$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $1140608dabb29752$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $1140608dabb29752$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $1140608dabb29752$export$2e2bcd8739ae039 = $1140608dabb29752$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $ebc588e78cad7c6a$var$formatRelativeLocale = {
    lastWeek: "'પાછલા' eeee p",
    // CLDR #1384
    yesterday: "'ગઈકાલે' p",
    // CLDR #1409
    today: "'આજે' p",
    // CLDR #1410
    tomorrow: "'આવતીકાલે' p",
    // CLDR #1411
    nextWeek: "eeee p",
    // CLDR #1386
    other: "P"
};
var $ebc588e78cad7c6a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ebc588e78cad7c6a$var$formatRelativeLocale[token];
};
var $ebc588e78cad7c6a$export$2e2bcd8739ae039 = $ebc588e78cad7c6a$var$formatRelative;



// #1621 - #1630
var $1bc6408cf5e4b798$var$eraValues = {
    narrow: [
        "ઈસપૂ",
        "ઈસ"
    ],
    abbreviated: [
        "ઈ.સ.પૂર્વે",
        "ઈ.સ."
    ],
    wide: [
        "ઈસવીસન પૂર્વે",
        "ઈસવીસન"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var $1bc6408cf5e4b798$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1લો ત્રિમાસ",
        "2જો ત્રિમાસ",
        "3જો ત્રિમાસ",
        "4થો ત્રિમાસ"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var $1bc6408cf5e4b798$var$monthValues = {
    narrow: [
        "જા",
        "ફે",
        "મા",
        "એ",
        "મે",
        "જૂ",
        "જુ",
        "ઓ",
        "સ",
        "ઓ",
        "ન",
        "ડિ"
    ],
    abbreviated: [
        "જાન્યુ",
        "ફેબ્રુ",
        "માર્ચ",
        "એપ્રિલ",
        "મે",
        "જૂન",
        "જુલાઈ",
        "ઑગસ્ટ",
        "સપ્ટે",
        "ઓક્ટો",
        "નવે",
        "ડિસે"
    ],
    wide: [
        "જાન્યુઆરી",
        "ફેબ્રુઆરી",
        "માર્ચ",
        "એપ્રિલ",
        "મે",
        "જૂન",
        "જુલાઇ",
        "ઓગસ્ટ",
        "સપ્ટેમ્બર",
        "ઓક્ટોબર",
        "નવેમ્બર",
        "ડિસેમ્બર"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var $1bc6408cf5e4b798$var$dayValues = {
    narrow: [
        "ર",
        "સો",
        "મં",
        "બુ",
        "ગુ",
        "શુ",
        "શ"
    ],
    short: [
        "ર",
        "સો",
        "મં",
        "બુ",
        "ગુ",
        "શુ",
        "શ"
    ],
    abbreviated: [
        "રવિ",
        "સોમ",
        "મંગળ",
        "બુધ",
        "ગુરુ",
        "શુક્ર",
        "શનિ"
    ],
    wide: [
        "રવિવાર" /* Sunday */ ,
        "સોમવાર" /* Monday */ ,
        "મંગળવાર" /* Tuesday */ ,
        "બુધવાર" /* Wednesday */ ,
        "ગુરુવાર" /* Thursday */ ,
        "શુક્રવાર" /* Friday */ ,
        "શનિવાર" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var $1bc6408cf5e4b798$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "મ.રાત્રિ",
        noon: "બ.",
        morning: "સવારે",
        afternoon: "બપોરે",
        evening: "સાંજે",
        night: "રાત્રે"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "​મધ્યરાત્રિ",
        noon: "બપોરે",
        morning: "સવારે",
        afternoon: "બપોરે",
        evening: "સાંજે",
        night: "રાત્રે"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "​મધ્યરાત્રિ",
        noon: "બપોરે",
        morning: "સવારે",
        afternoon: "બપોરે",
        evening: "સાંજે",
        night: "રાત્રે"
    }
};
var $1bc6408cf5e4b798$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "મ.રાત્રિ",
        noon: "બપોરે",
        morning: "સવારે",
        afternoon: "બપોરે",
        evening: "સાંજે",
        night: "રાત્રે"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "મધ્યરાત્રિ",
        noon: "બપોરે",
        morning: "સવારે",
        afternoon: "બપોરે",
        evening: "સાંજે",
        night: "રાત્રે"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "​મધ્યરાત્રિ",
        noon: "બપોરે",
        morning: "સવારે",
        afternoon: "બપોરે",
        evening: "સાંજે",
        night: "રાત્રે"
    }
};
var $1bc6408cf5e4b798$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $1bc6408cf5e4b798$var$localize = {
    ordinalNumber: $1bc6408cf5e4b798$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1bc6408cf5e4b798$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1bc6408cf5e4b798$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1bc6408cf5e4b798$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1bc6408cf5e4b798$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $1bc6408cf5e4b798$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1bc6408cf5e4b798$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $1bc6408cf5e4b798$export$2e2bcd8739ae039 = $1bc6408cf5e4b798$var$localize;




var $cf92dbac8fc25054$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var $cf92dbac8fc25054$var$parseOrdinalNumberPattern = /\d+/i;
var $cf92dbac8fc25054$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var $cf92dbac8fc25054$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var $cf92dbac8fc25054$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var $cf92dbac8fc25054$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cf92dbac8fc25054$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var $cf92dbac8fc25054$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var $cf92dbac8fc25054$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var $cf92dbac8fc25054$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var $cf92dbac8fc25054$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var $cf92dbac8fc25054$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var $cf92dbac8fc25054$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $cf92dbac8fc25054$var$matchOrdinalNumberPattern,
        parsePattern: $cf92dbac8fc25054$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cf92dbac8fc25054$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cf92dbac8fc25054$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cf92dbac8fc25054$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cf92dbac8fc25054$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cf92dbac8fc25054$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cf92dbac8fc25054$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cf92dbac8fc25054$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cf92dbac8fc25054$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cf92dbac8fc25054$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cf92dbac8fc25054$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $cf92dbac8fc25054$export$2e2bcd8739ae039 = $cf92dbac8fc25054$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var $4dadab21df4729d0$var$locale = {
    code: "gu",
    formatDistance: (0, $1b12d495bec8cf03$export$2e2bcd8739ae039),
    formatLong: (0, $1140608dabb29752$export$2e2bcd8739ae039),
    formatRelative: (0, $ebc588e78cad7c6a$export$2e2bcd8739ae039),
    localize: (0, $1bc6408cf5e4b798$export$2e2bcd8739ae039),
    match: (0, $cf92dbac8fc25054$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4dadab21df4729d0$export$2e2bcd8739ae039 = $4dadab21df4729d0$var$locale;


var $cab7b96fca0b34b5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "פחות משנייה",
        two: "פחות משתי שניות",
        other: "פחות מ־{{count}} שניות"
    },
    xSeconds: {
        one: "שנייה",
        two: "שתי שניות",
        other: "{{count}} שניות"
    },
    halfAMinute: "חצי דקה",
    lessThanXMinutes: {
        one: "פחות מדקה",
        two: "פחות משתי דקות",
        other: "פחות מ־{{count}} דקות"
    },
    xMinutes: {
        one: "דקה",
        two: "שתי דקות",
        other: "{{count}} דקות"
    },
    aboutXHours: {
        one: "כשעה",
        two: "כשעתיים",
        other: "כ־{{count}} שעות"
    },
    xHours: {
        one: "שעה",
        two: "שעתיים",
        other: "{{count}} שעות"
    },
    xDays: {
        one: "יום",
        two: "יומיים",
        other: "{{count}} ימים"
    },
    aboutXWeeks: {
        one: "כשבוע",
        two: "כשבועיים",
        other: "כ־{{count}} שבועות"
    },
    xWeeks: {
        one: "שבוע",
        two: "שבועיים",
        other: "{{count}} שבועות"
    },
    aboutXMonths: {
        one: "כחודש",
        two: "כחודשיים",
        other: "כ־{{count}} חודשים"
    },
    xMonths: {
        one: "חודש",
        two: "חודשיים",
        other: "{{count}} חודשים"
    },
    aboutXYears: {
        one: "כשנה",
        two: "כשנתיים",
        other: "כ־{{count}} שנים"
    },
    xYears: {
        one: "שנה",
        two: "שנתיים",
        other: "{{count}} שנים"
    },
    overXYears: {
        one: "יותר משנה",
        two: "יותר משנתיים",
        other: "יותר מ־{{count}} שנים"
    },
    almostXYears: {
        one: "כמעט שנה",
        two: "כמעט שנתיים",
        other: "כמעט {{count}} שנים"
    }
};
var $cab7b96fca0b34b5$var$formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === "xDays" && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "מחר" : "מחרתיים";
        return count === 1 ? "אתמול" : "שלשום";
    }
    var result;
    var tokenValue = $cab7b96fca0b34b5$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "בעוד " + result;
        else return "לפני " + result;
    }
    return result;
};
var $cab7b96fca0b34b5$export$2e2bcd8739ae039 = $cab7b96fca0b34b5$var$formatDistance;



var $41fc925d44f5d5d1$var$dateFormats = {
    full: "EEEE, d בMMMM y",
    long: "d בMMMM y",
    medium: "d בMMM y",
    short: "d.M.y"
};
var $41fc925d44f5d5d1$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $41fc925d44f5d5d1$var$dateTimeFormats = {
    full: "{{date}} 'בשעה' {{time}}",
    long: "{{date}} 'בשעה' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $41fc925d44f5d5d1$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $41fc925d44f5d5d1$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $41fc925d44f5d5d1$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $41fc925d44f5d5d1$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $41fc925d44f5d5d1$export$2e2bcd8739ae039 = $41fc925d44f5d5d1$var$formatLong;


var $ad7fa2feac42dca5$var$formatRelativeLocale = {
    lastWeek: "eeee 'שעבר בשעה' p",
    yesterday: "'אתמול בשעה' p",
    today: "'היום בשעה' p",
    tomorrow: "'מחר בשעה' p",
    nextWeek: "eeee 'בשעה' p",
    other: "P"
};
var $ad7fa2feac42dca5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ad7fa2feac42dca5$var$formatRelativeLocale[token];
};
var $ad7fa2feac42dca5$export$2e2bcd8739ae039 = $ad7fa2feac42dca5$var$formatRelative;



var $242411d46e74b7be$var$eraValues = {
    narrow: [
        "לפנה״ס",
        "לספירה"
    ],
    abbreviated: [
        "לפנה״ס",
        "לספירה"
    ],
    wide: [
        "לפני הספירה",
        "לספירה"
    ]
};
var $242411d46e74b7be$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "רבעון 1",
        "רבעון 2",
        "רבעון 3",
        "רבעון 4"
    ]
};
var $242411d46e74b7be$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "ינו׳",
        "פבר׳",
        "מרץ",
        "אפר׳",
        "מאי",
        "יוני",
        "יולי",
        "אוג׳",
        "ספט׳",
        "אוק׳",
        "נוב׳",
        "דצמ׳"
    ],
    wide: [
        "ינואר",
        "פברואר",
        "מרץ",
        "אפריל",
        "מאי",
        "יוני",
        "יולי",
        "אוגוסט",
        "ספטמבר",
        "אוקטובר",
        "נובמבר",
        "דצמבר"
    ]
};
var $242411d46e74b7be$var$dayValues = {
    narrow: [
        "א׳",
        "ב׳",
        "ג׳",
        "ד׳",
        "ה׳",
        "ו׳",
        "ש׳"
    ],
    short: [
        "א׳",
        "ב׳",
        "ג׳",
        "ד׳",
        "ה׳",
        "ו׳",
        "ש׳"
    ],
    abbreviated: [
        "יום א׳",
        "יום ב׳",
        "יום ג׳",
        "יום ד׳",
        "יום ה׳",
        "יום ו׳",
        "שבת"
    ],
    wide: [
        "יום ראשון",
        "יום שני",
        "יום שלישי",
        "יום רביעי",
        "יום חמישי",
        "יום שישי",
        "יום שבת"
    ]
};
var $242411d46e74b7be$var$dayPeriodValues = {
    narrow: {
        am: "לפנה״צ",
        pm: "אחה״צ",
        midnight: "חצות",
        noon: "צהריים",
        morning: "בוקר",
        afternoon: "אחר הצהריים",
        evening: "ערב",
        night: "לילה"
    },
    abbreviated: {
        am: "לפנה״צ",
        pm: "אחה״צ",
        midnight: "חצות",
        noon: "צהריים",
        morning: "בוקר",
        afternoon: "אחר הצהריים",
        evening: "ערב",
        night: "לילה"
    },
    wide: {
        am: "לפנה״צ",
        pm: "אחה״צ",
        midnight: "חצות",
        noon: "צהריים",
        morning: "בוקר",
        afternoon: "אחר הצהריים",
        evening: "ערב",
        night: "לילה"
    }
};
var $242411d46e74b7be$var$formattingDayPeriodValues = {
    narrow: {
        am: "לפנה״צ",
        pm: "אחה״צ",
        midnight: "חצות",
        noon: "צהריים",
        morning: "בבוקר",
        afternoon: "בצהריים",
        evening: "בערב",
        night: "בלילה"
    },
    abbreviated: {
        am: "לפנה״צ",
        pm: "אחה״צ",
        midnight: "חצות",
        noon: "צהריים",
        morning: "בבוקר",
        afternoon: "אחר הצהריים",
        evening: "בערב",
        night: "בלילה"
    },
    wide: {
        am: "לפנה״צ",
        pm: "אחה״צ",
        midnight: "חצות",
        noon: "צהריים",
        morning: "בבוקר",
        afternoon: "אחר הצהריים",
        evening: "בערב",
        night: "בלילה"
    }
};
var $242411d46e74b7be$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        "year",
        "hour",
        "minute",
        "second"
    ].indexOf(unit) >= 0;
    var male = [
        "ראשון",
        "שני",
        "שלישי",
        "רביעי",
        "חמישי",
        "שישי",
        "שביעי",
        "שמיני",
        "תשיעי",
        "עשירי"
    ];
    var female = [
        "ראשונה",
        "שנייה",
        "שלישית",
        "רביעית",
        "חמישית",
        "שישית",
        "שביעית",
        "שמינית",
        "תשיעית",
        "עשירית"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var $242411d46e74b7be$var$localize = {
    ordinalNumber: $242411d46e74b7be$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $242411d46e74b7be$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $242411d46e74b7be$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $242411d46e74b7be$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $242411d46e74b7be$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $242411d46e74b7be$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $242411d46e74b7be$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $242411d46e74b7be$export$2e2bcd8739ae039 = $242411d46e74b7be$var$localize;




var $3b5c07b41f3a77d9$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var $3b5c07b41f3a77d9$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var $3b5c07b41f3a77d9$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var $3b5c07b41f3a77d9$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var $3b5c07b41f3a77d9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var $3b5c07b41f3a77d9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3b5c07b41f3a77d9$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var $3b5c07b41f3a77d9$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var $3b5c07b41f3a77d9$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var $3b5c07b41f3a77d9$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var $3b5c07b41f3a77d9$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var $3b5c07b41f3a77d9$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var $3b5c07b41f3a77d9$var$ordinalName = [
    "רא",
    "שנ",
    "של",
    "רב",
    "ח",
    "שי",
    "שב",
    "שמ",
    "ת",
    "ע"
];
var $3b5c07b41f3a77d9$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $3b5c07b41f3a77d9$var$matchOrdinalNumberPattern,
        parsePattern: $3b5c07b41f3a77d9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? $3b5c07b41f3a77d9$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3b5c07b41f3a77d9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3b5c07b41f3a77d9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3b5c07b41f3a77d9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3b5c07b41f3a77d9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3b5c07b41f3a77d9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3b5c07b41f3a77d9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3b5c07b41f3a77d9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3b5c07b41f3a77d9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3b5c07b41f3a77d9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3b5c07b41f3a77d9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $3b5c07b41f3a77d9$export$2e2bcd8739ae039 = $3b5c07b41f3a77d9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var $8bf7aa47470d15dc$var$locale = {
    code: "he",
    formatDistance: (0, $cab7b96fca0b34b5$export$2e2bcd8739ae039),
    formatLong: (0, $41fc925d44f5d5d1$export$2e2bcd8739ae039),
    formatRelative: (0, $ad7fa2feac42dca5$export$2e2bcd8739ae039),
    localize: (0, $242411d46e74b7be$export$2e2bcd8739ae039),
    match: (0, $3b5c07b41f3a77d9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8bf7aa47470d15dc$export$2e2bcd8739ae039 = $8bf7aa47470d15dc$var$locale;



var $adf927a3cd941cfd$var$numberValues = {
    locale: {
        "1": "१",
        "2": "२",
        "3": "३",
        "4": "४",
        "5": "५",
        "6": "६",
        "7": "७",
        "8": "८",
        "9": "९",
        "0": "०"
    },
    number: {
        "१": "1",
        "२": "2",
        "३": "3",
        "४": "4",
        "५": "5",
        "६": "6",
        "७": "7",
        "८": "8",
        "९": "9",
        "०": "0"
    }
};
// CLDR #1585 - #1592
var $adf927a3cd941cfd$var$eraValues = {
    narrow: [
        "ईसा-पूर्व",
        "ईस्वी"
    ],
    abbreviated: [
        "ईसा-पूर्व",
        "ईस्वी"
    ],
    wide: [
        "ईसा-पूर्व",
        "ईसवी सन"
    ]
};
// CLDR #1593 - #1616
var $adf927a3cd941cfd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ति1",
        "ति2",
        "ति3",
        "ति4"
    ],
    wide: [
        "पहली तिमाही",
        "दूसरी तिमाही",
        "तीसरी तिमाही",
        "चौथी तिमाही"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var $adf927a3cd941cfd$var$monthValues = {
    narrow: [
        "ज",
        "फ़",
        "मा",
        "अ",
        "मई",
        "जू",
        "जु",
        "अग",
        "सि",
        "अक्टू",
        "न",
        "दि"
    ],
    abbreviated: [
        "जन",
        "फ़र",
        "मार्च",
        "अप्रैल",
        "मई",
        "जून",
        "जुल",
        "अग",
        "सित",
        "अक्टू",
        "नव",
        "दिस"
    ],
    wide: [
        "जनवरी",
        "फ़रवरी",
        "मार्च",
        "अप्रैल",
        "मई",
        "जून",
        "जुलाई",
        "अगस्त",
        "सितंबर",
        "अक्टूबर",
        "नवंबर",
        "दिसंबर"
    ]
};
// CLDR #1689 - #1744
var $adf927a3cd941cfd$var$dayValues = {
    narrow: [
        "र",
        "सो",
        "मं",
        "बु",
        "गु",
        "शु",
        "श"
    ],
    short: [
        "र",
        "सो",
        "मं",
        "बु",
        "गु",
        "शु",
        "श"
    ],
    abbreviated: [
        "रवि",
        "सोम",
        "मंगल",
        "बुध",
        "गुरु",
        "शुक्र",
        "शनि"
    ],
    wide: [
        "रविवार",
        "सोमवार",
        "मंगलवार",
        "बुधवार",
        "गुरुवार",
        "शुक्रवार",
        "शनिवार"
    ]
};
var $adf927a3cd941cfd$var$dayPeriodValues = {
    narrow: {
        am: "पूर्वाह्न",
        pm: "अपराह्न",
        midnight: "मध्यरात्रि",
        noon: "दोपहर",
        morning: "सुबह",
        afternoon: "दोपहर",
        evening: "शाम",
        night: "रात"
    },
    abbreviated: {
        am: "पूर्वाह्न",
        pm: "अपराह्न",
        midnight: "मध्यरात्रि",
        noon: "दोपहर",
        morning: "सुबह",
        afternoon: "दोपहर",
        evening: "शाम",
        night: "रात"
    },
    wide: {
        am: "पूर्वाह्न",
        pm: "अपराह्न",
        midnight: "मध्यरात्रि",
        noon: "दोपहर",
        morning: "सुबह",
        afternoon: "दोपहर",
        evening: "शाम",
        night: "रात"
    }
};
var $adf927a3cd941cfd$var$formattingDayPeriodValues = {
    narrow: {
        am: "पूर्वाह्न",
        pm: "अपराह्न",
        midnight: "मध्यरात्रि",
        noon: "दोपहर",
        morning: "सुबह",
        afternoon: "दोपहर",
        evening: "शाम",
        night: "रात"
    },
    abbreviated: {
        am: "पूर्वाह्न",
        pm: "अपराह्न",
        midnight: "मध्यरात्रि",
        noon: "दोपहर",
        morning: "सुबह",
        afternoon: "दोपहर",
        evening: "शाम",
        night: "रात"
    },
    wide: {
        am: "पूर्वाह्न",
        pm: "अपराह्न",
        midnight: "मध्यरात्रि",
        noon: "दोपहर",
        morning: "सुबह",
        afternoon: "दोपहर",
        evening: "शाम",
        night: "रात"
    }
};
var $adf927a3cd941cfd$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return $adf927a3cd941cfd$export$3e1d599946644f03(number);
};
function $adf927a3cd941cfd$export$b431cabd737c2a(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $adf927a3cd941cfd$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $adf927a3cd941cfd$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $adf927a3cd941cfd$var$numberValues.locale[match];
    });
}
var $adf927a3cd941cfd$var$localize = {
    ordinalNumber: $adf927a3cd941cfd$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $adf927a3cd941cfd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $adf927a3cd941cfd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $adf927a3cd941cfd$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $adf927a3cd941cfd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $adf927a3cd941cfd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $adf927a3cd941cfd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $adf927a3cd941cfd$export$2e2bcd8739ae039 = $adf927a3cd941cfd$var$localize;


var $23fade9f739d0731$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "१ सेकंड से कम",
        // CLDR #1310
        other: "{{count}} सेकंड से कम"
    },
    xSeconds: {
        one: "१ सेकंड",
        other: "{{count}} सेकंड"
    },
    halfAMinute: "आधा मिनट",
    lessThanXMinutes: {
        one: "१ मिनट से कम",
        other: "{{count}} मिनट से कम"
    },
    xMinutes: {
        one: "१ मिनट",
        // CLDR #1307
        other: "{{count}} मिनट"
    },
    aboutXHours: {
        one: "लगभग १ घंटा",
        other: "लगभग {{count}} घंटे"
    },
    xHours: {
        one: "१ घंटा",
        // CLDR #1304
        other: "{{count}} घंटे" // CLDR #4467
    },
    xDays: {
        one: "१ दिन",
        // CLDR #1286
        other: "{{count}} दिन"
    },
    aboutXWeeks: {
        one: "लगभग १ सप्ताह",
        other: "लगभग {{count}} सप्ताह"
    },
    xWeeks: {
        one: "१ सप्ताह",
        other: "{{count}} सप्ताह"
    },
    aboutXMonths: {
        one: "लगभग १ महीना",
        other: "लगभग {{count}} महीने"
    },
    xMonths: {
        one: "१ महीना",
        other: "{{count}} महीने"
    },
    aboutXYears: {
        one: "लगभग १ वर्ष",
        other: "लगभग {{count}} वर्ष" // CLDR #4823
    },
    xYears: {
        one: "१ वर्ष",
        other: "{{count}} वर्ष"
    },
    overXYears: {
        one: "१ वर्ष से अधिक",
        other: "{{count}} वर्ष से अधिक"
    },
    almostXYears: {
        one: "लगभग १ वर्ष",
        other: "लगभग {{count}} वर्ष"
    }
};
var $23fade9f739d0731$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $23fade9f739d0731$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $adf927a3cd941cfd$export$3e1d599946644f03)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "मे ";
        else return result + " पहले";
    }
    return result;
};
var $23fade9f739d0731$export$2e2bcd8739ae039 = $23fade9f739d0731$var$formatDistance;



var $d380799cf9a13018$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    // CLDR #1787
    long: "do MMMM, y",
    // CLDR #1788
    medium: "d MMM, y",
    // CLDR #1789
    short: "dd/MM/yyyy" // CLDR #1790
};
var $d380799cf9a13018$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    // CLDR #1791
    long: "h:mm:ss a z",
    // CLDR #1792
    medium: "h:mm:ss a",
    // CLDR #1793
    short: "h:mm a" // CLDR #1794
};
var $d380799cf9a13018$var$dateTimeFormats = {
    full: "{{date}} 'को' {{time}}",
    // CLDR #1795
    long: "{{date}} 'को' {{time}}",
    // CLDR #1796
    medium: "{{date}}, {{time}}",
    // CLDR #1797
    short: "{{date}}, {{time}}" // CLDR #1798
};
var $d380799cf9a13018$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d380799cf9a13018$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d380799cf9a13018$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d380799cf9a13018$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d380799cf9a13018$export$2e2bcd8739ae039 = $d380799cf9a13018$var$formatLong;


var $5fecaa2334dd65bd$var$formatRelativeLocale = {
    lastWeek: "'पिछले' eeee p",
    yesterday: "'कल' p",
    today: "'आज' p",
    tomorrow: "'कल' p",
    nextWeek: "eeee 'को' p",
    other: "P"
};
var $5fecaa2334dd65bd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5fecaa2334dd65bd$var$formatRelativeLocale[token];
};
var $5fecaa2334dd65bd$export$2e2bcd8739ae039 = $5fecaa2334dd65bd$var$formatRelative;






var $65f219a491d320d2$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $65f219a491d320d2$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $65f219a491d320d2$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var $65f219a491d320d2$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $65f219a491d320d2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var $65f219a491d320d2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $65f219a491d320d2$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var $65f219a491d320d2$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var $65f219a491d320d2$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var $65f219a491d320d2$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var $65f219a491d320d2$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var $65f219a491d320d2$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var $65f219a491d320d2$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $65f219a491d320d2$var$matchOrdinalNumberPattern,
        parsePattern: $65f219a491d320d2$var$parseOrdinalNumberPattern,
        valueCallback: (0, $adf927a3cd941cfd$export$b431cabd737c2a)
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65f219a491d320d2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65f219a491d320d2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65f219a491d320d2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65f219a491d320d2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65f219a491d320d2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65f219a491d320d2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65f219a491d320d2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $65f219a491d320d2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $65f219a491d320d2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $65f219a491d320d2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $65f219a491d320d2$export$2e2bcd8739ae039 = $65f219a491d320d2$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var $75288b88e219c44d$var$locale = {
    code: "hi",
    formatDistance: (0, $23fade9f739d0731$export$2e2bcd8739ae039),
    formatLong: (0, $d380799cf9a13018$export$2e2bcd8739ae039),
    formatRelative: (0, $5fecaa2334dd65bd$export$2e2bcd8739ae039),
    localize: (0, $adf927a3cd941cfd$export$2e2bcd8739ae039),
    match: (0, $65f219a491d320d2$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $75288b88e219c44d$export$2e2bcd8739ae039 = $75288b88e219c44d$var$locale;


var $e0047357c0bc03f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 tjedan",
            withPrepositionAgo: "oko 1 tjedan",
            withPrepositionIn: "oko 1 tjedan"
        },
        dual: "oko {{count}} tjedna",
        other: "oko {{count}} tjedana"
    },
    xWeeks: {
        one: {
            standalone: "1 tjedan",
            withPrepositionAgo: "1 tjedan",
            withPrepositionIn: "1 tjedan"
        },
        dual: "{{count}} tjedna",
        other: "{{count}} tjedana"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
var $e0047357c0bc03f2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e0047357c0bc03f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
var $e0047357c0bc03f2$export$2e2bcd8739ae039 = $e0047357c0bc03f2$var$formatDistance;



var $64ec9e577828dafd$var$dateFormats = {
    full: "EEEE, d. MMMM y.",
    long: "d. MMMM y.",
    medium: "d. MMM y.",
    short: "dd. MM. y."
};
var $64ec9e577828dafd$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $64ec9e577828dafd$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $64ec9e577828dafd$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $64ec9e577828dafd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $64ec9e577828dafd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $64ec9e577828dafd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $64ec9e577828dafd$export$2e2bcd8739ae039 = $64ec9e577828dafd$var$formatLong;


var $b5c77a6c6c64572e$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'prošlu nedjelju u' p";
            case 3:
                return "'prošlu srijedu u' p";
            case 6:
                return "'prošlu subotu u' p";
            default:
                return "'prošli' EEEE 'u' p";
        }
    },
    yesterday: "'jučer u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'iduću nedjelju u' p";
            case 3:
                return "'iduću srijedu u' p";
            case 6:
                return "'iduću subotu u' p";
            default:
                return "'prošli' EEEE 'u' p";
        }
    },
    other: "P"
};
var $b5c77a6c6c64572e$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $b5c77a6c6c64572e$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $b5c77a6c6c64572e$export$2e2bcd8739ae039 = $b5c77a6c6c64572e$var$formatRelative;



var $9abcb38d954586c6$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Kr.",
        "po. Kr."
    ],
    wide: [
        "Prije Krista",
        "Poslije Krista"
    ]
};
var $9abcb38d954586c6$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $9abcb38d954586c6$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "ožu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "siječanj",
        "veljača",
        "ožujak",
        "travanj",
        "svibanj",
        "lipanj",
        "srpanj",
        "kolovoz",
        "rujan",
        "listopad",
        "studeni",
        "prosinac"
    ]
};
var $9abcb38d954586c6$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "ožu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "siječnja",
        "veljače",
        "ožujka",
        "travnja",
        "svibnja",
        "lipnja",
        "srpnja",
        "kolovoza",
        "rujna",
        "listopada",
        "studenog",
        "prosinca"
    ]
};
var $9abcb38d954586c6$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "Č",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sri",
        "čet",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sri",
        "čet",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "četvrtak",
        "petak",
        "subota"
    ]
};
var $9abcb38d954586c6$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "navečer",
        night: "noću"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "navečer",
        night: "noću"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "navečer",
        night: "noću"
    }
};
var $9abcb38d954586c6$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "navečer",
        night: "noću"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "navečer",
        night: "noću"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "navečer",
        night: "noću"
    }
};
var $9abcb38d954586c6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $9abcb38d954586c6$var$localize = {
    ordinalNumber: $9abcb38d954586c6$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9abcb38d954586c6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9abcb38d954586c6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9abcb38d954586c6$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $9abcb38d954586c6$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9abcb38d954586c6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $9abcb38d954586c6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9abcb38d954586c6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9abcb38d954586c6$export$2e2bcd8739ae039 = $9abcb38d954586c6$var$localize;




var $0894f3daf6d5724c$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $0894f3daf6d5724c$var$parseOrdinalNumberPattern = /\d+/i;
var $0894f3daf6d5724c$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var $0894f3daf6d5724c$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $0894f3daf6d5724c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $0894f3daf6d5724c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0894f3daf6d5724c$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var $0894f3daf6d5724c$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var $0894f3daf6d5724c$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $0894f3daf6d5724c$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $0894f3daf6d5724c$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var $0894f3daf6d5724c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var $0894f3daf6d5724c$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $0894f3daf6d5724c$var$matchOrdinalNumberPattern,
        parsePattern: $0894f3daf6d5724c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0894f3daf6d5724c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0894f3daf6d5724c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0894f3daf6d5724c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0894f3daf6d5724c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0894f3daf6d5724c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0894f3daf6d5724c$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0894f3daf6d5724c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0894f3daf6d5724c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0894f3daf6d5724c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0894f3daf6d5724c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $0894f3daf6d5724c$export$2e2bcd8739ae039 = $0894f3daf6d5724c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var $e9ec61468eea6ed2$var$locale = {
    code: "hr",
    formatDistance: (0, $e0047357c0bc03f2$export$2e2bcd8739ae039),
    formatLong: (0, $64ec9e577828dafd$export$2e2bcd8739ae039),
    formatRelative: (0, $b5c77a6c6c64572e$export$2e2bcd8739ae039),
    localize: (0, $9abcb38d954586c6$export$2e2bcd8739ae039),
    match: (0, $0894f3daf6d5724c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e9ec61468eea6ed2$export$2e2bcd8739ae039 = $e9ec61468eea6ed2$var$locale;


var $1ae366dad4689c8c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mwens pase yon segond",
        other: "mwens pase {{count}} segond"
    },
    xSeconds: {
        one: "1 segond",
        other: "{{count}} segond"
    },
    halfAMinute: "30 segond",
    lessThanXMinutes: {
        one: "mwens pase yon minit",
        other: "mwens pase {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: "1 jou",
        other: "{{count}} jou"
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: "anviwon 1 mwa",
        other: "anviwon {{count}} mwa"
    },
    xMonths: {
        one: "1 mwa",
        other: "{{count}} mwa"
    },
    aboutXYears: {
        one: "anviwon 1 an",
        other: "anviwon {{count}} an"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} an"
    },
    overXYears: {
        one: "plis pase 1 an",
        other: "plis pase {{count}} an"
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var $1ae366dad4689c8c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1ae366dad4689c8c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "nan " + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
var $1ae366dad4689c8c$export$2e2bcd8739ae039 = $1ae366dad4689c8c$var$formatDistance;



var $5d35359950806e89$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $5d35359950806e89$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $5d35359950806e89$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $5d35359950806e89$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $5d35359950806e89$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $5d35359950806e89$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $5d35359950806e89$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $5d35359950806e89$export$2e2bcd8739ae039 = $5d35359950806e89$var$formatLong;


var $544bbad2a52d3901$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: "P"
};
var $544bbad2a52d3901$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $544bbad2a52d3901$var$formatRelativeLocale[token];
};
var $544bbad2a52d3901$export$2e2bcd8739ae039 = $544bbad2a52d3901$var$formatRelative;



var $e822e2de632d095f$var$eraValues = {
    narrow: [
        "av. J.-K",
        "ap. J.-K"
    ],
    abbreviated: [
        "av. J.-K",
        "ap. J.-K"
    ],
    wide: [
        "anvan Jezi Kris",
        "apre Jezi Kris"
    ]
};
var $e822e2de632d095f$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1ye trim.",
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var $e822e2de632d095f$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "fevr.",
        "mas",
        "avr.",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "sept.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "janvye",
        "fevrye",
        "mas",
        "avril",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "septanm",
        "okt\xf2b",
        "novanm",
        "desanm"
    ]
};
var $e822e2de632d095f$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "le",
        "ma",
        "m\xe8",
        "je",
        "va",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "len.",
        "mad.",
        "m\xe8k.",
        "jed.",
        "van.",
        "sam."
    ],
    wide: [
        "dimanch",
        "lendi",
        "madi",
        "m\xe8kredi",
        "jedi",
        "vandredi",
        "samdi"
    ]
};
var $e822e2de632d095f$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "swa",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "maten",
        afternoon: "apr\xe8midi",
        evening: "swa",
        night: "maten"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "nan maten",
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: "nan maten"
    }
};
var $e822e2de632d095f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? "ye" : "y\xe8m";
    return number + suffix;
};
var $e822e2de632d095f$var$localize = {
    ordinalNumber: $e822e2de632d095f$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e822e2de632d095f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e822e2de632d095f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e822e2de632d095f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e822e2de632d095f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e822e2de632d095f$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $e822e2de632d095f$export$2e2bcd8739ae039 = $e822e2de632d095f$var$localize;




var $19b861710d8b2962$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var $19b861710d8b2962$var$parseOrdinalNumberPattern = /\d+/i;
var $19b861710d8b2962$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var $19b861710d8b2962$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $19b861710d8b2962$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var $19b861710d8b2962$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $19b861710d8b2962$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var $19b861710d8b2962$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $19b861710d8b2962$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var $19b861710d8b2962$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var $19b861710d8b2962$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var $19b861710d8b2962$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var $19b861710d8b2962$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $19b861710d8b2962$var$matchOrdinalNumberPattern,
        parsePattern: $19b861710d8b2962$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $19b861710d8b2962$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b861710d8b2962$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $19b861710d8b2962$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b861710d8b2962$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $19b861710d8b2962$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b861710d8b2962$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $19b861710d8b2962$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $19b861710d8b2962$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $19b861710d8b2962$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $19b861710d8b2962$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $19b861710d8b2962$export$2e2bcd8739ae039 = $19b861710d8b2962$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var $9b1ebd2a57ebed66$var$locale = {
    code: "ht",
    formatDistance: (0, $1ae366dad4689c8c$export$2e2bcd8739ae039),
    formatLong: (0, $5d35359950806e89$export$2e2bcd8739ae039),
    formatRelative: (0, $544bbad2a52d3901$export$2e2bcd8739ae039),
    localize: (0, $e822e2de632d095f$export$2e2bcd8739ae039),
    match: (0, $19b861710d8b2962$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9b1ebd2a57ebed66$export$2e2bcd8739ae039 = $9b1ebd2a57ebed66$var$locale;


var $22e58206f217b73a$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: "majdnem",
    lessthan: "kevesebb mint"
};
var $22e58206f217b73a$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: " perc",
    xhours: " \xf3ra",
    xdays: " nap",
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $22e58206f217b73a$var$withSuffixes = {
    xseconds: {
        "-1": " m\xe1sodperccel ezelőtt",
        "1": " m\xe1sodperc m\xfalva",
        "0": " m\xe1sodperce"
    },
    halfaminute: {
        "-1": "f\xe9l perccel ezelőtt",
        "1": "f\xe9l perc m\xfalva",
        "0": "f\xe9l perce"
    },
    xminutes: {
        "-1": " perccel ezelőtt",
        "1": " perc m\xfalva",
        "0": " perce"
    },
    xhours: {
        "-1": " \xf3r\xe1val ezelőtt",
        "1": " \xf3ra m\xfalva",
        "0": " \xf3r\xe1ja"
    },
    xdays: {
        "-1": " nappal ezelőtt",
        "1": " nap m\xfalva",
        "0": " napja"
    },
    xweeks: {
        "-1": " h\xe9ttel ezelőtt",
        "1": " h\xe9t m\xfalva",
        "0": " hete"
    },
    xmonths: {
        "-1": " h\xf3nappal ezelőtt",
        "1": " h\xf3nap m\xfalva",
        "0": " h\xf3napja"
    },
    xyears: {
        "-1": " \xe9vvel ezelőtt",
        "1": " \xe9v m\xfalva",
        "0": " \xe9ve"
    }
};
var $22e58206f217b73a$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], "") : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $22e58206f217b73a$var$withSuffixes[key][comparison] : $22e58206f217b73a$var$withoutSuffixes[key];
    var result = key === "halfaminute" ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $22e58206f217b73a$var$translations[adv] + " " + result;
    }
    return result;
};
var $22e58206f217b73a$export$2e2bcd8739ae039 = $22e58206f217b73a$var$formatDistance;



var $958d4312049e9930$var$dateFormats = {
    full: "y. MMMM d., EEEE",
    long: "y. MMMM d.",
    medium: "y. MMM d.",
    short: "y. MM. dd."
};
var $958d4312049e9930$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $958d4312049e9930$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $958d4312049e9930$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $958d4312049e9930$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $958d4312049e9930$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $958d4312049e9930$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $958d4312049e9930$export$2e2bcd8739ae039 = $958d4312049e9930$var$formatLong;


var $8d7066c65f6f435b$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tfőn",
    "kedden",
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    "szombaton"
];
function $8d7066c65f6f435b$var$week(isFuture) {
    return function(date) {
        var weekday = $8d7066c65f6f435b$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? "" : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $8d7066c65f6f435b$var$formatRelativeLocale = {
    lastWeek: $8d7066c65f6f435b$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $8d7066c65f6f435b$var$week(true),
    other: "P"
};
var $8d7066c65f6f435b$var$formatRelative = function formatRelative(token, date) {
    var format = $8d7066c65f6f435b$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $8d7066c65f6f435b$export$2e2bcd8739ae039 = $8d7066c65f6f435b$var$formatRelative;



var $efaab084c89160a1$var$eraValues = {
    narrow: [
        "ie.",
        "isz."
    ],
    abbreviated: [
        "i. e.",
        "i. sz."
    ],
    wide: [
        "Krisztus előtt",
        "idősz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $efaab084c89160a1$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $efaab084c89160a1$var$formattingQuarterValues = {
    narrow: [
        "I.",
        "II.",
        "III.",
        "IV."
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $efaab084c89160a1$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "\xc1",
        "M",
        "J",
        "J",
        "A",
        "Sz",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "febr.",
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        "aug.",
        "szept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        "augusztus",
        "szeptember",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
var $efaab084c89160a1$var$dayValues = {
    narrow: [
        "V",
        "H",
        "K",
        "Sz",
        "Cs",
        "P",
        "Sz"
    ],
    short: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    abbreviated: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tfő",
        "kedd",
        "szerda",
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        "szombat"
    ]
};
var $efaab084c89160a1$var$dayPeriodValues = {
    narrow: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    abbreviated: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    wide: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "d\xe9lut\xe1n",
        evening: "este",
        night: "\xe9jjel"
    }
};
var $efaab084c89160a1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $efaab084c89160a1$var$localize = {
    ordinalNumber: $efaab084c89160a1$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $efaab084c89160a1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $efaab084c89160a1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $efaab084c89160a1$var$formattingQuarterValues,
        defaultFormattingWidth: "wide"
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $efaab084c89160a1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $efaab084c89160a1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $efaab084c89160a1$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $efaab084c89160a1$export$2e2bcd8739ae039 = $efaab084c89160a1$var$localize;




var $3a1402092e5098cb$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $3a1402092e5098cb$var$parseOrdinalNumberPattern = /\d+/i;
var $3a1402092e5098cb$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $3a1402092e5098cb$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $3a1402092e5098cb$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $3a1402092e5098cb$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $3a1402092e5098cb$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $3a1402092e5098cb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $3a1402092e5098cb$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $3a1402092e5098cb$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $3a1402092e5098cb$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $3a1402092e5098cb$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $3a1402092e5098cb$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $3a1402092e5098cb$var$matchOrdinalNumberPattern,
        parsePattern: $3a1402092e5098cb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3a1402092e5098cb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a1402092e5098cb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3a1402092e5098cb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a1402092e5098cb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3a1402092e5098cb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a1402092e5098cb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3a1402092e5098cb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3a1402092e5098cb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $3a1402092e5098cb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3a1402092e5098cb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $3a1402092e5098cb$export$2e2bcd8739ae039 = $3a1402092e5098cb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $7e0005519f36d882$var$locale = {
    code: "hu",
    formatDistance: (0, $22e58206f217b73a$export$2e2bcd8739ae039),
    formatLong: (0, $958d4312049e9930$export$2e2bcd8739ae039),
    formatRelative: (0, $8d7066c65f6f435b$export$2e2bcd8739ae039),
    localize: (0, $efaab084c89160a1$export$2e2bcd8739ae039),
    match: (0, $3a1402092e5098cb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7e0005519f36d882$export$2e2bcd8739ae039 = $7e0005519f36d882$var$locale;


var $a52677b0459b0138$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "ավելի քիչ քան 1 վայրկյան",
        other: "ավելի քիչ քան {{count}} վայրկյան"
    },
    xSeconds: {
        one: "1 վայրկյան",
        other: "{{count}} վայրկյան"
    },
    halfAMinute: "կես րոպե",
    lessThanXMinutes: {
        one: "ավելի քիչ քան 1 րոպե",
        other: "ավելի քիչ քան {{count}} րոպե"
    },
    xMinutes: {
        one: "1 րոպե",
        other: "{{count}} րոպե"
    },
    aboutXHours: {
        one: "մոտ 1 ժամ",
        other: "մոտ {{count}} ժամ"
    },
    xHours: {
        one: "1 ժամ",
        other: "{{count}} ժամ"
    },
    xDays: {
        one: "1 օր",
        other: "{{count}} օր"
    },
    aboutXWeeks: {
        one: "մոտ 1 շաբաթ",
        other: "մոտ {{count}} շաբաթ"
    },
    xWeeks: {
        one: "1 շաբաթ",
        other: "{{count}} շաբաթ"
    },
    aboutXMonths: {
        one: "մոտ 1 ամիս",
        other: "մոտ {{count}} ամիս"
    },
    xMonths: {
        one: "1 ամիս",
        other: "{{count}} ամիս"
    },
    aboutXYears: {
        one: "մոտ 1 տարի",
        other: "մոտ {{count}} տարի"
    },
    xYears: {
        one: "1 տարի",
        other: "{{count}} տարի"
    },
    overXYears: {
        one: "ավելի քան 1 տարի",
        other: "ավելի քան {{count}} տարի"
    },
    almostXYears: {
        one: "համարյա 1 տարի",
        other: "համարյա {{count}} տարի"
    }
};
var $a52677b0459b0138$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a52677b0459b0138$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " հետո";
        else return result + " առաջ";
    }
    return result;
};
var $a52677b0459b0138$export$2e2bcd8739ae039 = $a52677b0459b0138$var$formatDistance;



var $37069b0f5ed65f0c$var$dateFormats = {
    full: "d MMMM, y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd.MM.yyyy"
};
var $37069b0f5ed65f0c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $37069b0f5ed65f0c$var$dateTimeFormats = {
    full: "{{date}} 'ժ․'{{time}}",
    long: "{{date}} 'ժ․'{{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $37069b0f5ed65f0c$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $37069b0f5ed65f0c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $37069b0f5ed65f0c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $37069b0f5ed65f0c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $37069b0f5ed65f0c$export$2e2bcd8739ae039 = $37069b0f5ed65f0c$var$formatLong;


var $ea223ea4f8432601$var$formatRelativeLocale = {
    lastWeek: "'նախորդ' eeee p'֊ին'",
    yesterday: "'երեկ' p'֊ին'",
    today: "'այսօր' p'֊ին'",
    tomorrow: "'վաղը' p'֊ին'",
    nextWeek: "'հաջորդ' eeee p'֊ին'",
    other: "P"
};
var $ea223ea4f8432601$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ea223ea4f8432601$var$formatRelativeLocale[token];
};
var $ea223ea4f8432601$export$2e2bcd8739ae039 = $ea223ea4f8432601$var$formatRelative;



var $08fced37cfc062b5$var$eraValues = {
    narrow: [
        "Ք",
        "Մ"
    ],
    abbreviated: [
        "ՔԱ",
        "ՄԹ"
    ],
    wide: [
        "Քրիստոսից առաջ",
        "Մեր թվարկության"
    ]
};
var $08fced37cfc062b5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Ք1",
        "Ք2",
        "Ք3",
        "Ք4"
    ],
    wide: [
        "1֊ին քառորդ",
        "2֊րդ քառորդ",
        "3֊րդ քառորդ",
        "4֊րդ քառորդ"
    ]
};
var $08fced37cfc062b5$var$monthValues = {
    narrow: [
        "Հ",
        "Փ",
        "Մ",
        "Ա",
        "Մ",
        "Հ",
        "Հ",
        "Օ",
        "Ս",
        "Հ",
        "Ն",
        "Դ"
    ],
    abbreviated: [
        "հուն",
        "փետ",
        "մար",
        "ապր",
        "մայ",
        "հուն",
        "հուլ",
        "օգս",
        "սեպ",
        "հոկ",
        "նոյ",
        "դեկ"
    ],
    wide: [
        "հունվար",
        "փետրվար",
        "մարտ",
        "ապրիլ",
        "մայիս",
        "հունիս",
        "հուլիս",
        "օգոստոս",
        "սեպտեմբեր",
        "հոկտեմբեր",
        "նոյեմբեր",
        "դեկտեմբեր"
    ]
};
var $08fced37cfc062b5$var$dayValues = {
    narrow: [
        "Կ",
        "Ե",
        "Ե",
        "Չ",
        "Հ",
        "Ո",
        "Շ"
    ],
    short: [
        "կր",
        "եր",
        "եք",
        "չք",
        "հգ",
        "ուր",
        "շբ"
    ],
    abbreviated: [
        "կիր",
        "երկ",
        "երք",
        "չոր",
        "հնգ",
        "ուրբ",
        "շաբ"
    ],
    wide: [
        "կիրակի",
        "երկուշաբթի",
        "երեքշաբթի",
        "չորեքշաբթի",
        "հինգշաբթի",
        "ուրբաթ",
        "շաբաթ"
    ]
};
var $08fced37cfc062b5$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "կեսգշ",
        noon: "կեսօր",
        morning: "առավոտ",
        afternoon: "ցերեկ",
        evening: "երեկո",
        night: "գիշեր"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "կեսգիշեր",
        noon: "կեսօր",
        morning: "առավոտ",
        afternoon: "ցերեկ",
        evening: "երեկո",
        night: "գիշեր"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "կեսգիշեր",
        noon: "կեսօր",
        morning: "առավոտ",
        afternoon: "ցերեկ",
        evening: "երեկո",
        night: "գիշեր"
    }
};
var $08fced37cfc062b5$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "կեսգշ",
        noon: "կեսօր",
        morning: "առավոտը",
        afternoon: "ցերեկը",
        evening: "երեկոյան",
        night: "գիշերը"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "կեսգիշերին",
        noon: "կեսօրին",
        morning: "առավոտը",
        afternoon: "ցերեկը",
        evening: "երեկոյան",
        night: "գիշերը"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "կեսգիշերին",
        noon: "կեսօրին",
        morning: "առավոտը",
        afternoon: "ցերեկը",
        evening: "երեկոյան",
        night: "գիշերը"
    }
};
var $08fced37cfc062b5$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "֊ին";
    }
    return number + "֊րդ";
};
var $08fced37cfc062b5$var$localize = {
    ordinalNumber: $08fced37cfc062b5$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $08fced37cfc062b5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $08fced37cfc062b5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $08fced37cfc062b5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $08fced37cfc062b5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $08fced37cfc062b5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $08fced37cfc062b5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $08fced37cfc062b5$export$2e2bcd8739ae039 = $08fced37cfc062b5$var$localize;




var $951e98594100f700$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var $951e98594100f700$var$parseOrdinalNumberPattern = /\d+/i;
var $951e98594100f700$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var $951e98594100f700$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var $951e98594100f700$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var $951e98594100f700$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $951e98594100f700$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var $951e98594100f700$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var $951e98594100f700$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var $951e98594100f700$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var $951e98594100f700$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var $951e98594100f700$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var $951e98594100f700$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $951e98594100f700$var$matchOrdinalNumberPattern,
        parsePattern: $951e98594100f700$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $951e98594100f700$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $951e98594100f700$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $951e98594100f700$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $951e98594100f700$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $951e98594100f700$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $951e98594100f700$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $951e98594100f700$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $951e98594100f700$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $951e98594100f700$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $951e98594100f700$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $951e98594100f700$export$2e2bcd8739ae039 = $951e98594100f700$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var $016ab76aed515db7$var$locale = {
    code: "hy",
    formatDistance: (0, $a52677b0459b0138$export$2e2bcd8739ae039),
    formatLong: (0, $37069b0f5ed65f0c$export$2e2bcd8739ae039),
    formatRelative: (0, $ea223ea4f8432601$export$2e2bcd8739ae039),
    localize: (0, $08fced37cfc062b5$export$2e2bcd8739ae039),
    match: (0, $951e98594100f700$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $016ab76aed515db7$export$2e2bcd8739ae039 = $016ab76aed515db7$var$locale;


var $ba83b14769e88373$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 detik",
        other: "kurang dari {{count}} detik"
    },
    xSeconds: {
        one: "1 detik",
        other: "{{count}} detik"
    },
    halfAMinute: "setengah menit",
    lessThanXMinutes: {
        one: "kurang dari 1 menit",
        other: "kurang dari {{count}} menit"
    },
    xMinutes: {
        one: "1 menit",
        other: "{{count}} menit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
var $ba83b14769e88373$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ba83b14769e88373$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam waktu " + result;
        else return result + " yang lalu";
    }
    return result;
};
var $ba83b14769e88373$export$2e2bcd8739ae039 = $ba83b14769e88373$var$formatDistance;



var $3c21d319edfbf678$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
var $3c21d319edfbf678$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
var $3c21d319edfbf678$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $3c21d319edfbf678$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3c21d319edfbf678$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3c21d319edfbf678$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3c21d319edfbf678$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $3c21d319edfbf678$export$2e2bcd8739ae039 = $3c21d319edfbf678$var$formatLong;


var $eeebe23499199c07$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: "P"
};
var $eeebe23499199c07$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $eeebe23499199c07$var$formatRelativeLocale[token];
};
var $eeebe23499199c07$export$2e2bcd8739ae039 = $eeebe23499199c07$var$formatRelative;



// https://www.unicode.org/cldr/charts/32/summary/id.html
var $71450bf865c92fc8$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masehi",
        "Masehi"
    ]
};
var $71450bf865c92fc8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "Kuartal ke-1",
        "Kuartal ke-2",
        "Kuartal ke-3",
        "Kuartal ke-4"
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $71450bf865c92fc8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agt",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
var $71450bf865c92fc8$var$dayValues = {
    narrow: [
        "M",
        "S",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    wide: [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
    ]
};
var $71450bf865c92fc8$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
var $71450bf865c92fc8$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
var $71450bf865c92fc8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + number;
};
var $71450bf865c92fc8$var$localize = {
    ordinalNumber: $71450bf865c92fc8$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $71450bf865c92fc8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $71450bf865c92fc8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $71450bf865c92fc8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $71450bf865c92fc8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $71450bf865c92fc8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $71450bf865c92fc8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $71450bf865c92fc8$export$2e2bcd8739ae039 = $71450bf865c92fc8$var$localize;




var $a701d5a0b83fc2d9$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $a701d5a0b83fc2d9$var$parseOrdinalNumberPattern = /\d+/i;
var $a701d5a0b83fc2d9$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var $a701d5a0b83fc2d9$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var $a701d5a0b83fc2d9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var $a701d5a0b83fc2d9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a701d5a0b83fc2d9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var $a701d5a0b83fc2d9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a701d5a0b83fc2d9$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var $a701d5a0b83fc2d9$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $a701d5a0b83fc2d9$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var $a701d5a0b83fc2d9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var $a701d5a0b83fc2d9$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a701d5a0b83fc2d9$var$matchOrdinalNumberPattern,
        parsePattern: $a701d5a0b83fc2d9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a701d5a0b83fc2d9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a701d5a0b83fc2d9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a701d5a0b83fc2d9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a701d5a0b83fc2d9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a701d5a0b83fc2d9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a701d5a0b83fc2d9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a701d5a0b83fc2d9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a701d5a0b83fc2d9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a701d5a0b83fc2d9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a701d5a0b83fc2d9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a701d5a0b83fc2d9$export$2e2bcd8739ae039 = $a701d5a0b83fc2d9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var $835119ee92742082$var$locale = {
    code: "id",
    formatDistance: (0, $ba83b14769e88373$export$2e2bcd8739ae039),
    formatLong: (0, $3c21d319edfbf678$export$2e2bcd8739ae039),
    formatRelative: (0, $eeebe23499199c07$export$2e2bcd8739ae039),
    localize: (0, $71450bf865c92fc8$export$2e2bcd8739ae039),
    match: (0, $a701d5a0b83fc2d9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $835119ee92742082$export$2e2bcd8739ae039 = $835119ee92742082$var$locale;


var $f0e646a54b418d8e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: "1 klukkustund",
        other: "{{count}} klukkustundir"
    },
    xDays: {
        one: "1 dagur",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "um viku",
        other: "um {{count}} vikur"
    },
    xWeeks: {
        one: "1 viku",
        other: "{{count}} vikur"
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $f0e646a54b418d8e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f0e646a54b418d8e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $f0e646a54b418d8e$export$2e2bcd8739ae039 = $f0e646a54b418d8e$var$formatDistance;



var $d8e605f0dbc4ad43$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "d.MM.y"
};
var $d8e605f0dbc4ad43$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $d8e605f0dbc4ad43$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $d8e605f0dbc4ad43$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d8e605f0dbc4ad43$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d8e605f0dbc4ad43$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d8e605f0dbc4ad43$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d8e605f0dbc4ad43$export$2e2bcd8739ae039 = $d8e605f0dbc4ad43$var$formatLong;


var $16e49d9431d3cad0$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: "P"
};
var $16e49d9431d3cad0$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $16e49d9431d3cad0$var$formatRelativeLocale[token];
};
var $16e49d9431d3cad0$export$2e2bcd8739ae039 = $16e49d9431d3cad0$var$formatRelative;



var $a40fe3c086e1f8e8$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "fyrir Krist",
        "eftir Krist"
    ]
};
var $a40fe3c086e1f8e8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1F",
        "2F",
        "3F",
        "4F"
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $a40fe3c086e1f8e8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "\xc1",
        "S",
        "\xd3",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "sept.",
        "okt.",
        "n\xf3v.",
        "des."
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "september",
        "okt\xf3ber",
        "n\xf3vember",
        "desember"
    ]
};
var $a40fe3c086e1f8e8$var$dayValues = {
    narrow: [
        "S",
        "M",
        "\xde",
        "M",
        "F",
        "F",
        "L"
    ],
    short: [
        "Su",
        "M\xe1",
        "\xder",
        "Mi",
        "Fi",
        "F\xf6",
        "La"
    ],
    abbreviated: [
        "sun.",
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        "fim.",
        "f\xf6s.",
        "lau."
    ],
    wide: [
        "sunnudagur",
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        "fimmtudagur",
        "f\xf6studagur",
        "laugardagur"
    ]
};
var $a40fe3c086e1f8e8$var$dayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $a40fe3c086e1f8e8$var$formattingDayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $a40fe3c086e1f8e8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $a40fe3c086e1f8e8$var$localize = {
    ordinalNumber: $a40fe3c086e1f8e8$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a40fe3c086e1f8e8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a40fe3c086e1f8e8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a40fe3c086e1f8e8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a40fe3c086e1f8e8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a40fe3c086e1f8e8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a40fe3c086e1f8e8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a40fe3c086e1f8e8$export$2e2bcd8739ae039 = $a40fe3c086e1f8e8$var$localize;




var $ff1a07495432e6d5$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $ff1a07495432e6d5$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $ff1a07495432e6d5$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $ff1a07495432e6d5$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $ff1a07495432e6d5$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $ff1a07495432e6d5$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $ff1a07495432e6d5$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $ff1a07495432e6d5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $ff1a07495432e6d5$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $ff1a07495432e6d5$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $ff1a07495432e6d5$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $ff1a07495432e6d5$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $ff1a07495432e6d5$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $ff1a07495432e6d5$var$matchOrdinalNumberPattern,
        parsePattern: $ff1a07495432e6d5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff1a07495432e6d5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff1a07495432e6d5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff1a07495432e6d5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff1a07495432e6d5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff1a07495432e6d5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff1a07495432e6d5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff1a07495432e6d5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ff1a07495432e6d5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $ff1a07495432e6d5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ff1a07495432e6d5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $ff1a07495432e6d5$export$2e2bcd8739ae039 = $ff1a07495432e6d5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $09327723e077c271$var$locale = {
    code: "is",
    formatDistance: (0, $f0e646a54b418d8e$export$2e2bcd8739ae039),
    formatLong: (0, $d8e605f0dbc4ad43$export$2e2bcd8739ae039),
    formatRelative: (0, $16e49d9431d3cad0$export$2e2bcd8739ae039),
    localize: (0, $a40fe3c086e1f8e8$export$2e2bcd8739ae039),
    match: (0, $ff1a07495432e6d5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $09327723e077c271$export$2e2bcd8739ae039 = $09327723e077c271$var$locale;


var $a421d5f12faa9cb7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
var $a421d5f12faa9cb7$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a421d5f12faa9cb7$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};
var $a421d5f12faa9cb7$export$2e2bcd8739ae039 = $a421d5f12faa9cb7$var$formatDistance;



var $a1b4d0310699f90a$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $a1b4d0310699f90a$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $a1b4d0310699f90a$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $a1b4d0310699f90a$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a1b4d0310699f90a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a1b4d0310699f90a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a1b4d0310699f90a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a1b4d0310699f90a$export$2e2bcd8739ae039 = $a1b4d0310699f90a$var$formatLong;



var $eb3273bb69ebdb09$var$weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function $eb3273bb69ebdb09$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $eb3273bb69ebdb09$var$weekdays[day] + " scorso alle' p";
    }
}
function $eb3273bb69ebdb09$var$thisWeek(day) {
    return "'" + $eb3273bb69ebdb09$var$weekdays[day] + " alle' p";
}
function $eb3273bb69ebdb09$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $eb3273bb69ebdb09$var$weekdays[day] + " prossimo alle' p";
    }
}
var $eb3273bb69ebdb09$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $eb3273bb69ebdb09$var$thisWeek(day);
        else return $eb3273bb69ebdb09$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $eb3273bb69ebdb09$var$thisWeek(day);
        else return $eb3273bb69ebdb09$var$_nextWeek(day);
    },
    other: "P"
};
var $eb3273bb69ebdb09$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $eb3273bb69ebdb09$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $eb3273bb69ebdb09$export$2e2bcd8739ae039 = $eb3273bb69ebdb09$var$formatRelative;



var $e4ab5ee42d709d85$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
var $e4ab5ee42d709d85$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $e4ab5ee42d709d85$var$monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
var $e4ab5ee42d709d85$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
var $e4ab5ee42d709d85$var$dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
var $e4ab5ee42d709d85$var$formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
var $e4ab5ee42d709d85$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $e4ab5ee42d709d85$var$localize = {
    ordinalNumber: $e4ab5ee42d709d85$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e4ab5ee42d709d85$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e4ab5ee42d709d85$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e4ab5ee42d709d85$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e4ab5ee42d709d85$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e4ab5ee42d709d85$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e4ab5ee42d709d85$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $e4ab5ee42d709d85$export$2e2bcd8739ae039 = $e4ab5ee42d709d85$var$localize;




var $b6c663023389b60b$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $b6c663023389b60b$var$parseOrdinalNumberPattern = /\d+/i;
var $b6c663023389b60b$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $b6c663023389b60b$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $b6c663023389b60b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $b6c663023389b60b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b6c663023389b60b$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $b6c663023389b60b$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b6c663023389b60b$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $b6c663023389b60b$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $b6c663023389b60b$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $b6c663023389b60b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $b6c663023389b60b$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $b6c663023389b60b$var$matchOrdinalNumberPattern,
        parsePattern: $b6c663023389b60b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b6c663023389b60b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6c663023389b60b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b6c663023389b60b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6c663023389b60b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b6c663023389b60b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6c663023389b60b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b6c663023389b60b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6c663023389b60b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $b6c663023389b60b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b6c663023389b60b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $b6c663023389b60b$export$2e2bcd8739ae039 = $b6c663023389b60b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $04337a305d386c62$var$locale = {
    code: "it",
    formatDistance: (0, $a421d5f12faa9cb7$export$2e2bcd8739ae039),
    formatLong: (0, $a1b4d0310699f90a$export$2e2bcd8739ae039),
    formatRelative: (0, $eb3273bb69ebdb09$export$2e2bcd8739ae039),
    localize: (0, $e4ab5ee42d709d85$export$2e2bcd8739ae039),
    match: (0, $b6c663023389b60b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $04337a305d386c62$export$2e2bcd8739ae039 = $04337a305d386c62$var$locale;







var $e87cc291b9c64d1b$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
var $e87cc291b9c64d1b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $e87cc291b9c64d1b$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $e87cc291b9c64d1b$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e87cc291b9c64d1b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e87cc291b9c64d1b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e87cc291b9c64d1b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e87cc291b9c64d1b$export$2e2bcd8739ae039 = $e87cc291b9c64d1b$var$formatLong;


/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var $012ad164b7d0c867$var$locale = {
    code: "it-CH",
    formatDistance: (0, $a421d5f12faa9cb7$export$2e2bcd8739ae039),
    formatLong: (0, $e87cc291b9c64d1b$export$2e2bcd8739ae039),
    formatRelative: (0, $eb3273bb69ebdb09$export$2e2bcd8739ae039),
    localize: (0, $e4ab5ee42d709d85$export$2e2bcd8739ae039),
    match: (0, $b6c663023389b60b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $012ad164b7d0c867$export$2e2bcd8739ae039 = $012ad164b7d0c867$var$locale;


var $90e9457a1a5f0614$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1秒未満",
        other: "{{count}}秒未満",
        oneWithSuffix: "約1秒",
        otherWithSuffix: "約{{count}}秒"
    },
    xSeconds: {
        one: "1秒",
        other: "{{count}}秒"
    },
    halfAMinute: "30秒",
    lessThanXMinutes: {
        one: "1分未満",
        other: "{{count}}分未満",
        oneWithSuffix: "約1分",
        otherWithSuffix: "約{{count}}分"
    },
    xMinutes: {
        one: "1分",
        other: "{{count}}分"
    },
    aboutXHours: {
        one: "約1時間",
        other: "約{{count}}時間"
    },
    xHours: {
        one: "1時間",
        other: "{{count}}時間"
    },
    xDays: {
        one: "1日",
        other: "{{count}}日"
    },
    aboutXWeeks: {
        one: "約1週間",
        other: "約{{count}}週間"
    },
    xWeeks: {
        one: "1週間",
        other: "{{count}}週間"
    },
    aboutXMonths: {
        one: "約1か月",
        other: "約{{count}}か月"
    },
    xMonths: {
        one: "1か月",
        other: "{{count}}か月"
    },
    aboutXYears: {
        one: "約1年",
        other: "約{{count}}年"
    },
    xYears: {
        one: "1年",
        other: "{{count}}年"
    },
    overXYears: {
        one: "1年以上",
        other: "{{count}}年以上"
    },
    almostXYears: {
        one: "1年近く",
        other: "{{count}}年近く"
    }
};
var $90e9457a1a5f0614$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $90e9457a1a5f0614$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "後";
        else return result + "前";
    }
    return result;
};
var $90e9457a1a5f0614$export$2e2bcd8739ae039 = $90e9457a1a5f0614$var$formatDistance;



var $2d11277168b746db$var$dateFormats = {
    full: "y年M月d日EEEE",
    long: "y年M月d日",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
var $2d11277168b746db$var$timeFormats = {
    full: "H時mm分ss秒 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $2d11277168b746db$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $2d11277168b746db$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2d11277168b746db$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2d11277168b746db$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2d11277168b746db$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2d11277168b746db$export$2e2bcd8739ae039 = $2d11277168b746db$var$formatLong;


var $dee029ed6a6b8441$var$formatRelativeLocale = {
    lastWeek: "先週のeeeeのp",
    yesterday: "昨日のp",
    today: "今日のp",
    tomorrow: "明日のp",
    nextWeek: "翌週のeeeeのp",
    other: "P"
};
var $dee029ed6a6b8441$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $dee029ed6a6b8441$var$formatRelativeLocale[token];
};
var $dee029ed6a6b8441$export$2e2bcd8739ae039 = $dee029ed6a6b8441$var$formatRelative;



var $3b284305273d6add$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "紀元前",
        "西暦"
    ],
    wide: [
        "紀元前",
        "西暦"
    ]
};
var $3b284305273d6add$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "第1四半期",
        "第2四半期",
        "第3四半期",
        "第4四半期"
    ]
};
var $3b284305273d6add$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
    ],
    wide: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
    ]
};
var $3b284305273d6add$var$dayValues = {
    narrow: [
        "日",
        "月",
        "火",
        "水",
        "木",
        "金",
        "土"
    ],
    short: [
        "日",
        "月",
        "火",
        "水",
        "木",
        "金",
        "土"
    ],
    abbreviated: [
        "日",
        "月",
        "火",
        "水",
        "木",
        "金",
        "土"
    ],
    wide: [
        "日曜日",
        "月曜日",
        "火曜日",
        "水曜日",
        "木曜日",
        "金曜日",
        "土曜日"
    ]
};
var $3b284305273d6add$var$dayPeriodValues = {
    narrow: {
        am: "午前",
        pm: "午後",
        midnight: "深夜",
        noon: "正午",
        morning: "朝",
        afternoon: "午後",
        evening: "夜",
        night: "深夜"
    },
    abbreviated: {
        am: "午前",
        pm: "午後",
        midnight: "深夜",
        noon: "正午",
        morning: "朝",
        afternoon: "午後",
        evening: "夜",
        night: "深夜"
    },
    wide: {
        am: "午前",
        pm: "午後",
        midnight: "深夜",
        noon: "正午",
        morning: "朝",
        afternoon: "午後",
        evening: "夜",
        night: "深夜"
    }
};
var $3b284305273d6add$var$formattingDayPeriodValues = {
    narrow: {
        am: "午前",
        pm: "午後",
        midnight: "深夜",
        noon: "正午",
        morning: "朝",
        afternoon: "午後",
        evening: "夜",
        night: "深夜"
    },
    abbreviated: {
        am: "午前",
        pm: "午後",
        midnight: "深夜",
        noon: "正午",
        morning: "朝",
        afternoon: "午後",
        evening: "夜",
        night: "深夜"
    },
    wide: {
        am: "午前",
        pm: "午後",
        midnight: "深夜",
        noon: "正午",
        morning: "朝",
        afternoon: "午後",
        evening: "夜",
        night: "深夜"
    }
};
var $3b284305273d6add$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case "year":
            return "".concat(number, "年");
        case "quarter":
            return "第".concat(number, "四半期");
        case "month":
            return "".concat(number, "月");
        case "week":
            return "第".concat(number, "週");
        case "date":
            return "".concat(number, "日");
        case "hour":
            return "".concat(number, "時");
        case "minute":
            return "".concat(number, "分");
        case "second":
            return "".concat(number, "秒");
        default:
            return "".concat(number);
    }
};
var $3b284305273d6add$var$localize = {
    ordinalNumber: $3b284305273d6add$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $3b284305273d6add$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $3b284305273d6add$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $3b284305273d6add$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $3b284305273d6add$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $3b284305273d6add$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3b284305273d6add$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $3b284305273d6add$export$2e2bcd8739ae039 = $3b284305273d6add$var$localize;




var $a7dd9e2e61cbedb9$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $a7dd9e2e61cbedb9$var$parseOrdinalNumberPattern = /\d+/i;
var $a7dd9e2e61cbedb9$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $a7dd9e2e61cbedb9$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $a7dd9e2e61cbedb9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $a7dd9e2e61cbedb9$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $a7dd9e2e61cbedb9$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $a7dd9e2e61cbedb9$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $a7dd9e2e61cbedb9$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $a7dd9e2e61cbedb9$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $a7dd9e2e61cbedb9$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $a7dd9e2e61cbedb9$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $a7dd9e2e61cbedb9$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a7dd9e2e61cbedb9$var$matchOrdinalNumberPattern,
        parsePattern: $a7dd9e2e61cbedb9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a7dd9e2e61cbedb9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a7dd9e2e61cbedb9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a7dd9e2e61cbedb9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a7dd9e2e61cbedb9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a7dd9e2e61cbedb9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a7dd9e2e61cbedb9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a7dd9e2e61cbedb9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a7dd9e2e61cbedb9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a7dd9e2e61cbedb9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a7dd9e2e61cbedb9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a7dd9e2e61cbedb9$export$2e2bcd8739ae039 = $a7dd9e2e61cbedb9$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $9ac7f69fbde9c7b1$var$locale = {
    code: "ja",
    formatDistance: (0, $90e9457a1a5f0614$export$2e2bcd8739ae039),
    formatLong: (0, $2d11277168b746db$export$2e2bcd8739ae039),
    formatRelative: (0, $dee029ed6a6b8441$export$2e2bcd8739ae039),
    localize: (0, $3b284305273d6add$export$2e2bcd8739ae039),
    match: (0, $a7dd9e2e61cbedb9$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $9ac7f69fbde9c7b1$export$2e2bcd8739ae039 = $9ac7f69fbde9c7b1$var$locale;


var $7d043301a4e4e24c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1びょうみまん",
        other: "{{count}}びょうみまん",
        oneWithSuffix: "やく1びょう",
        otherWithSuffix: "やく{{count}}びょう"
    },
    xSeconds: {
        one: "1びょう",
        other: "{{count}}びょう"
    },
    halfAMinute: "30びょう",
    lessThanXMinutes: {
        one: "1ぷんみまん",
        other: "{{count}}ふんみまん",
        oneWithSuffix: "やく1ぷん",
        otherWithSuffix: "やく{{count}}ふん"
    },
    xMinutes: {
        one: "1ぷん",
        other: "{{count}}ふん"
    },
    aboutXHours: {
        one: "やく1じかん",
        other: "やく{{count}}じかん"
    },
    xHours: {
        one: "1じかん",
        other: "{{count}}じかん"
    },
    xDays: {
        one: "1にち",
        other: "{{count}}にち"
    },
    aboutXWeeks: {
        one: "やく1しゅうかん",
        other: "やく{{count}}しゅうかん"
    },
    xWeeks: {
        one: "1しゅうかん",
        other: "{{count}}しゅうかん"
    },
    aboutXMonths: {
        one: "やく1かげつ",
        other: "やく{{count}}かげつ"
    },
    xMonths: {
        one: "1かげつ",
        other: "{{count}}かげつ"
    },
    aboutXYears: {
        one: "やく1ねん",
        other: "やく{{count}}ねん"
    },
    xYears: {
        one: "1ねん",
        other: "{{count}}ねん"
    },
    overXYears: {
        one: "1ねんいじょう",
        other: "{{count}}ねんいじょう"
    },
    almostXYears: {
        one: "1ねんちかく",
        other: "{{count}}ねんちかく"
    }
};
var $7d043301a4e4e24c$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $7d043301a4e4e24c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "あと";
        else return result + "まえ";
    }
    return result;
};
var $7d043301a4e4e24c$export$2e2bcd8739ae039 = $7d043301a4e4e24c$var$formatDistance;



var $bc3a61a5800cb022$var$dateFormats = {
    full: "yねんMがつdにちEEEE",
    long: "yねんMがつdにち",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
var $bc3a61a5800cb022$var$timeFormats = {
    full: "Hじmmふんssびょう zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $bc3a61a5800cb022$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $bc3a61a5800cb022$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $bc3a61a5800cb022$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $bc3a61a5800cb022$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $bc3a61a5800cb022$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $bc3a61a5800cb022$export$2e2bcd8739ae039 = $bc3a61a5800cb022$var$formatLong;


var $9ae05f5341e30594$var$formatRelativeLocale = {
    lastWeek: "せんしゅうのeeeeのp",
    yesterday: "きのうのp",
    today: "きょうのp",
    tomorrow: "あしたのp",
    nextWeek: "よくしゅうのeeeeのp",
    other: "P"
};
var $9ae05f5341e30594$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9ae05f5341e30594$var$formatRelativeLocale[token];
};
var $9ae05f5341e30594$export$2e2bcd8739ae039 = $9ae05f5341e30594$var$formatRelative;



var $5e243ee85d46942a$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "きげんぜん",
        "せいれき"
    ],
    wide: [
        "きげんぜん",
        "せいれき"
    ]
};
var $5e243ee85d46942a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "だい1しはんき",
        "だい2しはんき",
        "だい3しはんき",
        "だい4しはんき"
    ]
};
var $5e243ee85d46942a$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1がつ",
        "2がつ",
        "3がつ",
        "4がつ",
        "5がつ",
        "6がつ",
        "7がつ",
        "8がつ",
        "9がつ",
        "10がつ",
        "11がつ",
        "12がつ"
    ],
    wide: [
        "1がつ",
        "2がつ",
        "3がつ",
        "4がつ",
        "5がつ",
        "6がつ",
        "7がつ",
        "8がつ",
        "9がつ",
        "10がつ",
        "11がつ",
        "12がつ"
    ]
};
var $5e243ee85d46942a$var$dayValues = {
    narrow: [
        "にち",
        "げつ",
        "か",
        "すい",
        "もく",
        "きん",
        "ど"
    ],
    short: [
        "にち",
        "げつ",
        "か",
        "すい",
        "もく",
        "きん",
        "ど"
    ],
    abbreviated: [
        "にち",
        "げつ",
        "か",
        "すい",
        "もく",
        "きん",
        "ど"
    ],
    wide: [
        "にちようび",
        "げつようび",
        "かようび",
        "すいようび",
        "もくようび",
        "きんようび",
        "どようび"
    ]
};
var $5e243ee85d46942a$var$dayPeriodValues = {
    narrow: {
        am: "ごぜん",
        pm: "ごご",
        midnight: "しんや",
        noon: "しょうご",
        morning: "あさ",
        afternoon: "ごご",
        evening: "よる",
        night: "しんや"
    },
    abbreviated: {
        am: "ごぜん",
        pm: "ごご",
        midnight: "しんや",
        noon: "しょうご",
        morning: "あさ",
        afternoon: "ごご",
        evening: "よる",
        night: "しんや"
    },
    wide: {
        am: "ごぜん",
        pm: "ごご",
        midnight: "しんや",
        noon: "しょうご",
        morning: "あさ",
        afternoon: "ごご",
        evening: "よる",
        night: "しんや"
    }
};
var $5e243ee85d46942a$var$formattingDayPeriodValues = {
    narrow: {
        am: "ごぜん",
        pm: "ごご",
        midnight: "しんや",
        noon: "しょうご",
        morning: "あさ",
        afternoon: "ごご",
        evening: "よる",
        night: "しんや"
    },
    abbreviated: {
        am: "ごぜん",
        pm: "ごご",
        midnight: "しんや",
        noon: "しょうご",
        morning: "あさ",
        afternoon: "ごご",
        evening: "よる",
        night: "しんや"
    },
    wide: {
        am: "ごぜん",
        pm: "ごご",
        midnight: "しんや",
        noon: "しょうご",
        morning: "あさ",
        afternoon: "ごご",
        evening: "よる",
        night: "しんや"
    }
};
var $5e243ee85d46942a$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case "year":
            return "".concat(number, "ねん");
        case "quarter":
            return "だい".concat(number, "しはんき");
        case "month":
            return "".concat(number, "がつ");
        case "week":
            return "だい".concat(number, "しゅう");
        case "date":
            return "".concat(number, "にち");
        case "hour":
            return "".concat(number, "じ");
        case "minute":
            return "".concat(number, "ふん");
        case "second":
            return "".concat(number, "びょう");
        default:
            return "".concat(number);
    }
};
var $5e243ee85d46942a$var$localize = {
    ordinalNumber: $5e243ee85d46942a$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5e243ee85d46942a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5e243ee85d46942a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5e243ee85d46942a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5e243ee85d46942a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5e243ee85d46942a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5e243ee85d46942a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $5e243ee85d46942a$export$2e2bcd8739ae039 = $5e243ee85d46942a$var$localize;




var $040d40207d84b781$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var $040d40207d84b781$var$parseOrdinalNumberPattern = /\d+/i;
var $040d40207d84b781$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var $040d40207d84b781$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var $040d40207d84b781$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var $040d40207d84b781$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $040d40207d84b781$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var $040d40207d84b781$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $040d40207d84b781$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var $040d40207d84b781$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var $040d40207d84b781$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var $040d40207d84b781$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var $040d40207d84b781$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $040d40207d84b781$var$matchOrdinalNumberPattern,
        parsePattern: $040d40207d84b781$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $040d40207d84b781$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $040d40207d84b781$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $040d40207d84b781$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $040d40207d84b781$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $040d40207d84b781$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $040d40207d84b781$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $040d40207d84b781$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $040d40207d84b781$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $040d40207d84b781$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $040d40207d84b781$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $040d40207d84b781$export$2e2bcd8739ae039 = $040d40207d84b781$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var $3cc349efc9715d82$var$locale = {
    code: "ja-Hira",
    formatDistance: (0, $7d043301a4e4e24c$export$2e2bcd8739ae039),
    formatLong: (0, $bc3a61a5800cb022$export$2e2bcd8739ae039),
    formatRelative: (0, $9ae05f5341e30594$export$2e2bcd8739ae039),
    localize: (0, $5e243ee85d46942a$export$2e2bcd8739ae039),
    match: (0, $040d40207d84b781$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $3cc349efc9715d82$export$2e2bcd8739ae039 = $3cc349efc9715d82$var$locale;


var $7d6e6960d903fa6e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} წამზე ნაკლები ხნის წინ",
        present: "{{count}} წამზე ნაკლები",
        future: "{{count}} წამზე ნაკლებში"
    },
    xSeconds: {
        past: "{{count}} წამის წინ",
        present: "{{count}} წამი",
        future: "{{count}} წამში"
    },
    halfAMinute: {
        past: "ნახევარი წუთის წინ",
        present: "ნახევარი წუთი",
        future: "ნახევარი წუთში"
    },
    lessThanXMinutes: {
        past: "{{count}} წუთზე ნაკლები ხნის წინ",
        present: "{{count}} წუთზე ნაკლები",
        future: "{{count}} წუთზე ნაკლებში"
    },
    xMinutes: {
        past: "{{count}} წუთის წინ",
        present: "{{count}} წუთი",
        future: "{{count}} წუთში"
    },
    aboutXHours: {
        past: "დაახლოებით {{count}} საათის წინ",
        present: "დაახლოებით {{count}} საათი",
        future: "დაახლოებით {{count}} საათში"
    },
    xHours: {
        past: "{{count}} საათის წინ",
        present: "{{count}} საათი",
        future: "{{count}} საათში"
    },
    xDays: {
        past: "{{count}} დღის წინ",
        present: "{{count}} დღე",
        future: "{{count}} დღეში"
    },
    aboutXWeeks: {
        past: "დაახლოებით {{count}} კვირას წინ",
        present: "დაახლოებით {{count}} კვირა",
        future: "დაახლოებით {{count}} კვირაში"
    },
    xWeeks: {
        past: "{{count}} კვირას კვირა",
        present: "{{count}} კვირა",
        future: "{{count}} კვირაში"
    },
    aboutXMonths: {
        past: "დაახლოებით {{count}} თვის წინ",
        present: "დაახლოებით {{count}} თვე",
        future: "დაახლოებით {{count}} თვეში"
    },
    xMonths: {
        past: "{{count}} თვის წინ",
        present: "{{count}} თვე",
        future: "{{count}} თვეში"
    },
    aboutXYears: {
        past: "დაახლოებით {{count}} წლის წინ",
        present: "დაახლოებით {{count}} წელი",
        future: "დაახლოებით {{count}} წელში"
    },
    xYears: {
        past: "{{count}} წლის წინ",
        present: "{{count}} წელი",
        future: "{{count}} წელში"
    },
    overXYears: {
        past: "{{count}} წელზე მეტი ხნის წინ",
        present: "{{count}} წელზე მეტი",
        future: "{{count}} წელზე მეტი ხნის შემდეგ"
    },
    almostXYears: {
        past: "თითქმის {{count}} წლის წინ",
        present: "თითქმის {{count}} წელი",
        future: "თითქმის {{count}} წელში"
    }
};
var $7d6e6960d903fa6e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7d6e6960d903fa6e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace("{{count}}", String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace("{{count}}", String(count));
    else result = tokenValue.present.replace("{{count}}", String(count));
    return result;
};
var $7d6e6960d903fa6e$export$2e2bcd8739ae039 = $7d6e6960d903fa6e$var$formatDistance;



var $74f1b64b44f17044$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do, MMMM, y",
    medium: "d, MMM, y",
    short: "dd/MM/yyyy"
};
var $74f1b64b44f17044$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $74f1b64b44f17044$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-ზე'",
    long: "{{date}} {{time}}'-ზე'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $74f1b64b44f17044$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $74f1b64b44f17044$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $74f1b64b44f17044$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $74f1b64b44f17044$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $74f1b64b44f17044$export$2e2bcd8739ae039 = $74f1b64b44f17044$var$formatLong;


var $82d1e19821a1aec1$var$formatRelativeLocale = {
    lastWeek: "'წინა' eeee p'-ზე'",
    yesterday: "'გუშინ' p'-ზე'",
    today: "'დღეს' p'-ზე'",
    tomorrow: "'ხვალ' p'-ზე'",
    nextWeek: "'შემდეგი' eeee p'-ზე'",
    other: "P"
};
var $82d1e19821a1aec1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $82d1e19821a1aec1$var$formatRelativeLocale[token];
};
var $82d1e19821a1aec1$export$2e2bcd8739ae039 = $82d1e19821a1aec1$var$formatRelative;



var $7411406094c5060f$var$eraValues = {
    narrow: [
        "ჩ.წ-მდე",
        "ჩ.წ"
    ],
    abbreviated: [
        "ჩვ.წ-მდე",
        "ჩვ.წ"
    ],
    wide: [
        "ჩვენს წელთაღრიცხვამდე",
        "ჩვენი წელთაღრიცხვით"
    ]
};
var $7411406094c5060f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-ლი კვ",
        "2-ე კვ",
        "3-ე კვ",
        "4-ე კვ"
    ],
    wide: [
        "1-ლი კვარტალი",
        "2-ე კვარტალი",
        "3-ე კვარტალი",
        "4-ე კვარტალი"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $7411406094c5060f$var$monthValues = {
    narrow: [
        "ია",
        "თე",
        "მა",
        "აპ",
        "მს",
        "ვნ",
        "ვლ",
        "აგ",
        "სე",
        "ოქ",
        "ნო",
        "დე"
    ],
    abbreviated: [
        "იან",
        "თებ",
        "მარ",
        "აპრ",
        "მაი",
        "ივნ",
        "ივლ",
        "აგვ",
        "სექ",
        "ოქტ",
        "ნოე",
        "დეკ"
    ],
    wide: [
        "იანვარი",
        "თებერვალი",
        "მარტი",
        "აპრილი",
        "მაისი",
        "ივნისი",
        "ივლისი",
        "აგვისტო",
        "სექტემბერი",
        "ოქტომბერი",
        "ნოემბერი",
        "დეკემბერი"
    ]
};
var $7411406094c5060f$var$dayValues = {
    narrow: [
        "კვ",
        "ორ",
        "სა",
        "ოთ",
        "ხუ",
        "პა",
        "შა"
    ],
    short: [
        "კვი",
        "ორშ",
        "სამ",
        "ოთხ",
        "ხუთ",
        "პარ",
        "შაბ"
    ],
    abbreviated: [
        "კვი",
        "ორშ",
        "სამ",
        "ოთხ",
        "ხუთ",
        "პარ",
        "შაბ"
    ],
    wide: [
        "კვირა",
        "ორშაბათი",
        "სამშაბათი",
        "ოთხშაბათი",
        "ხუთშაბათი",
        "პარასკევი",
        "შაბათი"
    ]
};
var $7411406094c5060f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "შუაღამე",
        noon: "შუადღე",
        morning: "დილა",
        afternoon: "საღამო",
        evening: "საღამო",
        night: "ღამე"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "შუაღამე",
        noon: "შუადღე",
        morning: "დილა",
        afternoon: "საღამო",
        evening: "საღამო",
        night: "ღამე"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "შუაღამე",
        noon: "შუადღე",
        morning: "დილა",
        afternoon: "საღამო",
        evening: "საღამო",
        night: "ღამე"
    }
};
var $7411406094c5060f$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "შუაღამით",
        noon: "შუადღისას",
        morning: "დილით",
        afternoon: "ნაშუადღევს",
        evening: "საღამოს",
        night: "ღამით"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "შუაღამით",
        noon: "შუადღისას",
        morning: "დილით",
        afternoon: "ნაშუადღევს",
        evening: "საღამოს",
        night: "ღამით"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "შუაღამით",
        noon: "შუადღისას",
        morning: "დილით",
        afternoon: "ნაშუადღევს",
        evening: "საღამოს",
        night: "ღამით"
    }
};
var $7411406094c5060f$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-ლი";
    return number + "-ე";
};
var $7411406094c5060f$var$localize = {
    ordinalNumber: $7411406094c5060f$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7411406094c5060f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7411406094c5060f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7411406094c5060f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7411406094c5060f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7411406094c5060f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7411406094c5060f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7411406094c5060f$export$2e2bcd8739ae039 = $7411406094c5060f$var$localize;




var $5028a9a56b0ebb64$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var $5028a9a56b0ebb64$var$parseOrdinalNumberPattern = /\d+/i;
var $5028a9a56b0ebb64$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var $5028a9a56b0ebb64$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var $5028a9a56b0ebb64$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var $5028a9a56b0ebb64$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5028a9a56b0ebb64$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var $5028a9a56b0ebb64$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var $5028a9a56b0ebb64$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var $5028a9a56b0ebb64$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var $5028a9a56b0ebb64$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var $5028a9a56b0ebb64$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var $5028a9a56b0ebb64$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $5028a9a56b0ebb64$var$matchOrdinalNumberPattern,
        parsePattern: $5028a9a56b0ebb64$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5028a9a56b0ebb64$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5028a9a56b0ebb64$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5028a9a56b0ebb64$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5028a9a56b0ebb64$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5028a9a56b0ebb64$var$matchMonthPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5028a9a56b0ebb64$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5028a9a56b0ebb64$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5028a9a56b0ebb64$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5028a9a56b0ebb64$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5028a9a56b0ebb64$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $5028a9a56b0ebb64$export$2e2bcd8739ae039 = $5028a9a56b0ebb64$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var $b0030840b48521e0$var$locale = {
    code: "ka",
    formatDistance: (0, $7d6e6960d903fa6e$export$2e2bcd8739ae039),
    formatLong: (0, $74f1b64b44f17044$export$2e2bcd8739ae039),
    formatRelative: (0, $82d1e19821a1aec1$export$2e2bcd8739ae039),
    localize: (0, $7411406094c5060f$export$2e2bcd8739ae039),
    match: (0, $5028a9a56b0ebb64$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $b0030840b48521e0$export$2e2bcd8739ae039 = $b0030840b48521e0$var$locale;


var $dc5da3e7a4b53766$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 секундтан аз",
            singularNominative: "{{count}} секундтан аз",
            singularGenitive: "{{count}} секундтан аз",
            pluralGenitive: "{{count}} секундтан аз"
        },
        future: {
            one: "бір секундтан кейін",
            singularNominative: "{{count}} секундтан кейін",
            singularGenitive: "{{count}} секундтан кейін",
            pluralGenitive: "{{count}} секундтан кейін"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} секунд",
            singularGenitive: "{{count}} секунд",
            pluralGenitive: "{{count}} секунд"
        },
        past: {
            singularNominative: "{{count}} секунд бұрын",
            singularGenitive: "{{count}} секунд бұрын",
            pluralGenitive: "{{count}} секунд бұрын"
        },
        future: {
            singularNominative: "{{count}} секундтан кейін",
            singularGenitive: "{{count}} секундтан кейін",
            pluralGenitive: "{{count}} секундтан кейін"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "жарты минут ішінде";
            else return "жарты минут бұрын";
        }
        return "жарты минут";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 минуттан аз",
            singularNominative: "{{count}} минуттан аз",
            singularGenitive: "{{count}} минуттан аз",
            pluralGenitive: "{{count}} минуттан аз"
        },
        future: {
            one: "минуттан кем ",
            singularNominative: "{{count}} минуттан кем",
            singularGenitive: "{{count}} минуттан кем",
            pluralGenitive: "{{count}} минуттан кем"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} минут",
            singularGenitive: "{{count}} минут",
            pluralGenitive: "{{count}} минут"
        },
        past: {
            singularNominative: "{{count}} минут бұрын",
            singularGenitive: "{{count}} минут бұрын",
            pluralGenitive: "{{count}} минут бұрын"
        },
        future: {
            singularNominative: "{{count}} минуттан кейін",
            singularGenitive: "{{count}} минуттан кейін",
            pluralGenitive: "{{count}} минуттан кейін"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "шамамен {{count}} сағат",
            singularGenitive: "шамамен {{count}} сағат",
            pluralGenitive: "шамамен {{count}} сағат"
        },
        future: {
            singularNominative: "шамамен {{count}} сағаттан кейін",
            singularGenitive: "шамамен {{count}} сағаттан кейін",
            pluralGenitive: "шамамен {{count}} сағаттан кейін"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} сағат",
            singularGenitive: "{{count}} сағат",
            pluralGenitive: "{{count}} сағат"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} күн",
            singularGenitive: "{{count}} күн",
            pluralGenitive: "{{count}} күн"
        },
        future: {
            singularNominative: "{{count}} күннен кейін",
            singularGenitive: "{{count}} күннен кейін",
            pluralGenitive: "{{count}} күннен кейін"
        }
    },
    aboutXWeeks: {
        type: "weeks",
        one: "шамамен 1 апта",
        other: "шамамен {{count}} апта"
    },
    xWeeks: {
        type: "weeks",
        one: "1 апта",
        other: "{{count}} апта"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "шамамен {{count}} ай",
            singularGenitive: "шамамен {{count}} ай",
            pluralGenitive: "шамамен {{count}} ай"
        },
        future: {
            singularNominative: "шамамен {{count}} айдан кейін",
            singularGenitive: "шамамен {{count}} айдан кейін",
            pluralGenitive: "шамамен {{count}} айдан кейін"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} ай",
            singularGenitive: "{{count}} ай",
            pluralGenitive: "{{count}} ай"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "шамамен {{count}} жыл",
            singularGenitive: "шамамен {{count}} жыл",
            pluralGenitive: "шамамен {{count}} жыл"
        },
        future: {
            singularNominative: "шамамен {{count}} жылдан кейін",
            singularGenitive: "шамамен {{count}} жылдан кейін",
            pluralGenitive: "шамамен {{count}} жылдан кейін"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} жыл",
            singularGenitive: "{{count}} жыл",
            pluralGenitive: "{{count}} жыл"
        },
        future: {
            singularNominative: "{{count}} жылдан кейін",
            singularGenitive: "{{count}} жылдан кейін",
            pluralGenitive: "{{count}} жылдан кейін"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} жылдан астам",
            singularGenitive: "{{count}} жылдан астам",
            pluralGenitive: "{{count}} жылдан астам"
        },
        future: {
            singularNominative: "{{count}} жылдан астам",
            singularGenitive: "{{count}} жылдан астам",
            pluralGenitive: "{{count}} жылдан астам"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} жылға жақын",
            singularGenitive: "{{count}} жылға жақын",
            pluralGenitive: "{{count}} жылға жақын"
        },
        future: {
            singularNominative: "{{count}} жылдан кейін",
            singularGenitive: "{{count}} жылдан кейін",
            pluralGenitive: "{{count}} жылдан кейін"
        }
    }
};
function $dc5da3e7a4b53766$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
var $dc5da3e7a4b53766$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $dc5da3e7a4b53766$var$formatDistanceLocale[token];
    if (typeof tokenValue === "function") return tokenValue(options);
    if (tokenValue.type === "weeks") return count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $dc5da3e7a4b53766$var$declension(tokenValue.future, count);
            else return $dc5da3e7a4b53766$var$declension(tokenValue.regular, count) + " кейін";
        } else {
            if (tokenValue.past) return $dc5da3e7a4b53766$var$declension(tokenValue.past, count);
            else return $dc5da3e7a4b53766$var$declension(tokenValue.regular, count) + " бұрын";
        }
    } else return $dc5da3e7a4b53766$var$declension(tokenValue.regular, count);
};
var $dc5da3e7a4b53766$export$2e2bcd8739ae039 = $dc5da3e7a4b53766$var$formatDistance;



var $c18ccfc8a1dc438b$var$dateFormats = {
    full: "EEEE, do MMMM y 'ж.'",
    long: "do MMMM y 'ж.'",
    medium: "d MMM y 'ж.'",
    short: "dd.MM.yyyy"
};
var $c18ccfc8a1dc438b$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $c18ccfc8a1dc438b$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $c18ccfc8a1dc438b$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $c18ccfc8a1dc438b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $c18ccfc8a1dc438b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $c18ccfc8a1dc438b$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $c18ccfc8a1dc438b$export$2e2bcd8739ae039 = $c18ccfc8a1dc438b$var$formatLong;



var $3899baa2c9984d56$var$accusativeWeekdays = [
    "жексенбіде",
    "дүйсенбіде",
    "сейсенбіде",
    "сәрсенбіде",
    "бейсенбіде",
    "жұмада",
    "сенбіде"
];
function $3899baa2c9984d56$var$_lastWeek(day) {
    var weekday = $3899baa2c9984d56$var$accusativeWeekdays[day];
    return "'өткен " + weekday + " сағат' p'-де'";
}
function $3899baa2c9984d56$var$thisWeek(day) {
    var weekday = $3899baa2c9984d56$var$accusativeWeekdays[day];
    return "'" + weekday + " сағат' p'-де'";
}
function $3899baa2c9984d56$var$_nextWeek(day) {
    var weekday = $3899baa2c9984d56$var$accusativeWeekdays[day];
    return "'келесі " + weekday + " сағат' p'-де'";
}
var $3899baa2c9984d56$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $3899baa2c9984d56$var$thisWeek(day);
        else return $3899baa2c9984d56$var$_lastWeek(day);
    },
    yesterday: "'кеше сағат' p'-де'",
    today: "'бүгін сағат' p'-де'",
    tomorrow: "'ертең сағат' p'-де'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $3899baa2c9984d56$var$thisWeek(day);
        else return $3899baa2c9984d56$var$_nextWeek(day);
    },
    other: "P"
};
var $3899baa2c9984d56$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $3899baa2c9984d56$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $3899baa2c9984d56$export$2e2bcd8739ae039 = $3899baa2c9984d56$var$formatRelative;



var $f6b3e57fc77b2f32$var$eraValues = {
    narrow: [
        "б.з.д.",
        "б.з."
    ],
    abbreviated: [
        "б.з.д.",
        "б.з."
    ],
    wide: [
        "біздің заманымызға дейін",
        "біздің заманымыз"
    ]
};
var $f6b3e57fc77b2f32$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-ші тоқ.",
        "2-ші тоқ.",
        "3-ші тоқ.",
        "4-ші тоқ."
    ],
    wide: [
        "1-ші тоқсан",
        "2-ші тоқсан",
        "3-ші тоқсан",
        "4-ші тоқсан"
    ]
};
var $f6b3e57fc77b2f32$var$monthValues = {
    narrow: [
        "Қ",
        "А",
        "Н",
        "С",
        "М",
        "М",
        "Ш",
        "Т",
        "Қ",
        "Қ",
        "Қ",
        "Ж"
    ],
    abbreviated: [
        "қаң",
        "ақп",
        "нау",
        "сәу",
        "мам",
        "мау",
        "шіл",
        "там",
        "қыр",
        "қаз",
        "қар",
        "жел"
    ],
    wide: [
        "қаңтар",
        "ақпан",
        "наурыз",
        "сәуір",
        "мамыр",
        "маусым",
        "шілде",
        "тамыз",
        "қыркүйек",
        "қазан",
        "қараша",
        "желтоқсан"
    ]
};
var $f6b3e57fc77b2f32$var$formattingMonthValues = {
    narrow: [
        "Қ",
        "А",
        "Н",
        "С",
        "М",
        "М",
        "Ш",
        "Т",
        "Қ",
        "Қ",
        "Қ",
        "Ж"
    ],
    abbreviated: [
        "қаң",
        "ақп",
        "нау",
        "сәу",
        "мам",
        "мау",
        "шіл",
        "там",
        "қыр",
        "қаз",
        "қар",
        "жел"
    ],
    wide: [
        "қаңтар",
        "ақпан",
        "наурыз",
        "сәуір",
        "мамыр",
        "маусым",
        "шілде",
        "тамыз",
        "қыркүйек",
        "қазан",
        "қараша",
        "желтоқсан"
    ]
};
var $f6b3e57fc77b2f32$var$dayValues = {
    narrow: [
        "Ж",
        "Д",
        "С",
        "С",
        "Б",
        "Ж",
        "С"
    ],
    short: [
        "жс",
        "дс",
        "сс",
        "ср",
        "бс",
        "жм",
        "сб"
    ],
    abbreviated: [
        "жс",
        "дс",
        "сс",
        "ср",
        "бс",
        "жм",
        "сб"
    ],
    wide: [
        "жексенбі",
        "дүйсенбі",
        "сейсенбі",
        "сәрсенбі",
        "бейсенбі",
        "жұма",
        "сенбі"
    ]
};
var $f6b3e57fc77b2f32$var$dayPeriodValues = {
    narrow: {
        am: "ТД",
        pm: "ТК",
        midnight: "түн ортасы",
        noon: "түс",
        morning: "таң",
        afternoon: "күндіз",
        evening: "кеш",
        night: "түн"
    },
    wide: {
        am: "ТД",
        pm: "ТК",
        midnight: "түн ортасы",
        noon: "түс",
        morning: "таң",
        afternoon: "күндіз",
        evening: "кеш",
        night: "түн"
    }
};
var $f6b3e57fc77b2f32$var$formattingDayPeriodValues = {
    narrow: {
        am: "ТД",
        pm: "ТК",
        midnight: "түн ортасында",
        noon: "түс",
        morning: "таң",
        afternoon: "күн",
        evening: "кеш",
        night: "түн"
    },
    wide: {
        am: "ТД",
        pm: "ТК",
        midnight: "түн ортасында",
        noon: "түсте",
        morning: "таңертең",
        afternoon: "күндіз",
        evening: "кеште",
        night: "түнде"
    }
};
var $f6b3e57fc77b2f32$var$suffixes = {
    0: "-ші",
    1: "-ші",
    2: "-ші",
    3: "-ші",
    4: "-ші",
    5: "-ші",
    6: "-шы",
    7: "-ші",
    8: "-ші",
    9: "-шы",
    10: "-шы",
    20: "-шы",
    30: "-шы",
    40: "-шы",
    50: "-ші",
    60: "-шы",
    70: "-ші",
    80: "-ші",
    90: "-шы",
    100: "-ші"
};
var $f6b3e57fc77b2f32$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = $f6b3e57fc77b2f32$var$suffixes[number] || $f6b3e57fc77b2f32$var$suffixes[mod10] || b && $f6b3e57fc77b2f32$var$suffixes[b] || "";
    return number + suffix;
};
var $f6b3e57fc77b2f32$var$localize = {
    ordinalNumber: $f6b3e57fc77b2f32$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f6b3e57fc77b2f32$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f6b3e57fc77b2f32$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f6b3e57fc77b2f32$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $f6b3e57fc77b2f32$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f6b3e57fc77b2f32$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f6b3e57fc77b2f32$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $f6b3e57fc77b2f32$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $f6b3e57fc77b2f32$export$2e2bcd8739ae039 = $f6b3e57fc77b2f32$var$localize;




var $bde26f8c4a7cb5fb$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var $bde26f8c4a7cb5fb$var$parseOrdinalNumberPattern = /\d+/i;
var $bde26f8c4a7cb5fb$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var $bde26f8c4a7cb5fb$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var $bde26f8c4a7cb5fb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var $bde26f8c4a7cb5fb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bde26f8c4a7cb5fb$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var $bde26f8c4a7cb5fb$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var $bde26f8c4a7cb5fb$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var $bde26f8c4a7cb5fb$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var $bde26f8c4a7cb5fb$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var $bde26f8c4a7cb5fb$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var $bde26f8c4a7cb5fb$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $bde26f8c4a7cb5fb$var$matchOrdinalNumberPattern,
        parsePattern: $bde26f8c4a7cb5fb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bde26f8c4a7cb5fb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bde26f8c4a7cb5fb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bde26f8c4a7cb5fb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bde26f8c4a7cb5fb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bde26f8c4a7cb5fb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bde26f8c4a7cb5fb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bde26f8c4a7cb5fb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bde26f8c4a7cb5fb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bde26f8c4a7cb5fb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bde26f8c4a7cb5fb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bde26f8c4a7cb5fb$export$2e2bcd8739ae039 = $bde26f8c4a7cb5fb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var $6bd584f076ef4669$var$locale = {
    code: "kk",
    formatDistance: (0, $dc5da3e7a4b53766$export$2e2bcd8739ae039),
    formatLong: (0, $c18ccfc8a1dc438b$export$2e2bcd8739ae039),
    formatRelative: (0, $3899baa2c9984d56$export$2e2bcd8739ae039),
    localize: (0, $f6b3e57fc77b2f32$export$2e2bcd8739ae039),
    match: (0, $bde26f8c4a7cb5fb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $6bd584f076ef4669$export$2e2bcd8739ae039 = $6bd584f076ef4669$var$locale;


var $ba5abb1b6fbae2af$var$formatDistanceLocale = {
    lessThanXSeconds: "តិចជាង {{count}} វិនាទី",
    xSeconds: "{{count}} វិនាទី",
    halfAMinute: "កន្លះនាទី",
    lessThanXMinutes: "តិចជាង {{count}} នាទី",
    xMinutes: "{{count}} នាទី",
    aboutXHours: "ប្រហែល {{count}} ម៉ោង",
    xHours: "{{count}} ម៉ោង",
    xDays: "{{count}} ថ្ងៃ",
    aboutXWeeks: "ប្រហែល {{count}} សប្តាហ៍",
    xWeeks: "{{count}} សប្តាហ៍",
    aboutXMonths: "ប្រហែល {{count}} ខែ",
    xMonths: "{{count}} ខែ",
    aboutXYears: "ប្រហែល {{count}} ឆ្នាំ",
    xYears: "{{count}} ឆ្នាំ",
    overXYears: "ជាង {{count}} ឆ្នាំ",
    almostXYears: "ជិត {{count}} ឆ្នាំ"
};
var $ba5abb1b6fbae2af$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $ba5abb1b6fbae2af$var$formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === "number") result = result.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "ក្នុងរយៈពេល " + result;
        else return result + "មុន";
    }
    return result;
};
var $ba5abb1b6fbae2af$export$2e2bcd8739ae039 = $ba5abb1b6fbae2af$var$formatDistance;



var $f19349bae1ec4e2c$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $f19349bae1ec4e2c$var$timeFormats = {
    full: "h:mm:ss a",
    long: "h:mm:ss a",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $f19349bae1ec4e2c$var$dateTimeFormats = {
    full: "{{date}} 'ម៉ោង' {{time}}",
    long: "{{date}} 'ម៉ោង' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f19349bae1ec4e2c$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f19349bae1ec4e2c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f19349bae1ec4e2c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f19349bae1ec4e2c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f19349bae1ec4e2c$export$2e2bcd8739ae039 = $f19349bae1ec4e2c$var$formatLong;


var $d8ca61512bb73472$var$formatRelativeLocale = {
    lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
    yesterday: "'ម្សិលមិញនៅម៉ោង' p",
    today: "'ថ្ងៃនេះម៉ោង' p",
    tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
    nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
    other: "P"
};
var $d8ca61512bb73472$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d8ca61512bb73472$var$formatRelativeLocale[token];
};
var $d8ca61512bb73472$export$2e2bcd8739ae039 = $d8ca61512bb73472$var$formatRelative;



var $0d9052b0debb3cdf$var$eraValues = {
    narrow: [
        "ម.គស",
        "គស"
    ],
    abbreviated: [
        "មុនគ.ស",
        "គ.ស"
    ],
    wide: [
        "មុនគ្រិស្តសករាជ",
        "នៃគ្រិស្តសករាជ"
    ]
};
var $0d9052b0debb3cdf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "ត្រីមាសទី 1",
        "ត្រីមាសទី 2",
        "ត្រីមាសទី 3",
        "ត្រីមាសទី 4"
    ]
};
var $0d9052b0debb3cdf$var$monthValues = {
    narrow: [
        "ម.ក",
        "ក.ម",
        "មិ",
        "ម.ស",
        "ឧ.ស",
        "ម.ថ",
        "ក.ដ",
        "សី",
        "កញ",
        "តុ",
        "វិ",
        "ធ"
    ],
    abbreviated: [
        "មករា",
        "កុម្ភៈ",
        "មីនា",
        "មេសា",
        "ឧសភា",
        "មិថុនា",
        "កក្កដា",
        "សីហា",
        "កញ្ញា",
        "តុលា",
        "វិច្ឆិកា",
        "ធ្នូ"
    ],
    wide: [
        "មករា",
        "កុម្ភៈ",
        "មីនា",
        "មេសា",
        "ឧសភា",
        "មិថុនា",
        "កក្កដា",
        "សីហា",
        "កញ្ញា",
        "តុលា",
        "វិច្ឆិកា",
        "ធ្នូ"
    ]
};
var $0d9052b0debb3cdf$var$dayValues = {
    narrow: [
        "អា",
        "ច",
        "អ",
        "ព",
        "ព្រ",
        "សុ",
        "ស"
    ],
    short: [
        "អា",
        "ច",
        "អ",
        "ព",
        "ព្រ",
        "សុ",
        "ស"
    ],
    abbreviated: [
        "អា",
        "ច",
        "អ",
        "ព",
        "ព្រ",
        "សុ",
        "ស"
    ],
    wide: [
        "អាទិត្យ",
        "ចន្ទ",
        "អង្គារ",
        "ពុធ",
        "ព្រហស្បតិ៍",
        "សុក្រ",
        "សៅរ៍"
    ]
};
var $0d9052b0debb3cdf$var$dayPeriodValues = {
    narrow: {
        am: "ព្រឹក",
        pm: "ល្ងាច",
        midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
        noon: "ពេលថ្ងៃត្រង់",
        morning: "ពេលព្រឹក",
        afternoon: "ពេលរសៀល",
        evening: "ពេលល្ងាច",
        night: "ពេលយប់"
    },
    abbreviated: {
        am: "ព្រឹក",
        pm: "ល្ងាច",
        midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
        noon: "ពេលថ្ងៃត្រង់",
        morning: "ពេលព្រឹក",
        afternoon: "ពេលរសៀល",
        evening: "ពេលល្ងាច",
        night: "ពេលយប់"
    },
    wide: {
        am: "ព្រឹក",
        pm: "ល្ងាច",
        midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
        noon: "ពេលថ្ងៃត្រង់",
        morning: "ពេលព្រឹក",
        afternoon: "ពេលរសៀល",
        evening: "ពេលល្ងាច",
        night: "ពេលយប់"
    }
};
var $0d9052b0debb3cdf$var$formattingDayPeriodValues = {
    narrow: {
        am: "ព្រឹក",
        pm: "ល្ងាច",
        midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
        noon: "ពេលថ្ងៃត្រង់",
        morning: "ពេលព្រឹក",
        afternoon: "ពេលរសៀល",
        evening: "ពេលល្ងាច",
        night: "ពេលយប់"
    },
    abbreviated: {
        am: "ព្រឹក",
        pm: "ល្ងាច",
        midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
        noon: "ពេលថ្ងៃត្រង់",
        morning: "ពេលព្រឹក",
        afternoon: "ពេលរសៀល",
        evening: "ពេលល្ងាច",
        night: "ពេលយប់"
    },
    wide: {
        am: "ព្រឹក",
        pm: "ល្ងាច",
        midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
        noon: "ពេលថ្ងៃត្រង់",
        morning: "ពេលព្រឹក",
        afternoon: "ពេលរសៀល",
        evening: "ពេលល្ងាច",
        night: "ពេលយប់"
    }
};
var $0d9052b0debb3cdf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var $0d9052b0debb3cdf$var$localize = {
    ordinalNumber: $0d9052b0debb3cdf$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0d9052b0debb3cdf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0d9052b0debb3cdf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0d9052b0debb3cdf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0d9052b0debb3cdf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $0d9052b0debb3cdf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0d9052b0debb3cdf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $0d9052b0debb3cdf$export$2e2bcd8739ae039 = $0d9052b0debb3cdf$var$localize;




var $64661d24e66eceb5$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $64661d24e66eceb5$var$parseOrdinalNumberPattern = /\d+/i;
var $64661d24e66eceb5$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var $64661d24e66eceb5$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var $64661d24e66eceb5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var $64661d24e66eceb5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $64661d24e66eceb5$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var $64661d24e66eceb5$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var $64661d24e66eceb5$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var $64661d24e66eceb5$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var $64661d24e66eceb5$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var $64661d24e66eceb5$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var $64661d24e66eceb5$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $64661d24e66eceb5$var$matchOrdinalNumberPattern,
        parsePattern: $64661d24e66eceb5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $64661d24e66eceb5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $64661d24e66eceb5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $64661d24e66eceb5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $64661d24e66eceb5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $64661d24e66eceb5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $64661d24e66eceb5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $64661d24e66eceb5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $64661d24e66eceb5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $64661d24e66eceb5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $64661d24e66eceb5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $64661d24e66eceb5$export$2e2bcd8739ae039 = $64661d24e66eceb5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var $a8289b4553e746e5$var$locale = {
    code: "km",
    formatDistance: (0, $ba5abb1b6fbae2af$export$2e2bcd8739ae039),
    formatLong: (0, $f19349bae1ec4e2c$export$2e2bcd8739ae039),
    formatRelative: (0, $d8ca61512bb73472$export$2e2bcd8739ae039),
    localize: (0, $0d9052b0debb3cdf$export$2e2bcd8739ae039),
    match: (0, $64661d24e66eceb5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $a8289b4553e746e5$export$2e2bcd8739ae039 = $a8289b4553e746e5$var$locale;


// note: no implementation for weeks
var $5492aee133670178$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
            future: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
            past: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
        },
        other: {
            default: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
            future: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
            past: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
        }
    },
    xSeconds: {
        one: {
            default: "1 ಸೆಕೆಂಡ್",
            future: "1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
            past: "1 ಸೆಕೆಂಡ್ ಹಿಂದೆ"
        },
        other: {
            default: "{{count}} ಸೆಕೆಂಡುಗಳು",
            future: "{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ",
            past: "{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ"
        }
    },
    halfAMinute: {
        other: {
            default: "ಅರ್ಧ ನಿಮಿಷ",
            future: "ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ",
            past: "ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
            future: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
            past: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
        },
        other: {
            default: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
            future: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
            past: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
        }
    },
    xMinutes: {
        one: {
            default: "1 ನಿಮಿಷ",
            future: "1 ನಿಮಿಷದಲ್ಲಿ",
            past: "1 ನಿಮಿಷದ ಹಿಂದೆ"
        },
        other: {
            default: "{{count}} ನಿಮಿಷಗಳು",
            future: "{{count}} ನಿಮಿಷಗಳಲ್ಲಿ",
            past: "{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ"
        }
    },
    aboutXHours: {
        one: {
            default: "ಸುಮಾರು 1 ಗಂಟೆ",
            future: "ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ",
            past: "ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ"
        },
        other: {
            default: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳು",
            future: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ",
            past: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
        }
    },
    xHours: {
        one: {
            default: "1 ಗಂಟೆ",
            future: "1 ಗಂಟೆಯಲ್ಲಿ",
            past: "1 ಗಂಟೆ ಹಿಂದೆ"
        },
        other: {
            default: "{{count}} ಗಂಟೆಗಳು",
            future: "{{count}} ಗಂಟೆಗಳಲ್ಲಿ",
            past: "{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
        }
    },
    xDays: {
        one: {
            default: "1 ದಿನ",
            future: "1 ದಿನದಲ್ಲಿ",
            past: "1 ದಿನದ ಹಿಂದೆ"
        },
        other: {
            default: "{{count}} ದಿನಗಳು",
            future: "{{count}} ದಿನಗಳಲ್ಲಿ",
            past: "{{count}} ದಿನಗಳ ಹಿಂದೆ"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "ಸುಮಾರು 1 ತಿಂಗಳು",
            future: "ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ",
            past: "ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ"
        },
        other: {
            default: "ಸುಮಾರು {{count}} ತಿಂಗಳು",
            future: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
            past: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
        }
    },
    xMonths: {
        one: {
            default: "1 ತಿಂಗಳು",
            future: "1 ತಿಂಗಳಲ್ಲಿ",
            past: "1 ತಿಂಗಳ ಹಿಂದೆ"
        },
        other: {
            default: "{{count}} ತಿಂಗಳು",
            future: "{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
            past: "{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
        }
    },
    aboutXYears: {
        one: {
            default: "ಸುಮಾರು 1 ವರ್ಷ",
            future: "ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ",
            past: "ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ"
        },
        other: {
            default: "ಸುಮಾರು {{count}} ವರ್ಷಗಳು",
            future: "ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ",
            past: "ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
        }
    },
    xYears: {
        one: {
            default: "1 ವರ್ಷ",
            future: "1 ವರ್ಷದಲ್ಲಿ",
            past: "1 ವರ್ಷದ ಹಿಂದೆ"
        },
        other: {
            default: "{{count}} ವರ್ಷಗಳು",
            future: "{{count}} ವರ್ಷಗಳಲ್ಲಿ",
            past: "{{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
        }
    },
    overXYears: {
        one: {
            default: "1 ವರ್ಷದ ಮೇಲೆ",
            future: "1 ವರ್ಷದ ಮೇಲೆ",
            past: "1 ವರ್ಷದ ಮೇಲೆ"
        },
        other: {
            default: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
            future: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
            past: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ"
        }
    },
    almostXYears: {
        one: {
            default: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
            future: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
            past: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ"
        },
        other: {
            default: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
            future: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
            past: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ"
        }
    }
};
function $5492aee133670178$var$getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var $5492aee133670178$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5492aee133670178$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $5492aee133670178$var$getResultByTense(tokenValue.one, options);
    else result = $5492aee133670178$var$getResultByTense(tokenValue.other, options);
    return result.replace("{{count}}", String(count));
};
var $5492aee133670178$export$2e2bcd8739ae039 = $5492aee133670178$var$formatDistance;



var $daeb8c0c8e76937c$var$dateFormats = {
    full: "EEEE, MMMM d, y",
    // CLDR 1816
    long: "MMMM d, y",
    // CLDR 1817
    medium: "MMM d, y",
    // CLDR 1818
    short: "d/M/yy" // CLDR 1819
};
var $daeb8c0c8e76937c$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    // CLDR 1820
    long: "hh:mm:ss a z",
    // CLDR 1821
    medium: "hh:mm:ss a",
    // CLDR 1822
    short: "hh:mm a" // CLDR 1823
};
var $daeb8c0c8e76937c$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    // CLDR 1824
    long: "{{date}} {{time}}",
    // CLDR 1825
    medium: "{{date}} {{time}}",
    // CLDR 1826
    short: "{{date}} {{time}}" // CLDR 1827
};
var $daeb8c0c8e76937c$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $daeb8c0c8e76937c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $daeb8c0c8e76937c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $daeb8c0c8e76937c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $daeb8c0c8e76937c$export$2e2bcd8739ae039 = $daeb8c0c8e76937c$var$formatLong;


var $1d4d6b78094ed610$var$formatRelativeLocale = {
    lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
    yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
    today: "'ಇಂದು' p 'ಕ್ಕೆ'",
    tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
    nextWeek: "eeee p 'ಕ್ಕೆ'",
    other: "P"
};
var $1d4d6b78094ed610$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1d4d6b78094ed610$var$formatRelativeLocale[token];
};
var $1d4d6b78094ed610$export$2e2bcd8739ae039 = $1d4d6b78094ed610$var$formatRelative;



var $67e1f95cbfb366cb$var$eraValues = {
    narrow: [
        "ಕ್ರಿ.ಪೂ",
        "ಕ್ರಿ.ಶ"
    ],
    abbreviated: [
        "ಕ್ರಿ.ಪೂ",
        "ಕ್ರಿ.ಶ"
    ],
    // CLDR #1618, #1620
    wide: [
        "ಕ್ರಿಸ್ತ ಪೂರ್ವ",
        "ಕ್ರಿಸ್ತ ಶಕ"
    ] // CLDR #1614, #1616
};
var $67e1f95cbfb366cb$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "ತ್ರೈ 1",
        "ತ್ರೈ 2",
        "ತ್ರೈ 3",
        "ತ್ರೈ 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1ನೇ ತ್ರೈಮಾಸಿಕ",
        "2ನೇ ತ್ರೈಮಾಸಿಕ",
        "3ನೇ ತ್ರೈಮಾಸಿಕ",
        "4ನೇ ತ್ರೈಮಾಸಿಕ"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var $67e1f95cbfb366cb$var$monthValues = {
    narrow: [
        "ಜ",
        "ಫೆ",
        "ಮಾ",
        "ಏ",
        "ಮೇ",
        "ಜೂ",
        "ಜು",
        "ಆ",
        "ಸೆ",
        "ಅ",
        "ನ",
        "ಡಿ"
    ],
    abbreviated: [
        "ಜನ",
        "ಫೆಬ್ರ",
        "ಮಾರ್ಚ್",
        "ಏಪ್ರಿ",
        "ಮೇ",
        "ಜೂನ್",
        "ಜುಲೈ",
        "ಆಗ",
        "ಸೆಪ್ಟೆಂ",
        "ಅಕ್ಟೋ",
        "ನವೆಂ",
        "ಡಿಸೆಂ"
    ],
    wide: [
        "ಜನವರಿ",
        "ಫೆಬ್ರವರಿ",
        "ಮಾರ್ಚ್",
        "ಏಪ್ರಿಲ್",
        "ಮೇ",
        "ಜೂನ್",
        "ಜುಲೈ",
        "ಆಗಸ್ಟ್",
        "ಸೆಪ್ಟೆಂಬರ್",
        "ಅಕ್ಟೋಬರ್",
        "ನವೆಂಬರ್",
        "ಡಿಸೆಂಬರ್"
    ]
};
// CLDR #1718 - #1773
var $67e1f95cbfb366cb$var$dayValues = {
    narrow: [
        "ಭಾ",
        "ಸೋ",
        "ಮಂ",
        "ಬು",
        "ಗು",
        "ಶು",
        "ಶ"
    ],
    short: [
        "ಭಾನು",
        "ಸೋಮ",
        "ಮಂಗಳ",
        "ಬುಧ",
        "ಗುರು",
        "ಶುಕ್ರ",
        "ಶನಿ"
    ],
    abbreviated: [
        "ಭಾನು",
        "ಸೋಮ",
        "ಮಂಗಳ",
        "ಬುಧ",
        "ಗುರು",
        "ಶುಕ್ರ",
        "ಶನಿ"
    ],
    wide: [
        "ಭಾನುವಾರ",
        "ಸೋಮವಾರ",
        "ಮಂಗಳವಾರ",
        "ಬುಧವಾರ",
        "ಗುರುವಾರ",
        "ಶುಕ್ರವಾರ",
        "ಶನಿವಾರ"
    ]
};
// CLDR #1774 - #1815
var $67e1f95cbfb366cb$var$dayPeriodValues = {
    narrow: {
        am: "ಪೂರ್ವಾಹ್ನ",
        pm: "ಅಪರಾಹ್ನ",
        midnight: "ಮಧ್ಯರಾತ್ರಿ",
        noon: "ಮಧ್ಯಾಹ್ನ",
        morning: "ಬೆಳಗ್ಗೆ",
        afternoon: "ಮಧ್ಯಾಹ್ನ",
        evening: "ಸಂಜೆ",
        night: "ರಾತ್ರಿ"
    },
    abbreviated: {
        am: "ಪೂರ್ವಾಹ್ನ",
        pm: "ಅಪರಾಹ್ನ",
        midnight: "ಮಧ್ಯರಾತ್ರಿ",
        noon: "ಮಧ್ಯಾನ್ಹ",
        morning: "ಬೆಳಗ್ಗೆ",
        afternoon: "ಮಧ್ಯಾನ್ಹ",
        evening: "ಸಂಜೆ",
        night: "ರಾತ್ರಿ"
    },
    wide: {
        am: "ಪೂರ್ವಾಹ್ನ",
        pm: "ಅಪರಾಹ್ನ",
        midnight: "ಮಧ್ಯರಾತ್ರಿ",
        noon: "ಮಧ್ಯಾನ್ಹ",
        morning: "ಬೆಳಗ್ಗೆ",
        afternoon: "ಮಧ್ಯಾನ್ಹ",
        evening: "ಸಂಜೆ",
        night: "ರಾತ್ರಿ"
    }
};
var $67e1f95cbfb366cb$var$formattingDayPeriodValues = {
    narrow: {
        am: "ಪೂ",
        pm: "ಅ",
        midnight: "ಮಧ್ಯರಾತ್ರಿ",
        noon: "ಮಧ್ಯಾನ್ಹ",
        morning: "ಬೆಳಗ್ಗೆ",
        afternoon: "ಮಧ್ಯಾನ್ಹ",
        evening: "ಸಂಜೆ",
        night: "ರಾತ್ರಿ"
    },
    abbreviated: {
        am: "ಪೂರ್ವಾಹ್ನ",
        pm: "ಅಪರಾಹ್ನ",
        midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
        noon: "ಮಧ್ಯಾನ್ಹ",
        morning: "ಬೆಳಗ್ಗೆ",
        afternoon: "ಮಧ್ಯಾನ್ಹ",
        evening: "ಸಂಜೆ",
        night: "ರಾತ್ರಿ"
    },
    wide: {
        am: "ಪೂರ್ವಾಹ್ನ",
        pm: "ಅಪರಾಹ್ನ",
        midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
        noon: "ಮಧ್ಯಾನ್ಹ",
        morning: "ಬೆಳಗ್ಗೆ",
        afternoon: "ಮಧ್ಯಾನ್ಹ",
        evening: "ಸಂಜೆ",
        night: "ರಾತ್ರಿ"
    }
};
var $67e1f95cbfb366cb$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "ನೇ";
};
var $67e1f95cbfb366cb$var$localize = {
    ordinalNumber: $67e1f95cbfb366cb$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $67e1f95cbfb366cb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $67e1f95cbfb366cb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $67e1f95cbfb366cb$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $67e1f95cbfb366cb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $67e1f95cbfb366cb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $67e1f95cbfb366cb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $67e1f95cbfb366cb$export$2e2bcd8739ae039 = $67e1f95cbfb366cb$var$localize;




var $4b5b1ac0817ec732$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var $4b5b1ac0817ec732$var$parseOrdinalNumberPattern = /\d+/i;
var $4b5b1ac0817ec732$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var $4b5b1ac0817ec732$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var $4b5b1ac0817ec732$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var $4b5b1ac0817ec732$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4b5b1ac0817ec732$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var $4b5b1ac0817ec732$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var $4b5b1ac0817ec732$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var $4b5b1ac0817ec732$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var $4b5b1ac0817ec732$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var $4b5b1ac0817ec732$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var $4b5b1ac0817ec732$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $4b5b1ac0817ec732$var$matchOrdinalNumberPattern,
        parsePattern: $4b5b1ac0817ec732$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4b5b1ac0817ec732$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b5b1ac0817ec732$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4b5b1ac0817ec732$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b5b1ac0817ec732$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4b5b1ac0817ec732$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b5b1ac0817ec732$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4b5b1ac0817ec732$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b5b1ac0817ec732$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4b5b1ac0817ec732$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4b5b1ac0817ec732$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $4b5b1ac0817ec732$export$2e2bcd8739ae039 = $4b5b1ac0817ec732$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var $f9d81869d00cc31e$var$locale = {
    code: "kn",
    formatDistance: (0, $5492aee133670178$export$2e2bcd8739ae039),
    formatLong: (0, $daeb8c0c8e76937c$export$2e2bcd8739ae039),
    formatRelative: (0, $1d4d6b78094ed610$export$2e2bcd8739ae039),
    localize: (0, $67e1f95cbfb366cb$export$2e2bcd8739ae039),
    match: (0, $4b5b1ac0817ec732$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f9d81869d00cc31e$export$2e2bcd8739ae039 = $f9d81869d00cc31e$var$locale;


var $c43d0c4134cc6039$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1초 미만",
        other: "{{count}}초 미만"
    },
    xSeconds: {
        one: "1초",
        other: "{{count}}초"
    },
    halfAMinute: "30초",
    lessThanXMinutes: {
        one: "1분 미만",
        other: "{{count}}분 미만"
    },
    xMinutes: {
        one: "1분",
        other: "{{count}}분"
    },
    aboutXHours: {
        one: "약 1시간",
        other: "약 {{count}}시간"
    },
    xHours: {
        one: "1시간",
        other: "{{count}}시간"
    },
    xDays: {
        one: "1일",
        other: "{{count}}일"
    },
    aboutXWeeks: {
        one: "약 1주",
        other: "약 {{count}}주"
    },
    xWeeks: {
        one: "1주",
        other: "{{count}}주"
    },
    aboutXMonths: {
        one: "약 1개월",
        other: "약 {{count}}개월"
    },
    xMonths: {
        one: "1개월",
        other: "{{count}}개월"
    },
    aboutXYears: {
        one: "약 1년",
        other: "약 {{count}}년"
    },
    xYears: {
        one: "1년",
        other: "{{count}}년"
    },
    overXYears: {
        one: "1년 이상",
        other: "{{count}}년 이상"
    },
    almostXYears: {
        one: "거의 1년",
        other: "거의 {{count}}년"
    }
};
var $c43d0c4134cc6039$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c43d0c4134cc6039$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " 후";
        else return result + " 전";
    }
    return result;
};
var $c43d0c4134cc6039$export$2e2bcd8739ae039 = $c43d0c4134cc6039$var$formatDistance;



var $d5411b68d6727e5b$var$dateFormats = {
    full: "y년 M월 d일 EEEE",
    long: "y년 M월 d일",
    medium: "y.MM.dd",
    short: "y.MM.dd"
};
var $d5411b68d6727e5b$var$timeFormats = {
    full: "a H시 mm분 ss초 zzzz",
    long: "a H:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $d5411b68d6727e5b$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $d5411b68d6727e5b$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d5411b68d6727e5b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d5411b68d6727e5b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $d5411b68d6727e5b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d5411b68d6727e5b$export$2e2bcd8739ae039 = $d5411b68d6727e5b$var$formatLong;


var $385c4fe82ab2c68f$var$formatRelativeLocale = {
    lastWeek: "'지난' eeee p",
    yesterday: "'어제' p",
    today: "'오늘' p",
    tomorrow: "'내일' p",
    nextWeek: "'다음' eeee p",
    other: "P"
};
var $385c4fe82ab2c68f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $385c4fe82ab2c68f$var$formatRelativeLocale[token];
};
var $385c4fe82ab2c68f$export$2e2bcd8739ae039 = $385c4fe82ab2c68f$var$formatRelative;



var $836e7008e9c3fb13$var$eraValues = {
    narrow: [
        "BC",
        "AD"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "기원전",
        "서기"
    ]
};
var $836e7008e9c3fb13$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1분기",
        "2분기",
        "3분기",
        "4분기"
    ]
};
var $836e7008e9c3fb13$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월"
    ],
    wide: [
        "1월",
        "2월",
        "3월",
        "4월",
        "5월",
        "6월",
        "7월",
        "8월",
        "9월",
        "10월",
        "11월",
        "12월"
    ]
};
var $836e7008e9c3fb13$var$dayValues = {
    narrow: [
        "일",
        "월",
        "화",
        "수",
        "목",
        "금",
        "토"
    ],
    short: [
        "일",
        "월",
        "화",
        "수",
        "목",
        "금",
        "토"
    ],
    abbreviated: [
        "일",
        "월",
        "화",
        "수",
        "목",
        "금",
        "토"
    ],
    wide: [
        "일요일",
        "월요일",
        "화요일",
        "수요일",
        "목요일",
        "금요일",
        "토요일"
    ]
};
var $836e7008e9c3fb13$var$dayPeriodValues = {
    narrow: {
        am: "오전",
        pm: "오후",
        midnight: "자정",
        noon: "정오",
        morning: "아침",
        afternoon: "오후",
        evening: "저녁",
        night: "밤"
    },
    abbreviated: {
        am: "오전",
        pm: "오후",
        midnight: "자정",
        noon: "정오",
        morning: "아침",
        afternoon: "오후",
        evening: "저녁",
        night: "밤"
    },
    wide: {
        am: "오전",
        pm: "오후",
        midnight: "자정",
        noon: "정오",
        morning: "아침",
        afternoon: "오후",
        evening: "저녁",
        night: "밤"
    }
};
var $836e7008e9c3fb13$var$formattingDayPeriodValues = {
    narrow: {
        am: "오전",
        pm: "오후",
        midnight: "자정",
        noon: "정오",
        morning: "아침",
        afternoon: "오후",
        evening: "저녁",
        night: "밤"
    },
    abbreviated: {
        am: "오전",
        pm: "오후",
        midnight: "자정",
        noon: "정오",
        morning: "아침",
        afternoon: "오후",
        evening: "저녁",
        night: "밤"
    },
    wide: {
        am: "오전",
        pm: "오후",
        midnight: "자정",
        noon: "정오",
        morning: "아침",
        afternoon: "오후",
        evening: "저녁",
        night: "밤"
    }
};
var $836e7008e9c3fb13$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case "minute":
        case "second":
            return String(number);
        case "date":
            return number + "일";
        default:
            return number + "번째";
    }
};
var $836e7008e9c3fb13$var$localize = {
    ordinalNumber: $836e7008e9c3fb13$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $836e7008e9c3fb13$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $836e7008e9c3fb13$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $836e7008e9c3fb13$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $836e7008e9c3fb13$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $836e7008e9c3fb13$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $836e7008e9c3fb13$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $836e7008e9c3fb13$export$2e2bcd8739ae039 = $836e7008e9c3fb13$var$localize;




var $29f6c0aa64cb8f5c$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $29f6c0aa64cb8f5c$var$parseOrdinalNumberPattern = /\d+/i;
var $29f6c0aa64cb8f5c$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $29f6c0aa64cb8f5c$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $29f6c0aa64cb8f5c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $29f6c0aa64cb8f5c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $29f6c0aa64cb8f5c$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $29f6c0aa64cb8f5c$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $29f6c0aa64cb8f5c$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $29f6c0aa64cb8f5c$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $29f6c0aa64cb8f5c$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $29f6c0aa64cb8f5c$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $29f6c0aa64cb8f5c$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $29f6c0aa64cb8f5c$var$matchOrdinalNumberPattern,
        parsePattern: $29f6c0aa64cb8f5c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $29f6c0aa64cb8f5c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f6c0aa64cb8f5c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $29f6c0aa64cb8f5c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f6c0aa64cb8f5c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $29f6c0aa64cb8f5c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f6c0aa64cb8f5c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $29f6c0aa64cb8f5c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f6c0aa64cb8f5c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $29f6c0aa64cb8f5c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $29f6c0aa64cb8f5c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $29f6c0aa64cb8f5c$export$2e2bcd8739ae039 = $29f6c0aa64cb8f5c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $2475feb152231d86$var$locale = {
    code: "ko",
    formatDistance: (0, $c43d0c4134cc6039$export$2e2bcd8739ae039),
    formatLong: (0, $d5411b68d6727e5b$export$2e2bcd8739ae039),
    formatRelative: (0, $385c4fe82ab2c68f$export$2e2bcd8739ae039),
    localize: (0, $836e7008e9c3fb13$export$2e2bcd8739ae039),
    match: (0, $29f6c0aa64cb8f5c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2475feb152231d86$export$2e2bcd8739ae039 = $2475feb152231d86$var$locale;


var $5633badf3ad70ba4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: "eng Sekonn",
            other: "{{count}} Sekonnen"
        },
        withPreposition: {
            one: "enger Sekonn",
            other: "{{count}} Sekonnen"
        }
    },
    halfAMinute: {
        standalone: "eng hallef Minutt",
        withPreposition: "enger hallwer Minutt"
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: "eng Minutt",
            other: "{{count}} Minutten"
        },
        withPreposition: {
            one: "enger Minutt",
            other: "{{count}} Minutten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: "eng Stonn",
            other: "{{count}} Stonnen"
        },
        withPreposition: {
            one: "enger Stonn",
            other: "{{count}} Stonnen"
        }
    },
    xDays: {
        standalone: {
            one: "een Dag",
            other: "{{count}} Deeg"
        },
        withPreposition: {
            one: "engem Dag",
            other: "{{count}} Deeg"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "eng Woch",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "enger Woch",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: "ee Mount",
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: "engem Mount",
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: "ee Joer",
            other: "{{count}} Joer"
        },
        withPreposition: {
            one: "engem Joer",
            other: "{{count}} Joer"
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: "bal ee Joer",
            other: "bal {{count}} Joer"
        },
        withPreposition: {
            one: "bal engem Joer",
            other: "bal {{count}} Joer"
        }
    }
};
var $5633badf3ad70ba4$var$EXCEPTION_CONSONANTS = [
    "d",
    "h",
    "n",
    "t",
    "z"
];
var $5633badf3ad70ba4$var$VOWELS = [
    "a,",
    "e",
    "i",
    "o",
    "u"
];
var $5633badf3ad70ba4$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var $5633badf3ad70ba4$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $5633badf3ad70ba4$var$isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if ($5633badf3ad70ba4$var$VOWELS.indexOf(firstLetter) != -1 || $5633badf3ad70ba4$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(" ")[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && $5633badf3ad70ba4$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $5633badf3ad70ba4$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var $5633badf3ad70ba4$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5633badf3ad70ba4$var$formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "a" + ($5633badf3ad70ba4$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
        else return "viru" + ($5633badf3ad70ba4$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
    }
    return result;
};
var $5633badf3ad70ba4$export$2e2bcd8739ae039 = $5633badf3ad70ba4$var$formatDistance;



var $19a027d69daae12a$var$dateFormats = {
    full: "EEEE, do MMMM y",
    // Méindeg, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan 2018
    short: "dd.MM.yy" // 07.01.18
};
var $19a027d69daae12a$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $19a027d69daae12a$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $19a027d69daae12a$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $19a027d69daae12a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $19a027d69daae12a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $19a027d69daae12a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $19a027d69daae12a$export$2e2bcd8739ae039 = $19a027d69daae12a$var$formatLong;


var $bacecf34f5c47209$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += "n";
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
var $bacecf34f5c47209$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $bacecf34f5c47209$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $bacecf34f5c47209$export$2e2bcd8739ae039 = $bacecf34f5c47209$var$formatRelative;



var $66691969439e6ab9$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "viru Christus",
        "no Christus"
    ]
};
var $66691969439e6ab9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
var $66691969439e6ab9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4e",
        "Abr",
        "Mee",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4erz",
        "Abr\xebll",
        "Mee",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
var $66691969439e6ab9$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "M\xe9",
        "D\xeb",
        "M\xeb",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonndeg",
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        "Donneschdeg",
        "Freideg",
        "Samschdeg"
    ]
};
var $66691969439e6ab9$var$dayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    }
};
var $66691969439e6ab9$var$formattingDayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom.",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    }
};
var $66691969439e6ab9$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $66691969439e6ab9$var$localize = {
    ordinalNumber: $66691969439e6ab9$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $66691969439e6ab9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $66691969439e6ab9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $66691969439e6ab9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $66691969439e6ab9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $66691969439e6ab9$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $66691969439e6ab9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $66691969439e6ab9$export$2e2bcd8739ae039 = $66691969439e6ab9$var$localize;




var $7bb3dc8724a2999f$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $7bb3dc8724a2999f$var$parseOrdinalNumberPattern = /\d+/i;
var $7bb3dc8724a2999f$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var $7bb3dc8724a2999f$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $7bb3dc8724a2999f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $7bb3dc8724a2999f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7bb3dc8724a2999f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var $7bb3dc8724a2999f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7bb3dc8724a2999f$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var $7bb3dc8724a2999f$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $7bb3dc8724a2999f$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var $7bb3dc8724a2999f$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var $7bb3dc8724a2999f$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $7bb3dc8724a2999f$var$matchOrdinalNumberPattern,
        parsePattern: $7bb3dc8724a2999f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7bb3dc8724a2999f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7bb3dc8724a2999f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7bb3dc8724a2999f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7bb3dc8724a2999f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7bb3dc8724a2999f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7bb3dc8724a2999f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7bb3dc8724a2999f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7bb3dc8724a2999f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7bb3dc8724a2999f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7bb3dc8724a2999f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7bb3dc8724a2999f$export$2e2bcd8739ae039 = $7bb3dc8724a2999f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var $6e9ced47150432d9$var$locale = {
    code: "lb",
    formatDistance: (0, $5633badf3ad70ba4$export$2e2bcd8739ae039),
    formatLong: (0, $19a027d69daae12a$export$2e2bcd8739ae039),
    formatRelative: (0, $bacecf34f5c47209$export$2e2bcd8739ae039),
    localize: (0, $66691969439e6ab9$export$2e2bcd8739ae039),
    match: (0, $7bb3dc8724a2999f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $6e9ced47150432d9$export$2e2bcd8739ae039 = $6e9ced47150432d9$var$locale;


var $d537a15b9c7e8cc6$var$translations = {
    xseconds_other: "sekundė_sekundžių_sekundes",
    xminutes_one: "minutė_minutės_minutę",
    xminutes_other: "minutės_minučių_minutes",
    xhours_one: "valanda_valandos_valandą",
    xhours_other: "valandos_valandų_valandas",
    xdays_one: "diena_dienos_dieną",
    xdays_other: "dienos_dienų_dienas",
    xweeks_one: "savaitė_savaitės_savaitę",
    xweeks_other: "savaitės_savaičių_savaites",
    xmonths_one: "mėnuo_mėnesio_mėnesį",
    xmonths_other: "mėnesiai_mėnesių_mėnesius",
    xyears_one: "metai_metų_metus",
    xyears_other: "metai_metų_metus",
    about: "apie",
    over: "daugiau nei",
    almost: "beveik",
    lessthan: "mažiau nei"
};
var $d537a15b9c7e8cc6$var$translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekundės";
    else return isFuture ? "kelių sekundžių" : "kelias sekundes";
};
var $d537a15b9c7e8cc6$var$translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? $d537a15b9c7e8cc6$var$forms(key)[0] : isFuture ? $d537a15b9c7e8cc6$var$forms(key)[1] : $d537a15b9c7e8cc6$var$forms(key)[2];
};
var $d537a15b9c7e8cc6$var$translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + " ";
    if (number === 1) return result + $d537a15b9c7e8cc6$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($d537a15b9c7e8cc6$var$special(number) ? $d537a15b9c7e8cc6$var$forms(key)[1] : $d537a15b9c7e8cc6$var$forms(key)[0]);
    else {
        if (isFuture) return result + $d537a15b9c7e8cc6$var$forms(key)[1];
        else return result + ($d537a15b9c7e8cc6$var$special(number) ? $d537a15b9c7e8cc6$var$forms(key)[1] : $d537a15b9c7e8cc6$var$forms(key)[2]);
    }
};
function $d537a15b9c7e8cc6$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $d537a15b9c7e8cc6$var$forms(key) {
    return $d537a15b9c7e8cc6$var$translations[key].split("_");
}
var $d537a15b9c7e8cc6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $d537a15b9c7e8cc6$var$translateSeconds,
        other: $d537a15b9c7e8cc6$var$translate
    },
    xSeconds: {
        one: $d537a15b9c7e8cc6$var$translateSeconds,
        other: $d537a15b9c7e8cc6$var$translate
    },
    halfAMinute: "pusė minutės",
    lessThanXMinutes: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    xMinutes: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    aboutXHours: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    xHours: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    xDays: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    aboutXWeeks: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    xWeeks: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    aboutXMonths: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    xMonths: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    aboutXYears: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    xYears: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    overXYears: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    },
    almostXYears: {
        one: $d537a15b9c7e8cc6$var$translateSingular,
        other: $d537a15b9c7e8cc6$var$translate
    }
};
var $d537a15b9c7e8cc6$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], "") : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = $d537a15b9c7e8cc6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + "_one", isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + "_other", isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = $d537a15b9c7e8cc6$var$translations[_key2] + " " + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "po " + result;
        else return "prieš " + result;
    }
    return result;
};
var $d537a15b9c7e8cc6$export$2e2bcd8739ae039 = $d537a15b9c7e8cc6$var$formatDistance;



var $386f16d4945b544c$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: "y-MM-dd",
    short: "y-MM-dd"
};
var $386f16d4945b544c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $386f16d4945b544c$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $386f16d4945b544c$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $386f16d4945b544c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $386f16d4945b544c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $386f16d4945b544c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $386f16d4945b544c$export$2e2bcd8739ae039 = $386f16d4945b544c$var$formatLong;


var $9befd53522a3dd72$var$formatRelativeLocale = {
    lastWeek: "'Praėjusį' eeee p",
    yesterday: "'Vakar' p",
    today: "'Šiandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: "eeee p",
    other: "P"
};
var $9befd53522a3dd72$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9befd53522a3dd72$var$formatRelativeLocale[token];
};
var $9befd53522a3dd72$export$2e2bcd8739ae039 = $9befd53522a3dd72$var$formatRelative;



var $16ef9d68107c6704$var$eraValues = {
    narrow: [
        "pr. Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pr. Kr.",
        "po Kr."
    ],
    wide: [
        "prieš Kristų",
        "po Kristaus"
    ]
};
var $16ef9d68107c6704$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I ketv.",
        "II ketv.",
        "III ketv.",
        "IV ketv."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
var $16ef9d68107c6704$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I k.",
        "II k.",
        "III k.",
        "IV k."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
var $16ef9d68107c6704$var$monthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "birž.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausis",
        "vasaris",
        "kovas",
        "balandis",
        "gegužė",
        "birželis",
        "liepa",
        "rugpjūtis",
        "rugsėjis",
        "spalis",
        "lapkritis",
        "gruodis"
    ]
};
var $16ef9d68107c6704$var$formattingMonthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "birž.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausio",
        "vasario",
        "kovo",
        "balandžio",
        "gegužės",
        "birželio",
        "liepos",
        "rugpjūčio",
        "rugsėjo",
        "spalio",
        "lapkričio",
        "gruodžio"
    ]
};
var $16ef9d68107c6704$var$dayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "Š"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "Št"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "št"
    ],
    wide: [
        "sekmadienis",
        "pirmadienis",
        "antradienis",
        "trečiadienis",
        "ketvirtadienis",
        "penktadienis",
        "šeštadienis"
    ]
};
var $16ef9d68107c6704$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "Š"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "Št"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "št"
    ],
    wide: [
        "sekmadienį",
        "pirmadienį",
        "antradienį",
        "trečiadienį",
        "ketvirtadienį",
        "penktadienį",
        "šeštadienį"
    ]
};
var $16ef9d68107c6704$var$dayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "priešpiet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "priešpiet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    }
};
var $16ef9d68107c6704$var$formattingDayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popietė",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "priešpiet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popietė",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "priešpiet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popietė",
        evening: "vakaras",
        night: "naktis"
    }
};
var $16ef9d68107c6704$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "-oji";
};
var $16ef9d68107c6704$var$localize = {
    ordinalNumber: $16ef9d68107c6704$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $16ef9d68107c6704$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $16ef9d68107c6704$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $16ef9d68107c6704$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $16ef9d68107c6704$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $16ef9d68107c6704$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $16ef9d68107c6704$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $16ef9d68107c6704$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $16ef9d68107c6704$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $16ef9d68107c6704$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $16ef9d68107c6704$export$2e2bcd8739ae039 = $16ef9d68107c6704$var$localize;




var $e1fd66f8f3727bfa$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var $e1fd66f8f3727bfa$var$parseOrdinalNumberPattern = /\d+/i;
var $e1fd66f8f3727bfa$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var $e1fd66f8f3727bfa$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var $e1fd66f8f3727bfa$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var $e1fd66f8f3727bfa$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var $e1fd66f8f3727bfa$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var $e1fd66f8f3727bfa$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var $e1fd66f8f3727bfa$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var $e1fd66f8f3727bfa$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var $e1fd66f8f3727bfa$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var $e1fd66f8f3727bfa$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var $e1fd66f8f3727bfa$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $e1fd66f8f3727bfa$var$matchOrdinalNumberPattern,
        parsePattern: $e1fd66f8f3727bfa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e1fd66f8f3727bfa$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1fd66f8f3727bfa$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e1fd66f8f3727bfa$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1fd66f8f3727bfa$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e1fd66f8f3727bfa$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1fd66f8f3727bfa$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e1fd66f8f3727bfa$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e1fd66f8f3727bfa$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e1fd66f8f3727bfa$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e1fd66f8f3727bfa$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e1fd66f8f3727bfa$export$2e2bcd8739ae039 = $e1fd66f8f3727bfa$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var $5ade964a3d27137e$var$locale = {
    code: "lt",
    formatDistance: (0, $d537a15b9c7e8cc6$export$2e2bcd8739ae039),
    formatLong: (0, $386f16d4945b544c$export$2e2bcd8739ae039),
    formatRelative: (0, $9befd53522a3dd72$export$2e2bcd8739ae039),
    localize: (0, $16ef9d68107c6704$export$2e2bcd8739ae039),
    match: (0, $e1fd66f8f3727bfa$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5ade964a3d27137e$export$2e2bcd8739ae039 = $5ade964a3d27137e$var$locale;


function $8bdc5c7252c4c396$var$buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace("{{time}}", schema.one[2]);
            else return schema.one[0].replace("{{time}}", schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", String(count));
            else return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", String(count));
        }
    };
}
var $8bdc5c7252c4c396$var$formatDistanceLocale = {
    lessThanXSeconds: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "mazāk par {{time}}",
            "sekundi",
            "sekundi"
        ],
        other: [
            "mazāk nekā {{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekundēm"
        ]
    }),
    xSeconds: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "sekunde",
            "sekundes"
        ],
        other: [
            "{{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekundēm"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusminūtes";
        else return "pusminūte";
    },
    lessThanXMinutes: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "mazāk par {{time}}",
            "minūti",
            "minūti"
        ],
        other: [
            "mazāk nekā {{count}} {{time}}",
            "minūte",
            "minūtes",
            "minūtes",
            "minūtēm"
        ]
    }),
    xMinutes: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "minūte",
            "minūtes"
        ],
        other: [
            "{{count}} {{time}}",
            "minūte",
            "minūtes",
            "minūtes",
            "minūtēm"
        ]
    }),
    aboutXHours: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "apmēram 1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "apmēram {{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stundām"
        ]
    }),
    xHours: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "{{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stundām"
        ]
    }),
    xDays: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "diena",
            "dienas"
        ],
        other: [
            "{{count}} {{time}}",
            "diena",
            "dienas",
            "dienas",
            "dienām"
        ]
    }),
    aboutXWeeks: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "apmēram 1 {{time}}",
            "nedēļa",
            "nedēļas"
        ],
        other: [
            "apmēram {{count}} {{time}}",
            "nedēļa",
            "nedēļu",
            "nedēļas",
            "nedēļām"
        ]
    }),
    xWeeks: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "nedēļa",
            "nedēļas"
        ],
        other: [
            "{{count}} {{time}}",
            // TODO
            "nedēļa",
            "nedēļu",
            "nedēļas",
            "nedēļām"
        ]
    }),
    aboutXMonths: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "apmēram 1 {{time}}",
            "mēnesis",
            "mēneša"
        ],
        other: [
            "apmēram {{count}} {{time}}",
            "mēnesis",
            "mēneši",
            "mēneša",
            "mēnešiem"
        ]
    }),
    xMonths: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "mēnesis",
            "mēneša"
        ],
        other: [
            "{{count}} {{time}}",
            "mēnesis",
            "mēneši",
            "mēneša",
            "mēnešiem"
        ]
    }),
    aboutXYears: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "apmēram 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "apmēram {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    xYears: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "{{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    overXYears: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "ilgāk par 1 {{time}}",
            "gadu",
            "gadu"
        ],
        other: [
            "vairāk nekā {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    almostXYears: $8bdc5c7252c4c396$var$buildLocalizeTokenFn({
        one: [
            "gandrīz 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "vairāk nekā {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    })
};
var $8bdc5c7252c4c396$var$formatDistance = function formatDistance(token, count, options) {
    var result = $8bdc5c7252c4c396$var$formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "pēc " + result;
        else return "pirms " + result;
    }
    return result;
};
var $8bdc5c7252c4c396$export$2e2bcd8739ae039 = $8bdc5c7252c4c396$var$formatDistance;



var $7ad128800c46e4a4$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: "dd.MM.y.",
    short: "dd.MM.y."
};
var $7ad128800c46e4a4$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $7ad128800c46e4a4$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $7ad128800c46e4a4$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $7ad128800c46e4a4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $7ad128800c46e4a4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $7ad128800c46e4a4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $7ad128800c46e4a4$export$2e2bcd8739ae039 = $7ad128800c46e4a4$var$formatLong;



var $413ca73312bf355f$var$weekdays = [
    "svētdienā",
    "pirmdienā",
    "otrdienā",
    "trešdienā",
    "ceturtdienā",
    "piektdienā",
    "sestdienā"
];
var $413ca73312bf355f$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $413ca73312bf355f$var$weekdays[date.getUTCDay()];
        return "'Pagājušā " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'Šodien plkst.' p",
    tomorrow: "'Rīt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $413ca73312bf355f$var$weekdays[date.getUTCDay()];
        return "'Nākamajā " + weekday + " plkst.' p";
    },
    other: "P"
};
var $413ca73312bf355f$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $413ca73312bf355f$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $413ca73312bf355f$export$2e2bcd8739ae039 = $413ca73312bf355f$var$formatRelative;



var $987e6e401124246b$var$eraValues = {
    narrow: [
        "p.m.ē",
        "m.ē"
    ],
    abbreviated: [
        "p. m. ē.",
        "m. ē."
    ],
    wide: [
        "pirms mūsu ēras",
        "mūsu ērā"
    ]
};
var $987e6e401124246b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmais ceturksnis",
        "otrais ceturksnis",
        "trešais ceturksnis",
        "ceturtais ceturksnis"
    ]
};
var $987e6e401124246b$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmajā ceturksnī",
        "otrajā ceturksnī",
        "trešajā ceturksnī",
        "ceturtajā ceturksnī"
    ]
};
var $987e6e401124246b$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "marts",
        "apr.",
        "maijs",
        "jūn.",
        "jūl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janvāris",
        "februāris",
        "marts",
        "aprīlis",
        "maijs",
        "jūnijs",
        "jūlijs",
        "augusts",
        "septembris",
        "oktobris",
        "novembris",
        "decembris"
    ]
};
var $987e6e401124246b$var$formattingMonthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "martā",
        "apr.",
        "maijs",
        "jūn.",
        "jūl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janvārī",
        "februārī",
        "martā",
        "aprīlī",
        "maijā",
        "jūnijā",
        "jūlijā",
        "augustā",
        "septembrī",
        "oktobrī",
        "novembrī",
        "decembrī"
    ]
};
var $987e6e401124246b$var$dayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "svētd.",
        "pirmd.",
        "otrd.",
        "trešd.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "svētdiena",
        "pirmdiena",
        "otrdiena",
        "trešdiena",
        "ceturtdiena",
        "piektdiena",
        "sestdiena"
    ]
};
var $987e6e401124246b$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "svētd.",
        "pirmd.",
        "otrd.",
        "trešd.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "svētdienā",
        "pirmdienā",
        "otrdienā",
        "trešdienā",
        "ceturtdienā",
        "piektdienā",
        "sestdienā"
    ]
};
var $987e6e401124246b$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "rīts",
        afternoon: "diena",
        evening: "vakars",
        night: "nakts"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "rīts",
        afternoon: "pēcpusd.",
        evening: "vakars",
        night: "nakts"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakts",
        noon: "pusdienlaiks",
        morning: "rīts",
        afternoon: "pēcpusdiena",
        evening: "vakars",
        night: "nakts"
    }
};
var $987e6e401124246b$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "rītā",
        afternoon: "dienā",
        evening: "vakarā",
        night: "naktī"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "rītā",
        afternoon: "pēcpusd.",
        evening: "vakarā",
        night: "naktī"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnaktī",
        noon: "pusdienlaikā",
        morning: "rītā",
        afternoon: "pēcpusdienā",
        evening: "vakarā",
        night: "naktī"
    }
};
var $987e6e401124246b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $987e6e401124246b$var$localize = {
    ordinalNumber: $987e6e401124246b$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $987e6e401124246b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $987e6e401124246b$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $987e6e401124246b$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $987e6e401124246b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $987e6e401124246b$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $987e6e401124246b$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $987e6e401124246b$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $987e6e401124246b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $987e6e401124246b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $987e6e401124246b$export$2e2bcd8739ae039 = $987e6e401124246b$var$localize;




var $337f412f0f7c6fae$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $337f412f0f7c6fae$var$parseOrdinalNumberPattern = /\d+/i;
var $337f412f0f7c6fae$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var $337f412f0f7c6fae$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var $337f412f0f7c6fae$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var $337f412f0f7c6fae$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var $337f412f0f7c6fae$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var $337f412f0f7c6fae$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $337f412f0f7c6fae$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var $337f412f0f7c6fae$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var $337f412f0f7c6fae$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var $337f412f0f7c6fae$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $337f412f0f7c6fae$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $337f412f0f7c6fae$var$matchOrdinalNumberPattern,
        parsePattern: $337f412f0f7c6fae$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $337f412f0f7c6fae$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $337f412f0f7c6fae$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $337f412f0f7c6fae$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $337f412f0f7c6fae$var$parseQuarterPatterns,
        defaultParseWidth: "wide",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $337f412f0f7c6fae$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $337f412f0f7c6fae$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $337f412f0f7c6fae$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $337f412f0f7c6fae$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $337f412f0f7c6fae$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $337f412f0f7c6fae$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $337f412f0f7c6fae$export$2e2bcd8739ae039 = $337f412f0f7c6fae$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var $2cf9697567fc0736$var$locale = {
    code: "lv",
    formatDistance: (0, $8bdc5c7252c4c396$export$2e2bcd8739ae039),
    formatLong: (0, $7ad128800c46e4a4$export$2e2bcd8739ae039),
    formatRelative: (0, $413ca73312bf355f$export$2e2bcd8739ae039),
    localize: (0, $987e6e401124246b$export$2e2bcd8739ae039),
    match: (0, $337f412f0f7c6fae$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2cf9697567fc0736$export$2e2bcd8739ae039 = $2cf9697567fc0736$var$locale;


var $93b0efcd15df434c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "помалку од секунда",
        other: "помалку од {{count}} секунди"
    },
    xSeconds: {
        one: "1 секунда",
        other: "{{count}} секунди"
    },
    halfAMinute: "половина минута",
    lessThanXMinutes: {
        one: "помалку од минута",
        other: "помалку од {{count}} минути"
    },
    xMinutes: {
        one: "1 минута",
        other: "{{count}} минути"
    },
    aboutXHours: {
        one: "околу 1 час",
        other: "околу {{count}} часа"
    },
    xHours: {
        one: "1 час",
        other: "{{count}} часа"
    },
    xDays: {
        one: "1 ден",
        other: "{{count}} дена"
    },
    aboutXWeeks: {
        one: "околу 1 недела",
        other: "околу {{count}} месеци"
    },
    xWeeks: {
        one: "1 недела",
        other: "{{count}} недели"
    },
    aboutXMonths: {
        one: "околу 1 месец",
        other: "околу {{count}} недели"
    },
    xMonths: {
        one: "1 месец",
        other: "{{count}} месеци"
    },
    aboutXYears: {
        one: "околу 1 година",
        other: "околу {{count}} години"
    },
    xYears: {
        one: "1 година",
        other: "{{count}} години"
    },
    overXYears: {
        one: "повеќе од 1 година",
        other: "повеќе од {{count}} години"
    },
    almostXYears: {
        one: "безмалку 1 година",
        other: "безмалку {{count}} години"
    }
};
var $93b0efcd15df434c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $93b0efcd15df434c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "за " + result;
        else return "пред " + result;
    }
    return result;
};
var $93b0efcd15df434c$export$2e2bcd8739ae039 = $93b0efcd15df434c$var$formatDistance;



var $4fd6e61e9b124e14$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
var $4fd6e61e9b124e14$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
var $4fd6e61e9b124e14$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
var $4fd6e61e9b124e14$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $4fd6e61e9b124e14$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $4fd6e61e9b124e14$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $4fd6e61e9b124e14$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $4fd6e61e9b124e14$export$2e2bcd8739ae039 = $4fd6e61e9b124e14$var$formatLong;



var $5de47cded9701c59$var$weekdays = [
    "недела",
    "понеделник",
    "вторник",
    "среда",
    "четврток",
    "петок",
    "сабота"
];
function $5de47cded9701c59$var$_lastWeek(day) {
    var weekday = $5de47cded9701c59$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'минатата " + weekday + " во' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'минатиот " + weekday + " во' p";
    }
}
function $5de47cded9701c59$var$thisWeek(day) {
    var weekday = $5de47cded9701c59$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'ова " + weekday + " вo' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'овој " + weekday + " вo' p";
    }
}
function $5de47cded9701c59$var$_nextWeek(day) {
    var weekday = $5de47cded9701c59$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'следната " + weekday + " вo' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'следниот " + weekday + " вo' p";
    }
}
var $5de47cded9701c59$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $5de47cded9701c59$var$thisWeek(day);
        else return $5de47cded9701c59$var$_lastWeek(day);
    },
    yesterday: "'вчера во' p",
    today: "'денес во' p",
    tomorrow: "'утре во' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $5de47cded9701c59$var$thisWeek(day);
        else return $5de47cded9701c59$var$_nextWeek(day);
    },
    other: "P"
};
var $5de47cded9701c59$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $5de47cded9701c59$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $5de47cded9701c59$export$2e2bcd8739ae039 = $5de47cded9701c59$var$formatRelative;



var $e05928af1d2ef7a1$var$eraValues = {
    narrow: [
        "пр.н.е.",
        "н.е."
    ],
    abbreviated: [
        "пред н. е.",
        "н. е."
    ],
    wide: [
        "пред нашата ера",
        "нашата ера"
    ]
};
var $e05928af1d2ef7a1$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-ви кв.",
        "2-ри кв.",
        "3-ти кв.",
        "4-ти кв."
    ],
    wide: [
        "1-ви квартал",
        "2-ри квартал",
        "3-ти квартал",
        "4-ти квартал"
    ]
};
var $e05928af1d2ef7a1$var$monthValues = {
    abbreviated: [
        "јан",
        "фев",
        "мар",
        "апр",
        "мај",
        "јун",
        "јул",
        "авг",
        "септ",
        "окт",
        "ноем",
        "дек"
    ],
    wide: [
        "јануари",
        "февруари",
        "март",
        "април",
        "мај",
        "јуни",
        "јули",
        "август",
        "септември",
        "октомври",
        "ноември",
        "декември"
    ]
};
var $e05928af1d2ef7a1$var$dayValues = {
    narrow: [
        "Н",
        "П",
        "В",
        "С",
        "Ч",
        "П",
        "С"
    ],
    short: [
        "не",
        "по",
        "вт",
        "ср",
        "че",
        "пе",
        "са"
    ],
    abbreviated: [
        "нед",
        "пон",
        "вто",
        "сре",
        "чет",
        "пет",
        "саб"
    ],
    wide: [
        "недела",
        "понеделник",
        "вторник",
        "среда",
        "четврток",
        "петок",
        "сабота"
    ]
};
var $e05928af1d2ef7a1$var$dayPeriodValues = {
    wide: {
        am: "претпладне",
        pm: "попладне",
        midnight: "полноќ",
        noon: "напладне",
        morning: "наутро",
        afternoon: "попладне",
        evening: "навечер",
        night: "ноќе"
    }
};
var $e05928af1d2ef7a1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-ви";
        case 2:
            return number + "-ри";
        case 7:
        case 8:
            return number + "-ми";
    }
    return number + "-ти";
};
var $e05928af1d2ef7a1$var$localize = {
    ordinalNumber: $e05928af1d2ef7a1$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e05928af1d2ef7a1$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e05928af1d2ef7a1$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e05928af1d2ef7a1$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e05928af1d2ef7a1$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $e05928af1d2ef7a1$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $e05928af1d2ef7a1$export$2e2bcd8739ae039 = $e05928af1d2ef7a1$var$localize;




var $751ee2ca74406043$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var $751ee2ca74406043$var$parseOrdinalNumberPattern = /\d+/i;
var $751ee2ca74406043$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var $751ee2ca74406043$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $751ee2ca74406043$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var $751ee2ca74406043$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $751ee2ca74406043$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var $751ee2ca74406043$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var $751ee2ca74406043$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var $751ee2ca74406043$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $751ee2ca74406043$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var $751ee2ca74406043$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var $751ee2ca74406043$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $751ee2ca74406043$var$matchOrdinalNumberPattern,
        parsePattern: $751ee2ca74406043$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $751ee2ca74406043$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $751ee2ca74406043$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $751ee2ca74406043$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $751ee2ca74406043$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $751ee2ca74406043$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $751ee2ca74406043$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $751ee2ca74406043$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $751ee2ca74406043$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $751ee2ca74406043$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $751ee2ca74406043$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $751ee2ca74406043$export$2e2bcd8739ae039 = $751ee2ca74406043$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var $495ddbe8bb3f8994$var$locale = {
    code: "mk",
    formatDistance: (0, $93b0efcd15df434c$export$2e2bcd8739ae039),
    formatLong: (0, $4fd6e61e9b124e14$export$2e2bcd8739ae039),
    formatRelative: (0, $5de47cded9701c59$export$2e2bcd8739ae039),
    localize: (0, $e05928af1d2ef7a1$export$2e2bcd8739ae039),
    match: (0, $751ee2ca74406043$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $495ddbe8bb3f8994$export$2e2bcd8739ae039 = $495ddbe8bb3f8994$var$locale;


var $95cf15f3893a4e93$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "секунд хүрэхгүй",
        other: "{{count}} секунд хүрэхгүй"
    },
    xSeconds: {
        one: "1 секунд",
        other: "{{count}} секунд"
    },
    halfAMinute: "хагас минут",
    lessThanXMinutes: {
        one: "минут хүрэхгүй",
        other: "{{count}} минут хүрэхгүй"
    },
    xMinutes: {
        one: "1 минут",
        other: "{{count}} минут"
    },
    aboutXHours: {
        one: "ойролцоогоор 1 цаг",
        other: "ойролцоогоор {{count}} цаг"
    },
    xHours: {
        one: "1 цаг",
        other: "{{count}} цаг"
    },
    xDays: {
        one: "1 өдөр",
        other: "{{count}} өдөр"
    },
    aboutXWeeks: {
        one: "ойролцоогоор 1 долоо хоног",
        other: "ойролцоогоор {{count}} долоо хоног"
    },
    xWeeks: {
        one: "1 долоо хоног",
        other: "{{count}} долоо хоног"
    },
    aboutXMonths: {
        one: "ойролцоогоор 1 сар",
        other: "ойролцоогоор {{count}} сар"
    },
    xMonths: {
        one: "1 сар",
        other: "{{count}} сар"
    },
    aboutXYears: {
        one: "ойролцоогоор 1 жил",
        other: "ойролцоогоор {{count}} жил"
    },
    xYears: {
        one: "1 жил",
        other: "{{count}} жил"
    },
    overXYears: {
        one: "1 жил гаран",
        other: "{{count}} жил гаран"
    },
    almostXYears: {
        one: "бараг 1 жил",
        other: "бараг {{count}} жил"
    }
};
var $95cf15f3893a4e93$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $95cf15f3893a4e93$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(" ");
        var lastword = words.pop();
        result = words.join(" ");
        switch(lastword){
            case "секунд":
                result += " секундийн";
                break;
            case "минут":
                result += " минутын";
                break;
            case "цаг":
                result += " цагийн";
                break;
            case "өдөр":
                result += " өдрийн";
                break;
            case "сар":
                result += " сарын";
                break;
            case "жил":
                result += " жилийн";
                break;
            case "хоног":
                result += " хоногийн";
                break;
            case "гаран":
                result += " гараны";
                break;
            case "хүрэхгүй":
                result += " хүрэхгүй хугацааны";
                break;
            default:
                result += lastword + "-н";
        }
        if (options.comparison && options.comparison > 0) return result + " дараа";
        else return result + " өмнө";
    }
    return result;
};
var $95cf15f3893a4e93$export$2e2bcd8739ae039 = $95cf15f3893a4e93$var$formatDistance;



var $02ac9cb9167d9e27$var$dateFormats = {
    full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
    long: "y 'оны' MMMM'ын' d",
    medium: "y 'оны' MMM'ын' d",
    short: "y.MM.dd"
};
var $02ac9cb9167d9e27$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $02ac9cb9167d9e27$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $02ac9cb9167d9e27$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $02ac9cb9167d9e27$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $02ac9cb9167d9e27$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $02ac9cb9167d9e27$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $02ac9cb9167d9e27$export$2e2bcd8739ae039 = $02ac9cb9167d9e27$var$formatLong;


var $48c11db0fbb21bbe$var$formatRelativeLocale = {
    lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
    yesterday: "'өчигдөр' p 'цагт'",
    today: "'өнөөдөр' p 'цагт'",
    tomorrow: "'маргааш' p 'цагт'",
    nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
    other: "P"
};
var $48c11db0fbb21bbe$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $48c11db0fbb21bbe$var$formatRelativeLocale[token];
};
var $48c11db0fbb21bbe$export$2e2bcd8739ae039 = $48c11db0fbb21bbe$var$formatRelative;



var $f44ba9e762aa026d$var$eraValues = {
    narrow: [
        "НТӨ",
        "НТ"
    ],
    abbreviated: [
        "НТӨ",
        "НТ"
    ],
    wide: [
        "нийтийн тооллын өмнөх",
        "нийтийн тооллын"
    ]
};
var $f44ba9e762aa026d$var$quarterValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV"
    ],
    abbreviated: [
        "I улирал",
        "II улирал",
        "III улирал",
        "IV улирал"
    ],
    wide: [
        "1-р улирал",
        "2-р улирал",
        "3-р улирал",
        "4-р улирал"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $f44ba9e762aa026d$var$monthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-р сар",
        "2-р сар",
        "3-р сар",
        "4-р сар",
        "5-р сар",
        "6-р сар",
        "7-р сар",
        "8-р сар",
        "9-р сар",
        "10-р сар",
        "11-р сар",
        "12-р сар"
    ],
    wide: [
        "Нэгдүгээр сар",
        "Хоёрдугаар сар",
        "Гуравдугаар сар",
        "Дөрөвдүгээр сар",
        "Тавдугаар сар",
        "Зургаадугаар сар",
        "Долоодугаар сар",
        "Наймдугаар сар",
        "Есдүгээр сар",
        "Аравдугаар сар",
        "Арваннэгдүгээр сар",
        "Арван хоёрдугаар сар"
    ]
};
var $f44ba9e762aa026d$var$formattingMonthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-р сар",
        "2-р сар",
        "3-р сар",
        "4-р сар",
        "5-р сар",
        "6-р сар",
        "7-р сар",
        "8-р сар",
        "9-р сар",
        "10-р сар",
        "11-р сар",
        "12-р сар"
    ],
    wide: [
        "нэгдүгээр сар",
        "хоёрдугаар сар",
        "гуравдугаар сар",
        "дөрөвдүгээр сар",
        "тавдугаар сар",
        "зургаадугаар сар",
        "долоодугаар сар",
        "наймдугаар сар",
        "есдүгээр сар",
        "аравдугаар сар",
        "арваннэгдүгээр сар",
        "арван хоёрдугаар сар"
    ]
};
var $f44ba9e762aa026d$var$dayValues = {
    narrow: [
        "Н",
        "Д",
        "М",
        "Л",
        "П",
        "Б",
        "Б"
    ],
    short: [
        "Ня",
        "Да",
        "Мя",
        "Лх",
        "Пү",
        "Ба",
        "Бя"
    ],
    abbreviated: [
        "Ням",
        "Дав",
        "Мяг",
        "Лха",
        "Пүр",
        "Баа",
        "Бям"
    ],
    wide: [
        "Ням",
        "Даваа",
        "Мягмар",
        "Лхагва",
        "Пүрэв",
        "Баасан",
        "Бямба"
    ]
};
var $f44ba9e762aa026d$var$formattingDayValues = {
    narrow: [
        "Н",
        "Д",
        "М",
        "Л",
        "П",
        "Б",
        "Б"
    ],
    short: [
        "Ня",
        "Да",
        "Мя",
        "Лх",
        "Пү",
        "Ба",
        "Бя"
    ],
    abbreviated: [
        "Ням",
        "Дав",
        "Мяг",
        "Лха",
        "Пүр",
        "Баа",
        "Бям"
    ],
    wide: [
        "ням",
        "даваа",
        "мягмар",
        "лхагва",
        "пүрэв",
        "баасан",
        "бямба"
    ]
};
var $f44ba9e762aa026d$var$dayPeriodValues = {
    narrow: {
        am: "ү.ө.",
        pm: "ү.х.",
        midnight: "шөнө дунд",
        noon: "үд дунд",
        morning: "өглөө",
        afternoon: "өдөр",
        evening: "орой",
        night: "шөнө"
    },
    abbreviated: {
        am: "ү.ө.",
        pm: "ү.х.",
        midnight: "шөнө дунд",
        noon: "үд дунд",
        morning: "өглөө",
        afternoon: "өдөр",
        evening: "орой",
        night: "шөнө"
    },
    wide: {
        am: "ү.ө.",
        pm: "ү.х.",
        midnight: "шөнө дунд",
        noon: "үд дунд",
        morning: "өглөө",
        afternoon: "өдөр",
        evening: "орой",
        night: "шөнө"
    }
};
var $f44ba9e762aa026d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $f44ba9e762aa026d$var$localize = {
    ordinalNumber: $f44ba9e762aa026d$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f44ba9e762aa026d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f44ba9e762aa026d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f44ba9e762aa026d$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $f44ba9e762aa026d$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f44ba9e762aa026d$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $f44ba9e762aa026d$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $f44ba9e762aa026d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $f44ba9e762aa026d$export$2e2bcd8739ae039 = $f44ba9e762aa026d$var$localize;




var $970c82b288b619bf$var$matchOrdinalNumberPattern = /\d+/i;
var $970c82b288b619bf$var$parseOrdinalNumberPattern = /\d+/i;
var $970c82b288b619bf$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var $970c82b288b619bf$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var $970c82b288b619bf$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var $970c82b288b619bf$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var $970c82b288b619bf$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var $970c82b288b619bf$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var $970c82b288b619bf$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var $970c82b288b619bf$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var $970c82b288b619bf$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var $970c82b288b619bf$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var $970c82b288b619bf$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $970c82b288b619bf$var$matchOrdinalNumberPattern,
        parsePattern: $970c82b288b619bf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $970c82b288b619bf$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $970c82b288b619bf$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $970c82b288b619bf$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $970c82b288b619bf$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $970c82b288b619bf$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $970c82b288b619bf$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $970c82b288b619bf$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $970c82b288b619bf$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $970c82b288b619bf$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $970c82b288b619bf$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $970c82b288b619bf$export$2e2bcd8739ae039 = $970c82b288b619bf$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var $bc2f4b050d639119$var$locale = {
    code: "mn",
    formatDistance: (0, $95cf15f3893a4e93$export$2e2bcd8739ae039),
    formatLong: (0, $02ac9cb9167d9e27$export$2e2bcd8739ae039),
    formatRelative: (0, $48c11db0fbb21bbe$export$2e2bcd8739ae039),
    localize: (0, $f44ba9e762aa026d$export$2e2bcd8739ae039),
    match: (0, $970c82b288b619bf$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $bc2f4b050d639119$export$2e2bcd8739ae039 = $bc2f4b050d639119$var$locale;


var $b1089caaf02726b4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 saat",
        other: "kurang dari {{count}} saat"
    },
    xSeconds: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    halfAMinute: "setengah minit",
    lessThanXMinutes: {
        one: "kurang dari 1 minit",
        other: "kurang dari {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
var $b1089caaf02726b4$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b1089caaf02726b4$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam masa " + result;
        else return result + " yang lalu";
    }
    return result;
};
var $b1089caaf02726b4$export$2e2bcd8739ae039 = $b1089caaf02726b4$var$formatDistance;



var $f17a0367c89882fb$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
var $f17a0367c89882fb$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
var $f17a0367c89882fb$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f17a0367c89882fb$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f17a0367c89882fb$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f17a0367c89882fb$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f17a0367c89882fb$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f17a0367c89882fb$export$2e2bcd8739ae039 = $f17a0367c89882fb$var$formatLong;


var $2fe81cff9f4b1b35$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: "P"
};
var $2fe81cff9f4b1b35$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2fe81cff9f4b1b35$var$formatRelativeLocale[token];
};
var $2fe81cff9f4b1b35$export$2e2bcd8739ae039 = $2fe81cff9f4b1b35$var$formatRelative;



// https://www.unicode.org/cldr/charts/32/summary/ms.html
var $ffd3a5e0c7836e42$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masihi",
        "Masihi"
    ]
};
var $ffd3a5e0c7836e42$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "S1",
        "S2",
        "S3",
        "S4"
    ],
    wide: [
        "Suku pertama",
        "Suku kedua",
        "Suku ketiga",
        "Suku keempat"
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $ffd3a5e0c7836e42$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mac",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ogo",
        "Sep",
        "Okt",
        "Nov",
        "Dis"
    ],
    wide: [
        "Januari",
        "Februari",
        "Mac",
        "April",
        "Mei",
        "Jun",
        "Julai",
        "Ogos",
        "September",
        "Oktober",
        "November",
        "Disember"
    ]
};
var $ffd3a5e0c7836e42$var$dayValues = {
    narrow: [
        "A",
        "I",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    wide: [
        "Ahad",
        "Isnin",
        "Selasa",
        "Rabu",
        "Khamis",
        "Jumaat",
        "Sabtu"
    ]
};
var $ffd3a5e0c7836e42$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tgh malam",
        noon: "tgh hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
var $ffd3a5e0c7836e42$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
var $ffd3a5e0c7836e42$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + Number(dirtyNumber);
};
var $ffd3a5e0c7836e42$var$localize = {
    ordinalNumber: $ffd3a5e0c7836e42$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $ffd3a5e0c7836e42$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $ffd3a5e0c7836e42$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $ffd3a5e0c7836e42$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $ffd3a5e0c7836e42$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $ffd3a5e0c7836e42$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $ffd3a5e0c7836e42$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $ffd3a5e0c7836e42$export$2e2bcd8739ae039 = $ffd3a5e0c7836e42$var$localize;




var $2c23631f2a7c50b4$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $2c23631f2a7c50b4$var$parseOrdinalNumberPattern = /petama|\d+/i;
var $2c23631f2a7c50b4$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var $2c23631f2a7c50b4$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var $2c23631f2a7c50b4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var $2c23631f2a7c50b4$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var $2c23631f2a7c50b4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var $2c23631f2a7c50b4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $2c23631f2a7c50b4$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var $2c23631f2a7c50b4$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $2c23631f2a7c50b4$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var $2c23631f2a7c50b4$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var $2c23631f2a7c50b4$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $2c23631f2a7c50b4$var$matchOrdinalNumberPattern,
        parsePattern: $2c23631f2a7c50b4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2c23631f2a7c50b4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c23631f2a7c50b4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2c23631f2a7c50b4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c23631f2a7c50b4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2c23631f2a7c50b4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c23631f2a7c50b4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2c23631f2a7c50b4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c23631f2a7c50b4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2c23631f2a7c50b4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2c23631f2a7c50b4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $2c23631f2a7c50b4$export$2e2bcd8739ae039 = $2c23631f2a7c50b4$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var $36aa0286c4020e90$var$locale = {
    code: "ms",
    formatDistance: (0, $b1089caaf02726b4$export$2e2bcd8739ae039),
    formatLong: (0, $f17a0367c89882fb$export$2e2bcd8739ae039),
    formatRelative: (0, $2fe81cff9f4b1b35$export$2e2bcd8739ae039),
    localize: (0, $ffd3a5e0c7836e42$export$2e2bcd8739ae039),
    match: (0, $2c23631f2a7c50b4$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $36aa0286c4020e90$export$2e2bcd8739ae039 = $36aa0286c4020e90$var$locale;


var $8226b1fa4abe052e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "inqas minn sekonda",
        other: "inqas minn {{count}} sekondi"
    },
    xSeconds: {
        one: "sekonda",
        other: "{{count}} sekondi"
    },
    halfAMinute: "nofs minuta",
    lessThanXMinutes: {
        one: "inqas minn minuta",
        other: "inqas minn {{count}} minuti"
    },
    xMinutes: {
        one: "minuta",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "madwar siegħa",
        other: "madwar {{count}} siegħat"
    },
    xHours: {
        one: "siegħa",
        other: "{{count}} siegħat"
    },
    xDays: {
        one: "ġurnata",
        other: "{{count}} ġranet"
    },
    aboutXWeeks: {
        one: "madwar ġimgħa",
        other: "madwar {{count}} ġimgħat"
    },
    xWeeks: {
        one: "ġimgħa",
        other: "{{count}} ġimgħat"
    },
    aboutXMonths: {
        one: "madwar xahar",
        other: "madwar {{count}} xhur"
    },
    xMonths: {
        one: "xahar",
        other: "{{count}} xhur"
    },
    aboutXYears: {
        one: "madwar sena",
        two: "madwar sentejn",
        other: "madwar {{count}} snin"
    },
    xYears: {
        one: "sena",
        two: "sentejn",
        other: "{{count}} snin"
    },
    overXYears: {
        one: "aktar minn sena",
        two: "aktar minn sentejn",
        other: "aktar minn {{count}} snin"
    },
    almostXYears: {
        one: "kważi sena",
        two: "kważi sentejn",
        other: "kważi {{count}} snin"
    }
};
var $8226b1fa4abe052e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8226b1fa4abe052e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + " ilu";
    }
    return result;
};
var $8226b1fa4abe052e$export$2e2bcd8739ae039 = $8226b1fa4abe052e$var$formatDistance;



var $fd6c5ab442275943$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $fd6c5ab442275943$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $fd6c5ab442275943$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $fd6c5ab442275943$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $fd6c5ab442275943$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $fd6c5ab442275943$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $fd6c5ab442275943$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $fd6c5ab442275943$export$2e2bcd8739ae039 = $fd6c5ab442275943$var$formatLong;


var $a01fe13f9ad26a00$var$formatRelativeLocale = {
    lastWeek: "eeee 'li għadda' 'fil-'p",
    yesterday: "'Il-bieraħ fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'Għada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: "P"
};
var $a01fe13f9ad26a00$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a01fe13f9ad26a00$var$formatRelativeLocale[token];
};
var $a01fe13f9ad26a00$export$2e2bcd8739ae039 = $a01fe13f9ad26a00$var$formatRelative;



var $7ab893b6a0548d15$var$eraValues = {
    narrow: [
        "Q",
        "W"
    ],
    abbreviated: [
        "QK",
        "WK"
    ],
    wide: [
        "qabel Kristu",
        "wara Kristu"
    ]
};
var $7ab893b6a0548d15$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kwart",
        "2. kwart",
        "3. kwart",
        "4. kwart"
    ]
};
var $7ab893b6a0548d15$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "Ġ",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Fra",
        "Mar",
        "Apr",
        "Mej",
        "Ġun",
        "Lul",
        "Aww",
        "Set",
        "Ott",
        "Nov",
        "Diċ"
    ],
    wide: [
        "Jannar",
        "Frar",
        "Marzu",
        "April",
        "Mejju",
        "Ġunju",
        "Lulju",
        "Awwissu",
        "Settembru",
        "Ottubru",
        "Novembru",
        "Diċembru"
    ]
};
var $7ab893b6a0548d15$var$dayValues = {
    narrow: [
        "Ħ",
        "T",
        "T",
        "E",
        "Ħ",
        "Ġ",
        "S"
    ],
    short: [
        "Ħa",
        "Tn",
        "Tl",
        "Er",
        "Ħa",
        "Ġi",
        "Si"
    ],
    abbreviated: [
        "Ħad",
        "Tne",
        "Tli",
        "Erb",
        "Ħam",
        "Ġim",
        "Sib"
    ],
    wide: [
        "Il-Ħadd",
        "It-Tnejn",
        "It-Tlieta",
        "L-Erbgħa",
        "Il-Ħamis",
        "Il-Ġimgħa",
        "Is-Sibt"
    ]
};
var $7ab893b6a0548d15$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "għodwa",
        afternoon: "wara nofsinhar",
        evening: "filgħaxija",
        night: "lejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "għodwa",
        afternoon: "wara nofsinhar",
        evening: "filgħaxija",
        night: "lejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "għodwa",
        afternoon: "wara nofsinhar",
        evening: "filgħaxija",
        night: "lejl"
    }
};
var $7ab893b6a0548d15$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filgħodu",
        afternoon: "wara nofsinhar",
        evening: "filgħaxija",
        night: "billejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filgħodu",
        afternoon: "wara nofsinhar",
        evening: "filgħaxija",
        night: "billejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filgħodu",
        afternoon: "wara nofsinhar",
        evening: "filgħaxija",
        night: "billejl"
    }
};
var $7ab893b6a0548d15$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $7ab893b6a0548d15$var$localize = {
    ordinalNumber: $7ab893b6a0548d15$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7ab893b6a0548d15$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7ab893b6a0548d15$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7ab893b6a0548d15$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7ab893b6a0548d15$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7ab893b6a0548d15$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7ab893b6a0548d15$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7ab893b6a0548d15$export$2e2bcd8739ae039 = $7ab893b6a0548d15$var$localize;




var $f94aa830ba95e409$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $f94aa830ba95e409$var$parseOrdinalNumberPattern = /\d+/i;
var $f94aa830ba95e409$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var $f94aa830ba95e409$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var $f94aa830ba95e409$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var $f94aa830ba95e409$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f94aa830ba95e409$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var $f94aa830ba95e409$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f94aa830ba95e409$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var $f94aa830ba95e409$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var $f94aa830ba95e409$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var $f94aa830ba95e409$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var $f94aa830ba95e409$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $f94aa830ba95e409$var$matchOrdinalNumberPattern,
        parsePattern: $f94aa830ba95e409$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f94aa830ba95e409$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f94aa830ba95e409$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f94aa830ba95e409$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f94aa830ba95e409$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f94aa830ba95e409$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f94aa830ba95e409$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f94aa830ba95e409$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f94aa830ba95e409$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f94aa830ba95e409$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f94aa830ba95e409$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $f94aa830ba95e409$export$2e2bcd8739ae039 = $f94aa830ba95e409$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var $ec5c7302abffe2df$var$locale = {
    code: "mt",
    formatDistance: (0, $8226b1fa4abe052e$export$2e2bcd8739ae039),
    formatLong: (0, $fd6c5ab442275943$export$2e2bcd8739ae039),
    formatRelative: (0, $a01fe13f9ad26a00$export$2e2bcd8739ae039),
    localize: (0, $7ab893b6a0548d15$export$2e2bcd8739ae039),
    match: (0, $f94aa830ba95e409$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $ec5c7302abffe2df$export$2e2bcd8739ae039 = $ec5c7302abffe2df$var$locale;


var $fad0f04cbca312ee$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $fad0f04cbca312ee$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fad0f04cbca312ee$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
var $fad0f04cbca312ee$export$2e2bcd8739ae039 = $fad0f04cbca312ee$var$formatDistance;



var $c18f9e26b841a0bf$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
var $c18f9e26b841a0bf$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $c18f9e26b841a0bf$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $c18f9e26b841a0bf$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $c18f9e26b841a0bf$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $c18f9e26b841a0bf$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $c18f9e26b841a0bf$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $c18f9e26b841a0bf$export$2e2bcd8739ae039 = $c18f9e26b841a0bf$var$formatLong;


var $2dedb75bfa2fed20$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $2dedb75bfa2fed20$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2dedb75bfa2fed20$var$formatRelativeLocale[token];
};
var $2dedb75bfa2fed20$export$2e2bcd8739ae039 = $2dedb75bfa2fed20$var$formatRelative;



var $877bf780e90a57a9$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
var $877bf780e90a57a9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $877bf780e90a57a9$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
var $877bf780e90a57a9$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
var $877bf780e90a57a9$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $877bf780e90a57a9$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $877bf780e90a57a9$var$localize = {
    ordinalNumber: $877bf780e90a57a9$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $877bf780e90a57a9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $877bf780e90a57a9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $877bf780e90a57a9$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $877bf780e90a57a9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $877bf780e90a57a9$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $877bf780e90a57a9$export$2e2bcd8739ae039 = $877bf780e90a57a9$var$localize;




var $bf27a25146e5b424$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $bf27a25146e5b424$var$parseOrdinalNumberPattern = /\d+/i;
var $bf27a25146e5b424$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $bf27a25146e5b424$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $bf27a25146e5b424$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $bf27a25146e5b424$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bf27a25146e5b424$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $bf27a25146e5b424$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $bf27a25146e5b424$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $bf27a25146e5b424$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $bf27a25146e5b424$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $bf27a25146e5b424$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $bf27a25146e5b424$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $bf27a25146e5b424$var$matchOrdinalNumberPattern,
        parsePattern: $bf27a25146e5b424$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bf27a25146e5b424$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf27a25146e5b424$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bf27a25146e5b424$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf27a25146e5b424$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bf27a25146e5b424$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf27a25146e5b424$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bf27a25146e5b424$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf27a25146e5b424$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bf27a25146e5b424$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bf27a25146e5b424$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bf27a25146e5b424$export$2e2bcd8739ae039 = $bf27a25146e5b424$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $bef79d848faf588a$var$locale = {
    code: "nb",
    formatDistance: (0, $fad0f04cbca312ee$export$2e2bcd8739ae039),
    formatLong: (0, $c18f9e26b841a0bf$export$2e2bcd8739ae039),
    formatRelative: (0, $2dedb75bfa2fed20$export$2e2bcd8739ae039),
    localize: (0, $877bf780e90a57a9$export$2e2bcd8739ae039),
    match: (0, $bf27a25146e5b424$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $bef79d848faf588a$export$2e2bcd8739ae039 = $bef79d848faf588a$var$locale;


var $ba0cb889c2d59b11$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
var $ba0cb889c2d59b11$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ba0cb889c2d59b11$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
var $ba0cb889c2d59b11$export$2e2bcd8739ae039 = $ba0cb889c2d59b11$var$formatDistance;



var $ea25a0187b23042b$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
var $ea25a0187b23042b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $ea25a0187b23042b$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $ea25a0187b23042b$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ea25a0187b23042b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ea25a0187b23042b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ea25a0187b23042b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $ea25a0187b23042b$export$2e2bcd8739ae039 = $ea25a0187b23042b$var$formatLong;


var $a4621e5b1e305d4a$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $a4621e5b1e305d4a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a4621e5b1e305d4a$var$formatRelativeLocale[token];
};
var $a4621e5b1e305d4a$export$2e2bcd8739ae039 = $a4621e5b1e305d4a$var$formatRelative;



var $43594c4bafc71d6d$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
var $43594c4bafc71d6d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
var $43594c4bafc71d6d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $43594c4bafc71d6d$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
var $43594c4bafc71d6d$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $43594c4bafc71d6d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "e";
};
var $43594c4bafc71d6d$var$localize = {
    ordinalNumber: $43594c4bafc71d6d$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $43594c4bafc71d6d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $43594c4bafc71d6d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $43594c4bafc71d6d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $43594c4bafc71d6d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $43594c4bafc71d6d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $43594c4bafc71d6d$export$2e2bcd8739ae039 = $43594c4bafc71d6d$var$localize;




var $e640bcf5604accbf$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $e640bcf5604accbf$var$parseOrdinalNumberPattern = /\d+/i;
var $e640bcf5604accbf$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $e640bcf5604accbf$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $e640bcf5604accbf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $e640bcf5604accbf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e640bcf5604accbf$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $e640bcf5604accbf$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $e640bcf5604accbf$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $e640bcf5604accbf$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $e640bcf5604accbf$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $e640bcf5604accbf$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $e640bcf5604accbf$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $e640bcf5604accbf$var$matchOrdinalNumberPattern,
        parsePattern: $e640bcf5604accbf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e640bcf5604accbf$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e640bcf5604accbf$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e640bcf5604accbf$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e640bcf5604accbf$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e640bcf5604accbf$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e640bcf5604accbf$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e640bcf5604accbf$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e640bcf5604accbf$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e640bcf5604accbf$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e640bcf5604accbf$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e640bcf5604accbf$export$2e2bcd8739ae039 = $e640bcf5604accbf$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $0db204b582725790$var$locale = {
    code: "nl",
    formatDistance: (0, $ba0cb889c2d59b11$export$2e2bcd8739ae039),
    formatLong: (0, $ea25a0187b23042b$export$2e2bcd8739ae039),
    formatRelative: (0, $a4621e5b1e305d4a$export$2e2bcd8739ae039),
    localize: (0, $43594c4bafc71d6d$export$2e2bcd8739ae039),
    match: (0, $e640bcf5604accbf$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0db204b582725790$export$2e2bcd8739ae039 = $0db204b582725790$var$locale;


var $af002af5851ec3e0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
var $af002af5851ec3e0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $af002af5851ec3e0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
var $af002af5851ec3e0$export$2e2bcd8739ae039 = $af002af5851ec3e0$var$formatDistance;



var $0b107296d81859a8$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
var $0b107296d81859a8$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $0b107296d81859a8$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $0b107296d81859a8$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $0b107296d81859a8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $0b107296d81859a8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $0b107296d81859a8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $0b107296d81859a8$export$2e2bcd8739ae039 = $0b107296d81859a8$var$formatLong;


var $207f7382c6c4a4e1$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $207f7382c6c4a4e1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $207f7382c6c4a4e1$var$formatRelativeLocale[token];
};
var $207f7382c6c4a4e1$export$2e2bcd8739ae039 = $207f7382c6c4a4e1$var$formatRelative;



var $11cb6704eafb6411$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
var $11cb6704eafb6411$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
var $11cb6704eafb6411$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $11cb6704eafb6411$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
var $11cb6704eafb6411$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $11cb6704eafb6411$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "e";
};
var $11cb6704eafb6411$var$localize = {
    ordinalNumber: $11cb6704eafb6411$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $11cb6704eafb6411$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $11cb6704eafb6411$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $11cb6704eafb6411$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $11cb6704eafb6411$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $11cb6704eafb6411$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $11cb6704eafb6411$export$2e2bcd8739ae039 = $11cb6704eafb6411$var$localize;




var $407e2025b00bc51b$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $407e2025b00bc51b$var$parseOrdinalNumberPattern = /\d+/i;
var $407e2025b00bc51b$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $407e2025b00bc51b$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $407e2025b00bc51b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $407e2025b00bc51b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $407e2025b00bc51b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $407e2025b00bc51b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $407e2025b00bc51b$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $407e2025b00bc51b$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $407e2025b00bc51b$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $407e2025b00bc51b$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $407e2025b00bc51b$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $407e2025b00bc51b$var$matchOrdinalNumberPattern,
        parsePattern: $407e2025b00bc51b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $407e2025b00bc51b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $407e2025b00bc51b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $407e2025b00bc51b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $407e2025b00bc51b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $407e2025b00bc51b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $407e2025b00bc51b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $407e2025b00bc51b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $407e2025b00bc51b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $407e2025b00bc51b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $407e2025b00bc51b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $407e2025b00bc51b$export$2e2bcd8739ae039 = $407e2025b00bc51b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $396c7e5bfb78e458$var$locale = {
    code: "nl-BE",
    formatDistance: (0, $af002af5851ec3e0$export$2e2bcd8739ae039),
    formatLong: (0, $0b107296d81859a8$export$2e2bcd8739ae039),
    formatRelative: (0, $207f7382c6c4a4e1$export$2e2bcd8739ae039),
    localize: (0, $11cb6704eafb6411$export$2e2bcd8739ae039),
    match: (0, $407e2025b00bc51b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $396c7e5bfb78e458$export$2e2bcd8739ae039 = $396c7e5bfb78e458$var$locale;


var $a545e82f66fe4c74$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn eitt sekund",
        other: "mindre enn {{count}} sekund"
    },
    xSeconds: {
        one: "eitt sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "eit halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn eitt minutt",
        other: "mindre enn {{count}} minutt"
    },
    xMinutes: {
        one: "eitt minutt",
        other: "{{count}} minutt"
    },
    aboutXHours: {
        one: "omtrent ein time",
        other: "omtrent {{count}} timar"
    },
    xHours: {
        one: "ein time",
        other: "{{count}} timar"
    },
    xDays: {
        one: "ein dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "omtrent ei veke",
        other: "omtrent {{count}} veker"
    },
    xWeeks: {
        one: "ei veke",
        other: "{{count}} veker"
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $a545e82f66fe4c74$var$wordMapping = [
    "null",
    "ein",
    "to",
    "tre",
    "fire",
    "fem",
    "seks",
    "sju",
    "\xe5tte",
    "ni",
    "ti",
    "elleve",
    "tolv"
];
var $a545e82f66fe4c74$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a545e82f66fe4c74$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $a545e82f66fe4c74$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sidan";
    }
    return result;
};
var $a545e82f66fe4c74$export$2e2bcd8739ae039 = $a545e82f66fe4c74$var$formatDistance;



var $a7b31dbdbab26cc1$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
var $a7b31dbdbab26cc1$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $a7b31dbdbab26cc1$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $a7b31dbdbab26cc1$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a7b31dbdbab26cc1$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a7b31dbdbab26cc1$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $a7b31dbdbab26cc1$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a7b31dbdbab26cc1$export$2e2bcd8739ae039 = $a7b31dbdbab26cc1$var$formatLong;


var $380b5957e0ff29fb$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $380b5957e0ff29fb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $380b5957e0ff29fb$var$formatRelativeLocale[token];
};
var $380b5957e0ff29fb$export$2e2bcd8739ae039 = $380b5957e0ff29fb$var$formatRelative;



var $7c4f891c72564780$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
var $7c4f891c72564780$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $7c4f891c72564780$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
var $7c4f891c72564780$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "su",
        "m\xe5",
        "ty",
        "on",
        "to",
        "fr",
        "lau"
    ],
    abbreviated: [
        "sun",
        "m\xe5n",
        "tys",
        "ons",
        "tor",
        "fre",
        "laur"
    ],
    wide: [
        "sundag",
        "m\xe5ndag",
        "tysdag",
        "onsdag",
        "torsdag",
        "fredag",
        "laurdag"
    ]
};
var $7c4f891c72564780$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var $7c4f891c72564780$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $7c4f891c72564780$var$localize = {
    ordinalNumber: $7c4f891c72564780$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7c4f891c72564780$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7c4f891c72564780$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7c4f891c72564780$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7c4f891c72564780$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7c4f891c72564780$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $7c4f891c72564780$export$2e2bcd8739ae039 = $7c4f891c72564780$var$localize;




var $0c48afac47decf42$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $0c48afac47decf42$var$parseOrdinalNumberPattern = /\d+/i;
var $0c48afac47decf42$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $0c48afac47decf42$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $0c48afac47decf42$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $0c48afac47decf42$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0c48afac47decf42$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $0c48afac47decf42$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $0c48afac47decf42$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var $0c48afac47decf42$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $0c48afac47decf42$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var $0c48afac47decf42$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $0c48afac47decf42$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $0c48afac47decf42$var$matchOrdinalNumberPattern,
        parsePattern: $0c48afac47decf42$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0c48afac47decf42$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c48afac47decf42$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0c48afac47decf42$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c48afac47decf42$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0c48afac47decf42$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c48afac47decf42$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0c48afac47decf42$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0c48afac47decf42$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $0c48afac47decf42$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0c48afac47decf42$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $0c48afac47decf42$export$2e2bcd8739ae039 = $0c48afac47decf42$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var $0317191b79441e45$var$locale = {
    code: "nn",
    formatDistance: (0, $a545e82f66fe4c74$export$2e2bcd8739ae039),
    formatLong: (0, $a7b31dbdbab26cc1$export$2e2bcd8739ae039),
    formatRelative: (0, $380b5957e0ff29fb$export$2e2bcd8739ae039),
    localize: (0, $7c4f891c72564780$export$2e2bcd8739ae039),
    match: (0, $0c48afac47decf42$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0317191b79441e45$export$2e2bcd8739ae039 = $0317191b79441e45$var$locale;


var $eb54a1f906cba289$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d’una segonda",
        other: "mens de {{count}} segondas"
    },
    xSeconds: {
        one: "1 segonda",
        other: "{{count}} segondas"
    },
    halfAMinute: "30 segondas",
    lessThanXMinutes: {
        one: "mens d’una minuta",
        other: "mens de {{count}} minutas"
    },
    xMinutes: {
        one: "1 minuta",
        other: "{{count}} minutas"
    },
    aboutXHours: {
        one: "environ 1 ora",
        other: "environ {{count}} oras"
    },
    xHours: {
        one: "1 ora",
        other: "{{count}} oras"
    },
    xDays: {
        one: "1 jorn",
        other: "{{count}} jorns"
    },
    aboutXWeeks: {
        one: "environ 1 setmana",
        other: "environ {{count}} setmanas"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanas"
    },
    aboutXMonths: {
        one: "environ 1 mes",
        other: "environ {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "mai d’un an",
        other: "mai de {{count}} ans"
    },
    almostXYears: {
        one: "gaireben un an",
        other: "gaireben {{count}} ans"
    }
};
var $eb54a1f906cba289$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $eb54a1f906cba289$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d’aqu\xed " + result;
        else return "fa " + result;
    }
    return result;
};
var $eb54a1f906cba289$export$2e2bcd8739ae039 = $eb54a1f906cba289$var$formatDistance;



var $f711063533c4a074$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $f711063533c4a074$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $f711063533c4a074$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f711063533c4a074$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f711063533c4a074$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f711063533c4a074$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $f711063533c4a074$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f711063533c4a074$export$2e2bcd8739ae039 = $f711063533c4a074$var$formatLong;


var $71af657e96e70ee9$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: "P"
};
var $71af657e96e70ee9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $71af657e96e70ee9$var$formatRelativeLocale[token];
};
var $71af657e96e70ee9$export$2e2bcd8739ae039 = $71af657e96e70ee9$var$formatRelative;



var $508a085dcbc27590$var$eraValues = {
    narrow: [
        "ab. J.C.",
        "apr. J.C."
    ],
    abbreviated: [
        "ab. J.C.",
        "apr. J.C."
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var $508a085dcbc27590$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1\xe8r trim.",
        "2nd trim.",
        "3en trim.",
        "4en trim."
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var $508a085dcbc27590$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MA",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DC"
    ],
    abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "mai",
        "junh",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "dec."
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        "abril",
        "mai",
        "junh",
        "julhet",
        "agost",
        "setembre",
        "oct\xf2bre",
        "novembre",
        "decembre"
    ]
};
var $508a085dcbc27590$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "dimenge",
        "diluns",
        "dimars",
        "dim\xe8cres",
        "dij\xf2us",
        "divendres",
        "dissabte"
    ]
};
var $508a085dcbc27590$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var $508a085dcbc27590$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l’apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l’apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l’apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    }
};
var $508a085dcbc27590$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = "nd";
            break;
        default:
            ordinal = "en";
    }
    // feminine for year, week, hour, minute, second
    if (unit === "year" || unit === "week" || unit === "hour" || unit === "minute" || unit === "second") ordinal += "a";
    return number + ordinal;
};
var $508a085dcbc27590$var$localize = {
    ordinalNumber: $508a085dcbc27590$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $508a085dcbc27590$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $508a085dcbc27590$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $508a085dcbc27590$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $508a085dcbc27590$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $508a085dcbc27590$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $508a085dcbc27590$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $508a085dcbc27590$export$2e2bcd8739ae039 = $508a085dcbc27590$var$localize;




var $bb789782513e7ebd$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var $bb789782513e7ebd$var$parseOrdinalNumberPattern = /\d+/i;
var $bb789782513e7ebd$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var $bb789782513e7ebd$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var $bb789782513e7ebd$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var $bb789782513e7ebd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bb789782513e7ebd$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var $bb789782513e7ebd$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $bb789782513e7ebd$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var $bb789782513e7ebd$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var $bb789782513e7ebd$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var $bb789782513e7ebd$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var $bb789782513e7ebd$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $bb789782513e7ebd$var$matchOrdinalNumberPattern,
        parsePattern: $bb789782513e7ebd$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb789782513e7ebd$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb789782513e7ebd$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb789782513e7ebd$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb789782513e7ebd$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb789782513e7ebd$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb789782513e7ebd$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb789782513e7ebd$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bb789782513e7ebd$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bb789782513e7ebd$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bb789782513e7ebd$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bb789782513e7ebd$export$2e2bcd8739ae039 = $bb789782513e7ebd$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var $a967f19e9b927cc9$var$locale = {
    code: "oc",
    formatDistance: (0, $eb54a1f906cba289$export$2e2bcd8739ae039),
    formatLong: (0, $f711063533c4a074$export$2e2bcd8739ae039),
    formatRelative: (0, $71af657e96e70ee9$export$2e2bcd8739ae039),
    localize: (0, $508a085dcbc27590$export$2e2bcd8739ae039),
    match: (0, $bb789782513e7ebd$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a967f19e9b927cc9$export$2e2bcd8739ae039 = $a967f19e9b927cc9$var$locale;


var $0110a74b9ce8630a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej niż sekunda",
            past: "mniej niż sekundę",
            future: "mniej niż sekundę"
        },
        twoFour: "mniej niż {{count}} sekundy",
        other: "mniej niż {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "sekundę",
            future: "sekundę"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
    },
    halfAMinute: {
        one: "p\xf3ł minuty",
        twoFour: "p\xf3ł minuty",
        other: "p\xf3ł minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej niż minuta",
            past: "mniej niż minutę",
            future: "mniej niż minutę"
        },
        twoFour: "mniej niż {{count}} minuty",
        other: "mniej niż {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "minutę",
            future: "minutę"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: {
            regular: "około godziny",
            past: "około godziny",
            future: "około godzinę"
        },
        twoFour: "około {{count}} godziny",
        other: "około {{count}} godzin"
    },
    xHours: {
        one: {
            regular: "godzina",
            past: "godzinę",
            future: "godzinę"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
    },
    xDays: {
        one: {
            regular: "dzień",
            past: "dzień",
            future: "1 dzień"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
    },
    aboutXWeeks: {
        one: "około tygodnia",
        twoFour: "około {{count}} tygodni",
        other: "około {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzień",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
    },
    aboutXMonths: {
        one: "około miesiąc",
        twoFour: "około {{count}} miesiące",
        other: "około {{count}} miesięcy"
    },
    xMonths: {
        one: "miesiąc",
        twoFour: "{{count}} miesiące",
        other: "{{count}} miesięcy"
    },
    aboutXYears: {
        one: "około rok",
        twoFour: "około {{count}} lata",
        other: "około {{count}} lat"
    },
    xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
    },
    overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
    },
    almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
    }
};
function $0110a74b9ce8630a$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $0110a74b9ce8630a$var$declension(scheme, count, time) {
    var group = $0110a74b9ce8630a$var$declensionGroup(scheme, count);
    var finalText = typeof group === "string" ? group : group[time];
    return finalText.replace("{{count}}", String(count));
}
var $0110a74b9ce8630a$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $0110a74b9ce8630a$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $0110a74b9ce8630a$var$declension(scheme, count, "regular");
    if (options.comparison && options.comparison > 0) return "za " + $0110a74b9ce8630a$var$declension(scheme, count, "future");
    else return $0110a74b9ce8630a$var$declension(scheme, count, "past") + " temu";
};
var $0110a74b9ce8630a$export$2e2bcd8739ae039 = $0110a74b9ce8630a$var$formatDistance;



var $090df1c5da0d81bc$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
var $090df1c5da0d81bc$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $090df1c5da0d81bc$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $090df1c5da0d81bc$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $090df1c5da0d81bc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $090df1c5da0d81bc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $090df1c5da0d81bc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $090df1c5da0d81bc$export$2e2bcd8739ae039 = $090df1c5da0d81bc$var$formatLong;



var $88cc805d33eccea8$var$adjectivesLastWeek = {
    masculine: "ostatni",
    feminine: "ostatnia"
};
var $88cc805d33eccea8$var$adjectivesThisWeek = {
    masculine: "ten",
    feminine: "ta"
};
var $88cc805d33eccea8$var$adjectivesNextWeek = {
    masculine: "następny",
    feminine: "następna"
};
var $88cc805d33eccea8$var$dayGrammaticalGender = {
    0: "feminine",
    1: "masculine",
    2: "masculine",
    3: "feminine",
    4: "masculine",
    5: "masculine",
    6: "feminine"
};
function $88cc805d33eccea8$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) adjectives = $88cc805d33eccea8$var$adjectivesThisWeek;
    else if (token === "lastWeek") adjectives = $88cc805d33eccea8$var$adjectivesLastWeek;
    else if (token === "nextWeek") adjectives = $88cc805d33eccea8$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $88cc805d33eccea8$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $88cc805d33eccea8$var$formatRelativeLocale = {
    lastWeek: $88cc805d33eccea8$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $88cc805d33eccea8$var$dayAndTimeWithAdjective,
    other: "P"
};
var $88cc805d33eccea8$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $88cc805d33eccea8$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(token, date, baseDate, options);
    return format;
};
var $88cc805d33eccea8$export$2e2bcd8739ae039 = $88cc805d33eccea8$var$formatRelative;



var $948300d7648d4c04$var$eraValues = {
    narrow: [
        "p.n.e.",
        "n.e."
    ],
    abbreviated: [
        "p.n.e.",
        "n.e."
    ],
    wide: [
        "przed naszą erą",
        "naszej ery"
    ]
};
var $948300d7648d4c04$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I kw.",
        "II kw.",
        "III kw.",
        "IV kw."
    ],
    wide: [
        "I kwartał",
        "II kwartał",
        "III kwartał",
        "IV kwartał"
    ]
};
var $948300d7648d4c04$var$monthValues = {
    narrow: [
        "S",
        "L",
        "M",
        "K",
        "M",
        "C",
        "L",
        "S",
        "W",
        "P",
        "L",
        "G"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "paź",
        "lis",
        "gru"
    ],
    wide: [
        "styczeń",
        "luty",
        "marzec",
        "kwiecień",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpień",
        "wrzesień",
        "październik",
        "listopad",
        "grudzień"
    ]
};
var $948300d7648d4c04$var$monthFormattingValues = {
    narrow: [
        "s",
        "l",
        "m",
        "k",
        "m",
        "c",
        "l",
        "s",
        "w",
        "p",
        "l",
        "g"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "paź",
        "lis",
        "gru"
    ],
    wide: [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "września",
        "października",
        "listopada",
        "grudnia"
    ]
};
var $948300d7648d4c04$var$dayValues = {
    narrow: [
        "N",
        "P",
        "W",
        "Ś",
        "C",
        "P",
        "S"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "śro",
        "czw",
        "pią",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "śr.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedziałek",
        "wtorek",
        "środa",
        "czwartek",
        "piątek",
        "sobota"
    ]
};
var $948300d7648d4c04$var$dayFormattingValues = {
    narrow: [
        "n",
        "p",
        "w",
        "ś",
        "c",
        "p",
        "s"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "śro",
        "czw",
        "pią",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "śr.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedziałek",
        "wtorek",
        "środa",
        "czwartek",
        "piątek",
        "sobota"
    ]
};
var $948300d7648d4c04$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xf3łn.",
        noon: "poł",
        morning: "rano",
        afternoon: "popoł.",
        evening: "wiecz.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3łnoc",
        noon: "południe",
        morning: "rano",
        afternoon: "popołudnie",
        evening: "wiecz\xf3r",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3łnoc",
        noon: "południe",
        morning: "rano",
        afternoon: "popołudnie",
        evening: "wiecz\xf3r",
        night: "noc"
    }
};
var $948300d7648d4c04$var$dayPeriodFormattingValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xf3łn.",
        noon: "w poł.",
        morning: "rano",
        afternoon: "po poł.",
        evening: "wiecz.",
        night: "w nocy"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3łnocy",
        noon: "w południe",
        morning: "rano",
        afternoon: "po południu",
        evening: "wieczorem",
        night: "w nocy"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3łnocy",
        noon: "w południe",
        morning: "rano",
        afternoon: "po południu",
        evening: "wieczorem",
        night: "w nocy"
    }
};
var $948300d7648d4c04$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $948300d7648d4c04$var$localize = {
    ordinalNumber: $948300d7648d4c04$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $948300d7648d4c04$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $948300d7648d4c04$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $948300d7648d4c04$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $948300d7648d4c04$var$monthFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $948300d7648d4c04$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $948300d7648d4c04$var$dayFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $948300d7648d4c04$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $948300d7648d4c04$var$dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
    })
};
var $948300d7648d4c04$export$2e2bcd8739ae039 = $948300d7648d4c04$var$localize;




var $7464997c92715f97$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $7464997c92715f97$var$parseOrdinalNumberPattern = /\d+/i;
var $7464997c92715f97$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $7464997c92715f97$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $7464997c92715f97$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $7464997c92715f97$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $7464997c92715f97$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $7464997c92715f97$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $7464997c92715f97$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $7464997c92715f97$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $7464997c92715f97$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $7464997c92715f97$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $7464997c92715f97$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $7464997c92715f97$var$matchOrdinalNumberPattern,
        parsePattern: $7464997c92715f97$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7464997c92715f97$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7464997c92715f97$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7464997c92715f97$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7464997c92715f97$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7464997c92715f97$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7464997c92715f97$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7464997c92715f97$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7464997c92715f97$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $7464997c92715f97$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7464997c92715f97$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7464997c92715f97$export$2e2bcd8739ae039 = $7464997c92715f97$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $b7175c8100508d67$var$locale = {
    code: "pl",
    formatDistance: (0, $0110a74b9ce8630a$export$2e2bcd8739ae039),
    formatLong: (0, $090df1c5da0d81bc$export$2e2bcd8739ae039),
    formatRelative: (0, $88cc805d33eccea8$export$2e2bcd8739ae039),
    localize: (0, $948300d7648d4c04$export$2e2bcd8739ae039),
    match: (0, $7464997c92715f97$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b7175c8100508d67$export$2e2bcd8739ae039 = $b7175c8100508d67$var$locale;


var $2540f92a9621f346$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
var $2540f92a9621f346$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2540f92a9621f346$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $2540f92a9621f346$export$2e2bcd8739ae039 = $2540f92a9621f346$var$formatDistance;



var $32c9961ae037ada6$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
var $32c9961ae037ada6$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $32c9961ae037ada6$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $32c9961ae037ada6$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $32c9961ae037ada6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $32c9961ae037ada6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $32c9961ae037ada6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $32c9961ae037ada6$export$2e2bcd8739ae039 = $32c9961ae037ada6$var$formatLong;


var $29b878883c51f2f1$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
var $29b878883c51f2f1$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $29b878883c51f2f1$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $29b878883c51f2f1$export$2e2bcd8739ae039 = $29b878883c51f2f1$var$formatRelative;



var $b0500f25496728ad$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
var $b0500f25496728ad$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $b0500f25496728ad$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
var $b0500f25496728ad$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
var $b0500f25496728ad$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
var $b0500f25496728ad$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
var $b0500f25496728ad$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $b0500f25496728ad$var$localize = {
    ordinalNumber: $b0500f25496728ad$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b0500f25496728ad$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b0500f25496728ad$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b0500f25496728ad$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b0500f25496728ad$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b0500f25496728ad$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b0500f25496728ad$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $b0500f25496728ad$export$2e2bcd8739ae039 = $b0500f25496728ad$var$localize;




var $a5bac67c0a933a83$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $a5bac67c0a933a83$var$parseOrdinalNumberPattern = /\d+/i;
var $a5bac67c0a933a83$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $a5bac67c0a933a83$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $a5bac67c0a933a83$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $a5bac67c0a933a83$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a5bac67c0a933a83$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $a5bac67c0a933a83$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a5bac67c0a933a83$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $a5bac67c0a933a83$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $a5bac67c0a933a83$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $a5bac67c0a933a83$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $a5bac67c0a933a83$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a5bac67c0a933a83$var$matchOrdinalNumberPattern,
        parsePattern: $a5bac67c0a933a83$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5bac67c0a933a83$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5bac67c0a933a83$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5bac67c0a933a83$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5bac67c0a933a83$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5bac67c0a933a83$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5bac67c0a933a83$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5bac67c0a933a83$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5bac67c0a933a83$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5bac67c0a933a83$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a5bac67c0a933a83$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a5bac67c0a933a83$export$2e2bcd8739ae039 = $a5bac67c0a933a83$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $7cf2a5e83f77d5ea$var$locale = {
    code: "pt",
    formatDistance: (0, $2540f92a9621f346$export$2e2bcd8739ae039),
    formatLong: (0, $32c9961ae037ada6$export$2e2bcd8739ae039),
    formatRelative: (0, $29b878883c51f2f1$export$2e2bcd8739ae039),
    localize: (0, $b0500f25496728ad$export$2e2bcd8739ae039),
    match: (0, $a5bac67c0a933a83$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7cf2a5e83f77d5ea$export$2e2bcd8739ae039 = $7cf2a5e83f77d5ea$var$locale;


var $ead0d38d55691af3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "cerca de 1 hora",
        other: "cerca de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "cerca de 1 semana",
        other: "cerca de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: "cerca de {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "cerca de 1 ano",
        other: "cerca de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
var $ead0d38d55691af3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ead0d38d55691af3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "em " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $ead0d38d55691af3$export$2e2bcd8739ae039 = $ead0d38d55691af3$var$formatDistance;



var $8266bce25941db56$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $8266bce25941db56$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $8266bce25941db56$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $8266bce25941db56$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $8266bce25941db56$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $8266bce25941db56$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $8266bce25941db56$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $8266bce25941db56$export$2e2bcd8739ae039 = $8266bce25941db56$var$formatLong;


var $cf9a5d9a02569ce5$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
var $cf9a5d9a02569ce5$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $cf9a5d9a02569ce5$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $cf9a5d9a02569ce5$export$2e2bcd8739ae039 = $cf9a5d9a02569ce5$var$formatRelative;



var $d1ab56b490eb0d09$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "depois de cristo"
    ]
};
var $d1ab56b490eb0d09$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $d1ab56b490eb0d09$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
var $d1ab56b490eb0d09$var$dayValues = {
    narrow: [
        "D",
        "S",
        "T",
        "Q",
        "Q",
        "S",
        "S"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sab"
    ],
    abbreviated: [
        "domingo",
        "segunda",
        "ter\xe7a",
        "quarta",
        "quinta",
        "sexta",
        "s\xe1bado"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
var $d1ab56b490eb0d09$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    }
};
var $d1ab56b490eb0d09$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    }
};
var $d1ab56b490eb0d09$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === "week") return number + "\xaa";
    return number + "\xba";
};
var $d1ab56b490eb0d09$var$localize = {
    ordinalNumber: $d1ab56b490eb0d09$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1ab56b490eb0d09$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1ab56b490eb0d09$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1ab56b490eb0d09$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1ab56b490eb0d09$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $d1ab56b490eb0d09$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d1ab56b490eb0d09$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $d1ab56b490eb0d09$export$2e2bcd8739ae039 = $d1ab56b490eb0d09$var$localize;




var $491cc11083ca5816$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $491cc11083ca5816$var$parseOrdinalNumberPattern = /\d+/i;
var $491cc11083ca5816$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $491cc11083ca5816$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $491cc11083ca5816$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $491cc11083ca5816$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $491cc11083ca5816$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $491cc11083ca5816$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $491cc11083ca5816$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $491cc11083ca5816$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $491cc11083ca5816$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $491cc11083ca5816$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $491cc11083ca5816$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $491cc11083ca5816$var$matchOrdinalNumberPattern,
        parsePattern: $491cc11083ca5816$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $491cc11083ca5816$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $491cc11083ca5816$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $491cc11083ca5816$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $491cc11083ca5816$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $491cc11083ca5816$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $491cc11083ca5816$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $491cc11083ca5816$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $491cc11083ca5816$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $491cc11083ca5816$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $491cc11083ca5816$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $491cc11083ca5816$export$2e2bcd8739ae039 = $491cc11083ca5816$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $22c49fd2559c5058$var$locale = {
    code: "pt-BR",
    formatDistance: (0, $ead0d38d55691af3$export$2e2bcd8739ae039),
    formatLong: (0, $8266bce25941db56$export$2e2bcd8739ae039),
    formatRelative: (0, $cf9a5d9a02569ce5$export$2e2bcd8739ae039),
    localize: (0, $d1ab56b490eb0d09$export$2e2bcd8739ae039),
    match: (0, $491cc11083ca5816$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $22c49fd2559c5058$export$2e2bcd8739ae039 = $22c49fd2559c5058$var$locale;


var $6b41e04560011567$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai puțin de o secundă",
        other: "mai puțin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secundă",
        other: "{{count}} secunde"
    },
    halfAMinute: "jumătate de minut",
    lessThanXMinutes: {
        one: "mai puțin de un minut",
        other: "mai puțin de {{count}} minute"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "circa 1 oră",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "1 oră",
        other: "{{count}} ore"
    },
    xDays: {
        one: "1 zi",
        other: "{{count}} zile"
    },
    aboutXWeeks: {
        one: "circa o săptăm\xe2nă",
        other: "circa {{count}} săptăm\xe2ni"
    },
    xWeeks: {
        one: "1 săptăm\xe2nă",
        other: "{{count}} săptăm\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lună",
        other: "circa {{count}} luni"
    },
    xMonths: {
        one: "1 lună",
        other: "{{count}} luni"
    },
    aboutXYears: {
        one: "circa 1 an",
        other: "circa {{count}} ani"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ani"
    },
    overXYears: {
        one: "peste 1 an",
        other: "peste {{count}} ani"
    },
    almostXYears: {
        one: "aproape 1 an",
        other: "aproape {{count}} ani"
    }
};
var $6b41e04560011567$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6b41e04560011567$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urmă";
    }
    return result;
};
var $6b41e04560011567$export$2e2bcd8739ae039 = $6b41e04560011567$var$formatDistance;



var $ca93a5e13c261102$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd.MM.yyyy"
};
var $ca93a5e13c261102$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $ca93a5e13c261102$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $ca93a5e13c261102$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ca93a5e13c261102$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ca93a5e13c261102$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ca93a5e13c261102$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $ca93a5e13c261102$export$2e2bcd8739ae039 = $ca93a5e13c261102$var$formatLong;


var $28c46eb654812025$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecută la' p",
    yesterday: "'ieri la' p",
    today: "'astăzi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: "P"
};
var $28c46eb654812025$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $28c46eb654812025$var$formatRelativeLocale[token];
};
var $28c46eb654812025$export$2e2bcd8739ae039 = $28c46eb654812025$var$formatRelative;



var $93cd5fee9ee91802$var$eraValues = {
    narrow: [
        "\xce",
        "D"
    ],
    abbreviated: [
        "\xce.d.C.",
        "D.C."
    ],
    wide: [
        "\xcenainte de Cristos",
        "După Cristos"
    ]
};
var $93cd5fee9ee91802$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "primul trimestru",
        "al doilea trimestru",
        "al treilea trimestru",
        "al patrulea trimestru"
    ]
};
var $93cd5fee9ee91802$var$monthValues = {
    narrow: [
        "I",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
    ],
    wide: [
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
    ]
};
var $93cd5fee9ee91802$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "du",
        "lu",
        "ma",
        "mi",
        "jo",
        "vi",
        "s\xe2"
    ],
    abbreviated: [
        "dum",
        "lun",
        "mar",
        "mie",
        "joi",
        "vin",
        "s\xe2m"
    ],
    wide: [
        "duminică",
        "luni",
        "marți",
        "miercuri",
        "joi",
        "vineri",
        "s\xe2mbătă"
    ]
};
var $93cd5fee9ee91802$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "ami",
        morning: "dim",
        afternoon: "da",
        evening: "s",
        night: "n"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nopții",
        noon: "amiază",
        morning: "dimineață",
        afternoon: "după-amiază",
        evening: "seară",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nopții",
        noon: "amiază",
        morning: "dimineață",
        afternoon: "după-amiază",
        evening: "seară",
        night: "noapte"
    }
};
var $93cd5fee9ee91802$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "amiază",
        morning: "dimineață",
        afternoon: "după-amiază",
        evening: "seară",
        night: "noapte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nopții",
        noon: "amiază",
        morning: "dimineață",
        afternoon: "după-amiază",
        evening: "seară",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nopții",
        noon: "amiază",
        morning: "dimineață",
        afternoon: "după-amiază",
        evening: "seară",
        night: "noapte"
    }
};
var $93cd5fee9ee91802$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $93cd5fee9ee91802$var$localize = {
    ordinalNumber: $93cd5fee9ee91802$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $93cd5fee9ee91802$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $93cd5fee9ee91802$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $93cd5fee9ee91802$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $93cd5fee9ee91802$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $93cd5fee9ee91802$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $93cd5fee9ee91802$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $93cd5fee9ee91802$export$2e2bcd8739ae039 = $93cd5fee9ee91802$var$localize;




var $38bb076ed53066af$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $38bb076ed53066af$var$parseOrdinalNumberPattern = /\d+/i;
var $38bb076ed53066af$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $38bb076ed53066af$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $38bb076ed53066af$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $38bb076ed53066af$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $38bb076ed53066af$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $38bb076ed53066af$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $38bb076ed53066af$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $38bb076ed53066af$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $38bb076ed53066af$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $38bb076ed53066af$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $38bb076ed53066af$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $38bb076ed53066af$var$matchOrdinalNumberPattern,
        parsePattern: $38bb076ed53066af$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $38bb076ed53066af$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38bb076ed53066af$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $38bb076ed53066af$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38bb076ed53066af$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $38bb076ed53066af$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38bb076ed53066af$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $38bb076ed53066af$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $38bb076ed53066af$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $38bb076ed53066af$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $38bb076ed53066af$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $38bb076ed53066af$export$2e2bcd8739ae039 = $38bb076ed53066af$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $8bd70ba50433c355$var$locale = {
    code: "ro",
    formatDistance: (0, $6b41e04560011567$export$2e2bcd8739ae039),
    formatLong: (0, $ca93a5e13c261102$export$2e2bcd8739ae039),
    formatRelative: (0, $28c46eb654812025$export$2e2bcd8739ae039),
    localize: (0, $93cd5fee9ee91802$export$2e2bcd8739ae039),
    match: (0, $38bb076ed53066af$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $8bd70ba50433c355$export$2e2bcd8739ae039 = $8bd70ba50433c355$var$locale;


function $366b313db28145fc$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $366b313db28145fc$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $366b313db28145fc$var$declension(scheme.future, count);
                else return "через " + $366b313db28145fc$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $366b313db28145fc$var$declension(scheme.past, count);
                else return $366b313db28145fc$var$declension(scheme.regular, count) + " назад";
            }
        } else return $366b313db28145fc$var$declension(scheme.regular, count);
    };
}
var $366b313db28145fc$var$formatDistanceLocale = {
    lessThanXSeconds: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            one: "меньше секунды",
            singularNominative: "меньше {{count}} секунды",
            singularGenitive: "меньше {{count}} секунд",
            pluralGenitive: "меньше {{count}} секунд"
        },
        future: {
            one: "меньше, чем через секунду",
            singularNominative: "меньше, чем через {{count}} секунду",
            singularGenitive: "меньше, чем через {{count}} секунды",
            pluralGenitive: "меньше, чем через {{count}} секунд"
        }
    }),
    xSeconds: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} секунда",
            singularGenitive: "{{count}} секунды",
            pluralGenitive: "{{count}} секунд"
        },
        past: {
            singularNominative: "{{count}} секунду назад",
            singularGenitive: "{{count}} секунды назад",
            pluralGenitive: "{{count}} секунд назад"
        },
        future: {
            singularNominative: "через {{count}} секунду",
            singularGenitive: "через {{count}} секунды",
            pluralGenitive: "через {{count}} секунд"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "через полминуты";
            else return "полминуты назад";
        }
        return "полминуты";
    },
    lessThanXMinutes: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            one: "меньше минуты",
            singularNominative: "меньше {{count}} минуты",
            singularGenitive: "меньше {{count}} минут",
            pluralGenitive: "меньше {{count}} минут"
        },
        future: {
            one: "меньше, чем через минуту",
            singularNominative: "меньше, чем через {{count}} минуту",
            singularGenitive: "меньше, чем через {{count}} минуты",
            pluralGenitive: "меньше, чем через {{count}} минут"
        }
    }),
    xMinutes: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} минута",
            singularGenitive: "{{count}} минуты",
            pluralGenitive: "{{count}} минут"
        },
        past: {
            singularNominative: "{{count}} минуту назад",
            singularGenitive: "{{count}} минуты назад",
            pluralGenitive: "{{count}} минут назад"
        },
        future: {
            singularNominative: "через {{count}} минуту",
            singularGenitive: "через {{count}} минуты",
            pluralGenitive: "через {{count}} минут"
        }
    }),
    aboutXHours: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "около {{count}} часа",
            singularGenitive: "около {{count}} часов",
            pluralGenitive: "около {{count}} часов"
        },
        future: {
            singularNominative: "приблизительно через {{count}} час",
            singularGenitive: "приблизительно через {{count}} часа",
            pluralGenitive: "приблизительно через {{count}} часов"
        }
    }),
    xHours: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} час",
            singularGenitive: "{{count}} часа",
            pluralGenitive: "{{count}} часов"
        }
    }),
    xDays: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} день",
            singularGenitive: "{{count}} дня",
            pluralGenitive: "{{count}} дней"
        }
    }),
    aboutXWeeks: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "около {{count}} недели",
            singularGenitive: "около {{count}} недель",
            pluralGenitive: "около {{count}} недель"
        },
        future: {
            singularNominative: "приблизительно через {{count}} неделю",
            singularGenitive: "приблизительно через {{count}} недели",
            pluralGenitive: "приблизительно через {{count}} недель"
        }
    }),
    xWeeks: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} неделя",
            singularGenitive: "{{count}} недели",
            pluralGenitive: "{{count}} недель"
        }
    }),
    aboutXMonths: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "около {{count}} месяца",
            singularGenitive: "около {{count}} месяцев",
            pluralGenitive: "около {{count}} месяцев"
        },
        future: {
            singularNominative: "приблизительно через {{count}} месяц",
            singularGenitive: "приблизительно через {{count}} месяца",
            pluralGenitive: "приблизительно через {{count}} месяцев"
        }
    }),
    xMonths: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} месяц",
            singularGenitive: "{{count}} месяца",
            pluralGenitive: "{{count}} месяцев"
        }
    }),
    aboutXYears: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "около {{count}} года",
            singularGenitive: "около {{count}} лет",
            pluralGenitive: "около {{count}} лет"
        },
        future: {
            singularNominative: "приблизительно через {{count}} год",
            singularGenitive: "приблизительно через {{count}} года",
            pluralGenitive: "приблизительно через {{count}} лет"
        }
    }),
    xYears: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} год",
            singularGenitive: "{{count}} года",
            pluralGenitive: "{{count}} лет"
        }
    }),
    overXYears: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "больше {{count}} года",
            singularGenitive: "больше {{count}} лет",
            pluralGenitive: "больше {{count}} лет"
        },
        future: {
            singularNominative: "больше, чем через {{count}} год",
            singularGenitive: "больше, чем через {{count}} года",
            pluralGenitive: "больше, чем через {{count}} лет"
        }
    }),
    almostXYears: $366b313db28145fc$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "почти {{count}} год",
            singularGenitive: "почти {{count}} года",
            pluralGenitive: "почти {{count}} лет"
        },
        future: {
            singularNominative: "почти через {{count}} год",
            singularGenitive: "почти через {{count}} года",
            pluralGenitive: "почти через {{count}} лет"
        }
    })
};
var $366b313db28145fc$var$formatDistance = function formatDistance(token, count, options) {
    return $366b313db28145fc$var$formatDistanceLocale[token](count, options);
};
var $366b313db28145fc$export$2e2bcd8739ae039 = $366b313db28145fc$var$formatDistance;



var $86febdb3df3a2a50$var$dateFormats = {
    full: "EEEE, d MMMM y 'г.'",
    long: "d MMMM y 'г.'",
    medium: "d MMM y 'г.'",
    short: "dd.MM.y"
};
var $86febdb3df3a2a50$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $86febdb3df3a2a50$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $86febdb3df3a2a50$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $86febdb3df3a2a50$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $86febdb3df3a2a50$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $86febdb3df3a2a50$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $86febdb3df3a2a50$export$2e2bcd8739ae039 = $86febdb3df3a2a50$var$formatLong;



var $d56f4b873c563ad3$var$accusativeWeekdays = [
    "воскресенье",
    "понедельник",
    "вторник",
    "среду",
    "четверг",
    "пятницу",
    "субботу"
];
function $d56f4b873c563ad3$var$_lastWeek(day) {
    var weekday = $d56f4b873c563ad3$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'в прошлое " + weekday + " в' p";
        case 1:
        case 2:
        case 4:
            return "'в прошлый " + weekday + " в' p";
        case 3:
        case 5:
        case 6:
            return "'в прошлую " + weekday + " в' p";
    }
}
function $d56f4b873c563ad3$var$thisWeek(day) {
    var weekday = $d56f4b873c563ad3$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'во " + weekday + " в' p";
    else return "'в " + weekday + " в' p";
}
function $d56f4b873c563ad3$var$_nextWeek(day) {
    var weekday = $d56f4b873c563ad3$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'в следующее " + weekday + " в' p";
        case 1:
        case 2:
        case 4:
            return "'в следующий " + weekday + " в' p";
        case 3:
        case 5:
        case 6:
            return "'в следующую " + weekday + " в' p";
    }
}
var $d56f4b873c563ad3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $d56f4b873c563ad3$var$thisWeek(day);
        else return $d56f4b873c563ad3$var$_lastWeek(day);
    },
    yesterday: "'вчера в' p",
    today: "'сегодня в' p",
    tomorrow: "'завтра в' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $d56f4b873c563ad3$var$thisWeek(day);
        else return $d56f4b873c563ad3$var$_nextWeek(day);
    },
    other: "P"
};
var $d56f4b873c563ad3$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $d56f4b873c563ad3$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $d56f4b873c563ad3$export$2e2bcd8739ae039 = $d56f4b873c563ad3$var$formatRelative;



var $8448cf19e70a7416$var$eraValues = {
    narrow: [
        "до н.э.",
        "н.э."
    ],
    abbreviated: [
        "до н. э.",
        "н. э."
    ],
    wide: [
        "до нашей эры",
        "нашей эры"
    ]
};
var $8448cf19e70a7416$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-й кв.",
        "2-й кв.",
        "3-й кв.",
        "4-й кв."
    ],
    wide: [
        "1-й квартал",
        "2-й квартал",
        "3-й квартал",
        "4-й квартал"
    ]
};
var $8448cf19e70a7416$var$monthValues = {
    narrow: [
        "Я",
        "Ф",
        "М",
        "А",
        "М",
        "И",
        "И",
        "А",
        "С",
        "О",
        "Н",
        "Д"
    ],
    abbreviated: [
        "янв.",
        "фев.",
        "март",
        "апр.",
        "май",
        "июнь",
        "июль",
        "авг.",
        "сент.",
        "окт.",
        "нояб.",
        "дек."
    ],
    wide: [
        "январь",
        "февраль",
        "март",
        "апрель",
        "май",
        "июнь",
        "июль",
        "август",
        "сентябрь",
        "октябрь",
        "ноябрь",
        "декабрь"
    ]
};
var $8448cf19e70a7416$var$formattingMonthValues = {
    narrow: [
        "Я",
        "Ф",
        "М",
        "А",
        "М",
        "И",
        "И",
        "А",
        "С",
        "О",
        "Н",
        "Д"
    ],
    abbreviated: [
        "янв.",
        "фев.",
        "мар.",
        "апр.",
        "мая",
        "июн.",
        "июл.",
        "авг.",
        "сент.",
        "окт.",
        "нояб.",
        "дек."
    ],
    wide: [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря"
    ]
};
var $8448cf19e70a7416$var$dayValues = {
    narrow: [
        "В",
        "П",
        "В",
        "С",
        "Ч",
        "П",
        "С"
    ],
    short: [
        "вс",
        "пн",
        "вт",
        "ср",
        "чт",
        "пт",
        "сб"
    ],
    abbreviated: [
        "вск",
        "пнд",
        "втр",
        "срд",
        "чтв",
        "птн",
        "суб"
    ],
    wide: [
        "воскресенье",
        "понедельник",
        "вторник",
        "среда",
        "четверг",
        "пятница",
        "суббота"
    ]
};
var $8448cf19e70a7416$var$dayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "полн.",
        noon: "полд.",
        morning: "утро",
        afternoon: "день",
        evening: "веч.",
        night: "ночь"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "полн.",
        noon: "полд.",
        morning: "утро",
        afternoon: "день",
        evening: "веч.",
        night: "ночь"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "полночь",
        noon: "полдень",
        morning: "утро",
        afternoon: "день",
        evening: "вечер",
        night: "ночь"
    }
};
var $8448cf19e70a7416$var$formattingDayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "полн.",
        noon: "полд.",
        morning: "утра",
        afternoon: "дня",
        evening: "веч.",
        night: "ночи"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "полн.",
        noon: "полд.",
        morning: "утра",
        afternoon: "дня",
        evening: "веч.",
        night: "ночи"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "полночь",
        noon: "полдень",
        morning: "утра",
        afternoon: "дня",
        evening: "вечера",
        night: "ночи"
    }
};
var $8448cf19e70a7416$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === "date") suffix = "-е";
    else if (unit === "week" || unit === "minute" || unit === "second") suffix = "-я";
    else suffix = "-й";
    return number + suffix;
};
var $8448cf19e70a7416$var$localize = {
    ordinalNumber: $8448cf19e70a7416$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8448cf19e70a7416$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8448cf19e70a7416$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8448cf19e70a7416$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $8448cf19e70a7416$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8448cf19e70a7416$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8448cf19e70a7416$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $8448cf19e70a7416$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $8448cf19e70a7416$export$2e2bcd8739ae039 = $8448cf19e70a7416$var$localize;




var $2979c889901c348d$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $2979c889901c348d$var$parseOrdinalNumberPattern = /\d+/i;
var $2979c889901c348d$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $2979c889901c348d$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $2979c889901c348d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $2979c889901c348d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2979c889901c348d$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $2979c889901c348d$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $2979c889901c348d$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $2979c889901c348d$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $2979c889901c348d$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $2979c889901c348d$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $2979c889901c348d$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $2979c889901c348d$var$matchOrdinalNumberPattern,
        parsePattern: $2979c889901c348d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2979c889901c348d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2979c889901c348d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2979c889901c348d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2979c889901c348d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2979c889901c348d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2979c889901c348d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2979c889901c348d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2979c889901c348d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $2979c889901c348d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2979c889901c348d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $2979c889901c348d$export$2e2bcd8739ae039 = $2979c889901c348d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $7f8fd36f2ae8dc9d$var$locale = {
    code: "ru",
    formatDistance: (0, $366b313db28145fc$export$2e2bcd8739ae039),
    formatLong: (0, $86febdb3df3a2a50$export$2e2bcd8739ae039),
    formatRelative: (0, $d56f4b873c563ad3$export$2e2bcd8739ae039),
    localize: (0, $8448cf19e70a7416$export$2e2bcd8739ae039),
    match: (0, $2979c889901c348d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $7f8fd36f2ae8dc9d$export$2e2bcd8739ae039 = $7f8fd36f2ae8dc9d$var$locale;


function $d2e05a6a8416dd1c$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $d2e05a6a8416dd1c$var$declension(scheme, count, time) {
    var group = $d2e05a6a8416dd1c$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace("{{count}}", String(count));
}
function $d2e05a6a8416dd1c$var$extractPreposition(token) {
    var result = [
        "lessThan",
        "about",
        "over",
        "almost"
    ].filter(function(preposition) {
        return !!token.match(new RegExp("^" + preposition));
    });
    return result[0];
}
function $d2e05a6a8416dd1c$var$prefixPreposition(preposition) {
    var translation = "";
    if (preposition === "almost") translation = "takmer";
    if (preposition === "about") translation = "približne";
    return translation.length > 0 ? translation + " " : "";
}
function $d2e05a6a8416dd1c$var$suffixPreposition(preposition) {
    var translation = "";
    if (preposition === "lessThan") translation = "menej než";
    if (preposition === "over") translation = "viac než";
    return translation.length > 0 ? translation + " " : "";
}
function $d2e05a6a8416dd1c$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $d2e05a6a8416dd1c$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: "sekunda",
            past: "sekundou",
            future: "sekundu"
        },
        twoFour: {
            present: "{{count}} sekundy",
            past: "{{count}} sekundami",
            future: "{{count}} sekundy"
        },
        other: {
            present: "{{count}} sek\xfand",
            past: "{{count}} sekundami",
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: "hodina",
            past: "hodinou",
            future: "hodinu"
        },
        twoFour: {
            present: "{{count}} hodiny",
            past: "{{count}} hodinami",
            future: "{{count}} hodiny"
        },
        other: {
            present: "{{count}} hod\xedn",
            past: "{{count}} hodinami",
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "deň",
            past: "dňom",
            future: "deň"
        },
        twoFour: {
            present: "{{count}} dni",
            past: "{{count}} dňami",
            future: "{{count}} dni"
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} dňami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfdždeň",
            past: "t\xfdždňom",
            future: "t\xfdždeň"
        },
        twoFour: {
            present: "{{count}} t\xfdždne",
            past: "{{count}} t\xfdždňami",
            future: "{{count}} t\xfdždne"
        },
        other: {
            present: "{{count}} t\xfdždňov",
            past: "{{count}} t\xfdždňami",
            future: "{{count}} t\xfdždňov"
        }
    },
    xMonths: {
        one: {
            present: "mesiac",
            past: "mesiacom",
            future: "mesiac"
        },
        twoFour: {
            present: "{{count}} mesiace",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiace"
        },
        other: {
            present: "{{count}} mesiacov",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiacov"
        }
    },
    xYears: {
        one: {
            present: "rok",
            past: "rokom",
            future: "rok"
        },
        twoFour: {
            present: "{{count}} roky",
            past: "{{count}} rokmi",
            future: "{{count}} roky"
        },
        other: {
            present: "{{count}} rokov",
            past: "{{count}} rokmi",
            future: "{{count}} rokov"
        }
    }
};
var $d2e05a6a8416dd1c$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $d2e05a6a8416dd1c$var$extractPreposition(token) || "";
    var key = $d2e05a6a8416dd1c$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $d2e05a6a8416dd1c$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $d2e05a6a8416dd1c$var$prefixPreposition(preposition) + $d2e05a6a8416dd1c$var$suffixPreposition(preposition) + $d2e05a6a8416dd1c$var$declension(scheme, count, "present");
    if (options.comparison && options.comparison > 0) return $d2e05a6a8416dd1c$var$prefixPreposition(preposition) + "o " + $d2e05a6a8416dd1c$var$suffixPreposition(preposition) + $d2e05a6a8416dd1c$var$declension(scheme, count, "future");
    else return $d2e05a6a8416dd1c$var$prefixPreposition(preposition) + "pred " + $d2e05a6a8416dd1c$var$suffixPreposition(preposition) + $d2e05a6a8416dd1c$var$declension(scheme, count, "past");
};
var $d2e05a6a8416dd1c$export$2e2bcd8739ae039 = $d2e05a6a8416dd1c$var$formatDistance;



var $26f83ea6a01103aa$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. M. y",
    short: "d. M. y"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $26f83ea6a01103aa$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $26f83ea6a01103aa$var$dateTimeFormats = {
    full: "{{date}}, {{time}}",
    long: "{{date}}, {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}} {{time}}"
};
var $26f83ea6a01103aa$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $26f83ea6a01103aa$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $26f83ea6a01103aa$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $26f83ea6a01103aa$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $26f83ea6a01103aa$export$2e2bcd8739ae039 = $26f83ea6a01103aa$var$formatLong;



// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $0bd461397cbd4508$var$accusativeWeekdays = [
    "nedeľu",
    "pondelok",
    "utorok",
    "stredu",
    "štvrtok",
    "piatok",
    "sobotu"
];
function $0bd461397cbd4508$var$_lastWeek(day) {
    var weekday = $0bd461397cbd4508$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $0bd461397cbd4508$var$thisWeek(day) {
    var weekday = $0bd461397cbd4508$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $0bd461397cbd4508$var$_nextWeek(day) {
    var weekday = $0bd461397cbd4508$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $0bd461397cbd4508$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $0bd461397cbd4508$var$thisWeek(day);
        else return $0bd461397cbd4508$var$_lastWeek(day);
    },
    yesterday: "'včera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $0bd461397cbd4508$var$thisWeek(day);
        else return $0bd461397cbd4508$var$_nextWeek(day);
    },
    other: "P"
};
var $0bd461397cbd4508$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $0bd461397cbd4508$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $0bd461397cbd4508$export$2e2bcd8739ae039 = $0bd461397cbd4508$var$formatRelative;



var $a1c084d0451efd41$var$eraValues = {
    narrow: [
        "pred Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pred Kr.",
        "po Kr."
    ],
    wide: [
        "pred Kristom",
        "po Kristovi"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $a1c084d0451efd41$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. štvrťrok",
        "2. štvrťrok",
        "3. štvrťrok",
        "4. štvrťrok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $a1c084d0451efd41$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "marec",
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "august",
        "september",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
var $a1c084d0451efd41$var$formattingMonthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        "marca",
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        "augusta",
        "septembra",
        "okt\xf3bra",
        "novembra",
        "decembra"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $a1c084d0451efd41$var$dayValues = {
    narrow: [
        "n",
        "p",
        "u",
        "s",
        "š",
        "p",
        "s"
    ],
    short: [
        "ne",
        "po",
        "ut",
        "st",
        "št",
        "pi",
        "so"
    ],
    abbreviated: [
        "ne",
        "po",
        "ut",
        "st",
        "št",
        "pi",
        "so"
    ],
    wide: [
        "nedeľa",
        "pondelok",
        "utorok",
        "streda",
        "štvrtok",
        "piatok",
        "sobota"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $a1c084d0451efd41$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "več.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "večer",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "polnoc",
        noon: "poludnie",
        morning: "r\xe1no",
        afternoon: "popoludnie",
        evening: "večer",
        night: "noc"
    }
};
var $a1c084d0451efd41$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "nap.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "več.",
        night: "v n."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "napol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "večer",
        night: "v noci"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o polnoci",
        noon: "napoludnie",
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "večer",
        night: "v noci"
    }
};
var $a1c084d0451efd41$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $a1c084d0451efd41$var$localize = {
    ordinalNumber: $a1c084d0451efd41$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a1c084d0451efd41$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a1c084d0451efd41$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a1c084d0451efd41$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $a1c084d0451efd41$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a1c084d0451efd41$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $a1c084d0451efd41$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a1c084d0451efd41$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a1c084d0451efd41$export$2e2bcd8739ae039 = $a1c084d0451efd41$var$localize;




var $1c04e900a3a2f261$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $1c04e900a3a2f261$var$parseOrdinalNumberPattern = /\d+/i;
var $1c04e900a3a2f261$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $1c04e900a3a2f261$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $1c04e900a3a2f261$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $1c04e900a3a2f261$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1c04e900a3a2f261$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $1c04e900a3a2f261$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $1c04e900a3a2f261$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $1c04e900a3a2f261$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $1c04e900a3a2f261$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $1c04e900a3a2f261$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $1c04e900a3a2f261$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $1c04e900a3a2f261$var$matchOrdinalNumberPattern,
        parsePattern: $1c04e900a3a2f261$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c04e900a3a2f261$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c04e900a3a2f261$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c04e900a3a2f261$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c04e900a3a2f261$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c04e900a3a2f261$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c04e900a3a2f261$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c04e900a3a2f261$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1c04e900a3a2f261$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $1c04e900a3a2f261$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1c04e900a3a2f261$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $1c04e900a3a2f261$export$2e2bcd8739ae039 = $1c04e900a3a2f261$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $884a7dc31f124290$var$locale = {
    code: "sk",
    formatDistance: (0, $d2e05a6a8416dd1c$export$2e2bcd8739ae039),
    formatLong: (0, $26f83ea6a01103aa$export$2e2bcd8739ae039),
    formatRelative: (0, $0bd461397cbd4508$export$2e2bcd8739ae039),
    localize: (0, $a1c084d0451efd41$export$2e2bcd8739ae039),
    match: (0, $1c04e900a3a2f261$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $884a7dc31f124290$export$2e2bcd8739ae039 = $884a7dc31f124290$var$locale;


function $4a9b27eb30cf471b$var$isPluralType(val) {
    return val.one !== undefined;
}
var $4a9b27eb30cf471b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: "manj kot {{count}} sekunda",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        },
        past: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundama",
            few: "manj kot {{count}} sekundami",
            other: "manj kot {{count}} sekundami"
        },
        future: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        }
    },
    xSeconds: {
        present: {
            one: "{{count}} sekunda",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        },
        past: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundama",
            few: "{{count}} sekundami",
            other: "{{count}} sekundami"
        },
        future: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        }
    },
    halfAMinute: "pol minute",
    lessThanXMinutes: {
        present: {
            one: "manj kot {{count}} minuta",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        },
        past: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minutama",
            few: "manj kot {{count}} minutami",
            other: "manj kot {{count}} minutami"
        },
        future: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        }
    },
    xMinutes: {
        present: {
            one: "{{count}} minuta",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        },
        past: {
            one: "{{count}} minuto",
            two: "{{count}} minutama",
            few: "{{count}} minutami",
            other: "{{count}} minutami"
        },
        future: {
            one: "{{count}} minuto",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        }
    },
    aboutXHours: {
        present: {
            one: "približno {{count}} ura",
            two: "približno {{count}} uri",
            few: "približno {{count}} ure",
            other: "približno {{count}} ur"
        },
        past: {
            one: "približno {{count}} uro",
            two: "približno {{count}} urama",
            few: "približno {{count}} urami",
            other: "približno {{count}} urami"
        },
        future: {
            one: "približno {{count}} uro",
            two: "približno {{count}} uri",
            few: "približno {{count}} ure",
            other: "približno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: "{{count}} ura",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        },
        past: {
            one: "{{count}} uro",
            two: "{{count}} urama",
            few: "{{count}} urami",
            other: "{{count}} urami"
        },
        future: {
            one: "{{count}} uro",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        }
    },
    xDays: {
        present: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        },
        past: {
            one: "{{count}} dnem",
            two: "{{count}} dnevoma",
            few: "{{count}} dnevi",
            other: "{{count}} dnevi"
        },
        future: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "približno {{count}} teden",
        two: "približno {{count}} tedna",
        few: "približno {{count}} tedne",
        other: "približno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: "{{count}} teden",
        two: "{{count}} tedna",
        few: "{{count}} tedne",
        other: "{{count}} tednov"
    },
    aboutXMonths: {
        present: {
            one: "približno {{count}} mesec",
            two: "približno {{count}} meseca",
            few: "približno {{count}} mesece",
            other: "približno {{count}} mesecev"
        },
        past: {
            one: "približno {{count}} mesecem",
            two: "približno {{count}} mesecema",
            few: "približno {{count}} meseci",
            other: "približno {{count}} meseci"
        },
        future: {
            one: "približno {{count}} mesec",
            two: "približno {{count}} meseca",
            few: "približno {{count}} mesece",
            other: "približno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} meseci",
            other: "{{count}} mesecev"
        },
        past: {
            one: "{{count}} mesecem",
            two: "{{count}} mesecema",
            few: "{{count}} meseci",
            other: "{{count}} meseci"
        },
        future: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} mesece",
            other: "{{count}} mesecev"
        }
    },
    aboutXYears: {
        present: {
            one: "približno {{count}} leto",
            two: "približno {{count}} leti",
            few: "približno {{count}} leta",
            other: "približno {{count}} let"
        },
        past: {
            one: "približno {{count}} letom",
            two: "približno {{count}} letoma",
            few: "približno {{count}} leti",
            other: "približno {{count}} leti"
        },
        future: {
            one: "približno {{count}} leto",
            two: "približno {{count}} leti",
            few: "približno {{count}} leta",
            other: "približno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        },
        past: {
            one: "{{count}} letom",
            two: "{{count}} letoma",
            few: "{{count}} leti",
            other: "{{count}} leti"
        },
        future: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        }
    },
    overXYears: {
        present: {
            one: "več kot {{count}} leto",
            two: "več kot {{count}} leti",
            few: "več kot {{count}} leta",
            other: "več kot {{count}} let"
        },
        past: {
            one: "več kot {{count}} letom",
            two: "več kot {{count}} letoma",
            few: "več kot {{count}} leti",
            other: "več kot {{count}} leti"
        },
        future: {
            one: "več kot {{count}} leto",
            two: "več kot {{count}} leti",
            few: "več kot {{count}} leta",
            other: "več kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        },
        past: {
            one: "skoraj {{count}} letom",
            two: "skoraj {{count}} letoma",
            few: "skoraj {{count}} leti",
            other: "skoraj {{count}} leti"
        },
        future: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        }
    }
};
function $4a9b27eb30cf471b$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return "one";
        case 2:
            return "two";
        case 3:
        case 4:
            return "few";
        default:
            return "other";
    }
}
var $4a9b27eb30cf471b$var$formatDistance = function formatDistance(token, count, options) {
    var result = "";
    var tense = "present";
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = "future";
            result = "čez ";
        } else {
            tense = "past";
            result = "pred ";
        }
    }
    var tokenValue = $4a9b27eb30cf471b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result += tokenValue;
    else {
        var form = $4a9b27eb30cf471b$var$getFormFromCount(count);
        if ($4a9b27eb30cf471b$var$isPluralType(tokenValue)) result += tokenValue[form].replace("{{count}}", String(count));
        else result += tokenValue[tense][form].replace("{{count}}", String(count));
    }
    return result;
};
var $4a9b27eb30cf471b$export$2e2bcd8739ae039 = $4a9b27eb30cf471b$var$formatDistance;



var $e22a423fce6cabc0$var$dateFormats = {
    full: "EEEE, dd. MMMM y",
    long: "dd. MMMM y",
    medium: "d. MMM y",
    short: "d. MM. yy"
};
var $e22a423fce6cabc0$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $e22a423fce6cabc0$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $e22a423fce6cabc0$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e22a423fce6cabc0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e22a423fce6cabc0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e22a423fce6cabc0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e22a423fce6cabc0$export$2e2bcd8739ae039 = $e22a423fce6cabc0$var$formatLong;


var $9dfa5b701713a0a3$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prejšnjo nedeljo ob' p";
            case 3:
                return "'prejšnjo sredo ob' p";
            case 6:
                return "'prejšnjo soboto ob' p";
            default:
                return "'prejšnji' EEEE 'ob' p";
        }
    },
    yesterday: "'včeraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: "P"
};
var $9dfa5b701713a0a3$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $9dfa5b701713a0a3$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $9dfa5b701713a0a3$export$2e2bcd8739ae039 = $9dfa5b701713a0a3$var$formatRelative;



var $6ae921048638644f$var$eraValues = {
    narrow: [
        "pr. n. št.",
        "po n. št."
    ],
    abbreviated: [
        "pr. n. št.",
        "po n. št."
    ],
    wide: [
        "pred našim štetjem",
        "po našem štetju"
    ]
};
var $6ae921048638644f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. čet.",
        "2. čet.",
        "3. čet.",
        "4. čet."
    ],
    wide: [
        "1. četrtletje",
        "2. četrtletje",
        "3. četrtletje",
        "4. četrtletje"
    ]
};
var $6ae921048638644f$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "avg.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marec",
        "april",
        "maj",
        "junij",
        "julij",
        "avgust",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $6ae921048638644f$var$dayValues = {
    narrow: [
        "n",
        "p",
        "t",
        "s",
        "č",
        "p",
        "s"
    ],
    short: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "čet.",
        "pet.",
        "sob."
    ],
    abbreviated: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "čet.",
        "pet.",
        "sob."
    ],
    wide: [
        "nedelja",
        "ponedeljek",
        "torek",
        "sreda",
        "četrtek",
        "petek",
        "sobota"
    ]
};
var $6ae921048638644f$var$dayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "j",
        afternoon: "p",
        evening: "v",
        night: "n"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "poln.",
        noon: "pold.",
        morning: "jut.",
        afternoon: "pop.",
        evening: "več.",
        night: "noč"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "polnoč",
        noon: "poldne",
        morning: "jutro",
        afternoon: "popoldne",
        evening: "večer",
        night: "noč"
    }
};
var $6ae921048638644f$var$formattingDayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "zj",
        afternoon: "p",
        evening: "zv",
        night: "po"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "opoln.",
        noon: "opold.",
        morning: "zjut.",
        afternoon: "pop.",
        evening: "zveč.",
        night: "ponoči"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "opolnoči",
        noon: "opoldne",
        morning: "zjutraj",
        afternoon: "popoldan",
        evening: "zvečer",
        night: "ponoči"
    }
};
var $6ae921048638644f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $6ae921048638644f$var$localize = {
    ordinalNumber: $6ae921048638644f$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6ae921048638644f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6ae921048638644f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6ae921048638644f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6ae921048638644f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $6ae921048638644f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6ae921048638644f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6ae921048638644f$export$2e2bcd8739ae039 = $6ae921048638644f$var$localize;




var $a2ba114839f4d6d3$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $a2ba114839f4d6d3$var$parseOrdinalNumberPattern = /\d+/i;
var $a2ba114839f4d6d3$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var $a2ba114839f4d6d3$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var $a2ba114839f4d6d3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var $a2ba114839f4d6d3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a2ba114839f4d6d3$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var $a2ba114839f4d6d3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a2ba114839f4d6d3$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var $a2ba114839f4d6d3$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var $a2ba114839f4d6d3$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var $a2ba114839f4d6d3$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var $a2ba114839f4d6d3$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a2ba114839f4d6d3$var$matchOrdinalNumberPattern,
        parsePattern: $a2ba114839f4d6d3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a2ba114839f4d6d3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a2ba114839f4d6d3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a2ba114839f4d6d3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a2ba114839f4d6d3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a2ba114839f4d6d3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a2ba114839f4d6d3$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a2ba114839f4d6d3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a2ba114839f4d6d3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a2ba114839f4d6d3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a2ba114839f4d6d3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a2ba114839f4d6d3$export$2e2bcd8739ae039 = $a2ba114839f4d6d3$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var $b6ef1862d3720b9f$var$locale = {
    code: "sl",
    formatDistance: (0, $4a9b27eb30cf471b$export$2e2bcd8739ae039),
    formatLong: (0, $e22a423fce6cabc0$export$2e2bcd8739ae039),
    formatRelative: (0, $9dfa5b701713a0a3$export$2e2bcd8739ae039),
    localize: (0, $6ae921048638644f$export$2e2bcd8739ae039),
    match: (0, $a2ba114839f4d6d3$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $b6ef1862d3720b9f$export$2e2bcd8739ae039 = $b6ef1862d3720b9f$var$locale;


var $960ec5dba3024bf6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: "{{count}} sekonda"
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: "rreth 1 muaj",
        other: "rreth {{count}} muaj"
    },
    xMonths: {
        one: "1 muaj",
        other: "{{count}} muaj"
    },
    aboutXYears: {
        one: "rreth 1 vit",
        other: "rreth {{count}} vite"
    },
    xYears: {
        one: "1 vit",
        other: "{{count}} vite"
    },
    overXYears: {
        one: "mbi 1 vit",
        other: "mbi {{count}} vite"
    },
    almostXYears: {
        one: "pothuajse 1 vit",
        other: "pothuajse {{count}} vite"
    }
};
var $960ec5dba3024bf6$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $960ec5dba3024bf6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
var $960ec5dba3024bf6$export$2e2bcd8739ae039 = $960ec5dba3024bf6$var$formatDistance;



var $ffdacb42eeac20fc$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $ffdacb42eeac20fc$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $ffdacb42eeac20fc$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $ffdacb42eeac20fc$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ffdacb42eeac20fc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ffdacb42eeac20fc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $ffdacb42eeac20fc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $ffdacb42eeac20fc$export$2e2bcd8739ae039 = $ffdacb42eeac20fc$var$formatLong;


var $c77ddfc3a35297aa$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $c77ddfc3a35297aa$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c77ddfc3a35297aa$var$formatRelativeLocale[token];
};
var $c77ddfc3a35297aa$export$2e2bcd8739ae039 = $c77ddfc3a35297aa$var$formatRelative;



var $c8dff77396eafa81$var$eraValues = {
    narrow: [
        "P",
        "M"
    ],
    abbreviated: [
        "PK",
        "MK"
    ],
    wide: [
        "Para Krishtit",
        "Mbas Krishtit"
    ]
};
var $c8dff77396eafa81$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "4-mujori I",
        "4-mujori II",
        "4-mujori III",
        "4-mujori IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c8dff77396eafa81$var$monthValues = {
    narrow: [
        "J",
        "S",
        "M",
        "P",
        "M",
        "Q",
        "K",
        "G",
        "S",
        "T",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Shk",
        "Mar",
        "Pri",
        "Maj",
        "Qer",
        "Kor",
        "Gus",
        "Sht",
        "Tet",
        "N\xebn",
        "Dhj"
    ],
    wide: [
        "Janar",
        "Shkurt",
        "Mars",
        "Prill",
        "Maj",
        "Qershor",
        "Korrik",
        "Gusht",
        "Shtator",
        "Tetor",
        "N\xebntor",
        "Dhjetor"
    ]
};
var $c8dff77396eafa81$var$dayValues = {
    narrow: [
        "D",
        "H",
        "M",
        "M",
        "E",
        "P",
        "S"
    ],
    short: [
        "Di",
        "H\xeb",
        "Ma",
        "M\xeb",
        "En",
        "Pr",
        "Sh"
    ],
    abbreviated: [
        "Die",
        "H\xebn",
        "Mar",
        "M\xebr",
        "Enj",
        "Pre",
        "Sht"
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        "Enjte",
        "Premte",
        "Shtun\xeb"
    ]
};
var $c8dff77396eafa81$var$dayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "m\xebngjes",
        afternoon: "dite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var $c8dff77396eafa81$var$formattingDayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var $c8dff77396eafa81$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === "hour") return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + "t";
    return number + "-t\xeb";
};
var $c8dff77396eafa81$var$localize = {
    ordinalNumber: $c8dff77396eafa81$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c8dff77396eafa81$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c8dff77396eafa81$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c8dff77396eafa81$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c8dff77396eafa81$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c8dff77396eafa81$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c8dff77396eafa81$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c8dff77396eafa81$export$2e2bcd8739ae039 = $c8dff77396eafa81$var$localize;




var $4e1e7048fcb54504$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var $4e1e7048fcb54504$var$parseOrdinalNumberPattern = /\d+/i;
var $4e1e7048fcb54504$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var $4e1e7048fcb54504$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var $4e1e7048fcb54504$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var $4e1e7048fcb54504$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4e1e7048fcb54504$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var $4e1e7048fcb54504$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var $4e1e7048fcb54504$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var $4e1e7048fcb54504$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var $4e1e7048fcb54504$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var $4e1e7048fcb54504$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var $4e1e7048fcb54504$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $4e1e7048fcb54504$var$matchOrdinalNumberPattern,
        parsePattern: $4e1e7048fcb54504$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1e7048fcb54504$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1e7048fcb54504$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1e7048fcb54504$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1e7048fcb54504$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1e7048fcb54504$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1e7048fcb54504$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1e7048fcb54504$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4e1e7048fcb54504$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $4e1e7048fcb54504$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4e1e7048fcb54504$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $4e1e7048fcb54504$export$2e2bcd8739ae039 = $4e1e7048fcb54504$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var $31611afb540af3cc$var$locale = {
    code: "sq",
    formatDistance: (0, $960ec5dba3024bf6$export$2e2bcd8739ae039),
    formatLong: (0, $ffdacb42eeac20fc$export$2e2bcd8739ae039),
    formatRelative: (0, $c77ddfc3a35297aa$export$2e2bcd8739ae039),
    localize: (0, $c8dff77396eafa81$export$2e2bcd8739ae039),
    match: (0, $4e1e7048fcb54504$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $31611afb540af3cc$export$2e2bcd8739ae039 = $31611afb540af3cc$var$locale;


var $efb06e4b79969d33$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "мање од 1 секунде",
            withPrepositionAgo: "мање од 1 секунде",
            withPrepositionIn: "мање од 1 секунду"
        },
        dual: "мање од {{count}} секунде",
        other: "мање од {{count}} секунди"
    },
    xSeconds: {
        one: {
            standalone: "1 секунда",
            withPrepositionAgo: "1 секунде",
            withPrepositionIn: "1 секунду"
        },
        dual: "{{count}} секунде",
        other: "{{count}} секунди"
    },
    halfAMinute: "пола минуте",
    lessThanXMinutes: {
        one: {
            standalone: "мање од 1 минуте",
            withPrepositionAgo: "мање од 1 минуте",
            withPrepositionIn: "мање од 1 минуту"
        },
        dual: "мање од {{count}} минуте",
        other: "мање од {{count}} минута"
    },
    xMinutes: {
        one: {
            standalone: "1 минута",
            withPrepositionAgo: "1 минуте",
            withPrepositionIn: "1 минуту"
        },
        dual: "{{count}} минуте",
        other: "{{count}} минута"
    },
    aboutXHours: {
        one: {
            standalone: "око 1 сат",
            withPrepositionAgo: "око 1 сат",
            withPrepositionIn: "око 1 сат"
        },
        dual: "око {{count}} сата",
        other: "око {{count}} сати"
    },
    xHours: {
        one: {
            standalone: "1 сат",
            withPrepositionAgo: "1 сат",
            withPrepositionIn: "1 сат"
        },
        dual: "{{count}} сата",
        other: "{{count}} сати"
    },
    xDays: {
        one: {
            standalone: "1 дан",
            withPrepositionAgo: "1 дан",
            withPrepositionIn: "1 дан"
        },
        dual: "{{count}} дана",
        other: "{{count}} дана"
    },
    aboutXWeeks: {
        one: {
            standalone: "око 1 недељу",
            withPrepositionAgo: "око 1 недељу",
            withPrepositionIn: "око 1 недељу"
        },
        dual: "око {{count}} недеље",
        other: "око {{count}} недеље"
    },
    xWeeks: {
        one: {
            standalone: "1 недељу",
            withPrepositionAgo: "1 недељу",
            withPrepositionIn: "1 недељу"
        },
        dual: "{{count}} недеље",
        other: "{{count}} недеље"
    },
    aboutXMonths: {
        one: {
            standalone: "око 1 месец",
            withPrepositionAgo: "око 1 месец",
            withPrepositionIn: "око 1 месец"
        },
        dual: "око {{count}} месеца",
        other: "око {{count}} месеци"
    },
    xMonths: {
        one: {
            standalone: "1 месец",
            withPrepositionAgo: "1 месец",
            withPrepositionIn: "1 месец"
        },
        dual: "{{count}} месеца",
        other: "{{count}} месеци"
    },
    aboutXYears: {
        one: {
            standalone: "око 1 годину",
            withPrepositionAgo: "око 1 годину",
            withPrepositionIn: "око 1 годину"
        },
        dual: "око {{count}} године",
        other: "око {{count}} година"
    },
    xYears: {
        one: {
            standalone: "1 година",
            withPrepositionAgo: "1 године",
            withPrepositionIn: "1 годину"
        },
        dual: "{{count}} године",
        other: "{{count}} година"
    },
    overXYears: {
        one: {
            standalone: "преко 1 годину",
            withPrepositionAgo: "преко 1 годину",
            withPrepositionIn: "преко 1 годину"
        },
        dual: "преко {{count}} године",
        other: "преко {{count}} година"
    },
    almostXYears: {
        one: {
            standalone: "готово 1 годину",
            withPrepositionAgo: "готово 1 годину",
            withPrepositionIn: "готово 1 годину"
        },
        dual: "готово {{count}} године",
        other: "готово {{count}} година"
    }
};
var $efb06e4b79969d33$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $efb06e4b79969d33$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "за " + result;
        else return "пре " + result;
    }
    return result;
};
var $efb06e4b79969d33$export$2e2bcd8739ae039 = $efb06e4b79969d33$var$formatDistance;



var $17c443a2b4e7c349$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
var $17c443a2b4e7c349$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $17c443a2b4e7c349$var$dateTimeFormats = {
    full: "{{date}} 'у' {{time}}",
    long: "{{date}} 'у' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $17c443a2b4e7c349$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17c443a2b4e7c349$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17c443a2b4e7c349$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17c443a2b4e7c349$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $17c443a2b4e7c349$export$2e2bcd8739ae039 = $17c443a2b4e7c349$var$formatLong;


var $0883d0f7b3415cb0$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'прошле недеље у' p";
            case 3:
                return "'прошле среде у' p";
            case 6:
                return "'прошле суботе у' p";
            default:
                return "'прошли' EEEE 'у' p";
        }
    },
    yesterday: "'јуче у' p",
    today: "'данас у' p",
    tomorrow: "'сутра у' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'следеће недеље у' p";
            case 3:
                return "'следећу среду у' p";
            case 6:
                return "'следећу суботу у' p";
            default:
                return "'следећи' EEEE 'у' p";
        }
    },
    other: "P"
};
var $0883d0f7b3415cb0$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $0883d0f7b3415cb0$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $0883d0f7b3415cb0$export$2e2bcd8739ae039 = $0883d0f7b3415cb0$var$formatRelative;



var $2be743fa121094b8$var$eraValues = {
    narrow: [
        "пр.н.е.",
        "АД"
    ],
    abbreviated: [
        "пр. Хр.",
        "по. Хр."
    ],
    wide: [
        "Пре Христа",
        "После Христа"
    ]
};
var $2be743fa121094b8$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. кв.",
        "2. кв.",
        "3. кв.",
        "4. кв."
    ],
    wide: [
        "1. квартал",
        "2. квартал",
        "3. квартал",
        "4. квартал"
    ]
};
var $2be743fa121094b8$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "јан",
        "феб",
        "мар",
        "апр",
        "мај",
        "јун",
        "јул",
        "авг",
        "сеп",
        "окт",
        "нов",
        "дец"
    ],
    wide: [
        "јануар",
        "фебруар",
        "март",
        "април",
        "мај",
        "јун",
        "јул",
        "август",
        "септембар",
        "октобар",
        "новембар",
        "децембар"
    ]
};
var $2be743fa121094b8$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "јан",
        "феб",
        "мар",
        "апр",
        "мај",
        "јун",
        "јул",
        "авг",
        "сеп",
        "окт",
        "нов",
        "дец"
    ],
    wide: [
        "јануар",
        "фебруар",
        "март",
        "април",
        "мај",
        "јун",
        "јул",
        "август",
        "септембар",
        "октобар",
        "новембар",
        "децембар"
    ]
};
var $2be743fa121094b8$var$dayValues = {
    narrow: [
        "Н",
        "П",
        "У",
        "С",
        "Ч",
        "П",
        "С"
    ],
    short: [
        "нед",
        "пон",
        "уто",
        "сре",
        "чет",
        "пет",
        "суб"
    ],
    abbreviated: [
        "нед",
        "пон",
        "уто",
        "сре",
        "чет",
        "пет",
        "суб"
    ],
    wide: [
        "недеља",
        "понедељак",
        "уторак",
        "среда",
        "четвртак",
        "петак",
        "субота"
    ]
};
var $2be743fa121094b8$var$formattingDayPeriodValues = {
    narrow: {
        am: "АМ",
        pm: "ПМ",
        midnight: "поноћ",
        noon: "подне",
        morning: "ујутру",
        afternoon: "поподне",
        evening: "увече",
        night: "ноћу"
    },
    abbreviated: {
        am: "АМ",
        pm: "ПМ",
        midnight: "поноћ",
        noon: "подне",
        morning: "ујутру",
        afternoon: "поподне",
        evening: "увече",
        night: "ноћу"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "поноћ",
        noon: "подне",
        morning: "ујутру",
        afternoon: "после подне",
        evening: "увече",
        night: "ноћу"
    }
};
var $2be743fa121094b8$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "поноћ",
        noon: "подне",
        morning: "ујутру",
        afternoon: "поподне",
        evening: "увече",
        night: "ноћу"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "поноћ",
        noon: "подне",
        morning: "ујутру",
        afternoon: "поподне",
        evening: "увече",
        night: "ноћу"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "поноћ",
        noon: "подне",
        morning: "ујутру",
        afternoon: "после подне",
        evening: "увече",
        night: "ноћу"
    }
};
var $2be743fa121094b8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $2be743fa121094b8$var$localize = {
    ordinalNumber: $2be743fa121094b8$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $2be743fa121094b8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $2be743fa121094b8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $2be743fa121094b8$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $2be743fa121094b8$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $2be743fa121094b8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $2be743fa121094b8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2be743fa121094b8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $2be743fa121094b8$export$2e2bcd8739ae039 = $2be743fa121094b8$var$localize;




var $c81a702321204795$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $c81a702321204795$var$parseOrdinalNumberPattern = /\d+/i;
var $c81a702321204795$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var $c81a702321204795$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var $c81a702321204795$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var $c81a702321204795$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c81a702321204795$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var $c81a702321204795$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $c81a702321204795$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var $c81a702321204795$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var $c81a702321204795$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var $c81a702321204795$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var $c81a702321204795$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $c81a702321204795$var$matchOrdinalNumberPattern,
        parsePattern: $c81a702321204795$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c81a702321204795$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c81a702321204795$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c81a702321204795$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c81a702321204795$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c81a702321204795$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c81a702321204795$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c81a702321204795$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c81a702321204795$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $c81a702321204795$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c81a702321204795$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $c81a702321204795$export$2e2bcd8739ae039 = $c81a702321204795$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $90ff0240df1c0b0c$var$locale = {
    code: "sr",
    formatDistance: (0, $efb06e4b79969d33$export$2e2bcd8739ae039),
    formatLong: (0, $17c443a2b4e7c349$export$2e2bcd8739ae039),
    formatRelative: (0, $0883d0f7b3415cb0$export$2e2bcd8739ae039),
    localize: (0, $2be743fa121094b8$export$2e2bcd8739ae039),
    match: (0, $c81a702321204795$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $90ff0240df1c0b0c$export$2e2bcd8739ae039 = $90ff0240df1c0b0c$var$locale;


var $81d76164c397ff8d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 nedelju",
            withPrepositionAgo: "oko 1 nedelju",
            withPrepositionIn: "oko 1 nedelju"
        },
        dual: "oko {{count}} nedelje",
        other: "oko {{count}} nedelje"
    },
    xWeeks: {
        one: {
            standalone: "1 nedelju",
            withPrepositionAgo: "1 nedelju",
            withPrepositionIn: "1 nedelju"
        },
        dual: "{{count}} nedelje",
        other: "{{count}} nedelje"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mesec",
            withPrepositionAgo: "oko 1 mesec",
            withPrepositionIn: "oko 1 mesec"
        },
        dual: "oko {{count}} meseca",
        other: "oko {{count}} meseci"
    },
    xMonths: {
        one: {
            standalone: "1 mesec",
            withPrepositionAgo: "1 mesec",
            withPrepositionIn: "1 mesec"
        },
        dual: "{{count}} meseca",
        other: "{{count}} meseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
var $81d76164c397ff8d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $81d76164c397ff8d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "pre " + result;
    }
    return result;
};
var $81d76164c397ff8d$export$2e2bcd8739ae039 = $81d76164c397ff8d$var$formatDistance;



var $264af25b25cfa818$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
var $264af25b25cfa818$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $264af25b25cfa818$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $264af25b25cfa818$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $264af25b25cfa818$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $264af25b25cfa818$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $264af25b25cfa818$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $264af25b25cfa818$export$2e2bcd8739ae039 = $264af25b25cfa818$var$formatLong;


var $b04475d3f78cf5d7$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'prošle nedelje u' p";
            case 3:
                return "'prošle srede u' p";
            case 6:
                return "'prošle subote u' p";
            default:
                return "'prošli' EEEE 'u' p";
        }
    },
    yesterday: "'juče u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sledeće nedelje u' p";
            case 3:
                return "'sledeću sredu u' p";
            case 6:
                return "'sledeću subotu u' p";
            default:
                return "'sledeći' EEEE 'u' p";
        }
    },
    other: "P"
};
var $b04475d3f78cf5d7$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $b04475d3f78cf5d7$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $b04475d3f78cf5d7$export$2e2bcd8739ae039 = $b04475d3f78cf5d7$var$formatRelative;



var $8923163528f02ff6$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Pre Hrista",
        "Posle Hrista"
    ]
};
var $8923163528f02ff6$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $8923163528f02ff6$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $8923163528f02ff6$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $8923163528f02ff6$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "Č",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "čet",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "čet",
        "pet",
        "sub"
    ],
    wide: [
        "nedelja",
        "ponedeljak",
        "utorak",
        "sreda",
        "četvrtak",
        "petak",
        "subota"
    ]
};
var $8923163528f02ff6$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uveče",
        night: "noću"
    }
};
var $8923163528f02ff6$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uveče",
        night: "noću"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "ponoć",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uveče",
        night: "noću"
    }
};
var $8923163528f02ff6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $8923163528f02ff6$var$localize = {
    ordinalNumber: $8923163528f02ff6$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8923163528f02ff6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8923163528f02ff6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8923163528f02ff6$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $8923163528f02ff6$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8923163528f02ff6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $8923163528f02ff6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8923163528f02ff6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $8923163528f02ff6$export$2e2bcd8739ae039 = $8923163528f02ff6$var$localize;




var $a9243677ec18b303$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $a9243677ec18b303$var$parseOrdinalNumberPattern = /\d+/i;
var $a9243677ec18b303$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var $a9243677ec18b303$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $a9243677ec18b303$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $a9243677ec18b303$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a9243677ec18b303$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $a9243677ec18b303$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $a9243677ec18b303$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $a9243677ec18b303$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $a9243677ec18b303$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var $a9243677ec18b303$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $a9243677ec18b303$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a9243677ec18b303$var$matchOrdinalNumberPattern,
        parsePattern: $a9243677ec18b303$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a9243677ec18b303$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9243677ec18b303$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a9243677ec18b303$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9243677ec18b303$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a9243677ec18b303$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9243677ec18b303$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a9243677ec18b303$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a9243677ec18b303$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a9243677ec18b303$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a9243677ec18b303$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a9243677ec18b303$export$2e2bcd8739ae039 = $a9243677ec18b303$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $e2c78867160f7887$var$locale = {
    code: "sr-Latn",
    formatDistance: (0, $81d76164c397ff8d$export$2e2bcd8739ae039),
    formatLong: (0, $264af25b25cfa818$export$2e2bcd8739ae039),
    formatRelative: (0, $b04475d3f78cf5d7$export$2e2bcd8739ae039),
    localize: (0, $8923163528f02ff6$export$2e2bcd8739ae039),
    match: (0, $a9243677ec18b303$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e2c78867160f7887$export$2e2bcd8739ae039 = $e2c78867160f7887$var$locale;


var $0ee7846488f6b956$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: "en sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: "en minut",
        other: "{{count}} minuter"
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: "en timme",
        other: "{{count}} timmar"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: "en vecka",
        other: "{{count}} vecka"
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $0ee7846488f6b956$var$wordMapping = [
    "noll",
    "en",
    "tv\xe5",
    "tre",
    "fyra",
    "fem",
    "sex",
    "sju",
    "\xe5tta",
    "nio",
    "tio",
    "elva",
    "tolv"
];
var $0ee7846488f6b956$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0ee7846488f6b956$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $0ee7846488f6b956$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sedan";
    }
    return result;
};
var $0ee7846488f6b956$export$2e2bcd8739ae039 = $0ee7846488f6b956$var$formatDistance;



var $17866be29104273f$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
};
var $17866be29104273f$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $17866be29104273f$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $17866be29104273f$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17866be29104273f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17866be29104273f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17866be29104273f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $17866be29104273f$export$2e2bcd8739ae039 = $17866be29104273f$var$formatLong;


var $57dab816dbd6fe7c$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $57dab816dbd6fe7c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $57dab816dbd6fe7c$var$formatRelativeLocale[token];
};
var $57dab816dbd6fe7c$export$2e2bcd8739ae039 = $57dab816dbd6fe7c$var$formatRelative;



var $fabfcde2c0e7e5bf$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf6re Kristus",
        "efter Kristus"
    ]
};
var $fabfcde2c0e7e5bf$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1:a kvartalet",
        "2:a kvartalet",
        "3:e kvartalet",
        "4:e kvartalet"
    ]
};
var $fabfcde2c0e7e5bf$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "maj",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $fabfcde2c0e7e5bf$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf6",
        "m\xe5",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        "tis",
        "ons",
        "tors",
        "fre",
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $fabfcde2c0e7e5bf$var$dayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "morg.",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    abbreviated: {
        am: "f.m.",
        pm: "e.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: "eftermiddag",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "eftermiddag",
        evening: "kv\xe4ll",
        night: "natt"
    }
};
var $fabfcde2c0e7e5bf$var$formattingDayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $fabfcde2c0e7e5bf$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ":a";
    }
    return number + ":e";
};
var $fabfcde2c0e7e5bf$var$localize = {
    ordinalNumber: $fabfcde2c0e7e5bf$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $fabfcde2c0e7e5bf$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $fabfcde2c0e7e5bf$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $fabfcde2c0e7e5bf$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $fabfcde2c0e7e5bf$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $fabfcde2c0e7e5bf$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $fabfcde2c0e7e5bf$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $fabfcde2c0e7e5bf$export$2e2bcd8739ae039 = $fabfcde2c0e7e5bf$var$localize;




var $cabe6c27785f2408$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $cabe6c27785f2408$var$parseOrdinalNumberPattern = /\d+/i;
var $cabe6c27785f2408$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $cabe6c27785f2408$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $cabe6c27785f2408$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $cabe6c27785f2408$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cabe6c27785f2408$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $cabe6c27785f2408$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $cabe6c27785f2408$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $cabe6c27785f2408$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $cabe6c27785f2408$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $cabe6c27785f2408$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $cabe6c27785f2408$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $cabe6c27785f2408$var$matchOrdinalNumberPattern,
        parsePattern: $cabe6c27785f2408$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cabe6c27785f2408$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cabe6c27785f2408$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cabe6c27785f2408$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cabe6c27785f2408$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cabe6c27785f2408$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cabe6c27785f2408$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cabe6c27785f2408$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cabe6c27785f2408$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $cabe6c27785f2408$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cabe6c27785f2408$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $cabe6c27785f2408$export$2e2bcd8739ae039 = $cabe6c27785f2408$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $4a2c237fdb92252c$var$locale = {
    code: "sv",
    formatDistance: (0, $0ee7846488f6b956$export$2e2bcd8739ae039),
    formatLong: (0, $17866be29104273f$export$2e2bcd8739ae039),
    formatRelative: (0, $57dab816dbd6fe7c$export$2e2bcd8739ae039),
    localize: (0, $fabfcde2c0e7e5bf$export$2e2bcd8739ae039),
    match: (0, $cabe6c27785f2408$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4a2c237fdb92252c$export$2e2bcd8739ae039 = $4a2c237fdb92252c$var$locale;


function $74221cec6b5d293a$var$isPluralType(val) {
    return val.one !== undefined;
}
var $74221cec6b5d293a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "ஒரு வினாடிக்கு குறைவாக",
            in: "ஒரு வினாடிக்குள்",
            ago: "ஒரு வினாடிக்கு முன்பு"
        },
        other: {
            default: "{{count}} வினாடிகளுக்கு குறைவாக",
            in: "{{count}} வினாடிகளுக்குள்",
            ago: "{{count}} வினாடிகளுக்கு முன்பு"
        }
    },
    xSeconds: {
        one: {
            default: "1 வினாடி",
            in: "1 வினாடியில்",
            ago: "1 வினாடி முன்பு"
        },
        other: {
            default: "{{count}} விநாடிகள்",
            in: "{{count}} வினாடிகளில்",
            ago: "{{count}} விநாடிகளுக்கு முன்பு"
        }
    },
    halfAMinute: {
        default: "அரை நிமிடம்",
        in: "அரை நிமிடத்தில்",
        ago: "அரை நிமிடம் முன்பு"
    },
    lessThanXMinutes: {
        one: {
            default: "ஒரு நிமிடத்திற்கும் குறைவாக",
            in: "ஒரு நிமிடத்திற்குள்",
            ago: "ஒரு நிமிடத்திற்கு முன்பு"
        },
        other: {
            default: "{{count}} நிமிடங்களுக்கும் குறைவாக",
            in: "{{count}} நிமிடங்களுக்குள்",
            ago: "{{count}} நிமிடங்களுக்கு முன்பு"
        }
    },
    xMinutes: {
        one: {
            default: "1 நிமிடம்",
            in: "1 நிமிடத்தில்",
            ago: "1 நிமிடம் முன்பு"
        },
        other: {
            default: "{{count}} நிமிடங்கள்",
            in: "{{count}} நிமிடங்களில்",
            ago: "{{count}} நிமிடங்களுக்கு முன்பு"
        }
    },
    aboutXHours: {
        one: {
            default: "சுமார் 1 மணி நேரம்",
            in: "சுமார் 1 மணி நேரத்தில்",
            ago: "சுமார் 1 மணி நேரத்திற்கு முன்பு"
        },
        other: {
            default: "சுமார் {{count}} மணி நேரம்",
            in: "சுமார் {{count}} மணி நேரத்திற்கு முன்பு",
            ago: "சுமார் {{count}} மணி நேரத்தில்"
        }
    },
    xHours: {
        one: {
            default: "1 மணி நேரம்",
            in: "1 மணி நேரத்தில்",
            ago: "1 மணி நேரத்திற்கு முன்பு"
        },
        other: {
            default: "{{count}} மணி நேரம்",
            in: "{{count}} மணி நேரத்தில்",
            ago: "{{count}} மணி நேரத்திற்கு முன்பு"
        }
    },
    xDays: {
        one: {
            default: "1 நாள்",
            in: "1 நாளில்",
            ago: "1 நாள் முன்பு"
        },
        other: {
            default: "{{count}} நாட்கள்",
            in: "{{count}} நாட்களில்",
            ago: "{{count}} நாட்களுக்கு முன்பு"
        }
    },
    aboutXWeeks: {
        one: {
            default: "சுமார் 1 வாரம்",
            in: "சுமார் 1 வாரத்தில்",
            ago: "சுமார் 1 வாரம் முன்பு"
        },
        other: {
            default: "சுமார் {{count}} வாரங்கள்",
            in: "சுமார் {{count}} வாரங்களில்",
            ago: "சுமார் {{count}} வாரங்களுக்கு முன்பு"
        }
    },
    xWeeks: {
        one: {
            default: "1 வாரம்",
            in: "1 வாரத்தில்",
            ago: "1 வாரம் முன்பு"
        },
        other: {
            default: "{{count}} வாரங்கள்",
            in: "{{count}} வாரங்களில்",
            ago: "{{count}} வாரங்களுக்கு முன்பு"
        }
    },
    aboutXMonths: {
        one: {
            default: "சுமார் 1 மாதம்",
            in: "சுமார் 1 மாதத்தில்",
            ago: "சுமார் 1 மாதத்திற்கு முன்பு"
        },
        other: {
            default: "சுமார் {{count}} மாதங்கள்",
            in: "சுமார் {{count}} மாதங்களில்",
            ago: "சுமார் {{count}} மாதங்களுக்கு முன்பு"
        }
    },
    xMonths: {
        one: {
            default: "1 மாதம்",
            in: "1 மாதத்தில்",
            ago: "1 மாதம் முன்பு"
        },
        other: {
            default: "{{count}} மாதங்கள்",
            in: "{{count}} மாதங்களில்",
            ago: "{{count}} மாதங்களுக்கு முன்பு"
        }
    },
    aboutXYears: {
        one: {
            default: "சுமார் 1 வருடம்",
            in: "சுமார் 1 ஆண்டில்",
            ago: "சுமார் 1 வருடம் முன்பு"
        },
        other: {
            default: "சுமார் {{count}} ஆண்டுகள்",
            in: "சுமார் {{count}} ஆண்டுகளில்",
            ago: "சுமார் {{count}} ஆண்டுகளுக்கு முன்பு"
        }
    },
    xYears: {
        one: {
            default: "1 வருடம்",
            in: "1 ஆண்டில்",
            ago: "1 வருடம் முன்பு"
        },
        other: {
            default: "{{count}} ஆண்டுகள்",
            in: "{{count}} ஆண்டுகளில்",
            ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
        }
    },
    overXYears: {
        one: {
            default: "1 வருடத்திற்கு மேல்",
            in: "1 வருடத்திற்கும் மேலாக",
            ago: "1 வருடம் முன்பு"
        },
        other: {
            default: "{{count}} ஆண்டுகளுக்கும் மேலாக",
            in: "{{count}} ஆண்டுகளில்",
            ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
        }
    },
    almostXYears: {
        one: {
            default: "கிட்டத்தட்ட 1 வருடம்",
            in: "கிட்டத்தட்ட 1 ஆண்டில்",
            ago: "கிட்டத்தட்ட 1 வருடம் முன்பு"
        },
        other: {
            default: "கிட்டத்தட்ட {{count}} ஆண்டுகள்",
            in: "கிட்டத்தட்ட {{count}} ஆண்டுகளில்",
            ago: "கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு"
        }
    }
};
var $74221cec6b5d293a$var$formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? "in" : "ago" : "default";
    var tokenValue = $74221cec6b5d293a$var$formatDistanceLocale[token];
    if (!$74221cec6b5d293a$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace("{{count}}", String(count));
};
var $74221cec6b5d293a$export$2e2bcd8739ae039 = $74221cec6b5d293a$var$formatDistance;



// CLDR #1846 - #1849
var $6251f7defb4d72e0$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
// CLDR #1850 - #1853
var $6251f7defb4d72e0$var$timeFormats = {
    full: "a h:mm:ss zzzz",
    long: "a h:mm:ss z",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $6251f7defb4d72e0$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $6251f7defb4d72e0$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6251f7defb4d72e0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6251f7defb4d72e0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $6251f7defb4d72e0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $6251f7defb4d72e0$export$2e2bcd8739ae039 = $6251f7defb4d72e0$var$formatLong;


var $46145cbb39fb9c69$var$formatRelativeLocale = {
    lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
    yesterday: "'நேற்று ' p 'மணிக்கு'",
    today: "'இன்று ' p 'மணிக்கு'",
    tomorrow: "'நாளை ' p 'மணிக்கு'",
    nextWeek: "eeee p 'மணிக்கு'",
    other: "P"
};
var $46145cbb39fb9c69$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $46145cbb39fb9c69$var$formatRelativeLocale[token];
};
var $46145cbb39fb9c69$export$2e2bcd8739ae039 = $46145cbb39fb9c69$var$formatRelative;



var $669327c4081bd081$var$eraValues = {
    narrow: [
        "கி.மு.",
        "கி.பி."
    ],
    abbreviated: [
        "கி.மு.",
        "கி.பி."
    ],
    // CLDR #1624, #1626
    wide: [
        "கிறிஸ்துவுக்கு முன்",
        "அன்னோ டோமினி"
    ] // CLDR #1620, #1622
};
var $669327c4081bd081$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "காலா.1",
        "காலா.2",
        "காலா.3",
        "காலா.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "ஒன்றாம் காலாண்டு",
        "இரண்டாம் காலாண்டு",
        "மூன்றாம் காலாண்டு",
        "நான்காம் காலாண்டு"
    ]
};
var $669327c4081bd081$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "ஜ",
        "பி",
        "மா",
        "ஏ",
        "மே",
        "ஜூ",
        "ஜூ",
        "ஆ",
        "செ",
        "அ",
        "ந",
        "டி"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "ஜன.",
        "பிப்.",
        "மார்.",
        "ஏப்.",
        "மே",
        "ஜூன்",
        "ஜூலை",
        "ஆக.",
        "செப்.",
        "அக்.",
        "நவ.",
        "டிச."
    ],
    // CLDR #1652 - #1663
    wide: [
        "ஜனவரி",
        // January
        "பிப்ரவரி",
        // February
        "மார்ச்",
        // March
        "ஏப்ரல்",
        // April
        "மே",
        // May
        "ஜூன்",
        // June
        "ஜூலை",
        // July
        "ஆகஸ்ட்",
        // August
        "செப்டம்பர்",
        // September
        "அக்டோபர்",
        // October
        "நவம்பர்",
        // November
        "டிசம்பர்" // December
    ]
};
var $669327c4081bd081$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "ஞா",
        "தி",
        "செ",
        "பு",
        "வி",
        "வெ",
        "ச"
    ],
    // CLDR #1752 - #1758
    short: [
        "ஞா",
        "தி",
        "செ",
        "பு",
        "வி",
        "வெ",
        "ச"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "ஞாயி.",
        "திங்.",
        "செவ்.",
        "புத.",
        "வியா.",
        "வெள்.",
        "சனி"
    ],
    // CLDR #1724 - #1730
    wide: [
        "ஞாயிறு",
        // Sunday
        "திங்கள்",
        // Monday
        "செவ்வாய்",
        // Tuesday
        "புதன்",
        // Wednesday
        "வியாழன்",
        // Thursday
        "வெள்ளி",
        // Friday
        "சனி" // Saturday
    ]
};
// CLDR #1780 - #1845
var $669327c4081bd081$var$dayPeriodValues = {
    narrow: {
        am: "மு.ப",
        pm: "பி.ப",
        midnight: "நள்.",
        noon: "நண்.",
        morning: "கா.",
        afternoon: "மதி.",
        evening: "மா.",
        night: "இர."
    },
    abbreviated: {
        am: "முற்பகல்",
        pm: "பிற்பகல்",
        midnight: "நள்ளிரவு",
        noon: "நண்பகல்",
        morning: "காலை",
        afternoon: "மதியம்",
        evening: "மாலை",
        night: "இரவு"
    },
    wide: {
        am: "முற்பகல்",
        pm: "பிற்பகல்",
        midnight: "நள்ளிரவு",
        noon: "நண்பகல்",
        morning: "காலை",
        afternoon: "மதியம்",
        evening: "மாலை",
        night: "இரவு"
    }
};
// CLDR #1780 - #1845
var $669327c4081bd081$var$formattingDayPeriodValues = {
    narrow: {
        am: "மு.ப",
        pm: "பி.ப",
        midnight: "நள்.",
        noon: "நண்.",
        morning: "கா.",
        afternoon: "மதி.",
        evening: "மா.",
        night: "இர."
    },
    abbreviated: {
        am: "முற்பகல்",
        pm: "பிற்பகல்",
        midnight: "நள்ளிரவு",
        noon: "நண்பகல்",
        morning: "காலை",
        afternoon: "மதியம்",
        evening: "மாலை",
        night: "இரவு"
    },
    wide: {
        am: "முற்பகல்",
        pm: "பிற்பகல்",
        midnight: "நள்ளிரவு",
        noon: "நண்பகல்",
        morning: "காலை",
        afternoon: "மதியம்",
        evening: "மாலை",
        night: "இரவு"
    }
};
var $669327c4081bd081$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $669327c4081bd081$var$localize = {
    ordinalNumber: $669327c4081bd081$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $669327c4081bd081$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $669327c4081bd081$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $669327c4081bd081$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $669327c4081bd081$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $669327c4081bd081$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $669327c4081bd081$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $669327c4081bd081$export$2e2bcd8739ae039 = $669327c4081bd081$var$localize;




var $168f0a9699879e1f$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var $168f0a9699879e1f$var$parseOrdinalNumberPattern = /\d+/i;
var $168f0a9699879e1f$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var $168f0a9699879e1f$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var $168f0a9699879e1f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var $168f0a9699879e1f$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var $168f0a9699879e1f$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var $168f0a9699879e1f$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var $168f0a9699879e1f$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var $168f0a9699879e1f$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var $168f0a9699879e1f$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var $168f0a9699879e1f$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var $168f0a9699879e1f$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $168f0a9699879e1f$var$matchOrdinalNumberPattern,
        parsePattern: $168f0a9699879e1f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $168f0a9699879e1f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $168f0a9699879e1f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $168f0a9699879e1f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $168f0a9699879e1f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $168f0a9699879e1f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $168f0a9699879e1f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $168f0a9699879e1f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $168f0a9699879e1f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $168f0a9699879e1f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $168f0a9699879e1f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $168f0a9699879e1f$export$2e2bcd8739ae039 = $168f0a9699879e1f$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var $13dc2957a9be2343$var$locale = {
    code: "ta",
    formatDistance: (0, $74221cec6b5d293a$export$2e2bcd8739ae039),
    formatLong: (0, $6251f7defb4d72e0$export$2e2bcd8739ae039),
    formatRelative: (0, $46145cbb39fb9c69$export$2e2bcd8739ae039),
    localize: (0, $669327c4081bd081$export$2e2bcd8739ae039),
    match: (0, $168f0a9699879e1f$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $13dc2957a9be2343$export$2e2bcd8739ae039 = $13dc2957a9be2343$var$locale;


// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $81b5972827a0d89a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "సెకను కన్నా తక్కువ",
            other: "{{count}} సెకన్ల కన్నా తక్కువ"
        },
        withPreposition: {
            one: "సెకను",
            other: "{{count}} సెకన్ల"
        }
    },
    xSeconds: {
        standalone: {
            one: "ఒక సెకను",
            // CLDR #1314
            other: "{{count}} సెకన్ల"
        },
        withPreposition: {
            one: "ఒక సెకను",
            other: "{{count}} సెకన్ల"
        }
    },
    halfAMinute: {
        standalone: "అర నిమిషం",
        withPreposition: "అర నిమిషం"
    },
    lessThanXMinutes: {
        standalone: {
            one: "ఒక నిమిషం కన్నా తక్కువ",
            other: "{{count}} నిమిషాల కన్నా తక్కువ"
        },
        withPreposition: {
            one: "ఒక నిమిషం",
            other: "{{count}} నిమిషాల"
        }
    },
    xMinutes: {
        standalone: {
            one: "ఒక నిమిషం",
            // CLDR #1311
            other: "{{count}} నిమిషాలు"
        },
        withPreposition: {
            one: "ఒక నిమిషం",
            // CLDR #1311
            other: "{{count}} నిమిషాల"
        }
    },
    aboutXHours: {
        standalone: {
            one: "సుమారు ఒక గంట",
            other: "సుమారు {{count}} గంటలు"
        },
        withPreposition: {
            one: "సుమారు ఒక గంట",
            other: "సుమారు {{count}} గంటల"
        }
    },
    xHours: {
        standalone: {
            one: "ఒక గంట",
            // CLDR #1308
            other: "{{count}} గంటలు"
        },
        withPreposition: {
            one: "ఒక గంట",
            other: "{{count}} గంటల"
        }
    },
    xDays: {
        standalone: {
            one: "ఒక రోజు",
            // CLDR #1292
            other: "{{count}} రోజులు"
        },
        withPreposition: {
            one: "ఒక రోజు",
            other: "{{count}} రోజుల"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "సుమారు ఒక వారం",
            other: "సుమారు {{count}} వారాలు"
        },
        withPreposition: {
            one: "సుమారు ఒక వారం",
            other: "సుమారు {{count}} వారాలల"
        }
    },
    xWeeks: {
        standalone: {
            one: "ఒక వారం",
            other: "{{count}} వారాలు"
        },
        withPreposition: {
            one: "ఒక వారం",
            other: "{{count}} వారాలల"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "సుమారు ఒక నెల",
            other: "సుమారు {{count}} నెలలు"
        },
        withPreposition: {
            one: "సుమారు ఒక నెల",
            other: "సుమారు {{count}} నెలల"
        }
    },
    xMonths: {
        standalone: {
            one: "ఒక నెల",
            // CLDR #1281
            other: "{{count}} నెలలు"
        },
        withPreposition: {
            one: "ఒక నెల",
            other: "{{count}} నెలల"
        }
    },
    aboutXYears: {
        standalone: {
            one: "సుమారు ఒక సంవత్సరం",
            other: "సుమారు {{count}} సంవత్సరాలు"
        },
        withPreposition: {
            one: "సుమారు ఒక సంవత్సరం",
            other: "సుమారు {{count}} సంవత్సరాల"
        }
    },
    xYears: {
        standalone: {
            one: "ఒక సంవత్సరం",
            // CLDR #1275
            other: "{{count}} సంవత్సరాలు"
        },
        withPreposition: {
            one: "ఒక సంవత్సరం",
            other: "{{count}} సంవత్సరాల"
        }
    },
    overXYears: {
        standalone: {
            one: "ఒక సంవత్సరం పైగా",
            other: "{{count}} సంవత్సరాలకు పైగా"
        },
        withPreposition: {
            one: "ఒక సంవత్సరం",
            other: "{{count}} సంవత్సరాల"
        }
    },
    almostXYears: {
        standalone: {
            one: "దాదాపు ఒక సంవత్సరం",
            other: "దాదాపు {{count}} సంవత్సరాలు"
        },
        withPreposition: {
            one: "దాదాపు ఒక సంవత్సరం",
            other: "దాదాపు {{count}} సంవత్సరాల"
        }
    }
};
var $81b5972827a0d89a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $81b5972827a0d89a$var$formatDistanceLocale[token].withPreposition : $81b5972827a0d89a$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "లో";
        else return result + " క్రితం";
    }
    return result;
};
var $81b5972827a0d89a$export$2e2bcd8739ae039 = $81b5972827a0d89a$var$formatDistance;



// CLDR #1807 - #1811
var $fa562c819061528b$var$dateFormats = {
    full: "d, MMMM y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd-MM-yy"
};
// CLDR #1807 - #1811
var $fa562c819061528b$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
// CLDR #1815 - #1818
var $fa562c819061528b$var$dateTimeFormats = {
    full: "{{date}} {{time}}'కి'",
    long: "{{date}} {{time}}'కి'",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $fa562c819061528b$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $fa562c819061528b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $fa562c819061528b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $fa562c819061528b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $fa562c819061528b$export$2e2bcd8739ae039 = $fa562c819061528b$var$formatLong;


// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $50c9f71700aa7604$var$formatRelativeLocale = {
    lastWeek: "'గత' eeee p",
    // CLDR #1384
    yesterday: "'నిన్న' p",
    // CLDR #1393
    today: "'ఈ రోజు' p",
    // CLDR #1394
    tomorrow: "'రేపు' p",
    // CLDR #1395
    nextWeek: "'తదుపరి' eeee p",
    // CLDR #1386
    other: "P"
};
var $50c9f71700aa7604$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $50c9f71700aa7604$var$formatRelativeLocale[token];
};
var $50c9f71700aa7604$export$2e2bcd8739ae039 = $50c9f71700aa7604$var$formatRelative;



// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var $496e71acda6a7726$var$eraValues = {
    narrow: [
        "క్రీ.పూ.",
        "క్రీ.శ."
    ],
    abbreviated: [
        "క్రీ.పూ.",
        "క్రీ.శ."
    ],
    wide: [
        "క్రీస్తు పూర్వం",
        "క్రీస్తుశకం"
    ]
};
// CLDR #1613 - #1628
var $496e71acda6a7726$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "త్రై1",
        "త్రై2",
        "త్రై3",
        "త్రై4"
    ],
    wide: [
        "1వ త్రైమాసికం",
        "2వ త్రైమాసికం",
        "3వ త్రైమాసికం",
        "4వ త్రైమాసికం"
    ]
};
// CLDR #1637 - #1708
var $496e71acda6a7726$var$monthValues = {
    narrow: [
        "జ",
        "ఫి",
        "మా",
        "ఏ",
        "మే",
        "జూ",
        "జు",
        "ఆ",
        "సె",
        "అ",
        "న",
        "డి"
    ],
    abbreviated: [
        "జన",
        "ఫిబ్ర",
        "మార్చి",
        "ఏప్రి",
        "మే",
        "జూన్",
        "జులై",
        "ఆగ",
        "సెప్టెం",
        "అక్టో",
        "నవం",
        "డిసెం"
    ],
    wide: [
        "జనవరి",
        "ఫిబ్రవరి",
        "మార్చి",
        "ఏప్రిల్",
        "మే",
        "జూన్",
        "జులై",
        "ఆగస్టు",
        "సెప్టెంబర్",
        "అక్టోబర్",
        "నవంబర్",
        "డిసెంబర్"
    ]
};
// CLDR #1709 - #1764
var $496e71acda6a7726$var$dayValues = {
    narrow: [
        "ఆ",
        "సో",
        "మ",
        "బు",
        "గు",
        "శు",
        "శ"
    ],
    short: [
        "ఆది",
        "సోమ",
        "మంగళ",
        "బుధ",
        "గురు",
        "శుక్ర",
        "శని"
    ],
    abbreviated: [
        "ఆది",
        "సోమ",
        "మంగళ",
        "బుధ",
        "గురు",
        "శుక్ర",
        "శని"
    ],
    wide: [
        "ఆదివారం",
        "సోమవారం",
        "మంగళవారం",
        "బుధవారం",
        "గురువారం",
        "శుక్రవారం",
        "శనివారం"
    ]
};
// CLDR #1767 - #1806
var $496e71acda6a7726$var$dayPeriodValues = {
    narrow: {
        am: "పూర్వాహ్నం",
        pm: "అపరాహ్నం",
        midnight: "అర్ధరాత్రి",
        noon: "మిట్టమధ్యాహ్నం",
        morning: "ఉదయం",
        afternoon: "మధ్యాహ్నం",
        evening: "సాయంత్రం",
        night: "రాత్రి"
    },
    abbreviated: {
        am: "పూర్వాహ్నం",
        pm: "అపరాహ్నం",
        midnight: "అర్ధరాత్రి",
        noon: "మిట్టమధ్యాహ్నం",
        morning: "ఉదయం",
        afternoon: "మధ్యాహ్నం",
        evening: "సాయంత్రం",
        night: "రాత్రి"
    },
    wide: {
        am: "పూర్వాహ్నం",
        pm: "అపరాహ్నం",
        midnight: "అర్ధరాత్రి",
        noon: "మిట్టమధ్యాహ్నం",
        morning: "ఉదయం",
        afternoon: "మధ్యాహ్నం",
        evening: "సాయంత్రం",
        night: "రాత్రి"
    }
};
var $496e71acda6a7726$var$formattingDayPeriodValues = {
    narrow: {
        am: "పూర్వాహ్నం",
        pm: "అపరాహ్నం",
        midnight: "అర్ధరాత్రి",
        noon: "మిట్టమధ్యాహ్నం",
        morning: "ఉదయం",
        afternoon: "మధ్యాహ్నం",
        evening: "సాయంత్రం",
        night: "రాత్రి"
    },
    abbreviated: {
        am: "పూర్వాహ్నం",
        pm: "అపరాహ్నం",
        midnight: "అర్ధరాత్రి",
        noon: "మిట్టమధ్యాహ్నం",
        morning: "ఉదయం",
        afternoon: "మధ్యాహ్నం",
        evening: "సాయంత్రం",
        night: "రాత్రి"
    },
    wide: {
        am: "పూర్వాహ్నం",
        pm: "అపరాహ్నం",
        midnight: "అర్ధరాత్రి",
        noon: "మిట్టమధ్యాహ్నం",
        morning: "ఉదయం",
        afternoon: "మధ్యాహ్నం",
        evening: "సాయంత్రం",
        night: "రాత్రి"
    }
};
var $496e71acda6a7726$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "వ";
};
var $496e71acda6a7726$var$localize = {
    ordinalNumber: $496e71acda6a7726$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $496e71acda6a7726$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $496e71acda6a7726$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $496e71acda6a7726$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $496e71acda6a7726$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $496e71acda6a7726$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $496e71acda6a7726$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $496e71acda6a7726$export$2e2bcd8739ae039 = $496e71acda6a7726$var$localize;




var $fef8e9ce963c93ef$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var $fef8e9ce963c93ef$var$parseOrdinalNumberPattern = /\d+/i;
var $fef8e9ce963c93ef$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var $fef8e9ce963c93ef$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var $fef8e9ce963c93ef$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var $fef8e9ce963c93ef$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fef8e9ce963c93ef$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var $fef8e9ce963c93ef$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var $fef8e9ce963c93ef$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var $fef8e9ce963c93ef$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var $fef8e9ce963c93ef$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var $fef8e9ce963c93ef$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var $fef8e9ce963c93ef$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $fef8e9ce963c93ef$var$matchOrdinalNumberPattern,
        parsePattern: $fef8e9ce963c93ef$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $fef8e9ce963c93ef$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fef8e9ce963c93ef$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $fef8e9ce963c93ef$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fef8e9ce963c93ef$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $fef8e9ce963c93ef$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fef8e9ce963c93ef$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $fef8e9ce963c93ef$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fef8e9ce963c93ef$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $fef8e9ce963c93ef$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fef8e9ce963c93ef$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $fef8e9ce963c93ef$export$2e2bcd8739ae039 = $fef8e9ce963c93ef$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var $e6c1073ec9e8542a$var$locale = {
    code: "te",
    formatDistance: (0, $81b5972827a0d89a$export$2e2bcd8739ae039),
    formatLong: (0, $fa562c819061528b$export$2e2bcd8739ae039),
    formatRelative: (0, $50c9f71700aa7604$export$2e2bcd8739ae039),
    localize: (0, $496e71acda6a7726$export$2e2bcd8739ae039),
    match: (0, $fef8e9ce963c93ef$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $e6c1073ec9e8542a$export$2e2bcd8739ae039 = $e6c1073ec9e8542a$var$locale;


var $afb83a6417f1a84b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "น้อยกว่า 1 วินาที",
        other: "น้อยกว่า {{count}} วินาที"
    },
    xSeconds: {
        one: "1 วินาที",
        other: "{{count}} วินาที"
    },
    halfAMinute: "ครึ่งนาที",
    lessThanXMinutes: {
        one: "น้อยกว่า 1 นาที",
        other: "น้อยกว่า {{count}} นาที"
    },
    xMinutes: {
        one: "1 นาที",
        other: "{{count}} นาที"
    },
    aboutXHours: {
        one: "ประมาณ 1 ชั่วโมง",
        other: "ประมาณ {{count}} ชั่วโมง"
    },
    xHours: {
        one: "1 ชั่วโมง",
        other: "{{count}} ชั่วโมง"
    },
    xDays: {
        one: "1 วัน",
        other: "{{count}} วัน"
    },
    aboutXWeeks: {
        one: "ประมาณ 1 สัปดาห์",
        other: "ประมาณ {{count}} สัปดาห์"
    },
    xWeeks: {
        one: "1 สัปดาห์",
        other: "{{count}} สัปดาห์"
    },
    aboutXMonths: {
        one: "ประมาณ 1 เดือน",
        other: "ประมาณ {{count}} เดือน"
    },
    xMonths: {
        one: "1 เดือน",
        other: "{{count}} เดือน"
    },
    aboutXYears: {
        one: "ประมาณ 1 ปี",
        other: "ประมาณ {{count}} ปี"
    },
    xYears: {
        one: "1 ปี",
        other: "{{count}} ปี"
    },
    overXYears: {
        one: "มากกว่า 1 ปี",
        other: "มากกว่า {{count}} ปี"
    },
    almostXYears: {
        one: "เกือบ 1 ปี",
        other: "เกือบ {{count}} ปี"
    }
};
var $afb83a6417f1a84b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $afb83a6417f1a84b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === "halfAMinute") return "ใน" + result;
            else return "ใน " + result;
        } else return result + "ที่ผ่านมา";
    }
    return result;
};
var $afb83a6417f1a84b$export$2e2bcd8739ae039 = $afb83a6417f1a84b$var$formatDistance;



var $2b3e5ad76f8bad65$var$dateFormats = {
    full: "วันEEEEที่ do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $2b3e5ad76f8bad65$var$timeFormats = {
    full: "H:mm:ss น. zzzz",
    long: "H:mm:ss น. z",
    medium: "H:mm:ss น.",
    short: "H:mm น."
};
var $2b3e5ad76f8bad65$var$dateTimeFormats = {
    full: "{{date}} 'เวลา' {{time}}",
    long: "{{date}} 'เวลา' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $2b3e5ad76f8bad65$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2b3e5ad76f8bad65$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2b3e5ad76f8bad65$var$timeFormats,
        defaultWidth: "medium"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $2b3e5ad76f8bad65$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2b3e5ad76f8bad65$export$2e2bcd8739ae039 = $2b3e5ad76f8bad65$var$formatLong;


var $fbeed638f5d75435$var$formatRelativeLocale = {
    lastWeek: "eeee'ที่แล้วเวลา' p",
    yesterday: "'เมื่อวานนี้เวลา' p",
    today: "'วันนี้เวลา' p",
    tomorrow: "'พรุ่งนี้เวลา' p",
    nextWeek: "eeee 'เวลา' p",
    other: "P"
};
var $fbeed638f5d75435$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fbeed638f5d75435$var$formatRelativeLocale[token];
};
var $fbeed638f5d75435$export$2e2bcd8739ae039 = $fbeed638f5d75435$var$formatRelative;



var $06d613c90c7426f5$var$eraValues = {
    narrow: [
        "B",
        "คศ"
    ],
    abbreviated: [
        "BC",
        "ค.ศ."
    ],
    wide: [
        "ปีก่อนคริสตกาล",
        "คริสต์ศักราช"
    ]
};
var $06d613c90c7426f5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "ไตรมาสแรก",
        "ไตรมาสที่สอง",
        "ไตรมาสที่สาม",
        "ไตรมาสที่สี่"
    ]
};
var $06d613c90c7426f5$var$dayValues = {
    narrow: [
        "อา.",
        "จ.",
        "อ.",
        "พ.",
        "พฤ.",
        "ศ.",
        "ส."
    ],
    short: [
        "อา.",
        "จ.",
        "อ.",
        "พ.",
        "พฤ.",
        "ศ.",
        "ส."
    ],
    abbreviated: [
        "อา.",
        "จ.",
        "อ.",
        "พ.",
        "พฤ.",
        "ศ.",
        "ส."
    ],
    wide: [
        "อาทิตย์",
        "จันทร์",
        "อังคาร",
        "พุธ",
        "พฤหัสบดี",
        "ศุกร์",
        "เสาร์"
    ]
};
var $06d613c90c7426f5$var$monthValues = {
    narrow: [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
    ],
    abbreviated: [
        "ม.ค.",
        "ก.พ.",
        "มี.ค.",
        "เม.ย.",
        "พ.ค.",
        "มิ.ย.",
        "ก.ค.",
        "ส.ค.",
        "ก.ย.",
        "ต.ค.",
        "พ.ย.",
        "ธ.ค."
    ],
    wide: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม"
    ]
};
var $06d613c90c7426f5$var$dayPeriodValues = {
    narrow: {
        am: "ก่อนเที่ยง",
        pm: "หลังเที่ยง",
        midnight: "เที่ยงคืน",
        noon: "เที่ยง",
        morning: "เช้า",
        afternoon: "บ่าย",
        evening: "เย็น",
        night: "กลางคืน"
    },
    abbreviated: {
        am: "ก่อนเที่ยง",
        pm: "หลังเที่ยง",
        midnight: "เที่ยงคืน",
        noon: "เที่ยง",
        morning: "เช้า",
        afternoon: "บ่าย",
        evening: "เย็น",
        night: "กลางคืน"
    },
    wide: {
        am: "ก่อนเที่ยง",
        pm: "หลังเที่ยง",
        midnight: "เที่ยงคืน",
        noon: "เที่ยง",
        morning: "เช้า",
        afternoon: "บ่าย",
        evening: "เย็น",
        night: "กลางคืน"
    }
};
var $06d613c90c7426f5$var$formattingDayPeriodValues = {
    narrow: {
        am: "ก่อนเที่ยง",
        pm: "หลังเที่ยง",
        midnight: "เที่ยงคืน",
        noon: "เที่ยง",
        morning: "ตอนเช้า",
        afternoon: "ตอนกลางวัน",
        evening: "ตอนเย็น",
        night: "ตอนกลางคืน"
    },
    abbreviated: {
        am: "ก่อนเที่ยง",
        pm: "หลังเที่ยง",
        midnight: "เที่ยงคืน",
        noon: "เที่ยง",
        morning: "ตอนเช้า",
        afternoon: "ตอนกลางวัน",
        evening: "ตอนเย็น",
        night: "ตอนกลางคืน"
    },
    wide: {
        am: "ก่อนเที่ยง",
        pm: "หลังเที่ยง",
        midnight: "เที่ยงคืน",
        noon: "เที่ยง",
        morning: "ตอนเช้า",
        afternoon: "ตอนกลางวัน",
        evening: "ตอนเย็น",
        night: "ตอนกลางคืน"
    }
};
var $06d613c90c7426f5$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $06d613c90c7426f5$var$localize = {
    ordinalNumber: $06d613c90c7426f5$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $06d613c90c7426f5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $06d613c90c7426f5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $06d613c90c7426f5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $06d613c90c7426f5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $06d613c90c7426f5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $06d613c90c7426f5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $06d613c90c7426f5$export$2e2bcd8739ae039 = $06d613c90c7426f5$var$localize;




var $e29a6e768f3a9e1e$var$matchOrdinalNumberPattern = /^\d+/i;
var $e29a6e768f3a9e1e$var$parseOrdinalNumberPattern = /\d+/i;
var $e29a6e768f3a9e1e$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var $e29a6e768f3a9e1e$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var $e29a6e768f3a9e1e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var $e29a6e768f3a9e1e$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var $e29a6e768f3a9e1e$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var $e29a6e768f3a9e1e$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var $e29a6e768f3a9e1e$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var $e29a6e768f3a9e1e$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var $e29a6e768f3a9e1e$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var $e29a6e768f3a9e1e$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var $e29a6e768f3a9e1e$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $e29a6e768f3a9e1e$var$matchOrdinalNumberPattern,
        parsePattern: $e29a6e768f3a9e1e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e29a6e768f3a9e1e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29a6e768f3a9e1e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e29a6e768f3a9e1e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29a6e768f3a9e1e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e29a6e768f3a9e1e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29a6e768f3a9e1e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e29a6e768f3a9e1e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e29a6e768f3a9e1e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $e29a6e768f3a9e1e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e29a6e768f3a9e1e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e29a6e768f3a9e1e$export$2e2bcd8739ae039 = $e29a6e768f3a9e1e$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var $8606191b94fc0138$var$locale = {
    code: "th",
    formatDistance: (0, $afb83a6417f1a84b$export$2e2bcd8739ae039),
    formatLong: (0, $2b3e5ad76f8bad65$export$2e2bcd8739ae039),
    formatRelative: (0, $fbeed638f5d75435$export$2e2bcd8739ae039),
    localize: (0, $06d613c90c7426f5$export$2e2bcd8739ae039),
    match: (0, $e29a6e768f3a9e1e$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8606191b94fc0138$export$2e2bcd8739ae039 = $8606191b94fc0138$var$locale;


var $834f130faa93d15e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniyeden az",
        other: "{{count}} saniyeden az"
    },
    xSeconds: {
        one: "1 saniye",
        other: "{{count}} saniye"
    },
    halfAMinute: "yarım dakika",
    lessThanXMinutes: {
        one: "bir dakikadan az",
        other: "{{count}} dakikadan az"
    },
    xMinutes: {
        one: "1 dakika",
        other: "{{count}} dakika"
    },
    aboutXHours: {
        one: "yaklaşık 1 saat",
        other: "yaklaşık {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yaklaşık 1 hafta",
        other: "yaklaşık {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "yaklaşık 1 ay",
        other: "yaklaşık {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "yaklaşık 1 yıl",
        other: "yaklaşık {{count}} yıl"
    },
    xYears: {
        one: "1 yıl",
        other: "{{count}} yıl"
    },
    overXYears: {
        one: "1 yıldan fazla",
        other: "{{count}} yıldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 yıl",
        other: "neredeyse {{count}} yıl"
    }
};
var $834f130faa93d15e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $834f130faa93d15e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \xf6nce";
    }
    return result;
};
var $834f130faa93d15e$export$2e2bcd8739ae039 = $834f130faa93d15e$var$formatDistance;



var $3be113634ce848fc$var$dateFormats = {
    full: "d MMMM y EEEE",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.yyyy"
};
var $3be113634ce848fc$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $3be113634ce848fc$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $3be113634ce848fc$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3be113634ce848fc$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3be113634ce848fc$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $3be113634ce848fc$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $3be113634ce848fc$export$2e2bcd8739ae039 = $3be113634ce848fc$var$formatLong;


var $73d83c58b66943e2$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yarın saat' p",
    nextWeek: "eeee 'saat' p",
    other: "P"
};
var $73d83c58b66943e2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $73d83c58b66943e2$var$formatRelativeLocale[token];
};
var $73d83c58b66943e2$export$2e2bcd8739ae039 = $73d83c58b66943e2$var$formatRelative;



var $4be30e6e6cfc06ca$var$eraValues = {
    narrow: [
        "M\xd6",
        "MS"
    ],
    abbreviated: [
        "M\xd6",
        "MS"
    ],
    wide: [
        "Milattan \xd6nce",
        "Milattan Sonra"
    ]
};
var $4be30e6e6cfc06ca$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "İlk \xe7eyrek",
        "İkinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $4be30e6e6cfc06ca$var$monthValues = {
    narrow: [
        "O",
        "Ş",
        "M",
        "N",
        "M",
        "H",
        "T",
        "A",
        "E",
        "E",
        "K",
        "A"
    ],
    abbreviated: [
        "Oca",
        "Şub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "Ağu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
    ],
    wide: [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eyl\xfcl",
        "Ekim",
        "Kasım",
        "Aralık"
    ]
};
var $4be30e6e6cfc06ca$var$dayValues = {
    narrow: [
        "P",
        "P",
        "S",
        "\xc7",
        "P",
        "C",
        "C"
    ],
    short: [
        "Pz",
        "Pt",
        "Sa",
        "\xc7a",
        "Pe",
        "Cu",
        "Ct"
    ],
    abbreviated: [
        "Paz",
        "Pzt",
        "Sal",
        "\xc7ar",
        "Per",
        "Cum",
        "Cts"
    ],
    wide: [
        "Pazar",
        "Pazartesi",
        "Salı",
        "\xc7arşamba",
        "Perşembe",
        "Cuma",
        "Cumartesi"
    ]
};
var $4be30e6e6cfc06ca$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yarısı",
        noon: "\xf6ğle",
        morning: "sabah",
        afternoon: "\xf6ğleden sonra",
        evening: "akşam",
        night: "gece"
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yarısı",
        noon: "\xf6ğle",
        morning: "sabah",
        afternoon: "\xf6ğleden sonra",
        evening: "akşam",
        night: "gece"
    }
};
var $4be30e6e6cfc06ca$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yarısı",
        noon: "\xf6ğlen",
        morning: "sabahleyin",
        afternoon: "\xf6ğleden sonra",
        evening: "akşamleyin",
        night: "geceleyin"
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yarısı",
        noon: "\xf6ğlen",
        morning: "sabahleyin",
        afternoon: "\xf6ğleden sonra",
        evening: "akşamleyin",
        night: "geceleyin"
    }
};
var $4be30e6e6cfc06ca$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $4be30e6e6cfc06ca$var$localize = {
    ordinalNumber: $4be30e6e6cfc06ca$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $4be30e6e6cfc06ca$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $4be30e6e6cfc06ca$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $4be30e6e6cfc06ca$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $4be30e6e6cfc06ca$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $4be30e6e6cfc06ca$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4be30e6e6cfc06ca$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $4be30e6e6cfc06ca$export$2e2bcd8739ae039 = $4be30e6e6cfc06ca$var$localize;




var $76cfa14b531a001b$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $76cfa14b531a001b$var$parseOrdinalNumberPattern = /\d+/i;
var $76cfa14b531a001b$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $76cfa14b531a001b$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $76cfa14b531a001b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $76cfa14b531a001b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $76cfa14b531a001b$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $76cfa14b531a001b$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $76cfa14b531a001b$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $76cfa14b531a001b$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $76cfa14b531a001b$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $76cfa14b531a001b$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $76cfa14b531a001b$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $76cfa14b531a001b$var$matchOrdinalNumberPattern,
        parsePattern: $76cfa14b531a001b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $76cfa14b531a001b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76cfa14b531a001b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $76cfa14b531a001b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76cfa14b531a001b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $76cfa14b531a001b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76cfa14b531a001b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $76cfa14b531a001b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $76cfa14b531a001b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $76cfa14b531a001b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $76cfa14b531a001b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $76cfa14b531a001b$export$2e2bcd8739ae039 = $76cfa14b531a001b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $5bb41a550539b55b$var$locale = {
    code: "tr",
    formatDistance: (0, $834f130faa93d15e$export$2e2bcd8739ae039),
    formatLong: (0, $3be113634ce848fc$export$2e2bcd8739ae039),
    formatRelative: (0, $73d83c58b66943e2$export$2e2bcd8739ae039),
    localize: (0, $4be30e6e6cfc06ca$export$2e2bcd8739ae039),
    match: (0, $76cfa14b531a001b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $5bb41a550539b55b$export$2e2bcd8739ae039 = $5bb41a550539b55b$var$locale;


var $3819cfaa78b6368b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "بىر سىكۇنت ئىچىدە",
        other: "سىكۇنت ئىچىدە {{count}}"
    },
    xSeconds: {
        one: "بىر سىكۇنت",
        other: "سىكۇنت {{count}}"
    },
    halfAMinute: "يىرىم مىنۇت",
    lessThanXMinutes: {
        one: "بىر مىنۇت ئىچىدە",
        other: "مىنۇت ئىچىدە {{count}}"
    },
    xMinutes: {
        one: "بىر مىنۇت",
        other: "مىنۇت {{count}}"
    },
    aboutXHours: {
        one: "تەخمىنەن بىر سائەت",
        other: "سائەت {{count}} تەخمىنەن"
    },
    xHours: {
        one: "بىر سائەت",
        other: "سائەت {{count}}"
    },
    xDays: {
        one: "بىر كۈن",
        other: "كۈن {{count}}"
    },
    aboutXWeeks: {
        one: "تەخمىنەن بىرھەپتە",
        other: "ھەپتە {{count}} تەخمىنەن"
    },
    xWeeks: {
        one: "بىرھەپتە",
        other: "ھەپتە {{count}}"
    },
    aboutXMonths: {
        one: "تەخمىنەن بىر ئاي",
        other: "ئاي {{count}} تەخمىنەن"
    },
    xMonths: {
        one: "بىر ئاي",
        other: "ئاي {{count}}"
    },
    aboutXYears: {
        one: "تەخمىنەن بىر يىل",
        other: "يىل {{count}} تەخمىنەن"
    },
    xYears: {
        one: "بىر يىل",
        other: "يىل {{count}}"
    },
    overXYears: {
        one: "بىر يىلدىن ئارتۇق",
        other: "يىلدىن ئارتۇق {{count}}"
    },
    almostXYears: {
        one: "ئاساسەن بىر يىل",
        other: "يىل {{count}} ئاساسەن"
    }
};
var $3819cfaa78b6368b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3819cfaa78b6368b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " بولدى";
    }
    return result;
};
var $3819cfaa78b6368b$export$2e2bcd8739ae039 = $3819cfaa78b6368b$var$formatDistance;



var $b339324fec2af1be$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b339324fec2af1be$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b339324fec2af1be$var$dateTimeFormats = {
    full: "{{date}} 'دە' {{time}}",
    long: "{{date}} 'دە' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b339324fec2af1be$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $b339324fec2af1be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $b339324fec2af1be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $b339324fec2af1be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b339324fec2af1be$export$2e2bcd8739ae039 = $b339324fec2af1be$var$formatLong;


var $ca866a28135514dd$var$formatRelativeLocale = {
    lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
    yesterday: "'تۈنۈگۈن دە' p",
    today: "'بۈگۈن دە' p",
    tomorrow: "'ئەتە دە' p",
    nextWeek: "eeee 'دە' p",
    other: "P"
};
var $ca866a28135514dd$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ca866a28135514dd$var$formatRelativeLocale[token];
};
var $ca866a28135514dd$export$2e2bcd8739ae039 = $ca866a28135514dd$var$formatRelative;



var $c59b5221dbd1a885$var$eraValues = {
    narrow: [
        "ب",
        "ك"
    ],
    abbreviated: [
        "ب",
        "ك"
    ],
    wide: [
        "مىيلادىدىن بۇرۇن",
        "مىيلادىدىن كىيىن"
    ]
};
var $c59b5221dbd1a885$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1",
        "2",
        "3",
        "4"
    ],
    wide: [
        "بىرىنجى چارەك",
        "ئىككىنجى چارەك",
        "ئۈچىنجى چارەك",
        "تۆتىنجى چارەك"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c59b5221dbd1a885$var$monthValues = {
    narrow: [
        "ي",
        "ف",
        "م",
        "ا",
        "م",
        "ى",
        "ى",
        "ا",
        "س",
        "ۆ",
        "ن",
        "د"
    ],
    abbreviated: [
        "يانۋار",
        "فېۋىرال",
        "مارت",
        "ئاپرىل",
        "ماي",
        "ئىيۇن",
        "ئىيول",
        "ئاۋغۇست",
        "سىنتەبىر",
        "ئۆكتەبىر",
        "نويابىر",
        "دىكابىر"
    ],
    wide: [
        "يانۋار",
        "فېۋىرال",
        "مارت",
        "ئاپرىل",
        "ماي",
        "ئىيۇن",
        "ئىيول",
        "ئاۋغۇست",
        "سىنتەبىر",
        "ئۆكتەبىر",
        "نويابىر",
        "دىكابىر"
    ]
};
var $c59b5221dbd1a885$var$dayValues = {
    narrow: [
        "ي",
        "د",
        "س",
        "چ",
        "پ",
        "ج",
        "ش"
    ],
    short: [
        "ي",
        "د",
        "س",
        "چ",
        "پ",
        "ج",
        "ش"
    ],
    abbreviated: [
        "يەكشەنبە",
        "دۈشەنبە",
        "سەيشەنبە",
        "چارشەنبە",
        "پەيشەنبە",
        "جۈمە",
        "شەنبە"
    ],
    wide: [
        "يەكشەنبە",
        "دۈشەنبە",
        "سەيشەنبە",
        "چارشەنبە",
        "پەيشەنبە",
        "جۈمە",
        "شەنبە"
    ]
};
var $c59b5221dbd1a885$var$dayPeriodValues = {
    narrow: {
        am: "ئە",
        pm: "چ",
        midnight: "ك",
        noon: "چ",
        morning: "ئەتىگەن",
        afternoon: "چۈشتىن كىيىن",
        evening: "ئاخشىم",
        night: "كىچە"
    },
    abbreviated: {
        am: "ئە",
        pm: "چ",
        midnight: "ك",
        noon: "چ",
        morning: "ئەتىگەن",
        afternoon: "چۈشتىن كىيىن",
        evening: "ئاخشىم",
        night: "كىچە"
    },
    wide: {
        am: "ئە",
        pm: "چ",
        midnight: "ك",
        noon: "چ",
        morning: "ئەتىگەن",
        afternoon: "چۈشتىن كىيىن",
        evening: "ئاخشىم",
        night: "كىچە"
    }
};
var $c59b5221dbd1a885$var$formattingDayPeriodValues = {
    narrow: {
        am: "ئە",
        pm: "چ",
        midnight: "ك",
        noon: "چ",
        morning: "ئەتىگەندە",
        afternoon: "چۈشتىن كىيىن",
        evening: "ئاخشامدا",
        night: "كىچىدە"
    },
    abbreviated: {
        am: "ئە",
        pm: "چ",
        midnight: "ك",
        noon: "چ",
        morning: "ئەتىگەندە",
        afternoon: "چۈشتىن كىيىن",
        evening: "ئاخشامدا",
        night: "كىچىدە"
    },
    wide: {
        am: "ئە",
        pm: "چ",
        midnight: "ك",
        noon: "چ",
        morning: "ئەتىگەندە",
        afternoon: "چۈشتىن كىيىن",
        evening: "ئاخشامدا",
        night: "كىچىدە"
    }
};
var $c59b5221dbd1a885$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $c59b5221dbd1a885$var$localize = {
    ordinalNumber: $c59b5221dbd1a885$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c59b5221dbd1a885$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c59b5221dbd1a885$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c59b5221dbd1a885$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c59b5221dbd1a885$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c59b5221dbd1a885$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c59b5221dbd1a885$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c59b5221dbd1a885$export$2e2bcd8739ae039 = $c59b5221dbd1a885$var$localize;




var $efee89c5c5561463$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $efee89c5c5561463$var$parseOrdinalNumberPattern = /\d+/i;
var $efee89c5c5561463$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var $efee89c5c5561463$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var $efee89c5c5561463$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var $efee89c5c5561463$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $efee89c5c5561463$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var $efee89c5c5561463$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var $efee89c5c5561463$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var $efee89c5c5561463$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var $efee89c5c5561463$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var $efee89c5c5561463$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var $efee89c5c5561463$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $efee89c5c5561463$var$matchOrdinalNumberPattern,
        parsePattern: $efee89c5c5561463$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $efee89c5c5561463$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efee89c5c5561463$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $efee89c5c5561463$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efee89c5c5561463$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $efee89c5c5561463$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efee89c5c5561463$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $efee89c5c5561463$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $efee89c5c5561463$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $efee89c5c5561463$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $efee89c5c5561463$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $efee89c5c5561463$export$2e2bcd8739ae039 = $efee89c5c5561463$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var $f540bb5d26e36a20$var$locale = {
    code: "ug",
    formatDistance: (0, $3819cfaa78b6368b$export$2e2bcd8739ae039),
    formatLong: (0, $b339324fec2af1be$export$2e2bcd8739ae039),
    formatRelative: (0, $ca866a28135514dd$export$2e2bcd8739ae039),
    localize: (0, $c59b5221dbd1a885$export$2e2bcd8739ae039),
    match: (0, $efee89c5c5561463$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $f540bb5d26e36a20$export$2e2bcd8739ae039 = $f540bb5d26e36a20$var$locale;


function $e8da4bea0205e80d$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $e8da4bea0205e80d$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $e8da4bea0205e80d$var$declension(scheme.future, count);
                else return "за " + $e8da4bea0205e80d$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $e8da4bea0205e80d$var$declension(scheme.past, count);
                else return $e8da4bea0205e80d$var$declension(scheme.regular, count) + " тому";
            }
        } else return $e8da4bea0205e80d$var$declension(scheme.regular, count);
    };
}
var $e8da4bea0205e80d$var$halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "за півхвилини";
        else return "півхвилини тому";
    }
    return "півхвилини";
};
var $e8da4bea0205e80d$var$formatDistanceLocale = {
    lessThanXSeconds: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            one: "менше секунди",
            singularNominative: "менше {{count}} секунди",
            singularGenitive: "менше {{count}} секунд",
            pluralGenitive: "менше {{count}} секунд"
        },
        future: {
            one: "менше, ніж за секунду",
            singularNominative: "менше, ніж за {{count}} секунду",
            singularGenitive: "менше, ніж за {{count}} секунди",
            pluralGenitive: "менше, ніж за {{count}} секунд"
        }
    }),
    xSeconds: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} секунда",
            singularGenitive: "{{count}} секунди",
            pluralGenitive: "{{count}} секунд"
        },
        past: {
            singularNominative: "{{count}} секунду тому",
            singularGenitive: "{{count}} секунди тому",
            pluralGenitive: "{{count}} секунд тому"
        },
        future: {
            singularNominative: "за {{count}} секунду",
            singularGenitive: "за {{count}} секунди",
            pluralGenitive: "за {{count}} секунд"
        }
    }),
    halfAMinute: $e8da4bea0205e80d$var$halfAtMinute,
    lessThanXMinutes: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            one: "менше хвилини",
            singularNominative: "менше {{count}} хвилини",
            singularGenitive: "менше {{count}} хвилин",
            pluralGenitive: "менше {{count}} хвилин"
        },
        future: {
            one: "менше, ніж за хвилину",
            singularNominative: "менше, ніж за {{count}} хвилину",
            singularGenitive: "менше, ніж за {{count}} хвилини",
            pluralGenitive: "менше, ніж за {{count}} хвилин"
        }
    }),
    xMinutes: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} хвилина",
            singularGenitive: "{{count}} хвилини",
            pluralGenitive: "{{count}} хвилин"
        },
        past: {
            singularNominative: "{{count}} хвилину тому",
            singularGenitive: "{{count}} хвилини тому",
            pluralGenitive: "{{count}} хвилин тому"
        },
        future: {
            singularNominative: "за {{count}} хвилину",
            singularGenitive: "за {{count}} хвилини",
            pluralGenitive: "за {{count}} хвилин"
        }
    }),
    aboutXHours: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "близько {{count}} години",
            singularGenitive: "близько {{count}} годин",
            pluralGenitive: "близько {{count}} годин"
        },
        future: {
            singularNominative: "приблизно за {{count}} годину",
            singularGenitive: "приблизно за {{count}} години",
            pluralGenitive: "приблизно за {{count}} годин"
        }
    }),
    xHours: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} годину",
            singularGenitive: "{{count}} години",
            pluralGenitive: "{{count}} годин"
        }
    }),
    xDays: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} день",
            singularGenitive: "{{count}} днi",
            pluralGenitive: "{{count}} днів"
        }
    }),
    aboutXWeeks: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "близько {{count}} тижня",
            singularGenitive: "близько {{count}} тижнів",
            pluralGenitive: "близько {{count}} тижнів"
        },
        future: {
            singularNominative: "приблизно за {{count}} тиждень",
            singularGenitive: "приблизно за {{count}} тижні",
            pluralGenitive: "приблизно за {{count}} тижнів"
        }
    }),
    xWeeks: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} тиждень",
            singularGenitive: "{{count}} тижні",
            pluralGenitive: "{{count}} тижнів"
        }
    }),
    aboutXMonths: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "близько {{count}} місяця",
            singularGenitive: "близько {{count}} місяців",
            pluralGenitive: "близько {{count}} місяців"
        },
        future: {
            singularNominative: "приблизно за {{count}} місяць",
            singularGenitive: "приблизно за {{count}} місяці",
            pluralGenitive: "приблизно за {{count}} місяців"
        }
    }),
    xMonths: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} місяць",
            singularGenitive: "{{count}} місяці",
            pluralGenitive: "{{count}} місяців"
        }
    }),
    aboutXYears: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "близько {{count}} року",
            singularGenitive: "близько {{count}} років",
            pluralGenitive: "близько {{count}} років"
        },
        future: {
            singularNominative: "приблизно за {{count}} рік",
            singularGenitive: "приблизно за {{count}} роки",
            pluralGenitive: "приблизно за {{count}} років"
        }
    }),
    xYears: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} рік",
            singularGenitive: "{{count}} роки",
            pluralGenitive: "{{count}} років"
        }
    }),
    overXYears: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "більше {{count}} року",
            singularGenitive: "більше {{count}} років",
            pluralGenitive: "більше {{count}} років"
        },
        future: {
            singularNominative: "більше, ніж за {{count}} рік",
            singularGenitive: "більше, ніж за {{count}} роки",
            pluralGenitive: "більше, ніж за {{count}} років"
        }
    }),
    almostXYears: $e8da4bea0205e80d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "майже {{count}} рік",
            singularGenitive: "майже {{count}} роки",
            pluralGenitive: "майже {{count}} років"
        },
        future: {
            singularNominative: "майже за {{count}} рік",
            singularGenitive: "майже за {{count}} роки",
            pluralGenitive: "майже за {{count}} років"
        }
    })
};
var $e8da4bea0205e80d$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $e8da4bea0205e80d$var$formatDistanceLocale[token](count, options);
};
var $e8da4bea0205e80d$export$2e2bcd8739ae039 = $e8da4bea0205e80d$var$formatDistance;



var $17aaee824065621c$var$dateFormats = {
    full: "EEEE, do MMMM y 'р.'",
    long: "do MMMM y 'р.'",
    medium: "d MMM y 'р.'",
    short: "dd.MM.y"
};
var $17aaee824065621c$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $17aaee824065621c$var$dateTimeFormats = {
    full: "{{date}} 'о' {{time}}",
    long: "{{date}} 'о' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $17aaee824065621c$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17aaee824065621c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17aaee824065621c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $17aaee824065621c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $17aaee824065621c$export$2e2bcd8739ae039 = $17aaee824065621c$var$formatLong;




var $9cf9aee0117eb5e2$var$accusativeWeekdays = [
    "неділю",
    "понеділок",
    "вівторок",
    "середу",
    "четвер",
    "п’ятницю",
    "суботу"
];
function $9cf9aee0117eb5e2$var$lastWeek(day) {
    var weekday = $9cf9aee0117eb5e2$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'у минулу " + weekday + " о' p";
        case 1:
        case 2:
        case 4:
            return "'у минулий " + weekday + " о' p";
    }
}
function $9cf9aee0117eb5e2$var$thisWeek(day) {
    var weekday = $9cf9aee0117eb5e2$var$accusativeWeekdays[day];
    return "'у " + weekday + " о' p";
}
function $9cf9aee0117eb5e2$var$nextWeek(day) {
    var weekday = $9cf9aee0117eb5e2$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'у наступну " + weekday + " о' p";
        case 1:
        case 2:
        case 4:
            return "'у наступний " + weekday + " о' p";
    }
}
var $9cf9aee0117eb5e2$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $9cf9aee0117eb5e2$var$thisWeek(day);
    else return $9cf9aee0117eb5e2$var$lastWeek(day);
};
var $9cf9aee0117eb5e2$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $2285621ea3fa8491$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return $9cf9aee0117eb5e2$var$thisWeek(day);
    else return $9cf9aee0117eb5e2$var$nextWeek(day);
};
var $9cf9aee0117eb5e2$var$formatRelativeLocale = {
    lastWeek: $9cf9aee0117eb5e2$var$lastWeekFormat,
    yesterday: "'вчора о' p",
    today: "'сьогодні о' p",
    tomorrow: "'завтра о' p",
    nextWeek: $9cf9aee0117eb5e2$var$nextWeekFormat,
    other: "P"
};
var $9cf9aee0117eb5e2$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $9cf9aee0117eb5e2$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $9cf9aee0117eb5e2$export$2e2bcd8739ae039 = $9cf9aee0117eb5e2$var$formatRelative;



var $b8ea0ae7578b9bbd$var$eraValues = {
    narrow: [
        "до н.е.",
        "н.е."
    ],
    abbreviated: [
        "до н. е.",
        "н. е."
    ],
    wide: [
        "до нашої ери",
        "нашої ери"
    ]
};
var $b8ea0ae7578b9bbd$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-й кв.",
        "2-й кв.",
        "3-й кв.",
        "4-й кв."
    ],
    wide: [
        "1-й квартал",
        "2-й квартал",
        "3-й квартал",
        "4-й квартал"
    ]
};
var $b8ea0ae7578b9bbd$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "С",
        "Л",
        "Б",
        "К",
        "Т",
        "Ч",
        "Л",
        "С",
        "В",
        "Ж",
        "Л",
        "Г"
    ],
    abbreviated: [
        "січ.",
        "лют.",
        "берез.",
        "квіт.",
        "трав.",
        "черв.",
        "лип.",
        "серп.",
        "верес.",
        "жовт.",
        "листоп.",
        "груд."
    ],
    wide: [
        "січень",
        "лютий",
        "березень",
        "квітень",
        "травень",
        "червень",
        "липень",
        "серпень",
        "вересень",
        "жовтень",
        "листопад",
        "грудень"
    ]
};
var $b8ea0ae7578b9bbd$var$formattingMonthValues = {
    narrow: [
        "С",
        "Л",
        "Б",
        "К",
        "Т",
        "Ч",
        "Л",
        "С",
        "В",
        "Ж",
        "Л",
        "Г"
    ],
    abbreviated: [
        "січ.",
        "лют.",
        "берез.",
        "квіт.",
        "трав.",
        "черв.",
        "лип.",
        "серп.",
        "верес.",
        "жовт.",
        "листоп.",
        "груд."
    ],
    wide: [
        "січня",
        "лютого",
        "березня",
        "квітня",
        "травня",
        "червня",
        "липня",
        "серпня",
        "вересня",
        "жовтня",
        "листопада",
        "грудня"
    ]
};
var $b8ea0ae7578b9bbd$var$dayValues = {
    narrow: [
        "Н",
        "П",
        "В",
        "С",
        "Ч",
        "П",
        "С"
    ],
    short: [
        "нд",
        "пн",
        "вт",
        "ср",
        "чт",
        "пт",
        "сб"
    ],
    abbreviated: [
        "нед",
        "пон",
        "вів",
        "сер",
        "чтв",
        "птн",
        "суб"
    ],
    wide: [
        "неділя",
        "понеділок",
        "вівторок",
        "середа",
        "четвер",
        "п’ятниця",
        "субота"
    ]
};
var $b8ea0ae7578b9bbd$var$dayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "півн.",
        noon: "пол.",
        morning: "ранок",
        afternoon: "день",
        evening: "веч.",
        night: "ніч"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "півн.",
        noon: "пол.",
        morning: "ранок",
        afternoon: "день",
        evening: "веч.",
        night: "ніч"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "північ",
        noon: "полудень",
        morning: "ранок",
        afternoon: "день",
        evening: "вечір",
        night: "ніч"
    }
};
var $b8ea0ae7578b9bbd$var$formattingDayPeriodValues = {
    narrow: {
        am: "ДП",
        pm: "ПП",
        midnight: "півн.",
        noon: "пол.",
        morning: "ранку",
        afternoon: "дня",
        evening: "веч.",
        night: "ночі"
    },
    abbreviated: {
        am: "ДП",
        pm: "ПП",
        midnight: "півн.",
        noon: "пол.",
        morning: "ранку",
        afternoon: "дня",
        evening: "веч.",
        night: "ночі"
    },
    wide: {
        am: "ДП",
        pm: "ПП",
        midnight: "північ",
        noon: "полудень",
        morning: "ранку",
        afternoon: "дня",
        evening: "веч.",
        night: "ночі"
    }
};
var $b8ea0ae7578b9bbd$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === "date") {
        if (number === 3 || number === 23) suffix = "-є";
        else suffix = "-е";
    } else if (unit === "minute" || unit === "second" || unit === "hour") suffix = "-а";
    else suffix = "-й";
    return number + suffix;
};
var $b8ea0ae7578b9bbd$var$localize = {
    ordinalNumber: $b8ea0ae7578b9bbd$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b8ea0ae7578b9bbd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b8ea0ae7578b9bbd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b8ea0ae7578b9bbd$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b8ea0ae7578b9bbd$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b8ea0ae7578b9bbd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $b8ea0ae7578b9bbd$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $b8ea0ae7578b9bbd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $b8ea0ae7578b9bbd$export$2e2bcd8739ae039 = $b8ea0ae7578b9bbd$var$localize;




var $bab416b4d9725df0$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var $bab416b4d9725df0$var$parseOrdinalNumberPattern = /\d+/i;
var $bab416b4d9725df0$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var $bab416b4d9725df0$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $bab416b4d9725df0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var $bab416b4d9725df0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bab416b4d9725df0$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var $bab416b4d9725df0$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var $bab416b4d9725df0$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var $bab416b4d9725df0$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var $bab416b4d9725df0$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var $bab416b4d9725df0$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $bab416b4d9725df0$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $bab416b4d9725df0$var$matchOrdinalNumberPattern,
        parsePattern: $bab416b4d9725df0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bab416b4d9725df0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab416b4d9725df0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bab416b4d9725df0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab416b4d9725df0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bab416b4d9725df0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab416b4d9725df0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bab416b4d9725df0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab416b4d9725df0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $bab416b4d9725df0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bab416b4d9725df0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bab416b4d9725df0$export$2e2bcd8739ae039 = $bab416b4d9725df0$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var $1e75cbfc6a899177$var$locale = {
    code: "uk",
    formatDistance: (0, $e8da4bea0205e80d$export$2e2bcd8739ae039),
    formatLong: (0, $17aaee824065621c$export$2e2bcd8739ae039),
    formatRelative: (0, $9cf9aee0117eb5e2$export$2e2bcd8739ae039),
    localize: (0, $b8ea0ae7578b9bbd$export$2e2bcd8739ae039),
    match: (0, $bab416b4d9725df0$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1e75cbfc6a899177$export$2e2bcd8739ae039 = $1e75cbfc6a899177$var$locale;


var $8b89f048b7161489$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "sekunddan kam",
        other: "{{count}} sekunddan kam"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "yarim minut",
    lessThanXMinutes: {
        one: "bir minutdan kam",
        other: "{{count}} minutdan kam"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: "tahminan 1 soat",
        other: "tahminan {{count}} soat"
    },
    xHours: {
        one: "1 soat",
        other: "{{count}} soat"
    },
    xDays: {
        one: "1 kun",
        other: "{{count}} kun"
    },
    aboutXWeeks: {
        one: "tahminan 1 hafta",
        other: "tahminan {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "tahminan 1 oy",
        other: "tahminan {{count}} oy"
    },
    xMonths: {
        one: "1 oy",
        other: "{{count}} oy"
    },
    aboutXYears: {
        one: "tahminan 1 yil",
        other: "tahminan {{count}} yil"
    },
    xYears: {
        one: "1 yil",
        other: "{{count}} yil"
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: "deyarli 1 yil",
        other: "deyarli {{count}} yil"
    }
};
var $8b89f048b7161489$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8b89f048b7161489$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " dan keyin";
        else return result + " oldin";
    }
    return result;
};
var $8b89f048b7161489$export$2e2bcd8739ae039 = $8b89f048b7161489$var$formatDistance;



var $cf00821efea6be2e$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
var $cf00821efea6be2e$var$timeFormats = {
    full: "h:mm:ss zzzz",
    long: "h:mm:ss z",
    medium: "h:mm:ss",
    short: "h:mm"
};
var $cf00821efea6be2e$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $cf00821efea6be2e$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $cf00821efea6be2e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $cf00821efea6be2e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $cf00821efea6be2e$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $cf00821efea6be2e$export$2e2bcd8739ae039 = $cf00821efea6be2e$var$formatLong;


var $0f6eadbf979f36f2$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: "P"
};
var $0f6eadbf979f36f2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0f6eadbf979f36f2$var$formatRelativeLocale[token];
};
var $0f6eadbf979f36f2$export$2e2bcd8739ae039 = $0f6eadbf979f36f2$var$formatRelative;



var $22e9fdb09d11640f$var$eraValues = {
    narrow: [
        "M.A",
        "M."
    ],
    abbreviated: [
        "M.A",
        "M."
    ],
    wide: [
        "Miloddan Avvalgi",
        "Milodiy"
    ]
};
var $22e9fdb09d11640f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "CH.1",
        "CH.2",
        "CH.3",
        "CH.4"
    ],
    wide: [
        "1-chi chorak",
        "2-chi chorak",
        "3-chi chorak",
        "4-chi chorak"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $22e9fdb09d11640f$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "Iyun",
        "Iyul",
        "Avg",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "Iyun",
        "Iyul",
        "Avgust",
        "Sentabr",
        "Oktabr",
        "Noyabr",
        "Dekabr"
    ]
};
var $22e9fdb09d11640f$var$dayValues = {
    narrow: [
        "Y",
        "D",
        "S",
        "CH",
        "P",
        "J",
        "SH"
    ],
    short: [
        "Ya",
        "Du",
        "Se",
        "Cho",
        "Pa",
        "Ju",
        "Sha"
    ],
    abbreviated: [
        "Yak",
        "Dush",
        "Sesh",
        "Chor",
        "Pay",
        "Jum",
        "Shan"
    ],
    wide: [
        "Yakshanba",
        "Dushanba",
        "Seshanba",
        "Chorshanba",
        "Payshanba",
        "Juma",
        "Shanba"
    ]
};
var $22e9fdb09d11640f$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
var $22e9fdb09d11640f$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
var $22e9fdb09d11640f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $22e9fdb09d11640f$var$localize = {
    ordinalNumber: $22e9fdb09d11640f$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $22e9fdb09d11640f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $22e9fdb09d11640f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $22e9fdb09d11640f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $22e9fdb09d11640f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $22e9fdb09d11640f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $22e9fdb09d11640f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $22e9fdb09d11640f$export$2e2bcd8739ae039 = $22e9fdb09d11640f$var$localize;




var $49dde0ec6a237a01$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var $49dde0ec6a237a01$var$parseOrdinalNumberPattern = /\d+/i;
var $49dde0ec6a237a01$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var $49dde0ec6a237a01$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $49dde0ec6a237a01$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var $49dde0ec6a237a01$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $49dde0ec6a237a01$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var $49dde0ec6a237a01$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $49dde0ec6a237a01$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var $49dde0ec6a237a01$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var $49dde0ec6a237a01$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var $49dde0ec6a237a01$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var $49dde0ec6a237a01$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $49dde0ec6a237a01$var$matchOrdinalNumberPattern,
        parsePattern: $49dde0ec6a237a01$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $49dde0ec6a237a01$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49dde0ec6a237a01$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $49dde0ec6a237a01$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49dde0ec6a237a01$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $49dde0ec6a237a01$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49dde0ec6a237a01$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $49dde0ec6a237a01$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $49dde0ec6a237a01$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $49dde0ec6a237a01$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $49dde0ec6a237a01$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $49dde0ec6a237a01$export$2e2bcd8739ae039 = $49dde0ec6a237a01$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var $c1176042d276b112$var$locale = {
    code: "uz",
    formatDistance: (0, $8b89f048b7161489$export$2e2bcd8739ae039),
    formatLong: (0, $cf00821efea6be2e$export$2e2bcd8739ae039),
    formatRelative: (0, $0f6eadbf979f36f2$export$2e2bcd8739ae039),
    localize: (0, $22e9fdb09d11640f$export$2e2bcd8739ae039),
    match: (0, $49dde0ec6a237a01$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c1176042d276b112$export$2e2bcd8739ae039 = $c1176042d276b112$var$locale;


var $6290142e8308451a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 сониядан кам",
        other: "{{count}} сониядан кам"
    },
    xSeconds: {
        one: "1 сония",
        other: "{{count}} сония"
    },
    halfAMinute: "ярим дақиқа",
    lessThanXMinutes: {
        one: "1 дақиқадан кам",
        other: "{{count}} дақиқадан кам"
    },
    xMinutes: {
        one: "1 дақиқа",
        other: "{{count}} дақиқа"
    },
    aboutXHours: {
        one: "тахминан 1 соат",
        other: "тахминан {{count}} соат"
    },
    xHours: {
        one: "1 соат",
        other: "{{count}} соат"
    },
    xDays: {
        one: "1 кун",
        other: "{{count}} кун"
    },
    aboutXWeeks: {
        one: "тахминан 1 хафта",
        other: "тахминан {{count}} хафта"
    },
    xWeeks: {
        one: "1 хафта",
        other: "{{count}} хафта"
    },
    aboutXMonths: {
        one: "тахминан 1 ой",
        other: "тахминан {{count}} ой"
    },
    xMonths: {
        one: "1 ой",
        other: "{{count}} ой"
    },
    aboutXYears: {
        one: "тахминан 1 йил",
        other: "тахминан {{count}} йил"
    },
    xYears: {
        one: "1 йил",
        other: "{{count}} йил"
    },
    overXYears: {
        one: "1 йилдан кўп",
        other: "{{count}} йилдан кўп"
    },
    almostXYears: {
        one: "деярли 1 йил",
        other: "деярли {{count}} йил"
    }
};
var $6290142e8308451a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6290142e8308451a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "дан кейин";
        else return result + " олдин";
    }
    return result;
};
var $6290142e8308451a$export$2e2bcd8739ae039 = $6290142e8308451a$var$formatDistance;



var $e5b4b3a7aa2738d7$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
var $e5b4b3a7aa2738d7$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $e5b4b3a7aa2738d7$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $e5b4b3a7aa2738d7$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e5b4b3a7aa2738d7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e5b4b3a7aa2738d7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e5b4b3a7aa2738d7$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $e5b4b3a7aa2738d7$export$2e2bcd8739ae039 = $e5b4b3a7aa2738d7$var$formatLong;


var $0b8be26b40487afa$var$formatRelativeLocale = {
    lastWeek: "'ўтган' eeee p 'да'",
    yesterday: "'кеча' p 'да'",
    today: "'бугун' p 'да'",
    tomorrow: "'эртага' p 'да'",
    nextWeek: "eeee p 'да'",
    other: "P"
};
var $0b8be26b40487afa$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0b8be26b40487afa$var$formatRelativeLocale[token];
};
var $0b8be26b40487afa$export$2e2bcd8739ae039 = $0b8be26b40487afa$var$formatRelative;



var $5d2e74f1350bdfea$var$eraValues = {
    narrow: [
        "М.А",
        "М"
    ],
    abbreviated: [
        "М.А",
        "М"
    ],
    wide: [
        "Милоддан Аввалги",
        "Милодий"
    ]
};
var $5d2e74f1350bdfea$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-чор.",
        "2-чор.",
        "3-чор.",
        "4-чор."
    ],
    wide: [
        "1-чорак",
        "2-чорак",
        "3-чорак",
        "4-чорак"
    ]
};
var $5d2e74f1350bdfea$var$monthValues = {
    narrow: [
        "Я",
        "Ф",
        "М",
        "А",
        "М",
        "И",
        "И",
        "А",
        "С",
        "О",
        "Н",
        "Д"
    ],
    abbreviated: [
        "янв",
        "фев",
        "мар",
        "апр",
        "май",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек"
    ],
    wide: [
        "январ",
        "феврал",
        "март",
        "апрел",
        "май",
        "июн",
        "июл",
        "август",
        "сентабр",
        "октабр",
        "ноябр",
        "декабр"
    ]
};
var $5d2e74f1350bdfea$var$dayValues = {
    narrow: [
        "Я",
        "Д",
        "С",
        "Ч",
        "П",
        "Ж",
        "Ш"
    ],
    short: [
        "як",
        "ду",
        "се",
        "чо",
        "па",
        "жу",
        "ша"
    ],
    abbreviated: [
        "якш",
        "душ",
        "сеш",
        "чор",
        "пай",
        "жум",
        "шан"
    ],
    wide: [
        "якшанба",
        "душанба",
        "сешанба",
        "чоршанба",
        "пайшанба",
        "жума",
        "шанба"
    ]
};
var $5d2e74f1350bdfea$var$dayPeriodValues = {
    any: {
        am: "П.О.",
        pm: "П.К.",
        midnight: "ярим тун",
        noon: "пешин",
        morning: "эрталаб",
        afternoon: "пешиндан кейин",
        evening: "кечаси",
        night: "тун"
    }
};
var $5d2e74f1350bdfea$var$formattingDayPeriodValues = {
    any: {
        am: "П.О.",
        pm: "П.К.",
        midnight: "ярим тун",
        noon: "пешин",
        morning: "эрталаб",
        afternoon: "пешиндан кейин",
        evening: "кечаси",
        night: "тун"
    }
};
var $5d2e74f1350bdfea$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $5d2e74f1350bdfea$var$localize = {
    ordinalNumber: $5d2e74f1350bdfea$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5d2e74f1350bdfea$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5d2e74f1350bdfea$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5d2e74f1350bdfea$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5d2e74f1350bdfea$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $5d2e74f1350bdfea$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $5d2e74f1350bdfea$var$formattingDayPeriodValues,
        defaultFormattingWidth: "any"
    })
};
var $5d2e74f1350bdfea$export$2e2bcd8739ae039 = $5d2e74f1350bdfea$var$localize;




var $5a195a2438510d6d$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var $5a195a2438510d6d$var$parseOrdinalNumberPattern = /\d+/i;
var $5a195a2438510d6d$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var $5a195a2438510d6d$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var $5a195a2438510d6d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var $5a195a2438510d6d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5a195a2438510d6d$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var $5a195a2438510d6d$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $5a195a2438510d6d$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var $5a195a2438510d6d$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var $5a195a2438510d6d$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var $5a195a2438510d6d$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var $5a195a2438510d6d$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $5a195a2438510d6d$var$matchOrdinalNumberPattern,
        parsePattern: $5a195a2438510d6d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5a195a2438510d6d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a195a2438510d6d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5a195a2438510d6d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a195a2438510d6d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5a195a2438510d6d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a195a2438510d6d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5a195a2438510d6d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a195a2438510d6d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $5a195a2438510d6d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5a195a2438510d6d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $5a195a2438510d6d$export$2e2bcd8739ae039 = $5a195a2438510d6d$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var $1475c7d72c7ae0f0$var$locale = {
    code: "uz-Cyrl",
    formatDistance: (0, $6290142e8308451a$export$2e2bcd8739ae039),
    formatLong: (0, $e5b4b3a7aa2738d7$export$2e2bcd8739ae039),
    formatRelative: (0, $0b8be26b40487afa$export$2e2bcd8739ae039),
    localize: (0, $5d2e74f1350bdfea$export$2e2bcd8739ae039),
    match: (0, $5a195a2438510d6d$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1475c7d72c7ae0f0$export$2e2bcd8739ae039 = $1475c7d72c7ae0f0$var$locale;


var $6d5f589e86b6c8ea$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "dưới 1 gi\xe2y",
        other: "dưới {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "nửa ph\xfat",
    lessThanXMinutes: {
        one: "dưới 1 ph\xfat",
        other: "dưới {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "khoảng 1 giờ",
        other: "khoảng {{count}} giờ"
    },
    xHours: {
        one: "1 giờ",
        other: "{{count}} giờ"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "khoảng 1 tuần",
        other: "khoảng {{count}} tuần"
    },
    xWeeks: {
        one: "1 tuần",
        other: "{{count}} tuần"
    },
    aboutXMonths: {
        one: "khoảng 1 th\xe1ng",
        other: "khoảng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "khoảng 1 năm",
        other: "khoảng {{count}} năm"
    },
    xYears: {
        one: "1 năm",
        other: "{{count}} năm"
    },
    overXYears: {
        one: "hơn 1 năm",
        other: "hơn {{count}} năm"
    },
    almostXYears: {
        one: "gần 1 năm",
        other: "gần {{count}} năm"
    }
};
var $6d5f589e86b6c8ea$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6d5f589e86b6c8ea$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " nữa";
        else return result + " trước";
    }
    return result;
};
var $6d5f589e86b6c8ea$export$2e2bcd8739ae039 = $6d5f589e86b6c8ea$var$formatDistance;



var $9109a68696fab0f9$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'năm' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'năm' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'năm' y",
    // 25/08/2017
    short: "dd/MM/y"
};
var $9109a68696fab0f9$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $9109a68696fab0f9$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: "{{date}} {{time}}",
    // ngày 25 tháng 08 năm 2017 23:25
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $9109a68696fab0f9$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $9109a68696fab0f9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $9109a68696fab0f9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $9109a68696fab0f9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $9109a68696fab0f9$export$2e2bcd8739ae039 = $9109a68696fab0f9$var$formatLong;


var $11d933c7074aad4f$var$formatRelativeLocale = {
    lastWeek: "eeee 'tuần trước v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 'tới v\xe0o l\xfac' p",
    other: "P"
};
var $11d933c7074aad4f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $11d933c7074aad4f$var$formatRelativeLocale[token];
};
var $11d933c7074aad4f$export$2e2bcd8739ae039 = $11d933c7074aad4f$var$formatRelative;



// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var $c562bcd105b4c24b$var$eraValues = {
    narrow: [
        "TCN",
        "SCN"
    ],
    abbreviated: [
        "trước CN",
        "sau CN"
    ],
    wide: [
        "trước C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var $c562bcd105b4c24b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var $c562bcd105b4c24b$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c562bcd105b4c24b$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "Thg 1",
        "Thg 2",
        "Thg 3",
        "Thg 4",
        "Thg 5",
        "Thg 6",
        "Thg 7",
        "Thg 8",
        "Thg 9",
        "Thg 10",
        "Thg 11",
        "Thg 12"
    ],
    wide: [
        "Th\xe1ng Một",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng Tư",
        "Th\xe1ng Năm",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng Bảy",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng Mười",
        "Th\xe1ng Mười Một",
        "Th\xe1ng Mười Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var $c562bcd105b4c24b$var$formattingMonthValues = {
    narrow: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "thg 1",
        "thg 2",
        "thg 3",
        "thg 4",
        "thg 5",
        "thg 6",
        "thg 7",
        "thg 8",
        "thg 9",
        "thg 10",
        "thg 11",
        "thg 12"
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var $c562bcd105b4c24b$var$dayValues = {
    narrow: [
        "CN",
        "T2",
        "T3",
        "T4",
        "T5",
        "T6",
        "T7"
    ],
    short: [
        "CN",
        "Th 2",
        "Th 3",
        "Th 4",
        "Th 5",
        "Th 6",
        "Th 7"
    ],
    abbreviated: [
        "CN",
        "Thứ 2",
        "Thứ 3",
        "Thứ 4",
        "Thứ 5",
        "Thứ 6",
        "Thứ 7"
    ],
    wide: [
        "Chủ Nhật",
        "Thứ Hai",
        "Thứ Ba",
        "Thứ Tư",
        "Thứ Năm",
        "Thứ S\xe1u",
        "Thứ Bảy"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var $c562bcd105b4c24b$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "nửa đ\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "tối",
        night: "đ\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nửa đ\xeam",
        noon: "trưa",
        morning: "s\xe1ng",
        afternoon: "chiều",
        evening: "tối",
        night: "đ\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "nửa đ\xeam",
        noon: "trưa",
        morning: "s\xe1ng",
        afternoon: "chiều",
        evening: "tối",
        night: "đ\xeam"
    }
};
var $c562bcd105b4c24b$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "nửa đ\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "tối",
        night: "đ\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nửa đ\xeam",
        noon: "trưa",
        morning: "s\xe1ng",
        afternoon: "chiều",
        evening: "tối",
        night: "đ\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "nửa đ\xeam",
        noon: "giữa trưa",
        morning: "v\xe0o buổi s\xe1ng",
        afternoon: "v\xe0o buổi chiều",
        evening: "v\xe0o buổi tối",
        night: "v\xe0o ban đ\xeam"
    }
};
var $c562bcd105b4c24b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === "quarter") // many news outlets use "quý I"...
    switch(number){
        case 1:
            return "I";
        case 2:
            return "II";
        case 3:
            return "III";
        case 4:
            return "IV";
    }
    else if (unit === "day") // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "thứ 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "thứ 3";
        // meaning 3rd day
        case 3:
            return "thứ 4";
        // meaning 4th day and so on
        case 4:
            return "thứ 5";
        case 5:
            return "thứ 6";
        case 6:
            return "thứ 7";
        case 7:
            return "chủ nhật";
    }
    else if (unit === "week") {
        if (number === 1) return "thứ nhất";
        else return "thứ " + number;
    } else if (unit === "dayOfYear") {
        if (number === 1) return "đầu ti\xean";
        else return "thứ " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var $c562bcd105b4c24b$var$localize = {
    ordinalNumber: $c562bcd105b4c24b$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c562bcd105b4c24b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c562bcd105b4c24b$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $c562bcd105b4c24b$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c562bcd105b4c24b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $c562bcd105b4c24b$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c562bcd105b4c24b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $c562bcd105b4c24b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c562bcd105b4c24b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c562bcd105b4c24b$export$2e2bcd8739ae039 = $c562bcd105b4c24b$var$localize;




var $a5b68e439e1239ca$var$matchOrdinalNumberPattern = /^(\d+)/i;
var $a5b68e439e1239ca$var$parseOrdinalNumberPattern = /\d+/i;
var $a5b68e439e1239ca$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var $a5b68e439e1239ca$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var $a5b68e439e1239ca$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var $a5b68e439e1239ca$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var $a5b68e439e1239ca$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var $a5b68e439e1239ca$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var $a5b68e439e1239ca$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var $a5b68e439e1239ca$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var $a5b68e439e1239ca$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var $a5b68e439e1239ca$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var $a5b68e439e1239ca$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $a5b68e439e1239ca$var$matchOrdinalNumberPattern,
        parsePattern: $a5b68e439e1239ca$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5b68e439e1239ca$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5b68e439e1239ca$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5b68e439e1239ca$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5b68e439e1239ca$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5b68e439e1239ca$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5b68e439e1239ca$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5b68e439e1239ca$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5b68e439e1239ca$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $a5b68e439e1239ca$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a5b68e439e1239ca$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a5b68e439e1239ca$export$2e2bcd8739ae039 = $a5b68e439e1239ca$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var $17d82b633a01358b$var$locale = {
    code: "vi",
    formatDistance: (0, $6d5f589e86b6c8ea$export$2e2bcd8739ae039),
    formatLong: (0, $9109a68696fab0f9$export$2e2bcd8739ae039),
    formatRelative: (0, $11d933c7074aad4f$export$2e2bcd8739ae039),
    localize: (0, $c562bcd105b4c24b$export$2e2bcd8739ae039),
    match: (0, $a5b68e439e1239ca$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
var $17d82b633a01358b$export$2e2bcd8739ae039 = $17d82b633a01358b$var$locale;


var $f9c238bf9008b0fa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "不到 1 秒",
        other: "不到 {{count}} 秒"
    },
    xSeconds: {
        one: "1 秒",
        other: "{{count}} 秒"
    },
    halfAMinute: "半分钟",
    lessThanXMinutes: {
        one: "不到 1 分钟",
        other: "不到 {{count}} 分钟"
    },
    xMinutes: {
        one: "1 分钟",
        other: "{{count}} 分钟"
    },
    xHours: {
        one: "1 小时",
        other: "{{count}} 小时"
    },
    aboutXHours: {
        one: "大约 1 小时",
        other: "大约 {{count}} 小时"
    },
    xDays: {
        one: "1 天",
        other: "{{count}} 天"
    },
    aboutXWeeks: {
        one: "大约 1 个星期",
        other: "大约 {{count}} 个星期"
    },
    xWeeks: {
        one: "1 个星期",
        other: "{{count}} 个星期"
    },
    aboutXMonths: {
        one: "大约 1 个月",
        other: "大约 {{count}} 个月"
    },
    xMonths: {
        one: "1 个月",
        other: "{{count}} 个月"
    },
    aboutXYears: {
        one: "大约 1 年",
        other: "大约 {{count}} 年"
    },
    xYears: {
        one: "1 年",
        other: "{{count}} 年"
    },
    overXYears: {
        one: "超过 1 年",
        other: "超过 {{count}} 年"
    },
    almostXYears: {
        one: "将近 1 年",
        other: "将近 {{count}} 年"
    }
};
var $f9c238bf9008b0fa$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f9c238bf9008b0fa$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "内";
        else return result + "前";
    }
    return result;
};
var $f9c238bf9008b0fa$export$2e2bcd8739ae039 = $f9c238bf9008b0fa$var$formatDistance;



var $e4f6567ced33af36$var$dateFormats = {
    full: "y'年'M'月'd'日' EEEE",
    long: "y'年'M'月'd'日'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
var $e4f6567ced33af36$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $e4f6567ced33af36$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $e4f6567ced33af36$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e4f6567ced33af36$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e4f6567ced33af36$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $e4f6567ced33af36$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e4f6567ced33af36$export$2e2bcd8739ae039 = $e4f6567ced33af36$var$formatLong;



function $4e32b3bfd059c919$var$checkWeek(date, baseDate, options) {
    var baseFormat = "eeee p";
    if ((0, $20baa0f6a4f9b6c5$export$2e2bcd8739ae039)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'下个'" + baseFormat; // in next week
    return "'上个'" + baseFormat; // in last week
}
var $4e32b3bfd059c919$var$formatRelativeLocale = {
    lastWeek: $4e32b3bfd059c919$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'昨天' p",
    today: "'今天' p",
    tomorrow: "'明天' p",
    nextWeek: $4e32b3bfd059c919$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: "PP p"
};
var $4e32b3bfd059c919$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $4e32b3bfd059c919$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $4e32b3bfd059c919$export$2e2bcd8739ae039 = $4e32b3bfd059c919$var$formatRelative;



var $7cdf7c05890ce469$var$eraValues = {
    narrow: [
        "前",
        "公元"
    ],
    abbreviated: [
        "前",
        "公元"
    ],
    wide: [
        "公元前",
        "公元"
    ]
};
var $7cdf7c05890ce469$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "第一季",
        "第二季",
        "第三季",
        "第四季"
    ],
    wide: [
        "第一季度",
        "第二季度",
        "第三季度",
        "第四季度"
    ]
};
var $7cdf7c05890ce469$var$monthValues = {
    narrow: [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二"
    ],
    abbreviated: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
    ],
    wide: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
    ]
};
var $7cdf7c05890ce469$var$dayValues = {
    narrow: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ],
    short: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ],
    abbreviated: [
        "周日",
        "周一",
        "周二",
        "周三",
        "周四",
        "周五",
        "周六"
    ],
    wide: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
    ]
};
var $7cdf7c05890ce469$var$dayPeriodValues = {
    narrow: {
        am: "上",
        pm: "下",
        midnight: "凌晨",
        noon: "午",
        morning: "早",
        afternoon: "下午",
        evening: "晚",
        night: "夜"
    },
    abbreviated: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜间"
    },
    wide: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜间"
    }
};
var $7cdf7c05890ce469$var$formattingDayPeriodValues = {
    narrow: {
        am: "上",
        pm: "下",
        midnight: "凌晨",
        noon: "午",
        morning: "早",
        afternoon: "下午",
        evening: "晚",
        night: "夜"
    },
    abbreviated: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜间"
    },
    wide: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜间"
    }
};
var $7cdf7c05890ce469$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case "date":
            return number.toString() + "日";
        case "hour":
            return number.toString() + "时";
        case "minute":
            return number.toString() + "分";
        case "second":
            return number.toString() + "秒";
        default:
            return "第 " + number.toString();
    }
};
var $7cdf7c05890ce469$var$localize = {
    ordinalNumber: $7cdf7c05890ce469$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7cdf7c05890ce469$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7cdf7c05890ce469$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7cdf7c05890ce469$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7cdf7c05890ce469$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7cdf7c05890ce469$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7cdf7c05890ce469$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7cdf7c05890ce469$export$2e2bcd8739ae039 = $7cdf7c05890ce469$var$localize;




var $f10c55fa41e38151$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $f10c55fa41e38151$var$parseOrdinalNumberPattern = /\d+/i;
var $f10c55fa41e38151$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $f10c55fa41e38151$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $f10c55fa41e38151$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $f10c55fa41e38151$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $f10c55fa41e38151$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $f10c55fa41e38151$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $f10c55fa41e38151$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $f10c55fa41e38151$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $f10c55fa41e38151$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $f10c55fa41e38151$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $f10c55fa41e38151$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $f10c55fa41e38151$var$matchOrdinalNumberPattern,
        parsePattern: $f10c55fa41e38151$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f10c55fa41e38151$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f10c55fa41e38151$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f10c55fa41e38151$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f10c55fa41e38151$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f10c55fa41e38151$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f10c55fa41e38151$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f10c55fa41e38151$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f10c55fa41e38151$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $f10c55fa41e38151$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f10c55fa41e38151$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $f10c55fa41e38151$export$2e2bcd8739ae039 = $f10c55fa41e38151$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $9ee9f757c51e022b$var$locale = {
    code: "zh-CN",
    formatDistance: (0, $f9c238bf9008b0fa$export$2e2bcd8739ae039),
    formatLong: (0, $e4f6567ced33af36$export$2e2bcd8739ae039),
    formatRelative: (0, $4e32b3bfd059c919$export$2e2bcd8739ae039),
    localize: (0, $7cdf7c05890ce469$export$2e2bcd8739ae039),
    match: (0, $f10c55fa41e38151$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9ee9f757c51e022b$export$2e2bcd8739ae039 = $9ee9f757c51e022b$var$locale;


var $405f1c23b1aa8760$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "少於 1 秒",
        other: "少於 {{count}} 秒"
    },
    xSeconds: {
        one: "1 秒",
        other: "{{count}} 秒"
    },
    halfAMinute: "半分鐘",
    lessThanXMinutes: {
        one: "少於 1 分鐘",
        other: "少於 {{count}} 分鐘"
    },
    xMinutes: {
        one: "1 分鐘",
        other: "{{count}} 分鐘"
    },
    xHours: {
        one: "1 小時",
        other: "{{count}} 小時"
    },
    aboutXHours: {
        one: "大約 1 小時",
        other: "大約 {{count}} 小時"
    },
    xDays: {
        one: "1 天",
        other: "{{count}} 天"
    },
    aboutXWeeks: {
        one: "大約 1 個星期",
        other: "大約 {{count}} 個星期"
    },
    xWeeks: {
        one: "1 個星期",
        other: "{{count}} 個星期"
    },
    aboutXMonths: {
        one: "大約 1 個月",
        other: "大約 {{count}} 個月"
    },
    xMonths: {
        one: "1 個月",
        other: "{{count}} 個月"
    },
    aboutXYears: {
        one: "大約 1 年",
        other: "大約 {{count}} 年"
    },
    xYears: {
        one: "1 年",
        other: "{{count}} 年"
    },
    overXYears: {
        one: "超過 1 年",
        other: "超過 {{count}} 年"
    },
    almostXYears: {
        one: "將近 1 年",
        other: "將近 {{count}} 年"
    }
};
var $405f1c23b1aa8760$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $405f1c23b1aa8760$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "內";
        else return result + "前";
    }
    return result;
};
var $405f1c23b1aa8760$export$2e2bcd8739ae039 = $405f1c23b1aa8760$var$formatDistance;



var $36953acdbd18154f$var$dateFormats = {
    full: "y'年'M'月'd'日' EEEE",
    long: "y'年'M'月'd'日'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
var $36953acdbd18154f$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $36953acdbd18154f$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $36953acdbd18154f$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $36953acdbd18154f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $36953acdbd18154f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $36953acdbd18154f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $36953acdbd18154f$export$2e2bcd8739ae039 = $36953acdbd18154f$var$formatLong;


var $096483d46127fad5$var$formatRelativeLocale = {
    lastWeek: "'上個'eeee p",
    yesterday: "'昨天' p",
    today: "'今天' p",
    tomorrow: "'明天' p",
    nextWeek: "'下個'eeee p",
    other: "P"
};
var $096483d46127fad5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $096483d46127fad5$var$formatRelativeLocale[token];
};
var $096483d46127fad5$export$2e2bcd8739ae039 = $096483d46127fad5$var$formatRelative;



var $26bb569e89f3c747$var$eraValues = {
    narrow: [
        "前",
        "公元"
    ],
    abbreviated: [
        "前",
        "公元"
    ],
    wide: [
        "公元前",
        "公元"
    ]
};
var $26bb569e89f3c747$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "第一季",
        "第二季",
        "第三季",
        "第四季"
    ],
    wide: [
        "第一季度",
        "第二季度",
        "第三季度",
        "第四季度"
    ]
};
var $26bb569e89f3c747$var$monthValues = {
    narrow: [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二"
    ],
    abbreviated: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
    ],
    wide: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
    ]
};
var $26bb569e89f3c747$var$dayValues = {
    narrow: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ],
    short: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ],
    abbreviated: [
        "週日",
        "週一",
        "週二",
        "週三",
        "週四",
        "週五",
        "週六"
    ],
    wide: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
    ]
};
var $26bb569e89f3c747$var$dayPeriodValues = {
    narrow: {
        am: "上",
        pm: "下",
        midnight: "午夜",
        noon: "晌",
        morning: "早",
        afternoon: "午",
        evening: "晚",
        night: "夜"
    },
    abbreviated: {
        am: "上午",
        pm: "下午",
        midnight: "午夜",
        noon: "中午",
        morning: "上午",
        afternoon: "下午",
        evening: "晚上",
        night: "夜晚"
    },
    wide: {
        am: "上午",
        pm: "下午",
        midnight: "午夜",
        noon: "中午",
        morning: "上午",
        afternoon: "下午",
        evening: "晚上",
        night: "夜晚"
    }
};
var $26bb569e89f3c747$var$formattingDayPeriodValues = {
    narrow: {
        am: "上",
        pm: "下",
        midnight: "午夜",
        noon: "晌",
        morning: "早",
        afternoon: "午",
        evening: "晚",
        night: "夜"
    },
    abbreviated: {
        am: "上午",
        pm: "下午",
        midnight: "午夜",
        noon: "中午",
        morning: "上午",
        afternoon: "下午",
        evening: "晚上",
        night: "夜晚"
    },
    wide: {
        am: "上午",
        pm: "下午",
        midnight: "午夜",
        noon: "中午",
        morning: "上午",
        afternoon: "下午",
        evening: "晚上",
        night: "夜晚"
    }
};
var $26bb569e89f3c747$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case "date":
            return number + "日";
        case "hour":
            return number + "時";
        case "minute":
            return number + "分";
        case "second":
            return number + "秒";
        default:
            return "第 " + number;
    }
};
var $26bb569e89f3c747$var$localize = {
    ordinalNumber: $26bb569e89f3c747$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $26bb569e89f3c747$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $26bb569e89f3c747$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $26bb569e89f3c747$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $26bb569e89f3c747$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $26bb569e89f3c747$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $26bb569e89f3c747$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $26bb569e89f3c747$export$2e2bcd8739ae039 = $26bb569e89f3c747$var$localize;




var $85ce639b17569af5$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $85ce639b17569af5$var$parseOrdinalNumberPattern = /\d+/i;
var $85ce639b17569af5$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $85ce639b17569af5$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $85ce639b17569af5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var $85ce639b17569af5$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $85ce639b17569af5$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $85ce639b17569af5$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $85ce639b17569af5$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $85ce639b17569af5$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $85ce639b17569af5$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $85ce639b17569af5$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $85ce639b17569af5$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $85ce639b17569af5$var$matchOrdinalNumberPattern,
        parsePattern: $85ce639b17569af5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $85ce639b17569af5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $85ce639b17569af5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $85ce639b17569af5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $85ce639b17569af5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $85ce639b17569af5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $85ce639b17569af5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $85ce639b17569af5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $85ce639b17569af5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $85ce639b17569af5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $85ce639b17569af5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $85ce639b17569af5$export$2e2bcd8739ae039 = $85ce639b17569af5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var $900dea089dd32305$var$locale = {
    code: "zh-HK",
    formatDistance: (0, $405f1c23b1aa8760$export$2e2bcd8739ae039),
    formatLong: (0, $36953acdbd18154f$export$2e2bcd8739ae039),
    formatRelative: (0, $096483d46127fad5$export$2e2bcd8739ae039),
    localize: (0, $26bb569e89f3c747$export$2e2bcd8739ae039),
    match: (0, $85ce639b17569af5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $900dea089dd32305$export$2e2bcd8739ae039 = $900dea089dd32305$var$locale;


var $526ef72527b1a617$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "少於 1 秒",
        other: "少於 {{count}} 秒"
    },
    xSeconds: {
        one: "1 秒",
        other: "{{count}} 秒"
    },
    halfAMinute: "半分鐘",
    lessThanXMinutes: {
        one: "少於 1 分鐘",
        other: "少於 {{count}} 分鐘"
    },
    xMinutes: {
        one: "1 分鐘",
        other: "{{count}} 分鐘"
    },
    xHours: {
        one: "1 小時",
        other: "{{count}} 小時"
    },
    aboutXHours: {
        one: "大約 1 小時",
        other: "大約 {{count}} 小時"
    },
    xDays: {
        one: "1 天",
        other: "{{count}} 天"
    },
    aboutXWeeks: {
        one: "大約 1 個星期",
        other: "大約 {{count}} 個星期"
    },
    xWeeks: {
        one: "1 個星期",
        other: "{{count}} 個星期"
    },
    aboutXMonths: {
        one: "大約 1 個月",
        other: "大約 {{count}} 個月"
    },
    xMonths: {
        one: "1 個月",
        other: "{{count}} 個月"
    },
    aboutXYears: {
        one: "大約 1 年",
        other: "大約 {{count}} 年"
    },
    xYears: {
        one: "1 年",
        other: "{{count}} 年"
    },
    overXYears: {
        one: "超過 1 年",
        other: "超過 {{count}} 年"
    },
    almostXYears: {
        one: "將近 1 年",
        other: "將近 {{count}} 年"
    }
};
var $526ef72527b1a617$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $526ef72527b1a617$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "內";
        else return result + "前";
    }
    return result;
};
var $526ef72527b1a617$export$2e2bcd8739ae039 = $526ef72527b1a617$var$formatDistance;



var $b6538e0bd543394f$var$dateFormats = {
    full: "y'年'M'月'd'日' EEEE",
    long: "y'年'M'月'd'日'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
var $b6538e0bd543394f$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $b6538e0bd543394f$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $b6538e0bd543394f$var$formatLong = {
    date: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $b6538e0bd543394f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $b6538e0bd543394f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $772b9d5c5acb67c6$export$2e2bcd8739ae039)({
        formats: $b6538e0bd543394f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b6538e0bd543394f$export$2e2bcd8739ae039 = $b6538e0bd543394f$var$formatLong;


var $e6980dd4943567d9$var$formatRelativeLocale = {
    lastWeek: "'上個'eeee p",
    yesterday: "'昨天' p",
    today: "'今天' p",
    tomorrow: "'明天' p",
    nextWeek: "'下個'eeee p",
    other: "P"
};
var $e6980dd4943567d9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e6980dd4943567d9$var$formatRelativeLocale[token];
};
var $e6980dd4943567d9$export$2e2bcd8739ae039 = $e6980dd4943567d9$var$formatRelative;



var $7e2818dc64149582$var$eraValues = {
    narrow: [
        "前",
        "公元"
    ],
    abbreviated: [
        "前",
        "公元"
    ],
    wide: [
        "公元前",
        "公元"
    ]
};
var $7e2818dc64149582$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "第一刻",
        "第二刻",
        "第三刻",
        "第四刻"
    ],
    wide: [
        "第一刻鐘",
        "第二刻鐘",
        "第三刻鐘",
        "第四刻鐘"
    ]
};
var $7e2818dc64149582$var$monthValues = {
    narrow: [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
        "十一",
        "十二"
    ],
    abbreviated: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
    ],
    wide: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
    ]
};
var $7e2818dc64149582$var$dayValues = {
    narrow: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ],
    short: [
        "日",
        "一",
        "二",
        "三",
        "四",
        "五",
        "六"
    ],
    abbreviated: [
        "週日",
        "週一",
        "週二",
        "週三",
        "週四",
        "週五",
        "週六"
    ],
    wide: [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
    ]
};
var $7e2818dc64149582$var$dayPeriodValues = {
    narrow: {
        am: "上",
        pm: "下",
        midnight: "凌晨",
        noon: "午",
        morning: "早",
        afternoon: "下午",
        evening: "晚",
        night: "夜"
    },
    abbreviated: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜間"
    },
    wide: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜間"
    }
};
var $7e2818dc64149582$var$formattingDayPeriodValues = {
    narrow: {
        am: "上",
        pm: "下",
        midnight: "凌晨",
        noon: "午",
        morning: "早",
        afternoon: "下午",
        evening: "晚",
        night: "夜"
    },
    abbreviated: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜間"
    },
    wide: {
        am: "上午",
        pm: "下午",
        midnight: "凌晨",
        noon: "中午",
        morning: "早晨",
        afternoon: "中午",
        evening: "晚上",
        night: "夜間"
    }
};
var $7e2818dc64149582$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case "date":
            return number + "日";
        case "hour":
            return number + "時";
        case "minute":
            return number + "分";
        case "second":
            return number + "秒";
        default:
            return "第 " + number;
    }
};
var $7e2818dc64149582$var$localize = {
    ordinalNumber: $7e2818dc64149582$var$ordinalNumber,
    era: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7e2818dc64149582$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7e2818dc64149582$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7e2818dc64149582$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7e2818dc64149582$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $2ca886d2c8d77e4d$export$2e2bcd8739ae039)({
        values: $7e2818dc64149582$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7e2818dc64149582$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7e2818dc64149582$export$2e2bcd8739ae039 = $7e2818dc64149582$var$localize;




var $82093c0e6fb8c229$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $82093c0e6fb8c229$var$parseOrdinalNumberPattern = /\d+/i;
var $82093c0e6fb8c229$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $82093c0e6fb8c229$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $82093c0e6fb8c229$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $82093c0e6fb8c229$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $82093c0e6fb8c229$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $82093c0e6fb8c229$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $82093c0e6fb8c229$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $82093c0e6fb8c229$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $82093c0e6fb8c229$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $82093c0e6fb8c229$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $82093c0e6fb8c229$var$match = {
    ordinalNumber: (0, $85cdfad058df8fd3$export$2e2bcd8739ae039)({
        matchPattern: $82093c0e6fb8c229$var$matchOrdinalNumberPattern,
        parsePattern: $82093c0e6fb8c229$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $82093c0e6fb8c229$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82093c0e6fb8c229$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $82093c0e6fb8c229$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82093c0e6fb8c229$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $82093c0e6fb8c229$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82093c0e6fb8c229$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $82093c0e6fb8c229$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $82093c0e6fb8c229$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $d8d845ab692d6dea$export$2e2bcd8739ae039)({
        matchPatterns: $82093c0e6fb8c229$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $82093c0e6fb8c229$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $82093c0e6fb8c229$export$2e2bcd8739ae039 = $82093c0e6fb8c229$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $59fbfcc273919242$var$locale = {
    code: "zh-TW",
    formatDistance: (0, $526ef72527b1a617$export$2e2bcd8739ae039),
    formatLong: (0, $b6538e0bd543394f$export$2e2bcd8739ae039),
    formatRelative: (0, $e6980dd4943567d9$export$2e2bcd8739ae039),
    localize: (0, $7e2818dc64149582$export$2e2bcd8739ae039),
    match: (0, $82093c0e6fb8c229$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $59fbfcc273919242$export$2e2bcd8739ae039 = $59fbfcc273919242$var$locale;




var $a67c49fb33face5a$exports = {};
/* eslint-env node */ var $91dbb6f60f851f00$exports = {};
/*
 * Copyright (c) 2010 Arc90 Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This code is heavily based on Arc90's readability.js (1.7.1) script
 * available at: http://code.google.com/p/arc90labs-readability
 */ /**
 * Public constructor.
 * @param {HTMLDocument} doc     The document to parse.
 * @param {Object}       options The options object.
 */ function $91dbb6f60f851f00$var$Readability(doc, options) {
    // In some older versions, people passed a URI as the first argument. Cope:
    if (options && options.documentElement) {
        doc = options;
        options = arguments[2];
    } else if (!doc || !doc.documentElement) throw new Error("First argument to Readability constructor should be a document object.");
    options = options || {};
    this._doc = doc;
    this._docJSDOMParser = this._doc.firstChild.__JSDOMParser__;
    this._articleTitle = null;
    this._articleByline = null;
    this._articleDir = null;
    this._articleSiteName = null;
    this._attempts = [];
    // Configurable options
    this._debug = !!options.debug;
    this._maxElemsToParse = options.maxElemsToParse || this.DEFAULT_MAX_ELEMS_TO_PARSE;
    this._nbTopCandidates = options.nbTopCandidates || this.DEFAULT_N_TOP_CANDIDATES;
    this._charThreshold = options.charThreshold || this.DEFAULT_CHAR_THRESHOLD;
    this._classesToPreserve = this.CLASSES_TO_PRESERVE.concat(options.classesToPreserve || []);
    this._keepClasses = !!options.keepClasses;
    this._serializer = options.serializer || function(el) {
        return el.innerHTML;
    };
    this._disableJSONLD = !!options.disableJSONLD;
    this._allowedVideoRegex = options.allowedVideoRegex || this.REGEXPS.videos;
    // Start with all flags set
    this._flags = this.FLAG_STRIP_UNLIKELYS | this.FLAG_WEIGHT_CLASSES | this.FLAG_CLEAN_CONDITIONALLY;
    // Control whether log messages are sent to the console
    if (this._debug) {
        let logNode = function(node) {
            if (node.nodeType == node.TEXT_NODE) return `${node.nodeName} ("${node.textContent}")`;
            let attrPairs = Array.from(node.attributes || [], function(attr) {
                return `${attr.name}="${attr.value}"`;
            }).join(" ");
            return `<${node.localName} ${attrPairs}>`;
        };
        this.log = function() {
            if (typeof console !== "undefined") {
                let args = Array.from(arguments, (arg)=>{
                    if (arg && arg.nodeType == this.ELEMENT_NODE) return logNode(arg);
                    return arg;
                });
                args.unshift("Reader: (Readability)");
                console.log.apply(console, args);
            } else if (typeof dump !== "undefined") {
                /* global dump */ var msg = Array.prototype.map.call(arguments, function(x) {
                    return x && x.nodeName ? logNode(x) : x;
                }).join(" ");
                dump("Reader: (Readability) " + msg + "\n");
            }
        };
    } else this.log = function() {};
}
$91dbb6f60f851f00$var$Readability.prototype = {
    FLAG_STRIP_UNLIKELYS: 0x1,
    FLAG_WEIGHT_CLASSES: 0x2,
    FLAG_CLEAN_CONDITIONALLY: 0x4,
    // https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
    ELEMENT_NODE: 1,
    TEXT_NODE: 3,
    // Max number of nodes supported by this parser. Default: 0 (no limit)
    DEFAULT_MAX_ELEMS_TO_PARSE: 0,
    // The number of top candidates to consider when analysing how
    // tight the competition is among candidates.
    DEFAULT_N_TOP_CANDIDATES: 5,
    // Element tags to score by default.
    DEFAULT_TAGS_TO_SCORE: "section,h2,h3,h4,h5,h6,p,td,pre".toUpperCase().split(","),
    // The default number of chars an article must have in order to return a result
    DEFAULT_CHAR_THRESHOLD: 500,
    // All of the regular expressions in use within readability.
    // Defined up here so we don't instantiate them repeatedly in loops.
    REGEXPS: {
        // NOTE: These two regular expressions are duplicated in
        // Readability-readerable.js. Please keep both copies in sync.
        unlikelyCandidates: /-ad-|ai2html|banner|breadcrumbs|combx|comment|community|cover-wrap|disqus|extra|footer|gdpr|header|legends|menu|related|remark|replies|rss|shoutbox|sidebar|skyscraper|social|sponsor|supplemental|ad-break|agegate|pagination|pager|popup|yom-remote/i,
        okMaybeItsACandidate: /and|article|body|column|content|main|shadow/i,
        positive: /article|body|content|entry|hentry|h-entry|main|page|pagination|post|text|blog|story/i,
        negative: /-ad-|hidden|^hid$| hid$| hid |^hid |banner|combx|comment|com-|contact|foot|footer|footnote|gdpr|masthead|media|meta|outbrain|promo|related|scroll|share|shoutbox|sidebar|skyscraper|sponsor|shopping|tags|tool|widget/i,
        extraneous: /print|archive|comment|discuss|e[\-]?mail|share|reply|all|login|sign|single|utility/i,
        byline: /byline|author|dateline|writtenby|p-author/i,
        replaceFonts: /<(\/?)font[^>]*>/gi,
        normalize: /\s{2,}/g,
        videos: /\/\/(www\.)?((dailymotion|youtube|youtube-nocookie|player\.vimeo|v\.qq)\.com|(archive|upload\.wikimedia)\.org|player\.twitch\.tv)/i,
        shareElements: /(\b|_)(share|sharedaddy)(\b|_)/i,
        nextLink: /(next|weiter|continue|>([^\|]|$)|»([^\|]|$))/i,
        prevLink: /(prev|earl|old|new|<|«)/i,
        tokenize: /\W+/g,
        whitespace: /^\s*$/,
        hasContent: /\S$/,
        hashUrl: /^#.+/,
        srcsetUrl: /(\S+)(\s+[\d.]+[xw])?(\s*(?:,|$))/g,
        b64DataUrl: /^data:\s*([^\s;,]+)\s*;\s*base64\s*,/i,
        // See: https://schema.org/Article
        jsonLdArticleTypes: /^Article|AdvertiserContentArticle|NewsArticle|AnalysisNewsArticle|AskPublicNewsArticle|BackgroundNewsArticle|OpinionNewsArticle|ReportageNewsArticle|ReviewNewsArticle|Report|SatiricalArticle|ScholarlyArticle|MedicalScholarlyArticle|SocialMediaPosting|BlogPosting|LiveBlogPosting|DiscussionForumPosting|TechArticle|APIReference$/
    },
    UNLIKELY_ROLES: [
        "menu",
        "menubar",
        "complementary",
        "navigation",
        "alert",
        "alertdialog",
        "dialog"
    ],
    DIV_TO_P_ELEMS: new Set([
        "BLOCKQUOTE",
        "DL",
        "DIV",
        "IMG",
        "OL",
        "P",
        "PRE",
        "TABLE",
        "UL"
    ]),
    ALTER_TO_DIV_EXCEPTIONS: [
        "DIV",
        "ARTICLE",
        "SECTION",
        "P"
    ],
    PRESENTATIONAL_ATTRIBUTES: [
        "align",
        "background",
        "bgcolor",
        "border",
        "cellpadding",
        "cellspacing",
        "frame",
        "hspace",
        "rules",
        "style",
        "valign",
        "vspace"
    ],
    DEPRECATED_SIZE_ATTRIBUTE_ELEMS: [
        "TABLE",
        "TH",
        "TD",
        "HR",
        "PRE"
    ],
    // The commented out elements qualify as phrasing content but tend to be
    // removed by readability when put into paragraphs, so we ignore them here.
    PHRASING_ELEMS: [
        // "CANVAS", "IFRAME", "SVG", "VIDEO",
        "ABBR",
        "AUDIO",
        "B",
        "BDO",
        "BR",
        "BUTTON",
        "CITE",
        "CODE",
        "DATA",
        "DATALIST",
        "DFN",
        "EM",
        "EMBED",
        "I",
        "IMG",
        "INPUT",
        "KBD",
        "LABEL",
        "MARK",
        "MATH",
        "METER",
        "NOSCRIPT",
        "OBJECT",
        "OUTPUT",
        "PROGRESS",
        "Q",
        "RUBY",
        "SAMP",
        "SCRIPT",
        "SELECT",
        "SMALL",
        "SPAN",
        "STRONG",
        "SUB",
        "SUP",
        "TEXTAREA",
        "TIME",
        "VAR",
        "WBR"
    ],
    // These are the classes that readability sets itself.
    CLASSES_TO_PRESERVE: [
        "page"
    ],
    // These are the list of HTML entities that need to be escaped.
    HTML_ESCAPE_MAP: {
        "lt": "<",
        "gt": ">",
        "amp": "&",
        "quot": '"',
        "apos": "'"
    },
    /**
   * Run any post-process modifications to article content as necessary.
   *
   * @param Element
   * @return void
  **/ _postProcessContent: function(articleContent) {
        // Readability cannot open relative uris so we convert them to absolute uris.
        this._fixRelativeUris(articleContent);
        this._simplifyNestedElements(articleContent);
        if (!this._keepClasses) // Remove classes.
        this._cleanClasses(articleContent);
    },
    /**
   * Iterates over a NodeList, calls `filterFn` for each node and removes node
   * if function returned `true`.
   *
   * If function is not passed, removes all the nodes in node list.
   *
   * @param NodeList nodeList The nodes to operate on
   * @param Function filterFn the function to use as a filter
   * @return void
   */ _removeNodes: function(nodeList, filterFn) {
        // Avoid ever operating on live node lists.
        if (this._docJSDOMParser && nodeList._isLiveNodeList) throw new Error("Do not pass live node lists to _removeNodes");
        for(var i = nodeList.length - 1; i >= 0; i--){
            var node = nodeList[i];
            var parentNode = node.parentNode;
            if (parentNode) {
                if (!filterFn || filterFn.call(this, node, i, nodeList)) parentNode.removeChild(node);
            }
        }
    },
    /**
   * Iterates over a NodeList, and calls _setNodeTag for each node.
   *
   * @param NodeList nodeList The nodes to operate on
   * @param String newTagName the new tag name to use
   * @return void
   */ _replaceNodeTags: function(nodeList, newTagName) {
        // Avoid ever operating on live node lists.
        if (this._docJSDOMParser && nodeList._isLiveNodeList) throw new Error("Do not pass live node lists to _replaceNodeTags");
        for (const node of nodeList)this._setNodeTag(node, newTagName);
    },
    /**
   * Iterate over a NodeList, which doesn't natively fully implement the Array
   * interface.
   *
   * For convenience, the current object context is applied to the provided
   * iterate function.
   *
   * @param  NodeList nodeList The NodeList.
   * @param  Function fn       The iterate function.
   * @return void
   */ _forEachNode: function(nodeList, fn) {
        Array.prototype.forEach.call(nodeList, fn, this);
    },
    /**
   * Iterate over a NodeList, and return the first node that passes
   * the supplied test function
   *
   * For convenience, the current object context is applied to the provided
   * test function.
   *
   * @param  NodeList nodeList The NodeList.
   * @param  Function fn       The test function.
   * @return void
   */ _findNode: function(nodeList, fn) {
        return Array.prototype.find.call(nodeList, fn, this);
    },
    /**
   * Iterate over a NodeList, return true if any of the provided iterate
   * function calls returns true, false otherwise.
   *
   * For convenience, the current object context is applied to the
   * provided iterate function.
   *
   * @param  NodeList nodeList The NodeList.
   * @param  Function fn       The iterate function.
   * @return Boolean
   */ _someNode: function(nodeList, fn) {
        return Array.prototype.some.call(nodeList, fn, this);
    },
    /**
   * Iterate over a NodeList, return true if all of the provided iterate
   * function calls return true, false otherwise.
   *
   * For convenience, the current object context is applied to the
   * provided iterate function.
   *
   * @param  NodeList nodeList The NodeList.
   * @param  Function fn       The iterate function.
   * @return Boolean
   */ _everyNode: function(nodeList, fn) {
        return Array.prototype.every.call(nodeList, fn, this);
    },
    /**
   * Concat all nodelists passed as arguments.
   *
   * @return ...NodeList
   * @return Array
   */ _concatNodeLists: function() {
        var slice = Array.prototype.slice;
        var args = slice.call(arguments);
        var nodeLists = args.map(function(list) {
            return slice.call(list);
        });
        return Array.prototype.concat.apply([], nodeLists);
    },
    _getAllNodesWithTag: function(node, tagNames) {
        if (node.querySelectorAll) return node.querySelectorAll(tagNames.join(","));
        return [].concat.apply([], tagNames.map(function(tag) {
            var collection = node.getElementsByTagName(tag);
            return Array.isArray(collection) ? collection : Array.from(collection);
        }));
    },
    /**
   * Removes the class="" attribute from every element in the given
   * subtree, except those that match CLASSES_TO_PRESERVE and
   * the classesToPreserve array from the options object.
   *
   * @param Element
   * @return void
   */ _cleanClasses: function(node) {
        var classesToPreserve = this._classesToPreserve;
        var className = (node.getAttribute("class") || "").split(/\s+/).filter(function(cls) {
            return classesToPreserve.indexOf(cls) != -1;
        }).join(" ");
        if (className) node.setAttribute("class", className);
        else node.removeAttribute("class");
        for(node = node.firstElementChild; node; node = node.nextElementSibling)this._cleanClasses(node);
    },
    /**
   * Converts each <a> and <img> uri in the given element to an absolute URI,
   * ignoring #ref URIs.
   *
   * @param Element
   * @return void
   */ _fixRelativeUris: function(articleContent) {
        var baseURI = this._doc.baseURI;
        var documentURI = this._doc.documentURI;
        function toAbsoluteURI(uri) {
            // Leave hash links alone if the base URI matches the document URI:
            if (baseURI == documentURI && uri.charAt(0) == "#") return uri;
            // Otherwise, resolve against base URI:
            try {
                return new URL(uri, baseURI).href;
            } catch (ex) {
            // Something went wrong, just return the original:
            }
            return uri;
        }
        var links = this._getAllNodesWithTag(articleContent, [
            "a"
        ]);
        this._forEachNode(links, function(link) {
            var href = link.getAttribute("href");
            if (href) {
                // Remove links with javascript: URIs, since
                // they won't work after scripts have been removed from the page.
                if (href.indexOf("javascript:") === 0) {
                    // if the link only contains simple text content, it can be converted to a text node
                    if (link.childNodes.length === 1 && link.childNodes[0].nodeType === this.TEXT_NODE) {
                        var text = this._doc.createTextNode(link.textContent);
                        link.parentNode.replaceChild(text, link);
                    } else {
                        // if the link has multiple children, they should all be preserved
                        var container = this._doc.createElement("span");
                        while(link.firstChild)container.appendChild(link.firstChild);
                        link.parentNode.replaceChild(container, link);
                    }
                } else link.setAttribute("href", toAbsoluteURI(href));
            }
        });
        var medias = this._getAllNodesWithTag(articleContent, [
            "img",
            "picture",
            "figure",
            "video",
            "audio",
            "source"
        ]);
        this._forEachNode(medias, function(media) {
            var src = media.getAttribute("src");
            var poster = media.getAttribute("poster");
            var srcset = media.getAttribute("srcset");
            if (src) media.setAttribute("src", toAbsoluteURI(src));
            if (poster) media.setAttribute("poster", toAbsoluteURI(poster));
            if (srcset) {
                var newSrcset = srcset.replace(this.REGEXPS.srcsetUrl, function(_, p1, p2, p3) {
                    return toAbsoluteURI(p1) + (p2 || "") + p3;
                });
                media.setAttribute("srcset", newSrcset);
            }
        });
    },
    _simplifyNestedElements: function(articleContent) {
        var node = articleContent;
        while(node){
            if (node.parentNode && [
                "DIV",
                "SECTION"
            ].includes(node.tagName) && !(node.id && node.id.startsWith("readability"))) {
                if (this._isElementWithoutContent(node)) {
                    node = this._removeAndGetNext(node);
                    continue;
                } else if (this._hasSingleTagInsideElement(node, "DIV") || this._hasSingleTagInsideElement(node, "SECTION")) {
                    var child = node.children[0];
                    for(var i = 0; i < node.attributes.length; i++)child.setAttribute(node.attributes[i].name, node.attributes[i].value);
                    node.parentNode.replaceChild(child, node);
                    node = child;
                    continue;
                }
            }
            node = this._getNextNode(node);
        }
    },
    /**
   * Get the article title as an H1.
   *
   * @return string
   **/ _getArticleTitle: function() {
        var doc = this._doc;
        var curTitle = "";
        var origTitle = "";
        try {
            curTitle = origTitle = doc.title.trim();
            // If they had an element with id "title" in their HTML
            if (typeof curTitle !== "string") curTitle = origTitle = this._getInnerText(doc.getElementsByTagName("title")[0]);
        } catch (e) {}
        var titleHadHierarchicalSeparators = false;
        function wordCount(str) {
            return str.split(/\s+/).length;
        }
        // If there's a separator in the title, first remove the final part
        if (/ [\|\-\\\/>»] /.test(curTitle)) {
            titleHadHierarchicalSeparators = / [\\\/>»] /.test(curTitle);
            curTitle = origTitle.replace(/(.*)[\|\-\\\/>»] .*/gi, "$1");
            // If the resulting title is too short (3 words or fewer), remove
            // the first part instead:
            if (wordCount(curTitle) < 3) curTitle = origTitle.replace(/[^\|\-\\\/>»]*[\|\-\\\/>»](.*)/gi, "$1");
        } else if (curTitle.indexOf(": ") !== -1) {
            // Check if we have an heading containing this exact string, so we
            // could assume it's the full title.
            var headings = this._concatNodeLists(doc.getElementsByTagName("h1"), doc.getElementsByTagName("h2"));
            var trimmedTitle = curTitle.trim();
            var match = this._someNode(headings, function(heading) {
                return heading.textContent.trim() === trimmedTitle;
            });
            // If we don't, let's extract the title out of the original title string.
            if (!match) {
                curTitle = origTitle.substring(origTitle.lastIndexOf(":") + 1);
                // If the title is now too short, try the first colon instead:
                if (wordCount(curTitle) < 3) curTitle = origTitle.substring(origTitle.indexOf(":") + 1);
                else if (wordCount(origTitle.substr(0, origTitle.indexOf(":"))) > 5) curTitle = origTitle;
            }
        } else if (curTitle.length > 150 || curTitle.length < 15) {
            var hOnes = doc.getElementsByTagName("h1");
            if (hOnes.length === 1) curTitle = this._getInnerText(hOnes[0]);
        }
        curTitle = curTitle.trim().replace(this.REGEXPS.normalize, " ");
        // If we now have 4 words or fewer as our title, and either no
        // 'hierarchical' separators (\, /, > or ») were found in the original
        // title or we decreased the number of words by more than 1 word, use
        // the original title.
        var curTitleWordCount = wordCount(curTitle);
        if (curTitleWordCount <= 4 && (!titleHadHierarchicalSeparators || curTitleWordCount != wordCount(origTitle.replace(/[\|\-\\\/>»]+/g, "")) - 1)) curTitle = origTitle;
        return curTitle;
    },
    /**
   * Prepare the HTML document for readability to scrape it.
   * This includes things like stripping javascript, CSS, and handling terrible markup.
   *
   * @return void
   **/ _prepDocument: function() {
        var doc = this._doc;
        // Remove all style tags in head
        this._removeNodes(this._getAllNodesWithTag(doc, [
            "style"
        ]));
        if (doc.body) this._replaceBrs(doc.body);
        this._replaceNodeTags(this._getAllNodesWithTag(doc, [
            "font"
        ]), "SPAN");
    },
    /**
   * Finds the next node, starting from the given node, and ignoring
   * whitespace in between. If the given node is an element, the same node is
   * returned.
   */ _nextNode: function(node) {
        var next = node;
        while(next && next.nodeType != this.ELEMENT_NODE && this.REGEXPS.whitespace.test(next.textContent))next = next.nextSibling;
        return next;
    },
    /**
   * Replaces 2 or more successive <br> elements with a single <p>.
   * Whitespace between <br> elements are ignored. For example:
   *   <div>foo<br>bar<br> <br><br>abc</div>
   * will become:
   *   <div>foo<br>bar<p>abc</p></div>
   */ _replaceBrs: function(elem) {
        this._forEachNode(this._getAllNodesWithTag(elem, [
            "br"
        ]), function(br) {
            var next = br.nextSibling;
            // Whether 2 or more <br> elements have been found and replaced with a
            // <p> block.
            var replaced = false;
            // If we find a <br> chain, remove the <br>s until we hit another node
            // or non-whitespace. This leaves behind the first <br> in the chain
            // (which will be replaced with a <p> later).
            while((next = this._nextNode(next)) && next.tagName == "BR"){
                replaced = true;
                var brSibling = next.nextSibling;
                next.parentNode.removeChild(next);
                next = brSibling;
            }
            // If we removed a <br> chain, replace the remaining <br> with a <p>. Add
            // all sibling nodes as children of the <p> until we hit another <br>
            // chain.
            if (replaced) {
                var p = this._doc.createElement("p");
                br.parentNode.replaceChild(p, br);
                next = p.nextSibling;
                while(next){
                    // If we've hit another <br><br>, we're done adding children to this <p>.
                    if (next.tagName == "BR") {
                        var nextElem = this._nextNode(next.nextSibling);
                        if (nextElem && nextElem.tagName == "BR") break;
                    }
                    if (!this._isPhrasingContent(next)) break;
                    // Otherwise, make this node a child of the new <p>.
                    var sibling = next.nextSibling;
                    p.appendChild(next);
                    next = sibling;
                }
                while(p.lastChild && this._isWhitespace(p.lastChild))p.removeChild(p.lastChild);
                if (p.parentNode.tagName === "P") this._setNodeTag(p.parentNode, "DIV");
            }
        });
    },
    _setNodeTag: function(node, tag) {
        this.log("_setNodeTag", node, tag);
        if (this._docJSDOMParser) {
            node.localName = tag.toLowerCase();
            node.tagName = tag.toUpperCase();
            return node;
        }
        var replacement = node.ownerDocument.createElement(tag);
        while(node.firstChild)replacement.appendChild(node.firstChild);
        node.parentNode.replaceChild(replacement, node);
        if (node.readability) replacement.readability = node.readability;
        for(var i = 0; i < node.attributes.length; i++)try {
            replacement.setAttribute(node.attributes[i].name, node.attributes[i].value);
        } catch (ex) {
        /* it's possible for setAttribute() to throw if the attribute name
         * isn't a valid XML Name. Such attributes can however be parsed from
         * source in HTML docs, see https://github.com/whatwg/html/issues/4275,
         * so we can hit them here and then throw. We don't care about such
         * attributes so we ignore them.
         */ }
        return replacement;
    },
    /**
   * Prepare the article node for display. Clean out any inline styles,
   * iframes, forms, strip extraneous <p> tags, etc.
   *
   * @param Element
   * @return void
   **/ _prepArticle: function(articleContent) {
        this._cleanStyles(articleContent);
        // Check for data tables before we continue, to avoid removing items in
        // those tables, which will often be isolated even though they're
        // visually linked to other content-ful elements (text, images, etc.).
        this._markDataTables(articleContent);
        this._fixLazyImages(articleContent);
        // Clean out junk from the article content
        this._cleanConditionally(articleContent, "form");
        this._cleanConditionally(articleContent, "fieldset");
        this._clean(articleContent, "object");
        this._clean(articleContent, "embed");
        this._clean(articleContent, "footer");
        this._clean(articleContent, "link");
        this._clean(articleContent, "aside");
        // Clean out elements with little content that have "share" in their id/class combinations from final top candidates,
        // which means we don't remove the top candidates even they have "share".
        var shareElementThreshold = this.DEFAULT_CHAR_THRESHOLD;
        this._forEachNode(articleContent.children, function(topCandidate) {
            this._cleanMatchedNodes(topCandidate, function(node, matchString) {
                return this.REGEXPS.shareElements.test(matchString) && node.textContent.length < shareElementThreshold;
            });
        });
        this._clean(articleContent, "iframe");
        this._clean(articleContent, "input");
        this._clean(articleContent, "textarea");
        this._clean(articleContent, "select");
        this._clean(articleContent, "button");
        this._cleanHeaders(articleContent);
        // Do these last as the previous stuff may have removed junk
        // that will affect these
        this._cleanConditionally(articleContent, "table");
        this._cleanConditionally(articleContent, "ul");
        this._cleanConditionally(articleContent, "div");
        // replace H1 with H2 as H1 should be only title that is displayed separately
        this._replaceNodeTags(this._getAllNodesWithTag(articleContent, [
            "h1"
        ]), "h2");
        // Remove extra paragraphs
        this._removeNodes(this._getAllNodesWithTag(articleContent, [
            "p"
        ]), function(paragraph) {
            var imgCount = paragraph.getElementsByTagName("img").length;
            var embedCount = paragraph.getElementsByTagName("embed").length;
            var objectCount = paragraph.getElementsByTagName("object").length;
            // At this point, nasty iframes have been removed, only remain embedded video ones.
            var iframeCount = paragraph.getElementsByTagName("iframe").length;
            var totalCount = imgCount + embedCount + objectCount + iframeCount;
            return totalCount === 0 && !this._getInnerText(paragraph, false);
        });
        this._forEachNode(this._getAllNodesWithTag(articleContent, [
            "br"
        ]), function(br) {
            var next = this._nextNode(br.nextSibling);
            if (next && next.tagName == "P") br.parentNode.removeChild(br);
        });
        // Remove single-cell tables
        this._forEachNode(this._getAllNodesWithTag(articleContent, [
            "table"
        ]), function(table) {
            var tbody = this._hasSingleTagInsideElement(table, "TBODY") ? table.firstElementChild : table;
            if (this._hasSingleTagInsideElement(tbody, "TR")) {
                var row = tbody.firstElementChild;
                if (this._hasSingleTagInsideElement(row, "TD")) {
                    var cell = row.firstElementChild;
                    cell = this._setNodeTag(cell, this._everyNode(cell.childNodes, this._isPhrasingContent) ? "P" : "DIV");
                    table.parentNode.replaceChild(cell, table);
                }
            }
        });
    },
    /**
   * Initialize a node with the readability object. Also checks the
   * className/id for special names to add to its score.
   *
   * @param Element
   * @return void
  **/ _initializeNode: function(node) {
        node.readability = {
            "contentScore": 0
        };
        switch(node.tagName){
            case "DIV":
                node.readability.contentScore += 5;
                break;
            case "PRE":
            case "TD":
            case "BLOCKQUOTE":
                node.readability.contentScore += 3;
                break;
            case "ADDRESS":
            case "OL":
            case "UL":
            case "DL":
            case "DD":
            case "DT":
            case "LI":
            case "FORM":
                node.readability.contentScore -= 3;
                break;
            case "H1":
            case "H2":
            case "H3":
            case "H4":
            case "H5":
            case "H6":
            case "TH":
                node.readability.contentScore -= 5;
                break;
        }
        node.readability.contentScore += this._getClassWeight(node);
    },
    _removeAndGetNext: function(node) {
        var nextNode = this._getNextNode(node, true);
        node.parentNode.removeChild(node);
        return nextNode;
    },
    /**
   * Traverse the DOM from node to node, starting at the node passed in.
   * Pass true for the second parameter to indicate this node itself
   * (and its kids) are going away, and we want the next node over.
   *
   * Calling this in a loop will traverse the DOM depth-first.
   */ _getNextNode: function(node, ignoreSelfAndKids) {
        // First check for kids if those aren't being ignored
        if (!ignoreSelfAndKids && node.firstElementChild) return node.firstElementChild;
        // Then for siblings...
        if (node.nextElementSibling) return node.nextElementSibling;
        // And finally, move up the parent chain *and* find a sibling
        // (because this is depth-first traversal, we will have already
        // seen the parent nodes themselves).
        do node = node.parentNode;
        while (node && !node.nextElementSibling);
        return node && node.nextElementSibling;
    },
    // compares second text to first one
    // 1 = same text, 0 = completely different text
    // works the way that it splits both texts into words and then finds words that are unique in second text
    // the result is given by the lower length of unique parts
    _textSimilarity: function(textA, textB) {
        var tokensA = textA.toLowerCase().split(this.REGEXPS.tokenize).filter(Boolean);
        var tokensB = textB.toLowerCase().split(this.REGEXPS.tokenize).filter(Boolean);
        if (!tokensA.length || !tokensB.length) return 0;
        var uniqTokensB = tokensB.filter((token)=>!tokensA.includes(token));
        var distanceB = uniqTokensB.join(" ").length / tokensB.join(" ").length;
        return 1 - distanceB;
    },
    _checkByline: function(node, matchString) {
        if (this._articleByline) return false;
        if (node.getAttribute !== undefined) {
            var rel = node.getAttribute("rel");
            var itemprop = node.getAttribute("itemprop");
        }
        if ((rel === "author" || itemprop && itemprop.indexOf("author") !== -1 || this.REGEXPS.byline.test(matchString)) && this._isValidByline(node.textContent)) {
            this._articleByline = node.textContent.trim();
            return true;
        }
        return false;
    },
    _getNodeAncestors: function(node, maxDepth) {
        maxDepth = maxDepth || 0;
        var i = 0, ancestors = [];
        while(node.parentNode){
            ancestors.push(node.parentNode);
            if (maxDepth && ++i === maxDepth) break;
            node = node.parentNode;
        }
        return ancestors;
    },
    /***
   * grabArticle - Using a variety of metrics (content score, classname, element types), find the content that is
   *         most likely to be the stuff a user wants to read. Then return it wrapped up in a div.
   *
   * @param page a document to run upon. Needs to be a full document, complete with body.
   * @return Element
  **/ _grabArticle: function(page) {
        this.log("**** grabArticle ****");
        var doc = this._doc;
        var isPaging = page !== null;
        page = page ? page : this._doc.body;
        // We can't grab an article if we don't have a page!
        if (!page) {
            this.log("No body found in document. Abort.");
            return null;
        }
        var pageCacheHtml = page.innerHTML;
        while(true){
            this.log("Starting grabArticle loop");
            var stripUnlikelyCandidates = this._flagIsActive(this.FLAG_STRIP_UNLIKELYS);
            // First, node prepping. Trash nodes that look cruddy (like ones with the
            // class name "comment", etc), and turn divs into P tags where they have been
            // used inappropriately (as in, where they contain no other block level elements.)
            var elementsToScore = [];
            var node = this._doc.documentElement;
            let shouldRemoveTitleHeader = true;
            while(node){
                if (node.tagName === "HTML") this._articleLang = node.getAttribute("lang");
                var matchString = node.className + " " + node.id;
                if (!this._isProbablyVisible(node)) {
                    this.log("Removing hidden node - " + matchString);
                    node = this._removeAndGetNext(node);
                    continue;
                }
                // User is not able to see elements applied with both "aria-modal = true" and "role = dialog"
                if (node.getAttribute("aria-modal") == "true" && node.getAttribute("role") == "dialog") {
                    node = this._removeAndGetNext(node);
                    continue;
                }
                // Check to see if this node is a byline, and remove it if it is.
                if (this._checkByline(node, matchString)) {
                    node = this._removeAndGetNext(node);
                    continue;
                }
                if (shouldRemoveTitleHeader && this._headerDuplicatesTitle(node)) {
                    this.log("Removing header: ", node.textContent.trim(), this._articleTitle.trim());
                    shouldRemoveTitleHeader = false;
                    node = this._removeAndGetNext(node);
                    continue;
                }
                // Remove unlikely candidates
                if (stripUnlikelyCandidates) {
                    if (this.REGEXPS.unlikelyCandidates.test(matchString) && !this.REGEXPS.okMaybeItsACandidate.test(matchString) && !this._hasAncestorTag(node, "table") && !this._hasAncestorTag(node, "code") && node.tagName !== "BODY" && node.tagName !== "A") {
                        this.log("Removing unlikely candidate - " + matchString);
                        node = this._removeAndGetNext(node);
                        continue;
                    }
                    if (this.UNLIKELY_ROLES.includes(node.getAttribute("role"))) {
                        this.log("Removing content with role " + node.getAttribute("role") + " - " + matchString);
                        node = this._removeAndGetNext(node);
                        continue;
                    }
                }
                // Remove DIV, SECTION, and HEADER nodes without any content(e.g. text, image, video, or iframe).
                if ((node.tagName === "DIV" || node.tagName === "SECTION" || node.tagName === "HEADER" || node.tagName === "H1" || node.tagName === "H2" || node.tagName === "H3" || node.tagName === "H4" || node.tagName === "H5" || node.tagName === "H6") && this._isElementWithoutContent(node)) {
                    node = this._removeAndGetNext(node);
                    continue;
                }
                if (this.DEFAULT_TAGS_TO_SCORE.indexOf(node.tagName) !== -1) elementsToScore.push(node);
                // Turn all divs that don't have children block level elements into p's
                if (node.tagName === "DIV") {
                    // Put phrasing content into paragraphs.
                    var p = null;
                    var childNode = node.firstChild;
                    while(childNode){
                        var nextSibling = childNode.nextSibling;
                        if (this._isPhrasingContent(childNode)) {
                            if (p !== null) p.appendChild(childNode);
                            else if (!this._isWhitespace(childNode)) {
                                p = doc.createElement("p");
                                node.replaceChild(p, childNode);
                                p.appendChild(childNode);
                            }
                        } else if (p !== null) {
                            while(p.lastChild && this._isWhitespace(p.lastChild))p.removeChild(p.lastChild);
                            p = null;
                        }
                        childNode = nextSibling;
                    }
                    // Sites like http://mobile.slate.com encloses each paragraph with a DIV
                    // element. DIVs with only a P element inside and no text content can be
                    // safely converted into plain P elements to avoid confusing the scoring
                    // algorithm with DIVs with are, in practice, paragraphs.
                    if (this._hasSingleTagInsideElement(node, "P") && this._getLinkDensity(node) < 0.25) {
                        var newNode = node.children[0];
                        node.parentNode.replaceChild(newNode, node);
                        node = newNode;
                        elementsToScore.push(node);
                    } else if (!this._hasChildBlockElement(node)) {
                        node = this._setNodeTag(node, "P");
                        elementsToScore.push(node);
                    }
                }
                node = this._getNextNode(node);
            }
            /**
       * Loop through all paragraphs, and assign a score to them based on how content-y they look.
       * Then add their score to their parent node.
       *
       * A score is determined by things like number of commas, class names, etc. Maybe eventually link density.
      **/ var candidates = [];
            this._forEachNode(elementsToScore, function(elementToScore) {
                if (!elementToScore.parentNode || typeof elementToScore.parentNode.tagName === "undefined") return;
                // If this paragraph is less than 25 characters, don't even count it.
                var innerText = this._getInnerText(elementToScore);
                if (innerText.length < 25) return;
                // Exclude nodes with no ancestor.
                var ancestors = this._getNodeAncestors(elementToScore, 5);
                if (ancestors.length === 0) return;
                var contentScore = 0;
                // Add a point for the paragraph itself as a base.
                contentScore += 1;
                // Add points for any commas within this paragraph.
                contentScore += innerText.split(",").length;
                // For every 100 characters in this paragraph, add another point. Up to 3 points.
                contentScore += Math.min(Math.floor(innerText.length / 100), 3);
                // Initialize and score ancestors.
                this._forEachNode(ancestors, function(ancestor, level) {
                    if (!ancestor.tagName || !ancestor.parentNode || typeof ancestor.parentNode.tagName === "undefined") return;
                    if (typeof ancestor.readability === "undefined") {
                        this._initializeNode(ancestor);
                        candidates.push(ancestor);
                    }
                    // Node score divider:
                    // - parent:             1 (no division)
                    // - grandparent:        2
                    // - great grandparent+: ancestor level * 3
                    if (level === 0) var scoreDivider = 1;
                    else if (level === 1) scoreDivider = 2;
                    else scoreDivider = level * 3;
                    ancestor.readability.contentScore += contentScore / scoreDivider;
                });
            });
            // After we've calculated scores, loop through all of the possible
            // candidate nodes we found and find the one with the highest score.
            var topCandidates = [];
            for(var c = 0, cl = candidates.length; c < cl; c += 1){
                var candidate = candidates[c];
                // Scale the final candidates score based on link density. Good content
                // should have a relatively small link density (5% or less) and be mostly
                // unaffected by this operation.
                var candidateScore = candidate.readability.contentScore * (1 - this._getLinkDensity(candidate));
                candidate.readability.contentScore = candidateScore;
                this.log("Candidate:", candidate, "with score " + candidateScore);
                for(var t = 0; t < this._nbTopCandidates; t++){
                    var aTopCandidate = topCandidates[t];
                    if (!aTopCandidate || candidateScore > aTopCandidate.readability.contentScore) {
                        topCandidates.splice(t, 0, candidate);
                        if (topCandidates.length > this._nbTopCandidates) topCandidates.pop();
                        break;
                    }
                }
            }
            var topCandidate = topCandidates[0] || null;
            var neededToCreateTopCandidate = false;
            var parentOfTopCandidate;
            // If we still have no top candidate, just use the body as a last resort.
            // We also have to copy the body node so it is something we can modify.
            if (topCandidate === null || topCandidate.tagName === "BODY") {
                // Move all of the page's children into topCandidate
                topCandidate = doc.createElement("DIV");
                neededToCreateTopCandidate = true;
                // Move everything (not just elements, also text nodes etc.) into the container
                // so we even include text directly in the body:
                while(page.firstChild){
                    this.log("Moving child out:", page.firstChild);
                    topCandidate.appendChild(page.firstChild);
                }
                page.appendChild(topCandidate);
                this._initializeNode(topCandidate);
            } else if (topCandidate) {
                // Find a better top candidate node if it contains (at least three) nodes which belong to `topCandidates` array
                // and whose scores are quite closed with current `topCandidate` node.
                var alternativeCandidateAncestors = [];
                for(var i = 1; i < topCandidates.length; i++)if (topCandidates[i].readability.contentScore / topCandidate.readability.contentScore >= 0.75) alternativeCandidateAncestors.push(this._getNodeAncestors(topCandidates[i]));
                var MINIMUM_TOPCANDIDATES = 3;
                if (alternativeCandidateAncestors.length >= MINIMUM_TOPCANDIDATES) {
                    parentOfTopCandidate = topCandidate.parentNode;
                    while(parentOfTopCandidate.tagName !== "BODY"){
                        var listsContainingThisAncestor = 0;
                        for(var ancestorIndex = 0; ancestorIndex < alternativeCandidateAncestors.length && listsContainingThisAncestor < MINIMUM_TOPCANDIDATES; ancestorIndex++)listsContainingThisAncestor += Number(alternativeCandidateAncestors[ancestorIndex].includes(parentOfTopCandidate));
                        if (listsContainingThisAncestor >= MINIMUM_TOPCANDIDATES) {
                            topCandidate = parentOfTopCandidate;
                            break;
                        }
                        parentOfTopCandidate = parentOfTopCandidate.parentNode;
                    }
                }
                if (!topCandidate.readability) this._initializeNode(topCandidate);
                // Because of our bonus system, parents of candidates might have scores
                // themselves. They get half of the node. There won't be nodes with higher
                // scores than our topCandidate, but if we see the score going *up* in the first
                // few steps up the tree, that's a decent sign that there might be more content
                // lurking in other places that we want to unify in. The sibling stuff
                // below does some of that - but only if we've looked high enough up the DOM
                // tree.
                parentOfTopCandidate = topCandidate.parentNode;
                var lastScore = topCandidate.readability.contentScore;
                // The scores shouldn't get too low.
                var scoreThreshold = lastScore / 3;
                while(parentOfTopCandidate.tagName !== "BODY"){
                    if (!parentOfTopCandidate.readability) {
                        parentOfTopCandidate = parentOfTopCandidate.parentNode;
                        continue;
                    }
                    var parentScore = parentOfTopCandidate.readability.contentScore;
                    if (parentScore < scoreThreshold) break;
                    if (parentScore > lastScore) {
                        // Alright! We found a better parent to use.
                        topCandidate = parentOfTopCandidate;
                        break;
                    }
                    lastScore = parentOfTopCandidate.readability.contentScore;
                    parentOfTopCandidate = parentOfTopCandidate.parentNode;
                }
                // If the top candidate is the only child, use parent instead. This will help sibling
                // joining logic when adjacent content is actually located in parent's sibling node.
                parentOfTopCandidate = topCandidate.parentNode;
                while(parentOfTopCandidate.tagName != "BODY" && parentOfTopCandidate.children.length == 1){
                    topCandidate = parentOfTopCandidate;
                    parentOfTopCandidate = topCandidate.parentNode;
                }
                if (!topCandidate.readability) this._initializeNode(topCandidate);
            }
            // Now that we have the top candidate, look through its siblings for content
            // that might also be related. Things like preambles, content split by ads
            // that we removed, etc.
            var articleContent = doc.createElement("DIV");
            if (isPaging) articleContent.id = "readability-content";
            var siblingScoreThreshold = Math.max(10, topCandidate.readability.contentScore * 0.2);
            // Keep potential top candidate's parent node to try to get text direction of it later.
            parentOfTopCandidate = topCandidate.parentNode;
            var siblings = parentOfTopCandidate.children;
            for(var s = 0, sl = siblings.length; s < sl; s++){
                var sibling = siblings[s];
                var append = false;
                this.log("Looking at sibling node:", sibling, sibling.readability ? "with score " + sibling.readability.contentScore : "");
                this.log("Sibling has score", sibling.readability ? sibling.readability.contentScore : "Unknown");
                if (sibling === topCandidate) append = true;
                else {
                    var contentBonus = 0;
                    // Give a bonus if sibling nodes and top candidates have the example same classname
                    if (sibling.className === topCandidate.className && topCandidate.className !== "") contentBonus += topCandidate.readability.contentScore * 0.2;
                    if (sibling.readability && sibling.readability.contentScore + contentBonus >= siblingScoreThreshold) append = true;
                    else if (sibling.nodeName === "P") {
                        var linkDensity = this._getLinkDensity(sibling);
                        var nodeContent = this._getInnerText(sibling);
                        var nodeLength = nodeContent.length;
                        if (nodeLength > 80 && linkDensity < 0.25) append = true;
                        else if (nodeLength < 80 && nodeLength > 0 && linkDensity === 0 && nodeContent.search(/\.( |$)/) !== -1) append = true;
                    }
                }
                if (append) {
                    this.log("Appending node:", sibling);
                    if (this.ALTER_TO_DIV_EXCEPTIONS.indexOf(sibling.nodeName) === -1) {
                        // We have a node that isn't a common block level element, like a form or td tag.
                        // Turn it into a div so it doesn't get filtered out later by accident.
                        this.log("Altering sibling:", sibling, "to div.");
                        sibling = this._setNodeTag(sibling, "DIV");
                    }
                    articleContent.appendChild(sibling);
                    // Fetch children again to make it compatible
                    // with DOM parsers without live collection support.
                    siblings = parentOfTopCandidate.children;
                    // siblings is a reference to the children array, and
                    // sibling is removed from the array when we call appendChild().
                    // As a result, we must revisit this index since the nodes
                    // have been shifted.
                    s -= 1;
                    sl -= 1;
                }
            }
            if (this._debug) this.log("Article content pre-prep: " + articleContent.innerHTML);
            // So we have all of the content that we need. Now we clean it up for presentation.
            this._prepArticle(articleContent);
            if (this._debug) this.log("Article content post-prep: " + articleContent.innerHTML);
            if (neededToCreateTopCandidate) {
                // We already created a fake div thing, and there wouldn't have been any siblings left
                // for the previous loop, so there's no point trying to create a new div, and then
                // move all the children over. Just assign IDs and class names here. No need to append
                // because that already happened anyway.
                topCandidate.id = "readability-page-1";
                topCandidate.className = "page";
            } else {
                var div = doc.createElement("DIV");
                div.id = "readability-page-1";
                div.className = "page";
                while(articleContent.firstChild)div.appendChild(articleContent.firstChild);
                articleContent.appendChild(div);
            }
            if (this._debug) this.log("Article content after paging: " + articleContent.innerHTML);
            var parseSuccessful = true;
            // Now that we've gone through the full algorithm, check to see if
            // we got any meaningful content. If we didn't, we may need to re-run
            // grabArticle with different flags set. This gives us a higher likelihood of
            // finding the content, and the sieve approach gives us a higher likelihood of
            // finding the -right- content.
            var textLength = this._getInnerText(articleContent, true).length;
            if (textLength < this._charThreshold) {
                parseSuccessful = false;
                page.innerHTML = pageCacheHtml;
                if (this._flagIsActive(this.FLAG_STRIP_UNLIKELYS)) {
                    this._removeFlag(this.FLAG_STRIP_UNLIKELYS);
                    this._attempts.push({
                        articleContent: articleContent,
                        textLength: textLength
                    });
                } else if (this._flagIsActive(this.FLAG_WEIGHT_CLASSES)) {
                    this._removeFlag(this.FLAG_WEIGHT_CLASSES);
                    this._attempts.push({
                        articleContent: articleContent,
                        textLength: textLength
                    });
                } else if (this._flagIsActive(this.FLAG_CLEAN_CONDITIONALLY)) {
                    this._removeFlag(this.FLAG_CLEAN_CONDITIONALLY);
                    this._attempts.push({
                        articleContent: articleContent,
                        textLength: textLength
                    });
                } else {
                    this._attempts.push({
                        articleContent: articleContent,
                        textLength: textLength
                    });
                    // No luck after removing flags, just return the longest text we found during the different loops
                    this._attempts.sort(function(a, b) {
                        return b.textLength - a.textLength;
                    });
                    // But first check if we actually have something
                    if (!this._attempts[0].textLength) return null;
                    articleContent = this._attempts[0].articleContent;
                    parseSuccessful = true;
                }
            }
            if (parseSuccessful) {
                // Find out text direction from ancestors of final top candidate.
                var ancestors = [
                    parentOfTopCandidate,
                    topCandidate
                ].concat(this._getNodeAncestors(parentOfTopCandidate));
                this._someNode(ancestors, function(ancestor) {
                    if (!ancestor.tagName) return false;
                    var articleDir = ancestor.getAttribute("dir");
                    if (articleDir) {
                        this._articleDir = articleDir;
                        return true;
                    }
                    return false;
                });
                return articleContent;
            }
        }
    },
    /**
   * Check whether the input string could be a byline.
   * This verifies that the input is a string, and that the length
   * is less than 100 chars.
   *
   * @param possibleByline {string} - a string to check whether its a byline.
   * @return Boolean - whether the input string is a byline.
   */ _isValidByline: function(byline) {
        if (typeof byline == "string" || byline instanceof String) {
            byline = byline.trim();
            return byline.length > 0 && byline.length < 100;
        }
        return false;
    },
    /**
   * Converts some of the common HTML entities in string to their corresponding characters.
   *
   * @param str {string} - a string to unescape.
   * @return string without HTML entity.
   */ _unescapeHtmlEntities: function(str) {
        if (!str) return str;
        var htmlEscapeMap = this.HTML_ESCAPE_MAP;
        return str.replace(/&(quot|amp|apos|lt|gt);/g, function(_, tag) {
            return htmlEscapeMap[tag];
        }).replace(/&#(?:x([0-9a-z]{1,4})|([0-9]{1,4}));/gi, function(_, hex, numStr) {
            var num = parseInt(hex || numStr, hex ? 16 : 10);
            return String.fromCharCode(num);
        });
    },
    /**
   * Try to extract metadata from JSON-LD object.
   * For now, only Schema.org objects of type Article or its subtypes are supported.
   * @return Object with any metadata that could be extracted (possibly none)
   */ _getJSONLD: function(doc) {
        var scripts = this._getAllNodesWithTag(doc, [
            "script"
        ]);
        var metadata;
        this._forEachNode(scripts, function(jsonLdElement) {
            if (!metadata && jsonLdElement.getAttribute("type") === "application/ld+json") try {
                // Strip CDATA markers if present
                var content = jsonLdElement.textContent.replace(/^\s*<!\[CDATA\[|\]\]>\s*$/g, "");
                var parsed = JSON.parse(content);
                if (!parsed["@context"] || !parsed["@context"].match(/^https?\:\/\/schema\.org$/)) return;
                if (!parsed["@type"] && Array.isArray(parsed["@graph"])) parsed = parsed["@graph"].find(function(it) {
                    return (it["@type"] || "").match(this.REGEXPS.jsonLdArticleTypes);
                });
                if (!parsed || !parsed["@type"] || !parsed["@type"].match(this.REGEXPS.jsonLdArticleTypes)) return;
                metadata = {};
                if (typeof parsed.name === "string" && typeof parsed.headline === "string" && parsed.name !== parsed.headline) {
                    // we have both name and headline element in the JSON-LD. They should both be the same but some websites like aktualne.cz
                    // put their own name into "name" and the article title to "headline" which confuses Readability. So we try to check if either
                    // "name" or "headline" closely matches the html title, and if so, use that one. If not, then we use "name" by default.
                    var title = this._getArticleTitle();
                    var nameMatches = this._textSimilarity(parsed.name, title) > 0.75;
                    var headlineMatches = this._textSimilarity(parsed.headline, title) > 0.75;
                    if (headlineMatches && !nameMatches) metadata.title = parsed.headline;
                    else metadata.title = parsed.name;
                } else if (typeof parsed.name === "string") metadata.title = parsed.name.trim();
                else if (typeof parsed.headline === "string") metadata.title = parsed.headline.trim();
                if (parsed.author) {
                    if (typeof parsed.author.name === "string") metadata.byline = parsed.author.name.trim();
                    else if (Array.isArray(parsed.author) && parsed.author[0] && typeof parsed.author[0].name === "string") metadata.byline = parsed.author.filter(function(author) {
                        return author && typeof author.name === "string";
                    }).map(function(author) {
                        return author.name.trim();
                    }).join(", ");
                }
                if (typeof parsed.description === "string") metadata.excerpt = parsed.description.trim();
                if (parsed.publisher && typeof parsed.publisher.name === "string") metadata.siteName = parsed.publisher.name.trim();
                return;
            } catch (err) {
                this.log(err.message);
            }
        });
        return metadata ? metadata : {};
    },
    /**
   * Attempts to get excerpt and byline metadata for the article.
   *
   * @param {Object} jsonld — object containing any metadata that
   * could be extracted from JSON-LD object.
   *
   * @return Object with optional "excerpt" and "byline" properties
   */ _getArticleMetadata: function(jsonld) {
        var metadata = {};
        var values = {};
        var metaElements = this._doc.getElementsByTagName("meta");
        // property is a space-separated list of values
        var propertyPattern = /\s*(dc|dcterm|og|twitter)\s*:\s*(author|creator|description|title|site_name)\s*/gi;
        // name is a single value
        var namePattern = /^\s*(?:(dc|dcterm|og|twitter|weibo:(article|webpage))\s*[\.:]\s*)?(author|creator|description|title|site_name)\s*$/i;
        // Find description tags.
        this._forEachNode(metaElements, function(element) {
            var elementName = element.getAttribute("name");
            var elementProperty = element.getAttribute("property");
            var content = element.getAttribute("content");
            if (!content) return;
            var matches = null;
            var name = null;
            if (elementProperty) {
                matches = elementProperty.match(propertyPattern);
                if (matches) {
                    // Convert to lowercase, and remove any whitespace
                    // so we can match below.
                    name = matches[0].toLowerCase().replace(/\s/g, "");
                    // multiple authors
                    values[name] = content.trim();
                }
            }
            if (!matches && elementName && namePattern.test(elementName)) {
                name = elementName;
                if (content) {
                    // Convert to lowercase, remove any whitespace, and convert dots
                    // to colons so we can match below.
                    name = name.toLowerCase().replace(/\s/g, "").replace(/\./g, ":");
                    values[name] = content.trim();
                }
            }
        });
        // get title
        metadata.title = jsonld.title || values["dc:title"] || values["dcterm:title"] || values["og:title"] || values["weibo:article:title"] || values["weibo:webpage:title"] || values["title"] || values["twitter:title"];
        if (!metadata.title) metadata.title = this._getArticleTitle();
        // get author
        metadata.byline = jsonld.byline || values["dc:creator"] || values["dcterm:creator"] || values["author"];
        // get description
        metadata.excerpt = jsonld.excerpt || values["dc:description"] || values["dcterm:description"] || values["og:description"] || values["weibo:article:description"] || values["weibo:webpage:description"] || values["description"] || values["twitter:description"];
        // get site name
        metadata.siteName = jsonld.siteName || values["og:site_name"];
        // in many sites the meta value is escaped with HTML entities,
        // so here we need to unescape it
        metadata.title = this._unescapeHtmlEntities(metadata.title);
        metadata.byline = this._unescapeHtmlEntities(metadata.byline);
        metadata.excerpt = this._unescapeHtmlEntities(metadata.excerpt);
        metadata.siteName = this._unescapeHtmlEntities(metadata.siteName);
        return metadata;
    },
    /**
   * Check if node is image, or if node contains exactly only one image
   * whether as a direct child or as its descendants.
   *
   * @param Element
  **/ _isSingleImage: function(node) {
        if (node.tagName === "IMG") return true;
        if (node.children.length !== 1 || node.textContent.trim() !== "") return false;
        return this._isSingleImage(node.children[0]);
    },
    /**
   * Find all <noscript> that are located after <img> nodes, and which contain only one
   * <img> element. Replace the first image with the image from inside the <noscript> tag,
   * and remove the <noscript> tag. This improves the quality of the images we use on
   * some sites (e.g. Medium).
   *
   * @param Element
  **/ _unwrapNoscriptImages: function(doc) {
        // Find img without source or attributes that might contains image, and remove it.
        // This is done to prevent a placeholder img is replaced by img from noscript in next step.
        var imgs = Array.from(doc.getElementsByTagName("img"));
        this._forEachNode(imgs, function(img) {
            for(var i = 0; i < img.attributes.length; i++){
                var attr = img.attributes[i];
                switch(attr.name){
                    case "src":
                    case "srcset":
                    case "data-src":
                    case "data-srcset":
                        return;
                }
                if (/\.(jpg|jpeg|png|webp)/i.test(attr.value)) return;
            }
            img.parentNode.removeChild(img);
        });
        // Next find noscript and try to extract its image
        var noscripts = Array.from(doc.getElementsByTagName("noscript"));
        this._forEachNode(noscripts, function(noscript) {
            // Parse content of noscript and make sure it only contains image
            var tmp = doc.createElement("div");
            tmp.innerHTML = noscript.innerHTML;
            if (!this._isSingleImage(tmp)) return;
            // If noscript has previous sibling and it only contains image,
            // replace it with noscript content. However we also keep old
            // attributes that might contains image.
            var prevElement = noscript.previousElementSibling;
            if (prevElement && this._isSingleImage(prevElement)) {
                var prevImg = prevElement;
                if (prevImg.tagName !== "IMG") prevImg = prevElement.getElementsByTagName("img")[0];
                var newImg = tmp.getElementsByTagName("img")[0];
                for(var i = 0; i < prevImg.attributes.length; i++){
                    var attr = prevImg.attributes[i];
                    if (attr.value === "") continue;
                    if (attr.name === "src" || attr.name === "srcset" || /\.(jpg|jpeg|png|webp)/i.test(attr.value)) {
                        if (newImg.getAttribute(attr.name) === attr.value) continue;
                        var attrName = attr.name;
                        if (newImg.hasAttribute(attrName)) attrName = "data-old-" + attrName;
                        newImg.setAttribute(attrName, attr.value);
                    }
                }
                noscript.parentNode.replaceChild(tmp.firstElementChild, prevElement);
            }
        });
    },
    /**
   * Removes script tags from the document.
   *
   * @param Element
  **/ _removeScripts: function(doc) {
        this._removeNodes(this._getAllNodesWithTag(doc, [
            "script",
            "noscript"
        ]));
    },
    /**
   * Check if this node has only whitespace and a single element with given tag
   * Returns false if the DIV node contains non-empty text nodes
   * or if it contains no element with given tag or more than 1 element.
   *
   * @param Element
   * @param string tag of child element
  **/ _hasSingleTagInsideElement: function(element, tag) {
        // There should be exactly 1 element child with given tag
        if (element.children.length != 1 || element.children[0].tagName !== tag) return false;
        // And there should be no text nodes with real content
        return !this._someNode(element.childNodes, function(node) {
            return node.nodeType === this.TEXT_NODE && this.REGEXPS.hasContent.test(node.textContent);
        });
    },
    _isElementWithoutContent: function(node) {
        return node.nodeType === this.ELEMENT_NODE && node.textContent.trim().length == 0 && (node.children.length == 0 || node.children.length == node.getElementsByTagName("br").length + node.getElementsByTagName("hr").length);
    },
    /**
   * Determine whether element has any children block level elements.
   *
   * @param Element
   */ _hasChildBlockElement: function(element) {
        return this._someNode(element.childNodes, function(node) {
            return this.DIV_TO_P_ELEMS.has(node.tagName) || this._hasChildBlockElement(node);
        });
    },
    /***
   * Determine if a node qualifies as phrasing content.
   * https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Content_categories#Phrasing_content
  **/ _isPhrasingContent: function(node) {
        return node.nodeType === this.TEXT_NODE || this.PHRASING_ELEMS.indexOf(node.tagName) !== -1 || (node.tagName === "A" || node.tagName === "DEL" || node.tagName === "INS") && this._everyNode(node.childNodes, this._isPhrasingContent);
    },
    _isWhitespace: function(node) {
        return node.nodeType === this.TEXT_NODE && node.textContent.trim().length === 0 || node.nodeType === this.ELEMENT_NODE && node.tagName === "BR";
    },
    /**
   * Get the inner text of a node - cross browser compatibly.
   * This also strips out any excess whitespace to be found.
   *
   * @param Element
   * @param Boolean normalizeSpaces (default: true)
   * @return string
  **/ _getInnerText: function(e, normalizeSpaces) {
        normalizeSpaces = typeof normalizeSpaces === "undefined" ? true : normalizeSpaces;
        var textContent = e.textContent.trim();
        if (normalizeSpaces) return textContent.replace(this.REGEXPS.normalize, " ");
        return textContent;
    },
    /**
   * Get the number of times a string s appears in the node e.
   *
   * @param Element
   * @param string - what to split on. Default is ","
   * @return number (integer)
  **/ _getCharCount: function(e, s) {
        s = s || ",";
        return this._getInnerText(e).split(s).length - 1;
    },
    /**
   * Remove the style attribute on every e and under.
   * TODO: Test if getElementsByTagName(*) is faster.
   *
   * @param Element
   * @return void
  **/ _cleanStyles: function(e) {
        if (!e || e.tagName.toLowerCase() === "svg") return;
        // Remove `style` and deprecated presentational attributes
        for(var i = 0; i < this.PRESENTATIONAL_ATTRIBUTES.length; i++)e.removeAttribute(this.PRESENTATIONAL_ATTRIBUTES[i]);
        if (this.DEPRECATED_SIZE_ATTRIBUTE_ELEMS.indexOf(e.tagName) !== -1) {
            e.removeAttribute("width");
            e.removeAttribute("height");
        }
        var cur = e.firstElementChild;
        while(cur !== null){
            this._cleanStyles(cur);
            cur = cur.nextElementSibling;
        }
    },
    /**
   * Get the density of links as a percentage of the content
   * This is the amount of text that is inside a link divided by the total text in the node.
   *
   * @param Element
   * @return number (float)
  **/ _getLinkDensity: function(element) {
        var textLength = this._getInnerText(element).length;
        if (textLength === 0) return 0;
        var linkLength = 0;
        // XXX implement _reduceNodeList?
        this._forEachNode(element.getElementsByTagName("a"), function(linkNode) {
            var href = linkNode.getAttribute("href");
            var coefficient = href && this.REGEXPS.hashUrl.test(href) ? 0.3 : 1;
            linkLength += this._getInnerText(linkNode).length * coefficient;
        });
        return linkLength / textLength;
    },
    /**
   * Get an elements class/id weight. Uses regular expressions to tell if this
   * element looks good or bad.
   *
   * @param Element
   * @return number (Integer)
  **/ _getClassWeight: function(e) {
        if (!this._flagIsActive(this.FLAG_WEIGHT_CLASSES)) return 0;
        var weight = 0;
        // Look for a special classname
        if (typeof e.className === "string" && e.className !== "") {
            if (this.REGEXPS.negative.test(e.className)) weight -= 25;
            if (this.REGEXPS.positive.test(e.className)) weight += 25;
        }
        // Look for a special ID
        if (typeof e.id === "string" && e.id !== "") {
            if (this.REGEXPS.negative.test(e.id)) weight -= 25;
            if (this.REGEXPS.positive.test(e.id)) weight += 25;
        }
        return weight;
    },
    /**
   * Clean a node of all elements of type "tag".
   * (Unless it's a youtube/vimeo video. People love movies.)
   *
   * @param Element
   * @param string tag to clean
   * @return void
   **/ _clean: function(e, tag) {
        var isEmbed = [
            "object",
            "embed",
            "iframe"
        ].indexOf(tag) !== -1;
        this._removeNodes(this._getAllNodesWithTag(e, [
            tag
        ]), function(element) {
            // Allow youtube and vimeo videos through as people usually want to see those.
            if (isEmbed) {
                // First, check the elements attributes to see if any of them contain youtube or vimeo
                for(var i = 0; i < element.attributes.length; i++){
                    if (this._allowedVideoRegex.test(element.attributes[i].value)) return false;
                }
                // For embed with <object> tag, check inner HTML as well.
                if (element.tagName === "object" && this._allowedVideoRegex.test(element.innerHTML)) return false;
            }
            return true;
        });
    },
    /**
   * Check if a given node has one of its ancestor tag name matching the
   * provided one.
   * @param  HTMLElement node
   * @param  String      tagName
   * @param  Number      maxDepth
   * @param  Function    filterFn a filter to invoke to determine whether this node 'counts'
   * @return Boolean
   */ _hasAncestorTag: function(node, tagName, maxDepth, filterFn) {
        maxDepth = maxDepth || 3;
        tagName = tagName.toUpperCase();
        var depth = 0;
        while(node.parentNode){
            if (maxDepth > 0 && depth > maxDepth) return false;
            if (node.parentNode.tagName === tagName && (!filterFn || filterFn(node.parentNode))) return true;
            node = node.parentNode;
            depth++;
        }
        return false;
    },
    /**
   * Return an object indicating how many rows and columns this table has.
   */ _getRowAndColumnCount: function(table) {
        var rows = 0;
        var columns = 0;
        var trs = table.getElementsByTagName("tr");
        for(var i = 0; i < trs.length; i++){
            var rowspan = trs[i].getAttribute("rowspan") || 0;
            if (rowspan) rowspan = parseInt(rowspan, 10);
            rows += rowspan || 1;
            // Now look for column-related info
            var columnsInThisRow = 0;
            var cells = trs[i].getElementsByTagName("td");
            for(var j = 0; j < cells.length; j++){
                var colspan = cells[j].getAttribute("colspan") || 0;
                if (colspan) colspan = parseInt(colspan, 10);
                columnsInThisRow += colspan || 1;
            }
            columns = Math.max(columns, columnsInThisRow);
        }
        return {
            rows: rows,
            columns: columns
        };
    },
    /**
   * Look for 'data' (as opposed to 'layout') tables, for which we use
   * similar checks as
   * https://searchfox.org/mozilla-central/rev/f82d5c549f046cb64ce5602bfd894b7ae807c8f8/accessible/generic/TableAccessible.cpp#19
   */ _markDataTables: function(root) {
        var tables = root.getElementsByTagName("table");
        for(var i = 0; i < tables.length; i++){
            var table = tables[i];
            var role = table.getAttribute("role");
            if (role == "presentation") {
                table._readabilityDataTable = false;
                continue;
            }
            var datatable = table.getAttribute("datatable");
            if (datatable == "0") {
                table._readabilityDataTable = false;
                continue;
            }
            var summary = table.getAttribute("summary");
            if (summary) {
                table._readabilityDataTable = true;
                continue;
            }
            var caption = table.getElementsByTagName("caption")[0];
            if (caption && caption.childNodes.length > 0) {
                table._readabilityDataTable = true;
                continue;
            }
            // If the table has a descendant with any of these tags, consider a data table:
            var dataTableDescendants = [
                "col",
                "colgroup",
                "tfoot",
                "thead",
                "th"
            ];
            var descendantExists = function(tag) {
                return !!table.getElementsByTagName(tag)[0];
            };
            if (dataTableDescendants.some(descendantExists)) {
                this.log("Data table because found data-y descendant");
                table._readabilityDataTable = true;
                continue;
            }
            // Nested tables indicate a layout table:
            if (table.getElementsByTagName("table")[0]) {
                table._readabilityDataTable = false;
                continue;
            }
            var sizeInfo = this._getRowAndColumnCount(table);
            if (sizeInfo.rows >= 10 || sizeInfo.columns > 4) {
                table._readabilityDataTable = true;
                continue;
            }
            // Now just go by size entirely:
            table._readabilityDataTable = sizeInfo.rows * sizeInfo.columns > 10;
        }
    },
    /* convert images and figures that have properties like data-src into images that can be loaded without JS */ _fixLazyImages: function(root) {
        this._forEachNode(this._getAllNodesWithTag(root, [
            "img",
            "picture",
            "figure"
        ]), function(elem) {
            // In some sites (e.g. Kotaku), they put 1px square image as base64 data uri in the src attribute.
            // So, here we check if the data uri is too short, just might as well remove it.
            if (elem.src && this.REGEXPS.b64DataUrl.test(elem.src)) {
                // Make sure it's not SVG, because SVG can have a meaningful image in under 133 bytes.
                var parts = this.REGEXPS.b64DataUrl.exec(elem.src);
                if (parts[1] === "image/svg+xml") return;
                // Make sure this element has other attributes which contains image.
                // If it doesn't, then this src is important and shouldn't be removed.
                var srcCouldBeRemoved = false;
                for(var i = 0; i < elem.attributes.length; i++){
                    var attr = elem.attributes[i];
                    if (attr.name === "src") continue;
                    if (/\.(jpg|jpeg|png|webp)/i.test(attr.value)) {
                        srcCouldBeRemoved = true;
                        break;
                    }
                }
                // Here we assume if image is less than 100 bytes (or 133B after encoded to base64)
                // it will be too small, therefore it might be placeholder image.
                if (srcCouldBeRemoved) {
                    var b64starts = elem.src.search(/base64\s*/i) + 7;
                    var b64length = elem.src.length - b64starts;
                    if (b64length < 133) elem.removeAttribute("src");
                }
            }
            // also check for "null" to work around https://github.com/jsdom/jsdom/issues/2580
            if ((elem.src || elem.srcset && elem.srcset != "null") && elem.className.toLowerCase().indexOf("lazy") === -1) return;
            for(var j = 0; j < elem.attributes.length; j++){
                attr = elem.attributes[j];
                if (attr.name === "src" || attr.name === "srcset" || attr.name === "alt") continue;
                var copyTo = null;
                if (/\.(jpg|jpeg|png|webp)\s+\d/.test(attr.value)) copyTo = "srcset";
                else if (/^\s*\S+\.(jpg|jpeg|png|webp)\S*\s*$/.test(attr.value)) copyTo = "src";
                if (copyTo) {
                    //if this is an img or picture, set the attribute directly
                    if (elem.tagName === "IMG" || elem.tagName === "PICTURE") elem.setAttribute(copyTo, attr.value);
                    else if (elem.tagName === "FIGURE" && !this._getAllNodesWithTag(elem, [
                        "img",
                        "picture"
                    ]).length) {
                        //if the item is a <figure> that does not contain an image or picture, create one and place it inside the figure
                        //see the nytimes-3 testcase for an example
                        var img = this._doc.createElement("img");
                        img.setAttribute(copyTo, attr.value);
                        elem.appendChild(img);
                    }
                }
            }
        });
    },
    _getTextDensity: function(e, tags) {
        var textLength = this._getInnerText(e, true).length;
        if (textLength === 0) return 0;
        var childrenLength = 0;
        var children = this._getAllNodesWithTag(e, tags);
        this._forEachNode(children, (child)=>childrenLength += this._getInnerText(child, true).length);
        return childrenLength / textLength;
    },
    /**
   * Clean an element of all tags of type "tag" if they look fishy.
   * "Fishy" is an algorithm based on content length, classnames, link density, number of images & embeds, etc.
   *
   * @return void
   **/ _cleanConditionally: function(e, tag) {
        if (!this._flagIsActive(this.FLAG_CLEAN_CONDITIONALLY)) return;
        // Gather counts for other typical elements embedded within.
        // Traverse backwards so we can remove nodes at the same time
        // without effecting the traversal.
        //
        // TODO: Consider taking into account original contentScore here.
        this._removeNodes(this._getAllNodesWithTag(e, [
            tag
        ]), function(node) {
            // First check if this node IS data table, in which case don't remove it.
            var isDataTable = function(t) {
                return t._readabilityDataTable;
            };
            var isList = tag === "ul" || tag === "ol";
            if (!isList) {
                var listLength = 0;
                var listNodes = this._getAllNodesWithTag(node, [
                    "ul",
                    "ol"
                ]);
                this._forEachNode(listNodes, (list)=>listLength += this._getInnerText(list).length);
                isList = listLength / this._getInnerText(node).length > 0.9;
            }
            if (tag === "table" && isDataTable(node)) return false;
            // Next check if we're inside a data table, in which case don't remove it as well.
            if (this._hasAncestorTag(node, "table", -1, isDataTable)) return false;
            if (this._hasAncestorTag(node, "code")) return false;
            var weight = this._getClassWeight(node);
            this.log("Cleaning Conditionally", node);
            var contentScore = 0;
            if (weight + contentScore < 0) return true;
            if (this._getCharCount(node, ",") < 10) {
                // If there are not very many commas, and the number of
                // non-paragraph elements is more than paragraphs or other
                // ominous signs, remove the element.
                var p = node.getElementsByTagName("p").length;
                var img = node.getElementsByTagName("img").length;
                var li = node.getElementsByTagName("li").length - 100;
                var input = node.getElementsByTagName("input").length;
                var headingDensity = this._getTextDensity(node, [
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6"
                ]);
                var embedCount = 0;
                var embeds = this._getAllNodesWithTag(node, [
                    "object",
                    "embed",
                    "iframe"
                ]);
                for(var i = 0; i < embeds.length; i++){
                    // If this embed has attribute that matches video regex, don't delete it.
                    for(var j = 0; j < embeds[i].attributes.length; j++){
                        if (this._allowedVideoRegex.test(embeds[i].attributes[j].value)) return false;
                    }
                    // For embed with <object> tag, check inner HTML as well.
                    if (embeds[i].tagName === "object" && this._allowedVideoRegex.test(embeds[i].innerHTML)) return false;
                    embedCount++;
                }
                var linkDensity = this._getLinkDensity(node);
                var contentLength = this._getInnerText(node).length;
                var haveToRemove = img > 1 && p / img < 0.5 && !this._hasAncestorTag(node, "figure") || !isList && li > p || input > Math.floor(p / 3) || !isList && headingDensity < 0.9 && contentLength < 25 && (img === 0 || img > 2) && !this._hasAncestorTag(node, "figure") || !isList && weight < 25 && linkDensity > 0.2 || weight >= 25 && linkDensity > 0.5 || embedCount === 1 && contentLength < 75 || embedCount > 1;
                // Allow simple lists of images to remain in pages
                if (isList && haveToRemove) {
                    for(var x = 0; x < node.children.length; x++){
                        let child = node.children[x];
                        // Don't filter in lists with li's that contain more than one child
                        if (child.children.length > 1) return haveToRemove;
                    }
                    let li_count = node.getElementsByTagName("li").length;
                    // Only allow the list to remain if every li contains an image
                    if (img == li_count) return false;
                }
                return haveToRemove;
            }
            return false;
        });
    },
    /**
   * Clean out elements that match the specified conditions
   *
   * @param Element
   * @param Function determines whether a node should be removed
   * @return void
   **/ _cleanMatchedNodes: function(e, filter) {
        var endOfSearchMarkerNode = this._getNextNode(e, true);
        var next = this._getNextNode(e);
        while(next && next != endOfSearchMarkerNode)if (filter.call(this, next, next.className + " " + next.id)) next = this._removeAndGetNext(next);
        else next = this._getNextNode(next);
    },
    /**
   * Clean out spurious headers from an Element.
   *
   * @param Element
   * @return void
  **/ _cleanHeaders: function(e) {
        let headingNodes = this._getAllNodesWithTag(e, [
            "h1",
            "h2"
        ]);
        this._removeNodes(headingNodes, function(node) {
            let shouldRemove = this._getClassWeight(node) < 0;
            if (shouldRemove) this.log("Removing header with low class weight:", node);
            return shouldRemove;
        });
    },
    /**
   * Check if this node is an H1 or H2 element whose content is mostly
   * the same as the article title.
   *
   * @param Element  the node to check.
   * @return boolean indicating whether this is a title-like header.
   */ _headerDuplicatesTitle: function(node) {
        if (node.tagName != "H1" && node.tagName != "H2") return false;
        var heading = this._getInnerText(node, false);
        this.log("Evaluating similarity of header:", heading, this._articleTitle);
        return this._textSimilarity(this._articleTitle, heading) > 0.75;
    },
    _flagIsActive: function(flag) {
        return (this._flags & flag) > 0;
    },
    _removeFlag: function(flag) {
        this._flags = this._flags & ~flag;
    },
    _isProbablyVisible: function(node) {
        // Have to null-check node.style and node.className.indexOf to deal with SVG and MathML nodes.
        return (!node.style || node.style.display != "none") && !node.hasAttribute("hidden") && (!node.hasAttribute("aria-hidden") || node.getAttribute("aria-hidden") != "true" || node.className && node.className.indexOf && node.className.indexOf("fallback-image") !== -1);
    },
    /**
   * Runs readability.
   *
   * Workflow:
   *  1. Prep the document by removing script tags, css, etc.
   *  2. Build readability's DOM tree.
   *  3. Grab the article content from the current dom tree.
   *  4. Replace the current DOM tree with the new one.
   *  5. Read peacefully.
   *
   * @return void
   **/ parse: function() {
        // Avoid parsing too large documents, as per configuration option
        if (this._maxElemsToParse > 0) {
            var numTags = this._doc.getElementsByTagName("*").length;
            if (numTags > this._maxElemsToParse) throw new Error("Aborting parsing document; " + numTags + " elements found");
        }
        // Unwrap image from noscript
        this._unwrapNoscriptImages(this._doc);
        // Extract JSON-LD metadata before removing scripts
        var jsonLd = this._disableJSONLD ? {} : this._getJSONLD(this._doc);
        // Remove script tags from the document.
        this._removeScripts(this._doc);
        this._prepDocument();
        var metadata = this._getArticleMetadata(jsonLd);
        this._articleTitle = metadata.title;
        var articleContent = this._grabArticle();
        if (!articleContent) return null;
        this.log("Grabbed: " + articleContent.innerHTML);
        this._postProcessContent(articleContent);
        // If we haven't found an excerpt in the article's metadata, use the article's
        // first paragraph as the excerpt. This is used for displaying a preview of
        // the article's content.
        if (!metadata.excerpt) {
            var paragraphs = articleContent.getElementsByTagName("p");
            if (paragraphs.length > 0) metadata.excerpt = paragraphs[0].textContent.trim();
        }
        var textContent = articleContent.textContent;
        return {
            title: this._articleTitle,
            byline: metadata.byline || this._articleByline,
            dir: this._articleDir,
            lang: this._articleLang,
            content: this._serializer(articleContent),
            textContent: textContent,
            length: textContent.length,
            excerpt: metadata.excerpt,
            siteName: metadata.siteName || this._articleSiteName
        };
    }
};
/* global module */ $91dbb6f60f851f00$exports = $91dbb6f60f851f00$var$Readability;


var $151f2342e9f5cb9d$exports = {};
/*
 * Copyright (c) 2010 Arc90 Inc
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * This code is heavily based on Arc90's readability.js (1.7.1) script
 * available at: http://code.google.com/p/arc90labs-readability
 */ var $151f2342e9f5cb9d$var$REGEXPS = {
    // NOTE: These two regular expressions are duplicated in
    // Readability.js. Please keep both copies in sync.
    unlikelyCandidates: /-ad-|ai2html|banner|breadcrumbs|combx|comment|community|cover-wrap|disqus|extra|footer|gdpr|header|legends|menu|related|remark|replies|rss|shoutbox|sidebar|skyscraper|social|sponsor|supplemental|ad-break|agegate|pagination|pager|popup|yom-remote/i,
    okMaybeItsACandidate: /and|article|body|column|content|main|shadow/i
};
function $151f2342e9f5cb9d$var$isNodeVisible(node) {
    // Have to null-check node.style and node.className.indexOf to deal with SVG and MathML nodes.
    return (!node.style || node.style.display != "none") && !node.hasAttribute("hidden") && (!node.hasAttribute("aria-hidden") || node.getAttribute("aria-hidden") != "true" || node.className && node.className.indexOf && node.className.indexOf("fallback-image") !== -1);
}
/**
 * Decides whether or not the document is reader-able without parsing the whole thing.
 * @param {Object} options Configuration object.
 * @param {number} [options.minContentLength=140] The minimum node content length used to decide if the document is readerable.
 * @param {number} [options.minScore=20] The minumum cumulated 'score' used to determine if the document is readerable.
 * @param {Function} [options.visibilityChecker=isNodeVisible] The function used to determine if a node is visible.
 * @return {boolean} Whether or not we suspect Readability.parse() will suceeed at returning an article object.
 */ function $151f2342e9f5cb9d$var$isProbablyReaderable(doc, options = {}) {
    // For backward compatibility reasons 'options' can either be a configuration object or the function used
    // to determine if a node is visible.
    if (typeof options == "function") options = {
        visibilityChecker: options
    };
    var defaultOptions = {
        minScore: 20,
        minContentLength: 140,
        visibilityChecker: $151f2342e9f5cb9d$var$isNodeVisible
    };
    options = Object.assign(defaultOptions, options);
    var nodes = doc.querySelectorAll("p, pre, article");
    // Get <div> nodes which have <br> node(s) and append them into the `nodes` variable.
    // Some articles' DOM structures might look like
    // <div>
    //   Sentences<br>
    //   <br>
    //   Sentences<br>
    // </div>
    var brNodes = doc.querySelectorAll("div > br");
    if (brNodes.length) {
        var set = new Set(nodes);
        [].forEach.call(brNodes, function(node) {
            set.add(node.parentNode);
        });
        nodes = Array.from(set);
    }
    var score = 0;
    // This is a little cheeky, we use the accumulator 'score' to decide what to return from
    // this callback:
    return [].some.call(nodes, function(node) {
        if (!options.visibilityChecker(node)) return false;
        var matchString = node.className + " " + node.id;
        if ($151f2342e9f5cb9d$var$REGEXPS.unlikelyCandidates.test(matchString) && !$151f2342e9f5cb9d$var$REGEXPS.okMaybeItsACandidate.test(matchString)) return false;
        if (node.matches("li p")) return false;
        var textContentLength = node.textContent.trim().length;
        if (textContentLength < options.minContentLength) return false;
        score += Math.sqrt(textContentLength - options.minContentLength);
        if (score > options.minScore) return true;
        return false;
    });
}
/* global module */ $151f2342e9f5cb9d$exports = $151f2342e9f5cb9d$var$isProbablyReaderable;


$a67c49fb33face5a$exports = {
    Readability: $91dbb6f60f851f00$exports,
    isProbablyReaderable: $151f2342e9f5cb9d$exports
};


var $2108e6874dfdf99f$var$highlightRegExp = /highlight-(?:text|source)-([a-z0-9]+)/;
function $2108e6874dfdf99f$export$c359330ed80b1889(turndownService) {
    turndownService.addRule("highlightedCodeBlock", {
        filter: function(node) {
            var firstChild = node.firstChild;
            return node.nodeName === "DIV" && $2108e6874dfdf99f$var$highlightRegExp.test(node.className) && firstChild && firstChild.nodeName === "PRE";
        },
        replacement: function(content, node, options) {
            var className = node.className || "";
            var language = (className.match($2108e6874dfdf99f$var$highlightRegExp) || [
                null,
                ""
            ])[1];
            return "\n\n" + options.fence + language + "\n" + node.firstChild.textContent + "\n" + options.fence + "\n\n";
        }
    });
}
function $2108e6874dfdf99f$export$19426ff118fe8be(turndownService) {
    turndownService.addRule("strikethrough", {
        filter: [
            "del",
            "s",
            "strike"
        ],
        replacement: function(content) {
            return "~" + content + "~";
        }
    });
}
var $2108e6874dfdf99f$var$indexOf = Array.prototype.indexOf;
var $2108e6874dfdf99f$var$every = Array.prototype.every;
var $2108e6874dfdf99f$var$rules = {};
$2108e6874dfdf99f$var$rules.tableCell = {
    filter: [
        "th",
        "td"
    ],
    replacement: function(content, node) {
        return $2108e6874dfdf99f$var$cell(content, node);
    }
};
$2108e6874dfdf99f$var$rules.tableRow = {
    filter: "tr",
    replacement: function(content, node) {
        var borderCells = "";
        var alignMap = {
            left: ":--",
            right: "--:",
            center: ":-:"
        };
        if ($2108e6874dfdf99f$var$isHeadingRow(node)) for(var i = 0; i < node.childNodes.length; i++){
            var border = "---";
            var align = (node.childNodes[i].getAttribute("align") || "").toLowerCase();
            if (align) border = alignMap[align] || border;
            borderCells += $2108e6874dfdf99f$var$cell(border, node.childNodes[i]);
        }
        return "\n" + content + (borderCells ? "\n" + borderCells : "");
    }
};
$2108e6874dfdf99f$var$rules.table = {
    // Only convert tables with a heading row.
    // Tables with no heading row are kept using `keep` (see below).
    filter: function(node) {
        return node.nodeName === "TABLE" && $2108e6874dfdf99f$var$isHeadingRow(node.rows[0]);
    },
    replacement: function(content) {
        // Ensure there are no blank lines
        content = content.replace("\n\n", "\n");
        return "\n\n" + content + "\n\n";
    }
};
$2108e6874dfdf99f$var$rules.tableSection = {
    filter: [
        "thead",
        "tbody",
        "tfoot"
    ],
    replacement: function(content) {
        return content;
    }
};
// A tr is a heading row if:
// - the parent is a THEAD
// - or if its the first child of the TABLE or the first TBODY (possibly
//   following a blank THEAD)
// - and every cell is a TH
function $2108e6874dfdf99f$var$isHeadingRow(tr) {
    var parentNode = tr.parentNode;
    return parentNode.nodeName === "THEAD" || parentNode.firstChild === tr && (parentNode.nodeName === "TABLE" || $2108e6874dfdf99f$var$isFirstTbody(parentNode)) && $2108e6874dfdf99f$var$every.call(tr.childNodes, function(n) {
        return n.nodeName === "TH";
    });
}
function $2108e6874dfdf99f$var$isFirstTbody(element) {
    var previousSibling = element.previousSibling;
    return element.nodeName === "TBODY" && (!previousSibling || previousSibling.nodeName === "THEAD" && /^\s*$/i.test(previousSibling.textContent));
}
function $2108e6874dfdf99f$var$cell(content, node) {
    var index = $2108e6874dfdf99f$var$indexOf.call(node.parentNode.childNodes, node);
    var prefix = " ";
    if (index === 0) prefix = "| ";
    return prefix + content + " |";
}
function $2108e6874dfdf99f$export$cc4ff83fc7bd256e(turndownService) {
    turndownService.keep(function(node) {
        return node.nodeName === "TABLE" && !$2108e6874dfdf99f$var$isHeadingRow(node.rows[0]);
    });
    for(var key in $2108e6874dfdf99f$var$rules)turndownService.addRule(key, $2108e6874dfdf99f$var$rules[key]);
}
function $2108e6874dfdf99f$export$1f0c2747e2ba0b8d(turndownService) {
    turndownService.addRule("taskListItems", {
        filter: function(node) {
            return node.type === "checkbox" && node.parentNode.nodeName === "LI";
        },
        replacement: function(content, node) {
            return (node.checked ? "[x]" : "[ ]") + " ";
        }
    });
}
function $2108e6874dfdf99f$export$59ffe8c4d7a4aab2(turndownService) {
    turndownService.use([
        $2108e6874dfdf99f$export$c359330ed80b1889,
        $2108e6874dfdf99f$export$19426ff118fe8be,
        $2108e6874dfdf99f$export$cc4ff83fc7bd256e,
        $2108e6874dfdf99f$export$1f0c2747e2ba0b8d
    ]);
}


function $acb81006d54b890a$var$extend(destination) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (source.hasOwnProperty(key)) destination[key] = source[key];
    }
    return destination;
}
function $acb81006d54b890a$var$repeat(character, count) {
    return Array(count + 1).join(character);
}
function $acb81006d54b890a$var$trimLeadingNewlines(string) {
    return string.replace(/^\n*/, "");
}
function $acb81006d54b890a$var$trimTrailingNewlines(string) {
    // avoid match-at-end regexp bottleneck, see #370
    var indexEnd = string.length;
    while(indexEnd > 0 && string[indexEnd - 1] === "\n")indexEnd--;
    return string.substring(0, indexEnd);
}
var $acb81006d54b890a$var$blockElements = [
    "ADDRESS",
    "ARTICLE",
    "ASIDE",
    "AUDIO",
    "BLOCKQUOTE",
    "BODY",
    "CANVAS",
    "CENTER",
    "DD",
    "DIR",
    "DIV",
    "DL",
    "DT",
    "FIELDSET",
    "FIGCAPTION",
    "FIGURE",
    "FOOTER",
    "FORM",
    "FRAMESET",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "HEADER",
    "HGROUP",
    "HR",
    "HTML",
    "ISINDEX",
    "LI",
    "MAIN",
    "MENU",
    "NAV",
    "NOFRAMES",
    "NOSCRIPT",
    "OL",
    "OUTPUT",
    "P",
    "PRE",
    "SECTION",
    "TABLE",
    "TBODY",
    "TD",
    "TFOOT",
    "TH",
    "THEAD",
    "TR",
    "UL"
];
function $acb81006d54b890a$var$isBlock(node) {
    return $acb81006d54b890a$var$is(node, $acb81006d54b890a$var$blockElements);
}
var $acb81006d54b890a$var$voidElements = [
    "AREA",
    "BASE",
    "BR",
    "COL",
    "COMMAND",
    "EMBED",
    "HR",
    "IMG",
    "INPUT",
    "KEYGEN",
    "LINK",
    "META",
    "PARAM",
    "SOURCE",
    "TRACK",
    "WBR"
];
function $acb81006d54b890a$var$isVoid(node) {
    return $acb81006d54b890a$var$is(node, $acb81006d54b890a$var$voidElements);
}
function $acb81006d54b890a$var$hasVoid(node) {
    return $acb81006d54b890a$var$has(node, $acb81006d54b890a$var$voidElements);
}
var $acb81006d54b890a$var$meaningfulWhenBlankElements = [
    "A",
    "TABLE",
    "THEAD",
    "TBODY",
    "TFOOT",
    "TH",
    "TD",
    "IFRAME",
    "SCRIPT",
    "AUDIO",
    "VIDEO"
];
function $acb81006d54b890a$var$isMeaningfulWhenBlank(node) {
    return $acb81006d54b890a$var$is(node, $acb81006d54b890a$var$meaningfulWhenBlankElements);
}
function $acb81006d54b890a$var$hasMeaningfulWhenBlank(node) {
    return $acb81006d54b890a$var$has(node, $acb81006d54b890a$var$meaningfulWhenBlankElements);
}
function $acb81006d54b890a$var$is(node, tagNames) {
    return tagNames.indexOf(node.nodeName) >= 0;
}
function $acb81006d54b890a$var$has(node, tagNames) {
    return node.getElementsByTagName && tagNames.some(function(tagName) {
        return node.getElementsByTagName(tagName).length;
    });
}
var $acb81006d54b890a$var$rules = {};
$acb81006d54b890a$var$rules.paragraph = {
    filter: "p",
    replacement: function(content) {
        return "\n\n" + content + "\n\n";
    }
};
$acb81006d54b890a$var$rules.lineBreak = {
    filter: "br",
    replacement: function(content, node, options) {
        return options.br + "\n";
    }
};
$acb81006d54b890a$var$rules.heading = {
    filter: [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
    ],
    replacement: function(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === "setext" && hLevel < 3) {
            var underline = $acb81006d54b890a$var$repeat(hLevel === 1 ? "=" : "-", content.length);
            return "\n\n" + content + "\n" + underline + "\n\n";
        } else return "\n\n" + $acb81006d54b890a$var$repeat("#", hLevel) + " " + content + "\n\n";
    }
};
$acb81006d54b890a$var$rules.blockquote = {
    filter: "blockquote",
    replacement: function(content) {
        content = content.replace(/^\n+|\n+$/g, "");
        content = content.replace(/^/gm, "> ");
        return "\n\n" + content + "\n\n";
    }
};
$acb81006d54b890a$var$rules.list = {
    filter: [
        "ul",
        "ol"
    ],
    replacement: function(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === "LI" && parent.lastElementChild === node) return "\n" + content;
        else return "\n\n" + content + "\n\n";
    }
};
$acb81006d54b890a$var$rules.listItem = {
    filter: "li",
    replacement: function(content, node, options) {
        content = content.replace(/^\n+/, "") // remove leading newlines
        .replace(/\n+$/, "\n") // replace trailing newlines with just a single one
        .replace(/\n/gm, "\n    "); // indent
        var prefix = options.bulletListMarker + "   ";
        var parent = node.parentNode;
        if (parent.nodeName === "OL") {
            var start = parent.getAttribute("start");
            var index = Array.prototype.indexOf.call(parent.children, node);
            prefix = (start ? Number(start) + index : index + 1) + ".  ";
        }
        return prefix + content + (node.nextSibling && !/\n$/.test(content) ? "\n" : "");
    }
};
$acb81006d54b890a$var$rules.indentedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === "indented" && node.nodeName === "PRE" && node.firstChild && node.firstChild.nodeName === "CODE";
    },
    replacement: function(content, node, options) {
        return "\n\n    " + node.firstChild.textContent.replace(/\n/g, "\n    ") + "\n\n";
    }
};
$acb81006d54b890a$var$rules.fencedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === "fenced" && node.nodeName === "PRE" && node.firstChild && node.firstChild.nodeName === "CODE";
    },
    replacement: function(content, node, options) {
        var className = node.firstChild.getAttribute("class") || "";
        var language = (className.match(/language-(\S+)/) || [
            null,
            ""
        ])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp("^" + fenceChar + "{3,}", "gm");
        var match;
        while(match = fenceInCodeRegex.exec(code))if (match[0].length >= fenceSize) fenceSize = match[0].length + 1;
        var fence = $acb81006d54b890a$var$repeat(fenceChar, fenceSize);
        return "\n\n" + fence + language + "\n" + code.replace(/\n$/, "") + "\n" + fence + "\n\n";
    }
};
$acb81006d54b890a$var$rules.horizontalRule = {
    filter: "hr",
    replacement: function(content, node, options) {
        return "\n\n" + options.hr + "\n\n";
    }
};
$acb81006d54b890a$var$rules.inlineLink = {
    filter: function(node, options) {
        return options.linkStyle === "inlined" && node.nodeName === "A" && node.getAttribute("href");
    },
    replacement: function(content, node) {
        var href = node.getAttribute("href");
        var title = $acb81006d54b890a$var$cleanAttribute(node.getAttribute("title"));
        if (title) title = ' "' + title + '"';
        return "[" + content + "](" + href + title + ")";
    }
};
$acb81006d54b890a$var$rules.referenceLink = {
    filter: function(node, options) {
        return options.linkStyle === "referenced" && node.nodeName === "A" && node.getAttribute("href");
    },
    replacement: function(content, node, options) {
        var href = node.getAttribute("href");
        var title = $acb81006d54b890a$var$cleanAttribute(node.getAttribute("title"));
        if (title) title = ' "' + title + '"';
        var replacement;
        var reference;
        switch(options.linkReferenceStyle){
            case "collapsed":
                replacement = "[" + content + "][]";
                reference = "[" + content + "]: " + href + title;
                break;
            case "shortcut":
                replacement = "[" + content + "]";
                reference = "[" + content + "]: " + href + title;
                break;
            default:
                var id = this.references.length + 1;
                replacement = "[" + content + "][" + id + "]";
                reference = "[" + id + "]: " + href + title;
        }
        this.references.push(reference);
        return replacement;
    },
    references: [],
    append: function(options) {
        var references = "";
        if (this.references.length) {
            references = "\n\n" + this.references.join("\n") + "\n\n";
            this.references = []; // Reset references
        }
        return references;
    }
};
$acb81006d54b890a$var$rules.emphasis = {
    filter: [
        "em",
        "i"
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return "";
        return options.emDelimiter + content + options.emDelimiter;
    }
};
$acb81006d54b890a$var$rules.strong = {
    filter: [
        "strong",
        "b"
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return "";
        return options.strongDelimiter + content + options.strongDelimiter;
    }
};
$acb81006d54b890a$var$rules.code = {
    filter: function(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === "PRE" && !hasSiblings;
        return node.nodeName === "CODE" && !isCodeBlock;
    },
    replacement: function(content) {
        if (!content) return "";
        content = content.replace(/\r?\n|\r/g, " ");
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? " " : "";
        var delimiter = "`";
        var matches = content.match(/`+/gm) || [];
        while(matches.indexOf(delimiter) !== -1)delimiter = delimiter + "`";
        return delimiter + extraSpace + content + extraSpace + delimiter;
    }
};
$acb81006d54b890a$var$rules.image = {
    filter: "img",
    replacement: function(content, node) {
        var alt = $acb81006d54b890a$var$cleanAttribute(node.getAttribute("alt"));
        var src = node.getAttribute("src") || "";
        var title = $acb81006d54b890a$var$cleanAttribute(node.getAttribute("title"));
        var titlePart = title ? ' "' + title + '"' : "";
        return src ? "![" + alt + "]" + "(" + src + titlePart + ")" : "";
    }
};
function $acb81006d54b890a$var$cleanAttribute(attribute) {
    return attribute ? attribute.replace(/(\n+\s*)+/g, "\n") : "";
}
/**
 * Manages a collection of rules used to convert HTML to Markdown
 */ function $acb81006d54b890a$var$Rules(options) {
    this.options = options;
    this._keep = [];
    this._remove = [];
    this.blankRule = {
        replacement: options.blankReplacement
    };
    this.keepReplacement = options.keepReplacement;
    this.defaultRule = {
        replacement: options.defaultReplacement
    };
    this.array = [];
    for(var key in options.rules)this.array.push(options.rules[key]);
}
$acb81006d54b890a$var$Rules.prototype = {
    add: function(key, rule) {
        this.array.unshift(rule);
    },
    keep: function(filter) {
        this._keep.unshift({
            filter: filter,
            replacement: this.keepReplacement
        });
    },
    remove: function(filter) {
        this._remove.unshift({
            filter: filter,
            replacement: function() {
                return "";
            }
        });
    },
    forNode: function(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = $acb81006d54b890a$var$findRule(this.array, node, this.options)) return rule;
        if (rule = $acb81006d54b890a$var$findRule(this._keep, node, this.options)) return rule;
        if (rule = $acb81006d54b890a$var$findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
    },
    forEach: function(fn) {
        for(var i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
};
function $acb81006d54b890a$var$findRule(rules, node, options) {
    for(var i = 0; i < rules.length; i++){
        var rule = rules[i];
        if ($acb81006d54b890a$var$filterValue(rule, node, options)) return rule;
    }
    return void 0;
}
function $acb81006d54b890a$var$filterValue(rule, node, options) {
    var filter = rule.filter;
    if (typeof filter === "string") {
        if (filter === node.nodeName.toLowerCase()) return true;
    } else if (Array.isArray(filter)) {
        if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true;
    } else if (typeof filter === "function") {
        if (filter.call(rule, node, options)) return true;
    } else throw new TypeError("`filter` needs to be a string, array, or function");
}
/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */ function $acb81006d54b890a$var$collapseWhitespace(options) {
    var element = options.element;
    var isBlock = options.isBlock;
    var isVoid = options.isVoid;
    var isPre = options.isPre || function(node) {
        return node.nodeName === "PRE";
    };
    if (!element.firstChild || isPre(element)) return;
    var prevText = null;
    var keepLeadingWs = false;
    var prev = null;
    var node = $acb81006d54b890a$var$next(prev, element, isPre);
    while(node !== element){
        if (node.nodeType === 3 || node.nodeType === 4) {
            var text = node.data.replace(/[ \r\n\t]+/g, " ");
            if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === " ") text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $acb81006d54b890a$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            if (isBlock(node) || node.nodeName === "BR") {
                if (prevText) prevText.data = prevText.data.replace(/ $/, "");
                prevText = null;
                keepLeadingWs = false;
            } else if (isVoid(node) || isPre(node)) {
                // Avoid trimming space around non-block, non-BR void elements and inline PRE.
                prevText = null;
                keepLeadingWs = true;
            } else if (prevText) // Drop protection if set previously.
            keepLeadingWs = false;
        } else {
            node = $acb81006d54b890a$var$remove(node);
            continue;
        }
        var nextNode = $acb81006d54b890a$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, "");
        if (!prevText.data) $acb81006d54b890a$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $acb81006d54b890a$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $acb81006d54b890a$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
/*
 * Set up window for Node.js
 */ var $acb81006d54b890a$var$root = typeof window !== "undefined" ? window : {};
/*
 * Parsing HTML strings
 */ function $acb81006d54b890a$var$canParseHTMLNatively() {
    var Parser = $acb81006d54b890a$var$root.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString("", "text/html")) canParse = true;
    } catch (e) {}
    return canParse;
}
function $acb81006d54b890a$var$createHTMLParser() {
    var Parser = function() {};
    if ($acb81006d54b890a$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject("htmlfile");
        doc.designMode = "on"; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument("");
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $acb81006d54b890a$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument("").open();
    } catch (e) {
        if (window.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
var $acb81006d54b890a$var$HTMLParser = $acb81006d54b890a$var$canParseHTMLNatively() ? $acb81006d54b890a$var$root.DOMParser : $acb81006d54b890a$var$createHTMLParser();
function $acb81006d54b890a$var$RootNode(input, options) {
    var root;
    if (typeof input === "string") {
        var doc = $acb81006d54b890a$var$htmlParser().parseFromString(// DOM parsers arrange elements in the <head> and <body>.
        // Wrapping in a custom element ensures elements are reliably arranged in
        // a single element.
        '<x-turndown id="turndown-root">' + input + "</x-turndown>", "text/html");
        root = doc.getElementById("turndown-root");
    } else root = input.cloneNode(true);
    $acb81006d54b890a$var$collapseWhitespace({
        element: root,
        isBlock: $acb81006d54b890a$var$isBlock,
        isVoid: $acb81006d54b890a$var$isVoid,
        isPre: options.preformattedCode ? $acb81006d54b890a$var$isPreOrCode : null
    });
    return root;
}
var $acb81006d54b890a$var$_htmlParser;
function $acb81006d54b890a$var$htmlParser() {
    $acb81006d54b890a$var$_htmlParser = $acb81006d54b890a$var$_htmlParser || new $acb81006d54b890a$var$HTMLParser();
    return $acb81006d54b890a$var$_htmlParser;
}
function $acb81006d54b890a$var$isPreOrCode(node) {
    return node.nodeName === "PRE" || node.nodeName === "CODE";
}
function $acb81006d54b890a$var$Node(node, options) {
    node.isBlock = $acb81006d54b890a$var$isBlock(node);
    node.isCode = node.nodeName === "CODE" || node.parentNode.isCode;
    node.isBlank = $acb81006d54b890a$var$isBlank(node);
    node.flankingWhitespace = $acb81006d54b890a$var$flankingWhitespace(node, options);
    return node;
}
function $acb81006d54b890a$var$isBlank(node) {
    return !$acb81006d54b890a$var$isVoid(node) && !$acb81006d54b890a$var$isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !$acb81006d54b890a$var$hasVoid(node) && !$acb81006d54b890a$var$hasMeaningfulWhenBlank(node);
}
function $acb81006d54b890a$var$flankingWhitespace(node, options) {
    if (node.isBlock || options.preformattedCode && node.isCode) return {
        leading: "",
        trailing: ""
    };
    var edges = $acb81006d54b890a$var$edgeWhitespace(node.textContent);
    // abandon leading ASCII WS if left-flanked by ASCII WS
    if (edges.leadingAscii && $acb81006d54b890a$var$isFlankedByWhitespace("left", node, options)) edges.leading = edges.leadingNonAscii;
    // abandon trailing ASCII WS if right-flanked by ASCII WS
    if (edges.trailingAscii && $acb81006d54b890a$var$isFlankedByWhitespace("right", node, options)) edges.trailing = edges.trailingNonAscii;
    return {
        leading: edges.leading,
        trailing: edges.trailing
    };
}
function $acb81006d54b890a$var$edgeWhitespace(string) {
    var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
    return {
        leading: m[1],
        leadingAscii: m[2],
        leadingNonAscii: m[3],
        trailing: m[4],
        trailingNonAscii: m[5],
        trailingAscii: m[6]
    };
}
function $acb81006d54b890a$var$isFlankedByWhitespace(side, node, options) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === "left") {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (options.preformattedCode && sibling.nodeName === "CODE") isFlanked = false;
        else if (sibling.nodeType === 1 && !$acb81006d54b890a$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
var $acb81006d54b890a$var$reduce = Array.prototype.reduce;
var $acb81006d54b890a$var$escapes = [
    [
        /\\/g,
        "\\\\"
    ],
    [
        /\*/g,
        "\\*"
    ],
    [
        /^-/g,
        "\\-"
    ],
    [
        /^\+ /g,
        "\\+ "
    ],
    [
        /^(=+)/g,
        "\\$1"
    ],
    [
        /^(#{1,6}) /g,
        "\\$1 "
    ],
    [
        /`/g,
        "\\`"
    ],
    [
        /^~~~/g,
        "\\~~~"
    ],
    [
        /\[/g,
        "\\["
    ],
    [
        /\]/g,
        "\\]"
    ],
    [
        /^>/g,
        "\\>"
    ],
    [
        /_/g,
        "\\_"
    ],
    [
        /^(\d+)\. /g,
        "$1\\. "
    ]
];
function $acb81006d54b890a$var$TurndownService(options) {
    if (!(this instanceof $acb81006d54b890a$var$TurndownService)) return new $acb81006d54b890a$var$TurndownService(options);
    var defaults = {
        rules: $acb81006d54b890a$var$rules,
        headingStyle: "setext",
        hr: "* * *",
        bulletListMarker: "*",
        codeBlockStyle: "indented",
        fence: "```",
        emDelimiter: "_",
        strongDelimiter: "**",
        linkStyle: "inlined",
        linkReferenceStyle: "full",
        br: "  ",
        preformattedCode: false,
        blankReplacement: function(content, node) {
            return node.isBlock ? "\n\n" : "";
        },
        keepReplacement: function(content, node) {
            return node.isBlock ? "\n\n" + node.outerHTML + "\n\n" : node.outerHTML;
        },
        defaultReplacement: function(content, node) {
            return node.isBlock ? "\n\n" + content + "\n\n" : content;
        }
    };
    this.options = $acb81006d54b890a$var$extend({}, defaults, options);
    this.rules = new $acb81006d54b890a$var$Rules(this.options);
}
$acb81006d54b890a$var$TurndownService.prototype = {
    /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */ turndown: function(input) {
        if (!$acb81006d54b890a$var$canConvert(input)) throw new TypeError(input + " is not a string, or an element/document/fragment node.");
        if (input === "") return "";
        var output = $acb81006d54b890a$var$process.call(this, new $acb81006d54b890a$var$RootNode(input, this.options));
        return $acb81006d54b890a$var$postProcess.call(this, output);
    },
    /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */ use: function(plugin) {
        if (Array.isArray(plugin)) for(var i = 0; i < plugin.length; i++)this.use(plugin[i]);
        else if (typeof plugin === "function") plugin(this);
        else throw new TypeError("plugin must be a Function or an Array of Functions");
        return this;
    },
    /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ addRule: function(key, rule) {
        this.rules.add(key, rule);
        return this;
    },
    /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ keep: function(filter) {
        this.rules.keep(filter);
        return this;
    },
    /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ remove: function(filter) {
        this.rules.remove(filter);
        return this;
    },
    /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */ escape: function(string) {
        return $acb81006d54b890a$var$escapes.reduce(function(accumulator, escape) {
            return accumulator.replace(escape[0], escape[1]);
        }, string);
    }
};
/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $acb81006d54b890a$var$process(parentNode) {
    var self = this;
    return $acb81006d54b890a$var$reduce.call(parentNode.childNodes, function(output, node) {
        node = new $acb81006d54b890a$var$Node(node, self.options);
        var replacement = "";
        if (node.nodeType === 3) replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
        else if (node.nodeType === 1) replacement = $acb81006d54b890a$var$replacementForNode.call(self, node);
        return $acb81006d54b890a$var$join(output, replacement);
    }, "");
}
/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */ function $acb81006d54b890a$var$postProcess(output) {
    var self = this;
    this.rules.forEach(function(rule) {
        if (typeof rule.append === "function") output = $acb81006d54b890a$var$join(output, rule.append(self.options));
    });
    return output.replace(/^[\t\r\n]+/, "").replace(/[\t\r\n\s]+$/, "");
}
/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $acb81006d54b890a$var$replacementForNode(node) {
    var rule = this.rules.forNode(node);
    var content = $acb81006d54b890a$var$process.call(this, node);
    var whitespace = node.flankingWhitespace;
    if (whitespace.leading || whitespace.trailing) content = content.trim();
    return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */ function $acb81006d54b890a$var$join(output, replacement) {
    var s1 = $acb81006d54b890a$var$trimTrailingNewlines(output);
    var s2 = $acb81006d54b890a$var$trimLeadingNewlines(replacement);
    var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
    var separator = "\n\n".substring(0, nls);
    return s1 + separator + s2;
}
/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */ function $acb81006d54b890a$var$canConvert(input) {
    return input != null && (typeof input === "string" || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}
var $acb81006d54b890a$export$2e2bcd8739ae039 = $acb81006d54b890a$var$TurndownService;


let $e8247bdc531b8cd1$var$getParsedDomFromHtml = (html)=>{
    return new window.DOMParser().parseFromString(html, "text/html");
};
function $e8247bdc531b8cd1$export$b6d0951759b98e95(fn) {
    $e8247bdc531b8cd1$var$getParsedDomFromHtml = fn;
}
function $e8247bdc531b8cd1$export$da7af07ba7ea4c5b(html) {
    if (html?.constructor !== String) return {};
    let useFirefoxReader = true;
    const lineBreakPlaceholder = ":::s-l=br-ph:::";
    function removeNonContentElements(dom) {
        [
            "script",
            "are",
            "command",
            "embed",
            "input",
            "keygen",
            "link",
            "param",
            "source",
            "track",
            "video",
            "audio",
            "svg",
            "iframe",
            "style"
        ].forEach((selector)=>{
            dom.querySelectorAll(selector).forEach((el)=>el.remove());
        });
        return dom;
    }
    function preparedDom(html) {
        // is it unique enough? :D
        let dom = $e8247bdc531b8cd1$var$getParsedDomFromHtml(html);
        dom.querySelectorAll("p, h1, h2, h3, h4, h5, h6").forEach((p)=>{
            p.innerHTML += lineBreakPlaceholder;
        });
        dom = removeNonContentElements(dom);
        return dom;
    }
    let textContent = "";
    let title = "";
    if (useFirefoxReader) {
        let reader = new (0, $a67c49fb33face5a$exports.Readability)(preparedDom(html));
        try {
            let parsed = reader.parse();
            if (parsed) {
                textContent = parsed.textContent;
                title = parsed.title;
                if (textContent) textContent = textContent.split(`\n`).map((line)=>{
                    return line.trim();
                }).join(`\n`).replace(new RegExp(lineBreakPlaceholder, "g"), `\n\n`).replace(/\n\n+/g, `\n\n`).trim();
            }
        } catch (e) {
            console.error(e);
        }
    }
    if (!textContent || !title) {
        let dom = $e8247bdc531b8cd1$var$getParsedDomFromHtml(html);
        dom.querySelectorAll("div, span").forEach((el)=>{
            if (!el.innerText || el.innerText.trim().length <= 25 && el.innerText.trim().match(/\w$/)) el.remove();
        });
        dom.querySelectorAll("a").forEach((el)=>{
            if (!el.innerText || !el.innerText.trim()) el.remove();
        });
        dom.querySelectorAll("img, picture, video").forEach((el)=>{
            el.remove();
        });
        textContent = dom.querySelector("main") || dom.querySelector("article") || dom.querySelector("#main") || dom.querySelector("#content") || dom.querySelector("body");
        title = dom.querySelector("h1")?.innerText || dom.querySelector("title")?.innerText || dom.querySelector("h2, h3, h4, h5, h6")?.innerText;
        title = title?.trim();
        textContent = textContent?.innerHTML ? new (0, $acb81006d54b890a$export$2e2bcd8739ae039)().use($2108e6874dfdf99f$export$59ffe8c4d7a4aab2).turndown(textContent.innerHTML) : null;
    }
    return {
        textContent: textContent,
        title: title
    };
}


function $1d6b0918345aa2c5$export$625550452a3fa3ec(key, replacements = {}, options = {}) {
    key = key.replace(/\./g, "_");
    // replacements = { ...replacements, ...{ dot: '.' } }
    return (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)(key, replacements, options);
}
function $1d6b0918345aa2c5$export$e3e42cd97e702527(text) {
    var str = text;
    var p = document.createElement("p");
    p.textContent = str;
    var converted = p.innerHTML;
    return (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)(converted.replace(/\n+/g, "<br><br>"));
}
function $1d6b0918345aa2c5$export$4c991b088e64f4e0(s) {
    return s.replace(/-/g, " ").trim().split(/\s+/g).length;
}
function $1d6b0918345aa2c5$export$1fbf6f199c05a66(html) {
    let div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
}
function $1d6b0918345aa2c5$export$867ac4db470f0958(str) {
    return str.replace(/(<([^>]+)>)/gi, "");
}
function $1d6b0918345aa2c5$export$be42e190aee03bc0(dateString, locale = null) {
    return new Date(dateString).toLocaleDateString(locale || undefined);
}
function $1d6b0918345aa2c5$export$af204b270ccca492(dateString, locale = null, fallbackDate = null) {
    if (!dateString) return null;
    let daysAgo = (0, $83985fc780dba6d7$export$2e2bcd8739ae039)(new Date(dateString), new Date());
    if ((0, $b4c5b0105a3de3c0$export$2e2bcd8739ae039)(new Date(dateString), new Date()) > 0 && fallbackDate) // date can not be in future (TODO: check TimeZones!)
    return $1d6b0918345aa2c5$export$af204b270ccca492(fallbackDate, locale);
    // if (daysAgo >= -1 && dateString.match(/\d{2}:\d{2}:\d{2}/)) {
    //   return formatDistance(new Date(dateString), new Date(), { addSuffix: true }) + ' ' + format(new Date(dateString), 'H:mm');
    // } else
    if (daysAgo > -30) return (0, $671507671fa5a6e8$export$2e2bcd8739ae039)(new Date(dateString), new Date(), {
        addSuffix: true,
        locale: $81b906d4525c15ad$exports[locale || "en"]
    });
    else return $1d6b0918345aa2c5$export$be42e190aee03bc0(dateString, locale);
}
function $1d6b0918345aa2c5$export$a1438f7216915f64(url) {
    let urlString = String(url);
    try {
        return new URL(urlString), true;
    } catch (error) {
        return false;
    }
}
function $1d6b0918345aa2c5$export$5ce9133daac3a00(image, callback) {
    // let imageSrc = image.getAttribute('src')
    var img = image.cloneNode(true) //document.createElement('img')
    ;
    img.crossOrigin = "Anonymous";
    // img.src = imageSrc
    img.style.display = "none";
    document.body.appendChild(img);
    var colorSum = 0;
    function onLoad() {
        // create canvas
        var canvas = document.createElement("canvas");
        canvas.width = this.width;
        canvas.height = this.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(this, 0, 0);
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var data = imageData.data;
        var r, g, b, avg;
        for(var x = 0, len = data.length; x < len; x += 4){
            r = data[x];
            g = data[x + 1];
            b = data[x + 2];
            avg = Math.floor((r + g + b) / 3);
            colorSum += avg;
        }
        img.remove();
        var brightness = Math.floor(colorSum / (this.width * this.height));
        callback(brightness);
    }
    img.onload = onLoad;
}
function $1d6b0918345aa2c5$export$6ab5b0b7846383d6(image, callback) {
    // var thisImgID = image.getAttribute('id')
    var img = image.cloneNode(true) //document.createElement('img')
    ;
    img.style.display = "none";
    img.crossOrigin = "Anonymous";
    document.body.appendChild(img);
    var colorSum = 0;
    function onLoad(img) {
        // create canvas
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var data = imageData.data;
        var r, g, b, avg;
        for(var x = 0, len = data.length; x < len; x += 4){
            r = data[x];
            g = data[x + 1];
            b = data[x + 2];
            avg = Math.floor((r + g + b) / 3);
            colorSum += avg;
        }
        var brightness = Math.floor(colorSum / (img.width * img.height));
        callback(brightness);
    }
    onLoad(img);
}
function $1d6b0918345aa2c5$export$99a686296b7eac67(imageElement) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const width = imageElement.naturalWidth;
    const height = imageElement.naturalHeight;
    canvas.width = width;
    canvas.height = height;
    imageElement.crossOrigin = "Anonymous";
    context.drawImage(imageElement, 0, 0, width, height);
    const imageData = context.getImageData(0, 0, width, height);
    const data = imageData.data;
    let brightness = 0;
    for(let i = 0; i < data.length; i += 4)brightness += 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
    brightness = brightness / (width * height);
    return brightness >= 128;
}
function $1d6b0918345aa2c5$export$a1d0d20ee9546562() {
    return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function $1d6b0918345aa2c5$export$6d53cfb944e81d50(min, max, lines = 1) {
    let linesList = [];
    if (min.constructor === Array) {
        min.forEach((def)=>{
            if (def.constructor === Array) {
                min = def[0];
                max = def[1] || def[0];
            } else min = max = def;
            linesList.push(Array(Math.floor(Math.random() * (max - min + 1) + min)).join("█"));
        });
        return linesList;
    }
    for(let i = 0; i < lines; i++)linesList.push(Array(Math.floor(Math.random() * (max - min + 1) + min)).join("█"));
    return linesList;
}
function $1d6b0918345aa2c5$export$decc2eeea1f0f170(headline, maxLength = 30, suffix = " …") {
    if (!headline || headline.trim().replace(/\s+/g, "").length < maxLength) return headline;
    let parts = headline.match(/^(.+?)([\:\-\|]\s+)(.*)$/);
    if (!parts) return headline;
    if (parts && parts[1].split(/\s+/).length > 1) return parts[1].trim() + suffix;
    return $1d6b0918345aa2c5$export$decc2eeea1f0f170(parts[3]?.trim(), maxLength, suffix);
}



var $exYeM = parcelRequire("exYeM");


parcelRequire("exYeM");



var $f62dcb4acda5e87d$exports = {};


$f62dcb4acda5e87d$exports = (parcelRequire("aNJCr")).getBundleURL("bDibm") + (parcelRequire("iE7OH")).resolve("73KLz");


var $9dcf4eca100a263d$exports = {};


$9dcf4eca100a263d$exports = (parcelRequire("aNJCr")).getBundleURL("bDibm") + (parcelRequire("iE7OH")).resolve("b813L");



function $7a2163ba25331c9c$export$b8a61e5c71402559({ actionMenu: actionMenu } = {}) {
    const [user] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    function toggleDarkLightTheme() {
        let body = document.querySelector("body");
        let darkModeApplied = body.dataset.theme === "dark";
        if (darkModeApplied) localStorage.setItem("theme", "light");
        else localStorage.setItem("theme", "dark");
        body.dataset.theme = localStorage.getItem("theme");
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("header", {
        className: "collapsed",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
            className: "navigation",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "logo",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                            to: user ? "/" : "/login",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                    className: "text-logo",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("use", {
                                        href: (0, (/*@__PURE__*/$parcel$interopDefault($f62dcb4acda5e87d$exports))) + "#svg-logo"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("svg", {
                                    className: "box-logo",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("use", {
                                        href: (0, (/*@__PURE__*/$parcel$interopDefault($9dcf4eca100a263d$exports))) + "#svg-box-empty"
                                    })
                                })
                            ]
                        }),
                        user && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                            to: "/add",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "plus",
                                children: "+"
                            })
                        })
                    ]
                }),
                actionMenu ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("nav", {
                    className: "action-menu",
                    children: actionMenu
                }) : null,
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("nav", {
                    className: "main-menu",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("ul", {
                        children: user ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "a theme",
                                        onClick: ()=>toggleDarkLightTheme(),
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Theme")
                                    })
                                }, "menu-theme"),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                        to: "/collections",
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Collections")
                                    })
                                }, "menu-collections"),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                    className: "profile",
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                        to: "/profile",
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Your Profile")
                                    })
                                }, "menu-profile"),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                        to: "/add",
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Add Website")
                                    })
                                }, "menu-add")
                            ]
                        }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                        to: "/signup",
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Signup")
                                    })
                                }, "menu-signup"),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                        to: "/login",
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Login")
                                    })
                                }, "menu-login")
                            ]
                        })
                    })
                })
            ]
        })
    });
}




var $exYeM = parcelRequire("exYeM");





function $5d63d1127835abb6$export$89200835fb4edfb9() {
    const [errors, setErrors] = (0, $exYeM.useState)({});
    const [email, setEmail] = (0, $exYeM.useState)("");
    const [password, setPassword] = (0, $exYeM.useState)("");
    const [passwordConfirm, setPasswordConfirm] = (0, $exYeM.useState)("");
    const [invitationCode, setInvitationCode] = (0, $exYeM.useState)(null);
    const [currentUser] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const minPasswordLength = 8;
    (0, $exYeM.useEffect)(()=>{
        if (!email) return;
        async function checkEmailIsAvailable(email) {
            let isAvailable = await $e6d4445b9ec5d3b6$export$f401af2a0cdbf548(email);
            if (!isAvailable) setErrors({
                ...errors,
                email: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("E-mail has already been signed up")
            });
        }
        setErrors({
            ...errors,
            email: null
        });
        if (/^[^@]+@[^@]+?\.[a-zA-Z]{2,}$/.test(email)) checkEmailIsAvailable(email);
    }, [
        email
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (currentUser.email) navigate("/");
    }, [
        currentUser
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!password) return;
        if (password && passwordConfirm) {
            if (passwordConfirm === password && password.length < 8) setErrors({
                ...errors,
                password: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Your password must have at least $chars characters", {
                    chars: minPasswordLength
                })
            });
            else if (passwordConfirm.length >= minPasswordLength - 1 && passwordConfirm !== password) setErrors({
                ...errors,
                password: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Passwords do not match")
            });
            else setErrors({
                ...errors,
                password: null
            });
        }
    }, [
        password,
        passwordConfirm
    ]);
    function handleFormSubmit(ev) {
        ev.preventDefault();
        // the timeouts ensures to start the request after the basic useEffect validations
        setTimeout(async ()=>{
            if (Object.keys(errors).map((k)=>errors[k]).filter((e)=>!!e).length > 0) return;
            try {
                let signupResult = await $e6d4445b9ec5d3b6$export$7200a869094fec36({
                    email: email,
                    password: password,
                    invitationCode: invitationCode
                });
                if (signupResult.message) {
                    alert((0, $1d6b0918345aa2c5$export$625550452a3fa3ec)(signupResult.message));
                    navigate("/login?afterSignup=true");
                }
            } catch (err) {
                console.log(err.response?.data?.message);
                alert((0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Could not signup") + ": " + (err.response?.data?.message || err.message));
                console.error(err);
            }
        }, 100);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
        onSubmit: handleFormSubmit,
        className: "form",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Signup")
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                    type: "email",
                    id: "email",
                    required: true,
                    placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("E-Mail"),
                    onChange: (ev)=>setEmail(ev.target.value)
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                    type: "password",
                    id: "password",
                    required: true,
                    placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Password"),
                    minLength: minPasswordLength,
                    autoComplete: "true",
                    onChange: (ev)=>setPassword(ev.target.value)
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                    type: "password",
                    id: "password-confirm",
                    required: true,
                    placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Confirm password"),
                    autoComplete: "true",
                    onChange: (ev)=>setPasswordConfirm(ev.target.value)
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                    type: "text",
                    required: true,
                    minLength: 4,
                    placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Invitation code"),
                    onChange: (ev)=>setInvitationCode(ev.target.value)
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                    type: "submit",
                    disabled: errors.length > 0,
                    children: "Signup"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                    style: {
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                        to: "/login",
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Return to login")
                    })
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    style: {
                        minHeight: "4rem"
                    },
                    children: errors && Object.keys(errors).map((k)=>errors[k] ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                            children: errors[k]
                        }, `error-${k}`) : null)
                })
            ]
        })
    });
}








var $exYeM = parcelRequire("exYeM");


var $c35f50cf85a9916f$exports = {};
$c35f50cf85a9916f$exports = JSON.parse('["adweek.com","ad.nl","ambito.com","americanbanker.com","baltimoresun.com","barrons.com","bloomberg.com","bloombergquint.com","bndestem.nl","bostonglobe.com","bd.nl","brisbanetimes.com.au","businessinsider.com","caixinglobal.com","centralwesterndaily.com.au","cen.acs.org","chicagotribune.com","corriere.it","chicagobusiness.com","dailypress.com","gelderlander.nl","groene.nl","demorgen.be","denverpost.com","speld.nl","destentor.nl","tijd.be","volkskrant.nl","df.cl","editorialedomani.it","dynamed.com","ed.nl","elmercurio.com","elmundo.es","elpais.com","elperiodico.com","elu24.ee","britannica.com","estadao.com.br","examiner.com.au","expansion.com","fnlondon.com","financialpost.com","ft.com","firstthings.com","foreignpolicy.com","fortune.com","genomeweb.com","glassdoor.com","globes.co.il","grubstreet.com","haaretz.com","haaretz.co.il","harpers.org","courant.com","hbr.org","hbrchina.org","heraldsun.com.au","fd.nl","historyextra.com","humo.be","ilmanifesto.it","inc.com","interest.co.nz","investorschronicle.co.uk","lanacion.com.ar","repubblica.it","lastampa.it","latercera.com","lavoixdunord.fr","lecho.be","ledevoir.com","leparisien.fr","lesechos.fr","loebclassics.com","lrb.co.uk","labusinessjournal.com","latimes.com","medium.com","medscape.com","mexiconewsdaily.com","sloanreview.mit.edu","technologyreview.com","mv-voice.com","nationalgeographic.com","nationalpost.com","nzz.ch","newstatesman.com","nydailynews.com","nymag.com","nzherald.co.nz","nrc.nl","ntnews.com.au","ocregister.com","orlandosentinel.com","paloaltoonline.com","parool.nl","postimees.ee","pzc.nl","qz.com","quora.com","gelocal.it","republic.ru","reuters.com","sandiegouniontribune.com","sfchronicle.com","scientificamerican.com","seekingalpha.com","slate.com","sofrep.com","startribune.com","statista.com","stuff.co.nz","\\"sueddeutsche.de\\"","sun-sentinel.com","techinasia.com","telegraaf.nl","time.com","adelaidenow.com.au","theadvocate.com.au","theage.com.au","the-american-interest.com","theathletic.com","theathletic.co.uk","theatlantic.com","afr.com","theaustralian.com.au","bizjournals.com","canberratimes.com.au","thecourier.com.au","couriermail.com.au","thecut.com","dailytelegraph.com.au","thediplomat.com","economist.com","theglobeandmail.com","theherald.com.au","thehindu.com","irishtimes.com","japantimes.co.jp","kansascity.com","themarker.com","mercurynews.com","themercury.com.au","mcall.com","thenation.com","thenational.scot","news-gazette.com","newyorker.com","nytimes.com","theolivepress.es","inquirer.com","thesaturdaypaper.com.au","seattletimes.com","spectator.com.au","spectator.co.uk","spectator.us","smh.com.au","telegraph.co.uk","thestar.com","wsj.com","washingtonpost.com","thewrap.com","the-tls.co.uk","towardsdatascience.com","trouw.nl","tubantia.nl","vanityfair.com","vn.nl","vulture.com","journalnow.com","wired.com","zeit.de"]');


function $fb045a3b65854a94$export$d0265b2c425512d6({ setActionMenu: setActionMenu } = {}) {
    const [user] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const [html, setHtml] = (0, $exYeM.useState)(null);
    const [isBehindPaywall, setIsBehindPaywall] = (0, $exYeM.useState)(false);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const [url, setUrl] = (0, $exYeM.useState)(null);
    const [submitButtonDisabled, setSubmitButtonDisabled] = (0, $exYeM.useState)(false);
    const isBehindPaywallChekboxRef = (0, $exYeM.useRef)(null);
    const inputUrlRef = (0, $exYeM.useRef)(null);
    const [showAdditionalOptions, setShowAdditionalOptions] = (0, $exYeM.useState)(false);
    const [availableLanguages, setAvailableLanguages] = (0, $exYeM.useState)(null);
    const [availableSummarizer, setAvailableSummarizer] = (0, $exYeM.useState)(null);
    const [collections, setCollections] = (0, $exYeM.useState)(null);
    const [collectionId, setCollectionId] = (0, $exYeM.useState)("auto");
    const [summarizer, setSummarizer] = (0, $exYeM.useState)(null);
    const [targetLanguage, setTargetLanguage] = (0, $exYeM.useState)(null);
    const [contentCategory, setContentCategory] = (0, $exYeM.useState)(null);
    const [contentCategories, setContentCategories] = (0, $exYeM.useState)(null);
    setActionMenu(null);
    function handleKeyDown(ev) {
        if (ev.ctrlKey || ev.metaKey) setShowAdditionalOptions(true);
    }
    (0, $exYeM.useEffect)(()=>{
        if (availableLanguages) return;
        async function fetchAvailableLanguages() {
            let data = await $e6d4445b9ec5d3b6$export$d0d68bb9ed2c643d();
            setAvailableLanguages(data.languages);
        }
        async function fetchAvailableSummarizer() {
            let data = await $e6d4445b9ec5d3b6$export$1eb8f9a671ab6195();
            setAvailableSummarizer(data.summarizer);
        }
        async function fetchAvailableCollections() {
            let collections = await $e6d4445b9ec5d3b6$export$167de583c0ce0e55();
            setCollections(collections);
        }
        async function fetchAvailableContentCategories() {
            let data = await $e6d4445b9ec5d3b6$export$c9b39eef4d7f6496(url);
            setContentCategories(data.categories);
        }
        fetchAvailableLanguages();
        fetchAvailableSummarizer();
        fetchAvailableCollections();
        fetchAvailableContentCategories();
    }, [
        availableLanguages
    ]);
    (0, $exYeM.useEffect)(()=>{
        let url = new URLSearchParams(location.search).get("url");
        if (url) setUrl(url);
    }, [
        location
    ]);
    (0, $exYeM.useEffect)(()=>{
        window.addEventListener("keydown", handleKeyDown);
        return ()=>window.removeEventListener("keydown", handleKeyDown);
    }, []);
    (0, $exYeM.useEffect)(()=>{
        if (!url && !isBehindPaywall.current) return;
        try {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($c35f50cf85a9916f$exports))).includes(new URL(url).hostname.replace(/^(.+?\.)(.+?\.)(.+)$/, "$2$3"))) {
                setIsBehindPaywall(true);
                isBehindPaywallChekboxRef.current.checked = true;
            }
        } catch (_) {}
    }, [
        url,
        isBehindPaywallChekboxRef
    ]);
    async function handleSubmit(ev) {
        ev.preventDefault();
        setSubmitButtonDisabled(true);
        // when pasting text on mobile, changed/keypress events are not fired
        let _url = url || inputUrlRef.current?.value;
        if (!_url) return alert((0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Please enter a URL"));
        try {
            let data = await $e6d4445b9ec5d3b6$export$b47079be406b9011({
                html: html,
                url: _url,
                is_behind_paywall: isBehindPaywall,
                language: targetLanguage,
                summarize_mode: summarizer,
                content_classification: contentCategory,
                collection_id: collectionId
            });
            if (data.website?.id) setTimeout(()=>{
                navigate(`/websites/${data.website.share_url}?wait=queue#top`);
                setSubmitButtonDisabled(false);
            }, 800);
        } catch (e) {
            console.error(e);
            let message = (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Some problem occured while adding site") + ": " + (e.response.data?.message || e.response.data?.error);
            setSubmitButtonDisabled(false);
            alert(message + "\n\n" + [
                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Please ensure that you have access to the site"),
                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("In most cases that means that you need to be logged in on the website you want to stash"),
                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Then try again to the save the website with the browser plugin")
            ].join(". ") + ".");
            document.getElementById("send-html").click();
        }
    }
    function handleChangeUrl(ev) {
        setUrl(ev.target.value);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "add-website",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
            className: "form",
            onSubmit: handleSubmit,
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Add Website")
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        type: "text",
                        required: true,
                        placeholder: "https://",
                        id: "url",
                        ref: inputUrlRef,
                        defaultValue: url,
                        onChange: handleChangeUrl
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "additional-options",
                        children: !showAdditionalOptions ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("h5", {
                            onClick: ()=>setShowAdditionalOptions(true),
                            children: [
                                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Click here to show all options"),
                                ". ",
                                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Or press ctrl / ⌘")
                            ]
                        }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "form-select",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("label", {
                                            htmlFor: "collection",
                                            children: [
                                                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Content classification"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("select", {
                                            onChange: (ev)=>setContentCategory(ev.target.value),
                                            children: contentCategories && Object.entries(contentCategories).map((v)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                                    value: v[0],
                                                    children: v[1]
                                                }, `content-cat-${v[0]}`))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "form-select",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("label", {
                                            htmlFor: "target-language",
                                            children: [
                                                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Target language"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("select", {
                                            onChange: (ev)=>setTargetLanguage(ev.target.value),
                                            children: availableLanguages && [
                                                [
                                                    null,
                                                    (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Keep original")
                                                ],
                                                ...Object.entries(availableLanguages)
                                            ].map((lang)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                                    value: lang[0],
                                                    selected: lang[0] === user.translate_to_language,
                                                    children: lang[1]
                                                }, `lang-${lang[0]}`))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                    className: "form-select",
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("label", {
                                            htmlFor: "collection",
                                            children: [
                                                (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Add to collection"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("select", {
                                            onChange: (ev)=>setCollectionId(ev.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                                    value: "auto",
                                                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Auto")
                                                }),
                                                collections && collections.map((v)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                                        value: v.id,
                                                        children: v.name
                                                    }, `collection-${v.id}`))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "checkbox",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                htmlFor: "send-html",
                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("The website is behind a paywall - or not accessible by third parties")
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                type: "checkbox",
                                id: "send-html",
                                defaultValue: isBehindPaywall,
                                onChange: (ev)=>setIsBehindPaywall(ev.target.checked),
                                ref: isBehindPaywallChekboxRef
                            })
                        ]
                    }),
                    isBehindPaywall && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "paywall-hint",
                                style: {
                                    marginBottom: "2rem"
                                },
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                                    children: [
                                        (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $1d6b0918345aa2c5$export$625550452a3fa3ec)(`Hint: It might be easier to use the <a href='https://www.sitestash.net/browser-extension' target='blank'>sitestash-browser-plugin</a> instead of inserting html code manually`)),
                                        " ",
                                        "\uD83D\uDE80"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("textarea", {
                                placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Insert the complete html of the page here, so that we can analyze the content without accessing the website"),
                                onChange: (ev)=>setHtml(ev.target.value),
                                id: "html",
                                rows: 10,
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        type: "submit",
                        disabled: submitButtonDisabled,
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Add Website")
                    })
                ]
            })
        })
    });
}





var $exYeM = parcelRequire("exYeM");





var $6e8ae56df3c331d7$exports = {};


$6e8ae56df3c331d7$exports = (parcelRequire("aNJCr")).getBundleURL("bDibm") + (parcelRequire("iE7OH")).resolve("ksNng");


function $e834f8d7ec9f3b13$export$21a94553ffa41578() {
    const [email, setEmail] = (0, $exYeM.useState)(null);
    const [password, setPassword] = (0, $exYeM.useState)(null);
    const [loginCode, setLoginCode] = (0, $exYeM.useState)(null);
    const [passwordlessLogin, setPasswordlessLogin] = (0, $exYeM.useState)(false);
    const [rememberLogin, setRememberLogin] = (0, $exYeM.useState)(true);
    const [showCodeInput, setShowCodeInput] = (0, $exYeM.useState)(false);
    const [, setUser] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    async function handleFormSubmit(ev) {
        ev.preventDefault();
        try {
            let token = null;
            if (passwordlessLogin) {
                if (!loginCode) try {
                    let res = await $e6d4445b9ec5d3b6$export$cc7f960a19545afa(email);
                    console.info(res.message);
                    setShowCodeInput(true);
                    return;
                } catch (e) {
                    console.error(e);
                    setPasswordlessLogin(false);
                }
                token = await $e6d4445b9ec5d3b6$export$fa4e1662809fcdbb(email, loginCode);
            } else token = await $e6d4445b9ec5d3b6$export$92a2a7f4653d8ef6(email, password);
            if (token) {
                $e6d4445b9ec5d3b6$export$7c4ce05e1c99c99b(token, rememberLogin ? localStorage : sessionStorage);
                const user = await $e6d4445b9ec5d3b6$export$ddb906a32562356c();
                setUser(user);
                navigate("/");
            }
        } catch (e) {
            if (e.response && e.response.data && e.response.data.message) {
                if (e.response.status === 422) alert(e.response.data.message ? `${(0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Could not login")}: ${e.response.data.message}` : (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Could not login. Wrong Password?"));
                console.debug(e.response.data.message);
            }
            console.error(e.message);
        }
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
        className: "form",
        onSubmit: handleFormSubmit,
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "logo",
                    "data-img-src": (0, (/*@__PURE__*/$parcel$interopDefault($6e8ae56df3c331d7$exports)))
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                    type: "email",
                    autoFocus: true,
                    required: true,
                    placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("E-Mail"),
                    onChange: (ev)=>setEmail(ev.target.value),
                    autoComplete: "username"
                }),
                !passwordlessLogin && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                    type: "password",
                    required: true,
                    placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Password"),
                    autoComplete: "current-password",
                    onChange: (ev)=>setPassword(ev.target.value)
                }),
                passwordlessLogin && showCodeInput && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                            type: "text",
                            inputMode: "numeric",
                            pattern: "\\d{4,}",
                            maxLength: 4,
                            required: true,
                            placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Your login code"),
                            "data-tooltip-content": (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("If you have signed up correctly, you have now received a login code which you can place here"),
                            autoFocus: true,
                            onChange: (ev)=>setLoginCode(ev.target.value)
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "password-info",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("We sent the login code")
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                    href: "#",
                                    onClick: ()=>setPasswordlessLogin(false),
                                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Click here, if you want to use your password instead")
                                })
                            ]
                        })
                    ]
                }),
                (password?.length >= 8 || loginCode?.length, /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "checkbox",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                            htmlFor: "remember-login",
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Remember login")
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                            type: "checkbox",
                            id: "remember-login",
                            onChange: (ev)=>setRememberLogin(ev.target.checked)
                        })
                    ]
                })),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                    type: "submit",
                    children: "Login"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "signup-here",
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                        to: "/signup",
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("No Account, yet? Sign up here")
                    })
                })
            ]
        })
    });
}






const $79a6aa2f003c21d2$export$36a381671975116c = (0, $5892d26dd4f89ebf$exports.atom)(null);





var $exYeM = parcelRequire("exYeM");






var $exYeM = parcelRequire("exYeM");
var $5815ed0933d43094$exports = {};


(()=>{
    var e = {
        296: (e, t, r)=>{
            var o = /^\s+|\s+$/g, n = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, c = /^0o[0-7]+$/i, u = parseInt, s = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, l = "object" == typeof self && self && self.Object === Object && self, a = s || l || Function("return this")(), f = Object.prototype.toString, p = Math.max, y = Math.min, d = function() {
                return a.Date.now();
            };
            function b(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function h(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && "[object Symbol]" == f.call(e);
                }(e)) return NaN;
                if (b(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = b(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(o, "");
                var r = i.test(e);
                return r || c.test(e) ? u(e.slice(2), r ? 2 : 8) : n.test(e) ? NaN : +e;
            }
            e.exports = function(e, t, r) {
                var o, n, i, c, u, s, l = 0, a = !1, f = !1, v = !0;
                if ("function" != typeof e) throw new TypeError("Expected a function");
                function m(t) {
                    var r = o, i = n;
                    return o = n = void 0, l = t, c = e.apply(i, r);
                }
                function O(e) {
                    var r = e - s;
                    return void 0 === s || r >= t || r < 0 || f && e - l >= i;
                }
                function w() {
                    var e = d();
                    if (O(e)) return g(e);
                    u = setTimeout(w, function(e) {
                        var r = t - (e - s);
                        return f ? y(r, i - (e - l)) : r;
                    }(e));
                }
                function g(e) {
                    return u = void 0, v && o ? m(e) : (o = n = void 0, c);
                }
                function P() {
                    var e = d(), r = O(e);
                    if (o = arguments, n = this, s = e, r) {
                        if (void 0 === u) return function(e) {
                            return l = e, u = setTimeout(w, t), a ? m(e) : c;
                        }(s);
                        if (f) return u = setTimeout(w, t), m(s);
                    }
                    return void 0 === u && (u = setTimeout(w, t)), c;
                }
                return t = h(t) || 0, b(r) && (a = !!r.leading, i = (f = "maxWait" in r) ? p(h(r.maxWait) || 0, t) : i, v = "trailing" in r ? !!r.trailing : v), P.cancel = function() {
                    void 0 !== u && clearTimeout(u), l = 0, o = s = n = u = void 0;
                }, P.flush = function() {
                    return void 0 === u ? c : g(d());
                }, P;
            };
        },
        96: (e, t, r)=>{
            var o = "Expected a function", n = NaN, i = "[object Symbol]", c = /^\s+|\s+$/g, u = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, l = /^0o[0-7]+$/i, a = parseInt, f = "object" == typeof r.g && r.g && r.g.Object === Object && r.g, p = "object" == typeof self && self && self.Object === Object && self, y = f || p || Function("return this")(), d = Object.prototype.toString, b = Math.max, h = Math.min, v = function() {
                return y.Date.now();
            };
            function m(e) {
                var t = typeof e;
                return !!e && ("object" == t || "function" == t);
            }
            function O(e) {
                if ("number" == typeof e) return e;
                if (function(e) {
                    return "symbol" == typeof e || function(e) {
                        return !!e && "object" == typeof e;
                    }(e) && d.call(e) == i;
                }(e)) return n;
                if (m(e)) {
                    var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                    e = m(t) ? t + "" : t;
                }
                if ("string" != typeof e) return 0 === e ? e : +e;
                e = e.replace(c, "");
                var r = s.test(e);
                return r || l.test(e) ? a(e.slice(2), r ? 2 : 8) : u.test(e) ? n : +e;
            }
            e.exports = function(e, t, r) {
                var n = !0, i = !0;
                if ("function" != typeof e) throw new TypeError(o);
                return m(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), function(e, t, r) {
                    var n, i, c, u, s, l, a = 0, f = !1, p = !1, y = !0;
                    if ("function" != typeof e) throw new TypeError(o);
                    function d(t) {
                        var r = n, o = i;
                        return n = i = void 0, a = t, u = e.apply(o, r);
                    }
                    function w(e) {
                        var r = e - l;
                        return void 0 === l || r >= t || r < 0 || p && e - a >= c;
                    }
                    function g() {
                        var e = v();
                        if (w(e)) return P(e);
                        s = setTimeout(g, function(e) {
                            var r = t - (e - l);
                            return p ? h(r, c - (e - a)) : r;
                        }(e));
                    }
                    function P(e) {
                        return s = void 0, y && n ? d(e) : (n = i = void 0, u);
                    }
                    function j() {
                        var e = v(), r = w(e);
                        if (n = arguments, i = this, l = e, r) {
                            if (void 0 === s) return function(e) {
                                return a = e, s = setTimeout(g, t), f ? d(e) : u;
                            }(l);
                            if (p) return s = setTimeout(g, t), d(l);
                        }
                        return void 0 === s && (s = setTimeout(g, t)), u;
                    }
                    return t = O(t) || 0, m(r) && (f = !!r.leading, c = (p = "maxWait" in r) ? b(O(r.maxWait) || 0, t) : c, y = "trailing" in r ? !!r.trailing : y), j.cancel = function() {
                        void 0 !== s && clearTimeout(s), a = 0, n = l = i = s = void 0;
                    }, j.flush = function() {
                        return void 0 === s ? u : P(v());
                    }, j;
                }(e, t, {
                    leading: n,
                    maxWait: t,
                    trailing: i
                });
            };
        },
        703: (e, t, r)=>{
            "use strict";
            var o = r(414);
            function n() {}
            function i() {}
            i.resetWarningCache = n, e.exports = function() {
                function e(e, t, r, n, i, c) {
                    if (c !== o) {
                        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw u.name = "Invariant Violation", u;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: i,
                    resetWarningCache: n
                };
                return r.PropTypes = r, r;
            };
        },
        697: (e, t, r)=>{
            e.exports = r(703)();
        },
        414: (e)=>{
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        }
    }, t = {};
    function r(o) {
        var n = t[o];
        if (void 0 !== n) return n.exports;
        var i = t[o] = {
            exports: {}
        };
        return e[o](i, i.exports, r), i.exports;
    }
    r.n = (e)=>{
        var t = e && e.__esModule ? ()=>e.default : ()=>e;
        return r.d(t, {
            a: t
        }), t;
    }, r.d = (e, t)=>{
        for(var o in t)r.o(t, o) && !r.o(e, o) && Object.defineProperty(e, o, {
            enumerable: !0,
            get: t[o]
        });
    }, r.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e) {
            if ("object" == typeof window) return window;
        }
    }(), r.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), r.r = (e)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    };
    var o = {};
    (()=>{
        "use strict";
        r.r(o), r.d(o, {
            LazyLoadComponent: ()=>A,
            LazyLoadImage: ()=>ce,
            trackWindowScroll: ()=>M
        });
        const e = (parcelRequire("exYeM"));
        var t = r.n(e), n = r(697);
        const i = (parcelRequire("d2lNW"));
        var c = r.n(i);
        function u() {
            return "undefined" != typeof window && "IntersectionObserver" in window && "isIntersecting" in window.IntersectionObserverEntry.prototype;
        }
        function s(e) {
            return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, s(e);
        }
        function l(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function a(e, t, r) {
            return (t = p(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function f(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, p(o.key), o);
            }
        }
        function p(e) {
            var t = function(e, t) {
                if ("object" !== s(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== s(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === s(t) ? t : String(t);
        }
        function y(e, t) {
            return y = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, y(e, t);
        }
        function d(e) {
            return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, d(e);
        }
        var b = function(e) {
            e.forEach(function(e) {
                e.isIntersecting && e.target.onVisible();
            });
        }, h = {}, v = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && y(e, t);
            }(v, e);
            var r, o, n, i, p = (n = v, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = d(n);
                if (i) {
                    var r = d(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === s(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function v(e) {
                var t;
                if (function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, v), (t = p.call(this, e)).supportsObserver = !e.scrollPosition && e.useIntersectionObserver && u(), t.supportsObserver) {
                    var r = e.threshold;
                    t.observer = function(e) {
                        return h[e] = h[e] || new IntersectionObserver(b, {
                            rootMargin: e + "px"
                        }), h[e];
                    }(r);
                }
                return t;
            }
            return r = v, o = [
                {
                    key: "componentDidMount",
                    value: function() {
                        this.placeholder && this.observer && (this.placeholder.onVisible = this.props.onVisible, this.observer.observe(this.placeholder)), this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        this.observer && this.placeholder && this.observer.unobserve(this.placeholder);
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function() {
                        this.supportsObserver || this.updateVisibility();
                    }
                },
                {
                    key: "getPlaceholderBoundingBox",
                    value: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props.scrollPosition, t = this.placeholder.getBoundingClientRect(), r = c().findDOMNode(this.placeholder).style, o = parseInt(r.getPropertyValue("margin-left"), 10) || 0, n = parseInt(r.getPropertyValue("margin-top"), 10) || 0;
                        return {
                            bottom: e.y + t.bottom + n,
                            left: e.x + t.left + o,
                            right: e.x + t.right + o,
                            top: e.y + t.top + n
                        };
                    }
                },
                {
                    key: "isPlaceholderInViewport",
                    value: function() {
                        if ("undefined" == typeof window || !this.placeholder) return !1;
                        var e = this.props, t = e.scrollPosition, r = e.threshold, o = this.getPlaceholderBoundingBox(t), n = t.y + window.innerHeight, i = t.x, c = t.x + window.innerWidth, u = t.y;
                        return Boolean(u - r <= o.bottom && n + r >= o.top && i - r <= o.right && c + r >= o.left);
                    }
                },
                {
                    key: "updateVisibility",
                    value: function() {
                        this.isPlaceholderInViewport() && this.props.onVisible();
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this, r = this.props, o = r.className, n = r.height, i = r.placeholder, c = r.style, u = r.width;
                        if (i && "function" != typeof i.type) return t().cloneElement(i, {
                            ref: function(t) {
                                return e.placeholder = t;
                            }
                        });
                        var s = function(e) {
                            for(var t = 1; t < arguments.length; t++){
                                var r = null != arguments[t] ? arguments[t] : {};
                                t % 2 ? l(Object(r), !0).forEach(function(t) {
                                    a(e, t, r[t]);
                                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : l(Object(r)).forEach(function(t) {
                                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                                });
                            }
                            return e;
                        }({
                            display: "inline-block"
                        }, c);
                        return void 0 !== u && (s.width = u), void 0 !== n && (s.height = n), t().createElement("span", {
                            className: o,
                            ref: function(t) {
                                return e.placeholder = t;
                            },
                            style: s
                        }, i);
                    }
                }
            ], o && f(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), v;
        }(t().Component);
        v.propTypes = {
            onVisible: n.PropTypes.func.isRequired,
            className: n.PropTypes.string,
            height: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ]),
            placeholder: n.PropTypes.element,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            scrollPosition: n.PropTypes.shape({
                x: n.PropTypes.number.isRequired,
                y: n.PropTypes.number.isRequired
            }),
            width: n.PropTypes.oneOfType([
                n.PropTypes.number,
                n.PropTypes.string
            ])
        }, v.defaultProps = {
            className: "",
            placeholder: null,
            threshold: 100,
            useIntersectionObserver: !0
        };
        const m = v;
        var O = r(296), w = r.n(O), g = r(96), P = r.n(g), j = function(e) {
            var t = getComputedStyle(e, null);
            return t.getPropertyValue("overflow") + t.getPropertyValue("overflow-y") + t.getPropertyValue("overflow-x");
        };
        const T = function(e) {
            if (!(e instanceof HTMLElement)) return window;
            for(var t = e; t && t instanceof HTMLElement;){
                if (/(scroll|auto)/.test(j(t))) return t;
                t = t.parentNode;
            }
            return window;
        };
        function S(e) {
            return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, S(e);
        }
        var E = [
            "delayMethod",
            "delayTime"
        ];
        function L() {
            return L = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, L.apply(this, arguments);
        }
        function _(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== S(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== S(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === S(n) ? n : String(n)), o);
            }
            var n;
        }
        function I(e, t) {
            return I = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, I(e, t);
        }
        function x(e, t) {
            if (t && ("object" === S(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return R(e);
        }
        function R(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function k(e) {
            return k = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, k(e);
        }
        var D = function() {
            return "undefined" == typeof window ? 0 : window.scrollX || window.pageXOffset;
        }, C = function() {
            return "undefined" == typeof window ? 0 : window.scrollY || window.pageYOffset;
        };
        const M = function(e) {
            var r = function(r) {
                !function(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), t && I(e, t);
                }(a, r);
                var o, n, i, s, l = (i = a, s = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }(), function() {
                    var e, t = k(i);
                    if (s) {
                        var r = k(this).constructor;
                        e = Reflect.construct(t, arguments, r);
                    } else e = t.apply(this, arguments);
                    return x(this, e);
                });
                function a(e) {
                    var r;
                    if (function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, a), (r = l.call(this, e)).useIntersectionObserver = e.useIntersectionObserver && u(), r.useIntersectionObserver) return x(r);
                    var o = r.onChangeScroll.bind(R(r));
                    return "debounce" === e.delayMethod ? r.delayedScroll = w()(o, e.delayTime) : "throttle" === e.delayMethod && (r.delayedScroll = P()(o, e.delayTime)), r.state = {
                        scrollPosition: {
                            x: D(),
                            y: C()
                        }
                    }, r.baseComponentRef = t().createRef(), r;
                }
                return o = a, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.addListeners();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.removeListeners();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || T(c().findDOMNode(this.baseComponentRef.current)) !== this.scrollElement && (this.removeListeners(), this.addListeners());
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement = T(c().findDOMNode(this.baseComponentRef.current)), this.scrollElement.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }), window.addEventListener("resize", this.delayedScroll, {
                                passive: !0
                            }), this.scrollElement !== window && window.addEventListener("scroll", this.delayedScroll, {
                                passive: !0
                            }));
                        }
                    },
                    {
                        key: "removeListeners",
                        value: function() {
                            "undefined" == typeof window || this.useIntersectionObserver || (this.scrollElement.removeEventListener("scroll", this.delayedScroll), window.removeEventListener("resize", this.delayedScroll), this.scrollElement !== window && window.removeEventListener("scroll", this.delayedScroll));
                        }
                    },
                    {
                        key: "onChangeScroll",
                        value: function() {
                            this.useIntersectionObserver || this.setState({
                                scrollPosition: {
                                    x: D(),
                                    y: C()
                                }
                            });
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var r = this.props, o = (r.delayMethod, r.delayTime, function(e, t) {
                                if (null == e) return {};
                                var r, o, n = function(e, t) {
                                    if (null == e) return {};
                                    var r, o, n = {}, i = Object.keys(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                    return n;
                                }(e, t);
                                if (Object.getOwnPropertySymbols) {
                                    var i = Object.getOwnPropertySymbols(e);
                                    for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                                }
                                return n;
                            }(r, E)), n = this.useIntersectionObserver ? null : this.state.scrollPosition;
                            return t().createElement(e, L({
                                forwardRef: this.baseComponentRef,
                                scrollPosition: n
                            }, o));
                        }
                    }
                ], _(o.prototype, n), Object.defineProperty(o, "prototype", {
                    writable: !1
                }), a;
            }(t().Component);
            return r.propTypes = {
                delayMethod: n.PropTypes.oneOf([
                    "debounce",
                    "throttle"
                ]),
                delayTime: n.PropTypes.number,
                useIntersectionObserver: n.PropTypes.bool
            }, r.defaultProps = {
                delayMethod: "throttle",
                delayTime: 300,
                useIntersectionObserver: !0
            }, r;
        };
        function N(e) {
            return N = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, N(e);
        }
        function B(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== N(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== N(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === N(n) ? n : String(n)), o);
            }
            var n;
        }
        function V(e, t) {
            return V = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, V(e, t);
        }
        function W(e) {
            return W = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, W(e);
        }
        var z = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && V(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = W(n);
                if (i) {
                    var r = W(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === N(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), c.call(this, e);
            }
            return r = u, o = [
                {
                    key: "render",
                    value: function() {
                        return t().createElement(m, this.props);
                    }
                }
            ], B(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        const $ = M(z);
        function U(e) {
            return U = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, U(e);
        }
        function q(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (n = function(e, t) {
                    if ("object" !== U(e) || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var o = r.call(e, "string");
                        if ("object" !== U(o)) return o;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(o.key), "symbol" === U(n) ? n : String(n)), o);
            }
            var n;
        }
        function F(e, t) {
            return F = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, F(e, t);
        }
        function H(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Y(e) {
            return Y = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, Y(e);
        }
        var X = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && F(e, t);
            }(s, e);
            var r, o, n, i, c = (n = s, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = Y(n);
                if (i) {
                    var r = Y(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === U(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return H(e);
                }(this, e);
            });
            function s(e) {
                var t;
                !function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, s), t = c.call(this, e);
                var r = e.afterLoad, o = e.beforeLoad, n = e.scrollPosition, i = e.visibleByDefault;
                return t.state = {
                    visible: i
                }, i && (o(), r()), t.onVisible = t.onVisible.bind(H(t)), t.isScrollTracked = Boolean(n && Number.isFinite(n.x) && n.x >= 0 && Number.isFinite(n.y) && n.y >= 0), t;
            }
            return r = s, o = [
                {
                    key: "componentDidUpdate",
                    value: function(e, t) {
                        t.visible !== this.state.visible && this.props.afterLoad();
                    }
                },
                {
                    key: "onVisible",
                    value: function() {
                        this.props.beforeLoad(), this.setState({
                            visible: !0
                        });
                    }
                },
                {
                    key: "render",
                    value: function() {
                        if (this.state.visible) return this.props.children;
                        var e = this.props, r = e.className, o = e.delayMethod, n = e.delayTime, i = e.height, c = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.width;
                        return this.isScrollTracked || f && u() ? t().createElement(m, {
                            className: r,
                            height: i,
                            onVisible: this.onVisible,
                            placeholder: c,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            width: p
                        }) : t().createElement($, {
                            className: r,
                            delayMethod: o,
                            delayTime: n,
                            height: i,
                            onVisible: this.onVisible,
                            placeholder: c,
                            style: l,
                            threshold: a,
                            width: p
                        });
                    }
                }
            ], q(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), s;
        }(t().Component);
        X.propTypes = {
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool
        }, X.defaultProps = {
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            useIntersectionObserver: !0,
            visibleByDefault: !1
        };
        const A = X;
        function G(e) {
            return G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            }, G(e);
        }
        var J = [
            "afterLoad",
            "beforeLoad",
            "delayMethod",
            "delayTime",
            "effect",
            "placeholder",
            "placeholderSrc",
            "scrollPosition",
            "threshold",
            "useIntersectionObserver",
            "visibleByDefault",
            "wrapperClassName",
            "wrapperProps"
        ];
        function K(e, t) {
            var r = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var o = Object.getOwnPropertySymbols(e);
                t && (o = o.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), r.push.apply(r, o);
            }
            return r;
        }
        function Q(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? K(Object(r), !0).forEach(function(t) {
                    Z(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : K(Object(r)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
            }
            return e;
        }
        function Z(e, t, r) {
            return (t = re(t)) in e ? Object.defineProperty(e, t, {
                value: r,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = r, e;
        }
        function ee() {
            return ee = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
                }
                return e;
            }, ee.apply(this, arguments);
        }
        function te(e, t) {
            for(var r = 0; r < t.length; r++){
                var o = t[r];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, re(o.key), o);
            }
        }
        function re(e) {
            var t = function(e, t) {
                if ("object" !== G(e) || null === e) return e;
                var r = e[Symbol.toPrimitive];
                if (void 0 !== r) {
                    var o = r.call(e, "string");
                    if ("object" !== G(o)) return o;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e);
            }(e);
            return "symbol" === G(t) ? t : String(t);
        }
        function oe(e, t) {
            return oe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            }, oe(e, t);
        }
        function ne(e) {
            return ne = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            }, ne(e);
        }
        var ie = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && oe(e, t);
            }(u, e);
            var r, o, n, i, c = (n = u, i = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }(), function() {
                var e, t = ne(n);
                if (i) {
                    var r = ne(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                } else e = t.apply(this, arguments);
                return function(e, t) {
                    if (t && ("object" === G(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }(this, e);
            });
            function u(e) {
                var t;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, u), (t = c.call(this, e)).state = {
                    loaded: !1
                }, t;
            }
            return r = u, o = [
                {
                    key: "onImageLoad",
                    value: function() {
                        var e = this;
                        return this.state.loaded ? null : function(t) {
                            e.props.onLoad(t), e.props.afterLoad(), e.setState({
                                loaded: !0
                            });
                        };
                    }
                },
                {
                    key: "getImg",
                    value: function() {
                        var e = this.props, r = (e.afterLoad, e.beforeLoad, e.delayMethod, e.delayTime, e.effect, e.placeholder, e.placeholderSrc, e.scrollPosition, e.threshold, e.useIntersectionObserver, e.visibleByDefault, e.wrapperClassName, e.wrapperProps, function(e, t) {
                            if (null == e) return {};
                            var r, o, n = function(e, t) {
                                if (null == e) return {};
                                var r, o, n = {}, i = Object.keys(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
                                return n;
                            }(e, t);
                            if (Object.getOwnPropertySymbols) {
                                var i = Object.getOwnPropertySymbols(e);
                                for(o = 0; o < i.length; o++)r = i[o], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
                            }
                            return n;
                        }(e, J));
                        return t().createElement("img", ee({}, r, {
                            onLoad: this.onImageLoad()
                        }));
                    }
                },
                {
                    key: "getLazyLoadImage",
                    value: function() {
                        var e = this.props, r = e.beforeLoad, o = e.className, n = e.delayMethod, i = e.delayTime, c = e.height, u = e.placeholder, s = e.scrollPosition, l = e.style, a = e.threshold, f = e.useIntersectionObserver, p = e.visibleByDefault, y = e.width;
                        return t().createElement(A, {
                            beforeLoad: r,
                            className: o,
                            delayMethod: n,
                            delayTime: i,
                            height: c,
                            placeholder: u,
                            scrollPosition: s,
                            style: l,
                            threshold: a,
                            useIntersectionObserver: f,
                            visibleByDefault: p,
                            width: y
                        }, this.getImg());
                    }
                },
                {
                    key: "getWrappedLazyLoadImage",
                    value: function(e) {
                        var r = this.props, o = r.effect, n = r.height, i = r.placeholderSrc, c = r.width, u = r.wrapperClassName, s = r.wrapperProps, l = this.state.loaded, a = l ? " lazy-load-image-loaded" : "", f = l || !i ? {} : {
                            backgroundImage: "url(".concat(i, ")"),
                            backgroundSize: "100% 100%"
                        };
                        return t().createElement("span", ee({
                            className: u + " lazy-load-image-background " + o + a,
                            style: Q(Q({}, f), {}, {
                                color: "transparent",
                                display: "inline-block",
                                height: n,
                                width: c
                            })
                        }, s), e);
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var e = this.props, t = e.effect, r = e.placeholderSrc, o = e.visibleByDefault, n = e.wrapperClassName, i = e.wrapperProps, c = this.getLazyLoadImage();
                        return (t || r) && !o || n || i ? this.getWrappedLazyLoadImage(c) : c;
                    }
                }
            ], te(r.prototype, o), Object.defineProperty(r, "prototype", {
                writable: !1
            }), u;
        }(t().Component);
        ie.propTypes = {
            onLoad: n.PropTypes.func,
            afterLoad: n.PropTypes.func,
            beforeLoad: n.PropTypes.func,
            delayMethod: n.PropTypes.string,
            delayTime: n.PropTypes.number,
            effect: n.PropTypes.string,
            placeholderSrc: n.PropTypes.string,
            threshold: n.PropTypes.number,
            useIntersectionObserver: n.PropTypes.bool,
            visibleByDefault: n.PropTypes.bool,
            wrapperClassName: n.PropTypes.string,
            wrapperProps: n.PropTypes.object
        }, ie.defaultProps = {
            onLoad: function() {},
            afterLoad: function() {
                return {};
            },
            beforeLoad: function() {
                return {};
            },
            delayMethod: "throttle",
            delayTime: 300,
            effect: "",
            placeholderSrc: null,
            threshold: 100,
            useIntersectionObserver: !0,
            visibleByDefault: !1,
            wrapperClassName: ""
        };
        const ce = ie;
    })(), $5815ed0933d43094$exports = o;
})();





var $exYeM = parcelRequire("exYeM");
function $eab5b28e57d35300$var$isShallowEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1){
        if (object1[key] !== object2[key]) return false;
    }
    return true;
}
function $eab5b28e57d35300$var$isTouchEvent({ nativeEvent: nativeEvent }) {
    return window.TouchEvent ? nativeEvent instanceof TouchEvent : "touches" in nativeEvent;
}
function $eab5b28e57d35300$var$isMouseEvent(event) {
    return event.nativeEvent instanceof MouseEvent;
}
function $eab5b28e57d35300$var$throttle(cb, ms) {
    let lastTime = 0;
    return ()=>{
        const now = Date.now();
        if (now - lastTime >= ms) {
            cb();
            lastTime = now;
        }
    };
}
function $eab5b28e57d35300$var$isPlainObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $eab5b28e57d35300$var$dispatchStorageEvent(key, newValue) {
    window.dispatchEvent(new StorageEvent("storage", {
        key: key,
        newValue: newValue
    }));
}
function $eab5b28e57d35300$export$2a2cdda660e4b159() {
    const [state, setState] = $exYeM.useState({
        supported: true,
        loading: true,
        level: null,
        charging: null,
        chargingTime: null,
        dischargingTime: null
    });
    $exYeM.useEffect(()=>{
        if (!navigator.getBattery) {
            setState((s)=>({
                    ...s,
                    supported: false,
                    loading: false
                }));
            return;
        }
        let battery = null;
        const handleChange = ()=>{
            setState({
                supported: true,
                loading: false,
                level: battery.level,
                charging: battery.charging,
                chargingTime: battery.chargingTime,
                dischargingTime: battery.dischargingTime
            });
        };
        navigator.getBattery().then((b)=>{
            battery = b;
            handleChange();
            b.addEventListener("levelchange", handleChange);
            b.addEventListener("chargingchange", handleChange);
            b.addEventListener("chargingtimechange", handleChange);
            b.addEventListener("dischargingtimechange", handleChange);
        });
        return ()=>{
            if (battery) {
                battery.removeEventListener("levelchange", handleChange);
                battery.removeEventListener("chargingchange", handleChange);
                battery.removeEventListener("chargingtimechange", handleChange);
                battery.removeEventListener("dischargingtimechange", handleChange);
            }
        };
    }, []);
    return state;
}
function $eab5b28e57d35300$export$682608ebc9a33151(cb) {
    const ref = $exYeM.useRef(null);
    const refCb = $exYeM.useRef(cb);
    $exYeM.useLayoutEffect(()=>{
        refCb.current = cb;
    });
    $exYeM.useEffect(()=>{
        const handler = (e)=>{
            const element = ref.current;
            if (element && !element.contains(e.target)) refCb.current(e);
        };
        document.addEventListener("mousedown", handler);
        document.addEventListener("touchstart", handler);
        return ()=>{
            document.removeEventListener("mousedown", handler);
            document.removeEventListener("touchstart", handler);
        };
    }, []);
    return ref;
}
function $eab5b28e57d35300$var$oldSchoolCopy(text) {
    const tempTextArea = document.createElement("textarea");
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
}
function $eab5b28e57d35300$export$b2199c37e85de4a7() {
    const [state, setState] = $exYeM.useState(null);
    const copyToClipboard = $exYeM.useCallback((value)=>{
        const handleCopy = async ()=>{
            try {
                if (navigator?.clipboard?.writeText) {
                    await navigator.clipboard.writeText(value);
                    setState(value);
                } else throw new Error("writeText not supported");
            } catch (e) {
                $eab5b28e57d35300$var$oldSchoolCopy(value);
                setState(value);
            }
        };
        handleCopy();
    }, []);
    return [
        state,
        copyToClipboard
    ];
}
function $eab5b28e57d35300$export$70c4067197c60e2d(startingValue = 0, options = {}) {
    const { min: min, max: max } = options;
    if (typeof min === "number" && startingValue < min) throw new Error(`Your starting value of ${startingValue} is less than your min of ${min}.`);
    if (typeof max === "number" && startingValue > max) throw new Error(`Your starting value of ${startingValue} is greater than your max of ${max}.`);
    const [count, setCount] = $exYeM.useState(startingValue);
    const increment = $exYeM.useCallback(()=>{
        setCount((c)=>{
            const nextCount = c + 1;
            if (typeof max === "number" && nextCount > max) return c;
            return nextCount;
        });
    }, [
        max
    ]);
    const decrement = $exYeM.useCallback(()=>{
        setCount((c)=>{
            const nextCount = c - 1;
            if (typeof min === "number" && nextCount < min) return c;
            return nextCount;
        });
    }, [
        min
    ]);
    const set = $exYeM.useCallback((nextCount)=>{
        setCount((c)=>{
            if (typeof max === "number" && nextCount > max) return c;
            if (typeof min === "number" && nextCount < min) return c;
            return nextCount;
        });
    }, [
        max,
        min
    ]);
    const reset = $exYeM.useCallback(()=>{
        setCount(startingValue);
    }, [
        startingValue
    ]);
    return [
        count,
        {
            increment: increment,
            decrement: decrement,
            set: set,
            reset: reset
        }
    ];
}
function $eab5b28e57d35300$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = $exYeM.useState(value);
    $exYeM.useEffect(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
function $eab5b28e57d35300$export$c285085960cfbe7d(initialValue, defaultValue) {
    const [state, setState] = $exYeM.useState(initialValue);
    if (typeof state === "undefined" || state === null) return [
        defaultValue,
        setState
    ];
    return [
        state,
        setState
    ];
}
function $eab5b28e57d35300$export$4b208edda918084f(title) {
    $exYeM.useEffect(()=>{
        document.title = title;
    }, [
        title
    ]);
}
function $eab5b28e57d35300$export$1252d0179ae6292b(url) {
    $exYeM.useEffect(()=>{
        let link = document.querySelector(`link[rel~="icon"]`);
        if (!link) {
            link = document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "icon";
            link.href = url;
            document.head.appendChild(link);
        } else link.href = url;
    }, [
        url
    ]);
}
function $eab5b28e57d35300$export$8c959c84e890409a(options = {}) {
    const [state, setState] = $exYeM.useState({
        loading: true,
        accuracy: null,
        altitude: null,
        altitudeAccuracy: null,
        heading: null,
        latitude: null,
        longitude: null,
        speed: null,
        timestamp: null,
        error: null
    });
    const optionsRef = $exYeM.useRef(options);
    $exYeM.useEffect(()=>{
        const onEvent = ({ coords: coords, timestamp: timestamp })=>{
            setState({
                loading: false,
                timestamp: timestamp,
                latitude: coords.latitude,
                longitude: coords.longitude,
                altitude: coords.altitude,
                accuracy: coords.accuracy,
                altitudeAccuracy: coords.altitudeAccuracy,
                heading: coords.heading,
                speed: coords.speed
            });
        };
        const onEventError = (error)=>{
            setState((s)=>({
                    ...s,
                    loading: false,
                    error: error
                }));
        };
        navigator.geolocation.getCurrentPosition(onEvent, onEventError, optionsRef.current);
        const watchId = navigator.geolocation.watchPosition(onEvent, onEventError, optionsRef.current);
        return ()=>{
            navigator.geolocation.clearWatch(watchId);
        };
    }, []);
    return state;
}
const $eab5b28e57d35300$var$initialUseHistoryStateState = {
    past: [],
    present: null,
    future: []
};
const $eab5b28e57d35300$var$useHistoryStateReducer = (state, action)=>{
    const { past: past, present: present, future: future } = state;
    if (action.type === "UNDO") return {
        past: past.slice(0, past.length - 1),
        present: past[past.length - 1],
        future: [
            present,
            ...future
        ]
    };
    else if (action.type === "REDO") return {
        past: [
            ...past,
            present
        ],
        present: future[0],
        future: future.slice(1)
    };
    else if (action.type === "SET") {
        const { newPresent: newPresent } = action;
        if (action.newPresent === present) return state;
        return {
            past: [
                ...past,
                present
            ],
            present: newPresent,
            future: []
        };
    } else if (action.type === "CLEAR") return {
        ...$eab5b28e57d35300$var$initialUseHistoryStateState,
        present: action.initialPresent
    };
    else throw new Error("Unsupported action type");
};
function $eab5b28e57d35300$export$3ba9310fb9209e7f(initialPresent = {}) {
    const initialPresentRef = $exYeM.useRef(initialPresent);
    const [state, dispatch] = $exYeM.useReducer($eab5b28e57d35300$var$useHistoryStateReducer, {
        ...$eab5b28e57d35300$var$initialUseHistoryStateState,
        present: initialPresentRef.current
    });
    const canUndo = state.past.length !== 0;
    const canRedo = state.future.length !== 0;
    const undo = $exYeM.useCallback(()=>{
        if (canUndo) dispatch({
            type: "UNDO"
        });
    }, [
        canUndo
    ]);
    const redo = $exYeM.useCallback(()=>{
        if (canRedo) dispatch({
            type: "REDO"
        });
    }, [
        canRedo
    ]);
    const set = $exYeM.useCallback((newPresent)=>dispatch({
            type: "SET",
            newPresent: newPresent
        }), []);
    const clear = $exYeM.useCallback(()=>dispatch({
            type: "CLEAR",
            initialPresent: initialPresentRef.current
        }), []);
    return {
        state: state.present,
        set: set,
        undo: undo,
        redo: redo,
        clear: clear,
        canUndo: canUndo,
        canRedo: canRedo
    };
}
function $eab5b28e57d35300$export$ae780daf29e6d456() {
    const [hovering, setHovering] = $exYeM.useState(false);
    const previousNode = $exYeM.useRef(null);
    const handleMouseEnter = $exYeM.useCallback(()=>{
        setHovering(true);
    }, []);
    const handleMouseLeave = $exYeM.useCallback(()=>{
        setHovering(false);
    }, []);
    const customRef = $exYeM.useCallback((node)=>{
        if (previousNode.current?.nodeType === Node.ELEMENT_NODE) {
            previousNode.current.removeEventListener("mouseenter", handleMouseEnter);
            previousNode.current.removeEventListener("mouseleave", handleMouseLeave);
        }
        if (node?.nodeType === Node.ELEMENT_NODE) {
            node.addEventListener("mouseenter", handleMouseEnter);
            node.addEventListener("mouseleave", handleMouseLeave);
        }
        previousNode.current = node;
    }, [
        handleMouseEnter,
        handleMouseLeave
    ]);
    return [
        customRef,
        hovering
    ];
}
function $eab5b28e57d35300$export$4fed27c116de10cb(ms = 60000) {
    const [idle, setIdle] = $exYeM.useState(false);
    $exYeM.useEffect(()=>{
        let timeoutId;
        const handleTimeout = ()=>{
            setIdle(true);
        };
        const handleEvent = $eab5b28e57d35300$var$throttle((e)=>{
            setIdle(false);
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(handleTimeout, ms);
        }, 500);
        const handleVisibilityChange = ()=>{
            if (!document.hidden) handleEvent();
        };
        timeoutId = window.setTimeout(handleTimeout, ms);
        window.addEventListener("mousemove", handleEvent);
        window.addEventListener("mousedown", handleEvent);
        window.addEventListener("resize", handleEvent);
        window.addEventListener("keydown", handleEvent);
        window.addEventListener("touchstart", handleEvent);
        window.addEventListener("wheel", handleEvent);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        return ()=>{
            window.removeEventListener("mousemove", handleEvent);
            window.removeEventListener("mousedown", handleEvent);
            window.removeEventListener("resize", handleEvent);
            window.removeEventListener("keydown", handleEvent);
            window.removeEventListener("touchstart", handleEvent);
            window.removeEventListener("wheel", handleEvent);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.clearTimeout(timeoutId);
        };
    }, [
        ms
    ]);
    return idle;
}
function $eab5b28e57d35300$export$a7395f9832c00176(options = {}) {
    const { threshold: threshold = 1, root: root = null, rootMargin: rootMargin = "0px" } = options;
    const [entry, setEntry] = $exYeM.useState(null);
    const previousObserver = $exYeM.useRef(null);
    const customRef = $exYeM.useCallback((node)=>{
        if (previousObserver.current) {
            previousObserver.current.disconnect();
            previousObserver.current = null;
        }
        if (node?.nodeType === Node.ELEMENT_NODE) {
            const observer = new IntersectionObserver(([entry])=>{
                setEntry(entry);
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            observer.observe(node);
            previousObserver.current = observer;
        }
    }, [
        threshold,
        root,
        rootMargin
    ]);
    return [
        customRef,
        entry
    ];
}
function $eab5b28e57d35300$export$7c8949515a63d2a1() {
    const [isClient, setIsClient] = $exYeM.useState(false);
    $exYeM.useEffect(()=>{
        setIsClient(true);
    }, []);
    return isClient;
}
function $eab5b28e57d35300$export$5964c316e853650f() {
    const renderRef = $exYeM.useRef(true);
    if (renderRef.current === true) {
        renderRef.current = false;
        return true;
    }
    return renderRef.current;
}
function $eab5b28e57d35300$export$f9763ecd339e95eb(defaultList = []) {
    const [list, setList] = $exYeM.useState(defaultList);
    const set = $exYeM.useCallback((l)=>{
        setList(l);
    }, []);
    const push = $exYeM.useCallback((element)=>{
        setList((l)=>[
                ...l,
                element
            ]);
    }, []);
    const removeAt = $exYeM.useCallback((index)=>{
        setList((l)=>[
                ...l.slice(0, index),
                ...l.slice(index + 1)
            ]);
    }, []);
    const insertAt = $exYeM.useCallback((index, element)=>{
        setList((l)=>[
                ...l.slice(0, index),
                element,
                ...l.slice(index)
            ]);
    }, []);
    const updateAt = $exYeM.useCallback((index, element)=>{
        setList((l)=>l.map((e, i)=>i === index ? element : e));
    }, []);
    const clear = $exYeM.useCallback(()=>setList([]), []);
    return [
        list,
        {
            set: set,
            push: push,
            removeAt: removeAt,
            insertAt: insertAt,
            updateAt: updateAt,
            clear: clear
        }
    ];
}
const $eab5b28e57d35300$var$setLocalStorageItem = (key, value)=>{
    const stringifiedValue = JSON.stringify(value);
    window.localStorage.setItem(key, stringifiedValue);
    $eab5b28e57d35300$var$dispatchStorageEvent(key, stringifiedValue);
};
const $eab5b28e57d35300$var$removeLocalStorageItem = (key)=>{
    window.localStorage.removeItem(key);
    $eab5b28e57d35300$var$dispatchStorageEvent(key, null);
};
const $eab5b28e57d35300$var$getLocalStorageItem = (key)=>{
    return window.localStorage.getItem(key);
};
const $eab5b28e57d35300$var$useLocalStorageSubscribe = (callback)=>{
    window.addEventListener("storage", callback);
    return ()=>window.removeEventListener("storage", callback);
};
const $eab5b28e57d35300$var$getLocalStorageServerSnapshot = ()=>{
    throw Error("useLocalStorage is a client-only hook");
};
function $eab5b28e57d35300$export$86e2cef2561044ac(key, initialValue) {
    const getSnapshot = ()=>$eab5b28e57d35300$var$getLocalStorageItem(key);
    const store = $exYeM.useSyncExternalStore($eab5b28e57d35300$var$useLocalStorageSubscribe, getSnapshot, $eab5b28e57d35300$var$getLocalStorageServerSnapshot);
    const setState = $exYeM.useCallback((v)=>{
        try {
            const nextState = typeof v === "function" ? v(JSON.parse(store)) : v;
            if (nextState === undefined || nextState === null) $eab5b28e57d35300$var$removeLocalStorageItem(key);
            else $eab5b28e57d35300$var$setLocalStorageItem(key, nextState);
        } catch (e) {
            console.warn(e);
        }
    }, [
        key,
        store
    ]);
    $exYeM.useEffect(()=>{
        if ($eab5b28e57d35300$var$getLocalStorageItem(key) === null && typeof initialValue !== "undefined") $eab5b28e57d35300$var$setLocalStorageItem(key, initialValue);
    }, [
        key,
        initialValue
    ]);
    return [
        store ? JSON.parse(store) : initialValue,
        setState
    ];
}
function $eab5b28e57d35300$export$bd4ec12442706c3d() {
    $exYeM.useLayoutEffect(()=>{
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = "hidden";
        return ()=>{
            document.body.style.overflow = originalStyle;
        };
    }, []);
}
function $eab5b28e57d35300$export$c24ed0104d07eab9(callback, options = {}) {
    const { threshold: threshold = 400, onStart: onStart, onFinish: onFinish, onCancel: onCancel } = options;
    const isLongPressActive = $exYeM.useRef(false);
    const isPressed = $exYeM.useRef(false);
    const timerId = $exYeM.useRef();
    return $exYeM.useMemo(()=>{
        if (typeof callback !== "function") return {};
        const start = (event)=>{
            if (!$eab5b28e57d35300$var$isMouseEvent(event) && !$eab5b28e57d35300$var$isTouchEvent(event)) return;
            if (onStart) onStart(event);
            isPressed.current = true;
            timerId.current = setTimeout(()=>{
                callback(event);
                isLongPressActive.current = true;
            }, threshold);
        };
        const cancel = (event)=>{
            if (!$eab5b28e57d35300$var$isMouseEvent(event) && !$eab5b28e57d35300$var$isTouchEvent(event)) return;
            if (isLongPressActive.current) {
                if (onFinish) onFinish(event);
            } else if (isPressed.current) {
                if (onCancel) onCancel(event);
            }
            isLongPressActive.current = false;
            isPressed.current = false;
            if (timerId.current) window.clearTimeout(timerId.current);
        };
        const mouseHandlers = {
            onMouseDown: start,
            onMouseUp: cancel,
            onMouseLeave: cancel
        };
        const touchHandlers = {
            onTouchStart: start,
            onTouchEnd: cancel
        };
        return {
            ...mouseHandlers,
            ...touchHandlers
        };
    }, [
        callback,
        threshold,
        onCancel,
        onFinish,
        onStart
    ]);
}
function $eab5b28e57d35300$export$86f8f9f08863e403(initialState) {
    const mapRef = $exYeM.useRef(new Map(initialState));
    const [, reRender] = $exYeM.useReducer((x)=>x + 1, 0);
    mapRef.current.set = (...args)=>{
        Map.prototype.set.apply(mapRef.current, args);
        reRender();
        return mapRef.current;
    };
    mapRef.current.clear = (...args)=>{
        Map.prototype.clear.apply(mapRef.current, args);
        reRender();
    };
    mapRef.current.delete = (...args)=>{
        const res = Map.prototype.delete.apply(mapRef.current, args);
        reRender();
        return res;
    };
    return mapRef.current;
}
function $eab5b28e57d35300$export$e295b0c537d32d7d() {
    const [dimensions, setDimensions] = $exYeM.useState({
        width: null,
        height: null
    });
    const previousObserver = $exYeM.useRef(null);
    const customRef = $exYeM.useCallback((node)=>{
        if (previousObserver.current) {
            previousObserver.current.disconnect();
            previousObserver.current = null;
        }
        if (node?.nodeType === Node.ELEMENT_NODE) {
            const observer = new ResizeObserver(([entry])=>{
                if (entry && entry.borderBoxSize) {
                    const { inlineSize: width, blockSize: height } = entry.borderBoxSize[0];
                    setDimensions({
                        width: width,
                        height: height
                    });
                }
            });
            observer.observe(node);
            previousObserver.current = observer;
        }
    }, []);
    return [
        customRef,
        dimensions
    ];
}
function $eab5b28e57d35300$export$32d5543ab307c01(query) {
    const subscribe = $exYeM.useCallback((callback)=>{
        const matchMedia = window.matchMedia(query);
        matchMedia.addEventListener("change", callback);
        return ()=>{
            matchMedia.removeEventListener("change", callback);
        };
    }, [
        query
    ]);
    const getSnapshot = ()=>{
        return window.matchMedia(query).matches;
    };
    const getServerSnapshot = ()=>{
        throw Error("useMediaQuery is a client-only hook");
    };
    return $exYeM.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
function $eab5b28e57d35300$export$70811b4970b0f258() {
    const [state, setState] = $exYeM.useState({
        x: 0,
        y: 0,
        elementX: 0,
        elementY: 0,
        elementPositionX: 0,
        elementPositionY: 0
    });
    const ref = $exYeM.useRef(null);
    $exYeM.useLayoutEffect(()=>{
        const handleMouseMove = (event)=>{
            let newState = {
                x: event.pageX,
                y: event.pageY
            };
            if (ref.current?.nodeType === Node.ELEMENT_NODE) {
                const { left: left, top: top } = ref.current.getBoundingClientRect();
                const elementPositionX = left + window.scrollX;
                const elementPositionY = top + window.scrollY;
                const elementX = event.pageX - elementPositionX;
                const elementY = event.pageY - elementPositionY;
                newState.elementX = elementX;
                newState.elementY = elementY;
                newState.elementPositionX = elementPositionX;
                newState.elementPositionY = elementPositionY;
            }
            setState((s)=>{
                return {
                    ...s,
                    ...newState
                };
            });
        };
        document.addEventListener("mousemove", handleMouseMove);
        return ()=>{
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    return [
        state,
        ref
    ];
}
const $eab5b28e57d35300$var$getConnection = ()=>{
    return navigator?.connection || navigator?.mozConnection || navigator?.webkitConnection;
};
const $eab5b28e57d35300$var$useNetworkStateSubscribe = (callback)=>{
    window.addEventListener("online", callback, {
        passive: true
    });
    window.addEventListener("offline", callback, {
        passive: true
    });
    const connection = $eab5b28e57d35300$var$getConnection();
    if (connection) connection.addEventListener("change", callback, {
        passive: true
    });
    return ()=>{
        window.removeEventListener("online", callback);
        window.removeEventListener("offline", callback);
        if (connection) connection.removeEventListener("change", callback);
    };
};
const $eab5b28e57d35300$var$getNetworkStateServerSnapshot = ()=>{
    throw Error("useNetworkState is a client-only hook");
};
function $eab5b28e57d35300$export$771cf3162c4459b4() {
    const cache = $exYeM.useRef({});
    const getSnapshot = ()=>{
        const online = navigator.onLine;
        const connection = $eab5b28e57d35300$var$getConnection();
        const nextState = {
            online: online,
            downlink: connection?.downlink,
            downlinkMax: connection?.downlinkMax,
            effectiveType: connection?.effectiveType,
            rtt: connection?.rtt,
            saveData: connection?.saveData,
            type: connection?.type
        };
        if ($eab5b28e57d35300$var$isShallowEqual(cache.current, nextState)) return cache.current;
        else {
            cache.current = nextState;
            return nextState;
        }
    };
    return $exYeM.useSyncExternalStore($eab5b28e57d35300$var$useNetworkStateSubscribe, getSnapshot, $eab5b28e57d35300$var$getNetworkStateServerSnapshot);
}
function $eab5b28e57d35300$export$64bcfd5faff4adc3(initialValue) {
    const [state, setState] = $exYeM.useState(initialValue);
    const handleUpdate = $exYeM.useCallback((arg)=>{
        if (typeof arg === "function") setState((s)=>{
            const newState = arg(s);
            if ($eab5b28e57d35300$var$isPlainObject(newState)) return {
                ...s,
                ...newState
            };
        });
        if ($eab5b28e57d35300$var$isPlainObject(arg)) setState((s)=>({
                ...s,
                ...arg
            }));
    }, []);
    return [
        state,
        handleUpdate
    ];
}
function $eab5b28e57d35300$export$550084c67147f6c4() {
    const [orientation, setOrientation] = $exYeM.useState({
        angle: 0,
        type: "landscape-primary"
    });
    $exYeM.useLayoutEffect(()=>{
        const handleChange = ()=>{
            const { angle: angle, type: type } = window.screen.orientation;
            setOrientation({
                angle: angle,
                type: type
            });
        };
        const handle_orientationchange = ()=>{
            setOrientation({
                type: "UNKNOWN",
                angle: window.orientation
            });
        };
        if (window.screen?.orientation) {
            handleChange();
            window.screen.orientation.addEventListener("change", handleChange);
        } else {
            handle_orientationchange();
            window.addEventListener("orientationchange", handle_orientationchange);
        }
        return ()=>{
            if (window.screen?.orientation) window.screen.orientation.removeEventListener("change", handleChange);
            else window.removeEventListener("orientationchange", handle_orientationchange);
        };
    }, []);
    return orientation;
}
const $eab5b28e57d35300$var$usePreferredLanguageSubscribe = (cb)=>{
    window.addEventListener("languagechange", cb);
    return ()=>window.removeEventListener("languagechange", cb);
};
const $eab5b28e57d35300$var$getPreferredLanguageSnapshot = ()=>{
    return navigator.language;
};
const $eab5b28e57d35300$var$getPreferredLanguageServerSnapshot = ()=>{
    throw Error("usePreferredLanguage is a client-only hook");
};
function $eab5b28e57d35300$export$49d816663ca832a7() {
    return $exYeM.useSyncExternalStore($eab5b28e57d35300$var$usePreferredLanguageSubscribe, $eab5b28e57d35300$var$getPreferredLanguageSnapshot, $eab5b28e57d35300$var$getPreferredLanguageServerSnapshot);
}
function $eab5b28e57d35300$export$5cae361ad82dce8b(value) {
    const [current, setCurrent] = $exYeM.useState(value);
    const [previous, setPrevious] = $exYeM.useState(null);
    if (value !== current) {
        setPrevious(current);
        setCurrent(value);
    }
    return previous;
}
function $eab5b28e57d35300$export$907c43d79990fc8d(initialValue = []) {
    const [queue, setQueue] = $exYeM.useState(initialValue);
    const add = $exYeM.useCallback((element)=>{
        setQueue((q)=>[
                ...q,
                element
            ]);
    }, []);
    const remove = $exYeM.useCallback(()=>{
        let removedElement;
        setQueue(([first, ...q])=>{
            removedElement = first;
            return q;
        });
        return removedElement;
    }, []);
    const clear = $exYeM.useCallback(()=>{
        setQueue([]);
    }, []);
    return {
        add: add,
        remove: remove,
        clear: clear,
        first: queue[0],
        last: queue[queue.length - 1],
        size: queue.length,
        queue: queue
    };
}
function $eab5b28e57d35300$export$894a34a32cdbdc06() {
    const count = $exYeM.useRef(0);
    count.current++;
    return count.current;
}
function $eab5b28e57d35300$export$4f6ac711e167c41b(name = "Unknown") {
    const count = $exYeM.useRef(0);
    const lastRender = $exYeM.useRef();
    const now = Date.now();
    count.current++;
    $exYeM.useEffect(()=>{
        lastRender.current = Date.now();
    });
    const sinceLastRender = lastRender.current ? now - lastRender.current : 0;
}
function $eab5b28e57d35300$export$1d3955b0b5cace9c(src, options = {}) {
    const [status, setStatus] = $exYeM.useState("loading");
    const optionsRef = $exYeM.useRef(options);
    $exYeM.useEffect(()=>{
        let script = document.querySelector(`script[src="${src}"]`);
        const domStatus = script?.getAttribute("data-status");
        if (domStatus) {
            setStatus(domStatus);
            return;
        }
        if (script === null) {
            script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.setAttribute("data-status", "loading");
            document.body.appendChild(script);
            const handleScriptLoad = ()=>{
                script.setAttribute("data-status", "ready");
                setStatus("ready");
                removeEventListeners();
            };
            const handleScriptError = ()=>{
                script.setAttribute("data-status", "error");
                setStatus("error");
                removeEventListeners();
            };
            const removeEventListeners = ()=>{
                script.removeEventListener("load", handleScriptLoad);
                script.removeEventListener("error", handleScriptError);
            };
            script.addEventListener("load", handleScriptLoad);
            script.addEventListener("error", handleScriptError);
            const removeOnUnmount = optionsRef.current.removeOnUnmount;
            return ()=>{
                if (removeOnUnmount === true) {
                    script.remove();
                    removeEventListeners();
                }
            };
        } else setStatus("unknown");
    }, [
        src
    ]);
    return status;
}
const $eab5b28e57d35300$var$setSessionStorageItem = (key, value)=>{
    const stringifiedValue = JSON.stringify(value);
    window.sessionStorage.setItem(key, stringifiedValue);
    $eab5b28e57d35300$var$dispatchStorageEvent(key, stringifiedValue);
};
const $eab5b28e57d35300$var$removeSessionStorageItem = (key)=>{
    window.sessionStorage.removeItem(key);
    $eab5b28e57d35300$var$dispatchStorageEvent(key, null);
};
const $eab5b28e57d35300$var$getSessionStorageItem = (key)=>{
    return window.sessionStorage.getItem(key);
};
const $eab5b28e57d35300$var$useSessionStorageSubscribe = (callback)=>{
    window.addEventListener("storage", callback);
    return ()=>window.removeEventListener("storage", callback);
};
const $eab5b28e57d35300$var$getSessionStorageServerSnapshot = ()=>{
    throw Error("useSessionStorage is a client-only hook");
};
function $eab5b28e57d35300$export$864b6828bd07eda6(key, initialValue) {
    const getSnapshot = ()=>$eab5b28e57d35300$var$getSessionStorageItem(key);
    const store = $exYeM.useSyncExternalStore($eab5b28e57d35300$var$useSessionStorageSubscribe, getSnapshot, $eab5b28e57d35300$var$getSessionStorageServerSnapshot);
    const setState = $exYeM.useCallback((v)=>{
        try {
            const nextState = typeof v === "function" ? v(JSON.parse(store)) : v;
            if (nextState === undefined || nextState === null) $eab5b28e57d35300$var$removeSessionStorageItem(key);
            else $eab5b28e57d35300$var$setSessionStorageItem(key, nextState);
        } catch (e) {
            console.warn(e);
        }
    }, [
        key,
        store
    ]);
    $exYeM.useEffect(()=>{
        if ($eab5b28e57d35300$var$getSessionStorageItem(key) === null && typeof initialValue !== "undefined") $eab5b28e57d35300$var$setSessionStorageItem(key, initialValue);
    }, [
        key,
        initialValue
    ]);
    return [
        store ? JSON.parse(store) : initialValue,
        setState
    ];
}
function $eab5b28e57d35300$export$5b4c1fde22d5926c(values) {
    const setRef = $exYeM.useRef(new Set(values));
    const [, reRender] = $exYeM.useReducer((x)=>x + 1, 0);
    setRef.current.add = (...args)=>{
        const res = Set.prototype.add.apply(setRef.current, args);
        reRender();
        return res;
    };
    setRef.current.clear = (...args)=>{
        Set.prototype.clear.apply(setRef.current, args);
        reRender();
    };
    setRef.current.delete = (...args)=>{
        const res = Set.prototype.delete.apply(setRef.current, args);
        reRender();
        return res;
    };
    return setRef.current;
}
function $eab5b28e57d35300$export$8b7b9481d6186f21(value, interval = 500) {
    const [throttledValue, setThrottledValue] = $exYeM.useState(value);
    const lastUpdated = $exYeM.useRef(null);
    $exYeM.useEffect(()=>{
        const now = Date.now();
        if (lastUpdated.current && now >= lastUpdated.current + interval) {
            lastUpdated.current = now;
            setThrottledValue(value);
        } else {
            const id = window.setTimeout(()=>{
                lastUpdated.current = now;
                setThrottledValue(value);
            }, interval);
            return ()=>window.clearTimeout(id);
        }
    }, [
        value,
        interval
    ]);
    return throttledValue;
}
function $eab5b28e57d35300$export$cbe85ee05b554577(initialValue) {
    const [on, setOn] = $exYeM.useState(()=>{
        if (typeof initialValue === "boolean") return initialValue;
        return Boolean(initialValue);
    });
    const handleToggle = $exYeM.useCallback((value)=>{
        if (typeof value === "boolean") return setOn(value);
        return setOn((v)=>!v);
    }, []);
    return [
        on,
        handleToggle
    ];
}
const $eab5b28e57d35300$var$useVisibilityChangeSubscribe = (callback)=>{
    document.addEventListener("visibilitychange", callback);
    return ()=>{
        document.removeEventListener("visibilitychange", callback);
    };
};
const $eab5b28e57d35300$var$getVisibilityChangeSnapshot = ()=>{
    return document.visibilityState;
};
const $eab5b28e57d35300$var$getVisibilityChangeServerSnapshot = ()=>{
    throw Error("useVisibilityChange is a client-only hook");
};
function $eab5b28e57d35300$export$b15225ef62b32b7d() {
    const visibilityState = $exYeM.useSyncExternalStore($eab5b28e57d35300$var$useVisibilityChangeSubscribe, $eab5b28e57d35300$var$getVisibilityChangeSnapshot, $eab5b28e57d35300$var$getVisibilityChangeServerSnapshot);
    return visibilityState === "visible";
}
function $eab5b28e57d35300$export$c510e5ca8a22f2a1() {
    const [state, setState] = $exYeM.useState({
        x: null,
        y: null
    });
    const scrollTo = $exYeM.useCallback((...args)=>{
        if (typeof args[0] === "object") window.scrollTo(args[0]);
        else if (typeof args[0] === "number" && typeof args[1] === "number") window.scrollTo(args[0], args[1]);
        else throw new Error(`Invalid arguments passed to scrollTo. See here for more info. https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollTo`);
    }, []);
    $exYeM.useLayoutEffect(()=>{
        const handleScroll = ()=>{
            setState({
                x: window.scrollX,
                y: window.scrollY
            });
        };
        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return [
        state,
        scrollTo
    ];
}
function $eab5b28e57d35300$export$42c02f33970a2afa() {
    const [size, setSize] = $exYeM.useState({
        width: null,
        height: null
    });
    $exYeM.useLayoutEffect(()=>{
        const handleResize = ()=>{
            setSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return size;
}




var $4f187667b545d850$exports = {};
/**
 * marked v11.0.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory($4f187667b545d850$exports);
})($4f187667b545d850$exports, function(exports1) {
    "use strict";
    /**
     * Gets the original marked default options.
     */ function _getDefaults() {
        return {
            async: false,
            breaks: false,
            extensions: null,
            gfm: true,
            hooks: null,
            pedantic: false,
            renderer: null,
            silent: false,
            tokenizer: null,
            walkTokens: null
        };
    }
    exports1.defaults = _getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
     * Helpers
     */ const escapeTest = /[&<>"']/;
    const escapeReplace = new RegExp(escapeTest.source, "g");
    const escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    const escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, "g");
    const escapeReplacements = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    const getEscapeReplacement = (ch)=>escapeReplacements[ch];
    function escape$1(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    const unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, (_, n)=>{
            n = n.toLowerCase();
            if (n === "colon") return ":";
            if (n.charAt(0) === "#") return n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return "";
        });
    }
    const caret = /(^|[^\[])\^/g;
    function edit(regex, opt) {
        let source = typeof regex === "string" ? regex : regex.source;
        opt = opt || "";
        const obj = {
            replace: (name, val)=>{
                let valSource = typeof val === "string" ? val : val.source;
                valSource = valSource.replace(caret, "$1");
                source = source.replace(name, valSource);
                return obj;
            },
            getRegex: ()=>{
                return new RegExp(source, opt);
            }
        };
        return obj;
    }
    function cleanUrl(href) {
        try {
            href = encodeURI(href).replace(/%25/g, "%");
        } catch (e) {
            return null;
        }
        return href;
    }
    const noopTest = {
        exec: ()=>null
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        const row = tableRow.replace(/\|/g, (match, offset, str)=>{
            let escaped = false;
            let curr = offset;
            while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return "|";
            else // add space before unescaped |
            return " |";
        }), cells = row.split(/ \|/);
        let i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (count) {
            if (cells.length > count) cells.splice(count);
            else while(cells.length < count)cells.push("");
        }
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, "|");
        return cells;
    }
    /**
     * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
     * /c*$/ is vulnerable to REDOS.
     *
     * @param str
     * @param c
     * @param invert Remove suffix of non-c chars instead. Default falsey.
     */ function rtrim(str, c, invert) {
        const l = str.length;
        if (l === 0) return "";
        // Length of suffix matching the invert condition.
        let suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            const currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        let level = 0;
        for(let i = 0; i < str.length; i++){
            if (str[i] === "\\") i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function outputLink(cap, link, raw, lexer) {
        const href = link.href;
        const title = link.title ? escape$1(link.title) : null;
        const text = cap[1].replace(/\\([\[\]])/g, "$1");
        if (cap[0].charAt(0) !== "!") {
            lexer.state.inLink = true;
            const token = {
                type: "link",
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: "image",
            raw: raw,
            href: href,
            title: title,
            text: escape$1(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        const matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        const indentToCode = matchIndentToCode[1];
        return text.split("\n").map((node)=>{
            const matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            const [indentInNode] = matchIndentInNode;
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join("\n");
    }
    /**
     * Tokenizer
     */ class _Tokenizer {
        options;
        rules;
        lexer;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        space(src) {
            const cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: "space",
                raw: cap[0]
            };
        }
        code(src) {
            const cap = this.rules.block.code.exec(src);
            if (cap) {
                const text = cap[0].replace(/^ {1,4}/gm, "");
                return {
                    type: "code",
                    raw: cap[0],
                    codeBlockStyle: "indented",
                    text: !this.options.pedantic ? rtrim(text, "\n") : text
                };
            }
        }
        fences(src) {
            const cap = this.rules.block.fences.exec(src);
            if (cap) {
                const raw = cap[0];
                const text = indentCodeCompensation(raw, cap[3] || "");
                return {
                    type: "code",
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                    text: text
                };
            }
        }
        heading(src) {
            const cap = this.rules.block.heading.exec(src);
            if (cap) {
                let text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    const trimmed = rtrim(text, "#");
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: "heading",
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        hr(src) {
            const cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: "hr",
                raw: cap[0]
            };
        }
        blockquote(src) {
            const cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                const text = rtrim(cap[0].replace(/^ *>[ \t]?/gm, ""), "\n");
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                const tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: "blockquote",
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        }
        list(src) {
            let cap = this.rules.block.list.exec(src);
            if (cap) {
                let bull = cap[1].trim();
                const isordered = bull.length > 1;
                const list = {
                    type: "list",
                    raw: "",
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : "",
                    loose: false,
                    items: []
                };
                bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
                if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
                // Get next list item
                const itemRegex = new RegExp(`^( {0,3}${bull})((?:[\t ][^\\n]*)?(?:\\n|$))`);
                let raw = "";
                let itemContents = "";
                let endsWithBlankLine = false;
                // Check if current bullet point can start a new List Item
                while(src){
                    let endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    let line = cap[2].split("\n", 1)[0].replace(/^\t+/, (t)=>" ".repeat(3 * t.length));
                    let nextLine = src.split("\n", 1)[0];
                    let indent = 0;
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimStart();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    let blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        raw += nextLine + "\n";
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        const nextBulletRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))`);
                        const hrRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`);
                        const fencesBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`);
                        const headingBeginRegex = new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`);
                        // Check if following lines should be included in List Item
                        while(src){
                            const rawLine = src.split("\n", 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ");
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) itemContents += "\n" + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += "\n" + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) blankLine = true;
                            raw += rawLine + "\n";
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    let istask = null;
                    let ischecked;
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== "[ ] ";
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, "");
                        }
                    }
                    list.items.push({
                        type: "list_item",
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents,
                        tokens: []
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimEnd();
                list.items[list.items.length - 1].text = itemContents.trimEnd();
                list.raw = list.raw.trimEnd();
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(let i = 0; i < list.items.length; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        const spacers = list.items[i].tokens.filter((t)=>t.type === "space");
                        const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>/\n.*\n/.test(t.raw));
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(let i = 0; i < list.items.length; i++)list.items[i].loose = true;
                return list;
            }
        }
        html(src) {
            const cap = this.rules.block.html.exec(src);
            if (cap) {
                const token = {
                    type: "html",
                    block: true,
                    raw: cap[0],
                    pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                    text: cap[0]
                };
                return token;
            }
        }
        def(src) {
            const cap = this.rules.block.def.exec(src);
            if (cap) {
                const tag = cap[1].toLowerCase().replace(/\s+/g, " ");
                const href = cap[2] ? cap[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
                const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
                return {
                    type: "def",
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        }
        table(src) {
            const cap = this.rules.block.table.exec(src);
            if (!cap) return;
            if (!/[:|]/.test(cap[2])) // delimiter row must have a pipe (|) or colon (:) otherwise it is a setext heading
            return;
            const headers = splitCells(cap[1]);
            const aligns = cap[2].replace(/^\||\| *$/g, "").split("|");
            const rows = cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, "").split("\n") : [];
            const item = {
                type: "table",
                raw: cap[0],
                header: [],
                align: [],
                rows: []
            };
            if (headers.length !== aligns.length) // header and align columns must be equal, rows can be different.
            return;
            for (const align of aligns){
                if (/^ *-+: *$/.test(align)) item.align.push("right");
                else if (/^ *:-+: *$/.test(align)) item.align.push("center");
                else if (/^ *:-+ *$/.test(align)) item.align.push("left");
                else item.align.push(null);
            }
            for (const header of headers)item.header.push({
                text: header,
                tokens: this.lexer.inline(header)
            });
            for (const row of rows)item.rows.push(splitCells(row, item.header.length).map((cell)=>{
                return {
                    text: cell,
                    tokens: this.lexer.inline(cell)
                };
            }));
            return item;
        }
        lheading(src) {
            const cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: "heading",
                raw: cap[0],
                depth: cap[2].charAt(0) === "=" ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        }
        paragraph(src) {
            const cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: "paragraph",
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        }
        text(src) {
            const cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        }
        escape(src) {
            const cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: "escape",
                raw: cap[0],
                text: escape$1(cap[1])
            };
        }
        tag(src) {
            const cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: "html",
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    block: false,
                    text: cap[0]
                };
            }
        }
        link(src) {
            const cap = this.rules.inline.link.exec(src);
            if (cap) {
                const trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    const rtrimSlash = rtrim(trimmedUrl.slice(0, -1), "\\");
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    const lastParenIndex = findClosingBracket(cap[2], "()");
                    if (lastParenIndex > -1) {
                        const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                        const linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = "";
                    }
                }
                let href = cap[2];
                let title = "";
                if (this.options.pedantic) {
                    // split pedantic href and title
                    const link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : "";
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                    title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
                }, cap[0], this.lexer);
            }
        }
        reflink(src, links) {
            let cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                const linkString = (cap[2] || cap[1]).replace(/\s+/g, " ");
                const link = links[linkString.toLowerCase()];
                if (!link) {
                    const text = cap[0].charAt(0);
                    return {
                        type: "text",
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        }
        emStrong(src, maskedSrc, prevChar = "") {
            let match = this.rules.inline.emStrongLDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/[\p{L}\p{N}]/u)) return;
            const nextChar = match[1] || match[2] || "";
            if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
                // unicode Regex counts emoji as 1 char; spread into array for proper count (used multiple times below)
                const lLength = [
                    ...match[0]
                ].length - 1;
                let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = [
                        ...rDelim
                    ].length;
                    if (match[3] || match[4]) {
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    // char length can be >1 for unicode characters;
                    const lastCharLength = [
                        ...match[0]
                    ][0].length;
                    const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        const text = raw.slice(1, -1);
                        return {
                            type: "em",
                            raw: raw,
                            text: text,
                            tokens: this.lexer.inlineTokens(text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    const text = raw.slice(2, -2);
                    return {
                        type: "strong",
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        }
        codespan(src) {
            const cap = this.rules.inline.code.exec(src);
            if (cap) {
                let text = cap[2].replace(/\n/g, " ");
                const hasNonSpaceChars = /[^ ]/.test(text);
                const hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape$1(text, true);
                return {
                    type: "codespan",
                    raw: cap[0],
                    text: text
                };
            }
        }
        br(src) {
            const cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: "br",
                raw: cap[0]
            };
        }
        del(src) {
            const cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: "del",
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        }
        autolink(src) {
            const cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                let text, href;
                if (cap[2] === "@") {
                    text = escape$1(cap[1]);
                    href = "mailto:" + text;
                } else {
                    text = escape$1(cap[1]);
                    href = text;
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        url(src) {
            let cap;
            if (cap = this.rules.inline.url.exec(src)) {
                let text, href;
                if (cap[2] === "@") {
                    text = escape$1(cap[0]);
                    href = "mailto:" + text;
                } else {
                    // do extended autolink path validation
                    let prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                    }while (prevCapZero !== cap[0]);
                    text = escape$1(cap[0]);
                    if (cap[1] === "www.") href = "http://" + cap[0];
                    else href = cap[0];
                }
                return {
                    type: "link",
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: "text",
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        }
        inlineText(src) {
            const cap = this.rules.inline.text.exec(src);
            if (cap) {
                let text;
                if (this.lexer.state.inRawBlock) text = cap[0];
                else text = escape$1(cap[0]);
                return {
                    type: "text",
                    raw: cap[0],
                    text: text
                };
            }
        }
    }
    /**
     * Block-Level Grammar
     */ const newline = /^(?: *(?:\n|$))+/;
    const blockCode = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/;
    const fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
    const hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
    const heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
    const bullet = /(?:[*+-]|\d{1,9}[.)])/;
    const lheading = edit(/^(?!bull )((?:.|\n(?!\s*?\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, bullet) // lists can interrupt
    .getRegex();
    const _paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
    const blockText = /^[^\n]+/;
    const _blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    const def = edit(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", _blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
    const list = edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, bullet).getRegex();
    const _tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    const _comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    const html = edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", _comment).replace("tag", _tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    const paragraph = edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
    .replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    const blockquote = edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", paragraph).getRegex();
    /**
     * Normal Block Grammar
     */ const blockNormal = {
        blockquote: blockquote,
        code: blockCode,
        def: def,
        fences: fences,
        heading: heading,
        hr: hr,
        html: html,
        lheading: lheading,
        list: list,
        newline: newline,
        paragraph: paragraph,
        table: noopTest,
        text: blockText
    };
    /**
     * GFM Block Grammar
     */ const gfmTable = edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)") // Cells
    .replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
    .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    const blockGfm = {
        ...blockNormal,
        table: gfmTable,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "") // setex headings don't interrupt commonmark paragraphs
        .replace("table", gfmTable) // interrupt paragraphs with table
        .replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ") // only lists starting from 1 can interrupt
        .replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _tag) // pars can be interrupted by type (6) html blocks
        .getRegex()
    };
    /**
     * Pedantic grammar (original John Gruber's loose markdown specification)
     */ const blockPedantic = {
        ...blockNormal,
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", _comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(_paragraph).replace("hr", hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    };
    /**
     * Inline-Level Grammar
     */ const escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
    const inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
    const br = /^( {2,}|\\)\n(?!\s*$)/;
    const inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
    // list of unicode punctuation marks, plus any missing characters from CommonMark spec
    const _punctuation = "\\p{P}$+<=>`^|~";
    const punctuation = edit(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, _punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    const blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
    const emStrongLDelim = edit(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, _punctuation).getRegex();
    const emStrongRDelimAst = edit("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu") // (6) a***a can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation).getRegex();
    // (6) Not allowed for _
    const emStrongRDelimUnd = edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu") // (5) #___# can be either Left or Right Delimiter
    .replace(/punct/g, _punctuation).getRegex();
    const anyPunctuation = edit(/\\([punct])/, "gu").replace(/punct/g, _punctuation).getRegex();
    const autolink = edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
    const _inlineComment = edit(_comment).replace("(?:-->|$)", "-->").getRegex();
    const tag = edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>") // CDATA section
    .replace("comment", _inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
    const _inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    const link = edit(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", _inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
    const reflink = edit(/^!?\[(label)\]\[(ref)\]/).replace("label", _inlineLabel).replace("ref", _blockLabel).getRegex();
    const nolink = edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", _blockLabel).getRegex();
    const reflinkSearch = edit("reflink|nolink(?!\\()", "g").replace("reflink", reflink).replace("nolink", nolink).getRegex();
    /**
     * Normal Inline Grammar
     */ const inlineNormal = {
        _backpedal: noopTest,
        anyPunctuation: anyPunctuation,
        autolink: autolink,
        blockSkip: blockSkip,
        br: br,
        code: inlineCode,
        del: noopTest,
        emStrongLDelim: emStrongLDelim,
        emStrongRDelimAst: emStrongRDelimAst,
        emStrongRDelimUnd: emStrongRDelimUnd,
        escape: escape,
        link: link,
        nolink: nolink,
        punctuation: punctuation,
        reflink: reflink,
        reflinkSearch: reflinkSearch,
        tag: tag,
        text: inlineText,
        url: noopTest
    };
    /**
     * Pedantic Inline Grammar
     */ const inlinePedantic = {
        ...inlineNormal,
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace("label", _inlineLabel).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", _inlineLabel).getRegex()
    };
    /**
     * GFM Inline Grammar
     */ const inlineGfm = {
        ...inlineNormal,
        escape: edit(escape).replace("])", "~|])").getRegex(),
        url: edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    };
    /**
     * GFM + Line Breaks Inline Grammar
     */ const inlineBreaks = {
        ...inlineGfm,
        br: edit(br).replace("{2,}", "*").getRegex(),
        text: edit(inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    };
    /**
     * exports
     */ const block = {
        normal: blockNormal,
        gfm: blockGfm,
        pedantic: blockPedantic
    };
    const inline = {
        normal: inlineNormal,
        gfm: inlineGfm,
        breaks: inlineBreaks,
        pedantic: inlinePedantic
    };
    /**
     * Block Lexer
     */ class _Lexer {
        tokens;
        options;
        state;
        tokenizer;
        inlineQueue;
        constructor(options){
            // TokenList cannot be created in one go
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new _Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            const rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
         * Expose Rules
         */ static get rules() {
            return {
                block: block,
                inline: inline
            };
        }
        /**
         * Static Lex Method
         */ static lex(src, options) {
            const lexer = new _Lexer(options);
            return lexer.lex(src);
        }
        /**
         * Static Lex Inline Method
         */ static lexInline(src, options) {
            const lexer = new _Lexer(options);
            return lexer.inlineTokens(src);
        }
        /**
         * Preprocessing
         */ lex(src) {
            src = src.replace(/\r\n|\r/g, "\n");
            this.blockTokens(src, this.tokens);
            let next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        }
        blockTokens(src, tokens = []) {
            if (this.options.pedantic) src = src.replace(/\t/g, "    ").replace(/^ +$/gm, "");
            else src = src.replace(/^( *)(\t+)/gm, (_, leading, tabs)=>{
                return leading + "    ".repeat(tabs.length);
            });
            let token;
            let lastToken;
            let cutSrc;
            let lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unnecessary paragraph tags
                    tokens[tokens.length - 1].raw += "\n";
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === "paragraph" || lastToken.type === "text")) {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startBlock.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === "paragraph") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += "\n" + token.raw;
                        lastToken.text += "\n" + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        }
        inline(src, tokens = []) {
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        }
        /**
         * Lexing/Compiling
         */ inlineTokens(src, tokens = []) {
            let token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            let maskedSrc = src;
            let match;
            let keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                const links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped characters
            while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            while(src){
                if (!keepPrevChar) prevChar = "";
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((extTokenizer)=>{
                    if (token = extTokenizer.call({
                        lexer: this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === "text" && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) {
                    let startIndex = Infinity;
                    const tempSrc = src.slice(1);
                    let tempStart;
                    this.options.extensions.startInline.forEach((getStartIndex)=>{
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                }
                if (token = this.tokenizer.inlineText(cutSrc)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === "text") {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        }
    }
    /**
     * Renderer
     */ class _Renderer {
        options;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        code(code, infostring, escaped) {
            const lang = (infostring || "").match(/^\S*/)?.[0];
            code = code.replace(/\n$/, "") + "\n";
            if (!lang) return "<pre><code>" + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
            return '<pre><code class="language-' + escape$1(lang) + '">' + (escaped ? code : escape$1(code, true)) + "</code></pre>\n";
        }
        blockquote(quote) {
            return `<blockquote>\n${quote}</blockquote>\n`;
        }
        html(html, block) {
            return html;
        }
        heading(text, level, raw) {
            // ignore IDs
            return `<h${level}>${text}</h${level}>\n`;
        }
        hr() {
            return "<hr>\n";
        }
        list(body, ordered, start) {
            const type = ordered ? "ol" : "ul";
            const startatt = ordered && start !== 1 ? ' start="' + start + '"' : "";
            return "<" + type + startatt + ">\n" + body + "</" + type + ">\n";
        }
        listitem(text, task, checked) {
            return `<li>${text}</li>\n`;
        }
        checkbox(checked) {
            return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
        }
        paragraph(text) {
            return `<p>${text}</p>\n`;
        }
        table(header, body) {
            if (body) body = `<tbody>${body}</tbody>`;
            return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
        }
        tablerow(content) {
            return `<tr>\n${content}</tr>\n`;
        }
        tablecell(content, flags) {
            const type = flags.header ? "th" : "td";
            const tag = flags.align ? `<${type} align="${flags.align}">` : `<${type}>`;
            return tag + content + `</${type}>\n`;
        }
        /**
         * span level renderer
         */ strong(text) {
            return `<strong>${text}</strong>`;
        }
        em(text) {
            return `<em>${text}</em>`;
        }
        codespan(text) {
            return `<code>${text}</code>`;
        }
        br() {
            return "<br>";
        }
        del(text) {
            return `<del>${text}</del>`;
        }
        link(href, title, text) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += ">" + text + "</a>";
            return out;
        }
        image(href, title, text) {
            const cleanHref = cleanUrl(href);
            if (cleanHref === null) return text;
            href = cleanHref;
            let out = `<img src="${href}" alt="${text}"`;
            if (title) out += ` title="${title}"`;
            out += ">";
            return out;
        }
        text(text) {
            return text;
        }
    }
    /**
     * TextRenderer
     * returns only the textual part of the token
     */ class _TextRenderer {
        // no need for block level renderers
        strong(text) {
            return text;
        }
        em(text) {
            return text;
        }
        codespan(text) {
            return text;
        }
        del(text) {
            return text;
        }
        html(text) {
            return text;
        }
        text(text) {
            return text;
        }
        link(href, title, text) {
            return "" + text;
        }
        image(href, title, text) {
            return "" + text;
        }
        br() {
            return "";
        }
    }
    /**
     * Parsing & Compiling
     */ class _Parser {
        options;
        renderer;
        textRenderer;
        constructor(options){
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new _Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new _TextRenderer();
        }
        /**
         * Static Parse Method
         */ static parse(tokens, options) {
            const parser = new _Parser(options);
            return parser.parse(tokens);
        }
        /**
         * Static Parse Inline Method
         */ static parseInline(tokens, options) {
            const parser = new _Parser(options);
            return parser.parseInline(tokens);
        }
        /**
         * Parse Loop
         */ parse(tokens, top = true) {
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    const genericToken = token;
                    const ret = this.options.extensions.renderers[genericToken.type].call({
                        parser: this
                    }, genericToken);
                    if (ret !== false || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "paragraph",
                        "text"
                    ].includes(genericToken.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "space":
                        continue;
                    case "hr":
                        out += this.renderer.hr();
                        continue;
                    case "heading":
                        {
                            const headingToken = token;
                            out += this.renderer.heading(this.parseInline(headingToken.tokens), headingToken.depth, unescape(this.parseInline(headingToken.tokens, this.textRenderer)));
                            continue;
                        }
                    case "code":
                        {
                            const codeToken = token;
                            out += this.renderer.code(codeToken.text, codeToken.lang, !!codeToken.escaped);
                            continue;
                        }
                    case "table":
                        {
                            const tableToken = token;
                            let header = "";
                            // header
                            let cell = "";
                            for(let j = 0; j < tableToken.header.length; j++)cell += this.renderer.tablecell(this.parseInline(tableToken.header[j].tokens), {
                                header: true,
                                align: tableToken.align[j]
                            });
                            header += this.renderer.tablerow(cell);
                            let body = "";
                            for(let j = 0; j < tableToken.rows.length; j++){
                                const row = tableToken.rows[j];
                                cell = "";
                                for(let k = 0; k < row.length; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                    header: false,
                                    align: tableToken.align[k]
                                });
                                body += this.renderer.tablerow(cell);
                            }
                            out += this.renderer.table(header, body);
                            continue;
                        }
                    case "blockquote":
                        {
                            const blockquoteToken = token;
                            const body = this.parse(blockquoteToken.tokens);
                            out += this.renderer.blockquote(body);
                            continue;
                        }
                    case "list":
                        {
                            const listToken = token;
                            const ordered = listToken.ordered;
                            const start = listToken.start;
                            const loose = listToken.loose;
                            let body = "";
                            for(let j = 0; j < listToken.items.length; j++){
                                const item = listToken.items[j];
                                const checked = item.checked;
                                const task = item.task;
                                let itemBody = "";
                                if (item.task) {
                                    const checkbox = this.renderer.checkbox(!!checked);
                                    if (loose) {
                                        if (item.tokens.length > 0 && item.tokens[0].type === "paragraph") {
                                            item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                                            if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") item.tokens[0].tokens[0].text = checkbox + " " + item.tokens[0].tokens[0].text;
                                        } else item.tokens.unshift({
                                            type: "text",
                                            text: checkbox + " "
                                        });
                                    } else itemBody += checkbox + " ";
                                }
                                itemBody += this.parse(item.tokens, loose);
                                body += this.renderer.listitem(itemBody, task, !!checked);
                            }
                            out += this.renderer.list(body, ordered, start);
                            continue;
                        }
                    case "html":
                        {
                            const htmlToken = token;
                            out += this.renderer.html(htmlToken.text, htmlToken.block);
                            continue;
                        }
                    case "paragraph":
                        {
                            const paragraphToken = token;
                            out += this.renderer.paragraph(this.parseInline(paragraphToken.tokens));
                            continue;
                        }
                    case "text":
                        {
                            let textToken = token;
                            let body = textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text;
                            while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                                textToken = tokens[++i];
                                body += "\n" + (textToken.tokens ? this.parseInline(textToken.tokens) : textToken.text);
                            }
                            out += top ? this.renderer.paragraph(body) : body;
                            continue;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
        /**
         * Parse Inline Tokens
         */ parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            let out = "";
            for(let i = 0; i < tokens.length; i++){
                const token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    const ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(token.type)) {
                        out += ret || "";
                        continue;
                    }
                }
                switch(token.type){
                    case "escape":
                        {
                            const escapeToken = token;
                            out += renderer.text(escapeToken.text);
                            break;
                        }
                    case "html":
                        {
                            const tagToken = token;
                            out += renderer.html(tagToken.text);
                            break;
                        }
                    case "link":
                        {
                            const linkToken = token;
                            out += renderer.link(linkToken.href, linkToken.title, this.parseInline(linkToken.tokens, renderer));
                            break;
                        }
                    case "image":
                        {
                            const imageToken = token;
                            out += renderer.image(imageToken.href, imageToken.title, imageToken.text);
                            break;
                        }
                    case "strong":
                        {
                            const strongToken = token;
                            out += renderer.strong(this.parseInline(strongToken.tokens, renderer));
                            break;
                        }
                    case "em":
                        {
                            const emToken = token;
                            out += renderer.em(this.parseInline(emToken.tokens, renderer));
                            break;
                        }
                    case "codespan":
                        {
                            const codespanToken = token;
                            out += renderer.codespan(codespanToken.text);
                            break;
                        }
                    case "br":
                        out += renderer.br();
                        break;
                    case "del":
                        {
                            const delToken = token;
                            out += renderer.del(this.parseInline(delToken.tokens, renderer));
                            break;
                        }
                    case "text":
                        {
                            const textToken = token;
                            out += renderer.text(textToken.text);
                            break;
                        }
                    default:
                        {
                            const errMsg = 'Token with "' + token.type + '" type was not found.';
                            if (this.options.silent) {
                                console.error(errMsg);
                                return "";
                            } else throw new Error(errMsg);
                        }
                }
            }
            return out;
        }
    }
    class _Hooks {
        options;
        constructor(options){
            this.options = options || exports1.defaults;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess"
        ]);
        /**
         * Process markdown before marked
         */ preprocess(markdown) {
            return markdown;
        }
        /**
         * Process HTML after marked is finished
         */ postprocess(html) {
            return html;
        }
    }
    class Marked {
        defaults = _getDefaults();
        options = this.setOptions;
        parse = this.#parseMarkdown(_Lexer.lex, _Parser.parse);
        parseInline = this.#parseMarkdown(_Lexer.lexInline, _Parser.parseInline);
        Parser = _Parser;
        Renderer = _Renderer;
        TextRenderer = _TextRenderer;
        Lexer = _Lexer;
        Tokenizer = _Tokenizer;
        Hooks = _Hooks;
        constructor(...args){
            this.use(...args);
        }
        /**
         * Run callback for every token
         */ walkTokens(tokens, callback) {
            let values = [];
            for (const token of tokens){
                values = values.concat(callback.call(this, token));
                switch(token.type){
                    case "table":
                        {
                            const tableToken = token;
                            for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                            for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                            break;
                        }
                    case "list":
                        {
                            const listToken = token;
                            values = values.concat(this.walkTokens(listToken.items, callback));
                            break;
                        }
                    default:
                        {
                            const genericToken = token;
                            if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                                values = values.concat(this.walkTokens(genericToken[childTokens], callback));
                            });
                            else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                        }
                }
            }
            return values;
        }
        use(...args) {
            const extensions = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            args.forEach((pack)=>{
                // copy options to new object
                const opts = {
                    ...pack
                };
                // set async to true if it was set to true before
                opts.async = this.defaults.async || opts.async || false;
                // ==-- Parse "addon" extensions --== //
                if (pack.extensions) {
                    pack.extensions.forEach((ext)=>{
                        if (!ext.name) throw new Error("extension name required");
                        if ("renderer" in ext) {
                            const prevRenderer = extensions.renderers[ext.name];
                            if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                            extensions.renderers[ext.name] = function(...args) {
                                let ret = ext.renderer.apply(this, args);
                                if (ret === false) ret = prevRenderer.apply(this, args);
                                return ret;
                            };
                            else extensions.renderers[ext.name] = ext.renderer;
                        }
                        if ("tokenizer" in ext) {
                            if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                            const extLevel = extensions[ext.level];
                            if (extLevel) extLevel.unshift(ext.tokenizer);
                            else extensions[ext.level] = [
                                ext.tokenizer
                            ];
                            if (ext.start) {
                                if (ext.level === "block") {
                                    if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                    else extensions.startBlock = [
                                        ext.start
                                    ];
                                } else if (ext.level === "inline") {
                                    if (extensions.startInline) extensions.startInline.push(ext.start);
                                    else extensions.startInline = [
                                        ext.start
                                    ];
                                }
                            }
                        }
                        if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                    });
                    opts.extensions = extensions;
                }
                // ==-- Parse "overwrite" extensions --== //
                if (pack.renderer) {
                    const renderer = this.defaults.renderer || new _Renderer(this.defaults);
                    for(const prop in pack.renderer){
                        if (!(prop in renderer) || prop === "options") throw new Error(`renderer '${prop}' does not exist`);
                        const rendererProp = prop;
                        const rendererFunc = pack.renderer[rendererProp];
                        const prevRenderer = renderer[rendererProp];
                        // Replace renderer with func to run extension, but fall back if false
                        renderer[rendererProp] = (...args)=>{
                            let ret = rendererFunc.apply(renderer, args);
                            if (ret === false) ret = prevRenderer.apply(renderer, args);
                            return ret || "";
                        };
                    }
                    opts.renderer = renderer;
                }
                if (pack.tokenizer) {
                    const tokenizer = this.defaults.tokenizer || new _Tokenizer(this.defaults);
                    for(const prop in pack.tokenizer){
                        if (!(prop in tokenizer) || [
                            "options",
                            "rules",
                            "lexer"
                        ].includes(prop)) throw new Error(`tokenizer '${prop}' does not exist`);
                        const tokenizerProp = prop;
                        const tokenizerFunc = pack.tokenizer[tokenizerProp];
                        const prevTokenizer = tokenizer[tokenizerProp];
                        // Replace tokenizer with func to run extension, but fall back if false
                        // @ts-expect-error cannot type tokenizer function dynamically
                        tokenizer[tokenizerProp] = (...args)=>{
                            let ret = tokenizerFunc.apply(tokenizer, args);
                            if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                            return ret;
                        };
                    }
                    opts.tokenizer = tokenizer;
                }
                // ==-- Parse Hooks extensions --== //
                if (pack.hooks) {
                    const hooks = this.defaults.hooks || new _Hooks();
                    for(const prop in pack.hooks){
                        if (!(prop in hooks) || prop === "options") throw new Error(`hook '${prop}' does not exist`);
                        const hooksProp = prop;
                        const hooksFunc = pack.hooks[hooksProp];
                        const prevHook = hooks[hooksProp];
                        if (_Hooks.passThroughHooks.has(prop)) hooks[hooksProp] = (arg)=>{
                            if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret)=>{
                                return prevHook.call(hooks, ret);
                            });
                            const ret = hooksFunc.call(hooks, arg);
                            return prevHook.call(hooks, ret);
                        };
                        else hooks[hooksProp] = (...args)=>{
                            let ret = hooksFunc.apply(hooks, args);
                            if (ret === false) ret = prevHook.apply(hooks, args);
                            return ret;
                        };
                    }
                    opts.hooks = hooks;
                }
                // ==-- Parse WalkTokens extensions --== //
                if (pack.walkTokens) {
                    const walkTokens = this.defaults.walkTokens;
                    const packWalktokens = pack.walkTokens;
                    opts.walkTokens = function(token) {
                        let values = [];
                        values.push(packWalktokens.call(this, token));
                        if (walkTokens) values = values.concat(walkTokens.call(this, token));
                        return values;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...opts
                };
            });
            return this;
        }
        setOptions(opt) {
            this.defaults = {
                ...this.defaults,
                ...opt
            };
            return this;
        }
        lexer(src, options) {
            return _Lexer.lex(src, options ?? this.defaults);
        }
        parser(tokens, options) {
            return _Parser.parse(tokens, options ?? this.defaults);
        }
        #parseMarkdown(lexer, parser) {
            return (src, options)=>{
                const origOpt = {
                    ...options
                };
                const opt = {
                    ...this.defaults,
                    ...origOpt
                };
                // Show warning if an extension set async to true but the parse was called with async: false
                if (this.defaults.async === true && origOpt.async === false) {
                    if (!opt.silent) console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored.");
                    opt.async = true;
                }
                const throwError = this.#onError(!!opt.silent, !!opt.async);
                // throw error in case of non string input
                if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
                if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
                if (opt.hooks) opt.hooks.options = opt;
                if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src)=>lexer(src, opt)).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser(tokens, opt)).then((html)=>opt.hooks ? opt.hooks.postprocess(html) : html).catch(throwError);
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    const tokens = lexer(src, opt);
                    if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                    let html = parser(tokens, opt);
                    if (opt.hooks) html = opt.hooks.postprocess(html);
                    return html;
                } catch (e) {
                    return throwError(e);
                }
            };
        }
        #onError(silent, async) {
            return (e)=>{
                e.message += "\nPlease report this to https://github.com/markedjs/marked.";
                if (silent) {
                    const msg = "<p>An error occurred:</p><pre>" + escape$1(e.message + "", true) + "</pre>";
                    if (async) return Promise.resolve(msg);
                    return msg;
                }
                if (async) return Promise.reject(e);
                throw e;
            };
        }
    }
    const markedInstance = new Marked();
    function marked(src, opt) {
        return markedInstance.parse(src, opt);
    }
    /**
     * Sets the default options.
     *
     * @param options Hash of options
     */ marked.options = marked.setOptions = function(options) {
        markedInstance.setOptions(options);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Gets the original marked default options.
     */ marked.getDefaults = _getDefaults;
    marked.defaults = exports1.defaults;
    /**
     * Use Extension
     */ marked.use = function(...args) {
        markedInstance.use(...args);
        marked.defaults = markedInstance.defaults;
        changeDefaults(marked.defaults);
        return marked;
    };
    /**
     * Run callback for every token
     */ marked.walkTokens = function(tokens, callback) {
        return markedInstance.walkTokens(tokens, callback);
    };
    /**
     * Compiles markdown to HTML without enclosing `p` tag.
     *
     * @param src String of markdown source to be compiled
     * @param options Hash of options
     * @return String of compiled HTML
     */ marked.parseInline = markedInstance.parseInline;
    /**
     * Expose
     */ marked.Parser = _Parser;
    marked.parser = _Parser.parse;
    marked.Renderer = _Renderer;
    marked.TextRenderer = _TextRenderer;
    marked.Lexer = _Lexer;
    marked.lexer = _Lexer.lex;
    marked.Tokenizer = _Tokenizer;
    marked.Hooks = _Hooks;
    marked.parse = marked;
    const options = marked.options;
    const setOptions = marked.setOptions;
    const use = marked.use;
    const walkTokens = marked.walkTokens;
    const parseInline = marked.parseInline;
    const parse = marked;
    const parser = _Parser.parse;
    const lexer = _Lexer.lex;
    exports1.Hooks = _Hooks;
    exports1.Lexer = _Lexer;
    exports1.Marked = Marked;
    exports1.Parser = _Parser;
    exports1.Renderer = _Renderer;
    exports1.TextRenderer = _TextRenderer;
    exports1.Tokenizer = _Tokenizer;
    exports1.getDefaults = _getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});


function $de1cf2e99b0bbaa2$export$fd15eb57367a61d4({ website: website, key: key, compactView: compactView } = {}) {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [searchQuery, setSearchQuery] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $79a6aa2f003c21d2$export$36a381671975116c));
    const [showFullHeadline, setShowFullHeadline] = (0, $exYeM.useState)(false);
    const [headline, setHeadline] = (0, $exYeM.useState)(null);
    const externalUrlAttr = (0, $eab5b28e57d35300$export$c24ed0104d07eab9)(()=>{
        addUrlToSearchQuery(website.url || website.scrape_url);
    });
    const [currentUser] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const [colorIndex, setColorIndex] = (0, $exYeM.useState)(website?.url ? parseInt((0, $cd9834982deadcf1$exports.md5)(website.url).slice(0, 1), 16) % 5 : 0);
    function withoutWWW(url) {
        return url?.replace(/^http[s]*\:\/\/(www\.)*/, "");
    }
    function justDomain(url) {
        return withoutWWW(url)?.replace(/\/.+?$/, "");
    }
    function visitArticle() {
        navigate("/websites/" + website.share_url);
    }
    function handleTagClick(tag1, append = false) {
        let query = `tag:${tag1}`;
        if (append && !searchQuery?.includes(`tag:${tag1}`)) query = `${searchQuery || ""} ${query}`.trim();
        else query = query === searchQuery ? "" : query;
        let params = new URLSearchParams({
            q: query
        });
        navigate(location.pathname + "?" + params.toString(), {
            replace: true
        });
    }
    function addUrlToSearchQuery(url, append = false) {
        url = url.replace(/^http[s]*\:\/\/(www\.)*/, "");
        url = new URL("https://" + url).hostname;
        let query = `site:${url}`;
        if (append && !searchQuery?.includes(`site:${tag}`)) query = `${searchQuery || ""} ${query}`.trim();
        else query = query === searchQuery ? "" : query;
        let params = new URLSearchParams({
            q: query
        });
        navigate(location.pathname + "?" + params.toString(), {
            replace: true
        });
    }
    (0, $exYeM.useEffect)(()=>{
        if (!website) return;
        setHeadline(website.translated.display_title || website.title || "");
    }, [
        website
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "article-preview",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "published-on",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "published-date",
                        children: (0, $1d6b0918345aa2c5$export$af204b270ccca492)(website.published_on || website.scraped_at, currentUser.language || website.display_lang, website.scraped_at)
                    }),
                    website && website.process_status !== "finished" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "processing-status",
                        "data-process-status": website.process_status,
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)(`${website.process_status}`)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: [
                    "headline",
                    compactView || showFullHeadline ? "full-headline" : ""
                ].join(" "),
                onClick: ()=>{
                    return visitArticle();
                },
                children: headline ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                            className: "text-masked",
                            "data-gradient": colorIndex,
                            children: (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parseInline(headline))
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "h2 short-headline text-masked",
                            "data-gradient": colorIndex,
                            children: (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parseInline((0, $1d6b0918345aa2c5$export$decc2eeea1f0f170)(headline)))
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                            className: "text-masked",
                            "data-gradient": colorIndex,
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Title could not be detected")
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "h2 short-headline text-masked",
                            "data-gradient": colorIndex,
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Title could not be detected")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "article-tags",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("ul", {
                    children: [
                        website.major_categories?.map((tag1)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                className: "main",
                                onClick: ()=>handleTagClick(tag1),
                                children: tag1
                            }, "tag-" + tag1 + website.id)),
                        website.non_major_categories?.slice(0, 12)?.map((tag1)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                onClick: ()=>handleTagClick(tag1),
                                children: tag1
                            }, "tag-" + tag1 + website.id))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "image",
                children: website.image_url ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5815ed0933d43094$exports.LazyLoadImage), {
                    src: website.image_url,
                    alt: website.translated.display_title || website.title
                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "placeholder"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "summary",
                onClick: (ev)=>{
                    return visitArticle();
                },
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                    children: (website.summary || website.custom_summary) && (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parseInline(website.custom_summary || website.translated.summary || website.summary || website.translated.detailed_summary || website.detailed_summary || ""))
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "core-data",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("a", {
                    ...externalUrlAttr,
                    className: "source",
                    onClick: (ev)=>{
                        ev.preventDefault();
                        window.open(website.url || website.scrape_url, "_blank").focus();
                    },
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                            className: "without-www",
                            children: withoutWWW(website.url || website.scrape_url)
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                            className: "just-domain",
                            children: justDomain(website.url || website.scrape_url)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "call2action",
                onClick: ()=>visitArticle(),
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("a", {
                    href: `/websites/${website.share_url}`,
                    className: "text-masked",
                    "data-gradient": colorIndex,
                    children: [
                        (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Read more"),
                        " \xa0→"
                    ]
                })
            })
        ]
    }, key ? key : "article-preview-" + website.id);
}




var $exYeM = parcelRequire("exYeM");


var $f4ea6fc35b8f94b3$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $f4ea6fc35b8f94b3$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $f4ea6fc35b8f94b3$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $f4ea6fc35b8f94b3$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $f4ea6fc35b8f94b3$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f4ea6fc35b8f94b3$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f4ea6fc35b8f94b3$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f4ea6fc35b8f94b3$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f4ea6fc35b8f94b3$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $f4ea6fc35b8f94b3$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $f4ea6fc35b8f94b3$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $f4ea6fc35b8f94b3$var$root = $f4ea6fc35b8f94b3$var$freeGlobal || $f4ea6fc35b8f94b3$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $f4ea6fc35b8f94b3$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f4ea6fc35b8f94b3$var$objectToString = $f4ea6fc35b8f94b3$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f4ea6fc35b8f94b3$var$nativeMax = Math.max, $f4ea6fc35b8f94b3$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f4ea6fc35b8f94b3$var$now = function() {
    return $f4ea6fc35b8f94b3$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $f4ea6fc35b8f94b3$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($f4ea6fc35b8f94b3$var$FUNC_ERROR_TEXT);
    wait = $f4ea6fc35b8f94b3$var$toNumber(wait) || 0;
    if ($f4ea6fc35b8f94b3$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $f4ea6fc35b8f94b3$var$nativeMax($f4ea6fc35b8f94b3$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $f4ea6fc35b8f94b3$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f4ea6fc35b8f94b3$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f4ea6fc35b8f94b3$var$now());
    }
    function debounced() {
        var time = $f4ea6fc35b8f94b3$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f4ea6fc35b8f94b3$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f4ea6fc35b8f94b3$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f4ea6fc35b8f94b3$var$isSymbol(value) {
    return typeof value == "symbol" || $f4ea6fc35b8f94b3$var$isObjectLike(value) && $f4ea6fc35b8f94b3$var$objectToString.call(value) == $f4ea6fc35b8f94b3$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f4ea6fc35b8f94b3$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($f4ea6fc35b8f94b3$var$isSymbol(value)) return $f4ea6fc35b8f94b3$var$NAN;
    if ($f4ea6fc35b8f94b3$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $f4ea6fc35b8f94b3$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($f4ea6fc35b8f94b3$var$reTrim, "");
    var isBinary = $f4ea6fc35b8f94b3$var$reIsBinary.test(value);
    return isBinary || $f4ea6fc35b8f94b3$var$reIsOctal.test(value) ? $f4ea6fc35b8f94b3$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f4ea6fc35b8f94b3$var$reIsBadHex.test(value) ? $f4ea6fc35b8f94b3$var$NAN : +value;
}
$f4ea6fc35b8f94b3$exports = $f4ea6fc35b8f94b3$var$debounce;





var $exYeM = parcelRequire("exYeM");
function $1dd14dcebd7f3a06$var$useBoolean(defaultValue) {
    const [value, setValue] = (0, $exYeM.useState)(!!defaultValue);
    const setTrue = (0, $exYeM.useCallback)(()=>setValue(true), []);
    const setFalse = (0, $exYeM.useCallback)(()=>setValue(false), []);
    const toggle = (0, $exYeM.useCallback)(()=>setValue((x)=>!x), []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $1dd14dcebd7f3a06$export$2e2bcd8739ae039 = $1dd14dcebd7f3a06$var$useBoolean;



function $b4bf4b200bb08ec5$var$useClickAnyWhere(handler) {
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("click", (event)=>{
        handler(event);
    });
}
var $b4bf4b200bb08ec5$export$2e2bcd8739ae039 = $b4bf4b200bb08ec5$var$useClickAnyWhere;


var $4c8f45c8333869cd$exports = {};

var $exYeM = parcelRequire("exYeM");
var $4c8f45c8333869cd$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $4c8f45c8333869cd$var$useCopyToClipboard() {
    const [copiedText, setCopiedText] = (0, $exYeM.useState)(null);
    const copy = (text)=>$4c8f45c8333869cd$var$__awaiter(this, void 0, void 0, function*() {
            if (!(navigator === null || navigator === void 0 ? void 0 : navigator.clipboard)) {
                console.warn("Clipboard not supported");
                return false;
            }
            try {
                yield navigator.clipboard.writeText(text);
                setCopiedText(text);
                return true;
            } catch (error) {
                console.warn("Copy failed", error);
                setCopiedText(null);
                return false;
            }
        });
    return [
        copiedText,
        copy
    ];
}
var $4c8f45c8333869cd$export$2e2bcd8739ae039 = $4c8f45c8333869cd$var$useCopyToClipboard;



var $exYeM = parcelRequire("exYeM");

function $4208d23ecfcec9a2$var$useCountdown(countdownOption) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ("seconds" in countdownOption) {
        console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.");
        isDeprecated = true;
        countStart = countdownOption.seconds;
        intervalMs = countdownOption.interval;
        isIncrement = countdownOption.isIncrement;
    } else ({ countStart: countStart, intervalMs: intervalMs, isIncrement: isIncrement, countStop: countStop } = countdownOption);
    intervalMs = intervalMs !== null && intervalMs !== void 0 ? intervalMs : 1000;
    isIncrement = isIncrement !== null && isIncrement !== void 0 ? isIncrement : false;
    countStop = countStop !== null && countStop !== void 0 ? countStop : 0;
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = (0, $9bb52f3b0e427b08$export$2e2bcd8739ae039)(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = (0, $1dd14dcebd7f3a06$export$2e2bcd8739ae039)(false);
    const resetCountdown = ()=>{
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0, $exYeM.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    (0, $ee2c4bf02ed37f72$export$2e2bcd8739ae039)(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated ? [
        count,
        {
            start: startCountdown,
            stop: stopCountdown,
            reset: resetCountdown
        }
    ] : [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
var $4208d23ecfcec9a2$export$2e2bcd8739ae039 = $4208d23ecfcec9a2$var$useCountdown;



var $exYeM = parcelRequire("exYeM");
function $9bb52f3b0e427b08$var$useCounter(initialValue) {
    const [count, setCount] = (0, $exYeM.useState)(initialValue || 0);
    const increment = ()=>setCount((x)=>x + 1);
    const decrement = ()=>setCount((x)=>x - 1);
    const reset = ()=>setCount(initialValue || 0);
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
var $9bb52f3b0e427b08$export$2e2bcd8739ae039 = $9bb52f3b0e427b08$var$useCounter;



const $9a5a5642340b2403$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
function $9a5a5642340b2403$var$useDarkMode(defaultValue) {
    var _a;
    const isDarkOS = (0, $e36eb2e233dd4d52$export$2e2bcd8739ae039)($9a5a5642340b2403$var$COLOR_SCHEME_QUERY);
    const [isDarkMode, setDarkMode] = (0, $fc47a0278df6b5e1$export$2e2bcd8739ae039)("usehooks-ts-dark-mode", (_a = defaultValue !== null && defaultValue !== void 0 ? defaultValue : isDarkOS) !== null && _a !== void 0 ? _a : false);
    (0, $ca0788c81918dd7f$export$2e2bcd8739ae039)(()=>{
        setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>setDarkMode((prev)=>!prev),
        enable: ()=>setDarkMode(true),
        disable: ()=>setDarkMode(false)
    };
}
var $9a5a5642340b2403$export$2e2bcd8739ae039 = $9a5a5642340b2403$var$useDarkMode;



var $exYeM = parcelRequire("exYeM");
function $05072e0982e27de5$var$useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $exYeM.useState)(value);
    (0, $exYeM.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay || 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
var $05072e0982e27de5$export$2e2bcd8739ae039 = $05072e0982e27de5$var$useDebounce;



function $7c54a22fe5056114$var$useDocumentTitle(title) {
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        window.document.title = title;
    }, [
        title
    ]);
}
var $7c54a22fe5056114$export$2e2bcd8739ae039 = $7c54a22fe5056114$var$useDocumentTitle;



var $exYeM = parcelRequire("exYeM");
function $afdd9a677e885c60$var$useEffectOnce(effect) {
    (0, $exYeM.useEffect)(effect, []);
}
var $afdd9a677e885c60$export$2e2bcd8739ae039 = $afdd9a677e885c60$var$useEffectOnce;



var $exYeM = parcelRequire("exYeM");

function $630eb6ad4ce953b3$var$useElementSize() {
    const [ref, setRef] = (0, $exYeM.useState)(null);
    const [size, setSize] = (0, $exYeM.useState)({
        width: 0,
        height: 0
    });
    const handleSize = (0, $exYeM.useCallback)(()=>{
        setSize({
            width: (ref === null || ref === void 0 ? void 0 : ref.offsetWidth) || 0,
            height: (ref === null || ref === void 0 ? void 0 : ref.offsetHeight) || 0
        });
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("resize", handleSize);
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        handleSize();
    }, [
        ref === null || ref === void 0 ? void 0 : ref.offsetHeight,
        ref === null || ref === void 0 ? void 0 : ref.offsetWidth
    ]);
    return [
        setRef,
        size
    ];
}
var $630eb6ad4ce953b3$export$2e2bcd8739ae039 = $630eb6ad4ce953b3$var$useElementSize;



var $exYeM = parcelRequire("exYeM");

function $d6ec6a2a3d01340a$export$2e2bcd8739ae039(fn) {
    const ref = (0, $exYeM.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $exYeM.useCallback)((...args)=>ref.current(...args), [
        ref
    ]);
}



var $exYeM = parcelRequire("exYeM");

function $843b1a40c9fe37a4$var$useEventListener(eventName, handler, element, options) {
    const savedHandler = (0, $exYeM.useRef)(handler);
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $exYeM.useEffect)(()=>{
        var _a;
        const targetElement = (_a = element === null || element === void 0 ? void 0 : element.current) !== null && _a !== void 0 ? _a : window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>savedHandler.current(event);
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
var $843b1a40c9fe37a4$export$2e2bcd8739ae039 = $843b1a40c9fe37a4$var$useEventListener;


var $4f59506d7c9b1c4f$exports = {};

var $exYeM = parcelRequire("exYeM");
var $4f59506d7c9b1c4f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $4f59506d7c9b1c4f$var$useFetch(url, options) {
    const cache = (0, $exYeM.useRef)({});
    const cancelRequest = (0, $exYeM.useRef)(false);
    const initialState = {
        error: undefined,
        data: undefined
    };
    const fetchReducer = (state, action)=>{
        switch(action.type){
            case "loading":
                return Object.assign({}, initialState);
            case "fetched":
                return Object.assign(Object.assign({}, initialState), {
                    data: action.payload
                });
            case "error":
                return Object.assign(Object.assign({}, initialState), {
                    error: action.payload
                });
            default:
                return state;
        }
    };
    const [state, dispatch] = (0, $exYeM.useReducer)(fetchReducer, initialState);
    (0, $exYeM.useEffect)(()=>{
        if (!url) return;
        cancelRequest.current = false;
        const fetchData = ()=>$4f59506d7c9b1c4f$var$__awaiter(this, void 0, void 0, function*() {
                dispatch({
                    type: "loading"
                });
                if (cache.current[url]) {
                    dispatch({
                        type: "fetched",
                        payload: cache.current[url]
                    });
                    return;
                }
                try {
                    const response = yield fetch(url, options);
                    if (!response.ok) throw new Error(response.statusText);
                    const data = yield response.json();
                    cache.current[url] = data;
                    if (cancelRequest.current) return;
                    dispatch({
                        type: "fetched",
                        payload: data
                    });
                } catch (error) {
                    if (cancelRequest.current) return;
                    dispatch({
                        type: "error",
                        payload: error
                    });
                }
            });
        fetchData();
        return ()=>{
            cancelRequest.current = true;
        };
    }, [
        url
    ]);
    return state;
}
var $4f59506d7c9b1c4f$export$2e2bcd8739ae039 = $4f59506d7c9b1c4f$var$useFetch;



var $exYeM = parcelRequire("exYeM");

function $3aa32e99ca4bd73c$var$useHover(elementRef) {
    const [value, setValue] = (0, $exYeM.useState)(false);
    const handleMouseEnter = ()=>setValue(true);
    const handleMouseLeave = ()=>setValue(false);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("mouseenter", handleMouseEnter, elementRef);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("mouseleave", handleMouseLeave, elementRef);
    return value;
}
var $3aa32e99ca4bd73c$export$2e2bcd8739ae039 = $3aa32e99ca4bd73c$var$useHover;



var $exYeM = parcelRequire("exYeM");
function $ead060ad60033c09$var$useImageOnLoad() {
    const [isLoaded, setIsLoaded] = (0, $exYeM.useState)(false);
    const handleImageOnLoad = ()=>{
        setIsLoaded(true);
    };
    const css = {
        thumbnail: {
            visibility: isLoaded ? "hidden" : "visible",
            filter: "blur(8px)",
            transition: "visibility 0ms ease-out 500ms"
        },
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 500ms ease-in 0ms"
        }
    };
    return {
        handleImageOnLoad: handleImageOnLoad,
        css: css
    };
}
var $ead060ad60033c09$export$2e2bcd8739ae039 = $ead060ad60033c09$var$useImageOnLoad;



var $exYeM = parcelRequire("exYeM");
function $b37333cd110b48fe$var$useIntersectionObserver(elementRef, { threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false }) {
    const [entry, setEntry] = (0, $exYeM.useState)();
    const frozen = (entry === null || entry === void 0 ? void 0 : entry.isIntersecting) && freezeOnceVisible;
    const updateEntry = ([entry])=>{
        setEntry(entry);
    };
    (0, $exYeM.useEffect)(()=>{
        const node = elementRef === null || elementRef === void 0 ? void 0 : elementRef.current;
        const hasIOSupport = !!window.IntersectionObserver;
        if (!hasIOSupport || frozen || !node) return;
        const observerParams = {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        };
        const observer = new IntersectionObserver(updateEntry, observerParams);
        observer.observe(node);
        return ()=>observer.disconnect();
    }, [
        elementRef === null || elementRef === void 0 ? void 0 : elementRef.current,
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen
    ]);
    return entry;
}
var $b37333cd110b48fe$export$2e2bcd8739ae039 = $b37333cd110b48fe$var$useIntersectionObserver;



var $exYeM = parcelRequire("exYeM");

function $ee2c4bf02ed37f72$var$useInterval(callback, delay) {
    const savedCallback = (0, $exYeM.useRef)(callback);
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setInterval(()=>savedCallback.current(), delay);
        return ()=>clearInterval(id);
    }, [
        delay
    ]);
}
var $ee2c4bf02ed37f72$export$2e2bcd8739ae039 = $ee2c4bf02ed37f72$var$useInterval;



var $exYeM = parcelRequire("exYeM");
function $699a8c717e7a28c7$var$useIsClient() {
    const [isClient, setClient] = (0, $exYeM.useState)(false);
    (0, $exYeM.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
var $699a8c717e7a28c7$export$2e2bcd8739ae039 = $699a8c717e7a28c7$var$useIsClient;



var $exYeM = parcelRequire("exYeM");
function $6800db55d72f6f50$var$useIsFirstRender() {
    const isFirst = (0, $exYeM.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
var $6800db55d72f6f50$export$2e2bcd8739ae039 = $6800db55d72f6f50$var$useIsFirstRender;



var $exYeM = parcelRequire("exYeM");
function $7953597875fa3e83$var$useIsMounted() {
    const isMounted = (0, $exYeM.useRef)(false);
    (0, $exYeM.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $exYeM.useCallback)(()=>isMounted.current, []);
}
var $7953597875fa3e83$export$2e2bcd8739ae039 = $7953597875fa3e83$var$useIsMounted;



var $exYeM = parcelRequire("exYeM");
const $af63c2fcac4ad893$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect);
var $af63c2fcac4ad893$export$2e2bcd8739ae039 = $af63c2fcac4ad893$var$useIsomorphicLayoutEffect;



var $exYeM = parcelRequire("exYeM");

function $fc47a0278df6b5e1$var$useLocalStorage(key, initialValue) {
    const readValue = (0, $exYeM.useCallback)(()=>{
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.localStorage.getItem(key);
            return item ? $fc47a0278df6b5e1$var$parseJSON(item) : initialValue;
        } catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [
        initialValue,
        key
    ]);
    const [storedValue, setStoredValue] = (0, $exYeM.useState)(readValue);
    const setValue = (0, $d6ec6a2a3d01340a$export$2e2bcd8739ae039)((value)=>{
        if (typeof window === "undefined") console.warn(`Tried setting localStorage key “${key}” even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.localStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event("local-storage"));
        } catch (error) {
            console.warn(`Error setting localStorage key “${key}”:`, error);
        }
    });
    (0, $exYeM.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $exYeM.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("storage", handleStorageChange);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $fc47a0278df6b5e1$export$2e2bcd8739ae039 = $fc47a0278df6b5e1$var$useLocalStorage;
function $fc47a0278df6b5e1$var$parseJSON(value) {
    try {
        return value === "undefined" ? undefined : JSON.parse(value !== null && value !== void 0 ? value : "");
    } catch (_a) {
        console.log("parsing error on", {
            value: value
        });
        return undefined;
    }
}



var $exYeM = parcelRequire("exYeM");

function $b41b40011493d975$var$useLockedBody(initialLocked = false, rootId = "___gatsby") {
    const [locked, setLocked] = (0, $exYeM.useState)(initialLocked);
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        if (!locked) return;
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = "hidden";
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
        return ()=>{
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) document.body.style.paddingRight = originalPaddingRight;
        };
    }, [
        locked
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (locked !== initialLocked) setLocked(initialLocked);
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
var $b41b40011493d975$export$2e2bcd8739ae039 = $b41b40011493d975$var$useLockedBody;



var $exYeM = parcelRequire("exYeM");
function $96429296f7f5e5ba$var$useMap(initialState = new Map()) {
    const [map, setMap] = (0, $exYeM.useState)(new Map(initialState));
    const actions = {
        set: (0, $exYeM.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $exYeM.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $exYeM.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $exYeM.useCallback)(()=>{
            setMap(()=>new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
var $96429296f7f5e5ba$export$2e2bcd8739ae039 = $96429296f7f5e5ba$var$useMap;



var $exYeM = parcelRequire("exYeM");
function $e36eb2e233dd4d52$var$useMediaQuery(query) {
    const getMatches = (query)=>{
        if (typeof window !== "undefined") return window.matchMedia(query).matches;
        return false;
    };
    const [matches, setMatches] = (0, $exYeM.useState)(getMatches(query));
    function handleChange() {
        setMatches(getMatches(query));
    }
    (0, $exYeM.useEffect)(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
var $e36eb2e233dd4d52$export$2e2bcd8739ae039 = $e36eb2e233dd4d52$var$useMediaQuery;



function $14b17481593924ad$var$useOnClickOutside(ref, handler, mouseEvent = "mousedown") {
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)(mouseEvent, (event)=>{
        const el = ref === null || ref === void 0 ? void 0 : ref.current;
        if (!el || el.contains(event.target)) return;
        handler(event);
    });
}
var $14b17481593924ad$export$2e2bcd8739ae039 = $14b17481593924ad$var$useOnClickOutside;



var $exYeM = parcelRequire("exYeM");

function $a47947f6bbf67534$var$useReadLocalStorage(key) {
    const readValue = (0, $exYeM.useCallback)(()=>{
        if (typeof window === "undefined") return null;
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key “${key}”:`, error);
            return null;
        }
    }, [
        key
    ]);
    const [storedValue, setStoredValue] = (0, $exYeM.useState)(readValue);
    (0, $exYeM.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $exYeM.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("storage", handleStorageChange);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("local-storage", handleStorageChange);
    return storedValue;
}
var $a47947f6bbf67534$export$2e2bcd8739ae039 = $a47947f6bbf67534$var$useReadLocalStorage;



var $exYeM = parcelRequire("exYeM");

function $f605b290b500007f$var$useScreen() {
    const getScreen = ()=>{
        if (typeof window !== "undefined" && window.screen) return window.screen;
        return undefined;
    };
    const [screen, setScreen] = (0, $exYeM.useState)(getScreen());
    function handleSize() {
        setScreen(getScreen());
    }
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("resize", handleSize);
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        handleSize();
    }, []);
    return screen;
}
var $f605b290b500007f$export$2e2bcd8739ae039 = $f605b290b500007f$var$useScreen;



var $exYeM = parcelRequire("exYeM");
const $b029ee91cf17946a$var$cachedScriptStatuses = {};
function $b029ee91cf17946a$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node === null || node === void 0 ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $b029ee91cf17946a$var$useScript(src, options) {
    const [status, setStatus] = (0, $exYeM.useState)(()=>{
        var _a;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return (_a = $b029ee91cf17946a$var$cachedScriptStatuses[src]) !== null && _a !== void 0 ? _a : "loading";
    });
    (0, $exYeM.useEffect)(()=>{
        var _a, _b;
        if (!src || (options === null || options === void 0 ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $b029ee91cf17946a$var$cachedScriptStatuses[src];
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $b029ee91cf17946a$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode === null || scriptNode === void 0 || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus((_b = (_a = script.status) !== null && _a !== void 0 ? _a : cachedScriptStatus) !== null && _b !== void 0 ? _b : "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $b029ee91cf17946a$var$cachedScriptStatuses[src] = newStatus;
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options === null || options === void 0 ? void 0 : options.removeOnUnmount)) scriptNode.remove();
        };
    }, [
        src,
        options === null || options === void 0 ? void 0 : options.shouldPreventLoad,
        options === null || options === void 0 ? void 0 : options.removeOnUnmount
    ]);
    return status;
}
var $b029ee91cf17946a$export$2e2bcd8739ae039 = $b029ee91cf17946a$var$useScript;



var $exYeM = parcelRequire("exYeM");

function $1bf0f549218b8ddc$var$useSessionStorage(key, initialValue) {
    const readValue = (0, $exYeM.useCallback)(()=>{
        if (typeof window === "undefined") return initialValue;
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? $1bf0f549218b8ddc$var$parseJSON(item) : initialValue;
        } catch (error) {
            console.warn(`Error reading sessionStorage key “${key}”:`, error);
            return initialValue;
        }
    }, [
        initialValue,
        key
    ]);
    const [storedValue, setStoredValue] = (0, $exYeM.useState)(readValue);
    const setValue = (0, $d6ec6a2a3d01340a$export$2e2bcd8739ae039)((value)=>{
        if (typeof window == "undefined") console.warn(`Tried setting sessionStorage key “${key}” even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(storedValue) : value;
            window.sessionStorage.setItem(key, JSON.stringify(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new Event("session-storage"));
        } catch (error) {
            console.warn(`Error setting sessionStorage key “${key}”:`, error);
        }
    });
    (0, $exYeM.useEffect)(()=>{
        setStoredValue(readValue());
    }, []);
    const handleStorageChange = (0, $exYeM.useCallback)((event)=>{
        if ((event === null || event === void 0 ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("storage", handleStorageChange);
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $1bf0f549218b8ddc$export$2e2bcd8739ae039 = $1bf0f549218b8ddc$var$useSessionStorage;
function $1bf0f549218b8ddc$var$parseJSON(value) {
    try {
        return value === "undefined" ? undefined : JSON.parse(value !== null && value !== void 0 ? value : "");
    } catch (_a) {
        console.log("parsing error on", {
            value: value
        });
        return undefined;
    }
}


function $a42eb00c950c75c1$var$useSsr() {
    const isDOM = typeof window !== "undefined" && window.document && window.document.documentElement;
    return {
        isBrowser: isDOM,
        isServer: !isDOM
    };
}
var $a42eb00c950c75c1$export$2e2bcd8739ae039 = $a42eb00c950c75c1$var$useSsr;



var $exYeM = parcelRequire("exYeM");
function $9cd90a5d5d637b2a$var$useStep(maxStep) {
    const [currentStep, setCurrentStep] = (0, $exYeM.useState)(1);
    const canGoToNextStep = (0, $exYeM.useMemo)(()=>currentStep + 1 <= maxStep, [
        currentStep,
        maxStep
    ]);
    const canGoToPrevStep = (0, $exYeM.useMemo)(()=>currentStep - 1 >= 1, [
        currentStep
    ]);
    const setStep = (0, $exYeM.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $exYeM.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $exYeM.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $exYeM.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
var $9cd90a5d5d637b2a$export$2e2bcd8739ae039 = $9cd90a5d5d637b2a$var$useStep;



var $exYeM = parcelRequire("exYeM");

const $9a4ee40c58878406$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
function $9a4ee40c58878406$var$useTernaryDarkMode() {
    const isDarkOS = (0, $e36eb2e233dd4d52$export$2e2bcd8739ae039)($9a4ee40c58878406$var$COLOR_SCHEME_QUERY);
    const [ternaryDarkMode, setTernaryDarkMode] = (0, $fc47a0278df6b5e1$export$2e2bcd8739ae039)("usehooks-ts-ternary-dark-mode", "system");
    const [isDarkMode, setDarkMode] = (0, $exYeM.useState)(isDarkOS);
    (0, $ca0788c81918dd7f$export$2e2bcd8739ae039)(()=>{
        if (ternaryDarkMode === "system") setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    (0, $exYeM.useEffect)(()=>{
        switch(ternaryDarkMode){
            case "light":
                setDarkMode(false);
                break;
            case "system":
                setDarkMode(isDarkOS);
                break;
            case "dark":
                setDarkMode(true);
                break;
        }
    }, [
        ternaryDarkMode,
        isDarkOS
    ]);
    function toggleTernaryDarkMode() {
        const toggleDict = {
            light: "system",
            system: "dark",
            dark: "light"
        };
        setTernaryDarkMode((prevMode)=>toggleDict[prevMode]);
    }
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: ternaryDarkMode,
        setTernaryDarkMode: setTernaryDarkMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
var $9a4ee40c58878406$export$2e2bcd8739ae039 = $9a4ee40c58878406$var$useTernaryDarkMode;



var $exYeM = parcelRequire("exYeM");

function $bc3bdce9724d855e$var$useTimeout(callback, delay) {
    const savedCallback = (0, $exYeM.useRef)(callback);
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>savedCallback.current(), delay);
        return ()=>clearTimeout(id);
    }, [
        delay
    ]);
}
var $bc3bdce9724d855e$export$2e2bcd8739ae039 = $bc3bdce9724d855e$var$useTimeout;



var $exYeM = parcelRequire("exYeM");
function $71530da070570049$var$useToggle(defaultValue) {
    const [value, setValue] = (0, $exYeM.useState)(!!defaultValue);
    const toggle = (0, $exYeM.useCallback)(()=>setValue((x)=>!x), []);
    return [
        value,
        toggle,
        setValue
    ];
}
var $71530da070570049$export$2e2bcd8739ae039 = $71530da070570049$var$useToggle;



var $exYeM = parcelRequire("exYeM");

function $ca0788c81918dd7f$var$useUpdateEffect(effect, deps) {
    const isFirst = (0, $6800db55d72f6f50$export$2e2bcd8739ae039)();
    (0, $exYeM.useEffect)(()=>{
        if (!isFirst) return effect();
    }, deps);
}
var $ca0788c81918dd7f$export$2e2bcd8739ae039 = $ca0788c81918dd7f$var$useUpdateEffect;



var $exYeM = parcelRequire("exYeM");

function $f6d628de04fe2ee5$var$useWindowSize() {
    const [windowSize, setWindowSize] = (0, $exYeM.useState)({
        width: 0,
        height: 0
    });
    const handleSize = ()=>{
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };
    (0, $843b1a40c9fe37a4$export$2e2bcd8739ae039)("resize", handleSize);
    (0, $af63c2fcac4ad893$export$2e2bcd8739ae039)(()=>{
        handleSize();
    }, []);
    return windowSize;
}
var $f6d628de04fe2ee5$export$2e2bcd8739ae039 = $f6d628de04fe2ee5$var$useWindowSize;




var $6d99e44aa80195de$exports = {};
// eslint-disable-next-line import/no-unresolved

$6d99e44aa80195de$exports = (parcelRequire("gPYQ3"));


function $a17a66d84e0a08e7$export$ffaf7158cdb6a1b9() {
    const [prevSearch, setPrevSearch] = (0, $exYeM.useState)(null);
    const [active, setActive] = (0, $exYeM.useState)(null);
    const inputRef = (0, $exYeM.useRef)(null);
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [searchQuery, setSearchQuery] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $79a6aa2f003c21d2$export$36a381671975116c));
    const [searchQueryText, setSearchQueryText] = (0, $exYeM.useState)(null);
    const debouncedSearchTerm = (0, $05072e0982e27de5$export$2e2bcd8739ae039)(searchQueryText, 300);
    (0, $exYeM.useEffect)(()=>{
        if (searchQuery?.trim() !== "") {
            setActive(!!prevSearch);
            if (!prevSearch) setSearchQuery(null);
        }
    }, [
        prevSearch
    ]);
    (0, $exYeM.useEffect)(()=>{
        setPrevSearch(searchQueryText);
        setSearchQuery(searchQueryText);
    }, [
        debouncedSearchTerm
    ]);
    function handleSearchInput(ev) {
        let params = new URLSearchParams({
            q: ev.target.value
        });
        navigate(`${location.pathname}?${params.toString()}`, {
            replace: true
        });
    }
    (0, $exYeM.useEffect)(()=>{
        const params = new URLSearchParams(location.search);
        if (params.get("q") !== null) setSearchQueryText(params.get("q"));
    }, [
        location
    ]);
    (0, $exYeM.useEffect)(()=>{
        let sq = searchQuery;
        if (sq === ":focus:") {
            setActive(true);
            if (inputRef?.current) inputRef.current.value = "";
            return;
        } else if (sq === null || sq === ":blur:") {
            setActive(false);
            return;
        }
        if (sq === "") inputRef?.current?.focus();
        if (sq === null) {
            setActive(false);
            return;
        } else if (inputRef?.current) inputRef.current.value = sq;
        setActive(true);
    }, [
        searchQuery,
        inputRef
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6d99e44aa80195de$exports))), {
        onOutsideClick: ()=>setActive(false),
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
            id: "article-search",
            className: [
                "article-search",
                active ? "active" : null
            ].filter((v)=>!!v).join(" "),
            onMouseMove: ()=>{
                setActive(true);
            },
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
                className: "form",
                onSubmit: (ev)=>ev.preventDefault(),
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("fieldset", {
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        type: "search",
                        placeholder: "Search",
                        focus: active ? "true" : undefined,
                        onChange: handleSearchInput,
                        ref: inputRef
                    })
                })
            })
        })
    });
}


var $53965c3273f651d7$exports = {};

$53965c3273f651d7$exports = (parcelRequire("bBc9P"));




var $exYeM = parcelRequire("exYeM");
function $0c1c12d856ffd7b8$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $0c1c12d856ffd7b8$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $0c1c12d856ffd7b8$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $0c1c12d856ffd7b8$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $0c1c12d856ffd7b8$export$2e2bcd8739ae039 = $0c1c12d856ffd7b8$export$4f5d2d50c9deca37;


"use client";
const $93891797481e717e$var$u = (t)=>"number" == typeof t && !isNaN(t), $93891797481e717e$var$d = (t)=>"string" == typeof t, $93891797481e717e$var$p = (t)=>"function" == typeof t, $93891797481e717e$var$m = (t)=>$93891797481e717e$var$d(t) || $93891797481e717e$var$p(t) ? t : null, $93891797481e717e$var$f = (t)=>(0, $exYeM.isValidElement)(t) || $93891797481e717e$var$d(t) || $93891797481e717e$var$p(t) || $93891797481e717e$var$u(t);
function $93891797481e717e$export$184cca501f1aed7f(t, e, n) {
    void 0 === n && (n = 300);
    const { scrollHeight: o, style: s } = t;
    requestAnimationFrame(()=>{
        s.minHeight = "initial", s.height = o + "px", s.transition = `all ${n}ms`, requestAnimationFrame(()=>{
            s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
        });
    });
}
function $93891797481e717e$export$3ff7dc44d332d222(e) {
    let { enter: a, exit: r, appendPosition: i = !1, collapse: l = !0, collapseDuration: c = 300 } = e;
    return function(e) {
        let { children: u, position: d, preventExitTransition: p, done: m, nodeRef: f, isIn: h } = e;
        const y = i ? `${a}--${d}` : a, v = i ? `${r}--${d}` : r, T = (0, $exYeM.useRef)(0);
        return (0, $exYeM.useLayoutEffect)(()=>{
            const t = f.current, e = y.split(" "), n = (o)=>{
                o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && t.classList.remove(...e));
            };
            t.classList.add(...e), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
        }, []), (0, $exYeM.useEffect)(()=>{
            const t = f.current, e = ()=>{
                t.removeEventListener("animationend", e), l ? $93891797481e717e$export$184cca501f1aed7f(t, m, c) : m();
            };
            h || (p ? e() : (T.current = 1, t.className += ` ${v}`, t.addEventListener("animationend", e)));
        }, [
            h
        ]), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).Fragment, null, u);
    };
}
function $93891797481e717e$var$y(t, e) {
    return null != t ? {
        content: t.content,
        containerId: t.props.containerId,
        id: t.props.toastId,
        theme: t.props.theme,
        type: t.props.type,
        data: t.props.data || {},
        isLoading: t.props.isLoading,
        icon: t.props.icon,
        status: e
    } : {};
}
const $93891797481e717e$var$v = {
    list: new Map,
    emitQueue: new Map,
    on (t, e) {
        return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off (t, e) {
        if (e) {
            const n = this.list.get(t).filter((t)=>t !== e);
            return this.list.set(t, n), this;
        }
        return this.list.delete(t), this;
    },
    cancelEmit (t) {
        const e = this.emitQueue.get(t);
        return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit (t) {
        this.list.has(t) && this.list.get(t).forEach((e)=>{
            const n = setTimeout(()=>{
                e(...[].slice.call(arguments, 1));
            }, 0);
            this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
        });
    }
}, $93891797481e717e$var$T = (e)=>{
    let { theme: n, type: o, ...s } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("svg", {
        viewBox: "0 0 24 24",
        width: "100%",
        height: "100%",
        fill: "colored" === n ? "currentColor" : `var(--toastify-icon-color-${o})`,
        ...s
    });
}, $93891797481e717e$export$4f13f83fd8bb1dac = {
    info: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93891797481e717e$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
        }));
    },
    warning: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93891797481e717e$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
        }));
    },
    success: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93891797481e717e$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
        }));
    },
    error: function(e) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93891797481e717e$var$T, {
            ...e
        }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
            d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
        }));
    },
    spinner: function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            className: "Toastify__spinner"
        });
    }
};
function $93891797481e717e$export$b262e13ca2dd2381(t) {
    const [, o] = (0, $exYeM.useReducer)((t)=>t + 1, 0), [l, c] = (0, $exYeM.useState)([]), g = (0, $exYeM.useRef)(null), h = (0, $exYeM.useRef)(new Map).current, T = (t)=>-1 !== l.indexOf(t), C = (0, $exYeM.useRef)({
        toastKey: 1,
        displayedToast: 0,
        count: 0,
        queue: [],
        props: t,
        containerId: null,
        isToastActive: T,
        getToast: (t)=>h.get(t)
    }).current;
    function b(t) {
        let { containerId: e } = t;
        const { limit: n } = C.props;
        !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
    }
    function I(t) {
        c((e)=>null == t ? [] : e.filter((e)=>e !== t));
    }
    function _() {
        const { toastContent: t, toastProps: e, staleId: n } = C.queue.shift();
        O(t, e, n);
    }
    function L(t, n) {
        let { delay: s, staleId: r, ...i } = n;
        if (!$93891797481e717e$var$f(t) || function(t) {
            return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
        }(i)) return;
        const { toastId: l, updateId: c, data: T } = i, { props: b } = C, L = ()=>I(l), N = null == c;
        N && C.count++;
        const M = {
            ...b,
            style: b.toastStyle,
            key: C.toastKey++,
            ...Object.fromEntries(Object.entries(i).filter((t)=>{
                let [e, n] = t;
                return null != n;
            })),
            toastId: l,
            updateId: c,
            data: T,
            closeToast: L,
            isIn: !1,
            className: $93891797481e717e$var$m(i.className || b.toastClassName),
            bodyClassName: $93891797481e717e$var$m(i.bodyClassName || b.bodyClassName),
            progressClassName: $93891797481e717e$var$m(i.progressClassName || b.progressClassName),
            autoClose: !i.isLoading && (R = i.autoClose, w = b.autoClose, !1 === R || $93891797481e717e$var$u(R) && R > 0 ? R : w),
            deleteToast () {
                const t = $93891797481e717e$var$y(h.get(l), "removed");
                h.delete(l), $93891797481e717e$var$v.emit(4, t);
                const e = C.queue.length;
                if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
                    const t = null == l ? C.props.limit : 1;
                    if (1 === e || 1 === t) C.displayedToast++, _();
                    else {
                        const n = t > e ? e : t;
                        C.displayedToast = n;
                        for(let t = 0; t < n; t++)_();
                    }
                } else o();
            }
        };
        var R, w;
        M.iconOut = function(t) {
            let { theme: n, type: o, isLoading: s, icon: r } = t, i = null;
            const l = {
                theme: n,
                type: o
            };
            return !1 === r || ($93891797481e717e$var$p(r) ? i = r(l) : (0, $exYeM.isValidElement)(r) ? i = (0, $exYeM.cloneElement)(r, l) : $93891797481e717e$var$d(r) || $93891797481e717e$var$u(r) ? i = r : s ? i = $93891797481e717e$export$4f13f83fd8bb1dac.spinner() : ((t)=>t in $93891797481e717e$export$4f13f83fd8bb1dac)(o) && (i = $93891797481e717e$export$4f13f83fd8bb1dac[o](l))), i;
        }(M), $93891797481e717e$var$p(i.onOpen) && (M.onOpen = i.onOpen), $93891797481e717e$var$p(i.onClose) && (M.onClose = i.onClose), M.closeButton = b.closeButton, !1 === i.closeButton || $93891797481e717e$var$f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !$93891797481e717e$var$f(b.closeButton) || b.closeButton);
        let x = t;
        (0, $exYeM.isValidElement)(t) && !$93891797481e717e$var$d(t.type) ? x = (0, $exYeM.cloneElement)(t, {
            closeToast: L,
            toastProps: M,
            data: T
        }) : $93891797481e717e$var$p(t) && (x = t({
            closeToast: L,
            toastProps: M,
            data: T
        })), b.limit && b.limit > 0 && C.count > b.limit && N ? C.queue.push({
            toastContent: x,
            toastProps: M,
            staleId: r
        }) : $93891797481e717e$var$u(s) ? setTimeout(()=>{
            O(x, M, r);
        }, s) : O(x, M, r);
    }
    function O(t, e, n) {
        const { toastId: o } = e;
        n && h.delete(n);
        const s = {
            content: t,
            props: e
        };
        h.set(o, s), c((t)=>[
                ...t,
                o
            ].filter((t)=>t !== n)), $93891797481e717e$var$v.emit(4, $93891797481e717e$var$y(s, null == s.props.updateId ? "added" : "updated"));
    }
    return (0, $exYeM.useEffect)(()=>(C.containerId = t.containerId, $93891797481e717e$var$v.cancelEmit(3).on(0, L).on(1, (t)=>g.current && I(t)).on(5, b).emit(2, C), ()=>{
            h.clear(), $93891797481e717e$var$v.emit(3, C);
        }), []), (0, $exYeM.useEffect)(()=>{
        C.props = t, C.isToastActive = T, C.displayedToast = l.length;
    }), {
        getToastToRender: function(e) {
            const n = new Map, o = Array.from(h.values());
            return t.newestOnTop && o.reverse(), o.forEach((t)=>{
                const { position: e } = t.props;
                n.has(e) || n.set(e, []), n.get(e).push(t);
            }), Array.from(n, (t)=>e(t[0], t[1]));
        },
        containerRef: g,
        isToastActive: T
    };
}
function $93891797481e717e$var$b(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function $93891797481e717e$var$I(t) {
    return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function $93891797481e717e$export$a407b657d3044108(t) {
    const [o, a] = (0, $exYeM.useState)(!1), [r, l] = (0, $exYeM.useState)(!1), c = (0, $exYeM.useRef)(null), u = (0, $exYeM.useRef)({
        start: 0,
        x: 0,
        y: 0,
        delta: 0,
        removalDistance: 0,
        canCloseOnClick: !0,
        canDrag: !1,
        boundingRect: null,
        didMove: !1
    }).current, d = (0, $exYeM.useRef)(t), { autoClose: m, pauseOnHover: f, closeToast: g, onClick: h, closeOnClick: y } = t;
    function v(e) {
        if (t.draggable) {
            "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
            const n = c.current;
            u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = n.getBoundingClientRect(), n.style.transition = "", u.x = $93891797481e717e$var$b(e.nativeEvent), u.y = $93891797481e717e$var$I(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = n.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = n.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
        }
    }
    function T(e) {
        if (u.boundingRect) {
            const { top: n, bottom: o, left: s, right: a } = u.boundingRect;
            "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= s && u.x <= a && u.y >= n && u.y <= o ? C() : E();
        }
    }
    function E() {
        a(!0);
    }
    function C() {
        a(!1);
    }
    function _(e) {
        const n = c.current;
        u.canDrag && n && (u.didMove = !0, o && C(), u.x = $93891797481e717e$var$b(e), u.y = $93891797481e717e$var$I(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = `translate${t.draggableDirection}(${u.delta}px)`, n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
    }
    function L() {
        document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
        const e = c.current;
        if (u.canDrag && u.didMove && e) {
            if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
            e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = `translate${t.draggableDirection}(0)`, e.style.opacity = "1";
        }
    }
    (0, $exYeM.useEffect)(()=>{
        d.current = t;
    }), (0, $exYeM.useEffect)(()=>(c.current && c.current.addEventListener("d", E, {
            once: !0
        }), $93891797481e717e$var$p(t.onOpen) && t.onOpen((0, $exYeM.isValidElement)(t.children) && t.children.props), ()=>{
            const t = d.current;
            $93891797481e717e$var$p(t.onClose) && t.onClose((0, $exYeM.isValidElement)(t.children) && t.children.props);
        }), []), (0, $exYeM.useEffect)(()=>(t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), ()=>{
            t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
        }), [
        t.pauseOnFocusLoss
    ]);
    const O = {
        onMouseDown: v,
        onTouchStart: v,
        onMouseUp: T,
        onTouchEnd: T
    };
    return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = (t)=>{
        h && h(t), u.canCloseOnClick && g();
    }), {
        playToast: E,
        pauseToast: C,
        isRunning: o,
        preventExitTransition: r,
        toastRef: c,
        eventHandlers: O
    };
}
function $93891797481e717e$var$L(e) {
    let { closeToast: n, theme: o, ariaLabel: s = "close" } = e;
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("button", {
        className: `Toastify__close-button Toastify__close-button--${o}`,
        type: "button",
        onClick: (t)=>{
            t.stopPropagation(), n(t);
        },
        "aria-label": s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $93891797481e717e$var$O(e) {
    let { delay: n, isRunning: o, closeToast: s, type: a = "default", hide: r, className: i, style: l, controlledProgress: u, progress: d, rtl: m, isIn: f, theme: g } = e;
    const h = r || u && 0 === d, y = {
        ...l,
        animationDuration: `${n}ms`,
        animationPlayState: o ? "running" : "paused",
        opacity: h ? 0 : 1
    };
    u && (y.transform = `scaleX(${d})`);
    const v = (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${g}`, `Toastify__progress-bar--${a}`, {
        "Toastify__progress-bar--rtl": m
    }), T = $93891797481e717e$var$p(i) ? i({
        rtl: m,
        type: a,
        defaultClassName: v
    }) : (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)(v, i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        role: "progressbar",
        "aria-hidden": h ? "true" : "false",
        "aria-label": "notification timer",
        className: T,
        style: y,
        [u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: u && d < 1 ? null : ()=>{
            f && s();
        }
    });
}
const $93891797481e717e$var$N = (n)=>{
    const { isRunning: o, preventExitTransition: s, toastRef: r, eventHandlers: i } = $93891797481e717e$export$a407b657d3044108(n), { closeButton: l, children: u, autoClose: d, onClick: m, type: f, hideProgressBar: g, closeToast: h, transition: y, position: v, className: T, style: E, bodyClassName: C, bodyStyle: b, progressClassName: I, progressStyle: N, updateId: M, role: R, progress: w, rtl: x, toastId: $, deleteToast: k, isIn: P, isLoading: B, iconOut: D, closeOnClick: A, theme: z } = n, F = (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("Toastify__toast", `Toastify__toast-theme--${z}`, `Toastify__toast--${f}`, {
        "Toastify__toast--rtl": x
    }, {
        "Toastify__toast--close-on-click": A
    }), H = $93891797481e717e$var$p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
    }) : (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)(F, T), S = !!w || !d, q = {
        closeToast: h,
        type: f,
        theme: z
    };
    let Q = null;
    return !1 === l || (Q = $93891797481e717e$var$p(l) ? l(q) : (0, $exYeM.isValidElement)(l) ? (0, $exYeM.cloneElement)(l, q) : $93891797481e717e$var$L(q)), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(y, {
        isIn: P,
        done: k,
        position: v,
        preventExitTransition: s,
        nodeRef: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        id: $,
        onClick: m,
        className: H,
        ...i,
        style: E,
        ref: r
    }, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ...P && {
            role: R
        },
        className: $93891797481e717e$var$p(C) ? C({
            type: f
        }) : (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("Toastify__toast-body", C),
        style: b
    }, null != D && (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        className: (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("Toastify__toast-icon", {
            "Toastify--animate-icon Toastify__zoom-enter": !B
        })
    }, D), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", null, u)), Q, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93891797481e717e$var$O, {
        ...M && !S ? {
            key: `pb-${M}`
        } : {},
        rtl: x,
        theme: z,
        delay: d,
        isRunning: o,
        isIn: P,
        closeToast: h,
        hide: g,
        type: f,
        style: N,
        className: I,
        controlledProgress: S,
        progress: w || 0
    })));
}, $93891797481e717e$var$M = function(t, e) {
    return void 0 === e && (e = !1), {
        enter: `Toastify--animate Toastify__${t}-enter`,
        exit: `Toastify--animate Toastify__${t}-exit`,
        appendPosition: e
    };
}, $93891797481e717e$export$d20e79fdc3899e95 = $93891797481e717e$export$3ff7dc44d332d222($93891797481e717e$var$M("bounce", !0)), $93891797481e717e$export$d8dc01b5c85a37b9 = $93891797481e717e$export$3ff7dc44d332d222($93891797481e717e$var$M("slide", !0)), $93891797481e717e$export$65cfd44a2050f99 = $93891797481e717e$export$3ff7dc44d332d222($93891797481e717e$var$M("zoom")), $93891797481e717e$export$4d2fae537bd90431 = $93891797481e717e$export$3ff7dc44d332d222($93891797481e717e$var$M("flip")), $93891797481e717e$export$f2815235e76a62b9 = (0, $exYeM.forwardRef)((e, n)=>{
    const { getToastToRender: o, containerRef: a, isToastActive: r } = $93891797481e717e$export$b262e13ca2dd2381(e), { className: i, style: l, rtl: u, containerId: d } = e;
    function f(t) {
        const e = (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)("Toastify__toast-container", `Toastify__toast-container--${t}`, {
            "Toastify__toast-container--rtl": u
        });
        return $93891797481e717e$var$p(i) ? i({
            position: t,
            rtl: u,
            defaultClassName: e
        }) : (0, $0c1c12d856ffd7b8$export$2e2bcd8739ae039)(e, $93891797481e717e$var$m(i));
    }
    return (0, $exYeM.useEffect)(()=>{
        n && (n.current = a.current);
    }, []), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
        ref: a,
        className: "Toastify",
        id: d
    }, o((e, n)=>{
        const o = n.length ? {
            ...l
        } : {
            ...l,
            pointerEvents: "none"
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            className: f(e),
            style: o,
            key: `container-${e}`
        }, n.map((e, o)=>{
            let { content: s, props: a } = e;
            return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($93891797481e717e$var$N, {
                ...a,
                isIn: r(a.toastId),
                style: {
                    ...a.style,
                    "--nth": o + 1,
                    "--len": n.length
                },
                key: `toast-${a.key}`
            }, s);
        }));
    }));
});
$93891797481e717e$export$f2815235e76a62b9.displayName = "ToastContainer", $93891797481e717e$export$f2815235e76a62b9.defaultProps = {
    position: "top-right",
    transition: $93891797481e717e$export$d20e79fdc3899e95,
    autoClose: 5e3,
    closeButton: $93891797481e717e$var$L,
    pauseOnHover: !0,
    pauseOnFocusLoss: !0,
    closeOnClick: !0,
    draggable: !0,
    draggablePercent: 80,
    draggableDirection: "x",
    role: "alert",
    theme: "light"
};
let $93891797481e717e$var$P, $93891797481e717e$var$B = new Map, $93891797481e717e$var$D = [], $93891797481e717e$var$A = 1;
function $93891797481e717e$var$z() {
    return "" + $93891797481e717e$var$A++;
}
function $93891797481e717e$var$F(t) {
    return t && ($93891797481e717e$var$d(t.toastId) || $93891797481e717e$var$u(t.toastId)) ? t.toastId : $93891797481e717e$var$z();
}
function $93891797481e717e$var$H(t, e) {
    return $93891797481e717e$var$B.size > 0 ? $93891797481e717e$var$v.emit(0, t, e) : $93891797481e717e$var$D.push({
        content: t,
        options: e
    }), e.toastId;
}
function $93891797481e717e$var$S(t, e) {
    return {
        ...e,
        type: e && e.type || t,
        toastId: $93891797481e717e$var$F(e)
    };
}
function $93891797481e717e$var$q(t) {
    return (e, n)=>$93891797481e717e$var$H(e, $93891797481e717e$var$S(t, n));
}
function $93891797481e717e$export$b410431fab84fa58(t, e) {
    return $93891797481e717e$var$H(t, $93891797481e717e$var$S("default", e));
}
$93891797481e717e$export$b410431fab84fa58.loading = (t, e)=>$93891797481e717e$var$H(t, $93891797481e717e$var$S("default", {
        isLoading: !0,
        autoClose: !1,
        closeOnClick: !1,
        closeButton: !1,
        draggable: !1,
        ...e
    })), $93891797481e717e$export$b410431fab84fa58.promise = function(t, e, n) {
    let o, { pending: s, error: a, success: r } = e;
    s && (o = $93891797481e717e$var$d(s) ? $93891797481e717e$export$b410431fab84fa58.loading(s, n) : $93891797481e717e$export$b410431fab84fa58.loading(s.render, {
        ...n,
        ...s
    }));
    const i = {
        isLoading: null,
        autoClose: null,
        closeOnClick: null,
        closeButton: null,
        draggable: null
    }, l = (t, e, s)=>{
        if (null == e) return void $93891797481e717e$export$b410431fab84fa58.dismiss(o);
        const a = {
            type: t,
            ...i,
            ...n,
            data: s
        }, r = $93891797481e717e$var$d(e) ? {
            render: e
        } : e;
        return o ? $93891797481e717e$export$b410431fab84fa58.update(o, {
            ...a,
            ...r
        }) : $93891797481e717e$export$b410431fab84fa58(r.render, {
            ...a,
            ...r
        }), s;
    }, c = $93891797481e717e$var$p(t) ? t() : t;
    return c.then((t)=>l("success", r, t)).catch((t)=>l("error", a, t)), c;
}, $93891797481e717e$export$b410431fab84fa58.success = $93891797481e717e$var$q("success"), $93891797481e717e$export$b410431fab84fa58.info = $93891797481e717e$var$q("info"), $93891797481e717e$export$b410431fab84fa58.error = $93891797481e717e$var$q("error"), $93891797481e717e$export$b410431fab84fa58.warning = $93891797481e717e$var$q("warning"), $93891797481e717e$export$b410431fab84fa58.warn = $93891797481e717e$export$b410431fab84fa58.warning, $93891797481e717e$export$b410431fab84fa58.dark = (t, e)=>$93891797481e717e$var$H(t, $93891797481e717e$var$S("default", {
        theme: "dark",
        ...e
    })), $93891797481e717e$export$b410431fab84fa58.dismiss = (t)=>{
    $93891797481e717e$var$B.size > 0 ? $93891797481e717e$var$v.emit(1, t) : $93891797481e717e$var$D = $93891797481e717e$var$D.filter((e)=>null != t && e.options.toastId !== t);
}, $93891797481e717e$export$b410431fab84fa58.clearWaitingQueue = function(t) {
    return void 0 === t && (t = {}), $93891797481e717e$var$v.emit(5, t);
}, $93891797481e717e$export$b410431fab84fa58.isActive = (t)=>{
    let e = !1;
    return $93891797481e717e$var$B.forEach((n)=>{
        n.isToastActive && n.isToastActive(t) && (e = !0);
    }), e;
}, $93891797481e717e$export$b410431fab84fa58.update = function(t, e) {
    void 0 === e && (e = {}), setTimeout(()=>{
        const n = function(t, e) {
            let { containerId: n } = e;
            const o = $93891797481e717e$var$B.get(n || $93891797481e717e$var$P);
            return o && o.getToast(t);
        }(t, e);
        if (n) {
            const { props: o, content: s } = n, a = {
                delay: 100,
                ...o,
                ...e,
                toastId: e.toastId || t,
                updateId: $93891797481e717e$var$z()
            };
            a.toastId !== t && (a.staleId = t);
            const r = a.render || s;
            delete a.render, $93891797481e717e$var$H(r, a);
        }
    }, 0);
}, $93891797481e717e$export$b410431fab84fa58.done = (t)=>{
    $93891797481e717e$export$b410431fab84fa58.update(t, {
        progress: 1
    });
}, $93891797481e717e$export$b410431fab84fa58.onChange = (t)=>($93891797481e717e$var$v.on(4, t), ()=>{
        $93891797481e717e$var$v.off(4, t);
    }), $93891797481e717e$export$b410431fab84fa58.POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
}, $93891797481e717e$export$b410431fab84fa58.TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default"
}, $93891797481e717e$var$v.on(2, (t)=>{
    $93891797481e717e$var$P = t.containerId || t, $93891797481e717e$var$B.set($93891797481e717e$var$P, t), $93891797481e717e$var$D.forEach((t)=>{
        $93891797481e717e$var$v.emit(0, t.content, t.options);
    }), $93891797481e717e$var$D = [];
}).on(3, (t)=>{
    $93891797481e717e$var$B.delete(t.containerId || t), 0 === $93891797481e717e$var$B.size && $93891797481e717e$var$v.off(0).off(1).off(5);
});


function $d74335a42d5298e4$export$b94310965bed44e6({ setActionMenu: setActionMenu } = {}) {
    const [websites, setWebsites] = (0, $exYeM.useState)(null);
    const [limit, setLimit] = (0, $exYeM.useState)(20);
    const [hasMorePage, setHasMorePage] = (0, $exYeM.useState)(true);
    const [searchQuery, setSearchQuery] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $79a6aa2f003c21d2$export$36a381671975116c));
    const [compactView, setCompactView] = (0, $exYeM.useState)(localStorage.getItem("compactView") === "true");
    (0, $exYeM.useEffect)(()=>{
        // TODO: cancel previous request
        if (searchQuery === ":focus:" || searchQuery === ":blur:") return;
        $e6d4445b9ec5d3b6$export$fb1f670b3e66577f({
            limit: limit,
            title: searchQuery,
            page: 1
        }).then((r)=>{
            setTimeout(()=>{
                // toast('This is a test')
                setWebsites(r);
                if (r.length === limit) setHasMorePage(true);
            }, 100);
        });
    }, [
        searchQuery
    ]);
    function handleToggleCompactView() {
        let newValue = localStorage.getItem("compactView") !== "true";
        localStorage.setItem("compactView", newValue);
        setCompactView(newValue);
        if (websites) setWebsites([
            ...websites
        ]);
    }
    (0, $exYeM.useEffect)(()=>{
        setActionMenu(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("ul", {
            className: "action-menu action-menu-home",
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                    className: "grid",
                    onClick: handleToggleCompactView
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                    className: "favourites",
                    onClick: ()=>{
                        setSearchQuery(!searchQuery?.match(/is_starred/) ? ((searchQuery || "") + "is_starred:").trim() : "");
                    }
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                    className: "menu-search",
                    onClick: ()=>{
                        location.hash = "";
                        location.hash = "#article-search";
                        setSearchQuery(":focus:");
                        setTimeout(()=>{
                            setSearchQuery("");
                        }, 100);
                    }
                })
            ]
        }));
    }, [
        websites
    ]);
    function loadFunc(page) {
        setHasMorePage(false);
        $e6d4445b9ec5d3b6$export$fb1f670b3e66577f({
            limit: limit,
            title: searchQuery,
            page: page
        }).then((r)=>{
            setWebsites([
                ...websites || [],
                ...r
            ]);
            if (r.length === limit) setHasMorePage(true);
        });
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: [
            "home-stash",
            compactView ? "compact-view" : ""
        ].filter((v)=>!!v).join(" "),
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $a17a66d84e0a08e7$export$ffaf7158cdb6a1b9), {}),
            websites?.length === 0 && !searchQuery && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "no-stash",
                style: {
                    textAlign: "center",
                    opacity: 0.5
                },
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("No websites stashed, yet")
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                href: "https://www.sitestash.net/browser-extension",
                                target: "_blank",
                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Start adding websites easily by using the browser plugin")
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                to: "/add",
                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("or add a website manually here")
                            })
                        ]
                    })
                ]
            }),
            websites?.length > 0 && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($53965c3273f651d7$exports))), {
                pageStart: 1,
                loadMore: loadFunc,
                hasMore: hasMorePage,
                threshold: 2000,
                loader: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                    className: "loader",
                    children: "Loading…"
                }, 0),
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("ul", {
                    className: "stash",
                    children: websites.map((website, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $de1cf2e99b0bbaa2$export$fd15eb57367a61d4), {
                                website: website,
                                i: i,
                                compactView: compactView
                            })
                        }, "website-preview-li-" + website.id))
                })
            })
        ]
    });
}




var $exYeM = parcelRequire("exYeM");




function $f6c7bbcc9e76a42c$export$cad1a703886b4e3a() {
    const [, setUser] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    (0, $exYeM.useEffect)(()=>{
        async function logoutAndRedirectToRootUrl() {
            async function logoutAndClearSession() {
                try {
                    await $e6d4445b9ec5d3b6$export$a0973bcfe11b05c9();
                } catch (e) {
                    console.error(e);
                }
                localStorage.clear();
                sessionStorage.clear();
            }
            await logoutAndClearSession();
            console.debug("Session cleared");
            setUser({});
            navigate("/");
        }
        logoutAndRedirectToRootUrl();
    });
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {});
}







var $exYeM = parcelRequire("exYeM");



var $742200f0fca97109$exports = {};
"use strict";
var $742200f0fca97109$var$__extends = $742200f0fca97109$exports && $742200f0fca97109$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $742200f0fca97109$var$__assign = $742200f0fca97109$exports && $742200f0fca97109$exports.__assign || function() {
    $742200f0fca97109$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $742200f0fca97109$var$__assign.apply(this, arguments);
};
var $742200f0fca97109$var$__createBinding = $742200f0fca97109$exports && $742200f0fca97109$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $742200f0fca97109$var$__setModuleDefault = $742200f0fca97109$exports && $742200f0fca97109$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $742200f0fca97109$var$__importStar = $742200f0fca97109$exports && $742200f0fca97109$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $742200f0fca97109$var$__createBinding(result, mod, k);
    }
    $742200f0fca97109$var$__setModuleDefault(result, mod);
    return result;
};
var $742200f0fca97109$var$__rest = $742200f0fca97109$exports && $742200f0fca97109$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $742200f0fca97109$var$__importDefault = $742200f0fca97109$exports && $742200f0fca97109$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($742200f0fca97109$exports, "__esModule", {
    value: true
});

var $742200f0fca97109$var$React = $742200f0fca97109$var$__importStar((parcelRequire("exYeM")));

var $742200f0fca97109$var$fast_deep_equal_1 = $742200f0fca97109$var$__importDefault((parcelRequire("5GlTO")));

var $742200f0fca97109$var$PropTypes = $742200f0fca97109$var$__importStar((parcelRequire("bisEj")));
function $742200f0fca97109$var$normalizeHtml(str) {
    return str && str.replace(/&nbsp;|\u202F|\u00A0/g, " ").replace(/<br \/>/g, "<br>");
}
function $742200f0fca97109$var$replaceCaret(el) {
    // Place the caret at the end of the element
    var target = document.createTextNode("");
    el.appendChild(target);
    // do not move caret if element was not focused
    var isTargetFocused = document.activeElement === el;
    if (target !== null && target.nodeValue !== null && isTargetFocused) {
        var sel = window.getSelection();
        if (sel !== null) {
            var range = document.createRange();
            range.setStart(target, target.nodeValue.length);
            range.collapse(true);
            sel.removeAllRanges();
            sel.addRange(range);
        }
        if (el instanceof HTMLElement) el.focus();
    }
}
/**
 * A simple component for an html element with editable contents.
 */ var $742200f0fca97109$var$ContentEditable = /** @class */ function(_super) {
    $742200f0fca97109$var$__extends(ContentEditable, _super);
    function ContentEditable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lastHtml = _this.props.html;
        _this.el = typeof _this.props.innerRef === "function" ? {
            current: null
        } : $742200f0fca97109$var$React.createRef();
        _this.getEl = function() {
            return (_this.props.innerRef && typeof _this.props.innerRef !== "function" ? _this.props.innerRef : _this.el).current;
        };
        _this.emitChange = function(originalEvt) {
            var el = _this.getEl();
            if (!el) return;
            var html = el.innerHTML;
            if (_this.props.onChange && html !== _this.lastHtml) {
                // Clone event with Object.assign to avoid
                // "Cannot assign to read only property 'target' of object"
                var evt = Object.assign({}, originalEvt, {
                    target: {
                        value: html
                    }
                });
                _this.props.onChange(evt);
            }
            _this.lastHtml = html;
        };
        return _this;
    }
    ContentEditable.prototype.render = function() {
        var _this = this;
        var _a = this.props, tagName = _a.tagName, html = _a.html, innerRef = _a.innerRef, props = $742200f0fca97109$var$__rest(_a, [
            "tagName",
            "html",
            "innerRef"
        ]);
        return $742200f0fca97109$var$React.createElement(tagName || "div", $742200f0fca97109$var$__assign($742200f0fca97109$var$__assign({}, props), {
            ref: typeof innerRef === "function" ? function(current) {
                innerRef(current);
                _this.el.current = current;
            } : innerRef || this.el,
            onInput: this.emitChange,
            onBlur: this.props.onBlur || this.emitChange,
            onKeyUp: this.props.onKeyUp || this.emitChange,
            onKeyDown: this.props.onKeyDown || this.emitChange,
            contentEditable: !this.props.disabled,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }), this.props.children);
    };
    ContentEditable.prototype.shouldComponentUpdate = function(nextProps) {
        var props = this.props;
        var el = this.getEl();
        // We need not rerender if the change of props simply reflects the user's edits.
        // Rerendering in this case would make the cursor/caret jump
        // Rerender if there is no element yet... (somehow?)
        if (!el) return true;
        // ...or if html really changed... (programmatically, not by user edit)
        if ($742200f0fca97109$var$normalizeHtml(nextProps.html) !== $742200f0fca97109$var$normalizeHtml(el.innerHTML)) return true;
        // Handle additional properties
        return props.disabled !== nextProps.disabled || props.tagName !== nextProps.tagName || props.className !== nextProps.className || props.innerRef !== nextProps.innerRef || props.placeholder !== nextProps.placeholder || !(0, $742200f0fca97109$var$fast_deep_equal_1.default)(props.style, nextProps.style);
    };
    ContentEditable.prototype.componentDidUpdate = function() {
        var el = this.getEl();
        if (!el) return;
        // Perhaps React (whose VDOM gets outdated because we often prevent
        // rerendering) did not update the DOM. So we update it manually now.
        if (this.props.html !== el.innerHTML) el.innerHTML = this.props.html;
        this.lastHtml = this.props.html;
        $742200f0fca97109$var$replaceCaret(el);
    };
    ContentEditable.propTypes = {
        html: $742200f0fca97109$var$PropTypes.string.isRequired,
        onChange: $742200f0fca97109$var$PropTypes.func,
        disabled: $742200f0fca97109$var$PropTypes.bool,
        tagName: $742200f0fca97109$var$PropTypes.string,
        className: $742200f0fca97109$var$PropTypes.string,
        style: $742200f0fca97109$var$PropTypes.object,
        innerRef: $742200f0fca97109$var$PropTypes.oneOfType([
            $742200f0fca97109$var$PropTypes.object,
            $742200f0fca97109$var$PropTypes.func
        ])
    };
    return ContentEditable;
}($742200f0fca97109$var$React.Component);
$742200f0fca97109$exports.default = $742200f0fca97109$var$ContentEditable;




/*
* React Tooltip
* {@link https://github.com/ReactTooltip/react-tooltip}
* @copyright ReactTooltip Team
* @license MIT
*/ 
var $exYeM = parcelRequire("exYeM");
const $93031e4206e8e991$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $93031e4206e8e991$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $93031e4206e8e991$export$803cd8101b6c182b = /*#__PURE__*/ $93031e4206e8e991$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[0], side + "-" + $93031e4206e8e991$export$27b07d8a310ed8b5[1]), []);
const $93031e4206e8e991$export$96ec731ed4dcb222 = Math.min;
const $93031e4206e8e991$export$8960430cfd85939f = Math.max;
const $93031e4206e8e991$export$2077e0241d6afd3c = Math.round;
const $93031e4206e8e991$export$a3fe094919f356fd = Math.floor;
const $93031e4206e8e991$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $93031e4206e8e991$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $93031e4206e8e991$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $93031e4206e8e991$export$7d15b64cf5a3a4c4(start, value, end) {
    return $93031e4206e8e991$export$8960430cfd85939f(start, $93031e4206e8e991$export$96ec731ed4dcb222(value, end));
}
function $93031e4206e8e991$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $93031e4206e8e991$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $93031e4206e8e991$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $93031e4206e8e991$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $93031e4206e8e991$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $93031e4206e8e991$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($93031e4206e8e991$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $93031e4206e8e991$export$2b57e0052a6d6d4c(placement) {
    return $93031e4206e8e991$export$8a000a963141ac32($93031e4206e8e991$export$f28e8f882010718a(placement));
}
function $93031e4206e8e991$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    const alignmentAxis = $93031e4206e8e991$export$2b57e0052a6d6d4c(placement);
    const length = $93031e4206e8e991$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $93031e4206e8e991$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $93031e4206e8e991$export$496432a3699e50b1(placement) {
    const oppositePlacement = $93031e4206e8e991$export$9c5e28bad23365fa(placement);
    return [
        $93031e4206e8e991$export$2b182c584985588b(placement),
        oppositePlacement,
        $93031e4206e8e991$export$2b182c584985588b(oppositePlacement)
    ];
}
function $93031e4206e8e991$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$93031e4206e8e991$var$oppositeAlignmentMap[alignment]);
}
function $93031e4206e8e991$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $93031e4206e8e991$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $93031e4206e8e991$export$f0989780f32bfcda(placement);
    let list = $93031e4206e8e991$var$getSideList($93031e4206e8e991$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($93031e4206e8e991$export$2b182c584985588b));
    }
    return list;
}
function $93031e4206e8e991$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$93031e4206e8e991$var$oppositeSideMap[side]);
}
function $93031e4206e8e991$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $93031e4206e8e991$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $93031e4206e8e991$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $93031e4206e8e991$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $28f1bf2594995773$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $93031e4206e8e991$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $93031e4206e8e991$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $93031e4206e8e991$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $28f1bf2594995773$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $28f1bf2594995773$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $28f1bf2594995773$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28f1bf2594995773$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $93031e4206e8e991$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $93031e4206e8e991$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $28f1bf2594995773$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $93031e4206e8e991$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28f1bf2594995773$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $93031e4206e8e991$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $93031e4206e8e991$export$803cd8101b6c182b) ? $28f1bf2594995773$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $93031e4206e8e991$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $93031e4206e8e991$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $93031e4206e8e991$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28f1bf2594995773$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $93031e4206e8e991$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $93031e4206e8e991$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $93031e4206e8e991$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $93031e4206e8e991$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $28f1bf2594995773$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $28f1bf2594995773$var$isAnySideFullyClipped(overflow) {
    return (0, $93031e4206e8e991$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28f1bf2594995773$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $28f1bf2594995773$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $28f1bf2594995773$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $28f1bf2594995773$var$getBoundingRect(rects) {
    const minX = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $93031e4206e8e991$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $93031e4206e8e991$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $28f1bf2594995773$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $93031e4206e8e991$export$ee05aea0aeecbad4)($28f1bf2594995773$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28f1bf2594995773$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $28f1bf2594995773$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $93031e4206e8e991$export$ee05aea0aeecbad4)($28f1bf2594995773$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $93031e4206e8e991$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $93031e4206e8e991$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $28f1bf2594995773$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28f1bf2594995773$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $28f1bf2594995773$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28f1bf2594995773$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)((0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $93031e4206e8e991$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $93031e4206e8e991$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28f1bf2594995773$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $93031e4206e8e991$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28f1bf2594995773$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $93031e4206e8e991$export$fef61f332f2c0afc)(options, state);
            const overflow = await $28f1bf2594995773$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $93031e4206e8e991$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $93031e4206e8e991$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $93031e4206e8e991$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $93031e4206e8e991$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $93031e4206e8e991$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $93031e4206e8e991$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $e07e1602e4c4ff5c$export$651544f548703224(node) {
    if ($e07e1602e4c4ff5c$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e07e1602e4c4ff5c$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e07e1602e4c4ff5c$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e07e1602e4c4ff5c$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e07e1602e4c4ff5c$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).Node;
}
function $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).Element;
}
function $e07e1602e4c4ff5c$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e07e1602e4c4ff5c$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e07e1602e4c4ff5c$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e07e1602e4c4ff5c$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $e07e1602e4c4ff5c$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e07e1602e4c4ff5c$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e07e1602e4c4ff5c$export$651544f548703224(element));
}
function $e07e1602e4c4ff5c$export$d6c4e8150c35fed1(element) {
    const webkit = $e07e1602e4c4ff5c$export$78551043582a6a98();
    const css = $e07e1602e4c4ff5c$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e07e1602e4c4ff5c$export$940d8225183e1404(element) {
    let currentNode = $e07e1602e4c4ff5c$export$4e12058fc4d51d56(element);
    while($e07e1602e4c4ff5c$export$1b3bfaa9684536aa(currentNode) && !$e07e1602e4c4ff5c$export$d1162fb0b6d4cd51(currentNode)){
        if ($e07e1602e4c4ff5c$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $e07e1602e4c4ff5c$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e07e1602e4c4ff5c$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e07e1602e4c4ff5c$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e07e1602e4c4ff5c$export$651544f548703224(node));
}
function $e07e1602e4c4ff5c$export$3735103072e4a80(element) {
    return $e07e1602e4c4ff5c$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e07e1602e4c4ff5c$export$dc8fc79fa2800137(element) {
    if ($e07e1602e4c4ff5c$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $e07e1602e4c4ff5c$export$4e12058fc4d51d56(node) {
    if ($e07e1602e4c4ff5c$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e07e1602e4c4ff5c$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e07e1602e4c4ff5c$export$e495491855dc5418(node);
    return $e07e1602e4c4ff5c$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e07e1602e4c4ff5c$export$7cd01a57c8ca906c(node) {
    const parentNode = $e07e1602e4c4ff5c$export$4e12058fc4d51d56(node);
    if ($e07e1602e4c4ff5c$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e07e1602e4c4ff5c$export$1b3bfaa9684536aa(parentNode) && $e07e1602e4c4ff5c$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e07e1602e4c4ff5c$export$7cd01a57c8ca906c(parentNode);
}
function $e07e1602e4c4ff5c$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $e07e1602e4c4ff5c$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e07e1602e4c4ff5c$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $e07e1602e4c4ff5c$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], win.frameElement && traverseIframes ? $e07e1602e4c4ff5c$export$3b57c1601291186b(win.frameElement) : []);
    return list.concat(scrollableAncestor, $e07e1602e4c4ff5c$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}


function $729e420fd9c85e8f$var$getCssDimensions(element) {
    const css = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $93031e4206e8e991$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $93031e4206e8e991$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $729e420fd9c85e8f$var$unwrapElement(element) {
    return !(0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $729e420fd9c85e8f$var$getScale(element) {
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    if (!(0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(domElement)) return (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $729e420fd9c85e8f$var$getCssDimensions(domElement);
    let x = ($ ? (0, $93031e4206e8e991$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $93031e4206e8e991$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $729e420fd9c85e8f$var$noOffsets = /*#__PURE__*/ (0, $93031e4206e8e991$export$a397704b5e280835)(0);
function $729e420fd9c85e8f$var$getVisualOffsets(element) {
    const win = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element);
    if (!(0, $e07e1602e4c4ff5c$export$78551043582a6a98)() || !win.visualViewport) return $729e420fd9c85e8f$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $729e420fd9c85e8f$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $729e420fd9c85e8f$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $729e420fd9c85e8f$var$unwrapElement(element);
    let scale = (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(offsetParent)) scale = $729e420fd9c85e8f$var$getScale(offsetParent);
        } else scale = $729e420fd9c85e8f$var$getScale(element);
    }
    const visualOffsets = $729e420fd9c85e8f$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $729e420fd9c85e8f$var$getVisualOffsets(domElement) : (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $729e420fd9c85e8f$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $93031e4206e8e991$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const offsets = (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) !== "body" || (0, $e07e1602e4c4ff5c$export$989e911fa9af580a)(documentElement)) scroll = (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent);
            scale = $729e420fd9c85e8f$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $729e420fd9c85e8f$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $729e420fd9c85e8f$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $729e420fd9c85e8f$var$getBoundingClientRect((0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element)).left + (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $729e420fd9c85e8f$var$getDocumentRect(element) {
    const html = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element);
    const scroll = (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $93031e4206e8e991$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $93031e4206e8e991$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $729e420fd9c85e8f$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $e07e1602e4c4ff5c$export$3735103072e4a80)(body).direction === "rtl") x += (0, $93031e4206e8e991$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getViewportRect(element, strategy) {
    const win = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element);
    const html = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $e07e1602e4c4ff5c$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $729e420fd9c85e8f$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element) ? $729e420fd9c85e8f$var$getScale(element) : (0, $93031e4206e8e991$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $729e420fd9c85e8f$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $729e420fd9c85e8f$var$getDocumentRect((0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element));
    else if ((0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $729e420fd9c85e8f$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $729e420fd9c85e8f$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $93031e4206e8e991$export$ee05aea0aeecbad4)(rect);
}
function $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $e07e1602e4c4ff5c$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(parentNode) || (0, $e07e1602e4c4ff5c$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(parentNode).position === "fixed" || $729e420fd9c85e8f$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $729e420fd9c85e8f$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $e07e1602e4c4ff5c$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(el) && (0, $e07e1602e4c4ff5c$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $e07e1602e4c4ff5c$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d)(currentNode) && !(0, $e07e1602e4c4ff5c$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $e07e1602e4c4ff5c$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $e07e1602e4c4ff5c$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $729e420fd9c85e8f$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $e07e1602e4c4ff5c$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $729e420fd9c85e8f$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $729e420fd9c85e8f$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $93031e4206e8e991$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $93031e4206e8e991$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $93031e4206e8e991$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $729e420fd9c85e8f$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $729e420fd9c85e8f$var$getDimensions(element) {
    return $729e420fd9c85e8f$var$getCssDimensions(element);
}
function $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $729e420fd9c85e8f$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $93031e4206e8e991$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) !== "body" || (0, $e07e1602e4c4ff5c$export$989e911fa9af580a)(documentElement)) scroll = (0, $e07e1602e4c4ff5c$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $729e420fd9c85e8f$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $729e420fd9c85e8f$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element) || (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $729e420fd9c85e8f$var$getOffsetParent(element, polyfill) {
    const window = (0, $e07e1602e4c4ff5c$export$38b2d434cce3ea22)(element);
    if (!(0, $e07e1602e4c4ff5c$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $e07e1602e4c4ff5c$export$71535ffaa902797f)(offsetParent) && (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $729e420fd9c85e8f$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) === "html" || (0, $e07e1602e4c4ff5c$export$651544f548703224)(offsetParent) === "body" && (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $e07e1602e4c4ff5c$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $e07e1602e4c4ff5c$export$940d8225183e1404)(element) || window;
}
const $729e420fd9c85e8f$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $729e420fd9c85e8f$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $729e420fd9c85e8f$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $729e420fd9c85e8f$var$isRTL(element) {
    return (0, $e07e1602e4c4ff5c$export$3735103072e4a80)(element).direction === "rtl";
}
const $729e420fd9c85e8f$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $729e420fd9c85e8f$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $e07e1602e4c4ff5c$export$e495491855dc5418,
    getClippingRect: $729e420fd9c85e8f$var$getClippingRect,
    getOffsetParent: $729e420fd9c85e8f$var$getOffsetParent,
    getElementRects: $729e420fd9c85e8f$var$getElementRects,
    getClientRects: $729e420fd9c85e8f$var$getClientRects,
    getDimensions: $729e420fd9c85e8f$var$getDimensions,
    getScale: $729e420fd9c85e8f$var$getScale,
    isElement: $e07e1602e4c4ff5c$export$45a5e7f76e0caa8d,
    isRTL: $729e420fd9c85e8f$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $729e420fd9c85e8f$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $e07e1602e4c4ff5c$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $93031e4206e8e991$export$a3fe094919f356fd)(top);
        const insetRight = (0, $93031e4206e8e991$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $93031e4206e8e991$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $93031e4206e8e991$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $93031e4206e8e991$export$8960430cfd85939f)(0, (0, $93031e4206e8e991$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $729e420fd9c85e8f$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $729e420fd9c85e8f$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $e07e1602e4c4ff5c$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $e07e1602e4c4ff5c$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $729e420fd9c85e8f$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $729e420fd9c85e8f$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $729e420fd9c85e8f$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $729e420fd9c85e8f$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $729e420fd9c85e8f$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $28f1bf2594995773$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};


var $02c2aab7657be691$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $02c2aab7657be691$exports) {
        classNames.default = classNames;
        $02c2aab7657be691$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $6qd2L = parcelRequire("6qd2L");
const $6569f55e54f7ff9d$var$f = "react-tooltip-core-styles", $6569f55e54f7ff9d$var$h = "react-tooltip-base-styles", $6569f55e54f7ff9d$var$w = {
    core: !1,
    base: !1
};
function $6569f55e54f7ff9d$var$b({ css: e, id: t = $6569f55e54f7ff9d$var$h, type: r = "base", ref: o }) {
    var n, l;
    if (!e || "undefined" == typeof document || $6569f55e54f7ff9d$var$w[r]) return;
    if ("core" === r && "undefined" != typeof $6qd2L && (null === (n = null === $6qd2L || void 0 === $6qd2L ? void 0 : $6qd2L.env) || void 0 === n ? void 0 : n.REACT_TOOLTIP_DISABLE_CORE_STYLES)) return;
    if ("base" !== r && "undefined" != typeof $6qd2L && (null === (l = null === $6qd2L || void 0 === $6qd2L ? void 0 : $6qd2L.env) || void 0 === l ? void 0 : l.REACT_TOOLTIP_DISABLE_BASE_STYLES)) return;
    "core" === r && (t = $6569f55e54f7ff9d$var$f), o || (o = {});
    const { insertAt: i } = o;
    if (document.getElementById(t)) return void console.warn(`[react-tooltip] Element with id '${t}' already exists. Call \`removeStyle()\` first`);
    const c = document.head || document.getElementsByTagName("head")[0], a = document.createElement("style");
    a.id = t, a.type = "text/css", "top" === i && c.firstChild ? c.insertBefore(a, c.firstChild) : c.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e)), $6569f55e54f7ff9d$var$w[r] = !0;
}
function $6569f55e54f7ff9d$export$afe978aceb0adefd({ type: e = "base", id: t = $6569f55e54f7ff9d$var$h } = {}) {
    if (!$6569f55e54f7ff9d$var$w[e]) return;
    "core" === e && (t = $6569f55e54f7ff9d$var$f);
    const r = document.getElementById(t);
    "style" === (null == r ? void 0 : r.tagName) ? null == r || r.remove() : console.warn(`[react-tooltip] Failed to remove 'style' element with id '${t}'. Call \`injectStyle()\` first`), $6569f55e54f7ff9d$var$w[e] = !1;
}
const $6569f55e54f7ff9d$var$E = (e, t, r)=>{
    let o = null;
    return function(...n) {
        const l = ()=>{
            o = null, r || e.apply(this, n);
        };
        r && !o && (e.apply(this, n), o = setTimeout(l, t)), r || (o && clearTimeout(o), o = setTimeout(l, t));
    };
}, $6569f55e54f7ff9d$var$_ = "DEFAULT_TOOLTIP_ID", $6569f55e54f7ff9d$var$g = {
    anchorRefs: new Set,
    activeAnchor: {
        current: null
    },
    attach: ()=>{},
    detach: ()=>{},
    setActiveAnchor: ()=>{}
}, $6569f55e54f7ff9d$var$A = (0, $exYeM.createContext)({
    getTooltipData: ()=>$6569f55e54f7ff9d$var$g
}), $6569f55e54f7ff9d$export$f78649fb9ca566b8 = ({ children: t })=>{
    const [l, i] = (0, $exYeM.useState)({
        [$6569f55e54f7ff9d$var$_]: new Set
    }), [c, a] = (0, $exYeM.useState)({
        [$6569f55e54f7ff9d$var$_]: {
            current: null
        }
    }), s = (e, ...t)=>{
        i((r)=>{
            var o;
            const n = null !== (o = r[e]) && void 0 !== o ? o : new Set;
            return t.forEach((e)=>n.add(e)), {
                ...r,
                [e]: new Set(n)
            };
        });
    }, u = (e, ...t)=>{
        i((r)=>{
            const o = r[e];
            return o ? (t.forEach((e)=>o.delete(e)), {
                ...r
            }) : r;
        });
    }, d = (0, $exYeM.useCallback)((e = $6569f55e54f7ff9d$var$_)=>{
        var t, r;
        return {
            anchorRefs: null !== (t = l[e]) && void 0 !== t ? t : new Set,
            activeAnchor: null !== (r = c[e]) && void 0 !== r ? r : {
                current: null
            },
            attach: (...t)=>s(e, ...t),
            detach: (...t)=>u(e, ...t),
            setActiveAnchor: (t)=>((e, t)=>{
                    a((r)=>{
                        var o;
                        return (null === (o = r[e]) || void 0 === o ? void 0 : o.current) === t.current ? r : {
                            ...r,
                            [e]: t
                        };
                    });
                })(e, t)
        };
    }, [
        l,
        c,
        s,
        u
    ]), p = (0, $exYeM.useMemo)(()=>({
            getTooltipData: d
        }), [
        d
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6569f55e54f7ff9d$var$A.Provider, {
        value: p
    }, t);
};
function $6569f55e54f7ff9d$var$O(e = $6569f55e54f7ff9d$var$_) {
    return (0, $exYeM.useContext)($6569f55e54f7ff9d$var$A).getTooltipData(e);
}
const $6569f55e54f7ff9d$export$57a09c4864b20b90 = ({ tooltipId: t, children: r, className: o, place: n, content: l, html: a, variant: s, offset: u, wrapper: d, events: p, positionStrategy: v, delayShow: m, delayHide: f })=>{
    const { attach: h, detach: w } = $6569f55e54f7ff9d$var$O(t), b = (0, $exYeM.useRef)(null);
    return (0, $exYeM.useEffect)(()=>(h(b), ()=>{
            w(b);
        }), []), (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        ref: b,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("react-tooltip-wrapper", o),
        "data-tooltip-place": n,
        "data-tooltip-content": l,
        "data-tooltip-html": a,
        "data-tooltip-variant": s,
        "data-tooltip-offset": u,
        "data-tooltip-wrapper": d,
        "data-tooltip-events": p,
        "data-tooltip-position-strategy": v,
        "data-tooltip-delay-show": m,
        "data-tooltip-delay-hide": f
    }, r);
}, $6569f55e54f7ff9d$var$R = "undefined" != typeof window ? (0, $exYeM.useLayoutEffect) : (0, $exYeM.useEffect), $6569f55e54f7ff9d$var$N = (e)=>{
    if (!(e instanceof HTMLElement || e instanceof SVGElement)) return !1;
    const t = getComputedStyle(e);
    return [
        "overflow",
        "overflow-x",
        "overflow-y"
    ].some((e)=>{
        const r = t.getPropertyValue(e);
        return "auto" === r || "scroll" === r;
    });
}, $6569f55e54f7ff9d$var$k = (e)=>{
    if (!e) return null;
    let t = e.parentElement;
    for(; t;){
        if ($6569f55e54f7ff9d$var$N(t)) return t;
        t = t.parentElement;
    }
    return document.scrollingElement || document.documentElement;
}, $6569f55e54f7ff9d$var$x = async ({ elementReference: e = null, tooltipReference: t = null, tooltipArrowReference: r = null, place: o = "top", offset: n = 10, strategy: l = "absolute", middlewares: i = [
    (0, $28f1bf2594995773$export$cc800923e997bb8)(Number(n)),
    (0, $28f1bf2594995773$export$8a83211c878a3f1f)(),
    (0, $28f1bf2594995773$export$fba63a578e423eb)({
        padding: 5
    })
], border: c })=>{
    if (!e) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: o
    };
    if (null === t) return {
        tooltipStyles: {},
        tooltipArrowStyles: {},
        place: o
    };
    const a = i;
    return r ? (a.push((0, $28f1bf2594995773$export$f2120bbfa5450bd2)({
        element: r,
        padding: 5
    })), (0, $729e420fd9c85e8f$export$48a53dcb22e581d0)(e, t, {
        placement: o,
        strategy: l,
        middleware: a
    }).then(({ x: e, y: t, placement: r, middlewareData: o })=>{
        var n, l;
        const i = {
            left: `${e}px`,
            top: `${t}px`,
            border: c
        }, { x: a, y: s } = null !== (n = o.arrow) && void 0 !== n ? n : {
            x: 0,
            y: 0
        }, u = null !== (l = ({
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
        })[r.split("-")[0]]) && void 0 !== l ? l : "bottom", d = c && {
            borderBottom: c,
            borderRight: c
        };
        let p = 0;
        if (c) {
            const e = `${c}`.match(/(\d+)px/);
            p = (null == e ? void 0 : e[1]) ? Number(e[1]) : 1;
        }
        return {
            tooltipStyles: i,
            tooltipArrowStyles: {
                left: null != a ? `${a}px` : "",
                top: null != s ? `${s}px` : "",
                right: "",
                bottom: "",
                ...d,
                [u]: `-${4 + p}px`
            },
            place: r
        };
    })) : (0, $729e420fd9c85e8f$export$48a53dcb22e581d0)(e, t, {
        placement: "bottom",
        strategy: l,
        middleware: a
    }).then(({ x: e, y: t, placement: r })=>({
            tooltipStyles: {
                left: `${e}px`,
                top: `${t}px`
            },
            tooltipArrowStyles: {},
            place: r
        }));
};
var $6569f55e54f7ff9d$var$C = "core-styles-module_tooltip__3vRRp", $6569f55e54f7ff9d$var$$ = "core-styles-module_fixed__pcSol", $6569f55e54f7ff9d$var$I = "core-styles-module_arrow__cvMwQ", $6569f55e54f7ff9d$var$j = "core-styles-module_noArrow__xock6", $6569f55e54f7ff9d$var$B = "core-styles-module_clickable__ZuTTB", $6569f55e54f7ff9d$var$D = "core-styles-module_show__Nt9eE", $6569f55e54f7ff9d$var$H = {
    tooltip: "styles-module_tooltip__mnnfp",
    arrow: "styles-module_arrow__K0L3T",
    dark: "styles-module_dark__xNqje",
    light: "styles-module_light__Z6W-X",
    success: "styles-module_success__A2AKt",
    warning: "styles-module_warning__SCK0X",
    error: "styles-module_error__JvumD",
    info: "styles-module_info__BWdHW"
};
const $6569f55e54f7ff9d$var$z = ({ id: t, className: n, classNameArrow: l, variant: a = "dark", anchorId: s, anchorSelect: u, place: d = "top", offset: p = 10, events: v = [
    "hover"
], openOnClick: f = !1, positionStrategy: h = "absolute", middlewares: w, wrapper: b, delayShow: S = 0, delayHide: _ = 0, float: g = !1, hidden: A = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: N = !1, closeOnScroll: z = !1, closeOnResize: q = !1, style: W, position: M, afterShow: P, afterHide: F, content: K, contentWrapperRef: U, isOpen: X, setIsOpen: Y, activeAnchor: V, setActiveAnchor: Z, border: G, opacity: J, arrowColor: Q })=>{
    const ee = (0, $exYeM.useRef)(null), te = (0, $exYeM.useRef)(null), re = (0, $exYeM.useRef)(null), oe = (0, $exYeM.useRef)(null), [ne, le] = (0, $exYeM.useState)(d), [ie, ce] = (0, $exYeM.useState)({}), [ae, se] = (0, $exYeM.useState)({}), [ue, de] = (0, $exYeM.useState)(!1), [pe, ve] = (0, $exYeM.useState)(!1), me = (0, $exYeM.useRef)(!1), ye = (0, $exYeM.useRef)(null), { anchorRefs: fe, setActiveAnchor: he } = $6569f55e54f7ff9d$var$O(t), we = (0, $exYeM.useRef)(!1), [be, Se] = (0, $exYeM.useState)([]), Ee = (0, $exYeM.useRef)(!1), _e = f || v.includes("click");
    $6569f55e54f7ff9d$var$R(()=>(Ee.current = !0, ()=>{
            Ee.current = !1;
        }), []), (0, $exYeM.useEffect)(()=>{
        if (!ue) {
            const e = setTimeout(()=>{
                ve(!1);
            }, 150);
            return ()=>{
                clearTimeout(e);
            };
        }
        return ()=>null;
    }, [
        ue
    ]);
    const ge = (e)=>{
        Ee.current && (e && ve(!0), setTimeout(()=>{
            Ee.current && (null == Y || Y(e), void 0 === X && de(e));
        }, 10));
    };
    (0, $exYeM.useEffect)(()=>{
        if (void 0 === X) return ()=>null;
        X && ve(!0);
        const e = setTimeout(()=>{
            de(X);
        }, 10);
        return ()=>{
            clearTimeout(e);
        };
    }, [
        X
    ]), (0, $exYeM.useEffect)(()=>{
        ue !== me.current && (me.current = ue, ue ? null == P || P() : null == F || F());
    }, [
        ue
    ]);
    const Ae = (e = _)=>{
        oe.current && clearTimeout(oe.current), oe.current = setTimeout(()=>{
            we.current || ge(!1);
        }, e);
    }, Te = (e)=>{
        var t;
        if (!e) return;
        const r = null !== (t = e.currentTarget) && void 0 !== t ? t : e.target;
        if (!(null == r ? void 0 : r.isConnected)) return Z(null), void he({
            current: null
        });
        S ? (re.current && clearTimeout(re.current), re.current = setTimeout(()=>{
            ge(!0);
        }, S)) : ge(!0), Z(r), he({
            current: r
        }), oe.current && clearTimeout(oe.current);
    }, Oe = ()=>{
        L ? Ae(_ || 100) : _ ? Ae() : ge(!1), re.current && clearTimeout(re.current);
    }, Le = ({ x: e, y: t })=>{
        $6569f55e54f7ff9d$var$x({
            place: d,
            offset: p,
            elementReference: {
                getBoundingClientRect: ()=>({
                        x: e,
                        y: t,
                        width: 0,
                        height: 0,
                        top: t,
                        left: e,
                        right: e,
                        bottom: t
                    })
            },
            tooltipReference: ee.current,
            tooltipArrowReference: te.current,
            strategy: h,
            middlewares: w,
            border: G
        }).then((e)=>{
            Object.keys(e.tooltipStyles).length && ce(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && se(e.tooltipArrowStyles), le(e.place);
        });
    }, Re = (e)=>{
        if (!e) return;
        const t = e, r = {
            x: t.clientX,
            y: t.clientY
        };
        Le(r), ye.current = r;
    }, Ne = (e)=>{
        Te(e), _ && Ae();
    }, ke = (e)=>{
        var t;
        [
            document.querySelector(`[id='${s}']`),
            ...be
        ].some((t)=>null == t ? void 0 : t.contains(e.target)) || (null === (t = ee.current) || void 0 === t ? void 0 : t.contains(e.target)) || (ge(!1), re.current && clearTimeout(re.current));
    }, xe = $6569f55e54f7ff9d$var$E(Te, 50, !0), Ce = $6569f55e54f7ff9d$var$E(Oe, 50, !0), $e = (0, $exYeM.useCallback)(()=>{
        M ? Le(M) : g ? ye.current && Le(ye.current) : $6569f55e54f7ff9d$var$x({
            place: d,
            offset: p,
            elementReference: V,
            tooltipReference: ee.current,
            tooltipArrowReference: te.current,
            strategy: h,
            middlewares: w,
            border: G
        }).then((e)=>{
            Ee.current && (Object.keys(e.tooltipStyles).length && ce(e.tooltipStyles), Object.keys(e.tooltipArrowStyles).length && se(e.tooltipArrowStyles), le(e.place));
        });
    }, [
        ue,
        V,
        K,
        W,
        d,
        p,
        h,
        M,
        g
    ]);
    (0, $exYeM.useEffect)(()=>{
        var e, t;
        const r = new Set(fe);
        be.forEach((e)=>{
            r.add({
                current: e
            });
        });
        const o = document.querySelector(`[id='${s}']`);
        o && r.add({
            current: o
        });
        const n = ()=>{
            ge(!1);
        }, l = $6569f55e54f7ff9d$var$k(V), i = $6569f55e54f7ff9d$var$k(ee.current);
        z && (window.addEventListener("scroll", n), null == l || l.addEventListener("scroll", n), null == i || i.addEventListener("scroll", n));
        let c = null;
        q ? window.addEventListener("resize", n) : V && ee.current && (c = (0, $729e420fd9c85e8f$export$deee3a793edee05f)(V, ee.current, $e, {
            ancestorResize: !0,
            elementResize: !0,
            layoutShift: !0
        }));
        const a = (e)=>{
            "Escape" === e.key && ge(!1);
        };
        N && window.addEventListener("keydown", a);
        const u = [];
        _e ? (window.addEventListener("click", ke), u.push({
            event: "click",
            listener: Ne
        })) : (u.push({
            event: "mouseenter",
            listener: xe
        }, {
            event: "mouseleave",
            listener: Ce
        }, {
            event: "focus",
            listener: xe
        }, {
            event: "blur",
            listener: Ce
        }), g && u.push({
            event: "mousemove",
            listener: Re
        }));
        const d = ()=>{
            we.current = !0;
        }, p = ()=>{
            we.current = !1, Oe();
        };
        return L && !_e && (null === (e = ee.current) || void 0 === e || e.addEventListener("mouseenter", d), null === (t = ee.current) || void 0 === t || t.addEventListener("mouseleave", p)), u.forEach(({ event: e, listener: t })=>{
            r.forEach((r)=>{
                var o;
                null === (o = r.current) || void 0 === o || o.addEventListener(e, t);
            });
        }), ()=>{
            var e, t;
            z && (window.removeEventListener("scroll", n), null == l || l.removeEventListener("scroll", n), null == i || i.removeEventListener("scroll", n)), q ? window.removeEventListener("resize", n) : null == c || c(), _e && window.removeEventListener("click", ke), N && window.removeEventListener("keydown", a), L && !_e && (null === (e = ee.current) || void 0 === e || e.removeEventListener("mouseenter", d), null === (t = ee.current) || void 0 === t || t.removeEventListener("mouseleave", p)), u.forEach(({ event: e, listener: t })=>{
                r.forEach((r)=>{
                    var o;
                    null === (o = r.current) || void 0 === o || o.removeEventListener(e, t);
                });
            });
        };
    }, [
        V,
        $e,
        pe,
        fe,
        be,
        N,
        v
    ]), (0, $exYeM.useEffect)(()=>{
        let e = null != u ? u : "";
        !e && t && (e = `[data-tooltip-id='${t}']`);
        const r = new MutationObserver((r)=>{
            const o = [];
            r.forEach((r)=>{
                if ("attributes" === r.type && "data-tooltip-id" === r.attributeName) r.target.getAttribute("data-tooltip-id") === t && o.push(r.target);
                if ("childList" === r.type && (V && [
                    ...r.removedNodes
                ].some((e)=>{
                    var t;
                    return !!(null === (t = null == e ? void 0 : e.contains) || void 0 === t ? void 0 : t.call(e, V)) && (ve(!1), ge(!1), Z(null), re.current && clearTimeout(re.current), oe.current && clearTimeout(oe.current), !0);
                }), e)) try {
                    const t = [
                        ...r.addedNodes
                    ].filter((e)=>1 === e.nodeType);
                    o.push(...t.filter((t)=>t.matches(e))), o.push(...t.flatMap((t)=>[
                            ...t.querySelectorAll(e)
                        ]));
                } catch (e) {}
            }), o.length && Se((e)=>[
                    ...e,
                    ...o
                ]);
        });
        return r.observe(document.body, {
            childList: !0,
            subtree: !0,
            attributes: !0,
            attributeFilter: [
                "data-tooltip-id"
            ]
        }), ()=>{
            r.disconnect();
        };
    }, [
        t,
        u,
        V
    ]), (0, $exYeM.useEffect)(()=>{
        $e();
    }, [
        $e
    ]), (0, $exYeM.useEffect)(()=>{
        if (!(null == U ? void 0 : U.current)) return ()=>null;
        const e = new ResizeObserver(()=>{
            $e();
        });
        return e.observe(U.current), ()=>{
            e.disconnect();
        };
    }, [
        K,
        null == U ? void 0 : U.current
    ]), (0, $exYeM.useEffect)(()=>{
        var e;
        const t = document.querySelector(`[id='${s}']`), r = [
            ...be,
            t
        ];
        V && r.includes(V) || Z(null !== (e = be[0]) && void 0 !== e ? e : t);
    }, [
        s,
        be,
        V
    ]), (0, $exYeM.useEffect)(()=>()=>{
            re.current && clearTimeout(re.current), oe.current && clearTimeout(oe.current);
        }, []), (0, $exYeM.useEffect)(()=>{
        let e = u;
        if (!e && t && (e = `[data-tooltip-id='${t}']`), e) try {
            const t = Array.from(document.querySelectorAll(e));
            Se(t);
        } catch (e) {
            Se([]);
        }
    }, [
        t,
        u
    ]);
    const Ie = !A && K && ue && Object.keys(ie).length > 0;
    return pe ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(b, {
        id: t,
        role: "tooltip",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("react-tooltip", $6569f55e54f7ff9d$var$C, $6569f55e54f7ff9d$var$H.tooltip, $6569f55e54f7ff9d$var$H[a], n, `react-tooltip__place-${ne}`, {
            "react-tooltip__show": Ie,
            [$6569f55e54f7ff9d$var$D]: Ie,
            [$6569f55e54f7ff9d$var$$]: "fixed" === h,
            [$6569f55e54f7ff9d$var$B]: L
        }),
        style: {
            ...W,
            ...ie,
            opacity: void 0 !== J && Ie ? J : void 0
        },
        ref: ee
    }, K, (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement(b, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("react-tooltip-arrow", $6569f55e54f7ff9d$var$I, $6569f55e54f7ff9d$var$H.arrow, l, {
            [$6569f55e54f7ff9d$var$j]: T
        }),
        style: {
            ...ae,
            background: Q ? `linear-gradient(to right bottom, transparent 50%, ${Q} 50%)` : void 0
        },
        ref: te
    })) : null;
}, $6569f55e54f7ff9d$var$q = ({ content: t })=>(0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: t
        }
    }), $6569f55e54f7ff9d$export$28c660c63b792dea = ({ id: t, anchorId: o, anchorSelect: n, content: l, html: a, render: s, className: u, classNameArrow: d, variant: p = "dark", place: v = "top", offset: m = 10, wrapper: y = "div", children: f = null, events: h = [
    "hover"
], openOnClick: w = !1, positionStrategy: b = "absolute", middlewares: S, delayShow: E = 0, delayHide: _ = 0, float: g = !1, hidden: A = !1, noArrow: T = !1, clickable: L = !1, closeOnEsc: R = !1, closeOnScroll: N = !1, closeOnResize: k = !1, style: x, position: C, isOpen: $, disableStyleInjection: I = !1, border: j, opacity: B, arrowColor: D, setIsOpen: H, afterShow: W, afterHide: M })=>{
    const [P, F] = (0, $exYeM.useState)(l), [K, U] = (0, $exYeM.useState)(a), [X, Y] = (0, $exYeM.useState)(v), [V, Z] = (0, $exYeM.useState)(p), [G, J] = (0, $exYeM.useState)(m), [Q, ee] = (0, $exYeM.useState)(E), [te, re] = (0, $exYeM.useState)(_), [oe, ne] = (0, $exYeM.useState)(g), [le, ie] = (0, $exYeM.useState)(A), [ce, ae] = (0, $exYeM.useState)(y), [se, ue] = (0, $exYeM.useState)(h), [de, pe] = (0, $exYeM.useState)(b), [ve, me] = (0, $exYeM.useState)(null), ye = (0, $exYeM.useRef)(I), { anchorRefs: fe, activeAnchor: he } = $6569f55e54f7ff9d$var$O(t), we = (e)=>null == e ? void 0 : e.getAttributeNames().reduce((t, r)=>{
            var o;
            if (r.startsWith("data-tooltip-")) t[r.replace(/^data-tooltip-/, "")] = null !== (o = null == e ? void 0 : e.getAttribute(r)) && void 0 !== o ? o : null;
            return t;
        }, {}), be = (e)=>{
        const t = {
            place: (e)=>{
                var t;
                Y(null !== (t = e) && void 0 !== t ? t : v);
            },
            content: (e)=>{
                F(null != e ? e : l);
            },
            html: (e)=>{
                U(null != e ? e : a);
            },
            variant: (e)=>{
                var t;
                Z(null !== (t = e) && void 0 !== t ? t : p);
            },
            offset: (e)=>{
                J(null === e ? m : Number(e));
            },
            wrapper: (e)=>{
                var t;
                ae(null !== (t = e) && void 0 !== t ? t : y);
            },
            events: (e)=>{
                const t = null == e ? void 0 : e.split(" ");
                ue(null != t ? t : h);
            },
            "position-strategy": (e)=>{
                var t;
                pe(null !== (t = e) && void 0 !== t ? t : b);
            },
            "delay-show": (e)=>{
                ee(null === e ? E : Number(e));
            },
            "delay-hide": (e)=>{
                re(null === e ? _ : Number(e));
            },
            float: (e)=>{
                ne(null === e ? g : "true" === e);
            },
            hidden: (e)=>{
                ie(null === e ? A : "true" === e);
            }
        };
        Object.values(t).forEach((e)=>e(null)), Object.entries(e).forEach(([e, r])=>{
            var o;
            null === (o = t[e]) || void 0 === o || o.call(t, r);
        });
    };
    (0, $exYeM.useEffect)(()=>{
        F(l);
    }, [
        l
    ]), (0, $exYeM.useEffect)(()=>{
        U(a);
    }, [
        a
    ]), (0, $exYeM.useEffect)(()=>{
        Y(v);
    }, [
        v
    ]), (0, $exYeM.useEffect)(()=>{
        Z(p);
    }, [
        p
    ]), (0, $exYeM.useEffect)(()=>{
        J(m);
    }, [
        m
    ]), (0, $exYeM.useEffect)(()=>{
        ee(E);
    }, [
        E
    ]), (0, $exYeM.useEffect)(()=>{
        re(_);
    }, [
        _
    ]), (0, $exYeM.useEffect)(()=>{
        ne(g);
    }, [
        g
    ]), (0, $exYeM.useEffect)(()=>{
        ie(A);
    }, [
        A
    ]), (0, $exYeM.useEffect)(()=>{
        pe(b);
    }, [
        b
    ]), (0, $exYeM.useEffect)(()=>{
        ye.current !== I && console.warn("[react-tooltip] Do not change `disableStyleInjection` dynamically.");
    }, [
        I
    ]), (0, $exYeM.useEffect)(()=>{
        "undefined" != typeof window && window.dispatchEvent(new CustomEvent("react-tooltip-inject-styles", {
            detail: {
                disableCore: "core" === I,
                disableBase: I
            }
        }));
    }, []), (0, $exYeM.useEffect)(()=>{
        var e;
        const r = new Set(fe);
        let l = n;
        if (!l && t && (l = `[data-tooltip-id='${t}']`), l) try {
            document.querySelectorAll(l).forEach((e)=>{
                r.add({
                    current: e
                });
            });
        } catch (e) {
            console.warn(`[react-tooltip] "${l}" is not a valid CSS selector`);
        }
        const i = document.querySelector(`[id='${o}']`);
        if (i && r.add({
            current: i
        }), !r.size) return ()=>null;
        const c = null !== (e = null != ve ? ve : i) && void 0 !== e ? e : he.current, a = new MutationObserver((e)=>{
            e.forEach((e)=>{
                var t;
                if (!c || "attributes" !== e.type || !(null === (t = e.attributeName) || void 0 === t ? void 0 : t.startsWith("data-tooltip-"))) return;
                const r = we(c);
                be(r);
            });
        }), s = {
            attributes: !0,
            childList: !1,
            subtree: !1
        };
        if (c) {
            const e = we(c);
            be(e), a.observe(c, s);
        }
        return ()=>{
            a.disconnect();
        };
    }, [
        fe,
        he,
        ve,
        o,
        n
    ]), (0, $exYeM.useEffect)(()=>{
        (null == x ? void 0 : x.border) && console.warn("[react-tooltip] Do not set `style.border`. Use `border` prop instead."), j && !CSS.supports("border", `${j}`) && console.warn(`[react-tooltip] "${j}" is not a valid \`border\`.`), (null == x ? void 0 : x.opacity) && console.warn("[react-tooltip] Do not set `style.opacity`. Use `opacity` prop instead."), B && !CSS.supports("opacity", `${B}`) && console.warn(`[react-tooltip] "${B}" is not a valid \`opacity\`.`);
    }, []);
    let Se = f;
    const Ee = (0, $exYeM.useRef)(null);
    if (s) {
        const t = s({
            content: null != P ? P : null,
            activeAnchor: ve
        });
        Se = t ? (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement("div", {
            ref: Ee,
            className: "react-tooltip-content-wrapper"
        }, t) : null;
    } else P && (Se = P);
    K && (Se = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6569f55e54f7ff9d$var$q, {
        content: K
    }));
    const _e = {
        id: t,
        anchorId: o,
        anchorSelect: n,
        className: u,
        classNameArrow: d,
        content: Se,
        contentWrapperRef: Ee,
        place: X,
        variant: V,
        offset: G,
        wrapper: ce,
        events: se,
        openOnClick: w,
        positionStrategy: de,
        middlewares: S,
        delayShow: Q,
        delayHide: te,
        float: oe,
        hidden: le,
        noArrow: T,
        clickable: L,
        closeOnEsc: R,
        closeOnScroll: N,
        closeOnResize: k,
        style: x,
        position: C,
        isOpen: $,
        border: j,
        opacity: B,
        arrowColor: D,
        setIsOpen: H,
        afterShow: W,
        afterHide: M,
        activeAnchor: ve,
        setActiveAnchor: (e)=>me(e)
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($6569f55e54f7ff9d$var$z, {
        ..._e
    });
};
"undefined" != typeof window && window.addEventListener("react-tooltip-inject-styles", (e)=>{
    e.detail.disableCore || $6569f55e54f7ff9d$var$b({
        css: `:root{--rt-color-white:#fff;--rt-color-dark:#222;--rt-color-success:#8dc572;--rt-color-error:#be6464;--rt-color-warning:#f0ad4e;--rt-color-info:#337ab7;--rt-opacity:0.9}.core-styles-module_tooltip__3vRRp{visibility:hidden;position:absolute;top:0;left:0;pointer-events:none;opacity:0;transition:opacity 0.3s ease-out;will-change:opacity,visibility}.core-styles-module_fixed__pcSol{position:fixed}.core-styles-module_arrow__cvMwQ{position:absolute;background:inherit}.core-styles-module_noArrow__xock6{display:none}.core-styles-module_clickable__ZuTTB{pointer-events:auto}.core-styles-module_show__Nt9eE{visibility:visible;opacity:var(--rt-opacity)}`,
        type: "core"
    }), e.detail.disableBase || $6569f55e54f7ff9d$var$b({
        css: `
.styles-module_tooltip__mnnfp{padding:8px 16px;border-radius:3px;font-size:90%;width:max-content}.styles-module_arrow__K0L3T{width:8px;height:8px}[class*='react-tooltip__place-top']>.styles-module_arrow__K0L3T{transform:rotate(45deg)}[class*='react-tooltip__place-right']>.styles-module_arrow__K0L3T{transform:rotate(135deg)}[class*='react-tooltip__place-bottom']>.styles-module_arrow__K0L3T{transform:rotate(225deg)}[class*='react-tooltip__place-left']>.styles-module_arrow__K0L3T{transform:rotate(315deg)}.styles-module_dark__xNqje{background:var(--rt-color-dark);color:var(--rt-color-white)}.styles-module_light__Z6W-X{background-color:var(--rt-color-white);color:var(--rt-color-dark)}.styles-module_success__A2AKt{background-color:var(--rt-color-success);color:var(--rt-color-white)}.styles-module_warning__SCK0X{background-color:var(--rt-color-warning);color:var(--rt-color-white)}.styles-module_error__JvumD{background-color:var(--rt-color-error);color:var(--rt-color-white)}.styles-module_info__BWdHW{background-color:var(--rt-color-info);color:var(--rt-color-white)}`,
        type: "base"
    });
});






var $exYeM = parcelRequire("exYeM");
var $3051c38200e5c7b1$exports = {};




(function webpackUniversalModuleDefinition(root, factory) {
    $3051c38200e5c7b1$exports = factory((parcelRequire("jPR8W")), (parcelRequire("bisEj")), (parcelRequire("exYeM")), (parcelRequire("d2lNW")));
})($3051c38200e5c7b1$exports, function(__WEBPACK_EXTERNAL_MODULE_clipboard__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./index.js");
    /******/ }({
        /***/ "./index.js": /*!******************!*\
  !*** ./index.js ***!
  \******************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    var ownKeys = Object.keys(source);
                    if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                    }));
                    ownKeys.forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                }
                return target;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            var ClipboardButton = /*#__PURE__*/ function(_React$Component) {
                _inherits(ClipboardButton, _React$Component);
                function ClipboardButton() {
                    _classCallCheck(this, ClipboardButton);
                    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));
                }
                _createClass(ClipboardButton, [
                    {
                        key: "propsWith",
                        value: function propsWith(regexp) {
                            var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var object = {};
                            Object.keys(this.props).forEach(function(key) {
                                if (key.search(regexp) !== -1) {
                                    var objectKey = remove ? key.replace(regexp, "") : key;
                                    object[objectKey] = this.props[key];
                                }
                            }, this);
                            return object;
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            this.clipboard && this.clipboard.destroy();
                        }
                    },
                    {
                        key: "componentDidMount",
                        value: function componentDidMount() {
                            // Support old API by trying to assign this.props.options first;
                            var options = this.props.options || this.propsWith(/^option-/, true);
                            var element = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this.element);
                            if (!element) return;
                            var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");
                            this.clipboard = new Clipboard(element, options);
                            var callbacks = this.propsWith(/^on/, true);
                            Object.keys(callbacks).forEach(function(callback) {
                                this.clipboard.on(callback.toLowerCase(), this.props["on" + callback]);
                            }, this);
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            var _this = this;
                            var attributes = _objectSpread({
                                title: this.props.title || "",
                                type: this.getType(),
                                className: this.props.className || "",
                                style: this.props.style || {},
                                ref: function ref(element) {
                                    return _this.element = element;
                                },
                                onClick: this.props.onClick
                            }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));
                            var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");
                            if (!this.props.isVisibleWhenUnsupported && !Clipboard.isSupported()) return null;
                            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.getComponent(), attributes, this.props.children);
                        }
                    },
                    {
                        key: "getType",
                        value: function getType() {
                            if (this.getComponent() === "button" || this.getComponent() === "input") return this.props.type || "button";
                            else return undefined;
                        }
                    },
                    {
                        key: "getComponent",
                        value: function getComponent() {
                            return this.props.component || "button";
                        }
                    }
                ]);
                return ClipboardButton;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _defineProperty(ClipboardButton, "propTypes", {
                options: function options(props, propName, componentName) {
                    var options = props[propName];
                    if (options && _typeof(options) !== "object" || Array.isArray(options)) return new Error("Invalid props '".concat(propName, "' supplied to '").concat(componentName, "'. ") + "'".concat(propName, "' is not an object."));
                    if (props["option-text"] !== undefined) {
                        var optionText = props["option-text"];
                        if (typeof optionText !== "function") return new Error("Invalid props 'option-text' supplied to '".concat(componentName, "'. ") + "'option-text' is not a function.");
                    }
                },
                title: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
                component: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
                children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any
            });
            _defineProperty(ClipboardButton, "defaultProps", {
                isVisibleWhenUnsupported: true,
                onClick: function onClick() {}
            });
            /* harmony default export */ __webpack_exports__["default"] = ClipboardButton;
        /***/ },
        /***/ "clipboard": /*!********************************************************************************************************!*\
  !*** external {"root":"ClipboardJS","amd":"clipboard","commonjs":"clipboard","commonjs2":"clipboard"} ***!
  \********************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_clipboard__;
        /***/ },
        /***/ "prop-types": /*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types"} ***!
  \*********************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ },
        /***/ "react-dom": /*!*****************************************************************************************************!*\
  !*** external {"root":"ReactDOM","amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom"} ***!
  \*****************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;
        /***/ }
    });
});



function $0687b2a27624ef21$export$599327668289acbc({ article: article, articleText: articleText, setArticle: setArticle, setSoftLoading: setSoftLoading, saveArticleCustomText: saveArticleCustomText } = props) {
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [isSaving, setIsSaving] = (0, $exYeM.useState)(null);
    const [analyzeHTML, setAnalyzeHTML] = (0, $exYeM.useState)(null);
    const [url, setUrl] = (0, $exYeM.useState)(article.url || article.scrape_url);
    const [customSummary, setCustomSummary] = (0, $exYeM.useState)(article.custom_summary);
    const [copiedShareUrl, setCopiedShareUrl] = (0, $exYeM.useState)(null);
    const [showOption, setShowOption] = (0, $exYeM.useState)(null);
    const [isUpdatingSummary, setIsUpdatingSummary] = (0, $exYeM.useState)(false);
    async function handleArticleTextSave() {
        saveArticleCustomText();
    }
    async function handleReanalyzeArticle(ev) {
        ev.preventDefault();
        if (!confirm((0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Sure?") + " " + (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("The summarizer will add extra costs"))) return;
        setSoftLoading(true);
        await $e6d4445b9ec5d3b6$export$a409bf62ca41eca7(article.id, {
            analyze: analyzeHTML ? "html" : "url"
        });
        setSoftLoading(false);
    }
    async function translateWebsite(id, lang) {
        setSoftLoading(true);
        try {
            let website = (await $e6d4445b9ec5d3b6$export$a46a2e1c490934e3(id, lang)).website;
            if (website) setArticle(website);
        } catch (e) {
            console.error(e);
        }
        setSoftLoading(false);
    }
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6d99e44aa80195de$exports))), {
        onOutsideClick: ()=>{
            setShowOption(null);
        },
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("ul", {
            children: [
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $6569f55e54f7ff9d$export$28c660c63b792dea), {
                    id: "my-tooltip"
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                    id: "translate-action",
                    className: showOption === "translate-action" ? "show" : "",
                    onMouseEnter: ()=>setShowOption("translate-action"),
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "icon",
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Translate")
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("ul", {
                            className: "options",
                            children: [
                                "original",
                                "de",
                                "en-US",
                                "fr",
                                "es"
                            ].map((lan)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                    onClick: (ev)=>translateWebsite(article.id, lan),
                                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)(lan.replace(/\-.*$/, ""))
                                }, lan))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                    id: "save-action",
                    onMouseEnter: ()=>setShowOption(null),
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: "icon",
                        onClick: handleArticleTextSave,
                        "data-tooltip-id": "my-tooltip",
                        "data-tooltip-content": isSaving ? (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Text is saving…") : (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Save text"),
                        "data-tooltip-place": "left",
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Save custom text")
                    })
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                    id: "reanalyze-action",
                    className: showOption === "reanalyze-action" ? "show" : "",
                    onMouseEnter: ()=>setShowOption("reanalyze-action"),
                    style: {
                        display: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "icon",
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Create professional summarize")
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "options",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
                                className: "form",
                                onSubmit: handleReanalyzeArticle,
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Professional Summary")
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                            children: "Create a professional and comprehensive summary, without consuming the whole website / video."
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                                            children: [
                                                "You can summarize ",
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("b", {
                                                    children: "public available"
                                                }),
                                                " websites, youtube-videos and pdf-files."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("b", {
                                                children: 'If the website is behind a paywall, check the "Analzye HTML" option to send the already stashed content.'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "checkbox",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                                    htmlFor: "analyze-html",
                                                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Analyze HTML")
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    id: "analyze-html",
                                                    onChange: (ev)=>setAnalyzeHTML(ev.target.checked)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                            type: "submit",
                                            children: "Create professional summary *"
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("small", {
                                                children: "* The costs will be ~ 0.4 - 1 USD"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("small", {
                                                children: "The process may take a while (about 1min)"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                    id: "trash-action",
                    onMouseEnter: ()=>setShowOption(null),
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: "icon",
                        "data-tooltip-id": "my-tooltip",
                        "data-tooltip-content": (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Delete Article"),
                        "data-tooltip-place": "left",
                        onClick: async ()=>{
                            if (confirm((0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Sure?"))) {
                                await $e6d4445b9ec5d3b6$export$10ca37dcc57736ab(article.id);
                                navigate("/");
                            }
                        },
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Delete Article")
                    })
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                    id: "edit-action",
                    className: showOption === "edit-action" ? "show" : "",
                    onMouseEnter: ()=>setShowOption("edit-action"),
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "icon",
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Change Article URL")
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "options",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("form", {
                                className: "form",
                                onSubmit: async (ev)=>{
                                    ev.preventDefault();
                                    setSoftLoading(true);
                                    let data = {
                                        custom_summary: customSummary
                                    };
                                    if (url !== article.scrape_url) data.url = url;
                                    let website = (await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, data)).website;
                                    setArticle(website);
                                    setSoftLoading(false);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("textarea", {
                                                defaultValue: customSummary,
                                                onChange: (ev)=>setCustomSummary(ev.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                className: "small",
                                                children: !customSummary && article.custom_summary ? (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Remove custom summary") : (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Save and use custom summary above")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                type: "text",
                                                defaultValue: url,
                                                onChange: (ev)=>setUrl(ev.target.value)
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                className: "small",
                                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Change URL")
                                            })
                                        ]
                                    }),
                                    articleText && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Summarize custom text instead of auto-extracted content")
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                                                children: [
                                                    (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Helpful if the summary seems to be wrong in regards of context"),
                                                    ".",
                                                    " ",
                                                    (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("The update of the summary may take a minute or so - so please be patient"),
                                                    " ",
                                                    ":)",
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                onClick: async ()=>{
                                                    setIsUpdatingSummary(true);
                                                    let data = await $e6d4445b9ec5d3b6$export$f133bf94867451a9(article.id, articleText);
                                                    setIsUpdatingSummary(false);
                                                    setArticle(data.website);
                                                },
                                                disabled: isUpdatingSummary,
                                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Summarize custom text")
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("li", {
                    id: "share-action",
                    className: showOption === "share-action" ? "show" : "",
                    onMouseEnter: ()=>setShowOption("share-action"),
                    children: [
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                            className: "icon",
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Share Article")
                        }),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "options",
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
                                className: "form",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("fieldset", {
                                    children: article.is_public ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                                    href: `https://sitestash.net/s/${article.share_url}`,
                                                    target: "_blank",
                                                    children: `https://sitestash.net/s/${article.share_url}`
                                                })
                                            }),
                                            articleText && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                                                className: "checkbox",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("label", {
                                                        htmlFor: "share-custom-text",
                                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Share edited article text")
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                                        id: "share-custom-text",
                                                        type: "checkbox",
                                                        defaultChecked: article.share_custom_text,
                                                        onChange: async (ev)=>{
                                                            setSoftLoading(true);
                                                            let _article = await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, {
                                                                share_custom_text: ev.target.checked,
                                                                custom_text: articleText
                                                            });
                                                            setSoftLoading(false);
                                                            setArticle(_article.website);
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                className: "small",
                                                onClick: async (ev)=>{
                                                    ev.preventDefault();
                                                    setSoftLoading(true);
                                                    let result = await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, {
                                                        is_public: false
                                                    });
                                                    setSoftLoading(false);
                                                    setArticle(result.website);
                                                },
                                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Don't share article anymore")
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3051c38200e5c7b1$exports))), {
                                                "data-clipboard-text": `https://sitestash.net/s/${article.share_url}`,
                                                onSuccess: ()=>{
                                                    setCopiedShareUrl(true);
                                                    setTimeout(()=>setCopiedShareUrl(false), 1000);
                                                },
                                                className: "small",
                                                children: copiedShareUrl ? (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Copied") : (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Copy Share URL to Clipboard")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Make this article public to share it with others")
                                            }),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                onClick: async (ev)=>{
                                                    ev.preventDefault();
                                                    let result = await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, {
                                                        is_public: true
                                                    });
                                                    setArticle(result.website);
                                                },
                                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Share article")
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                    id: "star-action",
                    // className={showOption === 'share-action' ? 'show' : ''}
                    onMouseEnter: ()=>setShowOption(""),
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        className: [
                            "icon",
                            article.is_starred ? "starred" : ""
                        ].join(" "),
                        onClick: async (ev)=>{
                            ev.preventDefault();
                            let result = await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, {
                                is_starred: !article.is_starred
                            });
                            setArticle(result.website);
                        },
                        "data-tooltip-id": "my-tooltip",
                        "data-tooltip-content": article.is_starred ? (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Remove from favourites") : (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Add to favourites"),
                        "data-tooltip-place": "left",
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Star")
                    })
                })
            ]
        })
    });
}




function $7fc0690c51c045a0$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        className: "fallback-route",
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
            children: "sitestash | 404"
        })
    });
}





const $f714cc7d5a767340$var$maxProcessTimeInMinutesBeforeRegardedAsFailure = 3;
const $f714cc7d5a767340$var$checkArticleChangesInterval = 8000;
function $f714cc7d5a767340$export$4edd9f0c79152338({ setActionMenu: setActionMenu }) {
    const params = (0, $b0e6fcd50b7ef685$export$99eaa27ddbbb95ef)();
    const [article, setArticle] = (0, $exYeM.useState)(null);
    const [softLoading, setSoftLoading] = (0, $exYeM.useState)(null);
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    const [showProcessingError, setShowProcessingError] = (0, $exYeM.useState)(false);
    const [articleText, setArticleText] = (0, $exYeM.useState)(null);
    const [imageHasChanged, setImageHasChanged] = (0, $exYeM.useState)(null);
    const [articleImageUrl, setArticleImageUrl] = (0, $exYeM.useState)(null);
    const [articleImageAspectRatio, setImageAspectRatio] = (0, $exYeM.useState)(null);
    const [customArticleTitle, setCustomArticleTitle] = (0, $exYeM.useState)(null);
    const [checkProcessStatus, setCheckProcessStatus] = (0, $exYeM.useState)(false);
    const [articleNotFound, setArticleNotFound] = (0, $exYeM.useState)(null);
    const [showOriginalContent, setShowOriginalContent] = (0, $exYeM.useState)(false);
    const [showImage, setShowImage] = (0, $exYeM.useState)(false);
    const imageRef = (0, $exYeM.useRef)(null);
    const [currentUser] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    (0, $exYeM.useEffect)(()=>{
        if (!article) return;
        setArticleImageUrl(article.image?.url || article.display_image_url || article.image_url || false);
        setImageAspectRatio(article.image?.aspect_ratio || null);
        setActionMenu(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $0687b2a27624ef21$export$599327668289acbc), {
            article: article,
            articleText: articleText,
            loadAndSetArticle: loadAndSetArticle,
            setArticle: setArticle,
            setSoftLoading: setSoftLoading,
            saveArticleCustomText: saveArticleCustomText
        }));
    }, [
        article,
        articleText
    ]);
    async function handleImageLoading(ev) {
        setSoftLoading(false);
    }
    function bestCustomTextToDisplayFromArticle(article) {
        if (article.custom_text?.trim()) return article.custom_text?.replace(/\n/g, "<br>")?.replace(/\n+/g, "<br>");
        if (article.plain_content) return article.plain_content.replace(/\n{1}/g, "<br>").replace(/\n{1,}/g, "<br><br>");
        if (article.content) return article.content;
        if (article.html) {
            let result = (0, $e8247bdc531b8cd1$export$da7af07ba7ea4c5b)(article.html);
            setCustomArticleTitle(result.title);
            if (result.textContent) return result.textContent;
        }
        return null;
    }
    async function saveArticleCustomText(custom_text = null) {
        if (!custom_text) custom_text = articleText;
        setSoftLoading(true);
        let res = await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, {
            custom_text: custom_text,
            share_custom_text: !custom_text ? false : article.share_custom_text
        });
        if (res.website.custom_text === null) // fill with content from firefox reader
        setArticleText(bestCustomTextToDisplayFromArticle(res.website));
        setArticle(res.website);
        setSoftLoading(false);
    }
    (0, $exYeM.useEffect)(()=>{
        if (!article) return;
        if (articleText === null) {
            setArticleText(bestCustomTextToDisplayFromArticle(article));
            if (article.html) setCustomArticleTitle((0, $e8247bdc531b8cd1$export$da7af07ba7ea4c5b)(article.html).title);
        }
    }, [
        articleText,
        article
    ]);
    async function loadAndSetArticle(id) {
        try {
            setArticle(await $e6d4445b9ec5d3b6$export$a998db9f214ca37d(id));
            setArticleNotFound(false);
        } catch (e) {
            console.error(e);
            setArticleNotFound(true);
        }
    }
    async function checkProcessStatusOfArticleAndDisplayErrorMessageIfNeeded() {
        let website = await $e6d4445b9ec5d3b6$export$a998db9f214ca37d(article.id);
        if (website?.process_status !== "finished" && (0, $b4c5b0105a3de3c0$export$2e2bcd8739ae039)(new Date(), new Date(article.updated_at)) > $f714cc7d5a767340$var$maxProcessTimeInMinutesBeforeRegardedAsFailure) {
            setShowProcessingError(true);
            return;
        }
        if (website?.process_status === "failed") {
            setShowProcessingError(true);
            return;
        }
        if (website?.process_status === "finished") {
            function setNewArticle(website) {
                setShowProcessingError(false);
                setArticle(website);
                // set image url again to trigger image reloading
                if (imageRef.current) {
                    let imageUrl = imageRef.current.src;
                    imageRef.current.src = null;
                    imageRef.current.src = imageUrl;
                }
            }
            setNewArticle(website);
            if (article.process_status !== "finished") setTimeout(()=>{
                setNewArticle(website);
            }, 4000);
        } else setArticle(website);
    }
    (0, $exYeM.useEffect)(()=>{
        if (params.websiteID && !article) loadAndSetArticle(params.websiteID);
    }, [
        params,
        article
    ]);
    (0, $exYeM.useEffect)(()=>{
        if (!article) return;
        if (article.process_status === "finished") return;
        if (article.process_status === "failed") {
            setShowProcessingError(true);
            return;
        }
        if (location.search.includes("?wait=queue")) setCheckProcessStatus(true);
        else if ((0, $b4c5b0105a3de3c0$export$2e2bcd8739ae039)(new Date(), new Date(article.updated_at)) > $f714cc7d5a767340$var$maxProcessTimeInMinutesBeforeRegardedAsFailure) setShowProcessingError(true);
    }, [
        location,
        article
    ]);
    (0, $ee2c4bf02ed37f72$export$2e2bcd8739ae039)(()=>{
        console.log("check");
        checkProcessStatusOfArticleAndDisplayErrorMessageIfNeeded();
    }, article && checkProcessStatus && (article.process_status === "processing" || article.process_status === "queued") ? /* &&
      differenceInMinutes(new Date(), new Date(article.updated_at)) <=
        maxProcessTimeInMinutesBeforeRegardedAsFailure*/ $f714cc7d5a767340$var$checkArticleChangesInterval : null);
    async function handleToggleTitle() {
        if (!article.headline) return;
        let { website: website } = await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, {
            show_headline_instead_of_title: !article.show_headline_instead_of_title
        });
        setArticle(website);
    }
    async function updateImageUrlForArticle(url = null, save = false) {
        setImageHasChanged(true);
        let { website: website } = await $e6d4445b9ec5d3b6$export$8a6bc556b09e441b(article.id, url, save);
        if (save) setArticle(website);
        else {
            let art = {
                ...article,
                display_image_url: url,
                image_url: url
            };
            if (art.image) {
                art.image.url = url;
                art.image.aspect_ratio = null;
            }
            setArticle(art);
        }
        setSoftLoading(false);
        if (save) setImageHasChanged(false);
    }
    async function handleArticleTextChange(ev) {
        setArticleText(ev.target.value);
        saveArticleCustomText(ev.target.value);
    }
    return articleNotFound ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7fc0690c51c045a0$export$271f9f08425019c7), {}) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: [
            "article",
            softLoading ? "loading" : "",
            article?.process_status !== "finished" ? "not-finished" : ""
        ].filter((v)=>!!v).join(" "),
        children: [
            article?.url && showProcessingError && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "process-error",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("There was a problem while processing the url")
                    }),
                    article.process_failed_reason ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("strong", {
                            children: article.process_failed_reason
                        })
                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)(`Maybe not all parts of the website are accessible or have relevant content? If the website is behind a paywall which you can access, you should try again with the browser plugin.`)
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                            hreg: "#",
                            onClick: async (ev)=>{
                                ev.preventDefault;
                                setSoftLoading(true);
                                let website = (await $e6d4445b9ec5d3b6$export$e5bbb53e009237db(article.id)).website;
                                setArticle(website);
                                setShowProcessingError(false);
                                setSoftLoading(false);
                            },
                            children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Alternatively you can read the article anyway, by clicking here")
                        })
                    })
                ]
            }),
            article && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "published-on",
                        children: article.published_on || article.scraped_at ? (0, $1d6b0918345aa2c5$export$af204b270ccca492)(article.published_on || article.scraped_at, currentUser.language || article.display_lang, article.scraped_at) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                            className: "block-placeholder published-on",
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                    className: "block-placeholder-line",
                                    style: {
                                        width: "4rem"
                                    }
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                    className: "block-placeholder-line",
                                    style: {
                                        width: "2rem"
                                    }
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                    className: "block-placeholder-line",
                                    style: {
                                        width: "2rem"
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "headline",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                            onDoubleClick: ()=>handleToggleTitle(),
                            children: article.title ? (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parseInline(article.translated.display_title || article.display_title)) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "block-placeholder headline",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        className: "block-placeholder-line",
                                        style: {
                                            width: "20%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        className: "block-placeholder-line",
                                        style: {
                                            width: "40%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        className: "block-placeholder-line",
                                        style: {
                                            width: "70%"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        className: "block-placeholder-line",
                                        style: {
                                            width: "10%"
                                        }
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "image-and-summary",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "summary summary-teaser",
                                onDoubleClick: async ()=>{
                                    let { website: website } = await $e6d4445b9ec5d3b6$export$475ece786eef46a9(article.id, {
                                        show_takeaway: !article.show_takeaway
                                    });
                                    setArticle(website);
                                },
                                children: [
                                    article.show_takeaway && article.takeaway ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                                        children: (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parse(article.translated.takeaway || article.takeaway))
                                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                                        children: article.custom_summary || article.summary ? (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parse(article.custom_summary || article.translated.summary || article.summary)) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                            className: "block-placeholder summary",
                                            children: [
                                                1,
                                                2,
                                                3
                                            ].map((i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                            className: "block-placeholder-line",
                                                            style: {
                                                                width: `${i * 30}%`
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                            className: "block-placeholder-line"
                                                        }),
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                            className: "block-placeholder-line",
                                                            style: {
                                                                width: "90%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                            className: "block-placeholder-line",
                                                            style: {
                                                                width: "95%"
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                                            className: "block-placeholder-line",
                                                            style: {
                                                                width: "100%"
                                                            }
                                                        })
                                                    ]
                                                }))
                                        })
                                    }),
                                    article.summary && article.content_is_shortened_for_summary && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                        className: "summary-warning",
                                        children: [
                                            (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Note"),
                                            ":",
                                            " ",
                                            (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("The original text was too long. So parts from the end of the text are not included in the summary and may corrupt the correct gist.")
                                        ]
                                    })
                                ]
                            }),
                            article.detailed_summary && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "detailed-summary",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                    className: "summary",
                                    children: (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parse(article.translated.detailed_summary || article.detailed_summary))
                                })
                            }),
                            article && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "url",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                                    href: article.url || article.scrape_url,
                                    target: "_blank",
                                    className: "source-url",
                                    "data-prefix-text": (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Source: "),
                                    children: article.url || article.scrape_url
                                })
                            }),
                            article?.key_moments && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "key-moments",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Key moments")
                                    }),
                                    (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)((0, $4f187667b545d850$exports.marked).parse(article.translated.key_moments || article.key_moments))
                                ]
                            }),
                            article?.process_status === "finished" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                                children: !showImage ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                        className: "subtle",
                                        onClick: ()=>setShowImage(true),
                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Show image")
                                    })
                                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                                    children: articleImageUrl !== false ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        style: {
                                            "--aspect-ratio": articleImageAspectRatio || "unset"
                                        },
                                        className: [
                                            "image",
                                            articleImageUrl ? "has-image" : null
                                        ].filter((v)=>!!v).join(" "),
                                        children: articleImageUrl && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                            className: "image-edit-container",
                                            children: [
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("img", {
                                                    src: articleImageUrl,
                                                    ref: imageRef,
                                                    onLoad: (ev)=>handleImageLoading(ev),
                                                    onError: ()=>{
                                                        // on initial load after processing the display_image_url is not ready to deliver, so use in this case the previous image_url instead
                                                        if (article.image_url && /^http/.test(article.image_url)) imageRef.src = article.image_url;
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "add-image-url",
                                                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                        className: "button small",
                                                        onClick: ()=>{
                                                            let url = prompt("Paste the image url you want to add");
                                                            if (url && url.match(/^http[s]*\:\/\//)) updateImageUrlForArticle(url, true);
                                                        },
                                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Add image by url")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                                    className: "save-image",
                                                    children: imageHasChanged && article.display_image_url && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                        className: "small",
                                                        onClick: ()=>{
                                                            if (article.display_image_url) updateImageUrlForArticle(article.display_image_url, true);
                                                        },
                                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Save")
                                                    })
                                                })
                                            ]
                                        })
                                    }) : article?.process_status !== "finished" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "block-placeholder image"
                                    })
                                })
                            })
                        ]
                    }),
                    showOriginalContent && articleText ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "more-options",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "all-content",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                                        children: customArticleTitle || ""
                                    }),
                                    articleText && ((0, $1d6b0918345aa2c5$export$a1d0d20ee9546562)() || article?.process_status !== "finished" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                        className: "custom-text",
                                        children: (0, $fb651b4393d0ff74$export$2e2bcd8739ae039)(articleText)
                                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($742200f0fca97109$exports))), {
                                        className: "custom-text",
                                        html: articleText,
                                        onChange: (0, (/*@__PURE__*/$parcel$interopDefault($f4ea6fc35b8f94b3$exports)))(handleArticleTextChange, 2500)
                                    }, `custom-text-${article.id}`)),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                                className: "subtle",
                                                onClick: ()=>setShowOriginalContent(false),
                                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Hide original content")
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                        children: articleText && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                className: "subtle",
                                onClick: ()=>setShowOriginalContent(true),
                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Show original content")
                            })
                        })
                    })
                ]
            }),
            article && article.scrape_url !== article.url && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "url",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("a", {
                    href: article.url,
                    target: "_blank",
                    className: "source-url",
                    "data-prefix-text": (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Original URL: "),
                    children: article.scrape_url
                })
            }),
            article && article.process_status !== "finished" && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: article.process_status === "failed" ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                    className: "error",
                    children: [
                        "Some problem occured while analyzing the website.",
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                            to: "/add?url=" + article.url,
                            children: "Please try again by adding the website again"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {})
            })
        ]
    });
}




var $exYeM = parcelRequire("exYeM");






function $2542d53a931f005f$export$5120f2d0b8d4cab8({ setActionMenu: setActionMenu } = {}) {
    const [currentUser] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const [credits, setCredits] = (0, $exYeM.useState)(null);
    const [user, setUser] = (0, $exYeM.useState)(null);
    const [languages, setLanguages] = (0, $exYeM.useState)(null);
    const [uiLanguages, setUiLanguages] = (0, $exYeM.useState)(null);
    setActionMenu(null);
    (0, $exYeM.useEffect)(()=>{
        if (!currentUser) return;
        $e6d4445b9ec5d3b6$export$1b3728eeff4927a2().then((data)=>{
            setCredits(data);
        });
        $e6d4445b9ec5d3b6$export$ddb906a32562356c().then((data)=>{
            setUser(data);
        });
        $e6d4445b9ec5d3b6$export$d0d68bb9ed2c643d().then((data)=>{
            setLanguages(data.languages);
            setUiLanguages(data.ui_languages);
        });
    }, [
        currentUser
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "profile limit-width form",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Your profile")
            }),
            currentUser && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                children: [
                    (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("E-Mail"),
                    ": ",
                    currentUser.email
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Language")
            }),
            user && languages && uiLanguages && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("select", {
                            onChange: async (ev)=>{
                                await $e6d4445b9ec5d3b6$export$bf950db3913272ff({
                                    language: ev.target.value
                                }).then(()=>location.reload());
                            },
                            defaultValue: user.language,
                            children: Object.entries(uiLanguages).map((language, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                    value: language[0],
                                    children: language[1]
                                }, "language-option-" + language[0]))
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("h3", {
                        children: [
                            (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Translate articles by default to"),
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("select", {
                            onChange: (ev)=>{
                                $e6d4445b9ec5d3b6$export$bf950db3913272ff({
                                    translate_to_language: ev.target.value
                                }).then(()=>location.reload());
                            },
                            defaultValue: user.translate_to_language,
                            children: [
                                [
                                    "",
                                    (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Keep original")
                                ],
                                ...Object.entries(languages)
                            ].map((language, i)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("option", {
                                    value: language[0],
                                    children: language[1]
                                }, "language-option-" + language[0]))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
            credits && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Credits")
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                        children: [
                            (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Number of credits left"),
                            ": ",
                            credits.redeemable_credits,
                            " (~",
                            " ",
                            Math.floor(credits.redeemable_credits / 10),
                            " ",
                            (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Articles"),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {})
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                    to: "/change-password",
                    className: "button",
                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Change password")
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                    to: "/plans",
                    className: "button",
                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Buy more credits")
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("p", {
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                    to: "/logout",
                    className: "button",
                    children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Log out")
                })
            })
        ]
    });
}




function $90b2986ed5867930$export$af7b1ba39a2418ba() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "limit-width",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                className: "button",
                children: "Primary Button"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "colors",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "color-red",
                        children: "Red"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "color-green",
                        children: "Green"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "color-violet",
                        children: "Violet"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "color-yellow",
                        children: "Yellow"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "color-blue",
                        children: "Blue"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "gradient-red button",
                        children: "Red"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "gradient-green button",
                        children: "Green"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "gradient-violet button",
                        children: "Violet"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "gradient-yellow button",
                        children: "Yellow"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "gradient-blue button",
                        children: "Blue"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        className: "no-color button",
                        children: "No Color"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "gradient-red text-masked",
                            children: "Red"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "gradient-green text-masked",
                            children: "Green"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "gradient-violet text-masked",
                            children: "Violet"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "gradient-yellow text-masked",
                            children: "Yellow"
                        })
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                            className: "gradient-blue text-masked",
                            children: "Blue"
                        })
                    })
                ]
            })
        ]
    });
}






function $744f1aee7c3e0f85$export$fa027c23da0a12ea() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "pricing",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                children: "Select Plan"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                className: "pricing-table",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "pricing-table-item",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                                children: "Free"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "pricing-table-item-content",
                                children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("5 websites")
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "pricing-table-item-price",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("0 €")
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("initial")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "pricing-table-item-cta",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "button no-color",
                                    children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("Select")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "pricing-table-item",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h3", {
                                children: "Starter"
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "pricing-table-item-content",
                                children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("200 websites")
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "pricing-table-item-price",
                                children: [
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("5 €")
                                    }),
                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("span", {
                                        children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("per Month")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                className: "pricing-table-item-cta",
                                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                    className: "button",
                                    children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("Select")
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $cae8f3803ff76424$exports = {};

$cae8f3803ff76424$exports = function(t) {
    var e = {};
    function n(o) {
        if (e[o]) return e[o].exports;
        var r = e[o] = {
            i: o,
            l: !1,
            exports: {}
        };
        return t[o].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
    }
    return n.m = t, n.c = e, n.d = function(t, e, o) {
        n.o(t, e) || Object.defineProperty(t, e, {
            configurable: !1,
            enumerable: !0,
            get: o
        });
    }, n.r = function(t) {
        Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, n.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return n.d(e, "a", e), e;
    }, n.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 4);
}([
    function(t, e) {
        t.exports = (parcelRequire("675Yl"));
    },
    function(t, e, n) {
        t.exports = n(3)();
    },
    function(t, e, n) {
        "use strict";
        t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    function(t, e, n) {
        "use strict";
        var o = n(2);
        function r() {}
        t.exports = function() {
            function t(t, e, n, r, c, i) {
                if (i !== o) {
                    var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw u.name = "Invariant Violation", u;
                }
            }
            function e() {
                return t;
            }
            t.isRequired = t;
            var n = {
                array: t,
                bool: t,
                func: t,
                number: t,
                object: t,
                string: t,
                symbol: t,
                any: t,
                arrayOf: e,
                element: t,
                instanceOf: e,
                node: t,
                objectOf: e,
                oneOf: e,
                oneOfType: e,
                shape: e,
                exact: e
            };
            return n.checkPropTypes = r, n.PropTypes = n, n;
        };
    },
    function(t, e, n) {
        "use strict";
        n.r(e);
        var o = n(1), r = n.n(o), c = n(0), i = n.n(c);
        function u(t) {
            return (u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            })(t);
        }
        function l(t, e) {
            for(var n = 0; n < e.length; n++){
                var o = e[n];
                o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(t, o.key, o);
            }
        }
        function a(t) {
            return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                return t.__proto__ || Object.getPrototypeOf(t);
            })(t);
        }
        function s(t, e) {
            return (s = Object.setPrototypeOf || function(t, e) {
                return t.__proto__ = e, t;
            })(t, e);
        }
        function p(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        }
        var f = function(t) {
            function e(t) {
                var n;
                return function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, e), (n = function(t, e) {
                    return !e || "object" !== u(e) && "function" != typeof e ? p(t) : e;
                }(this, a(e).call(this, t))).state = {
                    width: null
                }, n.Scrolling = n.Scrolling.bind(p(p(n))), n;
            }
            return function(t, e) {
                if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                t.prototype = Object.create(e && e.prototype, {
                    constructor: {
                        value: t,
                        writable: !0,
                        configurable: !0
                    }
                }), e && s(t, e);
            }(e, c["Component"]), function(t, e, n) {
                e && l(t.prototype, e), n && l(t, n);
            }(e, [
                {
                    key: "Scrolling",
                    value: function() {
                        var t = document.body.scrollTop || document.documentElement.scrollTop, e = document.documentElement.scrollHeight - document.documentElement.clientHeight, n = t / e * 100;
                        e > 0 ? this.setState({
                            width: "".concat(n, "%")
                        }) : this.setState({
                            width: null
                        });
                    }
                },
                {
                    key: "componentDidMount",
                    value: function() {
                        try {
                            window.addEventListener("scroll", this.Scrolling);
                        } catch (t) {
                            console.log(t);
                        }
                    }
                },
                {
                    key: "componentWillUnmount",
                    value: function() {
                        try {
                            window.removeEventListener("scroll", this.Scrolling);
                        } catch (t) {
                            console.log(t);
                        }
                    }
                },
                {
                    key: "render",
                    value: function() {
                        var t = this.state.width, e = this.props, n = e.height, o = e.bgcolor;
                        return i.a.createElement("div", {
                            style: function(t) {
                                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "4px", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "#F43059";
                                return {
                                    margin: 0,
                                    padding: 0,
                                    position: "fixed",
                                    top: 0,
                                    zIndex: "99",
                                    backgroundColor: "".concat(n),
                                    height: "".concat(e),
                                    width: "".concat(t),
                                    transition: "".concat(t, " 0.2s ease-out")
                                };
                            }(t, n, o)
                        });
                    }
                }
            ]), e;
        }();
        f.propTypes = {
            height: r.a.number,
            color: r.a.string.isRequired
        }, e.default = f;
    }
]);









var $exYeM = parcelRequire("exYeM");


function $fbfa0accfe58eefc$export$92f59d8b5148781d({ setActionMenu: setActionMenu } = {}) {
    const [collectionName, setCollectionName] = (0, $exYeM.useState)("");
    const [collections, setCollections] = (0, $exYeM.useState)(null);
    const navigate = (0, $b0e6fcd50b7ef685$export$9770f232ac06a008)();
    const [searchQuery, setSearchQuery] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $79a6aa2f003c21d2$export$36a381671975116c));
    setActionMenu(null);
    async function loadCollections() {
        let collections = await $e6d4445b9ec5d3b6$export$167de583c0ce0e55();
        setCollections(collections || []);
    }
    async function createCollection() {
        if (!collectionName) return;
        let data = await $e6d4445b9ec5d3b6$export$c74125a8e3af6bb2(collectionName);
        setCollections([
            data.collection,
            ...collections
        ]);
    }
    async function handleChangeCollectionName(ev, id) {
        await $e6d4445b9ec5d3b6$export$e7ff9a1e8c127508(id, {
            name: ev.target.value
        });
    }
    async function deleteCollection(id, ev) {
        await $e6d4445b9ec5d3b6$export$3d16e031f6551662(id);
        await loadCollections();
    }
    function handleClickOnWebsites(ids) {
        if (!ids?.length) return;
        let query = "id:" + ids.join(",");
        let params = new URLSearchParams({
            q: query
        });
        setSearchQuery(query);
        navigate("/?" + params.toString(), {
        });
    }
    (0, $exYeM.useEffect)(()=>{
        if (!collections) loadCollections();
    }, [
        collections
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "form collections",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "add-collection",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("form", {
                    onSubmit: (ev)=>{
                        ev.preventDefault();
                        createCollection();
                    },
                    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("fieldset", {
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                type: "text",
                                placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Name of the collection"),
                                maxLength: 16,
                                onChange: (ev)=>setCollectionName(ev.target.value)
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                type: "submit",
                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Add collection")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "collections-list",
                children: collections?.map((c)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        className: "collection",
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                className: "list",
                                onClick: ()=>handleClickOnWebsites(c.websites_ids),
                                children: [
                                    c.websites_ids.length,
                                    " ",
                                    (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Websites")
                                ]
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                                defaultValue: c.name,
                                placeholder: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Name of the collection"),
                                maxLength: 16,
                                required: true,
                                type: "text",
                                onChange: (ev)=>handleChangeCollectionName(ev, c.id)
                            }),
                            " ",
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                                className: "small",
                                onClick: (ev)=>confirm((0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("Sure?")) && deleteCollection(c.id),
                                children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("delete")
                            })
                        ]
                    }, `collection-${c.id}`))
            })
        ]
    });
}






function $aee6562ea73049eb$export$9ba90c23173739d1() {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        className: "limit-width",
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                children: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("Change password")
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("form", {
                className: "form",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        type: "password",
                        placeholder: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("Current password")
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        type: "password",
                        placeholder: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("New password")
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("input", {
                        type: "password",
                        placeholder: (0, $17c4d184a1f6cffa$export$2e2bcd8739ae039)("Repeat new password")
                    })
                ]
            })
        ]
    });
}



function $4f59010982e89e0f$export$86fbec116b87613f() {
    const [user, setUser] = (0, $5892d26dd4f89ebf$exports.useAtom)((0, $74b6691fdb32da4b$export$980ac9afb4d68a01));
    const [userIsNotLoggedIn, setUserIsNotLoggedIn] = (0, $exYeM.useState)(null);
    const [showProgressBar, setShowProgressBar] = (0, $exYeM.useState)(false);
    const [actionMenu, setActionMenu] = (0, $exYeM.useState)(null);
    const location = (0, $b0e6fcd50b7ef685$export$45d76561a5302f2b)();
    (0, $exYeM.useEffect)(()=>{
        document.querySelector("body").dataset.theme = localStorage.getItem("theme") || "dark";
    }, [
        (0, $74b6691fdb32da4b$export$980ac9afb4d68a01)
    ]);
    (0, $exYeM.useEffect)(()=>{
        // setActionMenu(null)
        if (!/^\/websites\/\d/.test(location.pathname)) {
            let body = document.querySelector("body");
            body.dataset.theme = localStorage.getItem("theme");
            body.style.removeProperty("--background-image-url");
            body.classList.remove("with-background-image");
            setShowProgressBar(false);
        } else // on show article
        setShowProgressBar(true);
    }, [
        location
    ]);
    (0, $exYeM.useEffect)(()=>{
        async function loginUser(token) {
            $e6d4445b9ec5d3b6$export$7c4ce05e1c99c99b(token, localStorage);
            let user = null;
            try {
                user = await $e6d4445b9ec5d3b6$export$ddb906a32562356c();
            } catch (e) {
                if (e.response?.status === 401) {
                    console.debug(`Session invalid. Clearing authtoken from local storage now`);
                    localStorage.removeItem("authToken");
                    setUserIsNotLoggedIn(true);
                    return;
                } else throw e;
            }
            setUser(user);
            setUserIsNotLoggedIn(false);
            // setLocale(translations[lang] ? lang : 'en')
            (0, $b7ce7ba39a245f74$export$c8aadf3621e41efb)(user.language);
            console.debug(`Logged in as ${user.email}`);
        }
        async function fetchUser() {
            if (!user.email) {
                let token = new URLSearchParams(window.location.search).get("authToken");
                // we have a authToken from a signup session
                if (token && /laravel_sanctum/.test(token)) {
                    loginUser(token);
                    return;
                }
                token = await $e6d4445b9ec5d3b6$export$38e1f53b76ec7fed();
                if (token) {
                    loginUser(token);
                    return;
                }
                setUserIsNotLoggedIn(true);
                console.info("User is not logged in. Send to login");
                if (window.location.pathname !== "/login") window.location.href = "/login";
            }
        }
        fetchUser();
    }, [
        user
    ]);
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
        children: [
            showProgressBar && /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                className: "scroll-progress-bar",
                children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cae8f3803ff76424$exports))), {
                    height: "2px",
                    bgcolor: "#7f00ff",
                    duration: "0.2"
                })
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $93891797481e717e$export$f2815235e76a62b9), {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                id: "app",
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7a2163ba25331c9c$export$b8a61e5c71402559), {
                        actionMenu: actionMenu
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        id: "main",
                        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $b0e6fcd50b7ef685$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                    path: "/lorem",
                                    element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $90b2986ed5867930$export$af7b1ba39a2418ba), {})
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                    path: "/plans",
                                    element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $744f1aee7c3e0f85$export$fa027c23da0a12ea), {})
                                }),
                                /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                    path: "/change-password",
                                    element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $aee6562ea73049eb$export$9ba90c23173739d1), {})
                                }),
                                user.email ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/login",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$444b3ab0cb9aec40), {
                                                replace: true,
                                                to: "/"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/signup",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$444b3ab0cb9aec40), {
                                                replace: true,
                                                to: "/"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $d74335a42d5298e4$export$b94310965bed44e6), {
                                                setActionMenu: setActionMenu
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/profile",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2542d53a931f005f$export$5120f2d0b8d4cab8), {
                                                setActionMenu: setActionMenu
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/collections",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fbfa0accfe58eefc$export$92f59d8b5148781d), {
                                                setActionMenu: setActionMenu
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/logout",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $f6c7bbcc9e76a42c$export$cad1a703886b4e3a), {})
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/websites/:websiteID",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $f714cc7d5a767340$export$4edd9f0c79152338), {
                                                setActionMenu: setActionMenu
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/add",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $fb045a3b65854a94$export$d0265b2c425512d6), {
                                                setActionMenu: setActionMenu
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $7fc0690c51c045a0$export$271f9f08425019c7), {})
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)((0, $7ead0b1397a835ed$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/",
                                            element: userIsNotLoggedIn === true ? /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                                                className: "welcome-screen",
                                                children: [
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h1", {
                                                        children: (0, $1d6b0918345aa2c5$export$625550452a3fa3ec)("sitestash")
                                                    }),
                                                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                                                to: "/signup",
                                                                className: "button signup primary",
                                                                children: "Signup here"
                                                            }),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("br", {}),
                                                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$a6c7ac8248d6e38a), {
                                                                to: "/login",
                                                                children: "Login here"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$444b3ab0cb9aec40), {
                                                to: "/"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/signup",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $5d63d1127835abb6$export$89200835fb4edfb9), {})
                                        }),
                                        /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $b0e6fcd50b7ef685$export$e7b0ac011bb776c6), {
                                            path: "/login",
                                            element: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $e834f8d7ec9f3b13$export$21a94553ffa41578), {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}



var $exYeM = parcelRequire("exYeM");

var $d2lNW = parcelRequire("d2lNW");

var $6qd2L = parcelRequire("6qd2L");
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$err(message) {
    const error = new Error(message); // In V8, Error objects keep the closure scope chain alive until the
    // err.stack property is accessed.
    if (error.stack === undefined) // IE sets the stack only if error is thrown
    try {
        throw error;
    } catch (_) {} // eslint-disable-line fb-www/no-unused-catch-bindings, no-empty
    return error;
}
var $1ee798bac53aa7db$var$err_1 = $1ee798bac53aa7db$var$err;
// @oss-only
var $1ee798bac53aa7db$var$Recoil_err = $1ee798bac53aa7db$var$err_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // Split declaration and implementation to allow this function to pretend to
// check for actual instance of Promise instead of something with a `then`
// method.
// eslint-disable-next-line no-redeclare
function $1ee798bac53aa7db$var$isPromise(p) {
    return !!p && typeof p.then === "function";
}
var $1ee798bac53aa7db$var$Recoil_isPromise = $1ee798bac53aa7db$var$isPromise;
function $1ee798bac53aa7db$var$nullthrows(x, message) {
    if (x != null) return x;
    throw $1ee798bac53aa7db$var$Recoil_err(message !== null && message !== void 0 ? message : "Got unexpected null or undefined");
}
var $1ee798bac53aa7db$var$Recoil_nullthrows = $1ee798bac53aa7db$var$nullthrows;
function $1ee798bac53aa7db$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
class $1ee798bac53aa7db$var$BaseLoadable {
    getValue() {
        throw $1ee798bac53aa7db$var$Recoil_err("BaseLoadable");
    }
    toPromise() {
        throw $1ee798bac53aa7db$var$Recoil_err("BaseLoadable");
    }
    valueMaybe() {
        throw $1ee798bac53aa7db$var$Recoil_err("BaseLoadable");
    }
    valueOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $1ee798bac53aa7db$var$Recoil_err(`Loadable expected value, but in "${this.state}" state`);
    }
    promiseMaybe() {
        throw $1ee798bac53aa7db$var$Recoil_err("BaseLoadable");
    }
    promiseOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $1ee798bac53aa7db$var$Recoil_err(`Loadable expected promise, but in "${this.state}" state`);
    }
    errorMaybe() {
        throw $1ee798bac53aa7db$var$Recoil_err("BaseLoadable");
    }
    errorOrThrow() {
        // $FlowFixMe[prop-missing]
        throw $1ee798bac53aa7db$var$Recoil_err(`Loadable expected error, but in "${this.state}" state`);
    }
    is(other) {
        // $FlowFixMe[prop-missing]
        return other.state === this.state && other.contents === this.contents;
    }
    map(_map) {
        throw $1ee798bac53aa7db$var$Recoil_err("BaseLoadable");
    }
}
class $1ee798bac53aa7db$var$ValueLoadable extends $1ee798bac53aa7db$var$BaseLoadable {
    constructor(value){
        super();
        $1ee798bac53aa7db$var$_defineProperty(this, "state", "hasValue");
        $1ee798bac53aa7db$var$_defineProperty(this, "contents", void 0);
        this.contents = value;
    }
    getValue() {
        return this.contents;
    }
    toPromise() {
        return Promise.resolve(this.contents);
    }
    valueMaybe() {
        return this.contents;
    }
    valueOrThrow() {
        return this.contents;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        try {
            const next = map(this.contents);
            return $1ee798bac53aa7db$var$Recoil_isPromise(next) ? $1ee798bac53aa7db$var$loadableWithPromise(next) : $1ee798bac53aa7db$var$isLoadable(next) ? next : $1ee798bac53aa7db$var$loadableWithValue(next);
        } catch (e) {
            return $1ee798bac53aa7db$var$Recoil_isPromise(e) ? // errors and subsequent retries will be handled in 'loading' case
            // $FlowFixMe[prop-missing]
            $1ee798bac53aa7db$var$loadableWithPromise(e.next(()=>this.map(map))) : $1ee798bac53aa7db$var$loadableWithError(e);
        }
    }
}
class $1ee798bac53aa7db$var$ErrorLoadable extends $1ee798bac53aa7db$var$BaseLoadable {
    constructor(error){
        super();
        $1ee798bac53aa7db$var$_defineProperty(this, "state", "hasError");
        $1ee798bac53aa7db$var$_defineProperty(this, "contents", void 0);
        this.contents = error;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return Promise.reject(this.contents);
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return undefined;
    }
    errorMaybe() {
        return this.contents;
    }
    errorOrThrow() {
        return this.contents;
    }
    map(_map) {
        // $FlowIssue[incompatible-return]
        return this;
    }
}
class $1ee798bac53aa7db$var$LoadingLoadable extends $1ee798bac53aa7db$var$BaseLoadable {
    constructor(promise){
        super();
        $1ee798bac53aa7db$var$_defineProperty(this, "state", "loading");
        $1ee798bac53aa7db$var$_defineProperty(this, "contents", void 0);
        this.contents = promise;
    }
    getValue() {
        throw this.contents;
    }
    toPromise() {
        return this.contents;
    }
    valueMaybe() {
        return undefined;
    }
    promiseMaybe() {
        return this.contents;
    }
    promiseOrThrow() {
        return this.contents;
    }
    errorMaybe() {
        return undefined;
    }
    map(map) {
        return $1ee798bac53aa7db$var$loadableWithPromise(this.contents.then((value)=>{
            const next = map(value);
            if ($1ee798bac53aa7db$var$isLoadable(next)) {
                const nextLoadable = next;
                switch(nextLoadable.state){
                    case "hasValue":
                        return nextLoadable.contents;
                    case "hasError":
                        throw nextLoadable.contents;
                    case "loading":
                        return nextLoadable.contents;
                }
            } // $FlowIssue[incompatible-return]
            return next;
        }) // $FlowFixMe[incompatible-call]
        .catch((e)=>{
            if ($1ee798bac53aa7db$var$Recoil_isPromise(e)) // we were "suspended," try again
            return e.then(()=>this.map(map).contents);
            throw e;
        }));
    }
}
function $1ee798bac53aa7db$var$loadableWithValue(value) {
    return Object.freeze(new $1ee798bac53aa7db$var$ValueLoadable(value));
}
function $1ee798bac53aa7db$var$loadableWithError(error) {
    return Object.freeze(new $1ee798bac53aa7db$var$ErrorLoadable(error));
}
function $1ee798bac53aa7db$var$loadableWithPromise(promise) {
    return Object.freeze(new $1ee798bac53aa7db$var$LoadingLoadable(promise));
}
function $1ee798bac53aa7db$var$loadableLoading() {
    return Object.freeze(new $1ee798bac53aa7db$var$LoadingLoadable(new Promise(()=>{})));
}
function $1ee798bac53aa7db$var$loadableAllArray(inputs) {
    return inputs.every((i)=>i.state === "hasValue") ? $1ee798bac53aa7db$var$loadableWithValue(inputs.map((i)=>i.contents)) : inputs.some((i)=>i.state === "hasError") ? $1ee798bac53aa7db$var$loadableWithError($1ee798bac53aa7db$var$Recoil_nullthrows(inputs.find((i)=>i.state === "hasError"), "Invalid loadable passed to loadableAll").contents) : $1ee798bac53aa7db$var$loadableWithPromise(Promise.all(inputs.map((i)=>i.contents)));
}
function $1ee798bac53aa7db$var$loadableAll(inputs) {
    const unwrapedInputs = Array.isArray(inputs) ? inputs : Object.getOwnPropertyNames(inputs).map((key)=>inputs[key]);
    const normalizedInputs = unwrapedInputs.map((x)=>$1ee798bac53aa7db$var$isLoadable(x) ? x : $1ee798bac53aa7db$var$Recoil_isPromise(x) ? $1ee798bac53aa7db$var$loadableWithPromise(x) : $1ee798bac53aa7db$var$loadableWithValue(x));
    const output = $1ee798bac53aa7db$var$loadableAllArray(normalizedInputs);
    return Array.isArray(inputs) ? output : // $FlowIssue[incompatible-call]
    output.map((outputs)=>Object.getOwnPropertyNames(inputs).reduce((out, key, idx)=>({
                ...out,
                [key]: outputs[idx]
            }), {}));
}
function $1ee798bac53aa7db$var$isLoadable(x) {
    return x instanceof $1ee798bac53aa7db$var$BaseLoadable;
}
const $1ee798bac53aa7db$var$LoadableStaticInterface = {
    of: (value)=>$1ee798bac53aa7db$var$Recoil_isPromise(value) ? $1ee798bac53aa7db$var$loadableWithPromise(value) : $1ee798bac53aa7db$var$isLoadable(value) ? value : $1ee798bac53aa7db$var$loadableWithValue(value),
    error: (error)=>$1ee798bac53aa7db$var$loadableWithError(error),
    // $FlowIssue[incompatible-return]
    loading: ()=>$1ee798bac53aa7db$var$loadableLoading(),
    // $FlowIssue[unclear-type]
    all: $1ee798bac53aa7db$var$loadableAll,
    isLoadable: $1ee798bac53aa7db$var$isLoadable
};
var $1ee798bac53aa7db$var$Recoil_Loadable = {
    loadableWithValue: $1ee798bac53aa7db$var$loadableWithValue,
    loadableWithError: $1ee798bac53aa7db$var$loadableWithError,
    loadableWithPromise: $1ee798bac53aa7db$var$loadableWithPromise,
    loadableLoading: $1ee798bac53aa7db$var$loadableLoading,
    loadableAll: $1ee798bac53aa7db$var$loadableAll,
    isLoadable: $1ee798bac53aa7db$var$isLoadable,
    RecoilLoadable: $1ee798bac53aa7db$var$LoadableStaticInterface
};
var $1ee798bac53aa7db$var$Recoil_Loadable_1 = $1ee798bac53aa7db$var$Recoil_Loadable.loadableWithValue;
var $1ee798bac53aa7db$var$Recoil_Loadable_2 = $1ee798bac53aa7db$var$Recoil_Loadable.loadableWithError;
var $1ee798bac53aa7db$var$Recoil_Loadable_3 = $1ee798bac53aa7db$var$Recoil_Loadable.loadableWithPromise;
var $1ee798bac53aa7db$var$Recoil_Loadable_4 = $1ee798bac53aa7db$var$Recoil_Loadable.loadableLoading;
var $1ee798bac53aa7db$var$Recoil_Loadable_5 = $1ee798bac53aa7db$var$Recoil_Loadable.loadableAll;
var $1ee798bac53aa7db$var$Recoil_Loadable_6 = $1ee798bac53aa7db$var$Recoil_Loadable.isLoadable;
var $1ee798bac53aa7db$var$Recoil_Loadable_7 = $1ee798bac53aa7db$var$Recoil_Loadable.RecoilLoadable;
var $1ee798bac53aa7db$var$Recoil_Loadable$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    loadableWithValue: $1ee798bac53aa7db$var$Recoil_Loadable_1,
    loadableWithError: $1ee798bac53aa7db$var$Recoil_Loadable_2,
    loadableWithPromise: $1ee798bac53aa7db$var$Recoil_Loadable_3,
    loadableLoading: $1ee798bac53aa7db$var$Recoil_Loadable_4,
    loadableAll: $1ee798bac53aa7db$var$Recoil_Loadable_5,
    isLoadable: $1ee798bac53aa7db$var$Recoil_Loadable_6,
    RecoilLoadable: $1ee798bac53aa7db$var$Recoil_Loadable_7
});
const $1ee798bac53aa7db$var$env = {
    RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: true,
    // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
    RECOIL_GKS_ENABLED: new Set([
        "recoil_hamt_2020",
        "recoil_sync_external_store",
        "recoil_suppress_rerender_in_callback",
        "recoil_memory_managament_2020"
    ])
};
function $1ee798bac53aa7db$var$readProcessEnvBooleanFlag(name, set) {
    var _process$env$name, _process$env$name$toL;
    const sanitizedValue = (_process$env$name = $6qd2L.env[name]) === null || _process$env$name === void 0 ? void 0 : (_process$env$name$toL = _process$env$name.toLowerCase()) === null || _process$env$name$toL === void 0 ? void 0 : _process$env$name$toL.trim();
    if (sanitizedValue == null || sanitizedValue === "") return;
    const allowedValues = [
        "true",
        "false"
    ];
    if (!allowedValues.includes(sanitizedValue)) throw $1ee798bac53aa7db$var$Recoil_err(`process.env.${name} value must be 'true', 'false', or empty: ${sanitizedValue}`);
    set(sanitizedValue === "true");
}
function $1ee798bac53aa7db$var$readProcessEnvStringArrayFlag(name, set) {
    var _process$env$name2;
    const sanitizedValue = (_process$env$name2 = $6qd2L.env[name]) === null || _process$env$name2 === void 0 ? void 0 : _process$env$name2.trim();
    if (sanitizedValue == null || sanitizedValue === "") return;
    set(sanitizedValue.split(/\s*,\s*|\s+/));
}
/**
 * Allow NodeJS/NextJS/etc to set the initial state through process.env variable
 * Note:  we don't assume 'process' is available in all runtime environments
 *
 * @see https://github.com/facebookexperimental/Recoil/issues/733
 */ function $1ee798bac53aa7db$var$applyProcessEnvFlagOverrides() {
    var _process;
    // note: this check is needed in addition to the check below, runtime error will occur without it!
    // eslint-disable-next-line fb-www/typeof-undefined
    if (typeof $6qd2L === "undefined") return;
    if (((_process = $6qd2L) === null || _process === void 0 ? void 0 : _process.env) == null) return;
    $1ee798bac53aa7db$var$readProcessEnvBooleanFlag("RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED", (value)=>{
        $1ee798bac53aa7db$var$env.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = value;
    });
    $1ee798bac53aa7db$var$readProcessEnvStringArrayFlag("RECOIL_GKS_ENABLED", (value)=>{
        value.forEach((gk)=>{
            $1ee798bac53aa7db$var$env.RECOIL_GKS_ENABLED.add(gk);
        });
    });
}
$1ee798bac53aa7db$var$applyProcessEnvFlagOverrides();
var $1ee798bac53aa7db$var$Recoil_RecoilEnv = $1ee798bac53aa7db$var$env;
function $1ee798bac53aa7db$var$Recoil_gkx_OSS(gk) {
    return $1ee798bac53aa7db$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.has(gk);
}
$1ee798bac53aa7db$var$Recoil_gkx_OSS.setPass = (gk)=>{
    $1ee798bac53aa7db$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.add(gk);
};
$1ee798bac53aa7db$var$Recoil_gkx_OSS.setFail = (gk)=>{
    $1ee798bac53aa7db$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.delete(gk);
};
$1ee798bac53aa7db$var$Recoil_gkx_OSS.clear = ()=>{
    $1ee798bac53aa7db$var$Recoil_RecoilEnv.RECOIL_GKS_ENABLED.clear();
};
var $1ee798bac53aa7db$var$Recoil_gkx = $1ee798bac53aa7db$var$Recoil_gkx_OSS; // @oss-only
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$recoverableViolation(message, _projectName, { error: error } = {}) {
    return null;
}
var $1ee798bac53aa7db$var$recoverableViolation_1 = $1ee798bac53aa7db$var$recoverableViolation;
// @oss-only
var $1ee798bac53aa7db$var$Recoil_recoverableViolation = $1ee798bac53aa7db$var$recoverableViolation_1;
var $1ee798bac53aa7db$var$_createMutableSource, $1ee798bac53aa7db$var$_useMutableSource, $1ee798bac53aa7db$var$_useSyncExternalStore;
const $1ee798bac53aa7db$var$createMutableSource = ($1ee798bac53aa7db$var$_createMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createMutableSource) !== null && $1ee798bac53aa7db$var$_createMutableSource !== void 0 ? $1ee798bac53aa7db$var$_createMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).unstable_createMutableSource;
const $1ee798bac53aa7db$var$useMutableSource = ($1ee798bac53aa7db$var$_useMutableSource = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useMutableSource) !== null && $1ee798bac53aa7db$var$_useMutableSource !== void 0 ? $1ee798bac53aa7db$var$_useMutableSource : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).unstable_useMutableSource; // https://github.com/reactwg/react-18/discussions/86
const $1ee798bac53aa7db$var$useSyncExternalStore = ($1ee798bac53aa7db$var$_useSyncExternalStore = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useSyncExternalStore) !== null && $1ee798bac53aa7db$var$_useSyncExternalStore !== void 0 ? $1ee798bac53aa7db$var$_useSyncExternalStore : (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).unstable_useSyncExternalStore;
let $1ee798bac53aa7db$var$ReactRendererVersionMismatchWarnOnce = false; // Check if the current renderer supports `useSyncExternalStore()`.
// Since React goes through a proxy dispatcher and the current renderer can
// change we can't simply check if `React.useSyncExternalStore()` is defined.
function $1ee798bac53aa7db$var$currentRendererSupportsUseSyncExternalStore() {
    var _ReactCurrentDispatch;
    // $FlowFixMe[incompatible-use]
    const { ReactCurrentDispatcher: ReactCurrentDispatcher, ReactCurrentOwner: ReactCurrentOwner } = /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
   * to detect if the current renderer supports useSyncExternalStore()
   * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    const dispatcher = (_ReactCurrentDispatch = ReactCurrentDispatcher === null || ReactCurrentDispatcher === void 0 ? void 0 : ReactCurrentDispatcher.current) !== null && _ReactCurrentDispatch !== void 0 ? _ReactCurrentDispatch : ReactCurrentOwner.currentDispatcher;
    const isUseSyncExternalStoreSupported = dispatcher.useSyncExternalStore != null;
    if ($1ee798bac53aa7db$var$useSyncExternalStore && !isUseSyncExternalStoreSupported && !$1ee798bac53aa7db$var$ReactRendererVersionMismatchWarnOnce) {
        $1ee798bac53aa7db$var$ReactRendererVersionMismatchWarnOnce = true;
        $1ee798bac53aa7db$var$Recoil_recoverableViolation("A React renderer without React 18+ API support is being used with React 18+.");
    }
    return isUseSyncExternalStoreSupported;
}
/**
 * mode: The React API and approach to use for syncing state with React
 * early: Re-renders from Recoil updates occur:
 *    1) earlier
 *    2) in sync with React updates in the same batch
 *    3) before transaction observers instead of after.
 * concurrent: Is the current mode compatible with Concurrent Mode and useTransition()
 */ function $1ee798bac53aa7db$var$reactMode() {
    // NOTE: This mode is currently broken with some Suspense cases
    // see Recoil_selector-test.js
    if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_transition_support")) return {
        mode: "TRANSITION_SUPPORT",
        early: true,
        concurrent: true
    };
    if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_sync_external_store") && $1ee798bac53aa7db$var$useSyncExternalStore != null) return {
        mode: "SYNC_EXTERNAL_STORE",
        early: true,
        concurrent: false
    };
    if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_mutable_source") && $1ee798bac53aa7db$var$useMutableSource != null && typeof window !== "undefined" && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE) return $1ee798bac53aa7db$var$Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
        mode: "MUTABLE_SOURCE",
        early: true,
        concurrent: true
    } : {
        mode: "MUTABLE_SOURCE",
        early: false,
        concurrent: false
    };
    return $1ee798bac53aa7db$var$Recoil_gkx("recoil_suppress_rerender_in_callback") ? {
        mode: "LEGACY",
        early: true,
        concurrent: false
    } : {
        mode: "LEGACY",
        early: false,
        concurrent: false
    };
} // TODO Need to figure out if there is a standard/open-source equivalent to see if hot module replacement is happening:
function $1ee798bac53aa7db$var$isFastRefreshEnabled() {
    // @fb-only: const {isAcceptingUpdate} = require('__debug');
    // @fb-only: return typeof isAcceptingUpdate === 'function' && isAcceptingUpdate();
    return false; // @oss-only
}
var $1ee798bac53aa7db$var$Recoil_ReactMode = {
    createMutableSource: $1ee798bac53aa7db$var$createMutableSource,
    useMutableSource: $1ee798bac53aa7db$var$useMutableSource,
    useSyncExternalStore: $1ee798bac53aa7db$var$useSyncExternalStore,
    currentRendererSupportsUseSyncExternalStore: $1ee798bac53aa7db$var$currentRendererSupportsUseSyncExternalStore,
    reactMode: $1ee798bac53aa7db$var$reactMode,
    isFastRefreshEnabled: $1ee798bac53aa7db$var$isFastRefreshEnabled
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ // eslint-disable-next-line no-unused-vars
class $1ee798bac53aa7db$var$AbstractRecoilValue {
    constructor(newKey){
        $1ee798bac53aa7db$var$_defineProperty(this, "key", void 0);
        this.key = newKey;
    }
    toJSON() {
        return {
            key: this.key
        };
    }
}
class $1ee798bac53aa7db$var$RecoilState extends $1ee798bac53aa7db$var$AbstractRecoilValue {
}
class $1ee798bac53aa7db$var$RecoilValueReadOnly extends $1ee798bac53aa7db$var$AbstractRecoilValue {
}
function $1ee798bac53aa7db$var$isRecoilValue(x) {
    return x instanceof $1ee798bac53aa7db$var$RecoilState || x instanceof $1ee798bac53aa7db$var$RecoilValueReadOnly;
}
var $1ee798bac53aa7db$var$Recoil_RecoilValue = {
    AbstractRecoilValue: $1ee798bac53aa7db$var$AbstractRecoilValue,
    RecoilState: $1ee798bac53aa7db$var$RecoilState,
    RecoilValueReadOnly: $1ee798bac53aa7db$var$RecoilValueReadOnly,
    isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue
};
var $1ee798bac53aa7db$var$Recoil_RecoilValue_1 = $1ee798bac53aa7db$var$Recoil_RecoilValue.AbstractRecoilValue;
var $1ee798bac53aa7db$var$Recoil_RecoilValue_2 = $1ee798bac53aa7db$var$Recoil_RecoilValue.RecoilState;
var $1ee798bac53aa7db$var$Recoil_RecoilValue_3 = $1ee798bac53aa7db$var$Recoil_RecoilValue.RecoilValueReadOnly;
var $1ee798bac53aa7db$var$Recoil_RecoilValue_4 = $1ee798bac53aa7db$var$Recoil_RecoilValue.isRecoilValue;
var $1ee798bac53aa7db$var$Recoil_RecoilValue$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    AbstractRecoilValue: $1ee798bac53aa7db$var$Recoil_RecoilValue_1,
    RecoilState: $1ee798bac53aa7db$var$Recoil_RecoilValue_2,
    RecoilValueReadOnly: $1ee798bac53aa7db$var$Recoil_RecoilValue_3,
    isRecoilValue: $1ee798bac53aa7db$var$Recoil_RecoilValue_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$sprintf(format, ...args) {
    let index = 0;
    return format.replace(/%s/g, ()=>String(args[index++]));
}
var $1ee798bac53aa7db$var$sprintf_1 = $1ee798bac53aa7db$var$sprintf;
function $1ee798bac53aa7db$var$expectationViolation(format, ...args) {}
var $1ee798bac53aa7db$var$expectationViolation_1 = $1ee798bac53aa7db$var$expectationViolation;
// @oss-only
var $1ee798bac53aa7db$var$Recoil_expectationViolation = $1ee798bac53aa7db$var$expectationViolation_1;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the mapper function.
 */ function $1ee798bac53aa7db$var$mapIterable(iterable, callback) {
    // Use generator to create iterable/iterator
    return function*() {
        let index = 0;
        for (const value of iterable)yield callback(value, index++);
    }();
}
var $1ee798bac53aa7db$var$Recoil_mapIterable = $1ee798bac53aa7db$var$mapIterable;
const { isFastRefreshEnabled: $1ee798bac53aa7db$var$isFastRefreshEnabled$1 } = $1ee798bac53aa7db$var$Recoil_ReactMode;
class $1ee798bac53aa7db$var$DefaultValue {
}
const $1ee798bac53aa7db$var$DEFAULT_VALUE = new $1ee798bac53aa7db$var$DefaultValue();
// flowlint-next-line unclear-type:off
const $1ee798bac53aa7db$var$nodes = new Map(); // flowlint-next-line unclear-type:off
const $1ee798bac53aa7db$var$recoilValues = new Map();
/* eslint-disable no-redeclare */ function $1ee798bac53aa7db$var$recoilValuesForKeys(keys) {
    return $1ee798bac53aa7db$var$Recoil_mapIterable(keys, (key)=>$1ee798bac53aa7db$var$Recoil_nullthrows($1ee798bac53aa7db$var$recoilValues.get(key)));
}
function $1ee798bac53aa7db$var$checkForDuplicateAtomKey(key) {
    if ($1ee798bac53aa7db$var$nodes.has(key)) {
        const message = `Duplicate atom key "${key}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;
        // @fb-only: recoverableViolation(message, 'recoil');
        console.warn(message); // @oss-only
    }
}
function $1ee798bac53aa7db$var$registerNode(node) {
    if ($1ee798bac53aa7db$var$Recoil_RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED) $1ee798bac53aa7db$var$checkForDuplicateAtomKey(node.key);
    $1ee798bac53aa7db$var$nodes.set(node.key, node);
    const recoilValue = node.set == null ? new $1ee798bac53aa7db$var$Recoil_RecoilValue$1.RecoilValueReadOnly(node.key) : new $1ee798bac53aa7db$var$Recoil_RecoilValue$1.RecoilState(node.key);
    $1ee798bac53aa7db$var$recoilValues.set(node.key, recoilValue);
    return recoilValue;
}
/* eslint-enable no-redeclare */ class $1ee798bac53aa7db$var$NodeMissingError extends Error {
} // flowlint-next-line unclear-type:off
function $1ee798bac53aa7db$var$getNode(key) {
    const node = $1ee798bac53aa7db$var$nodes.get(key);
    if (node == null) throw new $1ee798bac53aa7db$var$NodeMissingError(`Missing definition for RecoilValue: "${key}""`);
    return node;
} // flowlint-next-line unclear-type:off
function $1ee798bac53aa7db$var$getNodeMaybe(key) {
    return $1ee798bac53aa7db$var$nodes.get(key);
}
const $1ee798bac53aa7db$var$configDeletionHandlers = new Map();
function $1ee798bac53aa7db$var$deleteNodeConfigIfPossible(key) {
    var _node$shouldDeleteCon;
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const node = $1ee798bac53aa7db$var$nodes.get(key);
    if (node !== null && node !== void 0 && (_node$shouldDeleteCon = node.shouldDeleteConfigOnRelease) !== null && _node$shouldDeleteCon !== void 0 && _node$shouldDeleteCon.call(node)) {
        var _getConfigDeletionHan;
        $1ee798bac53aa7db$var$nodes.delete(key);
        (_getConfigDeletionHan = $1ee798bac53aa7db$var$getConfigDeletionHandler(key)) === null || _getConfigDeletionHan === void 0 || _getConfigDeletionHan();
        $1ee798bac53aa7db$var$configDeletionHandlers.delete(key);
    }
}
function $1ee798bac53aa7db$var$setConfigDeletionHandler(key, fn) {
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    if (fn === undefined) $1ee798bac53aa7db$var$configDeletionHandlers.delete(key);
    else $1ee798bac53aa7db$var$configDeletionHandlers.set(key, fn);
}
function $1ee798bac53aa7db$var$getConfigDeletionHandler(key) {
    return $1ee798bac53aa7db$var$configDeletionHandlers.get(key);
}
var $1ee798bac53aa7db$var$Recoil_Node = {
    nodes: $1ee798bac53aa7db$var$nodes,
    recoilValues: $1ee798bac53aa7db$var$recoilValues,
    registerNode: $1ee798bac53aa7db$var$registerNode,
    getNode: $1ee798bac53aa7db$var$getNode,
    getNodeMaybe: $1ee798bac53aa7db$var$getNodeMaybe,
    deleteNodeConfigIfPossible: $1ee798bac53aa7db$var$deleteNodeConfigIfPossible,
    setConfigDeletionHandler: $1ee798bac53aa7db$var$setConfigDeletionHandler,
    getConfigDeletionHandler: $1ee798bac53aa7db$var$getConfigDeletionHandler,
    recoilValuesForKeys: $1ee798bac53aa7db$var$recoilValuesForKeys,
    NodeMissingError: $1ee798bac53aa7db$var$NodeMissingError,
    DefaultValue: $1ee798bac53aa7db$var$DefaultValue,
    DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$enqueueExecution(s, f) {
    f();
}
var $1ee798bac53aa7db$var$Recoil_Queue = {
    enqueueExecution: $1ee798bac53aa7db$var$enqueueExecution
};
function $1ee798bac53aa7db$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $1ee798bac53aa7db$var$hamt_1 = $1ee798bac53aa7db$var$createCommonjsModule(function(module) {
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    /**
    @fileOverview Hash Array Mapped Trie.

    Code based on: https://github.com/exclipy/pdata
*/ var hamt = {}; // export
    /* Configuration
 ******************************************************************************/ var SIZE = 5;
    var BUCKET_SIZE = Math.pow(2, SIZE);
    var MASK = BUCKET_SIZE - 1;
    var MAX_INDEX_NODE = BUCKET_SIZE / 2;
    var MIN_ARRAY_NODE = BUCKET_SIZE / 4;
    /*
 ******************************************************************************/ var nothing = {};
    var constant = function constant(x) {
        return function() {
            return x;
        };
    };
    /**
    Get 32 bit hash of string.

    Based on:
    http://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
*/ var hash = hamt.hash = function(str) {
        var type = typeof str === "undefined" ? "undefined" : _typeof(str);
        if (type === "number") return str;
        if (type !== "string") str += "";
        var hash = 0;
        for(var i = 0, len = str.length; i < len; ++i){
            var c = str.charCodeAt(i);
            hash = (hash << 5) - hash + c | 0;
        }
        return hash;
    };
    /* Bit Ops
 ******************************************************************************/ /**
    Hamming weight.

    Taken from: http://jsperf.com/hamming-weight
*/ var popcount = function popcount(x) {
        x -= x >> 1 & 0x55555555;
        x = (x & 0x33333333) + (x >> 2 & 0x33333333);
        x = x + (x >> 4) & 0x0f0f0f0f;
        x += x >> 8;
        x += x >> 16;
        return x & 0x7f;
    };
    var hashFragment = function hashFragment(shift, h) {
        return h >>> shift & MASK;
    };
    var toBitmap = function toBitmap(x) {
        return 1 << x;
    };
    var fromBitmap = function fromBitmap(bitmap, bit) {
        return popcount(bitmap & bit - 1);
    };
    /* Array Ops
 ******************************************************************************/ /**
    Set a value in an array.

    @param mutate Should the input array be mutated?
    @param at Index to change.
    @param v New value
    @param arr Array.
*/ var arrayUpdate = function arrayUpdate(mutate, at, v, arr) {
        var out = arr;
        if (!mutate) {
            var len = arr.length;
            out = new Array(len);
            for(var i = 0; i < len; ++i)out[i] = arr[i];
        }
        out[at] = v;
        return out;
    };
    /**
    Remove a value from an array.

    @param mutate Should the input array be mutated?
    @param at Index to remove.
    @param arr Array.
*/ var arraySpliceOut = function arraySpliceOut(mutate, at, arr) {
        var newLen = arr.length - 1;
        var i = 0;
        var g = 0;
        var out = arr;
        if (mutate) i = g = at;
        else {
            out = new Array(newLen);
            while(i < at)out[g++] = arr[i++];
        }
        ++i;
        while(i <= newLen)out[g++] = arr[i++];
        if (mutate) out.length = newLen;
        return out;
    };
    /**
    Insert a value into an array.

    @param mutate Should the input array be mutated?
    @param at Index to insert at.
    @param v Value to insert,
    @param arr Array.
*/ var arraySpliceIn = function arraySpliceIn(mutate, at, v, arr) {
        var len = arr.length;
        if (mutate) {
            var _i = len;
            while(_i >= at)arr[_i--] = arr[_i];
            arr[at] = v;
            return arr;
        }
        var i = 0, g = 0;
        var out = new Array(len + 1);
        while(i < at)out[g++] = arr[i++];
        out[at] = v;
        while(i < len)out[++g] = arr[i++];
        return out;
    };
    /* Node Structures
 ******************************************************************************/ var LEAF = 1;
    var COLLISION = 2;
    var INDEX = 3;
    var ARRAY = 4;
    /**
    Empty node.
*/ var empty = {
        __hamt_isEmpty: true
    };
    var isEmptyNode = function isEmptyNode(x) {
        return x === empty || x && x.__hamt_isEmpty;
    };
    /**
    Leaf holding a value.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member key Key.
    @member value Value stored.
*/ var Leaf = function Leaf(edit, hash, key, value) {
        return {
            type: LEAF,
            edit: edit,
            hash: hash,
            key: key,
            value: value,
            _modify: Leaf__modify
        };
    };
    /**
    Leaf holding multiple values with the same hash but different keys.

    @member edit Edit of the node.
    @member hash Hash of key.
    @member children Array of collision children node.
*/ var Collision = function Collision(edit, hash, children) {
        return {
            type: COLLISION,
            edit: edit,
            hash: hash,
            children: children,
            _modify: Collision__modify
        };
    };
    /**
    Internal node with a sparse set of children.

    Uses a bitmap and array to pack children.

  @member edit Edit of the node.
    @member mask Bitmap that encode the positions of children in the array.
    @member children Array of child nodes.
*/ var IndexedNode = function IndexedNode(edit, mask, children) {
        return {
            type: INDEX,
            edit: edit,
            mask: mask,
            children: children,
            _modify: IndexedNode__modify
        };
    };
    /**
    Internal node with many children.

    @member edit Edit of the node.
    @member size Number of children.
    @member children Array of child nodes.
*/ var ArrayNode = function ArrayNode(edit, size, children) {
        return {
            type: ARRAY,
            edit: edit,
            size: size,
            children: children,
            _modify: ArrayNode__modify
        };
    };
    /**
    Is `node` a leaf node?
*/ var isLeaf = function isLeaf(node) {
        return node === empty || node.type === LEAF || node.type === COLLISION;
    };
    /* Internal node operations.
 ******************************************************************************/ /**
    Expand an indexed node into an array node.

  @param edit Current edit.
    @param frag Index of added child.
    @param child Added child.
    @param mask Index node mask before child added.
    @param subNodes Index node children before child added.
*/ var expand = function expand(edit, frag, child, bitmap, subNodes) {
        var arr = [];
        var bit = bitmap;
        var count = 0;
        for(var i = 0; bit; ++i){
            if (bit & 1) arr[i] = subNodes[count++];
            bit >>>= 1;
        }
        arr[frag] = child;
        return ArrayNode(edit, count + 1, arr);
    };
    /**
    Collapse an array node into a indexed node.

  @param edit Current edit.
    @param count Number of elements in new array.
    @param removed Index of removed element.
    @param elements Array node children before remove.
*/ var pack = function pack(edit, count, removed, elements) {
        var children = new Array(count - 1);
        var g = 0;
        var bitmap = 0;
        for(var i = 0, len = elements.length; i < len; ++i)if (i !== removed) {
            var elem = elements[i];
            if (elem && !isEmptyNode(elem)) {
                children[g++] = elem;
                bitmap |= 1 << i;
            }
        }
        return IndexedNode(edit, bitmap, children);
    };
    /**
    Merge two leaf nodes.

    @param shift Current shift.
    @param h1 Node 1 hash.
    @param n1 Node 1.
    @param h2 Node 2 hash.
    @param n2 Node 2.
*/ var mergeLeaves = function mergeLeaves(edit, shift, h1, n1, h2, n2) {
        if (h1 === h2) return Collision(edit, h1, [
            n2,
            n1
        ]);
        var subH1 = hashFragment(shift, h1);
        var subH2 = hashFragment(shift, h2);
        return IndexedNode(edit, toBitmap(subH1) | toBitmap(subH2), subH1 === subH2 ? [
            mergeLeaves(edit, shift + SIZE, h1, n1, h2, n2)
        ] : subH1 < subH2 ? [
            n1,
            n2
        ] : [
            n2,
            n1
        ]);
    };
    /**
    Update an entry in a collision list.

    @param mutate Should mutation be used?
    @param edit Current edit.
    @param keyEq Key compare function.
    @param hash Hash of collision.
    @param list Collision list.
    @param f Update function.
    @param k Key to update.
    @param size Size ref.
*/ var updateCollisionList = function updateCollisionList(mutate, edit, keyEq, h, list, f, k, size) {
        var len = list.length;
        for(var i = 0; i < len; ++i){
            var child = list[i];
            if (keyEq(k, child.key)) {
                var value = child.value;
                var _newValue = f(value);
                if (_newValue === value) return list;
                if (_newValue === nothing) {
                    --size.value;
                    return arraySpliceOut(mutate, i, list);
                }
                return arrayUpdate(mutate, i, Leaf(edit, h, k, _newValue), list);
            }
        }
        var newValue = f();
        if (newValue === nothing) return list;
        ++size.value;
        return arrayUpdate(mutate, len, Leaf(edit, h, k, newValue), list);
    };
    var canEditNode = function canEditNode(edit, node) {
        return edit === node.edit;
    };
    /* Editing
 ******************************************************************************/ var Leaf__modify = function Leaf__modify(edit, keyEq, shift, f, h, k, size) {
        if (keyEq(k, this.key)) {
            var _v = f(this.value);
            if (_v === this.value) return this;
            else if (_v === nothing) {
                --size.value;
                return empty;
            }
            if (canEditNode(edit, this)) {
                this.value = _v;
                return this;
            }
            return Leaf(edit, h, k, _v);
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var Collision__modify = function Collision__modify(edit, keyEq, shift, f, h, k, size) {
        if (h === this.hash) {
            var canEdit = canEditNode(edit, this);
            var list = updateCollisionList(canEdit, edit, keyEq, this.hash, this.children, f, k, size);
            if (list === this.children) return this;
            return list.length > 1 ? Collision(edit, this.hash, list) : list[0]; // collapse single element collision list
        }
        var v = f();
        if (v === nothing) return this;
        ++size.value;
        return mergeLeaves(edit, shift, this.hash, this, h, Leaf(edit, h, k, v));
    };
    var IndexedNode__modify = function IndexedNode__modify(edit, keyEq, shift, f, h, k, size) {
        var mask = this.mask;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var bit = toBitmap(frag);
        var indx = fromBitmap(mask, bit);
        var exists = mask & bit;
        var current = exists ? children[indx] : empty;
        var child = current._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (current === child) return this;
        var canEdit = canEditNode(edit, this);
        var bitmap = mask;
        var newChildren = void 0;
        if (exists && isEmptyNode(child)) {
            // remove
            bitmap &= ~bit;
            if (!bitmap) return empty;
            if (children.length <= 2 && isLeaf(children[indx ^ 1])) return children[indx ^ 1]; // collapse
            newChildren = arraySpliceOut(canEdit, indx, children);
        } else if (!exists && !isEmptyNode(child)) {
            // add
            if (children.length >= MAX_INDEX_NODE) return expand(edit, frag, child, mask, children);
            bitmap |= bit;
            newChildren = arraySpliceIn(canEdit, indx, child, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, indx, child, children);
        if (canEdit) {
            this.mask = bitmap;
            this.children = newChildren;
            return this;
        }
        return IndexedNode(edit, bitmap, newChildren);
    };
    var ArrayNode__modify = function ArrayNode__modify(edit, keyEq, shift, f, h, k, size) {
        var count = this.size;
        var children = this.children;
        var frag = hashFragment(shift, h);
        var child = children[frag];
        var newChild = (child || empty)._modify(edit, keyEq, shift + SIZE, f, h, k, size);
        if (child === newChild) return this;
        var canEdit = canEditNode(edit, this);
        var newChildren = void 0;
        if (isEmptyNode(child) && !isEmptyNode(newChild)) {
            // add
            ++count;
            newChildren = arrayUpdate(canEdit, frag, newChild, children);
        } else if (!isEmptyNode(child) && isEmptyNode(newChild)) {
            // remove
            --count;
            if (count <= MIN_ARRAY_NODE) return pack(edit, count, frag, children);
            newChildren = arrayUpdate(canEdit, frag, empty, children);
        } else // modify
        newChildren = arrayUpdate(canEdit, frag, newChild, children);
        if (canEdit) {
            this.size = count;
            this.children = newChildren;
            return this;
        }
        return ArrayNode(edit, count, newChildren);
    };
    empty._modify = function(edit, keyEq, shift, f, h, k, size) {
        var v = f();
        if (v === nothing) return empty;
        ++size.value;
        return Leaf(edit, h, k, v);
    };
    /*
 ******************************************************************************/ function Map1(editable, edit, config, root, size) {
        this._editable = editable;
        this._edit = edit;
        this._config = config;
        this._root = root;
        this._size = size;
    }
    Map1.prototype.setTree = function(newRoot, newSize) {
        if (this._editable) {
            this._root = newRoot;
            this._size = newSize;
            return this;
        }
        return newRoot === this._root ? this : new Map1(this._editable, this._edit, this._config, newRoot, newSize);
    };
    /* Queries
 ******************************************************************************/ /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `alt` if none.
*/ var tryGetHash = hamt.tryGetHash = function(alt, hash, key, map) {
        var node = map._root;
        var shift = 0;
        var keyEq = map._config.keyEq;
        while(true)switch(node.type){
            case LEAF:
                return keyEq(key, node.key) ? node.value : alt;
            case COLLISION:
                if (hash === node.hash) {
                    var children = node.children;
                    for(var i = 0, len = children.length; i < len; ++i){
                        var child = children[i];
                        if (keyEq(key, child.key)) return child.value;
                    }
                }
                return alt;
            case INDEX:
                var frag = hashFragment(shift, hash);
                var bit = toBitmap(frag);
                if (node.mask & bit) {
                    node = node.children[fromBitmap(node.mask, bit)];
                    shift += SIZE;
                    break;
                }
                return alt;
            case ARRAY:
                node = node.children[hashFragment(shift, hash)];
                if (node) {
                    shift += SIZE;
                    break;
                }
                return alt;
            default:
                return alt;
        }
    };
    Map1.prototype.tryGetHash = function(alt, hash, key) {
        return tryGetHash(alt, hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `tryGetHash`
*/ var tryGet = hamt.tryGet = function(alt, key, map) {
        return tryGetHash(alt, map._config.hash(key), key, map);
    };
    Map1.prototype.tryGet = function(alt, key) {
        return tryGet(alt, key, this);
    };
    /**
    Lookup the value for `key` in `map` using a custom `hash`.

    Returns the value or `undefined` if none.
*/ var getHash = hamt.getHash = function(hash, key, map) {
        return tryGetHash(undefined, hash, key, map);
    };
    Map1.prototype.getHash = function(hash, key) {
        return getHash(hash, key, this);
    };
    /**
    Lookup the value for `key` in `map` using internal hash function.

    @see `get`
*/ var get = hamt.get = function(key, map) {
        return tryGetHash(undefined, map._config.hash(key), key, map);
    };
    Map1.prototype.get = function(key, alt) {
        return tryGet(alt, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses custom `hash`.
*/ var hasHash = hamt.has = function(hash, key, map) {
        return tryGetHash(nothing, hash, key, map) !== nothing;
    };
    Map1.prototype.hasHash = function(hash, key) {
        return hasHash(hash, key, this);
    };
    /**
    Does an entry exist for `key` in `map`? Uses internal hash function.
*/ var has = hamt.has = function(key, map) {
        return hasHash(map._config.hash(key), key, map);
    };
    Map1.prototype.has = function(key) {
        return has(key, this);
    };
    var defKeyCompare = function defKeyCompare(x, y) {
        return x === y;
    };
    /**
    Create an empty map.

    @param config Configuration.
*/ hamt.make = function(config) {
        return new Map1(0, 0, {
            keyEq: config && config.keyEq || defKeyCompare,
            hash: config && config.hash || hash
        }, empty, 0);
    };
    /**
    Empty map.
*/ hamt.empty = hamt.make();
    /**
    Does `map` contain any elements?
*/ var isEmpty = hamt.isEmpty = function(map) {
        return map && !!isEmptyNode(map._root);
    };
    Map1.prototype.isEmpty = function() {
        return isEmpty(this);
    };
    /* Updates
 ******************************************************************************/ /**
    Alter the value stored for `key` in `map` using function `f` using
    custom hash.

    `f` is invoked with the current value for `k` if it exists,
    or no arguments if no such value exists. `modify` will always either
    update or insert a value into the map.

    Returns a map with the modified value. Does not alter `map`.
*/ var modifyHash = hamt.modifyHash = function(f, hash, key, map) {
        var size = {
            value: map._size
        };
        var newRoot = map._root._modify(map._editable ? map._edit : NaN, map._config.keyEq, 0, f, hash, key, size);
        return map.setTree(newRoot, size.value);
    };
    Map1.prototype.modifyHash = function(hash, key, f) {
        return modifyHash(f, hash, key, this);
    };
    /**
    Alter the value stored for `key` in `map` using function `f` using
    internal hash function.

    @see `modifyHash`
*/ var modify = hamt.modify = function(f, key, map) {
        return modifyHash(f, map._config.hash(key), key, map);
    };
    Map1.prototype.modify = function(key, f) {
        return modify(f, key, this);
    };
    /**
    Store `value` for `key` in `map` using custom `hash`.

    Returns a map with the modified value. Does not alter `map`.
*/ var setHash = hamt.setHash = function(hash, key, value, map) {
        return modifyHash(constant(value), hash, key, map);
    };
    Map1.prototype.setHash = function(hash, key, value) {
        return setHash(hash, key, value, this);
    };
    /**
    Store `value` for `key` in `map` using internal hash function.

    @see `setHash`
*/ var set = hamt.set = function(key, value, map) {
        return setHash(map._config.hash(key), key, value, map);
    };
    Map1.prototype.set = function(key, value) {
        return set(key, value, this);
    };
    /**
    Remove the entry for `key` in `map`.

    Returns a map with the value removed. Does not alter `map`.
*/ var del = constant(nothing);
    var removeHash = hamt.removeHash = function(hash, key, map) {
        return modifyHash(del, hash, key, map);
    };
    Map1.prototype.removeHash = Map1.prototype.deleteHash = function(hash, key) {
        return removeHash(hash, key, this);
    };
    /**
    Remove the entry for `key` in `map` using internal hash function.

    @see `removeHash`
*/ var remove = hamt.remove = function(key, map) {
        return removeHash(map._config.hash(key), key, map);
    };
    Map1.prototype.remove = Map1.prototype.delete = function(key) {
        return remove(key, this);
    };
    /* Mutation
 ******************************************************************************/ /**
    Mark `map` as mutable.
 */ var beginMutation = hamt.beginMutation = function(map) {
        return new Map1(map._editable + 1, map._edit + 1, map._config, map._root, map._size);
    };
    Map1.prototype.beginMutation = function() {
        return beginMutation(this);
    };
    /**
    Mark `map` as immutable.
 */ var endMutation = hamt.endMutation = function(map) {
        map._editable = map._editable && map._editable - 1;
        return map;
    };
    Map1.prototype.endMutation = function() {
        return endMutation(this);
    };
    /**
    Mutate `map` within the context of `f`.
    @param f
    @param map HAMT
*/ var mutate = hamt.mutate = function(f, map) {
        var transient = beginMutation(map);
        f(transient);
        return endMutation(transient);
    };
    Map1.prototype.mutate = function(f) {
        return mutate(f, this);
    };
    /* Traversal
 ******************************************************************************/ /**
    Apply a continuation.
*/ var appk = function appk(k) {
        return k && lazyVisitChildren(k[0], k[1], k[2], k[3], k[4]);
    };
    /**
    Recursively visit all values stored in an array of nodes lazily.
*/ var lazyVisitChildren = function lazyVisitChildren(len, children, i, f, k) {
        while(i < len){
            var child = children[i++];
            if (child && !isEmptyNode(child)) return lazyVisit(child, f, [
                len,
                children,
                i,
                f,
                k
            ]);
        }
        return appk(k);
    };
    /**
    Recursively visit all values stored in `node` lazily.
*/ var lazyVisit = function lazyVisit(node, f, k) {
        switch(node.type){
            case LEAF:
                return {
                    value: f(node),
                    rest: k
                };
            case COLLISION:
            case ARRAY:
            case INDEX:
                var children = node.children;
                return lazyVisitChildren(children.length, children, 0, f, k);
            default:
                return appk(k);
        }
    };
    var DONE = {
        done: true
    };
    /**
    Javascript iterator over a map.
*/ function MapIterator(v) {
        this.v = v;
    }
    MapIterator.prototype.next = function() {
        if (!this.v) return DONE;
        var v0 = this.v;
        this.v = appk(v0.rest);
        return v0;
    };
    MapIterator.prototype[Symbol.iterator] = function() {
        return this;
    };
    /**
    Lazily visit each value in map with function `f`.
*/ var visit = function visit(map, f) {
        return new MapIterator(lazyVisit(map._root, f));
    };
    /**
    Get a Javascsript iterator of `map`.

    Iterates over `[key, value]` arrays.
*/ var buildPairs = function buildPairs(x) {
        return [
            x.key,
            x.value
        ];
    };
    var entries = hamt.entries = function(map) {
        return visit(map, buildPairs);
    };
    Map1.prototype.entries = Map1.prototype[Symbol.iterator] = function() {
        return entries(this);
    };
    /**
    Get array of all keys in `map`.

    Order is not guaranteed.
*/ var buildKeys = function buildKeys(x) {
        return x.key;
    };
    var keys = hamt.keys = function(map) {
        return visit(map, buildKeys);
    };
    Map1.prototype.keys = function() {
        return keys(this);
    };
    /**
    Get array of all values in `map`.

    Order is not guaranteed, duplicates are preserved.
*/ var buildValues = function buildValues(x) {
        return x.value;
    };
    var values = hamt.values = Map1.prototype.values = function(map) {
        return visit(map, buildValues);
    };
    Map1.prototype.values = function() {
        return values(this);
    };
    /* Fold
 ******************************************************************************/ /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function mapping accumulated value, value, and key to new value.
    @param z Starting value.
    @param m HAMT
*/ var fold = hamt.fold = function(f, z, m) {
        var root = m._root;
        if (root.type === LEAF) return f(z, root.value, root.key);
        var toVisit = [
            root.children
        ];
        var children = void 0;
        while(children = toVisit.pop())for(var i = 0, len = children.length; i < len;){
            var child = children[i++];
            if (child && child.type) {
                if (child.type === LEAF) z = f(z, child.value, child.key);
                else toVisit.push(child.children);
            }
        }
        return z;
    };
    Map1.prototype.fold = function(f, z) {
        return fold(f, z, this);
    };
    /**
    Visit every entry in the map, aggregating data.

    Order of nodes is not guaranteed.

    @param f Function invoked with value and key
    @param map HAMT
*/ var forEach = hamt.forEach = function(f, map) {
        return fold(function(_, value, key) {
            return f(value, key, map);
        }, null, map);
    };
    Map1.prototype.forEach = function(f) {
        return forEach(f, this);
    };
    /* Aggregate
 ******************************************************************************/ /**
    Get the number of entries in `map`.
*/ var count = hamt.count = function(map) {
        return map._size;
    };
    Map1.prototype.count = function() {
        return count(this);
    };
    Object.defineProperty(Map1.prototype, "size", {
        get: Map1.prototype.count
    });
    /* Export
 ******************************************************************************/ if (module.exports) module.exports = hamt;
    else undefined.hamt = hamt;
});
class $1ee798bac53aa7db$var$BuiltInMap {
    constructor(existing){
        $1ee798bac53aa7db$var$_defineProperty(this, "_map", void 0);
        this._map = new Map(existing === null || existing === void 0 ? void 0 : existing.entries());
    }
    keys() {
        return this._map.keys();
    }
    entries() {
        return this._map.entries();
    }
    get(k) {
        return this._map.get(k);
    }
    has(k) {
        return this._map.has(k);
    }
    set(k, v) {
        this._map.set(k, v);
        return this;
    }
    delete(k) {
        this._map.delete(k);
        return this;
    }
    clone() {
        return $1ee798bac53aa7db$var$persistentMap(this);
    }
    toMap() {
        return new Map(this._map);
    }
}
class $1ee798bac53aa7db$var$HashArrayMappedTrieMap {
    // Because hamt.empty is not a function there is no way to introduce type
    // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
    // $FlowIssue
    constructor(existing){
        $1ee798bac53aa7db$var$_defineProperty(this, "_hamt", $1ee798bac53aa7db$var$hamt_1.empty.beginMutation());
        if (existing instanceof $1ee798bac53aa7db$var$HashArrayMappedTrieMap) {
            const h = existing._hamt.endMutation();
            existing._hamt = h.beginMutation();
            this._hamt = h.beginMutation();
        } else if (existing) for (const [k, v] of existing.entries())this._hamt.set(k, v);
    }
    keys() {
        return this._hamt.keys();
    }
    entries() {
        return this._hamt.entries();
    }
    get(k) {
        return this._hamt.get(k);
    }
    has(k) {
        return this._hamt.has(k);
    }
    set(k, v) {
        this._hamt.set(k, v);
        return this;
    }
    delete(k) {
        this._hamt.delete(k);
        return this;
    }
    clone() {
        return $1ee798bac53aa7db$var$persistentMap(this);
    }
    toMap() {
        return new Map(this._hamt);
    }
}
function $1ee798bac53aa7db$var$persistentMap(existing) {
    if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_hamt_2020")) return new $1ee798bac53aa7db$var$HashArrayMappedTrieMap(existing);
    else return new $1ee798bac53aa7db$var$BuiltInMap(existing);
}
var $1ee798bac53aa7db$var$Recoil_PersistentMap = {
    persistentMap: $1ee798bac53aa7db$var$persistentMap
};
var $1ee798bac53aa7db$var$Recoil_PersistentMap_1 = $1ee798bac53aa7db$var$Recoil_PersistentMap.persistentMap;
var $1ee798bac53aa7db$var$Recoil_PersistentMap$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    persistentMap: $1ee798bac53aa7db$var$Recoil_PersistentMap_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the first set that are not
 * present in any of the subsequent sets.
 *
 * Note: this is written procedurally (i.e., without filterSet) for performant
 * use in tight loops.
 */ function $1ee798bac53aa7db$var$differenceSets(set, ...setsWithValuesToRemove) {
    const ret = new Set();
    FIRST: for (const value of set){
        for (const otherSet of setsWithValuesToRemove){
            if (otherSet.has(value)) continue FIRST;
        }
        ret.add(value);
    }
    return ret;
}
var $1ee798bac53aa7db$var$Recoil_differenceSets = $1ee798bac53aa7db$var$differenceSets;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a new Map object with the same keys as the original, but with the
 * values replaced with the output of the given callback function.
 */ function $1ee798bac53aa7db$var$mapMap(map, callback) {
    const result = new Map();
    map.forEach((value, key)=>{
        result.set(key, callback(value, key));
    });
    return result;
}
var $1ee798bac53aa7db$var$Recoil_mapMap = $1ee798bac53aa7db$var$mapMap;
function $1ee798bac53aa7db$var$makeGraph() {
    return {
        nodeDeps: new Map(),
        nodeToNodeSubscriptions: new Map()
    };
}
function $1ee798bac53aa7db$var$cloneGraph(graph) {
    return {
        nodeDeps: $1ee798bac53aa7db$var$Recoil_mapMap(graph.nodeDeps, (s)=>new Set(s)),
        nodeToNodeSubscriptions: $1ee798bac53aa7db$var$Recoil_mapMap(graph.nodeToNodeSubscriptions, (s)=>new Set(s))
    };
} // Note that this overwrites the deps of existing nodes, rather than unioning
// the new deps with the old deps.
function $1ee798bac53aa7db$var$mergeDepsIntoGraph(key, newDeps, graph, // graph compared with olderGraph:
olderGraph) {
    const { nodeDeps: nodeDeps, nodeToNodeSubscriptions: nodeToNodeSubscriptions } = graph;
    const oldDeps = nodeDeps.get(key);
    if (oldDeps && olderGraph && oldDeps !== olderGraph.nodeDeps.get(key)) return;
     // Update nodeDeps:
    nodeDeps.set(key, newDeps); // Add new deps to nodeToNodeSubscriptions:
    const addedDeps = oldDeps == null ? newDeps : $1ee798bac53aa7db$var$Recoil_differenceSets(newDeps, oldDeps);
    for (const dep of addedDeps){
        if (!nodeToNodeSubscriptions.has(dep)) nodeToNodeSubscriptions.set(dep, new Set());
        const existing = $1ee798bac53aa7db$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
        existing.add(key);
    } // Remove removed deps from nodeToNodeSubscriptions:
    if (oldDeps) {
        const removedDeps = $1ee798bac53aa7db$var$Recoil_differenceSets(oldDeps, newDeps);
        for (const dep of removedDeps){
            if (!nodeToNodeSubscriptions.has(dep)) return;
            const existing = $1ee798bac53aa7db$var$Recoil_nullthrows(nodeToNodeSubscriptions.get(dep));
            existing.delete(key);
            if (existing.size === 0) nodeToNodeSubscriptions.delete(dep);
        }
    }
}
function $1ee798bac53aa7db$var$saveDepsToStore(key, deps, store, version) {
    var _storeState$nextTree, _storeState$previousT, _storeState$previousT2, _storeState$previousT3;
    const storeState = store.getState();
    if (!(version === storeState.currentTree.version || version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $1ee798bac53aa7db$var$Recoil_recoverableViolation("Tried to save dependencies to a discarded tree");
     // Merge the dependencies discovered into the store's dependency map
    // for the version that was read:
    const graph = store.getGraph(version);
    $1ee798bac53aa7db$var$mergeDepsIntoGraph(key, deps, graph); // If this version is not the latest version, also write these dependencies
    // into later versions if they don't already have their own:
    if (version === ((_storeState$previousT2 = storeState.previousTree) === null || _storeState$previousT2 === void 0 ? void 0 : _storeState$previousT2.version)) {
        const currentGraph = store.getGraph(storeState.currentTree.version);
        $1ee798bac53aa7db$var$mergeDepsIntoGraph(key, deps, currentGraph, graph);
    }
    if (version === ((_storeState$previousT3 = storeState.previousTree) === null || _storeState$previousT3 === void 0 ? void 0 : _storeState$previousT3.version) || version === storeState.currentTree.version) {
        var _storeState$nextTree2;
        const nextVersion = (_storeState$nextTree2 = storeState.nextTree) === null || _storeState$nextTree2 === void 0 ? void 0 : _storeState$nextTree2.version;
        if (nextVersion !== undefined) {
            const nextGraph = store.getGraph(nextVersion);
            $1ee798bac53aa7db$var$mergeDepsIntoGraph(key, deps, nextGraph, graph);
        }
    }
}
var $1ee798bac53aa7db$var$Recoil_Graph = {
    cloneGraph: $1ee798bac53aa7db$var$cloneGraph,
    graph: $1ee798bac53aa7db$var$makeGraph,
    saveDepsToStore: $1ee798bac53aa7db$var$saveDepsToStore
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let $1ee798bac53aa7db$var$nextTreeStateVersion = 0;
const $1ee798bac53aa7db$var$getNextTreeStateVersion = ()=>$1ee798bac53aa7db$var$nextTreeStateVersion++;
let $1ee798bac53aa7db$var$nextStoreID = 0;
const $1ee798bac53aa7db$var$getNextStoreID = ()=>$1ee798bac53aa7db$var$nextStoreID++;
let $1ee798bac53aa7db$var$nextComponentID = 0;
const $1ee798bac53aa7db$var$getNextComponentID = ()=>$1ee798bac53aa7db$var$nextComponentID++;
var $1ee798bac53aa7db$var$Recoil_Keys = {
    getNextTreeStateVersion: $1ee798bac53aa7db$var$getNextTreeStateVersion,
    getNextStoreID: $1ee798bac53aa7db$var$getNextStoreID,
    getNextComponentID: $1ee798bac53aa7db$var$getNextComponentID
};
const { persistentMap: $1ee798bac53aa7db$var$persistentMap$1 } = $1ee798bac53aa7db$var$Recoil_PersistentMap$1;
const { graph: $1ee798bac53aa7db$var$graph } = $1ee798bac53aa7db$var$Recoil_Graph;
const { getNextTreeStateVersion: $1ee798bac53aa7db$var$getNextTreeStateVersion$1 } = $1ee798bac53aa7db$var$Recoil_Keys;
function $1ee798bac53aa7db$var$makeEmptyTreeState() {
    const version = $1ee798bac53aa7db$var$getNextTreeStateVersion$1();
    return {
        version: version,
        stateID: version,
        transactionMetadata: {},
        dirtyAtoms: new Set(),
        atomValues: $1ee798bac53aa7db$var$persistentMap$1(),
        nonvalidatedAtoms: $1ee798bac53aa7db$var$persistentMap$1()
    };
}
function $1ee798bac53aa7db$var$makeEmptyStoreState() {
    const currentTree = $1ee798bac53aa7db$var$makeEmptyTreeState();
    return {
        currentTree: currentTree,
        nextTree: null,
        previousTree: null,
        commitDepth: 0,
        knownAtoms: new Set(),
        knownSelectors: new Set(),
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(currentTree.version, $1ee798bac53aa7db$var$graph()),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        nodeCleanupFunctions: new Map()
    };
}
var $1ee798bac53aa7db$var$Recoil_State = {
    makeEmptyTreeState: $1ee798bac53aa7db$var$makeEmptyTreeState,
    makeEmptyStoreState: $1ee798bac53aa7db$var$makeEmptyStoreState,
    getNextTreeStateVersion: $1ee798bac53aa7db$var$getNextTreeStateVersion$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $1ee798bac53aa7db$var$RetentionZone {
}
function $1ee798bac53aa7db$var$retentionZone() {
    return new $1ee798bac53aa7db$var$RetentionZone();
}
var $1ee798bac53aa7db$var$Recoil_RetentionZone = {
    RetentionZone: $1ee798bac53aa7db$var$RetentionZone,
    retentionZone: $1ee798bac53aa7db$var$retentionZone
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Utilities for working with built-in Maps and Sets without mutating them.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$setByAddingToSet(set, v) {
    const next = new Set(set);
    next.add(v);
    return next;
}
function $1ee798bac53aa7db$var$setByDeletingFromSet(set, v) {
    const next = new Set(set);
    next.delete(v);
    return next;
}
function $1ee798bac53aa7db$var$mapBySettingInMap(map, k, v) {
    const next = new Map(map);
    next.set(k, v);
    return next;
}
function $1ee798bac53aa7db$var$mapByUpdatingInMap(map, k, updater) {
    const next = new Map(map);
    next.set(k, updater(next.get(k)));
    return next;
}
function $1ee798bac53aa7db$var$mapByDeletingFromMap(map, k) {
    const next = new Map(map);
    next.delete(k);
    return next;
}
function $1ee798bac53aa7db$var$mapByDeletingMultipleFromMap(map, ks) {
    const next = new Map(map);
    ks.forEach((k)=>next.delete(k));
    return next;
}
var $1ee798bac53aa7db$var$Recoil_CopyOnWrite = {
    setByAddingToSet: $1ee798bac53aa7db$var$setByAddingToSet,
    setByDeletingFromSet: $1ee798bac53aa7db$var$setByDeletingFromSet,
    mapBySettingInMap: $1ee798bac53aa7db$var$mapBySettingInMap,
    mapByUpdatingInMap: $1ee798bac53aa7db$var$mapByUpdatingInMap,
    mapByDeletingFromMap: $1ee798bac53aa7db$var$mapByDeletingFromMap,
    mapByDeletingMultipleFromMap: $1ee798bac53aa7db$var$mapByDeletingMultipleFromMap
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Creates a new iterable whose output is generated by passing the input
 * iterable's values through the filter function.
 */ function* $1ee798bac53aa7db$var$filterIterable(iterable, predicate) {
    // Use generator to create iterable/iterator
    let index = 0;
    for (const value of iterable)if (predicate(value, index++)) yield value;
}
var $1ee798bac53aa7db$var$Recoil_filterIterable = $1ee798bac53aa7db$var$filterIterable;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Return a proxy object based on the provided base and factories objects.
 * The proxy will include all properties of the base object as-is.
 * The factories object contains callbacks to obtain the values of the properies
 * for its keys.
 *
 * This is useful for providing users an object where some properties may be
 * lazily computed only on first access.
 */ // $FlowIssue[unclear-type]
function $1ee798bac53aa7db$var$lazyProxy(base, factories) {
    const proxy = new Proxy(base, {
        // Compute and cache lazy property if not already done.
        get: (target, prop)=>{
            if (!(prop in target) && prop in factories) target[prop] = factories[prop]();
            return target[prop];
        },
        // This method allows user to iterate keys as normal
        ownKeys: (target)=>{
            return Object.keys(target);
        }
    }); // $FlowIssue[incompatible-return]
    return proxy;
}
var $1ee798bac53aa7db$var$Recoil_lazyProxy = $1ee798bac53aa7db$var$lazyProxy;
const { getNode: $1ee798bac53aa7db$var$getNode$1, getNodeMaybe: $1ee798bac53aa7db$var$getNodeMaybe$1, recoilValuesForKeys: $1ee798bac53aa7db$var$recoilValuesForKeys$1 } = $1ee798bac53aa7db$var$Recoil_Node;
const { RetentionZone: $1ee798bac53aa7db$var$RetentionZone$1 } = $1ee798bac53aa7db$var$Recoil_RetentionZone;
const { setByAddingToSet: $1ee798bac53aa7db$var$setByAddingToSet$1 } = $1ee798bac53aa7db$var$Recoil_CopyOnWrite;
// flowlint-next-line unclear-type:off
const $1ee798bac53aa7db$var$emptySet = Object.freeze(new Set());
class $1ee798bac53aa7db$var$ReadOnlyRecoilValueError extends Error {
}
function $1ee798bac53aa7db$var$initializeRetentionForNode(store, nodeKey, retainedBy) {
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return ()=>undefined;
    const { nodesRetainedByZone: nodesRetainedByZone } = store.getState().retention;
    function addToZone(zone) {
        let set = nodesRetainedByZone.get(zone);
        if (!set) nodesRetainedByZone.set(zone, set = new Set());
        set.add(nodeKey);
    }
    if (retainedBy instanceof $1ee798bac53aa7db$var$RetentionZone$1) addToZone(retainedBy);
    else if (Array.isArray(retainedBy)) for (const zone of retainedBy)addToZone(zone);
    return ()=>{
        if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
        const { retention: retention } = store.getState();
        function deleteFromZone(zone) {
            const set = retention.nodesRetainedByZone.get(zone);
            set === null || set === void 0 || set.delete(nodeKey);
            if (set && set.size === 0) retention.nodesRetainedByZone.delete(zone);
        }
        if (retainedBy instanceof $1ee798bac53aa7db$var$RetentionZone$1) deleteFromZone(retainedBy);
        else if (Array.isArray(retainedBy)) for (const zone of retainedBy)deleteFromZone(zone);
    };
}
function $1ee798bac53aa7db$var$initializeNodeIfNewToStore(store, treeState, key, trigger) {
    const storeState = store.getState();
    if (storeState.nodeCleanupFunctions.has(key)) return;
    const node = $1ee798bac53aa7db$var$getNode$1(key);
    const retentionCleanup = $1ee798bac53aa7db$var$initializeRetentionForNode(store, key, node.retainedBy);
    const nodeCleanup = node.init(store, treeState, trigger);
    storeState.nodeCleanupFunctions.set(key, ()=>{
        nodeCleanup();
        retentionCleanup();
    });
}
function $1ee798bac53aa7db$var$initializeNode(store, key, trigger) {
    $1ee798bac53aa7db$var$initializeNodeIfNewToStore(store, store.getState().currentTree, key, trigger);
}
function $1ee798bac53aa7db$var$cleanUpNode(store, key) {
    var _state$nodeCleanupFun;
    const state = store.getState();
    (_state$nodeCleanupFun = state.nodeCleanupFunctions.get(key)) === null || _state$nodeCleanupFun === void 0 || _state$nodeCleanupFun();
    state.nodeCleanupFunctions.delete(key);
} // Get the current value loadable of a node and update the state.
// Update dependencies and subscriptions for selectors.
// Update saved value validation for atoms.
function $1ee798bac53aa7db$var$getNodeLoadable(store, state, key) {
    $1ee798bac53aa7db$var$initializeNodeIfNewToStore(store, state, key, "get");
    return $1ee798bac53aa7db$var$getNode$1(key).get(store, state);
} // Peek at the current value loadable for a node without any evaluation or state change
function $1ee798bac53aa7db$var$peekNodeLoadable(store, state, key) {
    return $1ee798bac53aa7db$var$getNode$1(key).peek(store, state);
} // Write value directly to state bypassing the Node interface as the node
// definitions may not have been loaded yet when processing the initial snapshot.
function $1ee798bac53aa7db$var$setUnvalidatedAtomValue_DEPRECATED(state, key, newValue) {
    var _node$invalidate;
    const node = $1ee798bac53aa7db$var$getNodeMaybe$1(key);
    node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
    return {
        ...state,
        atomValues: state.atomValues.clone().delete(key),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone().set(key, newValue),
        dirtyAtoms: $1ee798bac53aa7db$var$setByAddingToSet$1(state.dirtyAtoms, key)
    };
} // Return the discovered dependencies and values to be written by setting
// a node value. (Multiple values may be written due to selectors getting to
// set upstreams; deps may be discovered because of reads in updater functions.)
function $1ee798bac53aa7db$var$setNodeValue(store, state, key, newValue) {
    const node = $1ee798bac53aa7db$var$getNode$1(key);
    if (node.set == null) throw new $1ee798bac53aa7db$var$ReadOnlyRecoilValueError(`Attempt to set read-only RecoilValue: ${key}`);
    const set = node.set; // so flow doesn't lose the above refinement.
    $1ee798bac53aa7db$var$initializeNodeIfNewToStore(store, state, key, "set");
    return set(store, state, newValue);
}
function $1ee798bac53aa7db$var$peekNodeInfo(store, state, key) {
    const storeState = store.getState();
    const graph = store.getGraph(state.version);
    const type = $1ee798bac53aa7db$var$getNode$1(key).nodeType;
    return $1ee798bac53aa7db$var$Recoil_lazyProxy({
        type: type
    }, {
        // $FlowFixMe[underconstrained-implicit-instantiation]
        loadable: ()=>$1ee798bac53aa7db$var$peekNodeLoadable(store, state, key),
        isActive: ()=>storeState.knownAtoms.has(key) || storeState.knownSelectors.has(key),
        isSet: ()=>type === "selector" ? false : state.atomValues.has(key),
        isModified: ()=>state.dirtyAtoms.has(key),
        // Report current dependencies.  If the node hasn't been evaluated, then
        // dependencies may be missing based on the current state.
        deps: ()=>{
            var _graph$nodeDeps$get;
            return $1ee798bac53aa7db$var$recoilValuesForKeys$1((_graph$nodeDeps$get = graph.nodeDeps.get(key)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : []);
        },
        // Reports all "current" subscribers.  Evaluating other nodes or
        // previous in-progress async evaluations may introduce new subscribers.
        subscribers: ()=>{
            var _storeState$nodeToCom, _storeState$nodeToCom2;
            return {
                nodes: $1ee798bac53aa7db$var$recoilValuesForKeys$1($1ee798bac53aa7db$var$Recoil_filterIterable($1ee798bac53aa7db$var$getDownstreamNodes(store, state, new Set([
                    key
                ])), (nodeKey)=>nodeKey !== key)),
                components: $1ee798bac53aa7db$var$Recoil_mapIterable((_storeState$nodeToCom = (_storeState$nodeToCom2 = storeState.nodeToComponentSubscriptions.get(key)) === null || _storeState$nodeToCom2 === void 0 ? void 0 : _storeState$nodeToCom2.values()) !== null && _storeState$nodeToCom !== void 0 ? _storeState$nodeToCom : [], ([name])=>({
                        name: name
                    }))
            };
        }
    });
} // Find all of the recursively dependent nodes
function $1ee798bac53aa7db$var$getDownstreamNodes(store, state, keys) {
    const visitedNodes = new Set();
    const visitingNodes = Array.from(keys);
    const graph = store.getGraph(state.version);
    for(let key = visitingNodes.pop(); key; key = visitingNodes.pop()){
        var _graph$nodeToNodeSubs;
        visitedNodes.add(key);
        const subscribedNodes = (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(key)) !== null && _graph$nodeToNodeSubs !== void 0 ? _graph$nodeToNodeSubs : $1ee798bac53aa7db$var$emptySet;
        for (const downstreamNode of subscribedNodes)if (!visitedNodes.has(downstreamNode)) visitingNodes.push(downstreamNode);
    }
    return visitedNodes;
}
var $1ee798bac53aa7db$var$Recoil_FunctionalCore = {
    getNodeLoadable: $1ee798bac53aa7db$var$getNodeLoadable,
    peekNodeLoadable: $1ee798bac53aa7db$var$peekNodeLoadable,
    setNodeValue: $1ee798bac53aa7db$var$setNodeValue,
    initializeNode: $1ee798bac53aa7db$var$initializeNode,
    cleanUpNode: $1ee798bac53aa7db$var$cleanUpNode,
    setUnvalidatedAtomValue_DEPRECATED: $1ee798bac53aa7db$var$setUnvalidatedAtomValue_DEPRECATED,
    peekNodeInfo: $1ee798bac53aa7db$var$peekNodeInfo,
    getDownstreamNodes: $1ee798bac53aa7db$var$getDownstreamNodes
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ let $1ee798bac53aa7db$var$_invalidateMemoizedSnapshot = null;
function $1ee798bac53aa7db$var$setInvalidateMemoizedSnapshot(invalidate) {
    $1ee798bac53aa7db$var$_invalidateMemoizedSnapshot = invalidate;
}
function $1ee798bac53aa7db$var$invalidateMemoizedSnapshot() {
    var _invalidateMemoizedSn;
    (_invalidateMemoizedSn = $1ee798bac53aa7db$var$_invalidateMemoizedSnapshot) === null || _invalidateMemoizedSn === void 0 || _invalidateMemoizedSn();
}
var $1ee798bac53aa7db$var$Recoil_SnapshotCache = {
    setInvalidateMemoizedSnapshot: $1ee798bac53aa7db$var$setInvalidateMemoizedSnapshot,
    invalidateMemoizedSnapshot: $1ee798bac53aa7db$var$invalidateMemoizedSnapshot
};
const { getDownstreamNodes: $1ee798bac53aa7db$var$getDownstreamNodes$1, getNodeLoadable: $1ee798bac53aa7db$var$getNodeLoadable$1, setNodeValue: $1ee798bac53aa7db$var$setNodeValue$1 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { getNextComponentID: $1ee798bac53aa7db$var$getNextComponentID$1 } = $1ee798bac53aa7db$var$Recoil_Keys;
const { getNode: $1ee798bac53aa7db$var$getNode$2, getNodeMaybe: $1ee798bac53aa7db$var$getNodeMaybe$2 } = $1ee798bac53aa7db$var$Recoil_Node;
const { DefaultValue: $1ee798bac53aa7db$var$DefaultValue$1 } = $1ee798bac53aa7db$var$Recoil_Node;
const { reactMode: $1ee798bac53aa7db$var$reactMode$1 } = $1ee798bac53aa7db$var$Recoil_ReactMode;
const { AbstractRecoilValue: $1ee798bac53aa7db$var$AbstractRecoilValue$1, RecoilState: $1ee798bac53aa7db$var$RecoilState$1, RecoilValueReadOnly: $1ee798bac53aa7db$var$RecoilValueReadOnly$1, isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValue$1;
const { invalidateMemoizedSnapshot: $1ee798bac53aa7db$var$invalidateMemoizedSnapshot$1 } = $1ee798bac53aa7db$var$Recoil_SnapshotCache;
function $1ee798bac53aa7db$var$getRecoilValueAsLoadable(store, { key: key }, treeState = store.getState().currentTree) {
    var _storeState$nextTree, _storeState$previousT;
    // Reading from an older tree can cause bugs because the dependencies that we
    // discover during the read are lost.
    const storeState = store.getState();
    if (!(treeState.version === storeState.currentTree.version || treeState.version === ((_storeState$nextTree = storeState.nextTree) === null || _storeState$nextTree === void 0 ? void 0 : _storeState$nextTree.version) || treeState.version === ((_storeState$previousT = storeState.previousTree) === null || _storeState$previousT === void 0 ? void 0 : _storeState$previousT.version))) $1ee798bac53aa7db$var$Recoil_recoverableViolation("Tried to read from a discarded tree");
    const loadable = $1ee798bac53aa7db$var$getNodeLoadable$1(store, treeState, key);
    if (loadable.state === "loading") loadable.contents.catch(()=>{
        /**
       * HACK: intercept thrown error here to prevent an uncaught promise exception. Ideally this would happen closer to selector
       * execution (perhaps introducing a new ERROR class to be resolved by async selectors that are in an error state)
       */ return;
    });
    return loadable;
}
function $1ee798bac53aa7db$var$applyAtomValueWrites(atomValues, writes) {
    const result = atomValues.clone();
    writes.forEach((v, k)=>{
        if (v.state === "hasValue" && v.contents instanceof $1ee798bac53aa7db$var$DefaultValue$1) result.delete(k);
        else result.set(k, v);
    });
    return result;
}
function $1ee798bac53aa7db$var$valueFromValueOrUpdater(store, state, { key: key }, valueOrUpdater) {
    if (typeof valueOrUpdater === "function") {
        // Updater form: pass in the current value. Throw if the current value
        // is unavailable (namely when updating an async selector that's
        // pending or errored):
        const current = $1ee798bac53aa7db$var$getNodeLoadable$1(store, state, key);
        if (current.state === "loading") {
            const msg = `Tried to set atom or selector "${key}" using an updater function while the current state is pending, this is not currently supported.`;
            $1ee798bac53aa7db$var$Recoil_recoverableViolation(msg);
            throw $1ee798bac53aa7db$var$Recoil_err(msg);
        } else if (current.state === "hasError") throw current.contents;
         // T itself may be a function, so our refinement is not sufficient:
        return valueOrUpdater(current.contents); // flowlint-line unclear-type:off
    } else return valueOrUpdater;
}
function $1ee798bac53aa7db$var$applyAction(store, state, action) {
    if (action.type === "set") {
        const { recoilValue: recoilValue, valueOrUpdater: valueOrUpdater } = action;
        const newValue = $1ee798bac53aa7db$var$valueFromValueOrUpdater(store, state, recoilValue, valueOrUpdater);
        const writes = $1ee798bac53aa7db$var$setNodeValue$1(store, state, recoilValue.key, newValue);
        for (const [key, loadable] of writes.entries())$1ee798bac53aa7db$var$writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === "setLoadable") {
        const { recoilValue: { key: key }, loadable: loadable } = action;
        $1ee798bac53aa7db$var$writeLoadableToTreeState(state, key, loadable);
    } else if (action.type === "markModified") {
        const { recoilValue: { key: key } } = action;
        state.dirtyAtoms.add(key);
    } else if (action.type === "setUnvalidated") {
        var _node$invalidate;
        // Write value directly to state bypassing the Node interface as the node
        // definitions may not have been loaded yet when processing the initial snapshot.
        const { recoilValue: { key: key }, unvalidatedValue: unvalidatedValue } = action;
        const node = $1ee798bac53aa7db$var$getNodeMaybe$2(key);
        node === null || node === void 0 || (_node$invalidate = node.invalidate) === null || _node$invalidate === void 0 || _node$invalidate.call(node, state);
        state.atomValues.delete(key);
        state.nonvalidatedAtoms.set(key, unvalidatedValue);
        state.dirtyAtoms.add(key);
    } else $1ee798bac53aa7db$var$Recoil_recoverableViolation(`Unknown action ${action.type}`);
}
function $1ee798bac53aa7db$var$writeLoadableToTreeState(state, key, loadable) {
    if (loadable.state === "hasValue" && loadable.contents instanceof $1ee798bac53aa7db$var$DefaultValue$1) state.atomValues.delete(key);
    else state.atomValues.set(key, loadable);
    state.dirtyAtoms.add(key);
    state.nonvalidatedAtoms.delete(key);
}
function $1ee798bac53aa7db$var$applyActionsToStore(store, actions) {
    store.replaceState((state)=>{
        const newState = $1ee798bac53aa7db$var$copyTreeState(state);
        for (const action of actions)$1ee798bac53aa7db$var$applyAction(store, newState, action);
        $1ee798bac53aa7db$var$invalidateDownstreams(store, newState);
        $1ee798bac53aa7db$var$invalidateMemoizedSnapshot$1();
        return newState;
    });
}
function $1ee798bac53aa7db$var$queueOrPerformStateUpdate(store, action) {
    if ($1ee798bac53aa7db$var$batchStack.length) {
        const actionsByStore = $1ee798bac53aa7db$var$batchStack[$1ee798bac53aa7db$var$batchStack.length - 1];
        let actions = actionsByStore.get(store);
        if (!actions) actionsByStore.set(store, actions = []);
        actions.push(action);
    } else $1ee798bac53aa7db$var$applyActionsToStore(store, [
        action
    ]);
}
const $1ee798bac53aa7db$var$batchStack = [];
function $1ee798bac53aa7db$var$batchStart() {
    const actionsByStore = new Map();
    $1ee798bac53aa7db$var$batchStack.push(actionsByStore);
    return ()=>{
        for (const [store, actions] of actionsByStore)$1ee798bac53aa7db$var$applyActionsToStore(store, actions);
        const popped = $1ee798bac53aa7db$var$batchStack.pop();
        if (popped !== actionsByStore) $1ee798bac53aa7db$var$Recoil_recoverableViolation("Incorrect order of batch popping");
    };
}
function $1ee798bac53aa7db$var$copyTreeState(state) {
    return {
        ...state,
        atomValues: state.atomValues.clone(),
        nonvalidatedAtoms: state.nonvalidatedAtoms.clone(),
        dirtyAtoms: new Set(state.dirtyAtoms)
    };
}
function $1ee798bac53aa7db$var$invalidateDownstreams(store, state) {
    // Inform any nodes that were changed or downstream of changes so that they
    // can clear out any caches as needed due to the update:
    const downstreams = $1ee798bac53aa7db$var$getDownstreamNodes$1(store, state, state.dirtyAtoms);
    for (const key of downstreams){
        var _getNodeMaybe, _getNodeMaybe$invalid;
        (_getNodeMaybe = $1ee798bac53aa7db$var$getNodeMaybe$2(key)) === null || _getNodeMaybe === void 0 || (_getNodeMaybe$invalid = _getNodeMaybe.invalidate) === null || _getNodeMaybe$invalid === void 0 || _getNodeMaybe$invalid.call(_getNodeMaybe, state);
    }
}
function $1ee798bac53aa7db$var$setRecoilValue(store, recoilValue, valueOrUpdater) {
    $1ee798bac53aa7db$var$queueOrPerformStateUpdate(store, {
        type: "set",
        recoilValue: recoilValue,
        valueOrUpdater: valueOrUpdater
    });
}
function $1ee798bac53aa7db$var$setRecoilValueLoadable(store, recoilValue, loadable) {
    if (loadable instanceof $1ee798bac53aa7db$var$DefaultValue$1) return $1ee798bac53aa7db$var$setRecoilValue(store, recoilValue, loadable);
    $1ee798bac53aa7db$var$queueOrPerformStateUpdate(store, {
        type: "setLoadable",
        recoilValue: recoilValue,
        loadable: loadable
    });
}
function $1ee798bac53aa7db$var$markRecoilValueModified(store, recoilValue) {
    $1ee798bac53aa7db$var$queueOrPerformStateUpdate(store, {
        type: "markModified",
        recoilValue: recoilValue
    });
}
function $1ee798bac53aa7db$var$setUnvalidatedRecoilValue(store, recoilValue, unvalidatedValue) {
    $1ee798bac53aa7db$var$queueOrPerformStateUpdate(store, {
        type: "setUnvalidated",
        recoilValue: recoilValue,
        unvalidatedValue: unvalidatedValue
    });
}
function $1ee798bac53aa7db$var$subscribeToRecoilValue(store, { key: key }, callback, componentDebugName = null) {
    const subID = $1ee798bac53aa7db$var$getNextComponentID$1();
    const storeState = store.getState();
    if (!storeState.nodeToComponentSubscriptions.has(key)) storeState.nodeToComponentSubscriptions.set(key, new Map());
    $1ee798bac53aa7db$var$Recoil_nullthrows(storeState.nodeToComponentSubscriptions.get(key)).set(subID, [
        componentDebugName !== null && componentDebugName !== void 0 ? componentDebugName : "<not captured>",
        callback
    ]); // Handle the case that, during the same tick that we are subscribing, an atom
    // has been updated by some effect handler. Otherwise we will miss the update.
    const mode = $1ee798bac53aa7db$var$reactMode$1();
    if (mode.early && (mode.mode === "LEGACY" || mode.mode === "MUTABLE_SOURCE")) {
        const nextTree = store.getState().nextTree;
        if (nextTree && nextTree.dirtyAtoms.has(key)) callback(nextTree);
    }
    return {
        release: ()=>{
            const releaseStoreState = store.getState();
            const subs = releaseStoreState.nodeToComponentSubscriptions.get(key);
            if (subs === undefined || !subs.has(subID)) {
                $1ee798bac53aa7db$var$Recoil_recoverableViolation(`Subscription missing at release time for atom ${key}. This is a bug in Recoil.`);
                return;
            }
            subs.delete(subID);
            if (subs.size === 0) releaseStoreState.nodeToComponentSubscriptions.delete(key);
        }
    };
}
function $1ee798bac53aa7db$var$refreshRecoilValue(store, recoilValue) {
    var _node$clearCache;
    const { currentTree: currentTree } = store.getState();
    const node = $1ee798bac53aa7db$var$getNode$2(recoilValue.key);
    (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, currentTree);
}
var $1ee798bac53aa7db$var$Recoil_RecoilValueInterface = {
    RecoilValueReadOnly: $1ee798bac53aa7db$var$RecoilValueReadOnly$1,
    AbstractRecoilValue: $1ee798bac53aa7db$var$AbstractRecoilValue$1,
    RecoilState: $1ee798bac53aa7db$var$RecoilState$1,
    getRecoilValueAsLoadable: $1ee798bac53aa7db$var$getRecoilValueAsLoadable,
    setRecoilValue: $1ee798bac53aa7db$var$setRecoilValue,
    setRecoilValueLoadable: $1ee798bac53aa7db$var$setRecoilValueLoadable,
    markRecoilValueModified: $1ee798bac53aa7db$var$markRecoilValueModified,
    setUnvalidatedRecoilValue: $1ee798bac53aa7db$var$setUnvalidatedRecoilValue,
    subscribeToRecoilValue: $1ee798bac53aa7db$var$subscribeToRecoilValue,
    isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue$1,
    applyAtomValueWrites: $1ee798bac53aa7db$var$applyAtomValueWrites,
    batchStart: // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
    $1ee798bac53aa7db$var$batchStart,
    writeLoadableToTreeState: $1ee798bac53aa7db$var$writeLoadableToTreeState,
    invalidateDownstreams: $1ee798bac53aa7db$var$invalidateDownstreams,
    copyTreeState: $1ee798bac53aa7db$var$copyTreeState,
    refreshRecoilValue: $1ee798bac53aa7db$var$refreshRecoilValue
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * The someSet() method tests whether some elements in the given Set pass the
 * test implemented by the provided function.
 */ function $1ee798bac53aa7db$var$someSet(set, callback, context) {
    const iterator = set.entries();
    let current = iterator.next();
    while(!current.done){
        const entry = current.value;
        if (callback.call(context, entry[1], entry[0], set)) return true;
        current = iterator.next();
    }
    return false;
}
var $1ee798bac53aa7db$var$Recoil_someSet = $1ee798bac53aa7db$var$someSet;
const { cleanUpNode: $1ee798bac53aa7db$var$cleanUpNode$1 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { deleteNodeConfigIfPossible: $1ee798bac53aa7db$var$deleteNodeConfigIfPossible$1, getNode: $1ee798bac53aa7db$var$getNode$3 } = $1ee798bac53aa7db$var$Recoil_Node;
const { RetentionZone: $1ee798bac53aa7db$var$RetentionZone$2 } = $1ee798bac53aa7db$var$Recoil_RetentionZone;
// Components that aren't mounted after suspending for this long will be assumed
// to be discarded and their resources released.
const $1ee798bac53aa7db$var$SUSPENSE_TIMEOUT_MS = 120000;
const $1ee798bac53aa7db$var$emptySet$1 = new Set();
function $1ee798bac53aa7db$var$releaseRetainablesNowOnCurrentTree(store, retainables) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    if (storeState.nextTree) {
        $1ee798bac53aa7db$var$Recoil_recoverableViolation("releaseNodesNowOnCurrentTree should only be called at the end of a batch");
        return; // leak memory rather than erase something that's about to be used.
    }
    const nodes = new Set();
    for (const r of retainables){
        if (r instanceof $1ee798bac53aa7db$var$RetentionZone$2) for (const n of $1ee798bac53aa7db$var$nodesRetainedByZone(storeState, r))nodes.add(n);
        else nodes.add(r);
    }
    const releasableNodes = $1ee798bac53aa7db$var$findReleasableNodes(store, nodes);
    for (const node of releasableNodes)$1ee798bac53aa7db$var$releaseNode(store, treeState, node);
}
function $1ee798bac53aa7db$var$findReleasableNodes(store, searchFromNodes) {
    const storeState = store.getState();
    const treeState = storeState.currentTree;
    const graph = store.getGraph(treeState.version);
    const releasableNodes = new Set(); // mutated to collect answer
    const nonReleasableNodes = new Set();
    findReleasableNodesInner(searchFromNodes);
    return releasableNodes;
    function findReleasableNodesInner(searchFromNodes) {
        const releasableNodesFoundThisIteration = new Set();
        const downstreams = $1ee798bac53aa7db$var$getDownstreamNodesInTopologicalOrder(store, treeState, searchFromNodes, releasableNodes, nonReleasableNodes // don't descend into these
        ); // Find which of the downstream nodes are releasable and which are not:
        for (const node of downstreams){
            var _storeState$retention;
            // Not releasable if configured to be retained forever:
            if ($1ee798bac53aa7db$var$getNode$3(node).retainedBy === "recoilRoot") {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained directly by a component:
            if (((_storeState$retention = storeState.retention.referenceCounts.get(node)) !== null && _storeState$retention !== void 0 ? _storeState$retention : 0) > 0) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if retained by a zone:
            if ($1ee798bac53aa7db$var$zonesThatCouldRetainNode(node).some((z)=>storeState.retention.referenceCounts.get(z))) {
                nonReleasableNodes.add(node);
                continue;
            } // Not releasable if it has a non-releasable child (which will already be in
            // nonReleasableNodes because we are going in topological order):
            const nodeChildren = graph.nodeToNodeSubscriptions.get(node);
            if (nodeChildren && $1ee798bac53aa7db$var$Recoil_someSet(nodeChildren, (child)=>nonReleasableNodes.has(child))) {
                nonReleasableNodes.add(node);
                continue;
            }
            releasableNodes.add(node);
            releasableNodesFoundThisIteration.add(node);
        } // If we found any releasable nodes, we need to walk UP from those nodes to
        // find whether their parents can now be released as well:
        const parents = new Set();
        for (const node of releasableNodesFoundThisIteration)for (const parent of (_graph$nodeDeps$get = graph.nodeDeps.get(node)) !== null && _graph$nodeDeps$get !== void 0 ? _graph$nodeDeps$get : $1ee798bac53aa7db$var$emptySet$1){
            var _graph$nodeDeps$get;
            if (!releasableNodes.has(parent)) parents.add(parent);
        }
        if (parents.size) findReleasableNodesInner(parents);
    }
} // Children before parents
function $1ee798bac53aa7db$var$getDownstreamNodesInTopologicalOrder(store, treeState, nodes, doNotDescendInto1, doNotDescendInto2) {
    const graph = store.getGraph(treeState.version);
    const answer = [];
    const visited = new Set();
    while(nodes.size > 0)visit($1ee798bac53aa7db$var$Recoil_nullthrows(nodes.values().next().value));
    return answer;
    function visit(node) {
        if (doNotDescendInto1.has(node) || doNotDescendInto2.has(node)) {
            nodes.delete(node);
            return;
        }
        if (visited.has(node)) return;
        const children = graph.nodeToNodeSubscriptions.get(node);
        if (children) for (const child of children)visit(child);
        visited.add(node);
        nodes.delete(node);
        answer.push(node);
    }
}
function $1ee798bac53aa7db$var$releaseNode(store, treeState, node) {
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
     // Atom effects, in-closure caches, etc.:
    $1ee798bac53aa7db$var$cleanUpNode$1(store, node); // Delete from store state:
    const storeState = store.getState();
    storeState.knownAtoms.delete(node);
    storeState.knownSelectors.delete(node);
    storeState.nodeTransactionSubscriptions.delete(node);
    storeState.retention.referenceCounts.delete(node);
    const zones = $1ee798bac53aa7db$var$zonesThatCouldRetainNode(node);
    for (const zone of zones){
        var _storeState$retention2;
        (_storeState$retention2 = storeState.retention.nodesRetainedByZone.get(zone)) === null || _storeState$retention2 === void 0 || _storeState$retention2.delete(node);
    } // Note that we DO NOT delete from nodeToComponentSubscriptions because this
    // already happens when the last component that was retaining the node unmounts,
    // and this could happen either before or after that.
    // Delete from TreeState and dep graph:
    treeState.atomValues.delete(node);
    treeState.dirtyAtoms.delete(node);
    treeState.nonvalidatedAtoms.delete(node);
    const graph = storeState.graphsByVersion.get(treeState.version);
    if (graph) {
        const deps = graph.nodeDeps.get(node);
        if (deps !== undefined) {
            graph.nodeDeps.delete(node);
            for (const dep of deps){
                var _graph$nodeToNodeSubs;
                (_graph$nodeToNodeSubs = graph.nodeToNodeSubscriptions.get(dep)) === null || _graph$nodeToNodeSubs === void 0 || _graph$nodeToNodeSubs.delete(node);
            }
        } // No need to delete sub's deps as there should be no subs at this point.
        // But an invariant would require deleting nodes in topological order.
        graph.nodeToNodeSubscriptions.delete(node);
    } // Node config (for family members only as their configs can be recreated, and
    // only if they are not retained within any other Stores):
    $1ee798bac53aa7db$var$deleteNodeConfigIfPossible$1(node);
}
function $1ee798bac53aa7db$var$nodesRetainedByZone(storeState, zone) {
    var _storeState$retention3;
    return (_storeState$retention3 = storeState.retention.nodesRetainedByZone.get(zone)) !== null && _storeState$retention3 !== void 0 ? _storeState$retention3 : $1ee798bac53aa7db$var$emptySet$1;
}
function $1ee798bac53aa7db$var$zonesThatCouldRetainNode(node) {
    const retainedBy = $1ee798bac53aa7db$var$getNode$3(node).retainedBy;
    if (retainedBy === undefined || retainedBy === "components" || retainedBy === "recoilRoot") return [];
    else if (retainedBy instanceof $1ee798bac53aa7db$var$RetentionZone$2) return [
        retainedBy
    ];
    else return retainedBy; // it's an array of zones
}
function $1ee798bac53aa7db$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable) {
    const state = store.getState();
    if (state.nextTree) state.retention.retainablesToCheckForRelease.add(retainable);
    else $1ee798bac53aa7db$var$releaseRetainablesNowOnCurrentTree(store, new Set([
        retainable
    ]));
}
function $1ee798bac53aa7db$var$updateRetainCount(store, retainable, delta) {
    var _map$get;
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const map = store.getState().retention.referenceCounts;
    const newCount = ((_map$get = map.get(retainable)) !== null && _map$get !== void 0 ? _map$get : 0) + delta;
    if (newCount === 0) $1ee798bac53aa7db$var$updateRetainCountToZero(store, retainable);
    else map.set(retainable, newCount);
}
function $1ee798bac53aa7db$var$updateRetainCountToZero(store, retainable) {
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const map = store.getState().retention.referenceCounts;
    map.delete(retainable);
    $1ee798bac53aa7db$var$scheduleOrPerformPossibleReleaseOfRetainable(store, retainable);
}
function $1ee798bac53aa7db$var$releaseScheduledRetainablesNow(store) {
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
    const state = store.getState();
    $1ee798bac53aa7db$var$releaseRetainablesNowOnCurrentTree(store, state.retention.retainablesToCheckForRelease);
    state.retention.retainablesToCheckForRelease.clear();
}
function $1ee798bac53aa7db$var$retainedByOptionWithDefault(r) {
    // The default will change from 'recoilRoot' to 'components' in the future.
    return r === undefined ? "recoilRoot" : r;
}
var $1ee798bac53aa7db$var$Recoil_Retention = {
    SUSPENSE_TIMEOUT_MS: $1ee798bac53aa7db$var$SUSPENSE_TIMEOUT_MS,
    updateRetainCount: $1ee798bac53aa7db$var$updateRetainCount,
    updateRetainCountToZero: $1ee798bac53aa7db$var$updateRetainCountToZero,
    releaseScheduledRetainablesNow: $1ee798bac53aa7db$var$releaseScheduledRetainablesNow,
    retainedByOptionWithDefault: $1ee798bac53aa7db$var$retainedByOptionWithDefault
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ const { unstable_batchedUpdates: $1ee798bac53aa7db$var$unstable_batchedUpdates } = (0, (/*@__PURE__*/$parcel$interopDefault($d2lNW)));
var $1ee798bac53aa7db$var$ReactBatchedUpdates = {
    unstable_batchedUpdates: $1ee798bac53aa7db$var$unstable_batchedUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is to export esstiential functions from react-dom
 * for our web build
 *
 * 
 * @format
 * @oncall recoil
 */ // @fb-only: const {unstable_batchedUpdates} = require('ReactDOMComet');
// prettier-ignore
const { unstable_batchedUpdates: $1ee798bac53aa7db$var$unstable_batchedUpdates$1 } = $1ee798bac53aa7db$var$ReactBatchedUpdates; // @oss-only
var $1ee798bac53aa7db$var$Recoil_ReactBatchedUpdates = {
    unstable_batchedUpdates: $1ee798bac53aa7db$var$unstable_batchedUpdates$1
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ const { batchStart: $1ee798bac53aa7db$var$batchStart$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { unstable_batchedUpdates: $1ee798bac53aa7db$var$unstable_batchedUpdates$2 } = $1ee798bac53aa7db$var$Recoil_ReactBatchedUpdates; // flowlint-next-line unclear-type:off
/*
 * During SSR, unstable_batchedUpdates may be undefined so this
 * falls back to a basic function that executes the batch
 */ let $1ee798bac53aa7db$var$batcher = $1ee798bac53aa7db$var$unstable_batchedUpdates$2 || ((batchFn)=>batchFn());
/**
 * Sets the provided batcher function as the batcher function used by Recoil.
 *
 * Set the batcher to a custom batcher for your renderer,
 * if you use a renderer other than React DOM or React Native.
 */ const $1ee798bac53aa7db$var$setBatcher = (newBatcher)=>{
    $1ee798bac53aa7db$var$batcher = newBatcher;
};
/**
 * Returns the current batcher function.
 */ const $1ee798bac53aa7db$var$getBatcher = ()=>$1ee798bac53aa7db$var$batcher;
/**
 * Calls the current batcher function and passes the
 * provided callback function.
 */ const $1ee798bac53aa7db$var$batchUpdates = (callback)=>{
    $1ee798bac53aa7db$var$batcher(()=>{
        let batchEnd = ()=>undefined;
        try {
            batchEnd = $1ee798bac53aa7db$var$batchStart$1();
            callback();
        } finally{
            batchEnd();
        }
    });
};
var $1ee798bac53aa7db$var$Recoil_Batching = {
    getBatcher: $1ee798bac53aa7db$var$getBatcher,
    setBatcher: $1ee798bac53aa7db$var$setBatcher,
    batchUpdates: $1ee798bac53aa7db$var$batchUpdates
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Combines multiple Iterables into a single Iterable.
 * Traverses the input Iterables in the order provided and maintains the order
 * of their elements.
 *
 * Example:
 * ```
 * const r = Array.from(concatIterables(['a', 'b'], ['c'], ['d', 'e', 'f']));
 * r == ['a', 'b', 'c', 'd', 'e', 'f'];
 * ```
 */ function* $1ee798bac53aa7db$var$concatIterables(iters) {
    for (const iter of iters)for (const val of iter)yield val;
}
var $1ee798bac53aa7db$var$Recoil_concatIterables = $1ee798bac53aa7db$var$concatIterables;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /* eslint-disable fb-www/typeof-undefined */ const $1ee798bac53aa7db$var$isSSR = typeof Window === "undefined" || typeof window === "undefined";
/* eslint-enable fb-www/typeof-undefined */ const $1ee798bac53aa7db$var$isWindow = (value)=>!$1ee798bac53aa7db$var$isSSR && (value === window || value instanceof Window);
const $1ee798bac53aa7db$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative"; // eslint-disable-line fb-www/typeof-undefined
var $1ee798bac53aa7db$var$Recoil_Environment = {
    isSSR: $1ee798bac53aa7db$var$isSSR,
    isReactNative: $1ee798bac53aa7db$var$isReactNative,
    isWindow: $1ee798bac53aa7db$var$isWindow
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Caches a function's results based on the key returned by the passed
 * hashFunction.
 */ function $1ee798bac53aa7db$var$memoizeWithArgsHash(fn, hashFunction) {
    let cache;
    return (...args)=>{
        if (!cache) cache = {};
        const key = hashFunction(...args);
        if (!Object.hasOwnProperty.call(cache, key)) cache[key] = fn(...args);
        return cache[key];
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $1ee798bac53aa7db$var$memoizeOneWithArgsHash(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    return (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
}
/**
 * Caches a function's results based on a comparison of the arguments.
 * Only caches the last return of the function.
 * Defaults to reference equality
 */ function $1ee798bac53aa7db$var$memoizeOneWithArgsHashAndInvalidation(fn, hashFunction) {
    let lastKey;
    let lastResult; // breaking cache when arguments change
    const memoizedFn = (...args)=>{
        const key = hashFunction(...args);
        if (lastKey === key) return lastResult;
        lastKey = key;
        lastResult = fn(...args);
        return lastResult;
    };
    const invalidate = ()=>{
        lastKey = null;
    };
    return [
        memoizedFn,
        invalidate
    ];
}
var $1ee798bac53aa7db$var$Recoil_Memoize = {
    memoizeWithArgsHash: $1ee798bac53aa7db$var$memoizeWithArgsHash,
    memoizeOneWithArgsHash: $1ee798bac53aa7db$var$memoizeOneWithArgsHash,
    memoizeOneWithArgsHashAndInvalidation: $1ee798bac53aa7db$var$memoizeOneWithArgsHashAndInvalidation
};
const { batchUpdates: $1ee798bac53aa7db$var$batchUpdates$1 } = $1ee798bac53aa7db$var$Recoil_Batching;
const { initializeNode: $1ee798bac53aa7db$var$initializeNode$1, peekNodeInfo: $1ee798bac53aa7db$var$peekNodeInfo$1 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { graph: $1ee798bac53aa7db$var$graph$1 } = $1ee798bac53aa7db$var$Recoil_Graph;
const { getNextStoreID: $1ee798bac53aa7db$var$getNextStoreID$1 } = $1ee798bac53aa7db$var$Recoil_Keys;
const { DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE$1, recoilValues: $1ee798bac53aa7db$var$recoilValues$1, recoilValuesForKeys: $1ee798bac53aa7db$var$recoilValuesForKeys$2 } = $1ee798bac53aa7db$var$Recoil_Node;
const { AbstractRecoilValue: $1ee798bac53aa7db$var$AbstractRecoilValue$2, getRecoilValueAsLoadable: $1ee798bac53aa7db$var$getRecoilValueAsLoadable$1, setRecoilValue: $1ee798bac53aa7db$var$setRecoilValue$1, setUnvalidatedRecoilValue: $1ee798bac53aa7db$var$setUnvalidatedRecoilValue$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { updateRetainCount: $1ee798bac53aa7db$var$updateRetainCount$1 } = $1ee798bac53aa7db$var$Recoil_Retention;
const { setInvalidateMemoizedSnapshot: $1ee798bac53aa7db$var$setInvalidateMemoizedSnapshot$1 } = $1ee798bac53aa7db$var$Recoil_SnapshotCache;
const { getNextTreeStateVersion: $1ee798bac53aa7db$var$getNextTreeStateVersion$2, makeEmptyStoreState: $1ee798bac53aa7db$var$makeEmptyStoreState$1 } = $1ee798bac53aa7db$var$Recoil_State;
const { isSSR: $1ee798bac53aa7db$var$isSSR$1 } = $1ee798bac53aa7db$var$Recoil_Environment;
const { memoizeOneWithArgsHashAndInvalidation: $1ee798bac53aa7db$var$memoizeOneWithArgsHashAndInvalidation$1 } = $1ee798bac53aa7db$var$Recoil_Memoize;
// Opaque at this surface because it's part of the public API from here.
const $1ee798bac53aa7db$var$retainWarning = `
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`; // A "Snapshot" is "read-only" and captures a specific set of values of atoms.
// However, the data-flow-graph and selector values may evolve as selector
// evaluation functions are executed and async selectors resolve.
class $1ee798bac53aa7db$var$Snapshot {
    // eslint-disable-next-line fb-www/no-uninitialized-properties
    constructor(storeState, parentStoreID){
        $1ee798bac53aa7db$var$_defineProperty(this, "_store", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_refCount", 1);
        $1ee798bac53aa7db$var$_defineProperty(this, "getLoadable", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return $1ee798bac53aa7db$var$getRecoilValueAsLoadable$1(this._store, recoilValue);
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "getPromise", (recoilValue)=>{
            this.checkRefCount_INTERNAL();
            return this.getLoadable(recoilValue).toPromise();
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "getNodes_UNSTABLE", (opt)=>{
            this.checkRefCount_INTERNAL(); // TODO Deal with modified selectors
            if ((opt === null || opt === void 0 ? void 0 : opt.isModified) === true) {
                if ((opt === null || opt === void 0 ? void 0 : opt.isInitialized) === false) return [];
                const state = this._store.getState().currentTree;
                return $1ee798bac53aa7db$var$recoilValuesForKeys$2(state.dirtyAtoms);
            }
            const knownAtoms = this._store.getState().knownAtoms;
            const knownSelectors = this._store.getState().knownSelectors;
            return (opt === null || opt === void 0 ? void 0 : opt.isInitialized) == null ? $1ee798bac53aa7db$var$recoilValues$1.values() : opt.isInitialized === true ? $1ee798bac53aa7db$var$recoilValuesForKeys$2($1ee798bac53aa7db$var$Recoil_concatIterables([
                knownAtoms,
                knownSelectors
            ])) : $1ee798bac53aa7db$var$Recoil_filterIterable($1ee798bac53aa7db$var$recoilValues$1.values(), ({ key: key })=>!knownAtoms.has(key) && !knownSelectors.has(key));
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "getInfo_UNSTABLE", ({ key: key })=>{
            this.checkRefCount_INTERNAL();
            return $1ee798bac53aa7db$var$peekNodeInfo$1(this._store, this._store.getState().currentTree, key);
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "map", (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new $1ee798bac53aa7db$var$MutableSnapshot(this, $1ee798bac53aa7db$var$batchUpdates$1);
            mapper(mutableSnapshot); // if removing batchUpdates from `set` add it here
            return mutableSnapshot;
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "asyncMap", async (mapper)=>{
            this.checkRefCount_INTERNAL();
            const mutableSnapshot = new $1ee798bac53aa7db$var$MutableSnapshot(this, $1ee798bac53aa7db$var$batchUpdates$1);
            mutableSnapshot.retain(); // Retain new snapshot during async mapper
            await mapper(mutableSnapshot); // Continue to retain the new snapshot for the user, but auto-release it
            // after the next tick, the same as a new synchronous snapshot.
            mutableSnapshot.autoRelease_INTERNAL();
            return mutableSnapshot;
        });
        this._store = {
            storeID: $1ee798bac53aa7db$var$getNextStoreID$1(),
            parentStoreID: parentStoreID,
            getState: ()=>storeState,
            replaceState: (replacer)=>{
                // no batching, so nextTree is never active
                storeState.currentTree = replacer(storeState.currentTree);
            },
            getGraph: (version)=>{
                const graphs = storeState.graphsByVersion;
                if (graphs.has(version)) return $1ee798bac53aa7db$var$Recoil_nullthrows(graphs.get(version));
                const newGraph = $1ee798bac53aa7db$var$graph$1();
                graphs.set(version, newGraph);
                return newGraph;
            },
            subscribeToTransactions: ()=>({
                    release: ()=>{}
                }),
            addTransactionMetadata: ()=>{
                throw $1ee798bac53aa7db$var$Recoil_err("Cannot subscribe to Snapshots");
            }
        }; // Initialize any nodes that are live in the parent store (primarily so that
        // this snapshot gets counted towards the node's live stores count).
        // TODO Optimize this when cloning snapshots for callbacks
        for (const nodeKey of this._store.getState().knownAtoms){
            $1ee798bac53aa7db$var$initializeNode$1(this._store, nodeKey, "get");
            $1ee798bac53aa7db$var$updateRetainCount$1(this._store, nodeKey, 1);
        }
        this.autoRelease_INTERNAL();
    }
    retain() {
        if (this._refCount <= 0) $1ee798bac53aa7db$var$Recoil_recoverableViolation("Attempt to retain() Snapshot that was already released.");
        this._refCount++;
        let released = false;
        return ()=>{
            if (!released) {
                released = true;
                this._release();
            }
        };
    }
    /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */ autoRelease_INTERNAL() {
        if (!$1ee798bac53aa7db$var$isSSR$1) // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
        window.setTimeout(()=>this._release(), 10);
    }
    _release() {
        this._refCount--;
        if (this._refCount === 0) {
            this._store.getState().nodeCleanupFunctions.forEach((cleanup)=>cleanup());
            this._store.getState().nodeCleanupFunctions.clear();
            if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
             // Temporarily nerfing this to allow us to find broken call sites without
        // actually breaking anybody yet.
        // for (const k of this._store.getState().knownAtoms) {
        //   updateRetainCountToZero(this._store, k);
        // }
        } else this._refCount;
    }
    isRetained() {
        return this._refCount > 0;
    }
    checkRefCount_INTERNAL() {
        $1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020") && this._refCount;
    }
    getStore_INTERNAL() {
        this.checkRefCount_INTERNAL();
        return this._store;
    }
    getID() {
        this.checkRefCount_INTERNAL();
        return this._store.getState().currentTree.stateID;
    }
    getStoreID() {
        this.checkRefCount_INTERNAL();
        return this._store.storeID;
    }
}
function $1ee798bac53aa7db$var$cloneStoreState(store, treeState, bumpVersion = false) {
    const storeState = store.getState();
    const version = bumpVersion ? $1ee798bac53aa7db$var$getNextTreeStateVersion$2() : treeState.version;
    return {
        // Always clone the TreeState to isolate stores from accidental mutations.
        // For example, reading a selector from a cloned snapshot shouldn't cache
        // in the original treestate which may cause the original to skip
        // initialization of upstream atoms.
        currentTree: {
            // TODO snapshots shouldn't really have versions because a new version number
            // is always assigned when the snapshot is gone to.
            version: bumpVersion ? version : treeState.version,
            stateID: bumpVersion ? version : treeState.stateID,
            transactionMetadata: {
                ...treeState.transactionMetadata
            },
            dirtyAtoms: new Set(treeState.dirtyAtoms),
            atomValues: treeState.atomValues.clone(),
            nonvalidatedAtoms: treeState.nonvalidatedAtoms.clone()
        },
        commitDepth: 0,
        nextTree: null,
        previousTree: null,
        knownAtoms: new Set(storeState.knownAtoms),
        // FIXME here's a copy
        knownSelectors: new Set(storeState.knownSelectors),
        // FIXME here's a copy
        transactionSubscriptions: new Map(),
        nodeTransactionSubscriptions: new Map(),
        nodeToComponentSubscriptions: new Map(),
        queuedComponentCallbacks_DEPRECATED: [],
        suspendedComponentResolvers: new Set(),
        graphsByVersion: new Map().set(version, store.getGraph(treeState.version)),
        retention: {
            referenceCounts: new Map(),
            nodesRetainedByZone: new Map(),
            retainablesToCheckForRelease: new Set()
        },
        // FIXME here's a copy
        // Create blank cleanup handlers for atoms so snapshots don't re-run
        // atom effects.
        nodeCleanupFunctions: new Map($1ee798bac53aa7db$var$Recoil_mapIterable(storeState.nodeCleanupFunctions.entries(), ([key])=>[
                key,
                ()=>{}
            ]))
    };
} // Factory to build a fresh snapshot
function $1ee798bac53aa7db$var$freshSnapshot(initializeState) {
    const snapshot = new $1ee798bac53aa7db$var$Snapshot($1ee798bac53aa7db$var$makeEmptyStoreState$1());
    return initializeState != null ? snapshot.map(initializeState) : snapshot;
} // Factory to clone a snapshot state
const [$1ee798bac53aa7db$var$memoizedCloneSnapshot, $1ee798bac53aa7db$var$invalidateMemoizedSnapshot$2] = $1ee798bac53aa7db$var$memoizeOneWithArgsHashAndInvalidation$1((store, version)=>{
    var _storeState$nextTree;
    const storeState = store.getState();
    const treeState = version === "latest" ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : $1ee798bac53aa7db$var$Recoil_nullthrows(storeState.previousTree);
    return new $1ee798bac53aa7db$var$Snapshot($1ee798bac53aa7db$var$cloneStoreState(store, treeState), store.storeID);
}, (store, version)=>{
    var _store$getState$nextT, _store$getState$previ;
    return String(version) + String(store.storeID) + String((_store$getState$nextT = store.getState().nextTree) === null || _store$getState$nextT === void 0 ? void 0 : _store$getState$nextT.version) + String(store.getState().currentTree.version) + String((_store$getState$previ = store.getState().previousTree) === null || _store$getState$previ === void 0 ? void 0 : _store$getState$previ.version);
}); // Avoid circular dependencies
$1ee798bac53aa7db$var$setInvalidateMemoizedSnapshot$1($1ee798bac53aa7db$var$invalidateMemoizedSnapshot$2);
function $1ee798bac53aa7db$var$cloneSnapshot(store, version = "latest") {
    const snapshot = $1ee798bac53aa7db$var$memoizedCloneSnapshot(store, version);
    if (!snapshot.isRetained()) {
        $1ee798bac53aa7db$var$invalidateMemoizedSnapshot$2();
        return $1ee798bac53aa7db$var$memoizedCloneSnapshot(store, version);
    }
    return snapshot;
}
class $1ee798bac53aa7db$var$MutableSnapshot extends $1ee798bac53aa7db$var$Snapshot {
    constructor(snapshot, batch){
        super($1ee798bac53aa7db$var$cloneStoreState(snapshot.getStore_INTERNAL(), snapshot.getStore_INTERNAL().getState().currentTree, true), snapshot.getStoreID());
        $1ee798bac53aa7db$var$_defineProperty(this, "_batch", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "set", (recoilState, newValueOrUpdater)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // This batchUpdates ensures this `set` is applied immediately and you can
            // read the written value after calling `set`. I would like to remove this
            // behavior and only batch in `Snapshot.map`, but this would be a breaking
            // change potentially.
            this._batch(()=>{
                $1ee798bac53aa7db$var$updateRetainCount$1(store, recoilState.key, 1);
                $1ee798bac53aa7db$var$setRecoilValue$1(this.getStore_INTERNAL(), recoilState, newValueOrUpdater);
            });
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "reset", (recoilState)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            this._batch(()=>{
                $1ee798bac53aa7db$var$updateRetainCount$1(store, recoilState.key, 1);
                $1ee798bac53aa7db$var$setRecoilValue$1(this.getStore_INTERNAL(), recoilState, $1ee798bac53aa7db$var$DEFAULT_VALUE$1);
            });
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "setUnvalidatedAtomValues_DEPRECATED", (values)=>{
            this.checkRefCount_INTERNAL();
            const store = this.getStore_INTERNAL(); // See note at `set` about batched updates.
            $1ee798bac53aa7db$var$batchUpdates$1(()=>{
                for (const [k, v] of values.entries()){
                    $1ee798bac53aa7db$var$updateRetainCount$1(store, k, 1);
                    $1ee798bac53aa7db$var$setUnvalidatedRecoilValue$1(store, new $1ee798bac53aa7db$var$AbstractRecoilValue$2(k), v);
                }
            });
        });
        this._batch = batch;
    }
}
var $1ee798bac53aa7db$var$Recoil_Snapshot = {
    Snapshot: $1ee798bac53aa7db$var$Snapshot,
    MutableSnapshot: $1ee798bac53aa7db$var$MutableSnapshot,
    freshSnapshot: $1ee798bac53aa7db$var$freshSnapshot,
    cloneSnapshot: $1ee798bac53aa7db$var$cloneSnapshot
};
var $1ee798bac53aa7db$var$Recoil_Snapshot_1 = $1ee798bac53aa7db$var$Recoil_Snapshot.Snapshot;
var $1ee798bac53aa7db$var$Recoil_Snapshot_2 = $1ee798bac53aa7db$var$Recoil_Snapshot.MutableSnapshot;
var $1ee798bac53aa7db$var$Recoil_Snapshot_3 = $1ee798bac53aa7db$var$Recoil_Snapshot.freshSnapshot;
var $1ee798bac53aa7db$var$Recoil_Snapshot_4 = $1ee798bac53aa7db$var$Recoil_Snapshot.cloneSnapshot;
var $1ee798bac53aa7db$var$Recoil_Snapshot$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Snapshot: $1ee798bac53aa7db$var$Recoil_Snapshot_1,
    MutableSnapshot: $1ee798bac53aa7db$var$Recoil_Snapshot_2,
    freshSnapshot: $1ee798bac53aa7db$var$Recoil_Snapshot_3,
    cloneSnapshot: $1ee798bac53aa7db$var$Recoil_Snapshot_4
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$unionSets(...sets) {
    const result = new Set();
    for (const set of sets)for (const value of set)result.add(value);
    return result;
}
var $1ee798bac53aa7db$var$Recoil_unionSets = $1ee798bac53aa7db$var$unionSets;
const { useRef: $1ee798bac53aa7db$var$useRef } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
/**
 * The same as `useRef()` except that if a function is specified then it will
 * call that function to get the value to initialize the reference with.
 * This is similar to how `useState()` behaves when given a function.  It allows
 * the user to avoid generating the initial value for subsequent renders.
 * The tradeoff is that to set the reference to a function itself you need to
 * nest it: useRefInitOnce(() => () => {...});
 */ function $1ee798bac53aa7db$var$useRefInitOnce(initialValue) {
    // $FlowExpectedError[incompatible-call]
    const ref = $1ee798bac53aa7db$var$useRef(initialValue);
    if (ref.current === initialValue && typeof initialValue === "function") // $FlowExpectedError[incompatible-use]
    ref.current = initialValue();
    return ref;
}
var $1ee798bac53aa7db$var$Recoil_useRefInitOnce = $1ee798bac53aa7db$var$useRefInitOnce;
// @fb-only: const RecoilusagelogEvent = require('RecoilusagelogEvent');
// @fb-only: const RecoilUsageLogFalcoEvent = require('RecoilUsageLogFalcoEvent');
// @fb-only: const URI = require('URI');
const { getNextTreeStateVersion: $1ee798bac53aa7db$var$getNextTreeStateVersion$3, makeEmptyStoreState: $1ee798bac53aa7db$var$makeEmptyStoreState$2 } = $1ee798bac53aa7db$var$Recoil_State;
const { cleanUpNode: $1ee798bac53aa7db$var$cleanUpNode$2, getDownstreamNodes: $1ee798bac53aa7db$var$getDownstreamNodes$2, initializeNode: $1ee798bac53aa7db$var$initializeNode$2, setNodeValue: $1ee798bac53aa7db$var$setNodeValue$2, setUnvalidatedAtomValue_DEPRECATED: $1ee798bac53aa7db$var$setUnvalidatedAtomValue_DEPRECATED$1 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { graph: $1ee798bac53aa7db$var$graph$2 } = $1ee798bac53aa7db$var$Recoil_Graph;
const { cloneGraph: $1ee798bac53aa7db$var$cloneGraph$1 } = $1ee798bac53aa7db$var$Recoil_Graph;
const { getNextStoreID: $1ee798bac53aa7db$var$getNextStoreID$2 } = $1ee798bac53aa7db$var$Recoil_Keys;
const { createMutableSource: $1ee798bac53aa7db$var$createMutableSource$1, reactMode: $1ee798bac53aa7db$var$reactMode$2 } = $1ee798bac53aa7db$var$Recoil_ReactMode;
const { applyAtomValueWrites: $1ee798bac53aa7db$var$applyAtomValueWrites$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { releaseScheduledRetainablesNow: $1ee798bac53aa7db$var$releaseScheduledRetainablesNow$1 } = $1ee798bac53aa7db$var$Recoil_Retention;
const { freshSnapshot: $1ee798bac53aa7db$var$freshSnapshot$1 } = $1ee798bac53aa7db$var$Recoil_Snapshot$1;
const { useCallback: $1ee798bac53aa7db$var$useCallback, useContext: $1ee798bac53aa7db$var$useContext, useEffect: $1ee798bac53aa7db$var$useEffect, useMemo: $1ee798bac53aa7db$var$useMemo, useRef: $1ee798bac53aa7db$var$useRef$1, useState: $1ee798bac53aa7db$var$useState } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
function $1ee798bac53aa7db$var$notInAContext() {
    throw $1ee798bac53aa7db$var$Recoil_err("This component must be used inside a <RecoilRoot> component.");
}
const $1ee798bac53aa7db$var$defaultStore = Object.freeze({
    storeID: $1ee798bac53aa7db$var$getNextStoreID$2(),
    getState: $1ee798bac53aa7db$var$notInAContext,
    replaceState: $1ee798bac53aa7db$var$notInAContext,
    getGraph: $1ee798bac53aa7db$var$notInAContext,
    subscribeToTransactions: $1ee798bac53aa7db$var$notInAContext,
    addTransactionMetadata: $1ee798bac53aa7db$var$notInAContext
});
let $1ee798bac53aa7db$var$stateReplacerIsBeingExecuted = false;
function $1ee798bac53aa7db$var$startNextTreeIfNeeded(store) {
    if ($1ee798bac53aa7db$var$stateReplacerIsBeingExecuted) throw $1ee798bac53aa7db$var$Recoil_err("An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.");
    const storeState = store.getState();
    if (storeState.nextTree === null) {
        if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020") && $1ee798bac53aa7db$var$Recoil_gkx("recoil_release_on_cascading_update_killswitch_2021")) // If this is a cascading update (that is, rendering due to one state change
        // invokes a second state change), we won't have cleaned up retainables yet
        // because this normally happens after notifying components. Do it before
        // proceeding with the cascading update so that it remains predictable:
        {
            if (storeState.commitDepth > 0) $1ee798bac53aa7db$var$releaseScheduledRetainablesNow$1(store);
        }
        const version = storeState.currentTree.version;
        const nextVersion = $1ee798bac53aa7db$var$getNextTreeStateVersion$3();
        storeState.nextTree = {
            ...storeState.currentTree,
            version: nextVersion,
            stateID: nextVersion,
            dirtyAtoms: new Set(),
            transactionMetadata: {}
        };
        storeState.graphsByVersion.set(nextVersion, $1ee798bac53aa7db$var$cloneGraph$1($1ee798bac53aa7db$var$Recoil_nullthrows(storeState.graphsByVersion.get(version))));
    }
}
const $1ee798bac53aa7db$var$AppContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext({
    current: $1ee798bac53aa7db$var$defaultStore
});
const $1ee798bac53aa7db$var$useStoreRef = ()=>$1ee798bac53aa7db$var$useContext($1ee798bac53aa7db$var$AppContext); // $FlowExpectedError[incompatible-call]
const $1ee798bac53aa7db$var$MutableSourceContext = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createContext(null);
function $1ee798bac53aa7db$var$useRecoilMutableSource() {
    const mutableSource = $1ee798bac53aa7db$var$useContext($1ee798bac53aa7db$var$MutableSourceContext);
    if (mutableSource == null) $1ee798bac53aa7db$var$Recoil_expectationViolation("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks.");
    return mutableSource;
}
function $1ee798bac53aa7db$var$notifyComponents(store, storeState, treeState) {
    const dependentNodes = $1ee798bac53aa7db$var$getDownstreamNodes$2(store, treeState, treeState.dirtyAtoms);
    for (const key of dependentNodes){
        const comps = storeState.nodeToComponentSubscriptions.get(key);
        if (comps) for (const [_subID, [_debugName, callback]] of comps)callback(treeState);
    }
}
function $1ee798bac53aa7db$var$sendEndOfBatchNotifications(store) {
    const storeState = store.getState();
    const treeState = storeState.currentTree; // Inform transaction subscribers of the transaction:
    const dirtyAtoms = treeState.dirtyAtoms;
    if (dirtyAtoms.size) {
        // Execute Node-specific subscribers before global subscribers
        for (const [key, subscriptions] of storeState.nodeTransactionSubscriptions){
            if (dirtyAtoms.has(key)) for (const [_, subscription] of subscriptions)subscription(store);
        }
        for (const [_, subscription] of storeState.transactionSubscriptions)subscription(store);
        if (!$1ee798bac53aa7db$var$reactMode$2().early || storeState.suspendedComponentResolvers.size > 0) {
            // Notifying components is needed to wake from suspense, even when using
            // early rendering.
            $1ee798bac53aa7db$var$notifyComponents(store, storeState, treeState); // Wake all suspended components so the right one(s) can try to re-render.
            // We need to wake up components not just when some asynchronous selector
            // resolved, but also when changing synchronous values because this may cause
            // a selector to change from asynchronous to synchronous, in which case there
            // would be no follow-up asynchronous resolution to wake us up.
            // TODO OPTIMIZATION Only wake up related downstream components
            storeState.suspendedComponentResolvers.forEach((cb)=>cb());
            storeState.suspendedComponentResolvers.clear();
        }
    } // Special behavior ONLY invoked by useInterface.
    // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
    storeState.queuedComponentCallbacks_DEPRECATED.forEach((cb)=>cb(treeState));
    storeState.queuedComponentCallbacks_DEPRECATED.splice(0, storeState.queuedComponentCallbacks_DEPRECATED.length);
}
function $1ee798bac53aa7db$var$endBatch(store) {
    const storeState = store.getState();
    storeState.commitDepth++;
    try {
        const { nextTree: nextTree } = storeState; // Ignore commits that are not because of Recoil transactions -- namely,
        // because something above RecoilRoot re-rendered:
        if (nextTree == null) return;
         // nextTree is now committed -- note that copying and reset occurs when
        // a transaction begins, in startNextTreeIfNeeded:
        storeState.previousTree = storeState.currentTree;
        storeState.currentTree = nextTree;
        storeState.nextTree = null;
        $1ee798bac53aa7db$var$sendEndOfBatchNotifications(store);
        if (storeState.previousTree != null) storeState.graphsByVersion.delete(storeState.previousTree.version);
        else $1ee798bac53aa7db$var$Recoil_recoverableViolation("Ended batch with no previous state, which is unexpected", "recoil");
        storeState.previousTree = null;
        if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) // Only release retainables if there were no writes during the end of the
        // batch.  This avoids releasing something we might be about to use.
        {
            if (nextTree == null) $1ee798bac53aa7db$var$releaseScheduledRetainablesNow$1(store);
        }
    } finally{
        storeState.commitDepth--;
    }
}
/*
 * The purpose of the Batcher is to observe when React batches end so that
 * Recoil state changes can be batched. Whenever Recoil state changes, we call
 * setState on the batcher. Then we wait for that change to be committed, which
 * signifies the end of the batch. That's when we respond to the Recoil change.
 */ function $1ee798bac53aa7db$var$Batcher({ setNotifyBatcherOfChange: setNotifyBatcherOfChange }) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef();
    const [, setState] = $1ee798bac53aa7db$var$useState([]); // $FlowFixMe[incompatible-call]
    setNotifyBatcherOfChange(()=>setState({}));
    $1ee798bac53aa7db$var$useEffect(()=>{
        // $FlowFixMe[incompatible-call]
        setNotifyBatcherOfChange(()=>setState({})); // If an asynchronous selector resolves after the Batcher is unmounted,
        // notifyBatcherOfChange will still be called. An error gets thrown whenever
        // setState is called after a component is already unmounted, so this sets
        // notifyBatcherOfChange to be a no-op.
        return ()=>{
            setNotifyBatcherOfChange(()=>{});
        };
    }, [
        setNotifyBatcherOfChange
    ]);
    $1ee798bac53aa7db$var$useEffect(()=>{
        // enqueueExecution runs this function immediately; it is only used to
        // manipulate the order of useEffects during tests, since React seems to
        // call useEffect in an unpredictable order sometimes.
        $1ee798bac53aa7db$var$Recoil_Queue.enqueueExecution("Batcher", ()=>{
            $1ee798bac53aa7db$var$endBatch(storeRef.current);
        });
    });
    return null;
}
// which will no longer be needed.
function $1ee798bac53aa7db$var$initialStoreState_DEPRECATED(store, initializeState) {
    const initial = $1ee798bac53aa7db$var$makeEmptyStoreState$2();
    initializeState({
        set: (atom, value)=>{
            const state = initial.currentTree;
            const writes = $1ee798bac53aa7db$var$setNodeValue$2(store, state, atom.key, value);
            const writtenNodes = new Set(writes.keys());
            const nonvalidatedAtoms = state.nonvalidatedAtoms.clone();
            for (const n of writtenNodes)nonvalidatedAtoms.delete(n);
            initial.currentTree = {
                ...state,
                dirtyAtoms: $1ee798bac53aa7db$var$Recoil_unionSets(state.dirtyAtoms, writtenNodes),
                atomValues: $1ee798bac53aa7db$var$applyAtomValueWrites$1(state.atomValues, writes),
                nonvalidatedAtoms: // NB: PLEASE un-export applyAtomValueWrites when deleting this code
                nonvalidatedAtoms
            };
        },
        setUnvalidatedAtomValues: (atomValues)=>{
            // FIXME replace this with a mutative loop
            atomValues.forEach((v, k)=>{
                initial.currentTree = $1ee798bac53aa7db$var$setUnvalidatedAtomValue_DEPRECATED$1(initial.currentTree, k, v);
            });
        }
    });
    return initial;
} // Initialize state snapshot for <RecoilRoot> for the initializeState prop.
// Atom effect initialization takes precedence over this prop.
// Any atom effects will be run before initialization, but then cleaned up,
// they are then re-run when used as part of rendering.  These semantics are
// compatible with React StrictMode where effects may be re-run multiple times
// but state initialization only happens once the first time.
function $1ee798bac53aa7db$var$initialStoreState(initializeState) {
    // Initialize a snapshot and get its store
    const snapshot = $1ee798bac53aa7db$var$freshSnapshot$1(initializeState);
    const storeState = snapshot.getStore_INTERNAL().getState(); // Counteract the snapshot auto-release
    snapshot.retain(); // Cleanup any effects run during initialization and clear the handlers so
    // they will re-initialize if used during rendering.  This allows atom effect
    // initialization to take precedence over initializeState and be compatible
    // with StrictMode semantics.
    storeState.nodeCleanupFunctions.forEach((cleanup)=>cleanup());
    storeState.nodeCleanupFunctions.clear();
    return storeState;
}
let $1ee798bac53aa7db$var$nextID = 0;
function $1ee798bac53aa7db$var$RecoilRoot_INTERNAL({ initializeState_DEPRECATED: initializeState_DEPRECATED, initializeState: initializeState, store_INTERNAL: storeProp, children: // For use with React "context bridging"
children }) {
    // prettier-ignore
    // @fb-only: useEffect(() => {
    // @fb-only: if (gkx('recoil_usage_logging')) {
    // @fb-only: try {
    // @fb-only: RecoilUsageLogFalcoEvent.log(() => ({
    // @fb-only: type: RecoilusagelogEvent.RECOIL_ROOT_MOUNTED,
    // @fb-only: path: URI.getRequestURI().getPath(),
    // @fb-only: }));
    // @fb-only: } catch {
    // @fb-only: recoverableViolation(
    // @fb-only: 'Error when logging Recoil Usage event',
    // @fb-only: 'recoil',
    // @fb-only: );
    // @fb-only: }
    // @fb-only: }
    // @fb-only: }, []);
    let storeStateRef; // eslint-disable-line prefer-const
    const getGraph = (version)=>{
        const graphs = storeStateRef.current.graphsByVersion;
        if (graphs.has(version)) return $1ee798bac53aa7db$var$Recoil_nullthrows(graphs.get(version));
        const newGraph = $1ee798bac53aa7db$var$graph$2();
        graphs.set(version, newGraph);
        return newGraph;
    };
    const subscribeToTransactions = (callback, key)=>{
        if (key == null) {
            // Global transaction subscriptions
            const { transactionSubscriptions: transactionSubscriptions } = storeRef.current.getState();
            const id = $1ee798bac53aa7db$var$nextID++;
            transactionSubscriptions.set(id, callback);
            return {
                release: ()=>{
                    transactionSubscriptions.delete(id);
                }
            };
        } else {
            // Node-specific transaction subscriptions:
            const { nodeTransactionSubscriptions: nodeTransactionSubscriptions } = storeRef.current.getState();
            if (!nodeTransactionSubscriptions.has(key)) nodeTransactionSubscriptions.set(key, new Map());
            const id = $1ee798bac53aa7db$var$nextID++;
            $1ee798bac53aa7db$var$Recoil_nullthrows(nodeTransactionSubscriptions.get(key)).set(id, callback);
            return {
                release: ()=>{
                    const subs = nodeTransactionSubscriptions.get(key);
                    if (subs) {
                        subs.delete(id);
                        if (subs.size === 0) nodeTransactionSubscriptions.delete(key);
                    }
                }
            };
        }
    };
    const addTransactionMetadata = (metadata)=>{
        $1ee798bac53aa7db$var$startNextTreeIfNeeded(storeRef.current);
        for (const k of Object.keys(metadata))$1ee798bac53aa7db$var$Recoil_nullthrows(storeRef.current.getState().nextTree).transactionMetadata[k] = metadata[k];
    };
    const replaceState = (replacer)=>{
        $1ee798bac53aa7db$var$startNextTreeIfNeeded(storeRef.current); // Use replacer to get the next state:
        const nextTree = $1ee798bac53aa7db$var$Recoil_nullthrows(storeStateRef.current.nextTree);
        let replaced;
        try {
            $1ee798bac53aa7db$var$stateReplacerIsBeingExecuted = true;
            replaced = replacer(nextTree);
        } finally{
            $1ee798bac53aa7db$var$stateReplacerIsBeingExecuted = false;
        }
        if (replaced === nextTree) return;
        storeStateRef.current.nextTree = replaced;
        if ($1ee798bac53aa7db$var$reactMode$2().early) $1ee798bac53aa7db$var$notifyComponents(storeRef.current, storeStateRef.current, replaced);
        $1ee798bac53aa7db$var$Recoil_nullthrows(notifyBatcherOfChange.current)();
    };
    const notifyBatcherOfChange = $1ee798bac53aa7db$var$useRef$1(null);
    const setNotifyBatcherOfChange = $1ee798bac53aa7db$var$useCallback((x)=>{
        notifyBatcherOfChange.current = x;
    }, [
        notifyBatcherOfChange
    ]);
    const storeRef = $1ee798bac53aa7db$var$Recoil_useRefInitOnce(()=>storeProp !== null && storeProp !== void 0 ? storeProp : {
            storeID: $1ee798bac53aa7db$var$getNextStoreID$2(),
            getState: ()=>storeStateRef.current,
            replaceState: replaceState,
            getGraph: getGraph,
            subscribeToTransactions: subscribeToTransactions,
            addTransactionMetadata: addTransactionMetadata
        });
    if (storeProp != null) storeRef.current = storeProp;
    storeStateRef = $1ee798bac53aa7db$var$Recoil_useRefInitOnce(()=>initializeState_DEPRECATED != null ? $1ee798bac53aa7db$var$initialStoreState_DEPRECATED(storeRef.current, initializeState_DEPRECATED) : initializeState != null ? $1ee798bac53aa7db$var$initialStoreState(initializeState) : $1ee798bac53aa7db$var$makeEmptyStoreState$2());
    const mutableSource = $1ee798bac53aa7db$var$useMemo(()=>$1ee798bac53aa7db$var$createMutableSource$1 === null || $1ee798bac53aa7db$var$createMutableSource$1 === void 0 ? void 0 : $1ee798bac53aa7db$var$createMutableSource$1(storeStateRef, ()=>storeStateRef.current.currentTree.version), [
        storeStateRef
    ]); // Cleanup when the <RecoilRoot> is unmounted
    $1ee798bac53aa7db$var$useEffect(()=>{
        // React is free to call effect cleanup handlers and effects at will, the
        // deps array is only an optimization.  For example, React strict mode
        // will execute each effect twice for testing.  Therefore, we need symmetry
        // to re-initialize all known atoms after they were cleaned up.
        const store = storeRef.current;
        for (const atomKey of new Set(store.getState().knownAtoms))$1ee798bac53aa7db$var$initializeNode$2(store, atomKey, "get");
        return ()=>{
            for (const atomKey of store.getState().knownAtoms)$1ee798bac53aa7db$var$cleanUpNode$2(store, atomKey);
        };
    }, [
        storeRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1ee798bac53aa7db$var$AppContext.Provider, {
        value: storeRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1ee798bac53aa7db$var$MutableSourceContext.Provider, {
        value: mutableSource
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1ee798bac53aa7db$var$Batcher, {
        setNotifyBatcherOfChange: setNotifyBatcherOfChange
    }), children));
}
function $1ee798bac53aa7db$var$RecoilRoot(props) {
    const { override: override, ...propsExceptOverride } = props;
    const ancestorStoreRef = $1ee798bac53aa7db$var$useStoreRef();
    if (override === false && ancestorStoreRef.current !== $1ee798bac53aa7db$var$defaultStore) // If ancestorStoreRef.current !== defaultStore, it means that this
    // RecoilRoot is not nested within another.
    return props.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1ee798bac53aa7db$var$RecoilRoot_INTERNAL, propsExceptOverride);
}
function $1ee798bac53aa7db$var$useRecoilStoreID() {
    return $1ee798bac53aa7db$var$useStoreRef().current.storeID;
}
var $1ee798bac53aa7db$var$Recoil_RecoilRoot = {
    RecoilRoot: $1ee798bac53aa7db$var$RecoilRoot,
    useStoreRef: $1ee798bac53aa7db$var$useStoreRef,
    useRecoilMutableSource: $1ee798bac53aa7db$var$useRecoilMutableSource,
    useRecoilStoreID: $1ee798bac53aa7db$var$useRecoilStoreID,
    notifyComponents_FOR_TESTING: $1ee798bac53aa7db$var$notifyComponents,
    sendEndOfBatchNotifications_FOR_TESTING: $1ee798bac53aa7db$var$sendEndOfBatchNotifications
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$shallowArrayEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
var $1ee798bac53aa7db$var$Recoil_shallowArrayEqual = $1ee798bac53aa7db$var$shallowArrayEqual;
const { useEffect: $1ee798bac53aa7db$var$useEffect$1, useRef: $1ee798bac53aa7db$var$useRef$2 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
function $1ee798bac53aa7db$var$usePrevious(value) {
    const ref = $1ee798bac53aa7db$var$useRef$2();
    $1ee798bac53aa7db$var$useEffect$1(()=>{
        // $FlowFixMe[incompatible-type]
        ref.current = value;
    });
    return ref.current;
}
var $1ee798bac53aa7db$var$Recoil_usePrevious = $1ee798bac53aa7db$var$usePrevious;
const { useStoreRef: $1ee798bac53aa7db$var$useStoreRef$1 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { SUSPENSE_TIMEOUT_MS: $1ee798bac53aa7db$var$SUSPENSE_TIMEOUT_MS$1 } = $1ee798bac53aa7db$var$Recoil_Retention;
const { updateRetainCount: $1ee798bac53aa7db$var$updateRetainCount$2 } = $1ee798bac53aa7db$var$Recoil_Retention;
const { RetentionZone: $1ee798bac53aa7db$var$RetentionZone$3 } = $1ee798bac53aa7db$var$Recoil_RetentionZone;
const { useEffect: $1ee798bac53aa7db$var$useEffect$2, useRef: $1ee798bac53aa7db$var$useRef$3 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
const { isSSR: $1ee798bac53aa7db$var$isSSR$2 } = $1ee798bac53aa7db$var$Recoil_Environment;
// I don't see a way to avoid the any type here because we want to accept readable
// and writable values with any type parameter, but normally with writable ones
// RecoilState<SomeT> is not a subtype of RecoilState<mixed>.
// flowlint-line unclear-type:off
function $1ee798bac53aa7db$var$useRetain(toRetain) {
    if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
     // eslint-disable-next-line fb-www/react-hooks
    return $1ee798bac53aa7db$var$useRetain_ACTUAL(toRetain);
}
function $1ee798bac53aa7db$var$useRetain_ACTUAL(toRetain) {
    const array = Array.isArray(toRetain) ? toRetain : [
        toRetain
    ];
    const retainables = array.map((a)=>a instanceof $1ee798bac53aa7db$var$RetentionZone$3 ? a : a.key);
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$1();
    $1ee798bac53aa7db$var$useEffect$2(()=>{
        if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) return;
        const store = storeRef.current;
        if (timeoutID.current && !$1ee798bac53aa7db$var$isSSR$2) {
            // Already performed a temporary retain on render, simply cancel the release
            // of that temporary retain.
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
        } else for (const r of retainables)$1ee798bac53aa7db$var$updateRetainCount$2(store, r, 1);
        return ()=>{
            for (const r of retainables)$1ee798bac53aa7db$var$updateRetainCount$2(store, r, -1);
        }; // eslint-disable-next-line fb-www/react-hooks-deps
    }, [
        storeRef,
        ...retainables
    ]); // We want to retain if the component suspends. This is terrible but the Suspense
    // API affords us no better option. If we suspend and never commit after some
    // seconds, then release. The 'actual' retain/release in the effect above
    // cancels this.
    const timeoutID = $1ee798bac53aa7db$var$useRef$3();
    const previousRetainables = $1ee798bac53aa7db$var$Recoil_usePrevious(retainables);
    if (!$1ee798bac53aa7db$var$isSSR$2 && (previousRetainables === undefined || !$1ee798bac53aa7db$var$Recoil_shallowArrayEqual(previousRetainables, retainables))) {
        const store = storeRef.current;
        for (const r of retainables)$1ee798bac53aa7db$var$updateRetainCount$2(store, r, 1);
        if (previousRetainables) for (const r of previousRetainables)$1ee798bac53aa7db$var$updateRetainCount$2(store, r, -1);
        if (timeoutID.current) window.clearTimeout(timeoutID.current);
        timeoutID.current = window.setTimeout(()=>{
            timeoutID.current = null;
            for (const r of retainables)$1ee798bac53aa7db$var$updateRetainCount$2(store, r, -1);
        }, $1ee798bac53aa7db$var$SUSPENSE_TIMEOUT_MS$1);
    }
}
var $1ee798bac53aa7db$var$Recoil_useRetain = $1ee798bac53aa7db$var$useRetain;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * THIS CODE HAS BEEN COMMENTED OUT INTENTIONALLY
 *
 * This technique of getting the component name is imperfect, since it both only
 * works in a non-minified code base, and more importantly introduces performance
 * problems since it relies in throwing errors which is an expensive operation.
 *
 * At some point we may want to reevaluate this technique hence why we have commented
 * this code out, rather than delete it all together.
 */ // const {useRef} = require('react');
// const gkx = require('recoil-shared/util/Recoil_gkx');
// const stackTraceParser = require('recoil-shared/util/Recoil_stackTraceParser');
function $1ee798bac53aa7db$var$useComponentName() {
    // const nameRef = useRef();
    // if (__DEV__) {
    //   if (gkx('recoil_infer_component_names')) {
    //     if (nameRef.current === undefined) {
    //       // There is no blessed way to determine the calling React component from
    //       // within a hook. This hack uses the fact that hooks must start with 'use'
    //       // and that hooks are either called by React Components or other hooks. It
    //       // follows therefore, that to find the calling component, you simply need
    //       // to look down the stack and find the first function which doesn't start
    //       // with 'use'. We are only enabling this in dev for now, since once the
    //       // codebase is minified, the naming assumptions no longer hold true.
    //       // eslint-disable-next-line fb-www/no-new-error
    //       const frames = stackTraceParser(new Error().stack);
    //       for (const {methodName} of frames) {
    //         // I observed cases where the frame was of the form 'Object.useXXX'
    //         // hence why I'm searching for hooks following a word boundary
    //         if (!methodName.match(/\buse[^\b]+$/)) {
    //           return (nameRef.current = methodName);
    //         }
    //       }
    //       nameRef.current = null;
    //     }
    //     return nameRef.current ?? '<unable to determine component name>';
    //   }
    // }
    // @fb-only: return "<component name only available when both in dev mode and when passing GK 'recoil_infer_component_names'>";
    return "<component name not available>"; // @oss-only
}
var $1ee798bac53aa7db$var$Recoil_useComponentName = $1ee798bac53aa7db$var$useComponentName;
const { batchUpdates: $1ee798bac53aa7db$var$batchUpdates$2 } = $1ee798bac53aa7db$var$Recoil_Batching;
const { DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE$2 } = $1ee798bac53aa7db$var$Recoil_Node;
const { currentRendererSupportsUseSyncExternalStore: $1ee798bac53aa7db$var$currentRendererSupportsUseSyncExternalStore$1, reactMode: $1ee798bac53aa7db$var$reactMode$3, useMutableSource: $1ee798bac53aa7db$var$useMutableSource$1, useSyncExternalStore: $1ee798bac53aa7db$var$useSyncExternalStore$1 } = $1ee798bac53aa7db$var$Recoil_ReactMode;
const { useRecoilMutableSource: $1ee798bac53aa7db$var$useRecoilMutableSource$1, useStoreRef: $1ee798bac53aa7db$var$useStoreRef$2 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue$2 } = $1ee798bac53aa7db$var$Recoil_RecoilValue$1;
const { AbstractRecoilValue: $1ee798bac53aa7db$var$AbstractRecoilValue$3, getRecoilValueAsLoadable: $1ee798bac53aa7db$var$getRecoilValueAsLoadable$2, setRecoilValue: $1ee798bac53aa7db$var$setRecoilValue$2, setUnvalidatedRecoilValue: $1ee798bac53aa7db$var$setUnvalidatedRecoilValue$2, subscribeToRecoilValue: $1ee798bac53aa7db$var$subscribeToRecoilValue$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { useCallback: $1ee798bac53aa7db$var$useCallback$1, useEffect: $1ee798bac53aa7db$var$useEffect$3, useMemo: $1ee798bac53aa7db$var$useMemo$1, useRef: $1ee798bac53aa7db$var$useRef$4, useState: $1ee798bac53aa7db$var$useState$1 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
const { setByAddingToSet: $1ee798bac53aa7db$var$setByAddingToSet$2 } = $1ee798bac53aa7db$var$Recoil_CopyOnWrite;
const { isSSR: $1ee798bac53aa7db$var$isSSR$3 } = $1ee798bac53aa7db$var$Recoil_Environment;
function $1ee798bac53aa7db$var$handleLoadable(loadable, recoilValue, storeRef) {
    // We can't just throw the promise we are waiting on to Suspense.  If the
    // upstream dependencies change it may produce a state in which the component
    // can render, but it would still be suspended on a Promise that may never resolve.
    if (loadable.state === "hasValue") return loadable.contents;
    else if (loadable.state === "loading") {
        const promise = new Promise((resolve)=>{
            const suspendedComponentResolvers = storeRef.current.getState().suspendedComponentResolvers;
            suspendedComponentResolvers.add(resolve); // SSR should clear out the wake-up resolver if the Promise is resolved
            // to avoid infinite loops.  (See https://github.com/facebookexperimental/Recoil/pull/2073)
            if ($1ee798bac53aa7db$var$isSSR$3 && $1ee798bac53aa7db$var$Recoil_isPromise(loadable.contents)) loadable.contents.finally(()=>{
                suspendedComponentResolvers.delete(resolve);
            });
        }); // $FlowExpectedError Flow(prop-missing) for integrating with tools that inspect thrown promises @fb-only
        // @fb-only: promise.displayName = `Recoil State: ${recoilValue.key}`;
        throw promise;
    } else if (loadable.state === "hasError") throw loadable.contents;
    else throw $1ee798bac53aa7db$var$Recoil_err(`Invalid value of loadable atom "${recoilValue.key}"`);
}
function $1ee798bac53aa7db$var$validateRecoilValue(recoilValue, hookName // $FlowFixMe[missing-local-annot]
) {
    if (!$1ee798bac53aa7db$var$isRecoilValue$2(recoilValue)) throw $1ee798bac53aa7db$var$Recoil_err(`Invalid argument to ${hookName}: expected an atom or selector but got ${String(recoilValue)}`);
}
/**
 * Various things are broken with useRecoilInterface, particularly concurrent
 * mode, React strict mode, and memory management. They will not be fixed.
 * */ function $1ee798bac53aa7db$var$useRecoilInterface_DEPRECATED() {
    const componentName = $1ee798bac53aa7db$var$Recoil_useComponentName();
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = $1ee798bac53aa7db$var$useState$1([]);
    const recoilValuesUsed = $1ee798bac53aa7db$var$useRef$4(new Set());
    recoilValuesUsed.current = new Set(); // Track the RecoilValues used just during this render
    const previousSubscriptions = $1ee798bac53aa7db$var$useRef$4(new Set());
    const subscriptions = $1ee798bac53aa7db$var$useRef$4(new Map());
    const unsubscribeFrom = $1ee798bac53aa7db$var$useCallback$1((key)=>{
        const sub = subscriptions.current.get(key);
        if (sub) {
            sub.release();
            subscriptions.current.delete(key);
        }
    }, [
        subscriptions
    ]);
    const updateState = $1ee798bac53aa7db$var$useCallback$1((_state, key)=>{
        if (subscriptions.current.has(key)) forceUpdate([]);
    }, []); // Effect to add/remove subscriptions as nodes are used
    $1ee798bac53aa7db$var$useEffect$3(()=>{
        const store = storeRef.current;
        $1ee798bac53aa7db$var$Recoil_differenceSets(recoilValuesUsed.current, previousSubscriptions.current).forEach((key)=>{
            if (subscriptions.current.has(key)) {
                $1ee798bac53aa7db$var$Recoil_expectationViolation(`Double subscription to RecoilValue "${key}"`);
                return;
            }
            const sub = $1ee798bac53aa7db$var$subscribeToRecoilValue$1(store, new $1ee798bac53aa7db$var$AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            subscriptions.current.set(key, sub);
            /**
       * Since we're subscribing in an effect we need to update to the latest
       * value of the atom since it may have changed since we rendered. We can
       * go ahead and do that now, unless we're in the middle of a batch --
       * in which case we should do it at the end of the batch, due to the
       * following edge case: Suppose an atom is updated in another useEffect
       * of this same component. Then the following sequence of events occur:
       * 1. Atom is updated and subs fired (but we may not be subscribed
       *    yet depending on order of effects, so we miss this) Updated value
       *    is now in nextTree, but not currentTree.
       * 2. This effect happens. We subscribe and update.
       * 3. From the update we re-render and read currentTree, with old value.
       * 4. Batcher's effect sets currentTree to nextTree.
       * In this sequence we miss the update. To avoid that, add the update
       * to queuedComponentCallback if a batch is in progress.
       */ // FIXME delete queuedComponentCallbacks_DEPRECATED when deleting useInterface.
            const state = store.getState();
            if (state.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
                updateState(store.getState(), key);
            });
            else updateState(store.getState(), key);
        });
        $1ee798bac53aa7db$var$Recoil_differenceSets(previousSubscriptions.current, recoilValuesUsed.current).forEach((key)=>{
            unsubscribeFrom(key);
        });
        previousSubscriptions.current = recoilValuesUsed.current;
    }); // Effect to unsubscribe from all when unmounting
    $1ee798bac53aa7db$var$useEffect$3(()=>{
        const currentSubscriptions = subscriptions.current; // Restore subscriptions that were cleared due to StrictMode running this effect twice
        $1ee798bac53aa7db$var$Recoil_differenceSets(recoilValuesUsed.current, new Set(currentSubscriptions.keys())).forEach((key)=>{
            const sub = $1ee798bac53aa7db$var$subscribeToRecoilValue$1(storeRef.current, new $1ee798bac53aa7db$var$AbstractRecoilValue$3(key), (state)=>updateState(state, key), componentName);
            currentSubscriptions.set(key, sub);
        });
        return ()=>currentSubscriptions.forEach((_, key)=>unsubscribeFrom(key));
    }, [
        componentName,
        storeRef,
        unsubscribeFrom,
        updateState
    ]);
    return $1ee798bac53aa7db$var$useMemo$1(()=>{
        // eslint-disable-next-line no-shadow
        function useSetRecoilState(recoilState) {
            return (newValueOrUpdater)=>{
                $1ee798bac53aa7db$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
            };
        } // eslint-disable-next-line no-shadow
        function useResetRecoilState(recoilState) {
            return ()=>$1ee798bac53aa7db$var$setRecoilValue$2(storeRef.current, recoilState, $1ee798bac53aa7db$var$DEFAULT_VALUE$2);
        } // eslint-disable-next-line no-shadow
        function useRecoilValueLoadable(recoilValue) {
            var _storeState$nextTree;
            if (!recoilValuesUsed.current.has(recoilValue.key)) recoilValuesUsed.current = $1ee798bac53aa7db$var$setByAddingToSet$2(recoilValuesUsed.current, recoilValue.key);
             // TODO Restore optimization to memoize lookup
            const storeState = storeRef.current.getState();
            return $1ee798bac53aa7db$var$getRecoilValueAsLoadable$2(storeRef.current, recoilValue, $1ee798bac53aa7db$var$reactMode$3().early ? (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree : storeState.currentTree);
        } // eslint-disable-next-line no-shadow
        function useRecoilValue(recoilValue) {
            const loadable = useRecoilValueLoadable(recoilValue);
            return $1ee798bac53aa7db$var$handleLoadable(loadable, recoilValue, storeRef);
        } // eslint-disable-next-line no-shadow
        function useRecoilState(recoilState) {
            return [
                useRecoilValue(recoilState),
                useSetRecoilState(recoilState)
            ];
        } // eslint-disable-next-line no-shadow
        function useRecoilStateLoadable(recoilState) {
            return [
                useRecoilValueLoadable(recoilState),
                useSetRecoilState(recoilState)
            ];
        }
        return {
            getRecoilValue: useRecoilValue,
            getRecoilValueLoadable: useRecoilValueLoadable,
            getRecoilState: useRecoilState,
            getRecoilStateLoadable: useRecoilStateLoadable,
            getSetRecoilState: useSetRecoilState,
            getResetRecoilState: useResetRecoilState
        };
    }, [
        recoilValuesUsed,
        storeRef
    ]);
}
const $1ee798bac53aa7db$var$recoilComponentGetRecoilValueCount_FOR_TESTING = {
    current: 0
};
function $1ee798bac53aa7db$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE(recoilValue) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    const componentName = $1ee798bac53aa7db$var$Recoil_useComponentName();
    const getSnapshot = $1ee798bac53aa7db$var$useCallback$1(()=>{
        var _storeState$nextTree2;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $1ee798bac53aa7db$var$reactMode$3().early ? (_storeState$nextTree2 = storeState.nextTree) !== null && _storeState$nextTree2 !== void 0 ? _storeState$nextTree2 : storeState.currentTree : storeState.currentTree;
        const loadable = $1ee798bac53aa7db$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
        return {
            loadable: loadable,
            key: recoilValue.key
        };
    }, [
        storeRef,
        recoilValue
    ]); // Memoize the state to avoid unnecessary rerenders
    const memoizePreviousSnapshot = $1ee798bac53aa7db$var$useCallback$1((getState)=>{
        let prevState;
        return ()=>{
            var _prevState, _prevState2;
            const nextState = getState();
            if ((_prevState = prevState) !== null && _prevState !== void 0 && _prevState.loadable.is(nextState.loadable) && ((_prevState2 = prevState) === null || _prevState2 === void 0 ? void 0 : _prevState2.key) === nextState.key) return prevState;
            prevState = nextState;
            return nextState;
        };
    }, []);
    const getMemoizedSnapshot = $1ee798bac53aa7db$var$useMemo$1(()=>memoizePreviousSnapshot(getSnapshot), [
        getSnapshot,
        memoizePreviousSnapshot
    ]);
    const subscribe = $1ee798bac53aa7db$var$useCallback$1((notify)=>{
        const store = storeRef.current;
        const subscription = $1ee798bac53aa7db$var$subscribeToRecoilValue$1(store, recoilValue, notify, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName
    ]);
    return $1ee798bac53aa7db$var$useSyncExternalStore$1(subscribe, getMemoizedSnapshot, getMemoizedSnapshot // getServerSnapshot() for SSR support
    ).loadable;
}
function $1ee798bac53aa7db$var$useRecoilValueLoadable_MUTABLE_SOURCE(recoilValue) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    const getLoadable = $1ee798bac53aa7db$var$useCallback$1(()=>{
        var _storeState$nextTree3;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $1ee798bac53aa7db$var$reactMode$3().early ? (_storeState$nextTree3 = storeState.nextTree) !== null && _storeState$nextTree3 !== void 0 ? _storeState$nextTree3 : storeState.currentTree : storeState.currentTree;
        return $1ee798bac53aa7db$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getLoadableWithTesting = $1ee798bac53aa7db$var$useCallback$1(()=>{
        return getLoadable();
    }, [
        getLoadable
    ]);
    const componentName = $1ee798bac53aa7db$var$Recoil_useComponentName();
    const subscribe = $1ee798bac53aa7db$var$useCallback$1((_storeState, notify)=>{
        const store = storeRef.current;
        const subscription = $1ee798bac53aa7db$var$subscribeToRecoilValue$1(store, recoilValue, ()=>{
            if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_suppress_rerender_in_callback")) return notify();
             // Only re-render if the value has changed.
            // This will evaluate the atom/selector now as well as when the
            // component renders, but that may help with prefetching.
            const newLoadable = getLoadable();
            if (!prevLoadableRef.current.is(newLoadable)) notify();
             // If the component is suspended then the effect setting prevLoadableRef
            // will not run.  So, set the previous value here when its subscription
            // is fired to wake it up.  We can't just rely on this, though, because
            // this only executes when an atom/selector is dirty and the atom/selector
            // passed to the hook can dynamically change.
            prevLoadableRef.current = newLoadable;
        }, componentName);
        return subscription.release;
    }, [
        storeRef,
        recoilValue,
        componentName,
        getLoadable
    ]);
    const source = $1ee798bac53aa7db$var$useRecoilMutableSource$1();
    if (source == null) throw $1ee798bac53aa7db$var$Recoil_err("Recoil hooks must be used in components contained within a <RecoilRoot> component.");
    const loadable = $1ee798bac53aa7db$var$useMutableSource$1(source, getLoadableWithTesting, subscribe);
    const prevLoadableRef = $1ee798bac53aa7db$var$useRef$4(loadable);
    $1ee798bac53aa7db$var$useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    return loadable;
}
function $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    const componentName = $1ee798bac53aa7db$var$Recoil_useComponentName(); // Accessors to get the current state
    const getLoadable = $1ee798bac53aa7db$var$useCallback$1(()=>{
        var _storeState$nextTree4;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $1ee798bac53aa7db$var$reactMode$3().early ? (_storeState$nextTree4 = storeState.nextTree) !== null && _storeState$nextTree4 !== void 0 ? _storeState$nextTree4 : storeState.currentTree : storeState.currentTree;
        return $1ee798bac53aa7db$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const getState = $1ee798bac53aa7db$var$useCallback$1(()=>({
            loadable: getLoadable(),
            key: recoilValue.key
        }), [
        getLoadable,
        recoilValue.key
    ]); // Memoize state snapshots
    const updateState = $1ee798bac53aa7db$var$useCallback$1((prevState)=>{
        const nextState = getState();
        return prevState.loadable.is(nextState.loadable) && prevState.key === nextState.key ? prevState : nextState;
    }, [
        getState
    ]); // Subscribe to Recoil state changes
    $1ee798bac53aa7db$var$useEffect$3(()=>{
        const subscription = $1ee798bac53aa7db$var$subscribeToRecoilValue$1(storeRef.current, recoilValue, (_state)=>{
            setState(updateState);
        }, componentName); // Update state in case we are using a different key
        setState(updateState);
        return subscription.release;
    }, [
        componentName,
        recoilValue,
        storeRef,
        updateState
    ]); // Get the current state
    const [state, setState] = $1ee798bac53aa7db$var$useState$1(getState); // If we changed keys, then return the state for the new key.
    // This is important in case the old key would cause the component to suspend.
    // We don't have to set the new state here since the subscribing effect above
    // will do that.
    return state.key !== recoilValue.key ? getState().loadable : state.loadable;
}
function $1ee798bac53aa7db$var$useRecoilValueLoadable_LEGACY(recoilValue) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2(); // eslint-disable-next-line fb-www/react-no-unused-state-hook
    const [, forceUpdate] = $1ee798bac53aa7db$var$useState$1([]);
    const componentName = $1ee798bac53aa7db$var$Recoil_useComponentName();
    const getLoadable = $1ee798bac53aa7db$var$useCallback$1(()=>{
        var _storeState$nextTree5;
        const store = storeRef.current;
        const storeState = store.getState();
        const treeState = $1ee798bac53aa7db$var$reactMode$3().early ? (_storeState$nextTree5 = storeState.nextTree) !== null && _storeState$nextTree5 !== void 0 ? _storeState$nextTree5 : storeState.currentTree : storeState.currentTree;
        return $1ee798bac53aa7db$var$getRecoilValueAsLoadable$2(store, recoilValue, treeState);
    }, [
        storeRef,
        recoilValue
    ]);
    const loadable = getLoadable();
    const prevLoadableRef = $1ee798bac53aa7db$var$useRef$4(loadable);
    $1ee798bac53aa7db$var$useEffect$3(()=>{
        prevLoadableRef.current = loadable;
    });
    $1ee798bac53aa7db$var$useEffect$3(()=>{
        const store = storeRef.current;
        const storeState = store.getState();
        const subscription = $1ee798bac53aa7db$var$subscribeToRecoilValue$1(store, recoilValue, (_state)=>{
            var _prevLoadableRef$curr;
            if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_suppress_rerender_in_callback")) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr = prevLoadableRef.current) !== null && _prevLoadableRef$curr !== void 0 && _prevLoadableRef$curr.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }, componentName);
        /**
     * Since we're subscribing in an effect we need to update to the latest
     * value of the atom since it may have changed since we rendered. We can
     * go ahead and do that now, unless we're in the middle of a batch --
     * in which case we should do it at the end of the batch, due to the
     * following edge case: Suppose an atom is updated in another useEffect
     * of this same component. Then the following sequence of events occur:
     * 1. Atom is updated and subs fired (but we may not be subscribed
     *    yet depending on order of effects, so we miss this) Updated value
     *    is now in nextTree, but not currentTree.
     * 2. This effect happens. We subscribe and update.
     * 3. From the update we re-render and read currentTree, with old value.
     * 4. Batcher's effect sets currentTree to nextTree.
     * In this sequence we miss the update. To avoid that, add the update
     * to queuedComponentCallback if a batch is in progress.
     */ if (storeState.nextTree) store.getState().queuedComponentCallbacks_DEPRECATED.push(()=>{
            // $FlowFixMe[incompatible-type]
            prevLoadableRef.current = null;
            forceUpdate([]);
        });
        else {
            var _prevLoadableRef$curr2;
            if (!$1ee798bac53aa7db$var$Recoil_gkx("recoil_suppress_rerender_in_callback")) return forceUpdate([]);
            const newLoadable = getLoadable();
            if (!((_prevLoadableRef$curr2 = prevLoadableRef.current) !== null && _prevLoadableRef$curr2 !== void 0 && _prevLoadableRef$curr2.is(newLoadable))) // $FlowFixMe[incompatible-call]
            forceUpdate(newLoadable);
            prevLoadableRef.current = newLoadable;
        }
        return subscription.release;
    }, [
        componentName,
        getLoadable,
        recoilValue,
        storeRef
    ]);
    return loadable;
}
/**
  Like useRecoilValue(), but either returns the value if available or
  just undefined if not available for any reason, such as pending or error.
*/ function $1ee798bac53aa7db$var$useRecoilValueLoadable(recoilValue) {
    if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) // eslint-disable-next-line fb-www/react-hooks
    $1ee798bac53aa7db$var$Recoil_useRetain(recoilValue);
    return ({
        TRANSITION_SUPPORT: $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
        // `reactMode()` before calling it.  However, sometimes the host React
        // environment supports it but uses additional React renderers (such as with
        // `react-three-fiber`) which do not.  While this is technically a user issue
        // by using a renderer with React 18+ that doesn't fully support React 18 we
        // don't want to break users if it can be avoided. As the current renderer can
        // change at runtime, we need to dynamically check and fallback if necessary.
        SYNC_EXTERNAL_STORE: $1ee798bac53aa7db$var$currentRendererSupportsUseSyncExternalStore$1() ? $1ee798bac53aa7db$var$useRecoilValueLoadable_SYNC_EXTERNAL_STORE : $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT,
        MUTABLE_SOURCE: $1ee798bac53aa7db$var$useRecoilValueLoadable_MUTABLE_SOURCE,
        LEGACY: $1ee798bac53aa7db$var$useRecoilValueLoadable_LEGACY
    })[$1ee798bac53aa7db$var$reactMode$3().mode](recoilValue);
}
/**
  Returns the value represented by the RecoilValue.
  If the value is pending, it will throw a Promise to suspend the component,
  if the value is an error it will throw it for the nearest React error boundary.
  This will also subscribe the component for any updates in the value.
  */ function $1ee798bac53aa7db$var$useRecoilValue(recoilValue) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    const loadable = $1ee798bac53aa7db$var$useRecoilValueLoadable(recoilValue);
    return $1ee798bac53aa7db$var$handleLoadable(loadable, recoilValue, storeRef);
}
/**
  Returns a function that allows the value of a RecoilState to be updated, but does
  not subscribe the component to changes to that RecoilState.
*/ function $1ee798bac53aa7db$var$useSetRecoilState(recoilState) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    return $1ee798bac53aa7db$var$useCallback$1((newValueOrUpdater)=>{
        $1ee798bac53aa7db$var$setRecoilValue$2(storeRef.current, recoilState, newValueOrUpdater);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Returns a function that will reset the value of a RecoilState to its default
*/ function $1ee798bac53aa7db$var$useResetRecoilState(recoilState) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    return $1ee798bac53aa7db$var$useCallback$1(()=>{
        $1ee798bac53aa7db$var$setRecoilValue$2(storeRef.current, recoilState, $1ee798bac53aa7db$var$DEFAULT_VALUE$2);
    }, [
        storeRef,
        recoilState
    ]);
}
/**
  Equivalent to useState(). Allows the value of the RecoilState to be read and written.
  Subsequent updates to the RecoilState will cause the component to re-render. If the
  RecoilState is pending, this will suspend the component and initiate the
  retrieval of the value. If evaluating the RecoilState resulted in an error, this will
  throw the error so that the nearest React error boundary can catch it.
*/ function $1ee798bac53aa7db$var$useRecoilState(recoilState) {
    return [
        $1ee798bac53aa7db$var$useRecoilValue(recoilState),
        $1ee798bac53aa7db$var$useSetRecoilState(recoilState)
    ];
}
/**
  Like useRecoilState(), but does not cause Suspense or React error handling. Returns
  an object that indicates whether the RecoilState is available, pending, or
  unavailable due to an error.
*/ function $1ee798bac53aa7db$var$useRecoilStateLoadable(recoilState) {
    return [
        $1ee798bac53aa7db$var$useRecoilValueLoadable(recoilState),
        $1ee798bac53aa7db$var$useSetRecoilState(recoilState)
    ];
}
function $1ee798bac53aa7db$var$useSetUnvalidatedAtomValues() {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    return (values, transactionMetadata = {})=>{
        $1ee798bac53aa7db$var$batchUpdates$2(()=>{
            storeRef.current.addTransactionMetadata(transactionMetadata);
            values.forEach((value, key)=>$1ee798bac53aa7db$var$setUnvalidatedRecoilValue$2(storeRef.current, new $1ee798bac53aa7db$var$AbstractRecoilValue$3(key), value));
        });
    };
}
/**
 * Experimental variants of hooks with support for useTransition()
 */ function $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    if ($1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020")) // eslint-disable-next-line fb-www/react-hooks
    $1ee798bac53aa7db$var$Recoil_useRetain(recoilValue);
    return $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT(recoilValue);
}
function $1ee798bac53aa7db$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilValue) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$2();
    const loadable = $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE(recoilValue);
    return $1ee798bac53aa7db$var$handleLoadable(loadable, recoilValue, storeRef);
}
function $1ee798bac53aa7db$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE(recoilState) {
    return [
        $1ee798bac53aa7db$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE(recoilState),
        $1ee798bac53aa7db$var$useSetRecoilState(recoilState)
    ];
}
var $1ee798bac53aa7db$var$Recoil_Hooks = {
    recoilComponentGetRecoilValueCount_FOR_TESTING: $1ee798bac53aa7db$var$recoilComponentGetRecoilValueCount_FOR_TESTING,
    useRecoilInterface: $1ee798bac53aa7db$var$useRecoilInterface_DEPRECATED,
    useRecoilState: $1ee798bac53aa7db$var$useRecoilState,
    useRecoilStateLoadable: $1ee798bac53aa7db$var$useRecoilStateLoadable,
    useRecoilValue: $1ee798bac53aa7db$var$useRecoilValue,
    useRecoilValueLoadable: $1ee798bac53aa7db$var$useRecoilValueLoadable,
    useResetRecoilState: $1ee798bac53aa7db$var$useResetRecoilState,
    useSetRecoilState: $1ee798bac53aa7db$var$useSetRecoilState,
    useSetUnvalidatedAtomValues: $1ee798bac53aa7db$var$useSetUnvalidatedAtomValues,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE
};
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a map containing all of the keys + values from the original map where
 * the given callback returned true.
 */ function $1ee798bac53aa7db$var$filterMap(map, callback) {
    const result = new Map();
    for (const [key, value] of map)if (callback(value, key)) result.set(key, value);
    return result;
}
var $1ee798bac53aa7db$var$Recoil_filterMap = $1ee798bac53aa7db$var$filterMap;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ /**
 * Returns a set containing all of the values from the original set where
 * the given callback returned true.
 */ function $1ee798bac53aa7db$var$filterSet(set, callback) {
    const result = new Set();
    for (const value of set)if (callback(value)) result.add(value);
    return result;
}
var $1ee798bac53aa7db$var$Recoil_filterSet = $1ee798bac53aa7db$var$filterSet;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$mergeMaps(...maps) {
    const result = new Map();
    for(let i = 0; i < maps.length; i++){
        const iterator = maps[i].keys();
        let nextKey;
        while(!(nextKey = iterator.next()).done)// $FlowIssue[incompatible-call] - map/iterator knows nothing about flow types
        result.set(nextKey.value, maps[i].get(nextKey.value));
    }
    return result;
}
var $1ee798bac53aa7db$var$Recoil_mergeMaps = $1ee798bac53aa7db$var$mergeMaps;
const { batchUpdates: $1ee798bac53aa7db$var$batchUpdates$3 } = $1ee798bac53aa7db$var$Recoil_Batching;
const { DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE$3, getNode: $1ee798bac53aa7db$var$getNode$4, nodes: $1ee798bac53aa7db$var$nodes$1 } = $1ee798bac53aa7db$var$Recoil_Node;
const { useStoreRef: $1ee798bac53aa7db$var$useStoreRef$3 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { AbstractRecoilValue: $1ee798bac53aa7db$var$AbstractRecoilValue$4, setRecoilValueLoadable: $1ee798bac53aa7db$var$setRecoilValueLoadable$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { SUSPENSE_TIMEOUT_MS: $1ee798bac53aa7db$var$SUSPENSE_TIMEOUT_MS$2 } = $1ee798bac53aa7db$var$Recoil_Retention;
const { cloneSnapshot: $1ee798bac53aa7db$var$cloneSnapshot$1 } = $1ee798bac53aa7db$var$Recoil_Snapshot$1;
const { useCallback: $1ee798bac53aa7db$var$useCallback$2, useEffect: $1ee798bac53aa7db$var$useEffect$4, useRef: $1ee798bac53aa7db$var$useRef$5, useState: $1ee798bac53aa7db$var$useState$2 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
const { isSSR: $1ee798bac53aa7db$var$isSSR$4 } = $1ee798bac53aa7db$var$Recoil_Environment;
function $1ee798bac53aa7db$var$useTransactionSubscription(callback) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$3();
    $1ee798bac53aa7db$var$useEffect$4(()=>{
        const sub = storeRef.current.subscribeToTransactions(callback);
        return sub.release;
    }, [
        callback,
        storeRef
    ]);
}
function $1ee798bac53aa7db$var$externallyVisibleAtomValuesInState(state) {
    const atomValues = state.atomValues.toMap();
    const persistedAtomContentsValues = $1ee798bac53aa7db$var$Recoil_mapMap($1ee798bac53aa7db$var$Recoil_filterMap(atomValues, (v, k)=>{
        const node = $1ee798bac53aa7db$var$getNode$4(k);
        const persistence = node.persistence_UNSTABLE;
        return persistence != null && persistence.type !== "none" && v.state === "hasValue";
    }), (v)=>v.contents); // Merge in nonvalidated atoms; we may not have defs for them but they will
    // all have persistence on or they wouldn't be there in the first place.
    return $1ee798bac53aa7db$var$Recoil_mergeMaps(state.nonvalidatedAtoms.toMap(), persistedAtomContentsValues);
}
/**
  Calls the given callback after any atoms have been modified and the consequent
  component re-renders have been committed. This is intended for persisting
  the values of the atoms to storage. The stored values can then be restored
  using the useSetUnvalidatedAtomValues hook.

  The callback receives the following info:

  atomValues: The current value of every atom that is both persistable (persistence
              type not set to 'none') and whose value is available (not in an
              error or loading state).

  previousAtomValues: The value of every persistable and available atom before
               the transaction began.

  atomInfo: A map containing the persistence settings for each atom. Every key
            that exists in atomValues will also exist in atomInfo.

  modifiedAtoms: The set of atoms that were written to during the transaction.

  transactionMetadata: Arbitrary information that was added via the
          useSetUnvalidatedAtomValues hook. Useful for ignoring the useSetUnvalidatedAtomValues
          transaction, to avoid loops.
*/ function $1ee798bac53aa7db$var$useTransactionObservation_DEPRECATED(callback) {
    $1ee798bac53aa7db$var$useTransactionSubscription($1ee798bac53aa7db$var$useCallback$2((store)=>{
        let previousTree = store.getState().previousTree;
        const currentTree = store.getState().currentTree;
        if (!previousTree) {
            $1ee798bac53aa7db$var$Recoil_recoverableViolation("Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil");
            previousTree = store.getState().currentTree; // attempt to trundle on
        }
        const atomValues = $1ee798bac53aa7db$var$externallyVisibleAtomValuesInState(currentTree);
        const previousAtomValues = $1ee798bac53aa7db$var$externallyVisibleAtomValuesInState(previousTree);
        const atomInfo = $1ee798bac53aa7db$var$Recoil_mapMap($1ee798bac53aa7db$var$nodes$1, (node)=>{
            var _node$persistence_UNS, _node$persistence_UNS2, _node$persistence_UNS3, _node$persistence_UNS4;
            return {
                persistence_UNSTABLE: {
                    type: (_node$persistence_UNS = (_node$persistence_UNS2 = node.persistence_UNSTABLE) === null || _node$persistence_UNS2 === void 0 ? void 0 : _node$persistence_UNS2.type) !== null && _node$persistence_UNS !== void 0 ? _node$persistence_UNS : "none",
                    backButton: (_node$persistence_UNS3 = (_node$persistence_UNS4 = node.persistence_UNSTABLE) === null || _node$persistence_UNS4 === void 0 ? void 0 : _node$persistence_UNS4.backButton) !== null && _node$persistence_UNS3 !== void 0 ? _node$persistence_UNS3 : false
                }
            };
        }); // Filter on existance in atomValues so that externally-visible rules
        // are also applied to modified atoms (specifically exclude selectors):
        const modifiedAtoms = $1ee798bac53aa7db$var$Recoil_filterSet(currentTree.dirtyAtoms, (k)=>atomValues.has(k) || previousAtomValues.has(k));
        callback({
            atomValues: atomValues,
            previousAtomValues: previousAtomValues,
            atomInfo: atomInfo,
            modifiedAtoms: modifiedAtoms,
            transactionMetadata: {
                ...currentTree.transactionMetadata
            }
        });
    }, [
        callback
    ]));
}
function $1ee798bac53aa7db$var$useRecoilTransactionObserver(callback) {
    $1ee798bac53aa7db$var$useTransactionSubscription($1ee798bac53aa7db$var$useCallback$2((store)=>{
        const snapshot = $1ee798bac53aa7db$var$cloneSnapshot$1(store, "latest");
        const previousSnapshot = $1ee798bac53aa7db$var$cloneSnapshot$1(store, "previous");
        callback({
            snapshot: snapshot,
            previousSnapshot: previousSnapshot
        });
    }, [
        callback
    ]));
} // Return a snapshot of the current state and subscribe to all state changes
function $1ee798bac53aa7db$var$useRecoilSnapshot() {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$3();
    const [snapshot, setSnapshot] = $1ee798bac53aa7db$var$useState$2(()=>$1ee798bac53aa7db$var$cloneSnapshot$1(storeRef.current));
    const previousSnapshot = $1ee798bac53aa7db$var$Recoil_usePrevious(snapshot);
    const timeoutID = $1ee798bac53aa7db$var$useRef$5();
    const releaseRef = $1ee798bac53aa7db$var$useRef$5();
    $1ee798bac53aa7db$var$useTransactionSubscription($1ee798bac53aa7db$var$useCallback$2((store)=>setSnapshot($1ee798bac53aa7db$var$cloneSnapshot$1(store)), [])); // Retain snapshot for duration component is mounted
    $1ee798bac53aa7db$var$useEffect$4(()=>{
        const release = snapshot.retain(); // Release the retain from the rendering call
        if (timeoutID.current && !$1ee798bac53aa7db$var$isSSR$4) {
            var _releaseRef$current;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current = releaseRef.current) === null || _releaseRef$current === void 0 || _releaseRef$current.call(releaseRef);
            releaseRef.current = null;
        }
        return ()=>{
            // Defer the release.  If "Fast Refresh"" is used then the component may
            // re-render with the same state.  The previous cleanup will then run and
            // then the new effect will run. We don't want the snapshot to be released
            // by that cleanup before the new effect has a chance to retain it again.
            // Use timeout of 10 to workaround Firefox issue: https://github.com/facebookexperimental/Recoil/issues/1936
            window.setTimeout(release, 10);
        };
    }, [
        snapshot
    ]); // Retain snapshot until above effect is run.
    // Release after a threshold in case component is suspended.
    if (previousSnapshot !== snapshot && !$1ee798bac53aa7db$var$isSSR$4) {
        // Release the previous snapshot
        if (timeoutID.current) {
            var _releaseRef$current2;
            window.clearTimeout(timeoutID.current);
            timeoutID.current = null;
            (_releaseRef$current2 = releaseRef.current) === null || _releaseRef$current2 === void 0 || _releaseRef$current2.call(releaseRef);
            releaseRef.current = null;
        }
        releaseRef.current = snapshot.retain();
        timeoutID.current = window.setTimeout(()=>{
            var _releaseRef$current3;
            timeoutID.current = null;
            (_releaseRef$current3 = releaseRef.current) === null || _releaseRef$current3 === void 0 || _releaseRef$current3.call(releaseRef);
            releaseRef.current = null;
        }, $1ee798bac53aa7db$var$SUSPENSE_TIMEOUT_MS$2);
    }
    return snapshot;
}
function $1ee798bac53aa7db$var$gotoSnapshot(store, snapshot) {
    var _storeState$nextTree;
    const storeState = store.getState();
    const prev = (_storeState$nextTree = storeState.nextTree) !== null && _storeState$nextTree !== void 0 ? _storeState$nextTree : storeState.currentTree;
    const next = snapshot.getStore_INTERNAL().getState().currentTree;
    $1ee798bac53aa7db$var$batchUpdates$3(()=>{
        const keysToUpdate = new Set();
        for (const keys of [
            prev.atomValues.keys(),
            next.atomValues.keys()
        ])for (const key of keys){
            var _prev$atomValues$get, _next$atomValues$get;
            if (((_prev$atomValues$get = prev.atomValues.get(key)) === null || _prev$atomValues$get === void 0 ? void 0 : _prev$atomValues$get.contents) !== ((_next$atomValues$get = next.atomValues.get(key)) === null || _next$atomValues$get === void 0 ? void 0 : _next$atomValues$get.contents) && $1ee798bac53aa7db$var$getNode$4(key).shouldRestoreFromSnapshots) keysToUpdate.add(key);
        }
        keysToUpdate.forEach((key)=>{
            $1ee798bac53aa7db$var$setRecoilValueLoadable$1(store, new $1ee798bac53aa7db$var$AbstractRecoilValue$4(key), next.atomValues.has(key) ? $1ee798bac53aa7db$var$Recoil_nullthrows(next.atomValues.get(key)) : $1ee798bac53aa7db$var$DEFAULT_VALUE$3);
        });
        store.replaceState((state)=>({
                ...state,
                stateID: snapshot.getID()
            }));
    });
}
function $1ee798bac53aa7db$var$useGotoRecoilSnapshot() {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$3();
    return $1ee798bac53aa7db$var$useCallback$2((snapshot)=>$1ee798bac53aa7db$var$gotoSnapshot(storeRef.current, snapshot), [
        storeRef
    ]);
}
var $1ee798bac53aa7db$var$Recoil_SnapshotHooks = {
    useRecoilSnapshot: $1ee798bac53aa7db$var$useRecoilSnapshot,
    gotoSnapshot: $1ee798bac53aa7db$var$gotoSnapshot,
    useGotoRecoilSnapshot: $1ee798bac53aa7db$var$useGotoRecoilSnapshot,
    useRecoilTransactionObserver: $1ee798bac53aa7db$var$useRecoilTransactionObserver,
    useTransactionObservation_DEPRECATED: $1ee798bac53aa7db$var$useTransactionObservation_DEPRECATED,
    useTransactionSubscription_DEPRECATED: $1ee798bac53aa7db$var$useTransactionSubscription
};
const { peekNodeInfo: $1ee798bac53aa7db$var$peekNodeInfo$2 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { useStoreRef: $1ee798bac53aa7db$var$useStoreRef$4 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
function $1ee798bac53aa7db$var$useGetRecoilValueInfo() {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$4(); // $FlowFixMe[incompatible-return]
    return ({ key: key })=>$1ee798bac53aa7db$var$peekNodeInfo$2(storeRef.current, storeRef.current.getState().currentTree, key);
}
var $1ee798bac53aa7db$var$Recoil_useGetRecoilValueInfo = $1ee798bac53aa7db$var$useGetRecoilValueInfo;
const { reactMode: $1ee798bac53aa7db$var$reactMode$4 } = $1ee798bac53aa7db$var$Recoil_ReactMode;
const { RecoilRoot: $1ee798bac53aa7db$var$RecoilRoot$1, useStoreRef: $1ee798bac53aa7db$var$useStoreRef$5 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { useMemo: $1ee798bac53aa7db$var$useMemo$2 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
function $1ee798bac53aa7db$var$useRecoilBridgeAcrossReactRoots() {
    // The test fails when using useMutableSource(), but only if act() is used
    // for the nested root.  So, this may only be a testing environment issue.
    if ($1ee798bac53aa7db$var$reactMode$4().mode === "MUTABLE_SOURCE") // eslint-disable-next-line fb-www/no-console
    console.warn("Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.");
    const store = $1ee798bac53aa7db$var$useStoreRef$5().current;
    return $1ee798bac53aa7db$var$useMemo$2(()=>{
        // eslint-disable-next-line no-shadow
        function RecoilBridge({ children: children }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).createElement($1ee798bac53aa7db$var$RecoilRoot$1, {
                store_INTERNAL: store
            }, children);
        }
        return RecoilBridge;
    }, [
        store
    ]);
}
var $1ee798bac53aa7db$var$Recoil_useRecoilBridgeAcrossReactRoots = $1ee798bac53aa7db$var$useRecoilBridgeAcrossReactRoots;
const { loadableWithValue: $1ee798bac53aa7db$var$loadableWithValue$1 } = $1ee798bac53aa7db$var$Recoil_Loadable$1;
const { initializeNode: $1ee798bac53aa7db$var$initializeNode$3 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE$4, getNode: $1ee798bac53aa7db$var$getNode$5 } = $1ee798bac53aa7db$var$Recoil_Node;
const { copyTreeState: $1ee798bac53aa7db$var$copyTreeState$1, getRecoilValueAsLoadable: $1ee798bac53aa7db$var$getRecoilValueAsLoadable$3, invalidateDownstreams: $1ee798bac53aa7db$var$invalidateDownstreams$1, writeLoadableToTreeState: $1ee798bac53aa7db$var$writeLoadableToTreeState$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
function $1ee798bac53aa7db$var$isAtom(recoilValue) {
    return $1ee798bac53aa7db$var$getNode$5(recoilValue.key).nodeType === "atom";
}
class $1ee798bac53aa7db$var$TransactionInterfaceImpl {
    constructor(store, treeState){
        $1ee798bac53aa7db$var$_defineProperty(this, "_store", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_treeState", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_changes", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "get", (recoilValue)=>{
            if (this._changes.has(recoilValue.key)) // $FlowIssue[incompatible-return]
            return this._changes.get(recoilValue.key);
            if (!$1ee798bac53aa7db$var$isAtom(recoilValue)) throw $1ee798bac53aa7db$var$Recoil_err("Reading selectors within atomicUpdate is not supported");
            const loadable = $1ee798bac53aa7db$var$getRecoilValueAsLoadable$3(this._store, recoilValue, this._treeState);
            if (loadable.state === "hasValue") return loadable.contents;
            else if (loadable.state === "hasError") throw loadable.contents;
            else throw $1ee798bac53aa7db$var$Recoil_err(`Expected Recoil atom ${recoilValue.key} to have a value, but it is in a loading state.`);
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "set", (recoilState, valueOrUpdater)=>{
            if (!$1ee798bac53aa7db$var$isAtom(recoilState)) throw $1ee798bac53aa7db$var$Recoil_err("Setting selectors within atomicUpdate is not supported");
            if (typeof valueOrUpdater === "function") {
                const current = this.get(recoilState);
                this._changes.set(recoilState.key, valueOrUpdater(current)); // flowlint-line unclear-type:off
            } else {
                // Initialize atom and run effects if not initialized yet
                $1ee798bac53aa7db$var$initializeNode$3(this._store, recoilState.key, "set");
                this._changes.set(recoilState.key, valueOrUpdater);
            }
        });
        $1ee798bac53aa7db$var$_defineProperty(this, "reset", (recoilState)=>{
            this.set(recoilState, $1ee798bac53aa7db$var$DEFAULT_VALUE$4);
        });
        this._store = store;
        this._treeState = treeState;
        this._changes = new Map();
    }
    // eslint-disable-next-line fb-www/extra-arrow-initializer
    newTreeState_INTERNAL() {
        if (this._changes.size === 0) return this._treeState;
        const newState = $1ee798bac53aa7db$var$copyTreeState$1(this._treeState);
        for (const [k, v] of this._changes)$1ee798bac53aa7db$var$writeLoadableToTreeState$1(newState, k, $1ee798bac53aa7db$var$loadableWithValue$1(v));
        $1ee798bac53aa7db$var$invalidateDownstreams$1(this._store, newState);
        return newState;
    }
}
function $1ee798bac53aa7db$var$atomicUpdater(store) {
    return (fn)=>{
        store.replaceState((treeState)=>{
            const changeset = new $1ee798bac53aa7db$var$TransactionInterfaceImpl(store, treeState);
            fn(changeset);
            return changeset.newTreeState_INTERNAL();
        });
    };
}
var $1ee798bac53aa7db$var$Recoil_AtomicUpdates = {
    atomicUpdater: $1ee798bac53aa7db$var$atomicUpdater
};
var $1ee798bac53aa7db$var$Recoil_AtomicUpdates_1 = $1ee798bac53aa7db$var$Recoil_AtomicUpdates.atomicUpdater;
var $1ee798bac53aa7db$var$Recoil_AtomicUpdates$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    atomicUpdater: $1ee798bac53aa7db$var$Recoil_AtomicUpdates_1
});
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$invariant(condition, message) {
    if (!condition) throw new Error(message);
}
var $1ee798bac53aa7db$var$invariant_1 = $1ee798bac53aa7db$var$invariant;
// @oss-only
var $1ee798bac53aa7db$var$Recoil_invariant = $1ee798bac53aa7db$var$invariant_1;
const { atomicUpdater: $1ee798bac53aa7db$var$atomicUpdater$1 } = $1ee798bac53aa7db$var$Recoil_AtomicUpdates$1;
const { batchUpdates: $1ee798bac53aa7db$var$batchUpdates$4 } = $1ee798bac53aa7db$var$Recoil_Batching;
const { DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE$5 } = $1ee798bac53aa7db$var$Recoil_Node;
const { useStoreRef: $1ee798bac53aa7db$var$useStoreRef$6 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { refreshRecoilValue: $1ee798bac53aa7db$var$refreshRecoilValue$1, setRecoilValue: $1ee798bac53aa7db$var$setRecoilValue$3 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { cloneSnapshot: $1ee798bac53aa7db$var$cloneSnapshot$2 } = $1ee798bac53aa7db$var$Recoil_Snapshot$1;
const { gotoSnapshot: $1ee798bac53aa7db$var$gotoSnapshot$1 } = $1ee798bac53aa7db$var$Recoil_SnapshotHooks;
const { useCallback: $1ee798bac53aa7db$var$useCallback$3 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
class $1ee798bac53aa7db$var$Sentinel {
}
const $1ee798bac53aa7db$var$SENTINEL = new $1ee798bac53aa7db$var$Sentinel();
function $1ee798bac53aa7db$var$recoilCallback(store, fn, args, extraInterface) {
    let ret = $1ee798bac53aa7db$var$SENTINEL;
    let releaseSnapshot;
    $1ee798bac53aa7db$var$batchUpdates$4(()=>{
        const errMsg = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
        if (typeof fn !== "function") throw $1ee798bac53aa7db$var$Recoil_err(errMsg);
         // Clone the snapshot lazily to avoid overhead if the callback does not use it.
        // Note that this means the snapshot may represent later state from when
        // the callback was called if it first accesses the snapshot asynchronously.
        const callbackInterface = $1ee798bac53aa7db$var$Recoil_lazyProxy({
            ...extraInterface !== null && extraInterface !== void 0 ? extraInterface : {},
            // flowlint-line unclear-type:off
            // $FlowFixMe[missing-local-annot]
            set: (node, newValue)=>$1ee798bac53aa7db$var$setRecoilValue$3(store, node, newValue),
            // $FlowFixMe[missing-local-annot]
            reset: (node)=>$1ee798bac53aa7db$var$setRecoilValue$3(store, node, $1ee798bac53aa7db$var$DEFAULT_VALUE$5),
            // $FlowFixMe[missing-local-annot]
            refresh: (node)=>$1ee798bac53aa7db$var$refreshRecoilValue$1(store, node),
            gotoSnapshot: (snapshot)=>$1ee798bac53aa7db$var$gotoSnapshot$1(store, snapshot),
            transact_UNSTABLE: (transaction)=>$1ee798bac53aa7db$var$atomicUpdater$1(store)(transaction)
        }, {
            snapshot: ()=>{
                const snapshot = $1ee798bac53aa7db$var$cloneSnapshot$2(store);
                releaseSnapshot = snapshot.retain();
                return snapshot;
            }
        });
        const callback = fn(callbackInterface);
        if (typeof callback !== "function") throw $1ee798bac53aa7db$var$Recoil_err(errMsg);
        ret = callback(...args);
    });
    !!(ret instanceof $1ee798bac53aa7db$var$Sentinel) && $1ee798bac53aa7db$var$Recoil_invariant(false);
    if ($1ee798bac53aa7db$var$Recoil_isPromise(ret)) ret = ret.finally(()=>{
        var _releaseSnapshot;
        (_releaseSnapshot = releaseSnapshot) === null || _releaseSnapshot === void 0 || _releaseSnapshot();
    });
    else {
        var _releaseSnapshot2;
        (_releaseSnapshot2 = releaseSnapshot) === null || _releaseSnapshot2 === void 0 || _releaseSnapshot2();
    }
    return ret;
}
function $1ee798bac53aa7db$var$useRecoilCallback(fn, deps) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$6();
    return $1ee798bac53aa7db$var$useCallback$3((...args)=>{
        return $1ee798bac53aa7db$var$recoilCallback(storeRef.current, fn, args);
    }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $1ee798bac53aa7db$var$Recoil_useRecoilCallback = {
    recoilCallback: $1ee798bac53aa7db$var$recoilCallback,
    useRecoilCallback: $1ee798bac53aa7db$var$useRecoilCallback
};
const { useStoreRef: $1ee798bac53aa7db$var$useStoreRef$7 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { refreshRecoilValue: $1ee798bac53aa7db$var$refreshRecoilValue$2 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { useCallback: $1ee798bac53aa7db$var$useCallback$4 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
function $1ee798bac53aa7db$var$useRecoilRefresher(recoilValue) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$7();
    return $1ee798bac53aa7db$var$useCallback$4(()=>{
        const store = storeRef.current;
        $1ee798bac53aa7db$var$refreshRecoilValue$2(store, recoilValue);
    }, [
        recoilValue,
        storeRef
    ]);
}
var $1ee798bac53aa7db$var$Recoil_useRecoilRefresher = $1ee798bac53aa7db$var$useRecoilRefresher;
const { atomicUpdater: $1ee798bac53aa7db$var$atomicUpdater$2 } = $1ee798bac53aa7db$var$Recoil_AtomicUpdates$1;
const { useStoreRef: $1ee798bac53aa7db$var$useStoreRef$8 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { useMemo: $1ee798bac53aa7db$var$useMemo$3 } = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM)));
function $1ee798bac53aa7db$var$useRecoilTransaction(fn, deps) {
    const storeRef = $1ee798bac53aa7db$var$useStoreRef$8();
    return $1ee798bac53aa7db$var$useMemo$3(()=>(...args)=>{
            const atomicUpdate = $1ee798bac53aa7db$var$atomicUpdater$2(storeRef.current);
            atomicUpdate((transactionInterface)=>{
                fn(transactionInterface)(...args);
            });
        }, deps != null ? [
        ...deps,
        storeRef
    ] : undefined // eslint-disable-line fb-www/react-hooks-deps
    );
}
var $1ee798bac53aa7db$var$Recoil_useRecoilTransaction = $1ee798bac53aa7db$var$useRecoilTransaction;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $1ee798bac53aa7db$var$WrappedValue {
    constructor(value){
        $1ee798bac53aa7db$var$_defineProperty(this, "value", void 0);
        this.value = value;
    }
}
var $1ee798bac53aa7db$var$Recoil_Wrapper = {
    WrappedValue: $1ee798bac53aa7db$var$WrappedValue
};
var $1ee798bac53aa7db$var$Recoil_Wrapper_1 = $1ee798bac53aa7db$var$Recoil_Wrapper.WrappedValue;
var $1ee798bac53aa7db$var$Recoil_Wrapper$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WrappedValue: $1ee798bac53aa7db$var$Recoil_Wrapper_1
});
const { isFastRefreshEnabled: $1ee798bac53aa7db$var$isFastRefreshEnabled$2 } = $1ee798bac53aa7db$var$Recoil_ReactMode;
class $1ee798bac53aa7db$var$ChangedPathError extends Error {
}
class $1ee798bac53aa7db$var$TreeCache {
    // $FlowIssue[unclear-type]
    constructor(options){
        var _options$onHit, _options$onSet, _options$mapNodeValue;
        $1ee798bac53aa7db$var$_defineProperty(this, "_name", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_numLeafs", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_root", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_onHit", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_onSet", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_mapNodeValue", void 0);
        this._name = options === null || options === void 0 ? void 0 : options.name;
        this._numLeafs = 0;
        this._root = null;
        this._onHit = (_options$onHit = options === null || options === void 0 ? void 0 : options.onHit) !== null && _options$onHit !== void 0 ? _options$onHit : ()=>{};
        this._onSet = (_options$onSet = options === null || options === void 0 ? void 0 : options.onSet) !== null && _options$onSet !== void 0 ? _options$onSet : ()=>{};
        this._mapNodeValue = (_options$mapNodeValue = options === null || options === void 0 ? void 0 : options.mapNodeValue) !== null && _options$mapNodeValue !== void 0 ? _options$mapNodeValue : (val)=>val;
    }
    size() {
        return this._numLeafs;
    }
    root() {
        return this._root;
    }
    get(getNodeValue, handlers) {
        var _this$getLeafNode;
        return (_this$getLeafNode = this.getLeafNode(getNodeValue, handlers)) === null || _this$getLeafNode === void 0 ? void 0 : _this$getLeafNode.value;
    }
    getLeafNode(getNodeValue, handlers) {
        if (this._root == null) return undefined;
         // Iterate down the tree based on the current node values until we hit a leaf
        // $FlowIssue[unclear-type]
        let node = this._root;
        while(node){
            handlers === null || handlers === void 0 || handlers.onNodeVisit(node);
            if (node.type === "leaf") {
                this._onHit(node);
                return node;
            }
            const nodeValue = this._mapNodeValue(getNodeValue(node.nodeKey));
            node = node.branches.get(nodeValue);
        }
        return undefined;
    }
    set(route, value, handlers) {
        const addLeaf = ()=>{
            var _node2, _node3, _this$_root2, _handlers$onNodeVisit2;
            // First, setup the branch nodes for the route:
            // Iterate down the tree to find or add branch nodes following the route
            let node;
            let branchKey;
            for (const [nodeKey, nodeValue] of route){
                var _node, _handlers$onNodeVisit, _this$_root;
                // If the previous root was a leaf, while we not have a get(), it means
                // the selector has inconsistent values or implementation changed.
                const root = this._root;
                if ((root === null || root === void 0 ? void 0 : root.type) === "leaf") throw this.invalidCacheError();
                 // node now refers to the next node down in the tree
                const parent = node; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = parent ? parent.branches.get(branchKey) : root; // $FlowFixMe[prop-missing]
                // $FlowFixMe[incompatible-type]
                node = (_node = node) !== null && _node !== void 0 ? _node : {
                    type: "branch",
                    nodeKey: nodeKey,
                    parent: parent,
                    branches: new Map(),
                    branchKey: branchKey
                }; // If we found an existing node, confirm it has a consistent value
                if (node.type !== "branch" || node.nodeKey !== nodeKey) throw this.invalidCacheError();
                 // Add the branch node to the tree
                parent === null || parent === void 0 || parent.branches.set(branchKey, node);
                handlers === null || handlers === void 0 || (_handlers$onNodeVisit = handlers.onNodeVisit) === null || _handlers$onNodeVisit === void 0 || _handlers$onNodeVisit.call(handlers, node); // Prepare for next iteration and install root if it is new.
                branchKey = this._mapNodeValue(nodeValue);
                this._root = (_this$_root = this._root) !== null && _this$_root !== void 0 ? _this$_root : node;
            } // Second, setup the leaf node:
            // If there is an existing leaf for this route confirm it is consistent
            const oldLeaf = node ? (_node2 = node) === null || _node2 === void 0 ? void 0 : _node2.branches.get(branchKey) : this._root;
            if (oldLeaf != null && (oldLeaf.type !== "leaf" || oldLeaf.branchKey !== branchKey)) throw this.invalidCacheError();
             // Create a new or replacement leaf.
            const leafNode = {
                type: "leaf",
                value: value,
                parent: node,
                branchKey: branchKey
            }; // Install the leaf and call handlers
            (_node3 = node) === null || _node3 === void 0 || _node3.branches.set(branchKey, leafNode);
            this._root = (_this$_root2 = this._root) !== null && _this$_root2 !== void 0 ? _this$_root2 : leafNode;
            this._numLeafs++;
            this._onSet(leafNode);
            handlers === null || handlers === void 0 || (_handlers$onNodeVisit2 = handlers.onNodeVisit) === null || _handlers$onNodeVisit2 === void 0 || _handlers$onNodeVisit2.call(handlers, leafNode);
        };
        try {
            addLeaf();
        } catch (error) {
            // If the cache was stale or observed inconsistent values, such as with
            // Fast Refresh, then clear it and rebuild with the new values.
            if (error instanceof $1ee798bac53aa7db$var$ChangedPathError) {
                this.clear();
                addLeaf();
            } else throw error;
        }
    }
    delete(leaf) {
        const root = this.root();
        if (!root) return false;
        if (leaf === root) {
            this._root = null;
            this._numLeafs = 0;
            return true;
        } // Iterate up from the leaf deleteing it from it's parent's branches.
        let node = leaf.parent;
        let branchKey = leaf.branchKey;
        while(node){
            var _node4;
            node.branches.delete(branchKey); // Stop iterating if we hit the root.
            if (node === root) {
                if (node.branches.size === 0) {
                    this._root = null;
                    this._numLeafs = 0;
                } else this._numLeafs--;
                return true;
            } // Stop iterating if there are other branches since we don't need to
            // remove any more nodes.
            if (node.branches.size > 0) break;
             // Iterate up to our parent
            branchKey = (_node4 = node) === null || _node4 === void 0 ? void 0 : _node4.branchKey;
            node = node.parent;
        } // Confirm that the leaf we are deleting is actually attached to our tree
        for(; node !== root; node = node.parent){
            if (node == null) return false;
        }
        this._numLeafs--;
        return true;
    }
    clear() {
        this._numLeafs = 0;
        this._root = null;
    }
    invalidCacheError() {
        const CHANGED_PATH_ERROR_MESSAGE = $1ee798bac53aa7db$var$isFastRefreshEnabled$2() ? "Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache." : "Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.";
        $1ee798bac53aa7db$var$Recoil_recoverableViolation(CHANGED_PATH_ERROR_MESSAGE + (this._name != null ? ` - ${this._name}` : ""));
        throw new $1ee798bac53aa7db$var$ChangedPathError();
    }
}
var $1ee798bac53aa7db$var$Recoil_TreeCache = {
    TreeCache: $1ee798bac53aa7db$var$TreeCache
};
var $1ee798bac53aa7db$var$Recoil_TreeCache_1 = $1ee798bac53aa7db$var$Recoil_TreeCache.TreeCache;
var $1ee798bac53aa7db$var$Recoil_TreeCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TreeCache: $1ee798bac53aa7db$var$Recoil_TreeCache_1
});
class $1ee798bac53aa7db$var$LRUCache {
    constructor(options){
        var _options$mapKey;
        $1ee798bac53aa7db$var$_defineProperty(this, "_maxSize", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_size", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_head", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_tail", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_map", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_keyMapper", void 0);
        this._maxSize = options.maxSize;
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    head() {
        return this._head;
    }
    tail() {
        return this._tail;
    }
    size() {
        return this._size;
    }
    maxSize() {
        return this._maxSize;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        const mappedKey = this._keyMapper(key);
        const node = this._map.get(mappedKey);
        if (!node) return undefined;
        this.set(key, node.value);
        return node.value;
    }
    set(key, val) {
        const mappedKey = this._keyMapper(key);
        const existingNode = this._map.get(mappedKey);
        if (existingNode) this.delete(key);
        const head = this.head();
        const node = {
            key: key,
            right: head,
            left: null,
            value: val
        };
        if (head) head.left = node;
        else this._tail = node;
        this._map.set(mappedKey, node);
        this._head = node;
        this._size++;
        this._maybeDeleteLRU();
    }
    _maybeDeleteLRU() {
        if (this.size() > this.maxSize()) this.deleteLru();
    }
    deleteLru() {
        const tail = this.tail();
        if (tail) this.delete(tail.key);
    }
    delete(key) {
        const mappedKey = this._keyMapper(key);
        if (!this._size || !this._map.has(mappedKey)) return;
        const node = $1ee798bac53aa7db$var$Recoil_nullthrows(this._map.get(mappedKey));
        const right = node.right;
        const left = node.left;
        if (right) right.left = node.left;
        if (left) left.right = node.right;
        if (node === this.head()) this._head = right;
        if (node === this.tail()) this._tail = left;
        this._map.delete(mappedKey);
        this._size--;
    }
    clear() {
        this._size = 0;
        this._head = null;
        this._tail = null;
        this._map = new Map();
    }
}
var $1ee798bac53aa7db$var$Recoil_LRUCache = {
    LRUCache: $1ee798bac53aa7db$var$LRUCache
};
var $1ee798bac53aa7db$var$Recoil_LRUCache_1 = $1ee798bac53aa7db$var$Recoil_LRUCache.LRUCache;
var $1ee798bac53aa7db$var$Recoil_LRUCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    LRUCache: $1ee798bac53aa7db$var$Recoil_LRUCache_1
});
const { LRUCache: $1ee798bac53aa7db$var$LRUCache$1 } = $1ee798bac53aa7db$var$Recoil_LRUCache$1;
const { TreeCache: $1ee798bac53aa7db$var$TreeCache$1 } = $1ee798bac53aa7db$var$Recoil_TreeCache$1;
function $1ee798bac53aa7db$var$treeCacheLRU({ name: name, maxSize: maxSize, mapNodeValue: mapNodeValue = (v)=>v }) {
    const lruCache = new $1ee798bac53aa7db$var$LRUCache$1({
        maxSize: maxSize
    });
    const cache = new $1ee798bac53aa7db$var$TreeCache$1({
        name: name,
        mapNodeValue: mapNodeValue,
        onHit: (node)=>{
            lruCache.set(node, true);
        },
        onSet: (node)=>{
            const lruNode = lruCache.tail();
            lruCache.set(node, true);
            if (lruNode && cache.size() > maxSize) // $FlowFixMe[incompatible-call]
            cache.delete(lruNode.key);
        }
    });
    return cache;
}
var $1ee798bac53aa7db$var$Recoil_treeCacheLRU = $1ee798bac53aa7db$var$treeCacheLRU;
const $1ee798bac53aa7db$var$TIME_WARNING_THRESHOLD_MS = 15;
function $1ee798bac53aa7db$var$stringify(x, opt, key) {
    // A optimization to avoid the more expensive JSON.stringify() for simple strings
    // This may lose protection for u2028 and u2029, though.
    if (typeof x === "string" && !x.includes('"') && !x.includes("\\")) return `"${x}"`;
     // Handle primitive types
    switch(typeof x){
        case "undefined":
            return "";
        // JSON.stringify(undefined) returns undefined, but we always want to return a string
        case "boolean":
            return x ? "true" : "false";
        case "number":
        case "symbol":
            // case 'bigint': // BigInt is not supported in www
            return String(x);
        case "string":
            // Add surrounding quotes and escape internal quotes
            return JSON.stringify(x);
        case "function":
            if ((opt === null || opt === void 0 ? void 0 : opt.allowFunctions) !== true) throw $1ee798bac53aa7db$var$Recoil_err("Attempt to serialize function in a Recoil cache key");
            return `__FUNCTION(${x.name})__`;
    }
    if (x === null) return "null";
     // Fallback case for unknown types
    if (typeof x !== "object") {
        var _JSON$stringify;
        return (_JSON$stringify = JSON.stringify(x)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : "";
    } // Deal with all promises as equivalent for now.
    if ($1ee798bac53aa7db$var$Recoil_isPromise(x)) return "__PROMISE__";
     // Arrays handle recursive stringification
    if (Array.isArray(x)) // $FlowFixMe[missing-local-annot]
    return `[${x.map((v, i)=>$1ee798bac53aa7db$var$stringify(v, opt, i.toString()))}]`;
     // If an object defines a toJSON() method, then use that to override the
    // serialization.  This matches the behavior of JSON.stringify().
    // Pass the key for compatibility.
    // Immutable.js collections define this method to allow us to serialize them.
    if (typeof x.toJSON === "function") // flowlint-next-line unclear-type: off
    return $1ee798bac53aa7db$var$stringify(x.toJSON(key), opt, key);
     // For built-in Maps, sort the keys in a stable order instead of the
    // default insertion order.  Support non-string keys.
    if (x instanceof Map) {
        const obj = {};
        for (const [k, v] of x)// Stringify will escape any nested quotes
        obj[typeof k === "string" ? k : $1ee798bac53aa7db$var$stringify(k, opt)] = v;
        return $1ee798bac53aa7db$var$stringify(obj, opt, key);
    } // For built-in Sets, sort the keys in a stable order instead of the
    // default insertion order.
    if (x instanceof Set) return $1ee798bac53aa7db$var$stringify(Array.from(x).sort((a, b)=>$1ee798bac53aa7db$var$stringify(a, opt).localeCompare($1ee798bac53aa7db$var$stringify(b, opt))), opt, key);
     // Anything else that is iterable serialize as an Array.
    if (Symbol !== undefined && x[Symbol.iterator] != null && typeof x[Symbol.iterator] === "function") // flowlint-next-line unclear-type: off
    return $1ee798bac53aa7db$var$stringify(Array.from(x), opt, key);
     // For all other Objects, sort the keys in a stable order.
    return `{${Object.keys(x).filter((k)=>x[k] !== undefined).sort() // stringify the key to add quotes and escape any nested slashes or quotes.
    .map((k)=>`${$1ee798bac53aa7db$var$stringify(k, opt)}:${$1ee798bac53aa7db$var$stringify(x[k], opt, k)}`).join(",")}}`;
} // Utility similar to JSON.stringify() except:
// * Serialize built-in Sets as an Array
// * Serialize built-in Maps as an Object.  Supports non-string keys.
// * Serialize other iterables as arrays
// * Sort the keys of Objects and Maps to have a stable order based on string conversion.
//    This overrides their default insertion order.
// * Still uses toJSON() of any object to override serialization
// * Support Symbols (though don't guarantee uniqueness)
// * We could support BigInt, but Flow doesn't seem to like it.
// See Recoil_stableStringify-test.js for examples
function $1ee798bac53aa7db$var$stableStringify(x, opt = {
    allowFunctions: false
}) {
    return $1ee798bac53aa7db$var$stringify(x, opt);
}
var $1ee798bac53aa7db$var$Recoil_stableStringify = $1ee798bac53aa7db$var$stableStringify;
const { TreeCache: $1ee798bac53aa7db$var$TreeCache$2 } = $1ee798bac53aa7db$var$Recoil_TreeCache$1;
const $1ee798bac53aa7db$var$defaultPolicy = {
    equality: "reference",
    eviction: "keep-all",
    maxSize: Infinity
};
function $1ee798bac53aa7db$var$treeCacheFromPolicy({ equality: equality = $1ee798bac53aa7db$var$defaultPolicy.equality, eviction: eviction = $1ee798bac53aa7db$var$defaultPolicy.eviction, maxSize: maxSize = $1ee798bac53aa7db$var$defaultPolicy.maxSize } = $1ee798bac53aa7db$var$defaultPolicy, name) {
    const valueMapper = $1ee798bac53aa7db$var$getValueMapper(equality);
    return $1ee798bac53aa7db$var$getTreeCache(eviction, maxSize, valueMapper, name);
}
function $1ee798bac53aa7db$var$getValueMapper(equality) {
    switch(equality){
        case "reference":
            return (val)=>val;
        case "value":
            return (val)=>$1ee798bac53aa7db$var$Recoil_stableStringify(val);
    }
    throw $1ee798bac53aa7db$var$Recoil_err(`Unrecognized equality policy ${equality}`);
}
function $1ee798bac53aa7db$var$getTreeCache(eviction, maxSize, mapNodeValue, name) {
    switch(eviction){
        case "keep-all":
            return new $1ee798bac53aa7db$var$TreeCache$2({
                name: name,
                mapNodeValue: mapNodeValue
            });
        case "lru":
            return $1ee798bac53aa7db$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: $1ee798bac53aa7db$var$Recoil_nullthrows(maxSize),
                mapNodeValue: mapNodeValue
            });
        case "most-recent":
            return $1ee798bac53aa7db$var$Recoil_treeCacheLRU({
                name: name,
                maxSize: 1,
                mapNodeValue: mapNodeValue
            });
    }
    throw $1ee798bac53aa7db$var$Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var $1ee798bac53aa7db$var$Recoil_treeCacheFromPolicy = $1ee798bac53aa7db$var$treeCacheFromPolicy;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$isNode(object) {
    var _ownerDocument, _doc$defaultView;
    if (typeof window === "undefined") return false;
    const doc = object != null ? (_ownerDocument = object.ownerDocument) !== null && _ownerDocument !== void 0 ? _ownerDocument : object : document;
    const defaultView = (_doc$defaultView = doc.defaultView) !== null && _doc$defaultView !== void 0 ? _doc$defaultView : window;
    return !!(object != null && (typeof defaultView.Node === "function" ? object instanceof defaultView.Node : typeof object === "object" && typeof object.nodeType === "number" && typeof object.nodeName === "string"));
}
var $1ee798bac53aa7db$var$Recoil_isNode = $1ee798bac53aa7db$var$isNode;
const { isReactNative: $1ee798bac53aa7db$var$isReactNative$1, isWindow: $1ee798bac53aa7db$var$isWindow$1 } = $1ee798bac53aa7db$var$Recoil_Environment;
function $1ee798bac53aa7db$var$shouldNotBeFrozen(value) {
    // Primitives and functions:
    if (value === null || typeof value !== "object") return true;
     // React elements:
    switch(typeof value.$$typeof){
        case "symbol":
            return true;
        case "number":
            return true;
    } // Immutable structures:
    if (value["@@__IMMUTABLE_ITERABLE__@@"] != null || value["@@__IMMUTABLE_KEYED__@@"] != null || value["@@__IMMUTABLE_INDEXED__@@"] != null || value["@@__IMMUTABLE_ORDERED__@@"] != null || value["@@__IMMUTABLE_RECORD__@@"] != null) return true;
     // DOM nodes:
    if ($1ee798bac53aa7db$var$Recoil_isNode(value)) return true;
    if ($1ee798bac53aa7db$var$Recoil_isPromise(value)) return true;
    if (value instanceof Error) return true;
    if (ArrayBuffer.isView(value)) return true;
     // Some environments, just as Jest, don't work with the instanceof check
    if (!$1ee798bac53aa7db$var$isReactNative$1 && $1ee798bac53aa7db$var$isWindow$1(value)) return true;
    return false;
} // Recursively freeze a value to enforce it is read-only.
// This may also have minimal performance improvements for enumerating
// objects (based on browser implementations, of course)
function $1ee798bac53aa7db$var$deepFreezeValue(value) {
    if (typeof value !== "object" || $1ee798bac53aa7db$var$shouldNotBeFrozen(value)) return;
    Object.freeze(value); // Make all properties read-only
    for(const key in value)// $FlowIssue[method-unbinding] added when improving typing for this parameters
    if (Object.prototype.hasOwnProperty.call(value, key)) {
        const prop = value[key]; // Prevent infinite recurssion for circular references.
        if (typeof prop === "object" && prop != null && !Object.isFrozen(prop)) $1ee798bac53aa7db$var$deepFreezeValue(prop);
    }
    Object.seal(value); // This also makes existing properties non-configurable.
}
var $1ee798bac53aa7db$var$Recoil_deepFreezeValue = $1ee798bac53aa7db$var$deepFreezeValue;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * This is a stub for some integration into FB internal stuff
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$startPerfBlock(_id) {
    return ()=>null;
}
var $1ee798bac53aa7db$var$Recoil_PerformanceTimings = {
    startPerfBlock: $1ee798bac53aa7db$var$startPerfBlock
};
const { isLoadable: $1ee798bac53aa7db$var$isLoadable$1, loadableWithError: $1ee798bac53aa7db$var$loadableWithError$1, loadableWithPromise: $1ee798bac53aa7db$var$loadableWithPromise$1, loadableWithValue: $1ee798bac53aa7db$var$loadableWithValue$2 } = $1ee798bac53aa7db$var$Recoil_Loadable$1;
const { WrappedValue: $1ee798bac53aa7db$var$WrappedValue$1 } = $1ee798bac53aa7db$var$Recoil_Wrapper$1;
const { getNodeLoadable: $1ee798bac53aa7db$var$getNodeLoadable$2, peekNodeLoadable: $1ee798bac53aa7db$var$peekNodeLoadable$1, setNodeValue: $1ee798bac53aa7db$var$setNodeValue$3 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { saveDepsToStore: $1ee798bac53aa7db$var$saveDepsToStore$1 } = $1ee798bac53aa7db$var$Recoil_Graph;
const { DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE$6, getConfigDeletionHandler: $1ee798bac53aa7db$var$getConfigDeletionHandler$1, getNode: $1ee798bac53aa7db$var$getNode$6, registerNode: $1ee798bac53aa7db$var$registerNode$1 } = $1ee798bac53aa7db$var$Recoil_Node;
const { isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue$3 } = $1ee798bac53aa7db$var$Recoil_RecoilValue$1;
const { markRecoilValueModified: $1ee798bac53aa7db$var$markRecoilValueModified$1 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: $1ee798bac53aa7db$var$retainedByOptionWithDefault$1 } = $1ee798bac53aa7db$var$Recoil_Retention;
const { recoilCallback: $1ee798bac53aa7db$var$recoilCallback$1 } = $1ee798bac53aa7db$var$Recoil_useRecoilCallback;
const { startPerfBlock: $1ee798bac53aa7db$var$startPerfBlock$1 } = $1ee798bac53aa7db$var$Recoil_PerformanceTimings;
class $1ee798bac53aa7db$var$Canceled {
}
const $1ee798bac53aa7db$var$CANCELED = new $1ee798bac53aa7db$var$Canceled();
/**
 * An ExecutionID is an arbitrary ID that lets us distinguish executions from
 * each other. This is necessary as we need a way of solving this problem:
 * "given 3 async executions, only update state for the 'latest' execution when
 * it finishes running regardless of when the other 2 finish". ExecutionIDs
 * provide a convenient way of identifying executions so that we can track and
 * manage them over time.
 */ const $1ee798bac53aa7db$var$dependencyStack = []; // for detecting circular dependencies.
const $1ee798bac53aa7db$var$waitingStores = new Map();
const $1ee798bac53aa7db$var$getNewExecutionID = (()=>{
    let executionID = 0;
    return ()=>executionID++;
})();
/* eslint-disable no-redeclare */ function $1ee798bac53aa7db$var$selector(options) {
    let recoilValue = null;
    const { key: key, get: get, cachePolicy_UNSTABLE: cachePolicy } = options;
    const set = options.set != null ? options.set : undefined; // flow
    const discoveredDependencyNodeKeys = new Set();
    const cache = $1ee798bac53aa7db$var$Recoil_treeCacheFromPolicy(cachePolicy !== null && cachePolicy !== void 0 ? cachePolicy : {
        equality: "reference",
        eviction: "keep-all"
    }, key);
    const retainedBy = $1ee798bac53aa7db$var$retainedByOptionWithDefault$1(options.retainedBy_UNSTABLE);
    const executionInfoMap = new Map();
    let liveStoresCount = 0;
    function selectorIsLive() {
        return !$1ee798bac53aa7db$var$Recoil_gkx("recoil_memory_managament_2020") || liveStoresCount > 0;
    }
    function selectorInit(store) {
        store.getState().knownSelectors.add(key);
        liveStoresCount++;
        return ()=>{
            liveStoresCount--;
        };
    }
    function selectorShouldDeleteConfigOnRelease() {
        return $1ee798bac53aa7db$var$getConfigDeletionHandler$1(key) !== undefined && !selectorIsLive();
    }
    function resolveAsync(store, state, executionID, loadable, depValues) {
        setCache(state, loadable, depValues);
        notifyStoresOfResolvedAsync(store, executionID);
    }
    function notifyStoresOfResolvedAsync(store, executionID) {
        if (isLatestExecution(store, executionID)) clearExecutionInfo(store);
        notifyWaitingStores(executionID, true);
    }
    /**
   * Notify stores to pull the selector again if a new async dep was discovered.
   * 1) Async selector adds a new dep but doesn't resolve yet.
   *    Note that deps for an async selector are based on the state when the
   *    evaluation started, in order to provide a consistent picture of state.
   * 2) But, new value of dep based on the current state might cause the selector
   *    to resolve or resolve differently.
   * 3) Therefore, this notification will pull the selector based on the current
   *    state for the components
   */ function notifyStoresOfNewAsyncDep(store, executionID) {
        if (isLatestExecution(store, executionID)) {
            const executionInfo = $1ee798bac53aa7db$var$Recoil_nullthrows(getExecutionInfo(store));
            executionInfo.stateVersions.clear();
            notifyWaitingStores(executionID, false);
        }
    }
    function notifyWaitingStores(executionID, clearWaitlist) {
        const stores = $1ee798bac53aa7db$var$waitingStores.get(executionID);
        if (stores != null) {
            for (const waitingStore of stores)$1ee798bac53aa7db$var$markRecoilValueModified$1(waitingStore, $1ee798bac53aa7db$var$Recoil_nullthrows(recoilValue));
            if (clearWaitlist) $1ee798bac53aa7db$var$waitingStores.delete(executionID);
        }
    }
    function markStoreWaitingForResolvedAsync(store, executionID) {
        let stores = $1ee798bac53aa7db$var$waitingStores.get(executionID);
        if (stores == null) $1ee798bac53aa7db$var$waitingStores.set(executionID, stores = new Set());
        stores.add(store);
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * returned from a selector's get() (either explicitly or implicitly by
   * running a function that uses the "async" keyword). If a selector's get()
   * returns a promise, we have two possibilities:
   *
   * 1. The promise will resolve, in which case it will have completely finished
   *    executing without any remaining pending dependencies. No more retries
   *    are needed and we can proceed with updating the cache and notifying
   *    subscribers (if it is the latest execution, otherwise only the cache
   *    will be updated and subscriptions will not be fired). This is the case
   *    handled by the attached then() handler.
   *
   * 2. The promise will throw because it either has an error or it came across
   *    an async dependency that has not yet resolved, in which case we will
   *    call wrapDepdencyPromise(), whose responsibility is to handle dependency
   *    promises. This case is handled by the attached catch() handler.
   *
   * Both branches will eventually resolve to the final result of the selector
   * (or an error if a real error occurred).
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was thrown--AKA a
   * dependency promise. Dependency promises should be passed to
   * wrapPendingDependencyPromise()).
   */ function wrapResultPromise(store, promise, state, depValues, executionID, loadingDepsState) {
        return promise.then((value)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $1ee798bac53aa7db$var$CANCELED;
            }
            const loadable = $1ee798bac53aa7db$var$loadableWithValue$2(value);
            resolveAsync(store, state, executionID, loadable, depValues);
            return value;
        }).catch((errorOrPromise)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $1ee798bac53aa7db$var$CANCELED;
            }
            if ($1ee798bac53aa7db$var$Recoil_isPromise(errorOrPromise)) return wrapPendingDependencyPromise(store, errorOrPromise, state, depValues, executionID, loadingDepsState);
            const loadable = $1ee798bac53aa7db$var$loadableWithError$1(errorOrPromise);
            resolveAsync(store, state, executionID, loadable, depValues);
            throw errorOrPromise;
        });
    }
    /**
   * This function attaches a then() and a catch() to a promise that was
   * thrown from a selector's get(). If a selector's get() throws a promise,
   * we have two possibilities:
   *
   * 1. The promise will resolve, meaning one of our selector's dependencies is
   *    now available and we should "retry" our get() by running it again. This
   *    is the case handled by the attached then() handler.
   *
   * 2. The promise will throw because something went wrong with the dependency
   *    promise (in other words a real error occurred). This case is handled by
   *    the attached catch() handler. If the dependency promise throws, it is
   *    _always_ a real error and not another dependency promise (any dependency
   *    promises would have been handled upstream).
   *
   * The then() branch will eventually resolve to the final result of the
   * selector (or an error if a real error occurs), and the catch() will always
   * resolve to an error because the dependency promise is a promise that was
   * wrapped upstream, meaning it will only resolve to its real value or to a
   * real error.
   *
   * The execution will run to completion even if it is stale, and its value
   * will be cached. But stale executions will not update global state or update
   * executionInfo as that is the responsibility of the 'latest' execution.
   *
   * Note this function should not be passed a promise that was returned from
   * get(). The intention is that this function is only passed promises that
   * were thrown due to a pending dependency. Promises returned by get() should
   * be passed to wrapResultPromise() instead.
   */ function wrapPendingDependencyPromise(store, promise, state, existingDeps, executionID, loadingDepsState) {
        return promise.then((resolvedDep)=>{
            if (!selectorIsLive()) {
                // The selector was released since the request began; ignore the response.
                clearExecutionInfo(store);
                throw $1ee798bac53aa7db$var$CANCELED;
            } // Check if we are handling a pending Recoil dependency or if the user
            // threw their own Promise to "suspend" a selector evaluation.  We need
            // to check that the loadingDepPromise actually matches the promise that
            // we caught in case the selector happened to catch the promise we threw
            // for a pending Recoil dependency from `getRecoilValue()` and threw
            // their own promise instead.
            if (loadingDepsState.loadingDepKey != null && loadingDepsState.loadingDepPromise === promise) /**
         * Note for async atoms, this means we are changing the atom's value
         * in the store for the given version. This should be alright because
         * the version of state is now stale and a new version will have
         * already been triggered by the atom being resolved (see this logic
         * in Recoil_atom.js)
         */ state.atomValues.set(loadingDepsState.loadingDepKey, $1ee798bac53aa7db$var$loadableWithValue$2(resolvedDep));
            else /**
         * If resolvedDepKey is not defined, the promise was a user-thrown
         * promise. User-thrown promises are an advanced feature and they
         * should be avoided in almost all cases. Using `loadable.map()` inside
         * of selectors for loading loadables and then throwing that mapped
         * loadable's promise is an example of a user-thrown promise.
         *
         * When we hit a user-thrown promise, we have to bail out of an optimization
         * where we bypass calculating selector cache keys for selectors that
         * have been previously seen for a given state (these selectors are saved in
         * state.atomValues) to avoid stale state as we have no way of knowing
         * what state changes happened (if any) in result to the promise resolving.
         *
         * Ideally we would only bail out selectors that are in the chain of
         * dependencies for this selector, but there's currently no way to get
         * a full list of a selector's downstream nodes because the state that
         * is executing may be a discarded tree (so store.getGraph(state.version)
         * will be empty), and the full dep tree may not be in the selector
         * caches in the case where the selector's cache was cleared. To solve
         * for this we would have to keep track of all running selector
         * executions and their downstream deps. Because this only covers edge
         * cases, that complexity might not be justifyable.
         */ store.getState().knownSelectors.forEach((nodeKey)=>{
                state.atomValues.delete(nodeKey);
            });
            /**
       * Optimization: Now that the dependency has resolved, let's try hitting
       * the cache in case the dep resolved to a value we have previously seen.
       *
       * TODO:
       * Note this optimization is not perfect because it only prevents re-executions
       * _after_ the point where an async dependency is found. Any code leading
       * up to the async dependency may have run unnecessarily. The ideal case
       * would be to wait for the async dependency to resolve first, check the
       * cache, and prevent _any_ execution of the selector if the resulting
       * value of the dependency leads to a path that is found in the cache.
       * The ideal case is more difficult to implement as it would require that
       * we capture and wait for the the async dependency right after checking
       * the cache. The current approach takes advantage of the fact that running
       * the selector already has a code path that lets us exit early when
       * an async dep resolves.
       */ const cachedLoadable = getLoadableFromCacheAndUpdateDeps(store, state);
            if (cachedLoadable && cachedLoadable.state !== "loading") {
                /**
         * This has to notify stores of a resolved async, even if there is no
         * current pending execution for the following case:
         * 1) A component renders with this pending loadable.
         * 2) The upstream dependency resolves.
         * 3) While processing some other selector it reads this one, such as
         *    while traversing its dependencies.  At this point it gets the
         *    new resolved value synchronously and clears the current
         *    execution ID.  The component wasn't getting the value itself,
         *    though, so it still has the pending loadable.
         * 4) When this code executes the current execution id was cleared
         *    and it wouldn't notify the component of the new value.
         *
         * I think this is only an issue with "early" rendering since the
         * components got their value using the in-progress execution.
         * We don't have a unit test for this case yet.  I'm not sure it is
         * necessary with recoil_transition_support mode.
         */ if (isLatestExecution(store, executionID) || getExecutionInfo(store) == null) notifyStoresOfResolvedAsync(store, executionID);
                if (cachedLoadable.state === "hasValue") return cachedLoadable.contents;
                else throw cachedLoadable.contents;
            }
            /**
       * If this execution is stale, let's check to see if there is some in
       * progress execution with a matching state. If we find a match, then
       * we can take the value from that in-progress execution. Note this may
       * sound like an edge case, but may be very common in cases where a
       * loading dependency resolves from loading to having a value (thus
       * possibly triggering a re-render), and React re-renders before the
       * chained .then() functions run, thus starting a new execution as the
       * dep has changed value. Without this check we will run the selector
       * twice (once in the new execution and once again in this .then(), so
       * this check is necessary to keep unnecessary re-executions to a
       * minimum).
       *
       * Also note this code does not check across all executions that may be
       * running. It only optimizes for the _latest_ execution per store as
       * we currently do not maintain a list of all currently running executions.
       * This means in some cases we may run selectors more than strictly
       * necessary when there are multiple executions running for the same
       * selector. This may be a valid tradeoff as checking for dep changes
       * across all in-progress executions may take longer than just
       * re-running the selector. This will be app-dependent, and maybe in the
       * future we can make the behavior configurable. An ideal fix may be
       * to extend the tree cache to support caching loading states.
       */ if (!isLatestExecution(store, executionID)) {
                const executionInfo = getInProgressExecutionInfo(store, state);
                if (executionInfo != null) /**
           * Returning promise here without wrapping as the wrapper logic was
           * already done upstream when this promise was generated.
           */ return executionInfo.loadingLoadable.contents;
            } // Retry the selector evaluation now that the dependency has resolved
            const [loadable, depValues] = evaluateSelectorGetter(store, state, executionID);
            if (loadable.state !== "loading") resolveAsync(store, state, executionID, loadable, depValues);
            if (loadable.state === "hasError") throw loadable.contents;
            return loadable.contents;
        }).catch((error)=>{
            // The selector was released since the request began; ignore the response.
            if (error instanceof $1ee798bac53aa7db$var$Canceled) throw $1ee798bac53aa7db$var$CANCELED;
            if (!selectorIsLive()) {
                clearExecutionInfo(store);
                throw $1ee798bac53aa7db$var$CANCELED;
            }
            const loadable = $1ee798bac53aa7db$var$loadableWithError$1(error);
            resolveAsync(store, state, executionID, loadable, existingDeps);
            throw error;
        });
    }
    function updateDeps(store, state, deps, executionID) {
        var _store$getState, _store$getState$curre, _store$getState2, _store$getState2$next;
        if (isLatestExecution(store, executionID) || state.version === ((_store$getState = store.getState()) === null || _store$getState === void 0 ? void 0 : (_store$getState$curre = _store$getState.currentTree) === null || _store$getState$curre === void 0 ? void 0 : _store$getState$curre.version) || state.version === ((_store$getState2 = store.getState()) === null || _store$getState2 === void 0 ? void 0 : (_store$getState2$next = _store$getState2.nextTree) === null || _store$getState2$next === void 0 ? void 0 : _store$getState2$next.version)) {
            var _store$getState$nextT, _store$getState3, _store$getState3$next;
            $1ee798bac53aa7db$var$saveDepsToStore$1(key, deps, store, (_store$getState$nextT = (_store$getState3 = store.getState()) === null || _store$getState3 === void 0 ? void 0 : (_store$getState3$next = _store$getState3.nextTree) === null || _store$getState3$next === void 0 ? void 0 : _store$getState3$next.version) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree.version);
        }
        for (const nodeKey of deps)discoveredDependencyNodeKeys.add(nodeKey);
    }
    function evaluateSelectorGetter(store, state, executionID) {
        const endPerfBlock = $1ee798bac53aa7db$var$startPerfBlock$1(key); // TODO T63965866: use execution ID here
        let duringSynchronousExecution = true;
        let duringAsynchronousExecution = true;
        const finishEvaluation = ()=>{
            endPerfBlock();
            duringAsynchronousExecution = false;
        };
        let result;
        let resultIsError = false;
        let loadable;
        const loadingDepsState = {
            loadingDepKey: null,
            loadingDepPromise: null
        };
        /**
     * Starting a fresh set of deps that we'll be using to update state. We're
     * starting a new set versus adding it in existing state deps because
     * the version of state that we update deps for may be a more recent version
     * than the version the selector was called with. This is because the latest
     * execution will update the deps of the current/latest version of state
     * (This is safe to do because the fact that the selector is the latest
     * execution means the deps we discover below are our best guess at the
     * deps for the current/latest state in the store)
     */ const depValues = new Map();
        function getRecoilValue({ key: depKey }) {
            const depLoadable = $1ee798bac53aa7db$var$getNodeLoadable$2(store, state, depKey);
            depValues.set(depKey, depLoadable); // We need to update asynchronous dependencies as we go so the selector
            // knows if it has to restart evaluation if one of them is updated before
            // the asynchronous selector completely resolves.
            if (!duringSynchronousExecution) {
                updateDeps(store, state, new Set(depValues.keys()), executionID);
                notifyStoresOfNewAsyncDep(store, executionID);
            }
            switch(depLoadable.state){
                case "hasValue":
                    return depLoadable.contents;
                case "hasError":
                    throw depLoadable.contents;
                case "loading":
                    loadingDepsState.loadingDepKey = depKey;
                    loadingDepsState.loadingDepPromise = depLoadable.contents;
                    throw depLoadable.contents;
            }
            throw $1ee798bac53aa7db$var$Recoil_err("Invalid Loadable state");
        }
        const getCallback = (fn)=>{
            return (...args)=>{
                if (duringAsynchronousExecution) throw $1ee798bac53aa7db$var$Recoil_err("Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.");
                !(recoilValue != null) && $1ee798bac53aa7db$var$Recoil_invariant(false);
                return $1ee798bac53aa7db$var$recoilCallback$1(store, fn, args, {
                    node: recoilValue
                } // flowlint-line unclear-type:off
                );
            };
        };
        try {
            result = get({
                get: getRecoilValue,
                getCallback: getCallback
            });
            result = $1ee798bac53aa7db$var$isRecoilValue$3(result) ? getRecoilValue(result) : result;
            if ($1ee798bac53aa7db$var$isLoadable$1(result)) {
                if (result.state === "hasError") resultIsError = true;
                result = result.contents;
            }
            if ($1ee798bac53aa7db$var$Recoil_isPromise(result)) result = wrapResultPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else finishEvaluation();
            result = result instanceof $1ee798bac53aa7db$var$WrappedValue$1 ? result.value : result;
        } catch (errorOrDepPromise) {
            result = errorOrDepPromise;
            if ($1ee798bac53aa7db$var$Recoil_isPromise(result)) result = wrapPendingDependencyPromise(store, result, state, depValues, executionID, loadingDepsState).finally(finishEvaluation);
            else {
                resultIsError = true;
                finishEvaluation();
            }
        }
        if (resultIsError) loadable = $1ee798bac53aa7db$var$loadableWithError$1(result);
        else if ($1ee798bac53aa7db$var$Recoil_isPromise(result)) loadable = $1ee798bac53aa7db$var$loadableWithPromise$1(result);
        else loadable = $1ee798bac53aa7db$var$loadableWithValue$2(result);
        duringSynchronousExecution = false;
        updateExecutionInfoDepValues(store, executionID, depValues);
        updateDeps(store, state, new Set(depValues.keys()), executionID);
        return [
            loadable,
            depValues
        ];
    }
    function getLoadableFromCacheAndUpdateDeps(store, state) {
        // First, look up in the state cache
        // If it's here, then the deps in the store should already be valid.
        let cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
         // Second, look up in the selector cache and update the deps in the store
        const depsAfterCacheLookup = new Set();
        try {
            cachedLoadable = cache.get((nodeKey)=>{
                !(typeof nodeKey === "string") && $1ee798bac53aa7db$var$Recoil_invariant(false);
                return $1ee798bac53aa7db$var$getNodeLoadable$2(store, state, nodeKey).contents;
            }, {
                onNodeVisit: (node)=>{
                    if (node.type === "branch" && node.nodeKey !== key) depsAfterCacheLookup.add(node.nodeKey);
                }
            });
        } catch (error) {
            throw $1ee798bac53aa7db$var$Recoil_err(`Problem with cache lookup for selector "${key}": ${error.message}`);
        }
        if (cachedLoadable) {
            var _getExecutionInfo;
            // Cache the results in the state to allow for cheaper lookup than
            // iterating the tree cache of dependencies.
            state.atomValues.set(key, cachedLoadable);
            /**
       * Ensure store contains correct dependencies if we hit the cache so that
       * the store deps and cache are in sync for a given state. This is important
       * because store deps are normally updated when new executions are created,
       * but cache hits don't trigger new executions but they still _may_ signify
       * a change in deps in the store if the store deps for this state are empty
       * or stale.
       */ updateDeps(store, state, depsAfterCacheLookup, (_getExecutionInfo = getExecutionInfo(store)) === null || _getExecutionInfo === void 0 ? void 0 : _getExecutionInfo.executionID);
        }
        return cachedLoadable;
    }
    /**
   * Given a tree state, this function returns a Loadable of the current state.
   *
   * The selector's get() function will only be re-evaluated if _both_ of the
   * following statements are true:
   *
   * 1. The current dep values from the given state produced a cache key that
   *    was not found in the cache.
   * 2. There is no currently running async execution OR there is an
   *    async execution that is running, but after comparing the dep values in
   *    the given state with the dep values that the execution has discovered so
   *    far we find that at least one dep value has changed, in which case we
   *    start a new execution (the previously running execution will continue to
   *    run to completion, but only the new execution will be deemed the
   *    'latest' execution, meaning it will be the only execution that will
   *    update global state when it is finished. Any non-latest executions will
   *    run to completion and update the selector cache but not global state).
   */ function getSelectorLoadableAndUpdateDeps(store, state) {
        // First, see if our current state is cached
        const cachedVal = getLoadableFromCacheAndUpdateDeps(store, state);
        if (cachedVal != null) {
            clearExecutionInfo(store);
            return cachedVal;
        } // Second, check if there is already an ongoing execution based on the current state
        const inProgressExecutionInfo = getInProgressExecutionInfo(store, state);
        if (inProgressExecutionInfo != null) {
            var _inProgressExecutionI;
            if (((_inProgressExecutionI = inProgressExecutionInfo.loadingLoadable) === null || _inProgressExecutionI === void 0 ? void 0 : _inProgressExecutionI.state) === "loading") markStoreWaitingForResolvedAsync(store, inProgressExecutionInfo.executionID);
             // FIXME: check after the fact to see if we made the right choice by waiting
            return inProgressExecutionInfo.loadingLoadable;
        } // Third, start a new evaluation of the selector
        const newExecutionID = $1ee798bac53aa7db$var$getNewExecutionID();
        const [loadable, newDepValues] = evaluateSelectorGetter(store, state, newExecutionID);
        /**
     * Conditionally updates the cache with a given loadable.
     *
     * We only cache loadables that are not loading because our cache keys are
     * based on dep values, which are in an unfinished state for loadables that
     * have a 'loading' state (new deps may be discovered while the selector
     * runs its async code). We never want to cache partial dependencies b/c it
     * could lead to errors, such as prematurely returning the result based on a
     * partial list of deps-- we need the full list of deps to ensure that we
     * are returning the correct result from cache.
     */ if (loadable.state === "loading") {
            setExecutionInfo(store, newExecutionID, loadable, newDepValues, state);
            markStoreWaitingForResolvedAsync(store, newExecutionID);
        } else {
            clearExecutionInfo(store);
            setCache(state, loadable, newDepValues);
        }
        return loadable;
    }
    /**
   * Searches execution info across all stores to see if there is an in-progress
   * execution whose dependency values match the values of the requesting store.
   */ function getInProgressExecutionInfo(store, state) {
        // Sort the pending executions so that our current store is checked first.
        const pendingExecutions = $1ee798bac53aa7db$var$Recoil_concatIterables([
            executionInfoMap.has(store) ? [
                $1ee798bac53aa7db$var$Recoil_nullthrows(executionInfoMap.get(store))
            ] : [],
            $1ee798bac53aa7db$var$Recoil_mapIterable($1ee798bac53aa7db$var$Recoil_filterIterable(executionInfoMap, ([s])=>s !== store), ([, execInfo])=>execInfo)
        ]);
        function anyDepChanged(execDepValues) {
            for (const [depKey, execLoadable] of execDepValues){
                if (!$1ee798bac53aa7db$var$getNodeLoadable$2(store, state, depKey).is(execLoadable)) return true;
            }
            return false;
        }
        for (const execInfo of pendingExecutions)if (// of state, then let's use it!
        execInfo.stateVersions.get(state.version) || // If the deps for the execution match our current state, then it's valid
        !anyDepChanged(execInfo.depValuesDiscoveredSoFarDuringAsyncWork)) {
            execInfo.stateVersions.set(state.version, true);
            return execInfo;
        } else execInfo.stateVersions.set(state.version, false);
        return undefined;
    }
    function getExecutionInfo(store) {
        return executionInfoMap.get(store);
    }
    /**
   * This function will update the selector's execution info when the selector
   * has either finished running an execution or has started a new execution. If
   * the given loadable is in a 'loading' state, the intention is that a new
   * execution has started. Otherwise, the intention is that an execution has
   * just finished.
   */ function setExecutionInfo(store, newExecutionID, loadable, depValues, state) {
        executionInfoMap.set(store, {
            depValuesDiscoveredSoFarDuringAsyncWork: depValues,
            executionID: newExecutionID,
            loadingLoadable: loadable,
            stateVersions: new Map([
                [
                    state.version,
                    true
                ]
            ])
        });
    }
    function updateExecutionInfoDepValues(store, executionID, depValues) {
        // We only need to bother updating the deps for the latest execution because
        // that's all getInProgressExecutionInfo() will be looking for.
        if (isLatestExecution(store, executionID)) {
            const executionInfo = getExecutionInfo(store);
            if (executionInfo != null) executionInfo.depValuesDiscoveredSoFarDuringAsyncWork = depValues;
        }
    }
    function clearExecutionInfo(store) {
        executionInfoMap.delete(store);
    }
    function isLatestExecution(store, executionID) {
        var _getExecutionInfo2;
        return executionID === ((_getExecutionInfo2 = getExecutionInfo(store)) === null || _getExecutionInfo2 === void 0 ? void 0 : _getExecutionInfo2.executionID);
    }
    /**
   * FIXME: dep keys should take into account the state of the loadable to
   * prevent the edge case where a loadable with an error and a loadable with
   * an error as a value are treated as the same thing incorrectly. For example
   * these two should be treated differently:
   *
   * selector({key: '', get: () => new Error('hi')});
   * selector({key: '', get () => {throw new Error('hi')}});
   *
   * With current implementation they are treated the same
   */ function depValuesToDepRoute(depValues) {
        return Array.from(depValues.entries()).map(([depKey, valLoadable])=>[
                depKey,
                valLoadable.contents
            ]);
    }
    function setCache(state, loadable, depValues) {
        state.atomValues.set(key, loadable);
        try {
            cache.set(depValuesToDepRoute(depValues), loadable);
        } catch (error) {
            throw $1ee798bac53aa7db$var$Recoil_err(`Problem with setting cache for selector "${key}": ${error.message}`);
        }
    }
    function detectCircularDependencies(fn) {
        if ($1ee798bac53aa7db$var$dependencyStack.includes(key)) {
            const message = `Recoil selector has circular dependencies: ${$1ee798bac53aa7db$var$dependencyStack.slice($1ee798bac53aa7db$var$dependencyStack.indexOf(key)).join(" → ")}`;
            return $1ee798bac53aa7db$var$loadableWithError$1($1ee798bac53aa7db$var$Recoil_err(message));
        }
        $1ee798bac53aa7db$var$dependencyStack.push(key);
        try {
            return fn();
        } finally{
            $1ee798bac53aa7db$var$dependencyStack.pop();
        }
    }
    function selectorPeek(store, state) {
        const cachedLoadable = state.atomValues.get(key);
        if (cachedLoadable != null) return cachedLoadable;
        return cache.get((nodeKey)=>{
            var _peekNodeLoadable;
            !(typeof nodeKey === "string") && $1ee798bac53aa7db$var$Recoil_invariant(false);
            return (_peekNodeLoadable = $1ee798bac53aa7db$var$peekNodeLoadable$1(store, state, nodeKey)) === null || _peekNodeLoadable === void 0 ? void 0 : _peekNodeLoadable.contents;
        });
    }
    function selectorGet(store, state) {
        return detectCircularDependencies(()=>getSelectorLoadableAndUpdateDeps(store, state));
    }
    function invalidateSelector(state) {
        state.atomValues.delete(key);
    }
    function clearSelectorCache(store, treeState) {
        !(recoilValue != null) && $1ee798bac53aa7db$var$Recoil_invariant(false);
        for (const nodeKey of discoveredDependencyNodeKeys){
            var _node$clearCache;
            const node = $1ee798bac53aa7db$var$getNode$6(nodeKey);
            (_node$clearCache = node.clearCache) === null || _node$clearCache === void 0 || _node$clearCache.call(node, store, treeState);
        }
        discoveredDependencyNodeKeys.clear();
        invalidateSelector(treeState);
        cache.clear();
        $1ee798bac53aa7db$var$markRecoilValueModified$1(store, recoilValue);
    }
    if (set != null) {
        /**
     * ES5 strict mode prohibits defining non-top-level function declarations,
     * so don't use function declaration syntax here
     */ const selectorSet = (store, state, newValue)=>{
            let syncSelectorSetFinished = false;
            const writes = new Map();
            function getRecoilValue({ key: depKey }) {
                if (syncSelectorSetFinished) throw $1ee798bac53aa7db$var$Recoil_err("Recoil: Async selector sets are not currently supported.");
                const loadable = $1ee798bac53aa7db$var$getNodeLoadable$2(store, state, depKey);
                if (loadable.state === "hasValue") return loadable.contents;
                else if (loadable.state === "loading") {
                    const msg = `Getting value of asynchronous atom or selector "${depKey}" in a pending state while setting selector "${key}" is not yet supported.`;
                    $1ee798bac53aa7db$var$Recoil_recoverableViolation(msg);
                    throw $1ee798bac53aa7db$var$Recoil_err(msg);
                } else throw loadable.contents;
            }
            function setRecoilState(recoilState, valueOrUpdater // $FlowFixMe[missing-local-annot]
            ) {
                if (syncSelectorSetFinished) {
                    const msg = "Recoil: Async selector sets are not currently supported.";
                    $1ee798bac53aa7db$var$Recoil_recoverableViolation(msg);
                    throw $1ee798bac53aa7db$var$Recoil_err(msg);
                }
                const setValue = typeof valueOrUpdater === "function" ? // flowlint-next-line unclear-type:off
                valueOrUpdater(getRecoilValue(recoilState)) : valueOrUpdater;
                const upstreamWrites = $1ee798bac53aa7db$var$setNodeValue$3(store, state, recoilState.key, setValue);
                upstreamWrites.forEach((v, k)=>writes.set(k, v));
            }
            function resetRecoilState(recoilState) {
                setRecoilState(recoilState, $1ee798bac53aa7db$var$DEFAULT_VALUE$6);
            }
            const ret = set({
                set: setRecoilState,
                get: getRecoilValue,
                reset: resetRecoilState
            }, newValue); // set should be a void method, but if the user makes it `async`, then it
            // will return a Promise, which we don't currently support.
            if (ret !== undefined) throw $1ee798bac53aa7db$var$Recoil_isPromise(ret) ? $1ee798bac53aa7db$var$Recoil_err("Recoil: Async selector sets are not currently supported.") : $1ee798bac53aa7db$var$Recoil_err("Recoil: selector set should be a void function.");
            syncSelectorSetFinished = true;
            return writes;
        };
        return recoilValue = $1ee798bac53aa7db$var$registerNode$1({
            key: key,
            nodeType: "selector",
            peek: selectorPeek,
            get: selectorGet,
            set: selectorSet,
            init: selectorInit,
            invalidate: invalidateSelector,
            clearCache: clearSelectorCache,
            shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            shouldRestoreFromSnapshots: false,
            retainedBy: retainedBy
        });
    } else return recoilValue = $1ee798bac53aa7db$var$registerNode$1({
        key: key,
        nodeType: "selector",
        peek: selectorPeek,
        get: selectorGet,
        init: selectorInit,
        invalidate: invalidateSelector,
        clearCache: clearSelectorCache,
        shouldDeleteConfigOnRelease: selectorShouldDeleteConfigOnRelease,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        shouldRestoreFromSnapshots: false,
        retainedBy: retainedBy
    });
}
/* eslint-enable no-redeclare */ // $FlowIssue[incompatible-use]
// $FlowFixMe[missing-local-annot]
$1ee798bac53aa7db$var$selector.value = (value)=>new $1ee798bac53aa7db$var$WrappedValue$1(value);
var $1ee798bac53aa7db$var$Recoil_selector = $1ee798bac53aa7db$var$selector;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
// @fb-only: const {scopedAtom} = require('Recoil_ScopedAtom');
const { isLoadable: $1ee798bac53aa7db$var$isLoadable$2, loadableWithError: $1ee798bac53aa7db$var$loadableWithError$2, loadableWithPromise: $1ee798bac53aa7db$var$loadableWithPromise$2, loadableWithValue: $1ee798bac53aa7db$var$loadableWithValue$3 } = $1ee798bac53aa7db$var$Recoil_Loadable$1;
const { WrappedValue: $1ee798bac53aa7db$var$WrappedValue$2 } = $1ee798bac53aa7db$var$Recoil_Wrapper$1;
const { peekNodeInfo: $1ee798bac53aa7db$var$peekNodeInfo$3 } = $1ee798bac53aa7db$var$Recoil_FunctionalCore;
const { DEFAULT_VALUE: $1ee798bac53aa7db$var$DEFAULT_VALUE$7, DefaultValue: $1ee798bac53aa7db$var$DefaultValue$2, getConfigDeletionHandler: $1ee798bac53aa7db$var$getConfigDeletionHandler$2, registerNode: $1ee798bac53aa7db$var$registerNode$2, setConfigDeletionHandler: $1ee798bac53aa7db$var$setConfigDeletionHandler$1 } = $1ee798bac53aa7db$var$Recoil_Node;
const { isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue$4 } = $1ee798bac53aa7db$var$Recoil_RecoilValue$1;
const { getRecoilValueAsLoadable: $1ee798bac53aa7db$var$getRecoilValueAsLoadable$4, markRecoilValueModified: $1ee798bac53aa7db$var$markRecoilValueModified$2, setRecoilValue: $1ee798bac53aa7db$var$setRecoilValue$4, setRecoilValueLoadable: $1ee798bac53aa7db$var$setRecoilValueLoadable$2 } = $1ee798bac53aa7db$var$Recoil_RecoilValueInterface;
const { retainedByOptionWithDefault: $1ee798bac53aa7db$var$retainedByOptionWithDefault$2 } = $1ee798bac53aa7db$var$Recoil_Retention;
const $1ee798bac53aa7db$var$unwrap = (x)=>x instanceof $1ee798bac53aa7db$var$WrappedValue$2 ? x.value : x;
function $1ee798bac53aa7db$var$baseAtom(options) {
    const { key: key, persistence_UNSTABLE: persistence } = options;
    const retainedBy = $1ee798bac53aa7db$var$retainedByOptionWithDefault$2(options.retainedBy_UNSTABLE);
    let liveStoresCount = 0;
    function unwrapPromise(promise) {
        return $1ee798bac53aa7db$var$loadableWithPromise$2(promise.then((value)=>{
            defaultLoadable = $1ee798bac53aa7db$var$loadableWithValue$3(value);
            return value;
        }).catch((error)=>{
            defaultLoadable = $1ee798bac53aa7db$var$loadableWithError$2(error);
            throw error;
        }));
    }
    let defaultLoadable = $1ee798bac53aa7db$var$Recoil_isPromise(options.default) ? unwrapPromise(options.default) : $1ee798bac53aa7db$var$isLoadable$2(options.default) ? options.default.state === "loading" ? unwrapPromise(options.default.contents) : options.default : $1ee798bac53aa7db$var$loadableWithValue$3($1ee798bac53aa7db$var$unwrap(options.default));
    maybeFreezeValueOrPromise(defaultLoadable.contents);
    let cachedAnswerForUnvalidatedValue = undefined; // Cleanup handlers for this atom
    // Rely on stable reference equality of the store to use it as a key per <RecoilRoot>
    const cleanupEffectsByStore = new Map();
    function maybeFreezeValueOrPromise(valueOrPromise) {
        var value;
        return valueOrPromise;
    }
    function wrapPendingPromise(store, promise) {
        const wrappedPromise = promise.then((value)=>{
            var _store$getState$nextT, _state$atomValues$get;
            const state = (_store$getState$nextT = store.getState().nextTree) !== null && _store$getState$nextT !== void 0 ? _store$getState$nextT : store.getState().currentTree;
            if (((_state$atomValues$get = state.atomValues.get(key)) === null || _state$atomValues$get === void 0 ? void 0 : _state$atomValues$get.contents) === wrappedPromise) $1ee798bac53aa7db$var$setRecoilValue$4(store, node, value);
            return value;
        }).catch((error)=>{
            var _store$getState$nextT2, _state$atomValues$get2;
            const state = (_store$getState$nextT2 = store.getState().nextTree) !== null && _store$getState$nextT2 !== void 0 ? _store$getState$nextT2 : store.getState().currentTree;
            if (((_state$atomValues$get2 = state.atomValues.get(key)) === null || _state$atomValues$get2 === void 0 ? void 0 : _state$atomValues$get2.contents) === wrappedPromise) $1ee798bac53aa7db$var$setRecoilValueLoadable$2(store, node, $1ee798bac53aa7db$var$loadableWithError$2(error));
            throw error;
        });
        return wrappedPromise;
    }
    function initAtom(store, initState, trigger) {
        var _options$effects;
        liveStoresCount++;
        const cleanupAtom = ()=>{
            var _cleanupEffectsByStor;
            liveStoresCount--;
            (_cleanupEffectsByStor = cleanupEffectsByStore.get(store)) === null || _cleanupEffectsByStor === void 0 || _cleanupEffectsByStor.forEach((cleanup)=>cleanup());
            cleanupEffectsByStore.delete(store);
        };
        store.getState().knownAtoms.add(key); // Setup async defaults to notify subscribers when they resolve
        if (defaultLoadable.state === "loading") {
            const notifyDefaultSubscribers = ()=>{
                var _store$getState$nextT3;
                const state = (_store$getState$nextT3 = store.getState().nextTree) !== null && _store$getState$nextT3 !== void 0 ? _store$getState$nextT3 : store.getState().currentTree;
                if (!state.atomValues.has(key)) $1ee798bac53aa7db$var$markRecoilValueModified$2(store, node);
            };
            defaultLoadable.contents.finally(notifyDefaultSubscribers);
        } ///////////////////
        // Run Atom Effects
        ///////////////////
        const effects = (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE;
        if (effects != null) {
            // This state is scoped by Store, since this is in the initAtom() closure
            let initValue = $1ee798bac53aa7db$var$DEFAULT_VALUE$7;
            let isDuringInit = true;
            let isInitError = false;
            let pendingSetSelf = null;
            function getLoadable(recoilValue) {
                // Normally we can just get the current value of another atom.
                // But for our own value we need to check if there is a pending
                // initialized value or get the fallback default value.
                if (isDuringInit && recoilValue.key === key) {
                    // Cast T to S
                    const retValue = initValue; // flowlint-line unclear-type:off
                    return retValue instanceof $1ee798bac53aa7db$var$DefaultValue$2 ? peekAtom(store, initState) // flowlint-line unclear-type:off
                     : $1ee798bac53aa7db$var$Recoil_isPromise(retValue) ? $1ee798bac53aa7db$var$loadableWithPromise$2(retValue.then((v)=>v instanceof $1ee798bac53aa7db$var$DefaultValue$2 ? defaultLoadable.toPromise() // flowlint-line unclear-type:off
                         : v)) : $1ee798bac53aa7db$var$loadableWithValue$3(retValue);
                }
                return $1ee798bac53aa7db$var$getRecoilValueAsLoadable$4(store, recoilValue);
            }
            function getPromise(recoilValue) {
                return getLoadable(recoilValue).toPromise();
            }
            function getInfo_UNSTABLE(recoilValue) {
                var _store$getState$nextT4;
                const info = $1ee798bac53aa7db$var$peekNodeInfo$3(store, (_store$getState$nextT4 = store.getState().nextTree) !== null && _store$getState$nextT4 !== void 0 ? _store$getState$nextT4 : store.getState().currentTree, recoilValue.key);
                return isDuringInit && recoilValue.key === key && !(initValue instanceof $1ee798bac53aa7db$var$DefaultValue$2) ? {
                    ...info,
                    isSet: true,
                    loadable: getLoadable(recoilValue)
                } : info;
            }
            const setSelf = (effect)=>(valueOrUpdater)=>{
                    if (isDuringInit) {
                        const currentLoadable = getLoadable(node);
                        const currentValue = currentLoadable.state === "hasValue" ? currentLoadable.contents : $1ee798bac53aa7db$var$DEFAULT_VALUE$7;
                        initValue = typeof valueOrUpdater === "function" ? valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                         : valueOrUpdater;
                        if ($1ee798bac53aa7db$var$Recoil_isPromise(initValue)) initValue = initValue.then((value)=>{
                            // Avoid calling onSet() when setSelf() initializes with a Promise
                            pendingSetSelf = {
                                effect: effect,
                                value: value
                            };
                            return value;
                        });
                    } else {
                        if ($1ee798bac53aa7db$var$Recoil_isPromise(valueOrUpdater)) throw $1ee798bac53aa7db$var$Recoil_err("Setting atoms to async values is not implemented.");
                        if (typeof valueOrUpdater !== "function") pendingSetSelf = {
                            effect: effect,
                            value: $1ee798bac53aa7db$var$unwrap(valueOrUpdater)
                        };
                        $1ee798bac53aa7db$var$setRecoilValue$4(store, node, typeof valueOrUpdater === "function" ? (currentValue)=>{
                            const newValue = $1ee798bac53aa7db$var$unwrap(valueOrUpdater(currentValue) // flowlint-line unclear-type:off
                            ); // $FlowFixMe[incompatible-type]
                            pendingSetSelf = {
                                effect: effect,
                                value: newValue
                            };
                            return newValue;
                        } : $1ee798bac53aa7db$var$unwrap(valueOrUpdater));
                    }
                };
            const resetSelf = (effect)=>()=>setSelf(effect)($1ee798bac53aa7db$var$DEFAULT_VALUE$7);
            const onSet = (effect)=>(handler)=>{
                    var _cleanupEffectsByStor2;
                    const { release: release } = store.subscribeToTransactions((currentStore)=>{
                        var _currentTree$atomValu;
                        // eslint-disable-next-line prefer-const
                        let { currentTree: currentTree, previousTree: previousTree } = currentStore.getState();
                        if (!previousTree) {
                            $1ee798bac53aa7db$var$Recoil_recoverableViolation("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil");
                            previousTree = currentTree; // attempt to trundle on
                        }
                        const newLoadable = (_currentTree$atomValu = currentTree.atomValues.get(key)) !== null && _currentTree$atomValu !== void 0 ? _currentTree$atomValu : defaultLoadable;
                        if (newLoadable.state === "hasValue") {
                            var _previousTree$atomVal, _pendingSetSelf, _pendingSetSelf2, _pendingSetSelf3;
                            const newValue = newLoadable.contents;
                            const oldLoadable = (_previousTree$atomVal = previousTree.atomValues.get(key)) !== null && _previousTree$atomVal !== void 0 ? _previousTree$atomVal : defaultLoadable;
                            const oldValue = oldLoadable.state === "hasValue" ? oldLoadable.contents : $1ee798bac53aa7db$var$DEFAULT_VALUE$7; // TODO This isn't actually valid, use as a placeholder for now.
                            // Ignore atom value changes that were set via setSelf() in the same effect.
                            // We will still properly call the handler if there was a subsequent
                            // set from something other than an atom effect which was batched
                            // with the `setSelf()` call.  However, we may incorrectly ignore
                            // the handler if the subsequent batched call happens to set the
                            // atom to the exact same value as the `setSelf()`.   But, in that
                            // case, it was kind of a noop, so the semantics are debatable..
                            if (((_pendingSetSelf = pendingSetSelf) === null || _pendingSetSelf === void 0 ? void 0 : _pendingSetSelf.effect) !== effect || ((_pendingSetSelf2 = pendingSetSelf) === null || _pendingSetSelf2 === void 0 ? void 0 : _pendingSetSelf2.value) !== newValue) handler(newValue, oldValue, !currentTree.atomValues.has(key));
                            else if (((_pendingSetSelf3 = pendingSetSelf) === null || _pendingSetSelf3 === void 0 ? void 0 : _pendingSetSelf3.effect) === effect) pendingSetSelf = null;
                        }
                    }, key);
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor2 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor2 !== void 0 ? _cleanupEffectsByStor2 : [],
                        release
                    ]);
                };
            for (const effect of effects)try {
                const cleanup = effect({
                    node: node,
                    storeID: store.storeID,
                    parentStoreID_UNSTABLE: store.parentStoreID,
                    trigger: trigger,
                    setSelf: setSelf(effect),
                    resetSelf: resetSelf(effect),
                    onSet: onSet(effect),
                    getPromise: getPromise,
                    getLoadable: getLoadable,
                    getInfo_UNSTABLE: getInfo_UNSTABLE
                });
                if (cleanup != null) {
                    var _cleanupEffectsByStor3;
                    cleanupEffectsByStore.set(store, [
                        ...(_cleanupEffectsByStor3 = cleanupEffectsByStore.get(store)) !== null && _cleanupEffectsByStor3 !== void 0 ? _cleanupEffectsByStor3 : [],
                        cleanup
                    ]);
                }
            } catch (error) {
                initValue = error;
                isInitError = true;
            }
            isDuringInit = false; // Mutate initial state in place since we know there are no other subscribers
            // since we are the ones initializing on first use.
            if (!(initValue instanceof $1ee798bac53aa7db$var$DefaultValue$2)) {
                var _store$getState$nextT5;
                const initLoadable = isInitError ? $1ee798bac53aa7db$var$loadableWithError$2(initValue) : $1ee798bac53aa7db$var$Recoil_isPromise(initValue) ? $1ee798bac53aa7db$var$loadableWithPromise$2(wrapPendingPromise(store, initValue)) : $1ee798bac53aa7db$var$loadableWithValue$3($1ee798bac53aa7db$var$unwrap(initValue));
                maybeFreezeValueOrPromise(initLoadable.contents);
                initState.atomValues.set(key, initLoadable); // If there is a pending transaction, then also mutate the next state tree.
                // This could happen if the atom was first initialized in an action that
                // also updated some other atom's state.
                (_store$getState$nextT5 = store.getState().nextTree) === null || _store$getState$nextT5 === void 0 || _store$getState$nextT5.atomValues.set(key, initLoadable);
            }
        }
        return cleanupAtom;
    }
    function peekAtom(_store, state) {
        var _ref, _state$atomValues$get3;
        return (_ref = (_state$atomValues$get3 = state.atomValues.get(key)) !== null && _state$atomValues$get3 !== void 0 ? _state$atomValues$get3 : cachedAnswerForUnvalidatedValue) !== null && _ref !== void 0 ? _ref : defaultLoadable;
    }
    function getAtom(_store, state) {
        if (state.atomValues.has(key)) // Atom value is stored in state:
        return $1ee798bac53aa7db$var$Recoil_nullthrows(state.atomValues.get(key));
        else if (state.nonvalidatedAtoms.has(key)) {
            // Atom value is stored but needs validation before use.
            // We might have already validated it and have a cached validated value:
            if (cachedAnswerForUnvalidatedValue != null) return cachedAnswerForUnvalidatedValue;
            if (persistence == null) {
                $1ee798bac53aa7db$var$Recoil_expectationViolation(`Tried to restore a persisted value for atom ${key} but it has no persistence settings.`);
                return defaultLoadable;
            }
            const nonvalidatedValue = state.nonvalidatedAtoms.get(key);
            const validatorResult = persistence.validator(nonvalidatedValue, $1ee798bac53aa7db$var$DEFAULT_VALUE$7);
            const validatedValueLoadable = validatorResult instanceof $1ee798bac53aa7db$var$DefaultValue$2 ? defaultLoadable : $1ee798bac53aa7db$var$loadableWithValue$3(validatorResult);
            cachedAnswerForUnvalidatedValue = validatedValueLoadable;
            return cachedAnswerForUnvalidatedValue;
        } else return defaultLoadable;
    }
    function invalidateAtom() {
        cachedAnswerForUnvalidatedValue = undefined;
    }
    function setAtom(_store, state, newValue) {
        // Bail out if we're being set to the existing value, or if we're being
        // reset but have no stored value (validated or unvalidated) to reset from:
        if (state.atomValues.has(key)) {
            const existing = $1ee798bac53aa7db$var$Recoil_nullthrows(state.atomValues.get(key));
            if (existing.state === "hasValue" && newValue === existing.contents) return new Map();
        } else if (!state.nonvalidatedAtoms.has(key) && newValue instanceof $1ee798bac53aa7db$var$DefaultValue$2) return new Map();
        maybeFreezeValueOrPromise(newValue);
        cachedAnswerForUnvalidatedValue = undefined; // can be released now if it was previously in use
        return new Map().set(key, $1ee798bac53aa7db$var$loadableWithValue$3(newValue));
    }
    function shouldDeleteConfigOnReleaseAtom() {
        return $1ee798bac53aa7db$var$getConfigDeletionHandler$2(key) !== undefined && liveStoresCount <= 0;
    }
    const node = $1ee798bac53aa7db$var$registerNode$2({
        key: key,
        nodeType: "atom",
        peek: peekAtom,
        get: getAtom,
        set: setAtom,
        init: initAtom,
        invalidate: invalidateAtom,
        shouldDeleteConfigOnRelease: shouldDeleteConfigOnReleaseAtom,
        dangerouslyAllowMutability: options.dangerouslyAllowMutability,
        persistence_UNSTABLE: options.persistence_UNSTABLE ? {
            type: options.persistence_UNSTABLE.type,
            backButton: options.persistence_UNSTABLE.backButton
        } : undefined,
        shouldRestoreFromSnapshots: true,
        retainedBy: retainedBy
    });
    return node;
} // prettier-ignore
function $1ee798bac53aa7db$var$atom(options) {
    const { ...restOptions } = options;
    const optionsDefault = "default" in options ? options.default : new Promise(()=>{});
    if ($1ee798bac53aa7db$var$isRecoilValue$4(optionsDefault) // Continue to use atomWithFallback for promise defaults for scoped atoms
    ) return $1ee798bac53aa7db$var$atomWithFallback({
        ...restOptions,
        default: optionsDefault // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    }); // @fb-only: } else if (scopeRules_APPEND_ONLY_READ_THE_DOCS
    else return $1ee798bac53aa7db$var$baseAtom({
        ...restOptions,
        default: optionsDefault
    });
}
function $1ee798bac53aa7db$var$atomWithFallback(options) {
    const base = $1ee798bac53aa7db$var$atom({
        ...options,
        default: $1ee798bac53aa7db$var$DEFAULT_VALUE$7,
        persistence_UNSTABLE: options.persistence_UNSTABLE === undefined ? undefined : {
            ...options.persistence_UNSTABLE,
            validator: (storedValue)=>storedValue instanceof $1ee798bac53aa7db$var$DefaultValue$2 ? storedValue : $1ee798bac53aa7db$var$Recoil_nullthrows(options.persistence_UNSTABLE).validator(storedValue, $1ee798bac53aa7db$var$DEFAULT_VALUE$7)
        },
        // TODO Hack for now.
        effects: options.effects,
        // flowlint-line unclear-type: off
        effects_UNSTABLE: options.effects_UNSTABLE // flowlint-line unclear-type: off
    }); // $FlowFixMe[incompatible-call]
    const sel = $1ee798bac53aa7db$var$Recoil_selector({
        key: `${options.key}__withFallback`,
        get: ({ get: get })=>{
            const baseValue = get(base);
            return baseValue instanceof $1ee798bac53aa7db$var$DefaultValue$2 ? options.default : baseValue;
        },
        // $FlowFixMe[incompatible-call]
        set: ({ set: set }, newValue)=>set(base, newValue),
        // This selector does not need to cache as it is a wrapper selector
        // and the selector within the wrapper selector will have a cache
        // option by default
        cachePolicy_UNSTABLE: {
            eviction: "most-recent"
        },
        dangerouslyAllowMutability: options.dangerouslyAllowMutability
    });
    $1ee798bac53aa7db$var$setConfigDeletionHandler$1(sel.key, $1ee798bac53aa7db$var$getConfigDeletionHandler$2(options.key));
    return sel;
} // $FlowFixMe[missing-local-annot]
$1ee798bac53aa7db$var$atom.value = (value)=>new $1ee798bac53aa7db$var$WrappedValue$2(value);
var $1ee798bac53aa7db$var$Recoil_atom = $1ee798bac53aa7db$var$atom;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall recoil
 */ class $1ee798bac53aa7db$var$MapCache {
    constructor(options){
        var _options$mapKey;
        $1ee798bac53aa7db$var$_defineProperty(this, "_map", void 0);
        $1ee798bac53aa7db$var$_defineProperty(this, "_keyMapper", void 0);
        this._map = new Map();
        this._keyMapper = (_options$mapKey = options === null || options === void 0 ? void 0 : options.mapKey) !== null && _options$mapKey !== void 0 ? _options$mapKey : (v)=>v;
    }
    size() {
        return this._map.size;
    }
    has(key) {
        return this._map.has(this._keyMapper(key));
    }
    get(key) {
        return this._map.get(this._keyMapper(key));
    }
    set(key, val) {
        this._map.set(this._keyMapper(key), val);
    }
    delete(key) {
        this._map.delete(this._keyMapper(key));
    }
    clear() {
        this._map.clear();
    }
}
var $1ee798bac53aa7db$var$Recoil_MapCache = {
    MapCache: $1ee798bac53aa7db$var$MapCache
};
var $1ee798bac53aa7db$var$Recoil_MapCache_1 = $1ee798bac53aa7db$var$Recoil_MapCache.MapCache;
var $1ee798bac53aa7db$var$Recoil_MapCache$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MapCache: $1ee798bac53aa7db$var$Recoil_MapCache_1
});
const { LRUCache: $1ee798bac53aa7db$var$LRUCache$2 } = $1ee798bac53aa7db$var$Recoil_LRUCache$1;
const { MapCache: $1ee798bac53aa7db$var$MapCache$1 } = $1ee798bac53aa7db$var$Recoil_MapCache$1;
const $1ee798bac53aa7db$var$defaultPolicy$1 = {
    equality: "reference",
    eviction: "none",
    maxSize: Infinity
};
function $1ee798bac53aa7db$var$cacheFromPolicy({ equality: equality = $1ee798bac53aa7db$var$defaultPolicy$1.equality, eviction: eviction = $1ee798bac53aa7db$var$defaultPolicy$1.eviction, maxSize: maxSize = $1ee798bac53aa7db$var$defaultPolicy$1.maxSize } = $1ee798bac53aa7db$var$defaultPolicy$1) {
    const valueMapper = $1ee798bac53aa7db$var$getValueMapper$1(equality);
    const cache = $1ee798bac53aa7db$var$getCache(eviction, maxSize, valueMapper);
    return cache;
}
function $1ee798bac53aa7db$var$getValueMapper$1(equality) {
    switch(equality){
        case "reference":
            return (val)=>val;
        case "value":
            return (val)=>$1ee798bac53aa7db$var$Recoil_stableStringify(val);
    }
    throw $1ee798bac53aa7db$var$Recoil_err(`Unrecognized equality policy ${equality}`);
}
function $1ee798bac53aa7db$var$getCache(eviction, maxSize, mapKey) {
    switch(eviction){
        case "keep-all":
            return new $1ee798bac53aa7db$var$MapCache$1({
                mapKey: mapKey
            });
        case "lru":
            return new $1ee798bac53aa7db$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: $1ee798bac53aa7db$var$Recoil_nullthrows(maxSize)
            });
        case "most-recent":
            return new $1ee798bac53aa7db$var$LRUCache$2({
                mapKey: mapKey,
                maxSize: 1
            });
    }
    throw $1ee798bac53aa7db$var$Recoil_err(`Unrecognized eviction policy ${eviction}`);
}
var $1ee798bac53aa7db$var$Recoil_cacheFromPolicy = $1ee798bac53aa7db$var$cacheFromPolicy;
// @fb-only: import type {ScopeRules} from 'Recoil_ScopedAtom';
const { setConfigDeletionHandler: $1ee798bac53aa7db$var$setConfigDeletionHandler$2 } = $1ee798bac53aa7db$var$Recoil_Node;
// Process scopeRules to handle any entries which are functions taking parameters
// prettier-ignore
// @fb-only: function mapScopeRules<P>(
// @fb-only: scopeRules?: ParameterizedScopeRules<P>,
// @fb-only: param: P,
// @fb-only: ): ScopeRules | void {
// @fb-only: return scopeRules?.map(rule =>
// @fb-only: Array.isArray(rule)
// @fb-only: ? rule.map(entry => (typeof entry === 'function' ? entry(param) : entry))
// @fb-only: : rule,
// @fb-only: );
// @fb-only: }
/*
A function which returns an atom based on the input parameter.

Each unique parameter returns a unique atom. E.g.,

  const f = atomFamily(...);
  f({a: 1}) => an atom
  f({a: 2}) => a different atom

This allows components to persist local, private state using atoms.  Each
instance of the component may have a different key, which it uses as the
parameter for a family of atoms; in this way, each component will have
its own atom not shared by other instances.  These state keys may be composed
into children's state keys as well.
*/ function $1ee798bac53aa7db$var$atomFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const atomCache = $1ee798bac53aa7db$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
        eviction: "keep-all"
    }); // Simple atomFamily implementation to cache individual atoms based
    // on the parameter value equality.
    return (params)=>{
        var _stableStringify, _options$effects;
        const cachedAtom = atomCache.get(params);
        if (cachedAtom != null) return cachedAtom;
        const { cachePolicyForParams_UNSTABLE: cachePolicyForParams_UNSTABLE, ...atomOptions } = options;
        const optionsDefault = "default" in options ? options.default : new Promise(()=>{});
        const newAtom = $1ee798bac53aa7db$var$Recoil_atom({
            ...atomOptions,
            key: `${options.key}__${(_stableStringify = $1ee798bac53aa7db$var$Recoil_stableStringify(params)) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}`,
            default: typeof optionsDefault === "function" ? // Flow doesn't know that T isn't a function, so we need to case to any
            // $FlowIssue[incompatible-use]
            optionsDefault(params) : optionsDefault,
            retainedBy_UNSTABLE: typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE,
            effects: typeof options.effects === "function" ? options.effects(params) : typeof options.effects_UNSTABLE === "function" ? options.effects_UNSTABLE(params) : (_options$effects = options.effects) !== null && _options$effects !== void 0 ? _options$effects : options.effects_UNSTABLE // prettier-ignore
        });
        atomCache.set(params, newAtom);
        $1ee798bac53aa7db$var$setConfigDeletionHandler$2(newAtom.key, ()=>{
            atomCache.delete(params);
        });
        return newAtom;
    };
}
var $1ee798bac53aa7db$var$Recoil_atomFamily = $1ee798bac53aa7db$var$atomFamily;
const { setConfigDeletionHandler: $1ee798bac53aa7db$var$setConfigDeletionHandler$3 } = $1ee798bac53aa7db$var$Recoil_Node;
// Keep in mind the parameter needs to be serializable as a cahche key
// using Recoil_stableStringify
// Add a unique index to each selector in case the cache implementation allows
// duplicate keys based on equivalent stringified parameters
let $1ee798bac53aa7db$var$nextIndex = 0;
/* eslint-disable no-redeclare */ // Return a function that returns members of a family of selectors of the same type
// E.g.,
//
// const s = selectorFamily(...);
// s({a: 1}) => a selector
// s({a: 2}) => a different selector
//
// By default, the selectors are distinguished by distinct values of the
// parameter based on value equality, not reference equality.  This allows using
// object literals or other equivalent objects at callsites to not create
// duplicate cache entries.  This behavior may be overridden with the
// cacheImplementationForParams option.
function $1ee798bac53aa7db$var$selectorFamily(options) {
    var _options$cachePolicyF, _options$cachePolicyF2;
    const selectorCache = $1ee798bac53aa7db$var$Recoil_cacheFromPolicy({
        equality: (_options$cachePolicyF = (_options$cachePolicyF2 = options.cachePolicyForParams_UNSTABLE) === null || _options$cachePolicyF2 === void 0 ? void 0 : _options$cachePolicyF2.equality) !== null && _options$cachePolicyF !== void 0 ? _options$cachePolicyF : "value",
        eviction: "keep-all"
    });
    return (params)=>{
        var _stableStringify;
        // Throw an error with selector key so that it is clear which
        // selector is causing an error
        let cachedSelector;
        try {
            cachedSelector = selectorCache.get(params);
        } catch (error) {
            throw $1ee798bac53aa7db$var$Recoil_err(`Problem with cache lookup for selector ${options.key}: ${error.message}`);
        }
        if (cachedSelector != null) return cachedSelector;
        const myKey = `${options.key}__selectorFamily/${(_stableStringify = $1ee798bac53aa7db$var$Recoil_stableStringify(params, {
            // It is possible to use functions in parameters if the user uses
            // a cache with reference equality thanks to the incrementing index.
            allowFunctions: true
        })) !== null && _stableStringify !== void 0 ? _stableStringify : "void"}/${$1ee798bac53aa7db$var$nextIndex++}`; // Append index in case values serialize to the same key string
        const myGet = (callbacks)=>options.get(params)(callbacks);
        const myCachePolicy = options.cachePolicy_UNSTABLE;
        const retainedBy = typeof options.retainedBy_UNSTABLE === "function" ? options.retainedBy_UNSTABLE(params) : options.retainedBy_UNSTABLE;
        let newSelector;
        if (options.set != null) {
            const set = options.set;
            const mySet = (callbacks, newValue)=>set(params)(callbacks, newValue);
            newSelector = $1ee798bac53aa7db$var$Recoil_selector({
                key: myKey,
                get: myGet,
                set: mySet,
                cachePolicy_UNSTABLE: myCachePolicy,
                dangerouslyAllowMutability: options.dangerouslyAllowMutability,
                retainedBy_UNSTABLE: retainedBy
            });
        } else newSelector = $1ee798bac53aa7db$var$Recoil_selector({
            key: myKey,
            get: myGet,
            cachePolicy_UNSTABLE: myCachePolicy,
            dangerouslyAllowMutability: options.dangerouslyAllowMutability,
            retainedBy_UNSTABLE: retainedBy
        });
        selectorCache.set(params, newSelector);
        $1ee798bac53aa7db$var$setConfigDeletionHandler$3(newSelector.key, ()=>{
            selectorCache.delete(params);
        });
        return newSelector;
    };
}
/* eslint-enable no-redeclare */ var $1ee798bac53aa7db$var$Recoil_selectorFamily = $1ee798bac53aa7db$var$selectorFamily;
// flowlint-next-line unclear-type:off
const $1ee798bac53aa7db$var$constantSelector = $1ee798bac53aa7db$var$Recoil_selectorFamily({
    key: "__constant",
    get: (constant)=>()=>constant,
    cachePolicyForParams_UNSTABLE: {
        equality: "reference"
    }
}); // Function that returns a selector which always produces the
// same constant value.  It may be called multiple times with the
// same value, based on reference equality, and will provide the
// same selector.
function $1ee798bac53aa7db$var$constSelector(constant) {
    return $1ee798bac53aa7db$var$constantSelector(constant);
}
var $1ee798bac53aa7db$var$Recoil_constSelector = $1ee798bac53aa7db$var$constSelector;
// flowlint-next-line unclear-type:off
const $1ee798bac53aa7db$var$throwingSelector = $1ee798bac53aa7db$var$Recoil_selectorFamily({
    key: "__error",
    get: (message)=>()=>{
            throw $1ee798bac53aa7db$var$Recoil_err(message);
        },
    // TODO Why?
    cachePolicyForParams_UNSTABLE: {
        equality: "reference"
    }
}); // Function that returns a selector which always throws an error
// with the provided message.
function $1ee798bac53aa7db$var$errorSelector(message) {
    return $1ee798bac53aa7db$var$throwingSelector(message);
}
var $1ee798bac53aa7db$var$Recoil_errorSelector = $1ee798bac53aa7db$var$errorSelector;
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Wraps another recoil value and prevents writing to it.
 *
 * 
 * @format
 * @oncall recoil
 */ function $1ee798bac53aa7db$var$readOnlySelector(atom) {
    // flowlint-next-line unclear-type: off
    return atom;
}
var $1ee798bac53aa7db$var$Recoil_readOnlySelector = $1ee798bac53aa7db$var$readOnlySelector;
const { loadableWithError: $1ee798bac53aa7db$var$loadableWithError$3, loadableWithPromise: $1ee798bac53aa7db$var$loadableWithPromise$3, loadableWithValue: $1ee798bac53aa7db$var$loadableWithValue$4 } = $1ee798bac53aa7db$var$Recoil_Loadable$1;
/////////////////
//  TRUTH TABLE
/////////////////
// Dependencies        waitForNone         waitForAny        waitForAll       waitForAllSettled
//  [loading, loading]  [Promise, Promise]  Promise           Promise         Promise
//  [value, loading]    [value, Promise]    [value, Promise]  Promise         Promise
//  [value, value]      [value, value]      [value, value]    [value, value]  [value, value]
//
//  [error, loading]    [Error, Promise]    [Error, Promise]  Error           Promise
//  [error, error]      [Error, Error]      [Error, Error]    Error           [error, error]
//  [value, error]      [value, Error]      [value, Error]    Error           [value, error]
// Issue parallel requests for all dependencies and return the current
// status if they have results, have some error, or are still pending.
function $1ee798bac53aa7db$var$concurrentRequests(getRecoilValue, deps) {
    const results = Array(deps.length).fill(undefined);
    const exceptions = Array(deps.length).fill(undefined);
    for (const [i, dep] of deps.entries())try {
        results[i] = getRecoilValue(dep);
    } catch (e) {
        // exceptions can either be Promises of pending results or real errors
        exceptions[i] = e;
    }
    return [
        results,
        exceptions
    ];
}
function $1ee798bac53aa7db$var$isError(exp) {
    return exp != null && !$1ee798bac53aa7db$var$Recoil_isPromise(exp);
}
function $1ee798bac53aa7db$var$unwrapDependencies(dependencies) {
    return Array.isArray(dependencies) ? dependencies : Object.getOwnPropertyNames(dependencies).map((key)=>dependencies[key]);
}
function $1ee798bac53aa7db$var$wrapResults(dependencies, /* $FlowFixMe[missing-local-annot] The type annotation(s) required by Flow's
 * LTI update could not be added via codemod */ results) {
    return Array.isArray(dependencies) ? results : Object.getOwnPropertyNames(dependencies).reduce((out, key, idx)=>({
            ...out,
            [key]: results[idx]
        }), {});
}
function $1ee798bac53aa7db$var$wrapLoadables(dependencies, results, exceptions) {
    const output = exceptions.map((exception, idx)=>exception == null ? $1ee798bac53aa7db$var$loadableWithValue$4(results[idx]) : $1ee798bac53aa7db$var$Recoil_isPromise(exception) ? $1ee798bac53aa7db$var$loadableWithPromise$3(exception) : $1ee798bac53aa7db$var$loadableWithError$3(exception));
    return $1ee798bac53aa7db$var$wrapResults(dependencies, output);
}
function $1ee798bac53aa7db$var$combineAsyncResultsWithSyncResults(syncResults, asyncResults) {
    return asyncResults.map((result, idx)=>/**
   * it's important we use === undefined as opposed to == null, because the
   * resolved value of the async promise could be `null`, in which case we
   * don't want to use syncResults[idx], which would be undefined. If async
   * promise resolves to `undefined`, that's ok because `syncResults[idx]`
   * will also be `undefined`. That's a little hacky, but it works.
   */ result === undefined ? syncResults[idx] : result);
} // Selector that requests all dependencies in parallel and immediately returns
// current results without waiting.
const $1ee798bac53aa7db$var$waitForNone = $1ee798bac53aa7db$var$Recoil_selectorFamily({
    key: "__waitForNone",
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            const deps = $1ee798bac53aa7db$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $1ee798bac53aa7db$var$concurrentRequests(get, deps); // Always return the current status of the results; never block.
            return $1ee798bac53aa7db$var$wrapLoadables(dependencies, results, exceptions);
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for at least
// one to be available before returning results.  It will only error if all
// dependencies have errors.
const $1ee798bac53aa7db$var$waitForAny = $1ee798bac53aa7db$var$Recoil_selectorFamily({
    key: "__waitForAny",
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $1ee798bac53aa7db$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $1ee798bac53aa7db$var$concurrentRequests(get, deps); // If any results are available, value or error, return the current status
            if (exceptions.some((exp)=>!$1ee798bac53aa7db$var$Recoil_isPromise(exp))) return $1ee798bac53aa7db$var$wrapLoadables(dependencies, results, exceptions);
             // Otherwise, return a promise that will resolve when the next result is
            // available, whichever one happens to be next.  But, if all pending
            // dependencies end up with errors, then reject the promise.
            return new Promise((resolve)=>{
                for (const [i, exp] of exceptions.entries())if ($1ee798bac53aa7db$var$Recoil_isPromise(exp)) exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                    resolve($1ee798bac53aa7db$var$wrapLoadables(dependencies, results, exceptions));
                }).catch((error)=>{
                    exceptions[i] = error;
                    resolve($1ee798bac53aa7db$var$wrapLoadables(dependencies, results, exceptions));
                });
            });
        },
    dangerouslyAllowMutability: true
}); // Selector that requests all dependencies in parallel and waits for all to be
// available before returning a value.  It will error if any dependencies error.
const $1ee798bac53aa7db$var$waitForAll = $1ee798bac53aa7db$var$Recoil_selectorFamily({
    key: "__waitForAll",
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $1ee798bac53aa7db$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $1ee798bac53aa7db$var$concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>exp == null)) return $1ee798bac53aa7db$var$wrapResults(dependencies, results);
             // If we have any errors, throw the first error
            const error = exceptions.find($1ee798bac53aa7db$var$isError);
            if (error != null) throw error;
             // Otherwise, return a promise that will resolve when all results are available
            return Promise.all(exceptions).then((exceptionResults)=>$1ee798bac53aa7db$var$wrapResults(dependencies, $1ee798bac53aa7db$var$combineAsyncResultsWithSyncResults(results, exceptionResults)));
        },
    dangerouslyAllowMutability: true
});
const $1ee798bac53aa7db$var$waitForAllSettled = $1ee798bac53aa7db$var$Recoil_selectorFamily({
    key: "__waitForAllSettled",
    get: (dependencies)=>({ get: get })=>{
            // Issue requests for all dependencies in parallel.
            // Exceptions can either be Promises of pending results or real errors
            const deps = $1ee798bac53aa7db$var$unwrapDependencies(dependencies);
            const [results, exceptions] = $1ee798bac53aa7db$var$concurrentRequests(get, deps); // If all results are available, return the results
            if (exceptions.every((exp)=>!$1ee798bac53aa7db$var$Recoil_isPromise(exp))) return $1ee798bac53aa7db$var$wrapLoadables(dependencies, results, exceptions);
             // Wait for all results to settle
            return Promise.all(exceptions.map((exp, i)=>$1ee798bac53aa7db$var$Recoil_isPromise(exp) ? exp.then((result)=>{
                    results[i] = result;
                    exceptions[i] = undefined;
                }).catch((error)=>{
                    results[i] = undefined;
                    exceptions[i] = error;
                }) : null)) // Then wrap them as loadables
            .then(()=>$1ee798bac53aa7db$var$wrapLoadables(dependencies, results, exceptions));
        },
    dangerouslyAllowMutability: true
});
const $1ee798bac53aa7db$var$noWait = $1ee798bac53aa7db$var$Recoil_selectorFamily({
    key: "__noWait",
    get: (dependency)=>({ get: get })=>{
            try {
                return $1ee798bac53aa7db$var$Recoil_selector.value($1ee798bac53aa7db$var$loadableWithValue$4(get(dependency)));
            } catch (exception) {
                return $1ee798bac53aa7db$var$Recoil_selector.value($1ee798bac53aa7db$var$Recoil_isPromise(exception) ? $1ee798bac53aa7db$var$loadableWithPromise$3(exception) : $1ee798bac53aa7db$var$loadableWithError$3(exception));
            }
        },
    dangerouslyAllowMutability: true
});
var $1ee798bac53aa7db$var$Recoil_WaitFor = {
    waitForNone: $1ee798bac53aa7db$var$waitForNone,
    waitForAny: $1ee798bac53aa7db$var$waitForAny,
    waitForAll: $1ee798bac53aa7db$var$waitForAll,
    waitForAllSettled: $1ee798bac53aa7db$var$waitForAllSettled,
    noWait: $1ee798bac53aa7db$var$noWait
};
const { RecoilLoadable: $1ee798bac53aa7db$var$RecoilLoadable } = $1ee798bac53aa7db$var$Recoil_Loadable$1;
const { DefaultValue: $1ee798bac53aa7db$var$DefaultValue$3 } = $1ee798bac53aa7db$var$Recoil_Node;
const { RecoilRoot: $1ee798bac53aa7db$var$RecoilRoot$2, useRecoilStoreID: $1ee798bac53aa7db$var$useRecoilStoreID$1 } = $1ee798bac53aa7db$var$Recoil_RecoilRoot;
const { isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue$5 } = $1ee798bac53aa7db$var$Recoil_RecoilValue$1;
const { retentionZone: $1ee798bac53aa7db$var$retentionZone$1 } = $1ee798bac53aa7db$var$Recoil_RetentionZone;
const { freshSnapshot: $1ee798bac53aa7db$var$freshSnapshot$2 } = $1ee798bac53aa7db$var$Recoil_Snapshot$1;
const { useRecoilState: $1ee798bac53aa7db$var$useRecoilState$1, useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1, useRecoilStateLoadable: $1ee798bac53aa7db$var$useRecoilStateLoadable$1, useRecoilValue: $1ee798bac53aa7db$var$useRecoilValue$1, useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1, useRecoilValueLoadable: $1ee798bac53aa7db$var$useRecoilValueLoadable$1, useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1, useResetRecoilState: $1ee798bac53aa7db$var$useResetRecoilState$1, useSetRecoilState: $1ee798bac53aa7db$var$useSetRecoilState$1 } = $1ee798bac53aa7db$var$Recoil_Hooks;
const { useGotoRecoilSnapshot: $1ee798bac53aa7db$var$useGotoRecoilSnapshot$1, useRecoilSnapshot: $1ee798bac53aa7db$var$useRecoilSnapshot$1, useRecoilTransactionObserver: $1ee798bac53aa7db$var$useRecoilTransactionObserver$1 } = $1ee798bac53aa7db$var$Recoil_SnapshotHooks;
const { useRecoilCallback: $1ee798bac53aa7db$var$useRecoilCallback$1 } = $1ee798bac53aa7db$var$Recoil_useRecoilCallback;
const { noWait: $1ee798bac53aa7db$var$noWait$1, waitForAll: $1ee798bac53aa7db$var$waitForAll$1, waitForAllSettled: $1ee798bac53aa7db$var$waitForAllSettled$1, waitForAny: $1ee798bac53aa7db$var$waitForAny$1, waitForNone: $1ee798bac53aa7db$var$waitForNone$1 } = $1ee798bac53aa7db$var$Recoil_WaitFor;
var $1ee798bac53aa7db$var$Recoil_index = {
    // Types
    DefaultValue: $1ee798bac53aa7db$var$DefaultValue$3,
    isRecoilValue: $1ee798bac53aa7db$var$isRecoilValue$5,
    RecoilLoadable: $1ee798bac53aa7db$var$RecoilLoadable,
    // Global Recoil environment settiongs
    RecoilEnv: $1ee798bac53aa7db$var$Recoil_RecoilEnv,
    // Recoil Root
    RecoilRoot: $1ee798bac53aa7db$var$RecoilRoot$2,
    useRecoilStoreID: $1ee798bac53aa7db$var$useRecoilStoreID$1,
    useRecoilBridgeAcrossReactRoots_UNSTABLE: $1ee798bac53aa7db$var$Recoil_useRecoilBridgeAcrossReactRoots,
    // Atoms/Selectors
    atom: $1ee798bac53aa7db$var$Recoil_atom,
    selector: $1ee798bac53aa7db$var$Recoil_selector,
    // Convenience Atoms/Selectors
    atomFamily: $1ee798bac53aa7db$var$Recoil_atomFamily,
    selectorFamily: $1ee798bac53aa7db$var$Recoil_selectorFamily,
    constSelector: $1ee798bac53aa7db$var$Recoil_constSelector,
    errorSelector: $1ee798bac53aa7db$var$Recoil_errorSelector,
    readOnlySelector: $1ee798bac53aa7db$var$Recoil_readOnlySelector,
    // Concurrency Helpers for Atoms/Selectors
    noWait: $1ee798bac53aa7db$var$noWait$1,
    waitForNone: $1ee798bac53aa7db$var$waitForNone$1,
    waitForAny: $1ee798bac53aa7db$var$waitForAny$1,
    waitForAll: $1ee798bac53aa7db$var$waitForAll$1,
    waitForAllSettled: $1ee798bac53aa7db$var$waitForAllSettled$1,
    // Hooks for Atoms/Selectors
    useRecoilValue: $1ee798bac53aa7db$var$useRecoilValue$1,
    useRecoilValueLoadable: $1ee798bac53aa7db$var$useRecoilValueLoadable$1,
    useRecoilState: $1ee798bac53aa7db$var$useRecoilState$1,
    useRecoilStateLoadable: $1ee798bac53aa7db$var$useRecoilStateLoadable$1,
    useSetRecoilState: $1ee798bac53aa7db$var$useSetRecoilState$1,
    useResetRecoilState: $1ee798bac53aa7db$var$useResetRecoilState$1,
    useGetRecoilValueInfo_UNSTABLE: $1ee798bac53aa7db$var$Recoil_useGetRecoilValueInfo,
    useRecoilRefresher_UNSTABLE: $1ee798bac53aa7db$var$Recoil_useRecoilRefresher,
    useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilValue_TRANSITION_SUPPORT_UNSTABLE$1,
    useRecoilState_TRANSITION_SUPPORT_UNSTABLE: $1ee798bac53aa7db$var$useRecoilState_TRANSITION_SUPPORT_UNSTABLE$1,
    // Hooks for complex operations
    useRecoilCallback: $1ee798bac53aa7db$var$useRecoilCallback$1,
    useRecoilTransaction_UNSTABLE: $1ee798bac53aa7db$var$Recoil_useRecoilTransaction,
    // Snapshots
    useGotoRecoilSnapshot: $1ee798bac53aa7db$var$useGotoRecoilSnapshot$1,
    useRecoilSnapshot: $1ee798bac53aa7db$var$useRecoilSnapshot$1,
    useRecoilTransactionObserver_UNSTABLE: $1ee798bac53aa7db$var$useRecoilTransactionObserver$1,
    snapshot_UNSTABLE: $1ee798bac53aa7db$var$freshSnapshot$2,
    // Memory Management
    useRetain: $1ee798bac53aa7db$var$Recoil_useRetain,
    retentionZone: $1ee798bac53aa7db$var$retentionZone$1
};
var $1ee798bac53aa7db$export$a4e369a19907695d = $1ee798bac53aa7db$var$Recoil_index.DefaultValue;
var $1ee798bac53aa7db$export$8e2120adc095590f = $1ee798bac53aa7db$var$Recoil_index.isRecoilValue;
var $1ee798bac53aa7db$export$b04cb8d38132ba6e = $1ee798bac53aa7db$var$Recoil_index.RecoilLoadable;
var $1ee798bac53aa7db$export$b6bd5219181c222b = $1ee798bac53aa7db$var$Recoil_index.RecoilEnv;
var $1ee798bac53aa7db$export$f72b9f9819639629 = $1ee798bac53aa7db$var$Recoil_index.RecoilRoot;
var $1ee798bac53aa7db$export$cb8baa5ebbbeec81 = $1ee798bac53aa7db$var$Recoil_index.useRecoilStoreID;
var $1ee798bac53aa7db$export$a42d8cff2ac8d9e5 = $1ee798bac53aa7db$var$Recoil_index.useRecoilBridgeAcrossReactRoots_UNSTABLE;
var $1ee798bac53aa7db$export$5fb5cc0d078610b = $1ee798bac53aa7db$var$Recoil_index.atom;
var $1ee798bac53aa7db$export$aea217a45095ce11 = $1ee798bac53aa7db$var$Recoil_index.selector;
var $1ee798bac53aa7db$export$98dc87c59e005bfc = $1ee798bac53aa7db$var$Recoil_index.atomFamily;
var $1ee798bac53aa7db$export$62317b671b80c71d = $1ee798bac53aa7db$var$Recoil_index.selectorFamily;
var $1ee798bac53aa7db$export$18e41ac5fdf5533e = $1ee798bac53aa7db$var$Recoil_index.constSelector;
var $1ee798bac53aa7db$export$47aec13333381be0 = $1ee798bac53aa7db$var$Recoil_index.errorSelector;
var $1ee798bac53aa7db$export$11880e5adc5def9 = $1ee798bac53aa7db$var$Recoil_index.readOnlySelector;
var $1ee798bac53aa7db$export$ab07e6aa23cd7e90 = $1ee798bac53aa7db$var$Recoil_index.noWait;
var $1ee798bac53aa7db$export$5c93b0ea2ae8f20b = $1ee798bac53aa7db$var$Recoil_index.waitForNone;
var $1ee798bac53aa7db$export$9ee161e2f87911b5 = $1ee798bac53aa7db$var$Recoil_index.waitForAny;
var $1ee798bac53aa7db$export$4dcf1964c6471cb6 = $1ee798bac53aa7db$var$Recoil_index.waitForAll;
var $1ee798bac53aa7db$export$a82851251af05082 = $1ee798bac53aa7db$var$Recoil_index.waitForAllSettled;
var $1ee798bac53aa7db$export$8b71bf98365f8042 = $1ee798bac53aa7db$var$Recoil_index.useRecoilValue;
var $1ee798bac53aa7db$export$23331814aa7f2650 = $1ee798bac53aa7db$var$Recoil_index.useRecoilValueLoadable;
var $1ee798bac53aa7db$export$12012bbeae92bfa2 = $1ee798bac53aa7db$var$Recoil_index.useRecoilState;
var $1ee798bac53aa7db$export$223ac8c28103fd98 = $1ee798bac53aa7db$var$Recoil_index.useRecoilStateLoadable;
var $1ee798bac53aa7db$export$4102102216e95cfa = $1ee798bac53aa7db$var$Recoil_index.useSetRecoilState;
var $1ee798bac53aa7db$export$75b418d01f19b2e = $1ee798bac53aa7db$var$Recoil_index.useResetRecoilState;
var $1ee798bac53aa7db$export$24dc7ee2767b2f1c = $1ee798bac53aa7db$var$Recoil_index.useGetRecoilValueInfo_UNSTABLE;
var $1ee798bac53aa7db$export$3726f445fa0ad4a7 = $1ee798bac53aa7db$var$Recoil_index.useRecoilRefresher_UNSTABLE;
var $1ee798bac53aa7db$export$c6e9c47eec22eb86 = $1ee798bac53aa7db$var$Recoil_index.useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE;
var $1ee798bac53aa7db$export$435b1bf0f9f79a38 = $1ee798bac53aa7db$var$Recoil_index.useRecoilValue_TRANSITION_SUPPORT_UNSTABLE;
var $1ee798bac53aa7db$export$2df379f232d6fe77 = $1ee798bac53aa7db$var$Recoil_index.useRecoilState_TRANSITION_SUPPORT_UNSTABLE;
var $1ee798bac53aa7db$export$6ef5088871c318c5 = $1ee798bac53aa7db$var$Recoil_index.useRecoilCallback;
var $1ee798bac53aa7db$export$4a76cc788f949bc4 = $1ee798bac53aa7db$var$Recoil_index.useRecoilTransaction_UNSTABLE;
var $1ee798bac53aa7db$export$a7cf2c8ce398f17a = $1ee798bac53aa7db$var$Recoil_index.useGotoRecoilSnapshot;
var $1ee798bac53aa7db$export$7cc4a4decba383e9 = $1ee798bac53aa7db$var$Recoil_index.useRecoilSnapshot;
var $1ee798bac53aa7db$export$924c13ee4d1c0013 = $1ee798bac53aa7db$var$Recoil_index.useRecoilTransactionObserver_UNSTABLE;
var $1ee798bac53aa7db$export$fe4c07befea3edfb = $1ee798bac53aa7db$var$Recoil_index.snapshot_UNSTABLE;
var $1ee798bac53aa7db$export$f9d5dc8f5133b7e8 = $1ee798bac53aa7db$var$Recoil_index.useRetain;
var $1ee798bac53aa7db$export$33ebb0dc02dfd75d = $1ee798bac53aa7db$var$Recoil_index.retentionZone;
var $1ee798bac53aa7db$export$2e2bcd8739ae039 = $1ee798bac53aa7db$var$Recoil_index;



const $a3b3c1bf0fb5d719$export$31499a9cd224b78c = "7.70.0";

var $deac3cf66fc00dd1$exports = {};

$parcel$export($deac3cf66fc00dd1$exports, "FunctionToString", function () { return $e6540cb9950e5925$export$da4704525c20ae79; });
$parcel$export($deac3cf66fc00dd1$exports, "InboundFilters", function () { return $eda692251a2c1f2e$export$2ffbb5359dcc6be4; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $da535ffc958c129e$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$e6127cc7fe7395c3(wat) {
    switch($da535ffc958c129e$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $da535ffc958c129e$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$var$isBuiltin(wat, className) {
    return $da535ffc958c129e$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$9f9636d330b71954(wat) {
    return $da535ffc958c129e$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$ef9e2056653f0c8e(wat) {
    return $da535ffc958c129e$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$12e869b2a583f783(wat) {
    return $da535ffc958c129e$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$844ec244b1367d54(wat) {
    return $da535ffc958c129e$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$53b83ca8eaab0383(wat) {
    return $da535ffc958c129e$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $da535ffc958c129e$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $da535ffc958c129e$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$49841c62b9eff15(wat) {
    return $da535ffc958c129e$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $da535ffc958c129e$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$bc2894c7158efbac(wat) {
    return $da535ffc958c129e$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $da535ffc958c129e$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}



var $j8hA7 = parcelRequire("j8hA7");
// eslint-disable-next-line deprecation/deprecation
const $10b7e35d980736f8$var$WINDOW = (0, $j8hA7.getGlobalObject)();
const $10b7e35d980736f8$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $10b7e35d980736f8$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $10b7e35d980736f8$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $10b7e35d980736f8$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $10b7e35d980736f8$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $da535ffc958c129e$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $10b7e35d980736f8$export$1cfafeee2987818b() {
    try {
        return $10b7e35d980736f8$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $10b7e35d980736f8$export$c660c1f3ab49225c(selector) {
    if ($10b7e35d980736f8$var$WINDOW.document && $10b7e35d980736f8$var$WINDOW.document.querySelector) return $10b7e35d980736f8$var$WINDOW.document.querySelector(selector);
    return null;
}




var $j8hA7 = parcelRequire("j8hA7");
/** Prefix for logging strings */ const $eace895db919f450$var$PREFIX = "Sentry Logger ";
const $eace895db919f450$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $eace895db919f450$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $eace895db919f450$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $j8hA7.GLOBAL_OBJ))) return callback();
    const console = (0, $j8hA7.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($eace895db919f450$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $eace895db919f450$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $eace895db919f450$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) $eace895db919f450$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $eace895db919f450$export$cda52e2a8927a2ca(()=>{
                (0, $j8hA7.GLOBAL_OBJ).console[name](`${$eace895db919f450$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $eace895db919f450$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $eace895db919f450$export$af88d00dbe7f521 = $eace895db919f450$var$makeLogger();



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $07665083d6e876d3$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $07665083d6e876d3$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $07665083d6e876d3$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $da535ffc958c129e$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $07665083d6e876d3$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $da535ffc958c129e$export$844ec244b1367d54)(value)) return false;
    if ((0, $da535ffc958c129e$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $da535ffc958c129e$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $07665083d6e876d3$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$07665083d6e876d3$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $00469dac6edb4ff1$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $00469dac6edb4ff1$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $00469dac6edb4ff1$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $00469dac6edb4ff1$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $00469dac6edb4ff1$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $00469dac6edb4ff1$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $00469dac6edb4ff1$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $00469dac6edb4ff1$export$62ff257738bf57f5(value) {
    if ((0, $da535ffc958c129e$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$00469dac6edb4ff1$var$getOwnProperties(value)
    };
    else if ((0, $da535ffc958c129e$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $00469dac6edb4ff1$var$serializeEventTarget(value.target),
            currentTarget: $00469dac6edb4ff1$var$serializeEventTarget(value.currentTarget),
            ...$00469dac6edb4ff1$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $da535ffc958c129e$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $00469dac6edb4ff1$var$serializeEventTarget(target) {
    try {
        return (0, $da535ffc958c129e$export$45a5e7f76e0caa8d)(target) ? (0, $10b7e35d980736f8$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $00469dac6edb4ff1$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $00469dac6edb4ff1$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($00469dac6edb4ff1$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $07665083d6e876d3$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $07665083d6e876d3$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $00469dac6edb4ff1$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $00469dac6edb4ff1$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $00469dac6edb4ff1$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $da535ffc958c129e$export$53b83ca8eaab0383)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $00469dac6edb4ff1$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($00469dac6edb4ff1$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $00469dac6edb4ff1$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $da535ffc958c129e$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


let $e6540cb9950e5925$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ class $e6540cb9950e5925$export$da4704525c20ae79 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "FunctionToString";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $e6540cb9950e5925$export$da4704525c20ae79.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $e6540cb9950e5925$var$originalFunctionToString = Function.prototype.toString;
        // intrinsics (like Function.prototype) might be immutable in some environments
        // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            Function.prototype.toString = function(...args) {
                const context = (0, $00469dac6edb4ff1$export$e6cc1e135e2092e5)(this) || this;
                return $e6540cb9950e5925$var$originalFunctionToString.apply(context, args);
            };
        } catch (e) {
        // ignore errors here, just don't patch this
        }
    }
}
$e6540cb9950e5925$export$da4704525c20ae79.__initStatic();





var $j8hA7 = parcelRequire("j8hA7");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $6db688138f32ddc5$export$19f53698e68b2496() {
    const gbl = (0, $j8hA7.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>crypto.getRandomValues(new Uint8Array(1))[0];
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $6db688138f32ddc5$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $6db688138f32ddc5$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $6db688138f32ddc5$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $6db688138f32ddc5$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $6db688138f32ddc5$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $6db688138f32ddc5$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $6db688138f32ddc5$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $6db688138f32ddc5$export$d364f2020ab30578(input) {
    const match = input.match($6db688138f32ddc5$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $6db688138f32ddc5$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $07665083d6e876d3$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $07665083d6e876d3$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $07665083d6e876d3$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $6db688138f32ddc5$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $00469dac6edb4ff1$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $6db688138f32ddc5$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $eda692251a2c1f2e$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
const $eda692251a2c1f2e$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*healthcheck.*$/,
    /^.*healthy.*$/,
    /^.*live.*$/,
    /^.*ready.*$/,
    /^.*heartbeat.*$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ /** Inbound filters configurable by the user */ class $eda692251a2c1f2e$export$2ffbb5359dcc6be4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "InboundFilters";
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $eda692251a2c1f2e$export$2ffbb5359dcc6be4.id;
        this._options = options;
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcess = (event)=>{
            const hub = getCurrentHub();
            if (hub) {
                const self = hub.getIntegration($eda692251a2c1f2e$export$2ffbb5359dcc6be4);
                if (self) {
                    const client = hub.getClient();
                    const clientOptions = client ? client.getOptions() : {};
                    const options = $eda692251a2c1f2e$export$6620a151868b99aa(self._options, clientOptions);
                    return $eda692251a2c1f2e$export$3c6361fddf6cd929(event, options) ? null : event;
                }
            }
            return event;
        };
        eventProcess.id = this.name;
        addGlobalEventProcessor(eventProcess);
    }
}
$eda692251a2c1f2e$export$2ffbb5359dcc6be4.__initStatic();
/** JSDoc */ function $eda692251a2c1f2e$export$6620a151868b99aa(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $eda692251a2c1f2e$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $eda692251a2c1f2e$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
/** JSDoc */ function $eda692251a2c1f2e$export$3c6361fddf6cd929(event, options) {
    if (options.ignoreInternal && $eda692251a2c1f2e$var$_isSentryError(event)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $6db688138f32ddc5$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($eda692251a2c1f2e$var$_isIgnoredError(event, options.ignoreErrors)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $6db688138f32ddc5$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($eda692251a2c1f2e$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $6db688138f32ddc5$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($eda692251a2c1f2e$var$_isDeniedUrl(event, options.denyUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $6db688138f32ddc5$export$4157119e2b157127)(event)}.\nUrl: ${$eda692251a2c1f2e$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$eda692251a2c1f2e$var$_isAllowedUrl(event, options.allowUrls)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $6db688138f32ddc5$export$4157119e2b157127)(event)}.\nUrl: ${$eda692251a2c1f2e$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $eda692251a2c1f2e$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $eda692251a2c1f2e$var$_getPossibleEventMessages(event).some((message)=>(0, $07665083d6e876d3$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $eda692251a2c1f2e$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $07665083d6e876d3$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $eda692251a2c1f2e$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $eda692251a2c1f2e$var$_getEventFilterUrl(event);
    return !url ? false : (0, $07665083d6e876d3$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $eda692251a2c1f2e$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $eda692251a2c1f2e$var$_getEventFilterUrl(event);
    return !url ? true : (0, $07665083d6e876d3$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $eda692251a2c1f2e$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && possibleMessages.length === 0) (0, $eace895db919f450$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $6db688138f32ddc5$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $eda692251a2c1f2e$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $eda692251a2c1f2e$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $eda692251a2c1f2e$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $eda692251a2c1f2e$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $6db688138f32ddc5$export$4157119e2b157127)(event)}`);
        return null;
    }
}





var $j8hA7 = parcelRequire("j8hA7");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $c7f04ac6ef2a7863$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($c7f04ac6ef2a7863$var$States || ($c7f04ac6ef2a7863$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa(value) {
    return new $c7f04ac6ef2a7863$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $c7f04ac6ef2a7863$export$78e43115b553f358(reason) {
    return new $c7f04ac6ef2a7863$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $c7f04ac6ef2a7863$export$6f292d4960313241 {
    constructor(executor){
        $c7f04ac6ef2a7863$export$6f292d4960313241.prototype.__init.call(this);
        $c7f04ac6ef2a7863$export$6f292d4960313241.prototype.__init2.call(this);
        $c7f04ac6ef2a7863$export$6f292d4960313241.prototype.__init3.call(this);
        $c7f04ac6ef2a7863$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $c7f04ac6ef2a7863$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $c7f04ac6ef2a7863$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $c7f04ac6ef2a7863$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($c7f04ac6ef2a7863$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($c7f04ac6ef2a7863$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $c7f04ac6ef2a7863$var$States.PENDING) return;
            if ((0, $da535ffc958c129e$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $c7f04ac6ef2a7863$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $c7f04ac6ef2a7863$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $c7f04ac6ef2a7863$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}


/**
 * Returns the global event processors.
 */ function $d89985e59bedb9f9$export$3c4238858b85e8ac() {
    return (0, $j8hA7.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $d89985e59bedb9f9$export$8e4e25f54d456511(callback) {
    $d89985e59bedb9f9$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $d89985e59bedb9f9$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $c7f04ac6ef2a7863$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && processor.id && result === null && (0, $eace895db919f450$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $da535ffc958c129e$export$f5b060c2914b97c8)(result)) result.then((final)=>$d89985e59bedb9f9$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $d89985e59bedb9f9$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



var $1LeEK = parcelRequire("1LeEK");
var $j8hA7 = parcelRequire("j8hA7");
const $0a2b370577402d1c$export$849dbeeeda01ae98 = "production";



var $1LeEK = parcelRequire("1LeEK");


var $1LeEK = parcelRequire("1LeEK");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $457c892d505f39dd$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $1LeEK.timestampInSeconds)();
    const session = {
        sid: (0, $6db688138f32ddc5$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$457c892d505f39dd$var$sessionToJSON(session)
    };
    if (context) $457c892d505f39dd$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $457c892d505f39dd$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $1LeEK.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $6db688138f32ddc5$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $457c892d505f39dd$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $457c892d505f39dd$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $457c892d505f39dd$var$sessionToJSON(session) {
    return (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $920bf7465f79c8a9$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $920bf7465f79c8a9$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $920bf7465f79c8a9$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $920bf7465f79c8a9$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
            newScope._propagationContext = {
                ...scope._propagationContext
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $457c892d505f39dd$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $920bf7465f79c8a9$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $920bf7465f79c8a9$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
            if (captureContext._propagationContext) this._propagationContext = captureContext._propagationContext;
        } else if ((0, $da535ffc958c129e$export$53b83ca8eaab0383)(captureContext)) {
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
            if (captureContext.propagationContext) this._propagationContext = captureContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $920bf7465f79c8a9$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $920bf7465f79c8a9$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $1LeEK.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transaction = this._span.transaction;
            if (transaction) {
                event.sdkProcessingMetadata = {
                    dynamicSamplingContext: transaction.getDynamicSamplingContext(),
                    ...event.sdkProcessingMetadata
                };
                const transactionName = transaction.name;
                if (transactionName) event.tags = {
                    transaction: transactionName,
                    ...event.tags
                };
            }
        }
        this._applyFingerprint(event);
        const scopeBreadcrumbs = this._getBreadcrumbs();
        const breadcrumbs = [
            ...event.breadcrumbs || [],
            ...scopeBreadcrumbs
        ];
        event.breadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata,
            propagationContext: this._propagationContext
        };
        return (0, $d89985e59bedb9f9$export$bf2a096c3e883e79)([
            ...(0, $d89985e59bedb9f9$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Get the breadcrumbs for this scope.
   */ _getBreadcrumbs() {
        return this._breadcrumbs;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $6db688138f32ddc5$export$3131421a7d01b4fb)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
function $920bf7465f79c8a9$var$generatePropagationContext() {
    return {
        traceId: (0, $6db688138f32ddc5$export$19f53698e68b2496)(),
        spanId: (0, $6db688138f32ddc5$export$19f53698e68b2496)().substring(16)
    };
}



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $1d80cfa15879bc41$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $1d80cfa15879bc41$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ class $1d80cfa15879bc41$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $920bf7465f79c8a9$export$775b6bb06e53a214)(), _version = $1d80cfa15879bc41$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $920bf7465f79c8a9$export$775b6bb06e53a214).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $6db688138f32ddc5$export$19f53698e68b2496)();
        const syntheticException = new Error("Sentry syntheticException");
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $6db688138f32ddc5$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $6db688138f32ddc5$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $1d80cfa15879bc41$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $1LeEK.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $eace895db919f450$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $1d80cfa15879bc41$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $1d80cfa15879bc41$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && !result) {
            const client = this.getClient();
            if (!client) // eslint-disable-next-line no-console
            console.warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else // eslint-disable-next-line no-console
            console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $457c892d505f39dd$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $0a2b370577402d1c$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $j8hA7.GLOBAL_OBJ).navigator || {};
        const session = (0, $457c892d505f39dd$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $457c892d505f39dd$export$531818e825e774db)(currentSession, {
            status: "exited"
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $1d80cfa15879bc41$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $1d80cfa15879bc41$export$19eade501500c6c1() {
    (0, $j8hA7.GLOBAL_OBJ).__SENTRY__ = (0, $j8hA7.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $j8hA7.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $1d80cfa15879bc41$export$4188a14ad302d1bc(hub) {
    const registry = $1d80cfa15879bc41$export$19eade501500c6c1();
    const oldHub = $1d80cfa15879bc41$export$bfa8a924a84a76b7(registry);
    $1d80cfa15879bc41$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $1d80cfa15879bc41$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $1d80cfa15879bc41$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $1d80cfa15879bc41$var$getGlobalHub(registry);
}
function $1d80cfa15879bc41$var$getGlobalHub(registry = $1d80cfa15879bc41$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$1d80cfa15879bc41$var$hasHubOnCarrier(registry) || $1d80cfa15879bc41$export$bfa8a924a84a76b7(registry).isOlderThan($1d80cfa15879bc41$export$24a86ef7798177e4)) $1d80cfa15879bc41$export$849f05434e95d2f2(registry, new $1d80cfa15879bc41$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $1d80cfa15879bc41$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ function $1d80cfa15879bc41$export$236689a79f5aa020(carrier, parent = $1d80cfa15879bc41$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$1d80cfa15879bc41$var$hasHubOnCarrier(carrier) || $1d80cfa15879bc41$export$bfa8a924a84a76b7(carrier).isOlderThan($1d80cfa15879bc41$export$24a86ef7798177e4)) {
        const globalHubTopStack = parent.getStackTop();
        $1d80cfa15879bc41$export$849f05434e95d2f2(carrier, new $1d80cfa15879bc41$export$8c41bb232f1008b1(globalHubTopStack.client, (0, $920bf7465f79c8a9$export$775b6bb06e53a214).clone(globalHubTopStack.scope)));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $1d80cfa15879bc41$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $1d80cfa15879bc41$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $1d80cfa15879bc41$export$70d775fb1f267027(callback, options = {}) {
    const registry = $1d80cfa15879bc41$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $1d80cfa15879bc41$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $1d80cfa15879bc41$export$bfa8a924a84a76b7(carrier) {
    return (0, $j8hA7.getGlobalSingleton)("hub", ()=>new $1d80cfa15879bc41$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $1d80cfa15879bc41$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}


const $54ac23158809bb6f$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $54ac23158809bb6f$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $54ac23158809bb6f$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $6db688138f32ddc5$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $54ac23158809bb6f$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $54ac23158809bb6f$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $54ac23158809bb6f$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $54ac23158809bb6f$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/** Setup a single integration.  */ function $54ac23158809bb6f$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    integrationIndex[integration.name] = integration;
    if ($54ac23158809bb6f$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        integration.setupOnce((0, $d89985e59bedb9f9$export$8e4e25f54d456511), (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c));
        $54ac23158809bb6f$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $54ac23158809bb6f$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}



/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $3fa3c736a0182633$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) (0, $eace895db919f450$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        // eslint-disable-next-line no-console
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
    }
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    hub.bindClient(client);
}


/** Regular expression used to parse a Dsn. */ const $63bed5cf139afbdd$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $63bed5cf139afbdd$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $63bed5cf139afbdd$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $63bed5cf139afbdd$export$b892860177f70a30(str) {
    const match = $63bed5cf139afbdd$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        // eslint-disable-next-line no-console
        console.error(`Invalid Sentry Dsn: ${str}`);
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $63bed5cf139afbdd$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $63bed5cf139afbdd$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $63bed5cf139afbdd$var$validateDsn(dsn) {
    if (!(typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $eace895db919f450$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $eace895db919f450$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$63bed5cf139afbdd$var$isValidProtocol(protocol)) {
        (0, $eace895db919f450$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $eace895db919f450$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $63bed5cf139afbdd$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $63bed5cf139afbdd$export$b892860177f70a30(from) : $63bed5cf139afbdd$var$dsnFromComponents(from);
    if (!components || !$63bed5cf139afbdd$var$validateDsn(components)) return undefined;
    return components;
}


const $a9ea3877ca9508d1$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a9ea3877ca9508d1$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a9ea3877ca9508d1$var$_getIngestEndpoint(dsn) {
    return `${$a9ea3877ca9508d1$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a9ea3877ca9508d1$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $00469dac6edb4ff1$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $a9ea3877ca9508d1$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a9ea3877ca9508d1$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$a9ea3877ca9508d1$var$_getIngestEndpoint(dsn)}?${$a9ea3877ca9508d1$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a9ea3877ca9508d1$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $63bed5cf139afbdd$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$a9ea3877ca9508d1$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $63bed5cf139afbdd$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


/** Node Stack line parser */ // eslint-disable-next-line complexity
function $90d1fbb12f42d14f$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
            !filename.startsWith("/") && // It's not internal if it's an absolute windows path
            !filename.includes(":\\") && // It's not internal if the path is starting with a dot
            !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
            !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
            // in_app is all that's not an internal Node function or a module within node_modules
            // note that isNative appears to return true even for node core libraries
            // see https://github.com/getsentry/raven-node/issues/176
            const in_app = !isInternal && filename !== undefined && !filename.includes("node_modules/");
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: in_app
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $d4b5117c528aef84$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $d4b5117c528aef84$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $d4b5117c528aef84$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $d4b5117c528aef84$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $d4b5117c528aef84$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($d4b5117c528aef84$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $d4b5117c528aef84$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $d4b5117c528aef84$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $d4b5117c528aef84$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $d4b5117c528aef84$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $d4b5117c528aef84$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($d4b5117c528aef84$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($d4b5117c528aef84$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $d4b5117c528aef84$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $d4b5117c528aef84$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $d4b5117c528aef84$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $d4b5117c528aef84$var$defaultFunctionName;
        return fn.name || $d4b5117c528aef84$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $d4b5117c528aef84$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $d4b5117c528aef84$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $90d1fbb12f42d14f$export$35059013cd4a06db)(getModule)
    ];
}



var $j8hA7 = parcelRequire("j8hA7");
// eslint-disable-next-line deprecation/deprecation
const $d7a491ae57601fc5$var$WINDOW = (0, $j8hA7.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $d7a491ae57601fc5$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $d7a491ae57601fc5$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $d7a491ae57601fc5$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $d7a491ae57601fc5$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $d7a491ae57601fc5$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d7a491ae57601fc5$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $d7a491ae57601fc5$export$c82d238e23c40b21() {
    if (!$d7a491ae57601fc5$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($d7a491ae57601fc5$export$18cf36ed71d733e7($d7a491ae57601fc5$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $d7a491ae57601fc5$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $d7a491ae57601fc5$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $d7a491ae57601fc5$export$531055a6c684a70a() {
    return "ReportingObserver" in $d7a491ae57601fc5$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $d7a491ae57601fc5$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$d7a491ae57601fc5$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}







var $j8hA7 = parcelRequire("j8hA7");

var $j8hA7 = parcelRequire("j8hA7");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $84b8a55de1cd79f9$var$WINDOW = (0, $j8hA7.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $84b8a55de1cd79f9$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $84b8a55de1cd79f9$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $84b8a55de1cd79f9$var$WINDOW && !!$84b8a55de1cd79f9$var$WINDOW.history.pushState && !!$84b8a55de1cd79f9$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}


// eslint-disable-next-line deprecation/deprecation
const $ff6cab9022b0c01d$var$WINDOW = (0, $j8hA7.getGlobalObject)();
const $ff6cab9022b0c01d$export$55b6bb1e45c6cf59 = "__sentry_xhr_v2__";
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $ff6cab9022b0c01d$var$handlers = {};
const $ff6cab9022b0c01d$var$instrumented = {};
/** Instruments given API */ function $ff6cab9022b0c01d$var$instrument(type) {
    if ($ff6cab9022b0c01d$var$instrumented[type]) return;
    $ff6cab9022b0c01d$var$instrumented[type] = true;
    switch(type){
        case "console":
            $ff6cab9022b0c01d$var$instrumentConsole();
            break;
        case "dom":
            $ff6cab9022b0c01d$export$3014bbf0af0e1d4a();
            break;
        case "xhr":
            $ff6cab9022b0c01d$export$c67d533bf77cbf54();
            break;
        case "fetch":
            $ff6cab9022b0c01d$var$instrumentFetch();
            break;
        case "history":
            $ff6cab9022b0c01d$var$instrumentHistory();
            break;
        case "error":
            $ff6cab9022b0c01d$var$instrumentError();
            break;
        case "unhandledrejection":
            $ff6cab9022b0c01d$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("unknown instrumentation type:", type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ff6cab9022b0c01d$export$285b9172a3741fb7(type, callback) {
    $ff6cab9022b0c01d$var$handlers[type] = $ff6cab9022b0c01d$var$handlers[type] || [];
    $ff6cab9022b0c01d$var$handlers[type].push(callback);
    $ff6cab9022b0c01d$var$instrument(type);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $ff6cab9022b0c01d$export$b17eab759a1cb5fe() {
    Object.keys($ff6cab9022b0c01d$var$handlers).forEach((key)=>{
        $ff6cab9022b0c01d$var$handlers[key] = undefined;
    });
}
/** JSDoc */ function $ff6cab9022b0c01d$var$triggerHandlers(type, data) {
    if (!type || !$ff6cab9022b0c01d$var$handlers[type]) return;
    for (const handler of $ff6cab9022b0c01d$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $d4b5117c528aef84$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $ff6cab9022b0c01d$var$instrumentConsole() {
    if (!("console" in (0, $j8hA7.GLOBAL_OBJ))) return;
    (0, $eace895db919f450$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $j8hA7.GLOBAL_OBJ).console)) return;
        (0, $00469dac6edb4ff1$export$9563e054e6f787fb)((0, $j8hA7.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $eace895db919f450$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                $ff6cab9022b0c01d$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                const log = (0, $eace895db919f450$export$77c4ce905194557b)[level];
                log && log.apply((0, $j8hA7.GLOBAL_OBJ).console, args);
            };
        });
    });
}
/** JSDoc */ function $ff6cab9022b0c01d$var$instrumentFetch() {
    if (!(0, $d7a491ae57601fc5$export$c82d238e23c40b21)()) return;
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)((0, $j8hA7.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $ff6cab9022b0c01d$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $ff6cab9022b0c01d$var$triggerHandlers("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $j8hA7.GLOBAL_OBJ), args).then((response)=>{
                $ff6cab9022b0c01d$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $ff6cab9022b0c01d$var$triggerHandlers("fetch", {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $ff6cab9022b0c01d$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $ff6cab9022b0c01d$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($ff6cab9022b0c01d$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $ff6cab9022b0c01d$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $ff6cab9022b0c01d$var$getUrlFromResource(url),
            method: $ff6cab9022b0c01d$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $ff6cab9022b0c01d$var$getUrlFromResource(arg),
        method: $ff6cab9022b0c01d$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
/** JSDoc */ function $ff6cab9022b0c01d$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$ff6cab9022b0c01d$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const url = args[1];
            const xhrInfo = this[$ff6cab9022b0c01d$export$55b6bb1e45c6cf59] = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $da535ffc958c129e$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $da535ffc958c129e$export$844ec244b1367d54)(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$ff6cab9022b0c01d$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $ff6cab9022b0c01d$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: this
                    });
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$ff6cab9022b0c01d$export$55b6bb1e45c6cf59];
                    if (xhrInfo) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$ff6cab9022b0c01d$export$55b6bb1e45c6cf59];
            if (sentryXhrData && args[0] !== undefined) sentryXhrData.body = args[0];
            $ff6cab9022b0c01d$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $ff6cab9022b0c01d$var$lastHref;
/** JSDoc */ function $ff6cab9022b0c01d$var$instrumentHistory() {
    if (!(0, $84b8a55de1cd79f9$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $ff6cab9022b0c01d$var$WINDOW.onpopstate;
    $ff6cab9022b0c01d$var$WINDOW.onpopstate = function(...args) {
        const to = $ff6cab9022b0c01d$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $ff6cab9022b0c01d$var$lastHref;
        $ff6cab9022b0c01d$var$lastHref = to;
        $ff6cab9022b0c01d$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $ff6cab9022b0c01d$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $ff6cab9022b0c01d$var$lastHref = to;
                $ff6cab9022b0c01d$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)($ff6cab9022b0c01d$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)($ff6cab9022b0c01d$var$WINDOW.history, "replaceState", historyReplacementFunction);
}
const $ff6cab9022b0c01d$var$debounceDuration = 1000;
let $ff6cab9022b0c01d$var$debounceTimerID;
let $ff6cab9022b0c01d$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $ff6cab9022b0c01d$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $ff6cab9022b0c01d$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== "keypress") return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $ff6cab9022b0c01d$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $ff6cab9022b0c01d$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($ff6cab9022b0c01d$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($ff6cab9022b0c01d$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $ff6cab9022b0c01d$var$lastCapturedEvent = event;
        } else if ($ff6cab9022b0c01d$var$shouldShortcircuitPreviousDebounce($ff6cab9022b0c01d$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $ff6cab9022b0c01d$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($ff6cab9022b0c01d$var$debounceTimerID);
        $ff6cab9022b0c01d$var$debounceTimerID = $ff6cab9022b0c01d$var$WINDOW.setTimeout(()=>{
            $ff6cab9022b0c01d$var$debounceTimerID = undefined;
        }, $ff6cab9022b0c01d$var$debounceDuration);
    };
}
/** JSDoc */ function $ff6cab9022b0c01d$export$3014bbf0af0e1d4a() {
    if (!$ff6cab9022b0c01d$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $ff6cab9022b0c01d$var$triggerHandlers.bind(null, "dom");
    const globalDOMEventHandler = $ff6cab9022b0c01d$var$makeDOMEventHandler(triggerDOMHandler, true);
    $ff6cab9022b0c01d$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $ff6cab9022b0c01d$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $ff6cab9022b0c01d$var$WINDOW[target] && $ff6cab9022b0c01d$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $ff6cab9022b0c01d$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $ff6cab9022b0c01d$var$_oldOnErrorHandler = null;
/** JSDoc */ function $ff6cab9022b0c01d$var$instrumentError() {
    $ff6cab9022b0c01d$var$_oldOnErrorHandler = $ff6cab9022b0c01d$var$WINDOW.onerror;
    $ff6cab9022b0c01d$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $ff6cab9022b0c01d$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($ff6cab9022b0c01d$var$_oldOnErrorHandler && !$ff6cab9022b0c01d$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $ff6cab9022b0c01d$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $ff6cab9022b0c01d$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let $ff6cab9022b0c01d$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $ff6cab9022b0c01d$var$instrumentUnhandledRejection() {
    $ff6cab9022b0c01d$var$_oldOnUnhandledRejectionHandler = $ff6cab9022b0c01d$var$WINDOW.onunhandledrejection;
    $ff6cab9022b0c01d$var$WINDOW.onunhandledrejection = function(e) {
        $ff6cab9022b0c01d$var$triggerHandlers("unhandledrejection", e);
        if ($ff6cab9022b0c01d$var$_oldOnUnhandledRejectionHandler && !$ff6cab9022b0c01d$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $ff6cab9022b0c01d$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $ff6cab9022b0c01d$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}




/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $cf223612d17b05df$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d060f3e5c438af18$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $d060f3e5c438af18$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $d060f3e5c438af18$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $d060f3e5c438af18$export$a3295358bff77e(object, depth);
    if ($d060f3e5c438af18$var$jsonSize(normalized) > maxSize) return $d060f3e5c438af18$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $d060f3e5c438af18$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $cf223612d17b05df$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $da535ffc958c129e$export$c9f5652083b8129d)(value)) return value;
    const stringified = $d060f3e5c438af18$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $d060f3e5c438af18$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $00469dac6edb4ff1$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $d060f3e5c438af18$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $d060f3e5c438af18$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $da535ffc958c129e$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $da535ffc958c129e$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $d4b5117c528aef84$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $d060f3e5c438af18$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $d060f3e5c438af18$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $d060f3e5c438af18$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d060f3e5c438af18$var$jsonSize(value) {
    return $d060f3e5c438af18$var$utf8Length(JSON.stringify(value));
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $62fb85999a5c3ef4$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $62fb85999a5c3ef4$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $62fb85999a5c3ef4$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $62fb85999a5c3ef4$export$604a45d95a155e2b(envelope, types) {
    return $62fb85999a5c3ef4$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $62fb85999a5c3ef4$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $62fb85999a5c3ef4$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $62fb85999a5c3ef4$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $62fb85999a5c3ef4$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $d060f3e5c438af18$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $62fb85999a5c3ef4$var$concatBuffers(parts);
}
function $62fb85999a5c3ef4$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $62fb85999a5c3ef4$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $62fb85999a5c3ef4$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $62fb85999a5c3ef4$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $62fb85999a5c3ef4$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $62fb85999a5c3ef4$export$b11169581eeaf237(type) {
    return $62fb85999a5c3ef4$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from from the metadata or an events */ function $62fb85999a5c3ef4$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $62fb85999a5c3ef4$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $63bed5cf139afbdd$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}

/** An error emitted by Sentry SDKs and related utilities. */ class $97d2d238d098382a$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $375ac2f6c35d268a$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $375ac2f6c35d268a$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $62fb85999a5c3ef4$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && {
            dsn: (0, $63bed5cf139afbdd$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $62fb85999a5c3ef4$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $375ac2f6c35d268a$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $62fb85999a5c3ef4$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $375ac2f6c35d268a$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $62fb85999a5c3ef4$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $62fb85999a5c3ef4$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}






/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatchs the `createDsc` lifecycle hook as a side effect.
 */ function $3af65ebbd3ebee85$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
        environment: options.environment || (0, $0a2b370577402d1c$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}



var $1LeEK = parcelRequire("1LeEK");
var $j8hA7 = parcelRequire("j8hA7");



/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $250f854364c0abb2$export$2d67fb380bd11267(options, event, hint, scope, client) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $6db688138f32ddc5$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $1LeEK.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $250f854364c0abb2$var$applyClientOptions(prepared, options);
    $250f854364c0abb2$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $250f854364c0abb2$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) finalScope = (0, $920bf7465f79c8a9$export$775b6bb06e53a214).clone(finalScope).update(hint.captureContext);
    // We prepare the result here with a resolved Event.
    let result = (0, $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa)(prepared);
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope) {
        // Collect attachments from the hint and scope
        if (finalScope.getAttachments) {
            const attachments = [
                ...hint.attachments || [],
                ...finalScope.getAttachments()
            ];
            if (attachments.length) hint.attachments = attachments;
        }
        // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
    }
    return result.then((evt)=>{
        // Process client-scoped event processors
        return client && client.getEventProcessors ? (0, $d89985e59bedb9f9$export$bf2a096c3e883e79)(client.getEventProcessors(), evt, hint) : evt;
    }).then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $250f854364c0abb2$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $250f854364c0abb2$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $250f854364c0abb2$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $0a2b370577402d1c$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $07665083d6e876d3$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $07665083d6e876d3$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $07665083d6e876d3$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $250f854364c0abb2$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $250f854364c0abb2$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $j8hA7.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $250f854364c0abb2$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $250f854364c0abb2$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $250f854364c0abb2$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $250f854364c0abb2$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $250f854364c0abb2$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $d060f3e5c438af18$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $d060f3e5c438af18$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $d060f3e5c438af18$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $d060f3e5c438af18$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $d060f3e5c438af18$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) span.data = (0, $d060f3e5c438af18$export$a3295358bff77e)(span.data, depth, maxBreadth);
        return span;
    });
    return normalized;
}


const $3e3d98427e923f66$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $3e3d98427e923f66$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $63bed5cf139afbdd$export$128827c3562ec0cb)(options.dsn);
        else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("No DSN provided, client will not do anything.");
        if (this._dsn) {
            const url = (0, $a9ea3877ca9508d1$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $6db688138f32ddc5$export$6de4ffac6a2f1098)(exception)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log($3e3d98427e923f66$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = (0, $da535ffc958c129e$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $6db688138f32ddc5$export$6de4ffac6a2f1098)(hint.originalException)) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log($3e3d98427e923f66$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("SDK not enabled, will not capture session.");
            return;
        }
        if (!(typeof session.release === "string")) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $457c892d505f39dd$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
            return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
        });
        else return (0, $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Sets up the integrations
   */ setupIntegrations() {
        if (this._isEnabled() && !this._integrationsInitialized) {
            this._integrations = (0, $54ac23158809bb6f$export$51abed9797baa598)(this, this._options.integrations);
            this._integrationsInitialized = true;
        }
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */ getIntegrationById(integrationId) {
        return this._integrations[integrationId];
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        (0, $54ac23158809bb6f$export$e7390a03b70a6f2f)(this, integration, this._integrations);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        if (this._dsn) {
            let env = (0, $375ac2f6c35d268a$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
            for (const attachment of hint.attachments || [])env = (0, $62fb85999a5c3ef4$export$d650323442802f6f)(env, (0, $62fb85999a5c3ef4$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
            const promise = this._sendEnvelope(env);
            if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
        }
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        if (this._dsn) {
            const env = (0, $375ac2f6c35d268a$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
            this._sendEnvelope(env);
        }
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $457c892d505f39dd$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $c7f04ac6ef2a7863$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $250f854364c0abb2$export$2d67fb380bd11267)(options, event, hint, scope, this).then((evt)=>{
            if (evt === null) return evt;
            // If a trace context is not set on the event, we use the propagationContext set on the event to
            // generate a trace context. If the propagationContext does not have a dynamic sampling context, we
            // also generate one for it.
            const { propagationContext: propagationContext } = evt.sdkProcessingMetadata || {};
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $3af65ebbd3ebee85$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $eace895db919f450$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $eace895db919f450$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        if (!this._isEnabled()) return (0, $c7f04ac6ef2a7863$export$78e43115b553f358)(new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)("SDK not enabled, will not capture event.", "log"));
        const isTransaction = $3e3d98427e923f66$var$isTransactionEvent(event);
        const isError = $3e3d98427e923f66$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $c7f04ac6ef2a7863$export$78e43115b553f358)(new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $3e3d98427e923f66$var$processBeforeSend(options, prepared, hint);
            return $3e3d98427e923f66$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $97d2d238d098382a$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        if (this._transport && this._dsn) {
            this.emit("beforeEnvelope", envelope);
            return this._transport.send(envelope).then(null, (reason)=>{
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("Error while sending event:", reason);
            });
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $3e3d98427e923f66$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $da535ffc958c129e$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $da535ffc958c129e$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $da535ffc958c129e$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $3e3d98427e923f66$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($3e3d98427e923f66$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($3e3d98427e923f66$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $3e3d98427e923f66$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $3e3d98427e923f66$var$isTransactionEvent(event) {
    return event.type === "transaction";
}



var $kol7a = parcelRequire("kol7a");

var $1LeEK = parcelRequire("1LeEK");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $742da42ca8b11f5b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $1LeEK.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $62fb85999a5c3ef4$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}




/**
 * This function creates an exception from a JavaScript Error
 */ function $c3cc7dd2038b9a71$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $c3cc7dd2038b9a71$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $c3cc7dd2038b9a71$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $c3cc7dd2038b9a71$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $da535ffc958c129e$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $c3cc7dd2038b9a71$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $d060f3e5c438af18$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $c3cc7dd2038b9a71$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $c3cc7dd2038b9a71$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $c3cc7dd2038b9a71$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $c3cc7dd2038b9a71$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $c3cc7dd2038b9a71$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $c3cc7dd2038b9a71$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $c3cc7dd2038b9a71$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($c3cc7dd2038b9a71$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $c3cc7dd2038b9a71$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $c3cc7dd2038b9a71$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c3cc7dd2038b9a71$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6db688138f32ddc5$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $c3cc7dd2038b9a71$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $c3cc7dd2038b9a71$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $c3cc7dd2038b9a71$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $da535ffc958c129e$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $c3cc7dd2038b9a71$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $da535ffc958c129e$export$ef9e2056653f0c8e)(exception) || (0, $da535ffc958c129e$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $c3cc7dd2038b9a71$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $da535ffc958c129e$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $c3cc7dd2038b9a71$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $6db688138f32ddc5$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $da535ffc958c129e$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $c3cc7dd2038b9a71$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $da535ffc958c129e$export$53b83ca8eaab0383)(exception) || (0, $da535ffc958c129e$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $c3cc7dd2038b9a71$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $6db688138f32ddc5$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $c3cc7dd2038b9a71$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $6db688138f32ddc5$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $6db688138f32ddc5$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $c3cc7dd2038b9a71$export$47d86ae4b3c9994(stackParser, input, syntheticException, attachStacktrace) {
    const event = {
        message: input
    };
    if (attachStacktrace && syntheticException) {
        const frames = $c3cc7dd2038b9a71$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: input,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    return event;
}
function $c3cc7dd2038b9a71$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $00469dac6edb4ff1$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $da535ffc958c129e$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $da535ffc958c129e$export$9671ea99bd126ace)(exception)) {
        const className = $c3cc7dd2038b9a71$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $c3cc7dd2038b9a71$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $cf77fc5b2b31ee0b$export$f5282963edea4a68(exception, captureContext) {
    return (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().captureException(exception, {
        captureContext: captureContext
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */ function $cf77fc5b2b31ee0b$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */ function $cf77fc5b2b31ee0b$export$1462b974fdcf6ba2(event, hint) {
    return (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */ function $cf77fc5b2b31ee0b$export$99d44f04437e9cb8(callback) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ function $cf77fc5b2b31ee0b$export$efda9a273d7a036d(breadcrumb) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $cf77fc5b2b31ee0b$export$2f04de43fe27971a(name, context) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $cf77fc5b2b31ee0b$export$bb4922da0dd51b92(extras) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $cf77fc5b2b31ee0b$export$8e8e7789d42ed61d(key, extra) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $cf77fc5b2b31ee0b$export$74a8fb34822092e6(tags) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $cf77fc5b2b31ee0b$export$a37d07ee78eb4569(key, value) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $cf77fc5b2b31ee0b$export$8b6bb3dd62a01be2(user) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */ function $cf77fc5b2b31ee0b$export$ec58d9285c204497(callback) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().withScope(callback);
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */ function $cf77fc5b2b31ee0b$export$e262da7ae6480481(context, customSamplingContext) {
    return (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $cf77fc5b2b31ee0b$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    const client = hub.getClient();
    if (!client) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $6db688138f32ddc5$export$19f53698e68b2496)();
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $cf77fc5b2b31ee0b$export$4909b86c8034bf73(timeout) {
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.flush(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $cf77fc5b2b31ee0b$export$8360e631d277ea4d(timeout) {
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.close(timeout);
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $cf77fc5b2b31ee0b$export$5d4e9fd7fac8e617() {
    return (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().lastEventId();
}



var $j8hA7 = parcelRequire("j8hA7");
const $783f622d07685de5$export$56d8a8a25bd48b81 = (0, $j8hA7.GLOBAL_OBJ);
let $783f622d07685de5$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $783f622d07685de5$export$b79738ab10c590b2() {
    return $783f622d07685de5$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $783f622d07685de5$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $783f622d07685de5$var$ignoreOnError++;
    setTimeout(()=>{
        $783f622d07685de5$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $783f622d07685de5$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $00469dac6edb4ff1$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$783f622d07685de5$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $783f622d07685de5$export$1265a142ff5ba165();
            (0, $cf77fc5b2b31ee0b$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $6db688138f32ddc5$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $6db688138f32ddc5$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $cf77fc5b2b31ee0b$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $00469dac6edb4ff1$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $00469dac6edb4ff1$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}



/**
 * Creates an envelope from a user feedback.
 */ function $aa7923b7c8e603b8$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $63bed5cf139afbdd$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $aa7923b7c8e603b8$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $62fb85999a5c3ef4$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $aa7923b7c8e603b8$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $259cc879b3927fd1$export$1df9218a526d318d extends (0, $3e3d98427e923f66$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $783f622d07685de5$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $kol7a.getSDKSource)();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: "sentry.javascript.browser",
            packages: [
                {
                    name: `${sdkSource}:@sentry/browser`,
                    version: (0, $a3b3c1bf0fb5d719$export$31499a9cd224b78c)
                }
            ],
            version: (0, $a3b3c1bf0fb5d719$export$31499a9cd224b78c)
        };
        super(options);
        if (options.sendClientReports && (0, $783f622d07685de5$export$56d8a8a25bd48b81).document) (0, $783f622d07685de5$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $783f622d07685de5$export$56d8a8a25bd48b81).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $c3cc7dd2038b9a71$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $c3cc7dd2038b9a71$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $aa7923b7c8e603b8$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        if (!this._dsn) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $742da42ca8b11f5b$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $63bed5cf139afbdd$export$44d472fbb931a776)(this._dsn));
        this._sendEnvelope(envelope);
    }
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Global handlers */ class $f7bd44a964bf4cf5$export$204155decbc90e5a {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "GlobalHandlers";
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */ /** JSDoc */ constructor(options){
        this.name = $f7bd44a964bf4cf5$export$204155decbc90e5a.id;
        this._options = {
            onerror: true,
            onunhandledrejection: true,
            ...options
        };
        this._installFunc = {
            onerror: $f7bd44a964bf4cf5$var$_installGlobalOnErrorHandler,
            onunhandledrejection: $f7bd44a964bf4cf5$var$_installGlobalOnUnhandledRejectionHandler
        };
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        Error.stackTraceLimit = 50;
        const options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for(const key in options){
            const installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                $f7bd44a964bf4cf5$var$globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    }
}
$f7bd44a964bf4cf5$export$204155decbc90e5a.__initStatic();
/** JSDoc */ function $f7bd44a964bf4cf5$var$_installGlobalOnErrorHandler() {
    (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("error", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data)=>{
        const [hub, stackParser, attachStacktrace] = $f7bd44a964bf4cf5$var$getHubAndOptions();
        if (!hub.getIntegration($f7bd44a964bf4cf5$export$204155decbc90e5a)) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        if ((0, $783f622d07685de5$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return;
        const event = error === undefined && (0, $da535ffc958c129e$export$844ec244b1367d54)(msg) ? $f7bd44a964bf4cf5$var$_eventFromIncompleteOnError(msg, url, line, column) : $f7bd44a964bf4cf5$var$_enhanceEventWithInitialFrame((0, $c3cc7dd2038b9a71$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        $f7bd44a964bf4cf5$var$addMechanismAndCapture(hub, error, event, "onerror");
    });
}
/** JSDoc */ function $f7bd44a964bf4cf5$var$_installGlobalOnUnhandledRejectionHandler() {
    (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("unhandledrejection", // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        const [hub, stackParser, attachStacktrace] = $f7bd44a964bf4cf5$var$getHubAndOptions();
        if (!hub.getIntegration($f7bd44a964bf4cf5$export$204155decbc90e5a)) return;
        let error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ("reason" in e) error = e.reason;
            else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
        } catch (_oO) {
        // no-empty
        }
        if ((0, $783f622d07685de5$export$b79738ab10c590b2)() || error && error.__sentry_own_request__) return true;
        const event = (0, $da535ffc958c129e$export$c3825b437cbdea5c)(error) ? $f7bd44a964bf4cf5$var$_eventFromRejectionWithPrimitive(error) : (0, $c3cc7dd2038b9a71$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        $f7bd44a964bf4cf5$var$addMechanismAndCapture(hub, error, event, "onunhandledrejection");
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $f7bd44a964bf4cf5$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7bd44a964bf4cf5$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $da535ffc958c129e$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $f7bd44a964bf4cf5$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f7bd44a964bf4cf5$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $da535ffc958c129e$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $10b7e35d980736f8$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $f7bd44a964bf4cf5$var$globalHandlerLog(type) {
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $f7bd44a964bf4cf5$var$addMechanismAndCapture(hub, error, event, type) {
    (0, $6db688138f32ddc5$export$c69a9a0313b03bb1)(event, {
        handled: false,
        type: type
    });
    hub.captureEvent(event, {
        originalException: error
    });
}
function $f7bd44a964bf4cf5$var$getHubAndOptions() {
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return [
        hub,
        options.stackParser,
        options.attachStacktrace
    ];
}




const $88e7aa69a4262935$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ class $88e7aa69a4262935$export$f1a018517668e6d3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "TryCatch";
    }
    /**
   * @inheritDoc
   */ /** JSDoc */ /**
   * @inheritDoc
   */ constructor(options){
        this.name = $88e7aa69a4262935$export$f1a018517668e6d3.id;
        this._options = {
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true,
            ...options
        };
    }
    /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */ setupOnce() {
        if (this._options.setTimeout) (0, $00469dac6edb4ff1$export$9563e054e6f787fb)((0, $783f622d07685de5$export$56d8a8a25bd48b81), "setTimeout", $88e7aa69a4262935$var$_wrapTimeFunction);
        if (this._options.setInterval) (0, $00469dac6edb4ff1$export$9563e054e6f787fb)((0, $783f622d07685de5$export$56d8a8a25bd48b81), "setInterval", $88e7aa69a4262935$var$_wrapTimeFunction);
        if (this._options.requestAnimationFrame) (0, $00469dac6edb4ff1$export$9563e054e6f787fb)((0, $783f622d07685de5$export$56d8a8a25bd48b81), "requestAnimationFrame", $88e7aa69a4262935$var$_wrapRAF);
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in (0, $783f622d07685de5$export$56d8a8a25bd48b81)) (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $88e7aa69a4262935$var$_wrapXHR);
        const eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $88e7aa69a4262935$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach($88e7aa69a4262935$var$_wrapEventTarget);
        }
    }
}
$88e7aa69a4262935$export$f1a018517668e6d3.__initStatic();
/** JSDoc */ function $88e7aa69a4262935$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $783f622d07685de5$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $d4b5117c528aef84$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $88e7aa69a4262935$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $783f622d07685de5$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $d4b5117c528aef84$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
/** JSDoc */ function $88e7aa69a4262935$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $d4b5117c528aef84$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $00469dac6edb4ff1$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $d4b5117c528aef84$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $783f622d07685de5$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */ function $88e7aa69a4262935$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $783f622d07685de5$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $783f622d07685de5$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $d4b5117c528aef84$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $783f622d07685de5$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $d4b5117c528aef84$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $5b27f0bed1ce5624$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $5b27f0bed1ce5624$export$e01cef29b4327697(level) {
    return $5b27f0bed1ce5624$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $5b27f0bed1ce5624$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $5b27f0bed1ce5624$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $c4b4359bf68cb04d$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $c4b4359bf68cb04d$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $c4b4359bf68cb04d$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $c4b4359bf68cb04d$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(":80", "").replace(":443", "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $6650a713797f405a$var$MAX_ALLOWED_STRING_LENGTH = 1024;
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ class $6650a713797f405a$export$2dc68d50d56fbbd {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Breadcrumbs";
    }
    /**
   * @inheritDoc
   */ /**
   * Options of the breadcrumbs integration.
   */ // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
    /**
   * @inheritDoc
   */ constructor(options){
        this.name = $6650a713797f405a$export$2dc68d50d56fbbd.id;
        this.options = {
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
            ...options
        };
    }
    /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */ setupOnce() {
        if (this.options.console) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("console", $6650a713797f405a$var$_consoleBreadcrumb);
        if (this.options.dom) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("dom", $6650a713797f405a$var$_domBreadcrumb(this.options.dom));
        if (this.options.xhr) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("xhr", $6650a713797f405a$var$_xhrBreadcrumb);
        if (this.options.fetch) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("fetch", $6650a713797f405a$var$_fetchBreadcrumb);
        if (this.options.history) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("history", $6650a713797f405a$var$_historyBreadcrumb);
        if (this.options.sentry) {
            const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
            client && client.on && client.on("beforeSendEvent", $6650a713797f405a$var$addSentryBreadcrumb);
        }
    }
}
$6650a713797f405a$export$2dc68d50d56fbbd.__initStatic();
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $6650a713797f405a$var$addSentryBreadcrumb(event) {
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
        event_id: event.event_id,
        level: event.level,
        message: (0, $6db688138f32ddc5$export$4157119e2b157127)(event)
    }, {
        event: event
    });
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $6650a713797f405a$var$_domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
        let target;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $6650a713797f405a$var$MAX_ALLOWED_STRING_LENGTH) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$6650a713797f405a$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$6650a713797f405a$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $6650a713797f405a$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            target = $6650a713797f405a$var$_isEvent(event) ? (0, $10b7e35d980736f8$export$5647df6b7814ac86)(event.target, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            }) : (0, $10b7e35d980736f8$export$5647df6b7814ac86)(event, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: `ui.${handlerData.name}`,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */ function $6650a713797f405a$var$_consoleBreadcrumb(handlerData) {
    const breadcrumb = {
        category: "console",
        data: {
            arguments: handlerData.args,
            logger: "console"
        },
        level: (0, $5b27f0bed1ce5624$export$d771ef054122c30a)(handlerData.level),
        message: (0, $07665083d6e876d3$export$465e9d514283d4fd)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
        if (handlerData.args[0] === false) {
            breadcrumb.message = `Assertion failed: ${(0, $07665083d6e876d3$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
            breadcrumb.data.arguments = handlerData.args.slice(1);
        } else // Don't capture a breadcrumb for passed assertions
        return;
    }
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $6650a713797f405a$var$_xhrBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[0, $ff6cab9022b0c01d$export$55b6bb1e45c6cf59];
    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
    const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
    const data = {
        method: method,
        url: url,
        status_code: status_code
    };
    const hint = {
        xhr: handlerData.xhr,
        input: body,
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp
    };
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: "xhr",
        data: data,
        type: "http"
    }, hint);
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $6650a713797f405a$var$_fetchBreadcrumb(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
    // We only capture complete fetch requests
    if (!endTimestamp) return;
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
    if (handlerData.error) {
        const data = handlerData.fetchData;
        const hint = {
            data: handlerData.error,
            input: handlerData.args,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "fetch",
            data: data,
            level: "error",
            type: "http"
        }, hint);
    } else {
        const data = {
            ...handlerData.fetchData,
            status_code: handlerData.response && handlerData.response.status
        };
        const hint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "fetch",
            data: data,
            type: "http"
        }, hint);
    }
}
/**
 * Creates breadcrumbs from history API calls
 */ function $6650a713797f405a$var$_historyBreadcrumb(handlerData) {
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0, $c4b4359bf68cb04d$export$7a5253c0f62e0150)((0, $783f622d07685de5$export$56d8a8a25bd48b81).location.href);
    let parsedFrom = (0, $c4b4359bf68cb04d$export$7a5253c0f62e0150)(from);
    const parsedTo = (0, $c4b4359bf68cb04d$export$7a5253c0f62e0150)(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) parsedFrom = parsedLoc;
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
    (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().addBreadcrumb({
        category: "navigation",
        data: {
            from: from,
            to: to
        }
    });
}
function $6650a713797f405a$var$_isEvent(event) {
    return !!event && !!event.target;
}




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $eb45e05999d01ebe$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $da535ffc958c129e$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $eb45e05999d01ebe$var$truncateAggregateExceptions($eb45e05999d01ebe$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $eb45e05999d01ebe$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    if ((0, $da535ffc958c129e$export$49034edbe6b62415)(error[key], Error)) {
        $eb45e05999d01ebe$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $eb45e05999d01ebe$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $eb45e05999d01ebe$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $da535ffc958c129e$export$49034edbe6b62415)(childError, Error)) {
            $eb45e05999d01ebe$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $eb45e05999d01ebe$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $eb45e05999d01ebe$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $eb45e05999d01ebe$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        is_exception_group: true,
        exception_id: exceptionId
    };
}
function $eb45e05999d01ebe$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $eb45e05999d01ebe$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $07665083d6e876d3$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $523ebf7301ac082e$var$DEFAULT_KEY = "cause";
const $523ebf7301ac082e$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ class $523ebf7301ac082e$export$8d1e60aaf616fb4f {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "LinkedErrors";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        this.name = $523ebf7301ac082e$export$8d1e60aaf616fb4f.id;
        this._key = options.key || $523ebf7301ac082e$var$DEFAULT_KEY;
        this._limit = options.limit || $523ebf7301ac082e$var$DEFAULT_LIMIT;
    }
    /** @inheritdoc */ setupOnce() {
    // noop
    }
    /**
   * @inheritDoc
   */ preprocessEvent(event, hint, client) {
        const options = client.getOptions();
        (0, $eb45e05999d01ebe$export$b91c38ed7d8ae9b2)((0, $c3cc7dd2038b9a71$export$a6c2d27607295951), options.stackParser, options.maxValueLength, this._key, this._limit, event, hint);
    }
}
$523ebf7301ac082e$export$8d1e60aaf616fb4f.__initStatic();




/** HttpContext integration collects information about HTTP request headers */ class $d3d125c3379b92ff$export$5d2ee9a544b09a94 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "HttpContext";
    }
    /**
   * @inheritDoc
   */ constructor(){
        this.name = $d3d125c3379b92ff$export$5d2ee9a544b09a94.id;
    }
    /**
   * @inheritDoc
   */ setupOnce() {
        (0, $d89985e59bedb9f9$export$8e4e25f54d456511)((event)=>{
            if ((0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getIntegration($d3d125c3379b92ff$export$5d2ee9a544b09a94)) {
                // if none of the information we want exists, don't bother
                if (!(0, $783f622d07685de5$export$56d8a8a25bd48b81).navigator && !(0, $783f622d07685de5$export$56d8a8a25bd48b81).location && !(0, $783f622d07685de5$export$56d8a8a25bd48b81).document) return event;
                // grab as much info as exists and add it to the event
                const url = event.request && event.request.url || (0, $783f622d07685de5$export$56d8a8a25bd48b81).location && (0, $783f622d07685de5$export$56d8a8a25bd48b81).location.href;
                const { referrer: referrer } = (0, $783f622d07685de5$export$56d8a8a25bd48b81).document || {};
                const { userAgent: userAgent } = (0, $783f622d07685de5$export$56d8a8a25bd48b81).navigator || {};
                const headers = {
                    ...event.request && event.request.headers,
                    ...referrer && {
                        Referer: referrer
                    },
                    ...userAgent && {
                        "User-Agent": userAgent
                    }
                };
                const request = {
                    ...event.request,
                    ...url && {
                        url: url
                    },
                    headers: headers
                };
                return {
                    ...event,
                    request: request
                };
            }
            return event;
        });
    }
}
$d3d125c3379b92ff$export$5d2ee9a544b09a94.__initStatic();



/** Deduplication filter */ class $be24c81b15689efd$export$688d98c249d31ad3 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Dedupe";
    }
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ constructor(){
        this.name = $be24c81b15689efd$export$688d98c249d31ad3.id;
    }
    /**
   * @inheritDoc
   */ setupOnce(addGlobalEventProcessor, getCurrentHub) {
        const eventProcessor = (currentEvent)=>{
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            const self = getCurrentHub().getIntegration($be24c81b15689efd$export$688d98c249d31ad3);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($be24c81b15689efd$var$_shouldDropEvent(currentEvent, self._previousEvent)) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        };
        eventProcessor.id = this.name;
        addGlobalEventProcessor(eventProcessor);
    }
}
$be24c81b15689efd$export$688d98c249d31ad3.__initStatic();
/** JSDoc */ function $be24c81b15689efd$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($be24c81b15689efd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($be24c81b15689efd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $be24c81b15689efd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$be24c81b15689efd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$be24c81b15689efd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $be24c81b15689efd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $be24c81b15689efd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $be24c81b15689efd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$be24c81b15689efd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$be24c81b15689efd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $be24c81b15689efd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $be24c81b15689efd$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $be24c81b15689efd$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $be24c81b15689efd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $be24c81b15689efd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $be24c81b15689efd$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}



// global reference to slice
const $ad0ac0d0c071d485$var$UNKNOWN_FUNCTION = "?";
const $ad0ac0d0c071d485$var$OPERA10_PRIORITY = 10;
const $ad0ac0d0c071d485$var$OPERA11_PRIORITY = 20;
const $ad0ac0d0c071d485$var$CHROME_PRIORITY = 30;
const $ad0ac0d0c071d485$var$WINJS_PRIORITY = 40;
const $ad0ac0d0c071d485$var$GECKO_PRIORITY = 50;
function $ad0ac0d0c071d485$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $ad0ac0d0c071d485$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $ad0ac0d0c071d485$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const $ad0ac0d0c071d485$var$chrome = (line)=>{
    const parts = $ad0ac0d0c071d485$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $ad0ac0d0c071d485$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $ad0ac0d0c071d485$var$extractSafariExtensionDetails(parts[1] || $ad0ac0d0c071d485$var$UNKNOWN_FUNCTION, parts[2]);
        return $ad0ac0d0c071d485$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $ad0ac0d0c071d485$export$263a749fff749872 = [
    $ad0ac0d0c071d485$var$CHROME_PRIORITY,
    $ad0ac0d0c071d485$var$chrome
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $ad0ac0d0c071d485$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $ad0ac0d0c071d485$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $ad0ac0d0c071d485$var$gecko = (line)=>{
    const parts = $ad0ac0d0c071d485$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $ad0ac0d0c071d485$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $ad0ac0d0c071d485$var$UNKNOWN_FUNCTION;
        [func, filename] = $ad0ac0d0c071d485$var$extractSafariExtensionDetails(func, filename);
        return $ad0ac0d0c071d485$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $ad0ac0d0c071d485$export$cdba47a5dd2804d = [
    $ad0ac0d0c071d485$var$GECKO_PRIORITY,
    $ad0ac0d0c071d485$var$gecko
];
const $ad0ac0d0c071d485$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $ad0ac0d0c071d485$var$winjs = (line)=>{
    const parts = $ad0ac0d0c071d485$var$winjsRegex.exec(line);
    return parts ? $ad0ac0d0c071d485$var$createFrame(parts[2], parts[1] || $ad0ac0d0c071d485$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $ad0ac0d0c071d485$export$179460296da408e8 = [
    $ad0ac0d0c071d485$var$WINJS_PRIORITY,
    $ad0ac0d0c071d485$var$winjs
];
const $ad0ac0d0c071d485$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $ad0ac0d0c071d485$var$opera10 = (line)=>{
    const parts = $ad0ac0d0c071d485$var$opera10Regex.exec(line);
    return parts ? $ad0ac0d0c071d485$var$createFrame(parts[2], parts[3] || $ad0ac0d0c071d485$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $ad0ac0d0c071d485$export$f892b52c880ffc7a = [
    $ad0ac0d0c071d485$var$OPERA10_PRIORITY,
    $ad0ac0d0c071d485$var$opera10
];
const $ad0ac0d0c071d485$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $ad0ac0d0c071d485$var$opera11 = (line)=>{
    const parts = $ad0ac0d0c071d485$var$opera11Regex.exec(line);
    return parts ? $ad0ac0d0c071d485$var$createFrame(parts[5], parts[3] || parts[4] || $ad0ac0d0c071d485$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $ad0ac0d0c071d485$export$af11af13f09fb0dc = [
    $ad0ac0d0c071d485$var$OPERA11_PRIORITY,
    $ad0ac0d0c071d485$var$opera11
];
const $ad0ac0d0c071d485$export$7197c0fe6554c079 = [
    $ad0ac0d0c071d485$export$263a749fff749872,
    $ad0ac0d0c071d485$export$cdba47a5dd2804d,
    $ad0ac0d0c071d485$export$179460296da408e8
];
const $ad0ac0d0c071d485$export$2b2b997d81bf3907 = (0, $d4b5117c528aef84$export$a5739666fb2d03d4)(...$ad0ac0d0c071d485$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $ad0ac0d0c071d485$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $ad0ac0d0c071d485$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $fc260cbd81b11ce1$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $c7f04ac6ef2a7863$export$78e43115b553f358)(new (0, $97d2d238d098382a$export$5949942ba2a7c0e2)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $c7f04ac6ef2a7863$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $be9cb83538f8d0b9$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $be9cb83538f8d0b9$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $be9cb83538f8d0b9$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $be9cb83538f8d0b9$export$b89fc7b2e4c799e7(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $be9cb83538f8d0b9$export$6c91fec22056810a(limits, category, now = Date.now()) {
    return $be9cb83538f8d0b9$export$b89fc7b2e4c799e7(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $be9cb83538f8d0b9$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories] = limit.split(":", 2);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";"))updatedRateLimits[category] = now + delay;
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $be9cb83538f8d0b9$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $8b5bd88753c9ab27$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $8b5bd88753c9ab27$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $fc260cbd81b11ce1$export$85a4f67f852183e6)(options.bufferSize || $8b5bd88753c9ab27$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $62fb85999a5c3ef4$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const envelopeItemDataCategory = (0, $62fb85999a5c3ef4$export$b11169581eeaf237)(type);
            if ((0, $be9cb83538f8d0b9$export$6c91fec22056810a)(rateLimits, envelopeItemDataCategory)) {
                const event = $8b5bd88753c9ab27$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $62fb85999a5c3ef4$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $62fb85999a5c3ef4$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $8b5bd88753c9ab27$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $62fb85999a5c3ef4$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $62fb85999a5c3ef4$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $be9cb83538f8d0b9$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $97d2d238d098382a$export$5949942ba2a7c0e2)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $c7f04ac6ef2a7863$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $8b5bd88753c9ab27$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}





let $137167940cf7add5$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $137167940cf7add5$export$8be2119ce08e3379() {
    if ($137167940cf7add5$var$cachedFetchImpl) return $137167940cf7add5$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $d7a491ae57601fc5$export$18cf36ed71d733e7)((0, $783f622d07685de5$export$56d8a8a25bd48b81).fetch)) return $137167940cf7add5$var$cachedFetchImpl = (0, $783f622d07685de5$export$56d8a8a25bd48b81).fetch.bind((0, $783f622d07685de5$export$56d8a8a25bd48b81));
    const document = (0, $783f622d07685de5$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $783f622d07685de5$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $137167940cf7add5$var$cachedFetchImpl = fetchImpl.bind((0, $783f622d07685de5$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $137167940cf7add5$export$d499686d2dd738c6() {
    $137167940cf7add5$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $f0ffd4a58e239832$export$b2311068c46d7cc8(options, nativeFetch = (0, $137167940cf7add5$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $137167940cf7add5$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $c7f04ac6ef2a7863$export$78e43115b553f358)(e);
        }
    }
    return (0, $8b5bd88753c9ab27$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $ac6e936a377ff5c2$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $ac6e936a377ff5c2$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $c7f04ac6ef2a7863$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $ac6e936a377ff5c2$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $8b5bd88753c9ab27$export$d09f50d9ab7f7b69)(options, makeRequest);
}


const $6531e4cb4ae593d8$export$5ef831fccfce35e5 = [
    new (0, $deac3cf66fc00dd1$exports).InboundFilters(),
    new (0, $deac3cf66fc00dd1$exports).FunctionToString(),
    new (0, $88e7aa69a4262935$export$f1a018517668e6d3)(),
    new (0, $6650a713797f405a$export$2dc68d50d56fbbd)(),
    new (0, $f7bd44a964bf4cf5$export$204155decbc90e5a)(),
    new (0, $523ebf7301ac082e$export$8d1e60aaf616fb4f)(),
    new (0, $be24c81b15689efd$export$688d98c249d31ad3)(),
    new (0, $d3d125c3379b92ff$export$5d2ee9a544b09a94)()
];
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $6531e4cb4ae593d8$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $6531e4cb4ae593d8$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $783f622d07685de5$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $783f622d07685de5$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $783f622d07685de5$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $d4b5117c528aef84$export$1d5cf88b347146d4)(options.stackParser || (0, $ad0ac0d0c071d485$export$2b2b997d81bf3907)),
        integrations: (0, $54ac23158809bb6f$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $d7a491ae57601fc5$export$edf3cb81fd7d2a3e)() ? (0, $f0ffd4a58e239832$export$b2311068c46d7cc8) : (0, $ac6e936a377ff5c2$export$5e1441cee30d5a39))
    };
    (0, $3fa3c736a0182633$export$5333c3f1c58d9bc1)((0, $259cc879b3927fd1$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $6531e4cb4ae593d8$var$startSessionTracking();
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $6531e4cb4ae593d8$export$3a8fd680da42627b(options = {}, hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)()) {
    // doesn't work without a document (React Native)
    if (!(0, $783f622d07685de5$export$56d8a8a25bd48b81).document) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) options.eventId = hub.lastEventId();
    const script = (0, $783f622d07685de5$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $a9ea3877ca9508d1$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const injectionPoint = (0, $783f622d07685de5$export$56d8a8a25bd48b81).document.head || (0, $783f622d07685de5$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $6531e4cb4ae593d8$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $6531e4cb4ae593d8$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6531e4cb4ae593d8$export$4997ffc0176396a6(fn) {
    return (0, $783f622d07685de5$export$4997ffc0176396a6)(fn)();
}
function $6531e4cb4ae593d8$var$startSessionOnHub(hub) {
    hub.startSession({
        ignoreDuration: true
    });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $6531e4cb4ae593d8$var$startSessionTracking() {
    if (typeof (0, $783f622d07685de5$export$56d8a8a25bd48b81).document === "undefined") {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) return;
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    $6531e4cb4ae593d8$var$startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("history", ({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) $6531e4cb4ae593d8$var$startSessionOnHub((0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)());
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $6531e4cb4ae593d8$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    if (client) client.captureUserFeedback(feedback);
}


/**
 * Inits the React SDK
 */ function $53d551888014e96e$export$2cd8252107eb640b(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: "sentry.javascript.react",
        packages: [
            {
                name: "npm:@sentry/react",
                version: (0, $a3b3c1bf0fb5d719$export$31499a9cd224b78c)
            }
        ],
        version: (0, $a3b3c1bf0fb5d719$export$31499a9cd224b78c)
    };
    (0, $6531e4cb4ae593d8$export$2cd8252107eb640b)(options);
}


var $1LeEK = parcelRequire("1LeEK");

var $1LeEK = parcelRequire("1LeEK");

const $696812169dc7e4a9$export$9ca9946bd449ac06 = "baggage";
const $696812169dc7e4a9$export$6e69537d67fa20f = "sentry-";
const $696812169dc7e4a9$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $696812169dc7e4a9$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $696812169dc7e4a9$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $da535ffc958c129e$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $696812169dc7e4a9$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $696812169dc7e4a9$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($696812169dc7e4a9$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($696812169dc7e4a9$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $696812169dc7e4a9$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$696812169dc7e4a9$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $696812169dc7e4a9$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $696812169dc7e4a9$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $696812169dc7e4a9$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $696812169dc7e4a9$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



const $a48211d39a0e0319$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $a48211d39a0e0319$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($a48211d39a0e0319$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 */ function $a48211d39a0e0319$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $a48211d39a0e0319$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $696812169dc7e4a9$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    const propagationContext = {
        traceId: traceId || (0, $6db688138f32ddc5$export$19f53698e68b2496)(),
        spanId: (0, $6db688138f32ddc5$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled
    };
    if (parentSpanId) propagationContext.parentSpanId = parentSpanId;
    if (dynamicSamplingContext) propagationContext.dsc = dynamicSamplingContext;
    return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext,
        propagationContext: propagationContext
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $a48211d39a0e0319$export$f35d907436da45cf(traceId = (0, $6db688138f32ddc5$export$19f53698e68b2496)(), spanId = (0, $6db688138f32ddc5$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $dc5f37af6efacf59$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $dc5f37af6efacf59$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ /**
   * The origin of the span, giving context about what created the span.
   */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this.traceId = spanContext.traceId || (0, $6db688138f32ddc5$export$19f53698e68b2496)();
        this.spanId = spanContext.spanId || (0, $6db688138f32ddc5$export$19f53698e68b2496)().substring(16);
        this.startTimestamp = spanContext.startTimestamp || (0, $1LeEK.timestampInSeconds)();
        this.tags = spanContext.tags || {};
        this.data = spanContext.data || {};
        this.instrumenter = spanContext.instrumenter || "sentry";
        this.origin = spanContext.origin || "manual";
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.name) this.description = spanContext.name;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
    }
    /** An alias for `description` of the Span. */ get name() {
        return this.description || "";
    }
    /** Update the name of the span. */ set name(name) {
        this.setName(name);
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $dc5f37af6efacf59$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || "< unknown op >";
            const nameStr = childSpan.transaction.name || "< unknown name >";
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $eace895db919f450$export$af88d00dbe7f521).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag("http.status_code", String(httpStatus));
        this.setData("http.response.status_code", httpStatus);
        const spanStatus = $dc5f37af6efacf59$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== "unknown_error") this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ setName(name) {
        this.description = name;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === "ok";
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $eace895db919f450$export$af88d00dbe7f521).log(logMessage.replace("Starting", "Finishing"));
        }
        this.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $1LeEK.timestampInSeconds)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        return (0, $a48211d39a0e0319$export$f35d907436da45cf)(this.traceId, this.spanId, this.sampled);
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
            origin: this.origin
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $dc5f37af6efacf59$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return "ok";
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return "unauthenticated";
        case 403:
            return "permission_denied";
        case 404:
            return "not_found";
        case 409:
            return "already_exists";
        case 413:
            return "failed_precondition";
        case 429:
            return "resource_exhausted";
        default:
            return "invalid_argument";
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline_exceeded";
        default:
            return "internal_error";
    }
    return "unknown_error";
}






/** JSDoc */ class $6c2f53509d093d65$export$febc5573c75cefb0 extends (0, $dc5f37af6efacf59$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        // We need to delete description since it's set by the Span class constructor
        // but not needed for transactions.
        delete this.description;
        this._measurements = {};
        this._contexts = {};
        this._hub = hub || (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || "";
        this.metadata = {
            source: "custom",
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = "custom") {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $dc5f37af6efacf59$export$10c95c129cd0d4fe)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = "") {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this.name = "<unlabeled transaction>";
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit("finishTransaction", this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] Discarding transaction because its trace was not chosen to be sampled.");
            if (client) client.recordDroppedEvent("sample_rate", "transaction");
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: "transaction",
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction", JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || "";
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
        const client = hub.getClient();
        if (!client) return {};
        const scope = hub.getScope();
        const dsc = (0, $3af65ebbd3ebee85$export$366bad00d6815eed)(this.traceId, client, scope);
        const maybeSampleRate = this.metadata.sampleRate;
        if (maybeSampleRate !== undefined) dsc.sample_rate = `${maybeSampleRate}`;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const source = this.metadata.source;
        if (source && source !== "url") dsc.transaction = this.name;
        if (this.sampled !== undefined) dsc.sampled = String(this.sampled);
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
}


const $191a44eca504ebee$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $191a44eca504ebee$var$FINISH_REASON_TAG = "finishReason";
const $191a44eca504ebee$var$IDLE_TRANSACTION_FINISH_REASONS = [
    "heartbeatFailed",
    "idleTimeout",
    "documentHidden",
    "finalTimeout",
    "externalFinish",
    "cancelled"
];
/**
 * @inheritDoc
 */ class $191a44eca504ebee$export$370d6113c18ba86c extends (0, $dc5f37af6efacf59$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === "number" ? endTimestamp : (0, $1LeEK.timestampInSeconds)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $191a44eca504ebee$export$b279e6bd7040371f extends (0, $6c2f53509d093d65$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $191a44eca504ebee$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $191a44eca504ebee$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $191a44eca504ebee$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $191a44eca504ebee$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus("deadline_exceeded");
                this._finishReason = $191a44eca504ebee$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $1LeEK.timestampInSeconds)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === "ui.action.click") this.setTag($191a44eca504ebee$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] finishing IdleTransaction", new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus("cancelled");
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] cancelling span since transaction ended early", JSON.stringify(span, undefined, 2));
                }
                const spanStartedBeforeTransactionFinish = span.startTimestamp < endTimestamp;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = span.endTimestamp - this.startTimestamp < timeoutWithMarginOfError;
                if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] discarding Span since it happened after Transaction was finished", stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] discarding Span since it finished after Transaction final timeout", stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] flushing IdleTransaction");
        } else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] No active IdleTransaction");
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $191a44eca504ebee$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("Starting heartbeat");
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $191a44eca504ebee$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $191a44eca504ebee$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] new activities count", Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $1LeEK.timestampInSeconds)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $191a44eca504ebee$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join("");
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus("deadline_exceeded");
            this._finishReason = $191a44eca504ebee$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}




// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $5e7658a02f682731$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || "tracesSampleRate" in options || "tracesSampler" in options);
}





/** Grabs active transaction off scope, if any */ function $a08d109ecf5a6e0c$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    return scope.getTransaction();
}


let $793a1419c4c7dbbf$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $793a1419c4c7dbbf$export$637857c1d87b640c() {
    if ($793a1419c4c7dbbf$var$errorsInstrumented) return;
    $793a1419c4c7dbbf$var$errorsInstrumented = true;
    (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("error", $793a1419c4c7dbbf$var$errorCallback);
    (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("unhandledrejection", $793a1419c4c7dbbf$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $793a1419c4c7dbbf$var$errorCallback() {
    const activeTransaction = (0, $a08d109ecf5a6e0c$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = "internal_error";
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$793a1419c4c7dbbf$var$errorCallback.tag = "sentry_tracingErrorCallback";




/** Returns all trace headers that are currently on the top scope. */ function $38362a6c62754650$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        "sentry-trace": span.toTraceparent()
    } : {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function $38362a6c62754650$var$sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $5e7658a02f682731$export$5008da00b1b6dee6)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$38362a6c62754650$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $38362a6c62754650$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $da535ffc958c129e$export$c9f5652083b8129d)(rate) || !(typeof rate === "number" || typeof rate === "boolean")) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $38362a6c62754650$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || "sentry";
    const transactionInstrumenter = transactionContext.instrumenter || "sentry";
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $6c2f53509d093d65$export$febc5573c75cefb0)(transactionContext, this);
    transaction = $38362a6c62754650$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $38362a6c62754650$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $191a44eca504ebee$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = $38362a6c62754650$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit("startTransaction", transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $38362a6c62754650$export$653d0ef2bad9cdf9() {
    const carrier = (0, $1d80cfa15879bc41$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $38362a6c62754650$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $38362a6c62754650$var$traceHeaders;
    (0, $793a1419c4c7dbbf$export$637857c1d87b640c)();
}






var $j8hA7 = parcelRequire("j8hA7");
const $185df414121a9730$export$56d8a8a25bd48b81 = (0, $j8hA7.GLOBAL_OBJ);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $592d458c9830130e$export$6f18f55521af71a1() {
    if ((0, $185df414121a9730$export$56d8a8a25bd48b81) && (0, $185df414121a9730$export$56d8a8a25bd48b81).document) (0, $185df414121a9730$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeTransaction = (0, $a08d109ecf5a6e0c$export$a7feb32fdd923295)();
        if ((0, $185df414121a9730$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = "cancelled";
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag("visibilitychange", "document.hidden");
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}




var $1LeEK = parcelRequire("1LeEK");

const $65555167a401be57$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $04c27be6e21b33b7$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7497fddd1443ad24$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $185df414121a9730$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $185df414121a9730$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: "navigation",
        startTime: 0,
        type: type == 2 ? "back_forward" : type === 1 ? "reload" : "navigate"
    };
    for(const key in timing)if (key !== "navigationStart" && key !== "toJSON") // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $7497fddd1443ad24$export$6431553786c94949 = ()=>{
    if ((0, $185df414121a9730$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $185df414121a9730$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType("navigation")[0] || $7497fddd1443ad24$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $185df414121a9730$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType("navigation")[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7070e05269aeef2a$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $7497fddd1443ad24$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $419ae23ad2e69b67$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $7497fddd1443ad24$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $185df414121a9730$export$56d8a8a25bd48b81).document.prerendering || (0, $7070e05269aeef2a$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else navigationType = navEntry.type.replace(/_/g, "-");
    }
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: [],
        id: (0, $04c27be6e21b33b7$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $87b29f0c11ff937f$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3be1fa4301983731$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $185df414121a9730$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
            cb(event);
            if (once) {
                removeEventListener("visibilitychange", onHiddenOrPageHide, true);
                removeEventListener("pagehide", onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener("visibilitychange", onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener("pagehide", onHiddenOrPageHide, true);
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $d2d6230743379306$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $419ae23ad2e69b67$export$3c29b44508a0612b)("CLS", 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $87b29f0c11ff937f$export$d1203567a167490e)("layout-shift", handleEntries);
    if (po) {
        report = (0, $65555167a401be57$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $3be1fa4301983731$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $a920431fb9f53c32$var$firstHiddenTime = -1;
const $a920431fb9f53c32$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $185df414121a9730$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $185df414121a9730$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $a920431fb9f53c32$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $3be1fa4301983731$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $a920431fb9f53c32$var$firstHiddenTime = timeStamp;
    }, true);
};
const $a920431fb9f53c32$export$443f86b2c77012c4 = ()=>{
    if ($a920431fb9f53c32$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $a920431fb9f53c32$var$firstHiddenTime = $a920431fb9f53c32$var$initHiddenTime();
        $a920431fb9f53c32$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $a920431fb9f53c32$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $d657b59609f359ba$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $a920431fb9f53c32$export$443f86b2c77012c4)();
    const metric = (0, $419ae23ad2e69b67$export$3c29b44508a0612b)("FID");
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $87b29f0c11ff937f$export$d1203567a167490e)("first-input", handleEntries);
    report = (0, $65555167a401be57$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $3be1fa4301983731$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $77f01ff3cd4f18ae$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $77f01ff3cd4f18ae$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $a920431fb9f53c32$export$443f86b2c77012c4)();
    const metric = (0, $419ae23ad2e69b67$export$3c29b44508a0612b)("LCP");
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $7070e05269aeef2a$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $87b29f0c11ff937f$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
    if (po) {
        report = (0, $65555167a401be57$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$77f01ff3cd4f18ae$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $77f01ff3cd4f18ae$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            "keydown",
            "click"
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $3be1fa4301983731$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};




/**
 * Checks if a given value is a valid measurement value.
 */ function $1186999365b0f59a$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $1186999365b0f59a$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}


/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $6be3d2e22d37432e$var$msToSec(time) {
    return time / 1000;
}
function $6be3d2e22d37432e$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $185df414121a9730$export$56d8a8a25bd48b81) && (0, $185df414121a9730$export$56d8a8a25bd48b81).addEventListener && (0, $185df414121a9730$export$56d8a8a25bd48b81).performance;
}
let $6be3d2e22d37432e$var$_performanceCursor = 0;
let $6be3d2e22d37432e$var$_measurements = {};
let $6be3d2e22d37432e$var$_lcpEntry;
let $6be3d2e22d37432e$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $6be3d2e22d37432e$export$7c69f0412d101b88() {
    const performance = $6be3d2e22d37432e$var$getBrowserPerformanceAPI();
    if (performance && (0, $1LeEK.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $185df414121a9730$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        $6be3d2e22d37432e$var$_trackFID();
        const clsCallback = $6be3d2e22d37432e$var$_trackCLS();
        const lcpCallback = $6be3d2e22d37432e$var$_trackLCP();
        return ()=>{
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $6be3d2e22d37432e$export$f396d19077034ad2() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $a08d109ecf5a6e0c$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $6be3d2e22d37432e$var$msToSec((0, $1LeEK.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $6be3d2e22d37432e$var$msToSec(entry.duration);
            transaction.startChild({
                description: "Main UI thread blocked",
                op: "ui.long-task",
                origin: "auto.ui.browser.metrics",
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    };
    (0, $87b29f0c11ff937f$export$d1203567a167490e)("longtask", entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $6be3d2e22d37432e$export$e27543e0976315e4() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $a08d109ecf5a6e0c$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === "click") {
                const startTime = $6be3d2e22d37432e$var$msToSec((0, $1LeEK.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $6be3d2e22d37432e$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $10b7e35d980736f8$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: "auto.ui.browser.metrics",
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    };
    (0, $87b29f0c11ff937f$export$d1203567a167490e)("event", entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $6be3d2e22d37432e$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $d2d6230743379306$export$a7873055838e5ad8)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding CLS");
        $6be3d2e22d37432e$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $6be3d2e22d37432e$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $6be3d2e22d37432e$var$_trackLCP() {
    return (0, $77f01ff3cd4f18ae$export$947b1626ab8d5632)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding LCP");
        $6be3d2e22d37432e$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $6be3d2e22d37432e$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $6be3d2e22d37432e$var$_trackFID() {
    (0, $d657b59609f359ba$export$39705a25c49af873)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $6be3d2e22d37432e$var$msToSec((0, $1LeEK.browserPerformanceTimeOrigin));
        const startTime = $6be3d2e22d37432e$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding FID");
        $6be3d2e22d37432e$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $6be3d2e22d37432e$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
/** Add performance related spans to a transaction */ function $6be3d2e22d37432e$export$5f8fa6b3467a7443(transaction) {
    const performance = $6be3d2e22d37432e$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $185df414121a9730$export$56d8a8a25bd48b81).performance.getEntries || !(0, $1LeEK.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Tracing] Adding & adjusting spans using Performance API");
    const timeOrigin = $6be3d2e22d37432e$var$msToSec((0, $1LeEK.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($6be3d2e22d37432e$var$_performanceCursor).forEach((entry)=>{
        const startTime = $6be3d2e22d37432e$var$msToSec(entry.startTime);
        const duration = $6be3d2e22d37432e$var$msToSec(entry.duration);
        if (transaction.op === "navigation" && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case "navigation":
                $6be3d2e22d37432e$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $6be3d2e22d37432e$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $6be3d2e22d37432e$var$msToSec(entry.requestStart);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $6be3d2e22d37432e$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $a920431fb9f53c32$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding FP");
                        $6be3d2e22d37432e$var$_measurements["fp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    if (entry.name === "first-contentful-paint" && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding FCP");
                        $6be3d2e22d37432e$var$_measurements["fcp"] = {
                            value: entry.startTime,
                            unit: "millisecond"
                        };
                    }
                    break;
                }
            case "resource":
                {
                    const resourceName = entry.name.replace((0, $185df414121a9730$export$56d8a8a25bd48b81).location.origin, "");
                    $6be3d2e22d37432e$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $6be3d2e22d37432e$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $6be3d2e22d37432e$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === "pageload") {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === "number") {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding TTFB");
            $6be3d2e22d37432e$var$_measurements["ttfb"] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: "millisecond"
            };
            if (typeof requestStartTimestamp === "number" && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $6be3d2e22d37432e$var$_measurements["ttfb.requestTime"] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: "millisecond"
            };
        }
        [
            "fcp",
            "fp",
            "lcp"
        ].forEach((name)=>{
            if (!$6be3d2e22d37432e$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $6be3d2e22d37432e$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $6be3d2e22d37432e$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $6be3d2e22d37432e$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $6be3d2e22d37432e$var$_measurements["mark.fid"];
        if (fidMark && $6be3d2e22d37432e$var$_measurements["fid"]) {
            // create span for FID
            (0, $1186999365b0f59a$export$8bd469e1f37aa721)(transaction, {
                description: "first input delay",
                endTimestamp: fidMark.value + $6be3d2e22d37432e$var$msToSec($6be3d2e22d37432e$var$_measurements["fid"].value),
                op: "ui.action",
                origin: "auto.ui.browser.metrics",
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $6be3d2e22d37432e$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!("fcp" in $6be3d2e22d37432e$var$_measurements)) delete $6be3d2e22d37432e$var$_measurements.cls;
        Object.keys($6be3d2e22d37432e$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $6be3d2e22d37432e$var$_measurements[measurementName].value, $6be3d2e22d37432e$var$_measurements[measurementName].unit);
        });
        $6be3d2e22d37432e$var$_tagMetricInfo(transaction);
    }
    $6be3d2e22d37432e$var$_lcpEntry = undefined;
    $6be3d2e22d37432e$var$_clsEntry = undefined;
    $6be3d2e22d37432e$var$_measurements = {};
}
/** Create measure related spans */ function $6be3d2e22d37432e$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $1186999365b0f59a$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: "auto.resource.browser.metrics",
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6be3d2e22d37432e$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $6be3d2e22d37432e$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $6be3d2e22d37432e$var$_addPerformanceNavigationTiming(transaction, entry, "secureConnection", timeOrigin, "TLS/SSL", "connectEnd");
    $6be3d2e22d37432e$var$_addPerformanceNavigationTiming(transaction, entry, "fetch", timeOrigin, "cache", "domainLookupStart");
    $6be3d2e22d37432e$var$_addPerformanceNavigationTiming(transaction, entry, "domainLookup", timeOrigin, "DNS");
    $6be3d2e22d37432e$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $6be3d2e22d37432e$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $1186999365b0f59a$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: description || event,
        startTimestamp: timeOrigin + $6be3d2e22d37432e$var$msToSec(start),
        endTimestamp: timeOrigin + $6be3d2e22d37432e$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6be3d2e22d37432e$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $1186999365b0f59a$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "request",
        startTimestamp: timeOrigin + $6be3d2e22d37432e$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $6be3d2e22d37432e$var$msToSec(entry.responseEnd)
    });
    (0, $1186999365b0f59a$export$8bd469e1f37aa721)(transaction, {
        op: "browser",
        origin: "auto.browser.browser.metrics",
        description: "response",
        startTimestamp: timeOrigin + $6be3d2e22d37432e$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $6be3d2e22d37432e$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $6be3d2e22d37432e$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    if ("transferSize" in entry) data["http.response_transfer_size"] = entry.transferSize;
    if ("encodedBodySize" in entry) data["http.response_content_length"] = entry.encodedBodySize;
    if ("decodedBodySize" in entry) data["http.decoded_response_content_length"] = entry.decodedBodySize;
    if ("renderBlockingStatus" in entry) data["resource.render_blocking_status"] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $1186999365b0f59a$export$8bd469e1f37aa721)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        origin: "auto.resource.browser.metrics",
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $6be3d2e22d37432e$var$_trackNavigator(transaction) {
    const navigator = (0, $185df414121a9730$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag("effectiveConnectionType", connection.effectiveType);
        if (connection.type) transaction.setTag("connectionType", connection.type);
        if ((0, $1186999365b0f59a$export$27169ccae1b439e3)(connection.rtt)) $6be3d2e22d37432e$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $1186999365b0f59a$export$27169ccae1b439e3)(navigator.deviceMemory)) transaction.setTag("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $1186999365b0f59a$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) transaction.setTag("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $6be3d2e22d37432e$var$_tagMetricInfo(transaction) {
    if ($6be3d2e22d37432e$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding LCP Data");
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($6be3d2e22d37432e$var$_lcpEntry.element) transaction.setTag("lcp.element", (0, $10b7e35d980736f8$export$5647df6b7814ac86)($6be3d2e22d37432e$var$_lcpEntry.element));
        if ($6be3d2e22d37432e$var$_lcpEntry.id) transaction.setTag("lcp.id", $6be3d2e22d37432e$var$_lcpEntry.id);
        if ($6be3d2e22d37432e$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag("lcp.url", $6be3d2e22d37432e$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag("lcp.size", $6be3d2e22d37432e$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($6be3d2e22d37432e$var$_clsEntry && $6be3d2e22d37432e$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Measurements] Adding CLS Data");
        $6be3d2e22d37432e$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $10b7e35d980736f8$export$5647df6b7814ac86)(source.node)));
    }
}




var $1LeEK = parcelRequire("1LeEK");
/* eslint-disable max-lines */ const $2cff9a46cd404d69$export$15bd0305d05ad07b = [
    "localhost",
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $2cff9a46cd404d69$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $2cff9a46cd404d69$export$15bd0305d05ad07b,
    tracePropagationTargets: $2cff9a46cd404d69$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $2cff9a46cd404d69$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $2cff9a46cd404d69$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $2cff9a46cd404d69$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$2cff9a46cd404d69$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("fetch", (handlerData)=>{
        const createdSpan = $2cff9a46cd404d69$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $2cff9a46cd404d69$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("xhr", (handlerData)=>{
        const createdSpan = $2cff9a46cd404d69$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $2cff9a46cd404d69$var$addHTTPTimings(createdSpan);
    });
}
function $2cff9a46cd404d69$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $2cff9a46cd404d69$var$addHTTPTimings(span) {
    const url = span.data.url;
    const observer = new PerformanceObserver((list)=>{
        const entries = list.getEntries();
        entries.forEach((entry)=>{
            if ($2cff9a46cd404d69$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $2cff9a46cd404d69$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setData(...data));
                observer.disconnect();
            }
        });
    });
    observer.observe({
        entryTypes: [
            "resource"
        ]
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $2cff9a46cd404d69$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $2cff9a46cd404d69$var$getAbsoluteTime(time = 0) {
    return (((0, $1LeEK.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function $2cff9a46cd404d69$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $2cff9a46cd404d69$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $1LeEK.browserPerformanceTimeOrigin)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $2cff9a46cd404d69$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $2cff9a46cd404d69$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $07665083d6e876d3$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $2cff9a46cd404d69$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $2cff9a46cd404d69$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $5e7658a02f682731$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
                const contentLength = // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                handlerData.response && handlerData.response.headers && handlerData.response.headers.get("content-length");
                const contentLengthNum = parseInt(contentLength);
                if (contentLengthNum > 0) span.setData("http.response_content_length", contentLengthNum);
            } else if (handlerData.error) span.setStatus("internal_error");
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    const client = hub.getClient();
    const parentSpan = scope.getSpan();
    const { method: method, url: url } = handlerData.fetchData;
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            url: url,
            type: "fetch",
            "http.method": method
        },
        description: `${method} ${url}`,
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $2cff9a46cd404d69$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $2cff9a46cd404d69$export$6717acf674206871(request, client, scope, options, requestSpan) {
    const span = requestSpan || scope.getSpan();
    const transaction = span && span.transaction;
    const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
    const sentryTraceHeader = span ? span.toTraceparent() : (0, $a48211d39a0e0319$export$f35d907436da45cf)(traceId, undefined, sampled);
    const dynamicSamplingContext = transaction ? transaction.getDynamicSamplingContext() : dsc ? dsc : (0, $3af65ebbd3ebee85$export$366bad00d6815eed)(traceId, client, scope);
    const sentryBaggageHeader = (0, $696812169dc7e4a9$export$56766feef403f365)(dynamicSamplingContext);
    const headers = typeof Request !== "undefined" && (0, $da535ffc958c129e$export$49034edbe6b62415)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        "sentry-trace": sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== "undefined" && (0, $da535ffc958c129e$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $696812169dc7e4a9$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                "sentry-trace",
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $696812169dc7e4a9$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            "sentry-trace": sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $2cff9a46cd404d69$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $ff6cab9022b0c01d$export$55b6bb1e45c6cf59];
    if (!(0, $5e7658a02f682731$export$5008da00b1b6dee6)() || xhr && xhr.__sentry_own_request__ || !xhr || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            span.setHttpStatus(sentryXhrData.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const scope = hub.getScope();
    const parentSpan = scope.getSpan();
    const span = shouldCreateSpanResult && parentSpan ? parentSpan.startChild({
        data: {
            ...sentryXhrData.data,
            type: "xhr",
            "http.method": sentryXhrData.method,
            url: sentryXhrData.url
        },
        description: `${sentryXhrData.method} ${sentryXhrData.url}`,
        op: "http.client",
        origin: "auto.http.browser"
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url)) {
        if (span) {
            const transaction = span && span.transaction;
            const dynamicSamplingContext = transaction && transaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $696812169dc7e4a9$export$56766feef403f365)(dynamicSamplingContext);
            $2cff9a46cd404d69$var$setHeaderOnXhr(xhr, span.toTraceparent(), sentryBaggageHeader);
        } else {
            const client = hub.getClient();
            const { traceId: traceId, sampled: sampled, dsc: dsc } = scope.getPropagationContext();
            const sentryTraceHeader = (0, $a48211d39a0e0319$export$f35d907436da45cf)(traceId, undefined, sampled);
            const dynamicSamplingContext = dsc || (client ? (0, $3af65ebbd3ebee85$export$366bad00d6815eed)(traceId, client, scope) : undefined);
            const sentryBaggageHeader = (0, $696812169dc7e4a9$export$56766feef403f365)(dynamicSamplingContext);
            $2cff9a46cd404d69$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
        }
    }
    return span;
}
function $2cff9a46cd404d69$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $696812169dc7e4a9$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}



var $1LeEK = parcelRequire("1LeEK");

/**
 * Default function implementing pageload and navigation transactions
 */ function $0b4447c8cb55b72a$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $185df414121a9730$export$56d8a8a25bd48b81) || !(0, $185df414121a9730$export$56d8a8a25bd48b81).location) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Could not initialize routing instrumentation due to invalid location");
        return;
    }
    let startingUrl = (0, $185df414121a9730$export$56d8a8a25bd48b81).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $185df414121a9730$export$56d8a8a25bd48b81).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, $1LeEK.browserPerformanceTimeOrigin) ? (0, $1LeEK.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: "pageload",
        origin: "auto.pageload.browser",
        metadata: {
            source: "url"
        }
    });
    if (startTransactionOnLocationChange) (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("history", ({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $185df414121a9730$export$56d8a8a25bd48b81).location.pathname,
                op: "navigation",
                origin: "auto.navigation.browser",
                metadata: {
                    source: "url"
                }
            });
        }
    });
}



const $a03bb66ebe33cb7a$export$bbd2089f30bd3708 = "BrowserTracing";
/** Options for Browser Tracing integration */ const $a03bb66ebe33cb7a$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $191a44eca504ebee$export$809a2b7987fd5306),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $0b4447c8cb55b72a$export$86649cc09fe75143),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $2cff9a46cd404d69$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $a03bb66ebe33cb7a$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ constructor(_options){
        this.name = $a03bb66ebe33cb7a$export$bbd2089f30bd3708;
        this._hasSetTracePropagationTargets = false;
        (0, $38362a6c62754650$export$653d0ef2bad9cdf9)();
        if (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = {
            ...$a03bb66ebe33cb7a$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $6be3d2e22d37432e$export$7c69f0412d101b88)();
        if (this.options.enableLongTask) (0, $6be3d2e22d37432e$export$f396d19077034ad2)();
        if (this.options._experiments.enableInteractions) (0, $6be3d2e22d37432e$export$e27543e0976315e4)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const hub = getCurrentHub();
        const client = hub.getClient();
        const clientOptions = client && client.getOptions();
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = this.options;
        const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
        // There are three ways to configure tracePropagationTargets:
        // 1. via top level client option `tracePropagationTargets`
        // 2. via BrowserTracing option `tracePropagationTargets`
        // 3. via BrowserTracing option `tracingOrigins` (deprecated)
        //
        // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
        // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
        // This is done as it minimizes bundle size (we don't have to have undefined checks).
        //
        // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
        // eslint-disable-next-line deprecation/deprecation
        const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $eace895db919f450$export$af88d00dbe7f521).warn("[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.");
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $592d458c9830130e$export$6f18f55521af71a1)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $2cff9a46cd404d69$export$864489cb3478db3e)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest,
            enableHTTPTimings: enableHTTPTimings
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const hub = this._getCurrentHub();
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === "pageload";
        const sentryTrace = isPageloadTransaction ? $a03bb66ebe33cb7a$export$f147b32b03c9cf11("sentry-trace") : "";
        const baggage = isPageloadTransaction ? $a03bb66ebe33cb7a$export$f147b32b03c9cf11("baggage") : "";
        const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $a48211d39a0e0319$export$ca5c066532785b6e)(sentryTrace, baggage);
        const expandedContext = {
            ...context,
            ...traceparentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === "function" ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: "custom"
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $185df414121a9730$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $38362a6c62754650$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        const scope = hub.getScope();
        // If it's a pageload and there is a meta tag set
        // use the traceparentData as the propagation context
        if (isPageloadTransaction && traceparentData) scope.setPropagationContext(propagationContext);
        else // Navigation transactions should set a new propagation context based on the
        // created idle transaction.
        scope.setPropagationContext({
            traceId: idleTransaction.traceId,
            spanId: idleTransaction.spanId,
            parentSpanId: idleTransaction.parentSpanId,
            sampled: idleTransaction.sampled
        });
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $6be3d2e22d37432e$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = "ui.action.click";
            const currentTransaction = (0, $a08d109ecf5a6e0c$export$a7feb32fdd923295)();
            if (currentTransaction && currentTransaction.op && [
                "navigation",
                "pageload"
            ].includes(currentTransaction.op)) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason("interactionInterrupted");
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $185df414121a9730$export$56d8a8a25bd48b81);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || "url"
                }
            };
            inflightInteractionTransaction = (0, $38362a6c62754650$export$479dbd817e392a4f)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            "click"
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $a03bb66ebe33cb7a$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $10b7e35d980736f8$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute("content") : undefined;
}



var $j8hA7 = parcelRequire("j8hA7");
var $1LeEK = parcelRequire("1LeEK");
var $g11oe = parcelRequire("g11oe");

var $6qd2L = parcelRequire("6qd2L");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $387daa7ca38f1a5d$var$WINDOW = (0, $j8hA7.GLOBAL_OBJ);
const $387daa7ca38f1a5d$var$REPLAY_SESSION_KEY = "sentryReplaySession";
const $387daa7ca38f1a5d$var$REPLAY_EVENT_NAME = "replay_event";
const $387daa7ca38f1a5d$var$UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
// The idle limit for a session after which recording is paused.
const $387daa7ca38f1a5d$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $387daa7ca38f1a5d$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $387daa7ca38f1a5d$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $387daa7ca38f1a5d$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $387daa7ca38f1a5d$var$BUFFER_CHECKOUT_TIME = 60000;
const $387daa7ca38f1a5d$var$RETRY_BASE_INTERVAL = 5000;
const $387daa7ca38f1a5d$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $387daa7ca38f1a5d$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $387daa7ca38f1a5d$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $387daa7ca38f1a5d$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $387daa7ca38f1a5d$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $387daa7ca38f1a5d$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $387daa7ca38f1a5d$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $387daa7ca38f1a5d$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $387daa7ca38f1a5d$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
var $387daa7ca38f1a5d$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($387daa7ca38f1a5d$var$NodeType$1 || ($387daa7ca38f1a5d$var$NodeType$1 = {}));
function $387daa7ca38f1a5d$var$isElement(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $387daa7ca38f1a5d$var$isShadowRoot(n) {
    const host = n === null || n === void 0 ? void 0 : n.host;
    return Boolean(host && host.shadowRoot && host.shadowRoot === n);
}
function $387daa7ca38f1a5d$var$isInputTypeMasked({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName.toLowerCase() === "option") tagName = "select";
    const actualType = typeof type === "string" ? type.toLowerCase() : undefined;
    return maskInputOptions[tagName.toLowerCase()] || actualType && maskInputOptions[actualType] || actualType === "password" || tagName === "input" && !type && maskInputOptions["text"];
}
function $387daa7ca38f1a5d$var$hasInputMaskOptions({ tagName: tagName, type: type, maskInputOptions: maskInputOptions, maskInputSelector: maskInputSelector }) {
    return maskInputSelector || $387daa7ca38f1a5d$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    });
}
function $387daa7ca38f1a5d$var$maskInputValue({ input: input, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskInputOptions: maskInputOptions, tagName: tagName, type: type, value: value, maskInputFn: maskInputFn }) {
    let text = value || "";
    if (unmaskInputSelector && input.matches(unmaskInputSelector)) return text;
    if (input.hasAttribute("data-rr-is-password")) type = "password";
    if ($387daa7ca38f1a5d$var$isInputTypeMasked({
        maskInputOptions: maskInputOptions,
        tagName: tagName,
        type: type
    }) || maskInputSelector && input.matches(maskInputSelector)) {
        if (maskInputFn) text = maskInputFn(text);
        else text = "*".repeat(text.length);
    }
    return text;
}
const $387daa7ca38f1a5d$var$ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function $387daa7ca38f1a5d$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext("2d");
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $387daa7ca38f1a5d$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$387daa7ca38f1a5d$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $387daa7ca38f1a5d$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute("data-rr-is-password") ? "password" : type ? type.toLowerCase() : null;
}
function $387daa7ca38f1a5d$var$getInputValue(el, tagName, type) {
    typeof type === "string" && type.toLowerCase();
    if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) return el.getAttribute("value") || "";
    return el.value;
}
let $387daa7ca38f1a5d$var$_id = 1;
const $387daa7ca38f1a5d$var$tagNameRegex = new RegExp("[^a-z0-9-_:]");
const $387daa7ca38f1a5d$var$IGNORED_NODE = -2;
function $387daa7ca38f1a5d$var$defaultMaskFn(str) {
    return str ? str.replace(/[\S]/g, "*") : "";
}
function $387daa7ca38f1a5d$var$genId() {
    return $387daa7ca38f1a5d$var$_id++;
}
function $387daa7ca38f1a5d$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return "form";
    const processedTagName = element.tagName.toLowerCase().trim();
    if ($387daa7ca38f1a5d$var$tagNameRegex.test(processedTagName)) return "div";
    return processedTagName;
}
function $387daa7ca38f1a5d$var$getCssRulesString(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? Array.from(rules).map($387daa7ca38f1a5d$var$getCssRuleString).join("") : null;
    } catch (error) {
        return null;
    }
}
function $387daa7ca38f1a5d$var$getCssRuleString(rule) {
    let cssStringified = rule.cssText;
    if ($387daa7ca38f1a5d$var$isCSSImportRule(rule)) try {
        cssStringified = $387daa7ca38f1a5d$var$getCssRulesString(rule.styleSheet) || cssStringified;
    } catch (_a) {}
    return $387daa7ca38f1a5d$var$validateStringifiedCssRule(cssStringified);
}
function $387daa7ca38f1a5d$var$validateStringifiedCssRule(cssStringified) {
    if (cssStringified.indexOf(":") > -1) {
        const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
        return cssStringified.replace(regex, "$1\\$2");
    }
    return cssStringified;
}
function $387daa7ca38f1a5d$var$isCSSImportRule(rule) {
    return "styleSheet" in rule;
}
function $387daa7ca38f1a5d$var$stringifyStyleSheet(sheet) {
    return sheet.cssRules ? Array.from(sheet.cssRules).map((rule)=>rule.cssText ? $387daa7ca38f1a5d$var$validateStringifiedCssRule(rule.cssText) : "").join("") : "";
}
function $387daa7ca38f1a5d$var$extractOrigin(url) {
    let origin = "";
    if (url.indexOf("//") > -1) origin = url.split("/").slice(0, 3).join("/");
    else origin = url.split("/")[0];
    origin = origin.split("?")[0];
    return origin;
}
let $387daa7ca38f1a5d$var$canvasService;
let $387daa7ca38f1a5d$var$canvasCtx;
const $387daa7ca38f1a5d$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $387daa7ca38f1a5d$var$RELATIVE_PATH = /^(?!www\.|(?:http|ftp)s?:\/\/|[A-Za-z]:\\|\/\/|#).*/;
const $387daa7ca38f1a5d$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $387daa7ca38f1a5d$var$absoluteToStylesheet(cssText, href) {
    return (cssText || "").replace($387daa7ca38f1a5d$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || "";
        if (!filePath) return origin;
        if (!$387daa7ca38f1a5d$var$RELATIVE_PATH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($387daa7ca38f1a5d$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === "/") return `url(${maybeQuote}${$387daa7ca38f1a5d$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split("/");
        const parts = filePath.split("/");
        stack.pop();
        for (const part of parts){
            if (part === ".") continue;
            else if (part === "..") stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    });
}
const $387daa7ca38f1a5d$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $387daa7ca38f1a5d$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $387daa7ca38f1a5d$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === "") return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        let match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return "";
    }
    let output = [];
    while(true){
        collectCharacters($387daa7ca38f1a5d$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($387daa7ca38f1a5d$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ",") {
            url = $387daa7ca38f1a5d$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = "";
            url = $387daa7ca38f1a5d$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                let c = attributeValue.charAt(pos);
                if (c === "") {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ",") {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === "(") inParens = true;
                } else if (c === ")") inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(", ");
}
function $387daa7ca38f1a5d$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === "") return attributeValue;
    const a = doc.createElement("a");
    a.href = attributeValue;
    return a.href;
}
function $387daa7ca38f1a5d$var$isSVGElement(el) {
    return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function $387daa7ca38f1a5d$var$getHref() {
    const a = document.createElement("a");
    a.href = "";
    return a.href;
}
function $387daa7ca38f1a5d$var$transformAttribute(doc, element, _tagName, _name, value, maskAllText, unmaskTextSelector, maskTextFn) {
    if (!value) return value;
    const name = _name.toLowerCase();
    const tagName = _tagName.toLowerCase();
    if (name === "src" || name === "href") return $387daa7ca38f1a5d$var$absoluteToDoc(doc, value);
    else if (name === "xlink:href" && value[0] !== "#") return $387daa7ca38f1a5d$var$absoluteToDoc(doc, value);
    else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) return $387daa7ca38f1a5d$var$absoluteToDoc(doc, value);
    else if (name === "srcset") return $387daa7ca38f1a5d$var$getAbsoluteSrcsetString(doc, value);
    else if (name === "style") return $387daa7ca38f1a5d$var$absoluteToStylesheet(value, $387daa7ca38f1a5d$var$getHref());
    else if (tagName === "object" && name === "data") return $387daa7ca38f1a5d$var$absoluteToDoc(doc, value);
    else if (maskAllText && $387daa7ca38f1a5d$var$_shouldMaskAttribute(element, name, tagName, unmaskTextSelector)) return maskTextFn ? maskTextFn(value) : $387daa7ca38f1a5d$var$defaultMaskFn(value);
    return value;
}
function $387daa7ca38f1a5d$var$_shouldMaskAttribute(element, attribute, tagName, unmaskTextSelector) {
    if (unmaskTextSelector && element.matches(unmaskTextSelector)) return false;
    return [
        "placeholder",
        "title",
        "aria-label"
    ].indexOf(attribute) > -1 || tagName === "input" && attribute === "value" && element.hasAttribute("type") && [
        "submit",
        "button"
    ].indexOf(element.getAttribute("type").toLowerCase()) > -1;
}
function $387daa7ca38f1a5d$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    if (unblockSelector && element.matches(unblockSelector)) return false;
    if (typeof blockClass === "string") {
        if (element.classList.contains(blockClass)) return true;
    } else for(let eIndex = 0; eIndex < element.classList.length; eIndex++){
        const className = element.classList[eIndex];
        if (blockClass.test(className)) return true;
    }
    if (blockSelector) return element.matches(blockSelector);
    return false;
}
function $387daa7ca38f1a5d$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) {
    if (!node) return false;
    if (node.nodeType !== node.ELEMENT_NODE) return $387daa7ca38f1a5d$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
    if (unmaskTextSelector) {
        if (node.matches(unmaskTextSelector) || node.closest(unmaskTextSelector)) return false;
    }
    if (maskAllText) return true;
    if (typeof maskTextClass === "string") {
        if (node.classList.contains(maskTextClass)) return true;
    } else for(let eIndex = 0; eIndex < node.classList.length; eIndex++){
        const className = node.classList[eIndex];
        if (maskTextClass.test(className)) return true;
    }
    if (maskTextSelector) {
        if (node.matches(maskTextSelector)) return true;
    }
    return $387daa7ca38f1a5d$var$needMaskingText(node.parentNode, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText);
}
function $387daa7ca38f1a5d$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== "complete") {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener("load", ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = "about:blank";
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
        setTimeout(listener, 0);
        return;
    }
    iframeEl.addEventListener("load", listener);
}
function $387daa7ca38f1a5d$var$serializeNode(n, options) {
    var _a;
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskAllText: maskAllText, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn } = options;
    let rootId;
    if (doc.__sn) {
        const docId = doc.__sn.id;
        rootId = docId === 1 ? undefined : docId;
    }
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== "CSS1Compat") return {
                type: $387daa7ca38f1a5d$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode,
                rootId: rootId
            };
            else return {
                type: $387daa7ca38f1a5d$var$NodeType$1.Document,
                childNodes: [],
                rootId: rootId
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $387daa7ca38f1a5d$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            const needBlock = $387daa7ca38f1a5d$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
            const tagName = $387daa7ca38f1a5d$var$getValidTagName(n);
            let attributes = {};
            for (const { name: name, value: value } of Array.from(n.attributes))if (!$387daa7ca38f1a5d$var$skipAttribute(tagName, name)) attributes[name] = $387daa7ca38f1a5d$var$transformAttribute(doc, n, tagName, name, value, maskAllText, unmaskTextSelector, maskTextFn);
            if (tagName === "link" && inlineStylesheet) {
                const stylesheet = Array.from(doc.styleSheets).find((s)=>{
                    return s.href === n.href;
                });
                let cssText = null;
                if (stylesheet) cssText = $387daa7ca38f1a5d$var$getCssRulesString(stylesheet);
                if (cssText) {
                    delete attributes.rel;
                    delete attributes.href;
                    attributes._cssText = $387daa7ca38f1a5d$var$absoluteToStylesheet(cssText, stylesheet.href);
                }
            }
            if (tagName === "style" && n.sheet && !(n.innerText || n.textContent || "").trim().length) {
                const cssText = $387daa7ca38f1a5d$var$getCssRulesString(n.sheet);
                if (cssText) attributes._cssText = $387daa7ca38f1a5d$var$absoluteToStylesheet(cssText, $387daa7ca38f1a5d$var$getHref());
            }
            if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
                const el = n;
                const type = $387daa7ca38f1a5d$var$getInputType(el);
                const value = $387daa7ca38f1a5d$var$getInputValue(el, tagName.toUpperCase(), type);
                const checked = n.checked;
                if (type !== "submit" && type !== "button" && value) attributes.value = $387daa7ca38f1a5d$var$maskInputValue({
                    input: el,
                    type: type,
                    tagName: tagName,
                    value: value,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
                if (checked) attributes.checked = checked;
            }
            if (tagName === "option") {
                if (n.selected && !maskInputOptions["select"]) attributes.selected = true;
                else delete attributes.selected;
            }
            if (tagName === "canvas" && recordCanvas) {
                if (n.__context === "2d") {
                    if (!$387daa7ca38f1a5d$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                } else if (!("__context" in n)) {
                    const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    const blankCanvas = document.createElement("canvas");
                    blankCanvas.width = n.width;
                    blankCanvas.height = n.height;
                    const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
                }
            }
            if (tagName === "img" && inlineImages) {
                if (!$387daa7ca38f1a5d$var$canvasService) {
                    $387daa7ca38f1a5d$var$canvasService = doc.createElement("canvas");
                    $387daa7ca38f1a5d$var$canvasCtx = $387daa7ca38f1a5d$var$canvasService.getContext("2d");
                }
                const image = n;
                const oldValue = image.crossOrigin;
                image.crossOrigin = "anonymous";
                const recordInlineImage = ()=>{
                    try {
                        $387daa7ca38f1a5d$var$canvasService.width = image.naturalWidth;
                        $387daa7ca38f1a5d$var$canvasService.height = image.naturalHeight;
                        $387daa7ca38f1a5d$var$canvasCtx.drawImage(image, 0, 0);
                        attributes.rr_dataURL = $387daa7ca38f1a5d$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
                    } catch (err) {
                        console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
                    }
                    oldValue ? attributes.crossOrigin = oldValue : delete attributes.crossOrigin;
                };
                if (image.complete && image.naturalWidth !== 0) recordInlineImage();
                else image.onload = recordInlineImage;
            }
            if (tagName === "audio" || tagName === "video") {
                attributes.rr_mediaState = n.paused ? "paused" : "played";
                attributes.rr_mediaCurrentTime = n.currentTime;
            }
            if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
            if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
            if (needBlock) {
                const { width: width, height: height } = n.getBoundingClientRect();
                attributes = {
                    class: attributes.class,
                    rr_width: `${width}px`,
                    rr_height: `${height}px`
                };
            }
            if (tagName === "iframe" && !keepIframeSrcFn(attributes.src)) {
                if (!n.contentDocument) attributes.rr_src = attributes.src;
                delete attributes.src;
            }
            return {
                type: $387daa7ca38f1a5d$var$NodeType$1.Element,
                tagName: tagName,
                attributes: attributes,
                childNodes: [],
                isSVG: $387daa7ca38f1a5d$var$isSVGElement(n) || undefined,
                needBlock: needBlock,
                rootId: rootId
            };
        case n.TEXT_NODE:
            const parentTagName = n.parentNode && n.parentNode.tagName;
            let textContent = n.textContent;
            const isStyle = parentTagName === "STYLE" ? true : undefined;
            const isScript = parentTagName === "SCRIPT" ? true : undefined;
            if (isStyle && textContent) {
                try {
                    if (n.nextSibling || n.previousSibling) ;
                    else if ((_a = n.parentNode.sheet) === null || _a === void 0 ? void 0 : _a.cssRules) textContent = $387daa7ca38f1a5d$var$stringifyStyleSheet(n.parentNode.sheet);
                } catch (err) {
                    console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
                }
                textContent = $387daa7ca38f1a5d$var$absoluteToStylesheet(textContent, $387daa7ca38f1a5d$var$getHref());
            }
            if (isScript) textContent = "SCRIPT_PLACEHOLDER";
            if (parentTagName === "TEXTAREA" && textContent) textContent = "";
            else if (parentTagName === "OPTION" && textContent) {
                const option = n.parentNode;
                textContent = $387daa7ca38f1a5d$var$maskInputValue({
                    input: option,
                    type: null,
                    tagName: parentTagName,
                    value: textContent,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    maskInputOptions: maskInputOptions,
                    maskInputFn: maskInputFn
                });
            } else if (!isStyle && !isScript && $387daa7ca38f1a5d$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextSelector, maskAllText) && textContent) textContent = maskTextFn ? maskTextFn(textContent) : $387daa7ca38f1a5d$var$defaultMaskFn(textContent);
            return {
                type: $387daa7ca38f1a5d$var$NodeType$1.Text,
                textContent: textContent || "",
                isStyle: isStyle,
                rootId: rootId
            };
        case n.CDATA_SECTION_NODE:
            return {
                type: $387daa7ca38f1a5d$var$NodeType$1.CDATA,
                textContent: "",
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $387daa7ca38f1a5d$var$NodeType$1.Comment,
                textContent: n.textContent || "",
                rootId: rootId
            };
        default:
            return false;
    }
}
function $387daa7ca38f1a5d$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return "";
    else return maybeAttr.toLowerCase();
}
function $387daa7ca38f1a5d$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $387daa7ca38f1a5d$var$NodeType$1.Comment) return true;
    else if (sn.type === $387daa7ca38f1a5d$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === "script" || sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") && sn.attributes.as === "script" || sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && sn.attributes.href.endsWith(".js"))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && ($387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "application-name" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.rel) === "icon" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.rel) === "shortcut icon"))) return true;
        else if (sn.tagName === "meta") {
            if (slimDOMOptions.headMetaDescKeywords && $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "pinterest")) return true;
            else if (slimDOMOptions.headMetaRobots && ($387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "robots" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "googlebot" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "bingbot")) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "author" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "generator" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "framework" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "publisher" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "progid" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "google-site-verification" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "yandex-verification" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "csrf-token" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "p:domain_verify" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "verify-v1" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "verification" || $387daa7ca38f1a5d$var$lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) return true;
        }
    }
    return false;
}
function $387daa7ca38f1a5d$var$serializeNodeWithId(n, options) {
    const { doc: doc, map: map, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskTextClass: maskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskAllText: maskAllText, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $387daa7ca38f1a5d$var$serializeNode(n, {
        doc: doc,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputSelector: maskInputSelector,
        unmaskInputSelector: unmaskInputSelector,
        maskAllText: maskAllText,
        maskInputOptions: maskInputOptions,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn
    });
    if (!_serializedNode) {
        console.warn(n, "not serialized");
        return null;
    }
    let id;
    if ("__sn" in n) id = n.__sn.id;
    else if ($387daa7ca38f1a5d$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $387daa7ca38f1a5d$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, "").length) id = $387daa7ca38f1a5d$var$IGNORED_NODE;
    else id = $387daa7ca38f1a5d$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    n.__sn = serializedNode;
    if (id === $387daa7ca38f1a5d$var$IGNORED_NODE) return null;
    map[id] = n;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $387daa7ca38f1a5d$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        if (n.shadowRoot) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $387daa7ca38f1a5d$var$NodeType$1.Document || serializedNode.type === $387daa7ca38f1a5d$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && _serializedNode.type === $387daa7ca38f1a5d$var$NodeType$1.Element && _serializedNode.tagName === "head") preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            map: map,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $387daa7ca38f1a5d$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($387daa7ca38f1a5d$var$isElement(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $387daa7ca38f1a5d$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                serializedChildNode.isShadow = true;
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $387daa7ca38f1a5d$var$isShadowRoot(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $387daa7ca38f1a5d$var$NodeType$1.Element && serializedNode.tagName === "iframe") $387daa7ca38f1a5d$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $387daa7ca38f1a5d$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                map: map,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskAllText: maskAllText,
                maskInputOptions: maskInputOptions,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    return serializedNode;
}
function $387daa7ca38f1a5d$var$snapshot(n, options) {
    const { blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskTextClass: maskTextClass = "rr-mask", maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskInputSelector: maskInputSelector = null, unmaskInputSelector: unmaskInputSelector = null, maskAllText: maskAllText = false, maskAllInputs: maskAllInputs = false, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const idNodeMap = {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === "all",
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return [
        $387daa7ca38f1a5d$var$serializeNodeWithId(n, {
            doc: n,
            map: idNodeMap,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: false,
            inlineStylesheet: inlineStylesheet,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        }),
        idNodeMap
    ];
}
function $387daa7ca38f1a5d$var$skipAttribute(tagName, attributeName, value) {
    return (tagName === "video" || tagName === "audio") && attributeName === "autoplay";
}
var $387daa7ca38f1a5d$var$EventType;
(function(EventType) {
    EventType[EventType["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType[EventType["Load"] = 1] = "Load";
    EventType[EventType["FullSnapshot"] = 2] = "FullSnapshot";
    EventType[EventType["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType[EventType["Meta"] = 4] = "Meta";
    EventType[EventType["Custom"] = 5] = "Custom";
    EventType[EventType["Plugin"] = 6] = "Plugin";
})($387daa7ca38f1a5d$var$EventType || ($387daa7ca38f1a5d$var$EventType = {}));
var $387daa7ca38f1a5d$var$IncrementalSource;
(function(IncrementalSource) {
    IncrementalSource[IncrementalSource["Mutation"] = 0] = "Mutation";
    IncrementalSource[IncrementalSource["MouseMove"] = 1] = "MouseMove";
    IncrementalSource[IncrementalSource["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource[IncrementalSource["Scroll"] = 3] = "Scroll";
    IncrementalSource[IncrementalSource["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource[IncrementalSource["Input"] = 5] = "Input";
    IncrementalSource[IncrementalSource["TouchMove"] = 6] = "TouchMove";
    IncrementalSource[IncrementalSource["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource[IncrementalSource["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource[IncrementalSource["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource[IncrementalSource["Font"] = 10] = "Font";
    IncrementalSource[IncrementalSource["Log"] = 11] = "Log";
    IncrementalSource[IncrementalSource["Drag"] = 12] = "Drag";
    IncrementalSource[IncrementalSource["StyleDeclaration"] = 13] = "StyleDeclaration";
})($387daa7ca38f1a5d$var$IncrementalSource || ($387daa7ca38f1a5d$var$IncrementalSource = {}));
var $387daa7ca38f1a5d$var$MouseInteractions;
(function(MouseInteractions) {
    MouseInteractions[MouseInteractions["MouseUp"] = 0] = "MouseUp";
    MouseInteractions[MouseInteractions["MouseDown"] = 1] = "MouseDown";
    MouseInteractions[MouseInteractions["Click"] = 2] = "Click";
    MouseInteractions[MouseInteractions["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions[MouseInteractions["DblClick"] = 4] = "DblClick";
    MouseInteractions[MouseInteractions["Focus"] = 5] = "Focus";
    MouseInteractions[MouseInteractions["Blur"] = 6] = "Blur";
    MouseInteractions[MouseInteractions["TouchStart"] = 7] = "TouchStart";
    MouseInteractions[MouseInteractions["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions[MouseInteractions["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions[MouseInteractions["TouchCancel"] = 10] = "TouchCancel";
})($387daa7ca38f1a5d$var$MouseInteractions || ($387daa7ca38f1a5d$var$MouseInteractions = {}));
var $387daa7ca38f1a5d$var$CanvasContext;
(function(CanvasContext) {
    CanvasContext[CanvasContext["2D"] = 0] = "2D";
    CanvasContext[CanvasContext["WebGL"] = 1] = "WebGL";
    CanvasContext[CanvasContext["WebGL2"] = 2] = "WebGL2";
})($387daa7ca38f1a5d$var$CanvasContext || ($387daa7ca38f1a5d$var$CanvasContext = {}));
var $387daa7ca38f1a5d$var$MediaInteractions;
(function(MediaInteractions) {
    MediaInteractions[MediaInteractions["Play"] = 0] = "Play";
    MediaInteractions[MediaInteractions["Pause"] = 1] = "Pause";
    MediaInteractions[MediaInteractions["Seeked"] = 2] = "Seeked";
    MediaInteractions[MediaInteractions["VolumeChange"] = 3] = "VolumeChange";
})($387daa7ca38f1a5d$var$MediaInteractions || ($387daa7ca38f1a5d$var$MediaInteractions = {}));
var $387daa7ca38f1a5d$var$ReplayerEvents;
(function(ReplayerEvents) {
    ReplayerEvents["Start"] = "start";
    ReplayerEvents["Pause"] = "pause";
    ReplayerEvents["Resume"] = "resume";
    ReplayerEvents["Resize"] = "resize";
    ReplayerEvents["Finish"] = "finish";
    ReplayerEvents["FullsnapshotRebuilded"] = "fullsnapshot-rebuilded";
    ReplayerEvents["LoadStylesheetStart"] = "load-stylesheet-start";
    ReplayerEvents["LoadStylesheetEnd"] = "load-stylesheet-end";
    ReplayerEvents["SkipStart"] = "skip-start";
    ReplayerEvents["SkipEnd"] = "skip-end";
    ReplayerEvents["MouseInteraction"] = "mouse-interaction";
    ReplayerEvents["EventCast"] = "event-cast";
    ReplayerEvents["CustomEvent"] = "custom-event";
    ReplayerEvents["Flush"] = "flush";
    ReplayerEvents["StateChange"] = "state-change";
    ReplayerEvents["PlayBack"] = "play-back";
})($387daa7ca38f1a5d$var$ReplayerEvents || ($387daa7ca38f1a5d$var$ReplayerEvents = {}));
function $387daa7ca38f1a5d$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
function $387daa7ca38f1a5d$var$createMirror() {
    return {
        map: {},
        getId (n) {
            if (!n || !n.__sn) return -1;
            return n.__sn.id;
        },
        getNode (id) {
            return this.map[id] || null;
        },
        removeNodeFromMap (n) {
            const id = n.__sn && n.__sn.id;
            delete this.map[id];
            if (n.childNodes) n.childNodes.forEach((child)=>this.removeNodeFromMap(child));
        },
        has (id) {
            return this.map.hasOwnProperty(id);
        },
        reset () {
            this.map = {};
        }
    };
}
const $387daa7ca38f1a5d$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $387daa7ca38f1a5d$var$_mirror = {
    map: {},
    getId () {
        console.error($387daa7ca38f1a5d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($387daa7ca38f1a5d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($387daa7ca38f1a5d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($387daa7ca38f1a5d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($387daa7ca38f1a5d$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) $387daa7ca38f1a5d$var$_mirror = new Proxy($387daa7ca38f1a5d$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === "map") console.error($387daa7ca38f1a5d$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $387daa7ca38f1a5d$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(arg) {
        let now = Date.now();
        if (!previous && options.leading === false) previous = now;
        let remaining = wait - (now - previous);
        let context = this;
        let args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $387daa7ca38f1a5d$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            setTimeout(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$387daa7ca38f1a5d$var$hookSetter(target, key, original || {}, true);
}
function $387daa7ca38f1a5d$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === "function") {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (_a) {
        return ()=>{};
    }
}
function $387daa7ca38f1a5d$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $387daa7ca38f1a5d$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $387daa7ca38f1a5d$var$isBlocked(node, blockClass, blockSelector, unblockSelector) {
    if (!node) return false;
    if (node.nodeType === node.ELEMENT_NODE) {
        let needBlock = false;
        const needUnblock = unblockSelector && node.matches(unblockSelector);
        if (typeof blockClass === "string") {
            if (node.closest !== undefined) needBlock = !needUnblock && node.closest("." + blockClass) !== null;
            else needBlock = !needUnblock && node.classList.contains(blockClass);
        } else !needUnblock && node.classList.forEach((className)=>{
            if (blockClass.test(className)) needBlock = true;
        });
        if (!needBlock && blockSelector) needBlock = node.matches(blockSelector);
        return !needUnblock && needBlock || $387daa7ca38f1a5d$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    }
    if (node.nodeType === node.TEXT_NODE) return $387daa7ca38f1a5d$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
    return $387daa7ca38f1a5d$var$isBlocked(node.parentNode, blockClass, blockSelector, unblockSelector);
}
function $387daa7ca38f1a5d$var$isIgnored(n) {
    if ("__sn" in n) return n.__sn.id === $387daa7ca38f1a5d$var$IGNORED_NODE;
    return false;
}
function $387daa7ca38f1a5d$var$isAncestorRemoved(target, mirror) {
    if ($387daa7ca38f1a5d$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $387daa7ca38f1a5d$var$isAncestorRemoved(target.parentNode, mirror);
}
function $387daa7ca38f1a5d$var$isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $387daa7ca38f1a5d$var$polyfill(win = window) {
    if ("NodeList" in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function contains(node) {
        if (!(0 in arguments)) throw new TypeError("1 argument is required");
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $387daa7ca38f1a5d$var$isIframeINode(node) {
    if ("__sn" in node) return node.__sn.type === $387daa7ca38f1a5d$var$NodeType$1.Element && node.__sn.tagName === "iframe";
    return false;
}
function $387daa7ca38f1a5d$var$hasShadowRoot(n) {
    return Boolean(n === null || n === void 0 ? void 0 : n.shadowRoot);
}
function $387daa7ca38f1a5d$var$isNodeInLinkedList(n) {
    return "__ln" in n;
}
class $387daa7ca38f1a5d$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
    }
    get(position) {
        if (position >= this.length) throw new Error("Position outside of list range");
        let current = this.head;
        for(let index = 0; index < position; index++)current = (current === null || current === void 0 ? void 0 : current.next) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $387daa7ca38f1a5d$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $387daa7ca38f1a5d$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $387daa7ca38f1a5d$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
function $387daa7ca38f1a5d$var$isINode(n) {
    return "__sn" in n;
}
class $387daa7ca38f1a5d$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addList = new $387daa7ca38f1a5d$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $387daa7ca38f1a5d$var$IGNORED_NODE;
                while(nextId === $387daa7ca38f1a5d$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                var _a, _b, _c, _d, _e;
                const shadowHost = n.getRootNode ? (_a = n.getRootNode()) === null || _a === void 0 ? void 0 : _a.host : null;
                let rootShadowHost = shadowHost;
                while((_c = (_b = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _b === void 0 ? void 0 : _b.call(rootShadowHost)) === null || _c === void 0 ? void 0 : _c.host)rootShadowHost = ((_e = (_d = rootShadowHost === null || rootShadowHost === void 0 ? void 0 : rootShadowHost.getRootNode) === null || _d === void 0 ? void 0 : _d.call(rootShadowHost)) === null || _e === void 0 ? void 0 : _e.host) || null;
                const notInDoc = !this.doc.contains(n) && (!rootShadowHost || !this.doc.contains(rootShadowHost));
                if (!n.parentNode || notInDoc) return;
                const parentId = $387daa7ca38f1a5d$var$isShadowRoot(n.parentNode) ? this.mirror.getId(shadowHost) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                let sn = $387daa7ca38f1a5d$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    map: this.mirror.map,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    maskInputSelector: this.maskInputSelector,
                    unmaskInputSelector: this.unmaskInputSelector,
                    skipChild: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskAllText: this.maskAllText,
                    maskInputOptions: this.maskInputOptions,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($387daa7ca38f1a5d$var$isIframeINode(currentN)) this.iframeManager.addIframe(currentN);
                        if ($387daa7ca38f1a5d$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, document);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    }
                });
                if (sn) adds.push({
                    parentId: parentId,
                    nextId: nextId,
                    node: sn
                });
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($387daa7ca38f1a5d$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$387daa7ca38f1a5d$var$isAncestorInSet(this.droppedSet, n) && !$387daa7ca38f1a5d$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($387daa7ca38f1a5d$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) for(let index = addList.length - 1; index >= 0; index--){
                    const _node = addList.get(index);
                    if (_node) {
                        const parentId = this.mirror.getId(_node.value.parentNode);
                        const nextId = getNextId(_node.value);
                        if (parentId !== -1 && nextId !== -1) {
                            node = _node;
                            break;
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>({
                        id: this.mirror.getId(attribute.node),
                        attributes: attribute.attributes
                    })).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($387daa7ca38f1a5d$var$isIgnored(m.target)) return;
            switch(m.type){
                case "characterData":
                    {
                        const value = m.target.textContent;
                        if (!$387daa7ca38f1a5d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) && value !== m.oldValue) this.texts.push({
                            value: $387daa7ca38f1a5d$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value) : value.replace(/[\S]/g, "*") : value,
                            node: m.target
                        });
                        break;
                    }
                case "attributes":
                    {
                        const target = m.target;
                        let value = target.getAttribute(m.attributeName);
                        if (m.attributeName === "value") value = $387daa7ca38f1a5d$var$maskInputValue({
                            input: target,
                            maskInputSelector: this.maskInputSelector,
                            unmaskInputSelector: this.unmaskInputSelector,
                            maskInputOptions: this.maskInputOptions,
                            tagName: target.tagName,
                            type: target.getAttribute("type"),
                            value: value,
                            maskInputFn: this.maskInputFn
                        });
                        if ($387daa7ca38f1a5d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || value === m.oldValue) return;
                        let item = this.attributes.find((a)=>a.node === m.target);
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {}
                            };
                            this.attributes.push(item);
                        }
                        if (m.attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") target.setAttribute("data-rr-is-password", "true");
                        if (m.attributeName === "style") {
                            const old = this.doc.createElement("span");
                            if (m.oldValue) old.setAttribute("style", m.oldValue);
                            if (item.attributes.style === undefined || item.attributes.style === null) item.attributes.style = {};
                            try {
                                const styleObj = item.attributes.style;
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === "") styleObj[pname] = newValue;
                                        else styleObj[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === "") styleObj[pname] = false;
                            } catch (error) {
                                console.warn("[rrweb] Error when parsing update to style attribute:", error);
                            }
                        } else {
                            const element = m.target;
                            item.attributes[m.attributeName] = $387daa7ca38f1a5d$var$transformAttribute(this.doc, element, element.tagName, m.attributeName, value, this.maskAllText, this.unmaskTextSelector, this.maskTextFn);
                        }
                        break;
                    }
                case "childList":
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $387daa7ca38f1a5d$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($387daa7ca38f1a5d$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector) || $387daa7ca38f1a5d$var$isIgnored(n)) return;
                        if (this.addedSet.has(n)) {
                            $387daa7ca38f1a5d$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($387daa7ca38f1a5d$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$387daa7ca38f1a5d$var$moveKey(nodeId, parentId)]) $387daa7ca38f1a5d$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $387daa7ca38f1a5d$var$isShadowRoot(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (target && $387daa7ca38f1a5d$var$isBlocked(target, this.blockClass, this.blockSelector, this.unblockSelector)) return;
            if ($387daa7ca38f1a5d$var$isINode(n)) {
                if ($387daa7ca38f1a5d$var$isIgnored(n)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && $387daa7ca38f1a5d$var$isINode(target)) targetId = target.__sn.id;
                if (targetId) this.movedMap[$387daa7ca38f1a5d$var$moveKey(n.__sn.id, targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$387daa7ca38f1a5d$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector)) n.childNodes.forEach((childN)=>this.genAdds(childN));
        };
    }
    init(options) {
        [
            "mutationCb",
            "blockClass",
            "blockSelector",
            "unblockSelector",
            "maskTextClass",
            "maskTextSelector",
            "unmaskTextSelector",
            "maskInputSelector",
            "unmaskInputSelector",
            "inlineStylesheet",
            "maskAllText",
            "maskInputOptions",
            "maskTextFn",
            "maskInputFn",
            "recordCanvas",
            "inlineImages",
            "slimDOMOptions",
            "doc",
            "mirror",
            "iframeManager",
            "shadowDomManager",
            "canvasManager"
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $387daa7ca38f1a5d$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$387daa7ca38f1a5d$var$deepDelete(addsSet, childN));
}
function $387daa7ca38f1a5d$var$isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $387daa7ca38f1a5d$var$isParentRemoved(removes, parentNode, mirror);
}
function $387daa7ca38f1a5d$var$isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $387daa7ca38f1a5d$var$isAncestorInSet(set, parentNode);
}
const $387daa7ca38f1a5d$var$callbackWrapper = (cb)=>{
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            try {
                error.__rrweb__ = true;
            } catch (_a) {}
            throw error;
        }
    };
    return rrwebWrapped;
};
const $387daa7ca38f1a5d$var$mutationBuffers = [];
function $387daa7ca38f1a5d$var$getEventTarget(event) {
    try {
        if ("composedPath" in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ("path" in event && event.path.length) return event.path[0];
    } catch (_a) {}
    return event && event.target;
}
function $387daa7ca38f1a5d$var$initMutationObserver(options, rootEl) {
    var _a, _b;
    const mutationBuffer = new $387daa7ca38f1a5d$var$MutationBuffer();
    $387daa7ca38f1a5d$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = (_b = (_a = window === null || window === void 0 ? void 0 : window.Zone) === null || _a === void 0 ? void 0 : _a.__symbol__) === null || _b === void 0 ? void 0 : _b.call(_a, "MutationObserver");
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($387daa7ca38f1a5d$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $387daa7ca38f1a5d$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $387daa7ca38f1a5d$var$throttle$1((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        $387daa7ca38f1a5d$var$callbackWrapper(mousemoveCb)(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }, callbackThreshold);
    const updatePosition = $387daa7ca38f1a5d$var$throttle$1((evt)=>{
        const target = $387daa7ca38f1a5d$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $387daa7ca38f1a5d$var$isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = Date.now();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: Date.now() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== "undefined" && evt instanceof DragEvent ? $387daa7ca38f1a5d$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $387daa7ca38f1a5d$var$IncrementalSource.MouseMove : $387daa7ca38f1a5d$var$IncrementalSource.TouchMove);
    }, threshold, {
        trailing: false
    });
    const handlers = [
        $387daa7ca38f1a5d$var$on("mousemove", $387daa7ca38f1a5d$var$callbackWrapper(updatePosition), doc),
        $387daa7ca38f1a5d$var$on("touchmove", $387daa7ca38f1a5d$var$callbackWrapper(updatePosition), doc),
        $387daa7ca38f1a5d$var$on("drag", $387daa7ca38f1a5d$var$callbackWrapper(updatePosition), doc)
    ];
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $387daa7ca38f1a5d$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $387daa7ca38f1a5d$var$getEventTarget(event);
            if ($387daa7ca38f1a5d$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const e = $387daa7ca38f1a5d$var$isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $387daa7ca38f1a5d$var$callbackWrapper(mouseInteractionCb)({
                type: $387daa7ca38f1a5d$var$MouseInteractions[eventKey],
                id: id,
                x: clientX,
                y: clientY
            });
        };
    };
    Object.keys($387daa7ca38f1a5d$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false).forEach((eventKey)=>{
        const eventName = eventKey.toLowerCase();
        const handler = $387daa7ca38f1a5d$var$callbackWrapper(getHandler(eventKey));
        handlers.push($387daa7ca38f1a5d$var$on(eventName, handler, doc));
    });
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $387daa7ca38f1a5d$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $387daa7ca38f1a5d$var$throttle$1((evt)=>{
        const target = $387daa7ca38f1a5d$var$getEventTarget(evt);
        if (!target || $387daa7ca38f1a5d$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const id = mirror.getId(target);
        if (target === doc) {
            const scrollEl = doc.scrollingElement || doc.documentElement;
            $387daa7ca38f1a5d$var$callbackWrapper(scrollCb)({
                id: id,
                x: scrollEl.scrollLeft,
                y: scrollEl.scrollTop
            });
        } else $387daa7ca38f1a5d$var$callbackWrapper(scrollCb)({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }, sampling.scroll || 100);
    return $387daa7ca38f1a5d$var$on("scroll", $387daa7ca38f1a5d$var$callbackWrapper(updatePosition), doc);
}
function $387daa7ca38f1a5d$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $387daa7ca38f1a5d$var$throttle$1(()=>{
        const height = $387daa7ca38f1a5d$var$getWindowHeight();
        const width = $387daa7ca38f1a5d$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            $387daa7ca38f1a5d$var$callbackWrapper(viewportResizeCb)({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }, 200);
    return $387daa7ca38f1a5d$var$on("resize", $387daa7ca38f1a5d$var$callbackWrapper(updateDimension), window);
}
function $387daa7ca38f1a5d$var$wrapEventWithUserTriggeredFlag(v, enable) {
    const value = Object.assign({}, v);
    if (!enable) delete value.userTriggered;
    return value;
}
const $387daa7ca38f1a5d$var$INPUT_TAGS = [
    "INPUT",
    "TEXTAREA",
    "SELECT"
];
const $387daa7ca38f1a5d$var$lastInputValueMap = new WeakMap();
function $387daa7ca38f1a5d$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputSelector: maskInputSelector, unmaskInputSelector: unmaskInputSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput }) {
    function eventHandler(event) {
        let target = $387daa7ca38f1a5d$var$getEventTarget(event);
        const tagName = target && target.tagName;
        const userTriggered = event.isTrusted;
        if (tagName === "OPTION") target = target.parentElement;
        if (!target || !tagName || $387daa7ca38f1a5d$var$INPUT_TAGS.indexOf(tagName) < 0 || $387daa7ca38f1a5d$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
        const el = target;
        const type = $387daa7ca38f1a5d$var$getInputType(el);
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        let text = $387daa7ca38f1a5d$var$getInputValue(el, tagName, type);
        let isChecked = false;
        if (type === "radio" || type === "checkbox") isChecked = target.checked;
        if ($387daa7ca38f1a5d$var$hasInputMaskOptions({
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            tagName: tagName,
            type: type
        })) text = $387daa7ca38f1a5d$var$maskInputValue({
            input: el,
            maskInputOptions: maskInputOptions,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            tagName: tagName,
            type: type,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, $387daa7ca38f1a5d$var$callbackWrapper($387daa7ca38f1a5d$var$wrapEventWithUserTriggeredFlag)({
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        }, userTriggeredOnInput));
        const name = target.name;
        if (type === "radio" && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $387daa7ca38f1a5d$var$maskInputValue({
                    input: el,
                    maskInputOptions: maskInputOptions,
                    maskInputSelector: maskInputSelector,
                    unmaskInputSelector: unmaskInputSelector,
                    tagName: tagName,
                    type: type,
                    value: $387daa7ca38f1a5d$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, $387daa7ca38f1a5d$var$callbackWrapper($387daa7ca38f1a5d$var$wrapEventWithUserTriggeredFlag)({
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                }, userTriggeredOnInput));
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $387daa7ca38f1a5d$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $387daa7ca38f1a5d$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            inputCb(Object.assign(Object.assign({}, v), {
                id: id
            }));
        }
    }
    const events = sampling.input === "last" ? [
        "change"
    ] : [
        "input",
        "change"
    ];
    const handlers = events.map((eventName)=>$387daa7ca38f1a5d$var$on(eventName, $387daa7ca38f1a5d$var$callbackWrapper(eventHandler), doc));
    const propertyDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
    const hookProperties = [
        [
            HTMLInputElement.prototype,
            "value"
        ],
        [
            HTMLInputElement.prototype,
            "checked"
        ],
        [
            HTMLSelectElement.prototype,
            "value"
        ],
        [
            HTMLTextAreaElement.prototype,
            "value"
        ],
        [
            HTMLSelectElement.prototype,
            "selectedIndex"
        ],
        [
            HTMLOptionElement.prototype,
            "selected"
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$387daa7ca38f1a5d$var$hookSetter(p[0], p[1], {
            set () {
                $387daa7ca38f1a5d$var$callbackWrapper(eventHandler)({
                    target: this
                });
            }
        })));
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $387daa7ca38f1a5d$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($387daa7ca38f1a5d$var$hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || $387daa7ca38f1a5d$var$hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || $387daa7ca38f1a5d$var$hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || $387daa7ca38f1a5d$var$hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $387daa7ca38f1a5d$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $387daa7ca38f1a5d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $387daa7ca38f1a5d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const id = mirror.getId(thisArg.ownerNode);
            if (id !== -1) styleSheetRuleCb({
                id: id,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const supportedNestedCSSRuleTypes = {};
    if ($387daa7ca38f1a5d$var$canMonkeyPatchNestedCSSRule("CSSGroupingRule")) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($387daa7ca38f1a5d$var$canMonkeyPatchNestedCSSRule("CSSMediaRule")) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($387daa7ca38f1a5d$var$canMonkeyPatchNestedCSSRule("CSSConditionRule")) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($387daa7ca38f1a5d$var$canMonkeyPatchNestedCSSRule("CSSSupportsRule")) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $387daa7ca38f1a5d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$387daa7ca38f1a5d$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $387daa7ca38f1a5d$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const id = mirror.getId(thisArg.parentStyleSheet.ownerNode);
                if (id !== -1) styleSheetRuleCb({
                    id: id,
                    removes: [
                        {
                            index: [
                                ...$387daa7ca38f1a5d$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $387daa7ca38f1a5d$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $387daa7ca38f1a5d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property, value, priority] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $387daa7ca38f1a5d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $387daa7ca38f1a5d$var$callbackWrapper((target, thisArg, argumentsList)=>{
            var _a, _b;
            const [property] = argumentsList;
            const id = mirror.getId((_b = (_a = thisArg.parentRule) === null || _a === void 0 ? void 0 : _a.parentStyleSheet) === null || _b === void 0 ? void 0 : _b.ownerNode);
            if (id !== -1) styleDeclarationCb({
                id: id,
                remove: {
                    property: property
                },
                index: $387daa7ca38f1a5d$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $387daa7ca38f1a5d$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling }) {
    const handler = (type)=>$387daa7ca38f1a5d$var$throttle$1($387daa7ca38f1a5d$var$callbackWrapper((event)=>{
            const target = $387daa7ca38f1a5d$var$getEventTarget(event);
            if (!target || $387daa7ca38f1a5d$var$isBlocked(target, blockClass, blockSelector, unblockSelector)) return;
            const { currentTime: currentTime, volume: volume, muted: muted } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted
            });
        }), sampling.media || 500);
    const handlers = [
        $387daa7ca38f1a5d$var$on("play", handler(0)),
        $387daa7ca38f1a5d$var$on("pause", handler(1)),
        $387daa7ca38f1a5d$var$on("seeked", handler(2)),
        $387daa7ca38f1a5d$var$on("volumechange", handler(3))
    ];
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $387daa7ca38f1a5d$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== "string",
            descriptors: descriptors,
            fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $387daa7ca38f1a5d$var$patch(doc.fonts, "add", function(original) {
        return function(fontFace) {
            setTimeout(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }, 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $387daa7ca38f1a5d$var$mergeHooks(o, hooks) {
    const { mutationCb: mutationCb, mousemoveCb: mousemoveCb, mouseInteractionCb: mouseInteractionCb, scrollCb: scrollCb, viewportResizeCb: viewportResizeCb, inputCb: inputCb, mediaInteractionCb: mediaInteractionCb, styleSheetRuleCb: styleSheetRuleCb, styleDeclarationCb: styleDeclarationCb, canvasMutationCb: canvasMutationCb, fontCb: fontCb } = o;
    o.mutationCb = (...p)=>{
        if (hooks.mutation) hooks.mutation(...p);
        mutationCb(...p);
    };
    o.mousemoveCb = (...p)=>{
        if (hooks.mousemove) hooks.mousemove(...p);
        mousemoveCb(...p);
    };
    o.mouseInteractionCb = (...p)=>{
        if (hooks.mouseInteraction) hooks.mouseInteraction(...p);
        mouseInteractionCb(...p);
    };
    o.scrollCb = (...p)=>{
        if (hooks.scroll) hooks.scroll(...p);
        scrollCb(...p);
    };
    o.viewportResizeCb = (...p)=>{
        if (hooks.viewportResize) hooks.viewportResize(...p);
        viewportResizeCb(...p);
    };
    o.inputCb = (...p)=>{
        if (hooks.input) hooks.input(...p);
        inputCb(...p);
    };
    o.mediaInteractionCb = (...p)=>{
        if (hooks.mediaInteaction) hooks.mediaInteaction(...p);
        mediaInteractionCb(...p);
    };
    o.styleSheetRuleCb = (...p)=>{
        if (hooks.styleSheetRule) hooks.styleSheetRule(...p);
        styleSheetRuleCb(...p);
    };
    o.styleDeclarationCb = (...p)=>{
        if (hooks.styleDeclaration) hooks.styleDeclaration(...p);
        styleDeclarationCb(...p);
    };
    o.canvasMutationCb = (...p)=>{
        if (hooks.canvasMutation) hooks.canvasMutation(...p);
        canvasMutationCb(...p);
    };
    o.fontCb = (...p)=>{
        if (hooks.font) hooks.font(...p);
        fontCb(...p);
    };
}
function $387daa7ca38f1a5d$var$initObservers(o, hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    $387daa7ca38f1a5d$var$mergeHooks(o, hooks);
    const mutationObserver = $387daa7ca38f1a5d$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $387daa7ca38f1a5d$var$initMoveObserver(o);
    const mouseInteractionHandler = $387daa7ca38f1a5d$var$initMouseInteractionObserver(o);
    const scrollHandler = $387daa7ca38f1a5d$var$initScrollObserver(o);
    const viewportResizeHandler = $387daa7ca38f1a5d$var$initViewportResizeObserver(o);
    const inputHandler = $387daa7ca38f1a5d$var$initInputObserver(o);
    const mediaInteractionHandler = $387daa7ca38f1a5d$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $387daa7ca38f1a5d$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const styleDeclarationObserver = $387daa7ca38f1a5d$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $387daa7ca38f1a5d$var$initFontObserver(o) : ()=>{};
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $387daa7ca38f1a5d$var$callbackWrapper(()=>{
        $387daa7ca38f1a5d$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        try {
            styleSheetObserver();
            styleDeclarationObserver();
        } catch (e) {}
        fontObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $387daa7ca38f1a5d$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== "undefined";
}
function $387daa7ca38f1a5d$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== "undefined" && window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype);
}
class $387daa7ca38f1a5d$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.mutationCb = options.mutationCb;
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        var _a;
        this.mutationCb({
            adds: [
                {
                    parentId: iframeEl.__sn.id,
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        (_a = this.loadListener) === null || _a === void 0 || _a.call(this, iframeEl);
    }
}
class $387daa7ca38f1a5d$var$ShadowDomManager {
    constructor(options){
        this.restorePatches = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        const manager = this;
        this.restorePatches.push($387daa7ca38f1a5d$var$patch(HTMLElement.prototype, "attachShadow", function(original) {
            return function() {
                const shadowRoot = original.apply(this, arguments);
                if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, this.ownerDocument);
                return shadowRoot;
            };
        }));
    }
    addShadowRoot(shadowRoot, doc) {
        $387daa7ca38f1a5d$var$initMutationObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }), shadowRoot);
        $387daa7ca38f1a5d$var$initScrollObserver(Object.assign(Object.assign({}, this.bypassOptions), {
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
    }
    observeAttachShadow(iframeElement) {
        if (iframeElement.contentWindow) {
            const manager = this;
            this.restorePatches.push($387daa7ca38f1a5d$var$patch(iframeElement.contentWindow.HTMLElement.prototype, "attachShadow", function(original) {
                return function() {
                    const shadowRoot = original.apply(this, arguments);
                    if (this.shadowRoot) manager.addShadowRoot(this.shadowRoot, iframeElement.contentDocument);
                    return shadowRoot;
                };
            }));
        }
    }
    reset() {
        this.restorePatches.forEach((restorePatch)=>restorePatch());
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $387daa7ca38f1a5d$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $387daa7ca38f1a5d$var$initCanvas2DMutationObserver(cb, win, blockClass, unblockSelector, blockSelector, mirror) {
    const handlers = [];
    const props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    for (const prop of props2D)try {
        if (typeof win.CanvasRenderingContext2D.prototype[prop] !== "function") continue;
        const restoreHandler = $387daa7ca38f1a5d$var$patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
            return function(...args) {
                if (!$387daa7ca38f1a5d$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) setTimeout(()=>{
                    const recordArgs = [
                        ...args
                    ];
                    if (prop === "drawImage") {
                        if (recordArgs[0] && recordArgs[0] instanceof HTMLCanvasElement) {
                            const canvas = recordArgs[0];
                            const ctx = canvas.getContext("2d");
                            let imgd = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
                            let pix = imgd === null || imgd === void 0 ? void 0 : imgd.data;
                            recordArgs[0] = JSON.stringify(pix);
                        }
                    }
                    cb(this.canvas, {
                        type: $387daa7ca38f1a5d$var$CanvasContext["2D"],
                        property: prop,
                        args: recordArgs
                    });
                }, 0);
                return original.apply(this, args);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $387daa7ca38f1a5d$var$hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: $387daa7ca38f1a5d$var$CanvasContext["2D"],
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
function $387daa7ca38f1a5d$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector) {
    const handlers = [];
    try {
        const restoreHandler = $387daa7ca38f1a5d$var$patch(win.HTMLCanvasElement.prototype, "getContext", function(original) {
            return function(contextType, ...args) {
                if (!$387daa7ca38f1a5d$var$isBlocked(this, blockClass, blockSelector, unblockSelector)) {
                    if (!("__context" in this)) this.__context = contextType;
                }
                return original.apply(this, [
                    contextType,
                    ...args
                ]);
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        console.error("failed to patch HTMLCanvasElement.prototype.getContext");
    }
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
/*
 * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $387daa7ca38f1a5d$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
// Use a lookup table to find the index.
var $387daa7ca38f1a5d$var$lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for(var $387daa7ca38f1a5d$var$i = 0; $387daa7ca38f1a5d$var$i < $387daa7ca38f1a5d$var$chars.length; $387daa7ca38f1a5d$var$i++)$387daa7ca38f1a5d$var$lookup[$387daa7ca38f1a5d$var$chars.charCodeAt($387daa7ca38f1a5d$var$i)] = $387daa7ca38f1a5d$var$i;
var $387daa7ca38f1a5d$var$encode = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
    for(i = 0; i < len; i += 3){
        base64 += $387daa7ca38f1a5d$var$chars[bytes[i] >> 2];
        base64 += $387daa7ca38f1a5d$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $387daa7ca38f1a5d$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $387daa7ca38f1a5d$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
    return base64;
};
const $387daa7ca38f1a5d$var$webGLVarMap = new Map();
function $387daa7ca38f1a5d$var$variableListFor(ctx, ctor) {
    let contextMap = $387daa7ca38f1a5d$var$webGLVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        $387daa7ca38f1a5d$var$webGLVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
const $387daa7ca38f1a5d$var$saveWebGLVar = (value, win, ctx)=>{
    if (!value || !($387daa7ca38f1a5d$var$isInstanceOfWebGLObject(value, win) || typeof value === "object")) return;
    const name = value.constructor.name;
    const list = $387daa7ca38f1a5d$var$variableListFor(ctx, name);
    let index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function $387daa7ca38f1a5d$var$serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map((arg)=>$387daa7ca38f1a5d$var$serializeArg(arg, win, ctx));
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        const name = value.constructor.name;
        const base64 = $387daa7ca38f1a5d$var$encode(value);
        return {
            rr_type: name,
            base64: base64
        };
    } else if (value instanceof DataView) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $387daa7ca38f1a5d$var$serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        const name = value.constructor.name;
        const { src: src } = value;
        return {
            rr_type: name,
            src: src
        };
    } else if (value instanceof ImageData) {
        const name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                $387daa7ca38f1a5d$var$serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if ($387daa7ca38f1a5d$var$isInstanceOfWebGLObject(value, win) || typeof value === "object") {
        const name = value.constructor.name;
        const index = $387daa7ca38f1a5d$var$saveWebGLVar(value, win, ctx);
        return {
            rr_type: name,
            index: index
        };
    }
    return value;
}
const $387daa7ca38f1a5d$var$serializeArgs = (args, win, ctx)=>{
    return [
        ...args
    ].map((arg)=>$387daa7ca38f1a5d$var$serializeArg(arg, win, ctx));
};
const $387daa7ca38f1a5d$var$isInstanceOfWebGLObject = (value, win)=>{
    const webGLConstructorNames = [
        "WebGLActiveInfo",
        "WebGLBuffer",
        "WebGLFramebuffer",
        "WebGLProgram",
        "WebGLRenderbuffer",
        "WebGLShader",
        "WebGLShaderPrecisionFormat",
        "WebGLTexture",
        "WebGLUniformLocation",
        "WebGLVertexArrayObject",
        "WebGLVertexArrayObjectOES"
    ];
    const supportedWebGLConstructorNames = webGLConstructorNames.filter((name)=>typeof win[name] === "function");
    return Boolean(supportedWebGLConstructorNames.find((name)=>value instanceof win[name]));
};
function $387daa7ca38f1a5d$var$patchGLPrototype(prototype, type, cb, blockClass, unblockSelector, blockSelector, mirror, win) {
    const handlers = [];
    const props = Object.getOwnPropertyNames(prototype);
    for (const prop of props)try {
        if (typeof prototype[prop] !== "function") continue;
        const restoreHandler = $387daa7ca38f1a5d$var$patch(prototype, prop, function(original) {
            return function(...args) {
                const result = original.apply(this, args);
                $387daa7ca38f1a5d$var$saveWebGLVar(result, win, prototype);
                if (!$387daa7ca38f1a5d$var$isBlocked(this.canvas, blockClass, blockSelector, unblockSelector)) {
                    const id = mirror.getId(this.canvas);
                    const recordArgs = $387daa7ca38f1a5d$var$serializeArgs([
                        ...args
                    ], win, prototype);
                    const mutation = {
                        type: type,
                        property: prop,
                        args: recordArgs
                    };
                    cb(this.canvas, mutation);
                }
                return result;
            };
        });
        handlers.push(restoreHandler);
    } catch (_a) {
        const hookHandler = $387daa7ca38f1a5d$var$hookSetter(prototype, prop, {
            set (v) {
                cb(this.canvas, {
                    type: type,
                    property: prop,
                    args: [
                        v
                    ],
                    setter: true
                });
            }
        });
        handlers.push(hookHandler);
    }
    return handlers;
}
function $387daa7ca38f1a5d$var$initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    const handlers = [];
    handlers.push(...$387daa7ca38f1a5d$var$patchGLPrototype(win.WebGLRenderingContext.prototype, $387daa7ca38f1a5d$var$CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    if (typeof win.WebGL2RenderingContext !== "undefined") handlers.push(...$387daa7ca38f1a5d$var$patchGLPrototype(win.WebGL2RenderingContext.prototype, $387daa7ca38f1a5d$var$CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win));
    return ()=>{
        handlers.forEach((h)=>h());
    };
}
class $387daa7ca38f1a5d$var$CanvasManager {
    reset() {
        this.pendingCanvasMutations.clear();
        this.resetObservers && this.resetObservers();
    }
    freeze() {
        this.frozen = true;
    }
    unfreeze() {
        this.frozen = false;
    }
    lock() {
        this.locked = true;
    }
    unlock() {
        this.locked = false;
    }
    constructor(options){
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            const newFrame = this.rafStamps.invokeId && this.rafStamps.latestId !== this.rafStamps.invokeId;
            if (newFrame || !this.rafStamps.invokeId) this.rafStamps.invokeId = this.rafStamps.latestId;
            if (!this.pendingCanvasMutations.has(target)) this.pendingCanvasMutations.set(target, []);
            this.pendingCanvasMutations.get(target).push(mutation);
        };
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        if (options.recordCanvas === true) this.initCanvasMutationObserver(options.win, options.blockClass, options.blockSelector, options.unblockSelector);
    }
    initCanvasMutationObserver(win, blockClass, unblockSelector, blockSelector) {
        this.startRAFTimestamping();
        this.startPendingCanvasMutationFlusher();
        const canvasContextReset = $387daa7ca38f1a5d$var$initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector);
        const canvas2DReset = $387daa7ca38f1a5d$var$initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        const canvasWebGL1and2Reset = $387daa7ca38f1a5d$var$initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
        this.resetObservers = ()=>{
            canvasContextReset();
            canvas2DReset();
            canvasWebGL1and2Reset();
        };
    }
    startPendingCanvasMutationFlusher() {
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    startRAFTimestamping() {
        const setLatestRAFTimestamp = (timestamp)=>{
            this.rafStamps.latestId = timestamp;
            requestAnimationFrame(setLatestRAFTimestamp);
        };
        requestAnimationFrame(setLatestRAFTimestamp);
    }
    flushPendingCanvasMutations() {
        this.pendingCanvasMutations.forEach((values, canvas)=>{
            const id = this.mirror.getId(canvas);
            this.flushPendingCanvasMutationFor(canvas, id);
        });
        requestAnimationFrame(()=>this.flushPendingCanvasMutations());
    }
    flushPendingCanvasMutationFor(canvas, id) {
        if (this.frozen || this.locked) return;
        const valuesWithType = this.pendingCanvasMutations.get(canvas);
        if (!valuesWithType || id === -1) return;
        const values = valuesWithType.map((value)=>{
            const rest = $387daa7ca38f1a5d$var$__rest(value, [
                "type"
            ]);
            return rest;
        });
        const { type: type } = valuesWithType[0];
        this.mutationCb({
            id: id,
            type: type,
            commands: values
        });
        this.pendingCanvasMutations.delete(canvas);
    }
}
function $387daa7ca38f1a5d$var$wrapEvent(e) {
    return Object.assign(Object.assign({}, e), {
        timestamp: Date.now()
    });
}
let $387daa7ca38f1a5d$var$wrappedEmit;
let $387daa7ca38f1a5d$var$takeFullSnapshot;
const $387daa7ca38f1a5d$var$mirror = $387daa7ca38f1a5d$var$createMirror();
function $387daa7ca38f1a5d$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = "rr-block", blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = "rr-ignore", ignoreSelector: ignoreSelector = null, maskTextClass: maskTextClass = "rr-mask", maskTextSelector: maskTextSelector = null, maskInputSelector: maskInputSelector = null, unmaskTextSelector: unmaskTextSelector = null, unmaskInputSelector: unmaskInputSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllText: maskAllText = false, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskInputFn: maskInputFn, maskTextFn: maskTextFn, hooks: hooks, packFn: packFn, sampling: sampling = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, onMutation: onMutation } = options;
    if (!emit) throw new Error("emit function is required");
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === "all",
        headMetaDescKeywords: _slimDOMOptions === "all"
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $387daa7ca38f1a5d$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn) e = packFn(e);
        return e;
    };
    $387daa7ca38f1a5d$var$wrappedEmit = (e, isCheckout)=>{
        var _a;
        if (((_a = $387daa7ca38f1a5d$var$mutationBuffers[0]) === null || _a === void 0 ? void 0 : _a.isFrozen()) && e.type !== $387daa7ca38f1a5d$var$EventType.FullSnapshot && !(e.type === $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot && e.data.source === $387daa7ca38f1a5d$var$IncrementalSource.Mutation)) $387daa7ca38f1a5d$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        emit(eventProcessor(e), isCheckout);
        if (e.type === $387daa7ca38f1a5d$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $387daa7ca38f1a5d$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) $387daa7ca38f1a5d$var$takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
            type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
            data: Object.assign({
                source: $387daa7ca38f1a5d$var$IncrementalSource.Mutation
            }, m)
        }));
    };
    const wrappedScrollEmit = (p)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
            type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
            data: Object.assign({
                source: $387daa7ca38f1a5d$var$IncrementalSource.Scroll
            }, p)
        }));
    const wrappedCanvasMutationEmit = (p)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
            type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
            data: Object.assign({
                source: $387daa7ca38f1a5d$var$IncrementalSource.CanvasMutation
            }, p)
        }));
    const iframeManager = new $387daa7ca38f1a5d$var$IframeManager({
        mutationCb: wrappedMutationEmit
    });
    const canvasManager = new $387daa7ca38f1a5d$var$CanvasManager({
        recordCanvas: recordCanvas,
        mutationCb: wrappedCanvasMutationEmit,
        win: window,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        mirror: $387daa7ca38f1a5d$var$mirror
    });
    const shadowDomManager = new $387daa7ca38f1a5d$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskInputOptions: maskInputOptions,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            canvasManager: canvasManager
        },
        mirror: $387daa7ca38f1a5d$var$mirror
    });
    $387daa7ca38f1a5d$var$takeFullSnapshot = (isCheckout = false)=>{
        var _a, _b, _c, _d;
        $387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
            type: $387daa7ca38f1a5d$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $387daa7ca38f1a5d$var$getWindowWidth(),
                height: $387daa7ca38f1a5d$var$getWindowHeight()
            }
        }), isCheckout);
        $387daa7ca38f1a5d$var$mutationBuffers.forEach((buf)=>buf.lock());
        const [node, idNodeMap] = $387daa7ca38f1a5d$var$snapshot(document, {
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            maskInputSelector: maskInputSelector,
            unmaskInputSelector: unmaskInputSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllText: maskAllText,
            maskAllInputs: maskInputOptions,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($387daa7ca38f1a5d$var$isIframeINode(n)) iframeManager.addIframe(n);
                if ($387daa7ca38f1a5d$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn("Failed to snapshot the document");
        $387daa7ca38f1a5d$var$mirror.map = idNodeMap;
        $387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
            type: $387daa7ca38f1a5d$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: {
                    left: window.pageXOffset !== undefined ? window.pageXOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollLeft) || ((_b = (_a = document === null || document === void 0 ? void 0 : document.body) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.scrollLeft) || (document === null || document === void 0 ? void 0 : document.body.scrollLeft) || 0,
                    top: window.pageYOffset !== undefined ? window.pageYOffset : (document === null || document === void 0 ? void 0 : document.documentElement.scrollTop) || ((_d = (_c = document === null || document === void 0 ? void 0 : document.body) === null || _c === void 0 ? void 0 : _c.parentElement) === null || _d === void 0 ? void 0 : _d.scrollTop) || (document === null || document === void 0 ? void 0 : document.body.scrollTop) || 0
                }
            }
        }));
        $387daa7ca38f1a5d$var$mutationBuffers.forEach((buf)=>buf.unlock());
    };
    try {
        const handlers = [];
        handlers.push($387daa7ca38f1a5d$var$on("DOMContentLoaded", ()=>{
            $387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                type: $387daa7ca38f1a5d$var$EventType.DomContentLoaded,
                data: {}
            }));
        }));
        const observe = (doc)=>{
            var _a;
            return $387daa7ca38f1a5d$var$callbackWrapper($387daa7ca38f1a5d$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    })),
                mouseInteractionCb: (d)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $387daa7ca38f1a5d$var$IncrementalSource.MouseInteraction
                        }, d)
                    })),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $387daa7ca38f1a5d$var$IncrementalSource.ViewportResize
                        }, d)
                    })),
                inputCb: (v)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $387daa7ca38f1a5d$var$IncrementalSource.Input
                        }, v)
                    })),
                mediaInteractionCb: (p)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $387daa7ca38f1a5d$var$IncrementalSource.MediaInteraction
                        }, p)
                    })),
                styleSheetRuleCb: (r)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $387daa7ca38f1a5d$var$IncrementalSource.StyleSheetRule
                        }, r)
                    })),
                styleDeclarationCb: (r)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $387daa7ca38f1a5d$var$IncrementalSource.StyleDeclaration
                        }, r)
                    })),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                        type: $387daa7ca38f1a5d$var$EventType.IncrementalSnapshot,
                        data: Object.assign({
                            source: $387daa7ca38f1a5d$var$IncrementalSource.Font
                        }, p)
                    })),
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputSelector: maskInputSelector,
                unmaskInputSelector: unmaskInputSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAllText: maskAllText,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                mirror: $387daa7ca38f1a5d$var$mirror,
                iframeManager: iframeManager,
                shadowDomManager: shadowDomManager,
                canvasManager: canvasManager,
                plugins: ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.filter((p)=>p.observer)) === null || _a === void 0 ? void 0 : _a.map((p)=>({
                        observer: p.observer,
                        options: p.options,
                        callback: (payload)=>$387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                                type: $387daa7ca38f1a5d$var$EventType.Plugin,
                                data: {
                                    plugin: p.name,
                                    payload: payload
                                }
                            }))
                    }))) || []
            }, hooks);
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            $387daa7ca38f1a5d$var$takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === "interactive" || document.readyState === "complete") init();
        else handlers.push($387daa7ca38f1a5d$var$on("load", ()=>{
            $387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
                type: $387daa7ca38f1a5d$var$EventType.Load,
                data: {}
            }));
            init();
        }, window));
        return ()=>{
            handlers.forEach((h)=>h());
        };
    } catch (error) {
        console.warn(error);
    }
}
$387daa7ca38f1a5d$var$record.addCustomEvent = (tag, payload)=>{
    if (!$387daa7ca38f1a5d$var$wrappedEmit) throw new Error("please add custom event after start recording");
    $387daa7ca38f1a5d$var$wrappedEmit($387daa7ca38f1a5d$var$wrapEvent({
        type: $387daa7ca38f1a5d$var$EventType.Custom,
        data: {
            tag: tag,
            payload: payload
        }
    }));
};
$387daa7ca38f1a5d$var$record.freezePage = ()=>{
    $387daa7ca38f1a5d$var$mutationBuffers.forEach((buf)=>buf.freeze());
};
$387daa7ca38f1a5d$var$record.takeFullSnapshot = (isCheckout)=>{
    if (!$387daa7ca38f1a5d$var$takeFullSnapshot) throw new Error("please take full snapshot after start recording");
    $387daa7ca38f1a5d$var$takeFullSnapshot(isCheckout);
};
$387daa7ca38f1a5d$var$record.mirror = $387daa7ca38f1a5d$var$mirror;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $387daa7ca38f1a5d$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $387daa7ca38f1a5d$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $387daa7ca38f1a5d$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === "sentry.transaction") return;
    if ([
        "ui.click",
        "ui.input"
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        replay.throttledAddEvent({
            type: $387daa7ca38f1a5d$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: "breadcrumb",
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $d060f3e5c438af18$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === "console";
    });
}
const $387daa7ca38f1a5d$var$INTERACTIVE_SELECTOR = "button,a";
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $387daa7ca38f1a5d$var$getClickTargetNode(event) {
    const target = $387daa7ca38f1a5d$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    const closestInteractive = target.closest($387daa7ca38f1a5d$var$INTERACTIVE_SELECTOR);
    return closestInteractive || target;
}
/** Get the event target node. */ function $387daa7ca38f1a5d$var$getTargetNode(event) {
    if ($387daa7ca38f1a5d$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $387daa7ca38f1a5d$var$isEventWithTarget(event) {
    return typeof event === "object" && !!event && "target" in event;
}
let $387daa7ca38f1a5d$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $387daa7ca38f1a5d$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$387daa7ca38f1a5d$var$handlers) {
        $387daa7ca38f1a5d$var$handlers = [];
        $387daa7ca38f1a5d$var$monkeyPatchWindowOpen();
    }
    $387daa7ca38f1a5d$var$handlers.push(cb);
    return ()=>{
        const pos = $387daa7ca38f1a5d$var$handlers ? $387daa7ca38f1a5d$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $387daa7ca38f1a5d$var$handlers.splice(pos, 1);
    };
}
function $387daa7ca38f1a5d$var$monkeyPatchWindowOpen() {
    (0, $00469dac6edb4ff1$export$9563e054e6f787fb)($387daa7ca38f1a5d$var$WINDOW, "open", function(originalWindowOpen) {
        return function(...args) {
            if ($387daa7ca38f1a5d$var$handlers) try {
                $387daa7ca38f1a5d$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($387daa7ca38f1a5d$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $387daa7ca38f1a5d$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $387daa7ca38f1a5d$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $387daa7ca38f1a5d$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const mutationHandler = ()=>{
            this._lastMutation = $387daa7ca38f1a5d$var$nowInSeconds();
        };
        const scrollHandler = ()=>{
            this._lastScroll = $387daa7ca38f1a5d$var$nowInSeconds();
        };
        const cleanupWindowOpen = $387daa7ca38f1a5d$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $387daa7ca38f1a5d$var$nowInSeconds();
        });
        const clickHandler = (event)=>{
            if (!event.target) return;
            const node = $387daa7ca38f1a5d$var$getClickTargetNode(event);
            if (node) this._handleMultiClick(node);
        };
        const obs = new MutationObserver(mutationHandler);
        obs.observe($387daa7ca38f1a5d$var$WINDOW.document.documentElement, {
            attributes: true,
            characterData: true,
            childList: true,
            subtree: true
        });
        $387daa7ca38f1a5d$var$WINDOW.addEventListener("scroll", scrollHandler, {
            passive: true
        });
        $387daa7ca38f1a5d$var$WINDOW.addEventListener("click", clickHandler, {
            passive: true
        });
        this._teardown = ()=>{
            $387daa7ca38f1a5d$var$WINDOW.removeEventListener("scroll", scrollHandler);
            $387daa7ca38f1a5d$var$WINDOW.removeEventListener("click", clickHandler);
            cleanupWindowOpen();
            obs.disconnect();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** Handle a click */ handleClick(breadcrumb, node) {
        if ($387daa7ca38f1a5d$var$ignoreElement(node, this._ignoreSelector) || !$387daa7ca38f1a5d$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $387daa7ca38f1a5d$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $387daa7ca38f1a5d$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? "mutation" : "timeout";
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.slowClickDetected",
                data: {
                    ...clickBreadcrumb.data,
                    url: $387daa7ca38f1a5d$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: "default",
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: "ui.multiClick",
                data: {
                    ...clickBreadcrumb.data,
                    url: $387daa7ca38f1a5d$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = setTimeout(()=>this._checkClicks(), 1000);
    }
}
const $387daa7ca38f1a5d$var$SLOW_CLICK_TAGS = [
    "A",
    "BUTTON",
    "INPUT"
];
/** exported for tests only */ function $387daa7ca38f1a5d$var$ignoreElement(node, ignoreSelector) {
    if (!$387daa7ca38f1a5d$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === "INPUT" && ![
        "submit",
        "button"
    ].includes(node.getAttribute("type") || "")) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $387daa7ca38f1a5d$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $387daa7ca38f1a5d$var$nowInSeconds() {
    return Date.now() / 1000;
}
/**
 * Create a breadcrumb for a replay.
 */ function $387daa7ca38f1a5d$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: "default",
        ...breadcrumb
    };
}
var $387daa7ca38f1a5d$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($387daa7ca38f1a5d$var$NodeType || ($387daa7ca38f1a5d$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $387daa7ca38f1a5d$var$ATTRIBUTES_TO_RECORD = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled"
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $387daa7ca38f1a5d$var$getAttributesToRecord(attributes) {
    const obj = {};
    for(const key in attributes)if ($387daa7ca38f1a5d$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === "data-testid" || key === "data-test-id") normalizedKey = "testId";
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $387daa7ca38f1a5d$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $387daa7ca38f1a5d$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === "click";
        const event = isClick && handlerData.event;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $387daa7ca38f1a5d$var$handleClick(replay.clickDetector, result, $387daa7ca38f1a5d$var$getClickTargetNode(handlerData.event));
        $387daa7ca38f1a5d$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $387daa7ca38f1a5d$var$getBaseDomBreadcrumb(target, message) {
    // `__sn` property is the serialized node created by rrweb
    const serializedNode = target && $387daa7ca38f1a5d$var$isRrwebNode(target) && target.__sn.type === $387daa7ca38f1a5d$var$NodeType.Element ? target.__sn : null;
    return {
        message: message,
        data: serializedNode ? {
            nodeId: serializedNode.id,
            node: {
                id: serializedNode.id,
                tagName: serializedNode.tagName,
                textContent: target ? Array.from(target.childNodes).map((node)=>"__sn" in node && node.__sn.type === $387daa7ca38f1a5d$var$NodeType.Text && node.__sn.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join("") : "",
                attributes: $387daa7ca38f1a5d$var$getAttributesToRecord(serializedNode.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $387daa7ca38f1a5d$var$handleDom(handlerData) {
    const { target: target, message: message } = $387daa7ca38f1a5d$var$getDomTarget(handlerData);
    return $387daa7ca38f1a5d$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$387daa7ca38f1a5d$var$getBaseDomBreadcrumb(target, message)
    });
}
function $387daa7ca38f1a5d$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === "click";
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $387daa7ca38f1a5d$var$getClickTargetNode(handlerData.event) : $387daa7ca38f1a5d$var$getTargetNode(handlerData.event);
        message = (0, $10b7e35d980736f8$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || "<unknown>";
    } catch (e) {
        message = "<unknown>";
    }
    return {
        target: target,
        message: message
    };
}
function $387daa7ca38f1a5d$var$isRrwebNode(node) {
    return "__sn" in node;
}
/** Handle keyboard events & create breadcrumbs. */ function $387daa7ca38f1a5d$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $387daa7ca38f1a5d$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $387daa7ca38f1a5d$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $387daa7ca38f1a5d$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $387daa7ca38f1a5d$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $10b7e35d980736f8$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || "<unknown>";
    const baseBreadcrumb = $387daa7ca38f1a5d$var$getBaseDomBreadcrumb(target, message);
    return $387daa7ca38f1a5d$var$createBreadcrumb({
        category: "ui.keyDown",
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $387daa7ca38f1a5d$var$isInputElement(target) {
    return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
const $387daa7ca38f1a5d$var$NAVIGATION_ENTRY_KEYS = [
    "name",
    "type",
    "startTime",
    "transferSize",
    "duration"
];
function $387daa7ca38f1a5d$var$isNavigationEntryEqual(a) {
    return function(b) {
        return $387daa7ca38f1a5d$var$NAVIGATION_ENTRY_KEYS.every((key)=>a[key] === b[key]);
    };
}
/**
 * There are some difficulties diagnosing why there are duplicate navigation
 * entries. We've witnessed several intermittent results:
 * - duplicate entries have duration = 0
 * - duplicate entries are the same object reference
 * - none of the above
 *
 * Compare the values of several keys to determine if the entries are duplicates or not.
 */ // TODO (high-prio): Figure out wth is returned here
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $387daa7ca38f1a5d$var$dedupePerformanceEntries(currentList, newList) {
    // Partition `currentList` into 3 different lists based on entryType
    const [existingNavigationEntries, existingLcpEntries, existingEntries] = currentList.reduce((acc, entry)=>{
        if (entry.entryType === "navigation") acc[0].push(entry);
        else if (entry.entryType === "largest-contentful-paint") acc[1].push(entry);
        else acc[2].push(entry);
        return acc;
    }, [
        [],
        [],
        []
    ]);
    const newEntries = [];
    const newNavigationEntries = [];
    let newLcpEntry = existingLcpEntries.length ? existingLcpEntries[existingLcpEntries.length - 1] // Take the last element as list is sorted
     : undefined;
    newList.forEach((entry)=>{
        if (entry.entryType === "largest-contentful-paint") {
            // We want the latest LCP event only
            if (!newLcpEntry || newLcpEntry.startTime < entry.startTime) newLcpEntry = entry;
            return;
        }
        if (entry.entryType === "navigation") {
            const navigationEntry = entry;
            // Check if the navigation entry is contained in currentList or newList
            if (// Ignore any navigation entries with duration 0, as they are likely duplicates
            entry.duration > 0 && // Ensure new entry does not already exist in existing entries
            !existingNavigationEntries.find($387daa7ca38f1a5d$var$isNavigationEntryEqual(navigationEntry)) && // Ensure new entry does not already exist in new list of navigation entries
            !newNavigationEntries.find($387daa7ca38f1a5d$var$isNavigationEntryEqual(navigationEntry))) newNavigationEntries.push(navigationEntry);
            // Otherwise this navigation entry is considered a duplicate and is thrown away
            return;
        }
        newEntries.push(entry);
    });
    // Re-combine and sort by startTime
    return [
        ...newLcpEntry ? [
            newLcpEntry
        ] : [],
        ...existingNavigationEntries,
        ...existingEntries,
        ...newEntries,
        ...newNavigationEntries
    ].sort((a, b)=>a.startTime - b.startTime);
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 */ function $387daa7ca38f1a5d$var$setupPerformanceObserver(replay) {
    const performanceObserverHandler = (list)=>{
        // For whatever reason the observer was returning duplicate navigation
        // entries (the other entry types were not duplicated).
        const newPerformanceEntries = $387daa7ca38f1a5d$var$dedupePerformanceEntries(replay.performanceEvents, list.getEntries());
        replay.performanceEvents = newPerformanceEntries;
    };
    const performanceObserver = new PerformanceObserver(performanceObserverHandler);
    [
        "element",
        "event",
        "first-input",
        "largest-contentful-paint",
        "layout-shift",
        "longtask",
        "navigation",
        "paint",
        "resource"
    ].forEach((type)=>{
        try {
            performanceObserver.observe({
                type: type,
                buffered: true
            });
        } catch (e) {
        // This can throw if an entry type is not supported in the browser.
        // Ignore these errors.
        }
    });
    return performanceObserver;
}
const $387daa7ca38f1a5d$var$r = `/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
function t(t){let e=t.length;for(;--e>=0;)t[e]=0}const e=new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]),a=new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]),i=new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]),n=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=new Array(576);t(s);const r=new Array(60);t(r);const o=new Array(512);t(o);const l=new Array(256);t(l);const h=new Array(29);t(h);const d=new Array(30);function _(t,e,a,i,n){this.static_tree=t,this.extra_bits=e,this.extra_base=a,this.elems=i,this.max_length=n,this.has_stree=t&&t.length}let f,c,u;function w(t,e){this.dyn_tree=t,this.max_code=0,this.stat_desc=e}t(d);const m=t=>t<256?o[t]:o[256+(t>>>7)],b=(t,e)=>{t.pending_buf[t.pending++]=255&e,t.pending_buf[t.pending++]=e>>>8&255},g=(t,e,a)=>{t.bi_valid>16-a?(t.bi_buf|=e<<t.bi_valid&65535,b(t,t.bi_buf),t.bi_buf=e>>16-t.bi_valid,t.bi_valid+=a-16):(t.bi_buf|=e<<t.bi_valid&65535,t.bi_valid+=a)},p=(t,e,a)=>{g(t,a[2*e],a[2*e+1])},k=(t,e)=>{let a=0;do{a|=1&t,t>>>=1,a<<=1}while(--e>0);return a>>>1},v=(t,e,a)=>{const i=new Array(16);let n,s,r=0;for(n=1;n<=15;n++)r=r+a[n-1]<<1,i[n]=r;for(s=0;s<=e;s++){let e=t[2*s+1];0!==e&&(t[2*s]=k(i[e]++,e))}},y=t=>{let e;for(e=0;e<286;e++)t.dyn_ltree[2*e]=0;for(e=0;e<30;e++)t.dyn_dtree[2*e]=0;for(e=0;e<19;e++)t.bl_tree[2*e]=0;t.dyn_ltree[512]=1,t.opt_len=t.static_len=0,t.sym_next=t.matches=0},x=t=>{t.bi_valid>8?b(t,t.bi_buf):t.bi_valid>0&&(t.pending_buf[t.pending++]=t.bi_buf),t.bi_buf=0,t.bi_valid=0},z=(t,e,a,i)=>{const n=2*e,s=2*a;return t[n]<t[s]||t[n]===t[s]&&i[e]<=i[a]},A=(t,e,a)=>{const i=t.heap[a];let n=a<<1;for(;n<=t.heap_len&&(n<t.heap_len&&z(e,t.heap[n+1],t.heap[n],t.depth)&&n++,!z(e,i,t.heap[n],t.depth));)t.heap[a]=t.heap[n],a=n,n<<=1;t.heap[a]=i},E=(t,i,n)=>{let s,r,o,_,f=0;if(0!==t.sym_next)do{s=255&t.pending_buf[t.sym_buf+f++],s+=(255&t.pending_buf[t.sym_buf+f++])<<8,r=t.pending_buf[t.sym_buf+f++],0===s?p(t,r,i):(o=l[r],p(t,o+256+1,i),_=e[o],0!==_&&(r-=h[o],g(t,r,_)),s--,o=m(s),p(t,o,n),_=a[o],0!==_&&(s-=d[o],g(t,s,_)))}while(f<t.sym_next);p(t,256,i)},R=(t,e)=>{const a=e.dyn_tree,i=e.stat_desc.static_tree,n=e.stat_desc.has_stree,s=e.stat_desc.elems;let r,o,l,h=-1;for(t.heap_len=0,t.heap_max=573,r=0;r<s;r++)0!==a[2*r]?(t.heap[++t.heap_len]=h=r,t.depth[r]=0):a[2*r+1]=0;for(;t.heap_len<2;)l=t.heap[++t.heap_len]=h<2?++h:0,a[2*l]=1,t.depth[l]=0,t.opt_len--,n&&(t.static_len-=i[2*l+1]);for(e.max_code=h,r=t.heap_len>>1;r>=1;r--)A(t,a,r);l=s;do{r=t.heap[1],t.heap[1]=t.heap[t.heap_len--],A(t,a,1),o=t.heap[1],t.heap[--t.heap_max]=r,t.heap[--t.heap_max]=o,a[2*l]=a[2*r]+a[2*o],t.depth[l]=(t.depth[r]>=t.depth[o]?t.depth[r]:t.depth[o])+1,a[2*r+1]=a[2*o+1]=l,t.heap[1]=l++,A(t,a,1)}while(t.heap_len>=2);t.heap[--t.heap_max]=t.heap[1],((t,e)=>{const a=e.dyn_tree,i=e.max_code,n=e.stat_desc.static_tree,s=e.stat_desc.has_stree,r=e.stat_desc.extra_bits,o=e.stat_desc.extra_base,l=e.stat_desc.max_length;let h,d,_,f,c,u,w=0;for(f=0;f<=15;f++)t.bl_count[f]=0;for(a[2*t.heap[t.heap_max]+1]=0,h=t.heap_max+1;h<573;h++)d=t.heap[h],f=a[2*a[2*d+1]+1]+1,f>l&&(f=l,w++),a[2*d+1]=f,d>i||(t.bl_count[f]++,c=0,d>=o&&(c=r[d-o]),u=a[2*d],t.opt_len+=u*(f+c),s&&(t.static_len+=u*(n[2*d+1]+c)));if(0!==w){do{for(f=l-1;0===t.bl_count[f];)f--;t.bl_count[f]--,t.bl_count[f+1]+=2,t.bl_count[l]--,w-=2}while(w>0);for(f=l;0!==f;f--)for(d=t.bl_count[f];0!==d;)_=t.heap[--h],_>i||(a[2*_+1]!==f&&(t.opt_len+=(f-a[2*_+1])*a[2*_],a[2*_+1]=f),d--)}})(t,e),v(a,h,t.bl_count)},Z=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),e[2*(a+1)+1]=65535,i=0;i<=a;i++)n=r,r=e[2*(i+1)+1],++o<l&&n===r||(o<h?t.bl_tree[2*n]+=o:0!==n?(n!==s&&t.bl_tree[2*n]++,t.bl_tree[32]++):o<=10?t.bl_tree[34]++:t.bl_tree[36]++,o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4))},U=(t,e,a)=>{let i,n,s=-1,r=e[1],o=0,l=7,h=4;for(0===r&&(l=138,h=3),i=0;i<=a;i++)if(n=r,r=e[2*(i+1)+1],!(++o<l&&n===r)){if(o<h)do{p(t,n,t.bl_tree)}while(0!=--o);else 0!==n?(n!==s&&(p(t,n,t.bl_tree),o--),p(t,16,t.bl_tree),g(t,o-3,2)):o<=10?(p(t,17,t.bl_tree),g(t,o-3,3)):(p(t,18,t.bl_tree),g(t,o-11,7));o=0,s=n,0===r?(l=138,h=3):n===r?(l=6,h=3):(l=7,h=4)}};let S=!1;const D=(t,e,a,i)=>{g(t,0+(i?1:0),3),x(t),b(t,a),b(t,~a),a&&t.pending_buf.set(t.window.subarray(e,e+a),t.pending),t.pending+=a};var T=(t,e,a,i)=>{let o,l,h=0;t.level>0?(2===t.strm.data_type&&(t.strm.data_type=(t=>{let e,a=4093624447;for(e=0;e<=31;e++,a>>>=1)if(1&a&&0!==t.dyn_ltree[2*e])return 0;if(0!==t.dyn_ltree[18]||0!==t.dyn_ltree[20]||0!==t.dyn_ltree[26])return 1;for(e=32;e<256;e++)if(0!==t.dyn_ltree[2*e])return 1;return 0})(t)),R(t,t.l_desc),R(t,t.d_desc),h=(t=>{let e;for(Z(t,t.dyn_ltree,t.l_desc.max_code),Z(t,t.dyn_dtree,t.d_desc.max_code),R(t,t.bl_desc),e=18;e>=3&&0===t.bl_tree[2*n[e]+1];e--);return t.opt_len+=3*(e+1)+5+5+4,e})(t),o=t.opt_len+3+7>>>3,l=t.static_len+3+7>>>3,l<=o&&(o=l)):o=l=a+5,a+4<=o&&-1!==e?D(t,e,a,i):4===t.strategy||l===o?(g(t,2+(i?1:0),3),E(t,s,r)):(g(t,4+(i?1:0),3),((t,e,a,i)=>{let s;for(g(t,e-257,5),g(t,a-1,5),g(t,i-4,4),s=0;s<i;s++)g(t,t.bl_tree[2*n[s]+1],3);U(t,t.dyn_ltree,e-1),U(t,t.dyn_dtree,a-1)})(t,t.l_desc.max_code+1,t.d_desc.max_code+1,h+1),E(t,t.dyn_ltree,t.dyn_dtree)),y(t),i&&x(t)},O={_tr_init:t=>{S||((()=>{let t,n,w,m,b;const g=new Array(16);for(w=0,m=0;m<28;m++)for(h[m]=w,t=0;t<1<<e[m];t++)l[w++]=m;for(l[w-1]=m,b=0,m=0;m<16;m++)for(d[m]=b,t=0;t<1<<a[m];t++)o[b++]=m;for(b>>=7;m<30;m++)for(d[m]=b<<7,t=0;t<1<<a[m]-7;t++)o[256+b++]=m;for(n=0;n<=15;n++)g[n]=0;for(t=0;t<=143;)s[2*t+1]=8,t++,g[8]++;for(;t<=255;)s[2*t+1]=9,t++,g[9]++;for(;t<=279;)s[2*t+1]=7,t++,g[7]++;for(;t<=287;)s[2*t+1]=8,t++,g[8]++;for(v(s,287,g),t=0;t<30;t++)r[2*t+1]=5,r[2*t]=k(t,5);f=new _(s,e,257,286,15),c=new _(r,a,0,30,15),u=new _(new Array(0),i,0,19,7)})(),S=!0),t.l_desc=new w(t.dyn_ltree,f),t.d_desc=new w(t.dyn_dtree,c),t.bl_desc=new w(t.bl_tree,u),t.bi_buf=0,t.bi_valid=0,y(t)},_tr_stored_block:D,_tr_flush_block:T,_tr_tally:(t,e,a)=>(t.pending_buf[t.sym_buf+t.sym_next++]=e,t.pending_buf[t.sym_buf+t.sym_next++]=e>>8,t.pending_buf[t.sym_buf+t.sym_next++]=a,0===e?t.dyn_ltree[2*a]++:(t.matches++,e--,t.dyn_ltree[2*(l[a]+256+1)]++,t.dyn_dtree[2*m(e)]++),t.sym_next===t.sym_end),_tr_align:t=>{g(t,2,3),p(t,256,s),(t=>{16===t.bi_valid?(b(t,t.bi_buf),t.bi_buf=0,t.bi_valid=0):t.bi_valid>=8&&(t.pending_buf[t.pending++]=255&t.bi_buf,t.bi_buf>>=8,t.bi_valid-=8)})(t)}};var F=(t,e,a,i)=>{let n=65535&t|0,s=t>>>16&65535|0,r=0;for(;0!==a;){r=a>2e3?2e3:a,a-=r;do{n=n+e[i++]|0,s=s+n|0}while(--r);n%=65521,s%=65521}return n|s<<16|0};const L=new Uint32Array((()=>{let t,e=[];for(var a=0;a<256;a++){t=a;for(var i=0;i<8;i++)t=1&t?3988292384^t>>>1:t>>>1;e[a]=t}return e})());var N=(t,e,a,i)=>{const n=L,s=i+a;t^=-1;for(let a=i;a<s;a++)t=t>>>8^n[255&(t^e[a])];return-1^t},I={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"},B={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_MEM_ERROR:-4,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8};const{_tr_init:C,_tr_stored_block:H,_tr_flush_block:M,_tr_tally:j,_tr_align:K}=O,{Z_NO_FLUSH:P,Z_PARTIAL_FLUSH:Y,Z_FULL_FLUSH:G,Z_FINISH:X,Z_BLOCK:W,Z_OK:q,Z_STREAM_END:J,Z_STREAM_ERROR:Q,Z_DATA_ERROR:V,Z_BUF_ERROR:$,Z_DEFAULT_COMPRESSION:tt,Z_FILTERED:et,Z_HUFFMAN_ONLY:at,Z_RLE:it,Z_FIXED:nt,Z_DEFAULT_STRATEGY:st,Z_UNKNOWN:rt,Z_DEFLATED:ot}=B,lt=(t,e)=>(t.msg=I[e],e),ht=t=>2*t-(t>4?9:0),dt=t=>{let e=t.length;for(;--e>=0;)t[e]=0},_t=t=>{let e,a,i,n=t.w_size;e=t.hash_size,i=e;do{a=t.head[--i],t.head[i]=a>=n?a-n:0}while(--e);e=n,i=e;do{a=t.prev[--i],t.prev[i]=a>=n?a-n:0}while(--e)};let ft=(t,e,a)=>(e<<t.hash_shift^a)&t.hash_mask;const ct=t=>{const e=t.state;let a=e.pending;a>t.avail_out&&(a=t.avail_out),0!==a&&(t.output.set(e.pending_buf.subarray(e.pending_out,e.pending_out+a),t.next_out),t.next_out+=a,e.pending_out+=a,t.total_out+=a,t.avail_out-=a,e.pending-=a,0===e.pending&&(e.pending_out=0))},ut=(t,e)=>{M(t,t.block_start>=0?t.block_start:-1,t.strstart-t.block_start,e),t.block_start=t.strstart,ct(t.strm)},wt=(t,e)=>{t.pending_buf[t.pending++]=e},mt=(t,e)=>{t.pending_buf[t.pending++]=e>>>8&255,t.pending_buf[t.pending++]=255&e},bt=(t,e,a,i)=>{let n=t.avail_in;return n>i&&(n=i),0===n?0:(t.avail_in-=n,e.set(t.input.subarray(t.next_in,t.next_in+n),a),1===t.state.wrap?t.adler=F(t.adler,e,n,a):2===t.state.wrap&&(t.adler=N(t.adler,e,n,a)),t.next_in+=n,t.total_in+=n,n)},gt=(t,e)=>{let a,i,n=t.max_chain_length,s=t.strstart,r=t.prev_length,o=t.nice_match;const l=t.strstart>t.w_size-262?t.strstart-(t.w_size-262):0,h=t.window,d=t.w_mask,_=t.prev,f=t.strstart+258;let c=h[s+r-1],u=h[s+r];t.prev_length>=t.good_match&&(n>>=2),o>t.lookahead&&(o=t.lookahead);do{if(a=e,h[a+r]===u&&h[a+r-1]===c&&h[a]===h[s]&&h[++a]===h[s+1]){s+=2,a++;do{}while(h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&h[++s]===h[++a]&&s<f);if(i=258-(f-s),s=f-258,i>r){if(t.match_start=e,r=i,i>=o)break;c=h[s+r-1],u=h[s+r]}}}while((e=_[e&d])>l&&0!=--n);return r<=t.lookahead?r:t.lookahead},pt=t=>{const e=t.w_size;let a,i,n;do{if(i=t.window_size-t.lookahead-t.strstart,t.strstart>=e+(e-262)&&(t.window.set(t.window.subarray(e,e+e-i),0),t.match_start-=e,t.strstart-=e,t.block_start-=e,t.insert>t.strstart&&(t.insert=t.strstart),_t(t),i+=e),0===t.strm.avail_in)break;if(a=bt(t.strm,t.window,t.strstart+t.lookahead,i),t.lookahead+=a,t.lookahead+t.insert>=3)for(n=t.strstart-t.insert,t.ins_h=t.window[n],t.ins_h=ft(t,t.ins_h,t.window[n+1]);t.insert&&(t.ins_h=ft(t,t.ins_h,t.window[n+3-1]),t.prev[n&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=n,n++,t.insert--,!(t.lookahead+t.insert<3)););}while(t.lookahead<262&&0!==t.strm.avail_in)},kt=(t,e)=>{let a,i,n,s=t.pending_buf_size-5>t.w_size?t.w_size:t.pending_buf_size-5,r=0,o=t.strm.avail_in;do{if(a=65535,n=t.bi_valid+42>>3,t.strm.avail_out<n)break;if(n=t.strm.avail_out-n,i=t.strstart-t.block_start,a>i+t.strm.avail_in&&(a=i+t.strm.avail_in),a>n&&(a=n),a<s&&(0===a&&e!==X||e===P||a!==i+t.strm.avail_in))break;r=e===X&&a===i+t.strm.avail_in?1:0,H(t,0,0,r),t.pending_buf[t.pending-4]=a,t.pending_buf[t.pending-3]=a>>8,t.pending_buf[t.pending-2]=~a,t.pending_buf[t.pending-1]=~a>>8,ct(t.strm),i&&(i>a&&(i=a),t.strm.output.set(t.window.subarray(t.block_start,t.block_start+i),t.strm.next_out),t.strm.next_out+=i,t.strm.avail_out-=i,t.strm.total_out+=i,t.block_start+=i,a-=i),a&&(bt(t.strm,t.strm.output,t.strm.next_out,a),t.strm.next_out+=a,t.strm.avail_out-=a,t.strm.total_out+=a)}while(0===r);return o-=t.strm.avail_in,o&&(o>=t.w_size?(t.matches=2,t.window.set(t.strm.input.subarray(t.strm.next_in-t.w_size,t.strm.next_in),0),t.strstart=t.w_size,t.insert=t.strstart):(t.window_size-t.strstart<=o&&(t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,t.insert>t.strstart&&(t.insert=t.strstart)),t.window.set(t.strm.input.subarray(t.strm.next_in-o,t.strm.next_in),t.strstart),t.strstart+=o,t.insert+=o>t.w_size-t.insert?t.w_size-t.insert:o),t.block_start=t.strstart),t.high_water<t.strstart&&(t.high_water=t.strstart),r?4:e!==P&&e!==X&&0===t.strm.avail_in&&t.strstart===t.block_start?2:(n=t.window_size-t.strstart,t.strm.avail_in>n&&t.block_start>=t.w_size&&(t.block_start-=t.w_size,t.strstart-=t.w_size,t.window.set(t.window.subarray(t.w_size,t.w_size+t.strstart),0),t.matches<2&&t.matches++,n+=t.w_size,t.insert>t.strstart&&(t.insert=t.strstart)),n>t.strm.avail_in&&(n=t.strm.avail_in),n&&(bt(t.strm,t.window,t.strstart,n),t.strstart+=n,t.insert+=n>t.w_size-t.insert?t.w_size-t.insert:n),t.high_water<t.strstart&&(t.high_water=t.strstart),n=t.bi_valid+42>>3,n=t.pending_buf_size-n>65535?65535:t.pending_buf_size-n,s=n>t.w_size?t.w_size:n,i=t.strstart-t.block_start,(i>=s||(i||e===X)&&e!==P&&0===t.strm.avail_in&&i<=n)&&(a=i>n?n:i,r=e===X&&0===t.strm.avail_in&&a===i?1:0,H(t,t.block_start,a,r),t.block_start+=a,ct(t.strm)),r?3:1)},vt=(t,e)=>{let a,i;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),0!==a&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a)),t.match_length>=3)if(i=j(t,t.strstart-t.match_start,t.match_length-3),t.lookahead-=t.match_length,t.match_length<=t.max_lazy_match&&t.lookahead>=3){t.match_length--;do{t.strstart++,t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart}while(0!=--t.match_length);t.strstart++}else t.strstart+=t.match_length,t.match_length=0,t.ins_h=t.window[t.strstart],t.ins_h=ft(t,t.ins_h,t.window[t.strstart+1]);else i=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++;if(i&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2},yt=(t,e)=>{let a,i,n;for(;;){if(t.lookahead<262){if(pt(t),t.lookahead<262&&e===P)return 1;if(0===t.lookahead)break}if(a=0,t.lookahead>=3&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart),t.prev_length=t.match_length,t.prev_match=t.match_start,t.match_length=2,0!==a&&t.prev_length<t.max_lazy_match&&t.strstart-a<=t.w_size-262&&(t.match_length=gt(t,a),t.match_length<=5&&(t.strategy===et||3===t.match_length&&t.strstart-t.match_start>4096)&&(t.match_length=2)),t.prev_length>=3&&t.match_length<=t.prev_length){n=t.strstart+t.lookahead-3,i=j(t,t.strstart-1-t.prev_match,t.prev_length-3),t.lookahead-=t.prev_length-1,t.prev_length-=2;do{++t.strstart<=n&&(t.ins_h=ft(t,t.ins_h,t.window[t.strstart+3-1]),a=t.prev[t.strstart&t.w_mask]=t.head[t.ins_h],t.head[t.ins_h]=t.strstart)}while(0!=--t.prev_length);if(t.match_available=0,t.match_length=2,t.strstart++,i&&(ut(t,!1),0===t.strm.avail_out))return 1}else if(t.match_available){if(i=j(t,0,t.window[t.strstart-1]),i&&ut(t,!1),t.strstart++,t.lookahead--,0===t.strm.avail_out)return 1}else t.match_available=1,t.strstart++,t.lookahead--}return t.match_available&&(i=j(t,0,t.window[t.strstart-1]),t.match_available=0),t.insert=t.strstart<2?t.strstart:2,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2};function xt(t,e,a,i,n){this.good_length=t,this.max_lazy=e,this.nice_length=a,this.max_chain=i,this.func=n}const zt=[new xt(0,0,0,0,kt),new xt(4,4,8,4,vt),new xt(4,5,16,8,vt),new xt(4,6,32,32,vt),new xt(4,4,16,16,yt),new xt(8,16,32,32,yt),new xt(8,16,128,128,yt),new xt(8,32,128,256,yt),new xt(32,128,258,1024,yt),new xt(32,258,258,4096,yt)];function At(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=ot,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new Uint16Array(1146),this.dyn_dtree=new Uint16Array(122),this.bl_tree=new Uint16Array(78),dt(this.dyn_ltree),dt(this.dyn_dtree),dt(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new Uint16Array(16),this.heap=new Uint16Array(573),dt(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new Uint16Array(573),dt(this.depth),this.sym_buf=0,this.lit_bufsize=0,this.sym_next=0,this.sym_end=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}const Et=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||42!==e.status&&57!==e.status&&69!==e.status&&73!==e.status&&91!==e.status&&103!==e.status&&113!==e.status&&666!==e.status?1:0},Rt=t=>{if(Et(t))return lt(t,Q);t.total_in=t.total_out=0,t.data_type=rt;const e=t.state;return e.pending=0,e.pending_out=0,e.wrap<0&&(e.wrap=-e.wrap),e.status=2===e.wrap?57:e.wrap?42:113,t.adler=2===e.wrap?0:1,e.last_flush=-2,C(e),q},Zt=t=>{const e=Rt(t);var a;return e===q&&((a=t.state).window_size=2*a.w_size,dt(a.head),a.max_lazy_match=zt[a.level].max_lazy,a.good_match=zt[a.level].good_length,a.nice_match=zt[a.level].nice_length,a.max_chain_length=zt[a.level].max_chain,a.strstart=0,a.block_start=0,a.lookahead=0,a.insert=0,a.match_length=a.prev_length=2,a.match_available=0,a.ins_h=0),e},Ut=(t,e,a,i,n,s)=>{if(!t)return Q;let r=1;if(e===tt&&(e=6),i<0?(r=0,i=-i):i>15&&(r=2,i-=16),n<1||n>9||a!==ot||i<8||i>15||e<0||e>9||s<0||s>nt||8===i&&1!==r)return lt(t,Q);8===i&&(i=9);const o=new At;return t.state=o,o.strm=t,o.status=42,o.wrap=r,o.gzhead=null,o.w_bits=i,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=n+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+3-1)/3),o.window=new Uint8Array(2*o.w_size),o.head=new Uint16Array(o.hash_size),o.prev=new Uint16Array(o.w_size),o.lit_bufsize=1<<n+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new Uint8Array(o.pending_buf_size),o.sym_buf=o.lit_bufsize,o.sym_end=3*(o.lit_bufsize-1),o.level=e,o.strategy=s,o.method=a,Zt(t)};var St={deflateInit:(t,e)=>Ut(t,e,ot,15,8,st),deflateInit2:Ut,deflateReset:Zt,deflateResetKeep:Rt,deflateSetHeader:(t,e)=>Et(t)||2!==t.state.wrap?Q:(t.state.gzhead=e,q),deflate:(t,e)=>{if(Et(t)||e>W||e<0)return t?lt(t,Q):Q;const a=t.state;if(!t.output||0!==t.avail_in&&!t.input||666===a.status&&e!==X)return lt(t,0===t.avail_out?$:Q);const i=a.last_flush;if(a.last_flush=e,0!==a.pending){if(ct(t),0===t.avail_out)return a.last_flush=-1,q}else if(0===t.avail_in&&ht(e)<=ht(i)&&e!==X)return lt(t,$);if(666===a.status&&0!==t.avail_in)return lt(t,$);if(42===a.status&&0===a.wrap&&(a.status=113),42===a.status){let e=ot+(a.w_bits-8<<4)<<8,i=-1;if(i=a.strategy>=at||a.level<2?0:a.level<6?1:6===a.level?2:3,e|=i<<6,0!==a.strstart&&(e|=32),e+=31-e%31,mt(a,e),0!==a.strstart&&(mt(a,t.adler>>>16),mt(a,65535&t.adler)),t.adler=1,a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(57===a.status)if(t.adler=0,wt(a,31),wt(a,139),wt(a,8),a.gzhead)wt(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(a.gzhead.extra?4:0)+(a.gzhead.name?8:0)+(a.gzhead.comment?16:0)),wt(a,255&a.gzhead.time),wt(a,a.gzhead.time>>8&255),wt(a,a.gzhead.time>>16&255),wt(a,a.gzhead.time>>24&255),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,255&a.gzhead.os),a.gzhead.extra&&a.gzhead.extra.length&&(wt(a,255&a.gzhead.extra.length),wt(a,a.gzhead.extra.length>>8&255)),a.gzhead.hcrc&&(t.adler=N(t.adler,a.pending_buf,a.pending,0)),a.gzindex=0,a.status=69;else if(wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,0),wt(a,9===a.level?2:a.strategy>=at||a.level<2?4:0),wt(a,3),a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q;if(69===a.status){if(a.gzhead.extra){let e=a.pending,i=(65535&a.gzhead.extra.length)-a.gzindex;for(;a.pending+i>a.pending_buf_size;){let n=a.pending_buf_size-a.pending;if(a.pending_buf.set(a.gzhead.extra.subarray(a.gzindex,a.gzindex+n),a.pending),a.pending=a.pending_buf_size,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex+=n,ct(t),0!==a.pending)return a.last_flush=-1,q;e=0,i-=n}let n=new Uint8Array(a.gzhead.extra);a.pending_buf.set(n.subarray(a.gzindex,a.gzindex+i),a.pending),a.pending+=i,a.gzhead.hcrc&&a.pending>e&&(t.adler=N(t.adler,a.pending_buf,a.pending-e,e)),a.gzindex=0}a.status=73}if(73===a.status){if(a.gzhead.name){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.name.length?255&a.gzhead.name.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),a.gzindex=0}a.status=91}if(91===a.status){if(a.gzhead.comment){let e,i=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i)),ct(t),0!==a.pending)return a.last_flush=-1,q;i=0}e=a.gzindex<a.gzhead.comment.length?255&a.gzhead.comment.charCodeAt(a.gzindex++):0,wt(a,e)}while(0!==e);a.gzhead.hcrc&&a.pending>i&&(t.adler=N(t.adler,a.pending_buf,a.pending-i,i))}a.status=103}if(103===a.status){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size&&(ct(t),0!==a.pending))return a.last_flush=-1,q;wt(a,255&t.adler),wt(a,t.adler>>8&255),t.adler=0}if(a.status=113,ct(t),0!==a.pending)return a.last_flush=-1,q}if(0!==t.avail_in||0!==a.lookahead||e!==P&&666!==a.status){let i=0===a.level?kt(a,e):a.strategy===at?((t,e)=>{let a;for(;;){if(0===t.lookahead&&(pt(t),0===t.lookahead)){if(e===P)return 1;break}if(t.match_length=0,a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++,a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):a.strategy===it?((t,e)=>{let a,i,n,s;const r=t.window;for(;;){if(t.lookahead<=258){if(pt(t),t.lookahead<=258&&e===P)return 1;if(0===t.lookahead)break}if(t.match_length=0,t.lookahead>=3&&t.strstart>0&&(n=t.strstart-1,i=r[n],i===r[++n]&&i===r[++n]&&i===r[++n])){s=t.strstart+258;do{}while(i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&i===r[++n]&&n<s);t.match_length=258-(s-n),t.match_length>t.lookahead&&(t.match_length=t.lookahead)}if(t.match_length>=3?(a=j(t,1,t.match_length-3),t.lookahead-=t.match_length,t.strstart+=t.match_length,t.match_length=0):(a=j(t,0,t.window[t.strstart]),t.lookahead--,t.strstart++),a&&(ut(t,!1),0===t.strm.avail_out))return 1}return t.insert=0,e===X?(ut(t,!0),0===t.strm.avail_out?3:4):t.sym_next&&(ut(t,!1),0===t.strm.avail_out)?1:2})(a,e):zt[a.level].func(a,e);if(3!==i&&4!==i||(a.status=666),1===i||3===i)return 0===t.avail_out&&(a.last_flush=-1),q;if(2===i&&(e===Y?K(a):e!==W&&(H(a,0,0,!1),e===G&&(dt(a.head),0===a.lookahead&&(a.strstart=0,a.block_start=0,a.insert=0))),ct(t),0===t.avail_out))return a.last_flush=-1,q}return e!==X?q:a.wrap<=0?J:(2===a.wrap?(wt(a,255&t.adler),wt(a,t.adler>>8&255),wt(a,t.adler>>16&255),wt(a,t.adler>>24&255),wt(a,255&t.total_in),wt(a,t.total_in>>8&255),wt(a,t.total_in>>16&255),wt(a,t.total_in>>24&255)):(mt(a,t.adler>>>16),mt(a,65535&t.adler)),ct(t),a.wrap>0&&(a.wrap=-a.wrap),0!==a.pending?q:J)},deflateEnd:t=>{if(Et(t))return Q;const e=t.state.status;return t.state=null,113===e?lt(t,V):q},deflateSetDictionary:(t,e)=>{let a=e.length;if(Et(t))return Q;const i=t.state,n=i.wrap;if(2===n||1===n&&42!==i.status||i.lookahead)return Q;if(1===n&&(t.adler=F(t.adler,e,a,0)),i.wrap=0,a>=i.w_size){0===n&&(dt(i.head),i.strstart=0,i.block_start=0,i.insert=0);let t=new Uint8Array(i.w_size);t.set(e.subarray(a-i.w_size,a),0),e=t,a=i.w_size}const s=t.avail_in,r=t.next_in,o=t.input;for(t.avail_in=a,t.next_in=0,t.input=e,pt(i);i.lookahead>=3;){let t=i.strstart,e=i.lookahead-2;do{i.ins_h=ft(i,i.ins_h,i.window[t+3-1]),i.prev[t&i.w_mask]=i.head[i.ins_h],i.head[i.ins_h]=t,t++}while(--e);i.strstart=t,i.lookahead=2,pt(i)}return i.strstart+=i.lookahead,i.block_start=i.strstart,i.insert=i.lookahead,i.lookahead=0,i.match_length=i.prev_length=2,i.match_available=0,t.next_in=r,t.input=o,t.avail_in=s,i.wrap=n,q},deflateInfo:"pako deflate (from Nodeca project)"};const Dt=(t,e)=>Object.prototype.hasOwnProperty.call(t,e);var Tt=function(t){const e=Array.prototype.slice.call(arguments,1);for(;e.length;){const a=e.shift();if(a){if("object"!=typeof a)throw new TypeError(a+"must be non-object");for(const e in a)Dt(a,e)&&(t[e]=a[e])}}return t},Ot=t=>{let e=0;for(let a=0,i=t.length;a<i;a++)e+=t[a].length;const a=new Uint8Array(e);for(let e=0,i=0,n=t.length;e<n;e++){let n=t[e];a.set(n,i),i+=n.length}return a};let Ft=!0;try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(t){Ft=!1}const Lt=new Uint8Array(256);for(let t=0;t<256;t++)Lt[t]=t>=252?6:t>=248?5:t>=240?4:t>=224?3:t>=192?2:1;Lt[254]=Lt[254]=1;var Nt=t=>{if("function"==typeof TextEncoder&&TextEncoder.prototype.encode)return(new TextEncoder).encode(t);let e,a,i,n,s,r=t.length,o=0;for(n=0;n<r;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),o+=a<128?1:a<2048?2:a<65536?3:4;for(e=new Uint8Array(o),s=0,n=0;s<o;n++)a=t.charCodeAt(n),55296==(64512&a)&&n+1<r&&(i=t.charCodeAt(n+1),56320==(64512&i)&&(a=65536+(a-55296<<10)+(i-56320),n++)),a<128?e[s++]=a:a<2048?(e[s++]=192|a>>>6,e[s++]=128|63&a):a<65536?(e[s++]=224|a>>>12,e[s++]=128|a>>>6&63,e[s++]=128|63&a):(e[s++]=240|a>>>18,e[s++]=128|a>>>12&63,e[s++]=128|a>>>6&63,e[s++]=128|63&a);return e},It=(t,e)=>{const a=e||t.length;if("function"==typeof TextDecoder&&TextDecoder.prototype.decode)return(new TextDecoder).decode(t.subarray(0,e));let i,n;const s=new Array(2*a);for(n=0,i=0;i<a;){let e=t[i++];if(e<128){s[n++]=e;continue}let r=Lt[e];if(r>4)s[n++]=65533,i+=r-1;else{for(e&=2===r?31:3===r?15:7;r>1&&i<a;)e=e<<6|63&t[i++],r--;r>1?s[n++]=65533:e<65536?s[n++]=e:(e-=65536,s[n++]=55296|e>>10&1023,s[n++]=56320|1023&e)}}return((t,e)=>{if(e<65534&&t.subarray&&Ft)return String.fromCharCode.apply(null,t.length===e?t:t.subarray(0,e));let a="";for(let i=0;i<e;i++)a+=String.fromCharCode(t[i]);return a})(s,n)},Bt=(t,e)=>{(e=e||t.length)>t.length&&(e=t.length);let a=e-1;for(;a>=0&&128==(192&t[a]);)a--;return a<0||0===a?e:a+Lt[t[a]]>e?a:e};var Ct=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0};const Ht=Object.prototype.toString,{Z_NO_FLUSH:Mt,Z_SYNC_FLUSH:jt,Z_FULL_FLUSH:Kt,Z_FINISH:Pt,Z_OK:Yt,Z_STREAM_END:Gt,Z_DEFAULT_COMPRESSION:Xt,Z_DEFAULT_STRATEGY:Wt,Z_DEFLATED:qt}=B;function Jt(t){this.options=Tt({level:Xt,method:qt,chunkSize:16384,windowBits:15,memLevel:8,strategy:Wt},t||{});let e=this.options;e.raw&&e.windowBits>0?e.windowBits=-e.windowBits:e.gzip&&e.windowBits>0&&e.windowBits<16&&(e.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=St.deflateInit2(this.strm,e.level,e.method,e.windowBits,e.memLevel,e.strategy);if(a!==Yt)throw new Error(I[a]);if(e.header&&St.deflateSetHeader(this.strm,e.header),e.dictionary){let t;if(t="string"==typeof e.dictionary?Nt(e.dictionary):"[object ArrayBuffer]"===Ht.call(e.dictionary)?new Uint8Array(e.dictionary):e.dictionary,a=St.deflateSetDictionary(this.strm,t),a!==Yt)throw new Error(I[a]);this._dict_set=!0}}function Qt(t,e){const a=new Jt(e);if(a.push(t,!0),a.err)throw a.msg||I[a.err];return a.result}Jt.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize;let n,s;if(this.ended)return!1;for(s=e===~~e?e:!0===e?Pt:Mt,"string"==typeof t?a.input=Nt(t):"[object ArrayBuffer]"===Ht.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;)if(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),(s===jt||s===Kt)&&a.avail_out<=6)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else{if(n=St.deflate(a,s),n===Gt)return a.next_out>0&&this.onData(a.output.subarray(0,a.next_out)),n=St.deflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===Yt;if(0!==a.avail_out){if(s>0&&a.next_out>0)this.onData(a.output.subarray(0,a.next_out)),a.avail_out=0;else if(0===a.avail_in)break}else this.onData(a.output)}return!0},Jt.prototype.onData=function(t){this.chunks.push(t)},Jt.prototype.onEnd=function(t){t===Yt&&(this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};var Vt={Deflate:Jt,deflate:Qt,deflateRaw:function(t,e){return(e=e||{}).raw=!0,Qt(t,e)},gzip:function(t,e){return(e=e||{}).gzip=!0,Qt(t,e)},constants:B};var $t=function(t,e){let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z,A;const E=t.state;a=t.next_in,z=t.input,i=a+(t.avail_in-5),n=t.next_out,A=t.output,s=n-(e-t.avail_out),r=n+(t.avail_out-257),o=E.dmax,l=E.wsize,h=E.whave,d=E.wnext,_=E.window,f=E.hold,c=E.bits,u=E.lencode,w=E.distcode,m=(1<<E.lenbits)-1,b=(1<<E.distbits)-1;t:do{c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=u[f&m];e:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,0===p)A[n++]=65535&g;else{if(!(16&p)){if(0==(64&p)){g=u[(65535&g)+(f&(1<<p)-1)];continue e}if(32&p){E.mode=16191;break t}t.msg="invalid literal/length code",E.mode=16209;break t}k=65535&g,p&=15,p&&(c<p&&(f+=z[a++]<<c,c+=8),k+=f&(1<<p)-1,f>>>=p,c-=p),c<15&&(f+=z[a++]<<c,c+=8,f+=z[a++]<<c,c+=8),g=w[f&b];a:for(;;){if(p=g>>>24,f>>>=p,c-=p,p=g>>>16&255,!(16&p)){if(0==(64&p)){g=w[(65535&g)+(f&(1<<p)-1)];continue a}t.msg="invalid distance code",E.mode=16209;break t}if(v=65535&g,p&=15,c<p&&(f+=z[a++]<<c,c+=8,c<p&&(f+=z[a++]<<c,c+=8)),v+=f&(1<<p)-1,v>o){t.msg="invalid distance too far back",E.mode=16209;break t}if(f>>>=p,c-=p,p=n-s,v>p){if(p=v-p,p>h&&E.sane){t.msg="invalid distance too far back",E.mode=16209;break t}if(y=0,x=_,0===d){if(y+=l-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}else if(d<p){if(y+=l+d-p,p-=d,p<k){k-=p;do{A[n++]=_[y++]}while(--p);if(y=0,d<k){p=d,k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}}}else if(y+=d-p,p<k){k-=p;do{A[n++]=_[y++]}while(--p);y=n-v,x=A}for(;k>2;)A[n++]=x[y++],A[n++]=x[y++],A[n++]=x[y++],k-=3;k&&(A[n++]=x[y++],k>1&&(A[n++]=x[y++]))}else{y=n-v;do{A[n++]=A[y++],A[n++]=A[y++],A[n++]=A[y++],k-=3}while(k>2);k&&(A[n++]=A[y++],k>1&&(A[n++]=A[y++]))}break}}break}}while(a<i&&n<r);k=c>>3,a-=k,c-=k<<3,f&=(1<<c)-1,t.next_in=a,t.next_out=n,t.avail_in=a<i?i-a+5:5-(a-i),t.avail_out=n<r?r-n+257:257-(n-r),E.hold=f,E.bits=c};const te=new Uint16Array([3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0]),ee=new Uint8Array([16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78]),ae=new Uint16Array([1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0]),ie=new Uint8Array([16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64]);var ne=(t,e,a,i,n,s,r,o)=>{const l=o.bits;let h,d,_,f,c,u,w=0,m=0,b=0,g=0,p=0,k=0,v=0,y=0,x=0,z=0,A=null;const E=new Uint16Array(16),R=new Uint16Array(16);let Z,U,S,D=null;for(w=0;w<=15;w++)E[w]=0;for(m=0;m<i;m++)E[e[a+m]]++;for(p=l,g=15;g>=1&&0===E[g];g--);if(p>g&&(p=g),0===g)return n[s++]=20971520,n[s++]=20971520,o.bits=1,0;for(b=1;b<g&&0===E[b];b++);for(p<b&&(p=b),y=1,w=1;w<=15;w++)if(y<<=1,y-=E[w],y<0)return-1;if(y>0&&(0===t||1!==g))return-1;for(R[1]=0,w=1;w<15;w++)R[w+1]=R[w]+E[w];for(m=0;m<i;m++)0!==e[a+m]&&(r[R[e[a+m]]++]=m);if(0===t?(A=D=r,u=20):1===t?(A=te,D=ee,u=257):(A=ae,D=ie,u=0),z=0,m=0,w=b,c=s,k=p,v=0,_=-1,x=1<<p,f=x-1,1===t&&x>852||2===t&&x>592)return 1;for(;;){Z=w-v,r[m]+1<u?(U=0,S=r[m]):r[m]>=u?(U=D[r[m]-u],S=A[r[m]-u]):(U=96,S=0),h=1<<w-v,d=1<<k,b=d;do{d-=h,n[c+(z>>v)+d]=Z<<24|U<<16|S|0}while(0!==d);for(h=1<<w-1;z&h;)h>>=1;if(0!==h?(z&=h-1,z+=h):z=0,m++,0==--E[w]){if(w===g)break;w=e[a+r[m]]}if(w>p&&(z&f)!==_){for(0===v&&(v=p),c+=b,k=w-v,y=1<<k;k+v<g&&(y-=E[k+v],!(y<=0));)k++,y<<=1;if(x+=1<<k,1===t&&x>852||2===t&&x>592)return 1;_=z&f,n[_]=p<<24|k<<16|c-s|0}}return 0!==z&&(n[c+z]=w-v<<24|64<<16|0),o.bits=p,0};const{Z_FINISH:se,Z_BLOCK:re,Z_TREES:oe,Z_OK:le,Z_STREAM_END:he,Z_NEED_DICT:de,Z_STREAM_ERROR:_e,Z_DATA_ERROR:fe,Z_MEM_ERROR:ce,Z_BUF_ERROR:ue,Z_DEFLATED:we}=B,me=16209,be=t=>(t>>>24&255)+(t>>>8&65280)+((65280&t)<<8)+((255&t)<<24);function ge(){this.strm=null,this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new Uint16Array(320),this.work=new Uint16Array(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}const pe=t=>{if(!t)return 1;const e=t.state;return!e||e.strm!==t||e.mode<16180||e.mode>16211?1:0},ke=t=>{if(pe(t))return _e;const e=t.state;return t.total_in=t.total_out=e.total=0,t.msg="",e.wrap&&(t.adler=1&e.wrap),e.mode=16180,e.last=0,e.havedict=0,e.flags=-1,e.dmax=32768,e.head=null,e.hold=0,e.bits=0,e.lencode=e.lendyn=new Int32Array(852),e.distcode=e.distdyn=new Int32Array(592),e.sane=1,e.back=-1,le},ve=t=>{if(pe(t))return _e;const e=t.state;return e.wsize=0,e.whave=0,e.wnext=0,ke(t)},ye=(t,e)=>{let a;if(pe(t))return _e;const i=t.state;return e<0?(a=0,e=-e):(a=5+(e>>4),e<48&&(e&=15)),e&&(e<8||e>15)?_e:(null!==i.window&&i.wbits!==e&&(i.window=null),i.wrap=a,i.wbits=e,ve(t))},xe=(t,e)=>{if(!t)return _e;const a=new ge;t.state=a,a.strm=t,a.window=null,a.mode=16180;const i=ye(t,e);return i!==le&&(t.state=null),i};let ze,Ae,Ee=!0;const Re=t=>{if(Ee){ze=new Int32Array(512),Ae=new Int32Array(32);let e=0;for(;e<144;)t.lens[e++]=8;for(;e<256;)t.lens[e++]=9;for(;e<280;)t.lens[e++]=7;for(;e<288;)t.lens[e++]=8;for(ne(1,t.lens,0,288,ze,0,t.work,{bits:9}),e=0;e<32;)t.lens[e++]=5;ne(2,t.lens,0,32,Ae,0,t.work,{bits:5}),Ee=!1}t.lencode=ze,t.lenbits=9,t.distcode=Ae,t.distbits=5},Ze=(t,e,a,i)=>{let n;const s=t.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new Uint8Array(s.wsize)),i>=s.wsize?(s.window.set(e.subarray(a-s.wsize,a),0),s.wnext=0,s.whave=s.wsize):(n=s.wsize-s.wnext,n>i&&(n=i),s.window.set(e.subarray(a-i,a-i+n),s.wnext),(i-=n)?(s.window.set(e.subarray(a-i,a),0),s.wnext=i,s.whave=s.wsize):(s.wnext+=n,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=n))),0};var Ue={inflateReset:ve,inflateReset2:ye,inflateResetKeep:ke,inflateInit:t=>xe(t,15),inflateInit2:xe,inflate:(t,e)=>{let a,i,n,s,r,o,l,h,d,_,f,c,u,w,m,b,g,p,k,v,y,x,z=0;const A=new Uint8Array(4);let E,R;const Z=new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);if(pe(t)||!t.output||!t.input&&0!==t.avail_in)return _e;a=t.state,16191===a.mode&&(a.mode=16192),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,_=o,f=l,x=le;t:for(;;)switch(a.mode){case 16180:if(0===a.wrap){a.mode=16192;break}for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(2&a.wrap&&35615===h){0===a.wbits&&(a.wbits=15),a.check=0,A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0),h=0,d=0,a.mode=16181;break}if(a.head&&(a.head.done=!1),!(1&a.wrap)||(((255&h)<<8)+(h>>8))%31){t.msg="incorrect header check",a.mode=me;break}if((15&h)!==we){t.msg="unknown compression method",a.mode=me;break}if(h>>>=4,d-=4,y=8+(15&h),0===a.wbits&&(a.wbits=y),y>15||y>a.wbits){t.msg="invalid window size",a.mode=me;break}a.dmax=1<<a.wbits,a.flags=0,t.adler=a.check=1,a.mode=512&h?16189:16191,h=0,d=0;break;case 16181:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.flags=h,(255&a.flags)!==we){t.msg="unknown compression method",a.mode=me;break}if(57344&a.flags){t.msg="unknown header flags set",a.mode=me;break}a.head&&(a.head.text=h>>8&1),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16182;case 16182:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.time=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,A[2]=h>>>16&255,A[3]=h>>>24&255,a.check=N(a.check,A,4,0)),h=0,d=0,a.mode=16183;case 16183:for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.head&&(a.head.xflags=255&h,a.head.os=h>>8),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0,a.mode=16184;case 16184:if(1024&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length=h,a.head&&(a.head.extra_len=h),512&a.flags&&4&a.wrap&&(A[0]=255&h,A[1]=h>>>8&255,a.check=N(a.check,A,2,0)),h=0,d=0}else a.head&&(a.head.extra=null);a.mode=16185;case 16185:if(1024&a.flags&&(c=a.length,c>o&&(c=o),c&&(a.head&&(y=a.head.extra_len-a.length,a.head.extra||(a.head.extra=new Uint8Array(a.head.extra_len)),a.head.extra.set(i.subarray(s,s+c),y)),512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,a.length-=c),a.length))break t;a.length=0,a.mode=16186;case 16186:if(2048&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.name+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.name=null);a.length=0,a.mode=16187;case 16187:if(4096&a.flags){if(0===o)break t;c=0;do{y=i[s+c++],a.head&&y&&a.length<65536&&(a.head.comment+=String.fromCharCode(y))}while(y&&c<o);if(512&a.flags&&4&a.wrap&&(a.check=N(a.check,i,c,s)),o-=c,s+=c,y)break t}else a.head&&(a.head.comment=null);a.mode=16188;case 16188:if(512&a.flags){for(;d<16;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(65535&a.check)){t.msg="header crc mismatch",a.mode=me;break}h=0,d=0}a.head&&(a.head.hcrc=a.flags>>9&1,a.head.done=!0),t.adler=a.check=0,a.mode=16191;break;case 16189:for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}t.adler=a.check=be(h),h=0,d=0,a.mode=16190;case 16190:if(0===a.havedict)return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,de;t.adler=a.check=1,a.mode=16191;case 16191:if(e===re||e===oe)break t;case 16192:if(a.last){h>>>=7&d,d-=7&d,a.mode=16206;break}for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}switch(a.last=1&h,h>>>=1,d-=1,3&h){case 0:a.mode=16193;break;case 1:if(Re(a),a.mode=16199,e===oe){h>>>=2,d-=2;break t}break;case 2:a.mode=16196;break;case 3:t.msg="invalid block type",a.mode=me}h>>>=2,d-=2;break;case 16193:for(h>>>=7&d,d-=7&d;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){t.msg="invalid stored block lengths",a.mode=me;break}if(a.length=65535&h,h=0,d=0,a.mode=16194,e===oe)break t;case 16194:a.mode=16195;case 16195:if(c=a.length,c){if(c>o&&(c=o),c>l&&(c=l),0===c)break t;n.set(i.subarray(s,s+c),r),o-=c,s+=c,l-=c,r+=c,a.length-=c;break}a.mode=16191;break;case 16196:for(;d<14;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(a.nlen=257+(31&h),h>>>=5,d-=5,a.ndist=1+(31&h),h>>>=5,d-=5,a.ncode=4+(15&h),h>>>=4,d-=4,a.nlen>286||a.ndist>30){t.msg="too many length or distance symbols",a.mode=me;break}a.have=0,a.mode=16197;case 16197:for(;a.have<a.ncode;){for(;d<3;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.lens[Z[a.have++]]=7&h,h>>>=3,d-=3}for(;a.have<19;)a.lens[Z[a.have++]]=0;if(a.lencode=a.lendyn,a.lenbits=7,E={bits:a.lenbits},x=ne(0,a.lens,0,19,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid code lengths set",a.mode=me;break}a.have=0,a.mode=16198;case 16198:for(;a.have<a.nlen+a.ndist;){for(;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(g<16)h>>>=m,d-=m,a.lens[a.have++]=g;else{if(16===g){for(R=m+2;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(h>>>=m,d-=m,0===a.have){t.msg="invalid bit length repeat",a.mode=me;break}y=a.lens[a.have-1],c=3+(3&h),h>>>=2,d-=2}else if(17===g){for(R=m+3;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=3+(7&h),h>>>=3,d-=3}else{for(R=m+7;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=m,d-=m,y=0,c=11+(127&h),h>>>=7,d-=7}if(a.have+c>a.nlen+a.ndist){t.msg="invalid bit length repeat",a.mode=me;break}for(;c--;)a.lens[a.have++]=y}}if(a.mode===me)break;if(0===a.lens[256]){t.msg="invalid code -- missing end-of-block",a.mode=me;break}if(a.lenbits=9,E={bits:a.lenbits},x=ne(1,a.lens,0,a.nlen,a.lencode,0,a.work,E),a.lenbits=E.bits,x){t.msg="invalid literal/lengths set",a.mode=me;break}if(a.distbits=6,a.distcode=a.distdyn,E={bits:a.distbits},x=ne(2,a.lens,a.nlen,a.ndist,a.distcode,0,a.work,E),a.distbits=E.bits,x){t.msg="invalid distances set",a.mode=me;break}if(a.mode=16199,e===oe)break t;case 16199:a.mode=16200;case 16200:if(o>=6&&l>=258){t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,$t(t,f),r=t.next_out,n=t.output,l=t.avail_out,s=t.next_in,i=t.input,o=t.avail_in,h=a.hold,d=a.bits,16191===a.mode&&(a.back=-1);break}for(a.back=0;z=a.lencode[h&(1<<a.lenbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(b&&0==(240&b)){for(p=m,k=b,v=g;z=a.lencode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,a.length=g,0===b){a.mode=16205;break}if(32&b){a.back=-1,a.mode=16191;break}if(64&b){t.msg="invalid literal/length code",a.mode=me;break}a.extra=15&b,a.mode=16201;case 16201:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.length+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}a.was=a.length,a.mode=16202;case 16202:for(;z=a.distcode[h&(1<<a.distbits)-1],m=z>>>24,b=z>>>16&255,g=65535&z,!(m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(0==(240&b)){for(p=m,k=b,v=g;z=a.distcode[v+((h&(1<<p+k)-1)>>p)],m=z>>>24,b=z>>>16&255,g=65535&z,!(p+m<=d);){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}h>>>=p,d-=p,a.back+=p}if(h>>>=m,d-=m,a.back+=m,64&b){t.msg="invalid distance code",a.mode=me;break}a.offset=g,a.extra=15&b,a.mode=16203;case 16203:if(a.extra){for(R=a.extra;d<R;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}a.offset+=h&(1<<a.extra)-1,h>>>=a.extra,d-=a.extra,a.back+=a.extra}if(a.offset>a.dmax){t.msg="invalid distance too far back",a.mode=me;break}a.mode=16204;case 16204:if(0===l)break t;if(c=f-l,a.offset>c){if(c=a.offset-c,c>a.whave&&a.sane){t.msg="invalid distance too far back",a.mode=me;break}c>a.wnext?(c-=a.wnext,u=a.wsize-c):u=a.wnext-c,c>a.length&&(c=a.length),w=a.window}else w=n,u=r-a.offset,c=a.length;c>l&&(c=l),l-=c,a.length-=c;do{n[r++]=w[u++]}while(--c);0===a.length&&(a.mode=16200);break;case 16205:if(0===l)break t;n[r++]=a.length,l--,a.mode=16200;break;case 16206:if(a.wrap){for(;d<32;){if(0===o)break t;o--,h|=i[s++]<<d,d+=8}if(f-=l,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,r-f):F(a.check,n,f,r-f)),f=l,4&a.wrap&&(a.flags?h:be(h))!==a.check){t.msg="incorrect data check",a.mode=me;break}h=0,d=0}a.mode=16207;case 16207:if(a.wrap&&a.flags){for(;d<32;){if(0===o)break t;o--,h+=i[s++]<<d,d+=8}if(4&a.wrap&&h!==(4294967295&a.total)){t.msg="incorrect length check",a.mode=me;break}h=0,d=0}a.mode=16208;case 16208:x=he;break t;case me:x=fe;break t;case 16210:return ce;default:return _e}return t.next_out=r,t.avail_out=l,t.next_in=s,t.avail_in=o,a.hold=h,a.bits=d,(a.wsize||f!==t.avail_out&&a.mode<me&&(a.mode<16206||e!==se))&&Ze(t,t.output,t.next_out,f-t.avail_out),_-=t.avail_in,f-=t.avail_out,t.total_in+=_,t.total_out+=f,a.total+=f,4&a.wrap&&f&&(t.adler=a.check=a.flags?N(a.check,n,f,t.next_out-f):F(a.check,n,f,t.next_out-f)),t.data_type=a.bits+(a.last?64:0)+(16191===a.mode?128:0)+(16199===a.mode||16194===a.mode?256:0),(0===_&&0===f||e===se)&&x===le&&(x=ue),x},inflateEnd:t=>{if(pe(t))return _e;let e=t.state;return e.window&&(e.window=null),t.state=null,le},inflateGetHeader:(t,e)=>{if(pe(t))return _e;const a=t.state;return 0==(2&a.wrap)?_e:(a.head=e,e.done=!1,le)},inflateSetDictionary:(t,e)=>{const a=e.length;let i,n,s;return pe(t)?_e:(i=t.state,0!==i.wrap&&16190!==i.mode?_e:16190===i.mode&&(n=1,n=F(n,e,a,0),n!==i.check)?fe:(s=Ze(t,e,a,a),s?(i.mode=16210,ce):(i.havedict=1,le)))},inflateInfo:"pako inflate (from Nodeca project)"};var Se=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1};const De=Object.prototype.toString,{Z_NO_FLUSH:Te,Z_FINISH:Oe,Z_OK:Fe,Z_STREAM_END:Le,Z_NEED_DICT:Ne,Z_STREAM_ERROR:Ie,Z_DATA_ERROR:Be,Z_MEM_ERROR:Ce}=B;function He(t){this.options=Tt({chunkSize:65536,windowBits:15,to:""},t||{});const e=this.options;e.raw&&e.windowBits>=0&&e.windowBits<16&&(e.windowBits=-e.windowBits,0===e.windowBits&&(e.windowBits=-15)),!(e.windowBits>=0&&e.windowBits<16)||t&&t.windowBits||(e.windowBits+=32),e.windowBits>15&&e.windowBits<48&&0==(15&e.windowBits)&&(e.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new Ct,this.strm.avail_out=0;let a=Ue.inflateInit2(this.strm,e.windowBits);if(a!==Fe)throw new Error(I[a]);if(this.header=new Se,Ue.inflateGetHeader(this.strm,this.header),e.dictionary&&("string"==typeof e.dictionary?e.dictionary=Nt(e.dictionary):"[object ArrayBuffer]"===De.call(e.dictionary)&&(e.dictionary=new Uint8Array(e.dictionary)),e.raw&&(a=Ue.inflateSetDictionary(this.strm,e.dictionary),a!==Fe)))throw new Error(I[a])}He.prototype.push=function(t,e){const a=this.strm,i=this.options.chunkSize,n=this.options.dictionary;let s,r,o;if(this.ended)return!1;for(r=e===~~e?e:!0===e?Oe:Te,"[object ArrayBuffer]"===De.call(t)?a.input=new Uint8Array(t):a.input=t,a.next_in=0,a.avail_in=a.input.length;;){for(0===a.avail_out&&(a.output=new Uint8Array(i),a.next_out=0,a.avail_out=i),s=Ue.inflate(a,r),s===Ne&&n&&(s=Ue.inflateSetDictionary(a,n),s===Fe?s=Ue.inflate(a,r):s===Be&&(s=Ne));a.avail_in>0&&s===Le&&a.state.wrap>0&&0!==t[a.next_in];)Ue.inflateReset(a),s=Ue.inflate(a,r);switch(s){case Ie:case Be:case Ne:case Ce:return this.onEnd(s),this.ended=!0,!1}if(o=a.avail_out,a.next_out&&(0===a.avail_out||s===Le))if("string"===this.options.to){let t=Bt(a.output,a.next_out),e=a.next_out-t,n=It(a.output,t);a.next_out=e,a.avail_out=i-e,e&&a.output.set(a.output.subarray(t,t+e),0),this.onData(n)}else this.onData(a.output.length===a.next_out?a.output:a.output.subarray(0,a.next_out));if(s!==Fe||0!==o){if(s===Le)return s=Ue.inflateEnd(this.strm),this.onEnd(s),this.ended=!0,!0;if(0===a.avail_in)break}}return!0},He.prototype.onData=function(t){this.chunks.push(t)},He.prototype.onEnd=function(t){t===Fe&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=Ot(this.chunks)),this.chunks=[],this.err=t,this.msg=this.strm.msg};const{Deflate:Me,deflate:je,deflateRaw:Ke,gzip:Pe}=Vt;var Ye=Me,Ge=je,Xe=B;const We=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const e=this._hasEvents?",":"";this.deflate.push(e+t,Xe.Z_SYNC_FLUSH),this._hasEvents=!0}finish(){if(this.deflate.push("]",Xe.Z_FINISH),this.deflate.err)throw this.deflate.err;const t=this.deflate.result;return this._init(),t}_init(){this._hasEvents=!1,this.deflate=new Ye,this.deflate.push("[",Xe.Z_NO_FLUSH)}},qe={clear:()=>{We.clear()},addEvent:t=>We.addEvent(t),finish:()=>We.finish(),compress:t=>function(t){return Ge(t)}(t)};addEventListener("message",(function(t){const e=t.data.method,a=t.data.id,i=t.data.arg;if(e in qe&&"function"==typeof qe[e])try{const t=qe[e](i);postMessage({id:a,method:e,success:!0,response:t})}catch(t){postMessage({id:a,method:e,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $387daa7ca38f1a5d$var$e() {
    const e = new Blob([
        $387daa7ca38f1a5d$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $387daa7ca38f1a5d$var$logInfo(message, shouldAddBreadcrumb) {
    if (!(typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__)) return;
    (0, $eace895db919f450$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $387daa7ca38f1a5d$var$addBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $387daa7ca38f1a5d$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!(typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__)) return;
    (0, $eace895db919f450$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(()=>{
        $387daa7ca38f1a5d$var$addBreadcrumb(message);
    }, 0);
}
function $387daa7ca38f1a5d$var$addBreadcrumb(message) {
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    hub.addBreadcrumb({
        category: "console",
        data: {
            logger: "replay"
        },
        level: "info",
        message: message
    }, {
        level: "info"
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $387daa7ca38f1a5d$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$387daa7ca38f1a5d$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $387daa7ca38f1a5d$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return "sync";
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $387daa7ca38f1a5d$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $387daa7ca38f1a5d$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $387daa7ca38f1a5d$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $387daa7ca38f1a5d$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener("message", ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener("error", (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $387daa7ca38f1a5d$var$logInfo("[Replay] Destroying compression worker");
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener("message", listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay]", response.response);
                    reject(new Error("Error in compression worker"));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener("message", listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $387daa7ca38f1a5d$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $387daa7ca38f1a5d$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return "worker";
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $387daa7ca38f1a5d$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $387daa7ca38f1a5d$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $387daa7ca38f1a5d$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        this._worker.postMessage("clear");
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage("addEvent", data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage("finish");
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $387daa7ca38f1a5d$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $387daa7ca38f1a5d$var$EventBufferArray();
        this._compression = new $387daa7ca38f1a5d$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $387daa7ca38f1a5d$var$logInfo("[Replay] Failed to load the compression worker, falling back to simple buffer");
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("[Replay] Failed to add events when switching buffers.", error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $387daa7ca38f1a5d$var$createEventBuffer({ useCompression: useCompression }) {
    // eslint-disable-next-line no-restricted-globals
    if (useCompression && window.Worker) try {
        const workerUrl = $387daa7ca38f1a5d$var$e();
        $387daa7ca38f1a5d$var$logInfo("[Replay] Using compression worker");
        const worker = new Worker(workerUrl);
        return new $387daa7ca38f1a5d$var$EventBufferProxy(worker);
    } catch (error) {
        $387daa7ca38f1a5d$var$logInfo("[Replay] Failed to create compression worker");
    // Fall back to use simple event buffer array
    }
    $387daa7ca38f1a5d$var$logInfo("[Replay] Using simple buffer");
    return new $387daa7ca38f1a5d$var$EventBufferArray();
}
/** If sessionStorage is available. */ function $387daa7ca38f1a5d$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return "sessionStorage" in $387daa7ca38f1a5d$var$WINDOW && !!$387daa7ca38f1a5d$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $387daa7ca38f1a5d$var$clearSession(replay) {
    $387daa7ca38f1a5d$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $387daa7ca38f1a5d$var$deleteSession() {
    if (!$387daa7ca38f1a5d$var$hasSessionStorage()) return;
    try {
        $387daa7ca38f1a5d$var$WINDOW.sessionStorage.removeItem($387daa7ca38f1a5d$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $387daa7ca38f1a5d$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Save a session to session storage.
 */ function $387daa7ca38f1a5d$var$saveSession(session) {
    if (!$387daa7ca38f1a5d$var$hasSessionStorage()) return;
    try {
        $387daa7ca38f1a5d$var$WINDOW.sessionStorage.setItem($387daa7ca38f1a5d$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get a session with defaults & applied sampling.
 */ function $387daa7ca38f1a5d$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $6db688138f32ddc5$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $387daa7ca38f1a5d$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $387daa7ca38f1a5d$var$isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $387daa7ca38f1a5d$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $387daa7ca38f1a5d$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $387daa7ca38f1a5d$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $387daa7ca38f1a5d$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $387daa7ca38f1a5d$var$fetchSession(traceInternals) {
    if (!$387daa7ca38f1a5d$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $387daa7ca38f1a5d$var$WINDOW.sessionStorage.getItem($387daa7ca38f1a5d$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $387daa7ca38f1a5d$var$logInfoNextTick("[Replay] Loading existing session", traceInternals);
        return $387daa7ca38f1a5d$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $387daa7ca38f1a5d$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $387daa7ca38f1a5d$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $387daa7ca38f1a5d$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $387daa7ca38f1a5d$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $387daa7ca38f1a5d$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$387daa7ca38f1a5d$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === "buffer" && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $387daa7ca38f1a5d$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $387daa7ca38f1a5d$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $387daa7ca38f1a5d$var$logInfoNextTick("[Replay] Creating new session", traceInternals);
        return $387daa7ca38f1a5d$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$387daa7ca38f1a5d$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $387daa7ca38f1a5d$var$logInfoNextTick("[Replay] Session in sessionStorage is expired, creating new one...");
    return $387daa7ca38f1a5d$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
const $387daa7ca38f1a5d$var$ReplayEventTypeCustom = 5;
function $387daa7ca38f1a5d$var$isCustomEvent(event) {
    return event.type === $387daa7ca38f1a5d$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $387daa7ca38f1a5d$var$addEventSync(replay, event, isCheckout) {
    if (!$387daa7ca38f1a5d$var$shouldAddEvent(replay, event)) return false;
    $387daa7ca38f1a5d$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $387daa7ca38f1a5d$var$addEvent(replay, event, isCheckout) {
    if (!$387daa7ca38f1a5d$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $387daa7ca38f1a5d$var$_addEvent(replay, event, isCheckout);
}
async function $387daa7ca38f1a5d$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === "buffer") replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $387daa7ca38f1a5d$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $387daa7ca38f1a5d$var$EventBufferSizeExceededError ? "addEventSizeExceeded" : "addEvent";
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
        if (client) client.recordDroppedEvent("internal_sdk_error", "replay");
    }
}
/** Exported only for tests. */ function $387daa7ca38f1a5d$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $387daa7ca38f1a5d$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $387daa7ca38f1a5d$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $387daa7ca38f1a5d$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === "function" && $387daa7ca38f1a5d$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...", error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $387daa7ca38f1a5d$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $387daa7ca38f1a5d$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** If the event is an replay event */ function $387daa7ca38f1a5d$var$isReplayEvent(event) {
    return event.type === "replay_event";
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $387daa7ca38f1a5d$var$handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    const enforceStatusCode = $387daa7ca38f1a5d$var$isBaseTransportSend();
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$387daa7ca38f1a5d$var$isErrorEvent(event) && !$387daa7ca38f1a5d$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if ($387daa7ca38f1a5d$var$isTransactionEvent(event)) {
            $387daa7ca38f1a5d$var$handleTransactionEvent(replay, event);
            return;
        }
        $387daa7ca38f1a5d$var$handleErrorEvent(replay, event);
    };
}
function $387daa7ca38f1a5d$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $387daa7ca38f1a5d$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode === "buffer" && event.tags && event.tags.replayId) setTimeout(()=>{
        replay.sendBufferedReplayOrFlush();
    });
}
function $387daa7ca38f1a5d$var$isBaseTransportSend() {
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    if (!client) return false;
    const transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $387daa7ca38f1a5d$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    // Check if any exception originates from rrweb
    return event.exception.values.some((exception)=>{
        if (!exception.stacktrace || !exception.stacktrace.frames || !exception.stacktrace.frames.length) return false;
        return exception.stacktrace.frames.some((frame)=>frame.filename && frame.filename.includes("/rrweb/src/"));
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $387daa7ca38f1a5d$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== "buffer") return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $387daa7ca38f1a5d$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $387daa7ca38f1a5d$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addGlobalEventProcessor(listener)`.
 */ function $387daa7ca38f1a5d$var$handleGlobalEventListener(replay, includeAfterSendEventHandling = false) {
    const afterSendHandler = includeAfterSendEventHandling ? $387daa7ca38f1a5d$var$handleAfterSendEvent(replay) : undefined;
    return (event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($387daa7ca38f1a5d$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors & transactions, nothing else
        if (!$387daa7ca38f1a5d$var$isErrorEvent(event) && !$387daa7ca38f1a5d$var$isTransactionEvent(event)) return event;
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($387daa7ca38f1a5d$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).log("[Replay] Ignoring error from rrweb internals", event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $387daa7ca38f1a5d$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    };
}
/**
 * Create a "span" for each performance entry.
 */ function $387daa7ca38f1a5d$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $387daa7ca38f1a5d$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: "performanceSpan",
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === "string" ? Promise.resolve(null) : response;
    });
}
function $387daa7ca38f1a5d$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: "navigation.push",
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('history', listener)`.
 */ function $387daa7ca38f1a5d$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $387daa7ca38f1a5d$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $387daa7ca38f1a5d$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $387daa7ca38f1a5d$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && replay.getOptions()._experiments.traceInternals) return false;
    return $387daa7ca38f1a5d$var$_isSentryRequest(url);
}
/**
 * Checks wether a given URL belongs to the configured Sentry DSN.
 */ function $387daa7ca38f1a5d$var$_isSentryRequest(url) {
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    const dsn = client && client.getDsn();
    return dsn ? url.includes(dsn.host) : false;
}
/** Add a performance entry breadcrumb */ function $387daa7ca38f1a5d$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($387daa7ca38f1a5d$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $387daa7ca38f1a5d$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function $387daa7ca38f1a5d$var$handleFetch(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, fetchData: fetchData, response: response } = handlerData;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url } = fetchData;
    return {
        type: "resource.fetch",
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('fetch', listener)`.
 */ function $387daa7ca38f1a5d$var$handleFetchSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $387daa7ca38f1a5d$var$handleFetch(handlerData);
        $387daa7ca38f1a5d$var$addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function $387daa7ca38f1a5d$var$handleXhr(handlerData) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, xhr: xhr } = handlerData;
    const sentryXhrData = xhr[0, $ff6cab9022b0c01d$export$55b6bb1e45c6cf59];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    const { method: method, url: url, status_code: statusCode } = sentryXhrData;
    if (url === undefined) return null;
    return {
        type: "resource.xhr",
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addInstrumentationHandler('xhr', listener)`.
 */ function $387daa7ca38f1a5d$var$handleXhrSpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $387daa7ca38f1a5d$var$handleXhr(handlerData);
        $387daa7ca38f1a5d$var$addNetworkBreadcrumb(replay, result);
    };
}
const $387daa7ca38f1a5d$var$OBJ = 10;
const $387daa7ca38f1a5d$var$OBJ_KEY = 11;
const $387daa7ca38f1a5d$var$OBJ_KEY_STR = 12;
const $387daa7ca38f1a5d$var$OBJ_VAL = 13;
const $387daa7ca38f1a5d$var$OBJ_VAL_STR = 14;
const $387daa7ca38f1a5d$var$OBJ_VAL_COMPLETED = 15;
const $387daa7ca38f1a5d$var$ARR = 20;
const $387daa7ca38f1a5d$var$ARR_VAL = 21;
const $387daa7ca38f1a5d$var$ARR_VAL_STR = 22;
const $387daa7ca38f1a5d$var$ARR_VAL_COMPLETED = 23;
const $387daa7ca38f1a5d$var$ALLOWED_PRIMITIVES = [
    "true",
    "false",
    "null"
];
/**
 * Complete an incomplete JSON string.
 * This will ensure that the last element always has a `"~~"` to indicate it was truncated.
 * For example, `[1,2,` will be completed to `[1,2,"~~"]`
 * and `{"aa":"b` will be completed to `{"aa":"b~~"}`
 */ function $387daa7ca38f1a5d$var$completeJson(incompleteJson, stack) {
    if (!stack.length) return incompleteJson;
    let json = incompleteJson;
    // Most checks are only needed for the last step in the stack
    const lastPos = stack.length - 1;
    const lastStep = stack[lastPos];
    json = $387daa7ca38f1a5d$var$_fixLastStep(json, lastStep);
    // Complete remaining steps - just add closing brackets
    for(let i = lastPos; i >= 0; i--){
        const step = stack[i];
        switch(step){
            case $387daa7ca38f1a5d$var$OBJ:
                json = `${json}}`;
                break;
            case $387daa7ca38f1a5d$var$ARR:
                json = `${json}]`;
                break;
        }
    }
    return json;
}
function $387daa7ca38f1a5d$var$_fixLastStep(json, lastStep) {
    switch(lastStep){
        // Object cases
        case $387daa7ca38f1a5d$var$OBJ:
            return `${json}"~~":"~~"`;
        case $387daa7ca38f1a5d$var$OBJ_KEY:
            return `${json}:"~~"`;
        case $387daa7ca38f1a5d$var$OBJ_KEY_STR:
            return `${json}~~":"~~"`;
        case $387daa7ca38f1a5d$var$OBJ_VAL:
            return $387daa7ca38f1a5d$var$_maybeFixIncompleteObjValue(json);
        case $387daa7ca38f1a5d$var$OBJ_VAL_STR:
            return `${json}~~"`;
        case $387daa7ca38f1a5d$var$OBJ_VAL_COMPLETED:
            return `${json},"~~":"~~"`;
        // Array cases
        case $387daa7ca38f1a5d$var$ARR:
            return `${json}"~~"`;
        case $387daa7ca38f1a5d$var$ARR_VAL:
            return $387daa7ca38f1a5d$var$_maybeFixIncompleteArrValue(json);
        case $387daa7ca38f1a5d$var$ARR_VAL_STR:
            return `${json}~~"`;
        case $387daa7ca38f1a5d$var$ARR_VAL_COMPLETED:
            return `${json},"~~"`;
    }
    return json;
}
function $387daa7ca38f1a5d$var$_maybeFixIncompleteArrValue(json) {
    const pos = $387daa7ca38f1a5d$var$_findLastArrayDelimiter(json);
    if (pos > -1) {
        const part = json.slice(pos + 1);
        if ($387daa7ca38f1a5d$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~"`;
        // Everything else is replaced with `"~~"`
        return `${json.slice(0, pos + 1)}"~~"`;
    }
    // fallback, this shouldn't happen, to be save
    return json;
}
function $387daa7ca38f1a5d$var$_findLastArrayDelimiter(json) {
    for(let i = json.length - 1; i >= 0; i--){
        const char = json[i];
        if (char === "," || char === "[") return i;
    }
    return -1;
}
function $387daa7ca38f1a5d$var$_maybeFixIncompleteObjValue(json) {
    const startPos = json.lastIndexOf(":");
    const part = json.slice(startPos + 1);
    if ($387daa7ca38f1a5d$var$ALLOWED_PRIMITIVES.includes(part.trim())) return `${json},"~~":"~~"`;
    // Everything else is replaced with `"~~"`
    // This also means we do not have incomplete numbers, e.g `[1` is replaced with `["~~"]`
    return `${json.slice(0, startPos + 1)}"~~"`;
}
/**
 * Evaluate an (incomplete) JSON string.
 */ function $387daa7ca38f1a5d$var$evaluateJson(json) {
    const stack = [];
    for(let pos = 0; pos < json.length; pos++)$387daa7ca38f1a5d$var$_evaluateJsonPos(stack, json, pos);
    return stack;
}
function $387daa7ca38f1a5d$var$_evaluateJsonPos(stack, json, pos) {
    const curStep = stack[stack.length - 1];
    const char = json[pos];
    const whitespaceRegex = /\s/;
    if (whitespaceRegex.test(char)) return;
    if (char === '"' && !$387daa7ca38f1a5d$var$_isEscaped(json, pos)) {
        $387daa7ca38f1a5d$var$_handleQuote(stack, curStep);
        return;
    }
    switch(char){
        case "{":
            $387daa7ca38f1a5d$var$_handleObj(stack, curStep);
            break;
        case "[":
            $387daa7ca38f1a5d$var$_handleArr(stack, curStep);
            break;
        case ":":
            $387daa7ca38f1a5d$var$_handleColon(stack, curStep);
            break;
        case ",":
            $387daa7ca38f1a5d$var$_handleComma(stack, curStep);
            break;
        case "}":
            $387daa7ca38f1a5d$var$_handleObjClose(stack, curStep);
            break;
        case "]":
            $387daa7ca38f1a5d$var$_handleArrClose(stack, curStep);
            break;
    }
}
function $387daa7ca38f1a5d$var$_handleQuote(stack, curStep) {
    // End of obj value
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL_STR) {
        stack.pop();
        stack.push($387daa7ca38f1a5d$var$OBJ_VAL_COMPLETED);
        return;
    }
    // End of arr value
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL_STR) {
        stack.pop();
        stack.push($387daa7ca38f1a5d$var$ARR_VAL_COMPLETED);
        return;
    }
    // Start of obj value
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL) {
        stack.push($387daa7ca38f1a5d$var$OBJ_VAL_STR);
        return;
    }
    // Start of arr value
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL) {
        stack.push($387daa7ca38f1a5d$var$ARR_VAL_STR);
        return;
    }
    // Start of obj key
    if (curStep === $387daa7ca38f1a5d$var$OBJ) {
        stack.push($387daa7ca38f1a5d$var$OBJ_KEY_STR);
        return;
    }
    // End of obj key
    if (curStep === $387daa7ca38f1a5d$var$OBJ_KEY_STR) {
        stack.pop();
        stack.push($387daa7ca38f1a5d$var$OBJ_KEY);
        return;
    }
}
function $387daa7ca38f1a5d$var$_handleObj(stack, curStep) {
    // Initial object
    if (!curStep) {
        stack.push($387daa7ca38f1a5d$var$OBJ);
        return;
    }
    // New object as obj value
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL) {
        stack.push($387daa7ca38f1a5d$var$OBJ);
        return;
    }
    // New object as array element
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL) stack.push($387daa7ca38f1a5d$var$OBJ);
    // New object as first array element
    if (curStep === $387daa7ca38f1a5d$var$ARR) {
        stack.push($387daa7ca38f1a5d$var$OBJ);
        return;
    }
}
function $387daa7ca38f1a5d$var$_handleArr(stack, curStep) {
    // Initial array
    if (!curStep) {
        stack.push($387daa7ca38f1a5d$var$ARR);
        stack.push($387daa7ca38f1a5d$var$ARR_VAL);
        return;
    }
    // New array as obj value
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL) {
        stack.push($387daa7ca38f1a5d$var$ARR);
        stack.push($387daa7ca38f1a5d$var$ARR_VAL);
        return;
    }
    // New array as array element
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL) {
        stack.push($387daa7ca38f1a5d$var$ARR);
        stack.push($387daa7ca38f1a5d$var$ARR_VAL);
    }
    // New array as first array element
    if (curStep === $387daa7ca38f1a5d$var$ARR) {
        stack.push($387daa7ca38f1a5d$var$ARR);
        stack.push($387daa7ca38f1a5d$var$ARR_VAL);
        return;
    }
}
function $387daa7ca38f1a5d$var$_handleColon(stack, curStep) {
    if (curStep === $387daa7ca38f1a5d$var$OBJ_KEY) {
        stack.pop();
        stack.push($387daa7ca38f1a5d$var$OBJ_VAL);
    }
}
function $387daa7ca38f1a5d$var$_handleComma(stack, curStep) {
    // Comma after obj value
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL) {
        stack.pop();
        return;
    }
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED & OBJ_VAL
        stack.pop();
        stack.pop();
        return;
    }
    // Comma after arr value
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL) // do nothing - basically we'd pop ARR_VAL but add it right back
    return;
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED
        stack.pop();
        // basically we'd pop ARR_VAL but add it right back
        return;
    }
}
function $387daa7ca38f1a5d$var$_handleObjClose(stack, curStep) {
    // Empty object {}
    if (curStep === $387daa7ca38f1a5d$var$OBJ) stack.pop();
    // Object with element
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL) {
        // Pop OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
    }
    // Obj with element
    if (curStep === $387daa7ca38f1a5d$var$OBJ_VAL_COMPLETED) {
        // Pop OBJ_VAL_COMPLETED, OBJ_VAL, OBJ
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $387daa7ca38f1a5d$var$OBJ_VAL) stack.push($387daa7ca38f1a5d$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $387daa7ca38f1a5d$var$ARR_VAL) stack.push($387daa7ca38f1a5d$var$ARR_VAL_COMPLETED);
}
function $387daa7ca38f1a5d$var$_handleArrClose(stack, curStep) {
    // Empty array []
    if (curStep === $387daa7ca38f1a5d$var$ARR) stack.pop();
    // Array with element
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL) {
        // Pop ARR_VAL, ARR
        stack.pop();
        stack.pop();
    }
    // Array with element
    if (curStep === $387daa7ca38f1a5d$var$ARR_VAL_COMPLETED) {
        // Pop ARR_VAL_COMPLETED, ARR_VAL, ARR
        stack.pop();
        stack.pop();
        stack.pop();
    }
    // if was obj value, complete it
    if (stack[stack.length - 1] === $387daa7ca38f1a5d$var$OBJ_VAL) stack.push($387daa7ca38f1a5d$var$OBJ_VAL_COMPLETED);
    // if was arr value, complete it
    if (stack[stack.length - 1] === $387daa7ca38f1a5d$var$ARR_VAL) stack.push($387daa7ca38f1a5d$var$ARR_VAL_COMPLETED);
}
function $387daa7ca38f1a5d$var$_isEscaped(str, pos) {
    const previousChar = str[pos - 1];
    return previousChar === "\\" && !$387daa7ca38f1a5d$var$_isEscaped(str, pos - 1);
}
/* eslint-disable max-lines */ /**
 * Takes an incomplete JSON string, and returns a hopefully valid JSON string.
 * Note that this _can_ fail, so you should check the return value is valid JSON.
 */ function $387daa7ca38f1a5d$var$fixJson(incompleteJson) {
    const stack = $387daa7ca38f1a5d$var$evaluateJson(incompleteJson);
    return $387daa7ca38f1a5d$var$completeJson(incompleteJson, stack);
}
/** Get the size of a body. */ function $387daa7ca38f1a5d$var$getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === "string") return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $387daa7ca38f1a5d$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $387daa7ca38f1a5d$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $387daa7ca38f1a5d$var$getBodyString(body) {
    if (typeof body === "string") return body;
    if (body instanceof URLSearchParams) return body.toString();
    if (body instanceof FormData) return $387daa7ca38f1a5d$var$_serializeFormData(body);
    return undefined;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $387daa7ca38f1a5d$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $00469dac6edb4ff1$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $387daa7ca38f1a5d$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                "URL_SKIPPED"
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $387daa7ca38f1a5d$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $387daa7ca38f1a5d$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $387daa7ca38f1a5d$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $387daa7ca38f1a5d$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== "string") return {
        body: body,
        warnings: []
    };
    const exceedsSizeLimit = body.length > $387daa7ca38f1a5d$var$NETWORK_BODY_MAX_SIZE;
    if ($387daa7ca38f1a5d$var$_strIsProbablyJson(body)) try {
        const json = exceedsSizeLimit ? $387daa7ca38f1a5d$var$fixJson(body.slice(0, $387daa7ca38f1a5d$var$NETWORK_BODY_MAX_SIZE)) : body;
        const normalizedBody = JSON.parse(json);
        return {
            body: normalizedBody,
            warnings: exceedsSizeLimit ? [
                "JSON_TRUNCATED"
            ] : []
        };
    } catch (e3) {
        return {
            body: exceedsSizeLimit ? `${body.slice(0, $387daa7ca38f1a5d$var$NETWORK_BODY_MAX_SIZE)}…` : body,
            warnings: exceedsSizeLimit ? [
                "INVALID_JSON",
                "TEXT_TRUNCATED"
            ] : [
                "INVALID_JSON"
            ]
        };
    }
    return {
        body: exceedsSizeLimit ? `${body.slice(0, $387daa7ca38f1a5d$var$NETWORK_BODY_MAX_SIZE)}…` : body,
        warnings: exceedsSizeLimit ? [
            "TEXT_TRUNCATED"
        ] : []
    };
}
function $387daa7ca38f1a5d$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === "[" && last === "]" || first === "{" && last === "}";
}
/** Match an URL against a list of strings/Regex. */ function $387daa7ca38f1a5d$var$urlMatches(url, urls) {
    const fullUrl = $387daa7ca38f1a5d$var$getFullUrl(url);
    return (0, $07665083d6e876d3$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $387daa7ca38f1a5d$var$getFullUrl(url, baseURI = $387daa7ca38f1a5d$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith($387daa7ca38f1a5d$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith("/") && fullUrl.endsWith("/")) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $387daa7ca38f1a5d$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $387daa7ca38f1a5d$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $387daa7ca38f1a5d$var$makeNetworkReplayBreadcrumb("resource.fetch", data);
        $387daa7ca38f1a5d$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $387daa7ca38f1a5d$var$enrichFetchBreadcrumb(breadcrumb, hint, options) {
    const { input: input, response: response } = hint;
    const body = $387daa7ca38f1a5d$var$_getFetchRequestArgBody(input);
    const reqSize = $387daa7ca38f1a5d$var$getBodySize(body, options.textEncoder);
    const resSize = response ? $387daa7ca38f1a5d$var$parseContentLengthHeader(response.headers.get("content-length")) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $387daa7ca38f1a5d$var$_prepareFetchData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $387daa7ca38f1a5d$var$urlMatches(url, options.networkDetailAllowUrls) && !$387daa7ca38f1a5d$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $387daa7ca38f1a5d$var$_getRequestInfo(options, hint.input, requestBodySize) : $387daa7ca38f1a5d$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $387daa7ca38f1a5d$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $387daa7ca38f1a5d$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = $387daa7ca38f1a5d$var$getRequestHeaders(input, networkRequestHeaders);
    if (!networkCaptureBodies) return $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $387daa7ca38f1a5d$var$_getFetchRequestArgBody(input);
    const bodyStr = $387daa7ca38f1a5d$var$getBodyString(requestBody);
    return $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
}
async function $387daa7ca38f1a5d$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, textEncoder: textEncoder, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $387daa7ca38f1a5d$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = $387daa7ca38f1a5d$var$getAllHeaders(response.headers, networkResponseHeaders);
    if (!networkCaptureBodies && responseBodySize !== undefined) return $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    // Only clone the response if we need to
    try {
        // We have to clone this, as the body can only be read once
        const res = response.clone();
        const bodyText = await $387daa7ca38f1a5d$var$_parseFetchBody(res);
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $387daa7ca38f1a5d$var$getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return $387daa7ca38f1a5d$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (e) {
        // fallback
        return $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $387daa7ca38f1a5d$var$_parseFetchBody(response) {
    try {
        return await response.text();
    } catch (e2) {
        return undefined;
    }
}
function $387daa7ca38f1a5d$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== "object") return undefined;
    return fetchArgs[1].body;
}
function $387daa7ca38f1a5d$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $387daa7ca38f1a5d$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") return $387daa7ca38f1a5d$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $387daa7ca38f1a5d$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $387daa7ca38f1a5d$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $387daa7ca38f1a5d$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $387daa7ca38f1a5d$var$getAllowedHeaders(headers, allowedHeaders);
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $387daa7ca38f1a5d$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $387daa7ca38f1a5d$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $387daa7ca38f1a5d$var$makeNetworkReplayBreadcrumb("resource.xhr", data);
        $387daa7ca38f1a5d$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay] Failed to capture fetch breadcrumb", error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $387daa7ca38f1a5d$var$enrichXhrBreadcrumb(breadcrumb, hint, options) {
    const { xhr: xhr, input: input } = hint;
    const reqSize = $387daa7ca38f1a5d$var$getBodySize(input, options.textEncoder);
    const resSize = xhr.getResponseHeader("content-length") ? $387daa7ca38f1a5d$var$parseContentLengthHeader(xhr.getResponseHeader("content-length")) : $387daa7ca38f1a5d$var$getBodySize(xhr.response, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $387daa7ca38f1a5d$var$_prepareXhrData(breadcrumb, hint, options) {
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!$387daa7ca38f1a5d$var$urlMatches(url, options.networkDetailAllowUrls) || $387daa7ca38f1a5d$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $387daa7ca38f1a5d$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $387daa7ca38f1a5d$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $ff6cab9022b0c01d$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $387daa7ca38f1a5d$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $387daa7ca38f1a5d$var$getAllowedHeaders($387daa7ca38f1a5d$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const request = $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, options.networkCaptureBodies ? $387daa7ca38f1a5d$var$getBodyString(input) : undefined);
    const response = $387daa7ca38f1a5d$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, options.networkCaptureBodies ? hint.xhr.responseText : undefined);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $387daa7ca38f1a5d$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $387daa7ca38f1a5d$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    try {
        const textEncoder = new TextEncoder();
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on("beforeAddBreadcrumb", (breadcrumb, hint)=>$387daa7ca38f1a5d$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
        else {
            // Fallback behavior
            (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("fetch", $387daa7ca38f1a5d$var$handleFetchSpanListener(replay));
            (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("xhr", $387daa7ca38f1a5d$var$handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $387daa7ca38f1a5d$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($387daa7ca38f1a5d$var$_isXhrBreadcrumb(breadcrumb) && $387daa7ca38f1a5d$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $387daa7ca38f1a5d$var$enrichXhrBreadcrumb(breadcrumb, hint, options);
            $387daa7ca38f1a5d$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($387daa7ca38f1a5d$var$_isFetchBreadcrumb(breadcrumb) && $387daa7ca38f1a5d$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $387daa7ca38f1a5d$var$enrichFetchBreadcrumb(breadcrumb, hint, options);
            $387daa7ca38f1a5d$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("Error when enriching network breadcrumb");
    }
}
function $387daa7ca38f1a5d$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === "xhr";
}
function $387daa7ca38f1a5d$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === "fetch";
}
function $387daa7ca38f1a5d$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $387daa7ca38f1a5d$var$_isFetchHint(hint) {
    return hint && hint.response;
}
let $387daa7ca38f1a5d$var$_LAST_BREADCRUMB = null;
function $387daa7ca38f1a5d$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
const $387daa7ca38f1a5d$var$handleScopeListener = (replay)=>(scope)=>{
        if (!replay.isEnabled()) return;
        const result = $387daa7ca38f1a5d$var$handleScope(scope);
        if (!result) return;
        $387daa7ca38f1a5d$var$addBreadcrumbEvent(replay, result);
    };
/**
 * An event handler to handle scope changes.
 */ function $387daa7ca38f1a5d$var$handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    const newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if ($387daa7ca38f1a5d$var$_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    $387daa7ca38f1a5d$var$_LAST_BREADCRUMB = newBreadcrumb;
    if (!$387daa7ca38f1a5d$var$isBreadcrumbWithCategory(newBreadcrumb) || [
        "fetch",
        "xhr",
        "sentry.event",
        "sentry.transaction"
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith("ui.")) return null;
    if (newBreadcrumb.category === "console") return $387daa7ca38f1a5d$var$normalizeConsoleBreadcrumb(newBreadcrumb);
    return $387daa7ca38f1a5d$var$createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function $387daa7ca38f1a5d$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $387daa7ca38f1a5d$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === "string") {
            if (arg.length > $387daa7ca38f1a5d$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $387daa7ca38f1a5d$var$CONSOLE_ARG_MAX_SIZE)}…`;
            }
            return arg;
        }
        if (typeof arg === "object") try {
            const normalizedArg = (0, $d060f3e5c438af18$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $387daa7ca38f1a5d$var$CONSOLE_ARG_MAX_SIZE) {
                const fixedJson = $387daa7ca38f1a5d$var$fixJson(stringified.slice(0, $387daa7ca38f1a5d$var$CONSOLE_ARG_MAX_SIZE));
                const json = JSON.parse(fixedJson);
                // We only set this after JSON.parse() was successfull, so we know we didn't run into `catch`
                isTruncated = true;
                return json;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $387daa7ca38f1a5d$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        "CONSOLE_ARG_TRUNCATED"
                    ]
                }
            } : {}
        }
    });
}
/**
 * Add global listeners that cannot be removed.
 */ function $387daa7ca38f1a5d$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const scope = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getScope();
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    scope.addScopeListener($387daa7ca38f1a5d$var$handleScopeListener(replay));
    (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("dom", $387daa7ca38f1a5d$var$handleDomListener(replay));
    (0, $ff6cab9022b0c01d$export$285b9172a3741fb7)("history", $387daa7ca38f1a5d$var$handleHistorySpanListener(replay));
    $387daa7ca38f1a5d$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    (0, $d89985e59bedb9f9$export$8e4e25f54d456511)($387daa7ca38f1a5d$var$handleGlobalEventListener(replay, !$387daa7ca38f1a5d$var$hasHooks(client)));
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if ($387daa7ca38f1a5d$var$hasHooks(client)) {
        client.on("afterSendEvent", $387daa7ca38f1a5d$var$handleAfterSendEvent(replay));
        client.on("createDsc", (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === "session") dsc.replay_id = replayId;
        });
        client.on("startTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on("finishTransaction", (transaction)=>{
            replay.lastTransaction = transaction;
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $387daa7ca38f1a5d$var$hasHooks(client) {
    return !!(client && client.on);
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $387daa7ca38f1a5d$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($387daa7ca38f1a5d$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $387daa7ca38f1a5d$var$createMemoryEntry($387daa7ca38f1a5d$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $387daa7ca38f1a5d$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: "memory",
        name: "memory",
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
// Map entryType -> function to normalize data for event
const $387daa7ca38f1a5d$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $387daa7ca38f1a5d$var$createResourceEntry,
    paint: $387daa7ca38f1a5d$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $387daa7ca38f1a5d$var$createNavigationEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    ["largest-contentful-paint"]: $387daa7ca38f1a5d$var$createLargestContentfulPaint
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $387daa7ca38f1a5d$var$createPerformanceEntries(entries) {
    return entries.map($387daa7ca38f1a5d$var$createPerformanceEntry).filter(Boolean);
}
function $387daa7ca38f1a5d$var$createPerformanceEntry(entry) {
    if ($387daa7ca38f1a5d$var$ENTRY_TYPES[entry.entryType] === undefined) return null;
    return $387daa7ca38f1a5d$var$ENTRY_TYPES[entry.entryType](entry);
}
function $387daa7ca38f1a5d$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $1LeEK.browserPerformanceTimeOrigin) || $387daa7ca38f1a5d$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $387daa7ca38f1a5d$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $387daa7ca38f1a5d$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $387daa7ca38f1a5d$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $387daa7ca38f1a5d$var$getAbsoluteTime(startTime),
        end: $387daa7ca38f1a5d$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $387daa7ca38f1a5d$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        "fetch",
        "xmlhttprequest"
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $387daa7ca38f1a5d$var$getAbsoluteTime(startTime),
        end: $387daa7ca38f1a5d$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
function $387daa7ca38f1a5d$var$createLargestContentfulPaint(entry) {
    const { entryType: entryType, startTime: startTime, size: size } = entry;
    let startTimeOrNavigationActivation = 0;
    if ($387daa7ca38f1a5d$var$WINDOW.performance) {
        const navEntry = $387daa7ca38f1a5d$var$WINDOW.performance.getEntriesByType("navigation")[0];
        // See https://github.com/GoogleChrome/web-vitals/blob/9f11c4c6578fb4c5ee6fa4e32b9d1d756475f135/src/lib/getActivationStart.ts#L21
        startTimeOrNavigationActivation = navEntry && navEntry.activationStart || 0;
    }
    // value is in ms
    const value = Math.max(startTime - startTimeOrNavigationActivation, 0);
    // LCP doesn't have a "duration", it just happens at a single point in time.
    // But the UI expects both, so use end (in seconds) for both timestamps.
    const end = $387daa7ca38f1a5d$var$getAbsoluteTime(startTimeOrNavigationActivation) + value / 1000;
    return {
        type: entryType,
        name: entryType,
        start: end,
        end: end,
        data: {
            value: value,
            size: size,
            // Not sure why this errors, Node should be correct (Argument of type 'Node' is not assignable to parameter of type 'INode')
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            nodeId: $387daa7ca38f1a5d$var$record.mirror.getId(entry.element)
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $387daa7ca38f1a5d$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $387daa7ca38f1a5d$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).warn("[Replay] Received replay event after session expired.");
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === "buffer" && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$387daa7ca38f1a5d$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $387daa7ca38f1a5d$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === "buffer" && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $387daa7ca38f1a5d$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $387daa7ca38f1a5d$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === "session") replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $387daa7ca38f1a5d$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $387daa7ca38f1a5d$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: "options",
            payload: {
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $387daa7ca38f1a5d$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $387daa7ca38f1a5d$var$addEventSync(replay, $387daa7ca38f1a5d$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $387daa7ca38f1a5d$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $62fb85999a5c3ef4$export$f93f7f385160c44e)((0, $62fb85999a5c3ef4$export$92b6093782fe661b)(replayEvent, (0, $62fb85999a5c3ef4$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: "replay_event"
            },
            replayEvent
        ],
        [
            {
                type: "replay_recording",
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $387daa7ca38f1a5d$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === "string") payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $387daa7ca38f1a5d$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === "object" && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    if (client.emit) client.emit("preprocessEvent", event, eventHint);
    const preparedEvent = await (0, $250f854364c0abb2$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client);
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || "javascript";
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata && client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || "sentry.javascript.unknown",
        version: version || "0.0.0"
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $387daa7ca38f1a5d$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $387daa7ca38f1a5d$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const hub = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)();
    const client = hub.getClient();
    const scope = hub.getScope();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return;
    const baseEvent = {
        type: $387daa7ca38f1a5d$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $387daa7ca38f1a5d$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent("event_processor", "replay", baseEvent);
        $387daa7ca38f1a5d$var$logInfo("An event processor returned `null`, will not send event.");
        return;
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $387daa7ca38f1a5d$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($387daa7ca38f1a5d$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
    if (!response) return response;
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) throw new $387daa7ca38f1a5d$var$TransportStatusCodeError(response.statusCode);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $387daa7ca38f1a5d$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $387daa7ca38f1a5d$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $387daa7ca38f1a5d$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $387daa7ca38f1a5d$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $387daa7ca38f1a5d$var$TransportStatusCodeError) throw err;
        // Capture error for every failed replay
        (0, $cf77fc5b2b31ee0b$export$2f04de43fe27971a)("Replays", {
            _retryCount: retryConfig.count
        });
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && options._experiments && options._experiments.captureExceptions) (0, $cf77fc5b2b31ee0b$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $387daa7ca38f1a5d$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$387daa7ca38f1a5d$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            setTimeout(async ()=>{
                try {
                    await $387daa7ca38f1a5d$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $387daa7ca38f1a5d$var$THROTTLED = "__THROTTLED";
const $387daa7ca38f1a5d$var$SKIPPED = "__SKIPPED";
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $387daa7ca38f1a5d$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $387daa7ca38f1a5d$var$SKIPPED : $387daa7ca38f1a5d$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $387daa7ca38f1a5d$var$ReplayContainer {
    /**
   * List of PerformanceEntry from PerformanceObserver
   */ /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active transcation.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $387daa7ca38f1a5d$var$ReplayContainer.prototype.__init.call(this);
        $387daa7ca38f1a5d$var$ReplayContainer.prototype.__init2.call(this);
        $387daa7ca38f1a5d$var$ReplayContainer.prototype.__init3.call(this);
        $387daa7ca38f1a5d$var$ReplayContainer.prototype.__init4.call(this);
        $387daa7ca38f1a5d$var$ReplayContainer.prototype.__init5.call(this);
        $387daa7ca38f1a5d$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEvents = [];
        this.recordingMode = "session";
        this.timeouts = {
            sessionIdlePause: $387daa7ca38f1a5d$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $387daa7ca38f1a5d$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ""
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $387daa7ca38f1a5d$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $387daa7ca38f1a5d$var$throttle((event, isCheckout)=>$387daa7ca38f1a5d$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($387daa7ca38f1a5d$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $387daa7ca38f1a5d$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $387daa7ca38f1a5d$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error("Unable to initialize and create session"));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
        $387daa7ca38f1a5d$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === "session") throw new Error("Replay recording is already in progress");
        if (this._isEnabled && this.recordingMode === "buffer") throw new Error("Replay buffering is in progress, call `flush()` to save the replay");
        $387daa7ca38f1a5d$var$logInfoNextTick("[Replay] Starting replay in session mode", this._options._experiments.traceInternals);
        const session = $387daa7ca38f1a5d$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error("Replay recording is already in progress");
        $387daa7ca38f1a5d$var$logInfoNextTick("[Replay] Starting replay in buffer mode", this._options._experiments.traceInternals);
        const session = $387daa7ca38f1a5d$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = "buffer";
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            this._stopRecording = $387daa7ca38f1a5d$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === "buffer" && {
                    checkoutEveryNms: $387daa7ca38f1a5d$var$BUFFER_CHECKOUT_TIME
                },
                emit: $387daa7ca38f1a5d$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $387daa7ca38f1a5d$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ""}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $387daa7ca38f1a5d$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $387daa7ca38f1a5d$var$logInfo("[Replay] Pausing replay", this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $387daa7ca38f1a5d$var$logInfo("[Replay] Resuming replay", this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === "session") return this.flushImmediate();
        const activityTime = Date.now();
        $387daa7ca38f1a5d$var$logInfo("[Replay] Converting buffer to session", this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === "session") return;
        // Re-start recording in session-mode
        this.recordingMode = "session";
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === "buffer") return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === "buffer") return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $387daa7ca38f1a5d$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === "session") {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$387daa7ca38f1a5d$var$WINDOW.location.pathname}${$387daa7ca38f1a5d$var$WINDOW.location.hash}${$387daa7ca38f1a5d$var$WINDOW.location.search}`;
        const url = `${$387daa7ca38f1a5d$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEvents = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $387daa7ca38f1a5d$var$THROTTLED) {
            const breadcrumb = $387daa7ca38f1a5d$var$createBreadcrumb({
                category: "replay.throttled"
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$387daa7ca38f1a5d$var$addEventSync(this, {
                    type: $387daa7ca38f1a5d$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: "breadcrumb",
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastTransaction = this.lastTransaction || (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getScope().getTransaction();
        if (!lastTransaction || ![
            "route",
            "custom"
        ].includes(lastTransaction.metadata.source)) return undefined;
        return lastTransaction.name;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $387daa7ca38f1a5d$var$createEventBuffer({
            useCompression: this._options.useCompression
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay]", error);
        if ((typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && this._options._experiments && this._options._experiments.captureExceptions) (0, $cf77fc5b2b31ee0b$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $387daa7ca38f1a5d$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($387daa7ca38f1a5d$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: "refresh session"
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $387daa7ca38f1a5d$var$WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
            $387daa7ca38f1a5d$var$WINDOW.addEventListener("blur", this._handleWindowBlur);
            $387daa7ca38f1a5d$var$WINDOW.addEventListener("focus", this._handleWindowFocus);
            $387daa7ca38f1a5d$var$WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $387daa7ca38f1a5d$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        // PerformanceObserver //
        if (!("PerformanceObserver" in $387daa7ca38f1a5d$var$WINDOW)) return;
        this._performanceObserver = $387daa7ca38f1a5d$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $387daa7ca38f1a5d$var$WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
            $387daa7ca38f1a5d$var$WINDOW.removeEventListener("blur", this._handleWindowBlur);
            $387daa7ca38f1a5d$var$WINDOW.removeEventListener("focus", this._handleWindowFocus);
            $387daa7ca38f1a5d$var$WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceObserver) {
                this._performanceObserver.disconnect();
                this._performanceObserver = undefined;
            }
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($387daa7ca38f1a5d$var$WINDOW.document.visibilityState === "visible") this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $387daa7ca38f1a5d$var$createBreadcrumb({
                category: "ui.blur"
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $387daa7ca38f1a5d$var$createBreadcrumb({
                category: "ui.focus"
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $387daa7ca38f1a5d$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $387daa7ca38f1a5d$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $387daa7ca38f1a5d$var$logInfo("[Replay] Document has become active, but session has expired");
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Trigger rrweb to take a full snapshot which will cause this plugin to
   * create a new Replay event.
   */ _triggerFullSnapshot(checkout = true) {
        try {
            $387daa7ca38f1a5d$var$logInfo("[Replay] Taking full rrweb snapshot");
            $387daa7ca38f1a5d$var$record.takeFullSnapshot(checkout);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            this.throttledAddEvent({
                type: $387daa7ca38f1a5d$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: "breadcrumb",
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEvents`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        // Copy and reset entries before processing
        const entries = [
            ...this.performanceEvents
        ];
        this.performanceEvents = [];
        return Promise.all($387daa7ca38f1a5d$var$createPerformanceSpans(this, $387daa7ca38f1a5d$var$createPerformanceEntries(entries)));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay] No session or eventBuffer found to flush.");
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $387daa7ca38f1a5d$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error("Session is too long, not sending replay");
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $387daa7ca38f1a5d$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            this.stop({
                reason: "sendReplay"
            });
            const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
            if (client) client.recordDroppedEvent("send_error", "replay");
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay] Attempting to finish replay event after session expired.");
                return;
            }
            if (!this.session) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error("[Replay] No session found to flush.");
                return;
            }
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $387daa7ca38f1a5d$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $387daa7ca38f1a5d$var$logInfo("[Replay] Flushing initial segment without checkout.", this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                (typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__) && (0, $eace895db919f450$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $387daa7ca38f1a5d$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $387daa7ca38f1a5d$var$createBreadcrumb({
                    category: "replay.mutations",
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                this.stop({
                    reason: "mutationLimit",
                    forceFlush: this.recordingMode === "session"
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $387daa7ca38f1a5d$var$getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    const deprecatedSelectors = typeof deprecatedSelectorOption === "string" ? deprecatedSelectorOption.split(",") : [];
    const allSelectors = [
        ...selectors,
        // @deprecated
        ...deprecatedSelectors,
        // sentry defaults
        ...defaultSelectors
    ];
    // @deprecated
    if (typeof deprecatedClassOption !== "undefined") {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === "string") allSelectors.push(`.${deprecatedClassOption}`);
        // eslint-disable-next-line no-console
        console.warn("[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.");
    }
    return allSelectors.join(",");
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $387daa7ca38f1a5d$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore, blockClass: // eslint-disable-next-line deprecation/deprecation
blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
blockSelector, maskTextClass: // eslint-disable-next-line deprecation/deprecation
maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
ignoreClass }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $387daa7ca38f1a5d$var$getOption(mask, [
        ".sentry-mask",
        "[data-sentry-mask]"
    ], maskTextClass, maskTextSelector);
    const unmaskSelector = $387daa7ca38f1a5d$var$getOption(unmask, [
        ".sentry-unmask",
        "[data-sentry-unmask]"
    ]);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        maskInputSelector: maskSelector,
        unmaskInputSelector: unmaskSelector,
        blockSelector: $387daa7ca38f1a5d$var$getOption(block, [
            ".sentry-block",
            "[data-sentry-block]",
            ...defaultBlockedElements
        ], blockClass, blockSelector),
        unblockSelector: $387daa7ca38f1a5d$var$getOption(unblock, [
            ".sentry-unblock",
            "[data-sentry-unblock]"
        ]),
        ignoreSelector: $387daa7ca38f1a5d$var$getOption(ignore, [
            ".sentry-ignore",
            "[data-sentry-ignore]",
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Returns true if we are in the browser.
 */ function $387daa7ca38f1a5d$var$isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== "undefined" && (!(0, $g11oe.isNodeEnv)() || $387daa7ca38f1a5d$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $387daa7ca38f1a5d$var$isElectronNodeRenderer() {
    return typeof $6qd2L !== "undefined" && $6qd2L.type === "renderer";
}
const $387daa7ca38f1a5d$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $387daa7ca38f1a5d$var$DEFAULT_NETWORK_HEADERS = [
    "content-length",
    "content-type",
    "accept"
];
let $387daa7ca38f1a5d$var$_initialized = false;
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 */ class $387daa7ca38f1a5d$export$a35c789ed37ee0f7 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = "Replay";
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $387daa7ca38f1a5d$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $387daa7ca38f1a5d$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $387daa7ca38f1a5d$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $387daa7ca38f1a5d$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, _experiments: _experiments = {}, sessionSampleRate: sessionSampleRate, errorSampleRate: errorSampleRate, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, blockClass: // eslint-disable-next-line deprecation/deprecation
    blockClass, blockSelector: // eslint-disable-next-line deprecation/deprecation
    blockSelector, maskInputOptions: // eslint-disable-next-line deprecation/deprecation
    maskInputOptions, maskTextClass: // eslint-disable-next-line deprecation/deprecation
    maskTextClass, maskTextSelector: // eslint-disable-next-line deprecation/deprecation
    maskTextSelector, ignoreClass: // eslint-disable-next-line deprecation/deprecation
    ignoreClass } = {}){
        this.name = $387daa7ca38f1a5d$export$a35c789ed37ee0f7.id;
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                ...maskInputOptions || {},
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            ...$387daa7ca38f1a5d$var$getPrivacyOptions({
                mask: mask,
                unmask: unmask,
                block: block,
                unblock: unblock,
                ignore: ignore,
                blockClass: blockClass,
                blockSelector: blockSelector,
                maskTextClass: maskTextClass,
                maskTextSelector: maskTextSelector,
                ignoreClass: ignoreClass
            }),
            // Our defaults
            slimDOMOptions: "all",
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $387daa7ca38f1a5d$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $387daa7ca38f1a5d$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $387daa7ca38f1a5d$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $387daa7ca38f1a5d$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === "number") {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $387daa7ca38f1a5d$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$387daa7ca38f1a5d$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && $387daa7ca38f1a5d$var$isBrowser()) throw new Error("Multiple Sentry Session Replay instances are not supported");
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $387daa7ca38f1a5d$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $387daa7ca38f1a5d$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!$387daa7ca38f1a5d$var$isBrowser()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === "session"
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $387daa7ca38f1a5d$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $387daa7ca38f1a5d$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
}
$387daa7ca38f1a5d$export$a35c789ed37ee0f7.__initStatic();
/** Parse Replay-related options from SDK options */ function $387daa7ca38f1a5d$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $1d80cfa15879bc41$export$a07cdf6544bbd7c)().getClient();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $00469dac6edb4ff1$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        // eslint-disable-next-line no-console
        console.warn("SDK client is not available.");
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) // eslint-disable-next-line no-console
    console.warn("Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.");
    if (typeof opt.replaysSessionSampleRate === "number") finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === "number") finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function $387daa7ca38f1a5d$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$387daa7ca38f1a5d$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}



if (!window?.location?.host?.startsWith("localhost")) $53d551888014e96e$export$2cd8252107eb640b({
    dsn: "https://a211f296b134585aa44edc10ea547aa3@o1128238.ingest.sentry.io/4505935375237120",
    integrations: [
        new $a03bb66ebe33cb7a$export$46d3bbd0375f5fa4({
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [
                "localhost",
                /^https:\/\/app\.sitestash\.net\//
            ]
        }),
        new $387daa7ca38f1a5d$export$a35c789ed37ee0f7()
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
});
const $1397cc89f1a50552$var$container = document.getElementById("app-container");
const $1397cc89f1a50552$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)($1397cc89f1a50552$var$container);
$1397cc89f1a50552$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $1ee798bac53aa7db$export$f72b9f9819639629), {
    children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $2cc1d3688dd37f6f$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4f59010982e89e0f$export$86fbec116b87613f), {})
    })
}));

})();
//# sourceMappingURL=index.8604574c.js.map
